/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				var _m = moreModules[moduleId];
/******/
/******/ 				// Check if module is deduplicated
/******/ 				switch(typeof _m) {
/******/ 				case "object":
/******/ 					// Module can be created from a template
/******/ 					modules[moduleId] = (function(_m) {
/******/ 						var args = _m.slice(1), templateId = _m[0];
/******/ 						return function (a,b,c) {
/******/ 							modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 						};
/******/ 					}(_m));
/******/ 					break;
/******/ 				case "function":
/******/ 					// Normal module
/******/ 					modules[moduleId] = _m;
/******/ 					break;
/******/ 				default:
/******/ 					// Module is a copy of another module
/******/ 					modules[moduleId] = modules[_m];
/******/ 					break;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + "." + "1a15ca4cc4973afe2f3d" + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _common = __webpack_require__(205);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(406);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(201);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(202);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Importando componentes base
	var root = _angular2.default.module('app', [_app4.default, _common2.default, _components2.default]).component('app', _app2.default).constant().name;
	
	// Bootstrap the app.
	document.addEventListener('DOMContentLoaded', function () {
	    return _angular2.default.bootstrap(document, ['app']);
	});
	
	exports.default = root;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.silentRejection = exports.silenceUncaughtInPromise = exports._extend = exports.copy = exports.tail = exports.applyPairs = exports.arrayTuples = exports.pairs = exports.assertFn = exports.assertMap = exports.assertPredicate = exports.flatten = exports.unnest = exports.uniqR = exports.pushR = exports.flattenR = exports.unnestR = exports.anyTrueR = exports.allTrueR = exports.values = exports.map = exports.mapObj = exports.find = exports.filter = exports.pluck = exports.omit = exports.pick = exports.ancestors = exports.mergeR = exports.defaults = exports.deregAll = exports._pushTo = exports.pushTo = exports._removeFrom = exports.removeFrom = exports._inArray = exports.inArray = exports.inherit = exports.createProxyFunctions = exports.noop = exports.identity = exports.equals = exports.extend = exports.forEach = exports.toJson = exports.fromJson = exports.root = void 0;
	/**
	 * Random utility functions used in the UI-Router code
	 *
	 * These functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 * @preferred
	 */
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var coreservices_1 = __webpack_require__(5);
	exports.root = (typeof self === 'object' && self.self === self && self) ||
	    (typeof global === 'object' && global.global === global && global) ||
	    this;
	var angular = exports.root.angular || {};
	exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
	exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
	exports.forEach = angular.forEach || _forEach;
	exports.extend = Object.assign || _extend;
	exports.equals = angular.equals || _equals;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	function noop() { }
	exports.noop = noop;
	/**
	 * Builds proxy functions on the `to` object which pass through to the `from` object.
	 *
	 * For each key in `fnNames`, creates a proxy function on the `to` object.
	 * The proxy function calls the real function on the `from` object.
	 *
	 *
	 * #### Example:
	 * This example creates an new class instance whose functions are prebound to the new'd object.
	 * ```js
	 * class Foo {
	 *   constructor(data) {
	 *     // Binds all functions from Foo.prototype to 'this',
	 *     // then copies them to 'this'
	 *     bindFunctions(Foo.prototype, this, this);
	 *     this.data = data;
	 *   }
	 *
	 *   log() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * let myFoo = new Foo([1,2,3]);
	 * var logit = myFoo.log;
	 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
	 * ```
	 *
	 * #### Example:
	 * This example creates a bound version of a service function, and copies it to another object
	 * ```
	 *
	 * var SomeService = {
	 *   this.data = [3, 4, 5];
	 *   this.log = function() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * // Constructor fn
	 * function OtherThing() {
	 *   // Binds all functions from SomeService to SomeService,
	 *   // then copies them to 'this'
	 *   bindFunctions(SomeService, this, SomeService);
	 * }
	 *
	 * let myOtherThing = new OtherThing();
	 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
	 * ```
	 *
	 * @param source A function that returns the source object which contains the original functions to be bound
	 * @param target A function that returns the target object which will receive the bound functions
	 * @param bind A function that returns the object which the functions will be bound to
	 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
	 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
	 */
	function createProxyFunctions(source, target, bind, fnNames, latebind) {
	    if (latebind === void 0) { latebind = false; }
	    var bindFunction = function (fnName) { return source()[fnName].bind(bind()); };
	    var makeLateRebindFn = function (fnName) {
	        return function lateRebindFunction() {
	            target[fnName] = bindFunction(fnName);
	            return target[fnName].apply(null, arguments);
	        };
	    };
	    fnNames = fnNames || Object.keys(source());
	    return fnNames.reduce(function (acc, name) {
	        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
	        return acc;
	    }, target);
	}
	exports.createProxyFunctions = createProxyFunctions;
	/**
	 * prototypal inheritance helper.
	 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
	 */
	exports.inherit = function (parent, extra) { return exports.extend(Object.create(parent), extra); };
	/** Given an array, returns true if the object is found in the array, (using indexOf) */
	exports.inArray = hof_1.curry(_inArray);
	function _inArray(array, obj) {
	    return array.indexOf(obj) !== -1;
	}
	exports._inArray = _inArray;
	/**
	 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
	 * The same array is returned
	 */
	exports.removeFrom = hof_1.curry(_removeFrom);
	function _removeFrom(array, obj) {
	    var idx = array.indexOf(obj);
	    if (idx >= 0)
	        array.splice(idx, 1);
	    return array;
	}
	exports._removeFrom = _removeFrom;
	/** pushes a values to an array and returns the value */
	exports.pushTo = hof_1.curry(_pushTo);
	function _pushTo(arr, val) {
	    return arr.push(val), val;
	}
	exports._pushTo = _pushTo;
	/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
	exports.deregAll = function (functions) {
	    return functions.slice().forEach(function (fn) {
	        typeof fn === 'function' && fn();
	        exports.removeFrom(functions, fn);
	    });
	};
	/**
	 * Applies a set of defaults to an options object.  The options object is filtered
	 * to only those properties of the objects in the defaultsList.
	 * Earlier objects in the defaultsList take precedence when applying defaults.
	 */
	function defaults(opts) {
	    var defaultsList = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        defaultsList[_i - 1] = arguments[_i];
	    }
	    var defaultVals = exports.extend.apply(void 0, __spreadArrays([{}], defaultsList.reverse()));
	    return exports.extend(defaultVals, pick(opts || {}, Object.keys(defaultVals)));
	}
	exports.defaults = defaults;
	/** Reduce function that merges each element of the list into a single object, using extend */
	exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	    var path = [];
	    // tslint:disable-next-line:forin
	    for (var n in first.path) {
	        if (first.path[n] !== second.path[n])
	            break;
	        path.push(first.path[n]);
	    }
	    return path;
	}
	exports.ancestors = ancestors;
	/**
	 * Return a copy of the object only containing the whitelisted properties.
	 *
	 * #### Example:
	 * ```
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the whitelisted property names
	 */
	function pick(obj, propNames) {
	    var objCopy = {};
	    for (var _prop in obj) {
	        if (propNames.indexOf(_prop) !== -1) {
	            objCopy[_prop] = obj[_prop];
	        }
	    }
	    return objCopy;
	}
	exports.pick = pick;
	/**
	 * Return a copy of the object omitting the blacklisted properties.
	 *
	 * @example
	 * ```
	 *
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = omit(foo, ['a', 'b']); // { c: 3 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the blacklisted property names
	 */
	function omit(obj, propNames) {
	    return Object.keys(obj)
	        .filter(hof_1.not(exports.inArray(propNames)))
	        .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
	}
	exports.omit = omit;
	/**
	 * Maps an array, or object to a property (by name)
	 */
	function pluck(collection, propName) {
	    return map(collection, hof_1.prop(propName));
	}
	exports.pluck = pluck;
	/** Filters an Array or an Object's properties based on a predicate */
	function filter(collection, callback) {
	    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
	    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return (result[key] = x); };
	    exports.forEach(collection, function (item, i) {
	        if (callback(item, i))
	            accept(item, i);
	    });
	    return result;
	}
	exports.filter = filter;
	/** Finds an object from an array, or a property of an object, that matches a predicate */
	function find(collection, callback) {
	    var result;
	    exports.forEach(collection, function (item, i) {
	        if (result)
	            return;
	        if (callback(item, i))
	            result = item;
	    });
	    return result;
	}
	exports.find = find;
	/** Given an object, returns a new object, where each property is transformed by the callback function */
	exports.mapObj = map;
	/** Maps an array or object properties using a callback function */
	function map(collection, callback, target) {
	    target = target || (predicates_1.isArray(collection) ? [] : {});
	    exports.forEach(collection, function (item, i) { return (target[i] = callback(item, i)); });
	    return target;
	}
	exports.map = map;
	/**
	 * Given an object, return its enumerable property values
	 *
	 * @example
	 * ```
	 *
	 * let foo = { a: 1, b: 2, c: 3 }
	 * let vals = values(foo); // [ 1, 2, 3 ]
	 * ```
	 */
	exports.values = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
	/**
	 * Reduce function that returns true if all of the values are truthy.
	 *
	 * @example
	 * ```
	 *
	 * let vals = [ 1, true, {}, "hello world"];
	 * vals.reduce(allTrueR, true); // true
	 *
	 * vals.push(0);
	 * vals.reduce(allTrueR, true); // false
	 * ```
	 */
	exports.allTrueR = function (memo, elem) { return memo && elem; };
	/**
	 * Reduce function that returns true if any of the values are truthy.
	 *
	 *  * @example
	 * ```
	 *
	 * let vals = [ 0, null, undefined ];
	 * vals.reduce(anyTrueR, true); // false
	 *
	 * vals.push("hello world");
	 * vals.reduce(anyTrueR, true); // true
	 * ```
	 */
	exports.anyTrueR = function (memo, elem) { return memo || elem; };
	/**
	 * Reduce function which un-nests a single level of arrays
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnestR = function (memo, elem) { return memo.concat(elem); };
	/**
	 * Reduce function which recursively un-nests all arrays
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flattenR = function (memo, elem) {
	    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
	};
	/**
	 * Reduce function that pushes an object to an array, then returns the array.
	 * Mostly just for [[flattenR]] and [[uniqR]]
	 */
	function pushR(arr, obj) {
	    arr.push(obj);
	    return arr;
	}
	exports.pushR = pushR;
	/** Reduce function that filters out duplicates */
	exports.uniqR = function (acc, token) { return (exports.inArray(acc, token) ? acc : pushR(acc, token)); };
	/**
	 * Return a new array with a single level of arrays unnested.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
	/**
	 * Return a completely flattened version of an array.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
	/**
	 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
	 * @example
	 * ```
	 *
	 * let isNumber = (obj) => typeof(obj) === 'number';
	 * let allNumbers = [ 1, 2, 3, 4, 5 ];
	 * allNumbers.filter(assertPredicate(isNumber)); //OK
	 *
	 * let oneString = [ 1, 2, 3, 4, "5" ];
	 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
	 * ```
	 */
	exports.assertPredicate = assertFn;
	/**
	 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
	 * @example
	 * ```
	 *
	 * var data = { foo: 1, bar: 2 };
	 *
	 * let keys = [ 'foo', 'bar' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // values is [1, 2]
	 *
	 * let keys = [ 'foo', 'bar', 'baz' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // throws Error("Key not found")
	 * ```
	 */
	exports.assertMap = assertFn;
	function assertFn(predicateOrMap, errMsg) {
	    if (errMsg === void 0) { errMsg = 'assert failure'; }
	    return function (obj) {
	        var result = predicateOrMap(obj);
	        if (!result) {
	            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
	        }
	        return result;
	    };
	}
	exports.assertFn = assertFn;
	/**
	 * Like _.pairs: Given an object, returns an array of key/value pairs
	 *
	 * @example
	 * ```
	 *
	 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
	 * ```
	 */
	exports.pairs = function (obj) { return Object.keys(obj).map(function (key) { return [key, obj[key]]; }); };
	/**
	 * Given two or more parallel arrays, returns an array of tuples where
	 * each tuple is composed of [ a[i], b[i], ... z[i] ]
	 *
	 * @example
	 * ```
	 *
	 * let foo = [ 0, 2, 4, 6 ];
	 * let bar = [ 1, 3, 5, 7 ];
	 * let baz = [ 10, 30, 50, 70 ];
	 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
	 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
	 * ```
	 */
	function arrayTuples() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    if (args.length === 0)
	        return [];
	    var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
	    var result = [];
	    var _loop_1 = function (i) {
	        // This is a hot function
	        // Unroll when there are 1-4 arguments
	        switch (args.length) {
	            case 1:
	                result.push([args[0][i]]);
	                break;
	            case 2:
	                result.push([args[0][i], args[1][i]]);
	                break;
	            case 3:
	                result.push([args[0][i], args[1][i], args[2][i]]);
	                break;
	            case 4:
	                result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
	                break;
	            default:
	                result.push(args.map(function (array) { return array[i]; }));
	                break;
	        }
	    };
	    for (var i = 0; i < maxArrayLen; i++) {
	        _loop_1(i);
	    }
	    return result;
	}
	exports.arrayTuples = arrayTuples;
	/**
	 * Reduce function which builds an object from an array of [key, value] pairs.
	 *
	 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
	 *
	 * Each keyValueTuple should be an array with values [ key: string, value: any ]
	 *
	 * @example
	 * ```
	 *
	 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
	 *
	 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 *
	 * // Or, more simply:
	 * var pairsToObj = pairs.reduce(applyPairs, {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 * ```
	 */
	function applyPairs(memo, keyValTuple) {
	    var key, value;
	    if (predicates_1.isArray(keyValTuple))
	        key = keyValTuple[0], value = keyValTuple[1];
	    if (!predicates_1.isString(key))
	        throw new Error('invalid parameters to applyPairs');
	    memo[key] = value;
	    return memo;
	}
	exports.applyPairs = applyPairs;
	/** Get the last element of an array */
	function tail(arr) {
	    return (arr.length && arr[arr.length - 1]) || undefined;
	}
	exports.tail = tail;
	/**
	 * shallow copy from src to dest
	 */
	function copy(src, dest) {
	    if (dest)
	        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
	    if (!dest)
	        dest = {};
	    return exports.extend(dest, src);
	}
	exports.copy = copy;
	/** Naive forEach implementation works with Objects or Arrays */
	function _forEach(obj, cb, _this) {
	    if (predicates_1.isArray(obj))
	        return obj.forEach(cb, _this);
	    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
	}
	function _extend(toObj) {
	    for (var i = 1; i < arguments.length; i++) {
	        var obj = arguments[i];
	        if (!obj)
	            continue;
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; j++) {
	            toObj[keys[j]] = obj[keys[j]];
	        }
	    }
	    return toObj;
	}
	exports._extend = _extend;
	function _equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2;
	    if (t1 !== t2 || t1 !== 'object')
	        return false;
	    var tup = [o1, o2];
	    if (hof_1.all(predicates_1.isArray)(tup))
	        return _arraysEq(o1, o2);
	    if (hof_1.all(predicates_1.isDate)(tup))
	        return o1.getTime() === o2.getTime();
	    if (hof_1.all(predicates_1.isRegExp)(tup))
	        return o1.toString() === o2.toString();
	    if (hof_1.all(predicates_1.isFunction)(tup))
	        return true; // meh
	    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
	    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
	        return false;
	    var keys = {};
	    // tslint:disable-next-line:forin
	    for (var key in o1) {
	        if (!_equals(o1[key], o2[key]))
	            return false;
	        keys[key] = true;
	    }
	    for (var key in o2) {
	        if (!keys[key])
	            return false;
	    }
	    return true;
	}
	function _arraysEq(a1, a2) {
	    if (a1.length !== a2.length)
	        return false;
	    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
	}
	// issue #2676
	exports.silenceUncaughtInPromise = function (promise) { return promise.catch(function (e) { return 0; }) && promise; };
	exports.silentRejection = function (error) { return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error)); };
	//# sourceMappingURL=common.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isPromise = exports.isInjectable = exports.isRegExp = exports.isDate = exports.isArray = exports.isObject = exports.isString = exports.isNumber = exports.isFunction = exports.isNullOrUndefined = exports.isNull = exports.isDefined = exports.isUndefined = void 0;
	/**
	 * Predicates
	 *
	 * These predicates return true/false based on the input.
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(3);
	var toStr = Object.prototype.toString;
	var tis = function (t) { return function (x) { return typeof x === t; }; };
	exports.isUndefined = tis('undefined');
	exports.isDefined = hof_1.not(exports.isUndefined);
	exports.isNull = function (o) { return o === null; };
	exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
	exports.isFunction = tis('function');
	exports.isNumber = tis('number');
	exports.isString = tis('string');
	exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
	exports.isArray = Array.isArray;
	exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
	exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
	/**
	 * Predicate which checks if a value is injectable
	 *
	 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
	 * where all the elements in the array are Strings, except the last one, which is a Function
	 */
	function isInjectable(val) {
	    if (exports.isArray(val) && val.length) {
	        var head = val.slice(0, -1), tail = val.slice(-1);
	        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
	    }
	    return exports.isFunction(val);
	}
	exports.isInjectable = isInjectable;
	/**
	 * Predicate which checks if a value looks like a Promise
	 *
	 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
	 */
	exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
	//# sourceMappingURL=predicates.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Higher order functions
	 *
	 * These utility functions are exported, but are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pattern = exports.invoke = exports.val = exports.eq = exports.is = exports.any = exports.all = exports.or = exports.and = exports.not = exports.parse = exports.propEq = exports.prop = exports.pipe = exports.compose = exports.curry = void 0;
	/**
	 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
	 *
	 * Given a function with N parameters, returns a new function that supports partial application.
	 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
	 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
	 * accept more parameters until all N parameters have been supplied.
	 *
	 *
	 * This contrived example uses a partially applied function as an predicate, which returns true
	 * if an object is found in both arrays.
	 * @example
	 * ```
	 * // returns true if an object is in both of the two arrays
	 * function inBoth(array1, array2, object) {
	 *   return array1.indexOf(object) !== -1 &&
	 *          array2.indexOf(object) !== 1;
	 * }
	 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
	 * let foos = [obj1, obj3]
	 * let bars = [obj3, obj4, obj5]
	 *
	 * // A curried "copy" of inBoth
	 * let curriedInBoth = curry(inBoth);
	 * // Partially apply both the array1 and array2
	 * let inFoosAndBars = curriedInBoth(foos, bars);
	 *
	 * // Supply the final argument; since all arguments are
	 * // supplied, the original inBoth function is then called.
	 * let obj1InBoth = inFoosAndBars(obj1); // false
	 *
	 * // Use the inFoosAndBars as a predicate.
	 * // Filter, on each iteration, supplies the final argument
	 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
	 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
	 *
	 * ```
	 *
	 * @param fn
	 * @returns {*|function(): (*|any)}
	 */
	function curry(fn) {
	    return function curried() {
	        if (arguments.length >= fn.length) {
	            return fn.apply(this, arguments);
	        }
	        var args = Array.prototype.slice.call(arguments);
	        return curried.bind.apply(curried, __spreadArrays([this], args));
	    };
	}
	exports.curry = curry;
	/**
	 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
	 * given: f(x), g(x), h(x)
	 * let composed = compose(f,g,h)
	 * then, composed is: f(g(h(x)))
	 */
	function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start, result = args[start].apply(this, arguments);
	        while (i--)
	            result = args[i].call(this, result);
	        return result;
	    };
	}
	exports.compose = compose;
	/**
	 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
	 * given: f(x), g(x), h(x)
	 * let piped = pipe(f,g,h);
	 * then, piped is: h(g(f(x)))
	 */
	function pipe() {
	    var funcs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        funcs[_i] = arguments[_i];
	    }
	    return compose.apply(null, [].slice.call(arguments).reverse());
	}
	exports.pipe = pipe;
	/**
	 * Given a property name, returns a function that returns that property from an object
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = prop("name");
	 * getName(obj) === "blarg"
	 */
	exports.prop = function (name) { return function (obj) { return obj && obj[name]; }; };
	/**
	 * Given a property name and a value, returns a function that returns a boolean based on whether
	 * the passed object has a property that matches the value
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = propEq("name", "blarg");
	 * getName(obj) === true
	 */
	exports.propEq = curry(function (name, _val, obj) { return obj && obj[name] === _val; });
	/**
	 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
	 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
	 * let getName = prop("nestedObj.name");
	 * getName(obj) === "blarg"
	 * let propNotFound = prop("this.property.doesnt.exist");
	 * propNotFound(obj) === undefined
	 */
	exports.parse = function (name) { return pipe.apply(null, name.split('.').map(exports.prop)); };
	/**
	 * Given a function that returns a truthy or falsey value, returns a
	 * function that returns the opposite (falsey or truthy) value given the same inputs
	 */
	exports.not = function (fn) { return function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return !fn.apply(null, args);
	}; };
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if both functions return truthy for the given arguments
	 */
	function and(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) && fn2.apply(null, args);
	    };
	}
	exports.and = and;
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if at least one of the functions returns truthy for the given arguments
	 */
	function or(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) || fn2.apply(null, args);
	    };
	}
	exports.or = or;
	/**
	 * Check if all the elements of an array match a predicate function
	 *
	 * @param fn1 a predicate function `fn1`
	 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
	 */
	exports.all = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); }; };
	// tslint:disable-next-line:variable-name
	exports.any = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); }; };
	/** Given a class, returns a Predicate function that returns true if the object is of that class */
	exports.is = function (ctor) { return function (obj) {
	    return (obj != null && obj.constructor === ctor) || obj instanceof ctor;
	}; };
	/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
	exports.eq = function (value) { return function (other) { return value === other; }; };
	/** Given a value, returns a function which returns the value */
	exports.val = function (v) { return function () { return v; }; };
	function invoke(fnName, args) {
	    return function (obj) { return obj[fnName].apply(obj, args); };
	}
	exports.invoke = invoke;
	/**
	 * Sorta like Pattern Matching (a functional programming conditional construct)
	 *
	 * See http://c2.com/cgi/wiki?PatternMatching
	 *
	 * This is a conditional construct which allows a series of predicates and output functions
	 * to be checked and then applied.  Each predicate receives the input.  If the predicate
	 * returns truthy, then its matching output function (mapping function) is provided with
	 * the input and, then the result is returned.
	 *
	 * Each combination (2-tuple) of predicate + output function should be placed in an array
	 * of size 2: [ predicate, mapFn ]
	 *
	 * These 2-tuples should be put in an outer array.
	 *
	 * @example
	 * ```
	 *
	 * // Here's a 2-tuple where the first element is the isString predicate
	 * // and the second element is a function that returns a description of the input
	 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
	 *
	 * // Second tuple: predicate "isNumber", mapfn returns a description
	 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
	 *
	 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
	 *
	 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
	 *
	 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
	 *
	 * console.log(descriptionOf(undefined)); // 'notdefined'
	 * console.log(descriptionOf(55)); // '(55) That's a number!'
	 * console.log(descriptionOf("foo")); // 'Here's your string foo'
	 * ```
	 *
	 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
	 * with a Predicate and a mapping/output function
	 * @returns {function(any): *}
	 */
	function pattern(struct) {
	    return function (x) {
	        for (var i = 0; i < struct.length; i++) {
	            if (struct[i][0](x))
	                return struct[i][1](x);
	        }
	    };
	}
	exports.pattern = pattern;
	//# sourceMappingURL=hof.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(1), exports);
	__exportStar(__webpack_require__(5), exports);
	__exportStar(__webpack_require__(33), exports);
	__exportStar(__webpack_require__(3), exports);
	__exportStar(__webpack_require__(2), exports);
	__exportStar(__webpack_require__(34), exports);
	__exportStar(__webpack_require__(6), exports);
	__exportStar(__webpack_require__(8), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.services = exports.makeStub = void 0;
	var noImpl = function (fnname) { return function () {
	    throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
	}; };
	exports.makeStub = function (service, methods) {
	    return methods.reduce(function (acc, key) { return ((acc[key] = noImpl(service + "." + key + "()")), acc); }, {});
	};
	var services = {
	    $q: undefined,
	    $injector: undefined,
	};
	exports.services = services;
	//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Functions that manipulate strings
	 *
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @packageDocumentation
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.joinNeighborsR = exports.splitOnDelim = exports.trimHashVal = exports.splitEqual = exports.splitQuery = exports.splitHash = exports.stripLastPathElement = exports.hostRegex = exports.beforeAfterSubstr = exports.stringify = exports.fnToString = exports.functionToString = exports.kebobString = exports.padString = exports.maxLength = void 0;
	var predicates_1 = __webpack_require__(2);
	var rejectFactory_1 = __webpack_require__(11);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	/**
	 * Returns a string shortened to a maximum length
	 *
	 * If the string is already less than the `max` length, return the string.
	 * Else return the string, shortened to `max - 3` and append three dots ("...").
	 *
	 * @param max the maximum length of the string to return
	 * @param str the input string
	 */
	function maxLength(max, str) {
	    if (str.length <= max)
	        return str;
	    return str.substr(0, max - 3) + '...';
	}
	exports.maxLength = maxLength;
	/**
	 * Returns a string, with spaces added to the end, up to a desired str length
	 *
	 * If the string is already longer than the desired length, return the string.
	 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
	 *
	 * @param length the desired length of the string to return
	 * @param str the input string
	 */
	function padString(length, str) {
	    while (str.length < length)
	        str += ' ';
	    return str;
	}
	exports.padString = padString;
	function kebobString(camelCase) {
	    return camelCase
	        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
	        .replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); }); // replace rest
	}
	exports.kebobString = kebobString;
	function functionToString(fn) {
	    var fnStr = fnToString(fn);
	    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
	    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
	    var fnName = fn['name'] || '';
	    if (fnName && toStr.match(/function \(/)) {
	        return 'function ' + fnName + toStr.substr(9);
	    }
	    return toStr;
	}
	exports.functionToString = functionToString;
	function fnToString(fn) {
	    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
	    return (_fn && _fn.toString()) || 'undefined';
	}
	exports.fnToString = fnToString;
	function stringify(o) {
	    var seen = [];
	    var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
	    var hasToString = function (obj) {
	        return predicates_1.isObject(obj) && !predicates_1.isArray(obj) && obj.constructor !== Object && predicates_1.isFunction(obj.toString);
	    };
	    var stringifyPattern = hof_1.pattern([
	        [predicates_1.isUndefined, hof_1.val('undefined')],
	        [predicates_1.isNull, hof_1.val('null')],
	        [predicates_1.isPromise, hof_1.val('[Promise]')],
	        [isRejection, function (x) { return x._transitionRejection.toString(); }],
	        [hasToString, function (x) { return x.toString(); }],
	        [predicates_1.isInjectable, functionToString],
	        [hof_1.val(true), common_1.identity],
	    ]);
	    function format(value) {
	        if (predicates_1.isObject(value)) {
	            if (seen.indexOf(value) !== -1)
	                return '[circular ref]';
	            seen.push(value);
	        }
	        return stringifyPattern(value);
	    }
	    if (predicates_1.isUndefined(o)) {
	        // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
	        // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
	        // manually stringifying it.
	        return format(o);
	    }
	    return JSON.stringify(o, function (key, value) { return format(value); }).replace(/\\"/g, '"');
	}
	exports.stringify = stringify;
	/** Returns a function that splits a string on a character or substring */
	exports.beforeAfterSubstr = function (char) {
	    return function (str) {
	        if (!str)
	            return ['', ''];
	        var idx = str.indexOf(char);
	        if (idx === -1)
	            return [str, ''];
	        return [str.substr(0, idx), str.substr(idx + 1)];
	    };
	};
	exports.hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
	exports.stripLastPathElement = function (str) { return str.replace(/\/[^/]*$/, ''); };
	exports.splitHash = exports.beforeAfterSubstr('#');
	exports.splitQuery = exports.beforeAfterSubstr('?');
	exports.splitEqual = exports.beforeAfterSubstr('=');
	exports.trimHashVal = function (str) { return (str ? str.replace(/^#/, '') : ''); };
	/**
	 * Splits on a delimiter, but returns the delimiters in the array
	 *
	 * #### Example:
	 * ```js
	 * var splitOnSlashes = splitOnDelim('/');
	 * splitOnSlashes("/foo"); // ["/", "foo"]
	 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
	 * ```
	 */
	function splitOnDelim(delim) {
	    var re = new RegExp('(' + delim + ')', 'g');
	    return function (str) { return str.split(re).filter(common_1.identity); };
	}
	exports.splitOnDelim = splitOnDelim;
	/**
	 * Reduce fn that joins neighboring strings
	 *
	 * Given an array of strings, returns a new array
	 * where all neighboring strings have been joined.
	 *
	 * #### Example:
	 * ```js
	 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
	 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
	 * ```
	 */
	function joinNeighborsR(acc, x) {
	    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
	        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
	    return common_1.pushR(acc, x);
	}
	exports.joinNeighborsR = joinNeighborsR;
	//# sourceMappingURL=strings.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.trace = exports.Trace = exports.Category = void 0;
	/**
	 * # Transition tracing (debug)
	 *
	 * Enable transition tracing to print transition information to the console,
	 * in order to help debug your application.
	 * Tracing logs detailed information about each Transition to your console.
	 *
	 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
	 *
	 * ### ES6
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
	 * ```
	 *
	 * ### CJS
	 * ```js
	 * let trace = require("@uirouter/core").trace;
	 * trace.enable("TRANSITION", "VIEWCONFIG");
	 * ```
	 *
	 * ### Globals
	 * ```js
	 * let trace = window["@uirouter/core"].trace;
	 * trace.enable(); // Trace everything (very verbose)
	 * ```
	 *
	 * ### Angular 1:
	 * ```js
	 * app.run($trace => $trace.enable());
	 * ```
	 *
	 * @packageDocumentation
	 */
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var safeConsole_1 = __webpack_require__(50);
	function uiViewString(uiview) {
	    if (!uiview)
	        return 'ui-view (defunct)';
	    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
	    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
	}
	var viewConfigString = function (viewConfig) {
	    var view = viewConfig.viewDecl;
	    var state = view.$context.name || '(root)';
	    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
	};
	function normalizedCat(input) {
	    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
	}
	/**
	 * Trace categories Enum
	 *
	 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
	 *
	 * `trace.enable(Category.TRANSITION)`
	 *
	 * These can also be provided using a matching string, or position ordinal
	 *
	 * `trace.enable("TRANSITION")`
	 *
	 * `trace.enable(1)`
	 */
	var Category;
	(function (Category) {
	    Category[Category["RESOLVE"] = 0] = "RESOLVE";
	    Category[Category["TRANSITION"] = 1] = "TRANSITION";
	    Category[Category["HOOK"] = 2] = "HOOK";
	    Category[Category["UIVIEW"] = 3] = "UIVIEW";
	    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
	})(Category || (Category = {}));
	exports.Category = Category;
	var _tid = hof_1.parse('$id');
	var _rid = hof_1.parse('router.$id');
	var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
	/**
	 * Prints UI-Router Transition trace information to the console.
	 */
	var Trace = /** @class */ (function () {
	    /** @internal */
	    function Trace() {
	        /** @internal */
	        this._enabled = {};
	        this.approximateDigests = 0;
	    }
	    /** @internal */
	    Trace.prototype._set = function (enabled, categories) {
	        var _this = this;
	        if (!categories.length) {
	            categories = Object.keys(Category)
	                .map(function (k) { return parseInt(k, 10); })
	                .filter(function (k) { return !isNaN(k); })
	                .map(function (key) { return Category[key]; });
	        }
	        categories.map(normalizedCat).forEach(function (category) { return (_this._enabled[category] = enabled); });
	    };
	    Trace.prototype.enable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(true, categories);
	    };
	    Trace.prototype.disable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(false, categories);
	    };
	    /**
	     * Retrieves the enabled stateus of a [[Category]]
	     *
	     * ```js
	     * trace.enabled("VIEWCONFIG"); // true or false
	     * ```
	     *
	     * @returns boolean true if the category is enabled
	     */
	    Trace.prototype.enabled = function (category) {
	        return !!this._enabled[normalizedCat(category)];
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionStart = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceTransitionIgnored = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookInvocation = function (step, trans, options) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.functionToString(step.registeredHook.callback);
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvePath = function (path, when, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceError = function (reason, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceSuccess = function (finalState, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        safeConsole_1.safeConsole.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
	        if (extra === void 0) { extra = ''; }
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        safeConsole_1.safeConsole.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceUIViewFill = function (viewData, html) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Fill', viewData, " with: " + strings_1.maxLength(200, html));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewSync = function (pairs) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        var uivheader = 'uiview component fqn';
	        var cfgheader = 'view config state (view name)';
	        var mapping = pairs
	            .map(function (_a) {
	            var _b;
	            var uiView = _a.uiView, viewConfig = _a.viewConfig;
	            var uiv = uiView && uiView.fqn;
	            var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
	            return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
	        })
	            .sort(function (a, b) { return (a[uivheader] || '').localeCompare(b[uivheader] || ''); });
	        safeConsole_1.safeConsole.table(mapping);
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
	    };
	    /** @internal called by ui-router code */
	    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        safeConsole_1.safeConsole.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
	    };
	    return Trace;
	}());
	exports.Trace = Trace;
	/**
	 * The [[Trace]] singleton
	 *
	 * #### Example:
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5);
	 * ```
	 */
	var trace = new Trace();
	exports.trace = trace;
	//# sourceMappingURL=trace.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(141);
	module.exports = angular;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHookScope = exports.TransitionHookPhase = void 0;
	var TransitionHookPhase;
	(function (TransitionHookPhase) {
	    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
	    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
	    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
	    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
	    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
	})(TransitionHookPhase || (TransitionHookPhase = {}));
	exports.TransitionHookPhase = TransitionHookPhase;
	var TransitionHookScope;
	(function (TransitionHookScope) {
	    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
	    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
	})(TransitionHookScope || (TransitionHookScope = {}));
	exports.TransitionHookScope = TransitionHookScope;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Rejection = exports.RejectType = void 0;
	var common_1 = __webpack_require__(1);
	var strings_1 = __webpack_require__(6);
	var hof_1 = __webpack_require__(3);
	/** An enum for Transition Rejection reasons */
	var RejectType;
	(function (RejectType) {
	    /**
	     * A new transition superseded this one.
	     *
	     * While this transition was running, a new transition started.
	     * This transition is cancelled because it was superseded by new transition.
	     */
	    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
	    /**
	     * The transition was aborted
	     *
	     * The transition was aborted by a hook which returned `false`
	     */
	    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
	    /**
	     * The transition was invalid
	     *
	     * The transition was never started because it was invalid
	     */
	    RejectType[RejectType["INVALID"] = 4] = "INVALID";
	    /**
	     * The transition was ignored
	     *
	     * The transition was ignored because it would have no effect.
	     *
	     * Either:
	     *
	     * - The transition is targeting the current state and parameter values
	     * - The transition is targeting the same state and parameter values as the currently running transition.
	     */
	    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
	    /**
	     * The transition errored.
	     *
	     * This generally means a hook threw an error or returned a rejected promise
	     */
	    RejectType[RejectType["ERROR"] = 6] = "ERROR";
	})(RejectType || (RejectType = {}));
	exports.RejectType = RejectType;
	/** @internal */
	var id = 0;
	var Rejection = /** @class */ (function () {
	    function Rejection(type, message, detail) {
	        /** @internal */
	        this.$id = id++;
	        this.type = type;
	        this.message = message;
	        this.detail = detail;
	    }
	    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
	    Rejection.isRejectionPromise = function (obj) {
	        return obj && typeof obj.then === 'function' && hof_1.is(Rejection)(obj._transitionRejection);
	    };
	    /** Returns a Rejection due to transition superseded */
	    Rejection.superseded = function (detail, options) {
	        var message = 'The transition has been superseded by a different transition';
	        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
	        if (options && options.redirected) {
	            rejection.redirected = true;
	        }
	        return rejection;
	    };
	    /** Returns a Rejection due to redirected transition */
	    Rejection.redirected = function (detail) {
	        return Rejection.superseded(detail, { redirected: true });
	    };
	    /** Returns a Rejection due to invalid transition */
	    Rejection.invalid = function (detail) {
	        var message = 'This transition is invalid';
	        return new Rejection(RejectType.INVALID, message, detail);
	    };
	    /** Returns a Rejection due to ignored transition */
	    Rejection.ignored = function (detail) {
	        var message = 'The transition was ignored';
	        return new Rejection(RejectType.IGNORED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.aborted = function (detail) {
	        var message = 'The transition has been aborted';
	        return new Rejection(RejectType.ABORTED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.errored = function (detail) {
	        var message = 'The transition errored';
	        return new Rejection(RejectType.ERROR, message, detail);
	    };
	    /**
	     * Returns a Rejection
	     *
	     * Normalizes a value as a Rejection.
	     * If the value is already a Rejection, returns it.
	     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
	     *
	     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
	     */
	    Rejection.normalize = function (detail) {
	        return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
	    };
	    Rejection.prototype.toString = function () {
	        var detailString = function (d) { return (d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d)); };
	        var detail = detailString(this.detail);
	        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
	        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
	    };
	    Rejection.prototype.toPromise = function () {
	        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
	    };
	    return Rejection;
	}());
	exports.Rejection = Rejection;
	//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(146)
	var ieee754 = __webpack_require__(197)
	var isArray = __webpack_require__(82)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjdetalleModalController = function () {
	  DdjjdetalleModalController.$inject = ["$uibModalInstance", "data", "$sce", "DataService", "$log"];
	  function DdjjdetalleModalController($uibModalInstance, data, $sce, DataService, $log) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjdetalleModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.DataService = DataService;
	    this.$log = $log;
	  }
	
	  _createClass(DdjjdetalleModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.selected = {
	        item: this.items[0]
	      };
	      this.urlPdf = this.items.urlPdf;
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close(this.selected.item);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return DdjjdetalleModalController;
	}();
	
	exports.default = DdjjdetalleModalController;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-file-pdf-o\"></i>{{title}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <iframe ng-src=\"{{$ctrl.urlPdf}}\" style=\"width:100%; height:550px;\" frameborder=\"0\">\n    <p>Su navegador no soporta iframe</p>\n  </iframe>\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>"

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(30);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(19));
	util.inherits = __webpack_require__(20);
	/*</replacement>*/
	
	var Readable = __webpack_require__(95);
	var Writable = __webpack_require__(97);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Param = exports.DefType = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var coreservices_1 = __webpack_require__(5);
	var paramType_1 = __webpack_require__(36);
	var hasOwn = Object.prototype.hasOwnProperty;
	var isShorthand = function (cfg) {
	    return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
	};
	var DefType;
	(function (DefType) {
	    DefType[DefType["PATH"] = 0] = "PATH";
	    DefType[DefType["SEARCH"] = 1] = "SEARCH";
	    DefType[DefType["CONFIG"] = 2] = "CONFIG";
	})(DefType || (DefType = {}));
	exports.DefType = DefType;
	function getParamDeclaration(paramName, location, state) {
	    var noReloadOnSearch = (state.reloadOnSearch === false && location === DefType.SEARCH) || undefined;
	    var dynamic = common_1.find([state.dynamic, noReloadOnSearch], predicates_1.isDefined);
	    var defaultConfig = predicates_1.isDefined(dynamic) ? { dynamic: dynamic } : {};
	    var paramConfig = unwrapShorthand(state && state.params && state.params[paramName]);
	    return common_1.extend(defaultConfig, paramConfig);
	}
	function unwrapShorthand(cfg) {
	    cfg = isShorthand(cfg) ? { value: cfg } : cfg;
	    getStaticDefaultValue['__cacheable'] = true;
	    function getStaticDefaultValue() {
	        return cfg.value;
	    }
	    var $$fn = predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue;
	    return common_1.extend(cfg, { $$fn: $$fn });
	}
	function getType(cfg, urlType, location, id, paramTypes) {
	    if (cfg.type && urlType && urlType.name !== 'string')
	        throw new Error("Param '" + id + "' has two type configurations.");
	    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
	        return paramTypes.type(cfg.type);
	    if (urlType)
	        return urlType;
	    if (!cfg.type) {
	        var type = location === DefType.CONFIG
	            ? 'any'
	            : location === DefType.PATH
	                ? 'path'
	                : location === DefType.SEARCH
	                    ? 'query'
	                    : 'string';
	        return paramTypes.type(type);
	    }
	    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
	}
	/** returns false, true, or the squash value to indicate the "default parameter url squash policy". */
	function getSquashPolicy(config, isOptional, defaultPolicy) {
	    var squash = config.squash;
	    if (!isOptional || squash === false)
	        return false;
	    if (!predicates_1.isDefined(squash) || squash == null)
	        return defaultPolicy;
	    if (squash === true || predicates_1.isString(squash))
	        return squash;
	    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	}
	function getReplace(config, arrayMode, isOptional, squash) {
	    var defaultPolicy = [
	        { from: '', to: isOptional || arrayMode ? undefined : '' },
	        { from: null, to: isOptional || arrayMode ? undefined : '' },
	    ];
	    var replace = predicates_1.isArray(config.replace) ? config.replace : [];
	    if (predicates_1.isString(squash))
	        replace.push({ from: squash, to: undefined });
	    var configuredKeys = common_1.map(replace, hof_1.prop('from'));
	    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
	}
	var Param = /** @class */ (function () {
	    function Param(id, type, location, urlConfig, state) {
	        var config = getParamDeclaration(id, location, state);
	        type = getType(config, type, location, id, urlConfig.paramTypes);
	        var arrayMode = getArrayMode();
	        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
	        var isOptional = config.value !== undefined || location === DefType.SEARCH;
	        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
	        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
	        var squash = getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
	        var replace = getReplace(config, arrayMode, isOptional, squash);
	        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
	        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	        function getArrayMode() {
	            var arrayDefaults = { array: location === DefType.SEARCH ? 'auto' : false };
	            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
	        }
	        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
	    }
	    Param.values = function (params, values) {
	        if (values === void 0) { values = {}; }
	        var paramValues = {};
	        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
	            var param = params_1[_i];
	            paramValues[param.id] = param.value(values[param.id]);
	        }
	        return paramValues;
	    };
	    /**
	     * Finds [[Param]] objects which have different param values
	     *
	     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
	     *
	     * @param params: The list of Param objects to filter
	     * @param values1: The first set of parameter values
	     * @param values2: the second set of parameter values
	     *
	     * @returns any Param objects whose values were different between values1 and values2
	     */
	    Param.changed = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
	    };
	    /**
	     * Checks if two param value objects are equal (for a set of [[Param]] objects)
	     *
	     * @param params The list of [[Param]] objects to check
	     * @param values1 The first set of param values
	     * @param values2 The second set of param values
	     *
	     * @returns true if the param values in values1 and values2 are equal
	     */
	    Param.equals = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return Param.changed(params, values1, values2).length === 0;
	    };
	    /** Returns true if a the parameter values are valid, according to the Param definitions */
	    Param.validates = function (params, values) {
	        if (values === void 0) { values = {}; }
	        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
	    };
	    Param.prototype.isDefaultValue = function (value) {
	        return this.isOptional && this.type.equals(this.value(), value);
	    };
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    Param.prototype.value = function (value) {
	        var _this = this;
	        /**
	         * [Internal] Get the default value of a parameter, which may be an injectable function.
	         */
	        var getDefaultValue = function () {
	            if (_this._defaultValueCache)
	                return _this._defaultValueCache.defaultValue;
	            if (!coreservices_1.services.$injector)
	                throw new Error('Injectable functions cannot be called at configuration time');
	            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
	            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
	                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
	            if (_this.config.$$fn['__cacheable']) {
	                _this._defaultValueCache = { defaultValue: defaultValue };
	            }
	            return defaultValue;
	        };
	        var replaceSpecialValues = function (val) {
	            for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
	                var tuple = _a[_i];
	                if (tuple.from === val)
	                    return tuple.to;
	            }
	            return val;
	        };
	        value = replaceSpecialValues(value);
	        return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
	    };
	    Param.prototype.isSearch = function () {
	        return this.location === DefType.SEARCH;
	    };
	    Param.prototype.validates = function (value) {
	        // There was no parameter value, but the param is optional
	        if ((predicates_1.isUndefined(value) || value === null) && this.isOptional)
	            return true;
	        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
	        var normalized = this.type.$normalize(value);
	        if (!this.type.is(normalized))
	            return false;
	        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
	        var encoded = this.type.encode(normalized);
	        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
	    };
	    Param.prototype.toString = function () {
	        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
	    };
	    return Param;
	}());
	exports.Param = Param;
	//# sourceMappingURL=param.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TargetState = void 0;
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var common_1 = __webpack_require__(4);
	/**
	 * Encapsulate the target (destination) state/params/options of a [[Transition]].
	 *
	 * This class is frequently used to redirect a transition to a new destination.
	 *
	 * See:
	 *
	 * - [[HookResult]]
	 * - [[TransitionHookFn]]
	 * - [[TransitionService.onStart]]
	 *
	 * To create a `TargetState`, use [[StateService.target]].
	 *
	 * ---
	 *
	 * This class wraps:
	 *
	 * 1) an identifier for a state
	 * 2) a set of parameters
	 * 3) and transition options
	 * 4) the registered state object (the [[StateDeclaration]])
	 *
	 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
	 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
	 * The `TargetState` class normalizes those options.
	 *
	 * A `TargetState` may be valid (the state being targeted exists in the registry)
	 * or invalid (the state being targeted is not registered).
	 */
	var TargetState = /** @class */ (function () {
	    /**
	     * The TargetState constructor
	     *
	     * Note: Do not construct a `TargetState` manually.
	     * To create a `TargetState`, use the [[StateService.target]] factory method.
	     *
	     * @param _stateRegistry The StateRegistry to use to look up the _definition
	     * @param _identifier An identifier for a state.
	     *    Either a fully-qualified state name, or the object used to define the state.
	     * @param _params Parameters for the target state
	     * @param _options Transition options.
	     *
	     * @internal
	     */
	    function TargetState(_stateRegistry, _identifier, _params, _options) {
	        this._stateRegistry = _stateRegistry;
	        this._identifier = _identifier;
	        this._identifier = _identifier;
	        this._params = common_1.extend({}, _params || {});
	        this._options = common_1.extend({}, _options || {});
	        this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
	    }
	    /** The name of the state this object targets */
	    TargetState.prototype.name = function () {
	        return (this._definition && this._definition.name) || this._identifier;
	    };
	    /** The identifier used when creating this TargetState */
	    TargetState.prototype.identifier = function () {
	        return this._identifier;
	    };
	    /** The target parameter values */
	    TargetState.prototype.params = function () {
	        return this._params;
	    };
	    /** The internal state object (if it was found) */
	    TargetState.prototype.$state = function () {
	        return this._definition;
	    };
	    /** The internal state declaration (if it was found) */
	    TargetState.prototype.state = function () {
	        return this._definition && this._definition.self;
	    };
	    /** The target options */
	    TargetState.prototype.options = function () {
	        return this._options;
	    };
	    /** True if the target state was found */
	    TargetState.prototype.exists = function () {
	        return !!(this._definition && this._definition.self);
	    };
	    /** True if the object is valid */
	    TargetState.prototype.valid = function () {
	        return !this.error();
	    };
	    /** If the object is invalid, returns the reason why */
	    TargetState.prototype.error = function () {
	        var base = this.options().relative;
	        if (!this._definition && !!base) {
	            var stateName = base.name ? base.name : base;
	            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
	        }
	        if (!this._definition)
	            return "No such state '" + this.name() + "'";
	        if (!this._definition.self)
	            return "State '" + this.name() + "' has an invalid definition";
	    };
	    TargetState.prototype.toString = function () {
	        return "'" + this.name() + "'" + strings_1.stringify(this.params());
	    };
	    /**
	     * Returns a copy of this TargetState which targets a different state.
	     * The new TargetState has the same parameter values and transition options.
	     *
	     * @param state The new state that should be targeted
	     */
	    TargetState.prototype.withState = function (state) {
	        return new TargetState(this._stateRegistry, state, this._params, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified parameter values.
	     *
	     * @param params the new parameter values to use
	     * @param replace When false (default) the new parameter values will be merged with the current values.
	     *                When true the parameter values will be used instead of the current values.
	     */
	    TargetState.prototype.withParams = function (params, replace) {
	        if (replace === void 0) { replace = false; }
	        var newParams = replace ? params : common_1.extend({}, this._params, params);
	        return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified Transition Options.
	     *
	     * @param options the new options to use
	     * @param replace When false (default) the new options will be merged with the current options.
	     *                When true the options will be used instead of the current options.
	     */
	    TargetState.prototype.withOptions = function (options, replace) {
	        if (replace === void 0) { replace = false; }
	        var newOpts = replace ? options : common_1.extend({}, this._options, options);
	        return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
	    };
	    /** Returns true if the object has a state property that might be a state or state name */
	    TargetState.isDef = function (obj) {
	        return obj && obj.state && (predicates_1.isString(obj.state) || (predicates_1.isObject(obj.state) && predicates_1.isString(obj.state.name)));
	    };
	    return TargetState;
	}());
	exports.TargetState = TargetState;
	//# sourceMappingURL=targetState.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionHook = void 0;
	var interface_1 = __webpack_require__(10);
	var common_1 = __webpack_require__(1);
	var strings_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var trace_1 = __webpack_require__(8);
	var coreservices_1 = __webpack_require__(5);
	var rejectFactory_1 = __webpack_require__(11);
	var targetState_1 = __webpack_require__(17);
	var defaultOptions = {
	    current: common_1.noop,
	    transition: null,
	    traceData: {},
	    bind: null,
	};
	var TransitionHook = /** @class */ (function () {
	    function TransitionHook(transition, stateContext, registeredHook, options) {
	        var _this = this;
	        this.transition = transition;
	        this.stateContext = stateContext;
	        this.registeredHook = registeredHook;
	        this.options = options;
	        this.isSuperseded = function () { return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive(); };
	        this.options = common_1.defaults(options, defaultOptions);
	        this.type = registeredHook.eventType;
	    }
	    /**
	     * Chains together an array of TransitionHooks.
	     *
	     * Given a list of [[TransitionHook]] objects, chains them together.
	     * Each hook is invoked after the previous one completes.
	     *
	     * #### Example:
	     * ```js
	     * var hooks: TransitionHook[] = getHooks();
	     * let promise: Promise<any> = TransitionHook.chain(hooks);
	     *
	     * promise.then(handleSuccess, handleError);
	     * ```
	     *
	     * @param hooks the list of hooks to chain together
	     * @param waitFor if provided, the chain is `.then()`'ed off this promise
	     * @returns a `Promise` for sequentially invoking the hooks (in order)
	     */
	    TransitionHook.chain = function (hooks, waitFor) {
	        // Chain the next hook off the previous
	        var createHookChainR = function (prev, nextHook) { return prev.then(function () { return nextHook.invokeHook(); }); };
	        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
	    };
	    /**
	     * Invokes all the provided TransitionHooks, in order.
	     * Each hook's return value is checked.
	     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
	     * If no hook returns a promise, then all hooks are processed synchronously.
	     *
	     * @param hooks the list of TransitionHooks to invoke
	     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
	     *
	     * @returns a promise for the async result, or the result of the callback
	     */
	    TransitionHook.invokeHooks = function (hooks, doneCallback) {
	        for (var idx = 0; idx < hooks.length; idx++) {
	            var hookResult = hooks[idx].invokeHook();
	            if (predicates_1.isPromise(hookResult)) {
	                var remainingHooks = hooks.slice(idx + 1);
	                return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
	            }
	        }
	        return doneCallback();
	    };
	    /**
	     * Run all TransitionHooks, ignoring their return value.
	     */
	    TransitionHook.runAllHooks = function (hooks) {
	        hooks.forEach(function (hook) { return hook.invokeHook(); });
	    };
	    TransitionHook.prototype.logError = function (err) {
	        this.transition.router.stateService.defaultErrorHandler()(err);
	    };
	    TransitionHook.prototype.invokeHook = function () {
	        var _this = this;
	        var hook = this.registeredHook;
	        if (hook._deregistered)
	            return;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        var options = this.options;
	        trace_1.trace.traceHookInvocation(this, this.transition, options);
	        var invokeCallback = function () { return hook.callback.call(options.bind, _this.transition, _this.stateContext); };
	        var normalizeErr = function (err) { return rejectFactory_1.Rejection.normalize(err).toPromise(); };
	        var handleError = function (err) { return hook.eventType.getErrorHandler(_this)(err); };
	        var handleResult = function (result) { return hook.eventType.getResultHandler(_this)(result); };
	        try {
	            var result = invokeCallback();
	            if (!this.type.synchronous && predicates_1.isPromise(result)) {
	                return result.catch(normalizeErr).then(handleResult, handleError);
	            }
	            else {
	                return handleResult(result);
	            }
	        }
	        catch (err) {
	            // If callback throws (synchronously)
	            return handleError(rejectFactory_1.Rejection.normalize(err));
	        }
	        finally {
	            if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
	                hook.deregister();
	            }
	        }
	    };
	    /**
	     * This method handles the return value of a Transition Hook.
	     *
	     * A hook can return false (cancel), a TargetState (redirect),
	     * or a promise (which may later resolve to false or a redirect)
	     *
	     * This also handles "transition superseded" -- when a new transition
	     * was started while the hook was still running
	     */
	    TransitionHook.prototype.handleHookResult = function (result) {
	        var _this = this;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        // Hook returned a promise
	        if (predicates_1.isPromise(result)) {
	            // Wait for the promise, then reprocess with the resulting value
	            return result.then(function (val) { return _this.handleHookResult(val); });
	        }
	        trace_1.trace.traceHookResult(result, this.transition, this.options);
	        // Hook returned false
	        if (result === false) {
	            // Abort this Transition
	            return rejectFactory_1.Rejection.aborted('Hook aborted transition').toPromise();
	        }
	        var isTargetState = hof_1.is(targetState_1.TargetState);
	        // hook returned a TargetState
	        if (isTargetState(result)) {
	            // Halt the current Transition and redirect (a new Transition) to the TargetState.
	            return rejectFactory_1.Rejection.redirected(result).toPromise();
	        }
	    };
	    /**
	     * Return a Rejection promise if the transition is no longer current due
	     * to a stopped router (disposed), or a new transition has started and superseded this one.
	     */
	    TransitionHook.prototype.getNotCurrentRejection = function () {
	        var router = this.transition.router;
	        // The router is stopped
	        if (router._disposed) {
	            return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
	        }
	        if (this.transition._aborted) {
	            return rejectFactory_1.Rejection.aborted().toPromise();
	        }
	        // This transition is no longer current.
	        // Another transition started while this hook was still running.
	        if (this.isSuperseded()) {
	            // Abort this transition
	            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
	        }
	    };
	    TransitionHook.prototype.toString = function () {
	        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.fnToString(registeredHook.callback);
	        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
	    };
	    /**
	     * These GetResultHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
	        return hook.handleHookResult(result);
	    }; };
	    /**
	     * If the result is a promise rejection, log it.
	     * Otherwise, ignore the result.
	     */
	    TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
	        predicates_1.isPromise(result) && result.catch(function (err) { return hook.logError(rejectFactory_1.Rejection.normalize(err)); });
	        return undefined;
	    }; };
	    /**
	     * These GetErrorHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.LOG_ERROR = function (hook) { return function (error) { return hook.logError(error); }; };
	    TransitionHook.REJECT_ERROR = function (hook) { return function (error) { return common_1.silentRejection(error); }; };
	    TransitionHook.THROW_ERROR = function (hook) { return function (error) {
	        throw error;
	    }; };
	    return TransitionHook;
	}());
	exports.TransitionHook = TransitionHook;
	//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(12).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathUtils = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var targetState_1 = __webpack_require__(17);
	var pathNode_1 = __webpack_require__(37);
	/**
	 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
	 */
	var PathUtils = /** @class */ (function () {
	    function PathUtils() {
	    }
	    /** Given a PathNode[], create an TargetState */
	    PathUtils.makeTargetState = function (registry, path) {
	        var state = common_1.tail(path).state;
	        return new targetState_1.TargetState(registry, state, path.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}), {});
	    };
	    PathUtils.buildPath = function (targetState) {
	        var toParams = targetState.params();
	        return targetState.$state().path.map(function (state) { return new pathNode_1.PathNode(state).applyRawParams(toParams); });
	    };
	    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
	    PathUtils.buildToPath = function (fromPath, targetState) {
	        var toPath = PathUtils.buildPath(targetState);
	        if (targetState.options().inherit) {
	            return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
	        }
	        return toPath;
	    };
	    /**
	     * Creates ViewConfig objects and adds to nodes.
	     *
	     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
	     */
	    PathUtils.applyViewConfigs = function ($view, path, states) {
	        // Only apply the viewConfigs to the nodes for the given states
	        path
	            .filter(function (node) { return common_1.inArray(states, node.state); })
	            .forEach(function (node) {
	            var viewDecls = common_1.values(node.state.views || {});
	            var subPath = PathUtils.subPath(path, function (n) { return n === node; });
	            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
	            node.views = viewConfigs.reduce(common_1.unnestR, []);
	        });
	    };
	    /**
	     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
	     *
	     * For a parameter in a node to be inherited from the from path:
	     * - The toPath's node must have a matching node in the fromPath (by state).
	     * - The parameter name must not be found in the toKeys parameter array.
	     *
	     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
	     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
	     * it is not inherited from the fromPath.
	     */
	    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
	        if (toKeys === void 0) { toKeys = []; }
	        function nodeParamVals(path, state) {
	            var node = common_1.find(path, hof_1.propEq('state', state));
	            return common_1.extend({}, node && node.paramValues);
	        }
	        var noInherit = fromPath
	            .map(function (node) { return node.paramSchema; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (param) { return !param.inherit; })
	            .map(hof_1.prop('id'));
	        /**
	         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
	         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
	         */
	        function makeInheritedParamsNode(toNode) {
	            // All param values for the node (may include default key/vals, when key was not found in toParams)
	            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
	            // limited to only those keys found in toParams
	            var incomingParamVals = common_1.pick(toParamVals, toKeys);
	            toParamVals = common_1.omit(toParamVals, toKeys);
	            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
	            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
	            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
	            return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
	        }
	        // The param keys specified by the incoming toParams
	        return toPath.map(makeInheritedParamsNode);
	    };
	    /**
	     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
	     */
	    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
	        var max = Math.min(fromPath.length, toPath.length);
	        var keep = 0;
	        var nodesMatch = function (node1, node2) { return node1.equals(node2, PathUtils.nonDynamicParams); };
	        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
	            keep++;
	        }
	        /** Given a retained node, return a new node which uses the to node's param values */
	        function applyToParams(retainedNode, idx) {
	            var cloned = retainedNode.clone();
	            cloned.paramValues = toPath[idx].paramValues;
	            return cloned;
	        }
	        var from, retained, exiting, entering, to;
	        from = fromPath;
	        retained = from.slice(0, keep);
	        exiting = from.slice(keep);
	        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
	        var retainedWithToParams = retained.map(applyToParams);
	        entering = toPath.slice(keep);
	        to = retainedWithToParams.concat(entering);
	        return { from: from, to: to, retained: retained, retainedWithToParams: retainedWithToParams, exiting: exiting, entering: entering };
	    };
	    /**
	     * Returns a new path which is: the subpath of the first path which matches the second path.
	     *
	     * The new path starts from root and contains any nodes that match the nodes in the second path.
	     * It stops before the first non-matching node.
	     *
	     * Nodes are compared using their state property and their parameter values.
	     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
	     *
	     * @param pathA the first path
	     * @param pathB the second path
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     *
	     * @returns an array of PathNodes from the first path which match the nodes in the second path
	     */
	    PathUtils.matching = function (pathA, pathB, paramsFn) {
	        var done = false;
	        var tuples = common_1.arrayTuples(pathA, pathB);
	        return tuples.reduce(function (matching, _a) {
	            var nodeA = _a[0], nodeB = _a[1];
	            done = done || !nodeA.equals(nodeB, paramsFn);
	            return done ? matching : matching.concat(nodeA);
	        }, []);
	    };
	    /**
	     * Returns true if two paths are identical.
	     *
	     * @param pathA
	     * @param pathB
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     * @returns true if the the states and parameter values for both paths are identical
	     */
	    PathUtils.equals = function (pathA, pathB, paramsFn) {
	        return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
	    };
	    /**
	     * Return a subpath of a path, which stops at the first matching node
	     *
	     * Given an array of nodes, returns a subset of the array starting from the first node,
	     * stopping when the first node matches the predicate.
	     *
	     * @param path a path of [[PathNode]]s
	     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
	     * @returns a subpath up to the matching node, or undefined if no match is found
	     */
	    PathUtils.subPath = function (path, predicate) {
	        var node = common_1.find(path, predicate);
	        var elementIdx = path.indexOf(node);
	        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
	    };
	    PathUtils.nonDynamicParams = function (node) {
	        return node.state.parameters({ inherit: false }).filter(function (param) { return !param.dynamic; });
	    };
	    /** Gets the raw parameter values from a path */
	    PathUtils.paramValues = function (path) { return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {}); };
	    return PathUtils;
	}());
	exports.PathUtils = PathUtils;
	//# sourceMappingURL=pathUtils.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Resolvable = exports.defaultResolvePolicy = void 0;
	var common_1 = __webpack_require__(1);
	var coreservices_1 = __webpack_require__(5);
	var trace_1 = __webpack_require__(8);
	var strings_1 = __webpack_require__(6);
	var predicates_1 = __webpack_require__(2);
	var predicates_2 = __webpack_require__(2);
	// TODO: explicitly make this user configurable
	exports.defaultResolvePolicy = {
	    when: 'LAZY',
	    async: 'WAIT',
	};
	/**
	 * The basic building block for the resolve system.
	 *
	 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
	 * and the unwrapped-when-complete (.data) result of the resolveFn.
	 *
	 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
	 * resolveFn) and returns the resulting promise.
	 *
	 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
	 * parameter to those fns.
	 */
	var Resolvable = /** @class */ (function () {
	    function Resolvable(arg1, resolveFn, deps, policy, data) {
	        this.resolved = false;
	        this.promise = undefined;
	        if (arg1 instanceof Resolvable) {
	            common_1.extend(this, arg1);
	        }
	        else if (predicates_1.isFunction(resolveFn)) {
	            if (predicates_2.isNullOrUndefined(arg1))
	                throw new Error('new Resolvable(): token argument is required');
	            if (!predicates_1.isFunction(resolveFn))
	                throw new Error('new Resolvable(): resolveFn argument must be a function');
	            this.token = arg1;
	            this.policy = policy;
	            this.resolveFn = resolveFn;
	            this.deps = deps || [];
	            this.data = data;
	            this.resolved = data !== undefined;
	            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
	        }
	        else if (predicates_1.isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
	            var literal = arg1;
	            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
	        }
	    }
	    Resolvable.prototype.getPolicy = function (state) {
	        var thisPolicy = this.policy || {};
	        var statePolicy = (state && state.resolvePolicy) || {};
	        return {
	            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
	            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
	        };
	    };
	    /**
	     * Asynchronously resolve this Resolvable's data
	     *
	     * Given a ResolveContext that this Resolvable is found in:
	     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
	     * and update the Resolvable's state
	     */
	    Resolvable.prototype.resolve = function (resolveContext, trans) {
	        var _this = this;
	        var $q = coreservices_1.services.$q;
	        // Gets all dependencies from ResolveContext and wait for them to be resolved
	        var getResolvableDependencies = function () {
	            return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) { return resolvable.get(resolveContext, trans); }));
	        };
	        // Invokes the resolve function passing the resolved dependencies as arguments
	        var invokeResolveFn = function (resolvedDeps) { return _this.resolveFn.apply(null, resolvedDeps); };
	        var node = resolveContext.findNode(this);
	        var state = node && node.state;
	        var asyncPolicy = this.getPolicy(state).async;
	        var customAsyncPolicy = predicates_1.isFunction(asyncPolicy) ? asyncPolicy : common_1.identity;
	        // After the final value has been resolved, update the state of the Resolvable
	        var applyResolvedValue = function (resolvedValue) {
	            _this.data = resolvedValue;
	            _this.resolved = true;
	            _this.resolveFn = null;
	            trace_1.trace.traceResolvableResolved(_this, trans);
	            return _this.data;
	        };
	        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
	        return (this.promise = $q
	            .when()
	            .then(getResolvableDependencies)
	            .then(invokeResolveFn)
	            .then(customAsyncPolicy)
	            .then(applyResolvedValue));
	    };
	    /**
	     * Gets a promise for this Resolvable's data.
	     *
	     * Fetches the data and returns a promise.
	     * Returns the existing promise if it has already been fetched once.
	     */
	    Resolvable.prototype.get = function (resolveContext, trans) {
	        return this.promise || this.resolve(resolveContext, trans);
	    };
	    Resolvable.prototype.toString = function () {
	        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
	    };
	    Resolvable.prototype.clone = function () {
	        return new Resolvable(this);
	    };
	    Resolvable.fromData = function (token, data) { return new Resolvable(token, function () { return data; }, null, null, data); };
	    return Resolvable;
	}());
	exports.Resolvable = Resolvable;
	//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ResolveContext = exports.NATIVE_INJECTOR_TOKEN = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var trace_1 = __webpack_require__(8);
	var coreservices_1 = __webpack_require__(5);
	var interface_1 = __webpack_require__(55);
	var resolvable_1 = __webpack_require__(22);
	var pathUtils_1 = __webpack_require__(21);
	var strings_1 = __webpack_require__(6);
	var common_2 = __webpack_require__(4);
	var whens = interface_1.resolvePolicies.when;
	var ALL_WHENS = [whens.EAGER, whens.LAZY];
	var EAGER_WHENS = [whens.EAGER];
	// tslint:disable-next-line:no-inferrable-types
	exports.NATIVE_INJECTOR_TOKEN = 'Native Injector';
	/**
	 * Encapsulates Dependency Injection for a path of nodes
	 *
	 * UI-Router states are organized as a tree.
	 * A nested state has a path of ancestors to the root of the tree.
	 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
	 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
	 *
	 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
	 */
	var ResolveContext = /** @class */ (function () {
	    function ResolveContext(_path) {
	        this._path = _path;
	    }
	    /** Gets all the tokens found in the resolve context, de-duplicated */
	    ResolveContext.prototype.getTokens = function () {
	        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
	    };
	    /**
	     * Gets the Resolvable that matches the token
	     *
	     * Gets the last Resolvable that matches the token in this context, or undefined.
	     * Throws an error if it doesn't exist in the ResolveContext
	     */
	    ResolveContext.prototype.getResolvable = function (token) {
	        var matching = this._path
	            .map(function (node) { return node.resolvables; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (r) { return r.token === token; });
	        return common_1.tail(matching);
	    };
	    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
	    ResolveContext.prototype.getPolicy = function (resolvable) {
	        var node = this.findNode(resolvable);
	        return resolvable.getPolicy(node.state);
	    };
	    /**
	     * Returns a ResolveContext that includes a portion of this one
	     *
	     * Given a state, this method creates a new ResolveContext from this one.
	     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
	     *
	     * #### Why
	     *
	     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
	     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
	     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
	     * This method is used to create a narrower context when injecting ancestor nodes.
	     *
	     * @example
	     * `let ABCD = new ResolveContext([A, B, C, D]);`
	     *
	     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
	     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
	     * However, `B` should only be able to access resolvables from `A`, `B`.
	     *
	     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
	     * `let AB = ABCD.subcontext(a)`
	     */
	    ResolveContext.prototype.subContext = function (state) {
	        return new ResolveContext(pathUtils_1.PathUtils.subPath(this._path, function (node) { return node.state === state; }));
	    };
	    /**
	     * Adds Resolvables to the node that matches the state
	     *
	     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
	     * The resolvable is added to the node matching the `state` parameter.
	     *
	     * These new resolvables are not automatically fetched.
	     * The calling code should either fetch them, fetch something that depends on them,
	     * or rely on [[resolvePath]] being called when some state is being entered.
	     *
	     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
	     *
	     * @param newResolvables the new Resolvables
	     * @param state Used to find the node to put the resolvable on
	     */
	    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
	        var node = common_1.find(this._path, hof_1.propEq('state', state));
	        var keys = newResolvables.map(function (r) { return r.token; });
	        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
	    };
	    /**
	     * Returns a promise for an array of resolved path Element promises
	     *
	     * @param when
	     * @param trans
	     * @returns {Promise<any>|any}
	     */
	    ResolveContext.prototype.resolvePath = function (when, trans) {
	        var _this = this;
	        if (when === void 0) { when = 'LAZY'; }
	        // This option determines which 'when' policy Resolvables we are about to fetch.
	        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : 'LAZY';
	        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
	        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
	        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
	        // get the subpath to the state argument, if provided
	        trace_1.trace.traceResolvePath(this._path, when, trans);
	        var matchesPolicy = function (acceptedVals, whenOrAsync) { return function (resolvable) {
	            return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
	        }; };
	        // Trigger all the (matching) Resolvables in the path
	        // Reduce all the "WAIT" Resolvables into an array
	        var promises = this._path.reduce(function (acc, node) {
	            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
	            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
	            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
	            // For the matching Resolvables, start their async fetch process.
	            var subContext = _this.subContext(node.state);
	            var getResult = function (r) {
	                return r
	                    .get(subContext, trans)
	                    // Return a tuple that includes the Resolvable's token
	                    .then(function (value) { return ({ token: r.token, value: value }); });
	            };
	            nowait.forEach(getResult);
	            return acc.concat(wait.map(getResult));
	        }, []);
	        // Wait for all the "WAIT" resolvables
	        return coreservices_1.services.$q.all(promises);
	    };
	    ResolveContext.prototype.injector = function () {
	        return this._injector || (this._injector = new UIInjectorImpl(this));
	    };
	    ResolveContext.prototype.findNode = function (resolvable) {
	        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
	    };
	    /**
	     * Gets the async dependencies of a Resolvable
	     *
	     * Given a Resolvable, returns its dependencies as a Resolvable[]
	     */
	    ResolveContext.prototype.getDependencies = function (resolvable) {
	        var _this = this;
	        var node = this.findNode(resolvable);
	        // Find which other resolvables are "visible" to the `resolvable` argument
	        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
	        var subPath = pathUtils_1.PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
	        var availableResolvables = subPath
	            .reduce(function (acc, _node) { return acc.concat(_node.resolvables); }, []) // all of subpath's resolvables
	            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
	        var getDependency = function (token) {
	            var matching = availableResolvables.filter(function (r) { return r.token === token; });
	            if (matching.length)
	                return common_1.tail(matching);
	            var fromInjector = _this.injector().getNative(token);
	            if (common_2.isUndefined(fromInjector)) {
	                throw new Error('Could not find Dependency Injection token: ' + strings_1.stringify(token));
	            }
	            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
	        };
	        return resolvable.deps.map(getDependency);
	    };
	    return ResolveContext;
	}());
	exports.ResolveContext = ResolveContext;
	/** @internal */
	var UIInjectorImpl = /** @class */ (function () {
	    function UIInjectorImpl(context) {
	        this.context = context;
	        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
	    }
	    UIInjectorImpl.prototype.get = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable) {
	            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
	                return resolvable.get(this.context);
	            }
	            if (!resolvable.resolved) {
	                throw new Error('Resolvable async .get() not complete:' + strings_1.stringify(resolvable.token));
	            }
	            return resolvable.data;
	        }
	        return this.getNative(token);
	    };
	    UIInjectorImpl.prototype.getAsync = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable)
	            return resolvable.get(this.context);
	        return coreservices_1.services.$q.when(this.native.get(token));
	    };
	    UIInjectorImpl.prototype.getNative = function (token) {
	        return this.native && this.native.get(token);
	    };
	    return UIInjectorImpl;
	}());
	//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcher = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var param_1 = __webpack_require__(16);
	var strings_1 = __webpack_require__(6);
	var common_2 = __webpack_require__(4);
	function quoteRegExp(str, param) {
	    var surroundPattern = ['', ''], result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
	    if (!param)
	        return result;
	    switch (param.squash) {
	        case false:
	            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
	            break;
	        case true:
	            result = result.replace(/\/$/, '');
	            surroundPattern = ['(?:/(', ')|/)?'];
	            break;
	        default:
	            surroundPattern = ["(" + param.squash + "|", ')?'];
	            break;
	    }
	    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
	}
	var memoizeTo = function (obj, _prop, fn) { return (obj[_prop] = obj[_prop] || fn()); };
	var splitOnSlash = strings_1.splitOnDelim('/');
	var defaultConfig = {
	    state: { params: {} },
	    strict: true,
	    caseInsensitive: true,
	    decodeParams: true,
	};
	/**
	 * Matches URLs against patterns.
	 *
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL.
	 *
	 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
	 * parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by [[UrlMatcher.exec]].
	 *
	 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
	 * or colon placeholders (`/somePath/:param`).
	 *
	 * - *A parameter RegExp* may be defined for a param after a colon
	 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
	 * The regexp must match for the url to be matched.
	 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
	 *
	 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
	 *   See [[UrlMatcherFactory.type]] for more information.
	 *
	 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
	 *   A catch-all * parameter value will contain the remainder of the URL.
	 *
	 * ---
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters).
	 * A path parameter matches any number of characters other than '/'. For catch-all
	 * placeholders the path parameter matches any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 */
	var UrlMatcher = /** @class */ (function () {
	    /**
	     * @param pattern The pattern to compile into a matcher.
	     * @param paramTypes The [[ParamTypes]] registry
	     * @param paramFactory A [[ParamFactory]] object
	     * @param config  A [[UrlMatcherCompileConfig]] configuration object
	     */
	    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
	        var _this = this;
	        /** @internal */
	        this._cache = { path: [this] };
	        /** @internal */
	        this._children = [];
	        /** @internal */
	        this._params = [];
	        /** @internal */
	        this._segments = [];
	        /** @internal */
	        this._compiled = [];
	        this.config = config = common_2.defaults(config, defaultConfig);
	        this.pattern = pattern;
	        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	        //   '*' name
	        //   ':' name
	        //   '{' name '}'
	        //   '{' name ':' regexp '}'
	        // The regular expression is somewhat complicated due to the need to allow curly braces
	        // inside the regular expression. The placeholder regexp breaks down as follows:
	        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	        //    [^{}\\]+                       - anything other than curly braces or backslash
	        //    \\.                            - a backslash escape
	        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var patterns = [];
	        var last = 0;
	        var matchArray;
	        var checkParamErrors = function (id) {
	            if (!UrlMatcher.nameValidator.test(id))
	                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	            if (common_1.find(_this._params, hof_1.propEq('id', id)))
	                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	        };
	        // Split into static segments separated by path parameter placeholders.
	        // The number of segments is always 1 more than the number of parameters.
	        var matchDetails = function (m, isSearch) {
	            // IE[78] returns '' for unmatched groups instead of null
	            var id = m[2] || m[3];
	            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
	            var makeRegexpType = function (str) {
	                return common_1.inherit(paramTypes.type(isSearch ? 'query' : 'path'), {
	                    pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined),
	                });
	            };
	            return {
	                id: id,
	                regexp: regexp,
	                segment: pattern.substring(last, m.index),
	                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp),
	            };
	        };
	        var details;
	        var segment;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((matchArray = placeholder.exec(pattern))) {
	            details = matchDetails(matchArray, false);
	            if (details.segment.indexOf('?') >= 0)
	                break; // we're into the search part
	            checkParamErrors(details.id);
	            this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
	            this._segments.push(details.segment);
	            patterns.push([details.segment, common_1.tail(this._params)]);
	            last = placeholder.lastIndex;
	        }
	        segment = pattern.substring(last);
	        // Find any search parameter names and remove them from the last segment
	        var i = segment.indexOf('?');
	        if (i >= 0) {
	            var search = segment.substring(i);
	            segment = segment.substring(0, i);
	            if (search.length > 0) {
	                last = 0;
	                // tslint:disable-next-line:no-conditional-assignment
	                while ((matchArray = searchPlaceholder.exec(search))) {
	                    details = matchDetails(matchArray, true);
	                    checkParamErrors(details.id);
	                    this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
	                    last = placeholder.lastIndex;
	                    // check if ?&
	                }
	            }
	        }
	        this._segments.push(segment);
	        this._compiled = patterns.map(function (_pattern) { return quoteRegExp.apply(null, _pattern); }).concat(quoteRegExp(segment));
	    }
	    /** @internal */
	    UrlMatcher.encodeDashes = function (str) {
	        // Replace dashes with encoded "\-"
	        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's path segments and path params, in order */
	    UrlMatcher.pathSegmentsAndParams = function (matcher) {
	        var staticSegments = matcher._segments;
	        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
	        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
	            .reduce(common_1.unnestR, [])
	            .filter(function (x) { return x !== '' && predicates_1.isDefined(x); });
	    };
	    /** @internal Given a matcher, return an array with the matcher's query params */
	    UrlMatcher.queryParams = function (matcher) {
	        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
	    };
	    /**
	     * Compare two UrlMatchers
	     *
	     * This comparison function converts a UrlMatcher into static and dynamic path segments.
	     * Each static path segment is a static string between a path separator (slash character).
	     * Each dynamic segment is a path parameter.
	     *
	     * The comparison function sorts static segments before dynamic ones.
	     */
	    UrlMatcher.compare = function (a, b) {
	        /**
	         * Turn a UrlMatcher and all its parent matchers into an array
	         * of slash literals '/', string literals, and Param objects
	         *
	         * This example matcher matches strings like "/foo/:param/tail":
	         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
	         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
	         *
	         * Caches the result as `matcher._cache.segments`
	         */
	        var segments = function (matcher) {
	            return (matcher._cache.segments =
	                matcher._cache.segments ||
	                    matcher._cache.path
	                        .map(UrlMatcher.pathSegmentsAndParams)
	                        .reduce(common_1.unnestR, [])
	                        .reduce(strings_1.joinNeighborsR, [])
	                        .map(function (x) { return (predicates_1.isString(x) ? splitOnSlash(x) : x); })
	                        .reduce(common_1.unnestR, []));
	        };
	        /**
	         * Gets the sort weight for each segment of a UrlMatcher
	         *
	         * Caches the result as `matcher._cache.weights`
	         */
	        var weights = function (matcher) {
	            return (matcher._cache.weights =
	                matcher._cache.weights ||
	                    segments(matcher).map(function (segment) {
	                        // Sort slashes first, then static strings, the Params
	                        if (segment === '/')
	                            return 1;
	                        if (predicates_1.isString(segment))
	                            return 2;
	                        if (segment instanceof param_1.Param)
	                            return 3;
	                    }));
	        };
	        /**
	         * Pads shorter array in-place (mutates)
	         */
	        var padArrays = function (l, r, padVal) {
	            var len = Math.max(l.length, r.length);
	            while (l.length < len)
	                l.push(padVal);
	            while (r.length < len)
	                r.push(padVal);
	        };
	        var weightsA = weights(a), weightsB = weights(b);
	        padArrays(weightsA, weightsB, 0);
	        var _pairs = common_1.arrayTuples(weightsA, weightsB);
	        var cmp, i;
	        for (i = 0; i < _pairs.length; i++) {
	            cmp = _pairs[i][0] - _pairs[i][1];
	            if (cmp !== 0)
	                return cmp;
	        }
	        return 0;
	    };
	    /**
	     * Creates a new concatenated UrlMatcher
	     *
	     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
	     *
	     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
	     */
	    UrlMatcher.prototype.append = function (url) {
	        this._children.push(url);
	        url._cache = {
	            path: this._cache.path.concat(url),
	            parent: this,
	            pattern: null,
	        };
	        return url;
	    };
	    /** @internal */
	    UrlMatcher.prototype.isRoot = function () {
	        return this._cache.path[0] === this;
	    };
	    /** Returns the input pattern string */
	    UrlMatcher.prototype.toString = function () {
	        return this.pattern;
	    };
	    UrlMatcher.prototype._getDecodedParamValue = function (value, param) {
	        if (predicates_1.isDefined(value)) {
	            if (this.config.decodeParams && !param.type.raw) {
	                if (predicates_1.isArray(value)) {
	                    value = value.map(function (paramValue) { return decodeURIComponent(paramValue); });
	                }
	                else {
	                    value = decodeURIComponent(value);
	                }
	            }
	            value = param.type.decode(value);
	        }
	        return param.value(value);
	    };
	    /**
	     * Tests the specified url/path against this matcher.
	     *
	     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
	     * parameter values.  Returns null if the path does not match.
	     *
	     * The returned object contains the values
	     * of any search parameters that are mentioned in the pattern, but their value may be null if
	     * they are not present in `search`. This means that search parameters are always treated
	     * as optional.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	     *   x: '1', q: 'hello'
	     * });
	     * // returns { id: 'bob', q: 'hello', r: null }
	     * ```
	     *
	     * @param path    The URL path to match, e.g. `$location.path()`.
	     * @param search  URL search parameters, e.g. `$location.search()`.
	     * @param hash    URL hash e.g. `$location.hash()`.
	     * @param options
	     *
	     * @returns The captured parameter values.
	     */
	    UrlMatcher.prototype.exec = function (path, search, hash, options) {
	        var _this = this;
	        if (search === void 0) { search = {}; }
	        if (options === void 0) { options = {}; }
	        var match = memoizeTo(this._cache, 'pattern', function () {
	            return new RegExp([
	                '^',
	                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
	                _this.config.strict === false ? '/?' : '',
	                '$',
	            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
	        }).exec(path);
	        if (!match)
	            return null;
	        // options = defaults(options, { isolate: false });
	        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
	        if (nPathSegments !== match.length - 1)
	            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
	        function decodePathArray(paramVal) {
	            var reverseString = function (str) { return str.split('').reverse().join(''); };
	            var unquoteDashes = function (str) { return str.replace(/\\-/g, '-'); };
	            var split = reverseString(paramVal).split(/-(?!\\)/);
	            var allReversed = common_1.map(split, reverseString);
	            return common_1.map(allReversed, unquoteDashes).reverse();
	        }
	        for (var i = 0; i < nPathSegments; i++) {
	            var param = pathParams[i];
	            var value = match[i + 1];
	            // if the param value matches a pre-replace pair, replace the value before decoding.
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (value && param.array === true)
	                value = decodePathArray(value);
	            values[param.id] = this._getDecodedParamValue(value, param);
	        }
	        searchParams.forEach(function (param) {
	            var value = search[param.id];
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            values[param.id] = _this._getDecodedParamValue(value, param);
	        });
	        if (hash)
	            values['#'] = hash;
	        return values;
	    };
	    /**
	     * @internal
	     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
	     *
	     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
	     *    pattern has no parameters, an empty array is returned.
	     */
	    UrlMatcher.prototype.parameters = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        if (opts.inherit === false)
	            return this._params;
	        return common_1.unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
	    };
	    /**
	     * @internal
	     * Returns a single parameter from this UrlMatcher by id
	     *
	     * @param id
	     * @param opts
	     * @returns {T|Param|any|boolean|UrlMatcher|null}
	     */
	    UrlMatcher.prototype.parameter = function (id, opts) {
	        var _this = this;
	        if (opts === void 0) { opts = {}; }
	        var findParam = function () {
	            for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
	                var param = _a[_i];
	                if (param.id === id)
	                    return param;
	            }
	        };
	        var parent = this._cache.parent;
	        return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
	    };
	    /**
	     * Validates the input parameter values against this UrlMatcher
	     *
	     * Checks an object hash of parameters to validate their correctness according to the parameter
	     * types of this `UrlMatcher`.
	     *
	     * @param params The object hash of parameters to validate.
	     * @returns Returns `true` if `params` validates, otherwise `false`.
	     */
	    UrlMatcher.prototype.validates = function (params) {
	        var validParamVal = function (param, val) { return !param || param.validates(val); };
	        params = params || {};
	        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
	        var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
	        return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(common_1.allTrueR, true);
	    };
	    /**
	     * Given a set of parameter values, creates a URL from this UrlMatcher.
	     *
	     * Creates a URL that matches this pattern by substituting the specified values
	     * for the path and search parameters.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	     * // returns '/user/bob?q=yes'
	     * ```
	     *
	     * @param values  the values to substitute for the parameters in this pattern.
	     * @returns the formatted URL (path and optionally search part).
	     */
	    UrlMatcher.prototype.format = function (values) {
	        if (values === void 0) { values = {}; }
	        // Build the full path of UrlMatchers (including all parent UrlMatchers)
	        var urlMatchers = this._cache.path;
	        // Extract all the static segments and Params (processed as ParamDetails)
	        // into an ordered array
	        var pathSegmentsAndParams = urlMatchers
	            .map(UrlMatcher.pathSegmentsAndParams)
	            .reduce(common_1.unnestR, [])
	            .map(function (x) { return (predicates_1.isString(x) ? x : getDetails(x)); });
	        // Extract the query params into a separate array
	        var queryParams = urlMatchers
	            .map(UrlMatcher.queryParams)
	            .reduce(common_1.unnestR, [])
	            .map(getDetails);
	        var isInvalid = function (param) { return param.isValid === false; };
	        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
	            return null;
	        }
	        /**
	         * Given a Param, applies the parameter value, then returns detailed information about it
	         */
	        function getDetails(param) {
	            // Normalize to typed value
	            var value = param.value(values[param.id]);
	            var isValid = param.validates(value);
	            var isDefaultValue = param.isDefaultValue(value);
	            // Check if we're in squash mode for the parameter
	            var squash = isDefaultValue ? param.squash : false;
	            // Allow the Parameter's Type to encode the value
	            var encoded = param.type.encode(value);
	            return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
	        }
	        // Build up the path-portion from the list of static segments and parameters
	        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
	            // The element is a static segment (a raw string); just append it
	            if (predicates_1.isString(x))
	                return acc + x;
	            // Otherwise, it's a ParamDetails.
	            var squash = x.squash, encoded = x.encoded, param = x.param;
	            // If squash is === true, try to remove a slash from the path
	            if (squash === true)
	                return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
	            // If squash is a string, use the string for the param value
	            if (predicates_1.isString(squash))
	                return acc + squash;
	            if (squash !== false)
	                return acc; // ?
	            if (encoded == null)
	                return acc;
	            // If this parameter value is an array, encode the value using encodeDashes
	            if (predicates_1.isArray(encoded))
	                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join('-');
	            // If the parameter type is "raw", then do not encodeURIComponent
	            if (param.raw)
	                return acc + encoded;
	            // Encode the value
	            return acc + encodeURIComponent(encoded);
	        }, '');
	        // Build the query string by applying parameter values (array or regular)
	        // then mapping to key=value, then flattening and joining using "&"
	        var queryString = queryParams
	            .map(function (paramDetails) {
	            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
	            if (encoded == null || (isDefaultValue && squash !== false))
	                return;
	            if (!predicates_1.isArray(encoded))
	                encoded = [encoded];
	            if (encoded.length === 0)
	                return;
	            if (!param.raw)
	                encoded = common_1.map(encoded, encodeURIComponent);
	            return encoded.map(function (val) { return param.id + "=" + val; });
	        })
	            .filter(common_1.identity)
	            .reduce(common_1.unnestR, [])
	            .join('&');
	        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
	        return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
	    };
	    /** @internal */
	    UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
	    return UrlMatcher;
	}());
	exports.UrlMatcher = UrlMatcher;
	//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseLocationServices = void 0;
	var common_1 = __webpack_require__(4);
	var utils_1 = __webpack_require__(44);
	/** A base `LocationServices` */
	var BaseLocationServices = /** @class */ (function () {
	    function BaseLocationServices(router, fireAfterUpdate) {
	        var _this = this;
	        this.fireAfterUpdate = fireAfterUpdate;
	        this._listeners = [];
	        this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
	        this.hash = function () { return utils_1.parseUrl(_this._get()).hash; };
	        this.path = function () { return utils_1.parseUrl(_this._get()).path; };
	        this.search = function () { return utils_1.getParams(utils_1.parseUrl(_this._get()).search); };
	        this._location = common_1.root.location;
	        this._history = common_1.root.history;
	    }
	    BaseLocationServices.prototype.url = function (url, replace) {
	        if (replace === void 0) { replace = true; }
	        if (common_1.isDefined(url) && url !== this._get()) {
	            this._set(null, null, url, replace);
	            if (this.fireAfterUpdate) {
	                this._listeners.forEach(function (cb) { return cb({ url: url }); });
	            }
	        }
	        return utils_1.buildUrl(this);
	    };
	    BaseLocationServices.prototype.onChange = function (cb) {
	        var _this = this;
	        this._listeners.push(cb);
	        return function () { return common_1.removeFrom(_this._listeners, cb); };
	    };
	    BaseLocationServices.prototype.dispose = function (router) {
	        common_1.deregAll(this._listeners);
	    };
	    return BaseLocationServices;
	}());
	exports.BaseLocationServices = BaseLocationServices;
	//# sourceMappingURL=baseLocationService.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DuplicarModalController = function () {
	  DuplicarModalController.$inject = ["$uibModalInstance", "data", "DataService", "$log", "$state", "Storage"];
	  function DuplicarModalController($uibModalInstance, data, DataService, $log, $state, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, DuplicarModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.$log = $log;
	    this.$state = $state;
	    this.Storage = Storage;
	  }
	
	  _createClass(DuplicarModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.selected = {
	        item: this.items[0]
	      };
	      //    this.urlPdf = this.items.urlPdf;
	
	      var xdate = new Date();
	      if (this.Storage.exist('dateNow')) xdate = new Date(this.Storage.get('dateNow'));
	
	      this.conf = {
	        maxDate: xdate,
	        minDate: new Date(xdate.getFullYear() - 1, xdate.getMonth(), xdate.getDate()),
	        startingDay: 1
	        // showWeeks: false
	      };
	      this.DataService.get('certificaciones/' + this.items.id_certificacion + '/escala').then(function (response) {
	        if (response) {
	          _this.$log.log('Monto = ', response);
	          _this.escalaPago = parseInt(response + "");
	        }
	      });
	    }
	  }, {
	    key: 'validateFechaDeposito',
	    value: function validateFechaDeposito(form) {
	      if (this.obj.fecha_deposito) {
	        form.fecha_deposito.$setValidity('min_date', !(this.obj.fecha_deposito < this.conf.minDate));
	        form.fecha_deposito.$setValidity('max_date', !(this.obj.fecha_deposito > this.conf.maxDate));
	      }
	    }
	  }, {
	    key: 'solicitar',
	    value: function solicitar() {
	      var _this2 = this;
	
	      this.$log.log('Solicitando duplicado', this.obj);
	      this.DataService.post('certificaciones/' + this.items.id_certificacion + '/duplicar', this.obj).then(function (response) {
	        if (response) {
	          _this2.$state.reload();
	          _this2.$uibModalInstance.close(_this2.selected.item);
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'numberFormat',
	    value: function numberFormat(amount, decimals) {
	
	      amount += ''; // por si pasan un numero en vez de un string
	      amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto
	
	      decimals = decimals || 0; // por si la variable no fue fue pasada
	
	      // si no es un numero o es igual a cero retorno el mismo cero
	      if (isNaN(amount) || amount === 0) return parseFloat(0).toFixed(decimals);
	
	      // si es mayor o menor que cero retorno el valor formateado como numero
	      amount = '' + amount.toFixed(decimals);
	
	      var amount_parts = amount.split('.'),
	          regexp = /(\d+)(\d{3})/;
	
	      while (regexp.test(amount_parts[0])) {
	        amount_parts[0] = amount_parts[0].replace(regexp, '$1' + ',' + '$2');
	      }return amount_parts.join('.');
	    }
	  }]);
	
	  return DuplicarModalController;
	}();
	
	exports.default = DuplicarModalController;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(512);
	
	var MODULE_NAME = 'ui.bootstrap.module.position';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.position']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-copy\"></i>  Solicitud de duplicados </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<ng-form name=\"general_form\">\n  <div class=\"modal-body\">\n\n    <div class=\"alert alert-warning row mx-0\" >\n      <i class=\"fa fa-info-circle\" ></i>\n      <span class=\"col\">\n        <p class=\"mb-0\">Para obtener duplicados de su certificado, debe llenar la siguiente información.</p>\n      </span>\n    </div>\n    <br/>\n    <div class=\"row\">\n      <div class=\"col-md form-group\">\n        <div class=\"form-group\">\n          <label>Cantidad de duplicados que requiere</label>\n          <input  name=\"cantidad\" ng-model=\"$ctrl.obj.duplicados\"  numeric maxlength=\"5\" class=\"form-control\"  placeholder=\"\" required  autocomplete=\"off\" >\n          <div ap-error ng-messages=\"general_form.cantidad.$error\" role=\"alert\" ng-if=\"general_form.cantidad.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>  \n          </div>\n        </div>\n      </div>\n      <div class=\"col-md form-group\">\n        <div ng-if=\"$ctrl.obj.duplicados\">\n          <div class=\"alert alert-info row mx-0\" >\n            <i class=\"fa fa-info-circle\" ></i>\n            <span class=\"col\">\n              <p class=\"mb-0\">El monto del deposito deberá ser de <br/>Bs. {{$ctrl.numberFormat(  ( $ctrl.escalaPago * $ctrl.obj.duplicados)  , 2)}} </p>\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md form-group\">\n        <div class=\"form-group\">\n          <label>Código de Boleta</label>\n          <input  name=\"codigo\" ng-model=\"$ctrl.obj.codigo_deposito\" class=\"form-control\"  placeholder=\"\" required maxlength=\"30\">\n          <div ap-error ng-messages=\"general_form.codigo.$error\" role=\"alert\" ng-if=\"general_form.codigo.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md form-group\">\n        <label>Fecha de Depósito</label>\n        <div class=\"input-group uib-input-date\">\n          <input name=\"fecha_deposito\" maxlength=\"10\" class=\"form-control\" datepicker-append-to-body=\"true\" placeholder=\"dd/mm/aaaa\"\n                 uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\" ng-model=\"$ctrl.obj.fecha_deposito\" is-open=\"$ctrl.deposito.is_open\" ng-change=\"$ctrl.validateFechaDeposito(general_form)\"\n                 datepicker-options=\"$ctrl.conf\" ng-required=\"true\" close-text=\"Close\"/>\n          <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.deposito.is_open = true\"><i class=\"fa fa-calendar\"></i></button>\n          </span>\n        </div>\n        <div ap-error ng-messages=\"general_form.fecha_deposito.$error\" role=\"alert\" ng-if=\"general_form.fecha_deposito.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n          <div ng-message=\"date\">Formato de fecha incorrecta (Ejemplo:15/02/1996)</div>\n          <div ng-message=\"min_date\">La fecha mínima aceptada es {{$ctrl.conf.minDate| date:'dd/MM/yyyy'}}</div>\n          <div ng-message=\"max_date\">La fecha máxima aceptada es {{$ctrl.conf.maxDate| date:'dd/MM/yyyy'}}</div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.solicitar()\" ng-disabled=\"general_form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Solicitar\n    </button>\n  </div>\n</ng-form>\n"

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(12)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Glob = void 0;
	/**
	 * Matches state names using glob-like pattern strings.
	 *
	 * Globs can be used in specific APIs including:
	 *
	 * - [[StateService.is]]
	 * - [[StateService.includes]]
	 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
	 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
	 *
	 * A `Glob` string is a pattern which matches state names.
	 * Nested state names are split into segments (separated by a dot) when processing.
	 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
	 *
	 * Globs work according to the following rules:
	 *
	 * ### Exact match:
	 *
	 * The glob `'A.B'` matches the state named exactly `'A.B'`.
	 *
	 * | Glob        |Matches states named|Does not match state named|
	 * |:------------|:--------------------|:---------------------|
	 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
	 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
	 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
	 *
	 * ### Single star (`*`)
	 *
	 * A single star (`*`) is a wildcard that matches exactly one segment.
	 *
	 * | Glob        |Matches states named  |Does not match state named |
	 * |:------------|:---------------------|:--------------------------|
	 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
	 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
	 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
	 *
	 * ### Double star (`**`)
	 *
	 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
	 *
	 * | Glob        |Matches states named                           |Does not match state named         |
	 * |:------------|:----------------------------------------------|:----------------------------------|
	 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
	 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
	 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
	 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
	 *
	 * @packageDocumentation
	 */
	var Glob = /** @class */ (function () {
	    function Glob(text) {
	        this.text = text;
	        this.glob = text.split('.');
	        var regexpString = this.text
	            .split('.')
	            .map(function (seg) {
	            if (seg === '**')
	                return '(?:|(?:\\.[^.]*)*)';
	            if (seg === '*')
	                return '\\.[^.]*';
	            return '\\.' + seg;
	        })
	            .join('');
	        this.regexp = new RegExp('^' + regexpString + '$');
	    }
	    /** Returns true if the string has glob-like characters in it */
	    Glob.is = function (text) {
	        return !!/[!,*]+/.exec(text);
	    };
	    /** Returns a glob from the string, or null if the string isn't Glob-like */
	    Glob.fromString = function (text) {
	        return Glob.is(text) ? new Glob(text) : null;
	    };
	    Glob.prototype.matches = function (name) {
	        return this.regexp.test('.' + name);
	    };
	    return Glob;
	}());
	exports.Glob = Glob;
	//# sourceMappingURL=glob.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Queue = void 0;
	var common_1 = __webpack_require__(1);
	var Queue = /** @class */ (function () {
	    function Queue(_items, _limit) {
	        if (_items === void 0) { _items = []; }
	        if (_limit === void 0) { _limit = null; }
	        this._items = _items;
	        this._limit = _limit;
	        this._evictListeners = [];
	        this.onEvict = common_1.pushTo(this._evictListeners);
	    }
	    Queue.prototype.enqueue = function (item) {
	        var items = this._items;
	        items.push(item);
	        if (this._limit && items.length > this._limit)
	            this.evict();
	        return item;
	    };
	    Queue.prototype.evict = function () {
	        var item = this._items.shift();
	        this._evictListeners.forEach(function (fn) { return fn(item); });
	        return item;
	    };
	    Queue.prototype.dequeue = function () {
	        if (this.size())
	            return this._items.splice(0, 1)[0];
	    };
	    Queue.prototype.clear = function () {
	        var current = this._items;
	        this._items = [];
	        return current;
	    };
	    Queue.prototype.size = function () {
	        return this._items.length;
	    };
	    Queue.prototype.remove = function (item) {
	        var idx = this._items.indexOf(item);
	        return idx > -1 && this._items.splice(idx, 1)[0];
	    };
	    Queue.prototype.peekTail = function () {
	        return this._items[this._items.length - 1];
	    };
	    Queue.prototype.peekHead = function () {
	        if (this.size())
	            return this._items[0];
	    };
	    return Queue;
	}());
	exports.Queue = Queue;
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This module contains code for State Parameters.
	 *
	 * See [[ParamDeclaration]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(112), exports);
	__exportStar(__webpack_require__(16), exports);
	__exportStar(__webpack_require__(113), exports);
	__exportStar(__webpack_require__(53), exports);
	__exportStar(__webpack_require__(36), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamType = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	/**
	 * An internal class which implements [[ParamTypeDefinition]].
	 *
	 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
	 * When a param type definition is registered, an instance of this class is created internally.
	 *
	 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
	 *
	 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
	 *
	 * #### Example:
	 * ```js
	 * var paramTypeDef = {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 *
	 * var paramType = new ParamType(paramTypeDef);
	 * ```
	 */
	var ParamType = /** @class */ (function () {
	    /**
	     * @param def  A configuration object which contains the custom type definition.  The object's
	     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
	     * @returns a new ParamType object
	     */
	    function ParamType(def) {
	        /** @inheritdoc */
	        this.pattern = /.*/;
	        /** @inheritdoc */
	        this.inherit = true;
	        common_1.extend(this, def);
	    }
	    // consider these four methods to be "abstract methods" that should be overridden
	    /** @inheritdoc */
	    ParamType.prototype.is = function (val, key) {
	        return true;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.encode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.decode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.equals = function (a, b) {
	        // tslint:disable-next-line:triple-equals
	        return a == b;
	    };
	    ParamType.prototype.$subPattern = function () {
	        var sub = this.pattern.toString();
	        return sub.substr(1, sub.length - 2);
	    };
	    ParamType.prototype.toString = function () {
	        return "{ParamType:" + this.name + "}";
	    };
	    /** Given an encoded string, or a decoded object, returns a decoded object */
	    ParamType.prototype.$normalize = function (val) {
	        return this.is(val) ? val : this.decode(val);
	    };
	    /**
	     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
	     * e.g.:
	     * - urlmatcher pattern "/path?{queryParam[]:int}"
	     * - url: "/path?queryParam=1&queryParam=2
	     * - $stateParams.queryParam will be [1, 2]
	     * if `mode` is "auto", then
	     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	     */
	    ParamType.prototype.$asArray = function (mode, isSearch) {
	        if (!mode)
	            return this;
	        if (mode === 'auto' && !isSearch)
	            throw new Error("'auto' array mode is for query parameters only");
	        return new ArrayType(this, mode);
	    };
	    return ParamType;
	}());
	exports.ParamType = ParamType;
	/** Wraps up a `ParamType` object to handle array values. */
	function ArrayType(type, mode) {
	    var _this = this;
	    // Wrap non-array value as array
	    function arrayWrap(val) {
	        return predicates_1.isArray(val) ? val : predicates_1.isDefined(val) ? [val] : [];
	    }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	        switch (val.length) {
	            case 0:
	                return undefined;
	            case 1:
	                return mode === 'auto' ? val[0] : val;
	            default:
	                return val;
	        }
	    }
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	            if (predicates_1.isArray(val) && val.length === 0)
	                return val;
	            var arr = arrayWrap(val);
	            var result = common_1.map(arr, callback);
	            return allTruthyMode === true ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
	        };
	    }
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	            var left = arrayWrap(val1), right = arrayWrap(val2);
	            if (left.length !== right.length)
	                return false;
	            for (var i = 0; i < left.length; i++) {
	                if (!callback(left[i], right[i]))
	                    return false;
	            }
	            return true;
	        };
	    }
	    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
	        var paramTypeFn = type[name].bind(type);
	        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
	        _this[name] = wrapperFn(paramTypeFn);
	    });
	    common_1.extend(this, {
	        dynamic: type.dynamic,
	        name: type.name,
	        pattern: type.pattern,
	        inherit: type.inherit,
	        raw: type.raw,
	        is: arrayHandler(type.is.bind(type), true),
	        $arrayMode: mode,
	    });
	}
	//# sourceMappingURL=paramType.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PathNode = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var param_1 = __webpack_require__(16);
	/**
	 * A node in a [[TreeChanges]] path
	 *
	 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
	 * Each PathNode corresponds to a state being entered, exited, or retained.
	 * The stateful information includes parameter values and resolve data.
	 */
	var PathNode = /** @class */ (function () {
	    function PathNode(stateOrNode) {
	        if (stateOrNode instanceof PathNode) {
	            var node = stateOrNode;
	            this.state = node.state;
	            this.paramSchema = node.paramSchema.slice();
	            this.paramValues = common_1.extend({}, node.paramValues);
	            this.resolvables = node.resolvables.slice();
	            this.views = node.views && node.views.slice();
	        }
	        else {
	            var state = stateOrNode;
	            this.state = state;
	            this.paramSchema = state.parameters({ inherit: false });
	            this.paramValues = {};
	            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
	        }
	    }
	    PathNode.prototype.clone = function () {
	        return new PathNode(this);
	    };
	    /** Sets [[paramValues]] for the node, from the values of an object hash */
	    PathNode.prototype.applyRawParams = function (params) {
	        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
	        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
	        return this;
	    };
	    /** Gets a specific [[Param]] metadata that belongs to the node */
	    PathNode.prototype.parameter = function (name) {
	        return common_1.find(this.paramSchema, hof_1.propEq('id', name));
	    };
	    /**
	     * @returns true if the state and parameter values for another PathNode are
	     * equal to the state and param values for this PathNode
	     */
	    PathNode.prototype.equals = function (node, paramsFn) {
	        var diff = this.diff(node, paramsFn);
	        return diff && diff.length === 0;
	    };
	    /**
	     * Finds Params with different parameter values on another PathNode.
	     *
	     * Given another node (of the same state), finds the parameter values which differ.
	     * Returns the [[Param]] (schema objects) whose parameter values differ.
	     *
	     * Given another node for a different state, returns `false`
	     *
	     * @param node The node to compare to
	     * @param paramsFn A function that returns which parameters should be compared.
	     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
	     */
	    PathNode.prototype.diff = function (node, paramsFn) {
	        if (this.state !== node.state)
	            return false;
	        var params = paramsFn ? paramsFn(this) : this.paramSchema;
	        return param_1.Param.changed(params, this.paramValues, node.paramValues);
	    };
	    /**
	     * Returns a clone of the PathNode
	     * @deprecated use instance method `node.clone()`
	     */
	    PathNode.clone = function (node) { return node.clone(); };
	    return PathNode;
	}());
	exports.PathNode = PathNode;
	//# sourceMappingURL=pathNode.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # The state subsystem
	 *
	 * This subsystem implements the ui-router state tree
	 *
	 * - The [[StateService]] has state-related service methods such as:
	 *   - [[StateService.get]]: Get a registered [[StateDeclaration]] object
	 *   - [[StateService.go]]: Transition from the current state to a new state
	 *   - [[StateService.reload]]: Reload the current state
	 *   - [[StateService.target]]: Get a [[TargetState]] (useful when redirecting from a Transition Hook)
	 *   - [[StateService.onInvalid]]: Register a callback for when a transition to an invalid state is started
	 *   - [[StateService.defaultErrorHandler]]: Register a global callback for when a transition errors
	 * - The [[StateDeclaration]] interface defines the shape of a state declaration
	 * - The [[StateRegistry]] contains all the registered states
	 *   - States can be added/removed using the [[StateRegistry.register]] and [[StateRegistry.deregister]]
	 *     - Note: Bootstrap state registration differs by front-end framework.
	 *   - Get notified of state registration/deregistration using [[StateRegistry.onStatesChanged]].
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(115), exports);
	__exportStar(__webpack_require__(57), exports);
	__exportStar(__webpack_require__(39), exports);
	__exportStar(__webpack_require__(58), exports);
	__exportStar(__webpack_require__(59), exports);
	__exportStar(__webpack_require__(60), exports);
	__exportStar(__webpack_require__(61), exports);
	__exportStar(__webpack_require__(17), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateObject = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var glob_1 = __webpack_require__(33);
	var predicates_1 = __webpack_require__(2);
	/**
	 * Internal representation of a UI-Router state.
	 *
	 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
	 *
	 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
	 *
	 * This class prototypally inherits from the corresponding [[StateDeclaration]].
	 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
	 */
	var StateObject = /** @class */ (function () {
	    /** @deprecated use State.create() */
	    function StateObject(config) {
	        return StateObject.create(config || {});
	    }
	    /**
	     * Create a state object to put the private/internal implementation details onto.
	     * The object's prototype chain looks like:
	     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
	     *
	     * @param stateDecl the user-supplied State Declaration
	     * @returns {StateObject} an internal State object
	     */
	    StateObject.create = function (stateDecl) {
	        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
	        var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
	        stateDecl.$$state = function () { return state; };
	        state.self = stateDecl;
	        state.__stateObjectCache = {
	            nameGlob: glob_1.Glob.fromString(state.name),
	        };
	        return state;
	    };
	    /**
	     * Returns true if the provided parameter is the same state.
	     *
	     * Compares the identity of the state against the passed value, which is either an object
	     * reference to the actual `State` instance, the original definition object passed to
	     * `$stateProvider.state()`, or the fully-qualified name.
	     *
	     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
	     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
	     * @returns Returns `true` if `ref` matches the current `State` instance.
	     */
	    StateObject.prototype.is = function (ref) {
	        return this === ref || this.self === ref || this.fqn() === ref;
	    };
	    /**
	     * @deprecated this does not properly handle dot notation
	     * @returns Returns a dot-separated name of the state.
	     */
	    StateObject.prototype.fqn = function () {
	        if (!this.parent || !(this.parent instanceof this.constructor))
	            return this.name;
	        var name = this.parent.fqn();
	        return name ? name + '.' + this.name : this.name;
	    };
	    /**
	     * Returns the root node of this state's tree.
	     *
	     * @returns The root of this state's tree.
	     */
	    StateObject.prototype.root = function () {
	        return (this.parent && this.parent.root()) || this;
	    };
	    /**
	     * Gets the state's `Param` objects
	     *
	     * Gets the list of [[Param]] objects owned by the state.
	     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
	     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
	     *
	     * @param opts options
	     */
	    StateObject.prototype.parameters = function (opts) {
	        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
	        var inherited = (opts.inherit && this.parent && this.parent.parameters()) || [];
	        return inherited
	            .concat(common_1.values(this.params))
	            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
	    };
	    /**
	     * Returns a single [[Param]] that is owned by the state
	     *
	     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
	     * @param id the name of the [[Param]] to return
	     * @param opts options
	     */
	    StateObject.prototype.parameter = function (id, opts) {
	        if (opts === void 0) { opts = {}; }
	        return ((this.url && this.url.parameter(id, opts)) ||
	            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
	            (opts.inherit && this.parent && this.parent.parameter(id)));
	    };
	    StateObject.prototype.toString = function () {
	        return this.fqn();
	    };
	    /** Predicate which returns true if the object is an class with @State() decorator */
	    StateObject.isStateClass = function (stateDecl) {
	        return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
	    };
	    /** Predicate which returns true if the object is a [[StateDeclaration]] object */
	    StateObject.isStateDeclaration = function (obj) { return predicates_1.isFunction(obj['$$state']); };
	    /** Predicate which returns true if the object is an internal [[StateObject]] object */
	    StateObject.isState = function (obj) { return predicates_1.isObject(obj['__stateObjectCache']); };
	    return StateObject;
	}());
	exports.StateObject = StateObject;
	//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.makeEvent = exports.RegisteredHook = exports.matchState = void 0;
	var common_1 = __webpack_require__(4);
	var interface_1 = __webpack_require__(10);
	/**
	 * Determines if the given state matches the matchCriteria
	 *
	 * @internal
	 *
	 * @param state a State Object to test against
	 * @param criterion
	 * - If a string, matchState uses the string as a glob-matcher against the state name
	 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
	 *   and returns a positive match if any of the globs match.
	 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
	 * @returns {boolean}
	 */
	function matchState(state, criterion, transition) {
	    var toMatch = common_1.isString(criterion) ? [criterion] : criterion;
	    function matchGlobs(_state) {
	        var globStrings = toMatch;
	        for (var i = 0; i < globStrings.length; i++) {
	            var glob = new common_1.Glob(globStrings[i]);
	            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    var matchFn = (common_1.isFunction(toMatch) ? toMatch : matchGlobs);
	    return !!matchFn(state, transition);
	}
	exports.matchState = matchState;
	/**
	 * The registration data for a registered transition hook
	 */
	var RegisteredHook = /** @class */ (function () {
	    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
	        if (options === void 0) { options = {}; }
	        this.tranSvc = tranSvc;
	        this.eventType = eventType;
	        this.callback = callback;
	        this.matchCriteria = matchCriteria;
	        this.removeHookFromRegistry = removeHookFromRegistry;
	        this.invokeCount = 0;
	        this._deregistered = false;
	        this.priority = options.priority || 0;
	        this.bind = options.bind || null;
	        this.invokeLimit = options.invokeLimit;
	    }
	    /**
	     * Gets the matching [[PathNode]]s
	     *
	     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
	     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
	     *
	     * Returning `null` is significant to distinguish between the default
	     * "match-all criterion value" of `true` compared to a `() => true` function,
	     * when the nodes is an empty array.
	     *
	     * This is useful to allow a transition match criteria of `entering: true`
	     * to still match a transition, even when `entering === []`.  Contrast that
	     * with `entering: (state) => true` which only matches when a state is actually
	     * being entered.
	     */
	    RegisteredHook.prototype._matchingNodes = function (nodes, criterion, transition) {
	        if (criterion === true)
	            return nodes;
	        var matching = nodes.filter(function (node) { return matchState(node.state, criterion, transition); });
	        return matching.length ? matching : null;
	    };
	    /**
	     * Gets the default match criteria (all `true`)
	     *
	     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
	     *
	     * ```js
	     * {
	     *   to: true,
	     *   from: true,
	     *   entering: true,
	     *   exiting: true,
	     *   retained: true,
	     * }
	     */
	    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
	        return common_1.mapObj(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
	    };
	    /**
	     * Gets matching nodes as [[IMatchingNodes]]
	     *
	     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
	     *
	     * ```js
	     * let matches: IMatchingNodes = {
	     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
	     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
	     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
	     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
	     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
	     * };
	     * ```
	     */
	    RegisteredHook.prototype._getMatchingNodes = function (treeChanges, transition) {
	        var _this = this;
	        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
	        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
	        return paths.reduce(function (mn, pathtype) {
	            // STATE scope criteria matches against every node in the path.
	            // TRANSITION scope criteria matches against only the last node in the path
	            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
	            var path = treeChanges[pathtype.name] || [];
	            var nodes = isStateHook ? path : [common_1.tail(path)];
	            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
	            return mn;
	        }, {});
	    };
	    /**
	     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
	     *
	     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
	     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
	     */
	    RegisteredHook.prototype.matches = function (treeChanges, transition) {
	        var matches = this._getMatchingNodes(treeChanges, transition);
	        // Check if all the criteria matched the TreeChanges object
	        var allMatched = common_1.values(matches).every(common_1.identity);
	        return allMatched ? matches : null;
	    };
	    RegisteredHook.prototype.deregister = function () {
	        this.removeHookFromRegistry(this);
	        this._deregistered = true;
	    };
	    return RegisteredHook;
	}());
	exports.RegisteredHook = RegisteredHook;
	/** Return a registration function of the requested type. */
	function makeEvent(registry, transitionService, eventType) {
	    // Create the object which holds the registered transition hooks.
	    var _registeredHooks = (registry._registeredHooks = registry._registeredHooks || {});
	    var hooks = (_registeredHooks[eventType.name] = []);
	    var removeHookFn = common_1.removeFrom(hooks);
	    // Create hook registration function on the IHookRegistry for the event
	    registry[eventType.name] = hookRegistrationFn;
	    function hookRegistrationFn(matchObject, callback, options) {
	        if (options === void 0) { options = {}; }
	        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
	        hooks.push(registeredHook);
	        return registeredHook.deregister.bind(registeredHook);
	    }
	    return hookRegistrationFn;
	}
	exports.makeEvent = makeEvent;
	//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Transition = void 0;
	var trace_1 = __webpack_require__(8);
	var coreservices_1 = __webpack_require__(5);
	var strings_1 = __webpack_require__(6);
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var interface_1 = __webpack_require__(10); // has or is using
	var transitionHook_1 = __webpack_require__(18);
	var hookRegistry_1 = __webpack_require__(40);
	var hookBuilder_1 = __webpack_require__(62);
	var pathUtils_1 = __webpack_require__(21);
	var param_1 = __webpack_require__(16);
	var resolvable_1 = __webpack_require__(22);
	var resolveContext_1 = __webpack_require__(23);
	var rejectFactory_1 = __webpack_require__(11);
	var common_2 = __webpack_require__(4);
	/** @internal */
	var stateSelf = hof_1.prop('self');
	/**
	 * Represents a transition between two states.
	 *
	 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
	 *
	 * This object contains all contextual information about the to/from states, parameters, resolves.
	 * It has information about all states being entered and exited as a result of the transition.
	 */
	var Transition = /** @class */ (function () {
	    /**
	     * Creates a new Transition object.
	     *
	     * If the target state is not valid, an error is thrown.
	     *
	     * @internal
	     *
	     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
	     *        encapsulates the "from state".
	     * @param targetState The target state and parameters being transitioned to (also, the transition options)
	     * @param router The [[UIRouter]] instance
	     * @internal
	     */
	    function Transition(fromPath, targetState, router) {
	        var _this = this;
	        /** @internal */
	        this._deferred = coreservices_1.services.$q.defer();
	        /**
	         * This promise is resolved or rejected based on the outcome of the Transition.
	         *
	         * When the transition is successful, the promise is resolved
	         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
	         */
	        this.promise = this._deferred.promise;
	        /** @internal Holds the hook registration functions such as those passed to Transition.onStart() */
	        this._registeredHooks = {};
	        /** @internal */
	        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
	        /** Checks if this transition is currently active/running. */
	        this.isActive = function () { return _this.router.globals.transition === _this; };
	        this.router = router;
	        this._targetState = targetState;
	        if (!targetState.valid()) {
	            throw new Error(targetState.error());
	        }
	        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
	        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
	        this.$id = router.transitionService._transitionCount++;
	        var toPath = pathUtils_1.PathUtils.buildToPath(fromPath, targetState);
	        this._treeChanges = pathUtils_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
	        this.createTransitionHookRegFns();
	        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
	        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
	        this.applyViewConfigs(router);
	    }
	    /** @internal */
	    Transition.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /** @internal
	     * Creates the transition-level hook registration functions
	     * (which can then be used to register hooks)
	     */
	    Transition.prototype.createTransitionHookRegFns = function () {
	        var _this = this;
	        this.router.transitionService._pluginapi
	            ._getEvents()
	            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
	            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
	    };
	    /** @internal */
	    Transition.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    Transition.prototype.applyViewConfigs = function (router) {
	        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
	        pathUtils_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
	    };
	    /**
	     * @internal
	     * @returns the internal from [State] object
	     */
	    Transition.prototype.$from = function () {
	        return common_1.tail(this._treeChanges.from).state;
	    };
	    /**
	     * @internal
	     * @returns the internal to [State] object
	     */
	    Transition.prototype.$to = function () {
	        return common_1.tail(this._treeChanges.to).state;
	    };
	    /**
	     * Returns the "from state"
	     *
	     * Returns the state that the transition is coming *from*.
	     *
	     * @returns The state declaration object for the Transition's ("from state").
	     */
	    Transition.prototype.from = function () {
	        return this.$from().self;
	    };
	    /**
	     * Returns the "to state"
	     *
	     * Returns the state that the transition is going *to*.
	     *
	     * @returns The state declaration object for the Transition's target state ("to state").
	     */
	    Transition.prototype.to = function () {
	        return this.$to().self;
	    };
	    /**
	     * Gets the Target State
	     *
	     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
	     *
	     * @returns the [[TargetState]] of this Transition
	     */
	    Transition.prototype.targetState = function () {
	        return this._targetState;
	    };
	    /**
	     * Determines whether two transitions are equivalent.
	     * @deprecated
	     */
	    Transition.prototype.is = function (compare) {
	        if (compare instanceof Transition) {
	            // TODO: Also compare parameters
	            return this.is({ to: compare.$to().name, from: compare.$from().name });
	        }
	        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to, this)) ||
	            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from, this)));
	    };
	    Transition.prototype.params = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}));
	    };
	    Transition.prototype.paramsChanged = function () {
	        var fromParams = this.params('from');
	        var toParams = this.params('to');
	        // All the parameters declared on both the "to" and "from" paths
	        var allParamDescriptors = []
	            .concat(this._treeChanges.to)
	            .concat(this._treeChanges.from)
	            .map(function (pathNode) { return pathNode.paramSchema; })
	            .reduce(common_2.flattenR, [])
	            .reduce(common_2.uniqR, []);
	        var changedParamDescriptors = param_1.Param.changed(allParamDescriptors, fromParams, toParams);
	        return changedParamDescriptors.reduce(function (changedValues, descriptor) {
	            changedValues[descriptor.id] = toParams[descriptor.id];
	            return changedValues;
	        }, {});
	    };
	    /**
	     * Creates a [[UIInjector]] Dependency Injector
	     *
	     * Returns a Dependency Injector for the Transition's target state (to state).
	     * The injector provides resolve values which the target state has access to.
	     *
	     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
	     *
	     * #### Example:
	     * ```js
	     * .onEnter({ entering: 'myState' }, trans => {
	     *   var myResolveValue = trans.injector().get('myResolve');
	     *   // Inject a global service from the global/native injector (if it exists)
	     *   var MyService = trans.injector().get('MyService');
	     * })
	     * ```
	     *
	     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
	     * You can use [[UIInjector.getAsync]] to get a promise for the data.
	     * #### Example:
	     * ```js
	     * .onBefore({}, trans => {
	     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
	     *     return myResolveValue !== 'ABORT';
	     *   });
	     * });
	     * ```
	     *
	     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
	     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
	     * #### Example:
	     * ```js
	     * .onEnter({ to: 'foo.bar' }, trans => {
	     *   // returns result of `foo` state's `myResolve` resolve
	     *   // even though `foo.bar` also has a `myResolve` resolve
	     *   var fooData = trans.injector('foo').get('myResolve');
	     * });
	     * ```
	     *
	     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
	     * The resolve data from the `from` path will be returned.
	     * #### Example:
	     * ```js
	     * .onExit({ exiting: 'foo.bar' }, trans => {
	     *   // Gets the resolve value of `myResolve` from the state being exited
	     *   var fooData = trans.injector(null, 'from').get('myResolve');
	     * });
	     * ```
	     *
	     *
	     * @param state Limits the resolves provided to only the resolves the provided state has access to.
	     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
	     *
	     * @returns a [[UIInjector]]
	     */
	    Transition.prototype.injector = function (state, pathName) {
	        if (pathName === void 0) { pathName = 'to'; }
	        var path = this._treeChanges[pathName];
	        if (state)
	            path = pathUtils_1.PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
	        return new resolveContext_1.ResolveContext(path).injector();
	    };
	    /**
	     * Gets all available resolve tokens (keys)
	     *
	     * This method can be used in conjunction with [[injector]] to inspect the resolve values
	     * available to the Transition.
	     *
	     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
	     * in the Transition's [[TreeChanges.to]] path.
	     *
	     * #### Example:
	     * This example logs all resolve values
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
	     * ```
	     *
	     * #### Example:
	     * This example creates promises for each resolve value.
	     * This triggers fetches of resolves (if any have not yet been fetched).
	     * When all promises have all settled, it logs the resolve values.
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * let promise = tokens.map(token => trans.injector().getAsync(token));
	     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
	     * ```
	     *
	     * Note: Angular 1 users whould use `$q.all()`
	     *
	     * @param pathname resolve context's path name (e.g., `to` or `from`)
	     *
	     * @returns an array of resolve tokens (keys)
	     */
	    Transition.prototype.getResolveTokens = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
	    };
	    /**
	     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
	     *
	     * Allows a transition hook to dynamically add a Resolvable to this Transition.
	     *
	     * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
	     *
	     * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
	     * If no `state` is provided then the root state is used.
	     * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
	     * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
	     *
	     * The `state` argument also scopes the resolved data.
	     * The resolved data is available from the injector for that `state` and any children states.
	     *
	     * #### Example:
	     * ```js
	     * transitionService.onBefore({}, transition => {
	     *   transition.addResolvable({
	     *     token: 'myResolve',
	     *     deps: ['MyService'],
	     *     resolveFn: myService => myService.getData()
	     *   });
	     * });
	     * ```
	     *
	     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
	     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
	     */
	    Transition.prototype.addResolvable = function (resolvable, state) {
	        if (state === void 0) { state = ''; }
	        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
	        var stateName = typeof state === 'string' ? state : state.name;
	        var topath = this._treeChanges.to;
	        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
	        var resolveContext = new resolveContext_1.ResolveContext(topath);
	        resolveContext.addResolvables([resolvable], targetNode.state);
	    };
	    /**
	     * Gets the transition from which this transition was redirected.
	     *
	     * If the current transition is a redirect, this method returns the transition that was redirected.
	     *
	     * #### Example:
	     * ```js
	     * let transitionA = $state.go('A').transition
	     * transitionA.onStart({}, () => $state.target('B'));
	     * $transitions.onSuccess({ to: 'B' }, (trans) => {
	     *   trans.to().name === 'B'; // true
	     *   trans.redirectedFrom() === transitionA; // true
	     * });
	     * ```
	     *
	     * @returns The previous Transition, or null if this Transition is not the result of a redirection
	     */
	    Transition.prototype.redirectedFrom = function () {
	        return this._options.redirectedFrom || null;
	    };
	    /**
	     * Gets the original transition in a redirect chain
	     *
	     * A transition might belong to a long chain of multiple redirects.
	     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
	     *
	     * #### Example:
	     * ```js
	     * // states
	     * registry.register({ name: 'A', redirectTo: 'B' });
	     * registry.register({ name: 'B', redirectTo: 'C' });
	     * registry.register({ name: 'C', redirectTo: 'D' });
	     * registry.register({ name: 'D' });
	     *
	     * let transitionA = $state.go('A').transition
	     *
	     * $transitions.onSuccess({ to: 'D' }, (trans) => {
	     *   trans.to().name === 'D'; // true
	     *   trans.redirectedFrom().to().name === 'C'; // true
	     *   trans.originalTransition() === transitionA; // true
	     *   trans.originalTransition().to().name === 'A'; // true
	     * });
	     * ```
	     *
	     * @returns The original Transition that started a redirect chain
	     */
	    Transition.prototype.originalTransition = function () {
	        var rf = this.redirectedFrom();
	        return (rf && rf.originalTransition()) || this;
	    };
	    /**
	     * Get the transition options
	     *
	     * @returns the options for this Transition.
	     */
	    Transition.prototype.options = function () {
	        return this._options;
	    };
	    /**
	     * Gets the states being entered.
	     *
	     * @returns an array of states that will be entered during this transition.
	     */
	    Transition.prototype.entering = function () {
	        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Gets the states being exited.
	     *
	     * @returns an array of states that will be exited during this transition.
	     */
	    Transition.prototype.exiting = function () {
	        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
	    };
	    /**
	     * Gets the states being retained.
	     *
	     * @returns an array of states that are already entered from a previous Transition, that will not be
	     *    exited during this Transition
	     */
	    Transition.prototype.retained = function () {
	        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Get the [[ViewConfig]]s associated with this Transition
	     *
	     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
	     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
	     *
	     * @param pathname the name of the path to fetch views for:
	     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
	     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
	     *
	     * @returns a list of ViewConfig objects for the given path.
	     */
	    Transition.prototype.views = function (pathname, state) {
	        if (pathname === void 0) { pathname = 'entering'; }
	        var path = this._treeChanges[pathname];
	        path = !state ? path : path.filter(hof_1.propEq('state', state));
	        return path.map(hof_1.prop('views')).filter(common_1.identity).reduce(common_1.unnestR, []);
	    };
	    Transition.prototype.treeChanges = function (pathname) {
	        return pathname ? this._treeChanges[pathname] : this._treeChanges;
	    };
	    /**
	     * Creates a new transition that is a redirection of the current one.
	     *
	     * This transition can be returned from a [[TransitionService]] hook to
	     * redirect a transition to a new state and/or set of parameters.
	     *
	     * @internal
	     *
	     * @returns Returns a new [[Transition]] instance.
	     */
	    Transition.prototype.redirect = function (targetState) {
	        var redirects = 1, trans = this;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((trans = trans.redirectedFrom()) != null) {
	            if (++redirects > 20)
	                throw new Error("Too many consecutive Transition redirects (20+)");
	        }
	        var redirectOpts = { redirectedFrom: this, source: 'redirect' };
	        // If the original transition was caused by URL sync, then use { location: 'replace' }
	        // on the new transition (unless the target state explicitly specifies location: false).
	        // This causes the original url to be replaced with the url for the redirect target
	        // so the original url disappears from the browser history.
	        if (this.options().source === 'url' && targetState.options().location !== false) {
	            redirectOpts.location = 'replace';
	        }
	        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
	        targetState = targetState.withOptions(newOptions, true);
	        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
	        var originalEnteringNodes = this._treeChanges.entering;
	        var redirectEnteringNodes = newTransition._treeChanges.entering;
	        // --- Re-use resolve data from original transition ---
	        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
	        // (because of the redirect), the resolves fetched by the original transition are still valid in the
	        // redirected transition.
	        //
	        // This allows you to define a redirect on a parent state which depends on an async resolve value.
	        // You can wait for the resolve, then redirect to a child state based on the result.
	        // The redirected transition does not have to re-fetch the resolve.
	        // ---------------------------------------------------------
	        var nodeIsReloading = function (reloadState) { return function (node) {
	            return reloadState && node.state.includes[reloadState.name];
	        }; };
	        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
	        var matchingEnteringNodes = pathUtils_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathUtils_1.PathUtils.nonDynamicParams).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
	        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
	        matchingEnteringNodes.forEach(function (node, idx) {
	            node.resolvables = originalEnteringNodes[idx].resolvables;
	        });
	        return newTransition;
	    };
	    /** @internal If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
	    Transition.prototype._changedParams = function () {
	        var tc = this._treeChanges;
	        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
	        // If user explicitly wants a reload
	        if (this._options.reload)
	            return undefined;
	        // If any states are exiting or entering
	        if (tc.exiting.length || tc.entering.length)
	            return undefined;
	        // If to/from path lengths differ
	        if (tc.to.length !== tc.from.length)
	            return undefined;
	        // If the to/from paths are different
	        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
	            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
	            .reduce(common_1.anyTrueR, false);
	        if (pathsDiffer)
	            return undefined;
	        // Find any parameter values that differ
	        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
	        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
	        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
	        return tuples.map(function (_a) {
	            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
	            return param_1.Param.changed(schema, toVals, fromVals);
	        }).reduce(common_1.unnestR, []);
	    };
	    /**
	     * Returns true if the transition is dynamic.
	     *
	     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
	     *
	     * @returns true if the Transition is dynamic
	     */
	    Transition.prototype.dynamic = function () {
	        var changes = this._changedParams();
	        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
	    };
	    /**
	     * Returns true if the transition is ignored.
	     *
	     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
	     *
	     * @returns true if the Transition is ignored.
	     */
	    Transition.prototype.ignored = function () {
	        return !!this._ignoredReason();
	    };
	    /** @internal */
	    Transition.prototype._ignoredReason = function () {
	        var pending = this.router.globals.transition;
	        var reloadState = this._options.reloadState;
	        var same = function (pathA, pathB) {
	            if (pathA.length !== pathB.length)
	                return false;
	            var matching = pathUtils_1.PathUtils.matching(pathA, pathB);
	            return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
	        };
	        var newTC = this.treeChanges();
	        var pendTC = pending && pending.treeChanges();
	        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
	            return 'SameAsPending';
	        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
	            return 'SameAsCurrent';
	    };
	    /**
	     * Runs the transition
	     *
	     * This method is generally called from the [[StateService.transitionTo]]
	     *
	     * @internal
	     *
	     * @returns a promise for a successful transition.
	     */
	    Transition.prototype.run = function () {
	        var _this = this;
	        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
	        // Gets transition hooks array for the given phase
	        var getHooksFor = function (phase) { return _this._hookBuilder.buildHooksForPhase(phase); };
	        // When the chain is complete, then resolve or reject the deferred
	        var transitionSuccess = function () {
	            trace_1.trace.traceSuccess(_this.$to(), _this);
	            _this.success = true;
	            _this._deferred.resolve(_this.to());
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
	        };
	        var transitionError = function (reason) {
	            trace_1.trace.traceError(reason, _this);
	            _this.success = false;
	            _this._deferred.reject(reason);
	            _this._error = reason;
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
	        };
	        var runTransition = function () {
	            // Wait to build the RUN hook chain until the BEFORE hooks are done
	            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
	            var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
	            var done = function () { return coreservices_1.services.$q.when(undefined); };
	            return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
	        };
	        var startTransition = function () {
	            var globals = _this.router.globals;
	            globals.lastStartedTransitionId = _this.$id;
	            globals.transition = _this;
	            globals.transitionHistory.enqueue(_this);
	            trace_1.trace.traceTransitionStart(_this);
	            return coreservices_1.services.$q.when(undefined);
	        };
	        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
	        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition)
	            .then(runTransition)
	            .then(transitionSuccess, transitionError);
	        return this.promise;
	    };
	    /**
	     * Checks if the Transition is valid
	     *
	     * @returns true if the Transition is valid
	     */
	    Transition.prototype.valid = function () {
	        return !this.error() || this.success !== undefined;
	    };
	    /**
	     * Aborts this transition
	     *
	     * Imperative API to abort a Transition.
	     * This only applies to Transitions that are not yet complete.
	     */
	    Transition.prototype.abort = function () {
	        // Do not set flag if the transition is already complete
	        if (predicates_1.isUndefined(this.success)) {
	            this._aborted = true;
	        }
	    };
	    /**
	     * The Transition error reason.
	     *
	     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
	     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
	     *
	     * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
	     */
	    Transition.prototype.error = function () {
	        var state = this.$to();
	        if (state.self.abstract) {
	            return rejectFactory_1.Rejection.invalid("Cannot transition to abstract state '" + state.name + "'");
	        }
	        var paramDefs = state.parameters();
	        var values = this.params();
	        var invalidParams = paramDefs.filter(function (param) { return !param.validates(values[param.id]); });
	        if (invalidParams.length) {
	            var invalidValues = invalidParams.map(function (param) { return "[" + param.id + ":" + strings_1.stringify(values[param.id]) + "]"; }).join(', ');
	            var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
	            return rejectFactory_1.Rejection.invalid(detail);
	        }
	        if (this.success === false)
	            return this._error;
	    };
	    /**
	     * A string representation of the Transition
	     *
	     * @returns A string representation of the Transition
	     */
	    Transition.prototype.toString = function () {
	        var fromStateOrName = this.from();
	        var toStateOrName = this.to();
	        var avoidEmptyHash = function (params) {
	            return params['#'] !== null && params['#'] !== undefined ? params : common_1.omit(params, ['#']);
	        };
	        // (X) means the to state is invalid.
	        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = strings_1.stringify(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? '' : '(X) ', to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = strings_1.stringify(avoidEmptyHash(this.params()));
	        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
	    };
	    /** @internal */
	    Transition.diToken = Transition;
	    return Transition;
	}());
	exports.Transition = Transition;
	//# sourceMappingURL=transition.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionService = exports.defaultTransOpts = void 0;
	var interface_1 = __webpack_require__(10);
	var transition_1 = __webpack_require__(41);
	var hookRegistry_1 = __webpack_require__(40);
	var coreResolvables_1 = __webpack_require__(101);
	var redirectTo_1 = __webpack_require__(105);
	var onEnterExitRetain_1 = __webpack_require__(104);
	var resolve_1 = __webpack_require__(106);
	var views_1 = __webpack_require__(109);
	var updateGlobals_1 = __webpack_require__(107);
	var url_1 = __webpack_require__(108);
	var lazyLoad_1 = __webpack_require__(52);
	var transitionEventType_1 = __webpack_require__(63);
	var transitionHook_1 = __webpack_require__(18);
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var ignoredTransition_1 = __webpack_require__(102);
	var invalidTransition_1 = __webpack_require__(103);
	/**
	 * The default [[Transition]] options.
	 *
	 * Include this object when applying custom defaults:
	 * let reloadOpts = { reload: true, notify: true }
	 * let options = defaults(theirOpts, customDefaults, defaultOptions);
	 */
	exports.defaultTransOpts = {
	    location: true,
	    relative: null,
	    inherit: false,
	    notify: true,
	    reload: false,
	    supercede: true,
	    custom: {},
	    current: function () { return null; },
	    source: 'unknown',
	};
	/**
	 * This class provides services related to Transitions.
	 *
	 * - Most importantly, it allows global Transition Hooks to be registered.
	 * - It allows the default transition error handler to be set.
	 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
	 *
	 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
	 *
	 * This API is located at `router.transitionService` ([[UIRouter.transitionService]])
	 */
	var TransitionService = /** @class */ (function () {
	    /** @internal */
	    function TransitionService(_router) {
	        /** @internal */
	        this._transitionCount = 0;
	        /** The transition hook types, such as `onEnter`, `onStart`, etc */
	        this._eventTypes = [];
	        /** @internal The registered transition hooks */
	        this._registeredHooks = {};
	        /** The  paths on a criteria object */
	        this._criteriaPaths = {};
	        this._router = _router;
	        this.$view = _router.viewService;
	        this._deregisterHookFns = {};
	        this._pluginapi = (common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
	            '_definePathType',
	            '_defineEvent',
	            '_getPathTypes',
	            '_getEvents',
	            'getHooks',
	        ]));
	        this._defineCorePaths();
	        this._defineCoreEvents();
	        this._registerCoreTransitionHooks();
	        _router.globals.successfulTransitions.onEvict(coreResolvables_1.treeChangesCleanup);
	    }
	    /**
	     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
	     *
	     * Registers a transition lifecycle hook, which is invoked during transition construction.
	     *
	     * This low level hook should only be used by plugins.
	     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
	     * The Sticky States plugin uses this hook to modify the treechanges.
	     *
	     * ### Lifecycle
	     *
	     * `onCreate` hooks are invoked *while a transition is being constructed*.
	     *
	     * ### Return value
	     *
	     * The hook's return value is ignored
	     *
	     * @internal
	     * @param criteria defines which Transitions the Hook should be invoked for.
	     * @param callback the hook function which will be invoked.
	     * @param options the registration options
	     * @returns a function which deregisters the hook.
	     */
	    TransitionService.prototype.onCreate = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /**
	     * dispose
	     * @internal
	     */
	    TransitionService.prototype.dispose = function (router) {
	        common_1.values(this._registeredHooks).forEach(function (hooksArray) {
	            return hooksArray.forEach(function (hook) {
	                hook._deregistered = true;
	                common_1.removeFrom(hooksArray, hook);
	            });
	        });
	    };
	    /**
	     * Creates a new [[Transition]] object
	     *
	     * This is a factory function for creating new Transition objects.
	     * It is used internally by the [[StateService]] and should generally not be called by application code.
	     *
	     * @internal
	     * @param fromPath the path to the current state (the from state)
	     * @param targetState the target state (destination)
	     * @returns a Transition
	     */
	    TransitionService.prototype.create = function (fromPath, targetState) {
	        return new transition_1.Transition(fromPath, targetState, this._router);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCoreEvents = function () {
	        var Phase = interface_1.TransitionHookPhase;
	        var TH = transitionHook_1.TransitionHook;
	        var paths = this._criteriaPaths;
	        var NORMAL_SORT = false, REVERSE_SORT = true;
	        var SYNCHRONOUS = true;
	        this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
	        this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
	        this._defineEvent('onStart', Phase.RUN, 0, paths.to);
	        this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
	        this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
	        this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
	        this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
	        this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	        this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	    };
	    /** @internal */
	    TransitionService.prototype._defineCorePaths = function () {
	        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
	        this._definePathType('to', TRANSITION);
	        this._definePathType('from', TRANSITION);
	        this._definePathType('exiting', STATE);
	        this._definePathType('retained', STATE);
	        this._definePathType('entering', STATE);
	    };
	    /** @internal */
	    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
	        this._eventTypes.push(eventType);
	        hookRegistry_1.makeEvent(this, this, eventType);
	    };
	    /** @internal */
	    TransitionService.prototype._getEvents = function (phase) {
	        var transitionHookTypes = predicates_1.isDefined(phase)
	            ? this._eventTypes.filter(function (type) { return type.hookPhase === phase; })
	            : this._eventTypes.slice();
	        return transitionHookTypes.sort(function (l, r) {
	            var cmpByPhase = l.hookPhase - r.hookPhase;
	            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
	        });
	    };
	    /**
	     * Adds a Path to be used as a criterion against a TreeChanges path
	     *
	     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
	     * Each state in the exiting path is checked against the criteria and returned as part of the match.
	     *
	     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
	     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
	     *
	     * @internal
	     */
	    TransitionService.prototype._definePathType = function (name, hookScope) {
	        this._criteriaPaths[name] = { name: name, scope: hookScope };
	    };
	    /** @internal */
	    // tslint:disable-next-line
	    TransitionService.prototype._getPathTypes = function () {
	        return this._criteriaPaths;
	    };
	    /** @internal */
	    TransitionService.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    /** @internal */
	    TransitionService.prototype._registerCoreTransitionHooks = function () {
	        var fns = this._deregisterHookFns;
	        fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
	        fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
	        fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
	        // Wire up redirectTo hook
	        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
	        // Wire up onExit/Retain/Enter state hooks
	        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
	        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
	        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
	        // Wire up Resolve hooks
	        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
	        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
	        fns.resolveAll = resolve_1.registerResolveRemaining(this);
	        // Wire up the View management hooks
	        fns.loadViews = views_1.registerLoadEnteringViews(this);
	        fns.activateViews = views_1.registerActivateViews(this);
	        // Updates global state after a transition
	        fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
	        // After globals.current is updated at priority: 10000
	        fns.updateUrl = url_1.registerUpdateUrl(this);
	        // Lazy load state trees
	        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
	    };
	    return TransitionService;
	}());
	exports.TransitionService = TransitionService;
	//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BaseUrlRule = exports.UrlRuleFactory = void 0;
	var urlMatcher_1 = __webpack_require__(24);
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var stateObject_1 = __webpack_require__(39);
	/**
	 * Creates a [[UrlRule]]
	 *
	 * Creates a [[UrlRule]] from a:
	 *
	 * - `string`
	 * - [[UrlMatcher]]
	 * - `RegExp`
	 * - [[StateObject]]
	 */
	var UrlRuleFactory = /** @class */ (function () {
	    function UrlRuleFactory(router) {
	        this.router = router;
	    }
	    UrlRuleFactory.prototype.compile = function (str) {
	        return this.router.urlMatcherFactory.compile(str);
	    };
	    UrlRuleFactory.prototype.create = function (what, handler) {
	        var _this = this;
	        var isState = stateObject_1.StateObject.isState, isStateDeclaration = stateObject_1.StateObject.isStateDeclaration;
	        var makeRule = hof_1.pattern([
	            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
	            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
	            [hof_1.or(isState, isStateDeclaration), function (_what) { return _this.fromState(_what, _this.router); }],
	            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
	            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
	        ]);
	        var rule = makeRule(what);
	        if (!rule)
	            throw new Error("invalid 'what' in when()");
	        return rule;
	    };
	    /**
	     * A UrlRule which matches based on a UrlMatcher
	     *
	     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     *
	     * ## Handler as UrlMatcher
	     *
	     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
	     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
	     * The url is replaced with the result.
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var handler = $umf.compile("/home/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
	        var _handler = handler;
	        if (predicates_1.isString(handler))
	            handler = this.router.urlMatcherFactory.compile(handler);
	        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
	            _handler = function (match) { return handler.format(match); };
	        function matchUrlParamters(url) {
	            var params = urlMatcher.exec(url.path, url.search, url.hash);
	            return urlMatcher.validates(params) && params;
	        }
	        // Prioritize URLs, lowest to highest:
	        // - Some optional URL parameters, but none matched
	        // - No optional parameters in URL
	        // - Some optional parameters, some matched
	        // - Some optional parameters, all matched
	        function matchPriority(params) {
	            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
	            if (!optional.length)
	                return 0.000001;
	            var matched = optional.filter(function (param) { return params[param.id]; });
	            return matched.length / optional.length;
	        }
	        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: 'URLMATCHER' };
	        return common_1.extend(new BaseUrlRule(matchUrlParamters, _handler), details);
	    };
	    /**
	     * A UrlRule which matches a state by its url
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromState($state.get('foo'), router);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match);
	     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
	     * ```
	     */
	    UrlRuleFactory.prototype.fromState = function (stateOrDecl, router) {
	        var state = stateObject_1.StateObject.isStateDeclaration(stateOrDecl) ? stateOrDecl.$$state() : stateOrDecl;
	        /**
	         * Handles match by transitioning to matched state
	         *
	         * First checks if the router should start a new transition.
	         * A new transition is not required if the current state's URL
	         * and the new URL are already identical
	         */
	        var handler = function (match) {
	            var $state = router.stateService;
	            var globals = router.globals;
	            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
	                $state.transitionTo(state, match, { inherit: true, source: 'url' });
	            }
	        };
	        var details = { state: state, type: 'STATE' };
	        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
	    };
	    /**
	     * A UrlRule which matches based on a regular expression
	     *
	     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - regexp match array (from `regexp`)
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     *
	     * ## Handler as string
	     *
	     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
	     * The string is first interpolated using `string.replace()` style pattern.
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
	        if (regexp.global || regexp.sticky)
	            throw new Error('Rule RegExp must not be global or sticky');
	        /**
	         * If handler is a string, the url will be replaced by the string.
	         * If the string has any String.replace() style variables in it (like `$2`),
	         * they will be replaced by the captures from [[match]]
	         */
	        var redirectUrlTo = function (match) {
	            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
	            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) { return match[what === '$' ? 0 : Number(what)]; });
	        };
	        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
	        var matchParamsFromRegexp = function (url) { return regexp.exec(url.path); };
	        var details = { regexp: regexp, type: 'REGEXP' };
	        return common_1.extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
	    };
	    UrlRuleFactory.isUrlRule = function (obj) { return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); }); };
	    return UrlRuleFactory;
	}());
	exports.UrlRuleFactory = UrlRuleFactory;
	/**
	 * A base rule which calls `match`
	 *
	 * The value from the `match` function is passed through to the `handler`.
	 * @internal
	 */
	var BaseUrlRule = /** @class */ (function () {
	    function BaseUrlRule(match, handler) {
	        var _this = this;
	        this.match = match;
	        this.type = 'RAW';
	        this.matchPriority = function (match) { return 0 - _this.$id; };
	        this.handler = handler || common_1.identity;
	    }
	    return BaseUrlRule;
	}());
	exports.BaseUrlRule = BaseUrlRule;
	//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.locationPluginFactory = exports.buildUrl = exports.parseUrl = exports.getParams = exports.keyValsToObjectR = void 0;
	var common_1 = __webpack_require__(4);
	exports.keyValsToObjectR = function (accum, _a) {
	    var key = _a[0], val = _a[1];
	    if (!accum.hasOwnProperty(key)) {
	        accum[key] = val;
	    }
	    else if (common_1.isArray(accum[key])) {
	        accum[key].push(val);
	    }
	    else {
	        accum[key] = [accum[key], val];
	    }
	    return accum;
	};
	exports.getParams = function (queryString) {
	    return queryString.split('&').filter(common_1.identity).map(common_1.splitEqual).reduce(exports.keyValsToObjectR, {});
	};
	function parseUrl(url) {
	    var orEmptyString = function (x) { return x || ''; };
	    var _a = common_1.splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
	    var _b = common_1.splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
	    return { path: path, search: search, hash: hash, url: url };
	}
	exports.parseUrl = parseUrl;
	exports.buildUrl = function (loc) {
	    var path = loc.path();
	    var searchObject = loc.search();
	    var hash = loc.hash();
	    var search = Object.keys(searchObject)
	        .map(function (key) {
	        var param = searchObject[key];
	        var vals = common_1.isArray(param) ? param : [param];
	        return vals.map(function (val) { return key + '=' + val; });
	    })
	        .reduce(common_1.unnestR, [])
	        .join('&');
	    return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	};
	function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
	    return function (uiRouter) {
	        var service = (uiRouter.locationService = new serviceClass(uiRouter));
	        var configuration = (uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5));
	        function dispose(router) {
	            router.dispose(service);
	            router.dispose(configuration);
	        }
	        return { name: name, service: service, configuration: configuration, dispose: dispose };
	    };
	}
	exports.locationPluginFactory = locationPluginFactory;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejapagoModalController = function () {
	  BandejapagoModalController.$inject = ["$uibModalInstance", "data", "DataService", "$log", "$state", "Storage"];
	  function BandejapagoModalController($uibModalInstance, data, DataService, $log, $state, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, BandejapagoModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.$log = $log;
	    this.$state = $state;
	    this.Storage = Storage;
	  }
	
	  _createClass(BandejapagoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.selected = {
	        item: this.items[0]
	      };
	      //    this.urlPdf = this.items.urlPdf;
	
	      var xdate = new Date();
	      if (this.Storage.exist('dateNow')) xdate = new Date(this.Storage.get('dateNow'));
	
	      this.conf = {
	        maxDate: xdate,
	        minDate: new Date(xdate.getFullYear() - 1, xdate.getMonth(), xdate.getDate()),
	        startingDay: 1
	        // showWeeks: false
	      };
	    }
	  }, {
	    key: 'validateFechaDeposito',
	    value: function validateFechaDeposito(form) {
	      if (this.obj.fecha_deposito) {
	        form.fecha_deposito.$setValidity('min_date', !(this.obj.fecha_deposito < this.conf.minDate));
	        form.fecha_deposito.$setValidity('max_date', !(this.obj.fecha_deposito > this.conf.maxDate));
	      }
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      this.DataService.put('certificaciones/' + this.items.id_certificacion + '/pagar', this.obj).then(function (response) {
	        if (response) {
	          _this.$state.reload();
	          _this.$uibModalInstance.close(_this.selected.item);
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return BandejapagoModalController;
	}();
	
	exports.default = BandejapagoModalController;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejapagoModalController = function () {
	  BandejapagoModalController.$inject = ["$uibModalInstance", "data", "DataService", "$log", "$state", "Storage", "Modal", "Message"];
	  function BandejapagoModalController($uibModalInstance, data, DataService, $log, $state, Storage, Modal, Message) {
	    'ngInject';
	
	    _classCallCheck(this, BandejapagoModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.$log = $log;
	    this.$state = $state;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.Message = Message;
	  }
	
	  _createClass(BandejapagoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.selected = this.items;
	      this.conf = {
	        prod: {
	          sec_nombre: "PRODUCTOS",
	          sec_visible: true,
	          // 1
	          nombre_producto: {
	            visible: true,
	            requerido: true,
	            label: "Producto"
	          },
	          precio_referencial: {
	            label: "Precio Referencial (Bs.)",
	            visible: true,
	            requerido: true
	          },
	          unidad_medida: {
	            visible: true,
	            requerido: false,
	            label: "Descripción unidad de medida"
	          },
	          fid_par_unidad_medida: {
	            visible: true,
	            requerido: true,
	            label: "Unidad de medida"
	          }
	        }
	      };
	      this.DataService.get('certificaciones/' + this.selected.certificacion.id_certificacion).then(function (response) {
	        _this.form = angular.copy(response.certificacion.formulario);
	        _this.esRefrigerio = false;
	        _this.$log.log('esRefrigerio en llenado de formulario de PRODUCTOS');
	        if (_this.form.id_formulario === 10) {
	          _this.esRefrigerio = true;
	        }
	        _this.$log.log(_this.esRefrigerio);
	      });
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this2 = this;
	
	      this.Modal.confirm('Una vez enviados los productos productos, ya no podrá modificarlos hasta la aprobación de un técnico. ¿Desea continuar?', function () {
	        _this2.DataService.put('certificaciones/' + _this2.selected.certificacion.id_certificacion + '/enviarEdicionProducto').then(function (respuesta) {
	          if (respuesta) {
	            _this2.Message.success('Su registro se encuentra Pendiente de Aprobación.');
	            _this2.$uibModalInstance.close(_this2.selected);
	            _this2.$state.reload();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	      this.$state.reload();
	    }
	  }]);
	
	  return BandejapagoModalController;
	}();
	
	exports.default = BandejapagoModalController;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-money\"></i> Depósito Bancario</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<ng-form name=\"general_form\">\n  <div class=\"modal-body\">\n\n    <div class=\"alert alert-warning row mx-0\" >\n      <i class=\"fa fa-info-circle\" ></i>\n      <span class=\"col\">\n        <p class=\"mb-0\">A partir del envío de estos datos, podrá recoger su certificado de las oficinas de ProBolivia <br/>en 24 horas.</p>\n      </span>\n    </div>\n    <div>\n      Ingrese los datos del comprobante del depósito realizado por el costo del trámite:\n    </div>\n    <br/>\n    <div class=\"row\">\n      <div class=\"col-md form-group\">\n        <div class=\"form-group\">\n          <label>Código de Boleta</label>\n          <input name=\"codigo\" alpha-dash minlength=\"5\" maxlength=\"15\" ng-model=\"$ctrl.obj.codigo\" class=\"form-control\"  placeholder=\"\" required>\n          <div ap-error ng-messages=\"general_form.codigo.$error\" role=\"alert\" ng-if=\"general_form.codigo.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>\n            <div ng-message=\"minlength\">El campo debe tener 5 caracteres como mínimo</div>\n            <!-- <div ng-message=\"maxlength\">El campo debe tener 15 caracteres como máximo</div> -->\n          </div>\n        </div>\n      </div>\n      <!--    <div class=\"col-md form-group\">\n            <div class=\"form-group\">\n              <label>Fecha de Depósito</label>\n              <input name=\"fecha_deposito\" maxlength=\"10\" class=\"form-control\" datepicker-append-to-body=\"true\" placeholder=\"dd/mm/aaaa\" uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\"\n                     ng-model=\"$ctrl.obj.fecha_deposito\" is-open=\"$ctrl.deposito.is_open\"\n                     datepicker-options=\"$ctrl.conf.pag.fecha_deposito.options\"\n                     close-text=\"Close\" required/>\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.deposito.is_open = true\"><i class=\"fa fa-calendar\"></i></button>\n              </span>\n            </div>\n\n          </div>-->\n      <div class=\"col-md form-group\">\n        <label>Fecha de Depósito</label>\n        <div class=\"input-group uib-input-date\">\n          <input name=\"fecha_deposito\" maxlength=\"10\" class=\"form-control\" datepicker-append-to-body=\"true\" placeholder=\"dd/mm/aaaa\"\n                 uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\" ng-model=\"$ctrl.obj.fecha_deposito\" is-open=\"$ctrl.deposito.is_open\" ng-change=\"$ctrl.validateFechaDeposito(general_form)\"\n                 datepicker-options=\"$ctrl.conf\" ng-required=\"true\" close-text=\"Close\"/>\n          <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.deposito.is_open = true\"><i class=\"fa fa-calendar\"></i></button>\n          </span>\n        </div>\n        <div ap-error ng-messages=\"general_form.fecha_deposito.$error\" role=\"alert\" ng-if=\"general_form.fecha_deposito.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n          <div ng-message=\"date\">Formato de fecha incorrecta (Ejemplo:15/02/1996)</div>\n          <div ng-message=\"min_date\">La fecha mínima aceptada es {{$ctrl.conf.minDate| date:'dd/MM/yyyy'}}</div>\n          <div ng-message=\"max_date\">La fecha máxima aceptada es {{$ctrl.conf.maxDate| date:'dd/MM/yyyy'}}</div>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"general_form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Enviar\n    </button>\n  </div>\n</ng-form>\n"

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\" ng-if=\"$ctrl.esRefrigerio\"><i class=\"fa fa-list\"></i> Editar Productos/Servicios</h5>\n  <h5 class=\"modal-title\" ng-if=\"!$ctrl.esRefrigerio\"><i class=\"fa fa-list\"></i> Editar Productos</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<ng-form name=\"general_form\">\n  <div class=\"modal-body\">\n    <div class=\"alert alert-warning row mx-0\" >\n      <i class=\"fa fa-info-circle\" ></i>\n      <span class=\"col\" >\n        <p class=\"mb-0\" ng-if=\"$ctrl.esRefrigerio\">Registre sus productos/Servicios</p>\n        <p class=\"mb-0\" ng-if=\"!$ctrl.esRefrigerio\">Registre sus productos</p>\n      </span>\n    </div>\n    <div class=\"alert alert-danger row mx-0\"  ng-if=\"$ctrl.selected.certificacion.estado === 'PRODUCTOS_OBSERVADOS'\">\n      <i class=\"fa fa-info-circle\" ></i>\n      <span class=\"col\">\n        <p class=\"mb-0\"><strong>Observaciones: </strong>{{$ctrl.selected.certificacion.observaciones}}</p>\n      </span>\n    </div>\n    <br/>\n    <div class=\"row container\">\n      <formulario-producto name=\"formulario_producto\" id-certificacion=\"$ctrl.selected.certificacion.id_certificacion\" data=\"$ctrl.conf.prod\"></formulario-producto>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" >\n      <i class=\"fa fa-check\"></i> Enviar\n    </button>\n  </div>\n</ng-form>\n"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.safeConsole = void 0;
	/**
	 * workaround for missing console object in IE9 when dev tools haven't been opened o_O
	 * @packageDocumentation
	 */
	/* tslint:disable:no-console */
	var common_1 = __webpack_require__(1);
	var noopConsoleStub = { log: common_1.noop, error: common_1.noop, table: common_1.noop };
	function ie9Console(console) {
	    var bound = function (fn) { return Function.prototype.bind.call(fn, console); };
	    return {
	        log: bound(console.log),
	        error: bound(console.log),
	        table: bound(console.log),
	    };
	}
	function fallbackConsole(console) {
	    var log = console.log.bind(console);
	    var error = console.error ? console.error.bind(console) : log;
	    var table = console.table ? console.table.bind(console) : log;
	    return { log: log, error: error, table: table };
	}
	function getSafeConsole() {
	    // @ts-ignore
	    var isIE9 = typeof document !== 'undefined' && document.documentMode && document.documentMode === 9;
	    if (isIE9) {
	        return window && window.console ? ie9Console(window.console) : noopConsoleStub;
	    }
	    else if (!console.table || !console.error) {
	        return fallbackConsole(console);
	    }
	    else {
	        return console;
	    }
	}
	exports.safeConsole = getSafeConsole();
	//# sourceMappingURL=safeConsole.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterGlobals = void 0;
	var stateParams_1 = __webpack_require__(53);
	var queue_1 = __webpack_require__(34);
	/**
	 * Global router state
	 *
	 * This is where we hold the global mutable state such as current state, current
	 * params, current transition, etc.
	 */
	var UIRouterGlobals = /** @class */ (function () {
	    function UIRouterGlobals() {
	        /**
	         * Current parameter values
	         *
	         * The parameter values from the latest successful transition
	         */
	        this.params = new stateParams_1.StateParams();
	        /** @internal */
	        this.lastStartedTransitionId = -1;
	        /** @internal */
	        this.transitionHistory = new queue_1.Queue([], 1);
	        /** @internal */
	        this.successfulTransitions = new queue_1.Queue([], 1);
	    }
	    UIRouterGlobals.prototype.dispose = function () {
	        this.transitionHistory.clear();
	        this.successfulTransitions.clear();
	        this.transition = null;
	    };
	    return UIRouterGlobals;
	}());
	exports.UIRouterGlobals = UIRouterGlobals;
	//# sourceMappingURL=globals.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lazyLoadState = exports.registerLazyLoadHook = void 0;
	var coreservices_1 = __webpack_require__(5);
	/**
	 * A [[TransitionHookFn]] that performs lazy loading
	 *
	 * When entering a state "abc" which has a `lazyLoad` function defined:
	 * - Invoke the `lazyLoad` function (unless it is already in process)
	 *   - Flag the hook function as "in process"
	 *   - The function should return a promise (that resolves when lazy loading is complete)
	 * - Wait for the promise to settle
	 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
	 *   - Flag the hook function as "not in process"
	 * - If the hook was successful
	 *   - Remove the `lazyLoad` function from the state declaration
	 * - If all the hooks were successful
	 *   - Retry the transition (by returning a TargetState)
	 *
	 * ```
	 * .state('abc', {
	 *   component: 'fooComponent',
	 *   lazyLoad: () => import('./fooComponent')
	 *   });
	 * ```
	 *
	 * See [[StateDeclaration.lazyLoad]]
	 */
	var lazyLoadHook = function (transition) {
	    var router = transition.router;
	    function retryTransition() {
	        if (transition.originalTransition().options().source !== 'url') {
	            // The original transition was not triggered via url sync
	            // The lazy state should be loaded now, so re-try the original transition
	            var orig = transition.targetState();
	            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
	        }
	        // The original transition was triggered via url sync
	        // Run the URL rules and find the best match
	        var $url = router.urlService;
	        var result = $url.match($url.parts());
	        var rule = result && result.rule;
	        // If the best match is a state, redirect the transition (instead
	        // of calling sync() which supersedes the current transition)
	        if (rule && rule.type === 'STATE') {
	            var state = rule.state;
	            var params = result.match;
	            return router.stateService.target(state, params, transition.options());
	        }
	        // No matching state found, so let .sync() choose the best non-state match/otherwise
	        router.urlService.sync();
	    }
	    var promises = transition
	        .entering()
	        .filter(function (state) { return !!state.$$state().lazyLoad; })
	        .map(function (state) { return lazyLoadState(transition, state); });
	    return coreservices_1.services.$q.all(promises).then(retryTransition);
	};
	exports.registerLazyLoadHook = function (transitionService) {
	    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
	};
	/**
	 * Invokes a state's lazy load function
	 *
	 * @param transition a Transition context
	 * @param state the state to lazy load
	 * @returns A promise for the lazy load result
	 */
	function lazyLoadState(transition, state) {
	    var lazyLoadFn = state.$$state().lazyLoad;
	    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
	    var promise = lazyLoadFn['_promise'];
	    if (!promise) {
	        var success = function (result) {
	            delete state.lazyLoad;
	            delete state.$$state().lazyLoad;
	            delete lazyLoadFn['_promise'];
	            return result;
	        };
	        var error = function (err) {
	            delete lazyLoadFn['_promise'];
	            return coreservices_1.services.$q.reject(err);
	        };
	        promise = lazyLoadFn['_promise'] = coreservices_1.services.$q
	            .when(lazyLoadFn(transition, state))
	            .then(updateStateRegistry)
	            .then(success, error);
	    }
	    /** Register any lazy loaded state definitions */
	    function updateStateRegistry(result) {
	        if (result && Array.isArray(result.states)) {
	            result.states.forEach(function (_state) { return transition.router.stateRegistry.register(_state); });
	        }
	        return result;
	    }
	    return promise;
	}
	exports.lazyLoadState = lazyLoadState;
	//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateParams = void 0;
	var common_1 = __webpack_require__(1);
	var StateParams = /** @class */ (function () {
	    function StateParams(params) {
	        if (params === void 0) { params = {}; }
	        common_1.extend(this, params);
	    }
	    /**
	     * Merges a set of parameters with all parameters inherited between the common parents of the
	     * current state and a given destination state.
	     *
	     * @param {Object} newParams The set of parameters which will be composited with inherited params.
	     * @param {Object} $current Internal definition of object representing the current state.
	     * @param {Object} $to Internal definition of object representing state to transition to.
	     */
	    StateParams.prototype.$inherit = function (newParams, $current, $to) {
	        var parentParams;
	        var parents = common_1.ancestors($current, $to), inherited = {}, inheritList = [];
	        for (var i in parents) {
	            if (!parents[i] || !parents[i].params)
	                continue;
	            parentParams = Object.keys(parents[i].params);
	            if (!parentParams.length)
	                continue;
	            for (var j in parentParams) {
	                if (inheritList.indexOf(parentParams[j]) >= 0)
	                    continue;
	                inheritList.push(parentParams[j]);
	                inherited[parentParams[j]] = this[parentParams[j]];
	            }
	        }
	        return common_1.extend({}, inherited, newParams);
	    };
	    return StateParams;
	}());
	exports.StateParams = StateParams;
	//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(55), exports);
	__exportStar(__webpack_require__(22), exports);
	__exportStar(__webpack_require__(23), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.resolvePolicies = void 0;
	exports.resolvePolicies = {
	    when: {
	        LAZY: 'LAZY',
	        EAGER: 'EAGER',
	    },
	    async: {
	        WAIT: 'WAIT',
	        NOWAIT: 'NOWAIT',
	    },
	};
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouter = void 0;
	var urlMatcherFactory_1 = __webpack_require__(65);
	var urlRouter_1 = __webpack_require__(66);
	var transitionService_1 = __webpack_require__(42);
	var view_1 = __webpack_require__(76);
	var stateRegistry_1 = __webpack_require__(60);
	var stateService_1 = __webpack_require__(61);
	var globals_1 = __webpack_require__(51);
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var urlService_1 = __webpack_require__(68);
	var trace_1 = __webpack_require__(8);
	var common_2 = __webpack_require__(4);
	/** @internal */
	var _routerInstance = 0;
	/** @internal */
	var locSvcFns = ['url', 'path', 'search', 'hash', 'onChange'];
	/** @internal */
	var locCfgFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
	/** @internal */
	var locationServiceStub = common_2.makeStub('LocationServices', locSvcFns);
	/** @internal */
	var locationConfigStub = common_2.makeStub('LocationConfig', locCfgFns);
	/**
	 * An instance of UI-Router.
	 *
	 * This object contains references to service APIs which define your application's routing behavior.
	 */
	var UIRouter = /** @class */ (function () {
	    /**
	     * Creates a new `UIRouter` object
	     *
	     * @param locationService a [[LocationServices]] implementation
	     * @param locationConfig a [[LocationConfig]] implementation
	     * @internal
	     */
	    function UIRouter(locationService, locationConfig) {
	        if (locationService === void 0) { locationService = locationServiceStub; }
	        if (locationConfig === void 0) { locationConfig = locationConfigStub; }
	        this.locationService = locationService;
	        this.locationConfig = locationConfig;
	        /** @internal */ this.$id = _routerInstance++;
	        /** @internal */ this._disposed = false;
	        /** @internal */ this._disposables = [];
	        /** Enable/disable tracing to the javascript console */
	        this.trace = trace_1.trace;
	        /** Provides services related to ui-view synchronization */
	        this.viewService = new view_1.ViewService(this);
	        /** An object that contains global router state, such as the current state and params */
	        this.globals = new globals_1.UIRouterGlobals();
	        /** A service that exposes global Transition Hooks */
	        this.transitionService = new transitionService_1.TransitionService(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlRouter = new urlRouter_1.UrlRouter(this);
	        /** Provides services related to the URL */
	        this.urlService = new urlService_1.UrlService(this);
	        /** Provides a registry for states, and related registration services */
	        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
	        /** Provides services related to states */
	        this.stateService = new stateService_1.StateService(this);
	        /** @internal plugin instances are registered here */
	        this._plugins = {};
	        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
	        this.globals.$current = this.stateRegistry.root();
	        this.globals.current = this.globals.$current.self;
	        this.disposable(this.globals);
	        this.disposable(this.stateService);
	        this.disposable(this.stateRegistry);
	        this.disposable(this.transitionService);
	        this.disposable(this.urlService);
	        this.disposable(locationService);
	        this.disposable(locationConfig);
	    }
	    /** Registers an object to be notified when the router is disposed */
	    UIRouter.prototype.disposable = function (disposable) {
	        this._disposables.push(disposable);
	    };
	    /**
	     * Disposes this router instance
	     *
	     * When called, clears resources retained by the router by calling `dispose(this)` on all
	     * registered [[disposable]] objects.
	     *
	     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
	     *
	     * @internal
	     * @param disposable (optional) the disposable to dispose
	     */
	    UIRouter.prototype.dispose = function (disposable) {
	        var _this = this;
	        if (disposable && predicates_1.isFunction(disposable.dispose)) {
	            disposable.dispose(this);
	            return undefined;
	        }
	        this._disposed = true;
	        this._disposables.slice().forEach(function (d) {
	            try {
	                typeof d.dispose === 'function' && d.dispose(_this);
	                common_1.removeFrom(_this._disposables, d);
	            }
	            catch (ignored) { }
	        });
	    };
	    /**
	     * Adds a plugin to UI-Router
	     *
	     * This method adds a UI-Router Plugin.
	     * A plugin can enhance or change UI-Router behavior using any public API.
	     *
	     * #### Example:
	     * ```js
	     * import { MyCoolPlugin } from "ui-router-cool-plugin";
	     *
	     * var plugin = router.addPlugin(MyCoolPlugin);
	     * ```
	     *
	     * ### Plugin authoring
	     *
	     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
	     *
	     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
	     * For example, it may configure router options or add a Transition Hook.
	     *
	     * The plugin can then be published as a separate module.
	     *
	     * #### Example:
	     * ```js
	     * export class MyAuthPlugin implements UIRouterPlugin {
	     *   constructor(router: UIRouter, options: any) {
	     *     this.name = "MyAuthPlugin";
	     *     let $transitions = router.transitionService;
	     *     let $state = router.stateService;
	     *
	     *     let authCriteria = {
	     *       to: (state) => state.data && state.data.requiresAuth
	     *     };
	     *
	     *     function authHook(transition: Transition) {
	     *       let authService = transition.injector().get('AuthService');
	     *       if (!authService.isAuthenticated()) {
	     *         return $state.target('login');
	     *       }
	     *     }
	     *
	     *     $transitions.onStart(authCriteria, authHook);
	     *   }
	     * }
	     * ```
	     *
	     * @param plugin one of:
	     *        - a plugin class which implements [[UIRouterPlugin]]
	     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
	     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
	     * @param options options to pass to the plugin class/factory
	     * @returns the registered plugin instance
	     */
	    UIRouter.prototype.plugin = function (plugin, options) {
	        if (options === void 0) { options = {}; }
	        var pluginInstance = new plugin(this, options);
	        if (!pluginInstance.name)
	            throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
	        this._disposables.push(pluginInstance);
	        return (this._plugins[pluginInstance.name] = pluginInstance);
	    };
	    UIRouter.prototype.getPlugin = function (pluginName) {
	        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
	    };
	    return UIRouter;
	}());
	exports.UIRouter = UIRouter;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateBuilder = exports.resolvablesBuilder = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var strings_1 = __webpack_require__(6);
	var hof_1 = __webpack_require__(3);
	var resolvable_1 = __webpack_require__(22);
	var coreservices_1 = __webpack_require__(5);
	var parseUrl = function (url) {
	    if (!predicates_1.isString(url))
	        return false;
	    var root = url.charAt(0) === '^';
	    return { val: root ? url.substring(1) : url, root: root };
	};
	function nameBuilder(state) {
	    return state.name;
	}
	function selfBuilder(state) {
	    state.self.$$state = function () { return state; };
	    return state.self;
	}
	function dataBuilder(state) {
	    if (state.parent && state.parent.data) {
	        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
	    }
	    return state.data;
	}
	var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
	    return function urlBuilder(stateObject) {
	        var stateDec = stateObject.self;
	        // For future states, i.e., states whose name ends with `.**`,
	        // match anything that starts with the url prefix
	        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
	            var newStateDec = {};
	            common_1.copy(stateDec, newStateDec);
	            newStateDec.url += '{remainder:any}'; // match any path (.*)
	            stateDec = newStateDec;
	        }
	        var parent = stateObject.parent;
	        var parsed = parseUrl(stateDec.url);
	        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, { state: stateDec });
	        if (!url)
	            return null;
	        if (!$urlMatcherFactoryProvider.isMatcher(url))
	            throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
	        return parsed && parsed.root ? url : ((parent && parent.navigable) || root()).url.append(url);
	    };
	};
	var getNavigableBuilder = function (isRoot) {
	    return function navigableBuilder(state) {
	        return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
	    };
	};
	var getParamsBuilder = function (paramFactory) {
	    return function paramsBuilder(state) {
	        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, state.self); };
	        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
	        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
	        return urlParams
	            .concat(nonUrlParams)
	            .map(function (p) { return [p.id, p]; })
	            .reduce(common_1.applyPairs, {});
	    };
	};
	function pathBuilder(state) {
	    return state.parent ? state.parent.path.concat(state) : /*root*/ [state];
	}
	function includesBuilder(state) {
	    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
	    includes[state.name] = true;
	    return includes;
	}
	/**
	 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
	 *
	 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	 * validates the `resolve` property and converts it to a [[Resolvable]] array.
	 *
	 * resolve: input value can be:
	 *
	 * {
	 *   // analyzed but not injected
	 *   myFooResolve: function() { return "myFooData"; },
	 *
	 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
	 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
	 *
	 *   // Array split; "DependencyName" dep as string
	 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
	 *
	 *   // Array split; DependencyType dep as token (compared using ===)
	 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
	 *
	 *   // val.$inject used as deps
	 *   // where:
	 *   //     corgeResolve.$inject = ["DependencyName"];
	 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
	 *   // then "DependencyName" dep as string
	 *   myCorgeResolve: corgeResolve,
	 *
	 *  // inject service by name
	 *  // When a string is found, desugar creating a resolve that injects the named service
	 *   myGraultResolve: "SomeService"
	 * }
	 *
	 * or:
	 *
	 * [
	 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
	 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
	 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
	 * ]
	 */
	function resolvablesBuilder(state) {
	    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
	    var objects2Tuples = function (resolveObj, resolvePolicies) {
	        return Object.keys(resolveObj || {}).map(function (token) { return ({
	            token: token,
	            val: resolveObj[token],
	            deps: undefined,
	            policy: resolvePolicies[token],
	        }); });
	    };
	    /** fetch DI annotations from a function or ng1-style array */
	    var annotate = function (fn) {
	        var $injector = coreservices_1.services.$injector;
	        // ng1 doesn't have an $injector until runtime.
	        // If the $injector doesn't exist, use "deferred" literal as a
	        // marker indicating they should be annotated when runtime starts
	        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || 'deferred';
	    };
	    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
	    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
	    /** true if the object looks like a provide literal, or a ng2 Provider */
	    var isLikeNg2Provider = function (obj) {
	        return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
	    };
	    /** true if the object looks like a tuple from obj2Tuples */
	    var isTupleFromObj = function (obj) {
	        return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
	    };
	    /** extracts the token from a Provider or provide literal */
	    var getToken = function (p) { return p.provide || p.token; };
	    // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
	    var literal2Resolvable = hof_1.pattern([
	        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.resolveFn, p.deps, p.policy); }],
	        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy); }],
	        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return new p.useClass(); }, [], p.policy); }],
	        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
	        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(getToken(p), common_1.identity, [p.useExisting], p.policy); }],
	    ]);
	    // prettier-ignore
	    var tuple2Resolvable = hof_1.pattern([
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
	    ]);
	    // prettier-ignore
	    var item2Resolvable = hof_1.pattern([
	        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
	        [isResolveLiteral, literal2Resolvable],
	        [isLikeNg2Provider, literal2Resolvable],
	        [isTupleFromObj, tuple2Resolvable],
	        [hof_1.val(true), function (obj) { throw new Error('Invalid resolve value: ' + strings_1.stringify(obj)); },],
	    ]);
	    // If resolveBlock is already an array, use it as-is.
	    // Otherwise, assume it's an object and convert to an Array of tuples
	    var decl = state.resolve;
	    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
	    return items.map(item2Resolvable);
	}
	exports.resolvablesBuilder = resolvablesBuilder;
	/**
	 * A internal global service
	 *
	 * StateBuilder is a factory for the internal [[StateObject]] objects.
	 *
	 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
	 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
	 * [[StateObject]] object, which has an API and is used internally.
	 *
	 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
	 * using the [[builder]] method.
	 */
	var StateBuilder = /** @class */ (function () {
	    function StateBuilder(matcher, urlMatcherFactory) {
	        this.matcher = matcher;
	        var self = this;
	        var root = function () { return matcher.find(''); };
	        var isRoot = function (state) { return state.name === ''; };
	        function parentBuilder(state) {
	            if (isRoot(state))
	                return null;
	            return matcher.find(self.parentName(state)) || root();
	        }
	        this.builders = {
	            name: [nameBuilder],
	            self: [selfBuilder],
	            parent: [parentBuilder],
	            data: [dataBuilder],
	            // Build a URLMatcher if necessary, either via a relative or absolute URL
	            url: [getUrlBuilder(urlMatcherFactory, root)],
	            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	            navigable: [getNavigableBuilder(isRoot)],
	            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
	            // Each framework-specific ui-router implementation should define its own `views` builder
	            // e.g., src/ng1/statebuilders/views.ts
	            views: [],
	            // Keep a full path from the root down to this state as this is needed for state activation.
	            path: [pathBuilder],
	            // Speed up $state.includes() as it's used a lot
	            includes: [includesBuilder],
	            resolvables: [resolvablesBuilder],
	        };
	    }
	    StateBuilder.prototype.builder = function (name, fn) {
	        var builders = this.builders;
	        var array = builders[name] || [];
	        // Backwards compat: if only one builder exists, return it, else return whole arary.
	        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
	            return array.length > 1 ? array : array[0];
	        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
	            return;
	        builders[name] = array;
	        builders[name].push(fn);
	        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
	    };
	    /**
	     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
	     * properties and API built.
	     *
	     * @param state an uninitialized State object
	     * @returns the built State object
	     */
	    StateBuilder.prototype.build = function (state) {
	        var _a = this, matcher = _a.matcher, builders = _a.builders;
	        var parent = this.parentName(state);
	        if (parent && !matcher.find(parent, undefined, false)) {
	            return null;
	        }
	        for (var key in builders) {
	            if (!builders.hasOwnProperty(key))
	                continue;
	            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
	            state[key] = chain(state);
	        }
	        return state;
	    };
	    StateBuilder.prototype.parentName = function (state) {
	        // name = 'foo.bar.baz.**'
	        var name = state.name || '';
	        // segments = ['foo', 'bar', 'baz', '.**']
	        var segments = name.split('.');
	        // segments = ['foo', 'bar', 'baz']
	        var lastSegment = segments.pop();
	        // segments = ['foo', 'bar'] (ignore .** segment for future states)
	        if (lastSegment === '**')
	            segments.pop();
	        if (segments.length) {
	            if (state.parent) {
	                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
	            }
	            // 'foo.bar'
	            return segments.join('.');
	        }
	        if (!state.parent)
	            return '';
	        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	    };
	    StateBuilder.prototype.name = function (state) {
	        var name = state.name;
	        if (name.indexOf('.') !== -1 || !state.parent)
	            return name;
	        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	        return parentName ? parentName + '.' + name : name;
	    };
	    return StateBuilder;
	}());
	exports.StateBuilder = StateBuilder;
	//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateMatcher = void 0;
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	var safeConsole_1 = __webpack_require__(50);
	var StateMatcher = /** @class */ (function () {
	    function StateMatcher(_states) {
	        this._states = _states;
	    }
	    StateMatcher.prototype.isRelative = function (stateName) {
	        stateName = stateName || '';
	        return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
	    };
	    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
	        if (matchGlob === void 0) { matchGlob = true; }
	        if (!stateOrName && stateOrName !== '')
	            return undefined;
	        var isStr = predicates_1.isString(stateOrName);
	        var name = isStr ? stateOrName : stateOrName.name;
	        if (this.isRelative(name))
	            name = this.resolvePath(name, base);
	        var state = this._states[name];
	        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	            return state;
	        }
	        else if (isStr && matchGlob) {
	            var _states = common_1.values(this._states);
	            var matches = _states.filter(function (_state) { return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name); });
	            if (matches.length > 1) {
	                safeConsole_1.safeConsole.error("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
	            }
	            return matches[0];
	        }
	        return undefined;
	    };
	    StateMatcher.prototype.resolvePath = function (name, base) {
	        if (!base)
	            throw new Error("No reference point given for path '" + name + "'");
	        var baseState = this.find(base);
	        var splitName = name.split('.');
	        var pathLength = splitName.length;
	        var i = 0, current = baseState;
	        for (; i < pathLength; i++) {
	            if (splitName[i] === '' && i === 0) {
	                current = baseState;
	                continue;
	            }
	            if (splitName[i] === '^') {
	                if (!current.parent)
	                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
	                current = current.parent;
	                continue;
	            }
	            break;
	        }
	        var relName = splitName.slice(i).join('.');
	        return current.name + (current.name && relName ? '.' : '') + relName;
	    };
	    return StateMatcher;
	}());
	exports.StateMatcher = StateMatcher;
	//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateQueueManager = void 0;
	var common_1 = __webpack_require__(4);
	var stateObject_1 = __webpack_require__(39);
	var StateQueueManager = /** @class */ (function () {
	    function StateQueueManager(router, states, builder, listeners) {
	        this.router = router;
	        this.states = states;
	        this.builder = builder;
	        this.listeners = listeners;
	        this.queue = [];
	    }
	    StateQueueManager.prototype.dispose = function () {
	        this.queue = [];
	    };
	    StateQueueManager.prototype.register = function (stateDecl) {
	        var queue = this.queue;
	        var state = stateObject_1.StateObject.create(stateDecl);
	        var name = state.name;
	        if (!common_1.isString(name))
	            throw new Error('State must have a valid name');
	        if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(common_1.prop('name')), name))
	            throw new Error("State '" + name + "' is already defined");
	        queue.push(state);
	        this.flush();
	        return state;
	    };
	    StateQueueManager.prototype.flush = function () {
	        var _this = this;
	        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
	        var registered = [], // states that got registered
	        orphans = [], // states that don't yet have a parent registered
	        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
	        var getState = function (name) { return _this.states.hasOwnProperty(name) && _this.states[name]; };
	        var notifyListeners = function () {
	            if (registered.length) {
	                _this.listeners.forEach(function (listener) {
	                    return listener('registered', registered.map(function (s) { return s.self; }));
	                });
	            }
	        };
	        while (queue.length > 0) {
	            var state = queue.shift();
	            var name_1 = state.name;
	            var result = builder.build(state);
	            var orphanIdx = orphans.indexOf(state);
	            if (result) {
	                var existingState = getState(name_1);
	                if (existingState && existingState.name === name_1) {
	                    throw new Error("State '" + name_1 + "' is already defined");
	                }
	                var existingFutureState = getState(name_1 + '.**');
	                if (existingFutureState) {
	                    // Remove future state of the same name
	                    this.router.stateRegistry.deregister(existingFutureState);
	                }
	                states[name_1] = state;
	                this.attachRoute(state);
	                if (orphanIdx >= 0)
	                    orphans.splice(orphanIdx, 1);
	                registered.push(state);
	                continue;
	            }
	            var prev = previousQueueLength[name_1];
	            previousQueueLength[name_1] = queue.length;
	            if (orphanIdx >= 0 && prev === queue.length) {
	                // Wait until two consecutive iterations where no additional states were dequeued successfully.
	                // throw new Error(`Cannot register orphaned state '${name}'`);
	                queue.push(state);
	                notifyListeners();
	                return states;
	            }
	            else if (orphanIdx < 0) {
	                orphans.push(state);
	            }
	            queue.push(state);
	        }
	        notifyListeners();
	        return states;
	    };
	    StateQueueManager.prototype.attachRoute = function (state) {
	        if (state.abstract || !state.url)
	            return;
	        var rulesApi = this.router.urlService.rules;
	        rulesApi.rule(rulesApi.urlRuleFactory.create(state));
	    };
	    return StateQueueManager;
	}());
	exports.StateQueueManager = StateQueueManager;
	//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateRegistry = void 0;
	var stateMatcher_1 = __webpack_require__(58);
	var stateBuilder_1 = __webpack_require__(57);
	var stateQueueManager_1 = __webpack_require__(59);
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	/**
	 * A registry for all of the application's [[StateDeclaration]]s
	 *
	 * This API is found at `router.stateRegistry` ([[UIRouter.stateRegistry]])
	 */
	var StateRegistry = /** @class */ (function () {
	    /** @internal */
	    function StateRegistry(router) {
	        this.router = router;
	        this.states = {};
	        /** @internal */
	        this.listeners = [];
	        this.matcher = new stateMatcher_1.StateMatcher(this.states);
	        this.builder = new stateBuilder_1.StateBuilder(this.matcher, router.urlMatcherFactory);
	        this.stateQueue = new stateQueueManager_1.StateQueueManager(router, this.states, this.builder, this.listeners);
	        this._registerRoot();
	    }
	    /** @internal */
	    StateRegistry.prototype._registerRoot = function () {
	        var rootStateDef = {
	            name: '',
	            url: '^',
	            views: null,
	            params: {
	                '#': { value: null, type: 'hash', dynamic: true },
	            },
	            abstract: true,
	        };
	        var _root = (this._root = this.stateQueue.register(rootStateDef));
	        _root.navigable = null;
	    };
	    /** @internal */
	    StateRegistry.prototype.dispose = function () {
	        var _this = this;
	        this.stateQueue.dispose();
	        this.listeners = [];
	        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
	    };
	    /**
	     * Listen for a State Registry events
	     *
	     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
	     *
	     * #### Example:
	     * ```js
	     * let allStates = registry.get();
	     *
	     * // Later, invoke deregisterFn() to remove the listener
	     * let deregisterFn = registry.onStatesChanged((event, states) => {
	     *   switch(event) {
	     *     case: 'registered':
	     *       states.forEach(state => allStates.push(state));
	     *       break;
	     *     case: 'deregistered':
	     *       states.forEach(state => {
	     *         let idx = allStates.indexOf(state);
	     *         if (idx !== -1) allStates.splice(idx, 1);
	     *       });
	     *       break;
	     *   }
	     * });
	     * ```
	     *
	     * @param listener a callback function invoked when the registered states changes.
	     *        The function receives two parameters, `event` and `state`.
	     *        See [[StateRegistryListener]]
	     * @return a function that deregisters the listener
	     */
	    StateRegistry.prototype.onStatesChanged = function (listener) {
	        this.listeners.push(listener);
	        return function deregisterListener() {
	            common_1.removeFrom(this.listeners)(listener);
	        }.bind(this);
	    };
	    /**
	     * Gets the implicit root state
	     *
	     * Gets the root of the state tree.
	     * The root state is implicitly created by UI-Router.
	     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
	     *
	     * @return the root [[StateObject]]
	     */
	    StateRegistry.prototype.root = function () {
	        return this._root;
	    };
	    /**
	     * Adds a state to the registry
	     *
	     * Registers a [[StateDeclaration]] or queues it for registration.
	     *
	     * Note: a state will be queued if the state's parent isn't yet registered.
	     *
	     * @param stateDefinition the definition of the state to register.
	     * @returns the internal [[StateObject]] object.
	     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
	     *          If the state was only queued, then the object is not fully built.
	     */
	    StateRegistry.prototype.register = function (stateDefinition) {
	        return this.stateQueue.register(stateDefinition);
	    };
	    /** @internal */
	    StateRegistry.prototype._deregisterTree = function (state) {
	        var _this = this;
	        var all = this.get().map(function (s) { return s.$$state(); });
	        var getChildren = function (states) {
	            var _children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
	            return _children.length === 0 ? _children : _children.concat(getChildren(_children));
	        };
	        var children = getChildren([state]);
	        var deregistered = [state].concat(children).reverse();
	        deregistered.forEach(function (_state) {
	            var rulesApi = _this.router.urlService.rules;
	            // Remove URL rule
	            rulesApi
	                .rules()
	                .filter(hof_1.propEq('state', _state))
	                .forEach(function (rule) { return rulesApi.removeRule(rule); });
	            // Remove state from registry
	            delete _this.states[_state.name];
	        });
	        return deregistered;
	    };
	    /**
	     * Removes a state from the registry
	     *
	     * This removes a state from the registry.
	     * If the state has children, they are are also removed from the registry.
	     *
	     * @param stateOrName the state's name or object representation
	     * @returns {StateObject[]} a list of removed states
	     */
	    StateRegistry.prototype.deregister = function (stateOrName) {
	        var _state = this.get(stateOrName);
	        if (!_state)
	            throw new Error("Can't deregister state; not found: " + stateOrName);
	        var deregisteredStates = this._deregisterTree(_state.$$state());
	        this.listeners.forEach(function (listener) {
	            return listener('deregistered', deregisteredStates.map(function (s) { return s.self; }));
	        });
	        return deregisteredStates;
	    };
	    StateRegistry.prototype.get = function (stateOrName, base) {
	        var _this = this;
	        if (arguments.length === 0)
	            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
	        var found = this.matcher.find(stateOrName, base);
	        return (found && found.self) || null;
	    };
	    /**
	     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
	     * More than one BuilderFunction can be registered for a given property.
	     *
	     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
	     *
	     * @param property The name of the State property being registered for.
	     * @param builderFunction The BuilderFunction which will be used to build the State property
	     * @returns a function which deregisters the BuilderFunction
	     */
	    StateRegistry.prototype.decorator = function (property, builderFunction) {
	        return this.builder.builder(property, builderFunction);
	    };
	    return StateRegistry;
	}());
	exports.StateRegistry = StateRegistry;
	//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.StateService = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var queue_1 = __webpack_require__(34);
	var coreservices_1 = __webpack_require__(5);
	var pathUtils_1 = __webpack_require__(21);
	var pathNode_1 = __webpack_require__(37);
	var transitionService_1 = __webpack_require__(42);
	var rejectFactory_1 = __webpack_require__(11);
	var targetState_1 = __webpack_require__(17);
	var param_1 = __webpack_require__(16);
	var glob_1 = __webpack_require__(33);
	var resolveContext_1 = __webpack_require__(23);
	var lazyLoad_1 = __webpack_require__(52);
	var hof_1 = __webpack_require__(3);
	/**
	 * Provides services related to ui-router states.
	 *
	 * This API is located at `router.stateService` ([[UIRouter.stateService]])
	 */
	var StateService = /** @class */ (function () {
	    /** @internal */
	    function StateService(/** @internal */ router) {
	        this.router = router;
	        /** @internal */
	        this.invalidCallbacks = [];
	        /** @internal */
	        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
	            if ($error$ instanceof Error && $error$.stack) {
	                console.error($error$);
	                console.error($error$.stack);
	            }
	            else if ($error$ instanceof rejectFactory_1.Rejection) {
	                console.error($error$.toString());
	                if ($error$.detail && $error$.detail.stack)
	                    console.error($error$.detail.stack);
	            }
	            else {
	                console.error($error$);
	            }
	        };
	        var getters = ['current', '$current', 'params', 'transition'];
	        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
	        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
	    }
	    Object.defineProperty(StateService.prototype, "transition", {
	        /**
	         * The [[Transition]] currently in progress (or null)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.transition]]
	         */
	        get: function () {
	            return this.router.globals.transition;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "params", {
	        /**
	         * The latest successful state parameters
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.params]]
	         */
	        get: function () {
	            return this.router.globals.params;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "current", {
	        /**
	         * The current [[StateDeclaration]]
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.current]]
	         */
	        get: function () {
	            return this.router.globals.current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "$current", {
	        /**
	         * The current [[StateObject]] (an internal API)
	         *
	         * @deprecated This is a passthrough through to [[UIRouterGlobals.$current]]
	         */
	        get: function () {
	            return this.router.globals.$current;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /** @internal */
	    StateService.prototype.dispose = function () {
	        this.defaultErrorHandler(common_1.noop);
	        this.invalidCallbacks = [];
	    };
	    /**
	     * Handler for when [[transitionTo]] is called with an invalid state.
	     *
	     * Invokes the [[onInvalid]] callbacks, in natural order.
	     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
	     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
	     *
	     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
	     *
	     * @internal
	     */
	    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
	        var _this = this;
	        var fromState = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
	        var globals = this.router.globals;
	        var latestThing = function () { return globals.transitionHistory.peekTail(); };
	        var latest = latestThing();
	        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
	        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
	        var checkForRedirect = function (result) {
	            if (!(result instanceof targetState_1.TargetState)) {
	                return;
	            }
	            var target = result;
	            // Recreate the TargetState, in case the state is now defined.
	            target = _this.target(target.identifier(), target.params(), target.options());
	            if (!target.valid()) {
	                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
	            }
	            if (latestThing() !== latest) {
	                return rejectFactory_1.Rejection.superseded().toPromise();
	            }
	            return _this.transitionTo(target.identifier(), target.params(), target.options());
	        };
	        function invokeNextCallback() {
	            var nextCallback = callbackQueue.dequeue();
	            if (nextCallback === undefined)
	                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
	            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
	            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
	        }
	        return invokeNextCallback();
	    };
	    /**
	     * Registers an Invalid State handler
	     *
	     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
	     * has been called with an invalid state reference parameter
	     *
	     * Example:
	     * ```js
	     * stateService.onInvalid(function(to, from, injector) {
	     *   if (to.name() === 'foo') {
	     *     let lazyLoader = injector.get('LazyLoadService');
	     *     return lazyLoader.load('foo')
	     *         .then(() => stateService.target('foo'));
	     *   }
	     * });
	     * ```
	     *
	     * @param {function} callback invoked when the toState is invalid
	     *   This function receives the (invalid) toState, the fromState, and an injector.
	     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
	     *   If one is returned, it is treated as a redirect.
	     *
	     * @returns a function which deregisters the callback
	     */
	    StateService.prototype.onInvalid = function (callback) {
	        this.invalidCallbacks.push(callback);
	        return function deregisterListener() {
	            common_1.removeFrom(this.invalidCallbacks)(callback);
	        }.bind(this);
	    };
	    /**
	     * Reloads the current state
	     *
	     * A method that force reloads the current state, or a partial state hierarchy.
	     * All resolves are re-resolved, and components reinstantiated.
	     *
	     * #### Example:
	     * ```js
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * ```
	     *
	     * Note: `reload()` is just an alias for:
	     *
	     * ```js
	     * $state.transitionTo($state.current, $state.params, {
	     *   reload: true, inherit: false
	     * });
	     * ```
	     *
	     * @param reloadState A state name or a state object.
	     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
	     *
	     * #### Example:
	     * ```js
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
	     * //and current state is 'contacts.detail.item'
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * ```
	     *
	     * @returns A promise representing the state of the new transition. See [[StateService.go]]
	     */
	    StateService.prototype.reload = function (reloadState) {
	        return this.transitionTo(this.current, this.params, {
	            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
	            inherit: false,
	            notify: false,
	        });
	    };
	    /**
	     * Transition to a different state and/or parameters
	     *
	     * Convenience method for transitioning to a new state.
	     *
	     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
	     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
	     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
	     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
	     * inherit from the current parameter values (because of `inherit: true`).
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to Absolute state name, state object, or relative state path (relative to current state).
	     *
	     * Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to the parent state
	     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
	     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
	     *
	     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
	     *
	     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
	     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
	     *
	     * @param options Transition options
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     */
	    StateService.prototype.go = function (to, params, options) {
	        var defautGoOpts = { relative: this.$current, inherit: true };
	        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
	        return this.transitionTo(to, params, transOpts);
	    };
	    /**
	     * Creates a [[TargetState]]
	     *
	     * This is a factory method for creating a TargetState
	     *
	     * This may be returned from a Transition Hook to redirect a transition, for example.
	     */
	    StateService.prototype.target = function (identifier, params, options) {
	        if (options === void 0) { options = {}; }
	        // If we're reloading, find the state object to reload from
	        if (predicates_1.isObject(options.reload) && !options.reload.name)
	            throw new Error('Invalid reload state object');
	        var reg = this.router.stateRegistry;
	        options.reloadState =
	            options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
	        if (options.reload && !options.reloadState)
	            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
	        return new targetState_1.TargetState(this.router.stateRegistry, identifier, params, options);
	    };
	    /** @internal */
	    StateService.prototype.getCurrentPath = function () {
	        var _this = this;
	        var globals = this.router.globals;
	        var latestSuccess = globals.successfulTransitions.peekTail();
	        var rootPath = function () { return [new pathNode_1.PathNode(_this.router.stateRegistry.root())]; };
	        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
	    };
	    /**
	     * Low-level method for transitioning to a new state.
	     *
	     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to State name or state object.
	     * @param toParams A map of the parameters that will be sent to the state,
	     *      will populate $stateParams.
	     * @param options Transition options
	     *
	     * @returns A promise representing the state of the new transition. See [[go]]
	     */
	    StateService.prototype.transitionTo = function (to, toParams, options) {
	        var _this = this;
	        if (toParams === void 0) { toParams = {}; }
	        if (options === void 0) { options = {}; }
	        var router = this.router;
	        var globals = router.globals;
	        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
	        var getCurrent = function () { return globals.transition; };
	        options = common_1.extend(options, { current: getCurrent });
	        var ref = this.target(to, toParams, options);
	        var currentPath = this.getCurrentPath();
	        if (!ref.exists())
	            return this._handleInvalidTargetState(currentPath, ref);
	        if (!ref.valid())
	            return common_1.silentRejection(ref.error());
	        if (options.supercede === false && getCurrent()) {
	            return (rejectFactory_1.Rejection.ignored('Another transition is in progress and supercede has been set to false in TransitionOptions for the transition. So the transition was ignored in favour of the existing one in progress.').toPromise());
	        }
	        /**
	         * Special handling for Ignored, Aborted, and Redirected transitions
	         *
	         * The semantics for the transition.run() promise and the StateService.transitionTo()
	         * promise differ. For instance, the run() promise may be rejected because it was
	         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
	         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
	         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
	         */
	        var rejectedTransitionHandler = function (trans) { return function (error) {
	            if (error instanceof rejectFactory_1.Rejection) {
	                var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
	                if (error.type === rejectFactory_1.RejectType.IGNORED) {
	                    isLatest && router.urlRouter.update();
	                    // Consider ignored `Transition.run()` as a successful `transitionTo`
	                    return coreservices_1.services.$q.when(globals.current);
	                }
	                var detail = error.detail;
	                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
	                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
	                    // by returning the promise for the new (redirect) `Transition.run()`.
	                    var redirect = trans.redirect(detail);
	                    return redirect.run().catch(rejectedTransitionHandler(redirect));
	                }
	                if (error.type === rejectFactory_1.RejectType.ABORTED) {
	                    isLatest && router.urlRouter.update();
	                    return coreservices_1.services.$q.reject(error);
	                }
	            }
	            var errorHandler = _this.defaultErrorHandler();
	            errorHandler(error);
	            return coreservices_1.services.$q.reject(error);
	        }; };
	        var transition = this.router.transitionService.create(currentPath, ref);
	        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
	        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
	        // Return a promise for the transition, which also has the transition object on it.
	        return common_1.extend(transitionToPromise, { transition: transition });
	    };
	    /**
	     * Checks if the current state *is* the provided state
	     *
	     * Similar to [[includes]] but only checks for the full state name.
	     * If params is supplied then it will be tested for strict equality against the current
	     * active params object, so all params must match with none missing and no extras.
	     *
	     * #### Example:
	     * ```js
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     * ```
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * ```html
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * ```
	     *
	     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns Returns true if it is the state.
	     */
	    StateService.prototype.is = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (this.$current !== state)
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Checks if the current state *includes* the provided state
	     *
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * #### Example when `$state.$current.name === 'contacts.details.item'`
	     * ```js
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     * ```
	     *
	     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
	     * ```js
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * ```
	     *
	     * @param stateOrName A partial name, relative name, glob pattern,
	     *   or state object to be searched for within the current state name.
	     * @param params A param object, e.g. `{sectionId: section.id}`,
	     *   that you'd like to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    StateService.prototype.includes = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
	        if (glob) {
	            if (!glob.matches(this.$current.name))
	                return false;
	            stateOrName = this.$current.name;
	        }
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (!predicates_1.isDefined(include[state.name]))
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Generates a URL for a state and parameters
	     *
	     * Returns the url for the given state populated with the given params.
	     *
	     * #### Example:
	     * ```js
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * ```
	     *
	     * @param stateOrName The state name or state object you'd like to generate a url from.
	     * @param params An object of parameter values to fill the state's required parameters.
	     * @param options Options object. The options are:
	     *
	     * @returns {string} compiled state url
	     */
	    StateService.prototype.href = function (stateOrName, params, options) {
	        var defaultHrefOpts = {
	            lossy: true,
	            inherit: true,
	            absolute: false,
	            relative: this.$current,
	        };
	        options = common_1.defaults(options, defaultHrefOpts);
	        params = params || {};
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return null;
	        if (options.inherit)
	            params = this.params.$inherit(params, this.$current, state);
	        var nav = state && options.lossy ? state.navigable : state;
	        if (!nav || nav.url === undefined || nav.url === null) {
	            return null;
	        }
	        return this.router.urlRouter.href(nav.url, params, { absolute: options.absolute });
	    };
	    /**
	     * Sets or gets the default [[transitionTo]] error handler.
	     *
	     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
	     * This includes errors caused by resolves and transition hooks.
	     *
	     * Note:
	     * This handler does not receive certain Transition rejections.
	     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
	     *
	     * The built-in default error handler logs the error to the console.
	     *
	     * You can provide your own custom handler.
	     *
	     * #### Example:
	     * ```js
	     * stateService.defaultErrorHandler(function() {
	     *   // Do not log transitionTo errors
	     * });
	     * ```
	     *
	     * @param handler a global error handler function
	     * @returns the current global error handler
	     */
	    StateService.prototype.defaultErrorHandler = function (handler) {
	        return (this._defaultErrorHandler = handler || this._defaultErrorHandler);
	    };
	    StateService.prototype.get = function (stateOrName, base) {
	        var reg = this.router.stateRegistry;
	        if (arguments.length === 0)
	            return reg.get();
	        return reg.get(stateOrName, base || this.$current);
	    };
	    /**
	     * Lazy loads a state
	     *
	     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
	     *
	     * @param stateOrName the state that should be lazy loaded
	     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
	     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
	     * This noop transition is not actually run.
	     *
	     * @returns a promise to lazy load
	     */
	    StateService.prototype.lazyLoad = function (stateOrName, transition) {
	        var state = this.get(stateOrName);
	        if (!state || !state.lazyLoad)
	            throw new Error('Can not lazy load ' + stateOrName);
	        var currentPath = this.getCurrentPath();
	        var target = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
	        transition = transition || this.router.transitionService.create(currentPath, target);
	        return lazyLoad_1.lazyLoadState(transition, state);
	    };
	    return StateService;
	}());
	exports.StateService = StateService;
	//# sourceMappingURL=stateService.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HookBuilder = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var interface_1 = __webpack_require__(10);
	var transitionHook_1 = __webpack_require__(18);
	/**
	 * This class returns applicable TransitionHooks for a specific Transition instance.
	 *
	 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
	 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
	 * determined by the type of hook)
	 *
	 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
	 *
	 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
	 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
	 * in the Transition class, so we must also provide the Transition's _treeChanges)
	 */
	var HookBuilder = /** @class */ (function () {
	    function HookBuilder(transition) {
	        this.transition = transition;
	    }
	    HookBuilder.prototype.buildHooksForPhase = function (phase) {
	        var _this = this;
	        var $transitions = this.transition.router.transitionService;
	        return $transitions._pluginapi
	            ._getEvents(phase)
	            .map(function (type) { return _this.buildHooks(type); })
	            .reduce(common_1.unnestR, [])
	            .filter(common_1.identity);
	    };
	    /**
	     * Returns an array of newly built TransitionHook objects.
	     *
	     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
	     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
	     * - For each of the [[PathNode]]s, creates a TransitionHook
	     *
	     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
	     */
	    HookBuilder.prototype.buildHooks = function (hookType) {
	        var transition = this.transition;
	        var treeChanges = transition.treeChanges();
	        // Find all the matching registered hooks for a given hook type
	        var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
	        if (!matchingHooks)
	            return [];
	        var baseHookOptions = {
	            transition: transition,
	            current: transition.options().current,
	        };
	        var makeTransitionHooks = function (hook) {
	            // Fetch the Nodes that caused this hook to match.
	            var matches = hook.matches(treeChanges, transition);
	            // Select the PathNode[] that will be used as TransitionHook context objects
	            var matchingNodes = matches[hookType.criteriaMatchPath.name];
	            // Return an array of HookTuples
	            return matchingNodes.map(function (node) {
	                var _options = common_1.extend({
	                    bind: hook.bind,
	                    traceData: { hookType: hookType.name, context: node },
	                }, baseHookOptions);
	                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
	                var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
	                return { hook: hook, node: node, transitionHook: transitionHook };
	            });
	        };
	        return matchingHooks
	            .map(makeTransitionHooks)
	            .reduce(common_1.unnestR, [])
	            .sort(tupleSort(hookType.reverseSort))
	            .map(function (tuple) { return tuple.transitionHook; });
	    };
	    /**
	     * Finds all RegisteredHooks from:
	     * - The Transition object instance hook registry
	     * - The TransitionService ($transitions) global hook registry
	     *
	     * which matched:
	     * - the eventType
	     * - the matchCriteria (to, from, exiting, retained, entering)
	     *
	     * @returns an array of matched [[RegisteredHook]]s
	     */
	    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges, transition) {
	        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
	        // Instance and Global hook registries
	        var $transitions = this.transition.router.transitionService;
	        var registries = isCreate ? [$transitions] : [this.transition, $transitions];
	        return registries
	            .map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
	            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
	            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
	            .filter(function (hook) { return hook.matches(treeChanges, transition); }); // Only those satisfying matchCriteria
	    };
	    return HookBuilder;
	}());
	exports.HookBuilder = HookBuilder;
	/**
	 * A factory for a sort function for HookTuples.
	 *
	 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
	 * the EventHook priority.
	 *
	 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
	 * @returns a tuple sort function
	 */
	function tupleSort(reverseDepthSort) {
	    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
	    return function nodeDepthThenPriority(l, r) {
	        var factor = reverseDepthSort ? -1 : 1;
	        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
	        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
	    };
	}
	//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TransitionEventType = void 0;
	var transitionHook_1 = __webpack_require__(18);
	/**
	 * This class defines a type of hook, such as `onBefore` or `onEnter`.
	 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
	 */
	var TransitionEventType = /** @class */ (function () {
	    /* tslint:disable:no-inferrable-types */
	    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        this.name = name;
	        this.hookPhase = hookPhase;
	        this.hookOrder = hookOrder;
	        this.criteriaMatchPath = criteriaMatchPath;
	        this.reverseSort = reverseSort;
	        this.getResultHandler = getResultHandler;
	        this.getErrorHandler = getErrorHandler;
	        this.synchronous = synchronous;
	    }
	    return TransitionEventType;
	}());
	exports.TransitionEventType = TransitionEventType;
	//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlConfig = void 0;
	var params_1 = __webpack_require__(35);
	var common_1 = __webpack_require__(4);
	/**
	 * An API to customize the URL behavior and retrieve URL configuration
	 *
	 * This API is used to customize the behavior of the URL.
	 * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
	 * and custom parameter encoding (custom [[type]]).
	 *
	 * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
	 * This information can be used to build absolute URLs, such as
	 * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
	 *
	 * This API is found at `router.urlService.config` (see: [[UIRouter.urlService]], [[URLService.config]])
	 */
	var UrlConfig = /** @class */ (function () {
	    /** @internal */ function UrlConfig(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.paramTypes = new params_1.ParamTypes();
	        /** @internal */ this._decodeParams = true;
	        /** @internal */ this._isCaseInsensitive = false;
	        /** @internal */ this._isStrictMode = true;
	        /** @internal */ this._defaultSquashPolicy = false;
	        /** @internal */ this.dispose = function () { return _this.paramTypes.dispose(); };
	        // Delegate these calls to the current LocationConfig implementation
	        /**
	         * Gets the base Href, e.g., `http://localhost/approot/`
	         *
	         * @return the application's base href
	         */
	        this.baseHref = function () { return _this.router.locationConfig.baseHref(); };
	        /**
	         * Gets or sets the hashPrefix
	         *
	         * This only applies when not running in [[html5Mode]] (pushstate mode)
	         *
	         * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
	         *
	         * @return the hash prefix
	         */
	        this.hashPrefix = function (newprefix) { return _this.router.locationConfig.hashPrefix(newprefix); };
	        /**
	         * Gets the host, e.g., `localhost`
	         *
	         * @return the protocol
	         */
	        this.host = function () { return _this.router.locationConfig.host(); };
	        /**
	         * Returns true when running in pushstate mode
	         *
	         * @return true when running in html5 mode (pushstate mode).
	         */
	        this.html5Mode = function () { return _this.router.locationConfig.html5Mode(); };
	        /**
	         * Gets the port, e.g., `80`
	         *
	         * @return the port number
	         */
	        this.port = function () { return _this.router.locationConfig.port(); };
	        /**
	         * Gets the protocol, e.g., `http`
	         *
	         * @return the protocol
	         */
	        this.protocol = function () { return _this.router.locationConfig.protocol(); };
	    }
	    /**
	     * Defines whether URL matching should be case sensitive (the default behavior), or not.
	     *
	     * #### Example:
	     * ```js
	     * // Allow case insensitive url matches
	     * urlService.config.caseInsensitive(true);
	     * ```
	     *
	     * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
	     * @returns the current value of caseInsensitive
	     */
	    UrlConfig.prototype.caseInsensitive = function (value) {
	        return (this._isCaseInsensitive = common_1.isDefined(value) ? value : this._isCaseInsensitive);
	    };
	    /**
	     * Sets the default behavior when generating or matching URLs with default parameter values.
	     *
	     * #### Example:
	     * ```js
	     * // Remove default parameter values from the url
	     * urlService.config.defaultSquashPolicy(true);
	     * ```
	     *
	     * @param value A string that defines the default parameter URL squashing behavior.
	     *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	     *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	     *      parameter is surrounded by slashes, squash (remove) one slash from the URL
	     *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	     *      the parameter value from the URL and replace it with this string.
	     * @returns the current value of defaultSquashPolicy
	     */
	    UrlConfig.prototype.defaultSquashPolicy = function (value) {
	        if (common_1.isDefined(value) && value !== true && value !== false && !common_1.isString(value))
	            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	        return (this._defaultSquashPolicy = common_1.isDefined(value) ? value : this._defaultSquashPolicy);
	    };
	    /**
	     * Defines whether URLs should match trailing slashes, or not (the default behavior).
	     *
	     * #### Example:
	     * ```js
	     * // Allow optional trailing slashes
	     * urlService.config.strictMode(false);
	     * ```
	     *
	     * @param value `false` to match trailing slashes in URLs, otherwise `true`.
	     * @returns the current value of strictMode
	     */
	    UrlConfig.prototype.strictMode = function (value) {
	        return (this._isStrictMode = common_1.isDefined(value) ? value : this._isStrictMode);
	    };
	    /**
	     * Creates and registers a custom [[ParamType]] object
	     *
	     * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
	     *
	     * #### Note: Register custom types *before using them* in a state definition.
	     *
	     * #### Example:
	     * ```js
	     * // Encode object parameter as JSON string
	     * urlService.config.type('myjson', {
	     *   encode: (obj) => JSON.stringify(obj),
	     *   decode: (str) => JSON.parse(str),
	     *   is: (val) => typeof(val) === 'object',
	     *   pattern: /[^/]+/,
	     *   equals: (a, b) => _.isEqual(a, b),
	     * });
	     * ```
	     *
	     * See [[ParamTypeDefinition]] for more examples
	     *
	     * @param name The type name.
	     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
	     * @param definitionFn A function that is injected before the app runtime starts.
	     *        The result of this function should be a [[ParamTypeDefinition]].
	     *        The result is merged into the existing `definition`.
	     *        See [[ParamType]] for information on the values accepted.
	     *
	     * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
	     */
	    UrlConfig.prototype.type = function (name, definition, definitionFn) {
	        var type = this.paramTypes.type(name, definition, definitionFn);
	        return !common_1.isDefined(definition) ? type : this;
	    };
	    return UrlConfig;
	}());
	exports.UrlConfig = UrlConfig;
	//# sourceMappingURL=urlConfig.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcherFactory = exports.ParamFactory = void 0;
	var common_1 = __webpack_require__(4);
	var urlMatcher_1 = __webpack_require__(24);
	var params_1 = __webpack_require__(35);
	var ParamFactory = /** @class */ (function () {
	    function ParamFactory(router) {
	        this.router = router;
	    }
	    ParamFactory.prototype.fromConfig = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.CONFIG, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromPath = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.PATH, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromSearch = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.SEARCH, this.router.urlService.config, state);
	    };
	    return ParamFactory;
	}());
	exports.ParamFactory = ParamFactory;
	/**
	 * Factory for [[UrlMatcher]] instances.
	 *
	 * The factory is available to ng1 services as
	 * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
	 */
	var UrlMatcherFactory = /** @class */ (function () {
	    // TODO: move implementations to UrlConfig (urlService.config)
	    function UrlMatcherFactory(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** Creates a new [[Param]] for a given location (DefType) */
	        this.paramFactory = new ParamFactory(this.router);
	        // TODO: Check if removal of this will break anything, then remove these
	        this.UrlMatcher = urlMatcher_1.UrlMatcher;
	        this.Param = params_1.Param;
	        /** @deprecated use [[UrlConfig.caseInsensitive]] */
	        this.caseInsensitive = function (value) { return _this.router.urlService.config.caseInsensitive(value); };
	        /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */
	        this.defaultSquashPolicy = function (value) { return _this.router.urlService.config.defaultSquashPolicy(value); };
	        /** @deprecated use [[UrlConfig.strictMode]] */
	        this.strictMode = function (value) { return _this.router.urlService.config.strictMode(value); };
	        /** @deprecated use [[UrlConfig.type]] */
	        this.type = function (name, definition, definitionFn) {
	            return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
	        };
	    }
	    /**
	     * Creates a [[UrlMatcher]] for the specified pattern.
	     *
	     * @param pattern  The URL pattern.
	     * @param config  The config object hash.
	     * @returns The UrlMatcher.
	     */
	    UrlMatcherFactory.prototype.compile = function (pattern, config) {
	        var urlConfig = this.router.urlService.config;
	        // backward-compatible support for config.params -> config.state.params
	        var params = config && !config.state && config.params;
	        config = params ? __assign({ state: { params: params } }, config) : config;
	        var globalConfig = {
	            strict: urlConfig._isStrictMode,
	            caseInsensitive: urlConfig._isCaseInsensitive,
	            decodeParams: urlConfig._decodeParams,
	        };
	        return new urlMatcher_1.UrlMatcher(pattern, urlConfig.paramTypes, this.paramFactory, common_1.extend(globalConfig, config));
	    };
	    /**
	     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
	     *
	     * @param object  The object to perform the type check against.
	     * @returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    UrlMatcherFactory.prototype.isMatcher = function (object) {
	        // TODO: typeof?
	        if (!common_1.isObject(object))
	            return false;
	        var result = true;
	        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
	            if (common_1.isFunction(val))
	                result = result && common_1.isDefined(object[name]) && common_1.isFunction(object[name]);
	        });
	        return result;
	    };
	    /** @internal */
	    UrlMatcherFactory.prototype.$get = function () {
	        var urlConfig = this.router.urlService.config;
	        urlConfig.paramTypes.enqueue = false;
	        urlConfig.paramTypes._flushTypeQueue();
	        return this;
	    };
	    return UrlMatcherFactory;
	}());
	exports.UrlMatcherFactory = UrlMatcherFactory;
	//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRouter = void 0;
	var common_1 = __webpack_require__(4);
	var urlRule_1 = __webpack_require__(43);
	function appendBasePath(url, isHtml5, absolute, baseHref) {
	    if (baseHref === '/')
	        return url;
	    if (isHtml5)
	        return common_1.stripLastPathElement(baseHref) + url;
	    if (absolute)
	        return baseHref.slice(1) + url;
	    return url;
	}
	/**
	 * Updates URL and responds to URL changes
	 *
	 * ### Deprecation warning:
	 * This class is now considered to be an internal API
	 * Use the [[UrlService]] instead.
	 * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
	 */
	var UrlRouter = /** @class */ (function () {
	    /** @internal */
	    function UrlRouter(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        // Delegate these calls to [[UrlService]]
	        /** @deprecated use [[UrlService.sync]]*/
	        this.sync = function (evt) { return _this.router.urlService.sync(evt); };
	        /** @deprecated use [[UrlService.listen]]*/
	        this.listen = function (enabled) { return _this.router.urlService.listen(enabled); };
	        /** @deprecated use [[UrlService.deferIntercept]]*/
	        this.deferIntercept = function (defer) { return _this.router.urlService.deferIntercept(defer); };
	        /** @deprecated use [[UrlService.match]]*/
	        this.match = function (urlParts) { return _this.router.urlService.match(urlParts); };
	        // Delegate these calls to [[UrlRules]]
	        /** @deprecated use [[UrlRules.initial]]*/
	        this.initial = function (handler) {
	            return _this.router.urlService.rules.initial(handler);
	        };
	        /** @deprecated use [[UrlRules.otherwise]]*/
	        this.otherwise = function (handler) {
	            return _this.router.urlService.rules.otherwise(handler);
	        };
	        /** @deprecated use [[UrlRules.removeRule]]*/
	        this.removeRule = function (rule) { return _this.router.urlService.rules.removeRule(rule); };
	        /** @deprecated use [[UrlRules.rule]]*/
	        this.rule = function (rule) { return _this.router.urlService.rules.rule(rule); };
	        /** @deprecated use [[UrlRules.rules]]*/
	        this.rules = function () { return _this.router.urlService.rules.rules(); };
	        /** @deprecated use [[UrlRules.sort]]*/
	        this.sort = function (compareFn) { return _this.router.urlService.rules.sort(compareFn); };
	        /** @deprecated use [[UrlRules.when]]*/
	        this.when = function (matcher, handler, options) { return _this.router.urlService.rules.when(matcher, handler, options); };
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** Internal API. */
	    UrlRouter.prototype.update = function (read) {
	        var $url = this.router.locationService;
	        if (read) {
	            this.location = $url.url();
	            return;
	        }
	        if ($url.url() === this.location)
	            return;
	        $url.url(this.location, true);
	    };
	    /**
	     * Internal API.
	     *
	     * Pushes a new location to the browser history.
	     *
	     * @internal
	     * @param urlMatcher
	     * @param params
	     * @param options
	     */
	    UrlRouter.prototype.push = function (urlMatcher, params, options) {
	        var replace = options && !!options.replace;
	        this.router.urlService.url(urlMatcher.format(params || {}), replace);
	    };
	    /**
	     * Builds and returns a URL with interpolated parameters
	     *
	     * #### Example:
	     * ```js
	     * matcher = $umf.compile("/about/:person");
	     * params = { person: "bob" };
	     * $bob = $urlRouter.href(matcher, params);
	     * // $bob == "/about/bob";
	     * ```
	     *
	     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
	     * @param params An object of parameter values to fill the matcher's required parameters.
	     * @param options Options object. The options are:
	     *
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     *
	     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	     */
	    UrlRouter.prototype.href = function (urlMatcher, params, options) {
	        var url = urlMatcher.format(params);
	        if (url == null)
	            return null;
	        options = options || { absolute: false };
	        var cfg = this.router.urlService.config;
	        var isHtml5 = cfg.html5Mode();
	        if (!isHtml5 && url !== null) {
	            url = '#' + cfg.hashPrefix() + url;
	        }
	        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
	        if (!options.absolute || !url) {
	            return url;
	        }
	        var slash = !isHtml5 && url ? '/' : '';
	        var cfgPort = cfg.port();
	        var port = (cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort);
	        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
	    };
	    Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
	        /** @deprecated use [[UrlService.interceptDeferred]]*/
	        get: function () {
	            return this.router.urlService.interceptDeferred;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return UrlRouter;
	}());
	exports.UrlRouter = UrlRouter;
	//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlRules = void 0;
	var state_1 = __webpack_require__(38);
	var urlMatcher_1 = __webpack_require__(24);
	var common_1 = __webpack_require__(4);
	var urlRule_1 = __webpack_require__(43);
	var prioritySort = function (a, b) { return (b.priority || 0) - (a.priority || 0); };
	var typeSort = function (a, b) {
	    var weights = { STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1 };
	    return (weights[a.type] || 0) - (weights[b.type] || 0);
	};
	var urlMatcherSort = function (a, b) {
	    return !a.urlMatcher || !b.urlMatcher ? 0 : urlMatcher_1.UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
	};
	var idSort = function (a, b) {
	    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
	    var useMatchPriority = { STATE: true, URLMATCHER: true };
	    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
	    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
	};
	/**
	 * Default rule priority sorting function.
	 *
	 * Sorts rules by:
	 *
	 * - Explicit priority (set rule priority using [[UrlRules.when]])
	 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
	 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
	 * - Rule registration order (for rule types other than STATE and URLMATCHER)
	 *   - Equally sorted State and UrlMatcher rules will each match the URL.
	 *     Then, the *best* match is chosen based on how many parameter values were matched.
	 */
	var defaultRuleSortFn;
	defaultRuleSortFn = function (a, b) {
	    var cmp = prioritySort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = typeSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = urlMatcherSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    return idSort(a, b);
	};
	function getHandlerFn(handler) {
	    if (!common_1.isFunction(handler) && !common_1.isString(handler) && !common_1.is(state_1.TargetState)(handler) && !state_1.TargetState.isDef(handler)) {
	        throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
	    }
	    return common_1.isFunction(handler) ? handler : common_1.val(handler);
	}
	/**
	 * API for managing URL rules
	 *
	 * This API is used to create and manage URL rules.
	 * URL rules are a mechanism to respond to specific URL patterns.
	 *
	 * The most commonly used methods are [[otherwise]] and [[when]].
	 *
	 * This API is found at `router.urlService.rules` (see: [[UIRouter.urlService]], [[URLService.rules]])
	 */
	var UrlRules = /** @class */ (function () {
	    /** @internal */
	    function UrlRules(/** @internal */ router) {
	        this.router = router;
	        /** @internal */ this._sortFn = defaultRuleSortFn;
	        /** @internal */ this._rules = [];
	        /** @internal */ this._id = 0;
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** @internal */
	    UrlRules.prototype.dispose = function (router) {
	        this._rules = [];
	        delete this._otherwiseFn;
	    };
	    /**
	     * Defines the initial state, path, or behavior to use when the app starts.
	     *
	     * This rule defines the initial/starting state for the application.
	     *
	     * This rule is triggered the first time the URL is checked (when the app initially loads).
	     * The rule is triggered only when the url matches either `""` or `"/"`.
	     *
	     * Note: The rule is intended to be used when the root of the application is directly linked to.
	     * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
	     * This allows 404-like behavior when an unknown URL is deep-linked.
	     *
	     * #### Example:
	     * Start app at `home` state.
	     * ```js
	     * .initial({ state: 'home' });
	     * ```
	     *
	     * #### Example:
	     * Start app at `/home` (by url)
	     * ```js
	     * .initial('/home');
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .initial((matchValue, url, router) => {
	     *   console.log('initial state');
	     *   return { state: 'home' };
	     * })
	     * ```
	     *
	     * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
	     */
	    UrlRules.prototype.initial = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        var matchFn = function (urlParts, router) {
	            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
	        };
	        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
	    };
	    /**
	     * Defines the state, url, or behavior to use when no other rule matches the URL.
	     *
	     * This rule is matched when *no other rule* matches.
	     * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
	     *
	     * - If `handler` a string, it is treated as a url redirect
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `/index`
	     * ```js
	     * .otherwise('/index');
	     * ```
	     *
	     * - If `handler` is an object with a `state` property, the state is activated.
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
	     * ```js
	     * .otherwise({ state: 'home', params: { dashboard: 'default' } });
	     * ```
	     *
	     * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
	     *   The function can perform actions, and/or return a value.
	     *
	     * #### Example:
	     * When no other url rule matches, manually trigger a transition to the `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   router.stateService.go('home');
	     * });
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   return { state: 'home' };
	     * });
	     * ```
	     *
	     * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
	     */
	    UrlRules.prototype.otherwise = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        this._otherwiseFn = this.urlRuleFactory.create(common_1.val(true), handlerFn);
	        this._sorted = false;
	    };
	    /**
	     * Remove a rule previously registered
	     *
	     * @param rule the matcher rule that was previously registered using [[rule]]
	     */
	    UrlRules.prototype.removeRule = function (rule) {
	        common_1.removeFrom(this._rules, rule);
	    };
	    /**
	     * Manually adds a URL Rule.
	     *
	     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
	     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
	     * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
	     *
	     * A rule should have a `match` function which returns truthy if the rule matched.
	     * It should also have a `handler` function which is invoked if the rule is the best match.
	     *
	     * @return a function that deregisters the rule
	     */
	    UrlRules.prototype.rule = function (rule) {
	        var _this = this;
	        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
	            throw new Error('invalid rule');
	        rule.$id = this._id++;
	        rule.priority = rule.priority || 0;
	        this._rules.push(rule);
	        this._sorted = false;
	        return function () { return _this.removeRule(rule); };
	    };
	    /**
	     * Gets all registered rules
	     *
	     * @returns an array of all the registered rules
	     */
	    UrlRules.prototype.rules = function () {
	        this.ensureSorted();
	        return this._rules.concat(this._otherwiseFn ? [this._otherwiseFn] : []);
	    };
	    /**
	     * Defines URL Rule priorities
	     *
	     * More than one rule ([[UrlRule]]) might match a given URL.
	     * This `compareFn` is used to sort the rules by priority.
	     * Higher priority rules should sort earlier.
	     *
	     * The [[defaultRuleSortFn]] is used by default.
	     *
	     * You only need to call this function once.
	     * The `compareFn` will be used to sort the rules as each is registered.
	     *
	     * If called without any parameter, it will re-sort the rules.
	     *
	     * ---
	     *
	     * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
	     * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
	     * The `$id` is is the order in which the rule was registered.
	     *
	     * The sort function should use these data, or data found on a specific type
	     * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
	     *
	     * #### Example:
	     * This compare function prioritizes rules by the order in which the rules were registered.
	     * A rule registered earlier has higher priority.
	     *
	     * ```js
	     * function compareFn(a, b) {
	     *   return a.$id - b.$id;
	     * }
	     * ```
	     *
	     * @param compareFn a function that compares to [[UrlRule]] objects.
	     *    The `compareFn` should abide by the `Array.sort` compare function rules.
	     *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
	     *    Return a positive number if `b` should be higher priority.
	     *    Return `0` if the rules are identical.
	     *
	     *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
	     *    for details.
	     */
	    UrlRules.prototype.sort = function (compareFn) {
	        var sorted = this.stableSort(this._rules, (this._sortFn = compareFn || this._sortFn));
	        // precompute _sortGroup values and apply to each rule
	        var group = 0;
	        for (var i = 0; i < sorted.length; i++) {
	            sorted[i]._group = group;
	            if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) {
	                group++;
	            }
	        }
	        this._rules = sorted;
	        this._sorted = true;
	    };
	    /** @internal */
	    UrlRules.prototype.ensureSorted = function () {
	        this._sorted || this.sort();
	    };
	    /** @internal */
	    UrlRules.prototype.stableSort = function (arr, compareFn) {
	        var arrOfWrapper = arr.map(function (elem, idx) { return ({ elem: elem, idx: idx }); });
	        arrOfWrapper.sort(function (wrapperA, wrapperB) {
	            var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
	            return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
	        });
	        return arrOfWrapper.map(function (wrapper) { return wrapper.elem; });
	    };
	    /**
	     * Registers a `matcher` and `handler` for custom URLs handling.
	     *
	     * The `matcher` can be:
	     *
	     * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
	     * - a `string`: The string is compiled to a [[UrlMatcher]]
	     * - a `RegExp`: The regexp is used to match the url.
	     *
	     * The `handler` can be:
	     *
	     * - a string: The url is redirected to the value of the string.
	     * - a function: The url is redirected to the return value of the function.
	     *
	     * ---
	     *
	     * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
	     * string is interpolated with parameter values.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when("/foo/:param1", "/bar/:param1")
	     * ```
	     *
	     * ---
	     *
	     * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
	     * interpolated with capture groups from the RegExp.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
	     * ```
	     *
	     * ---
	     *
	     * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
	     * The "matched value" differs based on the `matcher`.
	     * For [[UrlMatcher]]s, it will be the matched state params.
	     * For `RegExp`, it will be the match array from `regexp.exec()`.
	     *
	     * If the handler returns a string, the URL is redirected to the string.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
	     * ```
	     *
	     * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
	     *
	     * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
	     * @param handler The path to redirect to, or a function that returns the path.
	     * @param options `{ priority: number }`
	     *
	     * @return the registered [[UrlRule]]
	     */
	    UrlRules.prototype.when = function (matcher, handler, options) {
	        var rule = this.urlRuleFactory.create(matcher, handler);
	        if (common_1.isDefined(options && options.priority))
	            rule.priority = options.priority;
	        this.rule(rule);
	        return rule;
	    };
	    return UrlRules;
	}());
	exports.UrlRules = UrlRules;
	//# sourceMappingURL=urlRules.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlService = void 0;
	var common_1 = __webpack_require__(4);
	var urlRules_1 = __webpack_require__(67);
	var urlConfig_1 = __webpack_require__(64);
	var state_1 = __webpack_require__(38);
	/**
	 * API for URL management
	 */
	var UrlService = /** @class */ (function () {
	    /** @internal */
	    function UrlService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this.interceptDeferred = false;
	        /**
	         * The nested [[UrlRules]] API for managing URL rules and rewrites
	         *
	         * See: [[UrlRules]] for details
	         */
	        this.rules = new urlRules_1.UrlRules(this.router);
	        /**
	         * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
	         *
	         * See: [[UrlConfig]] for details
	         */
	        this.config = new urlConfig_1.UrlConfig(this.router);
	        // Delegate these calls to the current LocationServices implementation
	        /**
	         * Gets the current url, or updates the url
	         *
	         * ### Getting the current URL
	         *
	         * When no arguments are passed, returns the current URL.
	         * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
	         *
	         * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
	         * have a base HREF prepended ([[PushStateLocationServices]]).
	         *
	         * The raw URL in the browser might be:
	         *
	         * ```
	         * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * or
	         *
	         * ```
	         * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * then this method returns:
	         *
	         * ```
	         * /internal/path/123?param1=foo#anchor
	         * ```
	         *
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url(); // "/some/path?query=value#anchor"
	         * ```
	         *
	         * ### Updating the URL
	         *
	         * When `newurl` arguments is provided, changes the URL to reflect `newurl`
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url("/some/path?query=value#anchor", true);
	         * ```
	         *
	         * @param newurl The new value for the URL.
	         *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
	         *               It should not include the protocol, site, port, or base path of an absolute HREF.
	         * @param replace When true, replaces the current history entry (instead of appending it) with this new url
	         * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
	         *
	         * @return the url (after potentially being processed)
	         */
	        this.url = function (newurl, replace, state) {
	            return _this.router.locationService.url(newurl, replace, state);
	        };
	        /**
	         * Gets the path part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
	         *
	         * @return the path portion of the url
	         */
	        this.path = function () { return _this.router.locationService.path(); };
	        /**
	         * Gets the search part of the current url as an object
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
	         *
	         * @return the search (query) portion of the url, as an object
	         */
	        this.search = function () { return _this.router.locationService.search(); };
	        /**
	         * Gets the hash part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
	         *
	         * @return the hash (anchor) portion of the url
	         */
	        this.hash = function () { return _this.router.locationService.hash(); };
	        /**
	         * @internal
	         *
	         * Registers a low level url change handler
	         *
	         * Note: Because this is a low level handler, it's not recommended for general use.
	         *
	         * #### Example:
	         * ```js
	         * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
	         * ```
	         *
	         * @param callback a function that will be called when the url is changing
	         * @return a function that de-registers the callback
	         */
	        this.onChange = function (callback) { return _this.router.locationService.onChange(callback); };
	    }
	    /** @internal */
	    UrlService.prototype.dispose = function () {
	        this.listen(false);
	        this.rules.dispose();
	    };
	    /**
	     * Gets the current URL parts
	     *
	     * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
	     */
	    UrlService.prototype.parts = function () {
	        return { path: this.path(), search: this.search(), hash: this.hash() };
	    };
	    /**
	     * Activates the best rule for the current URL
	     *
	     * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
	     * This method is called internally any time the URL has changed.
	     *
	     * This effectively activates the state (or redirect, etc) which matches the current URL.
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   // Find the matching URL and invoke the handler.
	     *   urlService.sync();
	     * });
	     * ```
	     */
	    UrlService.prototype.sync = function (evt) {
	        if (evt && evt.defaultPrevented)
	            return;
	        var _a = this.router, urlService = _a.urlService, stateService = _a.stateService;
	        var url = { path: urlService.path(), search: urlService.search(), hash: urlService.hash() };
	        var best = this.match(url);
	        var applyResult = common_1.pattern([
	            [common_1.isString, function (newurl) { return urlService.url(newurl, true); }],
	            [state_1.TargetState.isDef, function (def) { return stateService.go(def.state, def.params, def.options); }],
	            [common_1.is(state_1.TargetState), function (target) { return stateService.go(target.state(), target.params(), target.options()); }],
	        ]);
	        applyResult(best && best.rule.handler(best.match, url, this.router));
	    };
	    /**
	     * Starts or stops listening for URL changes
	     *
	     * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
	     * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
	     *
	     * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   // Start responding to URL changes
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param enabled `true` or `false` to start or stop listening to URL changes
	     */
	    UrlService.prototype.listen = function (enabled) {
	        var _this = this;
	        if (enabled === false) {
	            this._stopListeningFn && this._stopListeningFn();
	            delete this._stopListeningFn;
	        }
	        else {
	            return (this._stopListeningFn =
	                this._stopListeningFn || this.router.urlService.onChange(function (evt) { return _this.sync(evt); }));
	        }
	    };
	    /**
	     * Disables monitoring of the URL.
	     *
	     * Call this method before UI-Router has bootstrapped.
	     * It will stop UI-Router from performing the initial url sync.
	     *
	     * This can be useful to perform some asynchronous initialization before the router starts.
	     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	     *
	     * #### Example:
	     * ```js
	     * // Prevent UI-Router from automatically intercepting URL changes when it starts;
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param defer Indicates whether to defer location change interception.
	     *        Passing no parameter is equivalent to `true`.
	     */
	    UrlService.prototype.deferIntercept = function (defer) {
	        if (defer === undefined)
	            defer = true;
	        this.interceptDeferred = defer;
	    };
	    /**
	     * Matches a URL
	     *
	     * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
	     * Return the result as a [[MatchResult]].
	     */
	    UrlService.prototype.match = function (url) {
	        var _this = this;
	        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
	        var rules = this.rules.rules();
	        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
	        var checkRule = function (rule) {
	            var match = rule.match(url, _this.router);
	            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
	        };
	        // The rules are pre-sorted.
	        // - Find the first matching rule.
	        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
	        // - Choose the rule with the highest match weight.
	        var best;
	        for (var i = 0; i < rules.length; i++) {
	            // Stop when there is a 'best' rule and the next rule sorts differently than it.
	            if (best && best.rule._group !== rules[i]._group)
	                break;
	            var current = checkRule(rules[i]);
	            // Pick the best MatchResult
	            best = !best || (current && current.weight > best.weight) ? current : best;
	        }
	        return best;
	    };
	    return UrlService;
	}());
	exports.UrlService = UrlService;
	//# sourceMappingURL=urlService.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BrowserLocationConfig = void 0;
	var predicates_1 = __webpack_require__(2);
	/** A `LocationConfig` that delegates to the browser's `location` object */
	var BrowserLocationConfig = /** @class */ (function () {
	    function BrowserLocationConfig(router, _isHtml5) {
	        if (_isHtml5 === void 0) { _isHtml5 = false; }
	        this._isHtml5 = _isHtml5;
	        this._baseHref = undefined;
	        this._hashPrefix = '';
	    }
	    BrowserLocationConfig.prototype.port = function () {
	        if (location.port) {
	            return Number(location.port);
	        }
	        return this.protocol() === 'https' ? 443 : 80;
	    };
	    BrowserLocationConfig.prototype.protocol = function () {
	        return location.protocol.replace(/:/g, '');
	    };
	    BrowserLocationConfig.prototype.host = function () {
	        return location.hostname;
	    };
	    BrowserLocationConfig.prototype.html5Mode = function () {
	        return this._isHtml5;
	    };
	    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
	        return predicates_1.isDefined(newprefix) ? (this._hashPrefix = newprefix) : this._hashPrefix;
	    };
	    BrowserLocationConfig.prototype.baseHref = function (href) {
	        if (predicates_1.isDefined(href))
	            this._baseHref = href;
	        if (predicates_1.isUndefined(this._baseHref))
	            this._baseHref = this.getBaseHref();
	        return this._baseHref;
	    };
	    BrowserLocationConfig.prototype.getBaseHref = function () {
	        var baseTag = document.getElementsByTagName('base')[0];
	        if (baseTag && baseTag.href) {
	            return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, '');
	        }
	        return this._isHtml5 ? '/' : location.pathname || '/';
	    };
	    BrowserLocationConfig.prototype.dispose = function () { };
	    return BrowserLocationConfig;
	}());
	exports.BrowserLocationConfig = BrowserLocationConfig;
	//# sourceMappingURL=browserLocationConfig.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HashLocationService = void 0;
	var common_1 = __webpack_require__(4);
	var baseLocationService_1 = __webpack_require__(25);
	/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
	var HashLocationService = /** @class */ (function (_super) {
	    __extends(HashLocationService, _super);
	    function HashLocationService(router) {
	        var _this = _super.call(this, router, false) || this;
	        common_1.root.addEventListener('hashchange', _this._listener, false);
	        return _this;
	    }
	    HashLocationService.prototype._get = function () {
	        return common_1.trimHashVal(this._location.hash);
	    };
	    HashLocationService.prototype._set = function (state, title, url, replace) {
	        this._location.hash = url;
	    };
	    HashLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('hashchange', this._listener);
	    };
	    return HashLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.HashLocationService = HashLocationService;
	//# sourceMappingURL=hashLocationService.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$injector = void 0;
	var index_1 = __webpack_require__(4);
	// globally available injectables
	var globals = {};
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
	var ARGUMENT_NAMES = /([^\s,]+)/g;
	/**
	 * A basic angular1-like injector api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This object provides a naive implementation of a globally scoped dependency injection system.
	 * It supports the following DI approaches:
	 *
	 * ### Function parameter names
	 *
	 * A function's `.toString()` is called, and the parameter names are parsed.
	 * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
	 *
	 * ```js
	 * function injectedFunction(FooService, BarService) {
	 *   // FooService and BarService are injected
	 * }
	 * ```
	 *
	 * ### Function annotation
	 *
	 * A function may be annotated with an array of dependency names as the `$inject` property.
	 *
	 * ```js
	 * injectedFunction.$inject = [ 'FooService', 'BarService' ];
	 * function injectedFunction(fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }
	 * ```
	 *
	 * ### Array notation
	 *
	 * An array provides the names of the dependencies to inject (as strings).
	 * The function is the last element of the array.
	 *
	 * ```js
	 * [ 'FooService', 'BarService', function (fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }]
	 * ```
	 *
	 * @type {$InjectorLike}
	 */
	exports.$injector = {
	    /** Gets an object from DI based on a string token */
	    get: function (name) { return globals[name]; },
	    /** Returns true if an object named `name` exists in global DI */
	    has: function (name) { return exports.$injector.get(name) != null; },
	    /**
	     * Injects a function
	     *
	     * @param fn the function to inject
	     * @param context the function's `this` binding
	     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
	     */
	    invoke: function (fn, context, locals) {
	        var all = index_1.extend({}, globals, locals || {});
	        var params = exports.$injector.annotate(fn);
	        var ensureExist = index_1.assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
	        var args = params.filter(ensureExist).map(function (x) { return all[x]; });
	        if (index_1.isFunction(fn))
	            return fn.apply(context, args);
	        else
	            return fn.slice(-1)[0].apply(context, args);
	    },
	    /**
	     * Returns a function's dependencies
	     *
	     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
	     * @return an array of `string`s
	     */
	    annotate: function (fn) {
	        if (!index_1.isInjectable(fn))
	            throw new Error("Not an injectable function: " + fn);
	        if (fn && fn.$inject)
	            return fn.$inject;
	        if (index_1.isArray(fn))
	            return fn.slice(0, -1);
	        var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
	        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
	        return result || [];
	    },
	};
	//# sourceMappingURL=injector.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationConfig = void 0;
	var predicates_1 = __webpack_require__(2);
	var common_1 = __webpack_require__(1);
	/** A `LocationConfig` mock that gets/sets all config from an in-memory object */
	var MemoryLocationConfig = /** @class */ (function () {
	    function MemoryLocationConfig() {
	        var _this = this;
	        this.dispose = common_1.noop;
	        this._baseHref = '';
	        this._port = 80;
	        this._protocol = 'http';
	        this._host = 'localhost';
	        this._hashPrefix = '';
	        this.port = function () { return _this._port; };
	        this.protocol = function () { return _this._protocol; };
	        this.host = function () { return _this._host; };
	        this.baseHref = function () { return _this._baseHref; };
	        this.html5Mode = function () { return false; };
	        this.hashPrefix = function (newval) { return (predicates_1.isDefined(newval) ? (_this._hashPrefix = newval) : _this._hashPrefix); };
	    }
	    return MemoryLocationConfig;
	}());
	exports.MemoryLocationConfig = MemoryLocationConfig;
	//# sourceMappingURL=memoryLocationConfig.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MemoryLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(25);
	/** A `LocationServices` that gets/sets the current location from an in-memory object */
	var MemoryLocationService = /** @class */ (function (_super) {
	    __extends(MemoryLocationService, _super);
	    function MemoryLocationService(router) {
	        return _super.call(this, router, true) || this;
	    }
	    MemoryLocationService.prototype._get = function () {
	        return this._url;
	    };
	    MemoryLocationService.prototype._set = function (state, title, url, replace) {
	        this._url = url;
	    };
	    return MemoryLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.MemoryLocationService = MemoryLocationService;
	//# sourceMappingURL=memoryLocationService.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PushStateLocationService = void 0;
	var baseLocationService_1 = __webpack_require__(25);
	var common_1 = __webpack_require__(4);
	/**
	 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
	 *
	 * Uses `history.pushState` and `history.replaceState`
	 */
	var PushStateLocationService = /** @class */ (function (_super) {
	    __extends(PushStateLocationService, _super);
	    function PushStateLocationService(router) {
	        var _this = _super.call(this, router, true) || this;
	        _this._config = router.urlService.config;
	        common_1.root.addEventListener('popstate', _this._listener, false);
	        return _this;
	    }
	    /**
	     * Gets the base prefix without:
	     * - trailing slash
	     * - trailing filename
	     * - protocol and hostname
	     *
	     * If <base href='/base/'>, this returns '/base'.
	     * If <base href='/foo/base/'>, this returns '/foo/base'.
	     * If <base href='/base/index.html'>, this returns '/base'.
	     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
	     * If <base href='/base'>, this returns ''.
	     * If <base href='http://localhost:8080'>, this returns ''.
	     * If <base href='http://localhost:8080/'>, this returns ''.
	     *
	     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
	     */
	    PushStateLocationService.prototype._getBasePrefix = function () {
	        return common_1.stripLastPathElement(this._config.baseHref());
	    };
	    PushStateLocationService.prototype._get = function () {
	        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
	        search = common_1.splitQuery(search)[1]; // strip ? if found
	        hash = common_1.splitHash(hash)[1]; // strip # if found
	        var basePrefix = this._getBasePrefix();
	        var exactBaseHrefMatch = pathname === this._config.baseHref();
	        var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
	        pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
	        return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	    };
	    PushStateLocationService.prototype._set = function (state, title, url, replace) {
	        var basePrefix = this._getBasePrefix();
	        var slash = url && url[0] !== '/' ? '/' : '';
	        var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
	        if (replace) {
	            this._history.replaceState(state, title, fullUrl);
	        }
	        else {
	            this._history.pushState(state, title, fullUrl);
	        }
	    };
	    PushStateLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('popstate', this._listener);
	    };
	    return PushStateLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.PushStateLocationService = PushStateLocationService;
	//# sourceMappingURL=pushStateLocationService.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.$q = void 0;
	var index_1 = __webpack_require__(4);
	/**
	 * An angular1-like promise api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This API provides native ES6 promise support wrapped as a $q-like API.
	 * Internally, UI-Router uses this $q object to perform promise operations.
	 * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
	 *
	 * $q-like promise api
	 */
	exports.$q = {
	    /** Normalizes a value as a promise */
	    when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
	    /** Normalizes a value as a promise rejection */
	    reject: function (val) {
	        return new Promise(function (resolve, reject) {
	            reject(val);
	        });
	    },
	    /** @returns a deferred object, which has `resolve` and `reject` functions */
	    defer: function () {
	        var deferred = {};
	        deferred.promise = new Promise(function (resolve, reject) {
	            deferred.resolve = resolve;
	            deferred.reject = reject;
	        });
	        return deferred;
	    },
	    /** Like Promise.all(), but also supports object key/promise notation like $q */
	    all: function (promises) {
	        if (index_1.isArray(promises)) {
	            return Promise.all(promises);
	        }
	        if (index_1.isObject(promises)) {
	            // Convert promises map to promises array.
	            // When each promise resolves, map it to a tuple { key: key, val: val }
	            var chain = Object.keys(promises).map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
	            // Then wait for all promises to resolve, and convert them back to an object
	            return exports.$q.all(chain).then(function (values) {
	                return values.reduce(function (acc, tuple) {
	                    acc[tuple.key] = tuple.val;
	                    return acc;
	                }, {});
	            });
	        }
	    },
	};
	//# sourceMappingURL=q.js.map

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ViewService = void 0;
	var common_1 = __webpack_require__(1);
	var hof_1 = __webpack_require__(3);
	var predicates_1 = __webpack_require__(2);
	var trace_1 = __webpack_require__(8);
	/**
	 * The View service
	 *
	 * This service pairs existing `ui-view` components (which live in the DOM)
	 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
	 *
	 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
	 *   The views from exited states are deactivated via [[deactivateViewConfig]].
	 *   (See: the [[registerActivateViews]] Transition Hook)
	 *
	 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
	 *
	 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
	 * are configured with the matching [[ViewConfig]](s)
	 *
	 */
	var ViewService = /** @class */ (function () {
	    /** @internal */
	    function ViewService(/** @internal */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internal */ this._uiViews = [];
	        /** @internal */ this._viewConfigs = [];
	        /** @internal */ this._viewConfigFactories = {};
	        /** @internal */ this._listeners = [];
	        /** @internal */
	        this._pluginapi = {
	            _rootViewContext: this._rootViewContext.bind(this),
	            _viewConfigFactory: this._viewConfigFactory.bind(this),
	            _registeredUIView: function (id) { return common_1.find(_this._uiViews, function (view) { return _this.router.$id + "." + view.id === id; }); },
	            _registeredUIViews: function () { return _this._uiViews; },
	            _activeViewConfigs: function () { return _this._viewConfigs; },
	            _onSync: function (listener) {
	                _this._listeners.push(listener);
	                return function () { return common_1.removeFrom(_this._listeners, listener); };
	            },
	        };
	    }
	    /**
	     * Normalizes a view's name from a state.views configuration block.
	     *
	     * This should be used by a framework implementation to calculate the values for
	     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
	     *
	     * @param context the context object (state declaration) that the view belongs to
	     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
	     *
	     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
	     */
	    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
	        if (rawViewName === void 0) { rawViewName = ''; }
	        // TODO: Validate incoming view name with a regexp to allow:
	        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
	        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
	        var viewAtContext = rawViewName.split('@');
	        var uiViewName = viewAtContext[0] || '$default'; // default to unnamed view
	        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : '^'; // default to parent context
	        // Handle relative view-name sugar syntax.
	        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
	        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
	        if (relativeViewNameSugar) {
	            // Clobbers existing contextAnchor (rawViewName validation will fix this)
	            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
	            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
	        }
	        if (uiViewName.charAt(0) === '!') {
	            uiViewName = uiViewName.substr(1);
	            uiViewContextAnchor = ''; // target absolutely from root
	        }
	        // handle parent relative targeting "^.^.^"
	        var relativeMatch = /^(\^(?:\.\^)*)$/;
	        if (relativeMatch.exec(uiViewContextAnchor)) {
	            var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) { return anchor.parent; }, context);
	            uiViewContextAnchor = anchorState.name;
	        }
	        else if (uiViewContextAnchor === '.') {
	            uiViewContextAnchor = context.name;
	        }
	        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
	    };
	    /** @internal */
	    ViewService.prototype._rootViewContext = function (context) {
	        return (this._rootContext = context || this._rootContext);
	    };
	    /** @internal */
	    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
	        this._viewConfigFactories[viewType] = factory;
	    };
	    ViewService.prototype.createViewConfig = function (path, decl) {
	        var cfgFactory = this._viewConfigFactories[decl.$type];
	        if (!cfgFactory)
	            throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
	        var cfgs = cfgFactory(path, decl);
	        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
	    };
	    /**
	     * Deactivates a ViewConfig.
	     *
	     * This function deactivates a `ViewConfig`.
	     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
	     *
	     * @param viewConfig The ViewConfig view to deregister.
	     */
	    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('<- Removing', viewConfig);
	        common_1.removeFrom(this._viewConfigs, viewConfig);
	    };
	    ViewService.prototype.activateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('-> Registering', viewConfig);
	        this._viewConfigs.push(viewConfig);
	    };
	    ViewService.prototype.sync = function () {
	        var _this = this;
	        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
	        // Return a weighted depth value for a uiView.
	        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
	        // plus the depth of the state that is populating the uiView
	        function uiViewDepth(uiView) {
	            var stateDepth = function (context) { return (context && context.parent ? stateDepth(context.parent) + 1 : 1); };
	            return uiView.fqn.split('.').length * 10000 + stateDepth(uiView.creationContext);
	        }
	        // Return the ViewConfig's context's depth in the context tree.
	        function viewConfigDepth(config) {
	            var context = config.viewDecl.$context, count = 0;
	            while (++count && context.parent)
	                context = context.parent;
	            return count;
	        }
	        // Given a depth function, returns a compare function which can return either ascending or descending order
	        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
	        var matchingConfigPair = function (uiView) {
	            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
	            if (matchingConfigs.length > 1) {
	                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
	                // Sort by depth and return the match from the deepest child
	                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
	                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
	            }
	            return { uiView: uiView, viewConfig: matchingConfigs[0] };
	        };
	        var configureUIView = function (tuple) {
	            // If a parent ui-view is reconfigured, it could destroy child ui-views.
	            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
	            if (_this._uiViews.indexOf(tuple.uiView) !== -1)
	                tuple.uiView.configUpdated(tuple.viewConfig);
	        };
	        // Sort views by FQN and state depth. Process uiviews nearest the root first.
	        var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
	        var matchedViewConfigs = uiViewTuples.map(function (tuple) { return tuple.viewConfig; });
	        var unmatchedConfigTuples = this._viewConfigs
	            .filter(function (config) { return !common_1.inArray(matchedViewConfigs, config); })
	            .map(function (viewConfig) { return ({ uiView: undefined, viewConfig: viewConfig }); });
	        uiViewTuples.forEach(configureUIView);
	        var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
	        this._listeners.forEach(function (cb) { return cb(allTuples); });
	        trace_1.trace.traceViewSync(allTuples);
	    };
	    /**
	     * Registers a `ui-view` component
	     *
	     * When a `ui-view` component is created, it uses this method to register itself.
	     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
	     *
	     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
	     * and what the view's state context is.
	     *
	     * Note: There is no corresponding `deregisterUIView`.
	     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
	     *
	     * @param uiView The metadata for a UIView
	     * @return a de-registration function used when the view is destroyed.
	     */
	    ViewService.prototype.registerUIView = function (uiView) {
	        trace_1.trace.traceViewServiceUIViewEvent('-> Registering', uiView);
	        var uiViews = this._uiViews;
	        var fqnAndTypeMatches = function (uiv) { return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type; };
	        if (uiViews.filter(fqnAndTypeMatches).length)
	            trace_1.trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
	        uiViews.push(uiView);
	        this.sync();
	        return function () {
	            var idx = uiViews.indexOf(uiView);
	            if (idx === -1) {
	                trace_1.trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
	                return;
	            }
	            trace_1.trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
	            common_1.removeFrom(uiViews)(uiView);
	        };
	    };
	    /**
	     * Returns the list of views currently available on the page, by fully-qualified name.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.available = function () {
	        return this._uiViews.map(hof_1.prop('fqn'));
	    };
	    /**
	     * Returns the list of views on the page containing loaded content.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.active = function () {
	        return this._uiViews.filter(hof_1.prop('$config')).map(hof_1.prop('name'));
	    };
	    /**
	     * Given a ui-view and a ViewConfig, determines if they "match".
	     *
	     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
	     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
	     *
	     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
	     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
	     *
	     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
	     *
	     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
	     * - the ui-view's name matches the ViewConfig's target name
	     * - the ui-view's context matches the ViewConfig's anchor
	     *
	     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
	     * - There exists a parent ui-view where:
	     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
	     *    - the parent ui-view's context matches the ViewConfig's anchor
	     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
	     *
	     * Example:
	     *
	     * DOM:
	     * <ui-view>                        <!-- created in the root context (name: "") -->
	     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
	     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
	     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
	     *       </ui-view>
	     *     </ui-view>
	     *   </ui-view>
	     * </ui-view>
	     *
	     * uiViews: [
	     *  { fqn: "$default",                  creationContext: { name: "" } },
	     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
	     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
	     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
	     * ]
	     *
	     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
	     *
	     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
	     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
	     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
	     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
	     *
	     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
	     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
	     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
	     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
	     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
	     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
	     *   the tail of the ui-view's fqn "default.bar"
	     *
	     * @internal
	     */
	    ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
	        // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
	        if (uiView.$type !== viewConfig.viewDecl.$type)
	            return false;
	        // Split names apart from both viewConfig and uiView into segments
	        var vc = viewConfig.viewDecl;
	        var vcSegments = vc.$uiViewName.split('.');
	        var uivSegments = uiView.fqn.split('.');
	        // Check if the tails of the segment arrays match. ex, these arrays' tails match:
	        // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
	        if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
	            return false;
	        // Now check if the fqn ending at the first segment of the viewConfig matches the context:
	        // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
	        var negOffset = 1 - vcSegments.length || undefined;
	        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
	        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
	        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
	    }; };
	    return ViewService;
	}());
	exports.ViewService = ViewService;
	//# sourceMappingURL=view.js.map

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	* angular-formly JavaScript Library v8.4.1
	*
	* @license MIT (http://license.angular-formly.com)
	*
	* built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us>
	* (ó ì_í)=óò=(ì_í ò)
	*/
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(9), __webpack_require__(78));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "api-check"], factory);
		else if(typeof exports === 'object')
			exports["ngFormly"] = factory(require("angular"), require("api-check"));
		else
			root["ngFormly"] = factory(root["angular"], root["apiCheck"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _indexCommon = __webpack_require__(1);
	
		var _indexCommon2 = _interopRequireDefault(_indexCommon);
	
		exports['default'] = _indexCommon2['default'];
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _providersFormlyApiCheck = __webpack_require__(4);
	
		var _providersFormlyApiCheck2 = _interopRequireDefault(_providersFormlyApiCheck);
	
		var _otherDocsBaseUrl = __webpack_require__(6);
	
		var _otherDocsBaseUrl2 = _interopRequireDefault(_otherDocsBaseUrl);
	
		var _providersFormlyUsability = __webpack_require__(7);
	
		var _providersFormlyUsability2 = _interopRequireDefault(_providersFormlyUsability);
	
		var _providersFormlyConfig = __webpack_require__(8);
	
		var _providersFormlyConfig2 = _interopRequireDefault(_providersFormlyConfig);
	
		var _providersFormlyValidationMessages = __webpack_require__(10);
	
		var _providersFormlyValidationMessages2 = _interopRequireDefault(_providersFormlyValidationMessages);
	
		var _servicesFormlyUtil = __webpack_require__(11);
	
		var _servicesFormlyUtil2 = _interopRequireDefault(_servicesFormlyUtil);
	
		var _servicesFormlyWarn = __webpack_require__(12);
	
		var _servicesFormlyWarn2 = _interopRequireDefault(_servicesFormlyWarn);
	
		var _directivesFormlyCustomValidation = __webpack_require__(13);
	
		var _directivesFormlyCustomValidation2 = _interopRequireDefault(_directivesFormlyCustomValidation);
	
		var _directivesFormlyField = __webpack_require__(14);
	
		var _directivesFormlyField2 = _interopRequireDefault(_directivesFormlyField);
	
		var _directivesFormlyFocus = __webpack_require__(15);
	
		var _directivesFormlyFocus2 = _interopRequireDefault(_directivesFormlyFocus);
	
		var _directivesFormlyForm = __webpack_require__(16);
	
		var _directivesFormlyForm2 = _interopRequireDefault(_directivesFormlyForm);
	
		var _directivesFormlyFormController = __webpack_require__(17);
	
		var _directivesFormlyFormController2 = _interopRequireDefault(_directivesFormlyFormController);
	
		var _runFormlyNgModelAttrsManipulator = __webpack_require__(18);
	
		var _runFormlyNgModelAttrsManipulator2 = _interopRequireDefault(_runFormlyNgModelAttrsManipulator);
	
		var _runFormlyCustomTags = __webpack_require__(19);
	
		var _runFormlyCustomTags2 = _interopRequireDefault(_runFormlyCustomTags);
	
		var ngModuleName = 'formly';
	
		exports['default'] = ngModuleName;
	
		var ngModule = _angularFix2['default'].module(ngModuleName, []);
	
		ngModule.constant('formlyApiCheck', _providersFormlyApiCheck2['default']);
		ngModule.constant('formlyErrorAndWarningsUrlPrefix', _otherDocsBaseUrl2['default']);
		ngModule.constant('formlyVersion', ("8.4.1")); // <-- webpack variable
	
		ngModule.provider('formlyUsability', _providersFormlyUsability2['default']);
		ngModule.provider('formlyConfig', _providersFormlyConfig2['default']);
	
		ngModule.factory('formlyValidationMessages', _providersFormlyValidationMessages2['default']);
		ngModule.factory('formlyUtil', _servicesFormlyUtil2['default']);
		ngModule.factory('formlyWarn', _servicesFormlyWarn2['default']);
	
		ngModule.directive('formlyCustomValidation', _directivesFormlyCustomValidation2['default']);
		ngModule.directive('formlyField', _directivesFormlyField2['default']);
		ngModule.directive('formlyFocus', _directivesFormlyFocus2['default']);
		ngModule.directive('formlyForm', _directivesFormlyForm2['default']);
		ngModule.controller('FormlyFormController', _directivesFormlyFormController2['default']);
	
		ngModule.run(_runFormlyNgModelAttrsManipulator2['default']);
		ngModule.run(_runFormlyCustomTags2['default']);
		module.exports = exports['default'];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// some versions of angular don't export the angular module properly,
		// so we get it from window in this case.
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var angular = __webpack_require__(3);
	
		/* istanbul ignore next */
		if (!angular.version) {
		  angular = window.angular;
		}
		exports['default'] = angular;
		module.exports = exports['default'];
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _apiCheck = __webpack_require__(5);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		var apiCheck = (0, _apiCheck2['default'])({
		  output: {
		    prefix: 'angular-formly:',
		    docsBaseUrl: __webpack_require__(6)
		  }
		});
	
		function shapeRequiredIfNot(otherProps, propChecker) {
		  if (!_angularFix2['default'].isArray(otherProps)) {
		    otherProps = [otherProps];
		  }
		  var type = 'specified if these are not specified: `' + otherProps.join(', ') + '` (otherwise it\'s optional)';
	
		  function shapeRequiredIfNotDefinition(prop, propName, location, obj) {
		    var propExists = obj && obj.hasOwnProperty(propName);
		    var otherPropsExist = otherProps.some(function (otherProp) {
		      return obj && obj.hasOwnProperty(otherProp);
		    });
		    if (!otherPropsExist && !propExists) {
		      return apiCheck.utils.getError(propName, location, type);
		    } else if (propExists) {
		      return propChecker(prop, propName, location, obj);
		    }
		  }
	
		  shapeRequiredIfNotDefinition.type = type;
		  return apiCheck.utils.checkerHelpers.setupChecker(shapeRequiredIfNotDefinition);
		}
	
		var formlyExpression = apiCheck.oneOfType([apiCheck.string, apiCheck.func]);
		var specifyWrapperType = apiCheck.typeOrArrayOf(apiCheck.string).nullable;
	
		var apiCheckProperty = apiCheck.func;
	
		var apiCheckInstanceProperty = apiCheck.shape.onlyIf('apiCheck', apiCheck.func.withProperties({
		  warn: apiCheck.func,
		  'throw': apiCheck.func,
		  shape: apiCheck.func
		}));
	
		var apiCheckFunctionProperty = apiCheck.shape.onlyIf('apiCheck', apiCheck.oneOf(['throw', 'warn']));
	
		var formlyWrapperType = apiCheck.shape({
		  name: shapeRequiredIfNot('types', apiCheck.string).optional,
		  template: apiCheck.shape.ifNot('templateUrl', apiCheck.string).optional,
		  templateUrl: apiCheck.shape.ifNot('template', apiCheck.string).optional,
		  types: apiCheck.typeOrArrayOf(apiCheck.string).optional,
		  overwriteOk: apiCheck.bool.optional,
		  apiCheck: apiCheckProperty.optional,
		  apiCheckInstance: apiCheckInstanceProperty.optional,
		  apiCheckFunction: apiCheckFunctionProperty.optional,
		  apiCheckOptions: apiCheck.object.optional
		}).strict;
	
		var expressionProperties = apiCheck.objectOf(apiCheck.oneOfType([formlyExpression, apiCheck.shape({
		  expression: formlyExpression,
		  message: formlyExpression.optional
		}).strict]));
	
		var modelChecker = apiCheck.oneOfType([apiCheck.string, apiCheck.object]);
	
		var templateManipulators = apiCheck.shape({
		  preWrapper: apiCheck.arrayOf(apiCheck.func).nullable.optional,
		  postWrapper: apiCheck.arrayOf(apiCheck.func).nullable.optional
		}).strict.nullable;
	
		var validatorChecker = apiCheck.objectOf(apiCheck.oneOfType([formlyExpression, apiCheck.shape({
		  expression: formlyExpression,
		  message: formlyExpression.optional
		}).strict]));
	
		var watcherChecker = apiCheck.typeOrArrayOf(apiCheck.shape({
		  expression: formlyExpression.optional,
		  listener: formlyExpression.optional,
		  runFieldExpressions: apiCheck.bool.optional
		}));
	
		var fieldOptionsApiShape = {
		  $$hashKey: apiCheck.any.optional,
		  type: apiCheck.shape.ifNot(['template', 'templateUrl'], apiCheck.string).optional,
		  template: apiCheck.shape.ifNot(['type', 'templateUrl'], apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  templateUrl: apiCheck.shape.ifNot(['type', 'template'], apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  key: apiCheck.oneOfType([apiCheck.string, apiCheck.number]).optional,
		  model: modelChecker.optional,
		  originalModel: modelChecker.optional,
		  className: apiCheck.string.optional,
		  id: apiCheck.string.optional,
		  name: apiCheck.string.optional,
		  expressionProperties: expressionProperties.optional,
		  extras: apiCheck.shape({
		    validateOnModelChange: apiCheck.bool.optional,
		    skipNgModelAttrsManipulator: apiCheck.oneOfType([apiCheck.string, apiCheck.bool]).optional
		  }).strict.optional,
		  data: apiCheck.object.optional,
		  templateOptions: apiCheck.object.optional,
		  wrapper: specifyWrapperType.optional,
		  modelOptions: apiCheck.shape({
		    updateOn: apiCheck.string.optional,
		    debounce: apiCheck.oneOfType([apiCheck.objectOf(apiCheck.number), apiCheck.number]).optional,
		    allowInvalid: apiCheck.bool.optional,
		    getterSetter: apiCheck.bool.optional,
		    timezone: apiCheck.string.optional
		  }).optional,
		  watcher: watcherChecker.optional,
		  validators: validatorChecker.optional,
		  asyncValidators: validatorChecker.optional,
		  parsers: apiCheck.arrayOf(formlyExpression).optional,
		  formatters: apiCheck.arrayOf(formlyExpression).optional,
		  noFormControl: apiCheck.bool.optional,
		  hide: apiCheck.bool.optional,
		  hideExpression: formlyExpression.optional,
		  ngModelElAttrs: apiCheck.objectOf(apiCheck.string).optional,
		  ngModelAttrs: apiCheck.objectOf(apiCheck.shape({
		    statement: apiCheck.shape.ifNot(['value', 'attribute', 'bound', 'boolean'], apiCheck.any).optional,
		    value: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    attribute: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    bound: apiCheck.shape.ifNot('statement', apiCheck.any).optional,
		    boolean: apiCheck.shape.ifNot('statement', apiCheck.any).optional
		  }).strict).optional,
		  elementAttributes: apiCheck.objectOf(apiCheck.string).optional,
		  optionsTypes: apiCheck.typeOrArrayOf(apiCheck.string).optional,
		  link: apiCheck.func.optional,
		  controller: apiCheck.oneOfType([apiCheck.string, apiCheck.func, apiCheck.array]).optional,
		  validation: apiCheck.shape({
		    show: apiCheck.bool.nullable.optional,
		    messages: apiCheck.objectOf(formlyExpression).optional,
		    errorExistsAndShouldBeVisible: apiCheck.bool.optional
		  }).optional,
		  formControl: apiCheck.typeOrArrayOf(apiCheck.object).optional,
		  value: apiCheck.func.optional,
		  runExpressions: apiCheck.func.optional,
		  templateManipulators: templateManipulators.optional,
		  resetModel: apiCheck.func.optional,
		  updateInitialValue: apiCheck.func.optional,
		  initialValue: apiCheck.any.optional,
		  defaultValue: apiCheck.any.optional
		};
	
		var formlyFieldOptions = apiCheck.shape(fieldOptionsApiShape).strict;
	
		var formOptionsApi = apiCheck.shape({
		  formState: apiCheck.object.optional,
		  resetModel: apiCheck.func.optional,
		  updateInitialValue: apiCheck.func.optional,
		  removeChromeAutoComplete: apiCheck.bool.optional,
		  parseKeyArrays: apiCheck.bool.optional,
		  templateManipulators: templateManipulators.optional,
		  manualModelWatcher: apiCheck.oneOfType([apiCheck.bool, apiCheck.func]).optional,
		  watchAllExpressions: apiCheck.bool.optional,
		  wrapper: specifyWrapperType.optional,
		  fieldTransform: apiCheck.oneOfType([apiCheck.func, apiCheck.array]).optional,
		  data: apiCheck.object.optional
		}).strict;
	
		var fieldGroup = apiCheck.shape({
		  $$hashKey: apiCheck.any.optional,
		  key: apiCheck.oneOfType([apiCheck.string, apiCheck.number]).optional,
		  // danger. Nested field groups wont get api-checked...
		  fieldGroup: apiCheck.arrayOf(apiCheck.oneOfType([formlyFieldOptions, apiCheck.object])),
		  className: apiCheck.string.optional,
		  options: formOptionsApi.optional,
		  templateOptions: apiCheck.object.optional,
		  wrapper: specifyWrapperType.optional,
		  watcher: watcherChecker.optional,
		  hide: apiCheck.bool.optional,
		  hideExpression: formlyExpression.optional,
		  data: apiCheck.object.optional,
		  model: modelChecker.optional,
		  form: apiCheck.object.optional,
		  elementAttributes: apiCheck.objectOf(apiCheck.string).optional
		}).strict;
	
		var typeOptionsDefaultOptions = _angularFix2['default'].copy(fieldOptionsApiShape);
		typeOptionsDefaultOptions.key = apiCheck.string.optional;
	
		var formlyTypeOptions = apiCheck.shape({
		  name: apiCheck.string,
		  template: apiCheck.shape.ifNot('templateUrl', apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  templateUrl: apiCheck.shape.ifNot('template', apiCheck.oneOfType([apiCheck.string, apiCheck.func])).optional,
		  controller: apiCheck.oneOfType([apiCheck.func, apiCheck.string, apiCheck.array]).optional,
		  link: apiCheck.func.optional,
		  defaultOptions: apiCheck.oneOfType([apiCheck.func, apiCheck.shape(typeOptionsDefaultOptions)]).optional,
		  'extends': apiCheck.string.optional,
		  wrapper: specifyWrapperType.optional,
		  data: apiCheck.object.optional,
		  apiCheck: apiCheckProperty.optional,
		  apiCheckInstance: apiCheckInstanceProperty.optional,
		  apiCheckFunction: apiCheckFunctionProperty.optional,
		  apiCheckOptions: apiCheck.object.optional,
		  overwriteOk: apiCheck.bool.optional
		}).strict;
	
		_angularFix2['default'].extend(apiCheck, {
		  formlyTypeOptions: formlyTypeOptions, formlyFieldOptions: formlyFieldOptions, formlyExpression: formlyExpression, formlyWrapperType: formlyWrapperType, fieldGroup: fieldGroup, formOptionsApi: formOptionsApi
		});
	
		exports['default'] = apiCheck;
		module.exports = exports['default'];
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports["default"] = "https://github.com/formly-js/angular-formly/blob/" + ("8.4.1") + "/other/ERRORS_AND_WARNINGS.md#";
		module.exports = exports["default"];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyUsability.$inject = ["formlyApiCheck", "formlyErrorAndWarningsUrlPrefix"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyUsability;
	
		// @ngInject
		function formlyUsability(formlyApiCheck, formlyErrorAndWarningsUrlPrefix) {
		  var _this = this;
	
		  _angularFix2['default'].extend(this, {
		    getFormlyError: getFormlyError,
		    getFieldError: getFieldError,
		    checkWrapper: checkWrapper,
		    checkWrapperTemplate: checkWrapperTemplate,
		    getErrorMessage: getErrorMessage,
		    $get: function $get() {
		      return _this;
		    }
		  });
	
		  function getFieldError(errorInfoSlug, message, field) {
		    if (arguments.length < 3) {
		      field = message;
		      message = errorInfoSlug;
		      errorInfoSlug = null;
		    }
		    return new Error(getErrorMessage(errorInfoSlug, message) + (' Field definition: ' + _angularFix2['default'].toJson(field)));
		  }
	
		  function getFormlyError(errorInfoSlug, message) {
		    if (!message) {
		      message = errorInfoSlug;
		      errorInfoSlug = null;
		    }
		    return new Error(getErrorMessage(errorInfoSlug, message));
		  }
	
		  function getErrorMessage(errorInfoSlug, message) {
		    var url = '';
		    if (errorInfoSlug !== null) {
		      url = '' + formlyErrorAndWarningsUrlPrefix + errorInfoSlug;
		    }
		    return 'Formly Error: ' + message + '. ' + url;
		  }
	
		  function checkWrapper(wrapper) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyWrapperType, wrapper, {
		      prefix: 'formlyConfig.setWrapper',
		      urlSuffix: 'setwrapper-validation-failed'
		    });
		  }
	
		  function checkWrapperTemplate(template, additionalInfo) {
		    var formlyTransclude = '<formly-transclude></formly-transclude>';
		    if (template.indexOf(formlyTransclude) === -1) {
		      throw getFormlyError('Template wrapper templates must use "' + formlyTransclude + '" somewhere in them. ' + ('This one does not have "<formly-transclude></formly-transclude>" in it: ' + template) + '\n' + ('Additional information: ' + JSON.stringify(additionalInfo)));
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyConfig.$inject = ["formlyUsabilityProvider", "formlyErrorAndWarningsUrlPrefix", "formlyApiCheck"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _otherUtils = __webpack_require__(9);
	
		var _otherUtils2 = _interopRequireDefault(_otherUtils);
	
		exports['default'] = formlyConfig;
	
		// @ngInject
		function formlyConfig(formlyUsabilityProvider, formlyErrorAndWarningsUrlPrefix, formlyApiCheck) {
		  var _this2 = this;
	
		  var typeMap = {};
		  var templateWrappersMap = {};
		  var defaultWrapperName = 'default';
		  var _this = this;
		  var getError = formlyUsabilityProvider.getFormlyError;
	
		  _angularFix2['default'].extend(this, {
		    setType: setType,
		    getType: getType,
		    getTypes: getTypes,
		    getTypeHeritage: getTypeHeritage,
		    setWrapper: setWrapper,
		    getWrapper: getWrapper,
		    getWrapperByType: getWrapperByType,
		    removeWrapperByName: removeWrapperByName,
		    removeWrappersForType: removeWrappersForType,
		    disableWarnings: false,
		    extras: {
		      disableNgModelAttrsManipulator: false,
		      fieldTransform: [],
		      ngModelAttrsManipulatorPreferUnbound: false,
		      removeChromeAutoComplete: false,
		      parseKeyArrays: false,
		      defaultHideDirective: 'ng-if',
		      getFieldId: null
		    },
		    templateManipulators: {
		      preWrapper: [],
		      postWrapper: []
		    },
		    $get: function $get() {
		      return _this2;
		    }
		  });
	
		  function setType(options) {
		    if (_angularFix2['default'].isArray(options)) {
		      var _ret = (function () {
		        var allTypes = [];
		        _angularFix2['default'].forEach(options, function (item) {
		          allTypes.push(setType(item));
		        });
		        return {
		          v: allTypes
		        };
		      })();
	
		      if (typeof _ret === 'object') return _ret.v;
		    } else if (_angularFix2['default'].isObject(options)) {
		      checkType(options);
		      if (options['extends']) {
		        extendTypeOptions(options);
		      }
		      typeMap[options.name] = options;
		      return typeMap[options.name];
		    } else {
		      throw getError('You must provide an object or array for setType. You provided: ' + JSON.stringify(arguments));
		    }
		  }
	
		  function checkType(options) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyTypeOptions, options, {
		      prefix: 'formlyConfig.setType',
		      url: 'settype-validation-failed'
		    });
		    if (!options.overwriteOk) {
		      checkOverwrite(options.name, typeMap, options, 'types');
		    } else {
		      options.overwriteOk = undefined;
		    }
		  }
	
		  function extendTypeOptions(options) {
		    var extendsType = getType(options['extends'], true, options);
		    extendTypeControllerFunction(options, extendsType);
		    extendTypeLinkFunction(options, extendsType);
		    extendTypeDefaultOptions(options, extendsType);
		    _otherUtils2['default'].reverseDeepMerge(options, extendsType);
		    extendTemplate(options, extendsType);
		  }
	
		  function extendTemplate(options, extendsType) {
		    if (options.template && extendsType.templateUrl) {
		      delete options.templateUrl;
		    } else if (options.templateUrl && extendsType.template) {
		      delete options.template;
		    }
		  }
	
		  function extendTypeControllerFunction(options, extendsType) {
		    var extendsCtrl = extendsType.controller;
		    if (!_angularFix2['default'].isDefined(extendsCtrl)) {
		      return;
		    }
		    var optionsCtrl = options.controller;
		    if (_angularFix2['default'].isDefined(optionsCtrl)) {
		      options.controller = function ($scope, $controller) {
		        $controller(extendsCtrl, { $scope: $scope });
		        $controller(optionsCtrl, { $scope: $scope });
		      };
		      options.controller.$inject = ['$scope', '$controller'];
		    } else {
		      options.controller = extendsCtrl;
		    }
		  }
	
		  function extendTypeLinkFunction(options, extendsType) {
		    var extendsFn = extendsType.link;
		    if (!_angularFix2['default'].isDefined(extendsFn)) {
		      return;
		    }
		    var optionsFn = options.link;
		    if (_angularFix2['default'].isDefined(optionsFn)) {
		      options.link = function () {
		        extendsFn.apply(undefined, arguments);
		        optionsFn.apply(undefined, arguments);
		      };
		    } else {
		      options.link = extendsFn;
		    }
		  }
	
		  function extendTypeDefaultOptions(options, extendsType) {
		    var extendsDO = extendsType.defaultOptions;
		    if (!_angularFix2['default'].isDefined(extendsDO)) {
		      return;
		    }
		    var optionsDO = options.defaultOptions || {};
		    var optionsDOIsFn = _angularFix2['default'].isFunction(optionsDO);
		    var extendsDOIsFn = _angularFix2['default'].isFunction(extendsDO);
		    if (extendsDOIsFn) {
		      options.defaultOptions = function defaultOptions(opts, scope) {
		        var extendsDefaultOptions = extendsDO(opts, scope);
		        var mergedDefaultOptions = {};
		        _otherUtils2['default'].reverseDeepMerge(mergedDefaultOptions, opts, extendsDefaultOptions);
		        var extenderOptionsDefaultOptions = optionsDO;
		        if (optionsDOIsFn) {
		          extenderOptionsDefaultOptions = extenderOptionsDefaultOptions(mergedDefaultOptions, scope);
		        }
		        _otherUtils2['default'].reverseDeepMerge(extenderOptionsDefaultOptions, extendsDefaultOptions);
		        return extenderOptionsDefaultOptions;
		      };
		    } else if (optionsDOIsFn) {
		      options.defaultOptions = function defaultOptions(opts, scope) {
		        var newDefaultOptions = {};
		        _otherUtils2['default'].reverseDeepMerge(newDefaultOptions, opts, extendsDO);
		        return optionsDO(newDefaultOptions, scope);
		      };
		    }
		  }
	
		  function getType(name, throwError, errorContext) {
		    if (!name) {
		      return undefined;
		    }
		    var type = typeMap[name];
		    if (!type && throwError === true) {
		      throw getError('There is no type by the name of "' + name + '": ' + JSON.stringify(errorContext));
		    } else {
		      return type;
		    }
		  }
	
		  function getTypes() {
		    return typeMap;
		  }
	
		  function getTypeHeritage(parent) {
		    var heritage = [];
		    var type = parent;
		    if (_angularFix2['default'].isString(type)) {
		      type = getType(parent);
		    }
		    parent = type['extends'];
		    while (parent) {
		      type = getType(parent);
		      heritage.push(type);
		      parent = type['extends'];
		    }
		    return heritage;
		  }
	
		  function setWrapper(_x, _x2) {
		    var _again = true;
	
		    _function: while (_again) {
		      var options = _x,
		          name = _x2;
		      _again = false;
	
		      if (_angularFix2['default'].isArray(options)) {
		        return options.map(function (wrapperOptions) {
		          return setWrapper(wrapperOptions);
		        });
		      } else if (_angularFix2['default'].isObject(options)) {
		        options.types = getOptionsTypes(options);
		        options.name = getOptionsName(options, name);
		        checkWrapperAPI(options);
		        templateWrappersMap[options.name] = options;
		        return options;
		      } else if (_angularFix2['default'].isString(options)) {
		        _x = {
		          template: options,
		          name: name
		        };
		        _x2 = undefined;
		        _again = true;
		        continue _function;
		      }
		    }
		  }
	
		  function getOptionsTypes(options) {
		    if (_angularFix2['default'].isString(options.types)) {
		      return [options.types];
		    }
		    if (!_angularFix2['default'].isDefined(options.types)) {
		      return [];
		    } else {
		      return options.types;
		    }
		  }
	
		  function getOptionsName(options, name) {
		    return options.name || name || options.types.join(' ') || defaultWrapperName;
		  }
	
		  function checkWrapperAPI(options) {
		    formlyUsabilityProvider.checkWrapper(options);
		    if (options.template) {
		      formlyUsabilityProvider.checkWrapperTemplate(options.template, options);
		    }
		    if (!options.overwriteOk) {
		      checkOverwrite(options.name, templateWrappersMap, options, 'templateWrappers');
		    } else {
		      delete options.overwriteOk;
		    }
		    checkWrapperTypes(options);
		  }
	
		  function checkWrapperTypes(options) {
		    var shouldThrow = !_angularFix2['default'].isArray(options.types) || !options.types.every(_angularFix2['default'].isString);
		    if (shouldThrow) {
		      throw getError('Attempted to create a template wrapper with types that is not a string or an array of strings');
		    }
		  }
	
		  function checkOverwrite(property, object, newValue, objectName) {
		    if (object.hasOwnProperty(property)) {
		      warn('overwriting-types-or-wrappers', ['Attempting to overwrite ' + property + ' on ' + objectName + ' which is currently', JSON.stringify(object[property]) + ' with ' + JSON.stringify(newValue), 'To supress this warning, specify the property "overwriteOk: true"'].join(' '));
		    }
		  }
	
		  function getWrapper(name) {
		    return templateWrappersMap[name || defaultWrapperName];
		  }
	
		  function getWrapperByType(type) {
		    /* eslint prefer-const:0 */
		    var wrappers = [];
		    for (var _name in templateWrappersMap) {
		      if (templateWrappersMap.hasOwnProperty(_name)) {
		        if (templateWrappersMap[_name].types && templateWrappersMap[_name].types.indexOf(type) !== -1) {
		          wrappers.push(templateWrappersMap[_name]);
		        }
		      }
		    }
		    return wrappers;
		  }
	
		  function removeWrapperByName(name) {
		    var wrapper = templateWrappersMap[name];
		    delete templateWrappersMap[name];
		    return wrapper;
		  }
	
		  function removeWrappersForType(type) {
		    var wrappers = getWrapperByType(type);
		    if (!wrappers) {
		      return undefined;
		    }
		    if (!_angularFix2['default'].isArray(wrappers)) {
		      return removeWrapperByName(wrappers.name);
		    } else {
		      wrappers.forEach(function (wrapper) {
		        return removeWrapperByName(wrapper.name);
		      });
		      return wrappers;
		    }
		  }
	
		  function warn() {
		    if (!_this.disableWarnings && console.warn) {
		      /* eslint no-console:0 */
		      var args = Array.prototype.slice.call(arguments);
		      var warnInfoSlug = args.shift();
		      args.unshift('Formly Warning:');
		      args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
		      console.warn.apply(console, _toConsumableArray(args));
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = {
		  containsSelector: containsSelector, containsSpecialChar: containsSpecialChar, formlyEval: formlyEval, getFieldId: getFieldId, reverseDeepMerge: reverseDeepMerge, findByNodeName: findByNodeName,
		  arrayify: arrayify, extendFunction: extendFunction, extendArray: extendArray, startsWith: startsWith, contains: contains
		};
	
		function containsSelector(string) {
		  return containsSpecialChar(string, '.') || containsSpecialChar(string, '[') && containsSpecialChar(string, ']');
		}
	
		function containsSpecialChar(a, b) {
		  if (!a || !a.indexOf) {
		    return false;
		  }
		  return a.indexOf(b) !== -1;
		}
	
		function formlyEval(scope, expression, $modelValue, $viewValue, extraLocals) {
		  if (_angularFix2['default'].isFunction(expression)) {
		    return expression($viewValue, $modelValue, scope, extraLocals);
		  } else {
		    return scope.$eval(expression, _angularFix2['default'].extend({ $viewValue: $viewValue, $modelValue: $modelValue }, extraLocals));
		  }
		}
	
		function getFieldId(formId, options, index) {
		  if (options.id) {
		    return options.id;
		  }
		  var type = options.type;
		  if (!type && options.template) {
		    type = 'template';
		  } else if (!type && options.templateUrl) {
		    type = 'templateUrl';
		  }
	
		  return [formId, type, options.key, index].join('_');
		}
	
		function reverseDeepMerge(dest) {
		  _angularFix2['default'].forEach(arguments, function (src, index) {
		    if (!index) {
		      return;
		    }
		    _angularFix2['default'].forEach(src, function (val, prop) {
		      if (!_angularFix2['default'].isDefined(dest[prop])) {
		        dest[prop] = _angularFix2['default'].copy(val);
		      } else if (objAndSameType(dest[prop], val)) {
		        reverseDeepMerge(dest[prop], val);
		      }
		    });
		  });
		  return dest;
		}
	
		function objAndSameType(obj1, obj2) {
		  return _angularFix2['default'].isObject(obj1) && _angularFix2['default'].isObject(obj2) && Object.getPrototypeOf(obj1) === Object.getPrototypeOf(obj2);
		}
	
		// recurse down a node tree to find a node with matching nodeName, for custom tags jQuery.find doesn't work in IE8
		function findByNodeName(el, nodeName) {
		  if (!el.prop) {
		    // not a jQuery or jqLite object -> wrap it
		    el = _angularFix2['default'].element(el);
		  }
	
		  if (el.prop('nodeName') === nodeName.toUpperCase()) {
		    return el;
		  }
	
		  var c = el.children();
		  for (var i = 0; c && i < c.length; i++) {
		    var node = findByNodeName(c[i], nodeName);
		    if (node) {
		      return node;
		    }
		  }
		}
	
		function arrayify(obj) {
		  if (obj && !_angularFix2['default'].isArray(obj)) {
		    obj = [obj];
		  } else if (!obj) {
		    obj = [];
		  }
		  return obj;
		}
	
		function extendFunction() {
		  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
		    fns[_key] = arguments[_key];
		  }
	
		  return function extendedFunction() {
		    var args = arguments;
		    fns.forEach(function (fn) {
		      return fn.apply(null, args);
		    });
		  };
		}
	
		function extendArray(primary, secondary, property) {
		  if (property) {
		    primary = primary[property];
		    secondary = secondary[property];
		  }
		  if (secondary && primary) {
		    _angularFix2['default'].forEach(secondary, function (item) {
		      if (primary.indexOf(item) === -1) {
		        primary.push(item);
		      }
		    });
		    return primary;
		  } else if (secondary) {
		    return secondary;
		  } else {
		    return primary;
		  }
		}
	
		function startsWith(str, search) {
		  if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
		    return str.length >= search.length && str.substring(0, search.length) === search;
		  } else {
		    return false;
		  }
		}
	
		function contains(str, search) {
		  if (_angularFix2['default'].isString(str) && _angularFix2['default'].isString(search)) {
		    return str.length >= search.length && str.indexOf(search) !== -1;
		  } else {
		    return false;
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = formlyValidationMessages;
	
		// @ngInject
		function formlyValidationMessages() {
	
		  var validationMessages = {
		    addTemplateOptionValueMessage: addTemplateOptionValueMessage,
		    addStringMessage: addStringMessage,
		    messages: {}
		  };
	
		  return validationMessages;
	
		  function addTemplateOptionValueMessage(name, prop, prefix, suffix, alternate) {
		    validationMessages.messages[name] = templateOptionValue(prop, prefix, suffix, alternate);
		  }
	
		  function addStringMessage(name, string) {
		    validationMessages.messages[name] = function () {
		      return string;
		    };
		  }
	
		  function templateOptionValue(prop, prefix, suffix, alternate) {
		    return function getValidationMessage(viewValue, modelValue, scope) {
		      if (typeof scope.options.templateOptions[prop] !== 'undefined') {
		        return prefix + ' ' + scope.options.templateOptions[prop] + ' ' + suffix;
		      } else {
		        return alternate;
		      }
		    };
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _otherUtils = __webpack_require__(9);
	
		var _otherUtils2 = _interopRequireDefault(_otherUtils);
	
		exports['default'] = formlyUtil;
	
		// @ngInject
		function formlyUtil() {
		  return _otherUtils2['default'];
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		'use strict';
	
		formlyWarn.$inject = ["formlyConfig", "formlyErrorAndWarningsUrlPrefix", "$log"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		exports['default'] = formlyWarn;
	
		// @ngInject
		function formlyWarn(formlyConfig, formlyErrorAndWarningsUrlPrefix, $log) {
		  return function warn() {
		    if (!formlyConfig.disableWarnings) {
		      var args = Array.prototype.slice.call(arguments);
		      var warnInfoSlug = args.shift();
		      args.unshift('Formly Warning:');
		      args.push('' + formlyErrorAndWarningsUrlPrefix + warnInfoSlug);
		      $log.warn.apply($log, _toConsumableArray(args));
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyCustomValidation.$inject = ["formlyUtil"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyCustomValidation;
	
		// @ngInject
		function formlyCustomValidation(formlyUtil) {
		  return {
		    restrict: 'A',
		    require: 'ngModel',
		    link: function formlyCustomValidationLink(scope, el, attrs, ctrl) {
		      var opts = scope.options;
		      opts.validation.messages = opts.validation.messages || {};
		      _angularFix2['default'].forEach(opts.validation.messages, function (message, key) {
		        opts.validation.messages[key] = function () {
		          return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
		        };
		      });
	
		      var useNewValidatorsApi = ctrl.hasOwnProperty('$validators') && !attrs.hasOwnProperty('useParsers');
		      _angularFix2['default'].forEach(opts.validators, _angularFix2['default'].bind(null, addValidatorToPipeline, false));
		      _angularFix2['default'].forEach(opts.asyncValidators, _angularFix2['default'].bind(null, addValidatorToPipeline, true));
	
		      function addValidatorToPipeline(isAsync, validator, name) {
		        setupMessage(validator, name);
		        validator = _angularFix2['default'].isObject(validator) ? validator.expression : validator;
		        if (useNewValidatorsApi) {
		          setupWithValidators(validator, name, isAsync);
		        } else {
		          setupWithParsers(validator, name, isAsync);
		        }
		      }
	
		      function setupMessage(validator, name) {
		        var message = validator.message;
		        if (message) {
		          opts.validation.messages[name] = function () {
		            return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
		          };
		        }
		      }
	
		      function setupWithValidators(validator, name, isAsync) {
		        var validatorCollection = isAsync ? '$asyncValidators' : '$validators';
	
		        ctrl[validatorCollection][name] = function evalValidity(modelValue, viewValue) {
		          return formlyUtil.formlyEval(scope, validator, modelValue, viewValue);
		        };
		      }
	
		      function setupWithParsers(validator, name, isAsync) {
		        var inFlightValidator = undefined;
		        ctrl.$parsers.unshift(function evalValidityOfParser(viewValue) {
		          var isValid = formlyUtil.formlyEval(scope, validator, ctrl.$modelValue, viewValue);
		          if (isAsync) {
		            ctrl.$pending = ctrl.$pending || {};
		            ctrl.$pending[name] = true;
		            inFlightValidator = isValid;
		            isValid.then(function () {
		              if (inFlightValidator === isValid) {
		                ctrl.$setValidity(name, true);
		              }
		            })['catch'](function () {
		              if (inFlightValidator === isValid) {
		                ctrl.$setValidity(name, false);
		              }
		            })['finally'](function () {
		              var $pending = ctrl.$pending || {};
		              if (Object.keys($pending).length === 1) {
		                delete ctrl.$pending;
		              } else {
		                delete ctrl.$pending[name];
		              }
		            });
		          } else {
		            ctrl.$setValidity(name, isValid);
		          }
		          return viewValue;
		        });
		      }
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyField.$inject = ["$http", "$q", "$compile", "$templateCache", "$interpolate", "formlyConfig", "formlyApiCheck", "formlyUtil", "formlyUsability", "formlyWarn"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _apiCheck = __webpack_require__(5);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		exports['default'] = formlyField;
	
		/**
		 * @ngdoc directive
		 * @name formlyField
		 * @restrict AE
		 */
		// @ngInject
		function formlyField($http, $q, $compile, $templateCache, $interpolate, formlyConfig, formlyApiCheck, formlyUtil, formlyUsability, formlyWarn) {
		  FormlyFieldController.$inject = ["$scope", "$timeout", "$parse", "$controller", "formlyValidationMessages"];
		  var arrayify = formlyUtil.arrayify;
	
		  return {
		    restrict: 'AE',
		    transclude: true,
		    require: '?^formlyForm',
		    scope: {
		      options: '=',
		      model: '=',
		      originalModel: '=?',
		      formId: '@', // TODO remove formId in a breaking release
		      index: '=?',
		      fields: '=?',
		      formState: '=?',
		      formOptions: '=?',
		      form: '=?' },
		    // TODO require form in a breaking release
		    controller: FormlyFieldController,
		    link: fieldLink
		  };
	
		  // @ngInject
		  function FormlyFieldController($scope, $timeout, $parse, $controller, formlyValidationMessages) {
		    /* eslint max-statements:[2, 37] */
		    if ($scope.options.fieldGroup) {
		      setupFieldGroup();
		      return;
		    }
	
		    var fieldType = getFieldType($scope.options);
		    simplifyLife($scope.options);
		    mergeFieldOptionsWithTypeDefaults($scope.options, fieldType);
		    extendOptionsWithDefaults($scope.options, $scope.index);
		    checkApi($scope.options);
		    // set field id to link labels and fields
	
		    // initalization
		    setFieldIdAndName();
		    setDefaultValue();
		    setInitialValue();
		    runExpressions();
		    watchExpressions();
		    addValidationMessages($scope.options);
		    invokeControllers($scope, $scope.options, fieldType);
	
		    // function definitions
		    function runExpressions() {
		      var deferred = $q.defer();
		      // must run on next tick to make sure that the current value is correct.
		      $timeout(function runExpressionsOnNextTick() {
		        var promises = [];
		        var field = $scope.options;
		        var currentValue = valueGetterSetter();
		        _angularFix2['default'].forEach(field.expressionProperties, function runExpression(expression, prop) {
		          var setter = $parse(prop).assign;
		          var promise = $q.when(formlyUtil.formlyEval($scope, expression, currentValue, currentValue)).then(function setFieldValue(value) {
		            setter(field, value);
		          });
		          promises.push(promise);
		        });
		        $q.all(promises).then(function () {
		          deferred.resolve();
		        });
		      }, 0, false);
		      return deferred.promise;
		    }
	
		    function watchExpressions() {
		      if ($scope.formOptions.watchAllExpressions) {
		        (function () {
		          var field = $scope.options;
		          var currentValue = valueGetterSetter();
		          _angularFix2['default'].forEach(field.expressionProperties, function watchExpression(expression, prop) {
		            var setter = $parse(prop).assign;
		            $scope.$watch(function expressionPropertyWatcher() {
		              return formlyUtil.formlyEval($scope, expression, currentValue, currentValue);
		            }, function expressionPropertyListener(value) {
		              setter(field, value);
		            }, true);
		          });
		        })();
		      }
		    }
	
		    function valueGetterSetter(newVal) {
		      if (!$scope.model || !$scope.options.key) {
		        return undefined;
		      }
		      if (_angularFix2['default'].isDefined(newVal)) {
		        parseSet($scope.options.key, $scope.model, newVal);
		      }
		      return parseGet($scope.options.key, $scope.model);
		    }
	
		    function shouldNotUseParseKey(key) {
		      return _angularFix2['default'].isNumber(key) || !formlyUtil.containsSelector(key);
		    }
	
		    function keyContainsArrays(key) {
		      return (/\[\d{1,}\]/.test(key)
		      );
		    }
	
		    function deepAssign(obj, prop, value) {
		      if (_angularFix2['default'].isString(prop)) {
		        prop = prop.replace(/\[(\w+)\]/g, '.$1').split('.');
		      }
	
		      if (prop.length > 1) {
		        var e = prop.shift();
		        obj[e] = obj[e] || isNaN(prop[0]) ? {} : [];
		        deepAssign(obj[e], prop, value);
		      } else {
		        obj[prop[0]] = value;
		      }
		    }
	
		    function parseSet(key, model, newVal) {
		      // If either of these are null/undefined then just return undefined
		      if (!key && key !== 0 || !model) {
		        return;
		      }
		      // If we are working with a number then $parse wont work, default back to the old way for now
		      if (shouldNotUseParseKey(key)) {
		        // TODO: Fix this so we can get several levels instead of just one with properties that are numeric
		        model[key] = newVal;
		      } else if (formlyConfig.extras.parseKeyArrays && keyContainsArrays(key)) {
		        deepAssign($scope.model, key, newVal);
		      } else {
		        var setter = $parse($scope.options.key).assign;
		        if (setter) {
		          setter($scope.model, newVal);
		        }
		      }
		    }
	
		    function parseGet(key, model) {
		      // If either of these are null/undefined then just return undefined
		      if (!key && key !== 0 || !model) {
		        return undefined;
		      }
	
		      // If we are working with a number then $parse wont work, default back to the old way for now
		      if (shouldNotUseParseKey(key)) {
		        // TODO: Fix this so we can get several levels instead of just one with properties that are numeric
		        return model[key];
		      } else {
		        return $parse(key)(model);
		      }
		    }
	
		    function simplifyLife(options) {
		      // add a few empty objects (if they don't already exist) so you don't have to undefined check everywhere
		      formlyUtil.reverseDeepMerge(options, {
		        originalModel: options.model,
		        extras: {},
		        data: {},
		        templateOptions: {},
		        validation: {}
		      });
		      // create $scope.to so template authors can reference to instead of $scope.options.templateOptions
		      $scope.to = $scope.options.templateOptions;
		      $scope.formOptions = $scope.formOptions || {};
		    }
	
		    function setFieldIdAndName() {
		      if (_angularFix2['default'].isFunction(formlyConfig.extras.getFieldId)) {
		        $scope.id = formlyConfig.extras.getFieldId($scope.options, $scope.model, $scope);
		      } else {
		        var formName = $scope.form && $scope.form.$name || $scope.formId;
		        $scope.id = formlyUtil.getFieldId(formName, $scope.options, $scope.index);
		      }
		      $scope.options.id = $scope.id;
		      $scope.name = $scope.options.name || $scope.options.id;
		      $scope.options.name = $scope.name;
		    }
	
		    function setDefaultValue() {
		      if (_angularFix2['default'].isDefined($scope.options.defaultValue) && !_angularFix2['default'].isDefined(parseGet($scope.options.key, $scope.model))) {
		        parseSet($scope.options.key, $scope.model, $scope.options.defaultValue);
		      }
		    }
	
		    function setInitialValue() {
		      $scope.options.initialValue = $scope.model && parseGet($scope.options.key, $scope.model);
		    }
	
		    function mergeFieldOptionsWithTypeDefaults(options, type) {
		      if (type) {
		        mergeOptions(options, type.defaultOptions);
		      }
		      var properOrder = arrayify(options.optionsTypes).reverse(); // so the right things are overridden
		      _angularFix2['default'].forEach(properOrder, function (typeName) {
		        mergeOptions(options, formlyConfig.getType(typeName, true, options).defaultOptions);
		      });
		    }
	
		    function mergeOptions(options, extraOptions) {
		      if (extraOptions) {
		        if (_angularFix2['default'].isFunction(extraOptions)) {
		          extraOptions = extraOptions(options, $scope);
		        }
		        formlyUtil.reverseDeepMerge(options, extraOptions);
		      }
		    }
	
		    function extendOptionsWithDefaults(options, index) {
		      var key = options.key || index || 0;
		      _angularFix2['default'].extend(options, {
		        // attach the key in case the formly-field directive is used directly
		        key: key,
		        value: options.value || valueGetterSetter,
		        runExpressions: runExpressions,
		        resetModel: resetModel,
		        updateInitialValue: updateInitialValue
		      });
		    }
	
		    function resetModel() {
		      parseSet($scope.options.key, $scope.model, $scope.options.initialValue);
		      if ($scope.options.formControl) {
		        if (_angularFix2['default'].isArray($scope.options.formControl)) {
		          _angularFix2['default'].forEach($scope.options.formControl, function (formControl) {
		            resetFormControl(formControl, true);
		          });
		        } else {
		          resetFormControl($scope.options.formControl);
		        }
		      }
		      if ($scope.form) {
		        $scope.form.$setUntouched && $scope.form.$setUntouched();
		        $scope.form.$setPristine();
		      }
		    }
	
		    function resetFormControl(formControl, isMultiNgModel) {
		      if (!isMultiNgModel) {
		        formControl.$setViewValue(parseGet($scope.options.key, $scope.model));
		      }
	
		      formControl.$render();
		      formControl.$setUntouched && formControl.$setUntouched();
		      formControl.$setPristine();
	
		      // To prevent breaking change requiring a digest to reset $viewModel
		      if (!$scope.$root.$$phase) {
		        $scope.$digest();
		      }
		    }
	
		    function updateInitialValue() {
		      $scope.options.initialValue = parseGet($scope.options.key, $scope.model);
		    }
	
		    function addValidationMessages(options) {
		      options.validation.messages = options.validation.messages || {};
		      _angularFix2['default'].forEach(formlyValidationMessages.messages, function createFunctionForMessage(expression, name) {
		        if (!options.validation.messages[name]) {
		          options.validation.messages[name] = function evaluateMessage(viewValue, modelValue, scope) {
		            return formlyUtil.formlyEval(scope, expression, modelValue, viewValue);
		          };
		        }
		      });
		    }
	
		    function invokeControllers(scope) {
		      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
		      var type = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
		      _angularFix2['default'].forEach([type.controller, options.controller], function (controller) {
		        if (controller) {
		          $controller(controller, { $scope: scope });
		        }
		      });
		    }
	
		    function setupFieldGroup() {
		      $scope.options.options = $scope.options.options || {};
		      $scope.options.options.formState = $scope.formState;
		      $scope.to = $scope.options.templateOptions;
		    }
		  }
	
		  // link function
		  function fieldLink(scope, el, attrs, formlyFormCtrl) {
		    if (scope.options.fieldGroup) {
		      setFieldGroupTemplate();
		      return;
		    }
	
		    // watch the field model (if exists) if there is no parent formly-form directive (that would watch it instead)
		    if (!formlyFormCtrl && scope.options.model) {
		      scope.$watch('options.model', function () {
		        return scope.options.runExpressions();
		      }, true);
		    }
	
		    addAttributes();
		    addClasses();
	
		    var type = getFieldType(scope.options);
		    var args = arguments;
		    var thusly = this;
		    var fieldCount = 0;
		    var fieldManipulators = getManipulators(scope.options, scope.formOptions);
		    getFieldTemplate(scope.options).then(runManipulators(fieldManipulators.preWrapper)).then(transcludeInWrappers(scope.options, scope.formOptions)).then(runManipulators(fieldManipulators.postWrapper)).then(setElementTemplate).then(watchFormControl).then(callLinkFunctions)['catch'](function (error) {
		      formlyWarn('there-was-a-problem-setting-the-template-for-this-field', 'There was a problem setting the template for this field ', scope.options, error);
		    });
	
		    function setFieldGroupTemplate() {
		      checkFieldGroupApi(scope.options);
		      el.addClass('formly-field-group');
		      var extraAttributes = '';
		      if (scope.options.elementAttributes) {
		        extraAttributes = Object.keys(scope.options.elementAttributes).map(function (key) {
		          return key + '="' + scope.options.elementAttributes[key] + '"';
		        }).join(' ');
		      }
		      var modelValue = 'model';
		      scope.options.form = scope.form;
		      if (scope.options.key) {
		        modelValue = 'model[\'' + scope.options.key + '\']';
		      }
		      getTemplate('\n          <formly-form model="' + modelValue + '"\n                       fields="options.fieldGroup"\n                       options="options.options"\n                       form="options.form"\n                       class="' + scope.options.className + '"\n                       ' + extraAttributes + '\n                       is-field-group>\n          </formly-form>\n        ').then(transcludeInWrappers(scope.options, scope.formOptions)).then(setElementTemplate);
		    }
	
		    function addAttributes() {
		      if (scope.options.elementAttributes) {
		        el.attr(scope.options.elementAttributes);
		      }
		    }
	
		    function addClasses() {
		      if (scope.options.className) {
		        el.addClass(scope.options.className);
		      }
		      if (scope.options.type) {
		        el.addClass('formly-field-' + scope.options.type);
		      }
		    }
	
		    function setElementTemplate(templateString) {
		      el.html(asHtml(templateString));
		      $compile(el.contents())(scope);
		      return templateString;
		    }
	
		    function watchFormControl(templateString) {
		      var stopWatchingShowError = _angularFix2['default'].noop;
		      if (scope.options.noFormControl) {
		        return;
		      }
		      var templateEl = _angularFix2['default'].element('<div>' + templateString + '</div>');
		      var ngModelNodes = templateEl[0].querySelectorAll('[ng-model],[data-ng-model]');
	
		      if (ngModelNodes.length) {
		        _angularFix2['default'].forEach(ngModelNodes, function (ngModelNode) {
		          fieldCount++;
		          watchFieldNameOrExistence(ngModelNode.getAttribute('name'));
		        });
		      }
	
		      function watchFieldNameOrExistence(name) {
		        var nameExpressionRegex = /\{\{(.*?)}}/;
		        var nameExpression = nameExpressionRegex.exec(name);
		        if (nameExpression) {
		          name = $interpolate(name)(scope);
		        }
		        watchFieldExistence(name);
		      }
	
		      function watchFieldExistence(name) {
		        scope.$watch('form["' + name + '"]', function formControlChange(formControl) {
		          if (formControl) {
		            if (fieldCount > 1) {
		              if (!scope.options.formControl) {
		                scope.options.formControl = [];
		              }
		              scope.options.formControl.push(formControl);
		            } else {
		              scope.options.formControl = formControl;
		            }
		            scope.fc = scope.options.formControl; // shortcut for template authors
		            stopWatchingShowError();
		            addShowMessagesWatcher();
		            addParsers();
		            addFormatters();
		          }
		        });
		      }
	
		      function addShowMessagesWatcher() {
		        stopWatchingShowError = scope.$watch(function watchShowValidationChange() {
		          var customExpression = formlyConfig.extras.errorExistsAndShouldBeVisibleExpression;
		          var options = scope.options;
		          var formControls = arrayify(scope.fc);
		          if (!formControls.some(function (fc) {
		            return fc.$invalid;
		          })) {
		            return false;
		          } else if (typeof options.validation.show === 'boolean') {
		            return options.validation.show;
		          } else if (customExpression) {
		            return formControls.some(function (fc) {
		              return formlyUtil.formlyEval(scope, customExpression, fc.$modelValue, fc.$viewValue);
		            });
		          } else {
		            return formControls.some(function (fc) {
		              var noTouchedButDirty = _angularFix2['default'].isUndefined(fc.$touched) && fc.$dirty;
		              return fc.$touched || noTouchedButDirty;
		            });
		          }
		        }, function onShowValidationChange(show) {
		          scope.options.validation.errorExistsAndShouldBeVisible = show;
		          scope.showError = show; // shortcut for template authors
		        });
		      }
	
		      function addParsers() {
		        setParsersOrFormatters('parsers');
		      }
	
		      function addFormatters() {
		        setParsersOrFormatters('formatters');
		        var ctrl = scope.fc;
		        var formWasPristine = scope.form.$pristine;
		        if (scope.options.formatters) {
		          (function () {
		            var value = ctrl.$modelValue;
		            ctrl.$formatters.forEach(function (formatter) {
		              value = formatter(value);
		            });
	
		            ctrl.$setViewValue(value);
		            ctrl.$render();
		            ctrl.$setPristine();
		            if (formWasPristine) {
		              scope.form.$setPristine();
		            }
		          })();
		        }
		      }
	
		      function setParsersOrFormatters(which) {
		        var originalThingProp = 'originalParser';
		        if (which === 'formatters') {
		          originalThingProp = 'originalFormatter';
		        }
	
		        // init with type's parsers
		        var things = getThingsFromType(type);
	
		        // get optionsTypes things
		        things = formlyUtil.extendArray(things, getThingsFromOptionsTypes(scope.options.optionsTypes));
	
		        // get field's things
		        things = formlyUtil.extendArray(things, scope.options[which]);
	
		        // convert things into formlyExpression things
		        _angularFix2['default'].forEach(things, function (thing, index) {
		          things[index] = getFormlyExpressionThing(thing);
		        });
	
		        var ngModelCtrls = scope.fc;
		        if (!_angularFix2['default'].isArray(ngModelCtrls)) {
		          ngModelCtrls = [ngModelCtrls];
		        }
	
		        _angularFix2['default'].forEach(ngModelCtrls, function (ngModelCtrl) {
		          var _ngModelCtrl;
	
		          ngModelCtrl['$' + which] = (_ngModelCtrl = ngModelCtrl['$' + which]).concat.apply(_ngModelCtrl, _toConsumableArray(things));
		        });
	
		        function getThingsFromType(theType) {
		          if (!theType) {
		            return [];
		          }
		          if (_angularFix2['default'].isString(theType)) {
		            theType = formlyConfig.getType(theType, true, scope.options);
		          }
		          var typeThings = [];
	
		          // get things from parent
		          if (theType['extends']) {
		            typeThings = formlyUtil.extendArray(typeThings, getThingsFromType(theType['extends']));
		          }
	
		          // get own type's things
		          typeThings = formlyUtil.extendArray(typeThings, getDefaultOptionsProperty(theType, which, []));
	
		          // get things from optionsTypes
		          typeThings = formlyUtil.extendArray(typeThings, getThingsFromOptionsTypes(getDefaultOptionsOptionsTypes(theType)));
	
		          return typeThings;
		        }
	
		        function getThingsFromOptionsTypes() {
		          var optionsTypes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
		          var optionsTypesThings = [];
		          _angularFix2['default'].forEach(_angularFix2['default'].copy(arrayify(optionsTypes)).reverse(), function (optionsTypeName) {
		            optionsTypesThings = formlyUtil.extendArray(optionsTypesThings, getThingsFromType(optionsTypeName));
		          });
		          return optionsTypesThings;
		        }
	
		        function getFormlyExpressionThing(thing) {
		          formlyExpressionParserOrFormatterFunction[originalThingProp] = thing;
		          return formlyExpressionParserOrFormatterFunction;
	
		          function formlyExpressionParserOrFormatterFunction($viewValue) {
		            var $modelValue = scope.options.value();
		            return formlyUtil.formlyEval(scope, thing, $modelValue, $viewValue);
		          }
		        }
		      }
		    }
	
		    function callLinkFunctions() {
		      if (type && type.link) {
		        type.link.apply(thusly, args);
		      }
		      if (scope.options.link) {
		        scope.options.link.apply(thusly, args);
		      }
		    }
	
		    function runManipulators(manipulators) {
		      return function runManipulatorsOnTemplate(templateToManipulate) {
		        var chain = $q.when(templateToManipulate);
		        _angularFix2['default'].forEach(manipulators, function (manipulator) {
		          chain = chain.then(function (template) {
		            return $q.when(manipulator(template, scope.options, scope)).then(function (newTemplate) {
		              return _angularFix2['default'].isString(newTemplate) ? newTemplate : asHtml(newTemplate);
		            });
		          });
		        });
		        return chain;
		      };
		    }
		  }
	
		  // sort-of stateless util functions
		  function asHtml(el) {
		    var wrapper = _angularFix2['default'].element('<a></a>');
		    return wrapper.append(el).html();
		  }
	
		  function getFieldType(options) {
		    return options.type && formlyConfig.getType(options.type);
		  }
	
		  function getManipulators(options, formOptions) {
		    var preWrapper = [];
		    var postWrapper = [];
		    addManipulators(options.templateManipulators);
		    addManipulators(formOptions.templateManipulators);
		    addManipulators(formlyConfig.templateManipulators);
		    return { preWrapper: preWrapper, postWrapper: postWrapper };
	
		    function addManipulators(manipulators) {
		      /* eslint-disable */ // it doesn't understand this :-(
	
		      var _ref = manipulators || {};
	
		      var _ref$preWrapper = _ref.preWrapper;
		      var pre = _ref$preWrapper === undefined ? [] : _ref$preWrapper;
		      var _ref$postWrapper = _ref.postWrapper;
		      var post = _ref$postWrapper === undefined ? [] : _ref$postWrapper;
	
		      preWrapper = preWrapper.concat(pre);
		      postWrapper = postWrapper.concat(post);
		      /* eslint-enable */
		    }
		  }
	
		  function getFieldTemplate(options) {
		    function fromOptionsOrType(key, fieldType) {
		      if (_angularFix2['default'].isDefined(options[key])) {
		        return options[key];
		      } else if (fieldType && _angularFix2['default'].isDefined(fieldType[key])) {
		        return fieldType[key];
		      }
		    }
	
		    var type = formlyConfig.getType(options.type, true, options);
		    var template = fromOptionsOrType('template', type);
		    var templateUrl = fromOptionsOrType('templateUrl', type);
		    if (_angularFix2['default'].isUndefined(template) && !templateUrl) {
		      throw formlyUsability.getFieldError('type-type-has-no-template', 'Type \'' + options.type + '\' has no template. On element:', options);
		    }
	
		    return getTemplate(templateUrl || template, _angularFix2['default'].isUndefined(template), options);
		  }
	
		  function getTemplate(template, isUrl, options) {
		    var templatePromise = undefined;
		    if (_angularFix2['default'].isFunction(template)) {
		      templatePromise = $q.when(template(options));
		    } else {
		      templatePromise = $q.when(template);
		    }
	
		    if (!isUrl) {
		      return templatePromise;
		    } else {
		      var _ret3 = (function () {
		        var httpOptions = { cache: $templateCache };
		        return {
		          v: templatePromise.then(function (url) {
		            return $http.get(url, httpOptions);
		          }).then(function (response) {
		            return response.data;
		          })['catch'](function handleErrorGettingATemplate(error) {
		            formlyWarn('problem-loading-template-for-templateurl', 'Problem loading template for ' + template, error);
		          })
		        };
		      })();
	
		      if (typeof _ret3 === 'object') return _ret3.v;
		    }
		  }
	
		  function transcludeInWrappers(options, formOptions) {
		    var wrapper = getWrapperOption(options, formOptions);
	
		    return function transcludeTemplate(template) {
		      if (!wrapper.length) {
		        return $q.when(template);
		      }
	
		      wrapper.forEach(function (aWrapper) {
		        formlyUsability.checkWrapper(aWrapper, options);
		        runApiCheck(aWrapper, options);
		      });
		      var promises = wrapper.map(function (w) {
		        return getTemplate(w.template || w.templateUrl, !w.template);
		      });
		      return $q.all(promises).then(function (wrappersTemplates) {
		        wrappersTemplates.forEach(function (wrapperTemplate, index) {
		          formlyUsability.checkWrapperTemplate(wrapperTemplate, wrapper[index]);
		        });
		        wrappersTemplates.reverse(); // wrapper 0 is wrapped in wrapper 1 and so on...
		        var totalWrapper = wrappersTemplates.shift();
		        wrappersTemplates.forEach(function (wrapperTemplate) {
		          totalWrapper = doTransclusion(totalWrapper, wrapperTemplate);
		        });
		        return doTransclusion(totalWrapper, template);
		      });
		    };
		  }
	
		  function doTransclusion(wrapper, template) {
		    var superWrapper = _angularFix2['default'].element('<a></a>'); // this allows people not have to have a single root in wrappers
		    superWrapper.append(wrapper);
		    var transcludeEl = superWrapper.find('formly-transclude');
		    if (!transcludeEl.length) {
		      // try it using our custom find function
		      transcludeEl = formlyUtil.findByNodeName(superWrapper, 'formly-transclude');
		    }
		    transcludeEl.replaceWith(template);
		    return superWrapper.html();
		  }
	
		  function getWrapperOption(options, formOptions) {
		    /* eslint complexity:[2, 6] */
		    var wrapper = options.wrapper;
		    // explicit null means no wrapper
		    if (wrapper === null) {
		      return [];
		    }
	
		    // nothing specified means use the default wrapper for the type
		    if (!wrapper) {
		      // get all wrappers that specify they apply to this type
		      wrapper = arrayify(formlyConfig.getWrapperByType(options.type));
		    } else {
		      wrapper = arrayify(wrapper).map(formlyConfig.getWrapper);
		    }
	
		    // get all wrappers for that the type specified that it uses.
		    var type = formlyConfig.getType(options.type, true, options);
		    if (type && type.wrapper) {
		      var typeWrappers = arrayify(type.wrapper).map(formlyConfig.getWrapper);
		      wrapper = wrapper.concat(typeWrappers);
		    }
	
		    // add form wrappers
		    if (formOptions.wrapper) {
		      var formWrappers = arrayify(formOptions.wrapper).map(formlyConfig.getWrapper);
		      wrapper = wrapper.concat(formWrappers);
		    }
	
		    // add the default wrapper last
		    var defaultWrapper = formlyConfig.getWrapper();
		    if (defaultWrapper) {
		      wrapper.push(defaultWrapper);
		    }
		    return wrapper;
		  }
	
		  function checkApi(options) {
		    formlyApiCheck['throw'](formlyApiCheck.formlyFieldOptions, options, {
		      prefix: 'formly-field directive',
		      url: 'formly-field-directive-validation-failed'
		    });
		    // validate with the type
		    var type = options.type && formlyConfig.getType(options.type);
		    if (type) {
		      runApiCheck(type, options, true);
		    }
		    if (options.expressionProperties && options.expressionProperties.hide) {
		      formlyWarn('dont-use-expressionproperties.hide-use-hideexpression-instead', 'You have specified `hide` in `expressionProperties`. Use `hideExpression` instead', options);
		    }
		  }
	
		  function checkFieldGroupApi(options) {
		    formlyApiCheck['throw'](formlyApiCheck.fieldGroup, options, {
		      prefix: 'formly-field directive',
		      url: 'formly-field-directive-validation-failed'
		    });
		  }
	
		  function runApiCheck(_ref2, options, forType) {
		    var apiCheck = _ref2.apiCheck;
		    var apiCheckInstance = _ref2.apiCheckInstance;
		    var apiCheckFunction = _ref2.apiCheckFunction;
		    var apiCheckOptions = _ref2.apiCheckOptions;
	
		    runApiCheckForType(apiCheck, apiCheckInstance, apiCheckFunction, apiCheckOptions, options);
		    if (forType && options.type) {
		      _angularFix2['default'].forEach(formlyConfig.getTypeHeritage(options.type), function (type) {
		        runApiCheckForType(type.apiCheck, type.apiCheckInstance, type.apiCheckFunction, type.apiCheckOptions, options);
		      });
		    }
		  }
	
		  function runApiCheckForType(apiCheck, apiCheckInstance, apiCheckFunction, apiCheckOptions, options) {
		    /* eslint complexity:[2, 9] */
		    if (!apiCheck) {
		      return;
		    }
		    var instance = apiCheckInstance || formlyConfig.extras.apiCheckInstance || formlyApiCheck;
		    if (instance.config.disabled || _apiCheck2['default'].globalConfig.disabled) {
		      return;
		    }
		    var fn = apiCheckFunction || 'warn';
		    // this is the new API
		    var checkerObjects = apiCheck(instance);
		    _angularFix2['default'].forEach(checkerObjects, function (shape, name) {
		      var checker = instance.shape(shape);
		      var checkOptions = _angularFix2['default'].extend({
		        prefix: 'formly-field type ' + options.type + ' for property ' + name,
		        url: formlyApiCheck.config.output.docsBaseUrl + 'formly-field-type-apicheck-failed'
		      }, apiCheckOptions);
		      instance[fn](checker, options[name], checkOptions);
		    });
		  }
		}
	
		// Stateless util functions
		function getDefaultOptionsOptionsTypes(type) {
		  return getDefaultOptionsProperty(type, 'optionsTypes', []);
		}
	
		function getDefaultOptionsProperty(type, prop, defaultValue) {
		  return type.defaultOptions && type.defaultOptions[prop] || defaultValue;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		'use strict';
	
		formlyFocus.$inject = ["$timeout", "$document"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = formlyFocus;
	
		// @ngInject
		function formlyFocus($timeout, $document) {
		  return {
		    restrict: 'A',
		    link: function formlyFocusLink(scope, element, attrs) {
		      var previousEl = null;
		      var el = element[0];
		      var doc = $document[0];
		      attrs.$observe('formlyFocus', function respondToFocusExpressionChange(value) {
		        /* eslint no-bitwise:0 */ // I know what I'm doing. I promise...
		        if (value === 'true') {
		          $timeout(function setElementFocus() {
		            previousEl = doc.activeElement;
		            el.focus();
		          }, ~ ~attrs.focusWait);
		        } else if (value === 'false') {
		          if (doc.activeElement === el) {
		            el.blur();
		            if (attrs.hasOwnProperty('refocus') && previousEl) {
		              previousEl.focus();
		            }
		          }
		        }
		      });
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		formlyForm.$inject = ["formlyUsability", "formlyWarn", "$parse", "formlyConfig", "$interpolate"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = formlyForm;
	
		/**
		 * @ngdoc directive
		 * @name formlyForm
		 * @restrict AE
		 */
		// @ngInject
		function formlyForm(formlyUsability, formlyWarn, $parse, formlyConfig, $interpolate) {
		  var currentFormId = 1;
		  return {
		    restrict: 'AE',
		    template: formlyFormGetTemplate,
		    replace: true,
		    transclude: true,
		    scope: {
		      fields: '=',
		      model: '=',
		      form: '=?',
		      options: '=?'
		    },
		    controller: 'FormlyFormController',
		    link: formlyFormLink
		  };
	
		  function formlyFormGetTemplate(el, attrs) {
		    var rootEl = getRootEl();
		    var fieldRootEl = getFieldRootEl();
		    var formId = 'formly_' + currentFormId++;
		    var parentFormAttributes = '';
		    if (attrs.hasOwnProperty('isFieldGroup') && el.parent().parent().hasClass('formly')) {
		      parentFormAttributes = copyAttributes(el.parent().parent()[0].attributes);
		    }
		    return '\n        <' + rootEl + ' class="formly"\n                 name="' + getFormName() + '"\n                 role="form" ' + parentFormAttributes + '>\n          <' + fieldRootEl + ' formly-field\n               ng-repeat="field in fields ' + getTrackBy() + '"\n               ' + getHideDirective() + '="!field.hide"\n               class="formly-field"\n               options="field"\n               model="field.model || model"\n               original-model="model"\n               fields="fields"\n               form="theFormlyForm"\n               form-id="' + getFormName() + '"\n               form-state="options.formState"\n               form-options="options"\n               index="$index">\n          </' + fieldRootEl + '>\n          <div ng-transclude class="' + getTranscludeClass() + '"></div>\n        </' + rootEl + '>\n      ';
	
		    function getRootEl() {
		      return attrs.rootEl || 'ng-form';
		    }
	
		    function getFieldRootEl() {
		      return attrs.fieldRootEl || 'div';
		    }
	
		    function getHideDirective() {
		      return attrs.hideDirective || formlyConfig.extras.defaultHideDirective || 'ng-if';
		    }
	
		    function getTrackBy() {
		      if (!attrs.trackBy) {
		        return '';
		      } else {
		        return 'track by ' + attrs.trackBy;
		      }
		    }
	
		    function getFormName() {
		      var formName = formId;
		      var bindName = attrs.bindName;
		      if (bindName) {
		        if (_angularFix2['default'].version.minor < 3) {
		          throw formlyUsability.getFormlyError('bind-name attribute on formly-form not allowed in < angular 1.3');
		        }
		        // we can do a one-time binding here because we know we're in 1.3.x territory
		        formName = $interpolate.startSymbol() + '::\'formly_\' + ' + bindName + $interpolate.endSymbol();
		      }
		      return formName;
		    }
	
		    function getTranscludeClass() {
		      return attrs.transcludeClass || '';
		    }
	
		    function copyAttributes(attributes) {
		      var excluded = ['model', 'form', 'fields', 'options', 'name', 'role', 'class', 'data-model', 'data-form', 'data-fields', 'data-options', 'data-name'];
		      var arrayAttrs = [];
		      _angularFix2['default'].forEach(attributes, function (_ref) {
		        var nodeName = _ref.nodeName;
		        var value = _ref.value;
	
		        if (nodeName !== 'undefined' && excluded.indexOf(nodeName) === -1) {
		          arrayAttrs.push(toKebabCase(nodeName) + '="' + value + '"');
		        }
		      });
		      return arrayAttrs.join(' ');
		    }
		  }
	
		  function formlyFormLink(scope, el, attrs) {
		    setFormController();
		    fixChromeAutocomplete();
	
		    function setFormController() {
		      var formId = attrs.name;
		      scope.formId = formId;
		      scope.theFormlyForm = scope[formId];
		      if (attrs.form) {
		        var getter = $parse(attrs.form);
		        var setter = getter.assign;
		        var parentForm = getter(scope.$parent);
		        if (parentForm) {
		          scope.theFormlyForm = parentForm;
		          if (scope[formId]) {
		            scope.theFormlyForm.$removeControl(scope[formId]);
		          }
	
		          // this next line is probably one of the more dangerous things that angular-formly does to improve the
		          // API for angular-formly forms. It ensures that the NgModelControllers inside of formly-form will be
		          // attached to the form that is passed to formly-form rather than the one that formly-form creates
		          // this is necessary because it's confusing to have a step between the form you pass in
		          // and the fields in that form. It also is because angular doesn't propagate properties like $submitted down
		          // to children forms :-( This line was added to solve this issue:
		          // https://github.com/formly-js/angular-formly/issues/287
		          // luckily, this is how the formController has been accessed by the NgModelController since angular 1.0.0
		          // so I expect it will remain this way for the life of angular 1.x
		          el.removeData('$formController');
		        } else {
		          setter(scope.$parent, scope[formId]);
		        }
		      }
		      if (!scope.theFormlyForm && !formlyConfig.disableWarnings) {
		        /* eslint no-console:0 */
		        formlyWarn('formly-form-has-no-formcontroller', 'Your formly-form does not have a `form` property. Many functions of the form (like validation) may not work', el, scope);
		      }
		    }
	
		    /*
		     * chrome autocomplete lameness
		     * see https://code.google.com/p/chromium/issues/detail?id=468153#c14
		     * ლ(ಠ益ಠლ)   (╯°□°)╯︵ ┻━┻    (◞‸◟；)
		     */
		    function fixChromeAutocomplete() {
		      var global = formlyConfig.extras.removeChromeAutoComplete === true;
		      var offInstance = scope.options && scope.options.removeChromeAutoComplete === false;
		      var onInstance = scope.options && scope.options.removeChromeAutoComplete === true;
		      if (global && !offInstance || onInstance) {
		        var input = document.createElement('input');
		        input.setAttribute('autocomplete', 'address-level4');
		        input.setAttribute('hidden', 'true');
		        el[0].appendChild(input);
		      }
		    }
		  }
	
		  // stateless util functions
		  function toKebabCase(string) {
		    if (string) {
		      return string.replace(/([A-Z])/g, function ($1) {
		        return '-' + $1.toLowerCase();
		      });
		    } else {
		      return '';
		    }
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		FormlyFormController.$inject = ["formlyUsability", "formlyWarn", "formlyConfig", "$parse", "$scope", "formlyApiCheck", "formlyUtil"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var _slice = Array.prototype.slice;
		exports['default'] = FormlyFormController;
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		function isFieldGroup(field) {
		  return field && !!field.fieldGroup;
		}
	
		// @ngInject
	
		function FormlyFormController(formlyUsability, formlyWarn, formlyConfig, $parse, $scope, formlyApiCheck, formlyUtil) {
	
		  setupOptions();
		  $scope.model = $scope.model || {};
		  setupFields();
	
		  // watch the model and evaluate watch expressions that depend on it.
		  if (!$scope.options.manualModelWatcher) {
		    $scope.$watch('model', onModelOrFormStateChange, true);
		  } else if (_angularFix2['default'].isFunction($scope.options.manualModelWatcher)) {
		    $scope.$watch($scope.options.manualModelWatcher, onModelOrFormStateChange, true);
		  }
	
		  if ($scope.options.formState) {
		    $scope.$watch('options.formState', onModelOrFormStateChange, true);
		  }
	
		  function onModelOrFormStateChange() {
		    _angularFix2['default'].forEach($scope.fields, runFieldExpressionProperties);
		  }
	
		  function validateFormControl(formControl, promise) {
		    var validate = formControl.$validate;
		    if (promise) {
		      promise.then(function () {
		        return validate.apply(formControl);
		      });
		    } else {
		      validate();
		    }
		  }
	
		  function runFieldExpressionProperties(field, index) {
		    var model = field.model || $scope.model;
		    var promise = field.runExpressions && field.runExpressions();
		    if (field.hideExpression) {
		      // can't use hide with expressionProperties reliably
		      var val = model[field.key];
		      field.hide = evalCloseToFormlyExpression(field.hideExpression, val, field, index, { model: model });
		    }
		    if (field.extras && field.extras.validateOnModelChange && field.formControl) {
		      if (_angularFix2['default'].isArray(field.formControl)) {
		        _angularFix2['default'].forEach(field.formControl, function (formControl) {
		          validateFormControl(formControl, promise);
		        });
		      } else {
		        validateFormControl(field.formControl, promise);
		      }
		    }
		  }
	
		  function setupFields() {
		    $scope.fields = $scope.fields || [];
	
		    checkDeprecatedOptions($scope.options);
	
		    var fieldTransforms = $scope.options.fieldTransform || formlyConfig.extras.fieldTransform;
	
		    if (!_angularFix2['default'].isArray(fieldTransforms)) {
		      fieldTransforms = [fieldTransforms];
		    }
	
		    _angularFix2['default'].forEach(fieldTransforms, function transformFields(fieldTransform) {
		      if (fieldTransform) {
		        $scope.fields = fieldTransform($scope.fields, $scope.model, $scope.options, $scope.form);
		        if (!$scope.fields) {
		          throw formlyUsability.getFormlyError('fieldTransform must return an array of fields');
		        }
		      }
		    });
	
		    setupModels();
	
		    if ($scope.options.watchAllExpressions) {
		      _angularFix2['default'].forEach($scope.fields, setupHideExpressionWatcher);
		    }
	
		    _angularFix2['default'].forEach($scope.fields, attachKey); // attaches a key based on the index if a key isn't specified
		    _angularFix2['default'].forEach($scope.fields, setupWatchers); // setup watchers for all fields
		  }
	
		  function checkDeprecatedOptions(options) {
		    if (formlyConfig.extras.fieldTransform && _angularFix2['default'].isFunction(formlyConfig.extras.fieldTransform)) {
		      formlyWarn('fieldtransform-as-a-function-deprecated', 'fieldTransform as a function has been deprecated.', 'Attempted for formlyConfig.extras: ' + formlyConfig.extras.fieldTransform.name, formlyConfig.extras);
		    } else if (options.fieldTransform && _angularFix2['default'].isFunction(options.fieldTransform)) {
		      formlyWarn('fieldtransform-as-a-function-deprecated', 'fieldTransform as a function has been deprecated.', 'Attempted for form', options);
		    }
		  }
	
		  function setupOptions() {
		    formlyApiCheck['throw']([formlyApiCheck.formOptionsApi.optional], [$scope.options], { prefix: 'formly-form options check' });
		    $scope.options = $scope.options || {};
		    $scope.options.formState = $scope.options.formState || {};
	
		    _angularFix2['default'].extend($scope.options, {
		      updateInitialValue: updateInitialValue,
		      resetModel: resetModel
		    });
		  }
	
		  function updateInitialValue() {
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      if (isFieldGroup(field) && field.options) {
		        field.options.updateInitialValue();
		      } else {
		        field.updateInitialValue();
		      }
		    });
		  }
	
		  function resetModel() {
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      if (isFieldGroup(field) && field.options) {
		        field.options.resetModel();
		      } else if (field.resetModel) {
		        field.resetModel();
		      }
		    });
		  }
	
		  function setupModels() {
		    // a set of field models that are already watched (the $scope.model will have its own watcher)
		    var watchedModels = [$scope.model];
		    // we will not set up automatic model watchers if manual mode is set
		    var manualModelWatcher = $scope.options.manualModelWatcher;
	
		    if ($scope.options.formState) {
		      // $scope.options.formState will have its own watcher
		      watchedModels.push($scope.options.formState);
		    }
	
		    _angularFix2['default'].forEach($scope.fields, function (field) {
		      var isNewModel = initModel(field);
	
		      if (field.model && isNewModel && watchedModels.indexOf(field.model) === -1 && !manualModelWatcher) {
		        $scope.$watch(function () {
		          return field.model;
		        }, onModelOrFormStateChange, true);
		        watchedModels.push(field.model);
		      }
		    });
		  }
	
		  function setupHideExpressionWatcher(field, index) {
		    if (field.hideExpression) {
		      (function () {
		        // can't use hide with expressionProperties reliably
		        var model = field.model || $scope.model;
		        $scope.$watch(function hideExpressionWatcher() {
		          var val = model[field.key];
		          return evalCloseToFormlyExpression(field.hideExpression, val, field, index, { model: model });
		        }, function (hide) {
		          return field.hide = hide;
		        }, true);
		      })();
		    }
		  }
	
		  function initModel(field) {
		    var isNewModel = true;
	
		    if (_angularFix2['default'].isString(field.model)) {
		      (function () {
		        var expression = field.model;
	
		        isNewModel = !referencesCurrentlyWatchedModel(expression);
	
		        field.model = resolveStringModel(expression);
	
		        $scope.$watch(function () {
		          return resolveStringModel(expression);
		        }, function (model) {
		          return field.model = model;
		        });
		      })();
		    }
	
		    return isNewModel;
	
		    function resolveStringModel(expression) {
		      var index = $scope.fields.indexOf(field);
		      var model = evalCloseToFormlyExpression(expression, undefined, field, index, { model: $scope.model });
	
		      if (!model) {
		        throw formlyUsability.getFieldError('field-model-must-be-initialized', 'Field model must be initialized. When specifying a model as a string for a field, the result of the' + ' expression must have been initialized ahead of time.', field);
		      }
	
		      return model;
		    }
		  }
	
		  function referencesCurrentlyWatchedModel(expression) {
		    return ['model', 'formState'].some(function (item) {
		      return formlyUtil.startsWith(expression, item + '.') || formlyUtil.startsWith(expression, item + '[');
		    });
		  }
	
		  function attachKey(field, index) {
		    if (!isFieldGroup(field)) {
		      field.key = field.key || index || 0;
		    }
		  }
	
		  function setupWatchers(field, index) {
		    if (!_angularFix2['default'].isDefined(field.watcher)) {
		      return;
		    }
		    var watchers = field.watcher;
		    if (!_angularFix2['default'].isArray(watchers)) {
		      watchers = [watchers];
		    }
		    _angularFix2['default'].forEach(watchers, function setupWatcher(watcher) {
		      if (!_angularFix2['default'].isDefined(watcher.listener) && !watcher.runFieldExpressions) {
		        throw formlyUsability.getFieldError('all-field-watchers-must-have-a-listener', 'All field watchers must have a listener', field);
		      }
		      var watchExpression = getWatchExpression(watcher, field, index);
		      var watchListener = getWatchListener(watcher, field, index);
	
		      var type = watcher.type || '$watch';
		      watcher.stopWatching = $scope[type](watchExpression, watchListener, watcher.watchDeep);
		    });
		  }
	
		  function getWatchExpression(watcher, field, index) {
		    var watchExpression = undefined;
		    if (!_angularFix2['default'].isUndefined(watcher.expression)) {
		      watchExpression = watcher.expression;
		    } else if (field.key) {
		      watchExpression = 'model[\'' + field.key.toString().split('.').join('\'][\'') + '\']';
		    }
		    if (_angularFix2['default'].isFunction(watchExpression)) {
		      (function () {
		        // wrap the field's watch expression so we can call it with the field as the first arg
		        // and the stop function as the last arg as a helper
		        var originalExpression = watchExpression;
		        watchExpression = function formlyWatchExpression() {
		          var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
		          return originalExpression.apply(undefined, _toConsumableArray(args));
		        };
		        watchExpression.displayName = 'Formly Watch Expression for field for ' + field.key;
		      })();
		    } else if (field.model) {
		      watchExpression = $parse(watchExpression).bind(null, $scope, { model: field.model });
		    }
		    return watchExpression;
		  }
	
		  function getWatchListener(watcher, field, index) {
		    var watchListener = watcher.listener;
		    if (_angularFix2['default'].isFunction(watchListener) || watcher.runFieldExpressions) {
		      (function () {
		        // wrap the field's watch listener so we can call it with the field as the first arg
		        // and the stop function as the last arg as a helper
		        var originalListener = watchListener;
		        watchListener = function formlyWatchListener() {
		          var value = undefined;
		          if (originalListener) {
		            var args = modifyArgs.apply(undefined, [watcher, index].concat(_slice.call(arguments)));
		            value = originalListener.apply(undefined, _toConsumableArray(args));
		          }
		          if (watcher.runFieldExpressions) {
		            runFieldExpressionProperties(field, index);
		          }
		          return value;
		        };
		        watchListener.displayName = 'Formly Watch Listener for field for ' + field.key;
		      })();
		    }
		    return watchListener;
		  }
	
		  function modifyArgs(watcher, index) {
		    for (var _len = arguments.length, originalArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		      originalArgs[_key - 2] = arguments[_key];
		    }
	
		    return [$scope.fields[index]].concat(originalArgs, [watcher.stopWatching]);
		  }
	
		  function evalCloseToFormlyExpression(expression, val, field, index) {
		    var extraLocals = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
	
		    extraLocals = _angularFix2['default'].extend(getFormlyFieldLikeLocals(field, index), extraLocals);
		    return formlyUtil.formlyEval($scope, expression, val, val, extraLocals);
		  }
	
		  function getFormlyFieldLikeLocals(field, index) {
		    // this makes it closer to what a regular formlyExpression would be
		    return {
		      model: field.model,
		      options: field,
		      index: index,
		      formState: $scope.options.formState,
		      originalModel: $scope.model,
		      formOptions: $scope.options,
		      formId: $scope.formId
		    };
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		addFormlyNgModelAttrsManipulator.$inject = ["formlyConfig", "$interpolate"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		var _otherUtils = __webpack_require__(9);
	
		exports['default'] = addFormlyNgModelAttrsManipulator;
	
		// @ngInject
		function addFormlyNgModelAttrsManipulator(formlyConfig, $interpolate) {
		  if (formlyConfig.extras.disableNgModelAttrsManipulator) {
		    return;
		  }
		  formlyConfig.templateManipulators.preWrapper.push(ngModelAttrsManipulator);
	
		  function ngModelAttrsManipulator(template, options, scope) {
		    var node = document.createElement('div');
		    var skip = options.extras && options.extras.skipNgModelAttrsManipulator;
		    if (skip === true) {
		      return template;
		    }
		    node.innerHTML = template;
	
		    var modelNodes = getNgModelNodes(node, skip);
		    if (!modelNodes || !modelNodes.length) {
		      return template;
		    }
	
		    addIfNotPresent(modelNodes, 'id', scope.id);
		    addIfNotPresent(modelNodes, 'name', scope.name || scope.id);
	
		    addValidation();
		    alterNgModelAttr();
		    addModelOptions();
		    addTemplateOptionsAttrs();
		    addNgModelElAttrs();
	
		    return node.innerHTML;
	
		    function addValidation() {
		      if (_angularFix2['default'].isDefined(options.validators) || _angularFix2['default'].isDefined(options.validation.messages)) {
		        addIfNotPresent(modelNodes, 'formly-custom-validation', '');
		      }
		    }
	
		    function alterNgModelAttr() {
		      if (isPropertyAccessor(options.key)) {
		        addRegardlessOfPresence(modelNodes, 'ng-model', 'model.' + options.key);
		      }
		    }
	
		    function addModelOptions() {
		      if (_angularFix2['default'].isDefined(options.modelOptions)) {
		        addIfNotPresent(modelNodes, 'ng-model-options', 'options.modelOptions');
		        if (options.modelOptions.getterSetter) {
		          addRegardlessOfPresence(modelNodes, 'ng-model', 'options.value');
		        }
		      }
		    }
	
		    function addTemplateOptionsAttrs() {
		      if (!options.templateOptions && !options.expressionProperties) {
		        // no need to run these if there are no templateOptions or expressionProperties
		        return;
		      }
		      var to = options.templateOptions || {};
		      var ep = options.expressionProperties || {};
	
		      var ngModelAttributes = getBuiltInAttributes();
	
		      // extend with the user's specifications winning
		      _angularFix2['default'].extend(ngModelAttributes, options.ngModelAttrs);
	
		      // Feel free to make this more simple :-)
		      _angularFix2['default'].forEach(ngModelAttributes, function (val, name) {
		        /* eslint complexity:[2, 14] */
		        var attrVal = undefined,
		            attrName = undefined;
		        var ref = 'options.templateOptions[\'' + name + '\']';
		        var toVal = to[name];
		        var epVal = getEpValue(ep, name);
	
		        var inTo = _angularFix2['default'].isDefined(toVal);
		        var inEp = _angularFix2['default'].isDefined(epVal);
		        if (val.value) {
		          // I realize this looks backwards, but it's right, trust me...
		          attrName = val.value;
		          attrVal = name;
		        } else if (val.statement && inTo) {
		          attrName = val.statement;
		          if (_angularFix2['default'].isString(to[name])) {
		            attrVal = '$eval(' + ref + ')';
		          } else if (_angularFix2['default'].isFunction(to[name])) {
		            attrVal = ref + '(model[options.key], options, this, $event)';
		          } else {
		            throw new Error('options.templateOptions.' + name + ' must be a string or function: ' + JSON.stringify(options));
		          }
		        } else if (val.bound && inEp) {
		          attrName = val.bound;
		          attrVal = ref;
		        } else if ((val.attribute || val.boolean) && inEp) {
		          attrName = val.attribute || val.boolean;
		          attrVal = '' + $interpolate.startSymbol() + ref + $interpolate.endSymbol();
		        } else if (val.attribute && inTo) {
		          attrName = val.attribute;
		          attrVal = toVal;
		        } else if (val.boolean) {
		          if (inTo && !inEp && toVal) {
		            attrName = val.boolean;
		            attrVal = true;
		          } else {
		            /* eslint no-empty:0 */
		            // empty to illustrate that a boolean will not be added via val.bound
		            // if you want it added via val.bound, then put it in expressionProperties
		          }
		        } else if (val.bound && inTo) {
		            attrName = val.bound;
		            attrVal = ref;
		          }
	
		        if (_angularFix2['default'].isDefined(attrName) && _angularFix2['default'].isDefined(attrVal)) {
		          addIfNotPresent(modelNodes, attrName, attrVal);
		        }
		      });
		    }
	
		    function addNgModelElAttrs() {
		      _angularFix2['default'].forEach(options.ngModelElAttrs, function (val, name) {
		        addRegardlessOfPresence(modelNodes, name, val);
		      });
		    }
		  }
	
		  // Utility functions
		  function getNgModelNodes(node, skip) {
		    var selectorNot = _angularFix2['default'].isString(skip) ? ':not(' + skip + ')' : '';
		    var skipNot = ':not([formly-skip-ng-model-attrs-manipulator])';
		    var query = '[ng-model]' + selectorNot + skipNot + ', [data-ng-model]' + selectorNot + skipNot;
		    try {
		      return node.querySelectorAll(query);
		    } catch (e) {
		      //this code is needed for IE8, as it does not support the CSS3 ':not' selector
		      //it should be removed when IE8 support is dropped
		      return getNgModelNodesFallback(node, skip);
		    }
		  }
	
		  function getNgModelNodesFallback(node, skip) {
		    var allNgModelNodes = node.querySelectorAll('[ng-model], [data-ng-model]');
		    var matchingNgModelNodes = [];
	
		    //make sure this array is compatible with NodeList type by adding an 'item' function
		    matchingNgModelNodes.item = function (i) {
		      return this[i];
		    };
	
		    for (var i = 0; i < allNgModelNodes.length; i++) {
		      var ngModelNode = allNgModelNodes[i];
		      if (!ngModelNode.hasAttribute('formly-skip-ng-model-attrs-manipulator') && !(_angularFix2['default'].isString(skip) && nodeMatches(ngModelNode, skip))) {
		        matchingNgModelNodes.push(ngModelNode);
		      }
		    }
	
		    return matchingNgModelNodes;
		  }
	
		  function nodeMatches(node, selector) {
		    var div = document.createElement('div');
		    div.innerHTML = node.outerHTML;
		    return div.querySelector(selector);
		  }
	
		  function getBuiltInAttributes() {
		    var ngModelAttributes = {
		      focus: {
		        attribute: 'formly-focus'
		      }
		    };
		    var boundOnly = [];
		    var bothBooleanAndBound = ['required', 'disabled'];
		    var bothAttributeAndBound = ['pattern', 'minlength'];
		    var statementOnly = ['change', 'keydown', 'keyup', 'keypress', 'click', 'focus', 'blur'];
		    var attributeOnly = ['placeholder', 'min', 'max', 'step', 'tabindex', 'type'];
		    if (formlyConfig.extras.ngModelAttrsManipulatorPreferUnbound) {
		      bothAttributeAndBound.push('maxlength');
		    } else {
		      boundOnly.push('maxlength');
		    }
	
		    _angularFix2['default'].forEach(boundOnly, function (item) {
		      ngModelAttributes[item] = { bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(bothBooleanAndBound, function (item) {
		      ngModelAttributes[item] = { boolean: item, bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(bothAttributeAndBound, function (item) {
		      ngModelAttributes[item] = { attribute: item, bound: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(statementOnly, function (item) {
		      var propName = 'on' + item.substr(0, 1).toUpperCase() + item.substr(1);
		      ngModelAttributes[propName] = { statement: 'ng-' + item };
		    });
	
		    _angularFix2['default'].forEach(attributeOnly, function (item) {
		      ngModelAttributes[item] = { attribute: item };
		    });
		    return ngModelAttributes;
		  }
	
		  function getEpValue(ep, name) {
		    return ep['templateOptions.' + name] || ep['templateOptions[\'' + name + '\']'] || ep['templateOptions["' + name + '"]'];
		  }
	
		  function addIfNotPresent(nodes, attr, val) {
		    _angularFix2['default'].forEach(nodes, function (node) {
		      if (!node.getAttribute(attr)) {
		        node.setAttribute(attr, val);
		      }
		    });
		  }
	
		  function addRegardlessOfPresence(nodes, attr, val) {
		    _angularFix2['default'].forEach(nodes, function (node) {
		      node.setAttribute(attr, val);
		    });
		  }
	
		  function isPropertyAccessor(key) {
		    return (0, _otherUtils.contains)(key, '.') || (0, _otherUtils.contains)(key, '[') && (0, _otherUtils.contains)(key, ']');
		  }
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		addCustomTags.$inject = ["$document"];
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _angularFix = __webpack_require__(2);
	
		var _angularFix2 = _interopRequireDefault(_angularFix);
	
		exports['default'] = addCustomTags;
	
		// @ngInject
		function addCustomTags($document) {
		  // IE8 check ->
		  // https://msdn.microsoft.com/en-us/library/cc196988(v=vs.85).aspx
		  if ($document && $document.documentMode < 9) {
		    (function () {
		      var document = $document.get(0);
		      // add the custom elements that we need for formly
		      var customElements = ['formly-field', 'formly-form'];
		      _angularFix2['default'].forEach(customElements, function (el) {
		        document.createElement(el);
		      });
		    })();
		  }
		}
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! api-check version 7.5.5 built with ♥ by Kent C. Dodds <kent@doddsfamily.us> (http://kent.doddsfamily.us) (ó ì_í)=óò=(ì_í ò)
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define(factory);
		else if(typeof exports === 'object')
			exports["apiCheck"] = factory();
		else
			root["apiCheck"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _apiCheck = __webpack_require__(1);
	
		var _apiCheck2 = _interopRequireDefault(_apiCheck);
	
		exports['default'] = _apiCheck2['default'];
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var stringify = __webpack_require__(2);
		var apiCheckUtil = __webpack_require__(3);
		var each = apiCheckUtil.each;
		var isError = apiCheckUtil.isError;
		var t = apiCheckUtil.t;
		var arrayify = apiCheckUtil.arrayify;
		var getCheckerDisplay = apiCheckUtil.getCheckerDisplay;
		var typeOf = apiCheckUtil.typeOf;
		var getError = apiCheckUtil.getError;
	
		var checkers = __webpack_require__(4);
		var apiCheckApis = getApiCheckApis();
	
		module.exports = getApiCheckInstance;
		module.exports.VERSION = ("7.5.5");
		module.exports.utils = apiCheckUtil;
		module.exports.globalConfig = {
		  verbose: false,
		  disabled: false
		};
	
		var apiCheckApiCheck = getApiCheckInstance({
		  output: { prefix: 'apiCheck' }
		});
		module.exports.internalChecker = apiCheckApiCheck;
	
		each(checkers, function (checker, name) {
		  return module.exports[name] = checker;
		});
	
		function getApiCheckInstance() {
		  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		  var extraCheckers = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		  /* eslint complexity:[2, 6] */
		  if (apiCheckApiCheck && arguments.length) {
		    apiCheckApiCheck['throw'](apiCheckApis.getApiCheckInstanceCheckers, arguments, {
		      prefix: 'creating an apiCheck instance'
		    });
		  }
	
		  var additionalProperties = {
		    'throw': getApiCheck(true),
		    warn: getApiCheck(false),
		    getErrorMessage: getErrorMessage,
		    handleErrorMessage: handleErrorMessage,
		    config: {
		      output: config.output || {
		        prefix: '',
		        suffix: '',
		        docsBaseUrl: ''
		      },
		      verbose: config.verbose || false,
		      disabled: config.disabled || false
		    },
		    utils: apiCheckUtil
		  };
	
		  each(additionalProperties, function (wrapper, name) {
		    return apiCheck[name] = wrapper;
		  });
	
		  var disabled = apiCheck.disabled || module.exports.globalConfig.disabled;
		  each(checkers.getCheckers(disabled), function (checker, name) {
		    return apiCheck[name] = checker;
		  });
		  each(extraCheckers, function (checker, name) {
		    return apiCheck[name] = checker;
		  });
	
		  return apiCheck;
	
		  /**
		   * This is the instance function. Other things are attached to this see additional properties above.
		   * @param {Array} api - the checkers to check with
		   * @param {Array} args - the args to check
		   * @param {Object} output - output options
		   * @returns {Object} - if this has a failed = true property, then it failed
		   */
		  function apiCheck(api, args, output) {
		    /* eslint complexity:[2, 8] */
		    if (apiCheck.config.disabled || module.exports.globalConfig.disabled) {
		      return {
		        apiTypes: {}, argTypes: {},
		        passed: true, message: '',
		        failed: false
		      }; // empty version of what is normally returned
		    }
		    checkApiCheckApi(arguments);
		    if (!Array.isArray(api)) {
		      api = [api];
		      args = [args];
		    } else {
		      // turn arguments into an array
		      args = Array.prototype.slice.call(args);
		    }
		    var messages = checkEnoughArgs(api, args);
		    if (!messages.length) {
		      // this is where we actually go perform the checks.
		      messages = checkApiWithArgs(api, args);
		    }
	
		    var returnObject = getTypes(api, args);
		    returnObject.args = args;
		    if (messages.length) {
		      returnObject.message = apiCheck.getErrorMessage(api, args, messages, output);
		      returnObject.failed = true;
		      returnObject.passed = false;
		    } else {
		      returnObject.message = '';
		      returnObject.failed = false;
		      returnObject.passed = true;
		    }
		    return returnObject;
		  }
	
		  /**
		   * checkApiCheckApi, should be read like: check apiCheck api. As in, check the api for apiCheck :-)
		   * @param {Array} checkApiArgs - args provided to apiCheck function
		   */
		  function checkApiCheckApi(checkApiArgs) {
		    var api = checkApiArgs[0];
		    var args = checkApiArgs[1];
		    var isArrayOrArgs = Array.isArray(args) || args && typeof args === 'object' && typeof args.length === 'number';
	
		    if (Array.isArray(api) && !isArrayOrArgs) {
		      throw new Error(getErrorMessage(api, [args], ['If an array is provided for the api, an array must be provided for the args as well.'], { prefix: 'apiCheck' }));
		    }
		    // dog fooding here
		    var errors = checkApiWithArgs(apiCheckApis.checkApiCheckApi, checkApiArgs);
		    if (errors.length) {
		      var message = apiCheck.getErrorMessage(apiCheckApis.checkApiCheckApi, checkApiArgs, errors, {
		        prefix: 'apiCheck'
		      });
		      apiCheck.handleErrorMessage(message, true);
		    }
		  }
	
		  function getApiCheck(shouldThrow) {
		    return function apiCheckWrapper(api, args, output) {
		      var result = apiCheck(api, args, output);
		      apiCheck.handleErrorMessage(result.message, shouldThrow);
		      return result; // wont get here if an error is thrown
		    };
		  }
	
		  function handleErrorMessage(message, shouldThrow) {
		    if (shouldThrow && message) {
		      throw new Error(message);
		    } else if (message) {
		      /* eslint no-console:0 */
		      console.warn(message);
		    }
		  }
	
		  function getErrorMessage(api, args) {
		    var messages = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
		    var output = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
		    var gOut = apiCheck.config.output || {};
		    var prefix = getPrefix();
		    var suffix = getSuffix();
		    var url = getUrl();
		    var message = 'apiCheck failed! ' + messages.join(', ');
		    var passedAndShouldHavePassed = '\n\n' + buildMessageFromApiAndArgs(api, args);
		    return (prefix + ' ' + message + ' ' + suffix + ' ' + (url || '') + passedAndShouldHavePassed).trim();
	
		    function getPrefix() {
		      var p = output.onlyPrefix;
		      if (!p) {
		        p = ((gOut.prefix || '') + ' ' + (output.prefix || '')).trim();
		      }
		      return p;
		    }
	
		    function getSuffix() {
		      var s = output.onlySuffix;
		      if (!s) {
		        s = ((output.suffix || '') + ' ' + (gOut.suffix || '')).trim();
		      }
		      return s;
		    }
	
		    function getUrl() {
		      var u = output.url;
		      if (!u) {
		        u = gOut.docsBaseUrl && output.urlSuffix && ('' + gOut.docsBaseUrl + output.urlSuffix).trim();
		      }
		      return u;
		    }
		  }
	
		  function buildMessageFromApiAndArgs(api, args) {
		    var _getTypes = getTypes(api, args);
	
		    var apiTypes = _getTypes.apiTypes;
		    var argTypes = _getTypes.argTypes;
	
		    var copy = Array.prototype.slice.call(args || []);
		    var replacedItems = [];
		    replaceFunctionWithName(copy);
		    var passedArgs = getObjectString(copy);
		    argTypes = getObjectString(argTypes);
		    apiTypes = getObjectString(apiTypes);
	
		    return generateMessage();
	
		    // functions
	
		    function replaceFunctionWithName(obj) {
		      each(obj, function (val, name) {
		        /* eslint complexity:[2, 6] */
		        if (replacedItems.indexOf(val) === -1) {
		          // avoid recursive problems
		          replacedItems.push(val);
		          if (typeof val === 'object') {
		            replaceFunctionWithName(obj);
		          } else if (typeof val === 'function') {
		            obj[name] = val.displayName || val.name || 'anonymous function';
		          }
		        }
		      });
		    }
	
		    function getObjectString(types) {
		      if (!types || !types.length) {
		        return 'nothing';
		      } else if (types && types.length === 1) {
		        types = types[0];
		      }
		      return stringify(types, null, 2);
		    }
	
		    function generateMessage() {
		      var n = '\n';
		      var useS = true;
		      if (args && args.length === 1) {
		        if (typeof args[0] === 'object' && args[0] !== null) {
		          useS = !!Object.keys(args[0]).length;
		        } else {
		          useS = false;
		        }
		      }
		      var types = 'type' + (useS ? 's' : '');
		      var newLine = n + n;
		      return 'You passed:' + n + passedArgs + newLine + ('With the ' + types + ':' + n + argTypes + newLine) + ('The API calls for:' + n + apiTypes);
		    }
		  }
	
		  function getTypes(api, args) {
		    api = arrayify(api);
		    args = arrayify(args);
		    var apiTypes = api.map(function (checker, index) {
		      var specified = module.exports.globalConfig.hasOwnProperty('verbose');
		      return getCheckerDisplay(checker, {
		        terse: specified ? !module.exports.globalConfig.verbose : !apiCheck.config.verbose,
		        obj: args[index],
		        addHelpers: true
		      });
		    });
		    var argTypes = args.map(function (arg) {
		      return getArgDisplay(arg, []);
		    });
		    return { argTypes: argTypes, apiTypes: apiTypes };
		  }
		}
	
		// STATELESS FUNCTIONS
	
		/**
		 * This is where the magic happens for actually checking the arguments with the api.
		 * @param {Array} api - checkers
		 * @param  {Array} args - and arguments object
		 * @returns {Array} - the error messages
		 */
		function checkApiWithArgs(api, args) {
		  /* eslint complexity:[2, 7] */
		  var messages = [];
		  var failed = false;
		  var checkerIndex = 0;
		  var argIndex = 0;
		  var arg = undefined,
		      checker = undefined,
		      res = undefined,
		      lastChecker = undefined,
		      argName = undefined,
		      argFailed = undefined,
		      skipPreviousChecker = undefined;
		  /* jshint -W084 */
		  while ((checker = api[checkerIndex++]) && argIndex < args.length) {
		    arg = args[argIndex++];
		    argName = 'Argument ' + argIndex + (checker.isOptional ? ' (optional)' : '');
		    res = checker(arg, 'value', argName);
		    argFailed = isError(res);
		    lastChecker = checkerIndex >= api.length;
		    skipPreviousChecker = checkerIndex > 1 && api[checkerIndex - 1].isOptional;
		    if (argFailed && lastChecker || argFailed && !lastChecker && !checker.isOptional && !skipPreviousChecker) {
		      failed = true;
		      messages.push(getCheckerErrorMessage(res, checker, arg));
		    } else if (argFailed && checker.isOptional) {
		      argIndex--;
		    } else {
		      messages.push(t(argName) + ' passed');
		    }
		  }
		  return failed ? messages : [];
		}
	
		checkerTypeType.type = 'function with __apiCheckData property and `${function.type}` property';
		function checkerTypeType(checkerType, name, location) {
		  var apiCheckDataChecker = checkers.shape({
		    type: checkers.string,
		    optional: checkers.bool
		  });
		  var asFunc = checkers.func.withProperties({ __apiCheckData: apiCheckDataChecker });
		  var asShape = checkers.shape({ __apiCheckData: apiCheckDataChecker });
		  var wrongShape = checkers.oneOfType([asFunc, asShape])(checkerType, name, location);
		  if (isError(wrongShape)) {
		    return wrongShape;
		  }
		  if (typeof checkerType !== 'function' && !checkerType.hasOwnProperty(checkerType.__apiCheckData.type)) {
		    return getError(name, location, checkerTypeType.type);
		  }
		}
	
		function getCheckerErrorMessage(res, checker, val) {
		  var checkerHelp = getCheckerHelp(checker, val);
		  checkerHelp = checkerHelp ? ' - ' + checkerHelp : '';
		  return res.message + checkerHelp;
		}
	
		function getCheckerHelp(_ref, val) {
		  var help = _ref.help;
	
		  if (!help) {
		    return '';
		  }
		  if (typeof help === 'function') {
		    help = help(val);
		  }
		  return help;
		}
	
		function checkEnoughArgs(api, args) {
		  var requiredArgs = api.filter(function (a) {
		    return !a.isOptional;
		  });
		  if (args.length < requiredArgs.length) {
		    return ['Not enough arguments specified. Requires `' + requiredArgs.length + '`, you passed `' + args.length + '`'];
		  } else {
		    return [];
		  }
		}
	
		function getArgDisplay(arg, gottenArgs) {
		  /* eslint complexity:[2, 7] */
		  var cName = arg && arg.constructor && arg.constructor.name;
		  var type = typeOf(arg);
		  if (type === 'function') {
		    if (hasKeys()) {
		      var properties = stringify(getDisplayIfNotGotten());
		      return cName + ' (with properties: ' + properties + ')';
		    }
		    return cName;
		  }
	
		  if (arg === null) {
		    return 'null';
		  }
	
		  if (type !== 'array' && type !== 'object') {
		    return type;
		  }
	
		  if (hasKeys()) {
		    return getDisplayIfNotGotten();
		  }
	
		  return cName;
	
		  // utility functions
		  function hasKeys() {
		    return arg && Object.keys(arg).length;
		  }
	
		  function getDisplayIfNotGotten() {
		    if (gottenArgs.indexOf(arg) !== -1) {
		      return '[Circular]';
		    }
		    gottenArgs.push(arg);
		    return getDisplay(arg, gottenArgs);
		  }
		}
	
		function getDisplay(obj, gottenArgs) {
		  var argDisplay = {};
		  each(obj, function (v, k) {
		    return argDisplay[k] = getArgDisplay(v, gottenArgs);
		  });
		  return argDisplay;
		}
	
		function getApiCheckApis() {
		  var os = checkers.string.optional;
	
		  var checkerFnChecker = checkers.func.withProperties({
		    type: checkers.oneOfType([checkers.string, checkerTypeType]).optional,
		    displayName: checkers.string.optional,
		    shortType: checkers.string.optional,
		    notOptional: checkers.bool.optional,
		    notRequired: checkers.bool.optional
		  });
	
		  var getApiCheckInstanceCheckers = [checkers.shape({
		    output: checkers.shape({
		      prefix: checkers.string.optional,
		      suffix: checkers.string.optional,
		      docsBaseUrl: checkers.string.optional
		    }).strict.optional,
		    verbose: checkers.bool.optional,
		    disabled: checkers.bool.optional
		  }).strict.optional, checkers.objectOf(checkerFnChecker).optional];
	
		  var checkApiCheckApi = [checkers.typeOrArrayOf(checkerFnChecker), checkers.any.optional, checkers.shape({
		    prefix: os, suffix: os, urlSuffix: os, // appended case
		    onlyPrefix: os, onlySuffix: os, url: os // override case
		  }).strict.optional];
	
		  return {
		    checkerFnChecker: checkerFnChecker,
		    getApiCheckInstanceCheckers: getApiCheckInstanceCheckers,
		    checkApiCheckApi: checkApiCheckApi
		  };
		}
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = stringify;
	
		function getSerialize (fn, decycle) {
		  var seen = [], keys = [];
		  decycle = decycle || function(key, value) {
		    return '[Circular ' + getPath(value, seen, keys) + ']'
		  };
		  return function(key, value) {
		    var ret = value;
		    if (typeof value === 'object' && value) {
		      if (seen.indexOf(value) !== -1)
		        ret = decycle(key, value);
		      else {
		        seen.push(value);
		        keys.push(key);
		      }
		    }
		    if (fn) ret = fn(key, ret);
		    return ret;
		  }
		}
	
		function getPath (value, seen, keys) {
		  var index = seen.indexOf(value);
		  var path = [ keys[index] ];
		  for (index--; index >= 0; index--) {
		    if (seen[index][ path[0] ] === value) {
		      value = seen[index];
		      path.unshift(keys[index]);
		    }
		  }
		  return '~' + path.join('.');
		}
	
		function stringify(obj, fn, spaces, decycle) {
		  return JSON.stringify(obj, getSerialize(fn, decycle), spaces);
		}
	
		stringify.getSerialize = getSerialize;
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		var stringify = __webpack_require__(2);
		var checkerHelpers = {
		  addOptional: addOptional, getRequiredVersion: getRequiredVersion, setupChecker: setupChecker, addNullable: addNullable
		};
	
		module.exports = {
		  each: each, copy: copy, typeOf: typeOf, arrayify: arrayify, getCheckerDisplay: getCheckerDisplay,
		  isError: isError, list: list, getError: getError, nAtL: nAtL, t: t, undef: undef, checkerHelpers: checkerHelpers,
		  noop: noop
		};
	
		function copy(obj) {
		  var type = typeOf(obj);
		  var daCopy = undefined;
		  if (type === 'array') {
		    daCopy = [];
		  } else if (type === 'object') {
		    daCopy = {};
		  } else {
		    return obj;
		  }
		  each(obj, function (val, key) {
		    daCopy[key] = val; // cannot single-line this because we don't want to abort the each
		  });
		  return daCopy;
		}
	
		function typeOf(obj) {
		  if (Array.isArray(obj)) {
		    return 'array';
		  } else if (obj instanceof RegExp) {
		    return 'object';
		  } else {
		    return typeof obj;
		  }
		}
	
		function getCheckerDisplay(checker, options) {
		  /* eslint complexity:[2, 7] */
		  var display = undefined;
		  var short = options && options.short;
		  if (short && checker.shortType) {
		    display = checker.shortType;
		  } else if (!short && typeof checker.type === 'object' || checker.type === 'function') {
		    display = getCheckerType(checker, options);
		  } else {
		    display = getCheckerType(checker, options) || checker.displayName || checker.name;
		  }
		  return display;
		}
	
		function getCheckerType(_ref, options) {
		  var type = _ref.type;
	
		  if (typeof type === 'function') {
		    var __apiCheckData = type.__apiCheckData;
		    var typeTypes = type(options);
		    type = _defineProperty({
		      __apiCheckData: __apiCheckData
		    }, __apiCheckData.type, typeTypes);
		  }
		  return type;
		}
	
		function arrayify(obj) {
		  if (!obj) {
		    return [];
		  } else if (Array.isArray(obj)) {
		    return obj;
		  } else {
		    return [obj];
		  }
		}
	
		function each(obj, iterator, context) {
		  if (Array.isArray(obj)) {
		    return eachArry(obj, iterator, context);
		  } else {
		    return eachObj(obj, iterator, context);
		  }
		}
	
		function eachObj(obj, iterator, context) {
		  var ret = undefined;
		  var hasOwn = Object.prototype.hasOwnProperty;
		  /* eslint prefer-const:0 */ // some weird eslint bug?
		  for (var key in obj) {
		    if (hasOwn.call(obj, key)) {
		      ret = iterator.call(context, obj[key], key, obj);
		      if (ret === false) {
		        return ret;
		      }
		    }
		  }
		  return true;
		}
	
		function eachArry(obj, iterator, context) {
		  var ret = undefined;
		  var length = obj.length;
		  for (var i = 0; i < length; i++) {
		    ret = iterator.call(context, obj[i], i, obj);
		    if (ret === false) {
		      return ret;
		    }
		  }
		  return true;
		}
	
		function isError(obj) {
		  return obj instanceof Error;
		}
	
		function list(arry, join, finalJoin) {
		  arry = arrayify(arry);
		  var copy = arry.slice();
		  var last = copy.pop();
		  if (copy.length === 1) {
		    join = ' ';
		  }
		  return copy.join(join) + ('' + (copy.length ? join + finalJoin : '') + last);
		}
	
		function getError(name, location, checkerType) {
		  if (typeof checkerType === 'function') {
		    checkerType = checkerType({ short: true });
		  }
		  var stringType = typeof checkerType !== 'object' ? checkerType : stringify(checkerType);
		  return new Error(nAtL(name, location) + ' must be ' + t(stringType));
		}
	
		function nAtL(name, location) {
		  var tName = t(name || 'value');
		  var tLocation = !location ? '' : ' at ' + t(location);
		  return '' + tName + tLocation;
		}
	
		function t(thing) {
		  return '`' + thing + '`';
		}
	
		function undef(thing) {
		  return typeof thing === 'undefined';
		}
	
		/**
		 * This will set up the checker with all of the defaults that most checkers want like required by default and an
		 * optional version
		 *
		 * @param {Function} checker - the checker to setup with properties
		 * @param {Object} properties - properties to add to the checker
		 * @param {boolean} disabled - when set to true, this will set the checker to a no-op function
		 * @returns {Function} checker - the setup checker
		 */
		function setupChecker(checker, properties, disabled) {
		  /* eslint complexity:[2, 9] */
		  if (disabled) {
		    // swap out the checker for its own copy of noop
		    checker = getNoop();
		    checker.isNoop = true;
		  }
	
		  if (typeof checker.type === 'string') {
		    checker.shortType = checker.type;
		  }
	
		  // assign all properties given
		  each(properties, function (prop, name) {
		    return checker[name] = prop;
		  });
	
		  if (!checker.displayName) {
		    checker.displayName = 'apiCheck ' + t(checker.shortType || checker.type || checker.name) + ' type checker';
		  }
	
		  if (!checker.notRequired) {
		    checker = getRequiredVersion(checker, disabled);
		  }
	
		  if (!checker.notNullable) {
		    addNullable(checker, disabled);
		  }
	
		  if (!checker.notOptional) {
		    addOptional(checker, disabled);
		  }
	
		  return checker;
		}
	
		function getRequiredVersion(checker, disabled) {
		  var requiredChecker = disabled ? getNoop() : function requiredChecker(val, name, location, obj) {
		    if (undef(val) && !checker.isOptional) {
		      var tLocation = location ? ' in ' + t(location) : '';
		      var type = getCheckerDisplay(checker, { short: true });
		      var stringType = typeof type !== 'object' ? type : stringify(type);
		      return new Error('Required ' + t(name) + ' not specified' + tLocation + '. Must be ' + t(stringType));
		    } else {
		      return checker(val, name, location, obj);
		    }
		  };
		  copyProps(checker, requiredChecker);
		  requiredChecker.originalChecker = checker;
		  return requiredChecker;
		}
	
		function addOptional(checker, disabled) {
		  var optionalCheck = disabled ? getNoop() : function optionalCheck(val, name, location, obj) {
		    if (!undef(val)) {
		      return checker(val, name, location, obj);
		    }
		  };
		  // inherit all properties on the original checker
		  copyProps(checker, optionalCheck);
	
		  optionalCheck.isOptional = true;
		  optionalCheck.displayName = checker.displayName + ' (optional)';
		  optionalCheck.originalChecker = checker;
	
		  // the magic line that allows you to add .optional to the end of the checkers
		  checker.optional = optionalCheck;
	
		  fixType(checker, checker.optional);
		}
	
		function addNullable(checker, disabled) {
		  var nullableCheck = disabled ? getNoop() : function nullableCheck(val, name, location, obj) {
		    if (val !== null) {
		      return checker(val, name, location, obj);
		    }
		  };
		  // inherit all properties on the original checker
		  copyProps(checker, nullableCheck);
	
		  nullableCheck.isNullable = true;
		  nullableCheck.displayName = checker.displayName + ' (nullable)';
		  nullableCheck.originalChecker = checker;
	
		  // the magic line that allows you to add .nullable to the end of the checkers
		  checker.nullable = nullableCheck;
	
		  fixType(checker, checker.nullable);
		  if (!checker.notOptional) {
		    addOptional(checker.nullable, disabled);
		  }
		}
	
		function fixType(checker, checkerCopy) {
		  // fix type, because it's not a straight copy...
		  // the reason is we need to specify type.__apiCheckData.optional as true for the terse/verbose option.
		  // we also want to add "(optional)" to the types with a string
		  if (typeof checkerCopy.type === 'object') {
		    checkerCopy.type = copy(checkerCopy.type); // make our own copy of this
		  } else if (typeof checkerCopy.type === 'function') {
		      checkerCopy.type = function () {
		        return checker.type.apply(checker, arguments);
		      };
		    } else {
		      checkerCopy.type += ' (optional)';
		      return;
		    }
		  checkerCopy.type.__apiCheckData = copy(checker.type.__apiCheckData) || {}; // and this
		  checkerCopy.type.__apiCheckData.optional = true;
		}
	
		// UTILS
	
		function copyProps(src, dest) {
		  each(Object.keys(src), function (key) {
		    return dest[key] = src[key];
		  });
		}
	
		function noop() {}
	
		function getNoop() {
		  /* eslint no-shadow:0 */
		  /* istanbul ignore next */
		  return function noop() {};
		}
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var stringify = __webpack_require__(2);
	
		var _require = __webpack_require__(3);
	
		var typeOf = _require.typeOf;
		var each = _require.each;
		var copy = _require.copy;
		var getCheckerDisplay = _require.getCheckerDisplay;
		var isError = _require.isError;
		var arrayify = _require.arrayify;
		var list = _require.list;
		var getError = _require.getError;
		var nAtL = _require.nAtL;
		var t = _require.t;
		var checkerHelpers = _require.checkerHelpers;
		var undef = _require.undef;
		var setupChecker = checkerHelpers.setupChecker;
	
		var checkers = module.exports = getCheckers();
		module.exports.getCheckers = getCheckers;
	
		function getCheckers(disabled) {
		  return {
		    array: typeOfCheckGetter('Array'),
		    bool: typeOfCheckGetter('Boolean'),
		    number: typeOfCheckGetter('Number'),
		    string: typeOfCheckGetter('String'),
		    func: funcCheckGetter(),
		    object: objectCheckGetter(),
	
		    emptyObject: emptyObjectCheckGetter(),
	
		    instanceOf: instanceCheckGetter,
		    oneOf: oneOfCheckGetter,
		    oneOfType: oneOfTypeCheckGetter,
	
		    arrayOf: arrayOfCheckGetter,
		    objectOf: objectOfCheckGetter,
		    typeOrArrayOf: typeOrArrayOfCheckGetter,
	
		    range: rangeCheckGetter,
		    lessThan: lessThanCheckGetter,
		    greaterThan: greaterThanCheckGetter,
	
		    shape: getShapeCheckGetter(),
		    args: argumentsCheckerGetter(),
	
		    any: anyCheckGetter(),
		    'null': nullCheckGetter()
	
		  };
	
		  function typeOfCheckGetter(type) {
		    var lType = type.toLowerCase();
		    return setupChecker(function typeOfCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== lType) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function funcCheckGetter() {
		    var type = 'Function';
		    var functionChecker = setupChecker(function functionCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== 'function') {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
	
		    functionChecker.withProperties = function getWithPropertiesChecker(properties) {
		      var apiError = checkers.objectOf(checkers.func)(properties, 'properties', 'apiCheck.func.withProperties');
		      if (isError(apiError)) {
		        throw apiError;
		      }
		      var shapeChecker = checkers.shape(properties, true);
		      shapeChecker.type.__apiCheckData.type = 'func.withProperties';
	
		      return setupChecker(function functionWithPropertiesChecker(val, name, location) {
		        var notFunction = checkers.func(val, name, location);
		        if (isError(notFunction)) {
		          return notFunction;
		        }
		        return shapeChecker(val, name, location);
		      }, { type: shapeChecker.type, shortType: 'func.withProperties' }, disabled);
		    };
		    return functionChecker;
		  }
	
		  function objectCheckGetter() {
		    var type = 'Object';
		    var nullType = 'Object (null ok)';
		    var objectNullOkChecker = setupChecker(function objectNullOkCheckerDefinition(val, name, location) {
		      if (typeOf(val) !== 'object') {
		        return getError(name, location, nullType);
		      }
		    }, { type: nullType }, disabled);
	
		    var objectChecker = setupChecker(function objectCheckerDefinition(val, name, location) {
		      if (val === null || isError(objectNullOkChecker(val, name, location))) {
		        return getError(name, location, objectChecker.type);
		      }
		    }, { type: type, nullOk: objectNullOkChecker }, disabled);
	
		    return objectChecker;
		  }
	
		  function instanceCheckGetter(classToCheck) {
		    return setupChecker(function instanceCheckerDefinition(val, name, location) {
		      if (!(val instanceof classToCheck)) {
		        return getError(name, location, classToCheck.name);
		      }
		    }, { type: classToCheck.name }, disabled);
		  }
	
		  function oneOfCheckGetter(enums) {
		    var type = {
		      __apiCheckData: { optional: false, type: 'enum' },
		      'enum': enums
		    };
		    var shortType = 'oneOf[' + enums.map(function (enm) {
		      return stringify(enm);
		    }).join(', ') + ']';
		    return setupChecker(function oneOfCheckerDefinition(val, name, location) {
		      if (!enums.some(function (enm) {
		        return enm === val;
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function oneOfTypeCheckGetter(typeCheckers) {
		    var checkersDisplay = typeCheckers.map(function (checker) {
		      return getCheckerDisplay(checker, { short: true });
		    });
		    var shortType = 'oneOfType[' + checkersDisplay.join(', ') + ']';
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return typeCheckers.map(function (checker) {
		        return getCheckerDisplay(checker, options);
		      });
		    }
		    type.__apiCheckData = { optional: false, type: 'oneOfType' };
		    return setupChecker(function oneOfTypeCheckerDefinition(val, name, location) {
		      if (!typeCheckers.some(function (checker) {
		        return !isError(checker(val, name, location));
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function arrayOfCheckGetter(checker) {
		    var shortCheckerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'arrayOf[' + shortCheckerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
		    type.__apiCheckData = { optional: false, type: 'arrayOf' };
	
		    return setupChecker(function arrayOfCheckerDefinition(val, name, location) {
		      if (isError(checkers.array(val)) || !val.every(function (item) {
		        return !isError(checker(item));
		      })) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function objectOfCheckGetter(checker) {
		    var checkerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'objectOf[' + checkerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
		    type.__apiCheckData = { optional: false, type: 'objectOf' };
	
		    return setupChecker(function objectOfCheckerDefinition(val, name, location) {
		      var notObject = checkers.object(val, name, location);
		      if (isError(notObject)) {
		        return notObject;
		      }
		      var allTypesSuccess = each(val, function (item, key) {
		        if (isError(checker(item, key, name))) {
		          return false;
		        }
		      });
		      if (!allTypesSuccess) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function typeOrArrayOfCheckGetter(checker) {
		    var checkerDisplay = getCheckerDisplay(checker, { short: true });
		    var shortType = 'typeOrArrayOf[' + checkerDisplay + ']';
	
		    function type(options) {
		      if (options && options.short) {
		        return shortType;
		      }
		      return getCheckerDisplay(checker, options);
		    }
	
		    type.__apiCheckData = { optional: false, type: 'typeOrArrayOf' };
		    return setupChecker(function typeOrArrayOfDefinition(val, name, location, obj) {
		      if (isError(checkers.oneOfType([checker, checkers.arrayOf(checker)])(val, name, location, obj))) {
		        return getError(name, location, shortType);
		      }
		    }, { type: type, shortType: shortType }, disabled);
		  }
	
		  function getShapeCheckGetter() {
		    function shapeCheckGetter(shape, nonObject) {
		      var shapeTypes = {};
		      each(shape, function (checker, prop) {
		        shapeTypes[prop] = getCheckerDisplay(checker);
		      });
		      function type() {
		        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		        var ret = {};
		        var terse = options.terse;
		        var obj = options.obj;
		        var addHelpers = options.addHelpers;
	
		        var parentRequired = options.required;
		        each(shape, function (checker, prop) {
		          /* eslint complexity:[2, 6] */
		          var specified = obj && obj.hasOwnProperty(prop);
		          var required = undef(parentRequired) ? !checker.isOptional : parentRequired;
		          if (!terse || (specified || !checker.isOptional)) {
		            ret[prop] = getCheckerDisplay(checker, { terse: terse, obj: obj && obj[prop], required: required, addHelpers: addHelpers });
		          }
		          if (addHelpers) {
		            modifyTypeDisplayToHelpOut(ret, prop, specified, checker, required);
		          }
		        });
		        return ret;
	
		        function modifyTypeDisplayToHelpOut(theRet, prop, specified, checker, required) {
		          if (!specified && required && !checker.isOptional) {
		            var item = 'ITEM';
		            if (checker.type && checker.type.__apiCheckData) {
		              item = checker.type.__apiCheckData.type.toUpperCase();
		            }
		            addHelper('missing', 'MISSING THIS ' + item, ' <-- YOU ARE MISSING THIS');
		          } else if (specified) {
		            var error = checker(obj[prop], prop, null, obj);
		            if (isError(error)) {
		              addHelper('error', 'THIS IS THE PROBLEM: ' + error.message, ' <-- THIS IS THE PROBLEM: ' + error.message);
		            }
		          }
	
		          function addHelper(property, objectMessage, stringMessage) {
		            if (typeof theRet[prop] === 'string') {
		              theRet[prop] += stringMessage;
		            } else {
		              theRet[prop].__apiCheckData[property] = objectMessage;
		            }
		          }
		        }
		      }
	
		      type.__apiCheckData = { strict: false, optional: false, type: 'shape' };
		      var shapeChecker = setupChecker(function shapeCheckerDefinition(val, name, location) {
		        /* eslint complexity:[2, 6] */
		        var isObject = !nonObject && checkers.object(val, name, location);
		        if (isError(isObject)) {
		          return isObject;
		        }
		        var shapePropError = undefined;
		        location = location ? location + (name ? '/' : '') : '';
		        name = name || '';
		        each(shape, function (checker, prop) {
		          if (val.hasOwnProperty(prop) || !checker.isOptional) {
		            shapePropError = checker(val[prop], prop, '' + location + name, val);
		            return !isError(shapePropError);
		          }
		        });
		        if (isError(shapePropError)) {
		          return shapePropError;
		        }
		      }, { type: type, shortType: 'shape' }, disabled);
	
		      function strictType() {
		        return type.apply(undefined, arguments);
		      }
	
		      strictType.__apiCheckData = copy(shapeChecker.type.__apiCheckData);
		      strictType.__apiCheckData.strict = true;
		      shapeChecker.strict = setupChecker(function strictShapeCheckerDefinition(val, name, location) {
		        var shapeError = shapeChecker(val, name, location);
		        if (isError(shapeError)) {
		          return shapeError;
		        }
		        var allowedProperties = Object.keys(shape);
		        var extraProps = Object.keys(val).filter(function (prop) {
		          return allowedProperties.indexOf(prop) === -1;
		        });
		        if (extraProps.length) {
		          return new Error(nAtL(name, location) + ' cannot have extra properties: ' + t(extraProps.join('`, `')) + '.' + ('It is limited to ' + t(allowedProperties.join('`, `'))));
		        }
		      }, { type: strictType, shortType: 'strict shape' }, disabled);
	
		      return shapeChecker;
		    }
	
		    shapeCheckGetter.ifNot = function ifNot(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        otherProps = [otherProps];
		      }
		      var description = undefined;
		      if (otherProps.length === 1) {
		        description = 'specified only if ' + otherProps[0] + ' is not specified';
		      } else {
		        description = 'specified only if none of the following are specified: [' + list(otherProps, ', ', 'and ') + ']';
		      }
		      var shortType = 'ifNot[' + otherProps.join(', ') + ']';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function ifNotChecker(prop, propName, location, obj) {
		        var propExists = obj && obj.hasOwnProperty(propName);
		        var otherPropsExist = otherProps.some(function (otherProp) {
		          return obj && obj.hasOwnProperty(otherProp);
		        });
		        if (propExists === otherPropsExist) {
		          return getError(propName, location, type);
		        } else if (propExists) {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { notRequired: true, type: type, shortType: shortType }, disabled);
		    };
	
		    shapeCheckGetter.onlyIf = function onlyIf(otherProps, propChecker) {
		      otherProps = arrayify(otherProps);
		      var description = undefined;
		      if (otherProps.length === 1) {
		        description = 'specified only if ' + otherProps[0] + ' is also specified';
		      } else {
		        description = 'specified only if all of the following are specified: [' + list(otherProps, ', ', 'and ') + ']';
		      }
		      var shortType = 'onlyIf[' + otherProps.join(', ') + ']';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function onlyIfCheckerDefinition(prop, propName, location, obj) {
		        var othersPresent = otherProps.every(function (property) {
		          return obj.hasOwnProperty(property);
		        });
		        if (!othersPresent) {
		          return getError(propName, location, type);
		        } else {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { type: type, shortType: shortType }, disabled);
		    };
	
		    shapeCheckGetter.requiredIfNot = function shapeRequiredIfNot(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        otherProps = [otherProps];
		      }
		      return getRequiredIfNotChecker(false, otherProps, propChecker);
		    };
	
		    shapeCheckGetter.requiredIfNot.all = function shapeRequiredIfNotAll(otherProps, propChecker) {
		      if (!Array.isArray(otherProps)) {
		        throw new Error('requiredIfNot.all must be passed an array');
		      }
		      return getRequiredIfNotChecker(true, otherProps, propChecker);
		    };
	
		    function getRequiredIfNotChecker(all, otherProps, propChecker) {
		      var props = t(otherProps.join(', '));
		      var ifProps = 'if ' + (all ? 'all of' : 'at least one of');
		      var description = 'specified ' + ifProps + ' these are not specified: ' + props + ' (otherwise it\'s optional)';
		      var shortType = 'requiredIfNot' + (all ? '.all' : '') + '[' + otherProps.join(', ') + '}]';
		      var type = getTypeForShapeChild(propChecker, description, shortType);
		      return setupChecker(function shapeRequiredIfNotDefinition(prop, propName, location, obj) {
		        var propExists = obj && obj.hasOwnProperty(propName);
		        var iteration = all ? 'every' : 'some';
		        var otherPropsExist = otherProps[iteration](function (otherProp) {
		          return obj && obj.hasOwnProperty(otherProp);
		        });
		        if (!otherPropsExist && !propExists) {
		          return getError(propName, location, type);
		        } else if (propExists) {
		          return propChecker(prop, propName, location, obj);
		        }
		      }, { type: type, notRequired: true }, disabled);
		    }
	
		    return shapeCheckGetter;
	
		    function getTypeForShapeChild(propChecker, description, shortType) {
		      function type(options) {
		        if (options && options.short) {
		          return shortType;
		        }
		        return getCheckerDisplay(propChecker);
		      }
		      type.__apiCheckData = { optional: false, type: 'ifNot', description: description };
		      return type;
		    }
		  }
	
		  function argumentsCheckerGetter() {
		    var type = 'function arguments';
		    return setupChecker(function argsCheckerDefinition(val, name, location) {
		      if (Array.isArray(val) || isError(checkers.object(val)) || isError(checkers.number(val.length))) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function anyCheckGetter() {
		    return setupChecker(function anyCheckerDefinition() {
		      // don't do anything
		    }, { type: 'any' }, disabled);
		  }
	
		  function nullCheckGetter() {
		    var type = 'null';
		    return setupChecker(function nullChecker(val, name, location) {
		      if (val !== null) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function rangeCheckGetter(min, max) {
		    var type = 'Range (' + min + ' - ' + max + ')';
		    return setupChecker(function rangeChecker(val, name, location) {
		      if (typeof val !== 'number' || val < min || val > max) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function lessThanCheckGetter(min) {
		    var type = 'lessThan[' + min + ']';
		    return setupChecker(function lessThanChecker(val, name, location) {
		      if (typeof val !== 'number' || val > min) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function greaterThanCheckGetter(max) {
		    var type = 'greaterThan[' + max + ']';
		    return setupChecker(function greaterThanChecker(val, name, location) {
		      if (typeof val !== 'number' || val < max) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
	
		  function emptyObjectCheckGetter() {
		    var type = 'empty object';
		    return setupChecker(function emptyObjectChecker(val, name, location) {
		      if (typeOf(val) !== 'object' || val === null || Object.keys(val).length) {
		        return getError(name, location, type);
		      }
		    }, { type: type }, disabled);
		  }
		}
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 80 */
26,
/* 81 */
26,
/* 82 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginModalController = __webpack_require__(321);
	
	var _loginModalController2 = _interopRequireDefault(_loginModalController);
	
	var _loginModal = __webpack_require__(589);
	
	var _loginModal2 = _interopRequireDefault(_loginModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// import modalNoticiasController from './login.modal.noticias.controller.js';
	// import modalmodalNoticiasTemplate from './login.modal.noticias.html';
	
	var LoginController = function () {
	  LoginController.$inject = ["$rootScope", "Storage", "Message", "timeSessionExpired", "Auth", "Modal", "Filter", "$location"];
	  function LoginController($rootScope, Storage, Message, timeSessionExpired, Auth, Modal, Filter, $location) {
	    'ngInject';
	
	    _classCallCheck(this, LoginController);
	
	    this.$rootScope = $rootScope;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.Auth = Auth;
	    this.timeSessionExpired = timeSessionExpired;
	    this.Modal = Modal;
	    this.Filter = Filter;
	    this.$location = $location;
	    this.isTipoOk = true;
	  }
	
	  _createClass(LoginController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$rootScope.auth = false;
	      this.nitCheck = true;
	      this.isCorreoOk = true;
	
	      if (this.Storage.exist('expired')) {
	        this.Message.warning('Su sesión ha sido cerrada automáticamente después de ' + this.timeSessionExpired + ' minutos de inactividad.', null, 0);
	        this.Storage.destroy('expired');
	      }
	      if (this.Storage.exist('menu') && this.Storage.existUser() && this.Storage.exist('token') && this.Storage.getUser().estado == 'ACTIVO') {
	        this.$rootScope.auth = true;
	        this.$location.path(this.Storage.getUser().pathInicio);
	      }
	      if (this.$location.path() === '/login') {}
	      /*
	      this.Modal.alert('Se comunica a todos los usuarios que solicitan Certificados de Costo Bruto de Producción y Bien Producido, Certificado Hecho en Bolivia y Certificado de Sello Social Boliviano, que a partir del día martes 27 de noviembre de 2018, el Servicio Nacional de Verificación de Exportaciones – SENAVEX se hará cargo de los mismos y el número de cuenta para los Certificados de Costo Bruto de Producción y Bien Producido es el siguiente: BANCO UNIÓN– Cuenta N° 1 - 3433658 (SENAVEX). Favor tomar nota.',
	        null, 'Atención', null, 'md');
	      */
	      // this.Modal.show({
	      //   template: modalmodalNoticiasTemplate,
	      //   controller: modalNoticiasController,
	      //   data: {}
	      // });
	
	
	      //    this.$log.log( '----->'+this.isValidEmail('asdasd@gmail.com')) ;
	    }
	  }, {
	    key: 'registrarCuenta',
	    value: function registrarCuenta() {
	      this.$location.path('registroArtesano');
	    }
	  }, {
	    key: 'signinNIT',
	    value: function signinNIT() {
	      this.Auth.signin({
	        nit: !this.Filter.empty(this.nit) ? parseInt(this.nit, 10) + "" : this.nit,
	        usuario: this.usuario,
	        contrasena: this.contrasena,
	        tipo: 'EMPRESARIO',
	        path: 'empresa',
	        pathLogin: 'login',
	        menu: false,
	        sidenav: false
	      });
	    }
	  }, {
	    key: 'signin',
	    value: function signin() {
	      this.Auth.signin({
	        email: this.usuario2,
	        usuario: this.usuario2,
	        contrasena: this.contrasena2,
	        //      tipo: this.tipo,
	        path: 'empresa',
	        pathLogin: 'login',
	        menu: false,
	        sidenav: false
	      });
	    }
	  }, {
	    key: 'signinAdmin',
	    value: function signinAdmin() {
	      this.Auth.signin({
	        usuario: this.usuario,
	        contrasena: this.contrasena,
	        path: 'dashboard',
	        tipo: 'OPERADOR',
	        pathLogin: 'loginAdmin'
	      });
	    }
	  }, {
	    key: 'recovery',
	    value: function recovery() {
	      this.flip = true;
	    }
	  }, {
	    key: 'goLogin',
	    value: function goLogin() {
	      this.flip = false;
	    }
	  }, {
	    key: 'cleanEstiloTipo',
	    value: function cleanEstiloTipo() {
	      this.isTipoOk = true;
	    }
	  }, {
	    key: 'validateMailKeyup',
	    value: function validateMailKeyup() {
	      if (angular.isUndefined(this.usuario2) || this.usuario2 === '') {
	        this.isCorreoOk = true;
	        return;
	      }
	      if (this.isValidEmail(this.usuario2)) {
	        this.isCorreoOk = true;
	      } else {
	        this.isCorreoOk = false;
	      }
	    }
	  }, {
	    key: 'isValidEmail',
	    value: function isValidEmail(mail) {
	      return (/^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail)
	      );
	    }
	  }, {
	    key: 'olvidoContrasena',
	    value: function olvidoContrasena() {
	      this.Modal.show({
	        template: _loginModal2.default,
	        controller: _loginModalController2.default,
	        data: {}
	      });
	    }
	  }, {
	    key: 'irCreditos123',
	    value: function irCreditos123() {
	      window.open('https://credito123.gob.bo/#/', '_blank');
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HistorialModalController = function () {
	  HistorialModalController.$inject = ["NgTableParams", "DataService", "Storage", "Sidenav", "Modal", "$log", "Util", "$uibModalInstance", "$filter", "data"];
	  function HistorialModalController(NgTableParams, DataService, Storage, Sidenav, Modal, $log, Util, $uibModalInstance, $filter, data) {
	    'ngInject';
	
	    _classCallCheck(this, HistorialModalController);
	
	    this.NgTableParams = NgTableParams;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.Sidenav = Sidenav;
	    this.$log = $log;
	    this.Util = Util;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$filter = $filter;
	    this.data = data;
	  }
	
	  _createClass(HistorialModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.id_certificacion = this.data.id_certificacion;
	      this.representante = this.data.representante;
	
	      this.DataService.get('certificacion/' + this.id_certificacion + '/historial').then(function (response) {
	        _this.Tiempos = response;
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return HistorialModalController;
	}();
	
	exports.default = HistorialModalController;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegistroModalController = function () {
	  RegistroModalController.$inject = ["$uibModalInstance", "data", "$log", "Storage", "DataService"];
	  function RegistroModalController($uibModalInstance, data, $log, Storage, DataService) {
	    'ngInject';
	
	    _classCallCheck(this, RegistroModalController);
	
	    this.empresa = data.empresa;
	    this.sucursales = this.empresa.hist_sucursales;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$log = $log;
	    this.Storage = Storage;
	    this.DataService = DataService;
	  }
	
	  _createClass(RegistroModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'seleccionarSucursal',
	    value: function seleccionarSucursal(tab) {
	      this.sucursal = tab;
	    }
	  }]);
	
	  return RegistroModalController;
	}();
	
	exports.default = RegistroModalController;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(494);
	__webpack_require__(503);
	__webpack_require__(526);
	__webpack_require__(527);
	__webpack_require__(528);
	__webpack_require__(529);
	__webpack_require__(495);
	
	var MODULE_NAME = 'ui.bootstrap.module.datepicker';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.datepicker', 'uib/template/datepicker/datepicker.html', 'uib/template/datepicker/day.html', 'uib/template/datepicker/month.html', 'uib/template/datepicker/year.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(508);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(513);
	
	var MODULE_NAME = 'ui.bootstrap.module.stackedMap';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(28);
	__webpack_require__(88);
	__webpack_require__(539);
	__webpack_require__(538);
	__webpack_require__(540);
	__webpack_require__(522);
	
	var MODULE_NAME = 'ui.bootstrap.module.tooltip';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tooltip', 'uib/template/tooltip/tooltip-popup.html', 'uib/template/tooltip/tooltip-html-popup.html', 'uib/template/tooltip/tooltip-template-popup.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\">\n  <i class=\"fa fa-line-chart\"></i> Historial\n  </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <section>\n    <page-timeline ng-model=\"$ctrl.Tiempos\" representante=\"$ctrl.representante\" ></page-timeline>\n  </section>\n</div>\n"

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-building\"></i> Datos de la empresa</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body empresa-modal\">\n  <section>\n    <header class=\"header-section\">Información general</header>\n    <div class=\"row\">\n      <div class=\"col form-group\">\n        <label> Nombre de la empresa:</label>\n        <p class=\"form-control-static\">{{$ctrl.empresa.razon_social}}</p>\n      </div>\n      <div class=\"col form-group\">\n        <label>Tipo de organización:</label>\n        <p class=\"form-control-static\">{{$ctrl.empresa.tipo_societario.nombre}}</p>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label>Objeto de la empresa:</label>\n      <p class=\"form-control-static\">{{$ctrl.empresa.hist_empresa.descripcion_actividad_declarada}}</p>\n    </div>\n  </section>\n  <section>\n    <header class=\"header-section\">Información del registro de fundempresa</header>\n    <div class=\"row\">\n      <div class=\"col form-group\">\n        <label>Matrícula de comercio:</label>\n        <p class=\"form-control-static\">{{$ctrl.empresa.matricula_comercio}}</p>\n      </div>\n      <div class=\"col form-group\">\n        <label>NIT:</label>\n        <p class=\"form-control-static\">{{$ctrl.empresa.nit}}</p>\n      </div>\n    </div>\n  </section>\n  <section>\n    <header class=\"header-section\">Representante legal</header>\n    <div class=\"row\">\n      <div class=\"col form-group\">\n        <label>Nombre:</label>\n        <p class=\"form-control-static\" >\n          <span ng-show=\"$ctrl.empresa.hist_representantes.nombre_completo !== undefined && $ctrl.empresa.hist_representantes.documento_identidad !== undefined\">\n            {{$ctrl.empresa.hist_representantes.nombre_completo}}\n          </span>\n        </p>\n      </div>\n      <div class=\"col form-group\">\n        <label>Cédula de identidad:</label>\n        <p class=\"form-control-static\" >\n          <span ng-show=\"$ctrl.empresa.hist_representantes.nombre_completo !== undefined && $ctrl.empresa.hist_representantes.documento_identidad !== undefined\">\n            {{$ctrl.empresa.hist_representantes.documento_identidad}}\n          </span>\n        </p>\n      </div>\n    </div>\n  </section>\n\n  <section>\n    <header class=\"header-section\">Datos de la empresa unipersonal o sociedad comercial</header>\n    <uib-tabset active=\"active\">\n      <uib-tab index=\"$index\" ng-repeat=\"sucursal in $ctrl.sucursales\">\n        <uib-tab-heading>\n          <i class=\"fa fa-building-o\"></i> {{sucursal.tipo_sucursal ==1? 'CASA MATRIZ': tab.nombre}}\n        </uib-tab-heading>\n        <div class=\"tab-container\">\n          <div class=\"row\">\n            <div class=\"col form-group\">\n              <label>Departamento:</label>\n              <p class=\"form-control-static\">{{ sucursal.departamento}}</p>\n            </div>\n            <div class=\"col form-group\">\n              <label>Municipio:</label>\n              <p class=\"form-control-static\">{{ sucursal.municipio}}</p>\n            </div>\n            <div class=\"col form-group\">\n              <label>Provincia:</label>\n              <p class=\"form-control-static\">{{ sucursal.provincia}}</p>\n            </div>          \n          </div>\n          <div class=\"row\">\n            <div class=\"col form-group\">\n              <label>Zona:</label>\n              <p class=\"form-control-static\">{{ sucursal.zona}}</p>\n            </div>\n            <div class=\"col form-group\">\n              <label>Avenida/Calle:</label>\n              <p class=\"form-control-static\">{{ sucursal.avenida_calle}}</p>\n            </div>\n            <div class=\"col form-group\">\n              <label>Nº: </label> \n              <p class=\"form-control-static\">{{ sucursal.numero}}</p> \n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col form-group\">\n              <label>Avenida/Calle de referencia:</label>\n              <p class=\"form-control-static\">{{ sucursal.avenida_calle_referencia}}</p>\n            </div>\n            <div class=\"col form-group\">\n              <label>Edificio:</label>\n              <p class=\"form-control-static\">{{ sucursal.edificio}}</p>\n            </div>\n            <div class=\"col form-group\">\n              <label>Piso:</label>\n              <p class=\"form-control-static\">{{ sucursal.piso}}</p> \n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col form-group\">\n              <label>Teléfonos:</label>\n              <p class=\"form-control-static\">{{ sucursal.telefonos}}</p>\n            </div>\n          </div>\n        </div>\n      </uib-tab>\n    </uib-tabset>\n  </section>\n\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.cancel()\">\n    <i class=\"fa fa-close\"></i> Cerrar\n  </button>\n</div>\n\n"

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(30);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(82);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(79).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(99);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(32).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(19));
	util.inherits = __webpack_require__(20);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(676);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(657);
	var destroyImpl = __webpack_require__(98);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(15);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(100).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(15);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(100).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)))

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(15);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(19));
	util.inherits = __webpack_require__(20);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(30);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(19));
	util.inherits = __webpack_require__(20);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(668)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(99);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(32).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(98);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(15);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(15);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(662).setImmediate, (function() { return this; }())))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(30);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(79).EventEmitter;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(32).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.treeChangesCleanup = exports.registerAddCoreResolvables = void 0;
	var transition_1 = __webpack_require__(41);
	var router_1 = __webpack_require__(56);
	var resolve_1 = __webpack_require__(54);
	var common_1 = __webpack_require__(4);
	function addCoreResolvables(trans) {
	    trans.addResolvable(resolve_1.Resolvable.fromData(router_1.UIRouter, trans.router), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData(transition_1.Transition, trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$transition$', trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$stateParams', trans.params()), '');
	    trans.entering().forEach(function (state) {
	        trans.addResolvable(resolve_1.Resolvable.fromData('$state$', state), state);
	    });
	}
	exports.registerAddCoreResolvables = function (transitionService) {
	    return transitionService.onCreate({}, addCoreResolvables);
	};
	var TRANSITION_TOKENS = ['$transition$', transition_1.Transition];
	var isTransition = common_1.inArray(TRANSITION_TOKENS);
	// References to Transition in the treeChanges pathnodes makes all
	// previous Transitions reachable in memory, causing a memory leak
	// This function removes resolves for '$transition$' and `Transition` from the treeChanges.
	// Do not use this on current transitions, only on old ones.
	exports.treeChangesCleanup = function (trans) {
	    var nodes = common_1.values(trans.treeChanges()).reduce(common_1.unnestR, []).reduce(common_1.uniqR, []);
	    // If the resolvable is a Transition, return a new resolvable with null data
	    var replaceTransitionWithNull = function (r) {
	        return isTransition(r.token) ? resolve_1.Resolvable.fromData(r.token, null) : r;
	    };
	    nodes.forEach(function (node) {
	        node.resolvables = node.resolvables.map(replaceTransitionWithNull);
	    });
	};
	//# sourceMappingURL=coreResolvables.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerIgnoredTransitionHook = void 0;
	var trace_1 = __webpack_require__(8);
	var rejectFactory_1 = __webpack_require__(11);
	/**
	 * A [[TransitionHookFn]] that skips a transition if it should be ignored
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 *
	 * If the transition should be ignored (because no parameter or states changed)
	 * then the transition is ignored and not processed.
	 */
	function ignoredHook(trans) {
	    var ignoredReason = trans._ignoredReason();
	    if (!ignoredReason)
	        return;
	    trace_1.trace.traceTransitionIgnored(trans);
	    var pending = trans.router.globals.transition;
	    // The user clicked a link going back to the *current state* ('A')
	    // However, there is also a pending transition in flight (to 'B')
	    // Abort the transition to 'B' because the user now wants to be back at 'A'.
	    if (ignoredReason === 'SameAsCurrent' && pending) {
	        pending.abort();
	    }
	    return rejectFactory_1.Rejection.ignored().toPromise();
	}
	exports.registerIgnoredTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
	};
	//# sourceMappingURL=ignoredTransition.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerInvalidTransitionHook = void 0;
	/**
	 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 * If the transition is invalid (for example, param values do not validate)
	 * then the transition is rejected.
	 */
	function invalidTransitionHook(trans) {
	    if (!trans.valid()) {
	        throw new Error(trans.error().toString());
	    }
	}
	exports.registerInvalidTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
	};
	//# sourceMappingURL=invalidTransition.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerOnEnterHook = exports.registerOnRetainHook = exports.registerOnExitHook = void 0;
	/**
	 * A factory which creates an onEnter, onExit or onRetain transition hook function
	 *
	 * The returned function invokes the (for instance) state.onEnter hook when the
	 * state is being entered.
	 */
	function makeEnterExitRetainHook(hookName) {
	    return function (transition, state) {
	        var _state = state.$$state();
	        var hookFn = _state[hookName];
	        return hookFn(transition, state);
	    };
	}
	/**
	 * The [[TransitionStateHookFn]] for onExit
	 *
	 * When the state is being exited, the state's .onExit function is invoked.
	 *
	 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
	 *
	 * See: [[IHookRegistry.onExit]]
	 */
	var onExitHook = makeEnterExitRetainHook('onExit');
	exports.registerOnExitHook = function (transitionService) {
	    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onRetain
	 *
	 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
	 *
	 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
	 *
	 * See: [[IHookRegistry.onRetain]]
	 */
	var onRetainHook = makeEnterExitRetainHook('onRetain');
	exports.registerOnRetainHook = function (transitionService) {
	    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onEnter
	 *
	 * When the state is being entered, the state's .onEnter function is invoked.
	 *
	 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
	 *
	 * See: [[IHookRegistry.onEnter]]
	 */
	var onEnterHook = makeEnterExitRetainHook('onEnter');
	exports.registerOnEnterHook = function (transitionService) {
	    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
	};
	//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerRedirectToHook = void 0;
	var predicates_1 = __webpack_require__(2);
	var coreservices_1 = __webpack_require__(5);
	var targetState_1 = __webpack_require__(17);
	/**
	 * A [[TransitionHookFn]] that redirects to a different state or params
	 *
	 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
	 *
	 * See [[StateDeclaration.redirectTo]]
	 */
	var redirectToHook = function (trans) {
	    var redirect = trans.to().redirectTo;
	    if (!redirect)
	        return;
	    var $state = trans.router.stateService;
	    function handleResult(result) {
	        if (!result)
	            return;
	        if (result instanceof targetState_1.TargetState)
	            return result;
	        if (predicates_1.isString(result))
	            return $state.target(result, trans.params(), trans.options());
	        if (result['state'] || result['params'])
	            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
	    }
	    if (predicates_1.isFunction(redirect)) {
	        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
	    }
	    return handleResult(redirect);
	};
	exports.registerRedirectToHook = function (transitionService) {
	    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
	};
	//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerResolveRemaining = exports.registerLazyResolveState = exports.registerEagerResolvePath = exports.RESOLVE_HOOK_PRIORITY = void 0;
	var common_1 = __webpack_require__(1);
	var resolveContext_1 = __webpack_require__(23);
	var hof_1 = __webpack_require__(3);
	exports.RESOLVE_HOOK_PRIORITY = 1000;
	/**
	 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
	 *
	 * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var eagerResolvePath = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(common_1.noop);
	};
	exports.registerEagerResolvePath = function (transitionService) {
	    return transitionService.onStart({}, eagerResolvePath, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
	 *
	 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
	 *
	 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var lazyResolveState = function (trans, state) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).subContext(state.$$state()).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerLazyResolveState = function (transitionService) {
	    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
	 *
	 * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * After all entering states have been entered, this hook resolves any remaining Resolvables.
	 * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var resolveRemaining = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerResolveRemaining = function (transitionService) {
	    return transitionService.onFinish({}, resolveRemaining, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	//# sourceMappingURL=resolve.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateGlobalState = void 0;
	var common_1 = __webpack_require__(1);
	/**
	 * A [[TransitionHookFn]] which updates global UI-Router state
	 *
	 * Registered using `transitionService.onBefore({}, updateGlobalState);`
	 *
	 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
	 * After a successful [[Transition]], updates the global values of "the current state"
	 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
	 *
	 * See also the deprecated properties:
	 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
	 */
	var updateGlobalState = function (trans) {
	    var globals = trans.router.globals;
	    var transitionSuccessful = function () {
	        globals.successfulTransitions.enqueue(trans);
	        globals.$current = trans.$to();
	        globals.current = globals.$current.self;
	        common_1.copy(trans.params(), globals.params);
	    };
	    var clearCurrentTransition = function () {
	        // Do not clear globals.transition if a different transition has started in the meantime
	        if (globals.transition === trans)
	            globals.transition = null;
	    };
	    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
	    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
	};
	exports.registerUpdateGlobalState = function (transitionService) {
	    return transitionService.onCreate({}, updateGlobalState);
	};
	//# sourceMappingURL=updateGlobals.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerUpdateUrl = void 0;
	/**
	 * A [[TransitionHookFn]] which updates the URL after a successful transition
	 *
	 * Registered using `transitionService.onSuccess({}, updateUrl);`
	 */
	var updateUrl = function (transition) {
	    var options = transition.options();
	    var $state = transition.router.stateService;
	    var $urlRouter = transition.router.urlRouter;
	    // Dont update the url in these situations:
	    // The transition was triggered by a URL sync (options.source === 'url')
	    // The user doesn't want the url to update (options.location === false)
	    // The destination state, and all parents have no navigable url
	    if (options.source !== 'url' && options.location && $state.$current.navigable) {
	        var urlOptions = { replace: options.location === 'replace' };
	        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
	    }
	    $urlRouter.update(true);
	};
	exports.registerUpdateUrl = function (transitionService) {
	    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
	};
	//# sourceMappingURL=url.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.registerActivateViews = exports.registerLoadEnteringViews = void 0;
	var common_1 = __webpack_require__(1);
	var coreservices_1 = __webpack_require__(5);
	/**
	 * A [[TransitionHookFn]] which waits for the views to load
	 *
	 * Registered using `transitionService.onStart({}, loadEnteringViews);`
	 *
	 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
	 * In angular 1, this includes loading the templates.
	 */
	var loadEnteringViews = function (transition) {
	    var $q = coreservices_1.services.$q;
	    var enteringViews = transition.views('entering');
	    if (!enteringViews.length)
	        return;
	    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
	};
	exports.registerLoadEnteringViews = function (transitionService) {
	    return transitionService.onFinish({}, loadEnteringViews);
	};
	/**
	 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
	 *
	 * Registered using `transitionService.onSuccess({}, activateViews);`
	 *
	 * After a transition is complete, this hook deactivates the old views from the previous state,
	 * and activates the new views from the destination state.
	 *
	 * See [[ViewService]]
	 */
	var activateViews = function (transition) {
	    var enteringViews = transition.views('entering');
	    var exitingViews = transition.views('exiting');
	    if (!enteringViews.length && !exitingViews.length)
	        return;
	    var $view = transition.router.viewService;
	    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
	    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
	    $view.sync();
	};
	exports.registerActivateViews = function (transitionService) {
	    return transitionService.onSuccess({}, activateViews);
	};
	//# sourceMappingURL=views.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(4), exports);
	__exportStar(__webpack_require__(35), exports);
	__exportStar(__webpack_require__(114), exports);
	__exportStar(__webpack_require__(54), exports);
	__exportStar(__webpack_require__(38), exports);
	__exportStar(__webpack_require__(116), exports);
	__exportStar(__webpack_require__(117), exports);
	__exportStar(__webpack_require__(123), exports);
	__exportStar(__webpack_require__(51), exports);
	__exportStar(__webpack_require__(56), exports);
	__exportStar(__webpack_require__(119), exports);
	__exportStar(__webpack_require__(111), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UIRouterPluginBase = void 0;
	var UIRouterPluginBase = /** @class */ (function () {
	    function UIRouterPluginBase() {
	    }
	    UIRouterPluginBase.prototype.dispose = function (router) { };
	    return UIRouterPluginBase;
	}());
	exports.UIRouterPluginBase = UIRouterPluginBase;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParamTypes = void 0;
	var common_1 = __webpack_require__(1);
	var predicates_1 = __webpack_require__(2);
	var hof_1 = __webpack_require__(3);
	var coreservices_1 = __webpack_require__(5);
	var paramType_1 = __webpack_require__(36);
	/**
	 * A registry for parameter types.
	 *
	 * This registry manages the built-in (and custom) parameter types.
	 *
	 * The built-in parameter types are:
	 *
	 * - [[string]]
	 * - [[path]]
	 * - [[query]]
	 * - [[hash]]
	 * - [[int]]
	 * - [[bool]]
	 * - [[date]]
	 * - [[json]]
	 * - [[any]]
	 *
	 * To register custom parameter types, use [[UrlConfig.type]], i.e.,
	 *
	 * ```js
	 * router.urlService.config.type(customType)
	 * ```
	 */
	var ParamTypes = /** @class */ (function () {
	    function ParamTypes() {
	        this.enqueue = true;
	        this.typeQueue = [];
	        this.defaultTypes = common_1.pick(ParamTypes.prototype, [
	            'hash',
	            'string',
	            'query',
	            'path',
	            'int',
	            'bool',
	            'date',
	            'json',
	            'any',
	        ]);
	        // Register default types. Store them in the prototype of this.types.
	        var makeType = function (definition, name) { return new paramType_1.ParamType(common_1.extend({ name: name }, definition)); };
	        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
	    }
	    ParamTypes.prototype.dispose = function () {
	        this.types = {};
	    };
	    /**
	     * Registers a parameter type
	     *
	     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
	     */
	    ParamTypes.prototype.type = function (name, definition, definitionFn) {
	        if (!predicates_1.isDefined(definition))
	            return this.types[name];
	        if (this.types.hasOwnProperty(name))
	            throw new Error("A type named '" + name + "' has already been defined.");
	        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
	        if (definitionFn) {
	            this.typeQueue.push({ name: name, def: definitionFn });
	            if (!this.enqueue)
	                this._flushTypeQueue();
	        }
	        return this;
	    };
	    ParamTypes.prototype._flushTypeQueue = function () {
	        while (this.typeQueue.length) {
	            var type = this.typeQueue.shift();
	            if (type.pattern)
	                throw new Error("You cannot override a type's .pattern at runtime.");
	            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
	        }
	    };
	    return ParamTypes;
	}());
	exports.ParamTypes = ParamTypes;
	function initDefaultTypes() {
	    var makeDefaultType = function (def) {
	        var valToString = function (val) { return (val != null ? val.toString() : val); };
	        var defaultTypeBase = {
	            encode: valToString,
	            decode: valToString,
	            is: hof_1.is(String),
	            pattern: /.*/,
	            // tslint:disable-next-line:triple-equals
	            equals: function (a, b) { return a == b; },
	        };
	        return common_1.extend({}, defaultTypeBase, def);
	    };
	    // Default Parameter Type Definitions
	    common_1.extend(ParamTypes.prototype, {
	        string: makeDefaultType({}),
	        path: makeDefaultType({
	            pattern: /[^/]*/,
	        }),
	        query: makeDefaultType({}),
	        hash: makeDefaultType({
	            inherit: false,
	        }),
	        int: makeDefaultType({
	            decode: function (val) { return parseInt(val, 10); },
	            is: function (val) {
	                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
	            },
	            pattern: /-?\d+/,
	        }),
	        bool: makeDefaultType({
	            encode: function (val) { return (val && 1) || 0; },
	            decode: function (val) { return parseInt(val, 10) !== 0; },
	            is: hof_1.is(Boolean),
	            pattern: /0|1/,
	        }),
	        date: makeDefaultType({
	            encode: function (val) {
	                return !this.is(val)
	                    ? undefined
	                    : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
	            },
	            decode: function (val) {
	                if (this.is(val))
	                    return val;
	                var match = this.capture.exec(val);
	                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	            },
	            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
	            equals: function (l, r) {
	                return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
	            },
	            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/,
	        }),
	        json: makeDefaultType({
	            encode: common_1.toJson,
	            decode: common_1.fromJson,
	            is: hof_1.is(Object),
	            equals: common_1.equals,
	            pattern: /[^/]*/,
	        }),
	        // does not encode/decode
	        any: makeDefaultType({
	            encode: common_1.identity,
	            decode: common_1.identity,
	            is: function () { return true; },
	            equals: common_1.equals,
	        }),
	    });
	}
	initDefaultTypes();
	//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(37), exports);
	__exportStar(__webpack_require__(21), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 115 */
112,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # Transition subsystem
	 *
	 * This module contains APIs related to a Transition.
	 *
	 * See:
	 * - [[TransitionService]]
	 * - [[Transition]]
	 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
	 *
	 * @packageDocumentation @preferred
	 */
	__exportStar(__webpack_require__(10), exports);
	__exportStar(__webpack_require__(62), exports);
	__exportStar(__webpack_require__(40), exports);
	__exportStar(__webpack_require__(11), exports);
	__exportStar(__webpack_require__(41), exports);
	__exportStar(__webpack_require__(18), exports);
	__exportStar(__webpack_require__(63), exports);
	__exportStar(__webpack_require__(42), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(118), exports);
	__exportStar(__webpack_require__(24), exports);
	__exportStar(__webpack_require__(65), exports);
	__exportStar(__webpack_require__(66), exports);
	__exportStar(__webpack_require__(43), exports);
	__exportStar(__webpack_require__(68), exports);
	var urlRules_1 = __webpack_require__(67);
	Object.defineProperty(exports, "UrlRules", { enumerable: true, get: function () { return urlRules_1.UrlRules; } });
	var urlConfig_1 = __webpack_require__(64);
	Object.defineProperty(exports, "UrlConfig", { enumerable: true, get: function () { return urlConfig_1.UrlConfig; } });
	//# sourceMappingURL=index.js.map

/***/ }),
/* 118 */
112,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(120), exports);
	//# sourceMappingURL=vanilla.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Naive, pure JS implementation of core ui-router services
	 *
	 * @packageDocumentation
	 */
	__exportStar(__webpack_require__(121), exports);
	__exportStar(__webpack_require__(75), exports);
	__exportStar(__webpack_require__(71), exports);
	__exportStar(__webpack_require__(25), exports);
	__exportStar(__webpack_require__(70), exports);
	__exportStar(__webpack_require__(73), exports);
	__exportStar(__webpack_require__(74), exports);
	__exportStar(__webpack_require__(72), exports);
	__exportStar(__webpack_require__(69), exports);
	__exportStar(__webpack_require__(44), exports);
	__exportStar(__webpack_require__(122), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 121 */
112,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.memoryLocationPlugin = exports.pushStateLocationPlugin = exports.hashLocationPlugin = exports.servicesPlugin = void 0;
	var browserLocationConfig_1 = __webpack_require__(69);
	var hashLocationService_1 = __webpack_require__(70);
	var utils_1 = __webpack_require__(44);
	var pushStateLocationService_1 = __webpack_require__(74);
	var memoryLocationService_1 = __webpack_require__(73);
	var memoryLocationConfig_1 = __webpack_require__(72);
	var injector_1 = __webpack_require__(71);
	var q_1 = __webpack_require__(75);
	var coreservices_1 = __webpack_require__(5);
	function servicesPlugin(router) {
	    coreservices_1.services.$injector = injector_1.$injector;
	    coreservices_1.services.$q = q_1.$q;
	    return { name: 'vanilla.services', $q: q_1.$q, $injector: injector_1.$injector, dispose: function () { return null; } };
	}
	exports.servicesPlugin = servicesPlugin;
	/** A `UIRouterPlugin` uses the browser hash to get/set the current location */
	exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
	exports.pushStateLocationPlugin = utils_1.locationPluginFactory('vanilla.pushStateLocation', true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
	exports.memoryLocationPlugin = utils_1.locationPluginFactory('vanilla.memoryLocation', false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
	//# sourceMappingURL=plugins.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(124), exports);
	__exportStar(__webpack_require__(76), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 124 */
112,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 angular-file-upload v2.6.1
	 https://github.com/nervgh/angular-file-upload
	*/
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["angular-file-upload"] = factory();
		else
			root["angular-file-upload"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		var _options = __webpack_require__(2);
		
		var _options2 = _interopRequireDefault(_options);
		
		var _FileUploader = __webpack_require__(3);
		
		var _FileUploader2 = _interopRequireDefault(_FileUploader);
		
		var _FileLikeObject = __webpack_require__(4);
		
		var _FileLikeObject2 = _interopRequireDefault(_FileLikeObject);
		
		var _FileItem = __webpack_require__(5);
		
		var _FileItem2 = _interopRequireDefault(_FileItem);
		
		var _FileDirective = __webpack_require__(6);
		
		var _FileDirective2 = _interopRequireDefault(_FileDirective);
		
		var _FileSelect = __webpack_require__(7);
		
		var _FileSelect2 = _interopRequireDefault(_FileSelect);
		
		var _Pipeline = __webpack_require__(8);
		
		var _Pipeline2 = _interopRequireDefault(_Pipeline);
		
		var _FileDrop = __webpack_require__(9);
		
		var _FileDrop2 = _interopRequireDefault(_FileDrop);
		
		var _FileOver = __webpack_require__(10);
		
		var _FileOver2 = _interopRequireDefault(_FileOver);
		
		var _FileSelect3 = __webpack_require__(11);
		
		var _FileSelect4 = _interopRequireDefault(_FileSelect3);
		
		var _FileDrop3 = __webpack_require__(12);
		
		var _FileDrop4 = _interopRequireDefault(_FileDrop3);
		
		var _FileOver3 = __webpack_require__(13);
		
		var _FileOver4 = _interopRequireDefault(_FileOver3);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		angular.module(_config2.default.name, []).value('fileUploaderOptions', _options2.default).factory('FileUploader', _FileUploader2.default).factory('FileLikeObject', _FileLikeObject2.default).factory('FileItem', _FileItem2.default).factory('FileDirective', _FileDirective2.default).factory('FileSelect', _FileSelect2.default).factory('FileDrop', _FileDrop2.default).factory('FileOver', _FileOver2.default).factory('Pipeline', _Pipeline2.default).directive('nvFileSelect', _FileSelect4.default).directive('nvFileDrop', _FileDrop4.default).directive('nvFileOver', _FileOver4.default).run(['FileUploader', 'FileLikeObject', 'FileItem', 'FileDirective', 'FileSelect', 'FileDrop', 'FileOver', 'Pipeline', function (FileUploader, FileLikeObject, FileItem, FileDirective, FileSelect, FileDrop, FileOver, Pipeline) {
		    // only for compatibility
		    FileUploader.FileLikeObject = FileLikeObject;
		    FileUploader.FileItem = FileItem;
		    FileUploader.FileDirective = FileDirective;
		    FileUploader.FileSelect = FileSelect;
		    FileUploader.FileDrop = FileDrop;
		    FileUploader.FileOver = FileOver;
		    FileUploader.Pipeline = Pipeline;
		}]);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = {"name":"angularFileUpload"}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = {
		    url: '/',
		    alias: 'file',
		    headers: {},
		    queue: [],
		    progress: 0,
		    autoUpload: false,
		    removeAfterUpload: false,
		    method: 'POST',
		    filters: [],
		    formData: [],
		    queueLimit: Number.MAX_VALUE,
		    withCredentials: false,
		    disableMultipart: false
		};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    bind = _angular.bind,
		    copy = _angular.copy,
		    extend = _angular.extend,
		    forEach = _angular.forEach,
		    isObject = _angular.isObject,
		    isNumber = _angular.isNumber,
		    isDefined = _angular.isDefined,
		    isArray = _angular.isArray,
		    isUndefined = _angular.isUndefined,
		    element = _angular.element;
		function __identity(fileUploaderOptions, $rootScope, $http, $window, $timeout, FileLikeObject, FileItem, Pipeline) {
		    var File = $window.File,
		        FormData = $window.FormData;
		
		    var FileUploader = function () {
		        /**********************
		         * PUBLIC
		         **********************/
		        /**
		         * Creates an instance of FileUploader
		         * @param {Object} [options]
		         * @constructor
		         */
		        function FileUploader(options) {
		            _classCallCheck(this, FileUploader);
		
		            var settings = copy(fileUploaderOptions);
		
		            extend(this, settings, options, {
		                isUploading: false,
		                _nextIndex: 0,
		                _directives: { select: [], drop: [], over: [] }
		            });
		
		            // add default filters
		            this.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
		            this.filters.unshift({ name: 'folder', fn: this._folderFilter });
		        }
		        /**
		         * Adds items to the queue
		         * @param {File|HTMLInputElement|Object|FileList|Array<Object>} files
		         * @param {Object} [options]
		         * @param {Array<Function>|String} filters
		         */
		
		
		        FileUploader.prototype.addToQueue = function addToQueue(files, options, filters) {
		            var _this = this;
		
		            var incomingQueue = this.isArrayLikeObject(files) ? Array.prototype.slice.call(files) : [files];
		            var arrayOfFilters = this._getFilters(filters);
		            var count = this.queue.length;
		            var addedFileItems = [];
		
		            var next = function next() {
		                var something = incomingQueue.shift();
		
		                if (isUndefined(something)) {
		                    return done();
		                }
		
		                var fileLikeObject = _this.isFile(something) ? something : new FileLikeObject(something);
		                var pipes = _this._convertFiltersToPipes(arrayOfFilters);
		                var pipeline = new Pipeline(pipes);
		                var onThrown = function onThrown(err) {
		                    var originalFilter = err.pipe.originalFilter;
		
		                    var _err$args = _slicedToArray(err.args, 2),
		                        fileLikeObject = _err$args[0],
		                        options = _err$args[1];
		
		                    _this._onWhenAddingFileFailed(fileLikeObject, originalFilter, options);
		                    next();
		                };
		                var onSuccessful = function onSuccessful(fileLikeObject, options) {
		                    var fileItem = new FileItem(_this, fileLikeObject, options);
		                    addedFileItems.push(fileItem);
		                    _this.queue.push(fileItem);
		                    _this._onAfterAddingFile(fileItem);
		                    next();
		                };
		                pipeline.onThrown = onThrown;
		                pipeline.onSuccessful = onSuccessful;
		                pipeline.exec(fileLikeObject, options);
		            };
		
		            var done = function done() {
		                if (_this.queue.length !== count) {
		                    _this._onAfterAddingAll(addedFileItems);
		                    _this.progress = _this._getTotalProgress();
		                }
		
		                _this._render();
		                if (_this.autoUpload) _this.uploadAll();
		            };
		
		            next();
		        };
		        /**
		         * Remove items from the queue. Remove last: index = -1
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.removeFromQueue = function removeFromQueue(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            if (item.isUploading) item.cancel();
		            this.queue.splice(index, 1);
		            item._destroy();
		            this.progress = this._getTotalProgress();
		        };
		        /**
		         * Clears the queue
		         */
		
		
		        FileUploader.prototype.clearQueue = function clearQueue() {
		            while (this.queue.length) {
		                this.queue[0].remove();
		            }
		            this.progress = 0;
		        };
		        /**
		         * Uploads a item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.uploadItem = function uploadItem(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var transport = this.isHTML5 ? '_xhrTransport' : '_iframeTransport';
		
		            item._prepareToUploading();
		            if (this.isUploading) return;
		
		            this._onBeforeUploadItem(item);
		            if (item.isCancel) return;
		
		            item.isUploading = true;
		            this.isUploading = true;
		            this[transport](item);
		            this._render();
		        };
		        /**
		         * Cancels uploading of item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.cancelItem = function cancelItem(value) {
		            var _this2 = this;
		
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var prop = this.isHTML5 ? '_xhr' : '_form';
		            if (!item) return;
		            item.isCancel = true;
		            if (item.isUploading) {
		                // It will call this._onCancelItem() & this._onCompleteItem() asynchronously
		                item[prop].abort();
		            } else {
		                var dummy = [undefined, 0, {}];
		                var onNextTick = function onNextTick() {
		                    _this2._onCancelItem.apply(_this2, [item].concat(dummy));
		                    _this2._onCompleteItem.apply(_this2, [item].concat(dummy));
		                };
		                $timeout(onNextTick); // Trigger callbacks asynchronously (setImmediate emulation)
		            }
		        };
		        /**
		         * Uploads all not uploaded items of queue
		         */
		
		
		        FileUploader.prototype.uploadAll = function uploadAll() {
		            var items = this.getNotUploadedItems().filter(function (item) {
		                return !item.isUploading;
		            });
		            if (!items.length) return;
		
		            forEach(items, function (item) {
		                return item._prepareToUploading();
		            });
		            items[0].upload();
		        };
		        /**
		         * Cancels all uploads
		         */
		
		
		        FileUploader.prototype.cancelAll = function cancelAll() {
		            var items = this.getNotUploadedItems();
		            forEach(items, function (item) {
		                return item.cancel();
		            });
		        };
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFile = function isFile(value) {
		            return this.constructor.isFile(value);
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFileLikeObject = function isFileLikeObject(value) {
		            return this.constructor.isFileLikeObject(value);
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.prototype.isArrayLikeObject = function isArrayLikeObject(value) {
		            return this.constructor.isArrayLikeObject(value);
		        };
		        /**
		         * Returns a index of item from the queue
		         * @param {Item|Number} value
		         * @returns {Number}
		         */
		
		
		        FileUploader.prototype.getIndexOfItem = function getIndexOfItem(value) {
		            return isNumber(value) ? value : this.queue.indexOf(value);
		        };
		        /**
		         * Returns not uploaded items
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getNotUploadedItems = function getNotUploadedItems() {
		            return this.queue.filter(function (item) {
		                return !item.isUploaded;
		            });
		        };
		        /**
		         * Returns items ready for upload
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getReadyItems = function getReadyItems() {
		            return this.queue.filter(function (item) {
		                return item.isReady && !item.isUploading;
		            }).sort(function (item1, item2) {
		                return item1.index - item2.index;
		            });
		        };
		        /**
		         * Destroys instance of FileUploader
		         */
		
		
		        FileUploader.prototype.destroy = function destroy() {
		            var _this3 = this;
		
		            forEach(this._directives, function (key) {
		                forEach(_this3._directives[key], function (object) {
		                    object.destroy();
		                });
		            });
		        };
		        /**
		         * Callback
		         * @param {Array} fileItems
		         */
		
		
		        FileUploader.prototype.onAfterAddingAll = function onAfterAddingAll(fileItems) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onAfterAddingFile = function onAfterAddingFile(fileItem) {};
		        /**
		         * Callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         */
		
		
		        FileUploader.prototype.onWhenAddingFileFailed = function onWhenAddingFileFailed(item, filter, options) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onBeforeUploadItem = function onBeforeUploadItem(fileItem) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressItem = function onProgressItem(fileItem, progress) {};
		        /**
		         * Callback
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressAll = function onProgressAll(progress) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onSuccessItem = function onSuccessItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onErrorItem = function onErrorItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCancelItem = function onCancelItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCompleteItem = function onCompleteItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         */
		
		
		        FileUploader.prototype.onTimeoutItem = function onTimeoutItem(item) {};
		        /**
		         * Callback
		         */
		
		
		        FileUploader.prototype.onCompleteAll = function onCompleteAll() {};
		        /**********************
		         * PRIVATE
		         **********************/
		        /**
		         * Returns the total progress
		         * @param {Number} [value]
		         * @returns {Number}
		         * @private
		         */
		
		
		        FileUploader.prototype._getTotalProgress = function _getTotalProgress(value) {
		            if (this.removeAfterUpload) return value || 0;
		
		            var notUploaded = this.getNotUploadedItems().length;
		            var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
		            var ratio = 100 / this.queue.length;
		            var current = (value || 0) * ratio / 100;
		
		            return Math.round(uploaded * ratio + current);
		        };
		        /**
		         * Returns array of filters
		         * @param {Array<Function>|String} filters
		         * @returns {Array<Function>}
		         * @private
		         */
		
		
		        FileUploader.prototype._getFilters = function _getFilters(filters) {
		            if (!filters) return this.filters;
		            if (isArray(filters)) return filters;
		            var names = filters.match(/[^\s,]+/g);
		            return this.filters.filter(function (filter) {
		                return names.indexOf(filter.name) !== -1;
		            });
		        };
		        /**
		        * @param {Array<Function>} filters
		        * @returns {Array<Function>}
		        * @private
		        */
		
		
		        FileUploader.prototype._convertFiltersToPipes = function _convertFiltersToPipes(filters) {
		            var _this4 = this;
		
		            return filters.map(function (filter) {
		                var fn = bind(_this4, filter.fn);
		                fn.isAsync = filter.fn.length === 3;
		                fn.originalFilter = filter;
		                return fn;
		            });
		        };
		        /**
		         * Updates html
		         * @private
		         */
		
		
		        FileUploader.prototype._render = function _render() {
		            if (!$rootScope.$$phase) $rootScope.$apply();
		        };
		        /**
		         * Returns "true" if item is a file (not folder)
		         * @param {File|FileLikeObject} item
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._folderFilter = function _folderFilter(item) {
		            return !!(item.size || item.type);
		        };
		        /**
		         * Returns "true" if the limit has not been reached
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._queueLimitFilter = function _queueLimitFilter() {
		            return this.queue.length < this.queueLimit;
		        };
		        /**
		         * Checks whether upload successful
		         * @param {Number} status
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._isSuccessCode = function _isSuccessCode(status) {
		            return status >= 200 && status < 300 || status === 304;
		        };
		        /**
		         * Transforms the server response
		         * @param {*} response
		         * @param {Object} headers
		         * @returns {*}
		         * @private
		         */
		
		
		        FileUploader.prototype._transformResponse = function _transformResponse(response, headers) {
		            var headersGetter = this._headersGetter(headers);
		            forEach($http.defaults.transformResponse, function (transformFn) {
		                response = transformFn(response, headersGetter);
		            });
		            return response;
		        };
		        /**
		         * Parsed response headers
		         * @param headers
		         * @returns {Object}
		         * @see https://github.com/angular/angular.js/blob/master/src/ng/http.js
		         * @private
		         */
		
		
		        FileUploader.prototype._parseHeaders = function _parseHeaders(headers) {
		            var parsed = {},
		                key,
		                val,
		                i;
		
		            if (!headers) return parsed;
		
		            forEach(headers.split('\n'), function (line) {
		                i = line.indexOf(':');
		                key = line.slice(0, i).trim().toLowerCase();
		                val = line.slice(i + 1).trim();
		
		                if (key) {
		                    parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
		                }
		            });
		
		            return parsed;
		        };
		        /**
		         * Returns function that returns headers
		         * @param {Object} parsedHeaders
		         * @returns {Function}
		         * @private
		         */
		
		
		        FileUploader.prototype._headersGetter = function _headersGetter(parsedHeaders) {
		            return function (name) {
		                if (name) {
		                    return parsedHeaders[name.toLowerCase()] || null;
		                }
		                return parsedHeaders;
		            };
		        };
		        /**
		         * The XMLHttpRequest transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._xhrTransport = function _xhrTransport(item) {
		            var _this5 = this;
		
		            var xhr = item._xhr = new XMLHttpRequest();
		            var sendable;
		
		            if (!item.disableMultipart) {
		                sendable = new FormData();
		                forEach(item.formData, function (obj) {
		                    forEach(obj, function (value, key) {
		                        sendable.append(key, value);
		                    });
		                });
		
		                sendable.append(item.alias, item._file, item.file.name);
		            } else {
		                sendable = item._file;
		            }
		
		            if (typeof item._file.size != 'number') {
		                throw new TypeError('The file specified is no longer valid');
		            }
		
		            xhr.upload.onprogress = function (event) {
		                var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
		                _this5._onProgressItem(item, progress);
		            };
		
		            xhr.onload = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                var gist = _this5._isSuccessCode(xhr.status) ? 'Success' : 'Error';
		                var method = '_on' + gist + 'Item';
		                _this5[method](item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onerror = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onErrorItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onabort = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onCancelItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.ontimeout = function (e) {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = "Request Timeout.";
		                _this5._onTimeoutItem(item);
		                _this5._onCompleteItem(item, response, 408, headers);
		            };
		
		            xhr.open(item.method, item.url, true);
		
		            xhr.timeout = item.timeout || 0;
		            xhr.withCredentials = item.withCredentials;
		
		            forEach(item.headers, function (value, name) {
		                xhr.setRequestHeader(name, value);
		            });
		
		            xhr.send(sendable);
		        };
		        /**
		         * The IFrame transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._iframeTransport = function _iframeTransport(item) {
		            var _this6 = this;
		
		            var form = element('<form style="display: none;" />');
		            var iframe = element('<iframe name="iframeTransport' + Date.now() + '">');
		            var input = item._input;
		
		            var timeout = 0;
		            var timer = null;
		            var isTimedOut = false;
		
		            if (item._form) item._form.replaceWith(input); // remove old form
		            item._form = form; // save link to new form
		
		            input.prop('name', item.alias);
		
		            forEach(item.formData, function (obj) {
		                forEach(obj, function (value, key) {
		                    var element_ = element('<input type="hidden" name="' + key + '" />');
		                    element_.val(value);
		                    form.append(element_);
		                });
		            });
		
		            form.prop({
		                action: item.url,
		                method: 'POST',
		                target: iframe.prop('name'),
		                enctype: 'multipart/form-data',
		                encoding: 'multipart/form-data' // old IE
		            });
		
		            iframe.bind('load', function () {
		                var html = '';
		                var status = 200;
		
		                try {
		                    // Fix for legacy IE browsers that loads internal error page
		                    // when failed WS response received. In consequence iframe
		                    // content access denied error is thrown becouse trying to
		                    // access cross domain page. When such thing occurs notifying
		                    // with empty response object. See more info at:
		                    // http://stackoverflow.com/questions/151362/access-is-denied-error-on-accessing-iframe-document-object
		                    // Note that if non standard 4xx or 5xx error code returned
		                    // from WS then response content can be accessed without error
		                    // but 'XHR' status becomes 200. In order to avoid confusion
		                    // returning response via same 'success' event handler.
		
		                    // fixed angular.contents() for iframes
		                    html = iframe[0].contentDocument.body.innerHTML;
		                } catch (e) {
		                    // in case we run into the access-is-denied error or we have another error on the server side
		                    // (intentional 500,40... errors), we at least say 'something went wrong' -> 500
		                    status = 500;
		                }
		
		                if (timer) {
		                    clearTimeout(timer);
		                }
		                timer = null;
		
		                if (isTimedOut) {
		                    return false; //throw 'Request Timeout'
		                }
		
		                var xhr = { response: html, status: status, dummy: true };
		                var headers = {};
		                var response = _this6._transformResponse(xhr.response, headers);
		
		                _this6._onSuccessItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            });
		
		            form.abort = function () {
		                var xhr = { status: 0, dummy: true };
		                var headers = {};
		                var response;
		
		                iframe.unbind('load').prop('src', 'javascript:false;');
		                form.replaceWith(input);
		
		                _this6._onCancelItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            input.after(form);
		            form.append(input).append(iframe);
		
		            timeout = item.timeout || 0;
		            timer = null;
		
		            if (timeout) {
		                timer = setTimeout(function () {
		                    isTimedOut = true;
		
		                    item.isCancel = true;
		                    if (item.isUploading) {
		                        iframe.unbind('load').prop('src', 'javascript:false;');
		                        form.replaceWith(input);
		                    }
		
		                    var headers = {};
		                    var response = "Request Timeout.";
		                    _this6._onTimeoutItem(item);
		                    _this6._onCompleteItem(item, response, 408, headers);
		                }, timeout);
		            }
		
		            form[0].submit();
		        };
		        /**
		         * Inner callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         * @private
		         */
		
		
		        FileUploader.prototype._onWhenAddingFileFailed = function _onWhenAddingFileFailed(item, filter, options) {
		            this.onWhenAddingFileFailed(item, filter, options);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         */
		
		
		        FileUploader.prototype._onAfterAddingFile = function _onAfterAddingFile(item) {
		            this.onAfterAddingFile(item);
		        };
		        /**
		         * Inner callback
		         * @param {Array<FileItem>} items
		         */
		
		
		        FileUploader.prototype._onAfterAddingAll = function _onAfterAddingAll(items) {
		            this.onAfterAddingAll(items);
		        };
		        /**
		         *  Inner callback
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._onBeforeUploadItem = function _onBeforeUploadItem(item) {
		            item._onBeforeUpload();
		            this.onBeforeUploadItem(item);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileUploader.prototype._onProgressItem = function _onProgressItem(item, progress) {
		            var total = this._getTotalProgress(progress);
		            this.progress = total;
		            item._onProgress(progress);
		            this.onProgressItem(item, progress);
		            this.onProgressAll(total);
		            this._render();
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onSuccessItem = function _onSuccessItem(item, response, status, headers) {
		            item._onSuccess(response, status, headers);
		            this.onSuccessItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onErrorItem = function _onErrorItem(item, response, status, headers) {
		            item._onError(response, status, headers);
		            this.onErrorItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCancelItem = function _onCancelItem(item, response, status, headers) {
		            item._onCancel(response, status, headers);
		            this.onCancelItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCompleteItem = function _onCompleteItem(item, response, status, headers) {
		            item._onComplete(response, status, headers);
		            this.onCompleteItem(item, response, status, headers);
		
		            var nextItem = this.getReadyItems()[0];
		            this.isUploading = false;
		
		            if (isDefined(nextItem)) {
		                nextItem.upload();
		                return;
		            }
		
		            this.onCompleteAll();
		            this.progress = this._getTotalProgress();
		            this._render();
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._onTimeoutItem = function _onTimeoutItem(item) {
		            item._onTimeout();
		            this.onTimeoutItem(item);
		        };
		        /**********************
		         * STATIC
		         **********************/
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFile = function isFile(value) {
		            return File && value instanceof File;
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFileLikeObject = function isFileLikeObject(value) {
		            return value instanceof FileLikeObject;
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.isArrayLikeObject = function isArrayLikeObject(value) {
		            return isObject(value) && 'length' in value;
		        };
		        /**
		         * Inherits a target (Class_1) by a source (Class_2)
		         * @param {Function} target
		         * @param {Function} source
		         */
		
		
		        FileUploader.inherit = function inherit(target, source) {
		            target.prototype = Object.create(source.prototype);
		            target.prototype.constructor = target;
		            target.super_ = source;
		        };
		
		        return FileUploader;
		    }();
		
		    /**********************
		     * PUBLIC
		     **********************/
		    /**
		     * Checks a support the html5 uploader
		     * @returns {Boolean}
		     * @readonly
		     */
		
		
		    FileUploader.prototype.isHTML5 = !!(File && FormData);
		    /**********************
		     * STATIC
		     **********************/
		    /**
		     * @borrows FileUploader.prototype.isHTML5
		     */
		    FileUploader.isHTML5 = FileUploader.prototype.isHTML5;
		
		    return FileUploader;
		}
		
		__identity.$inject = ['fileUploaderOptions', '$rootScope', '$http', '$window', '$timeout', 'FileLikeObject', 'FileItem', 'Pipeline'];
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    copy = _angular.copy,
		    isElement = _angular.isElement,
		    isString = _angular.isString;
		function __identity() {
		
		    return function () {
		        /**
		         * Creates an instance of FileLikeObject
		         * @param {File|HTMLInputElement|Object} fileOrInput
		         * @constructor
		         */
		        function FileLikeObject(fileOrInput) {
		            _classCallCheck(this, FileLikeObject);
		
		            var isInput = isElement(fileOrInput);
		            var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
		            var postfix = isString(fakePathOrObject) ? 'FakePath' : 'Object';
		            var method = '_createFrom' + postfix;
		            this[method](fakePathOrObject, fileOrInput);
		        }
		        /**
		         * Creates file like object from fake path string
		         * @param {String} path
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromFakePath = function _createFromFakePath(path, input) {
		            this.lastModifiedDate = null;
		            this.size = null;
		            this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
		            this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
		            this.input = input;
		        };
		        /**
		         * Creates file like object from object
		         * @param {File|FileLikeObject} object
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromObject = function _createFromObject(object) {
		            this.lastModifiedDate = copy(object.lastModifiedDate);
		            this.size = object.size;
		            this.type = object.type;
		            this.name = object.name;
		            this.input = object.input;
		        };
		
		        return FileLikeObject;
		    }();
		}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    copy = _angular.copy,
		    extend = _angular.extend,
		    element = _angular.element,
		    isElement = _angular.isElement;
		function __identity($compile, FileLikeObject) {
		
		  return function () {
		    /**
		     * Creates an instance of FileItem
		     * @param {FileUploader} uploader
		     * @param {File|HTMLInputElement|Object} some
		     * @param {Object} options
		     * @constructor
		     */
		    function FileItem(uploader, some, options) {
		      _classCallCheck(this, FileItem);
		
		      var isInput = !!some.input;
		      var input = isInput ? element(some.input) : null;
		      var file = !isInput ? some : null;
		
		      extend(this, {
		        url: uploader.url,
		        alias: uploader.alias,
		        headers: copy(uploader.headers),
		        formData: copy(uploader.formData),
		        removeAfterUpload: uploader.removeAfterUpload,
		        withCredentials: uploader.withCredentials,
		        disableMultipart: uploader.disableMultipart,
		        method: uploader.method,
		        timeout: uploader.timeout
		      }, options, {
		        uploader: uploader,
		        file: new FileLikeObject(some),
		        isReady: false,
		        isUploading: false,
		        isUploaded: false,
		        isSuccess: false,
		        isCancel: false,
		        isError: false,
		        progress: 0,
		        index: null,
		        _file: file,
		        _input: input
		      });
		
		      if (input) this._replaceNode(input);
		    }
		    /**********************
		     * PUBLIC
		     **********************/
		    /**
		     * Uploads a FileItem
		     */
		
		
		    FileItem.prototype.upload = function upload() {
		      try {
		        this.uploader.uploadItem(this);
		      } catch (e) {
		        var message = e.name + ':' + e.message;
		        this.uploader._onCompleteItem(this, message, e.code, []);
		        this.uploader._onErrorItem(this, message, e.code, []);
		      }
		    };
		    /**
		     * Cancels uploading of FileItem
		     */
		
		
		    FileItem.prototype.cancel = function cancel() {
		      this.uploader.cancelItem(this);
		    };
		    /**
		     * Removes a FileItem
		     */
		
		
		    FileItem.prototype.remove = function remove() {
		      this.uploader.removeFromQueue(this);
		    };
		    /**
		     * Callback
		     * @private
		     */
		
		
		    FileItem.prototype.onBeforeUpload = function onBeforeUpload() {};
		    /**
		     * Callback
		     * @param {Number} progress
		     * @private
		     */
		
		
		    FileItem.prototype.onProgress = function onProgress(progress) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onSuccess = function onSuccess(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onError = function onError(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onCancel = function onCancel(response, status, headers) {};
		    /**
		     * Callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     */
		
		
		    FileItem.prototype.onComplete = function onComplete(response, status, headers) {};
		    /**
		     * Callback         
		     */
		
		
		    FileItem.prototype.onTimeout = function onTimeout() {};
		    /**********************
		     * PRIVATE
		     **********************/
		    /**
		     * Inner callback
		     */
		
		
		    FileItem.prototype._onBeforeUpload = function _onBeforeUpload() {
		      this.isReady = true;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = false;
		      this.progress = 0;
		      this.onBeforeUpload();
		    };
		    /**
		     * Inner callback
		     * @param {Number} progress
		     * @private
		     */
		
		
		    FileItem.prototype._onProgress = function _onProgress(progress) {
		      this.progress = progress;
		      this.onProgress(progress);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onSuccess = function _onSuccess(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = true;
		      this.isSuccess = true;
		      this.isCancel = false;
		      this.isError = false;
		      this.progress = 100;
		      this.index = null;
		      this.onSuccess(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onError = function _onError(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = true;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = true;
		      this.progress = 0;
		      this.index = null;
		      this.onError(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onCancel = function _onCancel(response, status, headers) {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = true;
		      this.isError = false;
		      this.progress = 0;
		      this.index = null;
		      this.onCancel(response, status, headers);
		    };
		    /**
		     * Inner callback
		     * @param {*} response
		     * @param {Number} status
		     * @param {Object} headers
		     * @private
		     */
		
		
		    FileItem.prototype._onComplete = function _onComplete(response, status, headers) {
		      this.onComplete(response, status, headers);
		      if (this.removeAfterUpload) this.remove();
		    };
		    /**
		     * Inner callback         
		     * @private
		     */
		
		
		    FileItem.prototype._onTimeout = function _onTimeout() {
		      this.isReady = false;
		      this.isUploading = false;
		      this.isUploaded = false;
		      this.isSuccess = false;
		      this.isCancel = false;
		      this.isError = true;
		      this.progress = 0;
		      this.index = null;
		      this.onTimeout();
		    };
		    /**
		     * Destroys a FileItem
		     */
		
		
		    FileItem.prototype._destroy = function _destroy() {
		      if (this._input) this._input.remove();
		      if (this._form) this._form.remove();
		      delete this._form;
		      delete this._input;
		    };
		    /**
		     * Prepares to uploading
		     * @private
		     */
		
		
		    FileItem.prototype._prepareToUploading = function _prepareToUploading() {
		      this.index = this.index || ++this.uploader._nextIndex;
		      this.isReady = true;
		    };
		    /**
		     * Replaces input element on his clone
		     * @param {JQLite|jQuery} input
		     * @private
		     */
		
		
		    FileItem.prototype._replaceNode = function _replaceNode(input) {
		      var clone = $compile(input.clone())(input.scope());
		      clone.prop('value', null); // FF fix
		      input.css('display', 'none');
		      input.after(clone); // remove jquery dependency
		    };
		
		    return FileItem;
		  }();
		}
		
		__identity.$inject = ['$compile', 'FileLikeObject'];
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity() {
		    var FileDirective = function () {
		        /**
		         * Creates instance of {FileDirective} object
		         * @param {Object} options
		         * @param {Object} options.uploader
		         * @param {HTMLElement} options.element
		         * @param {Object} options.events
		         * @param {String} options.prop
		         * @constructor
		         */
		        function FileDirective(options) {
		            _classCallCheck(this, FileDirective);
		
		            extend(this, options);
		            this.uploader._directives[this.prop].push(this);
		            this._saveLinks();
		            this.bind();
		        }
		        /**
		         * Binds events handles
		         */
		
		
		        FileDirective.prototype.bind = function bind() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this.element.bind(key, this[prop]);
		            }
		        };
		        /**
		         * Unbinds events handles
		         */
		
		
		        FileDirective.prototype.unbind = function unbind() {
		            for (var key in this.events) {
		                this.element.unbind(key, this.events[key]);
		            }
		        };
		        /**
		         * Destroys directive
		         */
		
		
		        FileDirective.prototype.destroy = function destroy() {
		            var index = this.uploader._directives[this.prop].indexOf(this);
		            this.uploader._directives[this.prop].splice(index, 1);
		            this.unbind();
		            // this.element = null;
		        };
		        /**
		         * Saves links to functions
		         * @private
		         */
		
		
		        FileDirective.prototype._saveLinks = function _saveLinks() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this[prop] = this[prop].bind(this);
		            }
		        };
		
		        return FileDirective;
		    }();
		
		    /**
		     * Map of events
		     * @type {Object}
		     */
		
		
		    FileDirective.prototype.events = {};
		
		    return FileDirective;
		}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity($compile, FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileSelect, _FileDirective);
		
		        /**
		         * Creates instance of {FileSelect} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileSelect(options) {
		            _classCallCheck(this, FileSelect);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    change: 'onChange'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'select'
		            });
		
		            var _this = _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		
		            if (!_this.uploader.isHTML5) {
		                _this.element.removeAttr('multiple');
		            }
		            _this.element.prop('value', null); // FF fix
		            return _this;
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileSelect.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileSelect.prototype.getFilters = function getFilters() {};
		        /**
		         * If returns "true" then HTMLInputElement will be cleared
		         * @returns {Boolean}
		         */
		
		
		        FileSelect.prototype.isEmptyAfterSelection = function isEmptyAfterSelection() {
		            return !!this.element.attr('multiple');
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileSelect.prototype.onChange = function onChange() {
		            var files = this.uploader.isHTML5 ? this.element[0].files : this.element[0];
		            var options = this.getOptions();
		            var filters = this.getFilters();
		
		            if (!this.uploader.isHTML5) this.destroy();
		            this.uploader.addToQueue(files, options, filters);
		            if (this.isEmptyAfterSelection()) {
		                this.element.prop('value', null);
		                this.element.replaceWith($compile(this.element.clone())(this.scope)); // IE fix
		            }
		        };
		
		        return FileSelect;
		    }(FileDirective);
		}
		
		__identity.$inject = ['$compile', 'FileDirective'];
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = __identity;
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular,
		    bind = _angular.bind,
		    isUndefined = _angular.isUndefined;
		function __identity($q) {
		
		  return function () {
		    /**
		     * @param {Array<Function>} pipes
		     */
		    function Pipeline() {
		      var pipes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		
		      _classCallCheck(this, Pipeline);
		
		      this.pipes = pipes;
		    }
		
		    Pipeline.prototype.next = function next(args) {
		      var pipe = this.pipes.shift();
		      if (isUndefined(pipe)) {
		        this.onSuccessful.apply(this, _toConsumableArray(args));
		        return;
		      }
		      var err = new Error('The filter has not passed');
		      err.pipe = pipe;
		      err.args = args;
		      if (pipe.isAsync) {
		        var deferred = $q.defer();
		        var onFulfilled = bind(this, this.next, args);
		        var onRejected = bind(this, this.onThrown, err);
		        deferred.promise.then(onFulfilled, onRejected);
		        pipe.apply(undefined, _toConsumableArray(args).concat([deferred]));
		      } else {
		        var isDone = Boolean(pipe.apply(undefined, _toConsumableArray(args)));
		        if (isDone) {
		          this.next(args);
		        } else {
		          this.onThrown(err);
		        }
		      }
		    };
		
		    Pipeline.prototype.exec = function exec() {
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
		
		      this.next(args);
		    };
		
		    Pipeline.prototype.onThrown = function onThrown(err) {};
		
		    Pipeline.prototype.onSuccessful = function onSuccessful() {};
		
		    return Pipeline;
		  }();
		}
		
		__identity.$inject = ['$q'];
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend,
		    forEach = _angular.forEach;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileDrop, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileDrop(options) {
		            _classCallCheck(this, FileDrop);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    drop: 'onDrop',
		                    dragover: 'onDragOver',
		                    dragleave: 'onDragLeave'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'drop'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileDrop.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileDrop.prototype.getFilters = function getFilters() {};
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDrop = function onDrop(event) {
		            var transfer = this._getTransfer(event);
		            if (!transfer) return;
		            var options = this.getOptions();
		            var filters = this.getFilters();
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		            this.uploader.addToQueue(transfer.files, options, filters);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragOver = function onDragOver(event) {
		            var transfer = this._getTransfer(event);
		            if (!this._haveFiles(transfer.types)) return;
		            transfer.dropEffect = 'copy';
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._addOverClass, this);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragLeave = function onDragLeave(event) {
		            if (event.currentTarget === this.element[0]) return;
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._getTransfer = function _getTransfer(event) {
		            return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._preventAndStop = function _preventAndStop(event) {
		            event.preventDefault();
		            event.stopPropagation();
		        };
		        /**
		         * Returns "true" if types contains files
		         * @param {Object} types
		         */
		
		
		        FileDrop.prototype._haveFiles = function _haveFiles(types) {
		            if (!types) return false;
		            if (types.indexOf) {
		                return types.indexOf('Files') !== -1;
		            } else if (types.contains) {
		                return types.contains('Files');
		            } else {
		                return false;
		            }
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._addOverClass = function _addOverClass(item) {
		            item.addOverClass();
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._removeOverClass = function _removeOverClass(item) {
		            item.removeOverClass();
		        };
		
		        return FileDrop;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular,
		    extend = _angular.extend;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileOver, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		        function FileOver(options) {
		            _classCallCheck(this, FileOver);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'over',
		                // Over class
		                overClass: 'nv-file-over'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Adds over class
		         */
		
		
		        FileOver.prototype.addOverClass = function addOverClass() {
		            this.element.addClass(this.getOverClass());
		        };
		        /**
		         * Removes over class
		         */
		
		
		        FileOver.prototype.removeOverClass = function removeOverClass() {
		            this.element.removeClass(this.getOverClass());
		        };
		        /**
		         * Returns over class
		         * @returns {String}
		         */
		
		
		        FileOver.prototype.getOverClass = function getOverClass() {
		            return this.overClass;
		        };
		
		        return FileOver;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileSelect) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileSelect({
		                uploader: uploader,
		                element: element,
		                scope: scope
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileSelect'];
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileDrop) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            if (!uploader.isHTML5) return;
		
		            var object = new FileDrop({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileDrop'];
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity(FileUploader, FileOver) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileOver({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOverClass = function () {
		                return attributes.overClass || object.overClass;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['FileUploader', 'FileOver'];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=angular-file-upload.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! angular-formly-templates-bootstrap version 6.4.0 built with ♥ by Astrism <astrisms@gmail.com>, Kent C. Dodds <kent@doddsfamily.us> (ó ì_í)=óò=(ì_í ò)
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(9), __webpack_require__(77), __webpack_require__(78));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "angular-formly", "api-check"], factory);
		else if(typeof exports === 'object')
			exports["ngFormlyTemplatesBootstrap"] = factory(require("angular"), require("angular-formly"), require("api-check"));
		else
			root["ngFormlyTemplatesBootstrap"] = factory(root["angular"], root["ngFormly"], root["apiCheck"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var ngModuleName = 'formlyBootstrap';
		var angular = __webpack_require__(2);
		var ngModule = angular.module(ngModuleName, [__webpack_require__(4)]);
		ngModule.constant('formlyBootstrapApiCheck', __webpack_require__(5)({
		  output: {
		    prefix: 'angular-formly-bootstrap'
		  }
		}));
		ngModule.constant('formlyBootstrapVersion', ("6.4.0"));
	
		__webpack_require__(6)(ngModule);
		__webpack_require__(9)(ngModule);
		__webpack_require__(19)(ngModule);
	
		exports['default'] = ngModuleName;
		module.exports = exports['default'];
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		// some versions of angular don't export the angular module properly,
		// so we get it from window in this case.
		'use strict';
	
		var angular = __webpack_require__(3);
		if (!angular.version) {
		  angular = window.angular;
		}
		module.exports = angular;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_4__;
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addWrappers);
	
		  function addWrappers(formlyConfigProvider) {
		    formlyConfigProvider.setWrapper([{
		      name: 'bootstrapLabel',
		      template: __webpack_require__(7),
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string.optional,
		            required: check.bool.optional,
		            labelSrOnly: check.bool.optional
		          }
		        };
		      }
		    }, { name: 'bootstrapHasError', template: __webpack_require__(8) }]);
		  }
		  addWrappers.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = "<div>\n  <label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? 'sr-only' : ''}}\" ng-if=\"to.label\">\n    {{to.label}}\n    {{to.required ? '*' : ''}}\n  </label>\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"form-group\" ng-class=\"{'has-error': showError}\">\n  <formly-transclude></formly-transclude>\n</div>\n"
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  __webpack_require__(10)(ngModule);
		  __webpack_require__(12)(ngModule);
		  __webpack_require__(14)(ngModule);
		  __webpack_require__(15)(ngModule);
		  __webpack_require__(17)(ngModule);
		  __webpack_require__(18)(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'checkbox',
		      template: __webpack_require__(11),
		      wrapper: ['bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            label: check.string
		          }
		        };
		      }
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"checkbox\">\n\t<label>\n\t\t<input type=\"checkbox\"\n           class=\"formly-field-checkbox\"\n\t\t       ng-model=\"model[options.key]\">\n\t\t{{to.label}}\n\t\t{{to.required ? '*' : ''}}\n\t</label>\n</div>\n"
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addCheckboxType);
	
		  function addCheckboxType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'multiCheckbox',
		      template: __webpack_require__(13),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional
		          }
		        };
		      },
		      defaultOptions: {
		        noFormControl: false,
		        ngModelAttrs: {
		          required: {
		            attribute: '',
		            bound: ''
		          }
		        }
		      },
		      controller: /* @ngInject */["$scope", function controller($scope) {
		        var to = $scope.to;
		        var opts = $scope.options;
		        $scope.multiCheckbox = {
		          checked: [],
		          change: setModel
		        };
	
		        // initialize the checkboxes check property
		        $scope.$watch('model', function modelWatcher(newModelValue) {
		          var modelValue, valueProp;
	
		          if (Object.keys(newModelValue).length) {
		            modelValue = newModelValue[opts.key];
	
		            $scope.$watch('to.options', function optionsWatcher(newOptionsValues) {
		              if (newOptionsValues && Array.isArray(newOptionsValues) && Array.isArray(modelValue)) {
		                valueProp = to.valueProp || 'value';
		                for (var index = 0; index < newOptionsValues.length; index++) {
		                  $scope.multiCheckbox.checked[index] = modelValue.indexOf(newOptionsValues[index][valueProp]) !== -1;
		                }
		              }
		            });
		          }
		        }, true);
	
		        function checkValidity(expressionValue) {
		          var valid;
	
		          if ($scope.to.required) {
		            valid = angular.isArray($scope.model[opts.key]) && $scope.model[opts.key].length > 0 && expressionValue;
	
		            $scope.fc.$setValidity('required', valid);
		          }
		        }
	
		        function setModel() {
		          $scope.model[opts.key] = [];
		          angular.forEach($scope.multiCheckbox.checked, function (checkbox, index) {
		            if (checkbox) {
		              $scope.model[opts.key].push(to.options[index][to.valueProp || 'value']);
		            }
		          });
	
		          // Must make sure we mark as touched because only the last checkbox due to a bug in angular.
		          $scope.fc.$setTouched();
		          checkValidity(true);
	
		          if ($scope.to.onChange) {
		            $scope.to.onChange();
		          }
		        }
	
		        if (opts.expressionProperties && opts.expressionProperties['templateOptions.required']) {
		          $scope.$watch(function () {
		            return $scope.to.required;
		          }, function (newValue) {
		            checkValidity(newValue);
		          });
		        }
	
		        if ($scope.to.required) {
		          var unwatchFormControl = $scope.$watch('fc', function (newValue) {
		            if (!newValue) {
		              return;
		            }
		            checkValidity(true);
		            unwatchFormControl();
		          });
		        }
		      }]
		    });
		  }
		  addCheckboxType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\"\n             id=\"{{id + '_'+ $index}}\"\n             ng-model=\"multiCheckbox.checked[$index]\"\n             ng-change=\"multiCheckbox.change()\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addInputType);
	
		  function addInputType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'input',
		      template: '<input class="form-control" ng-model="model[options.key]">',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError']
		    });
		  }
		  addInputType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addRadioType);
	
		  function addRadioType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'radio',
		      template: __webpack_require__(16),
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        noFormControl: false
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            labelProp: check.string.optional,
		            valueProp: check.string.optional,
		            inline: check.bool.optional
		          }
		        };
		      }
		    });
		  }
		  addRadioType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = "<div class=\"radio-group\">\n  <div ng-repeat=\"(key, option) in to.options\" ng-class=\"{ 'radio': !to.inline, 'radio-inline': to.inline }\">\n    <label>\n      <input type=\"radio\"\n             id=\"{{id + '_'+ $index}}\"\n             tabindex=\"0\"\n             ng-value=\"option[to.valueProp || 'value']\"\n             ng-model=\"model[options.key]\">\n      {{option[to.labelProp || 'name']}}\n    </label>\n  </div>\n</div>\n"
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addSelectType);
	
		  var template = '<select class="form-control" ng-model="model[options.key]"></select>';
	
		  function addSelectType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'select',
		      template: template,
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: function defaultOptions(options) {
		        /* jshint maxlen:195 */
		        var ngOptions = options.templateOptions.ngOptions || 'option[to.valueProp || \'value\'] as option[to.labelProp || \'name\'] group by option[to.groupProp || \'group\'] for option in to.options';
		        return {
		          ngModelAttrs: _defineProperty({}, ngOptions, {
		            value: options.templateOptions.optionsAttr || 'ng-options'
		          })
		        };
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            options: check.arrayOf(check.object),
		            optionsAttr: check.string.optional,
		            labelProp: check.string.optional,
		            valueProp: check.string.optional,
		            groupProp: check.string.optional
		          }
		        };
		      }
		    });
		  }
		  addSelectType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.config(addTextareaType);
	
		  function addTextareaType(formlyConfigProvider) {
		    formlyConfigProvider.setType({
		      name: 'textarea',
		      template: '<textarea class="form-control" ng-model="model[options.key]"></textarea>',
		      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
		      defaultOptions: {
		        ngModelAttrs: {
		          rows: { attribute: 'rows' },
		          cols: { attribute: 'cols' }
		        }
		      },
		      apiCheck: function apiCheck(check) {
		        return {
		          templateOptions: {
		            rows: check.number.optional,
		            cols: check.number.optional
		          }
		        };
		      }
		    });
		  }
		  addTextareaType.$inject = ["formlyConfigProvider"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		var _addons = __webpack_require__(20);
	
		var _addons2 = _interopRequireDefault(_addons);
	
		var _description = __webpack_require__(22);
	
		var _description2 = _interopRequireDefault(_description);
	
		exports['default'] = function (ngModule) {
		  (0, _addons2['default'])(ngModule);
		  (0, _description2['default'])(ngModule);
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addAddonsManipulator);
	
		  function addAddonsManipulator(formlyConfig, formlyBootstrapApiCheck) {
		    var addonTemplate = __webpack_require__(21);
		    var addonChecker = formlyBootstrapApiCheck.shape({
		      'class': formlyBootstrapApiCheck.string.optional,
		      text: formlyBootstrapApiCheck.string.optional,
		      onClick: formlyBootstrapApiCheck.func.optional
		    }).strict.optional;
		    var api = formlyBootstrapApiCheck.shape({
		      templateOptions: formlyBootstrapApiCheck.shape({
		        addonLeft: addonChecker,
		        addonRight: addonChecker
		      })
		    });
		    formlyConfig.templateManipulators.preWrapper.push(function (template, options) {
		      if (!options.templateOptions.addonLeft && !options.templateOptions.addonRight) {
		        return template;
		      }
		      formlyBootstrapApiCheck.warn([api], [options]);
		      return addonTemplate.replace('<formly-transclude></formly-transclude>', template);
		    });
		  }
		  addAddonsManipulator.$inject = ["formlyConfig", "formlyBootstrapApiCheck"];
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		module.exports = "<div ng-class=\"{'input-group': to.addonLeft || to.addonRight}\">\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonLeft\"\n         ng-style=\"{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonLeft.onClick(options, this, $event)\">\n        <i class=\"{{to.addonLeft.class}}\" ng-if=\"to.addonLeft.class\"></i>\n        <span ng-if=\"to.addonLeft.text\">{{to.addonLeft.text}}</span>\n    </div>\n    <formly-transclude></formly-transclude>\n    <div class=\"input-group-addon\"\n         ng-if=\"to.addonRight\"\n         ng-style=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\"\n         ng-click=\"to.addonRight.onClick(options, this, $event)\">\n        <i class=\"{{to.addonRight.class}}\" ng-if=\"to.addonRight.class\"></i>\n        <span ng-if=\"to.addonRight.text\">{{to.addonRight.text}}</span>\n    </div>\n</div>\n"
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (ngModule) {
		  ngModule.run(addDescriptionManipulator);
	
		  function addDescriptionManipulator(formlyConfig) {
		    formlyConfig.templateManipulators.preWrapper.push(function ariaDescribedBy(template, options, scope) {
		      if (angular.isDefined(options.templateOptions.description)) {
		        var el = document.createElement('div');
		        el.appendChild(angular.element(template)[0]);
		        el.appendChild(angular.element('<p id="' + scope.id + '_description"' + 'class="help-block"' + 'ng-if="to.description">' + '{{to.description}}' + '</p>')[0]);
		        var modelEls = angular.element(el.querySelectorAll('[ng-model]'));
		        if (modelEls) {
		          modelEls.attr('aria-describedby', scope.id + '_description');
		        }
		        return el.innerHTML;
		      } else {
		        return template;
		      }
		    });
		  }
		  addDescriptionManipulator.$inject = ["formlyConfig"];
		};
	
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	/**!
	 * The MIT License
	 *
	 * Copyright (c) 2013 the angular-leaflet-directive Team, http://tombatossals.github.io/angular-leaflet-directive
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 *
	 * angular-leaflet-directive
	 * https://github.com/tombatossals/angular-leaflet-directive
	 *
	 * @authors https://github.com/tombatossals/angular-leaflet-directive/graphs/contributors
	 */
	
	/*!
	*  angular-leaflet-directive  2015-11-06
	*  angular-leaflet-directive - An AngularJS directive to easily interact with Leaflet maps
	*  git: https://github.com/tombatossals/angular-leaflet-directive
	*/
	(function(angular){
	'use strict';
	angular.module('leaflet-directive', []).directive('leaflet', ["$q", "leafletData", "leafletMapDefaults", "leafletHelpers", "leafletMapEvents", function($q, leafletData, leafletMapDefaults, leafletHelpers, leafletMapEvents) {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: {
	      center: '=',
	      lfCenter: '=',
	      defaults: '=',
	      maxbounds: '=',
	      bounds: '=',
	      markers: '=',
	      legend: '=',
	      geojson: '=',
	      paths: '=',
	      tiles: '=',
	      layers: '=',
	      controls: '=',
	      decorations: '=',
	      eventBroadcast: '=',
	      markersWatchOptions: '=',
	      geojsonWatchOptions: '=',
	    },
	    transclude: true,
	    template: '<div class="angular-leaflet-map"><div ng-transclude></div></div>',
	    controller: ["$scope", function($scope) {
	      this._leafletMap = $q.defer();
	      this.getMap = function() {
	        return this._leafletMap.promise;
	      };
	
	      this.getLeafletScope = function() {
	        return $scope;
	      };
	    }],
	
	    link: function(scope, element, attrs, ctrl) {
	      var isDefined = leafletHelpers.isDefined;
	      var defaults  = leafletMapDefaults.setDefaults(scope.defaults, attrs.id);
	      var mapEvents = leafletMapEvents.getAvailableMapEvents();
	      var addEvents = leafletMapEvents.addEvents;
	
	      scope.mapId =  attrs.id;
	      leafletData.setDirectiveControls({}, attrs.id);
	
	      // Set width and height utility functions
	      function updateWidth() {
	        if (isNaN(attrs.width)) {
	          element.css('width', attrs.width);
	        } else {
	          element.css('width', attrs.width + 'px');
	        }
	      }
	
	      function updateHeight() {
	        if (isNaN(attrs.height)) {
	          element.css('height', attrs.height);
	        } else {
	          element.css('height', attrs.height + 'px');
	        }
	      }
	
	      // If the width attribute defined update css
	      // Then watch if bound property changes and update css
	      if (isDefined(attrs.width)) {
	        updateWidth();
	
	        scope.$watch(
	          function() {
	            return element[0].getAttribute('width');
	          },
	
	          function() {
	            updateWidth();
	            map.invalidateSize();
	          });
	      }
	
	      // If the height attribute defined update css
	      // Then watch if bound property changes and update css
	      if (isDefined(attrs.height)) {
	        updateHeight();
	
	        scope.$watch(
	          function() {
	            return element[0].getAttribute('height');
	          },
	
	          function() {
	            updateHeight();
	            map.invalidateSize();
	          });
	      }
	
	      // Create the Leaflet Map Object with the options
	      var map = new L.Map(element[0], leafletMapDefaults.getMapCreationDefaults(attrs.id));
	      ctrl._leafletMap.resolve(map);
	
	      if (!isDefined(attrs.center) && !isDefined(attrs.lfCenter)) {
	        map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	      }
	
	      // If no layers nor tiles defined, set the default tileLayer
	      if (!isDefined(attrs.tiles) && (!isDefined(attrs.layers))) {
	        var tileLayerObj = L.tileLayer(defaults.tileLayer, defaults.tileLayerOptions);
	        tileLayerObj.addTo(map);
	        leafletData.setTiles(tileLayerObj, attrs.id);
	      }
	
	      // Set zoom control configuration
	      if (isDefined(map.zoomControl) &&
	          isDefined(defaults.zoomControlPosition)) {
	        map.zoomControl.setPosition(defaults.zoomControlPosition);
	      }
	
	      if (isDefined(map.zoomControl) && defaults.zoomControl === false) {
	        map.zoomControl.removeFrom(map);
	      }
	
	      if (isDefined(map.zoomsliderControl) &&
	          isDefined(defaults.zoomsliderControl) &&
	          defaults.zoomsliderControl === false) {
	        map.zoomsliderControl.removeFrom(map);
	      }
	
	      // if no event-broadcast attribute, all events are broadcasted
	      if (!isDefined(attrs.eventBroadcast)) {
	        var logic = 'broadcast';
	        addEvents(map, mapEvents, 'eventName', scope, logic);
	      }
	
	      // Resolve the map object to the promises
	      map.whenReady(function() {
	        leafletData.setMap(map, attrs.id);
	      });
	
	      scope.$on('$destroy', function() {
	        leafletMapDefaults.reset();
	        map.remove();
	        leafletData.unresolveMap(attrs.id);
	      });
	
	      //Handle request to invalidate the map size
	      //Up scope using $scope.$emit('invalidateSize')
	      //Down scope using $scope.$broadcast('invalidateSize')
	      scope.$on('invalidateSize', function() {
	        map.invalidateSize();
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').factory('leafletBoundsHelpers', ["$log", "leafletHelpers", function($log, leafletHelpers) {
	
	  var isArray = leafletHelpers.isArray;
	  var isNumber = leafletHelpers.isNumber;
	  var isFunction = leafletHelpers.isFunction;
	  var isDefined = leafletHelpers.isDefined;
	
	  function _isValidBounds(bounds) {
	    return angular.isDefined(bounds) && angular.isDefined(bounds.southWest) &&
	           angular.isDefined(bounds.northEast) && angular.isNumber(bounds.southWest.lat) &&
	           angular.isNumber(bounds.southWest.lng) && angular.isNumber(bounds.northEast.lat) &&
	           angular.isNumber(bounds.northEast.lng);
	  }
	
	  return {
	    createLeafletBounds: function(bounds) {
	      if (_isValidBounds(bounds)) {
	        return L.latLngBounds([bounds.southWest.lat, bounds.southWest.lng],
	                              [bounds.northEast.lat, bounds.northEast.lng]);
	      }
	    },
	
	    isValidBounds: _isValidBounds,
	
	    createBoundsFromArray: function(boundsArray) {
	      if (!(isArray(boundsArray) && boundsArray.length === 2 &&
	            isArray(boundsArray[0]) && isArray(boundsArray[1]) &&
	            boundsArray[0].length === 2 && boundsArray[1].length === 2 &&
	            isNumber(boundsArray[0][0]) && isNumber(boundsArray[0][1]) &&
	            isNumber(boundsArray[1][0]) && isNumber(boundsArray[1][1]))) {
	        $log.error('[AngularJS - Leaflet] The bounds array is not valid.');
	        return;
	      }
	
	      return {
	        northEast: {
	          lat: boundsArray[0][0],
	          lng: boundsArray[0][1],
	        },
	        southWest: {
	          lat: boundsArray[1][0],
	          lng: boundsArray[1][1],
	        },
	      };
	    },
	
	    createBoundsFromLeaflet: function(lfBounds) {
	      if (!(isDefined(lfBounds) && isFunction(lfBounds.getNorthEast) && isFunction(lfBounds.getSouthWest))) {
	        $log.error('[AngularJS - Leaflet] The leaflet bounds is not valid object.');
	        return;
	      }
	
	      var northEast = lfBounds.getNorthEast();
	      var southWest = lfBounds.getSouthWest();
	
	      return {
	        northEast: {
	          lat: northEast.lat,
	          lng: northEast.lng,
	        },
	        southWest: {
	          lat: southWest.lat,
	          lng: southWest.lng,
	        },
	      };
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').factory('leafletControlHelpers', ["$rootScope", "$log", "leafletHelpers", "leafletLayerHelpers", "leafletMapDefaults", function($rootScope, $log, leafletHelpers, leafletLayerHelpers, leafletMapDefaults) {
	  var isDefined = leafletHelpers.isDefined;
	  var isObject = leafletHelpers.isObject;
	  var createLayer = leafletLayerHelpers.createLayer;
	  var _controls = {};
	  var errorHeader = leafletHelpers.errorHeader + ' [Controls] ';
	
	  var _controlLayersMustBeVisible = function(baselayers, overlays, mapId) {
	    var defaults = leafletMapDefaults.getDefaults(mapId);
	    if (!defaults.controls.layers.visible) {
	      return false;
	    }
	
	    var atLeastOneControlItemMustBeShown = false;
	
	    if (isObject(baselayers)) {
	      Object.keys(baselayers).forEach(function(key) {
	        var layer = baselayers[key];
	        if (!isDefined(layer.layerOptions) || layer.layerOptions.showOnSelector !== false) {
	          atLeastOneControlItemMustBeShown = true;
	        }
	      });
	    }
	
	    if (isObject(overlays)) {
	      Object.keys(overlays).forEach(function(key) {
	        var layer = overlays[key];
	        if (!isDefined(layer.layerParams) || layer.layerParams.showOnSelector !== false) {
	          atLeastOneControlItemMustBeShown = true;
	        }
	      });
	    }
	
	    return atLeastOneControlItemMustBeShown;
	  };
	
	  var _createLayersControl = function(mapId) {
	    var defaults = leafletMapDefaults.getDefaults(mapId);
	    var controlOptions = {
	      collapsed: defaults.controls.layers.collapsed,
	      position: defaults.controls.layers.position,
	      autoZIndex: false,
	    };
	
	    angular.extend(controlOptions, defaults.controls.layers.options);
	
	    var control;
	    if (defaults.controls.layers && isDefined(defaults.controls.layers.control)) {
	      control = defaults.controls.layers.control.apply(this, [[], [], controlOptions]);
	    } else {
	      control = new L.control.layers([], [], controlOptions);
	    }
	
	    return control;
	  };
	
	  var controlTypes = {
	    draw: {
	      isPluginLoaded: function() {
	        if (!angular.isDefined(L.Control.Draw)) {
	          $log.error(errorHeader + ' Draw plugin is not loaded.');
	          return false;
	        }
	
	        return true;
	      },
	
	      checkValidParams: function(/* params */) {
	        return true;
	      },
	
	      createControl: function(params) {
	        return new L.Control.Draw(params);
	      },
	    },
	    scale: {
	      isPluginLoaded: function() {
	        return true;
	      },
	
	      checkValidParams: function(/* params */) {
	        return true;
	      },
	
	      createControl: function(params) {
	        return new L.control.scale(params);
	      },
	    },
	    fullscreen: {
	      isPluginLoaded: function() {
	        if (!angular.isDefined(L.Control.Fullscreen)) {
	          $log.error(errorHeader + ' Fullscreen plugin is not loaded.');
	          return false;
	        }
	
	        return true;
	      },
	
	      checkValidParams: function(/* params */) {
	        return true;
	      },
	
	      createControl: function(params) {
	        return new L.Control.Fullscreen(params);
	      },
	    },
	    search: {
	      isPluginLoaded: function() {
	        if (!angular.isDefined(L.Control.Search)) {
	          $log.error(errorHeader + ' Search plugin is not loaded.');
	          return false;
	        }
	
	        return true;
	      },
	
	      checkValidParams: function(/* params */) {
	        return true;
	      },
	
	      createControl: function(params) {
	        return new L.Control.Search(params);
	      },
	    },
	    custom: {},
	    minimap: {
	      isPluginLoaded: function() {
	        if (!angular.isDefined(L.Control.MiniMap)) {
	          $log.error(errorHeader + ' Minimap plugin is not loaded.');
	          return false;
	        }
	
	        return true;
	      },
	
	      checkValidParams: function(params) {
	        if (!isDefined(params.layer)) {
	          $log.warn(errorHeader + ' minimap "layer" option should be defined.');
	          return false;
	        }
	
	        return true;
	      },
	
	      createControl: function(params) {
	        var layer = createLayer(params.layer);
	
	        if (!isDefined(layer)) {
	          $log.warn(errorHeader + ' minimap control "layer" could not be created.');
	          return;
	        }
	
	        return new L.Control.MiniMap(layer, params);
	      },
	    },
	  };
	
	  return {
	    layersControlMustBeVisible: _controlLayersMustBeVisible,
	
	    isValidControlType: function(type) {
	      return Object.keys(controlTypes).indexOf(type) !== -1;
	    },
	
	    createControl: function(type, params) {
	      if (!controlTypes[type].checkValidParams(params)) {
	        return;
	      }
	
	      return controlTypes[type].createControl(params);
	    },
	
	    updateLayersControl: function(map, mapId, loaded, baselayers, overlays, leafletLayers) {
	      var i;
	      var _layersControl = _controls[mapId];
	      var mustBeLoaded = _controlLayersMustBeVisible(baselayers, overlays, mapId);
	
	      if (isDefined(_layersControl) && loaded) {
	        for (i in leafletLayers.baselayers) {
	          _layersControl.removeLayer(leafletLayers.baselayers[i]);
	        }
	
	        for (i in leafletLayers.overlays) {
	          _layersControl.removeLayer(leafletLayers.overlays[i]);
	        }
	
	        map.removeControl(_layersControl);
	        delete _controls[mapId];
	      }
	
	      if (mustBeLoaded) {
	        _layersControl = _createLayersControl(mapId);
	        _controls[mapId] = _layersControl;
	        for (i in baselayers) {
	          var hideOnSelector = isDefined(baselayers[i].layerOptions) &&
	                               baselayers[i].layerOptions.showOnSelector === false;
	          if (!hideOnSelector && isDefined(leafletLayers.baselayers[i])) {
	            _layersControl.addBaseLayer(leafletLayers.baselayers[i], baselayers[i].name);
	          }
	        }
	
	        for (i in overlays) {
	          var hideOverlayOnSelector = isDefined(overlays[i].layerParams) &&
	                      overlays[i].layerParams.showOnSelector === false;
	          if (!hideOverlayOnSelector && isDefined(leafletLayers.overlays[i])) {
	            _layersControl.addOverlay(leafletLayers.overlays[i], overlays[i].name);
	          }
	        }
	
	        map.addControl(_layersControl);
	      }
	
	      return mustBeLoaded;
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').service('leafletData', ["$log", "$q", "leafletHelpers", function($log, $q, leafletHelpers) {
	  var getDefer = leafletHelpers.getDefer,
	      getUnresolvedDefer = leafletHelpers.getUnresolvedDefer,
	      setResolvedDefer = leafletHelpers.setResolvedDefer;
	
	  var _private = {};
	  var self = this;
	
	  var upperFirst = function(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  };
	
	  var _privateItems = [
	      'map',
	      'tiles',
	      'layers',
	      'paths',
	      'markers',
	      'geoJSON',
	      'UTFGrid', //odd ball on naming convention keeping to not break
	      'decorations',
	      'directiveControls', ];
	
	  //init
	  _privateItems.forEach(function(itemName) {
	    _private[itemName] = {};
	  });
	
	  this.unresolveMap = function(scopeId) {
	    var id = leafletHelpers.obtainEffectiveMapId(_private.map, scopeId);
	    _privateItems.forEach(function(itemName) {
	      _private[itemName][id] = undefined;
	    });
	  };
	
	  //int repetitive stuff (get and sets)
	  _privateItems.forEach(function(itemName) {
	    var name = upperFirst(itemName);
	    self['set' + name] = function(lObject, scopeId) {
	      var defer = getUnresolvedDefer(_private[itemName], scopeId);
	      defer.resolve(lObject);
	      setResolvedDefer(_private[itemName], scopeId);
	    };
	
	    self['get' + name] = function(scopeId) {
	      var defer = getDefer(_private[itemName], scopeId);
	      return defer.promise;
	    };
	  });
	}]);
	
	angular.module('leaflet-directive')
	.service('leafletDirectiveControlsHelpers', ["$log", "leafletData", "leafletHelpers", function($log, leafletData, leafletHelpers) {
	  var _isDefined = leafletHelpers.isDefined;
	  var _isString = leafletHelpers.isString;
	  var _isObject = leafletHelpers.isObject;
	  var _mainErrorHeader = leafletHelpers.errorHeader;
	
	  var _errorHeader = _mainErrorHeader + '[leafletDirectiveControlsHelpers';
	
	  var _extend = function(id, thingToAddName, createFn, cleanFn) {
	    var _fnHeader = _errorHeader + '.extend] ';
	    var extender = {};
	    if (!_isDefined(thingToAddName)) {
	      $log.error(_fnHeader + 'thingToAddName cannot be undefined');
	      return;
	    }
	
	    if (_isString(thingToAddName) && _isDefined(createFn) && _isDefined(cleanFn)) {
	      extender[thingToAddName] = {
	        create: createFn,
	        clean: cleanFn,
	      };
	    }    else if (_isObject(thingToAddName) && !_isDefined(createFn) && !_isDefined(cleanFn)) {
	      extender = thingToAddName;
	    }    else {
	      $log.error(_fnHeader + 'incorrect arguments');
	      return;
	    }
	
	    //add external control to create / destroy markers without a watch
	    leafletData.getDirectiveControls().then(function(controls) {
	      angular.extend(controls, extender);
	      leafletData.setDirectiveControls(controls, id);
	    });
	  };
	
	  return {
	    extend: _extend,
	  };
	}]);
	
	angular.module('leaflet-directive')
	.service('leafletGeoJsonHelpers', ["leafletHelpers", "leafletIterators", function(leafletHelpers, leafletIterators) {
	  var lHlp = leafletHelpers;
	  var lIt = leafletIterators;
	  var Point = function(lat, lng) {
	    this.lat = lat;
	    this.lng = lng;
	    return this;
	  };
	
	  var _getLat = function(value) {
	    if (Array.isArray(value) && value.length === 2) {
	      return value[1];
	    } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	      return +value.coordinates[1];
	    } else {
	      return +value.lat;
	    }
	  };
	
	  var _getLng = function(value) {
	    if (Array.isArray(value) && value.length === 2) {
	      return value[0];
	    } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	      return +value.coordinates[0];
	    } else {
	      return +value.lng;
	    }
	  };
	
	  var _validateCoords = function(coords) {
	    if (lHlp.isUndefined(coords)) {
	      return false;
	    }
	
	    if (lHlp.isArray(coords)) {
	      if (coords.length === 2 && lHlp.isNumber(coords[0]) && lHlp.isNumber(coords[1])) {
	        return true;
	      }
	    } else if (lHlp.isDefined(coords.type)) {
	      if (
	          coords.type === 'Point' && lHlp.isArray(coords.coordinates) &&
	          coords.coordinates.length === 2  &&
	          lHlp.isNumber(coords.coordinates[0]) &&
	          lHlp.isNumber(coords.coordinates[1])) {
	        return true;
	      }
	    }
	
	    var ret = lIt.all(['lat', 'lng'], function(pos) {
	      return lHlp.isDefined(coords[pos]) && lHlp.isNumber(coords[pos]);
	    });
	
	    return ret;
	  };
	
	  var _getCoords = function(value) {
	    if (!value || !_validateCoords(value)) {
	      return;
	    }
	
	    var p =  null;
	    if (Array.isArray(value) && value.length === 2) {
	      p = new Point(value[1], value[0]);
	    } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
	      p = new Point(value.coordinates[1], value.coordinates[0]);
	    } else {
	      return value;
	    }
	
	    //note angular.merge is avail in angular 1.4.X we might want to fill it here
	    return angular.extend(value, p);//tap on lat, lng if it doesnt exist
	  };
	
	  return {
	    getLat: _getLat,
	    getLng: _getLng,
	    validateCoords: _validateCoords,
	    getCoords: _getCoords,
	  };
	}]);
	
	angular.module('leaflet-directive').service('leafletHelpers', ["$q", "$log", function($q, $log) {
	  var _errorHeader = '[AngularJS - Leaflet] ';
	  var _copy = angular.copy;
	  var _clone = _copy;
	  /*
	  For parsing paths to a field in an object
	
	  Example:
	  var obj = {
	      bike:{
	       1: 'hi'
	       2: 'foo'
	      }
	  };
	  _getObjectValue(obj,"bike.1") returns 'hi'
	  this is getPath in ui-gmap
	   */
	  var _getObjectValue = function(object, pathStr) {
	    var obj;
	    if (!object || !angular.isObject(object))
	        return;
	
	    //if the key is not a sting then we already have the value
	    if ((pathStr === null) || !angular.isString(pathStr)) {
	      return pathStr;
	    }
	
	    obj = object;
	    pathStr.split('.').forEach(function(value) {
	      if (obj) {
	        obj = obj[value];
	      }
	    });
	
	    return obj;
	  };
	
	  /*
	   Object Array Notation
	   _getObjectArrayPath("bike.one.two")
	   returns:
	   'bike["one"]["two"]'
	   */
	  var _getObjectArrayPath = function(pathStr) {
	    return pathStr.split('.').reduce(function(previous, current) {
	      return previous + '["' + current + '"]';
	    });
	  };
	
	  /* Object Dot Notation
	   _getObjectPath(["bike","one","two"])
	   returns:
	   "bike.one.two"
	   */
	  var _getObjectDotPath = function(arrayOfStrings) {
	    return arrayOfStrings.reduce(function(previous, current) {
	      return previous + '.' + current;
	    });
	  };
	
	  function _obtainEffectiveMapId(d, mapId) {
	    var id;
	    var i;
	    if (!angular.isDefined(mapId)) {
	      if (Object.keys(d).length === 0) {
	        id = 'main';
	      } else if (Object.keys(d).length >= 1) {
	        for (i in d) {
	          if (d.hasOwnProperty(i)) {
	            id = i;
	          }
	        }
	      } else {
	        $log.error(_errorHeader + '- You have more than 1 map on the DOM, you must provide the map ID to the leafletData.getXXX call');
	      }
	    } else {
	      id = mapId;
	    }
	
	    return id;
	  }
	
	  function _getUnresolvedDefer(d, mapId) {
	    var id = _obtainEffectiveMapId(d, mapId);
	    var defer;
	
	    if (!angular.isDefined(d[id]) || d[id].resolvedDefer === true) {
	      defer = $q.defer();
	      d[id] = {
	        defer: defer,
	        resolvedDefer: false,
	      };
	    } else {
	      defer = d[id].defer;
	    }
	
	    return defer;
	  }
	
	  var _isDefined = function(value) {
	    return angular.isDefined(value) && value !== null;
	  };
	
	  var _isUndefined = function(value) {
	    return !_isDefined(value);
	  };
	
	  // BEGIN DIRECT PORT FROM AngularJS code base
	
	  var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	
	  var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	
	  var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	
	  /**
	  Converts snake_case to camelCase.
	  Also there is special case for Moz prefix starting with upper case letter.
	  @param name Name to normalize
	   */
	
	  var camelCase = function(name) {
	      return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	        if (offset) {
	          return letter.toUpperCase();
	        } else {
	          return letter;
	        }
	      }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	    };
	
	  /**
	  Converts all accepted directives format into proper directive name.
	  @param name Name to normalize
	   */
	
	  var directiveNormalize = function(name) {
	      return camelCase(name.replace(PREFIX_REGEXP, ''));
	    };
	
	  // END AngularJS port
	
	  return {
	    camelCase: camelCase,
	    directiveNormalize: directiveNormalize,
	    copy:_copy,
	    clone:_clone,
	    errorHeader: _errorHeader,
	    getObjectValue: _getObjectValue,
	    getObjectArrayPath:_getObjectArrayPath,
	    getObjectDotPath: _getObjectDotPath,
	    defaultTo: function(val, _default) {
	      return _isDefined(val) ? val : _default;
	    },
	
	    //mainly for checking attributes of directives lets keep this minimal (on what we accept)
	    isTruthy: function(val) {
	      return val === 'true' || val === true;
	    },
	
	    //Determine if a reference is {}
	    isEmpty: function(value) {
	      return Object.keys(value).length === 0;
	    },
	
	    //Determine if a reference is undefined or {}
	    isUndefinedOrEmpty: function(value) {
	      return (angular.isUndefined(value) || value === null) || Object.keys(value).length === 0;
	    },
	
	    // Determine if a reference is defined
	    isDefined: _isDefined,
	    isUndefined:_isUndefined,
	    isNumber: angular.isNumber,
	    isString: angular.isString,
	    isArray: angular.isArray,
	    isObject: angular.isObject,
	    isFunction: angular.isFunction,
	    equals: angular.equals,
	
	    isValidCenter: function(center) {
	      return angular.isDefined(center) && angular.isNumber(center.lat) &&
	             angular.isNumber(center.lng) && angular.isNumber(center.zoom);
	    },
	
	    isValidPoint: function(point) {
	      if (!angular.isDefined(point)) {
	        return false;
	      }
	
	      if (angular.isArray(point)) {
	        return point.length === 2 && angular.isNumber(point[0]) && angular.isNumber(point[1]);
	      }
	
	      return angular.isNumber(point.lat) && angular.isNumber(point.lng);
	    },
	
	    isSameCenterOnMap: function(centerModel, map) {
	      var mapCenter = map.getCenter();
	      var zoom = map.getZoom();
	      if (centerModel.lat && centerModel.lng &&
	          mapCenter.lat.toFixed(4) === centerModel.lat.toFixed(4) &&
	          mapCenter.lng.toFixed(4) === centerModel.lng.toFixed(4) &&
	          zoom === centerModel.zoom) {
	        return true;
	      }
	
	      return false;
	    },
	
	    safeApply: function($scope, fn) {
	      var phase = $scope.$root.$$phase;
	      if (phase === '$apply' || phase === '$digest') {
	        $scope.$eval(fn);
	      } else {
	        $scope.$evalAsync(fn);
	      }
	    },
	
	    obtainEffectiveMapId: _obtainEffectiveMapId,
	
	    getDefer: function(d, mapId) {
	      var id = _obtainEffectiveMapId(d, mapId);
	      var defer;
	      if (!angular.isDefined(d[id]) || d[id].resolvedDefer === false) {
	        defer = _getUnresolvedDefer(d, mapId);
	      } else {
	        defer = d[id].defer;
	      }
	
	      return defer;
	    },
	
	    getUnresolvedDefer: _getUnresolvedDefer,
	
	    setResolvedDefer: function(d, mapId) {
	      var id = _obtainEffectiveMapId(d, mapId);
	      d[id].resolvedDefer = true;
	    },
	
	    rangeIsSupported: function() {
	      var testrange = document.createElement('input');
	      testrange.setAttribute('type', 'range');
	      return testrange.type === 'range';
	    },
	
	    FullScreenControlPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.Control.Fullscreen);
	      },
	    },
	
	    MiniMapControlPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.Control.MiniMap);
	      },
	    },
	
	    AwesomeMarkersPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.AwesomeMarkers) && angular.isDefined(L.AwesomeMarkers.Icon);
	      },
	
	      is: function(icon) {
	        if (this.isLoaded()) {
	          return icon instanceof L.AwesomeMarkers.Icon;
	        } else {
	          return false;
	        }
	      },
	
	      equal: function(iconA, iconB) {
	        if (!this.isLoaded()) {
	          return false;
	        }
	
	        if (this.is(iconA)) {
	          return angular.equals(iconA, iconB);
	        } else {
	          return false;
	        }
	      },
	    },
	
	    VectorMarkersPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.VectorMarkers) && angular.isDefined(L.VectorMarkers.Icon);
	      },
	
	      is: function(icon) {
	        if (this.isLoaded()) {
	          return icon instanceof L.VectorMarkers.Icon;
	        } else {
	          return false;
	        }
	      },
	
	      equal: function(iconA, iconB) {
	        if (!this.isLoaded()) {
	          return false;
	        }
	
	        if (this.is(iconA)) {
	          return angular.equals(iconA, iconB);
	        } else {
	          return false;
	        }
	      },
	    },
	
	    DomMarkersPlugin: {
	      isLoaded: function() {
	        if (angular.isDefined(L.DomMarkers) && angular.isDefined(L.DomMarkers.Icon)) {
	          return true;
	        } else {
	          return false;
	        }
	      },
	
	      is: function(icon) {
	        if (this.isLoaded()) {
	          return icon instanceof L.DomMarkers.Icon;
	        } else {
	          return false;
	        }
	      },
	
	      equal: function(iconA, iconB) {
	        if (!this.isLoaded()) {
	          return false;
	        }
	
	        if (this.is(iconA)) {
	          return angular.equals(iconA, iconB);
	        } else {
	          return false;
	        }
	      },
	    },
	
	    PolylineDecoratorPlugin: {
	      isLoaded: function() {
	        if (angular.isDefined(L.PolylineDecorator)) {
	          return true;
	        } else {
	          return false;
	        }
	      },
	
	      is: function(decoration) {
	        if (this.isLoaded()) {
	          return decoration instanceof L.PolylineDecorator;
	        } else {
	          return false;
	        }
	      },
	
	      equal: function(decorationA, decorationB) {
	        if (!this.isLoaded()) {
	          return false;
	        }
	
	        if (this.is(decorationA)) {
	          return angular.equals(decorationA, decorationB);
	        } else {
	          return false;
	        }
	      },
	    },
	
	    MakiMarkersPlugin: {
	      isLoaded: function() {
	        if (angular.isDefined(L.MakiMarkers) && angular.isDefined(L.MakiMarkers.Icon)) {
	          return true;
	        } else {
	          return false;
	        }
	      },
	
	      is: function(icon) {
	        if (this.isLoaded()) {
	          return icon instanceof L.MakiMarkers.Icon;
	        } else {
	          return false;
	        }
	      },
	
	      equal: function(iconA, iconB) {
	        if (!this.isLoaded()) {
	          return false;
	        }
	
	        if (this.is(iconA)) {
	          return angular.equals(iconA, iconB);
	        } else {
	          return false;
	        }
	      },
	    },
	    ExtraMarkersPlugin: {
	      isLoaded: function() {
	        if (angular.isDefined(L.ExtraMarkers) && angular.isDefined(L.ExtraMarkers.Icon)) {
	          return true;
	        } else {
	          return false;
	        }
	      },
	
	      is: function(icon) {
	        if (this.isLoaded()) {
	          return icon instanceof L.ExtraMarkers.Icon;
	        } else {
	          return false;
	        }
	      },
	
	      equal: function(iconA, iconB) {
	        if (!this.isLoaded()) {
	          return false;
	        }
	
	        if (this.is(iconA)) {
	          return angular.equals(iconA, iconB);
	        } else {
	          return false;
	        }
	      },
	    },
	    LabelPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.Label);
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.MarkerClusterGroup;
	        } else {
	          return false;
	        }
	      },
	    },
	    MarkerClusterPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.MarkerClusterGroup);
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.MarkerClusterGroup;
	        } else {
	          return false;
	        }
	      },
	    },
	    GoogleLayerPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.Google);
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.Google;
	        } else {
	          return false;
	        }
	      },
	    },
	    LeafletProviderPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.TileLayer.Provider);
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.TileLayer.Provider;
	        } else {
	          return false;
	        }
	      },
	    },
	    ChinaLayerPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.tileLayer.chinaProvider);
	      },
	    },
	    HeatLayerPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.heatLayer);
	      },
	    },
	    WebGLHeatMapLayerPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.TileLayer.WebGLHeatMap);
	      },
	    },
	    BingLayerPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.BingLayer);
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.BingLayer;
	        } else {
	          return false;
	        }
	      },
	    },
	    WFSLayerPlugin: {
	      isLoaded: function() {
	        return L.GeoJSON.WFS !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.GeoJSON.WFS;
	        } else {
	          return false;
	        }
	      },
	    },
	    AGSBaseLayerPlugin: {
	      isLoaded: function() {
	        return L.esri !== undefined && L.esri.basemapLayer !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.esri.basemapLayer;
	        } else {
	          return false;
	        }
	      },
	    },
	    AGSLayerPlugin: {
	      isLoaded: function() {
	        return lvector !== undefined && lvector.AGS !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof lvector.AGS;
	        } else {
	          return false;
	        }
	      },
	    },
	    AGSFeatureLayerPlugin: {
	      isLoaded: function() {
	        return L.esri !== undefined && L.esri.featureLayer !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.esri.featureLayer;
	        } else {
	          return false;
	        }
	      },
	    },
	    AGSTiledMapLayerPlugin: {
	      isLoaded: function() {
	        return L.esri !== undefined && L.esri.tiledMapLayer !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.esri.tiledMapLayer;
	        } else {
	          return false;
	        }
	      },
	    },
	    AGSDynamicMapLayerPlugin: {
	      isLoaded: function() {
	        return L.esri !== undefined && L.esri.dynamicMapLayer !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.esri.dynamicMapLayer;
	        } else {
	          return false;
	        }
	      },
	    },
	    AGSImageMapLayerPlugin: {
	      isLoaded: function() {
	        return L.esri !== undefined && L.esri.imageMapLayer !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.esri.imageMapLayer;
	        } else {
	          return false;
	        }
	      },
	    },
	    AGSClusteredLayerPlugin: {
	      isLoaded: function() {
	        return L.esri !== undefined && L.esri.clusteredFeatureLayer !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.esri.clusteredFeatureLayer;
	        } else {
	          return false;
	        }
	      },
	    },
	    AGSHeatmapLayerPlugin: {
	      isLoaded: function() {
	        return L.esri !== undefined && L.esri.heatmapFeatureLayer !== undefined;
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.esri.heatmapFeatureLayer;
	        } else {
	          return false;
	        }
	      },
	    },
	    YandexLayerPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.Yandex);
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.Yandex;
	        } else {
	          return false;
	        }
	      },
	    },
	    GeoJSONPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.TileLayer.GeoJSON);
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.TileLayer.GeoJSON;
	        } else {
	          return false;
	        }
	      },
	    },
	    UTFGridPlugin: {
	      isLoaded: function() {
	        return angular.isDefined(L.UtfGrid);
	      },
	
	      is: function(layer) {
	        if (this.isLoaded()) {
	          return layer instanceof L.UtfGrid;
	        } else {
	          $log.error('[AngularJS - Leaflet] No UtfGrid plugin found.');
	          return false;
	        }
	      },
	    },
	    CartoDB: {
	      isLoaded: function() {
	        return cartodb;
	      },
	
	      is: function(/*layer*/) {
	        return true;
	        /*
	        if (this.isLoaded()) {
	            return layer instanceof L.TileLayer.GeoJSON;
	        } else {
	            return false;
	        }*/
	      },
	    },
	    Leaflet: {
	      DivIcon: {
	        is: function(icon) {
	          return icon instanceof L.DivIcon;
	        },
	
	        equal: function(iconA, iconB) {
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        },
	      },
	      Icon: {
	        is: function(icon) {
	          return icon instanceof L.Icon;
	        },
	
	        equal: function(iconA, iconB) {
	          if (this.is(iconA)) {
	            return angular.equals(iconA, iconB);
	          } else {
	            return false;
	          }
	        },
	      },
	    },
	    /*
	     watchOptions - object to set deep nested watches and turn off watches all together
	     (rely on control / functional updates)
	     watchOptions - Object
	         doWatch:boolean
	         isDeep:boolean (sets $watch(function,isDeep))
	         individual
	             doWatch:boolean
	             isDeep:boolean
	     */
	
	    //legacy defaults
	    watchOptions: {
	      doWatch:true,
	      isDeep: true,
	      individual:{
	        doWatch:true,
	        isDeep: true,
	      },
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').service('leafletIterators', ["$log", "leafletHelpers", function($log, leafletHelpers) {
	
	  var lHlp = leafletHelpers;
	  var errorHeader = leafletHelpers.errorHeader + 'leafletIterators: ';
	
	  //BEGIN COPY from underscore
	  var _keys = Object.keys;
	  var _isFunction = lHlp.isFunction;
	  var _isObject = lHlp.isObject;
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  var _isArrayLike = function(collection) {
	    var length = collection !== null && collection.length;
	    return lHlp.isNumber(length) && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Keep the identity function around for default iteratees.
	  var _identity = function(value) {
	    return value;
	  };
	
	  var _property = function(key) {
	    return function(obj) {
	      return obj === null ? void 0 : obj[key];
	    };
	  };
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount === null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj === null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index];
	        var keys = keysFunc(source);
	        var l = keys.length;
	
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	
	      return obj;
	    };
	  };
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var _extendOwn;
	  var _assign = null;
	  _extendOwn = _assign = createAssigner(_keys);
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  var _isMatch = function(object, attrs) {
	    var keys = _keys(attrs);
	    var length = keys.length;
	    if (object === null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	
	    return true;
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  var _matcher;
	  var _matches = null;
	  _matcher = _matches = function(attrs) {
	    attrs = _extendOwn({}, attrs);
	    return function(obj) {
	      return _isMatch(obj, attrs);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value === null) return _identity;
	    if (_isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_isObject(value)) return _matcher(value);
	    return _property(value);
	  };
	
	  var _every;
	  var _all = null;
	  _every = _all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !_isArrayLike(obj) && _keys(obj);
	    var length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	
	    return true;
	  };
	
	  //END COPY fron underscore
	
	  var _hasErrors = function(collection, cb, ignoreCollection, cbName) {
	    if (!ignoreCollection) {
	      if (!lHlp.isDefined(collection) || !lHlp.isDefined(cb)) {
	        return true;
	      }
	    }
	
	    if (!lHlp.isFunction(cb)) {
	      cbName = lHlp.defaultTo(cb, 'cb');
	      $log.error(errorHeader + cbName + ' is not a function');
	      return true;
	    }
	
	    return false;
	  };
	
	  var _iterate = function(collection, externalCb, internalCb) {
	    if (_hasErrors(undefined, internalCb, true, 'internalCb')) {
	      return;
	    }
	
	    if (!_hasErrors(collection, externalCb)) {
	      for (var key in collection) {
	        if (collection.hasOwnProperty(key)) {
	          internalCb(collection[key], key);
	        }
	      }
	    }
	  };
	
	  //see http://jsperf.com/iterators/3
	  //utilizing for in is way faster
	  var _each = function(collection, cb) {
	    _iterate(collection, cb, function(val, key) {
	      cb(val, key);
	    });
	  };
	
	  return {
	    each:_each,
	    forEach: _each,
	    every: _every,
	    all: _all,
	  };
	}]);
	
	angular.module('leaflet-directive')
	.factory('leafletLayerHelpers', ["$rootScope", "$log", "$q", "leafletHelpers", "leafletIterators", function($rootScope, $log, $q, leafletHelpers, leafletIterators) {
	  var Helpers = leafletHelpers;
	  var isString = leafletHelpers.isString;
	  var isObject = leafletHelpers.isObject;
	  var isArray = leafletHelpers.isArray;
	  var isDefined = leafletHelpers.isDefined;
	  var errorHeader = leafletHelpers.errorHeader;
	  var $it = leafletIterators;
	
	  var utfGridCreateLayer = function(params) {
	    if (!Helpers.UTFGridPlugin.isLoaded()) {
	      $log.error('[AngularJS - Leaflet] The UTFGrid plugin is not loaded.');
	      return;
	    }
	
	    var utfgrid = new L.UtfGrid(params.url, params.pluginOptions);
	
	    utfgrid.on('mouseover', function(e) {
	      $rootScope.$broadcast('leafletDirectiveMap.utfgridMouseover', e);
	    });
	
	    utfgrid.on('mouseout', function(e) {
	      $rootScope.$broadcast('leafletDirectiveMap.utfgridMouseout', e);
	    });
	
	    utfgrid.on('click', function(e) {
	      $rootScope.$broadcast('leafletDirectiveMap.utfgridClick', e);
	    });
	
	    utfgrid.on('mousemove', function(e) {
	      $rootScope.$broadcast('leafletDirectiveMap.utfgridMousemove', e);
	    });
	
	    return utfgrid;
	  };
	
	  var layerTypes = {
	    xyz: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        return L.tileLayer(params.url, params.options);
	      },
	    },
	    mapbox: {
	      mustHaveKey: true,
	      createLayer: function(params) {
	        var version = 3;
	        if (isDefined(params.options.version) && params.options.version === 4) {
	          version = params.options.version;
	        }
	
	        var url = version === 3 ?
	            '//{s}.tiles.mapbox.com/v3/' + params.key + '/{z}/{x}/{y}.png' :
	            '//api.tiles.mapbox.com/v4/' + params.key + '/{z}/{x}/{y}.png?access_token=' + params.apiKey;
	        return L.tileLayer(url, params.options);
	      },
	    },
	    geoJSON: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        if (!Helpers.GeoJSONPlugin.isLoaded()) {
	          return;
	        }
	
	        return new L.TileLayer.GeoJSON(params.url, params.pluginOptions, params.options);
	      },
	    },
	    geoJSONShape: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        return new L.GeoJSON(params.data,
	            params.options);
	      },
	    },
	    geoJSONAwesomeMarker: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        return new L.geoJson(params.data, {
	          pointToLayer: function(feature, latlng) {
	            return L.marker(latlng, {icon: L.AwesomeMarkers.icon(params.icon)});
	          },
	        });
	      },
	    },
	    geoJSONVectorMarker: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        return new L.geoJson(params.data, {
	          pointToLayer: function(feature, latlng) {
	            return L.marker(latlng, {icon: L.VectorMarkers.icon(params.icon)});
	          },
	        });
	      },
	    },
	    utfGrid: {
	      mustHaveUrl: true,
	      createLayer: utfGridCreateLayer,
	    },
	    cartodbTiles: {
	      mustHaveKey: true,
	      createLayer: function(params) {
	        var url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/{z}/{x}/{y}.png';
	        return L.tileLayer(url, params.options);
	      },
	    },
	    cartodbUTFGrid: {
	      mustHaveKey: true,
	      mustHaveLayer: true,
	      createLayer: function(params) {
	        params.url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/' + params.layer + '/{z}/{x}/{y}.grid.json';
	        return utfGridCreateLayer(params);
	      },
	    },
	    cartodbInteractive: {
	      mustHaveKey: true,
	      mustHaveLayer: true,
	      createLayer: function(params) {
	        var tilesURL = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/{z}/{x}/{y}.png';
	        var tileLayer = L.tileLayer(tilesURL, params.options);
	        params.url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/' + params.layer + '/{z}/{x}/{y}.grid.json';
	        var utfLayer = utfGridCreateLayer(params);
	        return L.layerGroup([tileLayer, utfLayer]);
	      },
	    },
	    wms: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        return L.tileLayer.wms(params.url, params.options);
	      },
	    },
	    wmts: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        return L.tileLayer.wmts(params.url, params.options);
	      },
	    },
	    wfs: {
	      mustHaveUrl: true,
	      mustHaveLayer: true,
	      createLayer: function(params) {
	        if (!Helpers.WFSLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        var options = angular.copy(params.options);
	        if (options.crs && typeof options.crs === 'string') {
	          /*jshint -W061 */
	          options.crs = eval(options.crs);
	        }
	
	        return new L.GeoJSON.WFS(params.url, params.layer, options);
	      },
	    },
	    group: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        var lyrs = [];
	        $it.each(params.options.layers, function(l) {
	                  lyrs.push(createLayer(l));
	                });
	
	        params.options.loadedDefer = function() {
	          var defers = [];
	          if (isDefined(params.options.layers)) {
	            for (var i = 0; i < params.options.layers.length; i++) {
	              var d = params.options.layers[i].layerOptions.loadedDefer;
	              if (isDefined(d)) {
	                defers.push(d);
	              }
	            }
	          }
	
	          return defers;
	        };
	
	        return L.layerGroup(lyrs);
	      },
	    },
	    featureGroup: {
	      mustHaveUrl: false,
	      createLayer: function() {
	        return L.featureGroup();
	      },
	    },
	    google: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        var type = params.type || 'SATELLITE';
	        if (!Helpers.GoogleLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        return new L.Google(type, params.options);
	      },
	    },
	    here: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        var provider = params.provider || 'HERE.terrainDay';
	        if (!Helpers.LeafletProviderPlugin.isLoaded()) {
	          return;
	        }
	
	        return new L.TileLayer.Provider(provider, params.options);
	      },
	    },
	    china:{
	      mustHaveUrl:false,
	      createLayer:function(params) {
	        var type = params.type || '';
	        if (!Helpers.ChinaLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        return L.tileLayer.chinaProvider(type, params.options);
	      },
	    },
	    agsBase: {
	      mustHaveLayer: true,
	      createLayer: function(params) {
	        if (!Helpers.AGSBaseLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        return L.esri.basemapLayer(params.layer, params.options);
	      },
	    },
	    ags: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        if (!Helpers.AGSLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        var options = angular.copy(params.options);
	        angular.extend(options, {
	          url: params.url,
	        });
	        var layer = new lvector.AGS(options);
	        layer.onAdd = function(map) {
	          this.setMap(map);
	        };
	
	        layer.onRemove = function() {
	          this.setMap(null);
	        };
	
	        return layer;
	      },
	    },
	    agsFeature: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        if (!Helpers.AGSFeatureLayerPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The esri plugin is not loaded.');
	          return;
	        }
	
	        params.options.url = params.url;
	
	        var layer = L.esri.featureLayer(params.options);
	        var load = function() {
	          if (isDefined(params.options.loadedDefer)) {
	            params.options.loadedDefer.resolve();
	          }
	        };
	
	        layer.on('loading', function() {
	          params.options.loadedDefer = $q.defer();
	          layer.off('load', load);
	          layer.on('load', load);
	        });
	
	        return layer;
	      },
	    },
	    agsTiled: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        if (!Helpers.AGSTiledMapLayerPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The esri plugin is not loaded.');
	          return;
	        }
	
	        params.options.url = params.url;
	
	        return L.esri.tiledMapLayer(params.options);
	      },
	    },
	    agsDynamic: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        if (!Helpers.AGSDynamicMapLayerPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The esri plugin is not loaded.');
	          return;
	        }
	
	        params.options.url = params.url;
	
	        return L.esri.dynamicMapLayer(params.options);
	      },
	    },
	    agsImage: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        if (!Helpers.AGSImageMapLayerPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The esri plugin is not loaded.');
	          return;
	        }
	
	        params.options.url = params.url;
	
	        return L.esri.imageMapLayer(params.options);
	      },
	    },
	    agsClustered: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        if (!Helpers.AGSClusteredLayerPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The esri clustered layer plugin is not loaded.');
	          return;
	        }
	
	        if (!Helpers.MarkerClusterPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The markercluster plugin is not loaded.');
	          return;
	        }
	
	        return L.esri.clusteredFeatureLayer(params.url, params.options);
	      },
	    },
	    agsHeatmap: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        if (!Helpers.AGSHeatmapLayerPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The esri heatmap layer plugin is not loaded.');
	          return;
	        }
	
	        if (!Helpers.HeatLayerPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The heatlayer plugin is not loaded.');
	          return;
	        }
	
	        return L.esri.heatmapFeatureLayer(params.url, params.options);
	      },
	    },
	    markercluster: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        if (!Helpers.MarkerClusterPlugin.isLoaded()) {
	          $log.warn(errorHeader + ' The markercluster plugin is not loaded.');
	          return;
	        }
	
	        return new L.MarkerClusterGroup(params.options);
	      },
	    },
	    bing: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        if (!Helpers.BingLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        return new L.BingLayer(params.key, params.options);
	      },
	    },
	    webGLHeatmap: {
	      mustHaveUrl: false,
	      mustHaveData: true,
	      createLayer: function(params) {
	        if (!Helpers.WebGLHeatMapLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        var layer = new L.TileLayer.WebGLHeatMap(params.options);
	        if (isDefined(params.data)) {
	          layer.setData(params.data);
	        }
	
	        return layer;
	      },
	    },
	    heat: {
	      mustHaveUrl: false,
	      mustHaveData: true,
	      createLayer: function(params) {
	        if (!Helpers.HeatLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        var layer = new L.heatLayer();
	
	        if (isArray(params.data)) {
	          layer.setLatLngs(params.data);
	        }
	
	        if (isObject(params.options)) {
	          layer.setOptions(params.options);
	        }
	
	        return layer;
	      },
	    },
	    yandex: {
	      mustHaveUrl: false,
	      createLayer: function(params) {
	        var type = params.type || 'map';
	        if (!Helpers.YandexLayerPlugin.isLoaded()) {
	          return;
	        }
	
	        return new L.Yandex(type, params.options);
	      },
	    },
	    imageOverlay: {
	      mustHaveUrl: true,
	      mustHaveBounds: true,
	      createLayer: function(params) {
	        return L.imageOverlay(params.url, params.bounds, params.options);
	      },
	    },
	    iip: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        return L.tileLayer.iip(params.url, params.options);
	      },
	    },
	
	    // This "custom" type is used to accept every layer that user want to define himself.
	    // We can wrap these custom layers like heatmap or yandex, but it means a lot of work/code to wrap the world,
	    // so we let user to define their own layer outside the directive,
	    // and pass it on "createLayer" result for next processes
	    custom: {
	      createLayer: function(params) {
	        if (params.layer instanceof L.Class) {
	          return angular.copy(params.layer);
	        }        else {
	          $log.error('[AngularJS - Leaflet] A custom layer must be a leaflet Class');
	        }
	      },
	    },
	    cartodb: {
	      mustHaveUrl: true,
	      createLayer: function(params) {
	        return cartodb.createLayer(params.map, params.url);
	      },
	    },
	  };
	
	  function isValidLayerType(layerDefinition) {
	    // Check if the baselayer has a valid type
	    if (!isString(layerDefinition.type)) {
	      $log.error('[AngularJS - Leaflet] A layer must have a valid type defined.');
	      return false;
	    }
	
	    if (Object.keys(layerTypes).indexOf(layerDefinition.type) === -1) {
	      $log.error('[AngularJS - Leaflet] A layer must have a valid type: ' + Object.keys(layerTypes));
	      return false;
	    }
	
	    // Check if the layer must have an URL
	    if (layerTypes[layerDefinition.type].mustHaveUrl && !isString(layerDefinition.url)) {
	      $log.error('[AngularJS - Leaflet] A base layer must have an url');
	      return false;
	    }
	
	    if (layerTypes[layerDefinition.type].mustHaveData && !isDefined(layerDefinition.data)) {
	      $log.error('[AngularJS - Leaflet] The base layer must have a "data" array attribute');
	      return false;
	    }
	
	    if (layerTypes[layerDefinition.type].mustHaveLayer && !isDefined(layerDefinition.layer)) {
	      $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have an layer defined');
	      return false;
	    }
	
	    if (layerTypes[layerDefinition.type].mustHaveBounds && !isDefined(layerDefinition.bounds)) {
	      $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have bounds defined');
	      return false;
	    }
	
	    if (layerTypes[layerDefinition.type].mustHaveKey && !isDefined(layerDefinition.key)) {
	      $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have key defined');
	      return false;
	    }
	
	    return true;
	  }
	
	  function createLayer(layerDefinition) {
	    if (!isValidLayerType(layerDefinition)) {
	      return;
	    }
	
	    if (!isString(layerDefinition.name)) {
	      $log.error('[AngularJS - Leaflet] A base layer must have a name');
	      return;
	    }
	
	    if (!isObject(layerDefinition.layerParams)) {
	      layerDefinition.layerParams = {};
	    }
	
	    if (!isObject(layerDefinition.layerOptions)) {
	      layerDefinition.layerOptions = {};
	    }
	
	    // Mix the layer specific parameters with the general Leaflet options. Although this is an overhead
	    // the definition of a base layers is more 'clean' if the two types of parameters are differentiated
	    for (var attrname in layerDefinition.layerParams) {
	      layerDefinition.layerOptions[attrname] = layerDefinition.layerParams[attrname];
	    }
	
	    var params = {
	      url: layerDefinition.url,
	      data: layerDefinition.data,
	      options: layerDefinition.layerOptions,
	      layer: layerDefinition.layer,
	      icon: layerDefinition.icon,
	      type: layerDefinition.layerType,
	      bounds: layerDefinition.bounds,
	      key: layerDefinition.key,
	      apiKey: layerDefinition.apiKey,
	      pluginOptions: layerDefinition.pluginOptions,
	      user: layerDefinition.user,
	    };
	
	    //TODO Add $watch to the layer properties
	    return layerTypes[layerDefinition.type].createLayer(params);
	  }
	
	  function safeAddLayer(map, layer) {
	    if (layer && typeof layer.addTo === 'function') {
	      layer.addTo(map);
	    } else {
	      map.addLayer(layer);
	    }
	  }
	
	  function safeRemoveLayer(map, layer, layerOptions) {
	    if (isDefined(layerOptions) && isDefined(layerOptions.loadedDefer)) {
	      if (angular.isFunction(layerOptions.loadedDefer)) {
	        var defers = layerOptions.loadedDefer();
	        $log.debug('Loaded Deferred', defers);
	        var count = defers.length;
	        if (count > 0) {
	          var resolve = function() {
	            count--;
	            if (count === 0) {
	              map.removeLayer(layer);
	            }
	          };
	
	          for (var i = 0; i < defers.length; i++) {
	            defers[i].promise.then(resolve);
	          }
	        } else {
	          map.removeLayer(layer);
	        }
	      } else {
	        layerOptions.loadedDefer.promise.then(function() {
	          map.removeLayer(layer);
	        });
	      }
	    } else {
	      map.removeLayer(layer);
	    }
	  }
	
	  return {
	    createLayer: createLayer,
	    safeAddLayer: safeAddLayer,
	    safeRemoveLayer: safeRemoveLayer,
	  };
	}]);
	
	angular.module('leaflet-directive').factory('leafletLegendHelpers', function() {
	  var _updateLegend = function(div, legendData, type, url) {
	    div.innerHTML = '';
	    if (legendData.error) {
	      div.innerHTML += '<div class="info-title alert alert-danger">' + legendData.error.message + '</div>';
	    } else {
	      if (type === 'arcgis') {
	        for (var i = 0; i < legendData.layers.length; i++) {
	          var layer = legendData.layers[i];
	          div.innerHTML += '<div class="info-title" data-layerid="' + layer.layerId + '">' + layer.layerName + '</div>';
	          for (var j = 0; j < layer.legend.length; j++) {
	            var leg = layer.legend[j];
	            div.innerHTML +=
	            '<div class="inline" data-layerid="' + layer.layerId + '"><img src="data:' + leg.contentType + ';base64,' + leg.imageData + '" /></div>' +
	            '<div class="info-label" data-layerid="' + layer.layerId + '">' + leg.label + '</div>';
	          }
	        }
	      }      else if (type === 'image') {
	        div.innerHTML = '<img src="' + url + '"/>';
	      }
	    }
	  };
	
	  var _getOnAddLegend = function(legendData, legendClass, type, url) {
	    return function(/*map*/) {
	      var div = L.DomUtil.create('div', legendClass);
	
	      if (!L.Browser.touch) {
	        L.DomEvent.disableClickPropagation(div);
	        L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	      } else {
	        L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	      }
	
	      _updateLegend(div, legendData, type, url);
	      return div;
	    };
	  };
	
	  var _getOnAddArrayLegend = function(legend, legendClass) {
	    return function(/*map*/) {
	      var div = L.DomUtil.create('div', legendClass);
	      for (var i = 0; i < legend.colors.length; i++) {
	        div.innerHTML +=
	            '<div class="outline"><i style="background:' + legend.colors[i] + '"></i></div>' +
	            '<div class="info-label">' + legend.labels[i] + '</div>';
	      }
	
	      if (!L.Browser.touch) {
	        L.DomEvent.disableClickPropagation(div);
	        L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	      } else {
	        L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	      }
	
	      return div;
	    };
	  };
	
	  return {
	    getOnAddLegend: _getOnAddLegend,
	    getOnAddArrayLegend: _getOnAddArrayLegend,
	    updateLegend: _updateLegend,
	  };
	});
	
	angular.module('leaflet-directive').factory('leafletMapDefaults', ["$q", "leafletHelpers", function($q, leafletHelpers) {
	  function _getDefaults() {
	    return {
	      keyboard: true,
	      dragging: true,
	      worldCopyJump: false,
	      doubleClickZoom: true,
	      scrollWheelZoom: true,
	      tap: true,
	      touchZoom: true,
	      zoomControl: true,
	      zoomsliderControl: false,
	      zoomControlPosition: 'topleft',
	      attributionControl: true,
	      controls: {
	        layers: {
	          visible: true,
	          position: 'topright',
	          collapsed: true,
	        },
	      },
	      nominatim: {
	        server: ' http://nominatim.openstreetmap.org/search',
	      },
	      crs: L.CRS.EPSG3857,
	      tileLayer: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
	      tileLayerOptions: {
	        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
	      },
	      path: {
	        weight: 10,
	        opacity: 1,
	        color: '#0000ff',
	      },
	      center: {
	        lat: 0,
	        lng: 0,
	        zoom: 1,
	      },
	    };
	  }
	
	  var isDefined = leafletHelpers.isDefined;
	  var isObject = leafletHelpers.isObject;
	  var obtainEffectiveMapId = leafletHelpers.obtainEffectiveMapId;
	  var defaults = {};
	
	  // Get the _defaults dictionary, and override the properties defined by the user
	  return {
	    reset: function() {
	      defaults = {};
	    },
	
	    getDefaults: function(scopeId) {
	      var mapId = obtainEffectiveMapId(defaults, scopeId);
	      return defaults[mapId];
	    },
	
	    getMapCreationDefaults: function(scopeId) {
	      var mapId = obtainEffectiveMapId(defaults, scopeId);
	      var d = defaults[mapId];
	
	      var mapDefaults = {
	        maxZoom: d.maxZoom,
	        keyboard: d.keyboard,
	        dragging: d.dragging,
	        zoomControl: d.zoomControl,
	        doubleClickZoom: d.doubleClickZoom,
	        scrollWheelZoom: d.scrollWheelZoom,
	        tap: d.tap,
	        touchZoom: d.touchZoom,
	        attributionControl: d.attributionControl,
	        worldCopyJump: d.worldCopyJump,
	        crs: d.crs,
	      };
	
	      if (isDefined(d.minZoom)) {
	        mapDefaults.minZoom = d.minZoom;
	      }
	
	      if (isDefined(d.zoomAnimation)) {
	        mapDefaults.zoomAnimation = d.zoomAnimation;
	      }
	
	      if (isDefined(d.fadeAnimation)) {
	        mapDefaults.fadeAnimation = d.fadeAnimation;
	      }
	
	      if (isDefined(d.markerZoomAnimation)) {
	        mapDefaults.markerZoomAnimation = d.markerZoomAnimation;
	      }
	
	      if (d.map) {
	        for (var option in d.map) {
	          mapDefaults[option] = d.map[option];
	        }
	      }
	
	      return mapDefaults;
	    },
	
	    setDefaults: function(userDefaults, scopeId) {
	      var newDefaults = _getDefaults();
	
	      if (isDefined(userDefaults)) {
	        newDefaults.doubleClickZoom = isDefined(userDefaults.doubleClickZoom) ? userDefaults.doubleClickZoom : newDefaults.doubleClickZoom;
	        newDefaults.scrollWheelZoom = isDefined(userDefaults.scrollWheelZoom) ? userDefaults.scrollWheelZoom : newDefaults.doubleClickZoom;
	        newDefaults.tap = isDefined(userDefaults.tap) ? userDefaults.tap : newDefaults.tap;
	        newDefaults.touchZoom = isDefined(userDefaults.touchZoom) ? userDefaults.touchZoom : newDefaults.doubleClickZoom;
	        newDefaults.zoomControl = isDefined(userDefaults.zoomControl) ? userDefaults.zoomControl : newDefaults.zoomControl;
	        newDefaults.zoomsliderControl = isDefined(userDefaults.zoomsliderControl) ? userDefaults.zoomsliderControl : newDefaults.zoomsliderControl;
	        newDefaults.attributionControl = isDefined(userDefaults.attributionControl) ? userDefaults.attributionControl : newDefaults.attributionControl;
	        newDefaults.tileLayer = isDefined(userDefaults.tileLayer) ? userDefaults.tileLayer : newDefaults.tileLayer;
	        newDefaults.zoomControlPosition = isDefined(userDefaults.zoomControlPosition) ? userDefaults.zoomControlPosition : newDefaults.zoomControlPosition;
	        newDefaults.keyboard = isDefined(userDefaults.keyboard) ? userDefaults.keyboard : newDefaults.keyboard;
	        newDefaults.dragging = isDefined(userDefaults.dragging) ? userDefaults.dragging : newDefaults.dragging;
	
	        if (isDefined(userDefaults.controls)) {
	          angular.extend(newDefaults.controls, userDefaults.controls);
	        }
	
	        if (isObject(userDefaults.crs)) {
	          newDefaults.crs = userDefaults.crs;
	        } else if (isDefined(L.CRS[userDefaults.crs])) {
	          newDefaults.crs = L.CRS[userDefaults.crs];
	        }
	
	        if (isDefined(userDefaults.center)) {
	          angular.copy(userDefaults.center, newDefaults.center);
	        }
	
	        if (isDefined(userDefaults.tileLayerOptions)) {
	          angular.copy(userDefaults.tileLayerOptions, newDefaults.tileLayerOptions);
	        }
	
	        if (isDefined(userDefaults.maxZoom)) {
	          newDefaults.maxZoom = userDefaults.maxZoom;
	        }
	
	        if (isDefined(userDefaults.minZoom)) {
	          newDefaults.minZoom = userDefaults.minZoom;
	        }
	
	        if (isDefined(userDefaults.zoomAnimation)) {
	          newDefaults.zoomAnimation = userDefaults.zoomAnimation;
	        }
	
	        if (isDefined(userDefaults.fadeAnimation)) {
	          newDefaults.fadeAnimation = userDefaults.fadeAnimation;
	        }
	
	        if (isDefined(userDefaults.markerZoomAnimation)) {
	          newDefaults.markerZoomAnimation = userDefaults.markerZoomAnimation;
	        }
	
	        if (isDefined(userDefaults.worldCopyJump)) {
	          newDefaults.worldCopyJump = userDefaults.worldCopyJump;
	        }
	
	        if (isDefined(userDefaults.map)) {
	          newDefaults.map = userDefaults.map;
	        }
	
	        if (isDefined(userDefaults.path)) {
	          newDefaults.path = userDefaults.path;
	        }
	      }
	
	      var mapId = obtainEffectiveMapId(defaults, scopeId);
	      defaults[mapId] = newDefaults;
	      return newDefaults;
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').service('leafletMarkersHelpers', ["$rootScope", "$timeout", "leafletHelpers", "$log", "$compile", "leafletGeoJsonHelpers", function($rootScope, $timeout, leafletHelpers, $log, $compile, leafletGeoJsonHelpers) {
	  var isDefined = leafletHelpers.isDefined;
	  var defaultTo = leafletHelpers.defaultTo;
	  var MarkerClusterPlugin = leafletHelpers.MarkerClusterPlugin;
	  var AwesomeMarkersPlugin = leafletHelpers.AwesomeMarkersPlugin;
	  var VectorMarkersPlugin = leafletHelpers.VectorMarkersPlugin;
	  var MakiMarkersPlugin = leafletHelpers.MakiMarkersPlugin;
	  var ExtraMarkersPlugin = leafletHelpers.ExtraMarkersPlugin;
	  var DomMarkersPlugin = leafletHelpers.DomMarkersPlugin;
	  var safeApply = leafletHelpers.safeApply;
	  var Helpers = leafletHelpers;
	  var isString = leafletHelpers.isString;
	  var isNumber = leafletHelpers.isNumber;
	  var isObject = leafletHelpers.isObject;
	  var groups = {};
	  var geoHlp = leafletGeoJsonHelpers;
	  var errorHeader = leafletHelpers.errorHeader;
	
	  var _string = function(marker) {
	    //this exists since JSON.stringify barfs on cyclic
	    var retStr = '';
	    ['_icon', '_latlng', '_leaflet_id', '_map', '_shadow'].forEach(function(prop) {
	      retStr += prop + ': ' + defaultTo(marker[prop], 'undefined') + ' \n';
	    });
	
	    return '[leafletMarker] : \n' + retStr;
	  };
	
	  var _log = function(marker, useConsole) {
	    var logger = useConsole ? console : $log;
	    logger.debug(_string(marker));
	  };
	
	  var createLeafletIcon = function(iconData) {
	    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'awesomeMarker') {
	      if (!AwesomeMarkersPlugin.isLoaded()) {
	        $log.error(errorHeader + ' The AwesomeMarkers Plugin is not loaded.');
	      }
	
	      return new L.AwesomeMarkers.icon(iconData);
	    }
	
	    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'vectorMarker') {
	      if (!VectorMarkersPlugin.isLoaded()) {
	        $log.error(errorHeader + ' The VectorMarkers Plugin is not loaded.');
	      }
	
	      return new L.VectorMarkers.icon(iconData);
	    }
	
	    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'makiMarker') {
	      if (!MakiMarkersPlugin.isLoaded()) {
	        $log.error(errorHeader + 'The MakiMarkers Plugin is not loaded.');
	      }
	
	      return new L.MakiMarkers.icon(iconData);
	    }
	
	    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'extraMarker') {
	      if (!ExtraMarkersPlugin.isLoaded()) {
	        $log.error(errorHeader + 'The ExtraMarkers Plugin is not loaded.');
	      }
	
	      return new L.ExtraMarkers.icon(iconData);
	    }
	
	    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'div') {
	      return new L.divIcon(iconData);
	    }
	
	    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'dom') {
	      if (!DomMarkersPlugin.isLoaded()) {
	        $log.error(errorHeader + 'The DomMarkers Plugin is not loaded.');
	      }
	
	      var markerScope = angular.isFunction(iconData.getMarkerScope) ? iconData.getMarkerScope() : $rootScope;
	      var template = $compile(iconData.template)(markerScope);
	      var iconDataCopy = angular.copy(iconData);
	      iconDataCopy.element = template[0];
	      return new L.DomMarkers.icon(iconDataCopy);
	    }
	
	    // allow for any custom icon to be used... assumes the icon has already been initialized
	    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'icon') {
	      return iconData.icon;
	    }
	
	    var base64icon = 'data:image/png;base64,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';
	    var base64shadow = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAC5ElEQVRYw+2YW4/TMBCF45S0S1luXZCABy5CgLQgwf//S4BYBLTdJLax0fFqmB07nnQfEGqkIydpVH85M+NLjPe++dcPc4Q8Qh4hj5D/AaQJx6H/4TMwB0PeBNwU7EGQAmAtsNfAzoZkgIa0ZgLMa4Aj6CxIAsjhjOCoL5z7Glg1JAOkaicgvQBXuncwJAWjksLtBTWZe04CnYRktUGdilALppZBOgHGZcBzL6OClABvMSVIzyBjazOgrvACf1ydC5mguqAVg6RhdkSWQFj2uxfaq/BrIZOLEWgZdALIDvcMcZLD8ZbLC9de4yR1sYMi4G20S4Q/PWeJYxTOZn5zJXANZHIxAd4JWhPIloTJZhzMQduM89WQ3MUVAE/RnhAXpTycqys3NZALOBbB7kFrgLesQl2h45Fcj8L1tTSohUwuxhy8H/Qg6K7gIs+3kkaigQCOcyEXCHN07wyQazhrmIulvKMQAwMcmLNqyCVyMAI+BuxSMeTk3OPikLY2J1uE+VHQk6ANrhds+tNARqBeaGc72cK550FP4WhXmFmcMGhTwAR1ifOe3EvPqIegFmF+C8gVy0OfAaWQPMR7gF1OQKqGoBjq90HPMP01BUjPOqGFksC4emE48tWQAH0YmvOgF3DST6xieJgHAWxPAHMuNhrImIdvoNOKNWIOcE+UXE0pYAnkX6uhWsgVXDxHdTfCmrEEmMB2zMFimLVOtiiajxiGWrbU52EeCdyOwPEQD8LqyPH9Ti2kgYMf4OhSKB7qYILbBv3CuVTJ11Y80oaseiMWOONc/Y7kJYe0xL2f0BaiFTxknHO5HaMGMublKwxFGzYdWsBF174H/QDknhTHmHHN39iWFnkZx8lPyM8WHfYELmlLKtgWNmFNzQcC1b47gJ4hL19i7o65dhH0Negbca8vONZoP7doIeOC9zXm8RjuL0Gf4d4OYaU5ljo3GYiqzrWQHfJxA6ALhDpVKv9qYeZA8eM3EhfPSCmpuD0AAAAASUVORK5CYII=';
	
	    if (!isDefined(iconData) || !isDefined(iconData.iconUrl)) {
	      return new L.Icon.Default({
	        iconUrl: base64icon,
	        shadowUrl: base64shadow,
	        iconSize: [25, 41],
	        iconAnchor: [12, 41],
	        popupAnchor: [1, -34],
	        shadowSize: [41, 41],
	      });
	    }
	
	    return new L.Icon(iconData);
	  };
	
	  var _resetMarkerGroup = function(groupName) {
	    if (isDefined(groups[groupName])) {
	      groups.splice(groupName, 1);
	    }
	  };
	
	  var _resetMarkerGroups = function() {
	    groups = {};
	  };
	
	  var _deleteMarker = function(marker, map, layers) {
	    marker.closePopup();
	
	    // There is no easy way to know if a marker is added to a layer, so we search for it
	    // if there are overlays
	    if (isDefined(layers) && isDefined(layers.overlays)) {
	      for (var key in layers.overlays) {
	        if (layers.overlays[key] instanceof L.LayerGroup || layers.overlays[key] instanceof L.FeatureGroup) {
	          if (layers.overlays[key].hasLayer(marker)) {
	            layers.overlays[key].removeLayer(marker);
	            return;
	          }
	        }
	      }
	    }
	
	    if (isDefined(groups)) {
	      for (var groupKey in groups) {
	        if (groups[groupKey].hasLayer(marker)) {
	          groups[groupKey].removeLayer(marker);
	        }
	      }
	    }
	
	    if (map.hasLayer(marker)) {
	      map.removeLayer(marker);
	    }
	  };
	
	  var adjustPopupPan = function(marker, map) {
	    var containerHeight = marker._popup._container.offsetHeight;
	    var layerPos = new L.Point(marker._popup._containerLeft, -containerHeight - marker._popup._containerBottom);
	    var containerPos = map.layerPointToContainerPoint(layerPos);
	    if (containerPos !== null) {
	      marker._popup._adjustPan();
	    }
	  };
	
	  var compilePopup = function(marker, markerScope) {
	    $compile(marker._popup._contentNode)(markerScope);
	  };
	
	  var updatePopup = function(marker, markerScope, map) {
	    //The innerText should be more than 1 once angular has compiled.
	    //We need to keep trying until angular has compiled before we _updateLayout and _updatePosition
	    //This should take care of any scenario , eg ngincludes, whatever.
	    //Is there a better way to check for this?
	    var innerText = marker._popup._contentNode.innerText || marker._popup._contentNode.textContent;
	    if (innerText.length < 1) {
	      $timeout(function() {
	        updatePopup(marker, markerScope, map);
	      });
	    }
	
	    //cause a reflow - this is also very important - if we don't do this then the widths are from before $compile
	    var reflow = marker._popup._contentNode.offsetWidth;
	
	    marker._popup._updateLayout();
	    marker._popup._updatePosition();
	
	    if (marker._popup.options.autoPan) {
	      adjustPopupPan(marker, map);
	    }
	
	    //using / returning reflow so jshint doesn't moan
	    return reflow;
	  };
	
	  var _manageOpenPopup = function(marker, markerData, map) {
	    // The marker may provide a scope returning function used to compile the message
	    // default to $rootScope otherwise
	    var markerScope = angular.isFunction(markerData.getMessageScope) ? markerData.getMessageScope() : $rootScope;
	    var compileMessage = isDefined(markerData.compileMessage) ? markerData.compileMessage : true;
	
	    if (compileMessage) {
	      if (!isDefined(marker._popup) || !isDefined(marker._popup._contentNode)) {
	        $log.error(errorHeader + 'Popup is invalid or does not have any content.');
	        return false;
	      }
	
	      compilePopup(marker, markerScope);
	      updatePopup(marker, markerData, map);
	    }
	  };
	
	  var _manageOpenLabel = function(marker, markerData) {
	    var markerScope = angular.isFunction(markerData.getMessageScope) ? markerData.getMessageScope() : $rootScope;
	    var labelScope = angular.isFunction(markerData.getLabelScope) ? markerData.getLabelScope() : markerScope;
	    var compileMessage = isDefined(markerData.compileMessage) ? markerData.compileMessage : true;
	
	    if (Helpers.LabelPlugin.isLoaded() && isDefined(markerData.label)) {
	      if (isDefined(markerData.label.options) && markerData.label.options.noHide === true) {
	        marker.showLabel();
	      }
	
	      if (compileMessage && isDefined(marker.label)) {
	        $compile(marker.label._container)(labelScope);
	      }
	    }
	  };
	
	  var _updateMarker = function(markerData, oldMarkerData, marker, name, leafletScope, layers, map) {
	    if (!isDefined(oldMarkerData)) {
	      return;
	    }
	
	    // Update the lat-lng property (always present in marker properties)
	    if (!geoHlp.validateCoords(markerData)) {
	      $log.warn('There are problems with lat-lng data, please verify your marker model');
	      _deleteMarker(marker, map, layers);
	      return;
	    }
	
	    // watch is being initialized if old and new object is the same
	    var isInitializing = markerData === oldMarkerData;
	
	    // Update marker rotation
	    if (isDefined(markerData.iconAngle) && oldMarkerData.iconAngle !== markerData.iconAngle) {
	      marker.setIconAngle(markerData.iconAngle);
	    }
	
	    // It is possible that the layer has been removed or the layer marker does not exist
	    // Update the layer group if present or move it to the map if not
	    if (!isString(markerData.layer)) {
	      // There is no layer information, we move the marker to the map if it was in a layer group
	      if (isString(oldMarkerData.layer)) {
	        // Remove from the layer group that is supposed to be
	        if (isDefined(layers.overlays[oldMarkerData.layer]) && layers.overlays[oldMarkerData.layer].hasLayer(marker)) {
	          layers.overlays[oldMarkerData.layer].removeLayer(marker);
	          marker.closePopup();
	        }
	
	        // Test if it is not on the map and add it
	        if (!map.hasLayer(marker)) {
	          map.addLayer(marker);
	        }
	      }
	    }
	
	    if ((isNumber(markerData.opacity) || isNumber(parseFloat(markerData.opacity))) && markerData.opacity !== oldMarkerData.opacity) {
	      // There was a different opacity so we update it
	      marker.setOpacity(markerData.opacity);
	    }
	
	    if (isString(markerData.layer) && oldMarkerData.layer !== markerData.layer) {
	      // If it was on a layer group we have to remove it
	      if (isString(oldMarkerData.layer) && isDefined(layers.overlays[oldMarkerData.layer]) && layers.overlays[oldMarkerData.layer].hasLayer(marker)) {
	        layers.overlays[oldMarkerData.layer].removeLayer(marker);
	      }
	
	      marker.closePopup();
	
	      // Remove it from the map in case the new layer is hidden or there is an error in the new layer
	      if (map.hasLayer(marker)) {
	        map.removeLayer(marker);
	      }
	
	      // The markerData.layer is defined so we add the marker to the layer if it is different from the old data
	      if (!isDefined(layers.overlays[markerData.layer])) {
	        $log.error(errorHeader + 'You must use a name of an existing layer');
	        return;
	      }
	
	      // Is a group layer?
	      var layerGroup = layers.overlays[markerData.layer];
	      if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	        $log.error(errorHeader + 'A marker can only be added to a layer of type "group" or "featureGroup"');
	        return;
	      }
	
	      // The marker goes to a correct layer group, so first of all we add it
	      layerGroup.addLayer(marker);
	
	      // The marker is automatically added to the map depending on the visibility
	      // of the layer, so we only have to open the popup if the marker is in the map
	      if (map.hasLayer(marker) && markerData.focus === true) {
	        marker.openPopup();
	      }
	    }
	
	    // Update the draggable property
	    if (markerData.draggable !== true && oldMarkerData.draggable === true && (isDefined(marker.dragging))) {
	      marker.dragging.disable();
	    }
	
	    if (markerData.draggable === true && oldMarkerData.draggable !== true) {
	      // The markerData.draggable property must be true so we update if there wasn't a previous value or it wasn't true
	      if (marker.dragging) {
	        marker.dragging.enable();
	      } else {
	        if (L.Handler.MarkerDrag) {
	          marker.dragging = new L.Handler.MarkerDrag(marker);
	          marker.options.draggable = true;
	          marker.dragging.enable();
	        }
	      }
	    }
	
	    // Update the icon property
	    if (!isObject(markerData.icon)) {
	      // If there is no icon property or it's not an object
	      if (isObject(oldMarkerData.icon)) {
	        // If there was an icon before restore to the default
	        marker.setIcon(createLeafletIcon());
	        marker.closePopup();
	        marker.unbindPopup();
	        if (isString(markerData.message)) {
	          marker.bindPopup(markerData.message, markerData.popupOptions);
	        }
	      }
	    }
	
	    if (isObject(markerData.icon) && isObject(oldMarkerData.icon) && !angular.equals(markerData.icon, oldMarkerData.icon)) {
	      var dragG = false;
	      if (marker.dragging) {
	        dragG = marker.dragging.enabled();
	      }
	
	      marker.setIcon(createLeafletIcon(markerData.icon));
	      if (dragG) {
	        marker.dragging.enable();
	      }
	
	      marker.closePopup();
	      marker.unbindPopup();
	      if (isString(markerData.message)) {
	        marker.bindPopup(markerData.message, markerData.popupOptions);
	
	        // if marker has been already focused, reopen popup
	        if (map.hasLayer(marker) && markerData.focus === true) {
	          marker.openPopup();
	        }
	      }
	    }
	
	    // Update the Popup message property
	    if (!isString(markerData.message) && isString(oldMarkerData.message)) {
	      marker.closePopup();
	      marker.unbindPopup();
	    }
	
	    // Update the label content or bind a new label if the old one has been removed.
	    if (Helpers.LabelPlugin.isLoaded()) {
	      if (isDefined(markerData.label) && isDefined(markerData.label.message)) {
	        if ('label' in oldMarkerData && 'message' in oldMarkerData.label && !angular.equals(markerData.label.message, oldMarkerData.label.message)) {
	          marker.updateLabelContent(markerData.label.message);
	        } else if (!angular.isFunction(marker.getLabel) || angular.isFunction(marker.getLabel) && !isDefined(marker.getLabel())) {
	          marker.bindLabel(markerData.label.message, markerData.label.options);
	          _manageOpenLabel(marker, markerData);
	        } else {
	          _manageOpenLabel(marker, markerData);
	        }
	      } else if (!('label' in markerData && !('message' in markerData.label))) {
	        if (angular.isFunction(marker.unbindLabel)) {
	          marker.unbindLabel();
	        }
	      }
	    }
	
	    // There is some text in the popup, so we must show the text or update existing
	    if (isString(markerData.message) && !isString(oldMarkerData.message)) {
	      // There was no message before so we create it
	      marker.bindPopup(markerData.message, markerData.popupOptions);
	    }
	
	    if (isString(markerData.message) && isString(oldMarkerData.message) && markerData.message !== oldMarkerData.message) {
	      // There was a different previous message so we update it
	      marker.setPopupContent(markerData.message);
	    }
	
	    // Update the focus property
	    var updatedFocus = false;
	    if (markerData.focus !== true && oldMarkerData.focus === true) {
	      // If there was a focus property and was true we turn it off
	      marker.closePopup();
	      updatedFocus = true;
	    }
	
	    // The markerData.focus property must be true so we update if there wasn't a previous value or it wasn't true
	    if (markerData.focus === true && (!isDefined(oldMarkerData.focus) || oldMarkerData.focus === false) || (isInitializing && markerData.focus === true)) {
	      // Reopen the popup when focus is still true
	      marker.openPopup();
	      updatedFocus = true;
	    }
	
	    // zIndexOffset adjustment
	    if (oldMarkerData.zIndexOffset !== markerData.zIndexOffset) {
	      marker.setZIndexOffset(markerData.zIndexOffset);
	    }
	
	    var markerLatLng = marker.getLatLng();
	    var isCluster = (isString(markerData.layer) && Helpers.MarkerClusterPlugin.is(layers.overlays[markerData.layer]));
	
	    // If the marker is in a cluster it has to be removed and added to the layer when the location is changed
	    if (isCluster) {
	      // The focus has changed even by a user click or programatically
	      if (updatedFocus) {
	        // We only have to update the location if it was changed programatically, because it was
	        // changed by a user drag the marker data has already been updated by the internal event
	        // listened by the directive
	        if ((markerData.lat !== oldMarkerData.lat) || (markerData.lng !== oldMarkerData.lng)) {
	          layers.overlays[markerData.layer].removeLayer(marker);
	          marker.setLatLng([markerData.lat, markerData.lng]);
	          layers.overlays[markerData.layer].addLayer(marker);
	        }
	      } else {
	        // The marker has possibly moved. It can be moved by a user drag (marker location and data are equal but old
	        // data is diferent) or programatically (marker location and data are diferent)
	        if ((markerLatLng.lat !== markerData.lat) || (markerLatLng.lng !== markerData.lng)) {
	          // The marker was moved by a user drag
	          layers.overlays[markerData.layer].removeLayer(marker);
	          marker.setLatLng([markerData.lat, markerData.lng]);
	          layers.overlays[markerData.layer].addLayer(marker);
	        } else if ((markerData.lat !== oldMarkerData.lat) || (markerData.lng !== oldMarkerData.lng)) {
	          // The marker was moved programatically
	          layers.overlays[markerData.layer].removeLayer(marker);
	          marker.setLatLng([markerData.lat, markerData.lng]);
	          layers.overlays[markerData.layer].addLayer(marker);
	        } else if (isObject(markerData.icon) && isObject(oldMarkerData.icon) && !angular.equals(markerData.icon, oldMarkerData.icon)) {
	          layers.overlays[markerData.layer].removeLayer(marker);
	          layers.overlays[markerData.layer].addLayer(marker);
	        }
	      }
	    } else if (markerLatLng.lat !== markerData.lat || markerLatLng.lng !== markerData.lng) {
	      marker.setLatLng([markerData.lat, markerData.lng]);
	    }
	  };
	
	  return {
	    resetMarkerGroup: _resetMarkerGroup,
	
	    resetMarkerGroups: _resetMarkerGroups,
	
	    deleteMarker: _deleteMarker,
	
	    manageOpenPopup: _manageOpenPopup,
	
	    manageOpenLabel: _manageOpenLabel,
	
	    createMarker: function(markerData) {
	      if (!isDefined(markerData) || !geoHlp.validateCoords(markerData)) {
	        $log.error(errorHeader + 'The marker definition is not valid.');
	        return;
	      }
	
	      var coords = geoHlp.getCoords(markerData);
	
	      if (!isDefined(coords)) {
	        $log.error(errorHeader + 'Unable to get coordinates from markerData.');
	        return;
	      }
	
	      var markerOptions = {
	        icon: createLeafletIcon(markerData.icon),
	        title: isDefined(markerData.title) ? markerData.title : '',
	        draggable: isDefined(markerData.draggable) ? markerData.draggable : false,
	        clickable: isDefined(markerData.clickable) ? markerData.clickable : true,
	        riseOnHover: isDefined(markerData.riseOnHover) ? markerData.riseOnHover : false,
	        zIndexOffset: isDefined(markerData.zIndexOffset) ? markerData.zIndexOffset : 0,
	        iconAngle: isDefined(markerData.iconAngle) ? markerData.iconAngle : 0,
	      };
	
	      // Add any other options not added above to markerOptions
	      for (var markerDatum in markerData) {
	        if (markerData.hasOwnProperty(markerDatum) && !markerOptions.hasOwnProperty(markerDatum)) {
	          markerOptions[markerDatum] = markerData[markerDatum];
	        }
	      }
	
	      var marker = new L.marker(coords, markerOptions);
	
	      if (!isString(markerData.message)) {
	        marker.unbindPopup();
	      }
	
	      return marker;
	    },
	
	    addMarkerToGroup: function(marker, groupName, groupOptions, map) {
	      if (!isString(groupName)) {
	        $log.error(errorHeader + 'The marker group you have specified is invalid.');
	        return;
	      }
	
	      if (!MarkerClusterPlugin.isLoaded()) {
	        $log.error(errorHeader + 'The MarkerCluster plugin is not loaded.');
	        return;
	      }
	
	      if (!isDefined(groups[groupName])) {
	        groups[groupName] = new L.MarkerClusterGroup(groupOptions);
	        map.addLayer(groups[groupName]);
	      }
	
	      groups[groupName].addLayer(marker);
	    },
	
	    listenMarkerEvents: function(marker, markerData, leafletScope, doWatch, map) {
	      marker.on('popupopen', function(/* event */) {
	        safeApply(leafletScope, function() {
	          if (isDefined(marker._popup) || isDefined(marker._popup._contentNode)) {
	            markerData.focus = true;
	            _manageOpenPopup(marker, markerData, map);//needed since markerData is now a copy
	          }
	        });
	      });
	
	      marker.on('popupclose', function(/* event */) {
	        safeApply(leafletScope, function() {
	          markerData.focus = false;
	        });
	      });
	
	      marker.on('add', function(/* event */) {
	        safeApply(leafletScope, function() {
	          if ('label' in markerData)
	              _manageOpenLabel(marker, markerData);
	        });
	      });
	    },
	
	    updateMarker: _updateMarker,
	
	    addMarkerWatcher: function(marker, name, leafletScope, layers, map, isDeepWatch) {
	      var markerWatchPath = Helpers.getObjectArrayPath('markers.' + name);
	      isDeepWatch = defaultTo(isDeepWatch, true);
	
	      var clearWatch = leafletScope.$watch(markerWatchPath, function(markerData, oldMarkerData) {
	        if (!isDefined(markerData)) {
	          _deleteMarker(marker, map, layers);
	          clearWatch();
	          return;
	        }
	
	        _updateMarker(markerData, oldMarkerData, marker, name, leafletScope, layers, map);
	      }, isDeepWatch);
	    },
	
	    string: _string,
	    log: _log,
	  };
	}]);
	
	angular.module('leaflet-directive').factory('leafletPathsHelpers', ["$rootScope", "$log", "leafletHelpers", function($rootScope, $log, leafletHelpers) {
	  var isDefined = leafletHelpers.isDefined;
	  var isArray = leafletHelpers.isArray;
	  var isNumber = leafletHelpers.isNumber;
	  var isValidPoint = leafletHelpers.isValidPoint;
	
	  var availableOptions = [
	
	      // Path options
	      'stroke', 'weight', 'color', 'opacity',
	      'fill', 'fillColor', 'fillOpacity',
	      'dashArray', 'lineCap', 'lineJoin', 'clickable',
	      'pointerEvents', 'className',
	
	      // Polyline options
	      'smoothFactor', 'noClip',
	  ];
	  function _convertToLeafletLatLngs(latlngs) {
	    return latlngs.filter(function(latlng) {
	      return isValidPoint(latlng);
	    }).map(function(latlng) {
	      return _convertToLeafletLatLng(latlng);
	    });
	  }
	
	  function _convertToLeafletLatLng(latlng) {
	    if (isArray(latlng)) {
	      return new L.LatLng(latlng[0], latlng[1]);
	    } else {
	      return new L.LatLng(latlng.lat, latlng.lng);
	    }
	  }
	
	  function _convertToLeafletMultiLatLngs(paths) {
	    return paths.map(function(latlngs) {
	      return _convertToLeafletLatLngs(latlngs);
	    });
	  }
	
	  function _getOptions(path, defaults) {
	    var options = {};
	    for (var i = 0; i < availableOptions.length; i++) {
	      var optionName = availableOptions[i];
	
	      if (isDefined(path[optionName])) {
	        options[optionName] = path[optionName];
	      } else if (isDefined(defaults.path[optionName])) {
	        options[optionName] = defaults.path[optionName];
	      }
	    }
	
	    return options;
	  }
	
	  var _updatePathOptions = function(path, data) {
	    var updatedStyle = {};
	    for (var i = 0; i < availableOptions.length; i++) {
	      var optionName = availableOptions[i];
	      if (isDefined(data[optionName])) {
	        updatedStyle[optionName] = data[optionName];
	      }
	    }
	
	    path.setStyle(data);
	  };
	
	  var _isValidPolyline = function(latlngs) {
	    if (!isArray(latlngs)) {
	      return false;
	    }
	
	    for (var i = 0; i < latlngs.length; i++) {
	      var point = latlngs[i];
	      if (!isValidPoint(point)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  var pathTypes = {
	    polyline: {
	      isValid: function(pathData) {
	        var latlngs = pathData.latlngs;
	        return _isValidPolyline(latlngs);
	      },
	
	      createPath: function(options) {
	        return new L.Polyline([], options);
	      },
	
	      setPath: function(path, data) {
	        path.setLatLngs(_convertToLeafletLatLngs(data.latlngs));
	        _updatePathOptions(path, data);
	        return;
	      },
	    },
	    multiPolyline: {
	      isValid: function(pathData) {
	        var latlngs = pathData.latlngs;
	        if (!isArray(latlngs)) {
	          return false;
	        }
	
	        for (var i in latlngs) {
	          var polyline = latlngs[i];
	          if (!_isValidPolyline(polyline)) {
	            return false;
	          }
	        }
	
	        return true;
	      },
	
	      createPath: function(options) {
	        return new L.multiPolyline([[[0, 0], [1, 1]]], options);
	      },
	
	      setPath: function(path, data) {
	        path.setLatLngs(_convertToLeafletMultiLatLngs(data.latlngs));
	        _updatePathOptions(path, data);
	        return;
	      },
	    },
	    polygon: {
	      isValid: function(pathData) {
	        var latlngs = pathData.latlngs;
	        return _isValidPolyline(latlngs);
	      },
	
	      createPath: function(options) {
	        return new L.Polygon([], options);
	      },
	
	      setPath: function(path, data) {
	        path.setLatLngs(_convertToLeafletLatLngs(data.latlngs));
	        _updatePathOptions(path, data);
	        return;
	      },
	    },
	    multiPolygon: {
	      isValid: function(pathData) {
	        var latlngs = pathData.latlngs;
	
	        if (!isArray(latlngs)) {
	          return false;
	        }
	
	        for (var i in latlngs) {
	          var polyline = latlngs[i];
	          if (!_isValidPolyline(polyline)) {
	            return false;
	          }
	        }
	
	        return true;
	      },
	
	      createPath: function(options) {
	        return new L.MultiPolygon([[[0, 0], [1, 1], [0, 1]]], options);
	      },
	
	      setPath: function(path, data) {
	        path.setLatLngs(_convertToLeafletMultiLatLngs(data.latlngs));
	        _updatePathOptions(path, data);
	        return;
	      },
	    },
	    rectangle: {
	      isValid: function(pathData) {
	        var latlngs = pathData.latlngs;
	
	        if (!isArray(latlngs) || latlngs.length !== 2) {
	          return false;
	        }
	
	        for (var i in latlngs) {
	          var point = latlngs[i];
	          if (!isValidPoint(point)) {
	            return false;
	          }
	        }
	
	        return true;
	      },
	
	      createPath: function(options) {
	        return new L.Rectangle([[0, 0], [1, 1]], options);
	      },
	
	      setPath: function(path, data) {
	        path.setBounds(new L.LatLngBounds(_convertToLeafletLatLngs(data.latlngs)));
	        _updatePathOptions(path, data);
	      },
	    },
	    circle: {
	      isValid: function(pathData) {
	        var point = pathData.latlngs;
	        return isValidPoint(point) && isNumber(pathData.radius);
	      },
	
	      createPath: function(options) {
	        return new L.Circle([0, 0], 1, options);
	      },
	
	      setPath: function(path, data) {
	        path.setLatLng(_convertToLeafletLatLng(data.latlngs));
	        if (isDefined(data.radius)) {
	          path.setRadius(data.radius);
	        }
	
	        _updatePathOptions(path, data);
	      },
	    },
	    circleMarker: {
	      isValid: function(pathData) {
	        var point = pathData.latlngs;
	        return isValidPoint(point) && isNumber(pathData.radius);
	      },
	
	      createPath: function(options) {
	        return new L.CircleMarker([0, 0], options);
	      },
	
	      setPath: function(path, data) {
	        path.setLatLng(_convertToLeafletLatLng(data.latlngs));
	        if (isDefined(data.radius)) {
	          path.setRadius(data.radius);
	        }
	
	        _updatePathOptions(path, data);
	      },
	    },
	  };
	
	  var _getPathData = function(path) {
	    var pathData = {};
	    if (path.latlngs) {
	      pathData.latlngs = path.latlngs;
	    }
	
	    if (path.radius) {
	      pathData.radius = path.radius;
	    }
	
	    return pathData;
	  };
	
	  return {
	    setPathOptions: function(leafletPath, pathType, data) {
	      if (!isDefined(pathType)) {
	        pathType = 'polyline';
	      }
	
	      pathTypes[pathType].setPath(leafletPath, data);
	    },
	
	    createPath: function(name, path, defaults) {
	      if (!isDefined(path.type)) {
	        path.type = 'polyline';
	      }
	
	      var options = _getOptions(path, defaults);
	      var pathData = _getPathData(path);
	
	      if (!pathTypes[path.type].isValid(pathData)) {
	        $log.error('[AngularJS - Leaflet] Invalid data passed to the ' + path.type + ' path');
	        return;
	      }
	
	      return pathTypes[path.type].createPath(options);
	    },
	  };
	}]);
	
	angular.module('leaflet-directive')
	.service('leafletWatchHelpers', function() {
	
	  var _maybe = function(scope, watchFunctionName, thingToWatchStr, watchOptions, initCb) {
	    //watchOptions.isDeep is/should be ignored in $watchCollection
	    var unWatch = scope[watchFunctionName](thingToWatchStr, function(newValue, oldValue) {
	      initCb(newValue, oldValue);
	      if (!watchOptions.doWatch)
	          unWatch();
	    }, watchOptions.isDeep);
	
	    return unWatch;
	  };
	
	  /*
	  @name: maybeWatch
	  @description: Utility to watch something once or forever.
	  @returns unWatch function
	  @param watchOptions - see markersWatchOptions and or derrivatives. This object is used
	  to set watching to once and its watch depth.
	  */
	  var _maybeWatch = function(scope, thingToWatchStr, watchOptions, initCb) {
	    return _maybe(scope, '$watch', thingToWatchStr, watchOptions, initCb);
	  };
	
	  /*
	  @name: _maybeWatchCollection
	  @description: Utility to watch something once or forever.
	  @returns unWatch function
	  @param watchOptions - see markersWatchOptions and or derrivatives. This object is used
	  to set watching to once and its watch depth.
	  */
	  var _maybeWatchCollection = function(scope, thingToWatchStr, watchOptions, initCb) {
	    return _maybe(scope, '$watchCollection', thingToWatchStr, watchOptions, initCb);
	  };
	
	  return {
	    maybeWatch: _maybeWatch,
	    maybeWatchCollection: _maybeWatchCollection,
	  };
	});
	
	angular.module('leaflet-directive').factory('nominatimService', ["$q", "$http", "leafletHelpers", "leafletMapDefaults", function($q, $http, leafletHelpers, leafletMapDefaults) {
	  var isDefined = leafletHelpers.isDefined;
	
	  return {
	    query: function(address, mapId) {
	      var defaults = leafletMapDefaults.getDefaults(mapId);
	      var url = defaults.nominatim.server;
	      var df = $q.defer();
	
	      $http.get(url, { params: { format: 'json', limit: 1, q: address } }).success(function(data) {
	        if (data.length > 0 && isDefined(data[0].boundingbox)) {
	          df.resolve(data[0]);
	        } else {
	          df.reject('[Nominatim] Invalid address');
	        }
	      });
	
	      return df.promise;
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('bounds', ["$log", "$timeout", "$http", "leafletHelpers", "nominatimService", "leafletBoundsHelpers", function($log, $timeout, $http, leafletHelpers, nominatimService, leafletBoundsHelpers) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: ['leaflet'],
	
	    link: function(scope, element, attrs, controller) {
	      var isDefined = leafletHelpers.isDefined;
	      var createLeafletBounds = leafletBoundsHelpers.createLeafletBounds;
	      var leafletScope = controller[0].getLeafletScope();
	      var mapController = controller[0];
	      var errorHeader = leafletHelpers.errorHeader + ' [Bounds] ';
	
	      var emptyBounds = function(bounds) {
	        return (bounds._southWest.lat === 0 && bounds._southWest.lng === 0 &&
	                bounds._northEast.lat === 0 && bounds._northEast.lng === 0);
	      };
	
	      mapController.getMap().then(function(map) {
	        leafletScope.$on('boundsChanged', function(event) {
	          var scope = event.currentScope;
	          var bounds = map.getBounds();
	
	          if (emptyBounds(bounds) || scope.settingBoundsFromScope) {
	            return;
	          }
	
	          scope.settingBoundsFromLeaflet = true;
	          var newScopeBounds = {
	            northEast: {
	              lat: bounds._northEast.lat,
	              lng: bounds._northEast.lng,
	            },
	            southWest: {
	              lat: bounds._southWest.lat,
	              lng: bounds._southWest.lng,
	            },
	            options: bounds.options,
	          };
	          if (!angular.equals(scope.bounds, newScopeBounds)) {
	            scope.bounds = newScopeBounds;
	          }
	
	          $timeout(function() {
	            scope.settingBoundsFromLeaflet = false;
	          });
	        });
	
	        var lastNominatimQuery;
	        leafletScope.$watch('bounds', function(bounds) {
	          if (scope.settingBoundsFromLeaflet)
	              return;
	          if (isDefined(bounds.address) && bounds.address !== lastNominatimQuery) {
	            scope.settingBoundsFromScope = true;
	            nominatimService.query(bounds.address, attrs.id).then(function(data) {
	              var b = data.boundingbox;
	              var newBounds = [[b[0], b[2]], [b[1], b[3]]];
	              map.fitBounds(newBounds);
	            }, function(errMsg) {
	
	              $log.error(errorHeader + ' ' + errMsg + '.');
	            });
	
	            lastNominatimQuery = bounds.address;
	            $timeout(function() {
	              scope.settingBoundsFromScope = false;
	            });
	
	            return;
	          }
	
	          var leafletBounds = createLeafletBounds(bounds);
	          if (leafletBounds && !map.getBounds().equals(leafletBounds)) {
	            scope.settingBoundsFromScope = true;
	            map.fitBounds(leafletBounds, bounds.options);
	            $timeout(function() {
	              scope.settingBoundsFromScope = false;
	            });
	          }
	        }, true);
	      });
	    },
	  };
	}]);
	
	var centerDirectiveTypes = ['center', 'lfCenter'];
	var centerDirectives = {};
	
	centerDirectiveTypes.forEach(function(directiveName) {
	  centerDirectives[directiveName] = ['$log', '$q', '$location', '$timeout', 'leafletMapDefaults', 'leafletHelpers',
	      'leafletBoundsHelpers', 'leafletMapEvents',
	        function($log, $q, $location, $timeout, leafletMapDefaults, leafletHelpers,
	      leafletBoundsHelpers, leafletMapEvents) {
	
	      var isDefined = leafletHelpers.isDefined;
	      var isNumber = leafletHelpers.isNumber;
	      var isSameCenterOnMap = leafletHelpers.isSameCenterOnMap;
	      var safeApply = leafletHelpers.safeApply;
	      var isValidCenter = leafletHelpers.isValidCenter;
	      var isValidBounds = leafletBoundsHelpers.isValidBounds;
	      var isUndefinedOrEmpty = leafletHelpers.isUndefinedOrEmpty;
	      var errorHeader = leafletHelpers.errorHeader;
	
	      var shouldInitializeMapWithBounds = function(bounds, center) {
	        return isDefined(bounds) && isValidBounds(bounds) && isUndefinedOrEmpty(center);
	      };
	
	      var _leafletCenter;
	      return {
	        restrict: 'A',
	        scope: false,
	        replace: false,
	        require: 'leaflet',
	        controller: function() {
	          _leafletCenter = $q.defer();
	          this.getCenter = function() {
	            return _leafletCenter.promise;
	          };
	        },
	
	        link: function(scope, element, attrs, controller) {
	          var leafletScope = controller.getLeafletScope();
	          var centerModel = leafletScope[directiveName];
	
	          controller.getMap().then(function(map) {
	            var defaults = leafletMapDefaults.getDefaults(attrs.id);
	
	            if (attrs[directiveName].search('-') !== -1) {
	              $log.error(errorHeader + ' The "center" variable can\'t use a "-" on its key name: "' + attrs[directiveName] + '".');
	              map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	              return;
	            } else if (shouldInitializeMapWithBounds(leafletScope.bounds, centerModel)) {
	              map.fitBounds(leafletBoundsHelpers.createLeafletBounds(leafletScope.bounds), leafletScope.bounds.options);
	              centerModel = map.getCenter();
	              safeApply(leafletScope, function(scope) {
	                angular.extend(scope[directiveName], {
	                  lat: map.getCenter().lat,
	                  lng: map.getCenter().lng,
	                  zoom: map.getZoom(),
	                  autoDiscover: false,
	                });
	              });
	
	              safeApply(leafletScope, function(scope) {
	                var mapBounds = map.getBounds();
	                scope.bounds = {
	                  northEast: {
	                    lat: mapBounds._northEast.lat,
	                    lng: mapBounds._northEast.lng,
	                  },
	                  southWest: {
	                    lat: mapBounds._southWest.lat,
	                    lng: mapBounds._southWest.lng,
	                  },
	                };
	              });
	            } else if (!isDefined(centerModel)) {
	              $log.error(errorHeader + ' The "center" property is not defined in the main scope');
	              map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	              return;
	            } else if (!(isDefined(centerModel.lat) && isDefined(centerModel.lng)) && !isDefined(centerModel.autoDiscover)) {
	              angular.copy(defaults.center, centerModel);
	            }
	
	            var urlCenterHash;
	            var mapReady;
	            if (attrs.urlHashCenter === 'yes') {
	              var extractCenterFromUrl = function() {
	                var search = $location.search();
	                var centerParam;
	                if (isDefined(search.c)) {
	                  var cParam = search.c.split(':');
	                  if (cParam.length === 3) {
	                    centerParam = {
	                      lat: parseFloat(cParam[0]),
	                      lng: parseFloat(cParam[1]),
	                      zoom: parseInt(cParam[2], 10),
	                    };
	                  }
	                }
	
	                return centerParam;
	              };
	
	              urlCenterHash = extractCenterFromUrl();
	
	              leafletScope.$on('$locationChangeSuccess', function(event) {
	                var scope = event.currentScope;
	
	                //$log.debug("updated location...");
	                var urlCenter = extractCenterFromUrl();
	                if (isDefined(urlCenter) && !isSameCenterOnMap(urlCenter, map)) {
	                  //$log.debug("updating center model...", urlCenter);
	                  angular.extend(scope[directiveName], {
	                    lat: urlCenter.lat,
	                    lng: urlCenter.lng,
	                    zoom: urlCenter.zoom,
	                  });
	                }
	              });
	            }
	
	            leafletScope.$watch(directiveName, function(center) {
	              if (leafletScope.settingCenterFromLeaflet)
	                  return;
	
	              //$log.debug("updated center model...");
	              // The center from the URL has priority
	              if (isDefined(urlCenterHash)) {
	                angular.copy(urlCenterHash, center);
	                urlCenterHash = undefined;
	              }
	
	              if (!isValidCenter(center) && center.autoDiscover !== true) {
	                $log.warn(errorHeader + ' invalid \'center\'');
	
	                //map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                return;
	              }
	
	              if (center.autoDiscover === true) {
	                if (!isNumber(center.zoom)) {
	                  map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                }
	
	                if (isNumber(center.zoom) && center.zoom > defaults.center.zoom) {
	                  map.locate({
	                    setView: true,
	                    maxZoom: center.zoom,
	                  });
	                } else if (isDefined(defaults.maxZoom)) {
	                  map.locate({
	                    setView: true,
	                    maxZoom: defaults.maxZoom,
	                  });
	                } else {
	                  map.locate({
	                    setView: true,
	                  });
	                }
	
	                return;
	              }
	
	              if (mapReady && isSameCenterOnMap(center, map)) {
	                //$log.debug("no need to update map again.");
	                return;
	              }
	
	              //$log.debug("updating map center...", center);
	              leafletScope.settingCenterFromScope = true;
	              map.setView([center.lat, center.lng], center.zoom);
	              leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	              $timeout(function() {
	                leafletScope.settingCenterFromScope = false;
	
	                //$log.debug("allow center scope updates");
	              });
	            }, true);
	
	            map.whenReady(function() {
	              mapReady = true;
	            });
	
	            map.on('moveend', function(/* event */) {
	              // Resolve the center after the first map position
	              _leafletCenter.resolve();
	              leafletMapEvents.notifyCenterUrlHashChanged(leafletScope, map, attrs, $location.search());
	
	              //$log.debug("updated center on map...");
	              if (isSameCenterOnMap(centerModel, map) || leafletScope.settingCenterFromScope) {
	                //$log.debug("same center in model, no need to update again.");
	                return;
	              }
	
	              leafletScope.settingCenterFromLeaflet = true;
	              safeApply(leafletScope, function(scope) {
	                if (!leafletScope.settingCenterFromScope) {
	                  //$log.debug("updating center model...", map.getCenter(), map.getZoom());
	                  angular.extend(scope[directiveName], {
	                    lat: map.getCenter().lat,
	                    lng: map.getCenter().lng,
	                    zoom: map.getZoom(),
	                    autoDiscover: false,
	                  });
	                }
	
	                leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                $timeout(function() {
	                  leafletScope.settingCenterFromLeaflet = false;
	                });
	              });
	            });
	
	            if (centerModel.autoDiscover === true) {
	              map.on('locationerror', function() {
	                $log.warn(errorHeader + ' The Geolocation API is unauthorized on this page.');
	                if (isValidCenter(centerModel)) {
	                  map.setView([centerModel.lat, centerModel.lng], centerModel.zoom);
	                  leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                } else {
	                  map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
	                  leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
	                }
	              });
	            }
	          });
	        },
	      };
	    },
	    ];
	});
	
	centerDirectiveTypes.forEach(function(dirType) {
	  angular.module('leaflet-directive').directive(dirType, centerDirectives[dirType]);
	});
	
	angular.module('leaflet-directive').directive('controls', ["$log", "leafletHelpers", "leafletControlHelpers", function($log, leafletHelpers, leafletControlHelpers) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: '?^leaflet',
	
	    link: function(scope, element, attrs, controller) {
	      if (!controller) {
	        return;
	      }
	
	      var createControl = leafletControlHelpers.createControl;
	      var isValidControlType = leafletControlHelpers.isValidControlType;
	      var leafletScope  = controller.getLeafletScope();
	      var isDefined = leafletHelpers.isDefined;
	      var isArray = leafletHelpers.isArray;
	      var leafletControls = {};
	      var errorHeader = leafletHelpers.errorHeader + ' [Controls] ';
	
	      controller.getMap().then(function(map) {
	
	        leafletScope.$watchCollection('controls', function(newControls) {
	
	          // Delete controls from the array
	          for (var name in leafletControls) {
	            if (!isDefined(newControls[name])) {
	              if (map.hasControl(leafletControls[name])) {
	                map.removeControl(leafletControls[name]);
	              }
	
	              delete leafletControls[name];
	            }
	          }
	
	          for (var newName in newControls) {
	            var control;
	
	            var controlType = isDefined(newControls[newName].type) ? newControls[newName].type : newName;
	
	            if (!isValidControlType(controlType)) {
	              $log.error(errorHeader + ' Invalid control type: ' + controlType + '.');
	              return;
	            }
	
	            if (controlType !== 'custom') {
	              control = createControl(controlType, newControls[newName]);
	              map.addControl(control);
	              leafletControls[newName] = control;
	            } else {
	              var customControlValue = newControls[newName];
	              if (isArray(customControlValue)) {
	                for (var i in customControlValue) {
	                  var customControl = customControlValue[i];
	                  map.addControl(customControl);
	                  leafletControls[newName] = !isDefined(leafletControls[newName]) ? [customControl] : leafletControls[newName].concat([customControl]);
	                }
	              } else {
	                map.addControl(customControlValue);
	                leafletControls[newName] = customControlValue;
	              }
	            }
	          }
	
	        });
	
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('decorations', ["$log", "leafletHelpers", function($log, leafletHelpers) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: 'leaflet',
	
	    link: function(scope, element, attrs, controller) {
	      var leafletScope = controller.getLeafletScope();
	      var PolylineDecoratorPlugin = leafletHelpers.PolylineDecoratorPlugin;
	      var isDefined = leafletHelpers.isDefined;
	      var leafletDecorations = {};
	
	      /* Creates an "empty" decoration with a set of coordinates, but no pattern. */
	      function createDecoration(options) {
	        if (isDefined(options) && isDefined(options.coordinates)) {
	          if (!PolylineDecoratorPlugin.isLoaded()) {
	            $log.error('[AngularJS - Leaflet] The PolylineDecorator Plugin is not loaded.');
	          }
	        }
	
	        return L.polylineDecorator(options.coordinates);
	      }
	
	      /* Updates the path and the patterns for the provided decoration, and returns the decoration. */
	      function setDecorationOptions(decoration, options) {
	        if (isDefined(decoration) && isDefined(options)) {
	          if (isDefined(options.coordinates) && isDefined(options.patterns)) {
	            decoration.setPaths(options.coordinates);
	            decoration.setPatterns(options.patterns);
	            return decoration;
	          }
	        }
	      }
	
	      controller.getMap().then(function(map) {
	        leafletScope.$watch('decorations', function(newDecorations) {
	          for (var name in leafletDecorations) {
	            if (!isDefined(newDecorations[name]) || !angular.equals(newDecorations[name], leafletDecorations)) {
	              map.removeLayer(leafletDecorations[name]);
	              delete leafletDecorations[name];
	            }
	          }
	
	          for (var newName in newDecorations) {
	            var decorationData = newDecorations[newName];
	            var newDecoration = createDecoration(decorationData);
	
	            if (isDefined(newDecoration)) {
	              leafletDecorations[newName] = newDecoration;
	              map.addLayer(newDecoration);
	              setDecorationOptions(newDecoration, decorationData);
	            }
	          }
	        }, true);
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('eventBroadcast', ["$log", "$rootScope", "leafletHelpers", "leafletMapEvents", "leafletIterators", function($log, $rootScope, leafletHelpers, leafletMapEvents, leafletIterators) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: 'leaflet',
	
	    link: function(scope, element, attrs, controller) {
	      var isObject = leafletHelpers.isObject;
	      var isDefined = leafletHelpers.isDefined;
	      var leafletScope  = controller.getLeafletScope();
	      var eventBroadcast = leafletScope.eventBroadcast;
	      var availableMapEvents = leafletMapEvents.getAvailableMapEvents();
	      var addEvents = leafletMapEvents.addEvents;
	
	      controller.getMap().then(function(map) {
	
	        var mapEvents = [];
	        var logic = 'broadcast';
	
	        // We have a possible valid object
	        if (!isDefined(eventBroadcast.map)) {
	          // We do not have events enable/disable do we do nothing (all enabled by default)
	          mapEvents = availableMapEvents;
	        } else if (!isObject(eventBroadcast.map)) {
	          // Not a valid object
	          $log.warn('[AngularJS - Leaflet] event-broadcast.map must be an object check your model.');
	        } else {
	          // We have a possible valid map object
	          // Event propadation logic
	          if (eventBroadcast.map.logic !== 'emit' && eventBroadcast.map.logic !== 'broadcast') {
	            // This is an error
	            $log.warn('[AngularJS - Leaflet] Available event propagation logic are: \'emit\' or \'broadcast\'.');
	          } else {
	            logic = eventBroadcast.map.logic;
	          }
	
	          if (!(isObject(eventBroadcast.map.enable) && eventBroadcast.map.enable.length >= 0)) {
	            $log.warn('[AngularJS - Leaflet] event-broadcast.map.enable must be an object check your model.');
	          } else {
	            // Enable events
	            leafletIterators.each(eventBroadcast.map.enable, function(eventName) {
	              // Do we have already the event enabled?
	              if (mapEvents.indexOf(eventName) === -1 && availableMapEvents.indexOf(eventName) !== -1) {
	                mapEvents.push(eventName);
	              }
	            });
	          }
	
	        }
	
	        // as long as the map is removed in the root leaflet directive we
	        // do not need ot clean up the events as leaflet does it itself
	        addEvents(map, mapEvents, 'eventName', leafletScope, logic);
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive')
	.directive('geojson', ["$log", "$rootScope", "leafletData", "leafletHelpers", "leafletWatchHelpers", "leafletDirectiveControlsHelpers", "leafletIterators", "leafletGeoJsonEvents", function($log, $rootScope, leafletData, leafletHelpers,
	    leafletWatchHelpers, leafletDirectiveControlsHelpers, leafletIterators, leafletGeoJsonEvents) {
	  var _maybeWatch = leafletWatchHelpers.maybeWatch;
	  var _watchOptions = leafletHelpers.watchOptions;
	  var _extendDirectiveControls = leafletDirectiveControlsHelpers.extend;
	  var hlp = leafletHelpers;
	  var $it = leafletIterators;
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: 'leaflet',
	
	    link: function(scope, element, attrs, controller) {
	      var isDefined = leafletHelpers.isDefined;
	      var leafletScope  = controller.getLeafletScope();
	      var leafletGeoJSON = {};
	      var _hasSetLeafletData = false;
	
	      controller.getMap().then(function(map) {
	        var watchOptions = leafletScope.geojsonWatchOptions || _watchOptions;
	
	        var _hookUpEvents = function(geojson, maybeName) {
	          var onEachFeature;
	
	          if (angular.isFunction(geojson.onEachFeature)) {
	            onEachFeature = geojson.onEachFeature;
	          } else {
	            onEachFeature = function(feature, layer) {
	              if (leafletHelpers.LabelPlugin.isLoaded() && isDefined(feature.properties.description)) {
	                layer.bindLabel(feature.properties.description);
	              }
	
	              leafletGeoJsonEvents.bindEvents(attrs.id, layer, null, feature,
	                  leafletScope, maybeName,
	                  {resetStyleOnMouseout: geojson.resetStyleOnMouseout,
	                  mapId: attrs.id, });
	            };
	          }
	
	          return onEachFeature;
	        };
	
	        var isNested = (hlp.isDefined(attrs.geojsonNested) &&
	            hlp.isTruthy(attrs.geojsonNested));
	
	        var _clean = function() {
	          if (!leafletGeoJSON)
	              return;
	          var _remove = function(lObject) {
	            if (isDefined(lObject) && map.hasLayer(lObject)) {
	              map.removeLayer(lObject);
	            }
	          };
	
	          if (isNested) {
	            $it.each(leafletGeoJSON, function(lObject) {
	              _remove(lObject);
	            });
	
	            return;
	          }
	
	          _remove(leafletGeoJSON);
	        };
	
	        var _addGeojson = function(model, maybeName) {
	          var geojson = angular.copy(model);
	          if (!(isDefined(geojson) && isDefined(geojson.data))) {
	            return;
	          }
	
	          var onEachFeature = _hookUpEvents(geojson, maybeName);
	
	          if (!isDefined(geojson.options)) {
	            //right here is why we use a clone / copy (we modify and thus)
	            //would kick of a watcher.. we need to be more careful everywhere
	            //for stuff like this
	            geojson.options = {
	              style: geojson.style,
	              filter: geojson.filter,
	              onEachFeature: onEachFeature,
	              pointToLayer: geojson.pointToLayer,
	            };
	          }
	
	          var lObject = L.geoJson(geojson.data, geojson.options);
	
	          if (maybeName && hlp.isString(maybeName)) {
	            leafletGeoJSON[maybeName] = lObject;
	          }          else {
	            leafletGeoJSON = lObject;
	          }
	
	          lObject.addTo(map);
	
	          if (!_hasSetLeafletData) {//only do this once and play with the same ref forever
	            _hasSetLeafletData = true;
	            leafletData.setGeoJSON(leafletGeoJSON, attrs.id);
	          }
	        };
	
	        var _create = function(model) {
	          _clean();
	          if (isNested) {
	            if (!model || !Object.keys(model).length)
	                return;
	            $it.each(model, function(m, name) {
	              //name could be layerName and or groupName
	              //for now it is not tied to a layer
	              _addGeojson(m, name);
	            });
	
	            return;
	          }
	
	          _addGeojson(model);
	        };
	
	        _extendDirectiveControls(attrs.id, 'geojson', _create, _clean);
	
	        _maybeWatch(leafletScope, 'geojson', watchOptions, function(geojson) {
	          _create(geojson);
	        });
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('layercontrol', ["$filter", "$log", "leafletData", "leafletHelpers", function($filter, $log, leafletData, leafletHelpers) {
	
	  return {
	    restrict: 'E',
	    scope: {
	      icons: '=?',
	      autoHideOpacity: '=?', // Hide other opacity controls when one is activated.
	      showGroups: '=?', // Hide other opacity controls when one is activated.
	      title: '@',
	      baseTitle: '@',
	      overlaysTitle: '@',
	    },
	    replace: true,
	    transclude: false,
	    require: '^leaflet',
	    controller: ["$scope", "$element", "$sce", function($scope, $element, $sce) {
	      $log.debug('[Angular Directive - Layers] layers', $scope, $element);
	      var safeApply = leafletHelpers.safeApply;
	      var isDefined = leafletHelpers.isDefined;
	      angular.extend($scope, {
	        baselayer: '',
	        oldGroup: '',
	        layerProperties: {},
	        groupProperties: {},
	        rangeIsSupported: leafletHelpers.rangeIsSupported(),
	        changeBaseLayer: function(key, e) {
	          leafletHelpers.safeApply($scope, function(scp) {
	            scp.baselayer = key;
	            leafletData.getMap().then(function(map) {
	              leafletData.getLayers().then(function(leafletLayers) {
	                if (map.hasLayer(leafletLayers.baselayers[key])) {
	                  return;
	                }
	
	                for (var i in scp.layers.baselayers) {
	                  scp.layers.baselayers[i].icon = scp.icons.unradio;
	                  if (map.hasLayer(leafletLayers.baselayers[i])) {
	                    map.removeLayer(leafletLayers.baselayers[i]);
	                  }
	                }
	
	                map.addLayer(leafletLayers.baselayers[key]);
	                scp.layers.baselayers[key].icon = $scope.icons.radio;
	              });
	            });
	          });
	
	          e.preventDefault();
	        },
	
	        moveLayer: function(ly, newIndex, e) {
	          var delta = Object.keys($scope.layers.baselayers).length;
	          if (newIndex >= (1 + delta) && newIndex <= ($scope.overlaysArray.length + delta)) {
	            var oldLy;
	            for (var key in $scope.layers.overlays) {
	              if ($scope.layers.overlays[key].index === newIndex) {
	                oldLy = $scope.layers.overlays[key];
	                break;
	              }
	            }
	
	            if (oldLy) {
	              safeApply($scope, function() {
	                oldLy.index = ly.index;
	                ly.index = newIndex;
	              });
	            }
	          }
	
	          e.stopPropagation();
	          e.preventDefault();
	        },
	
	        initIndex: function(layer, idx) {
	          var delta = Object.keys($scope.layers.baselayers).length;
	          layer.index = isDefined(layer.index) ? layer.index : idx + delta + 1;
	        },
	
	        initGroup: function(groupName) {
	          $scope.groupProperties[groupName] = $scope.groupProperties[groupName] ? $scope.groupProperties[groupName] : {};
	        },
	
	        toggleOpacity: function(e, layer) {
	          if (layer.visible) {
	            if ($scope.autoHideOpacity && !$scope.layerProperties[layer.name].opacityControl) {
	              for (var k in $scope.layerProperties) {
	                $scope.layerProperties[k].opacityControl = false;
	              }
	            }
	
	            $scope.layerProperties[layer.name].opacityControl = !$scope.layerProperties[layer.name].opacityControl;
	          }
	
	          e.stopPropagation();
	          e.preventDefault();
	        },
	
	        toggleLegend: function(layer) {
	          $scope.layerProperties[layer.name].showLegend = !$scope.layerProperties[layer.name].showLegend;
	        },
	
	        showLegend: function(layer) {
	          return layer.legend && $scope.layerProperties[layer.name].showLegend;
	        },
	
	        unsafeHTML: function(html) {
	          return $sce.trustAsHtml(html);
	        },
	
	        getOpacityIcon: function(layer) {
	          return layer.visible && $scope.layerProperties[layer.name].opacityControl ? $scope.icons.close : $scope.icons.open;
	        },
	
	        getGroupIcon: function(group) {
	          return group.visible ? $scope.icons.check : $scope.icons.uncheck;
	        },
	
	        changeOpacity: function(layer) {
	          var op = $scope.layerProperties[layer.name].opacity;
	          leafletData.getMap().then(function(map) {
	            leafletData.getLayers().then(function(leafletLayers) {
	              var ly;
	              for (var k in $scope.layers.overlays) {
	                if ($scope.layers.overlays[k] === layer) {
	                  ly = leafletLayers.overlays[k];
	                  break;
	                }
	              }
	
	              if (map.hasLayer(ly)) {
	                if (ly.setOpacity) {
	                  ly.setOpacity(op / 100);
	                }
	
	                if (ly.getLayers && ly.eachLayer) {
	                  ly.eachLayer(function(lay) {
	                    if (lay.setOpacity) {
	                      lay.setOpacity(op / 100);
	                    }
	                  });
	                }
	              }
	            });
	          });
	        },
	
	        changeGroupVisibility: function(groupName) {
	          if (!isDefined($scope.groupProperties[groupName])) {
	            return;
	          }
	
	          var visible = $scope.groupProperties[groupName].visible;
	          for (var k in $scope.layers.overlays) {
	            var layer = $scope.layers.overlays[k];
	            if (layer.group === groupName) {
	              layer.visible = visible;
	            }
	          }
	        },
	      });
	
	      var div = $element.get(0);
	      if (!L.Browser.touch) {
	        L.DomEvent.disableClickPropagation(div);
	        L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
	      } else {
	        L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
	      }
	    }],
	
	    template:
	    '<div class="angular-leaflet-control-layers" ng-show="overlaysArray.length">' +
	        '<h4 ng-if="title">{{ title }}</h4>' +
	        '<div class="lf-baselayers">' +
	            '<h5 class="lf-title" ng-if="baseTitle">{{ baseTitle }}</h5>' +
	            '<div class="lf-row" ng-repeat="(key, layer) in baselayersArray">' +
	                '<label class="lf-icon-bl" ng-click="changeBaseLayer(key, $event)">' +
	                    '<input class="leaflet-control-layers-selector" type="radio" name="lf-radio" ' +
	                        'ng-show="false" ng-checked="baselayer === key" ng-value="key" /> ' +
	                    '<i class="lf-icon lf-icon-radio" ng-class="layer.icon"></i>' +
	                    '<div class="lf-text">{{layer.name}}</div>' +
	                '</label>' +
	            '</div>' +
	        '</div>' +
	        '<div class="lf-overlays">' +
	            '<h5 class="lf-title" ng-if="overlaysTitle">{{ overlaysTitle }}</h5>' +
	            '<div class="lf-container">' +
	                '<div class="lf-row" ng-repeat="layer in (o = (overlaysArray | orderBy:\'index\':order))" ng-init="initIndex(layer, $index)">' +
	                    '<label class="lf-icon-ol-group" ng-if="showGroups &amp;&amp; layer.group &amp;&amp; layer.group != o[$index-1].group">' +
	                        '<input class="lf-control-layers-selector" type="checkbox" ng-show="false" ' +
	                            'ng-change="changeGroupVisibility(layer.group)" ng-model="groupProperties[layer.group].visible"/> ' +
	                        '<i class="lf-icon lf-icon-check" ng-class="getGroupIcon(groupProperties[layer.group])"></i>' +
	                        '<div class="lf-text">{{ layer.group }}</div>' +
	                    '</label>' +
	                    '<label class="lf-icon-ol">' +
	                        '<input class="lf-control-layers-selector" type="checkbox" ng-show="false" ng-model="layer.visible"/> ' +
	                        '<i class="lf-icon lf-icon-check" ng-class="layer.icon"></i>' +
	                        '<div class="lf-text">{{layer.name}}</div>' +
	                    '</label>' +
	                    '<div class="lf-icons">' +
	                        '<i class="lf-icon lf-up" ng-class="icons.up" ng-click="moveLayer(layer, layer.index - orderNumber, $event)"></i> ' +
	                        '<i class="lf-icon lf-down" ng-class="icons.down" ng-click="moveLayer(layer, layer.index + orderNumber, $event)"></i> ' +
	                        '<i class="lf-icon lf-toggle-legend" ng-class="icons.toggleLegend" ng-if="layer.legend" ng-click="toggleLegend(layer)"></i> ' +
	                        '<i class="lf-icon lf-open" ng-class="getOpacityIcon(layer)" ng-click="toggleOpacity($event, layer)"></i>' +
	                    '</div>' +
	                    '<div class="lf-legend" ng-if="showLegend(layer)" ng-bind-html="unsafeHTML(layer.legend)"></div>' +
	                    '<div class="lf-opacity clearfix" ng-if="layer.visible &amp;&amp; layerProperties[layer.name].opacityControl">' +
	                        '<label ng-if="rangeIsSupported" class="pull-left" style="width: 50%">0</label>' +
	                        '<label ng-if="rangeIsSupported" class="pull-left text-right" style="width: 50%">100</label>' +
	                        '<input ng-if="rangeIsSupported" class="clearfix" type="range" min="0" max="100" class="lf-opacity-control" ' +
	                            'ng-model="layerProperties[layer.name].opacity" ng-change="changeOpacity(layer)"/>' +
	                        '<h6 ng-if="!rangeIsSupported">Range is not supported in this browser</h6>' +
	                    '</div>' +
	                '</div>' +
	            '</div>' +
	        '</div>' +
	    '</div>',
	    link: function(scope, element, attrs, controller) {
	      var isDefined = leafletHelpers.isDefined;
	      var leafletScope = controller.getLeafletScope();
	      var layers = leafletScope.layers;
	
	      scope.$watch('icons', function() {
	        var defaultIcons = {
	          uncheck: 'fa fa-square-o',
	          check: 'fa fa-check-square-o',
	          radio: 'fa fa-dot-circle-o',
	          unradio: 'fa fa-circle-o',
	          up: 'fa fa-angle-up',
	          down: 'fa fa-angle-down',
	          open: 'fa fa-angle-double-down',
	          close: 'fa fa-angle-double-up',
	          toggleLegend: 'fa fa-pencil-square-o',
	        };
	        if (isDefined(scope.icons)) {
	          angular.extend(defaultIcons, scope.icons);
	          angular.extend(scope.icons, defaultIcons);
	        } else {
	          scope.icons = defaultIcons;
	        }
	      });
	
	      // Setting layer stack order.
	      attrs.order = (isDefined(attrs.order) && (attrs.order === 'normal' || attrs.order === 'reverse')) ? attrs.order : 'normal';
	      scope.order = attrs.order === 'normal';
	      scope.orderNumber = attrs.order === 'normal' ? -1 : 1;
	
	      scope.layers = layers;
	      controller.getMap().then(function(map) {
	        leafletScope.$watch('layers.baselayers', function(newBaseLayers) {
	          var baselayersArray = {};
	          leafletData.getLayers().then(function(leafletLayers) {
	            var key;
	            for (key in newBaseLayers) {
	              var layer = newBaseLayers[key];
	              layer.icon = scope.icons[map.hasLayer(leafletLayers.baselayers[key]) ? 'radio' : 'unradio'];
	              baselayersArray[key] = layer;
	            }
	
	            scope.baselayersArray = baselayersArray;
	          });
	        });
	
	        leafletScope.$watch('layers.overlays', function(newOverlayLayers) {
	          var overlaysArray = [];
	          var groupVisibleCount = {};
	          leafletData.getLayers().then(function(leafletLayers) {
	            var key;
	            for (key in newOverlayLayers) {
	              var layer = newOverlayLayers[key];
	              layer.icon = scope.icons[(layer.visible ? 'check' : 'uncheck')];
	              overlaysArray.push(layer);
	              if (!isDefined(scope.layerProperties[layer.name])) {
	                scope.layerProperties[layer.name] = {
	                  opacity: isDefined(layer.layerOptions.opacity) ? layer.layerOptions.opacity * 100 : 100,
	                  opacityControl: false,
	                  showLegend: true,
	                };
	              }
	
	              if (isDefined(layer.group)) {
	                if (!isDefined(scope.groupProperties[layer.group])) {
	                  scope.groupProperties[layer.group] = {
	                    visible: false,
	                  };
	                }
	
	                groupVisibleCount[layer.group] = isDefined(groupVisibleCount[layer.group]) ? groupVisibleCount[layer.group] : {
	                  count: 0,
	                  visibles: 0,
	                };
	                groupVisibleCount[layer.group].count++;
	                if (layer.visible) {
	                  groupVisibleCount[layer.group].visibles++;
	                }
	              }
	
	              if (isDefined(layer.index) && leafletLayers.overlays[key].setZIndex) {
	                leafletLayers.overlays[key].setZIndex(newOverlayLayers[key].index);
	              }
	            }
	
	            for (key in groupVisibleCount) {
	              scope.groupProperties[key].visible = groupVisibleCount[key].visibles === groupVisibleCount[key].count;
	            }
	
	            scope.overlaysArray = overlaysArray;
	          });
	        }, true);
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('layers', ["$log", "$q", "leafletData", "leafletHelpers", "leafletLayerHelpers", "leafletControlHelpers", function($log, $q, leafletData, leafletHelpers, leafletLayerHelpers, leafletControlHelpers) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: 'leaflet',
	    controller: ["$scope", function($scope) {
	      $scope._leafletLayers = $q.defer();
	      this.getLayers = function() {
	        return $scope._leafletLayers.promise;
	      };
	    }],
	
	    link: function(scope, element, attrs, controller) {
	      var isDefined = leafletHelpers.isDefined;
	      var leafletLayers = {};
	      var leafletScope  = controller.getLeafletScope();
	      var layers = leafletScope.layers;
	      var createLayer = leafletLayerHelpers.createLayer;
	      var safeAddLayer = leafletLayerHelpers.safeAddLayer;
	      var safeRemoveLayer = leafletLayerHelpers.safeRemoveLayer;
	      var updateLayersControl = leafletControlHelpers.updateLayersControl;
	      var isLayersControlVisible = false;
	
	      controller.getMap().then(function(map) {
	
	        // We have baselayers to add to the map
	        scope._leafletLayers.resolve(leafletLayers);
	        leafletData.setLayers(leafletLayers, attrs.id);
	
	        leafletLayers.baselayers = {};
	        leafletLayers.overlays = {};
	
	        var mapId = attrs.id;
	
	        // Setup all baselayers definitions
	        var oneVisibleLayer = false;
	        for (var layerName in layers.baselayers) {
	          var newBaseLayer = createLayer(layers.baselayers[layerName]);
	          if (!isDefined(newBaseLayer)) {
	            delete layers.baselayers[layerName];
	            continue;
	          }
	
	          leafletLayers.baselayers[layerName] = newBaseLayer;
	
	          // Only add the visible layer to the map, layer control manages the addition to the map
	          // of layers in its control
	          if (layers.baselayers[layerName].top === true) {
	            safeAddLayer(map, leafletLayers.baselayers[layerName]);
	            oneVisibleLayer = true;
	          }
	        }
	
	        // If there is no visible layer add first to the map
	        if (!oneVisibleLayer && Object.keys(leafletLayers.baselayers).length > 0) {
	          safeAddLayer(map, leafletLayers.baselayers[Object.keys(layers.baselayers)[0]]);
	        }
	
	        // Setup the Overlays
	        for (layerName in layers.overlays) {
	          //if (layers.overlays[layerName].type === 'cartodb') {
	          //
	          //}
	
	          var newOverlayLayer = createLayer(layers.overlays[layerName]);
	          if (!isDefined(newOverlayLayer)) {
	            delete layers.overlays[layerName];
	            continue;
	          }
	
	          leafletLayers.overlays[layerName] = newOverlayLayer;
	
	          // Only add the visible overlays to the map
	          if (layers.overlays[layerName].visible === true) {
	            safeAddLayer(map, leafletLayers.overlays[layerName]);
	          }
	        }
	
	        // Watch for the base layers
	        leafletScope.$watch('layers.baselayers', function(newBaseLayers, oldBaseLayers) {
	          if (angular.equals(newBaseLayers, oldBaseLayers)) {
	            isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, newBaseLayers, layers.overlays, leafletLayers);
	            return true;
	          }
	
	          // Delete layers from the array
	          for (var name in leafletLayers.baselayers) {
	            if (!isDefined(newBaseLayers[name]) || newBaseLayers[name].doRefresh) {
	              // Remove from the map if it's on it
	              if (map.hasLayer(leafletLayers.baselayers[name])) {
	                map.removeLayer(leafletLayers.baselayers[name]);
	              }
	
	              delete leafletLayers.baselayers[name];
	
	              if (newBaseLayers[name] && newBaseLayers[name].doRefresh) {
	                newBaseLayers[name].doRefresh = false;
	              }
	            }
	          }
	
	          // add new layers
	          for (var newName in newBaseLayers) {
	            if (!isDefined(leafletLayers.baselayers[newName])) {
	              var testBaseLayer = createLayer(newBaseLayers[newName]);
	              if (isDefined(testBaseLayer)) {
	                leafletLayers.baselayers[newName] = testBaseLayer;
	
	                // Only add the visible layer to the map
	                if (newBaseLayers[newName].top === true) {
	                  safeAddLayer(map, leafletLayers.baselayers[newName]);
	                }
	              }
	            } else {
	              if (newBaseLayers[newName].top === true && !map.hasLayer(leafletLayers.baselayers[newName])) {
	                safeAddLayer(map, leafletLayers.baselayers[newName]);
	              } else if (newBaseLayers[newName].top === false && map.hasLayer(leafletLayers.baselayers[newName])) {
	                map.removeLayer(leafletLayers.baselayers[newName]);
	              }
	            }
	          }
	
	          //we have layers, so we need to make, at least, one active
	          var found = false;
	
	          // search for an active layer
	          for (var key in leafletLayers.baselayers) {
	            if (map.hasLayer(leafletLayers.baselayers[key])) {
	              found = true;
	              break;
	            }
	          }
	
	          // If there is no active layer make one active
	          if (!found && Object.keys(leafletLayers.baselayers).length > 0) {
	            safeAddLayer(map, leafletLayers.baselayers[Object.keys(leafletLayers.baselayers)[0]]);
	          }
	
	          // Only show the layers switch selector control if we have more than one baselayer + overlay
	          isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, newBaseLayers, layers.overlays, leafletLayers);
	        }, true);
	
	        // Watch for the overlay layers
	        leafletScope.$watch('layers.overlays', function(newOverlayLayers, oldOverlayLayers) {
	          if (angular.equals(newOverlayLayers, oldOverlayLayers)) {
	            isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, layers.baselayers, newOverlayLayers, leafletLayers);
	            return true;
	          }
	
	          // Delete layers from the array
	          for (var name in leafletLayers.overlays) {
	            if (!isDefined(newOverlayLayers[name]) || newOverlayLayers[name].doRefresh) {
	              // Remove from the map if it's on it
	              if (map.hasLayer(leafletLayers.overlays[name])) {
	                // Safe remove when ArcGIS layers is loading.
	                var options = isDefined(newOverlayLayers[name]) ?
	                    newOverlayLayers[name].layerOptions : null;
	                safeRemoveLayer(map, leafletLayers.overlays[name], options);
	              }
	
	              // TODO: Depending on the layer type we will have to delete what's included on it
	              delete leafletLayers.overlays[name];
	
	              if (newOverlayLayers[name] && newOverlayLayers[name].doRefresh) {
	                newOverlayLayers[name].doRefresh = false;
	              }
	            }
	          }
	
	          // add new overlays
	          for (var newName in newOverlayLayers) {
	            if (!isDefined(leafletLayers.overlays[newName])) {
	              var testOverlayLayer = createLayer(newOverlayLayers[newName]);
	              if (!isDefined(testOverlayLayer)) {
	                // If the layer creation fails, continue to the next overlay
	                continue;
	              }
	
	              leafletLayers.overlays[newName] = testOverlayLayer;
	              if (newOverlayLayers[newName].visible === true) {
	                safeAddLayer(map, leafletLayers.overlays[newName]);
	              }
	            } else {
	              // check for the .visible property to hide/show overLayers
	              if (newOverlayLayers[newName].visible && !map.hasLayer(leafletLayers.overlays[newName])) {
	                safeAddLayer(map, leafletLayers.overlays[newName]);
	              } else if (newOverlayLayers[newName].visible === false && map.hasLayer(leafletLayers.overlays[newName])) {
	                // Safe remove when ArcGIS layers is loading.
	                safeRemoveLayer(map, leafletLayers.overlays[newName], newOverlayLayers[newName].layerOptions);
	              }
	            }
	
	            //refresh heatmap data if present
	            if (newOverlayLayers[newName].visible && map._loaded && newOverlayLayers[newName].data && newOverlayLayers[newName].type === 'heatmap') {
	              leafletLayers.overlays[newName].setData(newOverlayLayers[newName].data);
	              leafletLayers.overlays[newName].update();
	            }
	          }
	
	          // Only add the layers switch selector control if we have more than one baselayer + overlay
	          isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, layers.baselayers, newOverlayLayers, leafletLayers);
	        }, true);
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('legend', ["$log", "$http", "leafletHelpers", "leafletLegendHelpers", function($log, $http, leafletHelpers, leafletLegendHelpers) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: 'leaflet',
	
	    link: function(scope, element, attrs, controller) {
	
	      var isArray = leafletHelpers.isArray;
	      var isDefined = leafletHelpers.isDefined;
	      var isFunction = leafletHelpers.isFunction;
	      var leafletScope = controller.getLeafletScope();
	      var legend = leafletScope.legend;
	
	      var legendClass;
	      var position;
	      var leafletLegend;
	      var type;
	
	      leafletScope.$watch('legend', function(newLegend) {
	
	        if (isDefined(newLegend)) {
	
	          legendClass = newLegend.legendClass ? newLegend.legendClass : 'legend';
	
	          position = newLegend.position || 'bottomright';
	
	          // default to arcgis
	          type = newLegend.type || 'arcgis';
	        }
	
	      }, true);
	
	      controller.getMap().then(function(map) {
	
	        leafletScope.$watch('legend', function(newLegend) {
	
	          if (!isDefined(newLegend)) {
	
	            if (isDefined(leafletLegend)) {
	              leafletLegend.removeFrom(map);
	              leafletLegend = null;
	            }
	
	            return;
	          }
	
	          if (!isDefined(newLegend.url) && (type === 'arcgis') && (!isArray(newLegend.colors) || !isArray(newLegend.labels) || newLegend.colors.length !== newLegend.labels.length)) {
	
	            $log.warn('[AngularJS - Leaflet] legend.colors and legend.labels must be set.');
	
	            return;
	          }
	
	          if (isDefined(newLegend.url)) {
	
	            $log.info('[AngularJS - Leaflet] loading legend service.');
	
	            return;
	          }
	
	          if (isDefined(leafletLegend)) {
	            leafletLegend.removeFrom(map);
	            leafletLegend = null;
	          }
	
	          leafletLegend = L.control({
	            position: position,
	          });
	          if (type === 'arcgis') {
	            leafletLegend.onAdd = leafletLegendHelpers.getOnAddArrayLegend(newLegend, legendClass);
	          }
	
	          leafletLegend.addTo(map);
	
	        });
	
	        leafletScope.$watch('legend.url', function(newURL) {
	
	          if (!isDefined(newURL)) {
	            return;
	          }
	
	          $http.get(newURL)
	                            .success(function(legendData) {
	
	                              if (isDefined(leafletLegend)) {
	
	                                leafletLegendHelpers.updateLegend(leafletLegend.getContainer(), legendData, type, newURL);
	
	                              } else {
	
	                                leafletLegend = L.control({
	                                  position: position,
	                                });
	                                leafletLegend.onAdd = leafletLegendHelpers.getOnAddLegend(legendData, legendClass, type, newURL);
	                                leafletLegend.addTo(map);
	                              }
	
	                              if (isDefined(legend.loadedData) && isFunction(legend.loadedData)) {
	                                legend.loadedData();
	                              }
	                            })
	                            .error(function() {
	                              $log.warn('[AngularJS - Leaflet] legend.url not loaded.');
	                            });
	        });
	
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('markers',
	    ["$log", "$rootScope", "$q", "leafletData", "leafletHelpers", "leafletMapDefaults", "leafletMarkersHelpers", "leafletMarkerEvents", "leafletIterators", "leafletWatchHelpers", "leafletDirectiveControlsHelpers", function($log, $rootScope, $q, leafletData, leafletHelpers, leafletMapDefaults,
	              leafletMarkersHelpers, leafletMarkerEvents, leafletIterators, leafletWatchHelpers,
	              leafletDirectiveControlsHelpers) {
	      //less terse vars to helpers
	      var isDefined = leafletHelpers.isDefined;
	      var errorHeader = leafletHelpers.errorHeader;
	      var Helpers = leafletHelpers;
	      var isString = leafletHelpers.isString;
	      var addMarkerWatcher = leafletMarkersHelpers.addMarkerWatcher;
	      var updateMarker = leafletMarkersHelpers.updateMarker;
	      var listenMarkerEvents = leafletMarkersHelpers.listenMarkerEvents;
	      var addMarkerToGroup = leafletMarkersHelpers.addMarkerToGroup;
	      var createMarker = leafletMarkersHelpers.createMarker;
	      var deleteMarker = leafletMarkersHelpers.deleteMarker;
	      var $it = leafletIterators;
	      var _markersWatchOptions = leafletHelpers.watchOptions;
	      var maybeWatch = leafletWatchHelpers.maybeWatch;
	      var extendDirectiveControls = leafletDirectiveControlsHelpers.extend;
	
	      var _getLMarker = function(leafletMarkers, name, maybeLayerName) {
	        if (!Object.keys(leafletMarkers).length) return;
	        if (maybeLayerName && isString(maybeLayerName)) {
	          if (!leafletMarkers[maybeLayerName] || !Object.keys(leafletMarkers[maybeLayerName]).length)
	              return;
	          return leafletMarkers[maybeLayerName][name];
	        }
	
	        return leafletMarkers[name];
	      };
	
	      var _setLMarker = function(lObject, leafletMarkers, name, maybeLayerName) {
	        if (maybeLayerName && isString(maybeLayerName)) {
	          if (!isDefined(leafletMarkers[maybeLayerName]))
	              leafletMarkers[maybeLayerName] = {};
	          leafletMarkers[maybeLayerName][name] = lObject;
	        } else
	            leafletMarkers[name] = lObject;
	        return lObject;
	      };
	
	      var _maybeAddMarkerToLayer = function(layerName, layers, model, marker, doIndividualWatch, map) {
	
	        if (!isString(layerName)) {
	          $log.error(errorHeader + ' A layername must be a string');
	          return false;
	        }
	
	        if (!isDefined(layers)) {
	          $log.error(errorHeader + ' You must add layers to the directive if the markers are going to use this functionality.');
	          return false;
	        }
	
	        if (!isDefined(layers.overlays) || !isDefined(layers.overlays[layerName])) {
	          $log.error(errorHeader + ' A marker can only be added to a layer of type "group"');
	          return false;
	        }
	
	        var layerGroup = layers.overlays[layerName];
	        if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	          $log.error(errorHeader + ' Adding a marker to an overlay needs a overlay of the type "group" or "featureGroup"');
	          return false;
	        }
	
	        // The marker goes to a correct layer group, so first of all we add it
	        layerGroup.addLayer(marker);
	
	        // The marker is automatically added to the map depending on the visibility
	        // of the layer, so we only have to open the popup if the marker is in the map
	        if (!doIndividualWatch && map.hasLayer(marker) && model.focus === true) {
	          marker.openPopup();
	        }
	
	        return true;
	      };
	
	      //TODO: move to leafletMarkersHelpers??? or make a new class/function file (leafletMarkersHelpers is large already)
	      var _addMarkers = function(mapId, markersToRender, oldModels, map, layers, leafletMarkers, leafletScope,
	                                 watchOptions, maybeLayerName, skips) {
	        for (var newName in markersToRender) {
	          if (skips[newName])
	              continue;
	
	          if (newName.search('-') !== -1) {
	            $log.error('The marker can\'t use a "-" on his key name: "' + newName + '".');
	            continue;
	          }
	
	          var model = Helpers.copy(markersToRender[newName]);
	          var pathToMarker = Helpers.getObjectDotPath(maybeLayerName ? [maybeLayerName, newName] : [newName]);
	          var maybeLMarker = _getLMarker(leafletMarkers, newName, maybeLayerName);
	          if (!isDefined(maybeLMarker)) {
	            //(nmccready) very important to not have model changes when lObject is changed
	            //this might be desirable in some cases but it causes two-way binding to lObject which is not ideal
	            //if it is left as the reference then all changes from oldModel vs newModel are ignored
	            //see _destroy (where modelDiff becomes meaningless if we do not copy here)
	            var marker = createMarker(model);
	            var layerName = (model ? model.layer : undefined) || maybeLayerName; //original way takes pref
	            if (!isDefined(marker)) {
	              $log.error(errorHeader + ' Received invalid data on the marker ' + newName + '.');
	              continue;
	            }
	
	            _setLMarker(marker, leafletMarkers, newName, maybeLayerName);
	
	            // Bind message
	            if (isDefined(model.message)) {
	              marker.bindPopup(model.message, model.popupOptions);
	            }
	
	            // Add the marker to a cluster group if needed
	            if (isDefined(model.group)) {
	              var groupOptions = isDefined(model.groupOption) ? model.groupOption : null;
	              addMarkerToGroup(marker, model.group, groupOptions, map);
	            }
	
	            // Show label if defined
	            if (Helpers.LabelPlugin.isLoaded() && isDefined(model.label) && isDefined(model.label.message)) {
	              marker.bindLabel(model.label.message, model.label.options);
	            }
	
	            // Check if the marker should be added to a layer
	            if (isDefined(model) && (isDefined(model.layer) || isDefined(maybeLayerName))) {
	
	              var pass = _maybeAddMarkerToLayer(layerName, layers, model, marker,
	                  watchOptions.individual.doWatch, map);
	              if (!pass)
	                  continue; //something went wrong move on in the loop
	            } else if (!isDefined(model.group)) {
	              // We do not have a layer attr, so the marker goes to the map layer
	              map.addLayer(marker);
	              if (!watchOptions.individual.doWatch && model.focus === true) {
	                marker.openPopup();
	              }
	            }
	
	            if (watchOptions.individual.doWatch) {
	              addMarkerWatcher(marker, pathToMarker, leafletScope, layers, map,
	                  watchOptions.individual.isDeep);
	            }
	
	            listenMarkerEvents(marker, model, leafletScope, watchOptions.individual.doWatch, map);
	            leafletMarkerEvents.bindEvents(mapId, marker, pathToMarker, model, leafletScope, layerName);
	          }          else {
	            var oldModel = isDefined(oldModel) ? oldModels[newName] : undefined;
	            updateMarker(model, oldModel, maybeLMarker, pathToMarker, leafletScope, layers, map);
	          }
	        }
	      };
	
	      var _seeWhatWeAlreadyHave = function(markerModels, oldMarkerModels, lMarkers, isEqual, cb) {
	        var hasLogged = false;
	        var equals = false;
	        var oldMarker;
	        var newMarker;
	
	        var doCheckOldModel =  isDefined(oldMarkerModels);
	        for (var name in lMarkers) {
	          if (!hasLogged) {
	            $log.debug(errorHeader + '[markers] destroy: ');
	            hasLogged = true;
	          }
	
	          if (doCheckOldModel) {
	            //might want to make the option (in watch options) to disable deep checking
	            //ie the options to only check !== (reference check) instead of angular.equals (slow)
	            newMarker = markerModels[name];
	            oldMarker = oldMarkerModels[name];
	            equals = angular.equals(newMarker, oldMarker) && isEqual;
	          }
	
	          if (!isDefined(markerModels) ||
	              !Object.keys(markerModels).length ||
	              !isDefined(markerModels[name]) ||
	              !Object.keys(markerModels[name]).length ||
	              equals) {
	            if (cb && Helpers.isFunction(cb))
	                cb(newMarker, oldMarker, name);
	          }
	        }
	      };
	
	      var _destroy = function(markerModels, oldMarkerModels, lMarkers, map, layers) {
	        _seeWhatWeAlreadyHave(markerModels, oldMarkerModels, lMarkers, false,
	            function(newMarker, oldMarker, lMarkerName) {
	              $log.debug(errorHeader + '[marker] is deleting marker: ' + lMarkerName);
	              deleteMarker(lMarkers[lMarkerName], map, layers);
	              delete lMarkers[lMarkerName];
	            });
	      };
	
	      var _getNewModelsToSkipp =  function(newModels, oldModels, lMarkers) {
	        var skips = {};
	        _seeWhatWeAlreadyHave(newModels, oldModels, lMarkers, true,
	            function(newMarker, oldMarker, lMarkerName) {
	              $log.debug(errorHeader + '[marker] is already rendered, marker: ' + lMarkerName);
	              skips[lMarkerName] = newMarker;
	            });
	
	        return skips;
	      };
	
	      return {
	        restrict: 'A',
	        scope: false,
	        replace: false,
	        require: ['leaflet', '?layers'],
	
	        link: function(scope, element, attrs, controller) {
	          var mapController = controller[0];
	          var leafletScope  = mapController.getLeafletScope();
	
	          mapController.getMap().then(function(map) {
	            var leafletMarkers = {};
	            var getLayers;
	
	            // If the layers attribute is used, we must wait until the layers are created
	            if (isDefined(controller[1])) {
	              getLayers = controller[1].getLayers;
	            } else {
	              getLayers = function() {
	                var deferred = $q.defer();
	                deferred.resolve();
	                return deferred.promise;
	              };
	            }
	
	            var watchOptions = leafletScope.markersWatchOptions || _markersWatchOptions;
	
	            // backwards compat
	            if (isDefined(attrs.watchMarkers))
	                watchOptions.doWatch = watchOptions.individual.doWatch =
	                    (!isDefined(attrs.watchMarkers) || Helpers.isTruthy(attrs.watchMarkers));
	
	            var isNested = (isDefined(attrs.markersNested) && Helpers.isTruthy(attrs.markersNested));
	
	            getLayers().then(function(layers) {
	              var _clean = function(models, oldModels) {
	                if (isNested) {
	                  $it.each(models, function(markerToMaybeDel, layerName) {
	                    var oldModel = isDefined(oldModel) ? oldModels[layerName] : undefined;
	                    _destroy(markerToMaybeDel, oldModel, leafletMarkers[layerName], map, layers);
	                  });
	
	                  return;
	                }
	
	                _destroy(models, oldModels, leafletMarkers, map, layers);
	              };
	
	              var _create = function(models, oldModels) {
	                _clean(models, oldModels);
	                var skips = null;
	                if (isNested) {
	                  $it.each(models, function(markersToAdd, layerName) {
	                    var oldModel = isDefined(oldModel) ? oldModels[layerName] : undefined;
	                    skips = _getNewModelsToSkipp(models[layerName], oldModel, leafletMarkers[layerName]);
	                    _addMarkers(attrs.id, markersToAdd, oldModels, map, layers, leafletMarkers, leafletScope,
	                        watchOptions, layerName, skips);
	                  });
	
	                  return;
	                }
	
	                skips = _getNewModelsToSkipp(models, oldModels, leafletMarkers);
	                _addMarkers(attrs.id, models, oldModels, map, layers, leafletMarkers, leafletScope,
	                    watchOptions, undefined, skips);
	              };
	
	              extendDirectiveControls(attrs.id, 'markers', _create, _clean);
	              leafletData.setMarkers(leafletMarkers, attrs.id);
	
	              maybeWatch(leafletScope, 'markers', watchOptions, function(newMarkers, oldMarkers) {
	                _create(newMarkers, oldMarkers);
	              });
	            });
	          });
	        },
	      };
	    }]);
	
	angular.module('leaflet-directive').directive('maxbounds', ["$log", "leafletMapDefaults", "leafletBoundsHelpers", "leafletHelpers", function($log, leafletMapDefaults, leafletBoundsHelpers, leafletHelpers) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: 'leaflet',
	
	    link: function(scope, element, attrs, controller) {
	      var leafletScope  = controller.getLeafletScope();
	      var isValidBounds = leafletBoundsHelpers.isValidBounds;
	      var isNumber = leafletHelpers.isNumber;
	
	      controller.getMap().then(function(map) {
	        leafletScope.$watch('maxbounds', function(maxbounds) {
	          if (!isValidBounds(maxbounds)) {
	            // Unset any previous maxbounds
	            map.setMaxBounds();
	            return;
	          }
	
	          var leafletBounds = leafletBoundsHelpers.createLeafletBounds(maxbounds);
	          if (isNumber(maxbounds.pad)) {
	            leafletBounds = leafletBounds.pad(maxbounds.pad);
	          }
	
	          map.setMaxBounds(leafletBounds);
	          if (!attrs.center && !attrs.lfCenter) {
	            map.fitBounds(leafletBounds);
	          }
	        });
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('paths', ["$log", "$q", "leafletData", "leafletMapDefaults", "leafletHelpers", "leafletPathsHelpers", "leafletPathEvents", function($log, $q, leafletData, leafletMapDefaults, leafletHelpers, leafletPathsHelpers, leafletPathEvents) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: ['leaflet', '?layers'],
	
	    link: function(scope, element, attrs, controller) {
	      var mapController = controller[0];
	      var isDefined = leafletHelpers.isDefined;
	      var isString = leafletHelpers.isString;
	      var leafletScope  = mapController.getLeafletScope();
	      var paths     = leafletScope.paths;
	      var createPath = leafletPathsHelpers.createPath;
	      var bindPathEvents = leafletPathEvents.bindPathEvents;
	      var setPathOptions = leafletPathsHelpers.setPathOptions;
	
	      mapController.getMap().then(function(map) {
	        var defaults = leafletMapDefaults.getDefaults(attrs.id);
	        var getLayers;
	
	        // If the layers attribute is used, we must wait until the layers are created
	        if (isDefined(controller[1])) {
	          getLayers = controller[1].getLayers;
	        } else {
	          getLayers = function() {
	            var deferred = $q.defer();
	            deferred.resolve();
	            return deferred.promise;
	          };
	        }
	
	        if (!isDefined(paths)) {
	          return;
	        }
	
	        getLayers().then(function(layers) {
	
	          var leafletPaths = {};
	          leafletData.setPaths(leafletPaths, attrs.id);
	
	          // Should we watch for every specific marker on the map?
	          var shouldWatch = (!isDefined(attrs.watchPaths) || attrs.watchPaths === 'true');
	
	          // Function for listening every single path once created
	          var watchPathFn = function(leafletPath, name) {
	            var clearWatch = leafletScope.$watch('paths["' + name + '"]', function(pathData, old) {
	              if (!isDefined(pathData)) {
	                if (isDefined(old.layer)) {
	                  for (var i in layers.overlays) {
	                    var overlay = layers.overlays[i];
	                    overlay.removeLayer(leafletPath);
	                  }
	                }
	
	                map.removeLayer(leafletPath);
	                clearWatch();
	                return;
	              }
	
	              setPathOptions(leafletPath, pathData.type, pathData);
	            }, true);
	          };
	
	          leafletScope.$watchCollection('paths', function(newPaths) {
	
	            // Delete paths (by name) from the array
	            for (var name in leafletPaths) {
	              if (!isDefined(newPaths[name])) {
	                map.removeLayer(leafletPaths[name]);
	                delete leafletPaths[name];
	              }
	            }
	
	            // Create the new paths
	            for (var newName in newPaths) {
	              if (newName.search('\\$') === 0) {
	                continue;
	              }
	
	              if (newName.search('-') !== -1) {
	                $log.error('[AngularJS - Leaflet] The path name "' + newName + '" is not valid. It must not include "-" and a number.');
	                continue;
	              }
	
	              if (!isDefined(leafletPaths[newName])) {
	                var pathData = newPaths[newName];
	                var newPath = createPath(newName, newPaths[newName], defaults);
	
	                // bind popup if defined
	                if (isDefined(newPath) && isDefined(pathData.message)) {
	                  newPath.bindPopup(pathData.message, pathData.popupOptions);
	                }
	
	                // Show label if defined
	                if (leafletHelpers.LabelPlugin.isLoaded() && isDefined(pathData.label) && isDefined(pathData.label.message)) {
	                  newPath.bindLabel(pathData.label.message, pathData.label.options);
	                }
	
	                // Check if the marker should be added to a layer
	                if (isDefined(pathData) && isDefined(pathData.layer)) {
	
	                  if (!isString(pathData.layer)) {
	                    $log.error('[AngularJS - Leaflet] A layername must be a string');
	                    continue;
	                  }
	
	                  if (!isDefined(layers)) {
	                    $log.error('[AngularJS - Leaflet] You must add layers to the directive if the markers are going to use this functionality.');
	                    continue;
	                  }
	
	                  if (!isDefined(layers.overlays) || !isDefined(layers.overlays[pathData.layer])) {
	                    $log.error('[AngularJS - Leaflet] A path can only be added to a layer of type "group"');
	                    continue;
	                  }
	
	                  var layerGroup = layers.overlays[pathData.layer];
	                  if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
	                    $log.error('[AngularJS - Leaflet] Adding a path to an overlay needs a overlay of the type "group" or "featureGroup"');
	                    continue;
	                  }
	
	                  // Listen for changes on the new path
	                  leafletPaths[newName] = newPath;
	
	                  // The path goes to a correct layer group, so first of all we add it
	                  layerGroup.addLayer(newPath);
	
	                  if (shouldWatch) {
	                    watchPathFn(newPath, newName);
	                  } else {
	                    setPathOptions(newPath, pathData.type, pathData);
	                  }
	                } else if (isDefined(newPath)) {
	                  // Listen for changes on the new path
	                  leafletPaths[newName] = newPath;
	                  map.addLayer(newPath);
	
	                  if (shouldWatch) {
	                    watchPathFn(newPath, newName);
	                  } else {
	                    setPathOptions(newPath, pathData.type, pathData);
	                  }
	                }
	
	                bindPathEvents(attrs.id, newPath, newName, pathData, leafletScope);
	              }
	            }
	          });
	        });
	      });
	    },
	  };
	}]);
	
	angular.module('leaflet-directive').directive('tiles', ["$log", "leafletData", "leafletMapDefaults", "leafletHelpers", function($log, leafletData, leafletMapDefaults, leafletHelpers) {
	
	  return {
	    restrict: 'A',
	    scope: false,
	    replace: false,
	    require: 'leaflet',
	
	    link: function(scope, element, attrs, controller) {
	      var isDefined = leafletHelpers.isDefined;
	      var leafletScope  = controller.getLeafletScope();
	      var tiles = leafletScope.tiles;
	
	      if (!isDefined(tiles) ||  !isDefined(tiles.url)) {
	        $log.warn('[AngularJS - Leaflet] The \'tiles\' definition doesn\'t have the \'url\' property.');
	        return;
	      }
	
	      controller.getMap().then(function(map) {
	        var defaults = leafletMapDefaults.getDefaults(attrs.id);
	        var tileLayerObj;
	        leafletScope.$watch('tiles', function(tiles, oldtiles) {
	          var tileLayerOptions = defaults.tileLayerOptions;
	          var tileLayerUrl = defaults.tileLayer;
	
	          // If no valid tiles are in the scope, remove the last layer
	          if (!isDefined(tiles.url) && isDefined(tileLayerObj)) {
	            map.removeLayer(tileLayerObj);
	            return;
	          }
	
	          // No leafletTiles object defined yet
	          if (!isDefined(tileLayerObj)) {
	            if (isDefined(tiles.options)) {
	              angular.copy(tiles.options, tileLayerOptions);
	            }
	
	            if (isDefined(tiles.url)) {
	              tileLayerUrl = tiles.url;
	            }
	
	            if (tiles.type === 'wms') {
	              tileLayerObj = L.tileLayer.wms(tileLayerUrl, tileLayerOptions);
	            } else {
	              tileLayerObj = L.tileLayer(tileLayerUrl, tileLayerOptions);
	            }
	
	            tileLayerObj.addTo(map);
	            leafletData.setTiles(tileLayerObj, attrs.id);
	            return;
	          }
	
	          // If the options of the tilelayer is changed, we need to redraw the layer
	          if (isDefined(tiles.url) && isDefined(tiles.options) &&
	              (tiles.type !== oldtiles.type || !angular.equals(tiles.options, tileLayerOptions))) {
	            map.removeLayer(tileLayerObj);
	            tileLayerOptions = defaults.tileLayerOptions;
	            angular.copy(tiles.options, tileLayerOptions);
	            tileLayerUrl = tiles.url;
	
	            if (tiles.type === 'wms') {
	              tileLayerObj = L.tileLayer.wms(tileLayerUrl, tileLayerOptions);
	            } else {
	              tileLayerObj = L.tileLayer(tileLayerUrl, tileLayerOptions);
	            }
	
	            tileLayerObj.addTo(map);
	            leafletData.setTiles(tileLayerObj, attrs.id);
	            return;
	          }
	
	          // Only the URL of the layer is changed, update the tiles object
	          if (isDefined(tiles.url)) {
	            tileLayerObj.setUrl(tiles.url);
	          }
	        }, true);
	      });
	    },
	  };
	}]);
	
	/*
	    Create multiple similar directives for watchOptions to support directiveControl
	    instead. (when watches are disabled)
	    NgAnnotate does not work here due to the functional creation
	*/
	['markers', 'geojson'].forEach(function(name) {
	  angular.module('leaflet-directive').directive(name + 'WatchOptions', [
	      '$log', '$rootScope', '$q', 'leafletData', 'leafletHelpers',
	        function($log, $rootScope, $q, leafletData, leafletHelpers) {
	
	          var isDefined = leafletHelpers.isDefined,
	              errorHeader = leafletHelpers.errorHeader,
	              isObject = leafletHelpers.isObject,
	              _watchOptions = leafletHelpers.watchOptions;
	
	          return {
	            restrict: 'A',
	            scope: false,
	            replace: false,
	            require: ['leaflet'],
	
	            link: function(scope, element, attrs, controller) {
	              var mapController = controller[0],
	                  leafletScope = mapController.getLeafletScope();
	
	              mapController.getMap().then(function() {
	                if (isDefined(scope[name + 'WatchOptions'])) {
	                  if (isObject(scope[name + 'WatchOptions']))
	                      angular.extend(_watchOptions, scope[name + 'WatchOptions']);
	                  else
	                      $log.error(errorHeader + '[' + name + 'WatchOptions] is not an object');
	                  leafletScope[name + 'WatchOptions'] = _watchOptions;
	                }
	              });
	            },
	          };
	        }, ]);
	});
	
	angular.module('leaflet-directive')
	.factory('LeafletEventsHelpersFactory', ["$rootScope", "$q", "$log", "leafletHelpers", function($rootScope, $q, $log, leafletHelpers) {
	  var safeApply = leafletHelpers.safeApply;
	  var isDefined = leafletHelpers.isDefined;
	  var isObject = leafletHelpers.isObject;
	  var isArray = leafletHelpers.isArray;
	  var errorHeader = leafletHelpers.errorHeader;
	
	  var EventsHelper = function(rootBroadcastName, lObjectType) {
	    this.rootBroadcastName = rootBroadcastName;
	    $log.debug('LeafletEventsHelpersFactory: lObjectType: ' + lObjectType + 'rootBroadcastName: ' + rootBroadcastName);
	
	    //used to path/key out certain properties based on the type , "markers", "geojson"
	    this.lObjectType = lObjectType;
	  };
	
	  EventsHelper.prototype.getAvailableEvents = function() {return [];};
	
	  /*
	   argument: name: Note this can be a single string or dot notation
	   Example:
	   markerModel : {
	   m1: { lat:_, lon: _}
	   }
	   //would yield name of
	   name = "m1"
	
	   If nested:
	   markerModel : {
	   cars: {
	   m1: { lat:_, lon: _}
	   }
	   }
	   //would yield name of
	   name = "cars.m1"
	   */
	  EventsHelper.prototype.genDispatchEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra) {
	    var _this = this;
	
	    maybeMapId = maybeMapId || '';
	    if (maybeMapId)
	      maybeMapId = '.' + maybeMapId;
	
	    return function(e) {
	      var broadcastName = _this.rootBroadcastName + maybeMapId + '.' + eventName;
	      $log.debug(broadcastName);
	      _this.fire(leafletScope, broadcastName, logic, e, e.target || lObject, model, name, layerName, extra);
	    };
	  };
	
	  EventsHelper.prototype.fire = function(scope, broadcastName, logic, event, lObject, model, modelName, layerName) {
	    // Safely broadcast the event
	    safeApply(scope, function() {
	      var toSend = {
	        leafletEvent: event,
	        leafletObject: lObject,
	        modelName: modelName,
	        model: model,
	      };
	      if (isDefined(layerName))
	          angular.extend(toSend, {layerName: layerName});
	
	      if (logic === 'emit') {
	        scope.$emit(broadcastName, toSend);
	      } else {
	        $rootScope.$broadcast(broadcastName, toSend);
	      }
	    });
	  };
	
	  EventsHelper.prototype.bindEvents = function(maybeMapId, lObject, name, model, leafletScope, layerName, extra) {
	    var events = [];
	    var logic = 'emit';
	    var _this = this;
	
	    if (!isDefined(leafletScope.eventBroadcast)) {
	      // Backward compatibility, if no event-broadcast attribute, all events are broadcasted
	      events = this.getAvailableEvents();
	    } else if (!isObject(leafletScope.eventBroadcast)) {
	      // Not a valid object
	      $log.error(errorHeader + 'event-broadcast must be an object check your model.');
	    } else {
	      // We have a possible valid object
	      if (!isDefined(leafletScope.eventBroadcast[_this.lObjectType])) {
	        // We do not have events enable/disable do we do nothing (all enabled by default)
	        events = this.getAvailableEvents();
	      } else if (!isObject(leafletScope.eventBroadcast[_this.lObjectType])) {
	        // Not a valid object
	        $log.warn(errorHeader + 'event-broadcast.' + [_this.lObjectType]  + ' must be an object check your model.');
	      } else {
	        // We have a possible valid map object
	        // Event propadation logic
	        if (isDefined(leafletScope.eventBroadcast[this.lObjectType].logic)) {
	          // We take care of possible propagation logic
	          if (leafletScope.eventBroadcast[_this.lObjectType].logic !== 'emit' &&
	              leafletScope.eventBroadcast[_this.lObjectType].logic !== 'broadcast')
	                  $log.warn(errorHeader + 'Available event propagation logic are: \'emit\' or \'broadcast\'.');
	        }
	
	        // Enable / Disable
	        var eventsEnable = false;
	        var eventsDisable = false;
	        if (isDefined(leafletScope.eventBroadcast[_this.lObjectType].enable) &&
	            isArray(leafletScope.eventBroadcast[_this.lObjectType].enable))
	                eventsEnable = true;
	        if (isDefined(leafletScope.eventBroadcast[_this.lObjectType].disable) &&
	            isArray(leafletScope.eventBroadcast[_this.lObjectType].disable))
	                eventsDisable = true;
	
	        if (eventsEnable && eventsDisable) {
	          // Both are active, this is an error
	          $log.warn(errorHeader + 'can not enable and disable events at the same time');
	        } else if (!eventsEnable && !eventsDisable) {
	          // Both are inactive, this is an error
	          $log.warn(errorHeader + 'must enable or disable events');
	        } else {
	          // At this point the object is OK, lets enable or disable events
	          if (eventsEnable) {
	            // Enable events
	            leafletScope.eventBroadcast[this.lObjectType].enable.forEach(function(eventName) {
	              // Do we have already the event enabled?
	              if (events.indexOf(eventName) !== -1) {
	                // Repeated event, this is an error
	                $log.warn(errorHeader + 'This event ' + eventName + ' is already enabled');
	              } else {
	                // Does the event exists?
	                if (_this.getAvailableEvents().indexOf(eventName) === -1) {
	                  // The event does not exists, this is an error
	                  $log.warn(errorHeader + 'This event ' + eventName + ' does not exist');
	                } else {
	                  // All ok enable the event
	                  events.push(eventName);
	                }
	              }
	            });
	          } else {
	            // Disable events
	            events = this.getAvailableEvents();
	            leafletScope.eventBroadcast[_this.lObjectType].disable.forEach(function(eventName) {
	              var index = events.indexOf(eventName);
	              if (index === -1) {
	                // The event does not exist
	                $log.warn(errorHeader + 'This event ' + eventName + ' does not exist or has been already disabled');
	
	              } else {
	                events.splice(index, 1);
	              }
	            });
	          }
	        }
	      }
	    }
	
	    events.forEach(function(eventName) {
	      lObject.on(eventName, _this.genDispatchEvent(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra));
	    });
	
	    return logic;
	  };
	
	  return EventsHelper;
	}])
	.service('leafletEventsHelpers', ["LeafletEventsHelpersFactory", function(LeafletEventsHelpersFactory) {
	  return new LeafletEventsHelpersFactory();
	}]);
	
	angular.module('leaflet-directive')
	.factory('leafletGeoJsonEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", "leafletData", function($rootScope, $q, $log, leafletHelpers,
	  LeafletEventsHelpersFactory, leafletData) {
	  var safeApply = leafletHelpers.safeApply;
	  var EventsHelper = LeafletEventsHelpersFactory;
	
	  var GeoJsonEvents = function() {
	      EventsHelper.call(this, 'leafletDirectiveGeoJson', 'geojson');
	    };
	
	  GeoJsonEvents.prototype =  new EventsHelper();
	
	  GeoJsonEvents.prototype.genDispatchEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra) {
	    var base = EventsHelper.prototype.genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName);
	    var _this = this;
	
	    return function(e) {
	      if (eventName === 'mouseout') {
	        if (extra.resetStyleOnMouseout) {
	          leafletData.getGeoJSON(extra.mapId)
	                    .then(function(leafletGeoJSON) {
	                      //this is broken on nested needs to traverse or user layerName (nested)
	                      var lobj = layerName ? leafletGeoJSON[layerName] : leafletGeoJSON;
	                      lobj.resetStyle(e.target);
	                    });
	
	        }
	
	        safeApply(leafletScope, function() {
	          $rootScope.$broadcast(_this.rootBroadcastName + '.mouseout', e);
	        });
	      }
	
	      base(e); //common
	    };
	  };
	
	  GeoJsonEvents.prototype.getAvailableEvents = function() { return [
	      'click',
	      'dblclick',
	      'mouseover',
	      'mouseout',
	      ];
	  };
	
	  return new GeoJsonEvents();
	}]);
	
	angular.module('leaflet-directive')
	.factory('leafletLabelEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", function($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory) {
	  var Helpers = leafletHelpers;
	  var EventsHelper = LeafletEventsHelpersFactory;
	
	  var LabelEvents = function() {
	          EventsHelper.call(this, 'leafletDirectiveLabel', 'markers');
	        };
	
	  LabelEvents.prototype =  new EventsHelper();
	
	  LabelEvents.prototype.genDispatchEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	    var markerName = name.replace('markers.', '');
	    return EventsHelper.prototype
	        .genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, markerName, model, layerName);
	  };
	
	  LabelEvents.prototype.getAvailableEvents = function() {
	    return [
	        'click',
	        'dblclick',
	        'mousedown',
	        'mouseover',
	        'mouseout',
	        'contextmenu',
	    ];
	  };
	
	  LabelEvents.prototype.genEvents = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	    var _this = this;
	    var labelEvents = this.getAvailableEvents();
	    var scopeWatchName = Helpers.getObjectArrayPath('markers.' + name);
	    labelEvents.forEach(function(eventName) {
	      lObject.label.on(eventName, _this.genDispatchEvent(
	          maybeMapId, eventName, logic, leafletScope, lObject.label, scopeWatchName, model, layerName));
	    });
	  };
	
	  LabelEvents.prototype.bindEvents = function() {};
	
	  return new LabelEvents();
	}]);
	
	angular.module('leaflet-directive')
	.factory('leafletMapEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "leafletEventsHelpers", "leafletIterators", function($rootScope, $q, $log, leafletHelpers, leafletEventsHelpers, leafletIterators) {
	  var isDefined = leafletHelpers.isDefined;
	  var fire = leafletEventsHelpers.fire;
	
	  var _getAvailableMapEvents = function() {
	    return [
	        'click',
	        'dblclick',
	        'mousedown',
	        'mouseup',
	        'mouseover',
	        'mouseout',
	        'mousemove',
	        'contextmenu',
	        'focus',
	        'blur',
	        'preclick',
	        'load',
	        'unload',
	        'viewreset',
	        'movestart',
	        'move',
	        'moveend',
	        'dragstart',
	        'drag',
	        'dragend',
	        'zoomstart',
	        'zoomanim',
	        'zoomend',
	        'zoomlevelschange',
	        'resize',
	        'autopanstart',
	        'layeradd',
	        'layerremove',
	        'baselayerchange',
	        'overlayadd',
	        'overlayremove',
	        'locationfound',
	        'locationerror',
	        'popupopen',
	        'popupclose',
	        'draw:created',
	        'draw:edited',
	        'draw:deleted',
	        'draw:drawstart',
	        'draw:drawstop',
	        'draw:editstart',
	        'draw:editstop',
	        'draw:deletestart',
	        'draw:deletestop',
	    ];
	  };
	
	  var _genDispatchMapEvent = function(scope, eventName, logic, maybeMapId) {
	    if (maybeMapId)
	      maybeMapId = maybeMapId + '.';
	    return function(e) {
	      // Put together broadcast name
	      var broadcastName = 'leafletDirectiveMap.' + maybeMapId + eventName;
	      $log.debug(broadcastName);
	
	      // Safely broadcast the event
	      fire(scope, broadcastName, logic, e, e.target, scope);
	    };
	  };
	
	  var _notifyCenterChangedToBounds = function(scope) {
	    scope.$broadcast('boundsChanged');
	  };
	
	  var _notifyCenterUrlHashChanged = function(scope, map, attrs, search) {
	    if (!isDefined(attrs.urlHashCenter)) {
	      return;
	    }
	
	    var center = map.getCenter();
	    var centerUrlHash = (center.lat).toFixed(4) + ':' + (center.lng).toFixed(4) + ':' + map.getZoom();
	    if (!isDefined(search.c) || search.c !== centerUrlHash) {
	      //$log.debug("notified new center...");
	      scope.$emit('centerUrlHash', centerUrlHash);
	    }
	  };
	
	  var _addEvents =  function(map, mapEvents, contextName, scope, logic) {
	    leafletIterators.each(mapEvents, function(eventName) {
	      var context = {};
	      context[contextName] = eventName;
	      map.on(eventName, _genDispatchMapEvent(scope, eventName, logic, map._container.id || ''), context);
	    });
	  };
	
	  return {
	    getAvailableMapEvents: _getAvailableMapEvents,
	    genDispatchMapEvent: _genDispatchMapEvent,
	    notifyCenterChangedToBounds: _notifyCenterChangedToBounds,
	    notifyCenterUrlHashChanged: _notifyCenterUrlHashChanged,
	    addEvents: _addEvents,
	  };
	}]);
	
	angular.module('leaflet-directive')
	.factory('leafletMarkerEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", "leafletLabelEvents", function($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory, leafletLabelEvents) {
	  var safeApply = leafletHelpers.safeApply;
	  var isDefined = leafletHelpers.isDefined;
	  var Helpers = leafletHelpers;
	  var lblHelp = leafletLabelEvents;
	  var EventsHelper = LeafletEventsHelpersFactory;
	
	  var MarkerEvents = function() {
	      EventsHelper.call(this, 'leafletDirectiveMarker', 'markers');
	    };
	
	  MarkerEvents.prototype = new EventsHelper();
	
	  MarkerEvents.prototype.genDispatchEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	    var handle = EventsHelper.prototype
	        .genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName);
	    return function(e) {
	      // Broadcast old marker click name for backwards compatibility
	      if (eventName === 'click') {
	        safeApply(leafletScope, function() {
	          $rootScope.$broadcast('leafletDirectiveMarkersClick', name);
	        });
	      } else if (eventName === 'dragend') {
	        safeApply(leafletScope, function() {
	          model.lat = lObject.getLatLng().lat;
	          model.lng = lObject.getLatLng().lng;
	        });
	
	        if (model.message && model.focus === true) {
	          lObject.openPopup();
	        }
	      }
	
	      handle(e); //common
	    };
	  };
	
	  MarkerEvents.prototype.getAvailableEvents = function() { return [
	      'click',
	      'dblclick',
	      'mousedown',
	      'mouseover',
	      'mouseout',
	      'contextmenu',
	      'dragstart',
	      'drag',
	      'dragend',
	      'move',
	      'remove',
	      'popupopen',
	      'popupclose',
	      'touchend',
	      'touchstart',
	      'touchmove',
	      'touchcancel',
	      'touchleave',
	      ];
	  };
	
	  MarkerEvents.prototype.bindEvents = function(maybeMapId, lObject, name, model, leafletScope, layerName) {
	      var logic = EventsHelper.prototype.bindEvents.call(this, maybeMapId, lObject, name, model, leafletScope, layerName);
	
	      if (Helpers.LabelPlugin.isLoaded() && isDefined(lObject.label)) {
	        lblHelp.genEvents(maybeMapId, name, logic, leafletScope, lObject, model, layerName);
	      }
	    };
	
	  return new MarkerEvents();
	}]);
	
	angular.module('leaflet-directive')
	.factory('leafletPathEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "leafletLabelEvents", "leafletEventsHelpers", function($rootScope, $q, $log, leafletHelpers, leafletLabelEvents, leafletEventsHelpers) {
	  var isDefined = leafletHelpers.isDefined;
	  var isObject = leafletHelpers.isObject;
	  var Helpers = leafletHelpers;
	  var errorHeader = leafletHelpers.errorHeader;
	  var lblHelp = leafletLabelEvents;
	  var fire = leafletEventsHelpers.fire;
	
	  /*
	  TODO (nmccready) This EventsHelper needs to be derrived from leafletEventsHelpers to elminate copy and paste code.
	  */
	
	  var _genDispatchPathEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
	    maybeMapId = maybeMapId || '';
	
	    if (maybeMapId)
	      maybeMapId = '.' + maybeMapId;
	
	    return function(e) {
	      var broadcastName = 'leafletDirectivePath' + maybeMapId + '.' + eventName;
	      $log.debug(broadcastName);
	      fire(leafletScope, broadcastName, logic, e, e.target || lObject, model, name, layerName);
	    };
	  };
	
	  var _bindPathEvents = function(maybeMapId, lObject, name, model, leafletScope) {
	    var pathEvents = [];
	    var i;
	    var eventName;
	    var logic = 'broadcast';
	
	    if (!isDefined(leafletScope.eventBroadcast)) {
	      // Backward compatibility, if no event-broadcast attribute, all events are broadcasted
	      pathEvents = _getAvailablePathEvents();
	    } else if (!isObject(leafletScope.eventBroadcast)) {
	      // Not a valid object
	      $log.error(errorHeader + 'event-broadcast must be an object check your model.');
	    } else {
	      // We have a possible valid object
	      if (!isDefined(leafletScope.eventBroadcast.path)) {
	        // We do not have events enable/disable do we do nothing (all enabled by default)
	        pathEvents = _getAvailablePathEvents();
	      } else if (isObject(leafletScope.eventBroadcast.paths)) {
	        // Not a valid object
	        $log.warn(errorHeader + 'event-broadcast.path must be an object check your model.');
	      } else {
	        // We have a possible valid map object
	        // Event propadation logic
	        if (leafletScope.eventBroadcast.path.logic !== undefined && leafletScope.eventBroadcast.path.logic !== null) {
	          // We take care of possible propagation logic
	          if (leafletScope.eventBroadcast.path.logic !== 'emit' && leafletScope.eventBroadcast.path.logic !== 'broadcast') {
	            // This is an error
	            $log.warn(errorHeader + 'Available event propagation logic are: \'emit\' or \'broadcast\'.');
	          } else if (leafletScope.eventBroadcast.path.logic === 'emit') {
	            logic = 'emit';
	          }
	        }
	
	        // Enable / Disable
	        var pathEventsEnable = false;
	        var pathEventsDisable = false;
	        if (leafletScope.eventBroadcast.path.enable !== undefined && leafletScope.eventBroadcast.path.enable !== null) {
	          if (typeof leafletScope.eventBroadcast.path.enable === 'object') {
	            pathEventsEnable = true;
	          }
	        }
	
	        if (leafletScope.eventBroadcast.path.disable !== undefined && leafletScope.eventBroadcast.path.disable !== null) {
	          if (typeof leafletScope.eventBroadcast.path.disable === 'object') {
	            pathEventsDisable = true;
	          }
	        }
	
	        if (pathEventsEnable && pathEventsDisable) {
	          // Both are active, this is an error
	          $log.warn(errorHeader + 'can not enable and disable events at the same time');
	        } else if (!pathEventsEnable && !pathEventsDisable) {
	          // Both are inactive, this is an error
	          $log.warn(errorHeader + 'must enable or disable events');
	        } else {
	          // At this point the path object is OK, lets enable or disable events
	          if (pathEventsEnable) {
	            // Enable events
	            for (i = 0; i < leafletScope.eventBroadcast.path.enable.length; i++) {
	              eventName = leafletScope.eventBroadcast.path.enable[i];
	
	              // Do we have already the event enabled?
	              if (pathEvents.indexOf(eventName) !== -1) {
	                // Repeated event, this is an error
	                $log.warn(errorHeader + 'This event ' + eventName + ' is already enabled');
	              } else {
	                // Does the event exists?
	                if (_getAvailablePathEvents().indexOf(eventName) === -1) {
	                  // The event does not exists, this is an error
	                  $log.warn(errorHeader + 'This event ' + eventName + ' does not exist');
	                } else {
	                  // All ok enable the event
	                  pathEvents.push(eventName);
	                }
	              }
	            }
	          } else {
	            // Disable events
	            pathEvents = _getAvailablePathEvents();
	            for (i = 0; i < leafletScope.eventBroadcast.path.disable.length; i++) {
	              eventName = leafletScope.eventBroadcast.path.disable[i];
	              var index = pathEvents.indexOf(eventName);
	              if (index === -1) {
	                // The event does not exist
	                $log.warn(errorHeader + 'This event ' + eventName + ' does not exist or has been already disabled');
	
	              } else {
	                pathEvents.splice(index, 1);
	              }
	            }
	          }
	        }
	      }
	    }
	
	    for (i = 0; i < pathEvents.length; i++) {
	      eventName = pathEvents[i];
	      lObject.on(eventName, _genDispatchPathEvent(maybeMapId, eventName, logic, leafletScope, pathEvents, name));
	    }
	
	    if (Helpers.LabelPlugin.isLoaded() && isDefined(lObject.label)) {
	      lblHelp.genEvents(maybeMapId, name, logic, leafletScope, lObject, model);
	    }
	  };
	
	  var _getAvailablePathEvents = function() {
	    return [
	        'click',
	        'dblclick',
	        'mousedown',
	        'mouseover',
	        'mouseout',
	        'contextmenu',
	        'add',
	        'remove',
	        'popupopen',
	        'popupclose',
	    ];
	  };
	
	  return {
	    getAvailablePathEvents: _getAvailablePathEvents,
	    bindPathEvents: _bindPathEvents,
	  };
	}]);
	
	}(angular));

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	/*! 
	 * angular-loading-bar v0.9.0
	 * https://chieffancypants.github.io/angular-loading-bar
	 * Copyright (c) 2016 Wes Cruver
	 * License: MIT
	 */
	/*
	 * angular-loading-bar
	 *
	 * intercepts XHR requests and creates a loading bar.
	 * Based on the excellent nprogress work by rstacruz (more info in readme)
	 *
	 * (c) 2013 Wes Cruver
	 * License: MIT
	 */
	
	
	(function() {
	
	'use strict';
	
	// Alias the loading bar for various backwards compatibilities since the project has matured:
	angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
	angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);
	
	
	/**
	 * loadingBarInterceptor service
	 *
	 * Registers itself as an Angular interceptor and listens for XHR requests.
	 */
	angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
	  .config(['$httpProvider', function ($httpProvider) {
	
	    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {
	
	      /**
	       * The total number of requests made
	       */
	      var reqsTotal = 0;
	
	      /**
	       * The number of requests completed (either successfully or not)
	       */
	      var reqsCompleted = 0;
	
	      /**
	       * The amount of time spent fetching before showing the loading bar
	       */
	      var latencyThreshold = cfpLoadingBar.latencyThreshold;
	
	      /**
	       * $timeout handle for latencyThreshold
	       */
	      var startTimeout;
	
	
	      /**
	       * calls cfpLoadingBar.complete() which removes the
	       * loading bar from the DOM.
	       */
	      function setComplete() {
	        $timeout.cancel(startTimeout);
	        cfpLoadingBar.complete();
	        reqsCompleted = 0;
	        reqsTotal = 0;
	      }
	
	      /**
	       * Determine if the response has already been cached
	       * @param  {Object}  config the config option from the request
	       * @return {Boolean} retrns true if cached, otherwise false
	       */
	      function isCached(config) {
	        var cache;
	        var defaultCache = $cacheFactory.get('$http');
	        var defaults = $httpProvider.defaults;
	
	        // Choose the proper cache source. Borrowed from angular: $http service
	        if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	            cache = angular.isObject(config.cache) ? config.cache
	              : angular.isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	        }
	
	        var cached = cache !== undefined ?
	          cache.get(config.url) !== undefined : false;
	
	        if (config.cached !== undefined && cached !== config.cached) {
	          return config.cached;
	        }
	        config.cached = cached;
	        return cached;
	      }
	
	
	      return {
	        'request': function(config) {
	          // Check to make sure this request hasn't already been cached and that
	          // the requester didn't explicitly ask us to ignore this request:
	          if (!config.ignoreLoadingBar && !isCached(config)) {
	            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
	            if (reqsTotal === 0) {
	              startTimeout = $timeout(function() {
	                cfpLoadingBar.start();
	              }, latencyThreshold);
	            }
	            reqsTotal++;
	            cfpLoadingBar.set(reqsCompleted / reqsTotal);
	          }
	          return config;
	        },
	
	        'response': function(response) {
	          if (!response || !response.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return response;
	          }
	
	          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return response;
	        },
	
	        'responseError': function(rejection) {
	          if (!rejection || !rejection.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return $q.reject(rejection);
	          }
	
	          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return $q.reject(rejection);
	        }
	      };
	    }];
	
	    $httpProvider.interceptors.push(interceptor);
	  }]);
	
	
	/**
	 * Loading Bar
	 *
	 * This service handles adding and removing the actual element in the DOM.
	 * Generally, best practices for DOM manipulation is to take place in a
	 * directive, but because the element itself is injected in the DOM only upon
	 * XHR requests, and it's likely needed on every view, the best option is to
	 * use a service.
	 */
	angular.module('cfp.loadingBar', [])
	  .provider('cfpLoadingBar', function() {
	
	    this.autoIncrement = true;
	    this.includeSpinner = true;
	    this.includeBar = true;
	    this.latencyThreshold = 100;
	    this.startSize = 0.02;
	    this.parentSelector = 'body';
	    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
	    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';
	
	    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
	      var $animate;
	      var $parentSelector = this.parentSelector,
	        loadingBarContainer = angular.element(this.loadingBarTemplate),
	        loadingBar = loadingBarContainer.find('div').eq(0),
	        spinner = angular.element(this.spinnerTemplate);
	
	      var incTimeout,
	        completeTimeout,
	        started = false,
	        status = 0;
	
	      var autoIncrement = this.autoIncrement;
	      var includeSpinner = this.includeSpinner;
	      var includeBar = this.includeBar;
	      var startSize = this.startSize;
	
	      /**
	       * Inserts the loading bar element into the dom, and sets it to 2%
	       */
	      function _start() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $timeout.cancel(completeTimeout);
	
	        // do not continually broadcast the started event:
	        if (started) {
	          return;
	        }
	
	        var document = $document[0];
	        var parent = document.querySelector ?
	          document.querySelector($parentSelector)
	          : $document.find($parentSelector)[0]
	        ;
	
	        if (! parent) {
	          parent = document.getElementsByTagName('body')[0];
	        }
	
	        var $parent = angular.element(parent);
	        var $after = parent.lastChild && angular.element(parent.lastChild);
	
	        $rootScope.$broadcast('cfpLoadingBar:started');
	        started = true;
	
	        if (includeBar) {
	          $animate.enter(loadingBarContainer, $parent, $after);
	        }
	
	        if (includeSpinner) {
	          $animate.enter(spinner, $parent, loadingBarContainer);
	        }
	
	        _set(startSize);
	      }
	
	      /**
	       * Set the loading bar's width to a certain percent.
	       *
	       * @param n any value between 0 and 1
	       */
	      function _set(n) {
	        if (!started) {
	          return;
	        }
	        var pct = (n * 100) + '%';
	        loadingBar.css('width', pct);
	        status = n;
	
	        // increment loadingbar to give the illusion that there is always
	        // progress but make sure to cancel the previous timeouts so we don't
	        // have multiple incs running at the same time.
	        if (autoIncrement) {
	          $timeout.cancel(incTimeout);
	          incTimeout = $timeout(function() {
	            _inc();
	          }, 250);
	        }
	      }
	
	      /**
	       * Increments the loading bar by a random amount
	       * but slows down as it progresses
	       */
	      function _inc() {
	        if (_status() >= 1) {
	          return;
	        }
	
	        var rnd = 0;
	
	        // TODO: do this mathmatically instead of through conditions
	
	        var stat = _status();
	        if (stat >= 0 && stat < 0.25) {
	          // Start out between 3 - 6% increments
	          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
	        } else if (stat >= 0.25 && stat < 0.65) {
	          // increment between 0 - 3%
	          rnd = (Math.random() * 3) / 100;
	        } else if (stat >= 0.65 && stat < 0.9) {
	          // increment between 0 - 2%
	          rnd = (Math.random() * 2) / 100;
	        } else if (stat >= 0.9 && stat < 0.99) {
	          // finally, increment it .5 %
	          rnd = 0.005;
	        } else {
	          // after 99%, don't increment:
	          rnd = 0;
	        }
	
	        var pct = _status() + rnd;
	        _set(pct);
	      }
	
	      function _status() {
	        return status;
	      }
	
	      function _completeAnimation() {
	        status = 0;
	        started = false;
	      }
	
	      function _complete() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $rootScope.$broadcast('cfpLoadingBar:completed');
	        _set(1);
	
	        $timeout.cancel(completeTimeout);
	
	        // Attempt to aggregate any start/complete calls within 500ms:
	        completeTimeout = $timeout(function() {
	          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
	          if (promise && promise.then) {
	            promise.then(_completeAnimation);
	          }
	          $animate.leave(spinner);
	        }, 500);
	      }
	
	      return {
	        start            : _start,
	        set              : _set,
	        status           : _status,
	        inc              : _inc,
	        complete         : _complete,
	        autoIncrement    : this.autoIncrement,
	        includeSpinner   : this.includeSpinner,
	        latencyThreshold : this.latencyThreshold,
	        parentSelector   : this.parentSelector,
	        startSize        : this.startSize
	      };
	
	
	    }];     //
	  });       // wtf javascript. srsly
	})();       //


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(128);
	module.exports = 'angular-loading-bar';


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.2
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage`, `ngMessageExp` and `ngMessageDefault` directives.
	 *
	 * ## Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritize messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, AngularJS may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate See the ngAnimate docs} to learn how to use JavaScript animations or to learn
	 * more about ngAnimate.
	 *
	 * ## Displaying a default message
	 * If the ngMessages renders no inner ngMessage directive (i.e. when none of the truthy
	 * keys are matched by a defined message), then it will render a default message
	 * using the {@link ngMessageDefault} directive.
	 * Note that matched messages will always take precedence over unmatched messages. That means
	 * the default message will not be displayed when another message is matched. This is also
	 * true for `ng-messages-multiple`.
	 *
	 * ```html
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 *   <div ng-message-default>This field has an input error</div>
	 * </div>
	 * ```
	 *
	
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from AngularJS core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	  .info({ angularVersion: '1.8.2' })
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used (With {@link ngMessagesInclude}) to promote message
	   * reusability and messages can also be overridden.
	   *
	   * A default message can also be displayed when no `ngMessage` directive is inserted, using the
	   * {@link ngMessageDefault} directive.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   *   <ANY ng-message-default>...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   *   <ng-message-default>...</ng-message-default>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *         <div ng-message-default>This field has an input error</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var truthyKeys = 0;
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (truthy(value) && !messageUsed) {
	                  truthyKeys++;
	
	                  if (messageCtrl.test(key)) {
	                    // this is to prevent the same error name from showing up twice
	                    if (matchedKeys[key]) return;
	                    matchedKeys[key] = true;
	
	                    messageUsed = true;
	                    messageCtrl.attach();
	                  }
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          var messageMatched = unmatchedMessages.length !== totalMessages;
	          var attachDefault = ctrl.default && !messageMatched && truthyKeys > 0;
	
	          if (attachDefault) {
	            ctrl.default.attach();
	          } else if (ctrl.default) {
	            ctrl.default.detach();
	          }
	
	          if (messageMatched || attachDefault) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl, isDefault) {
	          if (isDefault) {
	            ctrl.default = messageCtrl;
	          } else {
	            var nextKey = latestKey.toString();
	            messages[nextKey] = {
	              message: messageCtrl
	            };
	            insertMessageNode($element[0], comment, nextKey);
	            comment.$$ngMessageNode = nextKey;
	            latestKey++;
	          }
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment, isDefault) {
	          if (isDefault) {
	            delete ctrl.default;
	          } else {
	            var key = comment.$$ngMessageNode;
	            delete comment.$$ngMessageNode;
	            removeMessageNode($element[0], comment, key);
	            delete messages[key];
	          }
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          // This message node may have already been removed by a call to deregister()
	          if (!messageNode) return;
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   * @priority 1
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory())
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageDefault
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessageDefault` is a directive with the purpose to show and hide a default message for
	   * {@link directive:ngMessages}, when none of provided messages matches.
	   *
	   * More information about using `ngMessageDefault` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-default>...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message-default>...</ng-message-default>
	   * </ng-messages>
	   *
	  */
	  .directive('ngMessageDefault', ngMessageDirectiveFactory(true));
	
	function ngMessageDirectiveFactory(isDefault) {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode, records, staticExp, dynamicExp;
	
	        if (!isDefault) {
	          commentNode = element[0];
	          staticExp = attrs.ngMessage || attrs.when;
	          dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	
	          var assignRecords = function(items) {
	            records = items
	                ? (isArray(items)
	                      ? items
	                      : items.split(/[\s,]+/))
	                : null;
	            ngMessagesCtrl.reRender();
	          };
	
	          if (dynamicExp) {
	            assignRecords(scope.$eval(dynamicExp));
	            scope.$watchCollection(dynamicExp, assignRecords);
	          } else {
	            assignRecords(staticExp);
	          }
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  // If the message element was removed via a call to `detach` then `currentElement` will be null
	                  // So this handler only handles cases where something else removed the message element.
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode, isDefault);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        }, isDefault);
	
	        // We need to ensure that this directive deregisters itself when it no longer exists
	        // Normally this is done when the attached element is destroyed; but if this directive
	        // gets removed before we attach the message to the DOM there is nothing to watch
	        // in which case we must deregister when the containing scope is destroyed.
	        scope.$on('$destroy', function() {
	          ngMessagesCtrl.deregister(commentNode, isDefault);
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(130);
	module.exports = 'ngMessages';


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.2
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var $resourceMinErr = angular.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
	
	function isValidDottedPath(path) {
	  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
	      MEMBER_NAME_REGEX.test('.' + path));
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
	    var key = keys[i];
	    obj = (obj !== null) ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  angular.forEach(dst, function(value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
	 */
	
	/**
	 * @ngdoc provider
	 * @name $resourceProvider
	 *
	 * @description
	 *
	 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
	 * service.
	 *
	 * ## Dependencies
	 * Requires the {@link ngResource } module to be installed.
	 *
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 * @requires ng.$log
	 * @requires $q
	 * @requires ng.$timeout
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If a parameter value is a function, it will be called every time
	 *   a param value needs to be obtained for a request (unless the param was overridden). The
	 *   function will be passed the current data value as an argument.
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb: 'greet', salutation: 'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
	 *   extracted from the corresponding property on the `data` object (provided when calling actions
	 *   with a request body).
	 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
	 *   `someParam` will be `data.someProp`.
	 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
	 *   method that does not accept a request body).
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that will be available
	 *   in addition to the default set of resource actions (see below). If a custom action has the same
	 *   key as a default action (e.g. `save`), then the default action will be *overwritten*, and not
	 *   extended.
	 *
	 *   The declaration should be created in the format of {@link ng.$http#usage $http.config}:
	 *
	 *       {
	 *         action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *         action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *         ...
	 *       }
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be called every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden). The function will be passed the
	 *     current data value as an argument.
	 *   - **`url`** – {string} – Action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     Transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	 *     Transform function or an array of such functions. The transform function takes the HTTP
	 *     response body, headers and status and returns its transformed (typically deserialized)
	 *     version.
	 *     By default, transformResponse will contain one function that checks if the response looks
	 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
	 *     set `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – A boolean value or object created with
	 *     {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	 *     See {@link $http#caching $http Caching} for more information.
	 *   - **`timeout`** – `{number}` – Timeout in milliseconds.<br />
	 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
	 *     **not** supported in `$resource`, because the same value would be used for multiple requests.
	 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
	 *   - **`cancellable`** – `{boolean}` – If true, the request made by a "non-instance" call will be
	 *     cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	 *     value. Calling `$cancelRequest()` for a non-cancellable or an already completed/cancelled
	 *     request will have no effect.
	 *   - **`withCredentials`** – `{boolean}` – Whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials)
	 *     for more information.
	 *   - **`responseType`** – `{string}` – See
	 *     [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseType).
	 *   - **`interceptor`** – `{Object=}` – The interceptor object has four optional methods -
	 *     `request`, `requestError`, `response`, and `responseError`. See
	 *     {@link ng.$http#interceptors $http interceptors} for details. Note that
	 *     `request`/`requestError` interceptors are applied before calling `$http`, thus before any
	 *     global `$http` interceptors. Also, rejecting or throwing an error inside the `request`
	 *     interceptor will result in calling the `responseError` interceptor.
	 *     The resource instance or collection is available on the `resource` property of the
	 *     `http response` object passed to `response`/`responseError` interceptors.
	 *     Keep in mind that the associated promise will be resolved with the value returned by the
	 *     response interceptors. Make sure you return an appropriate value and not the `response`
	 *     object passed as input. For reference, the default `response` interceptor (which gets applied
	 *     if you don't specify a custom one) returns `response.resource`.<br />
	 *     See {@link ngResource.$resource#using-interceptors below} for an example of using
	 *     interceptors in `$resource`.
	 *   - **`hasBody`** – `{boolean}` – If true, then the request will have a body.
	 *     If not specified, then only POST, PUT and PATCH requests will have a body. *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The supported options are:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
	 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
	 *   This can be overwritten per action. (Defaults to false.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   {
	 *     'get':    {method: 'GET'},
	 *     'save':   {method: 'POST'},
	 *     'query':  {method: 'GET', isArray: true},
	 *     'remove': {method: 'DELETE'},
	 *     'delete': {method: 'DELETE'}
	 *   }
	 *   ```
	 *
	 *   Calling these methods invoke {@link ng.$http} with the specified http method, destination and
	 *   parameters. When the data is returned from the server then the object is an instance of the
	 *   resource class. The actions `save`, `remove` and `delete` are available on it as methods with
	 *   the `$` prefix. This allows you to easily perform CRUD operations (create, read, update,
	 *   delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId: '@id'});
	 *   User.get({userId: 123}).$promise.then(function(user) {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a `$resource` object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - "class" actions without a body: `Resource.action([parameters], [success], [error])`
	 *   - "class" actions with a body: `Resource.action([parameters], postData, [success], [error])`
	 *   - instance actions: `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   When calling instance methods, the instance itself is used as the request body (if the action
	 *   should have a body). By default, only actions using `POST`, `PUT` or `PATCH` have request
	 *   bodies, but you can use the `hasBody` configuration option to specify whether an action
	 *   should have a body or not (regardless of its HTTP method).
	 *
	 *
	 *   Success callback is called with (value (Object|Array), responseHeaders (Function),
	 *   status (number), statusText (string)) arguments, where `value` is the populated resource
	 *   instance or collection object. The error callback is called with (httpResponse) argument.
	 *
	 *   Class actions return an empty instance (with the additional properties listed below).
	 *   Instance actions return a promise for the operation.
	 *
	 *   The Resource instances and collections have these additional properties:
	 *
	 *   - `$promise`: The {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in the
	 *     {@link ngRoute.$routeProvider `resolve` section of `$routeProvider.when()`} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is rejected with the {@link ng.$http http response} object.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the response interceptor (on success) or responceError interceptor (on failure).
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding. If there is a response/responseError interceptor and it returns a promise,
	 *      `$resolved` will wait for that too.
	 *
	 *   The Resource instances and collections have these additional methods:
	 *
	 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
	 *      collection, calling this method will abort the request.
	 *
	 *   The Resource instances have these additional methods:
	 *
	 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
	 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
	 *     without attaching AngularJS-specific fields. Notice that `JSON.stringify` (and
	 *     `angular.toJson`) automatically use this method when serializing a Resource instance
	 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON%28%29_behavior)).
	 *
	 * @example
	 *
	 * ### Basic usage
	 *
	   ```js
	     // Define a CreditCard class
	     var CreditCard = $resource('/users/:userId/cards/:cardId',
	       {userId: 123, cardId: '@id'}, {
	         charge: {method: 'POST', params: {charge: true}}
	       });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query();
	         // GET: /users/123/cards
	         // server returns: [{id: 456, number: '1234', name: 'Smith'}]
	
	     // Wait for the request to complete
	     cards.$promise.then(function() {
	       var card = cards[0];
	
	       // Each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	
	       // Non-GET methods are mapped onto the instances
	       card.name = 'J. Smith';
	       card.$save();
	           // POST: /users/123/cards/456 {id: 456, number: '1234', name: 'J. Smith'}
	           // server returns: {id: 456, number: '1234', name: 'J. Smith'}
	
	       // Our custom method is mapped as well (since it uses POST)
	       card.$charge({amount: 9.99});
	           // POST: /users/123/cards/456?amount=9.99&charge=true {id: 456, number: '1234', name: 'J. Smith'}
	     });
	
	     // We can create an instance as well
	     var newCard = new CreditCard({number: '0123'});
	     newCard.name = 'Mike Smith';
	
	     var savePromise = newCard.$save();
	         // POST: /users/123/cards {number: '0123', name: 'Mike Smith'}
	         // server returns: {id: 789, number: '0123', name: 'Mike Smith'}
	
	     savePromise.then(function() {
	       // Once the promise is resolved, the created instance
	       // is populated with the data returned by the server
	       expect(newCard.id).toEqual(789);
	     });
	   ```
	 *
	 * The object returned from a call to `$resource` is a resource "class" which has one "static"
	 * method for each action in the definition.
	 *
	 * Calling these methods invokes `$http` on the `url` template with the given HTTP `method`,
	 * `params` and `headers`.
	 *
	 * @example
	 *
	 * ### Accessing the response
	 *
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	 *
	   ```js
	     var User = $resource('/users/:userId', {userId: '@id'});
	     User.get({userId: 123}).$promise.then(function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets called with
	 * the resource instance (populated with the data that came from the server) as well as an `$http`
	 * header getter function, the HTTP status code and the response status text. So one could rewrite
	 * the above example and get access to HTTP headers as follows:
	 *
	   ```js
	     var User = $resource('/users/:userId', {userId: '@id'});
	     User.get({userId: 123}, function(user, getResponseHeaders) {
	       user.abc = true;
	       user.$save(function(user, putResponseHeaders) {
	         // `user` => saved `User` object
	         // `putResponseHeaders` => `$http` header getter
	       });
	     });
	   ```
	 *
	 * @example
	 *
	 * ### Creating custom actions
	 *
	 * In this example we create a custom method on our resource to make a PUT request:
	 *
	   ```js
	      var app = angular.module('app', ['ngResource']);
	
	      // Some APIs expect a PUT request in the format URL/object/ID
	      // Here we are creating an 'update' method
	      app.factory('Notes', ['$resource', function($resource) {
	        return $resource('/notes/:id', {id: '@id'}, {
	          update: {method: 'PUT'}
	        });
	      }]);
	
	      // In our controller we get the ID from the URL using `$location`
	      app.controller('NotesCtrl', ['$location', 'Notes', function($location, Notes) {
	        // First, retrieve the corresponding `Note` object from the server
	        // (Assuming a URL of the form `.../notes?id=XYZ`)
	        var noteId = $location.search().id;
	        var note = Notes.get({id: noteId});
	
	        note.$promise.then(function() {
	          note.content = 'Hello, world!';
	
	          // Now call `update` to save the changes on the server
	          Notes.update(note);
	              // This will PUT /notes/ID with the note object as the request payload
	
	          // Since `update` is a non-GET method, it will also be available on the instance
	          // (prefixed with `$`), so we could replace the `Note.update()` call with:
	          //note.$update();
	        });
	      }]);
	   ```
	 *
	 * @example
	 *
	 * ### Cancelling requests
	 *
	 * If an action's configuration specifies that it is cancellable, you can cancel the request related
	 * to an instance or collection (as long as it is a result of a "non-instance" call):
	 *
	   ```js
	     // ...defining the `Hotel` resource...
	     var Hotel = $resource('/api/hotels/:id', {id: '@id'}, {
	       // Let's make the `query()` method cancellable
	       query: {method: 'get', isArray: true, cancellable: true}
	     });
	
	     // ...somewhere in the PlanVacationController...
	     ...
	     this.onDestinationChanged = function onDestinationChanged(destination) {
	       // We don't care about any pending request for hotels
	       // in a different destination any more
	       if (this.availableHotels) {
	         this.availableHotels.$cancelRequest();
	       }
	
	       // Let's query for hotels in `destination`
	       // (calls: /api/hotels?location=<destination>)
	       this.availableHotels = Hotel.query({location: destination});
	     };
	   ```
	 *
	 * @example
	 *
	 * ### Using interceptors
	 *
	 * You can use interceptors to transform the request or response, perform additional operations, and
	 * modify the returned instance/collection. The following example, uses `request` and `response`
	 * interceptors to augment the returned instance with additional info:
	 *
	   ```js
	     var Thing = $resource('/api/things/:id', {id: '@id'}, {
	       save: {
	         method: 'POST',
	         interceptor: {
	           request: function(config) {
	             // Before the request is sent out, store a timestamp on the request config
	             config.requestTimestamp = Date.now();
	             return config;
	           },
	           response: function(response) {
	             // Get the instance from the response object
	             var instance = response.resource;
	
	             // Augment the instance with a custom `saveLatency` property, computed as the time
	             // between sending the request and receiving the response.
	             instance.saveLatency = Date.now() - response.config.requestTimestamp;
	
	             // Return the instance
	             return instance;
	           }
	         }
	       }
	     });
	
	     Thing.save({foo: 'bar'}).$promise.then(function(thing) {
	       console.log('That thing was saved in ' + thing.saveLatency + 'ms.');
	     });
	   ```
	 *
	 */
	angular.module('ngResource', ['ng']).
	  info({ angularVersion: '1.8.2' }).
	  provider('$resource', function ResourceProvider() {
	    var PROTOCOL_AND_IPV6_REGEX = /^https?:\/\/\[[^\]]*][^/]*/;
	
	    var provider = this;
	
	    /**
	     * @ngdoc property
	     * @name $resourceProvider#defaults
	     * @description
	     * Object containing default options used when creating `$resource` instances.
	     *
	     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
	     * them to further customize your instances. The available properties are:
	     *
	     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
	     *   calculated URL will be stripped.<br />
	     *   (Defaults to true.)
	     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
	     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
	     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
	     *   resource class or action.<br />
	     *   (Defaults to false.)
	     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
	     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
	     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
	     *   object or a collection (array) of objects etc. For more details, see
	     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
	     *   class.<br />
	     *   The default actions are:
	     *   ```js
	     *   {
	     *     get: {method: 'GET'},
	     *     save: {method: 'POST'},
	     *     query: {method: 'GET', isArray: true},
	     *     remove: {method: 'DELETE'},
	     *     delete: {method: 'DELETE'}
	     *   }
	     *   ```
	     *
	     * #### Example
	     *
	     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions.update = {
	     *         method: 'PUT'
	     *       };
	     *     }]);
	     * ```
	     *
	     * Or you can even overwrite the whole `actions` list and specify your own:
	     *
	     * ```js
	     *   angular.
	     *     module('myApp').
	     *     config(['$resourceProvider', function ($resourceProvider) {
	     *       $resourceProvider.defaults.actions = {
	     *         create: {method: 'POST'},
	     *         get:    {method: 'GET'},
	     *         getAll: {method: 'GET', isArray:true},
	     *         update: {method: 'PUT'},
	     *         delete: {method: 'DELETE'}
	     *       };
	     *     });
	     * ```
	     *
	     */
	    this.defaults = {
	      // Strip slashes by default
	      stripTrailingSlashes: true,
	
	      // Make non-instance requests cancellable (via `$cancelRequest()`)
	      cancellable: false,
	
	      // Default actions configuration
	      actions: {
	        'get': {method: 'GET'},
	        'save': {method: 'POST'},
	        'query': {method: 'GET', isArray: true},
	        'remove': {method: 'DELETE'},
	        'delete': {method: 'DELETE'}
	      }
	    };
	
	    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {
	
	      var noop = angular.noop,
	          forEach = angular.forEach,
	          extend = angular.extend,
	          copy = angular.copy,
	          isArray = angular.isArray,
	          isDefined = angular.isDefined,
	          isFunction = angular.isFunction,
	          isNumber = angular.isNumber,
	          encodeUriQuery = angular.$$encodeUriQuery,
	          encodeUriSegment = angular.$$encodeUriSegment;
	
	      function Route(template, defaults) {
	        this.template = template;
	        this.defaults = extend({}, provider.defaults, defaults);
	        this.urlParams = {};
	      }
	
	      Route.prototype = {
	        setUrlParams: function(config, params, actionUrl) {
	          var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal,
	            protocolAndIpv6 = '';
	
	          var urlParams = self.urlParams = Object.create(null);
	          forEach(url.split(/\W/), function(param) {
	            if (param === 'hasOwnProperty') {
	              throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
	            }
	            if (!(new RegExp('^\\d+$').test(param)) && param &&
	              (new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url))) {
	              urlParams[param] = {
	                isQueryParamValue: (new RegExp('\\?.*=:' + param + '(?:\\W|$)')).test(url)
	              };
	            }
	          });
	          url = url.replace(/\\:/g, ':');
	          url = url.replace(PROTOCOL_AND_IPV6_REGEX, function(match) {
	            protocolAndIpv6 = match;
	            return '';
	          });
	
	          params = params || {};
	          forEach(self.urlParams, function(paramInfo, urlParam) {
	            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	            if (isDefined(val) && val !== null) {
	              if (paramInfo.isQueryParamValue) {
	                encodedVal = encodeUriQuery(val, true);
	              } else {
	                encodedVal = encodeUriSegment(val);
	              }
	              url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function(match, p1) {
	                return encodedVal + p1;
	              });
	            } else {
	              url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function(match,
	                  leadingSlashes, tail) {
	                if (tail.charAt(0) === '/') {
	                  return tail;
	                } else {
	                  return leadingSlashes + tail;
	                }
	              });
	            }
	          });
	
	          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	          if (self.defaults.stripTrailingSlashes) {
	            url = url.replace(/\/+$/, '') || '/';
	          }
	
	          // Collapse `/.` if found in the last URL path segment before the query.
	          // E.g. `http://url.com/id/.format?q=x` becomes `http://url.com/id.format?q=x`.
	          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	          // Replace escaped `/\.` with `/.`.
	          // (If `\.` comes from a param value, it will be encoded as `%5C.`.)
	          config.url = protocolAndIpv6 + url.replace(/\/(\\|%5C)\./, '/.');
	
	
	          // set params - delegate param encoding to $http
	          forEach(params, function(value, key) {
	            if (!self.urlParams[key]) {
	              config.params = config.params || {};
	              config.params[key] = value;
	            }
	          });
	        }
	      };
	
	
	      function resourceFactory(url, paramDefaults, actions, options) {
	        var route = new Route(url, options);
	
	        actions = extend({}, provider.defaults.actions, actions);
	
	        function extractParams(data, actionParams) {
	          var ids = {};
	          actionParams = extend({}, paramDefaults, actionParams);
	          forEach(actionParams, function(value, key) {
	            if (isFunction(value)) { value = value(data); }
	            ids[key] = value && value.charAt && value.charAt(0) === '@' ?
	              lookupDottedPath(data, value.substr(1)) : value;
	          });
	          return ids;
	        }
	
	        function defaultResponseInterceptor(response) {
	          return response.resource;
	        }
	
	        function Resource(value) {
	          shallowClearAndCopy(value || {}, this);
	        }
	
	        Resource.prototype.toJSON = function() {
	          var data = extend({}, this);
	          delete data.$promise;
	          delete data.$resolved;
	          delete data.$cancelRequest;
	          return data;
	        };
	
	        forEach(actions, function(action, name) {
	          var hasBody = action.hasBody === true || (action.hasBody !== false && /^(POST|PUT|PATCH)$/i.test(action.method));
	          var numericTimeout = action.timeout;
	          var cancellable = isDefined(action.cancellable) ?
	              action.cancellable : route.defaults.cancellable;
	
	          if (numericTimeout && !isNumber(numericTimeout)) {
	            $log.debug('ngResource:\n' +
	                       '  Only numeric values are allowed as `timeout`.\n' +
	                       '  Promises are not supported in $resource, because the same value would ' +
	                       'be used for multiple requests. If you are looking for a way to cancel ' +
	                       'requests, you should use the `cancellable` option.');
	            delete action.timeout;
	            numericTimeout = null;
	          }
	
	          Resource[name] = function(a1, a2, a3, a4) {
	            var params = {}, data, onSuccess, onError;
	
	            switch (arguments.length) {
	              case 4:
	                onError = a4;
	                onSuccess = a3;
	                // falls through
	              case 3:
	              case 2:
	                if (isFunction(a2)) {
	                  if (isFunction(a1)) {
	                    onSuccess = a1;
	                    onError = a2;
	                    break;
	                  }
	
	                  onSuccess = a2;
	                  onError = a3;
	                  // falls through
	                } else {
	                  params = a1;
	                  data = a2;
	                  onSuccess = a3;
	                  break;
	                }
	                // falls through
	              case 1:
	                if (isFunction(a1)) onSuccess = a1;
	                else if (hasBody) data = a1;
	                else params = a1;
	                break;
	              case 0: break;
	              default:
	                throw $resourceMinErr('badargs',
	                  'Expected up to 4 arguments [params, data, success, error], got {0} arguments',
	                  arguments.length);
	            }
	
	            var isInstanceCall = this instanceof Resource;
	            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
	            var httpConfig = {};
	            var requestInterceptor = action.interceptor && action.interceptor.request || undefined;
	            var requestErrorInterceptor = action.interceptor && action.interceptor.requestError ||
	              undefined;
	            var responseInterceptor = action.interceptor && action.interceptor.response ||
	              defaultResponseInterceptor;
	            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
	              $q.reject;
	            var successCallback = onSuccess ? function(val) {
	              onSuccess(val, response.headers, response.status, response.statusText);
	            } : undefined;
	            var errorCallback = onError || undefined;
	            var timeoutDeferred;
	            var numericTimeoutPromise;
	            var response;
	
	            forEach(action, function(value, key) {
	              switch (key) {
	                default:
	                  httpConfig[key] = copy(value);
	                  break;
	                case 'params':
	                case 'isArray':
	                case 'interceptor':
	                case 'cancellable':
	                  break;
	              }
	            });
	
	            if (!isInstanceCall && cancellable) {
	              timeoutDeferred = $q.defer();
	              httpConfig.timeout = timeoutDeferred.promise;
	
	              if (numericTimeout) {
	                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
	              }
	            }
	
	            if (hasBody) httpConfig.data = data;
	            route.setUrlParams(httpConfig,
	              extend({}, extractParams(data, action.params || {}), params),
	              action.url);
	
	            // Start the promise chain
	            var promise = $q.
	              resolve(httpConfig).
	              then(requestInterceptor).
	              catch(requestErrorInterceptor).
	              then($http);
	
	            promise = promise.then(function(resp) {
	              var data = resp.data;
	
	              if (data) {
	                // Need to convert action.isArray to boolean in case it is undefined
	                if (isArray(data) !== (!!action.isArray)) {
	                  throw $resourceMinErr('badcfg',
	                      'Error in resource configuration for action `{0}`. Expected response to ' +
	                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
	                    isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
	                }
	                if (action.isArray) {
	                  value.length = 0;
	                  forEach(data, function(item) {
	                    if (typeof item === 'object') {
	                      value.push(new Resource(item));
	                    } else {
	                      // Valid JSON values may be string literals, and these should not be converted
	                      // into objects. These items will not have access to the Resource prototype
	                      // methods, but unfortunately there
	                      value.push(item);
	                    }
	                  });
	                } else {
	                  var promise = value.$promise;     // Save the promise
	                  shallowClearAndCopy(data, value);
	                  value.$promise = promise;         // Restore the promise
	                }
	              }
	
	              resp.resource = value;
	              response = resp;
	              return responseInterceptor(resp);
	            }, function(rejectionOrResponse) {
	              rejectionOrResponse.resource = value;
	              response = rejectionOrResponse;
	              return responseErrorInterceptor(rejectionOrResponse);
	            });
	
	            promise = promise['finally'](function() {
	              value.$resolved = true;
	              if (!isInstanceCall && cancellable) {
	                value.$cancelRequest = noop;
	                $timeout.cancel(numericTimeoutPromise);
	                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
	              }
	            });
	
	            // Run the `success`/`error` callbacks, but do not let them affect the returned promise.
	            promise.then(successCallback, errorCallback);
	
	            if (!isInstanceCall) {
	              // we are creating instance / collection
	              // - set the initial promise
	              // - return the instance / collection
	              value.$promise = promise;
	              value.$resolved = false;
	              if (cancellable) value.$cancelRequest = cancelRequest;
	
	              return value;
	            }
	
	            // instance call
	            return promise;
	
	            function cancelRequest(value) {
	              promise.catch(noop);
	              if (timeoutDeferred !== null) {
	                timeoutDeferred.resolve(value);
	              }
	            }
	          };
	
	
	          Resource.prototype['$' + name] = function(params, success, error) {
	            if (isFunction(params)) {
	              error = success; success = params; params = {};
	            }
	            var result = Resource[name].call(this, params, this, success, error);
	            return result.$promise || result;
	          };
	        });
	
	        return Resource;
	      }
	
	      return resourceFactory;
	    }];
	  });
	
	
	})(window, window.angular);


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(132);
	module.exports = 'ngResource';


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.2
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var lowercase;
	var noop;
	var nodeContains;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
	 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var hasBeenInstantiated = false;
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    hasBeenInstantiated = true;
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidElements
	   * @kind function
	   *
	   * @description
	   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
	   * and are not stripped off during sanitization. You can extend the following lists of elements:
	   *
	   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
	   *   elements. HTML elements considered safe will not be removed during sanitization. All other
	   *   elements will be stripped off.
	   *
	   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
	   *   "void elements" (similar to HTML
	   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
	   *   elements have no end tag and cannot have content.
	   *
	   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
	   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
	   *   `$sanitize`.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the elements you add.
	   * </div>
	   *
	   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
	   *   more of the following properties:
	   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     HTML elements.
	   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     void HTML elements; i.e. elements that do not have an end tag.
	   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
	   *     elements. The list of SVG elements is only taken into account if SVG is
	   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
	   *
	   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
	   *
	   * @return {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidElements = function(elements) {
	    if (!hasBeenInstantiated) {
	      if (isArray(elements)) {
	        elements = {htmlElements: elements};
	      }
	
	      addElementsTo(svgElements, elements.svgElements);
	      addElementsTo(voidElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlElements);
	    }
	
	    return this;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidAttrs
	   * @kind function
	   *
	   * @description
	   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
	   * not stripped off during sanitization.
	   *
	   * **Note**:
	   * The new attributes will not be treated as URI attributes, which means their values will not be
	   * sanitized as URIs using `$compileProvider`'s
	   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
	   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the attributes you add.
	   * </div>
	   *
	   * @param {Array<String>} attrs - A list of valid attributes.
	   *
	   * @returns {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidAttrs = function(attrs) {
	    if (!hasBeenInstantiated) {
	      extend(validAttrs, arrayToMap(attrs, true));
	    }
	    return this;
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isDefined = angular.isDefined;
	  lowercase = angular.$$lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
	    // eslint-disable-next-line no-bitwise
	    return !!(this.compareDocumentPosition(arg) & 16);
	  };
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = stringToMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = stringToMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = stringToMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');
	
	  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function stringToMap(str, lowercaseKeys) {
	    return arrayToMap(str.split(','), lowercaseKeys);
	  }
	
	  function arrayToMap(items, lowercaseKeys) {
	    var obj = {}, i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  function addElementsTo(elementsMap, newElements) {
	    if (newElements && newElements.length) {
	      extend(elementsMap, arrayToMap(newElements));
	    }
	  }
	
	  /**
	   * Create an inert document that contains the dirty HTML that needs sanitizing.
	   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
	   * available.
	   */
	  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
	    if (isDOMParserAvailable()) {
	      return getInertBodyElement_DOMParser;
	    }
	
	    if (!document || !document.implementation) {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var inertDocument = document.implementation.createHTMLDocument('inert');
	    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
	    return getInertBodyElement_InertDocument;
	
	    function isDOMParserAvailable() {
	      try {
	        return !!getInertBodyElement_DOMParser('');
	      } catch (e) {
	        return false;
	      }
	    }
	
	    function getInertBodyElement_DOMParser(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
	        body.firstChild.remove();
	        return body;
	      } catch (e) {
	        return undefined;
	      }
	    }
	
	    function getInertBodyElement_InertDocument(html) {
	      inertBodyElement.innerHTML = html;
	
	      // Support: IE 9-11 only
	      // strip custom-namespaced attributes on IE<=11
	      if (document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	
	      return inertBodyElement;
	    }
	  })(window, window.document);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	
	    var inertBodyElement = getInertBodyElement(html);
	    if (!inertBodyElement) return '';
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // trigger mXSS if it is going to happen by reading and writing the innerHTML
	      html = inertBodyElement.innerHTML;
	      inertBodyElement = getInertBodyElement(html);
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = getNonDescendant('nextSibling', node);
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = getNonDescendant('parentNode', node);
	            if (node === inertBodyElement) break;
	            nextNode = getNonDescendant('nextSibling', node);
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = getNonDescendant('nextSibling', node);
	    }
	  }
	
	  function getNonDescendant(propName, node) {
	    // An element is clobbered if its `propName` property points to one of its descendants
	    var nextNode = node[propName];
	    if (nextNode && nodeContains.call(node, nextNode)) {
	      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
	    }
	    return nextNode;
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', [])
	  .provider('$sanitize', $SanitizeProvider)
	  .info({ angularVersion: '1.8.2' });
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(134);
	module.exports = 'ngSanitize';


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	
	  angular.module('toastr', [])
	    .factory('toastr', toastr);
	
	  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];
	
	  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
	    var container;
	    var index = 0;
	    var toasts = [];
	
	    var previousToastMessage = '';
	    var openToasts = {};
	
	    var containerDefer = $q.defer();
	
	    var toast = {
	      active: active,
	      clear: clear,
	      error: error,
	      info: info,
	      remove: remove,
	      success: success,
	      warning: warning,
	      refreshTimer: refreshTimer
	    };
	
	    return toast;
	
	    /* Public API */
	    function active() {
	      return toasts.length;
	    }
	
	    function clear(toast) {
	      // Bit of a hack, I will remove this soon with a BC
	      if (arguments.length === 1 && !toast) { return; }
	
	      if (toast) {
	        remove(toast.toastId);
	      } else {
	        for (var i = 0; i < toasts.length; i++) {
	          remove(toasts[i].toastId);
	        }
	      }
	    }
	
	    function error(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.error;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function info(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.info;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function success(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.success;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function warning(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.warning;
	      return _buildNotification(type, message, title, optionsOverride);
	    }
	
	    function refreshTimer(toast, newTime) {
	      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
	          toast.scope.refreshTimer(newTime);
	      }
	    }
	
	    function remove(toastId, wasClicked) {
	      var toast = findToast(toastId);
	
	      if (toast && ! toast.deleting) { // Avoid clicking when fading out
	        toast.deleting = true;
	        toast.isOpened = false;
	        $animate.leave(toast.el).then(function() {
	          if (toast.scope.options.onHidden) {
	            toast.scope.options.onHidden(!!wasClicked, toast);
	          }
	          toast.scope.$destroy();
	          var index = toasts.indexOf(toast);
	          delete openToasts[toast.scope.message];
	          toasts.splice(index, 1);
	          var maxOpened = toastrConfig.maxOpened;
	          if (maxOpened && toasts.length >= maxOpened) {
	            toasts[maxOpened - 1].open.resolve();
	          }
	          if (lastToast()) {
	            container.remove();
	            container = null;
	            containerDefer = $q.defer();
	          }
	        });
	      }
	
	      function findToast(toastId) {
	        for (var i = 0; i < toasts.length; i++) {
	          if (toasts[i].toastId === toastId) {
	            return toasts[i];
	          }
	        }
	      }
	
	      function lastToast() {
	        return !toasts.length;
	      }
	    }
	
	    /* Internal functions */
	    function _buildNotification(type, message, title, optionsOverride) {
	      if (angular.isObject(title)) {
	        optionsOverride = title;
	        title = null;
	      }
	
	      return _notify({
	        iconClass: type,
	        message: message,
	        optionsOverride: optionsOverride,
	        title: title
	      });
	    }
	
	    function _getOptions() {
	      return angular.extend({}, toastrConfig);
	    }
	
	    function _createOrGetContainer(options) {
	      if(container) { return containerDefer.promise; }
	
	      container = angular.element('<div></div>');
	      container.attr('id', options.containerId);
	      container.addClass(options.positionClass);
	      container.css({'pointer-events': 'auto'});
	
	      var target = angular.element(document.querySelector(options.target));
	
	      if ( ! target || ! target.length) {
	        throw 'Target for toasts doesn\'t exist';
	      }
	
	      $animate.enter(container, target).then(function() {
	        containerDefer.resolve();
	      });
	
	      return containerDefer.promise;
	    }
	
	    function _notify(map) {
	      var options = _getOptions();
	
	      if (shouldExit()) { return; }
	
	      var newToast = createToast();
	
	      toasts.push(newToast);
	
	      if (ifMaxOpenedAndAutoDismiss()) {
	        var oldToasts = toasts.slice(0, (toasts.length - options.maxOpened));
	        for (var i = 0, len = oldToasts.length; i < len; i++) {
	          remove(oldToasts[i].toastId);
	        }
	      }
	
	      if (maxOpenedNotReached()) {
	        newToast.open.resolve();
	      }
	
	      newToast.open.promise.then(function() {
	        _createOrGetContainer(options).then(function() {
	          newToast.isOpened = true;
	          if (options.newestOnTop) {
	            $animate.enter(newToast.el, container).then(function() {
	              newToast.scope.init();
	            });
	          } else {
	            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
	            $animate.enter(newToast.el, container, sibling).then(function() {
	              newToast.scope.init();
	            });
	          }
	        });
	      });
	
	      return newToast;
	
	      function ifMaxOpenedAndAutoDismiss() {
	        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
	      }
	
	      function createScope(toast, map, options) {
	        if (options.allowHtml) {
	          toast.scope.allowHtml = true;
	          toast.scope.title = $sce.trustAsHtml(map.title);
	          toast.scope.message = $sce.trustAsHtml(map.message);
	        } else {
	          toast.scope.title = map.title;
	          toast.scope.message = map.message;
	        }
	
	        toast.scope.toastType = toast.iconClass;
	        toast.scope.toastId = toast.toastId;
	        toast.scope.extraData = options.extraData;
	
	        toast.scope.options = {
	          extendedTimeOut: options.extendedTimeOut,
	          messageClass: options.messageClass,
	          onHidden: options.onHidden,
	          onShown: generateEvent('onShown'),
	          onTap: generateEvent('onTap'),
	          progressBar: options.progressBar,
	          tapToDismiss: options.tapToDismiss,
	          timeOut: options.timeOut,
	          titleClass: options.titleClass,
	          toastClass: options.toastClass
	        };
	
	        if (options.closeButton) {
	          toast.scope.options.closeHtml = options.closeHtml;
	        }
	
	        function generateEvent(event) {
	          if (options[event]) {
	            return function() {
	              options[event](toast);
	            };
	          }
	        }
	      }
	
	      function createToast() {
	        var newToast = {
	          toastId: index++,
	          isOpened: false,
	          scope: $rootScope.$new(),
	          open: $q.defer()
	        };
	        newToast.iconClass = map.iconClass;
	        if (map.optionsOverride) {
	          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
	          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
	        }
	
	        createScope(newToast, map, options);
	
	        newToast.el = createToastEl(newToast.scope);
	
	        return newToast;
	
	        function cleanOptionsOverride(options) {
	          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop',
	                            'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
	          for (var i = 0, l = badOptions.length; i < l; i++) {
	            delete options[badOptions[i]];
	          }
	
	          return options;
	        }
	      }
	
	      function createToastEl(scope) {
	        var angularDomEl = angular.element('<div toast></div>'),
	          $compile = $injector.get('$compile');
	        return $compile(angularDomEl)(scope);
	      }
	
	      function maxOpenedNotReached() {
	        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
	      }
	
	      function shouldExit() {
	        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
	        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];
	
	        if (isDuplicateOfLast || isDuplicateOpen) {
	          return true;
	        }
	
	        previousToastMessage = map.message;
	        openToasts[map.message] = true;
	
	        return false;
	      }
	    }
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .constant('toastrConfig', {
	      allowHtml: false,
	      autoDismiss: false,
	      closeButton: false,
	      closeHtml: '<button>&times;</button>',
	      containerId: 'toast-container',
	      extendedTimeOut: 1000,
	      iconClasses: {
	        error: 'toast-error',
	        info: 'toast-info',
	        success: 'toast-success',
	        warning: 'toast-warning'
	      },
	      maxOpened: 0,
	      messageClass: 'toast-message',
	      newestOnTop: true,
	      onHidden: null,
	      onShown: null,
	      onTap: null,
	      positionClass: 'toast-top-right',
	      preventDuplicates: false,
	      preventOpenDuplicates: false,
	      progressBar: false,
	      tapToDismiss: true,
	      target: 'body',
	      templates: {
	        toast: 'directives/toast/toast.html',
	        progressbar: 'directives/progressbar/progressbar.html'
	      },
	      timeOut: 5000,
	      titleClass: 'toast-title',
	      toastClass: 'toast'
	    });
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .directive('progressBar', progressBar);
	
	  progressBar.$inject = ['toastrConfig'];
	
	  function progressBar(toastrConfig) {
	    return {
	      require: '^toast',
	      templateUrl: function() {
	        return toastrConfig.templates.progressbar;
	      },
	      link: linkFunction
	    };
	
	    function linkFunction(scope, element, attrs, toastCtrl) {
	      var intervalId, currentTimeOut, hideTime;
	
	      toastCtrl.progressBar = scope;
	
	      scope.start = function(duration) {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	
	        currentTimeOut = parseFloat(duration);
	        hideTime = new Date().getTime() + currentTimeOut;
	        intervalId = setInterval(updateProgress, 10);
	      };
	
	      scope.stop = function() {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	      };
	
	      function updateProgress() {
	        var percentage = ((hideTime - (new Date().getTime())) / currentTimeOut) * 100;
	        element.css('width', percentage + '%');
	      }
	
	      scope.$on('$destroy', function() {
	        // Failsafe stop
	        clearInterval(intervalId);
	      });
	    }
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .controller('ToastController', ToastController);
	
	  function ToastController() {
	    this.progressBar = null;
	
	    this.startProgressBar = function(duration) {
	      if (this.progressBar) {
	        this.progressBar.start(duration);
	      }
	    };
	
	    this.stopProgressBar = function() {
	      if (this.progressBar) {
	        this.progressBar.stop();
	      }
	    };
	  }
	}());
	
	(function() {
	  'use strict';
	
	  angular.module('toastr')
	    .directive('toast', toast);
	
	  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];
	
	  function toast($injector, $interval, toastrConfig, toastr) {
	    return {
	      templateUrl: function() {
	        return toastrConfig.templates.toast;
	      },
	      controller: 'ToastController',
	      link: toastLinkFunction
	    };
	
	    function toastLinkFunction(scope, element, attrs, toastCtrl) {
	      var timeout;
	
	      scope.toastClass = scope.options.toastClass;
	      scope.titleClass = scope.options.titleClass;
	      scope.messageClass = scope.options.messageClass;
	      scope.progressBar = scope.options.progressBar;
	
	      if (wantsCloseButton()) {
	        var button = angular.element(scope.options.closeHtml),
	          $compile = $injector.get('$compile');
	        button.addClass('toast-close-button');
	        button.attr('ng-click', 'close(true, $event)');
	        $compile(button)(scope);
	        element.children().prepend(button);
	      }
	
	      scope.init = function() {
	        if (scope.options.timeOut) {
	          timeout = createTimeout(scope.options.timeOut);
	        }
	        if (scope.options.onShown) {
	          scope.options.onShown();
	        }
	      };
	
	      element.on('mouseenter', function() {
	        hideAndStopProgressBar();
	        if (timeout) {
	          $interval.cancel(timeout);
	        }
	      });
	
	      scope.tapToast = function () {
	        if (angular.isFunction(scope.options.onTap)) {
	          scope.options.onTap();
	        }
	        if (scope.options.tapToDismiss) {
	          scope.close(true);
	        }
	      };
	
	      scope.close = function (wasClicked, $event) {
	        if ($event && angular.isFunction($event.stopPropagation)) {
	          $event.stopPropagation();
	        }
	        toastr.remove(scope.toastId, wasClicked);
	      };
	      
	      scope.refreshTimer = function(newTime) {
	        if (timeout) {
	          $interval.cancel(timeout);
	          timeout = createTimeout(newTime || scope.options.timeOut);
	        }
	      };
	
	      element.on('mouseleave', function() {
	        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) { return; }
	        scope.$apply(function() {
	          scope.progressBar = scope.options.progressBar;
	        });
	        timeout = createTimeout(scope.options.extendedTimeOut);
	      });
	
	      function createTimeout(time) {
	        toastCtrl.startProgressBar(time);
	        return $interval(function() {
	          toastCtrl.stopProgressBar();
	          toastr.remove(scope.toastId);
	        }, time, 1);
	      }
	
	      function hideAndStopProgressBar() {
	        scope.progressBar = false;
	        toastCtrl.stopProgressBar();
	      }
	
	      function wantsCloseButton() {
	        return scope.options.closeHtml;
	      }
	    }
	  }
	}());
	
	angular.module("toastr").run(["$templateCache", function($templateCache) {$templateCache.put("directives/progressbar/progressbar.html","<div class=\"toast-progress\"></div>\n");
	$templateCache.put("directives/toast/toast.html","<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");}]);

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(136);
	module.exports = 'toastr';
	


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * State-based routing for AngularJS 1.x
	 * This bundle requires the ui-router-core.js bundle from the @uirouter/core package.
	 * @version v1.0.30
	 * @link https://ui-router.github.io
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(9), __webpack_require__(110)) :
	    typeof define === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) :
	    (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular, global['@uirouter/core']));
	}(this, (function (exports, ng_from_import, core) { 'use strict';
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */ var ng_from_global = angular;
	    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
	
	    /** @publicapi @module ng1 */ /** */
	    /** @internalapi */
	    function getNg1ViewConfigFactory() {
	        var templateFactory = null;
	        return function (path, view) {
	            templateFactory = templateFactory || core.services.$injector.get('$templateFactory');
	            return [new Ng1ViewConfig(path, view, templateFactory)];
	        };
	    }
	    /** @internalapi */
	    var hasAnyKey = function (keys, obj) { return keys.reduce(function (acc, key) { return acc || core.isDefined(obj[key]); }, false); };
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `views`.
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
	     *
	     * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
	     * and applies the state-level configuration to a view named `$default`.
	     *
	     * @internalapi
	     */
	    function ng1ViewsBuilder(state) {
	        // Do not process root state
	        if (!state.parent)
	            return {};
	        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
	        // Do not allow a state to have both state-level props and also a `views: {}` property.
	        // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
	        // However, the `$default` approach should not be mixed with a separate `views: ` block.
	        if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
	            throw new Error("State '" + state.name + "' has a 'views' object. " +
	                "It cannot also have \"view properties\" at the state level.  " +
	                "Move the following properties into a view (in the 'views' object): " +
	                (" " + allViewKeys.filter(function (key) { return core.isDefined(state[key]); }).join(', ')));
	        }
	        var views = {}, viewsObject = state.views || { $default: core.pick(state, allViewKeys) };
	        core.forEach(viewsObject, function (config, name) {
	            // Account for views: { "": { template... } }
	            name = name || '$default';
	            // Account for views: { header: "headerComponent" }
	            if (core.isString(config))
	                config = { component: config };
	            // Make a shallow copy of the config object
	            config = core.extend({}, config);
	            // Do not allow a view to mix props for component-style view with props for template/controller-style view
	            if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
	                throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
	            }
	            config.resolveAs = config.resolveAs || '$resolve';
	            config.$type = 'ng1';
	            config.$context = state;
	            config.$name = name;
	            var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
	            config.$uiViewName = normalized.uiViewName;
	            config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
	            views[name] = config;
	        });
	        return views;
	    }
	    /** @hidden */
	    var id = 0;
	    /** @internalapi */
	    var Ng1ViewConfig = /** @class */ (function () {
	        function Ng1ViewConfig(path, viewDecl, factory) {
	            var _this = this;
	            this.path = path;
	            this.viewDecl = viewDecl;
	            this.factory = factory;
	            this.$id = id++;
	            this.loaded = false;
	            this.getTemplate = function (uiView, context) {
	                return _this.component
	                    ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings)
	                    : _this.template;
	            };
	        }
	        Ng1ViewConfig.prototype.load = function () {
	            var _this = this;
	            var $q = core.services.$q;
	            var context = new core.ResolveContext(this.path);
	            var params = this.path.reduce(function (acc, node) { return core.extend(acc, node.paramValues); }, {});
	            var promises = {
	                template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
	                controller: $q.when(this.getController(context)),
	            };
	            return $q.all(promises).then(function (results) {
	                core.trace.traceViewServiceEvent('Loaded', _this);
	                _this.controller = results.controller;
	                core.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
	                return _this;
	            });
	        };
	        /**
	         * Gets the controller for a view configuration.
	         *
	         * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
	         */
	        Ng1ViewConfig.prototype.getController = function (context) {
	            var provider = this.viewDecl.controllerProvider;
	            if (!core.isInjectable(provider))
	                return this.viewDecl.controller;
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        return Ng1ViewConfig;
	    }());
	
	    /** @publicapi @module view */ /** */
	    /**
	     * Service which manages loading of templates from a ViewConfig.
	     */
	    var TemplateFactory = /** @class */ (function () {
	        function TemplateFactory() {
	            var _this = this;
	            /** @hidden */ this._useHttp = ng.version.minor < 3;
	            /** @hidden */ this.$get = [
	                '$http',
	                '$templateCache',
	                '$injector',
	                function ($http, $templateCache, $injector) {
	                    _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
	                    _this.$http = $http;
	                    _this.$templateCache = $templateCache;
	                    return _this;
	                },
	            ];
	        }
	        /** @hidden */
	        TemplateFactory.prototype.useHttpService = function (value) {
	            this._useHttp = value;
	        };
	        /**
	         * Creates a template from a configuration object.
	         *
	         * @param config Configuration object for which to load a template.
	         * The following properties are search in the specified order, and the first one
	         * that is defined is used to create the template:
	         *
	         * @param params  Parameters to pass to the template function.
	         * @param context The resolve context associated with the template's view
	         *
	         * @return {string|object}  The template html as a string, or a promise for
	         * that string,or `null` if no template is configured.
	         */
	        TemplateFactory.prototype.fromConfig = function (config, params, context) {
	            var defaultTemplate = '<ui-view></ui-view>';
	            var asTemplate = function (result) { return core.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
	            var asComponent = function (result) { return core.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
	            return core.isDefined(config.template)
	                ? asTemplate(this.fromString(config.template, params))
	                : core.isDefined(config.templateUrl)
	                    ? asTemplate(this.fromUrl(config.templateUrl, params))
	                    : core.isDefined(config.templateProvider)
	                        ? asTemplate(this.fromProvider(config.templateProvider, params, context))
	                        : core.isDefined(config.component)
	                            ? asComponent(config.component)
	                            : core.isDefined(config.componentProvider)
	                                ? asComponent(this.fromComponentProvider(config.componentProvider, params, context))
	                                : asTemplate(defaultTemplate);
	        };
	        /**
	         * Creates a template from a string or a function returning a string.
	         *
	         * @param template html template as a string or function that returns an html template as a string.
	         * @param params Parameters to pass to the template function.
	         *
	         * @return {string|object} The template html as a string, or a promise for that
	         * string.
	         */
	        TemplateFactory.prototype.fromString = function (template, params) {
	            return core.isFunction(template) ? template(params) : template;
	        };
	        /**
	         * Loads a template from the a URL via `$http` and `$templateCache`.
	         *
	         * @param {string|Function} url url of the template to load, or a function
	         * that returns a url.
	         * @param {Object} params Parameters to pass to the url function.
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromUrl = function (url, params) {
	            if (core.isFunction(url))
	                url = url(params);
	            if (url == null)
	                return null;
	            if (this._useHttp) {
	                return this.$http
	                    .get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
	                    .then(function (response) {
	                    return response.data;
	                });
	            }
	            return this.$templateRequest(url);
	        };
	        /**
	         * Creates a template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a component's template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a template from a component's name
	         *
	         * This implements route-to-component.
	         * It works by retrieving the component (directive) metadata from the injector.
	         * It analyses the component's bindings, then constructs a template that instantiates the component.
	         * The template wires input and output bindings to resolves or from the parent component.
	         *
	         * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
	         * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
	         * @param component {string} Component's name in camel case.
	         * @param bindings An object defining the component's bindings: {foo: '<'}
	         * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
	            bindings = bindings || {};
	            // Bind once prefix
	            var prefix = ng.version.minor >= 3 ? '::' : '';
	            // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
	            var kebob = function (camelCase) {
	                var kebobed = core.kebobString(camelCase);
	                return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
	            };
	            var attributeTpl = function (input) {
	                var name = input.name, type = input.type;
	                var attrName = kebob(name);
	                // If the ui-view has an attribute which matches a binding on the routed component
	                // then pass that attribute through to the routed component template.
	                // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
	                if (uiView.attr(attrName) && !bindings[name])
	                    return attrName + "='" + uiView.attr(attrName) + "'";
	                var resolveName = bindings[name] || name;
	                // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
	                // some-attr="{{ ::$resolve.someResolveName }}"
	                if (type === '@')
	                    return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
	                // Wire "&" callbacks to resolves that return a callback function
	                // Get the result of the resolve (should be a function) and annotate it to get its arguments.
	                // some-attr="$resolve.someResolveResultName(foo, bar)"
	                if (type === '&') {
	                    var res = context.getResolvable(resolveName);
	                    var fn = res && res.data;
	                    var args = (fn && core.services.$injector.annotate(fn)) || [];
	                    // account for array style injection, i.e., ['foo', function(foo) {}]
	                    var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
	                    return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
	                }
	                // some-attr="::$resolve.someResolveName"
	                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
	            };
	            var attrs = getComponentBindings(component).map(attributeTpl).join(' ');
	            var kebobName = kebob(component);
	            return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
	        };
	        return TemplateFactory;
	    }());
	    // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
	    function getComponentBindings(name) {
	        var cmpDefs = core.services.$injector.get(name + 'Directive'); // could be multiple
	        if (!cmpDefs || !cmpDefs.length)
	            throw new Error("Unable to find component named '" + name + "'");
	        return cmpDefs.map(getBindings).reduce(core.unnestR, []);
	    }
	    // Given a directive definition, find its object input attributes
	    // Use different properties, depending on the type of directive (component, bindToController, normal)
	    var getBindings = function (def) {
	        if (core.isObject(def.bindToController))
	            return scopeBindings(def.bindToController);
	        return scopeBindings(def.scope);
	    };
	    // for ng 1.2 style, process the scope: { input: "=foo" }
	    // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
	    var scopeBindings = function (bindingsObj) {
	        return Object.keys(bindingsObj || {})
	            // [ 'input', [ '=foo', '=', 'foo' ] ]
	            .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
	            // skip malformed values
	            .filter(function (tuple) { return core.isDefined(tuple) && core.isArray(tuple[1]); })
	            // { name: ('foo' || 'input'), type: '=' }
	            .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); });
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * The Angular 1 `StateProvider`
	     *
	     * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	     * on state.
	     *
	     * A state corresponds to a "place" in the application in terms of the overall UI and
	     * navigation. A state describes (via the controller / template / view properties) what
	     * the UI looks like and does at that place.
	     *
	     * States often have things in common, and the primary way of factoring out these
	     * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	     * nested states.
	     *
	     * The `$stateProvider` provides interfaces to declare these states for your app.
	     */
	    var StateProvider = /** @class */ (function () {
	        function StateProvider(stateRegistry, stateService) {
	            this.stateRegistry = stateRegistry;
	            this.stateService = stateService;
	            core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
	        }
	        /**
	         * Decorates states when they are registered
	         *
	         * Allows you to extend (carefully) or override (at your own peril) the
	         * `stateBuilder` object used internally by [[StateRegistry]].
	         * This can be used to add custom functionality to ui-router,
	         * for example inferring templateUrl based on the state name.
	         *
	         * When passing only a name, it returns the current (original or decorated) builder
	         * function that matches `name`.
	         *
	         * The builder functions that can be decorated are listed below. Though not all
	         * necessarily have a good use case for decoration, that is up to you to decide.
	         *
	         * In addition, users can attach custom decorators, which will generate new
	         * properties within the state's internal definition. There is currently no clear
	         * use-case for this beyond accessing internal states (i.e. $state.$current),
	         * however, expect this to become increasingly relevant as we introduce additional
	         * meta-programming features.
	         *
	         * **Warning**: Decorators should not be interdependent because the order of
	         * execution of the builder functions in non-deterministic. Builder functions
	         * should only be dependent on the state definition object and super function.
	         *
	         *
	         * Existing builder functions and current return values:
	         *
	         * - **parent** `{object}` - returns the parent state object.
	         * - **data** `{object}` - returns state data, including any inherited data that is not
	         *   overridden by own values (if any).
	         * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	         *   or `null`.
	         * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
	         *   navigable).
	         * - **params** `{object}` - returns an array of state params that are ensured to
	         *   be a super-set of parent's params.
	         * - **views** `{object}` - returns a views object where each key is an absolute view
	         *   name (i.e. "viewName@stateName") and each value is the config object
	         *   (template, controller) for the view. Even when you don't use the views object
	         *   explicitly on a state config, one is still created for you internally.
	         *   So by decorating this builder function you have access to decorating template
	         *   and controller properties.
	         * - **ownParams** `{object}` - returns an array of params that belong to the state,
	         *   not including any params defined by ancestor states.
	         * - **path** `{string}` - returns the full path from the root down to this state.
	         *   Needed for state activation.
	         * - **includes** `{object}` - returns an object that includes every state that
	         *   would pass a `$state.includes()` test.
	         *
	         * #### Example:
	         * Override the internal 'views' builder with a function that takes the state
	         * definition, and a reference to the internal function being overridden:
	         * ```js
	         * $stateProvider.decorator('views', function (state, parent) {
	         *   let result = {},
	         *       views = parent(state);
	         *
	         *   angular.forEach(views, function (config, name) {
	         *     let autoName = (state.name + '.' + name).replace('.', '/');
	         *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	         *     result[name] = config;
	         *   });
	         *   return result;
	         * });
	         *
	         * $stateProvider.state('home', {
	         *   views: {
	         *     'contact.list': { controller: 'ListController' },
	         *     'contact.item': { controller: 'ItemController' }
	         *   }
	         * });
	         * ```
	         *
	         *
	         * ```js
	         * // Auto-populates list and item views with /partials/home/contact/list.html,
	         * // and /partials/home/contact/item.html, respectively.
	         * $state.go('home');
	         * ```
	         *
	         * @param {string} name The name of the builder function to decorate.
	         * @param {object} func A function that is responsible for decorating the original
	         * builder function. The function receives two parameters:
	         *
	         *   - `{object}` - state - The state config object.
	         *   - `{object}` - super - The original builder function.
	         *
	         * @return {object} $stateProvider - $stateProvider instance
	         */
	        StateProvider.prototype.decorator = function (name, func) {
	            return this.stateRegistry.decorator(name, func) || this;
	        };
	        StateProvider.prototype.state = function (name, definition) {
	            if (core.isObject(name)) {
	                definition = name;
	            }
	            else {
	                definition.name = name;
	            }
	            this.stateRegistry.register(definition);
	            return this;
	        };
	        /**
	         * Registers an invalid state handler
	         *
	         * This is a passthrough to [[StateService.onInvalid]] for ng1.
	         */
	        StateProvider.prototype.onInvalid = function (callback) {
	            return this.stateService.onInvalid(callback);
	        };
	        return StateProvider;
	    }());
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
	     * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
	     *
	     * @internalapi
	     */
	    var getStateHookBuilder = function (hookName) {
	        return function stateHookBuilder(stateObject) {
	            var hook = stateObject[hookName];
	            var pathname = hookName === 'onExit' ? 'from' : 'to';
	            function decoratedNg1Hook(trans, state) {
	                var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
	                var subContext = resolveContext.subContext(state.$$state());
	                var locals = core.extend(getLocals(subContext), { $state$: state, $transition$: trans });
	                return core.services.$injector.invoke(hook, this, locals);
	            }
	            return hook ? decoratedNg1Hook : undefined;
	        };
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
	     * @internalapi
	     */
	    var Ng1LocationServices = /** @class */ (function () {
	        function Ng1LocationServices($locationProvider) {
	            // .onChange() registry
	            this._urlListeners = [];
	            this.$locationProvider = $locationProvider;
	            var _lp = core.val($locationProvider);
	            core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
	        }
	        /**
	         * Applys ng1-specific path parameter encoding
	         *
	         * The Angular 1 `$location` service is a bit weird.
	         * It doesn't allow slashes to be encoded/decoded bi-directionally.
	         *
	         * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
	         *
	         * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
	         *
	         * @param router
	         */
	        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
	            var pathType = router.urlMatcherFactory.type('path');
	            pathType.encode = function (x) {
	                return x != null ? x.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : x;
	            };
	            pathType.decode = function (x) {
	                return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : x;
	            };
	        };
	        // eslint-disable-next-line @typescript-eslint/no-empty-function
	        Ng1LocationServices.prototype.dispose = function () { };
	        Ng1LocationServices.prototype.onChange = function (callback) {
	            var _this = this;
	            this._urlListeners.push(callback);
	            return function () { return core.removeFrom(_this._urlListeners)(callback); };
	        };
	        Ng1LocationServices.prototype.html5Mode = function () {
	            var html5Mode = this.$locationProvider.html5Mode();
	            html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
	            return html5Mode && this.$sniffer.history;
	        };
	        Ng1LocationServices.prototype.baseHref = function () {
	            return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
	        };
	        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
	            if (replace === void 0) { replace = false; }
	            if (core.isDefined(newUrl))
	                this.$location.url(newUrl);
	            if (replace)
	                this.$location.replace();
	            if (state)
	                this.$location.state(state);
	            return this.$location.url();
	        };
	        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
	            var _this = this;
	            this.$location = $location;
	            this.$sniffer = $sniffer;
	            this.$browser = $browser;
	            this.$window = $window;
	            // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
	            $rootScope.$on('$locationChangeSuccess', function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
	            var _loc = core.val($location);
	            // Bind these LocationService functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
	            // Bind these LocationConfig functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
	        };
	        return Ng1LocationServices;
	    }());
	
	    /** @publicapi @module url */ /** */
	    /**
	     * Manages rules for client-side URL
	     *
	     * ### Deprecation warning:
	     * This class is now considered to be an internal API
	     * Use the [[UrlService]] instead.
	     * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
	     *
	     * This class manages the router rules for what to do when the URL changes.
	     *
	     * This provider remains for backwards compatibility.
	     *
	     * @internalapi
	     * @deprecated
	     */
	    var UrlRouterProvider = /** @class */ (function () {
	        /** @hidden */
	        function UrlRouterProvider(/** @hidden */ router) {
	            this.router = router;
	        }
	        UrlRouterProvider.injectableHandler = function (router, handler) {
	            return function (match) { return core.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params }); };
	        };
	        /** @hidden */
	        UrlRouterProvider.prototype.$get = function () {
	            var urlService = this.router.urlService;
	            this.router.urlRouter.update(true);
	            if (!urlService.interceptDeferred)
	                urlService.listen();
	            return this.router.urlRouter;
	        };
	        /**
	         * Registers a url handler function.
	         *
	         * Registers a low level url handler (a `rule`).
	         * A rule detects specific URL patterns and returns a redirect, or performs some action.
	         *
	         * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Here's an example of how you might allow case insensitive urls
	         *   $urlRouterProvider.rule(function ($injector, $location) {
	         *     var path = $location.path(),
	         *         normalized = path.toLowerCase();
	         *
	         *     if (path !== normalized) {
	         *       return normalized;
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param ruleFn
	         * Handler function that takes `$injector` and `$location` services as arguments.
	         * You can use them to detect a url and return a different url as a string.
	         *
	         * @return [[UrlRouterProvider]] (`this`)
	         */
	        UrlRouterProvider.prototype.rule = function (ruleFn) {
	            var _this = this;
	            if (!core.isFunction(ruleFn))
	                throw new Error("'rule' must be a function");
	            var match = function () { return ruleFn(core.services.$injector, _this.router.locationService); };
	            var rule = new core.BaseUrlRule(match, core.identity);
	            this.router.urlService.rules.rule(rule);
	            return this;
	        };
	        /**
	         * Defines the path or behavior to use when no url can be matched.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // if the path doesn't match any of the urls you configured
	         *   // otherwise will take care of routing the user to the
	         *   // specified url
	         *   $urlRouterProvider.otherwise('/index');
	         *
	         *   // Example of using function rule as param
	         *   $urlRouterProvider.otherwise(function ($injector, $location) {
	         *     return '/a/valid/url';
	         *   });
	         * });
	         * ```
	         *
	         * @param rule
	         * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
	         * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
	         *
	         * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	         */
	        UrlRouterProvider.prototype.otherwise = function (rule) {
	            var _this = this;
	            var urlRules = this.router.urlService.rules;
	            if (core.isString(rule)) {
	                urlRules.otherwise(rule);
	            }
	            else if (core.isFunction(rule)) {
	                urlRules.otherwise(function () { return rule(core.services.$injector, _this.router.locationService); });
	            }
	            else {
	                throw new Error("'rule' must be a string or function");
	            }
	            return this;
	        };
	        /**
	         * Registers a handler for a given url matching.
	         *
	         * If the handler is a string, it is
	         * treated as a redirect, and is interpolated according to the syntax of match
	         * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	         *
	         * If the handler is a function, it is injectable.
	         * It gets invoked if `$location` matches.
	         * You have the option of inject the match object as `$match`.
	         *
	         * The handler can return
	         *
	         * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	         *   will continue trying to find another one that matches.
	         * - **string** which is treated as a redirect and passed to `$location.url()`
	         * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	         *     if ($state.$current.navigable !== state ||
	         *         !equalForKeys($match, $stateParams) {
	         *      $state.transitionTo(state, $match, false);
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param what A pattern string to match, compiled as a [[UrlMatcher]].
	         * @param handler The path (or function that returns a path) that you want to redirect your user to.
	         * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
	         *
	         * Note: the handler may also invoke arbitrary code, such as `$state.go()`
	         */
	        UrlRouterProvider.prototype.when = function (what, handler) {
	            if (core.isArray(handler) || core.isFunction(handler)) {
	                handler = UrlRouterProvider.injectableHandler(this.router, handler);
	            }
	            this.router.urlService.rules.when(what, handler);
	            return this;
	        };
	        /**
	         * Disables monitoring of the URL.
	         *
	         * Call this method before UI-Router has bootstrapped.
	         * It will stop UI-Router from performing the initial url sync.
	         *
	         * This can be useful to perform some asynchronous initialization before the router starts.
	         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Prevent $urlRouter from automatically intercepting URL changes;
	         *   $urlRouterProvider.deferIntercept();
	         * })
	         *
	         * app.run(function (MyService, $urlRouter, $http) {
	         *   $http.get("/stuff").then(function(resp) {
	         *     MyService.doStuff(resp.data);
	         *     $urlRouter.listen();
	         *     $urlRouter.sync();
	         *   });
	         * });
	         * ```
	         *
	         * @param defer Indicates whether to defer location change interception.
	         *        Passing no parameter is equivalent to `true`.
	         */
	        UrlRouterProvider.prototype.deferIntercept = function (defer) {
	            this.router.urlService.deferIntercept(defer);
	        };
	        return UrlRouterProvider;
	    }());
	
	    /* eslint-disable @typescript-eslint/no-empty-function */
	    ng.module('ui.router.angular1', []);
	    var mod_init = ng.module('ui.router.init', ['ng']);
	    var mod_util = ng.module('ui.router.util', ['ui.router.init']);
	    var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
	    var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
	    var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
	    var mod_cmpt = ng.module('ui.router.compat', ['ui.router']);
	    var router = null;
	    $uiRouterProvider.$inject = ['$locationProvider'];
	    /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
	    function $uiRouterProvider($locationProvider) {
	        // Create a new instance of the Router when the $uiRouterProvider is initialized
	        router = this.router = new core.UIRouter();
	        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
	        // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
	        router.stateRegistry.decorator('views', ng1ViewsBuilder);
	        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
	        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
	        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
	        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
	        // Disable decoding of params by UrlMatcherFactory because $location already handles this
	        router.urlService.config._decodeParams = false;
	        var ng1LocationService = (router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider));
	        Ng1LocationServices.monkeyPatchPathParameterType(router);
	        // backwards compat: also expose router instance as $uiRouterProvider.router
	        router['router'] = router;
	        router['$get'] = $get;
	        $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
	        function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
	            ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
	            delete router['router'];
	            delete router['$get'];
	            return router;
	        }
	        return router;
	    }
	    var getProviderFor = function (serviceName) { return [
	        '$uiRouterProvider',
	        function ($urp) {
	            var service = $urp.router[serviceName];
	            service['$get'] = function () { return service; };
	            return service;
	        },
	    ]; };
	    // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
	    runBlock.$inject = ['$injector', '$q', '$uiRouter'];
	    function runBlock($injector, $q, $uiRouter) {
	        core.services.$injector = $injector;
	        core.services.$q = $q;
	        // https://github.com/angular-ui/ui-router/issues/3678
	        if (!Object.prototype.hasOwnProperty.call($injector, 'strictDi')) {
	            try {
	                $injector.invoke(function (checkStrictDi) { });
	            }
	            catch (error) {
	                $injector.strictDi = !!/strict mode/.exec(error && error.toString());
	            }
	        }
	        // The $injector is now available.
	        // Find any resolvables that had dependency annotation deferred
	        $uiRouter.stateRegistry
	            .get()
	            .map(function (x) { return x.$$state().resolvables; })
	            .reduce(core.unnestR, [])
	            .filter(function (x) { return x.deps === 'deferred'; })
	            .forEach(function (resolvable) { return (resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi)); });
	    }
	    // $urlRouter service and $urlRouterProvider
	    var getUrlRouterProvider = function (uiRouter) { return (uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter)); };
	    // $state service and $stateProvider
	    // $urlRouter service and $urlRouterProvider
	    var getStateProvider = function () { return core.extend(router.stateProvider, { $get: function () { return router.stateService; } }); };
	    watchDigests.$inject = ['$rootScope'];
	    function watchDigests($rootScope) {
	        $rootScope.$watch(function () {
	            core.trace.approximateDigests++;
	        });
	    }
	    mod_init.provider('$uiRouter', $uiRouterProvider);
	    mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
	    mod_util.provider('$urlService', getProviderFor('urlService'));
	    mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
	    mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
	    mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
	    mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
	    mod_state.provider('$transitions', getProviderFor('transitionService'));
	    mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
	    mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
	    mod_main.factory('$view', function () { return router.viewService; });
	    mod_main.service('$trace', function () { return core.trace; });
	    mod_main.run(watchDigests);
	    mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
	    mod_state.run(['$state', function ($state) { }]);
	    mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
	    mod_init.run(runBlock);
	    /** @hidden TODO: find a place to move this */
	    var getLocals = function (ctx) {
	        var tokens = ctx.getTokens().filter(core.isString);
	        var tuples = tokens.map(function (key) {
	            var resolvable = ctx.getResolvable(key);
	            var waitPolicy = ctx.getPolicy(resolvable).async;
	            return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
	        });
	        return tuples.reduce(core.applyPairs, {});
	    };
	
	    /* eslint-disable @typescript-eslint/no-empty-interface */
	    /** @hidden */
	    function parseStateRef(ref) {
	        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
	        if (paramsOnly)
	            ref = '(' + paramsOnly[1] + ')';
	        var parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
	        if (!parsed || parsed.length !== 4)
	            throw new Error("Invalid state ref '" + ref + "'");
	        return { state: parsed[1] || null, paramExpr: parsed[3] || null };
	    }
	    /** @hidden */
	    function stateContext(el) {
	        var $uiView = el.parent().inheritedData('$uiView');
	        var path = core.parse('$cfg.path')($uiView);
	        return path ? core.tail(path).state.name : undefined;
	    }
	    /** @hidden */
	    function processedDef($state, $element, def) {
	        var uiState = def.uiState || $state.current.name;
	        var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
	        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
	        return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
	    }
	    /** @hidden */
	    function getTypeInfo(el) {
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	        var isForm = el[0].nodeName === 'FORM';
	        return {
	            attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
	            isAnchor: el.prop('tagName').toUpperCase() === 'A',
	            clickable: !isForm,
	        };
	    }
	    /** @hidden */
	    function clickHook(el, $state, $timeout, type, getDef) {
	        return function (e) {
	            var button = e.which || e.button, target = getDef();
	            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || el.attr('target'))) {
	                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	                var transition_1 = $timeout(function () {
	                    if (!el.attr('disabled')) {
	                        $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
	                    }
	                });
	                e.preventDefault();
	                // if the state has no URL, ignore one preventDefault from the <a> directive.
	                var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
	                e.preventDefault = function () {
	                    if (ignorePreventDefaultCount_1-- <= 0)
	                        $timeout.cancel(transition_1);
	                };
	            }
	        };
	    }
	    /** @hidden */
	    function defaultOpts(el, $state) {
	        return {
	            relative: stateContext(el) || $state.$current,
	            inherit: true,
	            source: 'sref',
	        };
	    }
	    /** @hidden */
	    function bindEvents(element, scope, hookFn, uiStateOpts) {
	        var events;
	        if (uiStateOpts) {
	            events = uiStateOpts.events;
	        }
	        if (!core.isArray(events)) {
	            events = ['click'];
	        }
	        var on = element.on ? 'on' : 'bind';
	        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
	            var event_1 = events_1[_i];
	            element[on](event_1, hookFn);
	        }
	        scope.$on('$destroy', function () {
	            var off = element.off ? 'off' : 'unbind';
	            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
	                var event_2 = events_2[_i];
	                element[off](event_2, hookFn);
	            }
	        });
	    }
	    /**
	     * `ui-sref`: A directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of the `ui-sref` is the name of the state to link to.
	     *
	     * #### Example:
	     * This will activate the `home` state when the link is clicked.
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * ```
	     *
	     * ### Relative Links
	     * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create a relative `ui-sref` which always targets the same destination.
	     *
	     * #### Example:
	     * Both these links are relative to the parent state, even when a child state is currently active.
	     * ```html
	     * <a ui-sref=".child1">child 1 state</a>
	     * <a ui-sref=".child2">child 2 state</a>
	     * ```
	     *
	     * This link activates the parent state.
	     * ```html
	     * <a ui-sref="^">Return</a>
	     * ```
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * #### Example:
	     * Assuming the `users` state has a url of `/users/`
	     * ```html
	     * <a ui-sref="users" href="/users/">Users</a>
	     * ```
	     *
	     * ### Parameter Values
	     * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
	     * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
	     * The content inside the parentheses is an expression, evaluated to the parameter values.
	     *
	     * #### Example:
	     * This example renders a list of links to users.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="user in users">
	     *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * Note:
	     * The parameter values expression is `$watch`ed for updates.
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-sref-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Examples
	     * If you have the following template:
	     *
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * <a ui-sref="about">About</a>
	     * <a ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	     *     </li>
	     * </ul>
	     * ```
	     *
	     * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
	     *
	     * ```html
	     * <a href="#/home" ui-sref="home">Home</a>
	     * <a href="#/about" ui-sref="about">About</a>
	     * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	     *     </li>
	     * </ul>
	     *
	     * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	     * ```
	     *
	     * ### Notes
	     *
	     * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-sref="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     *
	     * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
	     * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
	     */
	    var uiSrefDirective;
	    uiSrefDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var ref = parseStateRef(attrs.uiSref);
	                    rawDef.uiState = ref.state;
	                    rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    if (ref.paramExpr) {
	                        scope.$watch(ref.paramExpr, function (val) {
	                            rawDef.uiStateParams = core.extend({}, val);
	                            update();
	                        }, true);
	                        rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
	                    }
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    var hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-state`: A fully dynamic directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
	     * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
	     *
	     * #### Example:
	     * Create a list of links.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Relative Links
	     * If the expression evaluates to a relative path, it is processed like [[uiSref]].
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create relative `ui-state` which always targets the same destination.
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * ### Parameter Values
	     * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
	     * Param values should be provided using the `ui-state-params` attribute.
	     * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * This example renders a list of links with param values.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-state-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Notes
	     *
	     * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
	     *   However, it might be simpler to use [[uiSref]] parameter-only links.
	     *
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     * ```
	     */
	    var uiStateDirective;
	    uiStateDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDynamicDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
	                    var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return ((acc[attr] = core.noop), acc); }, {});
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    inputAttrs.forEach(function (field) {
	                        rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
	                        attrs.$observe(field, function (expr) {
	                            watchDeregFns[field]();
	                            watchDeregFns[field] = scope.$watch(expr, function (newval) {
	                                rawDef[field] = newval;
	                                update();
	                            }, true);
	                        });
	                    });
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
	     *
	     * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
	     * related directive's state is active (and remove them when it is inactive).
	     *
	     * The primary use-case is to highlight the active link in navigation menus,
	     * distinguishing it from the inactive menu items.
	     *
	     * ### Linking to a `ui-sref` or `ui-state`
	     * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
	     * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
	     *
	     * ### Matching
	     *
	     * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
	     * This is a "fuzzy match" which uses [[StateService.includes]].
	     *
	     * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
	     * This is an "exact match" which uses [[StateService.is]].
	     *
	     * ### Parameter values
	     * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
	     * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
	     *
	     * #### Example:
	     * ```html
	     * <li ng-repeat="user in users" ui-sref-active="active">
	     *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Examples
	     *
	     * Given the following template:
	     * #### Example:
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item">
	     *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * When the app state is `app.user` (or any child state),
	     * and contains the state parameter "user" with value "bilbobaggins",
	     * the resulting HTML will appear as (note the 'active' class):
	     *
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item active">
	     *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * ### Glob mode
	     *
	     * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
	     * The objects keys represent active class names and values represent the respective state names/globs.
	     * `ui-sref-active` will match if the current active state **includes** any of
	     * the specified state names/globs, even the abstract ones.
	     *
	     * #### Example:
	     * Given the following template, with "admin" being an abstract state:
	     * ```html
	     * <div ui-sref-active="{'active': 'admin.**'}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * Arrays are also supported as values in the `ngClass`-like interface.
	     * This allows multiple states to add `active` class.
	     *
	     * #### Example:
	     * Given the following template, with "admin.roles" being the current state, the class will be added too:
	     * ```html
	     * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
	     * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
	     *
	     * ### Notes:
	     *
	     * - The class name is interpolated **once** during the directives link time (any further changes to the
	     * interpolated value are ignored).
	     *
	     * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
	     */
	    var uiSrefActiveDirective;
	    uiSrefActiveDirective = [
	        '$state',
	        '$stateParams',
	        '$interpolate',
	        '$uiRouter',
	        function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
	            return {
	                restrict: 'A',
	                controller: [
	                    '$scope',
	                    '$element',
	                    '$attrs',
	                    function ($scope, $element, $attrs) {
	                        var states = [];
	                        var activeEqClass;
	                        var uiSrefActive;
	                        // There probably isn't much point in $observing this
	                        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	                        // slight difference in logic routing
	                        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	                        try {
	                            uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	                        }
	                        catch (e) {
	                            // Do nothing. uiSrefActive is not a valid expression.
	                            // Fall back to using $interpolate below
	                        }
	                        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	                        setStatesFromDefinitionObject(uiSrefActive);
	                        // Allow uiSref to communicate with uiSrefActive[Equals]
	                        this.$$addStateInfo = function (newState, newParams) {
	                            // we already got an explicit state provided by ui-sref-active, so we
	                            // shadow the one that comes from ui-sref
	                            if (core.isObject(uiSrefActive) && states.length > 0) {
	                                return;
	                            }
	                            var deregister = addState(newState, newParams, uiSrefActive);
	                            update();
	                            return deregister;
	                        };
	                        function updateAfterTransition(trans) {
	                            trans.promise.then(update, core.noop);
	                        }
	                        $scope.$on('$destroy', setupEventListeners());
	                        if ($uiRouter.globals.transition) {
	                            updateAfterTransition($uiRouter.globals.transition);
	                        }
	                        function setupEventListeners() {
	                            var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
	                            var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
	                            var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
	                            return function cleanUp() {
	                                deregisterStatesChangedListener();
	                                deregisterOnStartListener();
	                                deregisterStateChangeSuccessListener();
	                            };
	                        }
	                        function handleStatesChanged() {
	                            setStatesFromDefinitionObject(uiSrefActive);
	                        }
	                        function setStatesFromDefinitionObject(statesDefinition) {
	                            if (core.isObject(statesDefinition)) {
	                                states = [];
	                                core.forEach(statesDefinition, function (stateOrName, activeClass) {
	                                    // Helper function to abstract adding state.
	                                    var addStateForClass = function (stateOrName, activeClass) {
	                                        var ref = parseStateRef(stateOrName);
	                                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	                                    };
	                                    if (core.isString(stateOrName)) {
	                                        // If state is string, just add it.
	                                        addStateForClass(stateOrName, activeClass);
	                                    }
	                                    else if (core.isArray(stateOrName)) {
	                                        // If state is an array, iterate over it and add each array item individually.
	                                        core.forEach(stateOrName, function (stateOrName) {
	                                            addStateForClass(stateOrName, activeClass);
	                                        });
	                                    }
	                                });
	                            }
	                        }
	                        function addState(stateName, stateParams, activeClass) {
	                            var state = $state.get(stateName, stateContext($element));
	                            var stateInfo = {
	                                state: state || { name: stateName },
	                                params: stateParams,
	                                activeClass: activeClass,
	                            };
	                            states.push(stateInfo);
	                            return function removeState() {
	                                core.removeFrom(states)(stateInfo);
	                            };
	                        }
	                        // Update route state
	                        function update() {
	                            var splitClasses = function (str) { return str.split(/\s/).filter(core.identity); };
	                            var getClasses = function (stateList) {
	                                return stateList
	                                    .map(function (x) { return x.activeClass; })
	                                    .map(splitClasses)
	                                    .reduce(core.unnestR, []);
	                            };
	                            var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(core.uniqR, []);
	                            var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
	                            var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
	                            var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
	                            var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
	                            var removeClasses = allClasses.filter(function (cls) { return !core.inArray(addClasses, cls); });
	                            $scope.$evalAsync(function () {
	                                addClasses.forEach(function (className) { return $element.addClass(className); });
	                                removeClasses.forEach(function (className) { return $element.removeClass(className); });
	                            });
	                        }
	                        update();
	                    },
	                ],
	            };
	        },
	    ];
	    ng
	        .module('ui.router.state')
	        .directive('uiSref', uiSrefDirective)
	        .directive('uiSrefActive', uiSrefActiveDirective)
	        .directive('uiSrefActiveEq', uiSrefActiveDirective)
	        .directive('uiState', uiStateDirective);
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * `isState` Filter: truthy if the current state is the parameter
	     *
	     * Translates to [[StateService.is]] `$state.is("stateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
	     * ```
	     */
	    $IsStateFilter.$inject = ['$state'];
	    function $IsStateFilter($state) {
	        var isFilter = function (state, params, options) {
	            return $state.is(state, params, options);
	        };
	        isFilter.$stateful = true;
	        return isFilter;
	    }
	    /**
	     * `includedByState` Filter: truthy if the current state includes the parameter
	     *
	     * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
	     * ```
	     */
	    $IncludedByStateFilter.$inject = ['$state'];
	    function $IncludedByStateFilter($state) {
	        var includesFilter = function (state, params, options) {
	            return $state.includes(state, params, options);
	        };
	        includesFilter.$stateful = true;
	        return includesFilter;
	    }
	    ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
	
	    /** @publicapi @module directives */ /** */
	    /**
	     * `ui-view`: A viewport directive which is filled in by a view from the active state.
	     *
	     * ### Attributes
	     *
	     * - `name`: (Optional) A view name.
	     *   The name should be unique amongst the other views in the same state.
	     *   You can have views of the same name that live in different states.
	     *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
	     *
	     * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
	     *   Uses [[$uiViewScroll]] to do the scrolling.
	     *
	     * - `onload`: Expression to evaluate whenever the view updates.
	     *
	     * #### Example:
	     * A view can be unnamed or named.
	     * ```html
	     * <!-- Unnamed -->
	     * <div ui-view></div>
	     *
	     * <!-- Named -->
	     * <div ui-view="viewName"></div>
	     *
	     * <!-- Named (different style) -->
	     * <ui-view name="viewName"></ui-view>
	     * ```
	     *
	     * You can only have one unnamed view within any template (or root html). If you are only using a
	     * single view and it is unnamed then you can populate it like so:
	     *
	     * ```html
	     * <div ui-view></div>
	     * $stateProvider.state("home", {
	     *   template: "<h1>HELLO!</h1>"
	     * })
	     * ```
	     *
	     * The above is a convenient shortcut equivalent to specifying your view explicitly with the
	     * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * But typically you'll only use the views property if you name your view or have more than one view
	     * in the same template. There's not really a compelling reason to name a view if its the only one,
	     * but you could if you wanted, like so:
	     *
	     * ```html
	     * <div ui-view="main"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "main": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * Really though, you'll use views to set up multiple views:
	     *
	     * ```html
	     * <div ui-view></div>
	     * <div ui-view="chart"></div>
	     * <div ui-view="data"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     },
	     *     "chart": {
	     *       template: "<chart_thing/>"
	     *     },
	     *     "data": {
	     *       template: "<data_thing/>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * #### Examples for `autoscroll`:
	     * ```html
	     * <!-- If autoscroll present with no expression,
	     *      then scroll ui-view into view -->
	     * <ui-view autoscroll/>
	     *
	     * <!-- If autoscroll present with valid expression,
	     *      then scroll ui-view into view if expression evaluates to true -->
	     * <ui-view autoscroll='true'/>
	     * <ui-view autoscroll='false'/>
	     * <ui-view autoscroll='scopeVariable'/>
	     * ```
	     *
	     * Resolve data:
	     *
	     * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	     * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	     *
	     * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	     * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	     * depends on `$resolve` data.
	     *
	     * #### Example:
	     * ```js
	     * $stateProvider.state('home', {
	     *   template: '<my-component user="$resolve.user"></my-component>',
	     *   resolve: {
	     *     user: function(UserService) { return UserService.fetchUser(); }
	     *   }
	     * });
	     * ```
	     */
	    var uiView;
	    // eslint-disable-next-line prefer-const
	    uiView = [
	        '$view',
	        '$animate',
	        '$uiViewScroll',
	        '$interpolate',
	        '$q',
	        function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
	            function getRenderer() {
	                return {
	                    enter: function (element, target, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.enter(element, null, target).then(cb);
	                        }
	                        else {
	                            $animate.enter(element, null, target, cb);
	                        }
	                    },
	                    leave: function (element, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.leave(element).then(cb);
	                        }
	                        else {
	                            $animate.leave(element, cb);
	                        }
	                    },
	                };
	            }
	            function configsEqual(config1, config2) {
	                return config1 === config2;
	            }
	            var rootData = {
	                $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
	                $uiView: {},
	            };
	            var directive = {
	                count: 0,
	                restrict: 'ECA',
	                terminal: true,
	                priority: 400,
	                transclude: 'element',
	                compile: function (tElement, tAttrs, $transclude) {
	                    return function (scope, $element, attrs) {
	                        var onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(), inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
	                        var previousEl, currentEl, currentScope, viewConfig;
	                        var activeUIView = {
	                            $type: 'ng1',
	                            id: directive.count++,
	                            name: name,
	                            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
	                            config: null,
	                            configUpdated: configUpdatedCallback,
	                            get creationContext() {
	                                // The context in which this ui-view "tag" was created
	                                var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
	                                // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
	                                // See https://github.com/angular-ui/ui-router/issues/3355
	                                var fromParentTag = core.parse('$uiView.creationContext')(inherited);
	                                return fromParentTagConfig || fromParentTag;
	                            },
	                        };
	                        core.trace.traceUIViewEvent('Linking', activeUIView);
	                        function configUpdatedCallback(config) {
	                            if (config && !(config instanceof Ng1ViewConfig))
	                                return;
	                            if (configsEqual(viewConfig, config))
	                                return;
	                            core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
	                            viewConfig = config;
	                            updateView(config);
	                        }
	                        $element.data('$uiView', { $uiView: activeUIView });
	                        updateView();
	                        var unregister = $view.registerUIView(activeUIView);
	                        scope.$on('$destroy', function () {
	                            core.trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
	                            unregister();
	                        });
	                        function cleanupLastView() {
	                            if (previousEl) {
	                                core.trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
	                                previousEl.remove();
	                                previousEl = null;
	                            }
	                            if (currentScope) {
	                                core.trace.traceUIViewEvent('Destroying scope', activeUIView);
	                                currentScope.$destroy();
	                                currentScope = null;
	                            }
	                            if (currentEl) {
	                                var _viewData_1 = currentEl.data('$uiViewAnim');
	                                core.trace.traceUIViewEvent('Animate out', _viewData_1);
	                                renderer.leave(currentEl, function () {
	                                    _viewData_1.$$animLeave.resolve();
	                                    previousEl = null;
	                                });
	                                previousEl = currentEl;
	                                currentEl = null;
	                            }
	                        }
	                        function updateView(config) {
	                            var newScope = scope.$new();
	                            var animEnter = $q.defer(), animLeave = $q.defer();
	                            var $uiViewData = {
	                                $cfg: config,
	                                $uiView: activeUIView,
	                            };
	                            var $uiViewAnim = {
	                                $animEnter: animEnter.promise,
	                                $animLeave: animLeave.promise,
	                                $$animLeave: animLeave,
	                            };
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoading
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description
	                             *
	                             * Fired once the view **begins loading**, *before* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             * @param {string} viewName Name of the view.
	                             */
	                            newScope.$emit('$viewContentLoading', name);
	                            var cloned = $transclude(newScope, function (clone) {
	                                clone.data('$uiViewAnim', $uiViewAnim);
	                                clone.data('$uiView', $uiViewData);
	                                renderer.enter(clone, $element, function onUIViewEnter() {
	                                    animEnter.resolve();
	                                    if (currentScope)
	                                        currentScope.$emit('$viewContentAnimationEnded');
	                                    if ((core.isDefined(autoScrollExp) && !autoScrollExp) || scope.$eval(autoScrollExp)) {
	                                        $uiViewScroll(clone);
	                                    }
	                                });
	                                cleanupLastView();
	                            });
	                            currentEl = cloned;
	                            currentScope = newScope;
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description           *
	                             * Fired once the view is **loaded**, *after* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             */
	                            currentScope.$emit('$viewContentLoaded', config || viewConfig);
	                            currentScope.$eval(onloadExp);
	                        }
	                    };
	                },
	            };
	            return directive;
	        },
	    ];
	    $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q'];
	    /** @hidden */
	    function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q) {
	        var getControllerAs = core.parse('viewDecl.controllerAs');
	        var getResolveAs = core.parse('viewDecl.resolveAs');
	        return {
	            restrict: 'ECA',
	            priority: -400,
	            compile: function (tElement) {
	                var initial = tElement.html();
	                tElement.empty();
	                return function (scope, $element) {
	                    var data = $element.data('$uiView');
	                    if (!data) {
	                        $element.html(initial);
	                        $compile($element.contents())(scope);
	                        return;
	                    }
	                    var cfg = data.$cfg || { viewDecl: {}, getTemplate: core.noop };
	                    var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
	                    $element.html(cfg.getTemplate($element, resolveCtx) || initial);
	                    core.trace.traceUIViewFill(data.$uiView, $element.html());
	                    var link = $compile($element.contents());
	                    var controller = cfg.controller;
	                    var controllerAs = getControllerAs(cfg);
	                    var resolveAs = getResolveAs(cfg);
	                    var locals = resolveCtx && getLocals(resolveCtx);
	                    scope[resolveAs] = locals;
	                    if (controller) {
	                        var controllerInstance = ($controller(controller, core.extend({}, locals, { $scope: scope, $element: $element })));
	                        if (controllerAs) {
	                            scope[controllerAs] = controllerInstance;
	                            scope[controllerAs][resolveAs] = locals;
	                        }
	                        // TODO: Use $view service as a central point for registering component-level hooks
	                        // Then, when a component is created, tell the $view service, so it can invoke hooks
	                        // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
	                        // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
	                        $element.data('$ngControllerController', controllerInstance);
	                        $element.children().data('$ngControllerController', controllerInstance);
	                        registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
	                    }
	                    // Wait for the component to appear in the DOM
	                    if (core.isString(cfg.component)) {
	                        var kebobName = core.kebobString(cfg.component);
	                        var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
	                        var getComponentController = function () {
	                            var directiveEl = [].slice
	                                .call($element[0].children)
	                                .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
	                            return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
	                        };
	                        var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
	                            if (!ctrlInstance)
	                                return;
	                            registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
	                            deregisterWatch_1();
	                        });
	                    }
	                    link(scope);
	                };
	            },
	        };
	    }
	    /** @hidden */
	    var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
	    /** @hidden incrementing id */
	    var _uiCanExitId = 0;
	    /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
	    function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
	        // Call $onInit() ASAP
	        if (core.isFunction(controllerInstance.$onInit) &&
	            !((cfg.viewDecl.component || cfg.viewDecl.componentProvider) && hasComponentImpl)) {
	            controllerInstance.$onInit();
	        }
	        var viewState = core.tail(cfg.path).state.self;
	        var hookOptions = { bind: controllerInstance };
	        // Add component-level hook for onUiParamsChanged
	        if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
	            var resolveContext = new core.ResolveContext(cfg.path);
	            var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
	            // Fire callback on any successful transition
	            var paramsUpdated = function ($transition$) {
	                // Exit early if the $transition$ is the same as the view was created within.
	                // Exit early if the $transition$ will exit the state the view is for.
	                if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
	                    return;
	                var toParams = $transition$.params('to');
	                var fromParams = $transition$.params('from');
	                var getNodeSchema = function (node) { return node.paramSchema; };
	                var toSchema = $transition$.treeChanges('to').map(getNodeSchema).reduce(core.unnestR, []);
	                var fromSchema = $transition$.treeChanges('from').map(getNodeSchema).reduce(core.unnestR, []);
	                // Find the to params that have different values than the from params
	                var changedToParams = toSchema.filter(function (param) {
	                    var idx = fromSchema.indexOf(param);
	                    return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
	                });
	                // Only trigger callback if a to param has changed or is new
	                if (changedToParams.length) {
	                    var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
	                    // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
	                    var newValues = core.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
	                    controllerInstance.uiOnParamsChanged(newValues, $transition$);
	                }
	            };
	            $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
	        }
	        // Add component-level hook for uiCanExit
	        if (core.isFunction(controllerInstance.uiCanExit)) {
	            var id_1 = _uiCanExitId++;
	            var cacheProp_1 = '_uiCanExitIds';
	            // Returns true if a redirect transition already answered truthy
	            var prevTruthyAnswer_1 = function (trans) {
	                return !!trans && ((trans[cacheProp_1] && trans[cacheProp_1][id_1] === true) || prevTruthyAnswer_1(trans.redirectedFrom()));
	            };
	            // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
	            var wrappedHook = function (trans) {
	                var promise;
	                var ids = (trans[cacheProp_1] = trans[cacheProp_1] || {});
	                if (!prevTruthyAnswer_1(trans)) {
	                    promise = $q.when(controllerInstance.uiCanExit(trans));
	                    promise.then(function (val) { return (ids[id_1] = val !== false); });
	                }
	                return promise;
	            };
	            var criteria = { exiting: viewState.name };
	            $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
	        }
	    }
	    ng.module('ui.router.state').directive('uiView', uiView);
	    ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */
	    function $ViewScrollProvider() {
	        var useAnchorScroll = false;
	        this.useAnchorScroll = function () {
	            useAnchorScroll = true;
	        };
	        this.$get = [
	            '$anchorScroll',
	            '$timeout',
	            function ($anchorScroll, $timeout) {
	                if (useAnchorScroll) {
	                    return $anchorScroll;
	                }
	                return function ($element) {
	                    return $timeout(function () {
	                        $element[0].scrollIntoView();
	                    }, 0, false);
	                };
	            },
	        ];
	    }
	    ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	    /**
	     * Main entry point for angular 1.x build
	     * @publicapi @module ng1
	     */ /** */
	    var index = 'ui.router';
	
	    Object.keys(core).forEach(function (k) {
	        if (k !== 'default') Object.defineProperty(exports, k, {
	            enumerable: true,
	            get: function () {
	                return core[k];
	            }
	        });
	    });
	    exports.core = core;
	    exports.Ng1ViewConfig = Ng1ViewConfig;
	    exports.StateProvider = StateProvider;
	    exports.UrlRouterProvider = UrlRouterProvider;
	    exports.default = index;
	    exports.getLocals = getLocals;
	    exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
	    exports.ng1ViewsBuilder = ng1ViewsBuilder;
	    exports.watchDigests = watchDigests;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=ui-router-angularjs.js.map


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	/*!
	 * angular-ui-validate
	 * https://github.com/angular-ui/ui-validate
	 * Version: 1.2.3 - 2017-05-18T08:07:23.042Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/**
	 * General-purpose validator for ngModel.
	 * angular.js comes with several built-in validation mechanism for input fields (ngRequired, ngPattern etc.) but using
	 * an arbitrary validation function requires creation of custom directives for interact with angular's validation mechanism.
	 * The ui-validate directive makes it easy to use any function(s) defined in scope as a validator function(s).
	 * A validator function will trigger validation on both model and input changes.
	 *
	 * This utility bring 'ui-validate' directives to handle regular validations and 'ui-validate-async' for asynchronous validations.
	 *
	 * @example <input ui-validate=" 'myValidatorFunction($value)' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }">
	 * @example <input ui-validate="{ foo : '$value > anotherModel' }" ui-validate-watch=" 'anotherModel' ">
	 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }" ui-validate-watch=" { foo : 'anotherModel' } ">
	 * @example <input ui-validate-async=" 'myAsyncValidatorFunction($value)' ">
	 * @example <input ui-validate-async="{ foo: 'myAsyncValidatorFunction($value, anotherModel)' }" ui-validate-watch=" 'anotherModel' ">
	 *
	 * @param ui-validate {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
	 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
	 * In both cases validator function should take a value to validate as its argument and should return true/false indicating a validation result.
	 * It is possible for a validator function to return a promise, however promises are better handled by ui-validate-async.
	 *
	 * @param ui-validate-async {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
	 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
	 * Async validator function should take a value to validate as its argument and should return a promise that resolves if valid and reject if not,
	 * indicating a validation result.
	 * ui-validate-async supports non asyncronous validators. They are wrapped into a promise. Although is recomented to use ui-validate instead, since
	 * all validations declared in ui-validate-async are registered un ngModel.$asyncValidators that runs after ngModel.$validators if and only if
	 * all validators in ngModel.$validators reports as valid.
	 */
	angular.module('ui.validate',[])
	  .directive('uiValidate', ['$$uiValidateApplyWatch', '$$uiValidateApplyWatchCollection', function ($$uiValidateApplyWatch, $$uiValidateApplyWatchCollection) {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function(scope, elm, attrs, ctrl) {
	      var validateFn, validateExpr = scope.$eval(attrs.uiValidate);
	
	      if (!validateExpr) {
	        return;
	      }
	
	      if (angular.isString(validateExpr)) {
	        validateExpr = {
	          validator: validateExpr
	        };
	      }
	
	      angular.forEach(validateExpr, function(exprssn, key) {
	        validateFn = function(modelValue, viewValue) {
	          // $value is left for retrocompatibility
	          var expression = scope.$eval(exprssn, {
	            '$value': modelValue,
	            '$modelValue': modelValue,
	            '$viewValue': viewValue,
	            '$name': ctrl.$name
	          });
	          // Keep support for promises for retrocompatibility
	          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
	            expression.then(function() {
	              ctrl.$setValidity(key, true);
	            }, function() {
	              ctrl.$setValidity(key, false);
	            });
	            // Return as valid for now. Validity is updated when promise resolves.
	            return true;
	          } else {
	            return !!expression; // Transform 'undefined' to false (to avoid corrupting the NgModelController and the FormController)
	          }
	        };
	        ctrl.$validators[key] = validateFn;
	      });
	
	      // Support for ui-validate-watch
	      if (attrs.uiValidateWatch) {
	        $$uiValidateApplyWatch(scope, ctrl, scope.$eval(attrs.uiValidateWatch), attrs.uiValidateWatchObjectEquality);
	      }
	      if (attrs.uiValidateWatchCollection) {
	        $$uiValidateApplyWatchCollection(scope, ctrl, scope.$eval(attrs.uiValidateWatchCollection));
	      }
	    }
	  };
	}])
	  .directive('uiValidateAsync', ['$$uiValidateApplyWatch', '$$uiValidateApplyWatchCollection', '$timeout', '$q', function ($$uiValidateApplyWatch, $$uiValidateApplyWatchCollection, $timeout, $q) {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function (scope, elm, attrs, ctrl) {
	      var validateFn, validateExpr = scope.$eval(attrs.uiValidateAsync);
	
	      if (!validateExpr){ return;}
	
	      if (angular.isString(validateExpr)) {
	        validateExpr = { validatorAsync: validateExpr };
	      }
	
	      angular.forEach(validateExpr, function (exprssn, key) {
	        validateFn = function(modelValue, viewValue) {
	          // $value is left for ease of use
	          var expression = scope.$eval(exprssn, {
	            '$value': modelValue,
	            '$modelValue': modelValue,
	            '$viewValue': viewValue,
	            '$name': ctrl.$name
	          });
	          // Check if it's a promise
	          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
	            return expression;
	            // Support for validate non-async validators
	          } else {
	            return $q(function(resolve, reject) {
	              setTimeout(function() {
	                if (expression) {
	                  resolve();
	                } else {
	                  reject();
	                }
	              }, 0);
	            });
	          }
	        };
	        ctrl.$asyncValidators[key] = validateFn;
	      });
	
	      // Support for ui-validate-watch
	      if (attrs.uiValidateWatch){
	          $$uiValidateApplyWatch( scope, ctrl, scope.$eval(attrs.uiValidateWatch), attrs.uiValidateWatchObjectEquality);
	      }
	      if (attrs.uiValidateWatchCollection) {
	        $$uiValidateApplyWatchCollection(scope, ctrl, scope.$eval(attrs.uiValidateWatchCollection));
	      }
	    }
	  };
	}])
	  .service('$$uiValidateApplyWatch', function () {
	    return function (scope, ctrl, watch, objectEquality) {
	      var watchCallback = function () {
	        ctrl.$validate();
	      };
	
	      //string - update all validators on expression change
	      if (angular.isString(watch)) {
	        scope.$watch(watch, watchCallback, objectEquality);
	        //array - update all validators on change of any expression
	      } else if (angular.isArray(watch)) {
	        angular.forEach(watch, function (expression) {
	          scope.$watch(expression, watchCallback, objectEquality);
	        });
	        //object - update appropriate validator
	      } else if (angular.isObject(watch)) {
	        angular.forEach(watch, function (expression/*, validatorKey*/) {
	          //value is string - look after one expression
	          if (angular.isString(expression)) {
	            scope.$watch(expression, watchCallback, objectEquality);
	          }
	          //value is array - look after all expressions in array
	          if (angular.isArray(expression)) {
	            angular.forEach(expression, function (intExpression) {
	              scope.$watch(intExpression, watchCallback, objectEquality);
	            });
	          }
	        });
	      }
	    };
	  })
	  .service('$$uiValidateApplyWatchCollection', function () {
	    return function (scope, ctrl, watch) {
	      var watchCallback = function () {
	        ctrl.$validate();
	      };
	
	      //string - update all validators on expression change
	      if (angular.isString(watch)) {
	        scope.$watchCollection(watch, watchCallback);
	        //array - update all validators on change of any expression
	      } else if (angular.isArray(watch)) {
	        angular.forEach(watch, function (expression) {
	          scope.$watchCollection(expression, watchCallback);
	        });
	        //object - update appropriate validator
	      } else if (angular.isObject(watch)) {
	        angular.forEach(watch, function (expression/*, validatorKey*/) {
	          //value is string - look after one expression
	          if (angular.isString(expression)) {
	            scope.$watchCollection(expression, watchCallback);
	          }
	          //value is array - look after all expressions in array
	          if (angular.isArray(expression)) {
	            angular.forEach(expression, function (intExpression) {
	              scope.$watchCollection(intExpression, watchCallback);
	            });
	          }
	        });
	      }
	    };
	  });
	
	}());

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(139);
	module.exports = 'ui.validate';


/***/ }),
/* 141 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.2
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5,
	  urlErrorParamsEnabled: true
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 *
	 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
	 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
	 *   generated error url is very long.
	 *
	 *   Default: true. When used without argument, it returns the current value.
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
	      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace'). Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	
	  var url = 'https://errors.angularjs.org/1.8.2/';
	  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
	  var errRegExp = new RegExp(regex, 'g');
	
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    // A minErr message has two parts: the message itself and the url that contains the
	    // encoded message.
	    // The message's parameters can contain other error messages which also include error urls.
	    // To prevent the messages from getting too long, we strip the error urls from the parameters.
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index].replace(errRegExp, '');
	      }
	
	      return match;
	    });
	
	    message += '\n' + url + (module ? module + '/' : '') + code;
	
	    if (minErrConfig.urlErrorParamsEnabled) {
	      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	      }
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  addDateMinutes,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (key !== '__proto__') {
	            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	            baseExtend(dst[key], [src], true);
	          }
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest using another, similar library for all-purpose merging,
	* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* `angular.merge` also does not support merging objects with circular references.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	function isArray(arr) {
	  return Array.isArray(arr) || arr instanceof Array;
	}
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
	 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
	 * function, and has several limitations (see below).
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 *
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 *   `angular.copy` does not check if destination and source are of the same type. It's the
	 *   developer's responsibility to make sure they are compatible.
	 * </div>
	 *
	 * @knownIssue
	 * This is a non-exhaustive list of object types / features that are not handled correctly by
	 * `angular.copy`. Note that since this functions is used by the change detection code, this
	 * means binding or watching objects of these types (or that include these types) might not work
	 * correctly.
	 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
	 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
	 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
	 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
	 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
	 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
	 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
	 *
	 * @param {*} source The source that will be used to make a copy. Can be any type, including
	 *     primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
	 *     must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div></div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for banned URL schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	  } else {
	    jqLite = JQLite;
	  }
	
	  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
	  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
	  // the $destroy event on all removed nodes.
	  originalCleanData = jqLite.cleanData;
	  jqLite.cleanData = function(elems) {
	    var events;
	    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	      events = (jqLite._data(elem) || {}).events;
	      if (events && events.$destroy) {
	        jqLite(elem).triggerHandler('$destroy');
	      }
	    }
	    originalCleanData(elems);
	  };
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
	 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
	 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
	 * your code for this change and remove your use of this function as soon as possible.
	
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 */
	function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
	  JQLite.legacyXHTMLReplacement = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	           *    or an object map of components where the keys are the names and the values are the component definition objects.
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  hiddenInputBrowserCacheDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRefDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $$IntervalFactoryProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $$TaskTrackerFactoryProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.8.2',
	  major: 1,
	  minor: 8,
	  dot: 2,
	  codeName: 'meteoric-mining'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$lowercase': lowercase,
	    '$$stringify': stringify,
	    '$$uppercase': uppercase
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRef: ngRefDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective,
	          input: hiddenInputBrowserCacheDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $$intervalFactory: $$IntervalFactoryProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.8.2' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
	 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
	 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
	 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
	 * ```js
	 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
	 * ```
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	// Table parts need to be wrapped with `<table>` or they're
	// stripped to their contents when put in a div.
	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do, so we cannot shorten
	// this by omitting <tbody> or other required elements.
	var wrapMap = {
	  thead: ['table'],
	  col: ['colgroup', 'table'],
	  tr: ['tbody', 'table'],
	  td: ['tr', 'tbody', 'table']
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <10 only
	// IE 9 requires an option wrapper & it needs to have the whole table structure
	// set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
	var wrapMapIE9 = {
	  option: [1, '<select multiple="multiple">', '</select>'],
	  _default: [0, '', '']
	};
	
	for (var key in wrapMap) {
	  var wrapMapValueClosing = wrapMap[key];
	  var wrapMapValue = wrapMapValueClosing.slice().reverse();
	  wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
	}
	
	wrapMapIE9.optgroup = wrapMapIE9.option;
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap, finalHtml,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    finalHtml = JQLite.legacyXHTMLReplacement ?
	      html.replace(XHTML_TAG_REGEXP, '<$1></$2>') :
	      html;
	
	    if (msie < 10) {
	      wrap = wrapMapIE9[tag] || wrapMapIE9._default;
	      tmp.innerHTML = wrap[1] + finalHtml + wrap[2];
	
	      // Descend through wrappers to the right content
	      i = wrap[0];
	      while (i--) {
	        tmp = tmp.firstChild;
	      }
	    } else {
	      wrap = wrapMap[tag] || [];
	
	      // Create wrappers & descend into them
	      i = wrap.length;
	      while (--i > -1) {
	        tmp.appendChild(window.document.createElement(wrap[i]));
	        tmp = tmp.firstChild;
	      }
	
	      tmp.innerHTML = finalHtml;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function isEmptyObject(obj) {
	  var name;
	
	  for (name in obj) {
	    return false;
	  }
	  return true;
	}
	
	function removeIfEmptyData(element) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  var events = expandoStore && expandoStore.events;
	  var data = expandoStore && expandoStore.data;
	
	  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	
	  removeIfEmptyData(element);
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	    } else {
	      expandoStore.data = {};
	    }
	
	    removeIfEmptyData(element);
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	      jqLiteOff(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key !== this._lastKey) {
	      this._lastKey = key;
	      this._lastIndex = this._keys.indexOf(key);
	    }
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  has: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    return idx !== -1;
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  instanceInjector.loadNewModules = function(mods) {
	    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  };
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * <div class="alert alert-warning">
	       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
	       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
	       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
	       * However, there are two exceptions:
	       *
	       * <ul>
	       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
	       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
	       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
	       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
	       *   the `setClass` event, but if it either removes or adds classes,
	       *   it will fire `animate` instead.</li>
	       * </ul>
	       *
	       * </div>
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered.
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       * * `data` - an object with these properties:
	       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
	       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
	       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
	       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
	       *
	       * Note that the callback does not trigger a scope digest. Wrap your call into a
	       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation and applies the end state of the animation.
	       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
	       * adding the element to the DOM.
	       *
	       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
	       *
	       * @example
	        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
	          <file name="app.js">
	            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
	              templateUrl: 'template.html',
	              controller: function($element, $animate) {
	                this.runner = null;
	
	                this.addClass = function() {
	                  this.runner = $animate.addClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.removeClass = function() {
	                  this.runner = $animate.removeClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.cancel = function() {
	                  $animate.cancel(this.runner);
	                };
	              }
	            });
	          </file>
	          <file name="template.html">
	            <p>
	              <button id="add" ng-click="$ctrl.addClass()">Add</button>
	              <button ng-click="$ctrl.removeClass()">Remove</button>
	              <br>
	              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
	              <br>
	              <div id="target">CSS-Animated Text</div>
	            </p>
	          </file>
	          <file name="index.html">
	            <cancel-example></cancel-example>
	          </file>
	          <file name="style.css">
	            .red-add, .red-remove {
	              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
	            }
	
	            .red,
	            .red-add.red-add-active {
	              color: #FF0000;
	              font-size: 40px;
	            }
	
	            .red-remove.red-remove-active {
	              font-size: 10px;
	              color: black;
	            }
	
	          </file>
	        </example>
	       */
	      cancel: function(runner) {
	        if (runner.cancel) {
	          runner.cancel();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} animationRunner the animation runner
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global getHash: true, stripHash: false */
	
	function getHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? '' : url.substr(index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/#$/, '');
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {},
	      taskTracker = $$taskTrackerFactory($log);
	
	  self.isMock = false;
	
	  //////////////////////////////////////////////////////////////
	  // Task-tracking API
	  //////////////////////////////////////////////////////////////
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = taskTracker.completeTask;
	  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
	
	  // TODO(vojta): prefix this method with $$ ?
	  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of `location.href` (with a
	   * trailing `#` stripped of if the hash is empty).
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
	   * `location.href`/`location.replace` is used.
	   * Returns its own instance to allow chaining.
	   *
	   * NOTE: this api is intended for use only by the `$location` service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state State object to use with `pushState`/`replaceState`
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Normalize the inputted URL
	      url = urlResolve(url).href;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      return trimEmptyHash(pendingLocation || location.href);
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay, taskType) {
	    var timeoutId;
	
	    delay = delay || 0;
	    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
	
	    taskTracker.incTaskCount(taskType);
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      taskTracker.completeTask(fn, taskType);
	    }, delay);
	    pendingDeferIds[timeoutId] = taskType;
	
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds.hasOwnProperty(deferId)) {
	      var taskType = pendingDeferIds[deferId];
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      taskTracker.completeTask(noop, taskType);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
	       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
	    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance.)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
	 *   isn't  optional and doesn't exist, an exception
	 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
	 *   to the local value, since it will be impossible to sync them back to the parent scope.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr`
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   It's also possible to watch the evaluated value shallowly with
	 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
	 * The marker must come after the mode and before the attribute name.
	 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
	 * This is useful to refine the interface directives provide.
	 * One subtle difference between optional and non-optional happens **when the binding attribute is not
	 * set**:
	 * - the binding is optional: the property will not be defined
	 * - the binding is not optional: the property is defined
	 *
	 * ```js
	 *app.directive('testDir', function() {
	    return {
	      scope: {
	        notoptional: '=',
	        optional: '=?',
	      },
	      bindToController: true,
	      controller: function() {
	        this.$onInit = function() {
	          console.log(this.hasOwnProperty('notoptional')) // true
	          console.log(this.hasOwnProperty('optional')) // false
	        }
	      }
	    }
	  })
	 *```
	 *
	 *
	 * ##### Combining directives with different scope defintions
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace`
	 * <div class="alert alert-danger">
	 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
	 * </div>
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that are defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
	 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // Configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects '$compile'.
	        $compileProvider.directive('compile', function($compile) {
	          // The directive factory creates a link function.
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                // Watch the 'compile' expression for changes.
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // When the 'compile' expression changes
	                // assign it into the current DOM.
	                element.html(value);
	
	                // Compile the new DOM and link it to the current scope.
	                // NOTE: we only compile '.childNodes' so that we
	                // don't get into an infinite loop compiling ourselves.
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
	 *        elements (e.g. SVG elements). See also the `directive.controller` property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to `$digest`, which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = angular.element('<p>{{total}}</p>');
	 *     $compile(element)(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
	 *   linking function:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>');
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       // Attach the clone to DOM document at the right place.
	 *     });
	 *
	 *     // Now we have reference to the cloned DOM via `clonedElement`.
	 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
	 *     //       `clonedElement` passed to `cloneAttachFn`.
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	
	 * @knownIssue
	
	   ### Issues with `replace: true`
	 *
	 * <div class="alert alert-danger">
	 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
	 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
	 * </div>
	 *
	 * #### Attribute values are not merged
	 *
	 * When a `replace` directive encounters the same attribute on the original and the replace node,
	 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
	 * the `style` attribute.
	 * ```html
	 * Original Node: <span class="original" style="color: red;"></span>
	 * Replace Template: <span class="replaced" style="background: blue;"></span>
	 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
	 * ```
	 *
	 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
	 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
	 *
	 * ```html
	 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
	 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
	 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
	 * ```
	 *
	 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
	 *
	 * #### Directives are not deduplicated before compilation
	 *
	 * When the original node and the replace template declare the same directive(s), they will be
	 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
	 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
	 * attach `$formatters` and `$parsers` twice.
	 *
	 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
	 *
	 * #### `transclude: element` in the replace template root can have unexpected effects
	 *
	 * When the replace template has a directive at the root node that uses
	 * {@link $compile#-transclude- `transclude: element`}, e.g.
	 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
	 * See the following issues:
	 *
	 * - Incorrect scope on replaced element:
	 * [#9837](https://github.com/angular/angular.js/issues/9837)
	 * - Different DOM between `template` and `templateUrl`:
	 * [#10612](https://github.com/angular/angular.js/issues/14326)
	 *
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngProp
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-prop-propname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "propName"):
	 *
	 *
	 * ```html
	 * <ANY ng-prop-prop_name="expression">
	 * </ANY>
	 * ```
	 *
	 *
	 * @description
	 * The `ngProp` directive binds an expression to a DOM element property.
	 * `ngProp` allows writing to arbitrary properties by including
	 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
	 * the `value` property.
	 *
	 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
	 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
	 *
	 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
	 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
	 * custom elements.
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
	 * example, and for binding HTML {@link ngBindHtml} should be used.
	 *
	 * ## Security
	 *
	 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
	 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
	 * malicious code.
	 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
	 * This means vulnerable properties require their content to be "trusted", based on the
	 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
	 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
	 * this property are trusted as a `RESOURCE_URL`.
	 *
	 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
	 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
	 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
	 *
	 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
	 *
	 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
	 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
	 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
	 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
	 *
	 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
	 *
	 * ### HTML Sanitization
	 *
	 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
	 * content.
	 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
	 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
	 * `innerHTML`.
	 *
	 * @example
	 * ### Binding to different contexts
	 *
	 * <example name="ngProp" module="exampleNgProp">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         Binding to a property without security context:
	 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerText</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... so that actually dangerous content cannot be executed:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Binding to innerHTML with ngSanitize
	 *
	 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', ['ngSanitize'])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         "Safe" content will be sanitized ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... as will dangerous content:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 */
	
	/** @ngdoc directive
	 * @name ngOn
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-on-eventname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "eventName"):
	 *
	 *
	 * ```html
	 * <ANY ng-on-event_name="expression">
	 * </ANY>
	 * ```
	 *
	 * @description
	 * The `ngOn` directive adds an event listener to a DOM element via
	 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
	 * fired.
	 * `ngOn` allows adding listeners for arbitrary events by including
	 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
	 * when the `drop` event is fired.
	 *
	 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
	 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
	 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
	 * standards.
	 *
	 * Another use-case for `ngOn` is listening to
	 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
	 * fired by
	 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `myEvent` must be written as `ng-on-my_event="expression"`.
	 *
	 * @example
	 * ### Bind to built-in DOM events
	 *
	 * <example name="ngOn" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.clickCount = 0;
	 *           this.mouseoverCount = 0;
	 *
	 *           this.loadingState = 0;
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
	 *       <button
	 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
	 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
	 *       clickCount: {{$ctrl.clickCount}}<br>
	 *       mouseover: {{$ctrl.mouseoverCount}}
	 *
	 *       <hr>
	 *
	 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
	 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
	 *       <div ng-switch="$ctrl.loadingState">
	 *         <span ng-switch-when="0">Image is loading</span>
	 *         <span ng-switch-when="-1">Image load error</span>
	 *         <span ng-switch-when="1">Image loaded successfully</span>
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Bind to custom DOM events
	 *
	 * <example name="ngOnCustom" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.eventLog = '';
	 *
	 *           this.listener = function($event) {
	 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
	 *           };
	 *         }
	 *       })
	 *       .component('childComponent', {
	 *         templateUrl: 'child.html',
	 *         controller: function($element) {
	 *           this.fireEvent = function() {
	 *             var event = new CustomEvent('customtype', { detail: new Date()});
	 *
	 *             $element[0].dispatchEvent(event);
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
	 *     <span>Event log: {{$ctrl.eventLog}}</span>
	 *   </file>
	 *   <file name="child.html">
	      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      definition = definition.trim();
	
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
	   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
	   *    are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
	   * aHrefSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'aHrefSanitizationWhitelist', {
	    get: function() {
	      return this.aHrefSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.aHrefSanitizationTrustedUrlList = value;
	    }
	  });
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
	   * imgSrcSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'imgSrcSanitizationWhitelist', {
	    get: function() {
	      return this.imgSrcSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.imgSrcSanitizationTrustedUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
	   * otherwise return the current strictComponentBindingsEnabled state.
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable / disable the strict component bindings check. If enabled, the
	   * compiler will enforce that all scope / controller bindings of a
	   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
	   * that are not set as optional with `?`, must be provided when the directive is instantiated.
	   * If not provided, the compiler will throw the
	   * {@link error/$compile/missingattr $compile:missingattr error}.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	
	  /**
	   * The security context of DOM Properties.
	   * @private
	   */
	  var PROP_CONTEXTS = createMap();
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#addPropertySecurityContext
	   * @description
	   *
	   * Defines the security context for DOM properties bound by ng-prop-*.
	   *
	   * @param {string} elementName The element name or '*' to match any element.
	   * @param {string} propertyName The DOM property name.
	   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
	   * @returns {object} `this` for chaining
	   */
	  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
	    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());
	
	    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
	      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
	    }
	
	    PROP_CONTEXTS[key] = ctx;
	    return this;
	  };
	
	  /* Default property contexts.
	   *
	   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
	   * Changing:
	   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
	   * - STYLE => CSS
	   * - various URL => MEDIA_URL
	   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
	   */
	  (function registerNativePropertyContexts() {
	    function registerContext(ctx, values) {
	      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
	    }
	
	    registerContext(SCE_CONTEXTS.HTML, [
	      'iframe|srcdoc',
	      '*|innerHTML',
	      '*|outerHTML'
	    ]);
	    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
	    registerContext(SCE_CONTEXTS.URL, [
	      'area|href',       'area|ping',
	      'a|href',          'a|ping',
	      'blockquote|cite',
	      'body|background',
	      'del|cite',
	      'input|src',
	      'ins|cite',
	      'q|cite'
	    ]);
	    registerContext(SCE_CONTEXTS.MEDIA_URL, [
	      'audio|src',
	      'img|src',    'img|srcset',
	      'source|src', 'source|srcset',
	      'track|src',
	      'video|src',  'video|poster'
	    ]);
	    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
	      '*|formAction',
	      'applet|code',      'applet|codebase',
	      'base|href',
	      'embed|src',
	      'frame|src',
	      'form|action',
	      'head|profile',
	      'html|manifest',
	      'iframe|src',
	      'link|href',
	      'media|src',
	      'object|codebase',  'object|data',
	      'script|src'
	    ]);
	  })();
	
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function sanitizeSrcset(value, invokeType) {
	      if (!value) {
	        return value;
	      }
	      if (!isString(value)) {
	        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
	      }
	
	      // Such values are a bit too complex to handle automatically inside $sce.
	      // Instead, we sanitize each of the URIs individually, which works, even dynamically.
	
	      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
	      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
	      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
	      // `ng-bind-html` directive.
	
	      var result = '';
	
	      // first check if there are spaces because it's not the same pattern
	      var trimmedSrcset = trim(value);
	      //                (   999x   ,|   999w   ,|   ,|,   )
	      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	      // split srcset into tuple of uri and descriptor except for the last item
	      var rawUris = trimmedSrcset.split(pattern);
	
	      // for each tuples
	      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	      for (var i = 0; i < nbrUrisWith2parts; i++) {
	        var innerIdx = i * 2;
	        // sanitize the uri
	        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
	        // add the descriptor
	        result += ' ' + trim(rawUris[innerIdx + 1]);
	      }
	
	      // split the last item into uri and descriptor
	      var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	      // sanitize the last uri
	      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
	
	      // and add the last descriptor if any
	      if (lastTuple.length === 2) {
	        result += (' ' + trim(lastTuple[1]));
	      }
	      return result;
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        // is set through this function since it may cause $updateClass to
	        // become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        // Sanitize img[srcset] values.
	        if (nodeName === 'img' && key === 'srcset') {
	          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              // jQuery skips special boolean attrs treatment in XML nodes for
	              // historical reasons and hence AngularJS cannot freely call
	              // `.attr(attrName, false) with such attributes. To avoid issues
	              // in XHTML, call `removeAttr` in such cases instead.
	              // See https://github.com/jquery/jquery/issues/4249
	              if (booleanKey && value === false) {
	                this.$$element.removeAttr(attrName);
	              } else {
	                this.$$element.attr(attrName, value);
	              }
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            var isNgAttr = false, isNgProp = false, isNgEvent = false;
	            var multiElementMatch;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            nName = directiveNormalize(name.toLowerCase());
	
	            // Support ng-attr-*, ng-prop-* and ng-on-*
	            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
	              isNgAttr = ngPrefixMatch[1] === 'Attr';
	              isNgProp = ngPrefixMatch[1] === 'Prop';
	              isNgEvent = ngPrefixMatch[1] === 'On';
	
	              // Normalize the non-prefixed name
	              name = name.replace(PREFIX_REGEXP, '')
	                .toLowerCase()
	                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	
	            // Support *-start / *-end multi element directives
	            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            if (isNgProp || isNgEvent) {
	              attrs[nName] = value;
	              attrsMap[nName] = attr.name;
	
	              if (isNgProp) {
	                addPropertyDirective(node, directives, nName, name);
	              } else {
	                addEventDirective(directives, nName, name);
	              }
	            } else {
	              // Update nName for cases where a prefix was removed
	              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
	              nName = directiveNormalize(name.toLowerCase());
	              attrsMap[nName] = name;
	
	              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	              }
	
	              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                            attrEndName);
	            }
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = window.document.createDocumentFragment();
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
	                  slots[slotName].appendChild(node);
	                } else {
	                  $template.appendChild(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
	                }
	              }
	
	              $template = jqLite($template.childNodes);
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          controller.instance = controller();
	          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	          controller.bindingInfo =
	            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	
	          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
	            // inheritedData() uses the documentElement when it finds the document, so we would
	            // require from the element itself.
	            value = null;
	          } else {
	            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	          }
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedAttrContext(nodeName, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      // All nodes with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media nodes, which require the MEDIA_URL context.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	        return $sce.MEDIA_URL;
	      } else if (attrNormalizedName === 'xlinkHref') {
	        // Some xlink:href are okay, most aren't
	        if (nodeName === 'image') return $sce.MEDIA_URL;
	        if (nodeName === 'a') return $sce.URL;
	        return $sce.RESOURCE_URL;
	      } else if (
	          // Formaction
	          (nodeName === 'form' && attrNormalizedName === 'action') ||
	          // If relative URLs can go where they are not expected to, then
	          // all sorts of trust issues can arise.
	          (nodeName === 'base' && attrNormalizedName === 'href') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (nodeName === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
	                                 attrNormalizedName === 'ngHref')) {
	        return $sce.URL;
	      }
	    }
	
	    function getTrustedPropContext(nodeName, propNormalizedName) {
	      var prop = propNormalizedName.toLowerCase();
	      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
	    }
	
	    function sanitizeSrcsetPropertyValue(value) {
	      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
	    }
	    function addPropertyDirective(node, directives, attrName, propName) {
	      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
	        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
	      }
	
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedPropContext(nodeName, propName);
	
	      var sanitizer = identity;
	      // Sanitize img[srcset] + source[srcset] values.
	      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
	        sanitizer = sanitizeSrcsetPropertyValue;
	      } else if (trustedContext) {
	        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function ngPropCompileFn(_, attr) {
	          var ngPropGetter = $parse(attr[attrName]);
	          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
	            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	            return $sce.valueOf(val);
	          });
	
	          return {
	            pre: function ngPropPreLinkFn(scope, $element) {
	              function applyPropValue() {
	                var propValue = ngPropGetter(scope);
	                $element[0][propName] = sanitizer(propValue);
	              }
	
	              applyPropValue();
	              scope.$watch(ngPropWatch, applyPropValue);
	            }
	          };
	        }
	      });
	    }
	
	    function addEventDirective(directives, attrName, eventName) {
	      directives.push(
	        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
	      );
	    }
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedAttrContext(nodeName, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var isLiteral = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            });
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {};
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          if (isFunction(toSerialize)) {
	            toSerialize = toSerialize();
	          }
	          parts.push(encodeUriQuery(prefix) + '=' +
	              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   */
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   */
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   */
	  var interceptorFactories = this.interceptors = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfTrustedOrigins
	   * @description
	   *
	   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
	   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
	   * XSRF.
	   *
	   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
	   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
	   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
	   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
	   * Examples: `http://example.com`, `https://api.example.com:9876`
	   *
	   * <div class="alert alert-warning">
	   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
	   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
	   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
	   *   `https://foo.com/` will include the XSRF token.
	   * </div>
	   *
	   * @example
	   *
	   * ```js
	   * // App served from `https://example.com/`.
	   * angular.
	   *   module('xsrfTrustedOriginsExample', []).
	   *   config(['$httpProvider', function($httpProvider) {
	   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
	   *   }]).
	   *   run(['$http', function($http) {
	   *     // The XSRF token will be sent.
	   *     $http.get('https://api.example.com/preferences').then(...);
	   *
	   *     // The XSRF token will NOT be sent.
	   *     $http.get('https://stats.example.com/activity').then(...);
	   *   }]);
	   * ```
	   */
	  var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfWhitelistedOrigins
	   * @description
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
	   * instead.
	   */
	  Object.defineProperty(this, 'xsrfWhitelistedOrigins', {
	    get: function() {
	      return this.xsrfTrustedOrigins;
	    },
	    set: function(origins) {
	      this.xsrfTrustedOrigins = origins;
	    }
	  });
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * A function to check request URLs against a list of allowed origins.
	     */
	    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
	     * resolved (request success) or rejected (request failure) with a
	     * {@link ng.$http#$http-returns response} object.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
	     * the cookie, your server can be assured that the XHR came from JavaScript running on your
	     * domain.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
	     * sure that only JavaScript running on your domain could have sent the request. The token must
	     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
	     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
	     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
	     * want to, you can trust additional origins to also receive the XSRF token, by adding them
	     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
	     * useful, for example, if your application, served from `example.com`, needs to access your API
	     * at `api.example.com`.
	     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
	     * more details.
	     *
	     * <div class="alert alert-danger">
	     *   **Warning**<br />
	     *   Only trusted origins that you have control over and make sure you understand the
	     *   implications of doing so.
	     * </div>
	     *
	     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
	     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
	     * `$http.defaults` at run-time, or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses a unique cookie name.
	     *
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *
	     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
	     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
	     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
	     *
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
	     *   or rejected (request failure) with a response object.
	     *
	     *   The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with
	     *     the transform functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used
	     *     to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
	     *     (`complete`, `error`, `timeout` or `abort`).
	     *
	     *
	     *   A response status code between 200 and 299 is considered a success status
	     *   and will result in the success callback being called. Any response status
	     *   code outside of that range is considered an error status and will result
	     *   in the error callback being called.
	     *   Also, status codes less than -1 are normalized to zero. -1 usually means
	     *   the request was aborted, e.g. using a `config.timeout`. More information
	     *   about the status might be available in the `xhrStatus` property.
	     *
	     *   Note that if the response is a redirect, XMLHttpRequest will transparently
	     *   follow it, meaning that the outcome (success or error) will be determined
	     *   by the final response status code.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
	      $sceDelegateProvider.trustedResourceUrlList([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount('$http');
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop, '$http');
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the trusted resource URL list via
	     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	      * See {@link ng.$http#$http-returns `$http()` return value}.
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsAllowedOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	      var abortedByTimeout = false;
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.ontimeout = requestTimeout;
	      xhr.onabort = requestAborted;
	
	      forEach(eventHandlers, function(value, key) {
	        xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    // Since we are using xhr.abort() when a request times out, we have to set a flag that
	    // indicates to requestAborted if the request timed out or was aborted.
	    //
	    // http.timeout = numerical timeout   timeout
	    // http.timeout = $timeout            timeout
	    // http.timeout = promise             abort
	    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
	    //                                    can be exposed with the xhrFactory)
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(function() {
	        timeoutRequest('timeout');
	      }, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(function() {
	        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
	      });
	    }
	
	    function timeoutRequest(reason) {
	      abortedByTimeout = reason === 'timeout';
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    }
	    return startSymbol;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    }
	    return endSymbol;
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
	
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        if (mustHaveExpression) return;
	
	        var unescapedText = unescapeText(text);
	        if (contextAllowsConcatenation) {
	          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
	        }
	        var constantInterp = valueFn(unescapedText);
	        constantInterp.exp = text;
	        constantInterp.expressions = [];
	        constantInterp.$$watchDelegate = constantWatchDelegate;
	
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns,
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [],
	          singleExpression;
	
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      singleExpression = concat.length === 1 && expressionPositions.length === 1;
	      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
	      // objects rather than simple strings
	      // (we don't modify the expression if the input consists of only a single trusted input)
	      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
	      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
	      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
	      // that is more testable or make it obvious that you bound the value to some user controlled
	      // value.  This helps reduce the load when auditing for XSS issues.
	
	      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
	      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
	      // or on the overall concatenated string (losing trusted types used in the mix, by design).
	      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
	      // only used in srcdoc attributes, this would not be very useful.
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	
	          if (contextAllowsConcatenation) {
	            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
	            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
	          } else if (trustedContext && concat.length > 1) {
	            // This context does not allow more than one part, e.g. expr + string or exp + exp.
	            $interpolateMinErr.throwNoconcat(text);
	          }
	          // In an unprivileged context or only one part: just concatenate and return.
	          return concat.join('');
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
	          // parts of a full URL. We don't care about losing the trustedness here.
	          // In non-concatenable contexts, where there is only one expression, this interceptor is
	          // not applied to the expression.
	          value = (trustedContext && !contextAllowsConcatenation) ?
	                    $sce.getTrusted(trustedContext, value) :
	                    $sce.valueOf(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	var $intervalMinErr = minErr('$interval');
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$$intervalFactory', '$window',
	       function($$intervalFactory,   $window) {
	    var intervals = {};
	    var setIntervalFn = function(tick, delay, deferred) {
	      var id = $window.setInterval(tick, delay);
	      intervals[id] = deferred;
	      return id;
	    };
	    var clearIntervalFn = function(id) {
	      $window.clearInterval(id);
	      delete intervals[id];
	    };
	
	    /**
	     * @ngdoc service
	     * @name $interval
	     *
	     * @description
	     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	     * milliseconds.
	     *
	     * The return value of registering an interval function is a promise. This promise will be
	     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	     * run indefinitely if `count` is not defined. The value of the notification will be the
	     * number of iterations that have run.
	     * To cancel an interval, call `$interval.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	     * time.
	     *
	     * <div class="alert alert-warning">
	     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	     * with them.  In particular they are not automatically destroyed when a controller's scope or a
	     * directive's element are destroyed.
	     * You should take this into consideration and make sure to always cancel the interval at the
	     * appropriate moment.  See the example below for more details on how and when to do this.
	     * </div>
	     *
	     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	     *   are passed (see below), the function is called with the current iteration count.
	     * @param {number} delay Number of milliseconds between each function call.
	     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	     *   indefinitely.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	     *
	     * @example
	     * <example module="intervalExample" name="interval-service">
	     * <file name="index.html">
	     *   <script>
	     *     angular.module('intervalExample', [])
	     *       .controller('ExampleController', ['$scope', '$interval',
	     *         function($scope, $interval) {
	     *           $scope.format = 'M/d/yy h:mm:ss a';
	     *           $scope.blood_1 = 100;
	     *           $scope.blood_2 = 120;
	     *
	     *           var stop;
	     *           $scope.fight = function() {
	     *             // Don't start a new fight if we are already fighting
	     *             if ( angular.isDefined(stop) ) return;
	     *
	     *             stop = $interval(function() {
	     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	     *                 $scope.blood_1 = $scope.blood_1 - 3;
	     *                 $scope.blood_2 = $scope.blood_2 - 4;
	     *               } else {
	     *                 $scope.stopFight();
	     *               }
	     *             }, 100);
	     *           };
	     *
	     *           $scope.stopFight = function() {
	     *             if (angular.isDefined(stop)) {
	     *               $interval.cancel(stop);
	     *               stop = undefined;
	     *             }
	     *           };
	     *
	     *           $scope.resetFight = function() {
	     *             $scope.blood_1 = 100;
	     *             $scope.blood_2 = 120;
	     *           };
	     *
	     *           $scope.$on('$destroy', function() {
	     *             // Make sure that the interval is destroyed too
	     *             $scope.stopFight();
	     *           });
	     *         }])
	     *       // Register the 'myCurrentTime' directive factory method.
	     *       // We inject $interval and dateFilter service since the factory method is DI.
	     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	     *         function($interval, dateFilter) {
	     *           // return the directive link function. (compile function not needed)
	     *           return function(scope, element, attrs) {
	     *             var format,  // date format
	     *                 stopTime; // so that we can cancel the time updates
	     *
	     *             // used to update the UI
	     *             function updateTime() {
	     *               element.text(dateFilter(new Date(), format));
	     *             }
	     *
	     *             // watch the expression, and update the UI on change.
	     *             scope.$watch(attrs.myCurrentTime, function(value) {
	     *               format = value;
	     *               updateTime();
	     *             });
	     *
	     *             stopTime = $interval(updateTime, 1000);
	     *
	     *             // listen on DOM destroy (removal) event, and cancel the next UI update
	     *             // to prevent updating time after the DOM element was removed.
	     *             element.on('$destroy', function() {
	     *               $interval.cancel(stopTime);
	     *             });
	     *           }
	     *         }]);
	     *   </script>
	     *
	     *   <div>
	     *     <div ng-controller="ExampleController">
	     *       <label>Date format: <input ng-model="format"></label> <hr/>
	     *       Current time is: <span my-current-time="format"></span>
	     *       <hr/>
	     *       Blood 1 : <font color='red'>{{blood_1}}</font>
	     *       Blood 2 : <font color='red'>{{blood_2}}</font>
	     *       <button type="button" data-ng-click="fight()">Fight</button>
	     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	     *     </div>
	     *   </div>
	     *
	     * </file>
	     * </example>
	     */
	    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
	
	    /**
	     * @ngdoc method
	     * @name $interval#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`.
	     *
	     * @param {Promise=} promise returned by the `$interval` function.
	     * @returns {boolean} Returns `true` if the task was successfully canceled.
	     */
	    interval.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$intervalId')) {
	        throw $intervalMinErr('badprom',
	            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
	      }
	
	      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
	
	      var id = promise.$$intervalId;
	      var deferred = intervals[id];
	
	      // Interval cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      clearIntervalFn(id);
	
	      return true;
	    };
	
	    return interval;
	  }];
	}
	
	/** @this */
	function $$IntervalFactoryProvider() {
	  this.$get = ['$browser', '$q', '$$q', '$rootScope',
	       function($browser,   $q,   $$q,   $rootScope) {
	    return function intervalFactory(setIntervalFn, clearIntervalFn) {
	      return function intervalFn(fn, delay, count, invokeApply) {
	        var hasParams = arguments.length > 4,
	            args = hasParams ? sliceArgs(arguments, 4) : [],
	            iteration = 0,
	            skipApply = isDefined(invokeApply) && !invokeApply,
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise;
	
	        count = isDefined(count) ? count : 0;
	
	        function callback() {
	          if (!hasParams) {
	            fn(iteration);
	          } else {
	            fn.apply(null, args);
	          }
	        }
	
	        function tick() {
	          if (skipApply) {
	            $browser.defer(callback);
	          } else {
	            $rootScope.$evalAsync(callback);
	          }
	          deferred.notify(iteration++);
	
	          if (count > 0 && iteration >= count) {
	            deferred.resolve(iteration);
	            clearIntervalFn(promise.$$intervalId);
	          }
	
	          if (!skipApply) $rootScope.$apply();
	        }
	
	        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
	
	        return promise;
	      };
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	/* global stripHash: true */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function normalizePath(pathValue, searchValue, hashValue) {
	  var search = toKeyValue(searchValue),
	    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
	    path = encodePath(pathValue);
	
	  return path + (search ? '?' + search : '') + hash;
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBaseNoFile + url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBase + (url ? hashPrefix + url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$normalizeUrl = function(url) {
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    return appBase + hashPrefix + url;
	  };
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * Compose url and update `url` and `absUrl` property
	   * @private
	   */
	  $$compose: function() {
	    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
	    this.$$absUrl = this.$$normalizeUrl(this.$$url);
	    this.$$urlUpdatedByLocation = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    // Determine if two URLs are equal despite potentially having different encoding/normalizing
	    //  such as $location.absUrl() vs $browser.url()
	    // See https://github.com/angular/angular.js/issues/16592
	    function urlsEqual(a, b) {
	      return a === b || urlResolve(a).href === urlResolve(b).href;
	    }
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if ($location.absUrl() !== initialUrl) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = $browser.url();
	        var newUrl = $location.absUrl();
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	
	            cache[cacheKey] = addWatchDelegate(parsedExpression);
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	
	      var exp = parsedExpression.$$intercepted || parsedExpression;
	      var post = parsedExpression.$$interceptor || identity;
	
	      var useInputs = parsedExpression.inputs && !exp.inputs;
	
	      // Propogate the literal/inputs/constant attributes
	      // ... but not oneTime since we are handling it
	      oneTimeWatch.literal = parsedExpression.literal;
	      oneTimeWatch.constant = parsedExpression.constant;
	      oneTimeWatch.inputs = parsedExpression.inputs;
	
	      // Allow other delegates to run on this wrapped expression
	      addWatchDelegate(oneTimeWatch);
	
	      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
	
	      return unwatch;
	
	      function unwatchIfDone() {
	        if (isDone(lastValue)) {
	          unwatch();
	        }
	      }
	
	      function oneTimeWatch(scope, locals, assign, inputs) {
	        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
	        if (isDone(lastValue)) {
	          scope.$$postDigest(unwatchIfDone);
	        }
	        return post(lastValue);
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addWatchDelegate(parsedExpression) {
	      if (parsedExpression.constant) {
	        parsedExpression.$$watchDelegate = constantWatchDelegate;
	      } else if (parsedExpression.oneTime) {
	        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	      } else if (parsedExpression.inputs) {
	        parsedExpression.$$watchDelegate = inputsWatchDelegate;
	      }
	
	      return parsedExpression;
	    }
	
	    function chainInterceptors(first, second) {
	      function chainedInterceptor(value) {
	        return second(first(value));
	      }
	      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
	      chainedInterceptor.$$pure = first.$$pure && second.$$pure;
	
	      return chainedInterceptor;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	
	      // Extract any existing interceptors out of the parsedExpression
	      // to ensure the original parsedExpression is always the $$intercepted
	      if (parsedExpression.$$interceptor) {
	        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
	        parsedExpression = parsedExpression.$$intercepted;
	      }
	
	      var useInputs = false;
	
	      var fn = function interceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value);
	      };
	
	      // Maintain references to the interceptor/intercepted
	      fn.$$intercepted = parsedExpression;
	      fn.$$interceptor = interceptorFn;
	
	      // Propogate the literal/oneTime/constant attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	      fn.constant = parsedExpression.constant;
	
	      // Treat the interceptor like filters.
	      // If it is not $stateful then only watch its inputs.
	      // If the expression itself has no inputs then use the full expression as an input.
	      if (!interceptorFn.$stateful) {
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	
	        if (!interceptorFn.$$pure) {
	          fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	        }
	      }
	
	      return addWatchDelegate(fn);
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
	  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
	  // (Currently, this is the only method that might be called with a promise, even if it is not
	  // created by the built-in `$q`.)
	  if (q.$$state) {
	    markQStateExceptionHandled(q.$$state);
	  }
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	      this.$$suspended = false;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$suspended = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are (or contain)
	       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
	            newValues[i] = value;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          try {
	            if (firstRun) {
	              firstRun = false;
	              listener(newValues, newValues, self);
	            } else {
	              listener(newValues, oldValues, self);
	            }
	          } finally {
	            for (var i = 0; i < watchExpressions.length; i++) {
	              oldValues[i] = newValues[i];
	            }
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        // Mark the interceptor as
	        // ... $$pure when literal since the instance will change when any input changes
	        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
	        // ... $stateful when non-literal since we must read the state of the collection
	        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = asyncQueue.length ? $rootScope : this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = !current.$$suspended && current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            // (though it differs due to having the extra check for $$suspended and does not
	            // check $$listenerCount)
	            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$suspend
	       * @kind function
	       *
	       * @description
	       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
	       *
	       * This can be used to optimize your application when you know that running those watchers
	       * is redundant.
	       *
	       * **Warning**
	       *
	       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
	       * Only use this approach if you are confident that you know what you are doing and have
	       * ample tests to ensure that bindings get updated as you expect.
	       *
	       * Some of the things to consider are:
	       *
	       * * Any external event on a directive/component will not trigger a digest while the hosting
	       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
	       * * Transcluded content exists on a scope that inherits from outside a directive but exists
	       *   as a child of the directive's containing scope. If the containing scope is suspended the
	       *   transcluded scope will also be suspended, even if the scope from which the transcluded
	       *   scope inherits is not suspended.
	       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
	       *    * A call to `$suspend()` on an already suspended scope is a no-op.
	       *    * A call to `$resume()` on a non-suspended scope is a no-op.
	       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
	       *      longer be suspended. This could result in the other directive believing a scope to be
	       *      suspended when it is not.
	       * * If a parent scope is suspended then all its descendants will be also excluded from future
	       *   digests whether or not they have been suspended themselves. Note that this also applies to
	       *   isolate child scopes.
	       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
	       *   for that scope and its descendants. When digesting we only check whether the current scope is
	       *   locally suspended, rather than checking whether it has a suspended ancestor.
	       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
	       *   included in future digests until all its ancestors have been resumed.
	       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
	       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
	       *   initiated by a component that lives on a suspended scope.
	       */
	      $suspend: function() {
	        this.$$suspended = true;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$isSuspended
	       * @kind function
	       *
	       * @description
	       * Call this method to determine if this scope has been explicitly suspended. It will not
	       * tell you whether an ancestor has been suspended.
	       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
	       * for example, you must check all its ancestors:
	       *
	       * ```
	       * function isExcludedFromDigest(scope) {
	       *   while(scope) {
	       *     if (scope.$isSuspended()) return true;
	       *     scope = scope.$parent;
	       *   }
	       *   return false;
	       * ```
	       *
	       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
	       * even if `$isSuspended()` returns false.
	       *
	       * @returns true if the current scope has been suspended.
	       */
	      $isSuspended: function() {
	        return this.$$suspended;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$resume
	       * @kind function
	       *
	       * @description
	       * Resume watchers of this scope subtree in case it was suspended.
	       *
	       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
	       */
	      $resume: function() {
	        this.$$suspended = false;
	      },
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          }, null, '$evalAsync');
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount and
	          // does not check $$suspended)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        }, null, '$applyAsync');
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	
	  var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
	   *
	   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
	   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
	   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
	   *
	   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return aHrefSanitizationTrustedUrlList;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
	   *
	   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
	   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
	   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
	   * the potentially malicious URL.
	   *
	   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
	   * unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return imgSrcSanitizationTrustedUrlList;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isMediaUrl) {
	      // if (!uri) return uri;
	      var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
	      var normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it refers to the source of media, which are not expected to be run
	  // as scripts, such as an image, audio, video, etc.
	  MEDIA_URL: 'mediaUrl',
	
	  // An URL used in a context where it does not refer to a resource that loads code.
	  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
	 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
	 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
	 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and
	 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.trustedResourceUrlList([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
	 *    // here is blocked.
	 *    $sceDelegateProvider.bannedResourceUrlList([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
	 * of issues, like for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var trustedResourceUrlList = ['self'],
	      bannedResourceUrlList = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#trustedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
	   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
	   *     further changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set trusted resource URL array.
	   *
	   * @description
	   * Sets/Gets the list trusted of resource URLs.
	   *
	   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
	   * allowing only same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
	   * its origin with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.trustedResourceUrlList = function(value) {
	    if (arguments.length) {
	      trustedResourceUrlList = adjustMatchers(value);
	    }
	    return trustedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
	   * trustedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlWhitelist', {
	    get: function() {
	      return this.trustedResourceUrlList;
	    },
	    set: function(value) {
	      this.trustedResourceUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#bannedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
	   *     the value provided. This must be an array or null. A snapshot of this array is used so
	   *     further changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the `bannedResourceUrlList` is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
	   *     the final say.
	   *
	   * @return {Array} The currently set `bannedResourceUrlList` array.
	   *
	   * @description
	   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
	   *
	   * The **default value** when no trusted resource URL list has been explicitly set is the empty
	   * array (i.e. there is no `bannedResourceUrlList`.)
	   */
	  this.bannedResourceUrlList = function(value) {
	    if (arguments.length) {
	      bannedResourceUrlList = adjustMatchers(value);
	    }
	    return bannedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
	   * bannedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlBlacklist', {
	    get: function() {
	      return this.bannedResourceUrlList;
	    },
	    set: function(value) {
	      this.bannedResourceUrlList = value;
	    }
	  });
	
	  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the trusted resource URL list allows this url.
	      for (i = 0, n = trustedResourceUrlList.length; i < n; i++) {
	        if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the banned resource URL list has blocked this url.
	        for (i = 0, n = bannedResourceUrlList.length; i < n; i++) {
	          if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Given an object and a security context in which to assign it, returns a value that's safe to
	     * use in this context, which was represented by the parameter. To do so, this function either
	     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
	     * the context and sanitizer availablility.
	     *
	     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
	     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
	     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
	     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
	     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
	     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
	     *
	     * This function will throw if the safe type isn't appropriate for this context, or if the
	     * value given cannot be accepted in the context (which might be caused by sanitization not
	     * being available, or the value not being recognized as safe).
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If maybeTrusted is a trusted class instance but not of the correct trusted type
	      // then unwrap it and allow it to pass through to the rest of the checks
	      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
	        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If we get here, then we will either sanitize the value or throw an exception.
	      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
	        // we attempt to sanitize non-resource URLs
	        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
	      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
	 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
	 * HTML can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
	 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
	 * when binding untrusted values to `$sce.HTML` context.
	 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 *
	 * <div class="alert alert-warning">
	 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
	 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
	 *
	 * **As of 1.7.0, this is no longer the case.**
	 *
	 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
	 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
	 * service evaluates the expressions.
	 * </div>
	 *
	 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
	 * functions aren't useful yet. This might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      for matching resource URL lists.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $$taskTrackerFactory
	 * @description
	 * A function to create `TaskTracker` instances.
	 *
	 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
	 * parties when all pending tasks (or tasks of a specific type) have been completed.
	 *
	 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
	 *     execution.
	 *
	 * @this
	 */
	function $$TaskTrackerFactoryProvider() {
	  this.$get = valueFn(function(log) { return new TaskTracker(log); });
	}
	
	function TaskTracker(log) {
	  var self = this;
	  var taskCounts = {};
	  var taskCallbacks = [];
	
	  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
	  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';
	
	  /**
	   * Execute the specified function and decrement the appropriate `taskCounts` counter.
	   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
	   *
	   * @param {Function} fn - The function to execute.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
	   */
	  self.completeTask = completeTask;
	
	  /**
	   * Increase the task count for the specified task type (or the default task type if non is
	   * specified).
	   *
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
	   */
	  self.incTaskCount = incTaskCount;
	
	  /**
	   * Execute the specified callback when all pending tasks have been completed.
	   *
	   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
	   * the tasks that will be waited for to a specific type, by passing a `taskType`.
	   *
	   * @param {function} callback - The function to call when there are no pending tasks.
	   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
	   */
	  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
	
	  function completeTask(fn, taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	
	    try {
	      fn();
	    } finally {
	      decTaskCount(taskType);
	
	      var countForType = taskCounts[taskType];
	      var countForAll = taskCounts[ALL_TASKS_TYPE];
	
	      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
	      if (!countForAll || !countForType) {
	        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
	        var nextCb;
	
	        while ((nextCb = getNextCallback(taskType))) {
	          try {
	            nextCb();
	          } catch (e) {
	            log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function decTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    if (taskCounts[taskType]) {
	      taskCounts[taskType]--;
	      taskCounts[ALL_TASKS_TYPE]--;
	    }
	  }
	
	  function getLastCallback() {
	    var cbInfo = taskCallbacks.pop();
	    return cbInfo && cbInfo.cb;
	  }
	
	  function getLastCallbackForType(taskType) {
	    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
	      var cbInfo = taskCallbacks[i];
	      if (cbInfo.type === taskType) {
	        taskCallbacks.splice(i, 1);
	        return cbInfo.cb;
	      }
	    }
	  }
	
	  function incTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
	    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
	  }
	
	  function notifyWhenNoPendingTasks(callback, taskType) {
	    taskType = taskType || ALL_TASKS_TYPE;
	    if (!taskCounts[taskType]) {
	      callback();
	    } else {
	      taskCallbacks.push({type: taskType, cb: callback});
	    }
	  }
	}
	
	var $templateRequestMinErr = minErr('$templateRequest');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through adding the template again to the trusted
	        // resources for keys that already are included in there. This also makes
	        // AngularJS accept any script directive, no matter its name. However, we
	        // still need to unwrap trusted types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            return $templateCache.put(tpl, response.data);
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when all pending tasks are completed.
	     *
	     * Types of tasks waited for include:
	     * - Pending timeouts (via {@link $timeout}).
	     * - Pending HTTP requests (via {@link $http}).
	     * - In-progress route transitions (via {@link $route}).
	     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
	     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
	     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	var $timeoutMinErr = minErr('$timeout');
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	    /**
	     * @ngdoc service
	     * @name $timeout
	     *
	     * @description
	     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	     * block and delegates any exceptions to
	     * {@link ng.$exceptionHandler $exceptionHandler} service.
	     *
	     * The return value of calling `$timeout` is a promise, which will be resolved when
	     * the delay has passed and the timeout function, if provided, is executed.
	     *
	     * To cancel a timeout request, call `$timeout.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	     * synchronously flush the queue of deferred functions.
	     *
	     * If you only want a promise that will be resolved after some specified delay
	     * then you can call `$timeout` without the `fn` function.
	     *
	     * @param {function()=} fn A function, whose execution should be delayed.
	     * @param {number=} [delay=0] Delay in milliseconds.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	     *   will be resolved with the return value of the `fn` function.
	     *
	     */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay, '$timeout');
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $timeout#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`. As a result of this, the promise will be
	     * resolved with a rejection.
	     *
	     * @param {Promise=} promise Promise returned by the `$timeout` function.
	     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	     *   canceled.
	     */
	    timeout.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$timeoutId')) {
	        throw $timeoutMinErr('badprom',
	            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
	      }
	
	      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
	
	      var id = promise.$$timeoutId;
	      var deferred = deferreds[id];
	
	      // Timeout cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      delete deferreds[id];
	
	      return $browser.defer.cancel(id);
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	var baseUrlParsingNode;
	
	urlParsingNode.href = 'http://[::1]';
	
	// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
	// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
	// when parsed out of an anchor element.
	var ipv6InBrackets = urlParsingNode.hostname === '[::1]';
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
	 *     unchanged.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description                                                            |
	 *   |---------------|------------------------------------------------------------------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol without the trailing colon                                |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol                                 |
	 *   | hostname      | The hostname                                                           |
	 *   | port          | The port, without ":"                                                  |
	 *   | pathname      | The pathname, beginning with "/"                                       |
	 *
	 */
	function urlResolve(url) {
	  if (!isString(url)) return url;
	
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  var hostname = urlParsingNode.hostname;
	
	  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
	    hostname = '[' + hostname + ']';
	  }
	
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application
	 * document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, originUrl);
	}
	
	/**
	 * Parse a request URL and determine whether it is same-origin as the current document base URL.
	 *
	 * Note: The base URL is usually the same as the document location (`location.href`) but can
	 * be overriden by using the `<base>` tag.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the URL is same-origin as the document base URL.
	 */
	function urlIsSameOriginAsBaseUrl(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, getBaseUrl());
	}
	
	/**
	 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
	 * The current location's origin is implicitly trusted.
	 *
	 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
	 *
	 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
	 *     whether it is of an allowed origin.
	 */
	function urlIsAllowedOriginFactory(trustedOriginUrls) {
	  var parsedAllowedOriginUrls = [originUrl].concat(trustedOriginUrls.map(urlResolve));
	
	  /**
	   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
	   * based on a list of trusted-origin URLs. The current location's origin is implicitly
	   * trusted.
	   *
	   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
	   *     resolved or a parsed URL object).
	   *
	   * @returns {boolean} - Whether the specified URL is of an allowed origin.
	   */
	  return function urlIsAllowedOrigin(requestUrl) {
	    var parsedUrl = urlResolve(requestUrl);
	    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
	  };
	}
	
	/**
	 * Determine if two URLs share the same origin.
	 *
	 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
	 *     a dictionary object returned by `urlResolve()`.
	 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
	 *     of a dictionary object returned by `urlResolve()`.
	 *
	 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
	 */
	function urlsAreSameOrigin(url1, url2) {
	  url1 = urlResolve(url1);
	  url2 = urlResolve(url2);
	
	  return (url1.protocol === url2.protocol &&
	          url1.host === url2.host);
	}
	
	/**
	 * Returns the current document base URL.
	 * @returns {string}
	 */
	function getBaseUrl() {
	  if (window.document.baseURI) {
	    return window.document.baseURI;
	  }
	
	  // `document.baseURI` is available everywhere except IE
	  if (!baseUrlParsingNode) {
	    baseUrlParsingNode = window.document.createElement('a');
	    baseUrlParsingNode.href = '.';
	
	    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
	    // suitable here because we need to track changes to the base URL.
	    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
	  }
	  return baseUrlParsingNode.href;
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 *    **Note:** `null` values use `'null'` as their type.
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, sorts values of different types by type and puts
	 * `undefined` and `null` values at the end of the sorted list.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types:
	 *    - If one of the values is undefined, consider it "greater than" the other.
	 *    - Else if one of the values is null, consider it "greater than" the other.
	 *    - Else compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
	 *           any other value (with undefined "greater than" null). This effectively means that `null`
	 *           and `undefined` values end up at the end of a list sorted in ascending order.
	 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = (type1 === 'undefined') ? 1 :
	        (type2 === 'undefined') ? -1 :
	        (type1 === 'null') ? 1 :
	        (type2 === 'null') ? -1 :
	        (type1 < type2) ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        // We need to sanitize the url at least once, in case it is a constant
	        // non-interpolated attribute.
	        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set might have sanitized the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  }];
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $getControls: valueFn([]),
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop,
	  $$setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$getControls
	   * @returns {Array} the controls that are currently part of this form
	   *
	   * @description
	   * This method returns a **shallow copy** of the controls that are currently part of this form.
	   * The controls can be instances of {@link form.FormController `FormController`}
	   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
	   * If you need access to the controls of child-forms, you have to call `$getControls()`
	   * recursively on them.
	   * This can be used for example to iterate over all controls to validate them.
	   *
	   * The controls can be accessed normally, but adding to, or removing controls from the array has
	   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
	   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
	   * Likewise, adding a control to, or removing a control from the form is not reflected
	   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
	   * you need access to the controls.
	   */
	  $getControls: function() {
	    return shallowCopy(this.$$controls);
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
	   * parent forms of the form.
	   */
	  $setSubmitted: function() {
	    var rootForm = this;
	    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
	      rootForm = rootForm.$$parentForm;
	    }
	    rootForm.$$setSubmitted();
	  },
	
	  $$setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    forEach(this.$$controls, function(control) {
	      if (control.$$setSubmitted) {
	        control.$$setSubmitted();
	      }
	    });
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Helper directive that makes it possible to create control groups inside a
	 * {@link ng.directive:form `form`} directive.
	 * These "child forms" can be used, for example, to determine the validity of a sub-group of
	 * controls.
	 *
	 * <div class="alert alert-danger">
	 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
	 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
	 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
	 * you cannot send data to the server with `ngForm`, or integrate it with
	 * {@link ng.directive:ngSubmit `ngSubmit`}.
	 * </div>
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
	 *                              be published into the related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * The format of the displayed time can be adjusted with the
	    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	    * and `timeStripZeroSeconds`.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
	   * this is the timezone of the browser.
	   *
	   * The format of the displayed time can be adjusted with the
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	   * and `timeStripZeroSeconds`.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
	    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
	    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   *
	   *
	   * @knownIssue
	   *
	   * ### HTML5 constraint validation and `allowInvalid`
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   * @knownIssue
	   *
	   * ### Large numbers and `step` validation
	   *
	   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
	   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
	   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
	   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
	   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
	   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
	   * point for both implementations.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium, which may not fulfill your app's requirements.
	   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
	   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
	   * modify the built-in validators (see the {@link guide/forms Forms guide}).
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * **Note:**<br>
	   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
	   * value of their `name` attribute to determine the property under which their
	   * {@link ngModel.NgModelController NgModelController} will be published on the parent
	   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
	   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
	   * published on the parent `FormController` under that name. The rest of the controllers will
	   * continue to work as expected, but you won't be able to access them as properties on the parent
	   * `FormController`.
	   *
	   * <div class="alert alert-info">
	   *   <p>
	   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
	   *     that the browser can manage their state (checked/unchecked) based on the state of other
	   *     inputs in the same group.
	   *   </p>
	   *   <p>
	   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
	   *     value of the underlying model data.
	   *   </p>
	   * </div>
	   *
	   * <div class="alert alert-success">
	   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
	   *   unique name.
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                      to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    // Support: IE9+
	    element.on('compositionupdate', function(ev) {
	      // End composition when ev.data is empty string on 'compositionupdate' event.
	      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
	      // instead of 'compositionend'.
	      if (isUndefined(ev.data) || ev.data === '') {
	        composing = false;
	      }
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, previousDate) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (previousDate) {
	          map = {
	            yyyy: previousDate.getFullYear(),
	            MM: previousDate.getMonth() + 1,
	            dd: previousDate.getDate(),
	            HH: previousDate.getHours(),
	            mm: previousDate.getMinutes(),
	            ss: previousDate.getSeconds(),
	            sss: previousDate.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	
	        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	        if (map.yyyy < 100) {
	          // In the constructor, 2-digit years map to 1900-1999.
	          // Use `setFullYear()` to set the correct year.
	          date.setFullYear(map.yyyy);
	        }
	
	        return date;
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	    badInputChecker(scope, element, attr, ctrl, type);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	    var isTimeType = type === 'time' || type === 'datetimelocal';
	    var previousDate;
	    var previousTimezone;
	
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
	      }
	      ctrl.$$parserName = type;
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        var timezone = ctrl.$options.getOption('timezone');
	
	        if (timezone) {
	          previousTimezone = timezone;
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	
	        return formatter(value, timezone);
	      } else {
	        previousDate = null;
	        previousTimezone = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal = attr.min || $parse(attr.ngMin)(scope);
	      var parsedMinVal = parseObservedDateValue(minVal);
	
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
	      };
	      attr.$observe('min', function(val) {
	        if (val !== minVal) {
	          parsedMinVal = parseObservedDateValue(val);
	          minVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal = attr.max || $parse(attr.ngMax)(scope);
	      var parsedMaxVal = parseObservedDateValue(maxVal);
	
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
	      };
	      attr.$observe('max', function(val) {
	        if (val !== maxVal) {
	          parsedMaxVal = parseObservedDateValue(val);
	          maxVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
	    }
	
	    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
	      var timezone = ctrl.$options.getOption('timezone');
	
	      if (previousTimezone && previousTimezone !== timezone) {
	        // If the timezone has changed, adjust the previousDate to the default timezone
	        // so that the new date is converted with the correct timezone offset
	        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
	      }
	
	      var parsedDate = parseDate(value, previousDate);
	
	      if (!isNaN(parsedDate) && timezone) {
	        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	      }
	      return parsedDate;
	    }
	
	    function formatter(value, timezone) {
	      var targetFormat = format;
	
	      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
	        targetFormat = format
	          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
	          .replace(/:$/, '');
	      }
	
	      var formatted =  $filter('date')(value, targetFormat, timezone);
	
	      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
	        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
	      }
	
	      return formatted;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl, parserName) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      if (validity.badInput || validity.typeMismatch) {
	        ctrl.$$parserName = parserName;
	        return undefined;
	      }
	
	      return value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	
	    ctrl.$$parserName = 'number';
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  badInputChecker(scope, element, attr, ctrl, 'number');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var parsedMinVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal = attr.min || $parse(attr.ngMin)(scope);
	    parsedMinVal = parseNumberAttrVal(minVal);
	
	    ctrl.$validators.min = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (val !== minVal) {
	        parsedMinVal = parseNumberAttrVal(val);
	        minVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal = attr.max || $parse(attr.ngMax)(scope);
	    var parsedMaxVal = parseNumberAttrVal(maxVal);
	
	    ctrl.$validators.max = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (val !== maxVal) {
	        parsedMaxVal = parseNumberAttrVal(val);
	        maxVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal = attr.step || $parse(attr.ngStep)(scope);
	    var parsedStepVal = parseNumberAttrVal(stepVal);
	
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
	        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      if (val !== stepVal) {
	        parsedStepVal = parseNumberAttrVal(val);
	        stepVal = val;
	        ctrl.$validate();
	      }
	
	    });
	
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl, 'range');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    minVal = parseNumberAttrVal(attr.min);
	
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    maxVal = parseNumberAttrVal(attr.max);
	
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    stepVal = parseNumberAttrVal(attr.step);
	
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    var oldVal = attr[htmlAttrName];
	    attr.$observe(htmlAttrName, function wrappedObserver(val) {
	      if (val !== oldVal) {
	        oldVal = val;
	        changeFn(val);
	      }
	    });
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (!supportsRange) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    } else if (ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	var hiddenInputBrowserCacheDirective = function() {
	  var valueProperty = {
	    configurable: true,
	    enumerable: false,
	    get: function() {
	      return this.getAttribute('value') || '';
	    },
	    set: function(val) {
	      this.setAttribute('value', val);
	    }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 200,
	    compile: function(_, attr) {
	      if (lowercase(attr.type) !== 'hidden') {
	        return;
	      }
	
	      return {
	        pre: function(scope, element, attr, ctrls) {
	          var node = element[0];
	
	          // Support: Edge
	          // Moving the DOM around prevents autofillling
	          if (node.parentNode) {
	            node.parentNode.insertBefore(node, node.nextSibling);
	          }
	
	          // Support: FF, IE
	          // Avoiding direct assignment to .value prevents autofillling
	          if (Object.defineProperty) {
	            Object.defineProperty(node, 'value', valueProperty);
	          }
	        }
	      };
	    }
	  };
	};
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    if (!classValue) return classValue;
	
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    } else if (!isString(classValue)) {
	      classString = classValue + '';
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassOdd`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-odd="'odd'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .odd {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .odd-add, .odd-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add odd class to odd entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassEven`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-even="'even'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .even {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .even-add, .even-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add even class to even entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
	      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
	    }];
	  }
	);
	
	function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
	  return {
	    restrict: 'A',
	    compile: function($element, attr) {
	      // NOTE:
	      // We expose the powerful `$event` object on the scope that provides access to the Window,
	      // etc. This is OK, because expressions are not sandboxed any more (and the expression
	      // sandbox was never meant to be a security feature anyway).
	      var fn = $parse(attr[directiveName]);
	      return function ngEventHandler(scope, element) {
	        element.on(eventName, function(event) {
	          var callback = function() {
	            fn(scope, {$event: event});
	          };
	
	          if (!$rootScope.$$phase) {
	            scope.$apply(callback);
	          } else if (forceAsync) {
	            scope.$evalAsync(callback);
	          } else {
	            try {
	              callback();
	            } catch (error) {
	              $exceptionHandler(error);
	            }
	          }
	        });
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
	 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
	 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	  this.$$parserName = 'parse';
	
	  this.$$currentValidationRunId = 0;
	
	  this.$$scope = $scope;
	  this.$$rootScope = $scope.$root;
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName;
	
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    // Reset any previous parse error
	    this.$setValidity(this.$$parserName, null);
	    this.$$parserName = 'parse';
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default']) &&
	      this.$options.getOption('updateOn').indexOf(trigger) === -1
	    ) {
	      debounceDelay = debounceDelay['default'];
	    } else if (isNumber(debounceDelay['*'])) {
	      debounceDelay = debounceDelay['*'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$rootScope.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /** @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ### Default events, extra triggers, and catch-all debounce values
	 *
	 * This example shows the relationship between "default" update events and
	 * additional `updateOn` triggers.
	 *
	 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
	 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
	 * in `updateOn` is considered a "default" event, since different control types have different
	 * default events.
	 *
	 * The control in this example updates by "default", "click", and "blur", with different `debounce`
	 * values. You can see that "click" doesn't have an individual `debounce` value -
	 * therefore it uses the `*` debounce value.
	 *
	 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
	 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
	 * it is considered a "default" event and will update the
	 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
	 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
	 *
	 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
	 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
	 *
	  <example name="ngModelOptions-advanced" module="optionsExample">
	    <file name="index.html">
	       <model-update-demo></model-update-demo>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .component('modelUpdateDemo', {
	          templateUrl: 'template.html',
	          controller: function() {
	            this.name = 'Chinua';
	
	            this.options = {
	              updateOn: 'default blur click',
	              debounce: {
	                default: 2000,
	                blur: 0,
	                '*': 1000
	              }
	            };
	
	            this.updateEvents = function() {
	              var eventList = this.options.updateOn.split(' ');
	              eventList.push('*');
	              var events = {};
	
	              for (var i = 0; i < eventList.length; i++) {
	                events[eventList[i]] = this.options.debounce[eventList[i]];
	              }
	
	              this.events = events;
	            };
	
	            this.updateOptions = function() {
	              var options = angular.extend(this.options, {
	                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
	                debounce: this.events
	              });
	
	              this.form.input.$overrideModelOptions(options);
	            };
	
	            // Initialize the event form
	            this.updateEvents();
	          }
	        });
	    </file>
	    <file name="template.html">
	      <form name="$ctrl.form">
	        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
	      </form>
	      Model: <tt>{{$ctrl.name}}</tt>
	      <hr>
	      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>
	
	      <hr>
	      <form ng-submit="$ctrl.updateOptions()">
	        <b>updateOn</b><br>
	        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">
	
	        <table>
	          <tr>
	            <th>Option</th>
	            <th>Debounce value</th>
	          </tr>
	          <tr ng-repeat="(key, value) in $ctrl.events">
	            <td>{{key}}</td>
	            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
	          </tr>
	        </table>
	
	        <br>
	        <input type="submit" value="Update options">
	      </form>
	    </file>
	  </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 * See also the example for
	 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
	 * Default events, extra triggers, and catch-all debounce values}.
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Formatting the value of `time` and `datetime-local`
	 *
	 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
	 * that is displayed in the control. Note that browsers may apply their own formatting
	 * in the user interface.
	 *
	   <example name="ngModelOptions-time-format" module="timeExample">
	     <file name="index.html">
	       <time-example></time-example>
	     </file>
	     <file name="script.js">
	        angular.module('timeExample', [])
	          .component('timeExample', {
	            templateUrl: 'timeExample.html',
	            controller: function() {
	              this.time = new Date(1970, 0, 1, 14, 57, 0);
	
	              this.options = {
	                timeSecondsFormat: 'ss',
	                timeStripZeroSeconds: true
	              };
	
	              this.optionChange = function() {
	                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
	                this.time = new Date(this.time);
	              };
	            }
	          });
	     </file>
	     <file name="timeExample.html">
	       <form name="$ctrl.timeForm">
	         <strong>Default</strong>:
	         <input type="time" ng-model="$ctrl.time" step="any" /><br>
	         <strong>With options</strong>:
	         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
	         <br>
	
	         Options:<br>
	         <code>timeSecondsFormat</code>:
	         <input
	           type="text"
	           ng-model="$ctrl.options.timeSecondsFormat"
	           ng-change="$ctrl.optionChange()">
	         <br>
	         <code>timeStripZeroSeconds</code>:
	         <input
	           type="checkbox"
	           ng-model="$ctrl.options.timeStripZeroSeconds"
	           ng-change="$ctrl.optionChange()">
	        </form>
	      </file>
	 *  </example>
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents.
	 *
	 * **General options**:
	 *
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *     You can use the `*` key to specify a debounce value that applies to all events that are not
	 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur mouseup',
	 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *
	 *
	 *  **Input-type specific options**:
	 *
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *     Note that changing the timezone will have no effect on the current date, and is only applied after
	 *     the next input / model change.
	 *
	 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
	 *     milliseconds. The option follows the format string of {@link date date filter}.
	 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
	 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
	 *     seconds and milliseconds.
	 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
	 *     part of the time string, and may show the value differently in the user interface.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
	 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
	 *     after `timeSecondsFormat`.
	 *     This option can be used to make the formatting consistent over different browsers, as some
	 *     browsers with support for `time` will natively hide the milliseconds and
	 *     seconds if they are zero, but others won't, and browsers that don't implement these input
	 *     types will always show the full string.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRef
	 * @restrict A
	 *
	 * @description
	 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
	 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
	 * element to the scope.
	 *
	 * If the element with `ngRef` is destroyed `null` is assigned to the property.
	 *
	 * Note that if you want to assign from a child into the parent scope, you must initialize the
	 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
	 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
	 * {@link ngRepeat}. See the second example below.
	 *
	 *
	 * @element ANY
	 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
	 *                       controller or jqlite-wrapped DOM element will be bound.
	 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
	 *                            or the special string `$element`. If a name is provided, `ngRef` will
	 *                            assign the matching controller. If `$element` is provided, the element
	 *                            itself is assigned (even if a controller is available).
	 *
	 *
	 * @example
	 * ### Simple toggle
	 * This example shows how the controller of the component toggle
	 * is reused in the template through the scope to use its logic.
	 * <example name="ng-ref-component" module="myApp">
	 *   <file name="index.html">
	 *     <my-toggle ng-ref="myToggle"></my-toggle>
	 *     <button ng-click="myToggle.toggle()">Toggle</button>
	 *     <div ng-show="myToggle.isOpen()">
	 *       You are using a component in the same template to show it.
	 *     </div>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myToggle', {
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should publish the toggle into the scope', function() {
	 *        var toggle = element(by.buttonText('Toggle'));
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
	 *        toggle.click();
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### ngRef inside scopes
	 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
	 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
	 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
	 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
	 * because the target property has not been initialized on the `myRoot` component controller.
	 *
	 * <example name="ng-ref-scopes" module="myApp">
	 *   <file name="index.html">
	 *     <my-root></my-root>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myRoot', {
	 *       templateUrl: 'root.html',
	 *       controller: function() {
	 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
	 *       }
	 *     })
	 *     .component('myToggle', {
	 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
	 *       transclude: true,
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     })
	 *     .component('myWrapper', {
	 *       transclude: true,
	 *       template: '<strong>myWrapper</strong>' +
	 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
	 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
	 *     });
	 *   </file>
	 *   <file name="root.html">
	 *     <strong>myRoot</strong>
	 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
	 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     <div><em>wrappers assigned to root</em><br>
	 *     <div ng-repeat="wrapper in $ctrl.wrappers">
	 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
	 *     </div>
	 *
	 *     <ul>
	 *       <li ng-repeat="(index, value) in [1,2,3]">
	 *         <strong>ngRepeat</strong>
	 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
	 *       </li>
	 *     </ul>
	 *
	 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
	 *       assigned to the child scope created by ngIf.
	 *     </div>
	 *     <div ng-if="true">
	          <strong>ngIf</strong>
	 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
	 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
	 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     </div>
	 *   </file>
	 *   <file name="styles.css">
	 *     ul {
	 *       list-style: none;
	 *       padding-left: 0;
	 *     }
	 *
	 *     li[ng-repeat] {
	 *       background: lightgreen;
	 *       padding: 8px;
	 *       margin: 8px;
	 *     }
	 *
	 *     [ng-if] {
	 *       background: lightgrey;
	 *       padding: 8px;
	 *     }
	 *
	 *     my-root {
	 *       background: lightgoldenrodyellow;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-wrapper {
	 *       background: lightsalmon;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-toggle {
	 *       background: lightblue;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      var OuterToggle = function() {
	 *        this.toggle = function() {
	 *          element(by.buttonText('Outer Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
	 *        };
	 *      };
	 *      var NgRepeatToggle = function(i) {
	 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *      var NgRepeatToggles = function() {
	 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
	 *        this.forEach = function(fn) {
	 *          toggles.forEach(fn);
	 *        };
	 *        this.isOuterOpen = function(i) {
	 *          return toggles[i - 1].isOuterOpen();
	 *        };
	 *      };
	 *      var NgIfToggle = function() {
	 *        var parent = element(by.css('[ng-if]'));
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngIf Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return by.binding('ngIfToggle.isOpen() | json').getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *
	 *      it('should toggle the outer toggle', function() {
	 *        var outerToggle = new OuterToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle all outer toggles', function() {
	 *        var outerToggle = new OuterToggle();
	 *        var repeatToggles = new NgRepeatToggles();
	 *        var ifToggle = new NgIfToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle each repeat iteration separately', function() {
	 *        var repeatToggles = new NgRepeatToggles();
	 *
	 *        repeatToggles.forEach(function(repeatToggle) {
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *          repeatToggle.toggle();
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        });
	 *      });
	 *   </file>
	 * </example>
	 *
	 */
	
	var ngRefMinErr = minErr('ngRef');
	
	var ngRefDirective = ['$parse', function($parse) {
	  return {
	    priority: -1, // Needed for compatibility with element transclusion on the same element
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      // Get the expected controller name, converts <data-some-thing> into "someThing"
	      var controllerName = directiveNormalize(nodeName_(tElement));
	
	      // Get the expression for value binding
	      var getter = $parse(tAttrs.ngRef);
	      var setter = getter.assign || function() {
	        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
	      };
	
	      return function(scope, element, attrs) {
	        var refValue;
	
	        if (attrs.hasOwnProperty('ngRefRead')) {
	          if (attrs.ngRefRead === '$element') {
	            refValue = element;
	          } else {
	            refValue = element.data('$' + attrs.ngRefRead + 'Controller');
	
	            if (!refValue) {
	              throw ngRefMinErr(
	                'noctrl',
	                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
	                attrs.ngRefRead,
	                tAttrs.ngRef
	              );
	            }
	          }
	        } else {
	          refValue = element.data('$' + controllerName + 'Controller');
	        }
	
	        refValue = refValue || element;
	
	        setter(scope, refValue);
	
	        // when the element is removed, remove it (nullify it)
	        element.on('$destroy', function() {
	          // only remove it if value has not changed,
	          // because animations (and other procedures) may duplicate elements
	          if (getter(scope) === refValue) {
	            setter(scope, null);
	          }
	        });
	      };
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	  var trackByIdArrayFn = function($scope, key, value) {
	    return hashKey(value);
	  };
	
	  var trackByIdObjFn = function($scope, key) {
	    return key;
	  };
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByIdExpFn;
	
	      if (trackByExp) {
	        var hashFnLocals = {$id: hashKey};
	        var trackByExpGetter = $parse(trackByExp);
	
	        trackByIdExpFn = function($scope, key, value, index) {
	          // assign key, value, and $index to the locals so that they can be used in hash functions
	          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	          hashFnLocals[valueIdentifier] = value;
	          hashFnLocals.$index = index;
	          return trackByExpGetter($scope, hashFnLocals);
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn($scope, key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
	          // being leaked into the ngRepeatCompile function scope
	          if (hashFnLocals) {
	            hashFnLocals[valueIdentifier] = undefined;
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngShow to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngHide to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, ''); });
	    }
	    if (newStyles) element.css(newStyles);
	  });
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      // For boolean attributes like required, presence means true
	      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);
	
	      if (!attr.ngRequired) {
	        // force truthy in case we are on non input element
	        // (input elements do this automatically for boolean attributes like required)
	        attr.required = true;
	      }
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !value || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function(newVal) {
	
	        if (value !== newVal) {
	          value = newVal;
	          ctrl.$validate();
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    compile: function(tElm, tAttr) {
	      var patternExp;
	      var parseFn;
	
	      if (tAttr.ngPattern) {
	        patternExp = tAttr.ngPattern;
	
	        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
	        // We get value of the attribute here, so we can compare the old and the new value
	        // in the observer to avoid unnecessary validations
	        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
	          parseFn = function() { return tAttr.ngPattern; };
	        } else {
	          parseFn = $parse(tAttr.ngPattern);
	        }
	      }
	
	      return function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var attrVal = attr.pattern;
	
	        if (attr.ngPattern) {
	          attrVal = parseFn(scope);
	        } else {
	          patternExp = attr.pattern;
	        }
	
	        var regexp = parsePatternAttr(attrVal, patternExp, elm);
	
	        attr.$observe('pattern', function(newVal) {
	          var oldRegexp = regexp;
	
	          regexp = parsePatternAttr(newVal, patternExp, elm);
	
	          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
	            ctrl.$validate();
	          }
	        });
	
	        ctrl.$validators.pattern = function(modelValue, viewValue) {
	          // HTML5 pattern constraint validates the input value, so we validate the viewValue
	          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	        };
	      };
	    }
	
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
	      var maxlengthParsed = parseLength(maxlength);
	
	      attr.$observe('maxlength', function(value) {
	        if (maxlength !== value) {
	          maxlengthParsed = parseLength(value);
	          maxlength = value;
	          ctrl.$validate();
	        }
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
	      var minlengthParsed = parseLength(minlength) || -1;
	
	      attr.$observe('minlength', function(value) {
	        if (minlength !== value) {
	          minlengthParsed = parseLength(value) || -1;
	          minlength = value;
	          ctrl.$validate();
	        }
	
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
	      };
	    }
	  };
	}];
	
	
	function parsePatternAttr(regex, patternExp, elm) {
	  if (!regex) return undefined;
	
	  if (isString(regex)) {
	    regex = new RegExp('^' + regex + '$');
	  }
	
	  if (!regex.test) {
	    throw minErr('ngPattern')('noregexp',
	      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	      regex, startingTag(elm));
	  }
	
	  return regex;
	}
	
	function parseLength(val) {
	  var intVal = toInt(val);
	  return isNumberNaN(intVal) ? -1 : intVal;
	}
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var objectAssign = __webpack_require__(549);
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(145);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 145 */
[678, 144, 143],
/* 146 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var msg = __webpack_require__(92);
	var zstream = __webpack_require__(556);
	var zlib_deflate = __webpack_require__(551);
	var zlib_inflate = __webpack_require__(553);
	var constants = __webpack_require__(550);
	
	for (var key in constants) {
	  exports[key] = constants[key];
	}
	
	// zlib modes
	exports.NONE = 0;
	exports.DEFLATE = 1;
	exports.INFLATE = 2;
	exports.GZIP = 3;
	exports.GUNZIP = 4;
	exports.DEFLATERAW = 5;
	exports.INFLATERAW = 6;
	exports.UNZIP = 7;
	
	/**
	 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
	 */
	function Zlib(mode) {
	  if (mode < exports.DEFLATE || mode > exports.UNZIP)
	    throw new TypeError("Bad argument");
	    
	  this.mode = mode;
	  this.init_done = false;
	  this.write_in_progress = false;
	  this.pending_close = false;
	  this.windowBits = 0;
	  this.level = 0;
	  this.memLevel = 0;
	  this.strategy = 0;
	  this.dictionary = null;
	}
	
	Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
	  this.windowBits = windowBits;
	  this.level = level;
	  this.memLevel = memLevel;
	  this.strategy = strategy;
	  // dictionary not supported.
	  
	  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
	    this.windowBits += 16;
	    
	  if (this.mode === exports.UNZIP)
	    this.windowBits += 32;
	    
	  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
	    this.windowBits = -this.windowBits;
	    
	  this.strm = new zstream();
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateInit2(
	        this.strm,
	        this.level,
	        exports.Z_DEFLATED,
	        this.windowBits,
	        this.memLevel,
	        this.strategy
	      );
	      break;
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	    case exports.UNZIP:
	      var status  = zlib_inflate.inflateInit2(
	        this.strm,
	        this.windowBits
	      );
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	    return;
	  }
	  
	  this.write_in_progress = false;
	  this.init_done = true;
	};
	
	Zlib.prototype.params = function() {
	  throw new Error("deflateParams Not supported");
	};
	
	Zlib.prototype._writeCheck = function() {
	  if (!this.init_done)
	    throw new Error("write before init");
	    
	  if (this.mode === exports.NONE)
	    throw new Error("already finalized");
	    
	  if (this.write_in_progress)
	    throw new Error("write already in progress");
	    
	  if (this.pending_close)
	    throw new Error("close is pending");
	};
	
	Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
	  this._writeCheck();
	  this.write_in_progress = true;
	  
	  var self = this;
	  process.nextTick(function() {
	    self.write_in_progress = false;
	    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
	    self.callback(res[0], res[1]);
	    
	    if (self.pending_close)
	      self.close();
	  });
	  
	  return this;
	};
	
	// set method for Node buffers, used by pako
	function bufferSet(data, offset) {
	  for (var i = 0; i < data.length; i++) {
	    this[offset + i] = data[i];
	  }
	}
	
	Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this._writeCheck();
	  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
	};
	
	Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this.write_in_progress = true;
	  
	  if (flush !== exports.Z_NO_FLUSH &&
	      flush !== exports.Z_PARTIAL_FLUSH &&
	      flush !== exports.Z_SYNC_FLUSH &&
	      flush !== exports.Z_FULL_FLUSH &&
	      flush !== exports.Z_FINISH &&
	      flush !== exports.Z_BLOCK) {
	    throw new Error("Invalid flush value");
	  }
	  
	  if (input == null) {
	    input = new Buffer(0);
	    in_len = 0;
	    in_off = 0;
	  }
	  
	  if (out._set)
	    out.set = out._set;
	  else
	    out.set = bufferSet;
	  
	  var strm = this.strm;
	  strm.avail_in = in_len;
	  strm.input = input;
	  strm.next_in = in_off;
	  strm.avail_out = out_len;
	  strm.output = out;
	  strm.next_out = out_off;
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflate(strm, flush);
	      break;
	    case exports.UNZIP:
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflate(strm, flush);
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
	    this._error(status);
	  }
	  
	  this.write_in_progress = false;
	  return [strm.avail_in, strm.avail_out];
	};
	
	Zlib.prototype.close = function() {
	  if (this.write_in_progress) {
	    this.pending_close = true;
	    return;
	  }
	  
	  this.pending_close = false;
	  
	  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
	    zlib_deflate.deflateEnd(this.strm);
	  } else {
	    zlib_inflate.inflateEnd(this.strm);
	  }
	  
	  this.mode = exports.NONE;
	};
	
	Zlib.prototype.reset = function() {
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateReset(this.strm);
	      break;
	    case exports.INFLATE:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflateReset(this.strm);
	      break;
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	  }
	};
	
	Zlib.prototype._error = function(status) {
	  this.onerror(msg[status] + ': ' + this.strm.msg, status);
	  
	  this.write_in_progress = false;
	  if (this.pending_close)
	    this.close();
	};
	
	exports.Zlib = Zlib;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(12).Buffer))

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Transform = __webpack_require__(659);
	
	var binding = __webpack_require__(147);
	var util = __webpack_require__(671);
	var assert = __webpack_require__(142).ok;
	
	// zlib doesn't provide these, so kludge them in following the same
	// const naming scheme zlib uses.
	binding.Z_MIN_WINDOWBITS = 8;
	binding.Z_MAX_WINDOWBITS = 15;
	binding.Z_DEFAULT_WINDOWBITS = 15;
	
	// fewer than 64 bytes per chunk is stupid.
	// technically it could work with as few as 8, but even 64 bytes
	// is absurdly low.  Usually a MB or more is best.
	binding.Z_MIN_CHUNK = 64;
	binding.Z_MAX_CHUNK = Infinity;
	binding.Z_DEFAULT_CHUNK = (16 * 1024);
	
	binding.Z_MIN_MEMLEVEL = 1;
	binding.Z_MAX_MEMLEVEL = 9;
	binding.Z_DEFAULT_MEMLEVEL = 8;
	
	binding.Z_MIN_LEVEL = -1;
	binding.Z_MAX_LEVEL = 9;
	binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
	
	// expose all the zlib constants
	Object.keys(binding).forEach(function(k) {
	  if (k.match(/^Z/)) exports[k] = binding[k];
	});
	
	// translation table for return codes.
	exports.codes = {
	  Z_OK: binding.Z_OK,
	  Z_STREAM_END: binding.Z_STREAM_END,
	  Z_NEED_DICT: binding.Z_NEED_DICT,
	  Z_ERRNO: binding.Z_ERRNO,
	  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
	  Z_DATA_ERROR: binding.Z_DATA_ERROR,
	  Z_MEM_ERROR: binding.Z_MEM_ERROR,
	  Z_BUF_ERROR: binding.Z_BUF_ERROR,
	  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
	};
	
	Object.keys(exports.codes).forEach(function(k) {
	  exports.codes[exports.codes[k]] = k;
	});
	
	exports.Deflate = Deflate;
	exports.Inflate = Inflate;
	exports.Gzip = Gzip;
	exports.Gunzip = Gunzip;
	exports.DeflateRaw = DeflateRaw;
	exports.InflateRaw = InflateRaw;
	exports.Unzip = Unzip;
	
	exports.createDeflate = function(o) {
	  return new Deflate(o);
	};
	
	exports.createInflate = function(o) {
	  return new Inflate(o);
	};
	
	exports.createDeflateRaw = function(o) {
	  return new DeflateRaw(o);
	};
	
	exports.createInflateRaw = function(o) {
	  return new InflateRaw(o);
	};
	
	exports.createGzip = function(o) {
	  return new Gzip(o);
	};
	
	exports.createGunzip = function(o) {
	  return new Gunzip(o);
	};
	
	exports.createUnzip = function(o) {
	  return new Unzip(o);
	};
	
	
	// Convenience methods.
	// compress/decompress a string or buffer in one step.
	exports.deflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Deflate(opts), buffer, callback);
	};
	
	exports.deflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Deflate(opts), buffer);
	};
	
	exports.gzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gzip(opts), buffer, callback);
	};
	
	exports.gzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gzip(opts), buffer);
	};
	
	exports.deflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
	};
	
	exports.deflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new DeflateRaw(opts), buffer);
	};
	
	exports.unzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Unzip(opts), buffer, callback);
	};
	
	exports.unzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Unzip(opts), buffer);
	};
	
	exports.inflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Inflate(opts), buffer, callback);
	};
	
	exports.inflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Inflate(opts), buffer);
	};
	
	exports.gunzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gunzip(opts), buffer, callback);
	};
	
	exports.gunzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gunzip(opts), buffer);
	};
	
	exports.inflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new InflateRaw(opts), buffer, callback);
	};
	
	exports.inflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new InflateRaw(opts), buffer);
	};
	
	function zlibBuffer(engine, buffer, callback) {
	  var buffers = [];
	  var nread = 0;
	
	  engine.on('error', onError);
	  engine.on('end', onEnd);
	
	  engine.end(buffer);
	  flow();
	
	  function flow() {
	    var chunk;
	    while (null !== (chunk = engine.read())) {
	      buffers.push(chunk);
	      nread += chunk.length;
	    }
	    engine.once('readable', flow);
	  }
	
	  function onError(err) {
	    engine.removeListener('end', onEnd);
	    engine.removeListener('readable', flow);
	    callback(err);
	  }
	
	  function onEnd() {
	    var buf = Buffer.concat(buffers, nread);
	    buffers = [];
	    callback(null, buf);
	    engine.close();
	  }
	}
	
	function zlibBufferSync(engine, buffer) {
	  if (typeof buffer === 'string')
	    buffer = new Buffer(buffer);
	  if (!Buffer.isBuffer(buffer))
	    throw new TypeError('Not a string or buffer');
	
	  var flushFlag = binding.Z_FINISH;
	
	  return engine._processChunk(buffer, flushFlag);
	}
	
	// generic zlib
	// minimal 2-byte header
	function Deflate(opts) {
	  if (!(this instanceof Deflate)) return new Deflate(opts);
	  Zlib.call(this, opts, binding.DEFLATE);
	}
	
	function Inflate(opts) {
	  if (!(this instanceof Inflate)) return new Inflate(opts);
	  Zlib.call(this, opts, binding.INFLATE);
	}
	
	
	
	// gzip - bigger header, same deflate compression
	function Gzip(opts) {
	  if (!(this instanceof Gzip)) return new Gzip(opts);
	  Zlib.call(this, opts, binding.GZIP);
	}
	
	function Gunzip(opts) {
	  if (!(this instanceof Gunzip)) return new Gunzip(opts);
	  Zlib.call(this, opts, binding.GUNZIP);
	}
	
	
	
	// raw - no header
	function DeflateRaw(opts) {
	  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
	  Zlib.call(this, opts, binding.DEFLATERAW);
	}
	
	function InflateRaw(opts) {
	  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
	  Zlib.call(this, opts, binding.INFLATERAW);
	}
	
	
	// auto-detect header.
	function Unzip(opts) {
	  if (!(this instanceof Unzip)) return new Unzip(opts);
	  Zlib.call(this, opts, binding.UNZIP);
	}
	
	
	// the Zlib class they all inherit from
	// This thing manages the queue of requests, and returns
	// true or false if there is anything in the queue when
	// you call the .write() method.
	
	function Zlib(opts, mode) {
	  this._opts = opts = opts || {};
	  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
	
	  Transform.call(this, opts);
	
	  if (opts.flush) {
	    if (opts.flush !== binding.Z_NO_FLUSH &&
	        opts.flush !== binding.Z_PARTIAL_FLUSH &&
	        opts.flush !== binding.Z_SYNC_FLUSH &&
	        opts.flush !== binding.Z_FULL_FLUSH &&
	        opts.flush !== binding.Z_FINISH &&
	        opts.flush !== binding.Z_BLOCK) {
	      throw new Error('Invalid flush flag: ' + opts.flush);
	    }
	  }
	  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
	
	  if (opts.chunkSize) {
	    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
	        opts.chunkSize > exports.Z_MAX_CHUNK) {
	      throw new Error('Invalid chunk size: ' + opts.chunkSize);
	    }
	  }
	
	  if (opts.windowBits) {
	    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
	        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
	      throw new Error('Invalid windowBits: ' + opts.windowBits);
	    }
	  }
	
	  if (opts.level) {
	    if (opts.level < exports.Z_MIN_LEVEL ||
	        opts.level > exports.Z_MAX_LEVEL) {
	      throw new Error('Invalid compression level: ' + opts.level);
	    }
	  }
	
	  if (opts.memLevel) {
	    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
	        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
	      throw new Error('Invalid memLevel: ' + opts.memLevel);
	    }
	  }
	
	  if (opts.strategy) {
	    if (opts.strategy != exports.Z_FILTERED &&
	        opts.strategy != exports.Z_HUFFMAN_ONLY &&
	        opts.strategy != exports.Z_RLE &&
	        opts.strategy != exports.Z_FIXED &&
	        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
	      throw new Error('Invalid strategy: ' + opts.strategy);
	    }
	  }
	
	  if (opts.dictionary) {
	    if (!Buffer.isBuffer(opts.dictionary)) {
	      throw new Error('Invalid dictionary: it should be a Buffer instance');
	    }
	  }
	
	  this._binding = new binding.Zlib(mode);
	
	  var self = this;
	  this._hadError = false;
	  this._binding.onerror = function(message, errno) {
	    // there is no way to cleanly recover.
	    // continuing only obscures problems.
	    self._binding = null;
	    self._hadError = true;
	
	    var error = new Error(message);
	    error.errno = errno;
	    error.code = exports.codes[errno];
	    self.emit('error', error);
	  };
	
	  var level = exports.Z_DEFAULT_COMPRESSION;
	  if (typeof opts.level === 'number') level = opts.level;
	
	  var strategy = exports.Z_DEFAULT_STRATEGY;
	  if (typeof opts.strategy === 'number') strategy = opts.strategy;
	
	  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
	                     level,
	                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
	                     strategy,
	                     opts.dictionary);
	
	  this._buffer = new Buffer(this._chunkSize);
	  this._offset = 0;
	  this._closed = false;
	  this._level = level;
	  this._strategy = strategy;
	
	  this.once('end', this.close);
	}
	
	util.inherits(Zlib, Transform);
	
	Zlib.prototype.params = function(level, strategy, callback) {
	  if (level < exports.Z_MIN_LEVEL ||
	      level > exports.Z_MAX_LEVEL) {
	    throw new RangeError('Invalid compression level: ' + level);
	  }
	  if (strategy != exports.Z_FILTERED &&
	      strategy != exports.Z_HUFFMAN_ONLY &&
	      strategy != exports.Z_RLE &&
	      strategy != exports.Z_FIXED &&
	      strategy != exports.Z_DEFAULT_STRATEGY) {
	    throw new TypeError('Invalid strategy: ' + strategy);
	  }
	
	  if (this._level !== level || this._strategy !== strategy) {
	    var self = this;
	    this.flush(binding.Z_SYNC_FLUSH, function() {
	      self._binding.params(level, strategy);
	      if (!self._hadError) {
	        self._level = level;
	        self._strategy = strategy;
	        if (callback) callback();
	      }
	    });
	  } else {
	    process.nextTick(callback);
	  }
	};
	
	Zlib.prototype.reset = function() {
	  return this._binding.reset();
	};
	
	// This is the _flush function called by the transform class,
	// internally, when the last chunk has been written.
	Zlib.prototype._flush = function(callback) {
	  this._transform(new Buffer(0), '', callback);
	};
	
	Zlib.prototype.flush = function(kind, callback) {
	  var ws = this._writableState;
	
	  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
	    callback = kind;
	    kind = binding.Z_FULL_FLUSH;
	  }
	
	  if (ws.ended) {
	    if (callback)
	      process.nextTick(callback);
	  } else if (ws.ending) {
	    if (callback)
	      this.once('end', callback);
	  } else if (ws.needDrain) {
	    var self = this;
	    this.once('drain', function() {
	      self.flush(callback);
	    });
	  } else {
	    this._flushFlag = kind;
	    this.write(new Buffer(0), '', callback);
	  }
	};
	
	Zlib.prototype.close = function(callback) {
	  if (callback)
	    process.nextTick(callback);
	
	  if (this._closed)
	    return;
	
	  this._closed = true;
	
	  this._binding.close();
	
	  var self = this;
	  process.nextTick(function() {
	    self.emit('close');
	  });
	};
	
	Zlib.prototype._transform = function(chunk, encoding, cb) {
	  var flushFlag;
	  var ws = this._writableState;
	  var ending = ws.ending || ws.ended;
	  var last = ending && (!chunk || ws.length === chunk.length);
	
	  if (!chunk === null && !Buffer.isBuffer(chunk))
	    return cb(new Error('invalid input'));
	
	  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
	  // If it's explicitly flushing at some other time, then we use
	  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
	  // goodness.
	  if (last)
	    flushFlag = binding.Z_FINISH;
	  else {
	    flushFlag = this._flushFlag;
	    // once we've flushed the last of the queue, stop flushing and
	    // go back to the normal behavior.
	    if (chunk.length >= ws.length) {
	      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
	    }
	  }
	
	  var self = this;
	  this._processChunk(chunk, flushFlag, cb);
	};
	
	Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
	  var availInBefore = chunk && chunk.length;
	  var availOutBefore = this._chunkSize - this._offset;
	  var inOff = 0;
	
	  var self = this;
	
	  var async = typeof cb === 'function';
	
	  if (!async) {
	    var buffers = [];
	    var nread = 0;
	
	    var error;
	    this.on('error', function(er) {
	      error = er;
	    });
	
	    do {
	      var res = this._binding.writeSync(flushFlag,
	                                        chunk, // in
	                                        inOff, // in_off
	                                        availInBefore, // in_len
	                                        this._buffer, // out
	                                        this._offset, //out_off
	                                        availOutBefore); // out_len
	    } while (!this._hadError && callback(res[0], res[1]));
	
	    if (this._hadError) {
	      throw error;
	    }
	
	    var buf = Buffer.concat(buffers, nread);
	    this.close();
	
	    return buf;
	  }
	
	  var req = this._binding.write(flushFlag,
	                                chunk, // in
	                                inOff, // in_off
	                                availInBefore, // in_len
	                                this._buffer, // out
	                                this._offset, //out_off
	                                availOutBefore); // out_len
	
	  req.buffer = chunk;
	  req.callback = callback;
	
	  function callback(availInAfter, availOutAfter) {
	    if (self._hadError)
	      return;
	
	    var have = availOutBefore - availOutAfter;
	    assert(have >= 0, 'have should not go down');
	
	    if (have > 0) {
	      var out = self._buffer.slice(self._offset, self._offset + have);
	      self._offset += have;
	      // serve some output to the consumer.
	      if (async) {
	        self.push(out);
	      } else {
	        buffers.push(out);
	        nread += out.length;
	      }
	    }
	
	    // exhausted the output buffer, or used all the input create a new one.
	    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
	      availOutBefore = self._chunkSize;
	      self._offset = 0;
	      self._buffer = new Buffer(self._chunkSize);
	    }
	
	    if (availOutAfter === 0) {
	      // Not actually done.  Need to reprocess.
	      // Also, update the availInBefore to the availInAfter value,
	      // so that if we have to hit it a third (fourth, etc.) time,
	      // it'll have the correct byte counts.
	      inOff += (availInBefore - availInAfter);
	      availInBefore = availInAfter;
	
	      if (!async)
	        return true;
	
	      var newReq = self._binding.write(flushFlag,
	                                       chunk,
	                                       inOff,
	                                       availInBefore,
	                                       self._buffer,
	                                       self._offset,
	                                       self._chunkSize);
	      newReq.callback = callback; // this same function
	      newReq.buffer = chunk;
	      return;
	    }
	
	    if (!async)
	      return false;
	
	    // finished with the chunk.
	    cb();
	  }
	};
	
	util.inherits(Deflate, Zlib);
	util.inherits(Inflate, Zlib);
	util.inherits(Gzip, Zlib);
	util.inherits(Gunzip, Zlib);
	util.inherits(DeflateRaw, Zlib);
	util.inherits(InflateRaw, Zlib);
	util.inherits(Unzip, Zlib);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12).Buffer, __webpack_require__(7)))

/***/ }),
/* 149 */
26,
/* 150 */
26,
/* 151 */
26,
/* 152 */
26,
/* 153 */
26,
/* 154 */
26,
/* 155 */
26,
/* 156 */
26,
/* 157 */
26,
/* 158 */
26,
/* 159 */
26,
/* 160 */
26,
/* 161 */
26,
/* 162 */
26,
/* 163 */
26,
/* 164 */
26,
/* 165 */
26,
/* 166 */
26,
/* 167 */
26,
/* 168 */
26,
/* 169 */
26,
/* 170 */
26,
/* 171 */
26,
/* 172 */
26,
/* 173 */
26,
/* 174 */
26,
/* 175 */
26,
/* 176 */
26,
/* 177 */
26,
/* 178 */
26,
/* 179 */
26,
/* 180 */
26,
/* 181 */
26,
/* 182 */
26,
/* 183 */
26,
/* 184 */
26,
/* 185 */
26,
/* 186 */
26,
/* 187 */
26,
/* 188 */
26,
/* 189 */
26,
/* 190 */
26,
/* 191 */
26,
/* 192 */
26,
/* 193 */
26,
/* 194 */
26,
/* 195 */
26,
/* 196 */
26,
/* 197 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	module.exports = {"server":"https://certificacion.probolivia.gob.bo/ws","timeSessionExpired":30,"debug":false,"onbeforeunload":false,"port":443,"subDomain":"/","portDev":443}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = {"name":"mindesarrollo-probolivia-frontend","version":"3.0.7","description":"SIDCUP","main":"server.js","scripts":{"build":"webpack --colors --display-error-details --progress","start":"webpack-dev-server --history-api-fallback --inline --progress --colors","server":"node server","check-node-version":"node ./node_modules/.bin/check-node-version","postinstall":"npm run check-node-version","prestart":"npm run check-node-version","prebuild":"npm run check-node-version","pretest":"npm run check-node-version","test":"jest"},"keywords":["Frontend"],"jest":{"verbose":true,"moduleDirectories":["node_modules","app"],"testMatch":["**/tests/**/*.test.+(ts|js)"]},"author":"team5@agetic.gob.bo","license":"MIT","devDependencies":{"angular-mocks":"^1.8.2","babel-cli":"^6.22.2","babel-loader":"^6.2.10","babel-preset-es2015":"^6.22.0","babel-preset-stage-2":"^6.22.0","copy-webpack-plugin":"^4.0.1","css-loader":"^0.26.1","css-mqpacker":"^5.0.1","eslint":"^3.14.1","eslint-config-angular":"^0.5.0","eslint-loader":"^1.6.1","eslint-plugin-angular":"^1.6.1","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.9.0","font-awesome":"^4.7.0","html-loader":"^0.4.4","html-webpack-plugin":"^2.28.0","jest":"^26.6.3","json-loader":"^0.5.4","ng-annotate-loader":"^0.2.0","ng-annotate-webpack-plugin":"^0.2.1-pre","nginject-loader":"^2.1.0","node-sass":"^4.0.0","postcss-discard-comments":"^2.0.4","postcss-flexbugs-fixes":"^2.1.0","postcss-functions":"^2.1.1","postcss-hexrgba":"^0.2.1","postcss-loader":"^1.2.2","postcss-nested":"^1.0.0","postcss-size":"^1.1.1","postcss-strip-inline-comments":"^0.1.5","precss":"^1.4.0","raw-loader":"^0.5.1","sass-loader":"^4.1.1","style-loader":"^0.13.1","url-loader":"^0.5.7","webpack":"^1.14.0","webpack-dev-server":"^1.16.2"},"dependencies":{"@elartedelcodigo/check-node-version":"^1.1.2","angular":"^1.8.2","angular-file-upload":"^2.5.0","angular-formly":"^8.4.1","angular-formly-templates-bootstrap":"6.4.0","angular-leaflet-directive":"^0.10.0","angular-loading-bar":"^0.9.0","angular-messages":"^1.6.4","angular-resource":"^1.6.2","angular-sanitize":"^1.6.2","angular-toastr":"^2.1.1","angular-translate":"^2.14.0","angular-ui-router":"^1.0.0-rc.1","angular-ui-validate":"^1.2.3","api-check":"^7.5.5","bootstrap":"4.6.1","compression":"^1.6.2","connect-gzip-static":"^2.0.0","cors":"^2.8.1","express":"^4.14.1","ng-device-detector":"^4.0.3","pdfjs-dist":"^1.10.81","pdfjs-dist-for-node":"^1.0.892-rc.1","satellizer":"^0.15.5","ui-select":"^0.19.6"},"engines":{"node":"10.x","npm":"6.x"}}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Leaflet, a JavaScript library for mobile-friendly interactive maps. http://leafletjs.com
	 (c) 2010-2013, Vladimir Agafonkin
	 (c) 2010-2011, CloudMade
	*/
	!function(t,e,i){var n=t.L,o={};o.version="0.7.7","object"==typeof module&&"object"==typeof module.exports?module.exports=o:"function"=="function"&&__webpack_require__(672)&&!(__WEBPACK_AMD_DEFINE_FACTORY__ = (o), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)),o.noConflict=function(){return t.L=n,this},t.L=o,o.Util={extend:function(t){var e,i,n,o,s=Array.prototype.slice.call(arguments,1);for(i=0,n=s.length;n>i;i++){o=s[i]||{};for(e in o)o.hasOwnProperty(e)&&(t[e]=o[e])}return t},bind:function(t,e){var i=arguments.length>2?Array.prototype.slice.call(arguments,2):null;return function(){return t.apply(e,i||arguments)}},stamp:function(){var t=0,e="_leaflet_id";return function(i){return i[e]=i[e]||++t,i[e]}}(),invokeEach:function(t,e,i){var n,o;if("object"==typeof t){o=Array.prototype.slice.call(arguments,3);for(n in t)e.apply(i,[n,t[n]].concat(o));return!0}return!1},limitExecByInterval:function(t,e,i){var n,o;return function s(){var a=arguments;return n?void(o=!0):(n=!0,setTimeout(function(){n=!1,o&&(s.apply(i,a),o=!1)},e),void t.apply(i,a))}},falseFn:function(){return!1},formatNum:function(t,e){var i=Math.pow(10,e||5);return Math.round(t*i)/i},trim:function(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")},splitWords:function(t){return o.Util.trim(t).split(/\s+/)},setOptions:function(t,e){return t.options=o.extend({},t.options,e),t.options},getParamString:function(t,e,i){var n=[];for(var o in t)n.push(encodeURIComponent(i?o.toUpperCase():o)+"="+encodeURIComponent(t[o]));return(e&&-1!==e.indexOf("?")?"&":"?")+n.join("&")},template:function(t,e){return t.replace(/\{ *([\w_]+) *\}/g,function(t,n){var o=e[n];if(o===i)throw new Error("No value provided for variable "+t);return"function"==typeof o&&(o=o(e)),o})},isArray:Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},emptyImageUrl:"data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="},function(){function e(e){var i,n,o=["webkit","moz","o","ms"];for(i=0;i<o.length&&!n;i++)n=t[o[i]+e];return n}function i(e){var i=+new Date,o=Math.max(0,16-(i-n));return n=i+o,t.setTimeout(e,o)}var n=0,s=t.requestAnimationFrame||e("RequestAnimationFrame")||i,a=t.cancelAnimationFrame||e("CancelAnimationFrame")||e("CancelRequestAnimationFrame")||function(e){t.clearTimeout(e)};o.Util.requestAnimFrame=function(e,n,a,r){return e=o.bind(e,n),a&&s===i?void e():s.call(t,e,r)},o.Util.cancelAnimFrame=function(e){e&&a.call(t,e)}}(),o.extend=o.Util.extend,o.bind=o.Util.bind,o.stamp=o.Util.stamp,o.setOptions=o.Util.setOptions,o.Class=function(){},o.Class.extend=function(t){var e=function(){this.initialize&&this.initialize.apply(this,arguments),this._initHooks&&this.callInitHooks()},i=function(){};i.prototype=this.prototype;var n=new i;n.constructor=e,e.prototype=n;for(var s in this)this.hasOwnProperty(s)&&"prototype"!==s&&(e[s]=this[s]);t.statics&&(o.extend(e,t.statics),delete t.statics),t.includes&&(o.Util.extend.apply(null,[n].concat(t.includes)),delete t.includes),t.options&&n.options&&(t.options=o.extend({},n.options,t.options)),o.extend(n,t),n._initHooks=[];var a=this;return e.__super__=a.prototype,n.callInitHooks=function(){if(!this._initHooksCalled){a.prototype.callInitHooks&&a.prototype.callInitHooks.call(this),this._initHooksCalled=!0;for(var t=0,e=n._initHooks.length;e>t;t++)n._initHooks[t].call(this)}},e},o.Class.include=function(t){o.extend(this.prototype,t)},o.Class.mergeOptions=function(t){o.extend(this.prototype.options,t)},o.Class.addInitHook=function(t){var e=Array.prototype.slice.call(arguments,1),i="function"==typeof t?t:function(){this[t].apply(this,e)};this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(i)};var s="_leaflet_events";o.Mixin={},o.Mixin.Events={addEventListener:function(t,e,i){if(o.Util.invokeEach(t,this.addEventListener,this,e,i))return this;var n,a,r,h,l,u,c,d=this[s]=this[s]||{},p=i&&i!==this&&o.stamp(i);for(t=o.Util.splitWords(t),n=0,a=t.length;a>n;n++)r={action:e,context:i||this},h=t[n],p?(l=h+"_idx",u=l+"_len",c=d[l]=d[l]||{},c[p]||(c[p]=[],d[u]=(d[u]||0)+1),c[p].push(r)):(d[h]=d[h]||[],d[h].push(r));return this},hasEventListeners:function(t){var e=this[s];return!!e&&(t in e&&e[t].length>0||t+"_idx"in e&&e[t+"_idx_len"]>0)},removeEventListener:function(t,e,i){if(!this[s])return this;if(!t)return this.clearAllEventListeners();if(o.Util.invokeEach(t,this.removeEventListener,this,e,i))return this;var n,a,r,h,l,u,c,d,p,_=this[s],m=i&&i!==this&&o.stamp(i);for(t=o.Util.splitWords(t),n=0,a=t.length;a>n;n++)if(r=t[n],u=r+"_idx",c=u+"_len",d=_[u],e){if(h=m&&d?d[m]:_[r]){for(l=h.length-1;l>=0;l--)h[l].action!==e||i&&h[l].context!==i||(p=h.splice(l,1),p[0].action=o.Util.falseFn);i&&d&&0===h.length&&(delete d[m],_[c]--)}}else delete _[r],delete _[u],delete _[c];return this},clearAllEventListeners:function(){return delete this[s],this},fireEvent:function(t,e){if(!this.hasEventListeners(t))return this;var i,n,a,r,h,l=o.Util.extend({},e,{type:t,target:this}),u=this[s];if(u[t])for(i=u[t].slice(),n=0,a=i.length;a>n;n++)i[n].action.call(i[n].context,l);r=u[t+"_idx"];for(h in r)if(i=r[h].slice())for(n=0,a=i.length;a>n;n++)i[n].action.call(i[n].context,l);return this},addOneTimeEventListener:function(t,e,i){if(o.Util.invokeEach(t,this.addOneTimeEventListener,this,e,i))return this;var n=o.bind(function(){this.removeEventListener(t,e,i).removeEventListener(t,n,i)},this);return this.addEventListener(t,e,i).addEventListener(t,n,i)}},o.Mixin.Events.on=o.Mixin.Events.addEventListener,o.Mixin.Events.off=o.Mixin.Events.removeEventListener,o.Mixin.Events.once=o.Mixin.Events.addOneTimeEventListener,o.Mixin.Events.fire=o.Mixin.Events.fireEvent,function(){var n="ActiveXObject"in t,s=n&&!e.addEventListener,a=navigator.userAgent.toLowerCase(),r=-1!==a.indexOf("webkit"),h=-1!==a.indexOf("chrome"),l=-1!==a.indexOf("phantom"),u=-1!==a.indexOf("android"),c=-1!==a.search("android [23]"),d=-1!==a.indexOf("gecko"),p=typeof orientation!=i+"",_=!t.PointerEvent&&t.MSPointerEvent,m=t.PointerEvent&&t.navigator.pointerEnabled||_,f="devicePixelRatio"in t&&t.devicePixelRatio>1||"matchMedia"in t&&t.matchMedia("(min-resolution:144dpi)")&&t.matchMedia("(min-resolution:144dpi)").matches,g=e.documentElement,v=n&&"transition"in g.style,y="WebKitCSSMatrix"in t&&"m11"in new t.WebKitCSSMatrix&&!c,P="MozPerspective"in g.style,L="OTransition"in g.style,x=!t.L_DISABLE_3D&&(v||y||P||L)&&!l,w=!t.L_NO_TOUCH&&!l&&(m||"ontouchstart"in t||t.DocumentTouch&&e instanceof t.DocumentTouch);o.Browser={ie:n,ielt9:s,webkit:r,gecko:d&&!r&&!t.opera&&!n,android:u,android23:c,chrome:h,ie3d:v,webkit3d:y,gecko3d:P,opera3d:L,any3d:x,mobile:p,mobileWebkit:p&&r,mobileWebkit3d:p&&y,mobileOpera:p&&t.opera,touch:w,msPointer:_,pointer:m,retina:f}}(),o.Point=function(t,e,i){this.x=i?Math.round(t):t,this.y=i?Math.round(e):e},o.Point.prototype={clone:function(){return new o.Point(this.x,this.y)},add:function(t){return this.clone()._add(o.point(t))},_add:function(t){return this.x+=t.x,this.y+=t.y,this},subtract:function(t){return this.clone()._subtract(o.point(t))},_subtract:function(t){return this.x-=t.x,this.y-=t.y,this},divideBy:function(t){return this.clone()._divideBy(t)},_divideBy:function(t){return this.x/=t,this.y/=t,this},multiplyBy:function(t){return this.clone()._multiplyBy(t)},_multiplyBy:function(t){return this.x*=t,this.y*=t,this},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},distanceTo:function(t){t=o.point(t);var e=t.x-this.x,i=t.y-this.y;return Math.sqrt(e*e+i*i)},equals:function(t){return t=o.point(t),t.x===this.x&&t.y===this.y},contains:function(t){return t=o.point(t),Math.abs(t.x)<=Math.abs(this.x)&&Math.abs(t.y)<=Math.abs(this.y)},toString:function(){return"Point("+o.Util.formatNum(this.x)+", "+o.Util.formatNum(this.y)+")"}},o.point=function(t,e,n){return t instanceof o.Point?t:o.Util.isArray(t)?new o.Point(t[0],t[1]):t===i||null===t?t:new o.Point(t,e,n)},o.Bounds=function(t,e){if(t)for(var i=e?[t,e]:t,n=0,o=i.length;o>n;n++)this.extend(i[n])},o.Bounds.prototype={extend:function(t){return t=o.point(t),this.min||this.max?(this.min.x=Math.min(t.x,this.min.x),this.max.x=Math.max(t.x,this.max.x),this.min.y=Math.min(t.y,this.min.y),this.max.y=Math.max(t.y,this.max.y)):(this.min=t.clone(),this.max=t.clone()),this},getCenter:function(t){return new o.Point((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,t)},getBottomLeft:function(){return new o.Point(this.min.x,this.max.y)},getTopRight:function(){return new o.Point(this.max.x,this.min.y)},getSize:function(){return this.max.subtract(this.min)},contains:function(t){var e,i;return t="number"==typeof t[0]||t instanceof o.Point?o.point(t):o.bounds(t),t instanceof o.Bounds?(e=t.min,i=t.max):e=i=t,e.x>=this.min.x&&i.x<=this.max.x&&e.y>=this.min.y&&i.y<=this.max.y},intersects:function(t){t=o.bounds(t);var e=this.min,i=this.max,n=t.min,s=t.max,a=s.x>=e.x&&n.x<=i.x,r=s.y>=e.y&&n.y<=i.y;return a&&r},isValid:function(){return!(!this.min||!this.max)}},o.bounds=function(t,e){return!t||t instanceof o.Bounds?t:new o.Bounds(t,e)},o.Transformation=function(t,e,i,n){this._a=t,this._b=e,this._c=i,this._d=n},o.Transformation.prototype={transform:function(t,e){return this._transform(t.clone(),e)},_transform:function(t,e){return e=e||1,t.x=e*(this._a*t.x+this._b),t.y=e*(this._c*t.y+this._d),t},untransform:function(t,e){return e=e||1,new o.Point((t.x/e-this._b)/this._a,(t.y/e-this._d)/this._c)}},o.DomUtil={get:function(t){return"string"==typeof t?e.getElementById(t):t},getStyle:function(t,i){var n=t.style[i];if(!n&&t.currentStyle&&(n=t.currentStyle[i]),(!n||"auto"===n)&&e.defaultView){var o=e.defaultView.getComputedStyle(t,null);n=o?o[i]:null}return"auto"===n?null:n},getViewportOffset:function(t){var i,n=0,s=0,a=t,r=e.body,h=e.documentElement;do{if(n+=a.offsetTop||0,s+=a.offsetLeft||0,n+=parseInt(o.DomUtil.getStyle(a,"borderTopWidth"),10)||0,s+=parseInt(o.DomUtil.getStyle(a,"borderLeftWidth"),10)||0,i=o.DomUtil.getStyle(a,"position"),a.offsetParent===r&&"absolute"===i)break;if("fixed"===i){n+=r.scrollTop||h.scrollTop||0,s+=r.scrollLeft||h.scrollLeft||0;break}if("relative"===i&&!a.offsetLeft){var l=o.DomUtil.getStyle(a,"width"),u=o.DomUtil.getStyle(a,"max-width"),c=a.getBoundingClientRect();("none"!==l||"none"!==u)&&(s+=c.left+a.clientLeft),n+=c.top+(r.scrollTop||h.scrollTop||0);break}a=a.offsetParent}while(a);a=t;do{if(a===r)break;n-=a.scrollTop||0,s-=a.scrollLeft||0,a=a.parentNode}while(a);return new o.Point(s,n)},documentIsLtr:function(){return o.DomUtil._docIsLtrCached||(o.DomUtil._docIsLtrCached=!0,o.DomUtil._docIsLtr="ltr"===o.DomUtil.getStyle(e.body,"direction")),o.DomUtil._docIsLtr},create:function(t,i,n){var o=e.createElement(t);return o.className=i,n&&n.appendChild(o),o},hasClass:function(t,e){if(t.classList!==i)return t.classList.contains(e);var n=o.DomUtil._getClass(t);return n.length>0&&new RegExp("(^|\\s)"+e+"(\\s|$)").test(n)},addClass:function(t,e){if(t.classList!==i)for(var n=o.Util.splitWords(e),s=0,a=n.length;a>s;s++)t.classList.add(n[s]);else if(!o.DomUtil.hasClass(t,e)){var r=o.DomUtil._getClass(t);o.DomUtil._setClass(t,(r?r+" ":"")+e)}},removeClass:function(t,e){t.classList!==i?t.classList.remove(e):o.DomUtil._setClass(t,o.Util.trim((" "+o.DomUtil._getClass(t)+" ").replace(" "+e+" "," ")))},_setClass:function(t,e){t.className.baseVal===i?t.className=e:t.className.baseVal=e},_getClass:function(t){return t.className.baseVal===i?t.className:t.className.baseVal},setOpacity:function(t,e){if("opacity"in t.style)t.style.opacity=e;else if("filter"in t.style){var i=!1,n="DXImageTransform.Microsoft.Alpha";try{i=t.filters.item(n)}catch(o){if(1===e)return}e=Math.round(100*e),i?(i.Enabled=100!==e,i.Opacity=e):t.style.filter+=" progid:"+n+"(opacity="+e+")"}},testProp:function(t){for(var i=e.documentElement.style,n=0;n<t.length;n++)if(t[n]in i)return t[n];return!1},getTranslateString:function(t){var e=o.Browser.webkit3d,i="translate"+(e?"3d":"")+"(",n=(e?",0":"")+")";return i+t.x+"px,"+t.y+"px"+n},getScaleString:function(t,e){var i=o.DomUtil.getTranslateString(e.add(e.multiplyBy(-1*t))),n=" scale("+t+") ";return i+n},setPosition:function(t,e,i){t._leaflet_pos=e,!i&&o.Browser.any3d?t.style[o.DomUtil.TRANSFORM]=o.DomUtil.getTranslateString(e):(t.style.left=e.x+"px",t.style.top=e.y+"px")},getPosition:function(t){return t._leaflet_pos}},o.DomUtil.TRANSFORM=o.DomUtil.testProp(["transform","WebkitTransform","OTransform","MozTransform","msTransform"]),o.DomUtil.TRANSITION=o.DomUtil.testProp(["webkitTransition","transition","OTransition","MozTransition","msTransition"]),o.DomUtil.TRANSITION_END="webkitTransition"===o.DomUtil.TRANSITION||"OTransition"===o.DomUtil.TRANSITION?o.DomUtil.TRANSITION+"End":"transitionend",function(){if("onselectstart"in e)o.extend(o.DomUtil,{disableTextSelection:function(){o.DomEvent.on(t,"selectstart",o.DomEvent.preventDefault)},enableTextSelection:function(){o.DomEvent.off(t,"selectstart",o.DomEvent.preventDefault)}});else{var i=o.DomUtil.testProp(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]);o.extend(o.DomUtil,{disableTextSelection:function(){if(i){var t=e.documentElement.style;this._userSelect=t[i],t[i]="none"}},enableTextSelection:function(){i&&(e.documentElement.style[i]=this._userSelect,delete this._userSelect)}})}o.extend(o.DomUtil,{disableImageDrag:function(){o.DomEvent.on(t,"dragstart",o.DomEvent.preventDefault)},enableImageDrag:function(){o.DomEvent.off(t,"dragstart",o.DomEvent.preventDefault)}})}(),o.LatLng=function(t,e,n){if(t=parseFloat(t),e=parseFloat(e),isNaN(t)||isNaN(e))throw new Error("Invalid LatLng object: ("+t+", "+e+")");this.lat=t,this.lng=e,n!==i&&(this.alt=parseFloat(n))},o.extend(o.LatLng,{DEG_TO_RAD:Math.PI/180,RAD_TO_DEG:180/Math.PI,MAX_MARGIN:1e-9}),o.LatLng.prototype={equals:function(t){if(!t)return!1;t=o.latLng(t);var e=Math.max(Math.abs(this.lat-t.lat),Math.abs(this.lng-t.lng));return e<=o.LatLng.MAX_MARGIN},toString:function(t){return"LatLng("+o.Util.formatNum(this.lat,t)+", "+o.Util.formatNum(this.lng,t)+")"},distanceTo:function(t){t=o.latLng(t);var e=6378137,i=o.LatLng.DEG_TO_RAD,n=(t.lat-this.lat)*i,s=(t.lng-this.lng)*i,a=this.lat*i,r=t.lat*i,h=Math.sin(n/2),l=Math.sin(s/2),u=h*h+l*l*Math.cos(a)*Math.cos(r);return 2*e*Math.atan2(Math.sqrt(u),Math.sqrt(1-u))},wrap:function(t,e){var i=this.lng;return t=t||-180,e=e||180,i=(i+e)%(e-t)+(t>i||i===e?e:t),new o.LatLng(this.lat,i)}},o.latLng=function(t,e){return t instanceof o.LatLng?t:o.Util.isArray(t)?"number"==typeof t[0]||"string"==typeof t[0]?new o.LatLng(t[0],t[1],t[2]):null:t===i||null===t?t:"object"==typeof t&&"lat"in t?new o.LatLng(t.lat,"lng"in t?t.lng:t.lon):e===i?null:new o.LatLng(t,e)},o.LatLngBounds=function(t,e){if(t)for(var i=e?[t,e]:t,n=0,o=i.length;o>n;n++)this.extend(i[n])},o.LatLngBounds.prototype={extend:function(t){if(!t)return this;var e=o.latLng(t);return t=null!==e?e:o.latLngBounds(t),t instanceof o.LatLng?this._southWest||this._northEast?(this._southWest.lat=Math.min(t.lat,this._southWest.lat),this._southWest.lng=Math.min(t.lng,this._southWest.lng),this._northEast.lat=Math.max(t.lat,this._northEast.lat),this._northEast.lng=Math.max(t.lng,this._northEast.lng)):(this._southWest=new o.LatLng(t.lat,t.lng),this._northEast=new o.LatLng(t.lat,t.lng)):t instanceof o.LatLngBounds&&(this.extend(t._southWest),this.extend(t._northEast)),this},pad:function(t){var e=this._southWest,i=this._northEast,n=Math.abs(e.lat-i.lat)*t,s=Math.abs(e.lng-i.lng)*t;return new o.LatLngBounds(new o.LatLng(e.lat-n,e.lng-s),new o.LatLng(i.lat+n,i.lng+s))},getCenter:function(){return new o.LatLng((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new o.LatLng(this.getNorth(),this.getWest())},getSouthEast:function(){return new o.LatLng(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(t){t="number"==typeof t[0]||t instanceof o.LatLng?o.latLng(t):o.latLngBounds(t);var e,i,n=this._southWest,s=this._northEast;return t instanceof o.LatLngBounds?(e=t.getSouthWest(),i=t.getNorthEast()):e=i=t,e.lat>=n.lat&&i.lat<=s.lat&&e.lng>=n.lng&&i.lng<=s.lng},intersects:function(t){t=o.latLngBounds(t);var e=this._southWest,i=this._northEast,n=t.getSouthWest(),s=t.getNorthEast(),a=s.lat>=e.lat&&n.lat<=i.lat,r=s.lng>=e.lng&&n.lng<=i.lng;return a&&r},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(t){return t?(t=o.latLngBounds(t),this._southWest.equals(t.getSouthWest())&&this._northEast.equals(t.getNorthEast())):!1},isValid:function(){return!(!this._southWest||!this._northEast)}},o.latLngBounds=function(t,e){return!t||t instanceof o.LatLngBounds?t:new o.LatLngBounds(t,e)},o.Projection={},o.Projection.SphericalMercator={MAX_LATITUDE:85.0511287798,project:function(t){var e=o.LatLng.DEG_TO_RAD,i=this.MAX_LATITUDE,n=Math.max(Math.min(i,t.lat),-i),s=t.lng*e,a=n*e;return a=Math.log(Math.tan(Math.PI/4+a/2)),new o.Point(s,a)},unproject:function(t){var e=o.LatLng.RAD_TO_DEG,i=t.x*e,n=(2*Math.atan(Math.exp(t.y))-Math.PI/2)*e;return new o.LatLng(n,i)}},o.Projection.LonLat={project:function(t){return new o.Point(t.lng,t.lat)},unproject:function(t){return new o.LatLng(t.y,t.x)}},o.CRS={latLngToPoint:function(t,e){var i=this.projection.project(t),n=this.scale(e);return this.transformation._transform(i,n)},pointToLatLng:function(t,e){var i=this.scale(e),n=this.transformation.untransform(t,i);return this.projection.unproject(n)},project:function(t){return this.projection.project(t)},scale:function(t){return 256*Math.pow(2,t)},getSize:function(t){var e=this.scale(t);return o.point(e,e)}},o.CRS.Simple=o.extend({},o.CRS,{projection:o.Projection.LonLat,transformation:new o.Transformation(1,0,-1,0),scale:function(t){return Math.pow(2,t)}}),o.CRS.EPSG3857=o.extend({},o.CRS,{code:"EPSG:3857",projection:o.Projection.SphericalMercator,transformation:new o.Transformation(.5/Math.PI,.5,-.5/Math.PI,.5),project:function(t){var e=this.projection.project(t),i=6378137;return e.multiplyBy(i)}}),o.CRS.EPSG900913=o.extend({},o.CRS.EPSG3857,{code:"EPSG:900913"}),o.CRS.EPSG4326=o.extend({},o.CRS,{code:"EPSG:4326",projection:o.Projection.LonLat,transformation:new o.Transformation(1/360,.5,-1/360,.5)}),o.Map=o.Class.extend({includes:o.Mixin.Events,options:{crs:o.CRS.EPSG3857,fadeAnimation:o.DomUtil.TRANSITION&&!o.Browser.android23,trackResize:!0,markerZoomAnimation:o.DomUtil.TRANSITION&&o.Browser.any3d},initialize:function(t,e){e=o.setOptions(this,e),this._initContainer(t),this._initLayout(),this._onResize=o.bind(this._onResize,this),this._initEvents(),e.maxBounds&&this.setMaxBounds(e.maxBounds),e.center&&e.zoom!==i&&this.setView(o.latLng(e.center),e.zoom,{reset:!0}),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._tileLayersNum=0,this.callInitHooks(),this._addLayers(e.layers)},setView:function(t,e){return e=e===i?this.getZoom():e,this._resetView(o.latLng(t),this._limitZoom(e)),this},setZoom:function(t,e){return this._loaded?this.setView(this.getCenter(),t,{zoom:e}):(this._zoom=this._limitZoom(t),this)},zoomIn:function(t,e){return this.setZoom(this._zoom+(t||1),e)},zoomOut:function(t,e){return this.setZoom(this._zoom-(t||1),e)},setZoomAround:function(t,e,i){var n=this.getZoomScale(e),s=this.getSize().divideBy(2),a=t instanceof o.Point?t:this.latLngToContainerPoint(t),r=a.subtract(s).multiplyBy(1-1/n),h=this.containerPointToLatLng(s.add(r));return this.setView(h,e,{zoom:i})},fitBounds:function(t,e){e=e||{},t=t.getBounds?t.getBounds():o.latLngBounds(t);var i=o.point(e.paddingTopLeft||e.padding||[0,0]),n=o.point(e.paddingBottomRight||e.padding||[0,0]),s=this.getBoundsZoom(t,!1,i.add(n));s=e.maxZoom?Math.min(e.maxZoom,s):s;var a=n.subtract(i).divideBy(2),r=this.project(t.getSouthWest(),s),h=this.project(t.getNorthEast(),s),l=this.unproject(r.add(h).divideBy(2).add(a),s);return this.setView(l,s,e)},fitWorld:function(t){return this.fitBounds([[-90,-180],[90,180]],t)},panTo:function(t,e){return this.setView(t,this._zoom,{pan:e})},panBy:function(t){return this.fire("movestart"),this._rawPanBy(o.point(t)),this.fire("move"),this.fire("moveend")},setMaxBounds:function(t){return t=o.latLngBounds(t),this.options.maxBounds=t,t?(this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds,this)):this.off("moveend",this._panInsideMaxBounds,this)},panInsideBounds:function(t,e){var i=this.getCenter(),n=this._limitCenter(i,this._zoom,t);return i.equals(n)?this:this.panTo(n,e)},addLayer:function(t){var e=o.stamp(t);return this._layers[e]?this:(this._layers[e]=t,!t.options||isNaN(t.options.maxZoom)&&isNaN(t.options.minZoom)||(this._zoomBoundLayers[e]=t,this._updateZoomLevels()),this.options.zoomAnimation&&o.TileLayer&&t instanceof o.TileLayer&&(this._tileLayersNum++,this._tileLayersToLoad++,t.on("load",this._onTileLayerLoad,this)),this._loaded&&this._layerAdd(t),this)},removeLayer:function(t){var e=o.stamp(t);return this._layers[e]?(this._loaded&&t.onRemove(this),delete this._layers[e],this._loaded&&this.fire("layerremove",{layer:t}),this._zoomBoundLayers[e]&&(delete this._zoomBoundLayers[e],this._updateZoomLevels()),this.options.zoomAnimation&&o.TileLayer&&t instanceof o.TileLayer&&(this._tileLayersNum--,this._tileLayersToLoad--,t.off("load",this._onTileLayerLoad,this)),this):this},hasLayer:function(t){return t?o.stamp(t)in this._layers:!1},eachLayer:function(t,e){for(var i in this._layers)t.call(e,this._layers[i]);return this},invalidateSize:function(t){if(!this._loaded)return this;t=o.extend({animate:!1,pan:!0},t===!0?{animate:!0}:t);var e=this.getSize();this._sizeChanged=!0,this._initialCenter=null;var i=this.getSize(),n=e.divideBy(2).round(),s=i.divideBy(2).round(),a=n.subtract(s);return a.x||a.y?(t.animate&&t.pan?this.panBy(a):(t.pan&&this._rawPanBy(a),this.fire("move"),t.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(o.bind(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:e,newSize:i})):this},addHandler:function(t,e){if(!e)return this;var i=this[t]=new e(this);return this._handlers.push(i),this.options[t]&&i.enable(),this},remove:function(){this._loaded&&this.fire("unload"),this._initEvents("off");try{delete this._container._leaflet}catch(t){this._container._leaflet=i}return this._clearPanes(),this._clearControlPos&&this._clearControlPos(),this._clearHandlers(),this},getCenter:function(){return this._checkIfLoaded(),this._initialCenter&&!this._moved()?this._initialCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var t=this.getPixelBounds(),e=this.unproject(t.getBottomLeft()),i=this.unproject(t.getTopRight());return new o.LatLngBounds(e,i)},getMinZoom:function(){return this.options.minZoom===i?this._layersMinZoom===i?0:this._layersMinZoom:this.options.minZoom},getMaxZoom:function(){return this.options.maxZoom===i?this._layersMaxZoom===i?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(t,e,i){t=o.latLngBounds(t);var n,s=this.getMinZoom()-(e?1:0),a=this.getMaxZoom(),r=this.getSize(),h=t.getNorthWest(),l=t.getSouthEast(),u=!0;i=o.point(i||[0,0]);do s++,n=this.project(l,s).subtract(this.project(h,s)).add(i),u=e?n.x<r.x||n.y<r.y:r.contains(n);while(u&&a>=s);return u&&e?null:e?s:s-1},getSize:function(){return(!this._size||this._sizeChanged)&&(this._size=new o.Point(this._container.clientWidth,this._container.clientHeight),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(){var t=this._getTopLeftPoint();return new o.Bounds(t,t.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._initialTopLeftPoint},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(t){var e=this.options.crs;return e.scale(t)/e.scale(this._zoom)},getScaleZoom:function(t){return this._zoom+Math.log(t)/Math.LN2},project:function(t,e){return e=e===i?this._zoom:e,this.options.crs.latLngToPoint(o.latLng(t),e)},unproject:function(t,e){return e=e===i?this._zoom:e,this.options.crs.pointToLatLng(o.point(t),e)},layerPointToLatLng:function(t){var e=o.point(t).add(this.getPixelOrigin());return this.unproject(e)},latLngToLayerPoint:function(t){var e=this.project(o.latLng(t))._round();return e._subtract(this.getPixelOrigin())},containerPointToLayerPoint:function(t){return o.point(t).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(t){return o.point(t).add(this._getMapPanePos())},containerPointToLatLng:function(t){var e=this.containerPointToLayerPoint(o.point(t));return this.layerPointToLatLng(e)},latLngToContainerPoint:function(t){return this.layerPointToContainerPoint(this.latLngToLayerPoint(o.latLng(t)))},mouseEventToContainerPoint:function(t){return o.DomEvent.getMousePosition(t,this._container)},mouseEventToLayerPoint:function(t){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t))},mouseEventToLatLng:function(t){return this.layerPointToLatLng(this.mouseEventToLayerPoint(t))},_initContainer:function(t){var e=this._container=o.DomUtil.get(t);if(!e)throw new Error("Map container not found.");if(e._leaflet)throw new Error("Map container is already initialized.");e._leaflet=!0},_initLayout:function(){var t=this._container;o.DomUtil.addClass(t,"leaflet-container"+(o.Browser.touch?" leaflet-touch":"")+(o.Browser.retina?" leaflet-retina":"")+(o.Browser.ielt9?" leaflet-oldie":"")+(this.options.fadeAnimation?" leaflet-fade-anim":""));var e=o.DomUtil.getStyle(t,"position");"absolute"!==e&&"relative"!==e&&"fixed"!==e&&(t.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var t=this._panes={};this._mapPane=t.mapPane=this._createPane("leaflet-map-pane",this._container),this._tilePane=t.tilePane=this._createPane("leaflet-tile-pane",this._mapPane),t.objectsPane=this._createPane("leaflet-objects-pane",this._mapPane),t.shadowPane=this._createPane("leaflet-shadow-pane"),t.overlayPane=this._createPane("leaflet-overlay-pane"),t.markerPane=this._createPane("leaflet-marker-pane"),t.popupPane=this._createPane("leaflet-popup-pane");var e=" leaflet-zoom-hide";this.options.markerZoomAnimation||(o.DomUtil.addClass(t.markerPane,e),o.DomUtil.addClass(t.shadowPane,e),o.DomUtil.addClass(t.popupPane,e))},_createPane:function(t,e){return o.DomUtil.create("div",t,e||this._panes.objectsPane)},_clearPanes:function(){this._container.removeChild(this._mapPane)},_addLayers:function(t){t=t?o.Util.isArray(t)?t:[t]:[];for(var e=0,i=t.length;i>e;e++)this.addLayer(t[e])},_resetView:function(t,e,i,n){var s=this._zoom!==e;n||(this.fire("movestart"),s&&this.fire("zoomstart")),this._zoom=e,this._initialCenter=t,this._initialTopLeftPoint=this._getNewTopLeftPoint(t),i?this._initialTopLeftPoint._add(this._getMapPanePos()):o.DomUtil.setPosition(this._mapPane,new o.Point(0,0)),this._tileLayersToLoad=this._tileLayersNum;var a=!this._loaded;this._loaded=!0,this.fire("viewreset",{hard:!i}),a&&(this.fire("load"),this.eachLayer(this._layerAdd,this)),this.fire("move"),(s||n)&&this.fire("zoomend"),this.fire("moveend",{hard:!i})},_rawPanBy:function(t){o.DomUtil.setPosition(this._mapPane,this._getMapPanePos().subtract(t))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_updateZoomLevels:function(){var t,e=1/0,n=-(1/0),o=this._getZoomSpan();for(t in this._zoomBoundLayers){var s=this._zoomBoundLayers[t];isNaN(s.options.minZoom)||(e=Math.min(e,s.options.minZoom)),isNaN(s.options.maxZoom)||(n=Math.max(n,s.options.maxZoom))}t===i?this._layersMaxZoom=this._layersMinZoom=i:(this._layersMaxZoom=n,this._layersMinZoom=e),o!==this._getZoomSpan()&&this.fire("zoomlevelschange")},_panInsideMaxBounds:function(){this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(e){if(o.DomEvent){e=e||"on",o.DomEvent[e](this._container,"click",this._onMouseClick,this);var i,n,s=["dblclick","mousedown","mouseup","mouseenter","mouseleave","mousemove","contextmenu"];for(i=0,n=s.length;n>i;i++)o.DomEvent[e](this._container,s[i],this._fireMouseEvent,this);this.options.trackResize&&o.DomEvent[e](t,"resize",this._onResize,this)}},_onResize:function(){o.Util.cancelAnimFrame(this._resizeRequest),this._resizeRequest=o.Util.requestAnimFrame(function(){this.invalidateSize({debounceMoveend:!0})},this,!1,this._container)},_onMouseClick:function(t){!this._loaded||!t._simulated&&(this.dragging&&this.dragging.moved()||this.boxZoom&&this.boxZoom.moved())||o.DomEvent._skipped(t)||(this.fire("preclick"),this._fireMouseEvent(t))},_fireMouseEvent:function(t){if(this._loaded&&!o.DomEvent._skipped(t)){var e=t.type;if(e="mouseenter"===e?"mouseover":"mouseleave"===e?"mouseout":e,this.hasEventListeners(e)){"contextmenu"===e&&o.DomEvent.preventDefault(t);var i=this.mouseEventToContainerPoint(t),n=this.containerPointToLayerPoint(i),s=this.layerPointToLatLng(n);this.fire(e,{latlng:s,layerPoint:n,containerPoint:i,originalEvent:t})}}},_onTileLayerLoad:function(){this._tileLayersToLoad--,this._tileLayersNum&&!this._tileLayersToLoad&&this.fire("tilelayersload")},_clearHandlers:function(){for(var t=0,e=this._handlers.length;e>t;t++)this._handlers[t].disable()},whenReady:function(t,e){return this._loaded?t.call(e||this,this):this.on("load",t,e),this},_layerAdd:function(t){t.onAdd(this),this.fire("layeradd",{layer:t})},_getMapPanePos:function(){return o.DomUtil.getPosition(this._mapPane)},_moved:function(){var t=this._getMapPanePos();return t&&!t.equals([0,0])},_getTopLeftPoint:function(){return this.getPixelOrigin().subtract(this._getMapPanePos())},_getNewTopLeftPoint:function(t,e){var i=this.getSize()._divideBy(2);return this.project(t,e)._subtract(i)._round()},_latLngToNewLayerPoint:function(t,e,i){var n=this._getNewTopLeftPoint(i,e).add(this._getMapPanePos());return this.project(t,e)._subtract(n)},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(t){return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint())},_limitCenter:function(t,e,i){if(!i)return t;var n=this.project(t,e),s=this.getSize().divideBy(2),a=new o.Bounds(n.subtract(s),n.add(s)),r=this._getBoundsOffset(a,i,e);return this.unproject(n.add(r),e)},_limitOffset:function(t,e){if(!e)return t;var i=this.getPixelBounds(),n=new o.Bounds(i.min.add(t),i.max.add(t));return t.add(this._getBoundsOffset(n,e))},_getBoundsOffset:function(t,e,i){var n=this.project(e.getNorthWest(),i).subtract(t.min),s=this.project(e.getSouthEast(),i).subtract(t.max),a=this._rebound(n.x,-s.x),r=this._rebound(n.y,-s.y);return new o.Point(a,r)},_rebound:function(t,e){return t+e>0?Math.round(t-e)/2:Math.max(0,Math.ceil(t))-Math.max(0,Math.floor(e))},_limitZoom:function(t){var e=this.getMinZoom(),i=this.getMaxZoom();return Math.max(e,Math.min(i,t))}}),o.map=function(t,e){return new o.Map(t,e)},o.Projection.Mercator={MAX_LATITUDE:85.0840591556,R_MINOR:6356752.314245179,R_MAJOR:6378137,project:function(t){var e=o.LatLng.DEG_TO_RAD,i=this.MAX_LATITUDE,n=Math.max(Math.min(i,t.lat),-i),s=this.R_MAJOR,a=this.R_MINOR,r=t.lng*e*s,h=n*e,l=a/s,u=Math.sqrt(1-l*l),c=u*Math.sin(h);c=Math.pow((1-c)/(1+c),.5*u);var d=Math.tan(.5*(.5*Math.PI-h))/c;return h=-s*Math.log(d),new o.Point(r,h)},unproject:function(t){for(var e,i=o.LatLng.RAD_TO_DEG,n=this.R_MAJOR,s=this.R_MINOR,a=t.x*i/n,r=s/n,h=Math.sqrt(1-r*r),l=Math.exp(-t.y/n),u=Math.PI/2-2*Math.atan(l),c=15,d=1e-7,p=c,_=.1;Math.abs(_)>d&&--p>0;)e=h*Math.sin(u),_=Math.PI/2-2*Math.atan(l*Math.pow((1-e)/(1+e),.5*h))-u,u+=_;return new o.LatLng(u*i,a)}},o.CRS.EPSG3395=o.extend({},o.CRS,{code:"EPSG:3395",projection:o.Projection.Mercator,
	transformation:function(){var t=o.Projection.Mercator,e=t.R_MAJOR,i=.5/(Math.PI*e);return new o.Transformation(i,.5,-i,.5)}()}),o.TileLayer=o.Class.extend({includes:o.Mixin.Events,options:{minZoom:0,maxZoom:18,tileSize:256,subdomains:"abc",errorTileUrl:"",attribution:"",zoomOffset:0,opacity:1,unloadInvisibleTiles:o.Browser.mobile,updateWhenIdle:o.Browser.mobile},initialize:function(t,e){e=o.setOptions(this,e),e.detectRetina&&o.Browser.retina&&e.maxZoom>0&&(e.tileSize=Math.floor(e.tileSize/2),e.zoomOffset++,e.minZoom>0&&e.minZoom--,this.options.maxZoom--),e.bounds&&(e.bounds=o.latLngBounds(e.bounds)),this._url=t;var i=this.options.subdomains;"string"==typeof i&&(this.options.subdomains=i.split(""))},onAdd:function(t){this._map=t,this._animated=t._zoomAnimated,this._initContainer(),t.on({viewreset:this._reset,moveend:this._update},this),this._animated&&t.on({zoomanim:this._animateZoom,zoomend:this._endZoomAnim},this),this.options.updateWhenIdle||(this._limitedUpdate=o.Util.limitExecByInterval(this._update,150,this),t.on("move",this._limitedUpdate,this)),this._reset(),this._update()},addTo:function(t){return t.addLayer(this),this},onRemove:function(t){this._container.parentNode.removeChild(this._container),t.off({viewreset:this._reset,moveend:this._update},this),this._animated&&t.off({zoomanim:this._animateZoom,zoomend:this._endZoomAnim},this),this.options.updateWhenIdle||t.off("move",this._limitedUpdate,this),this._container=null,this._map=null},bringToFront:function(){var t=this._map._panes.tilePane;return this._container&&(t.appendChild(this._container),this._setAutoZIndex(t,Math.max)),this},bringToBack:function(){var t=this._map._panes.tilePane;return this._container&&(t.insertBefore(this._container,t.firstChild),this._setAutoZIndex(t,Math.min)),this},getAttribution:function(){return this.options.attribution},getContainer:function(){return this._container},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},setUrl:function(t,e){return this._url=t,e||this.redraw(),this},redraw:function(){return this._map&&(this._reset({hard:!0}),this._update()),this},_updateZIndex:function(){this._container&&this.options.zIndex!==i&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(t,e){var i,n,o,s=t.children,a=-e(1/0,-(1/0));for(n=0,o=s.length;o>n;n++)s[n]!==this._container&&(i=parseInt(s[n].style.zIndex,10),isNaN(i)||(a=e(a,i)));this.options.zIndex=this._container.style.zIndex=(isFinite(a)?a:0)+e(1,-1)},_updateOpacity:function(){var t,e=this._tiles;if(o.Browser.ielt9)for(t in e)o.DomUtil.setOpacity(e[t],this.options.opacity);else o.DomUtil.setOpacity(this._container,this.options.opacity)},_initContainer:function(){var t=this._map._panes.tilePane;if(!this._container){if(this._container=o.DomUtil.create("div","leaflet-layer"),this._updateZIndex(),this._animated){var e="leaflet-tile-container";this._bgBuffer=o.DomUtil.create("div",e,this._container),this._tileContainer=o.DomUtil.create("div",e,this._container)}else this._tileContainer=this._container;t.appendChild(this._container),this.options.opacity<1&&this._updateOpacity()}},_reset:function(t){for(var e in this._tiles)this.fire("tileunload",{tile:this._tiles[e]});this._tiles={},this._tilesToLoad=0,this.options.reuseTiles&&(this._unusedTiles=[]),this._tileContainer.innerHTML="",this._animated&&t&&t.hard&&this._clearBgBuffer(),this._initContainer()},_getTileSize:function(){var t=this._map,e=t.getZoom()+this.options.zoomOffset,i=this.options.maxNativeZoom,n=this.options.tileSize;return i&&e>i&&(n=Math.round(t.getZoomScale(e)/t.getZoomScale(i)*n)),n},_update:function(){if(this._map){var t=this._map,e=t.getPixelBounds(),i=t.getZoom(),n=this._getTileSize();if(!(i>this.options.maxZoom||i<this.options.minZoom)){var s=o.bounds(e.min.divideBy(n)._floor(),e.max.divideBy(n)._floor());this._addTilesFromCenterOut(s),(this.options.unloadInvisibleTiles||this.options.reuseTiles)&&this._removeOtherTiles(s)}}},_addTilesFromCenterOut:function(t){var i,n,s,a=[],r=t.getCenter();for(i=t.min.y;i<=t.max.y;i++)for(n=t.min.x;n<=t.max.x;n++)s=new o.Point(n,i),this._tileShouldBeLoaded(s)&&a.push(s);var h=a.length;if(0!==h){a.sort(function(t,e){return t.distanceTo(r)-e.distanceTo(r)});var l=e.createDocumentFragment();for(this._tilesToLoad||this.fire("loading"),this._tilesToLoad+=h,n=0;h>n;n++)this._addTile(a[n],l);this._tileContainer.appendChild(l)}},_tileShouldBeLoaded:function(t){if(t.x+":"+t.y in this._tiles)return!1;var e=this.options;if(!e.continuousWorld){var i=this._getWrapTileNum();if(e.noWrap&&(t.x<0||t.x>=i.x)||t.y<0||t.y>=i.y)return!1}if(e.bounds){var n=this._getTileSize(),o=t.multiplyBy(n),s=o.add([n,n]),a=this._map.unproject(o),r=this._map.unproject(s);if(e.continuousWorld||e.noWrap||(a=a.wrap(),r=r.wrap()),!e.bounds.intersects([a,r]))return!1}return!0},_removeOtherTiles:function(t){var e,i,n,o;for(o in this._tiles)e=o.split(":"),i=parseInt(e[0],10),n=parseInt(e[1],10),(i<t.min.x||i>t.max.x||n<t.min.y||n>t.max.y)&&this._removeTile(o)},_removeTile:function(t){var e=this._tiles[t];this.fire("tileunload",{tile:e,url:e.src}),this.options.reuseTiles?(o.DomUtil.removeClass(e,"leaflet-tile-loaded"),this._unusedTiles.push(e)):e.parentNode===this._tileContainer&&this._tileContainer.removeChild(e),o.Browser.android||(e.onload=null,e.src=o.Util.emptyImageUrl),delete this._tiles[t]},_addTile:function(t,e){var i=this._getTilePos(t),n=this._getTile();o.DomUtil.setPosition(n,i,o.Browser.chrome),this._tiles[t.x+":"+t.y]=n,this._loadTile(n,t),n.parentNode!==this._tileContainer&&e.appendChild(n)},_getZoomForUrl:function(){var t=this.options,e=this._map.getZoom();return t.zoomReverse&&(e=t.maxZoom-e),e+=t.zoomOffset,t.maxNativeZoom?Math.min(e,t.maxNativeZoom):e},_getTilePos:function(t){var e=this._map.getPixelOrigin(),i=this._getTileSize();return t.multiplyBy(i).subtract(e)},getTileUrl:function(t){return o.Util.template(this._url,o.extend({s:this._getSubdomain(t),z:t.z,x:t.x,y:t.y},this.options))},_getWrapTileNum:function(){var t=this._map.options.crs,e=t.getSize(this._map.getZoom());return e.divideBy(this._getTileSize())._floor()},_adjustTilePoint:function(t){var e=this._getWrapTileNum();this.options.continuousWorld||this.options.noWrap||(t.x=(t.x%e.x+e.x)%e.x),this.options.tms&&(t.y=e.y-t.y-1),t.z=this._getZoomForUrl()},_getSubdomain:function(t){var e=Math.abs(t.x+t.y)%this.options.subdomains.length;return this.options.subdomains[e]},_getTile:function(){if(this.options.reuseTiles&&this._unusedTiles.length>0){var t=this._unusedTiles.pop();return this._resetTile(t),t}return this._createTile()},_resetTile:function(){},_createTile:function(){var t=o.DomUtil.create("img","leaflet-tile");return t.style.width=t.style.height=this._getTileSize()+"px",t.galleryimg="no",t.onselectstart=t.onmousemove=o.Util.falseFn,o.Browser.ielt9&&this.options.opacity!==i&&o.DomUtil.setOpacity(t,this.options.opacity),o.Browser.mobileWebkit3d&&(t.style.WebkitBackfaceVisibility="hidden"),t},_loadTile:function(t,e){t._layer=this,t.onload=this._tileOnLoad,t.onerror=this._tileOnError,this._adjustTilePoint(e),t.src=this.getTileUrl(e),this.fire("tileloadstart",{tile:t,url:t.src})},_tileLoaded:function(){this._tilesToLoad--,this._animated&&o.DomUtil.addClass(this._tileContainer,"leaflet-zoom-animated"),this._tilesToLoad||(this.fire("load"),this._animated&&(clearTimeout(this._clearBgBufferTimer),this._clearBgBufferTimer=setTimeout(o.bind(this._clearBgBuffer,this),500)))},_tileOnLoad:function(){var t=this._layer;this.src!==o.Util.emptyImageUrl&&(o.DomUtil.addClass(this,"leaflet-tile-loaded"),t.fire("tileload",{tile:this,url:this.src})),t._tileLoaded()},_tileOnError:function(){var t=this._layer;t.fire("tileerror",{tile:this,url:this.src});var e=t.options.errorTileUrl;e&&(this.src=e),t._tileLoaded()}}),o.tileLayer=function(t,e){return new o.TileLayer(t,e)},o.TileLayer.WMS=o.TileLayer.extend({defaultWmsParams:{service:"WMS",request:"GetMap",version:"1.1.1",layers:"",styles:"",format:"image/jpeg",transparent:!1},initialize:function(t,e){this._url=t;var i=o.extend({},this.defaultWmsParams),n=e.tileSize||this.options.tileSize;e.detectRetina&&o.Browser.retina?i.width=i.height=2*n:i.width=i.height=n;for(var s in e)this.options.hasOwnProperty(s)||"crs"===s||(i[s]=e[s]);this.wmsParams=i,o.setOptions(this,e)},onAdd:function(t){this._crs=this.options.crs||t.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var e=this._wmsVersion>=1.3?"crs":"srs";this.wmsParams[e]=this._crs.code,o.TileLayer.prototype.onAdd.call(this,t)},getTileUrl:function(t){var e=this._map,i=this.options.tileSize,n=t.multiplyBy(i),s=n.add([i,i]),a=this._crs.project(e.unproject(n,t.z)),r=this._crs.project(e.unproject(s,t.z)),h=this._wmsVersion>=1.3&&this._crs===o.CRS.EPSG4326?[r.y,a.x,a.y,r.x].join(","):[a.x,r.y,r.x,a.y].join(","),l=o.Util.template(this._url,{s:this._getSubdomain(t)});return l+o.Util.getParamString(this.wmsParams,l,!0)+"&BBOX="+h},setParams:function(t,e){return o.extend(this.wmsParams,t),e||this.redraw(),this}}),o.tileLayer.wms=function(t,e){return new o.TileLayer.WMS(t,e)},o.TileLayer.Canvas=o.TileLayer.extend({options:{async:!1},initialize:function(t){o.setOptions(this,t)},redraw:function(){this._map&&(this._reset({hard:!0}),this._update());for(var t in this._tiles)this._redrawTile(this._tiles[t]);return this},_redrawTile:function(t){this.drawTile(t,t._tilePoint,this._map._zoom)},_createTile:function(){var t=o.DomUtil.create("canvas","leaflet-tile");return t.width=t.height=this.options.tileSize,t.onselectstart=t.onmousemove=o.Util.falseFn,t},_loadTile:function(t,e){t._layer=this,t._tilePoint=e,this._redrawTile(t),this.options.async||this.tileDrawn(t)},drawTile:function(){},tileDrawn:function(t){this._tileOnLoad.call(t)}}),o.tileLayer.canvas=function(t){return new o.TileLayer.Canvas(t)},o.ImageOverlay=o.Class.extend({includes:o.Mixin.Events,options:{opacity:1},initialize:function(t,e,i){this._url=t,this._bounds=o.latLngBounds(e),o.setOptions(this,i)},onAdd:function(t){this._map=t,this._image||this._initImage(),t._panes.overlayPane.appendChild(this._image),t.on("viewreset",this._reset,this),t.options.zoomAnimation&&o.Browser.any3d&&t.on("zoomanim",this._animateZoom,this),this._reset()},onRemove:function(t){t.getPanes().overlayPane.removeChild(this._image),t.off("viewreset",this._reset,this),t.options.zoomAnimation&&t.off("zoomanim",this._animateZoom,this)},addTo:function(t){return t.addLayer(this),this},setOpacity:function(t){return this.options.opacity=t,this._updateOpacity(),this},bringToFront:function(){return this._image&&this._map._panes.overlayPane.appendChild(this._image),this},bringToBack:function(){var t=this._map._panes.overlayPane;return this._image&&t.insertBefore(this._image,t.firstChild),this},setUrl:function(t){this._url=t,this._image.src=this._url},getAttribution:function(){return this.options.attribution},_initImage:function(){this._image=o.DomUtil.create("img","leaflet-image-layer"),this._map.options.zoomAnimation&&o.Browser.any3d?o.DomUtil.addClass(this._image,"leaflet-zoom-animated"):o.DomUtil.addClass(this._image,"leaflet-zoom-hide"),this._updateOpacity(),o.extend(this._image,{galleryimg:"no",onselectstart:o.Util.falseFn,onmousemove:o.Util.falseFn,onload:o.bind(this._onImageLoad,this),src:this._url})},_animateZoom:function(t){var e=this._map,i=this._image,n=e.getZoomScale(t.zoom),s=this._bounds.getNorthWest(),a=this._bounds.getSouthEast(),r=e._latLngToNewLayerPoint(s,t.zoom,t.center),h=e._latLngToNewLayerPoint(a,t.zoom,t.center)._subtract(r),l=r._add(h._multiplyBy(.5*(1-1/n)));i.style[o.DomUtil.TRANSFORM]=o.DomUtil.getTranslateString(l)+" scale("+n+") "},_reset:function(){var t=this._image,e=this._map.latLngToLayerPoint(this._bounds.getNorthWest()),i=this._map.latLngToLayerPoint(this._bounds.getSouthEast())._subtract(e);o.DomUtil.setPosition(t,e),t.style.width=i.x+"px",t.style.height=i.y+"px"},_onImageLoad:function(){this.fire("load")},_updateOpacity:function(){o.DomUtil.setOpacity(this._image,this.options.opacity)}}),o.imageOverlay=function(t,e,i){return new o.ImageOverlay(t,e,i)},o.Icon=o.Class.extend({options:{className:""},initialize:function(t){o.setOptions(this,t)},createIcon:function(t){return this._createIcon("icon",t)},createShadow:function(t){return this._createIcon("shadow",t)},_createIcon:function(t,e){var i=this._getIconUrl(t);if(!i){if("icon"===t)throw new Error("iconUrl not set in Icon options (see the docs).");return null}var n;return n=e&&"IMG"===e.tagName?this._createImg(i,e):this._createImg(i),this._setIconStyles(n,t),n},_setIconStyles:function(t,e){var i,n=this.options,s=o.point(n[e+"Size"]);i="shadow"===e?o.point(n.shadowAnchor||n.iconAnchor):o.point(n.iconAnchor),!i&&s&&(i=s.divideBy(2,!0)),t.className="leaflet-marker-"+e+" "+n.className,i&&(t.style.marginLeft=-i.x+"px",t.style.marginTop=-i.y+"px"),s&&(t.style.width=s.x+"px",t.style.height=s.y+"px")},_createImg:function(t,i){return i=i||e.createElement("img"),i.src=t,i},_getIconUrl:function(t){return o.Browser.retina&&this.options[t+"RetinaUrl"]?this.options[t+"RetinaUrl"]:this.options[t+"Url"]}}),o.icon=function(t){return new o.Icon(t)},o.Icon.Default=o.Icon.extend({options:{iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],shadowSize:[41,41]},_getIconUrl:function(t){var e=t+"Url";if(this.options[e])return this.options[e];o.Browser.retina&&"icon"===t&&(t+="-2x");var i=o.Icon.Default.imagePath;if(!i)throw new Error("Couldn't autodetect L.Icon.Default.imagePath, set it manually.");return i+"/marker-"+t+".png"}}),o.Icon.Default.imagePath=function(){var t,i,n,o,s,a=e.getElementsByTagName("script"),r=/[\/^]leaflet[\-\._]?([\w\-\._]*)\.js\??/;for(t=0,i=a.length;i>t;t++)if(n=a[t].src,o=n.match(r))return s=n.split(r)[0],(s?s+"/":"")+"images"}(),o.Marker=o.Class.extend({includes:o.Mixin.Events,options:{icon:new o.Icon.Default,title:"",alt:"",clickable:!0,draggable:!1,keyboard:!0,zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250},initialize:function(t,e){o.setOptions(this,e),this._latlng=o.latLng(t)},onAdd:function(t){this._map=t,t.on("viewreset",this.update,this),this._initIcon(),this.update(),this.fire("add"),t.options.zoomAnimation&&t.options.markerZoomAnimation&&t.on("zoomanim",this._animateZoom,this)},addTo:function(t){return t.addLayer(this),this},onRemove:function(t){this.dragging&&this.dragging.disable(),this._removeIcon(),this._removeShadow(),this.fire("remove"),t.off({viewreset:this.update,zoomanim:this._animateZoom},this),this._map=null},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=o.latLng(t),this.update(),this.fire("move",{latlng:this._latlng})},setZIndexOffset:function(t){return this.options.zIndexOffset=t,this.update(),this},setIcon:function(t){return this.options.icon=t,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup),this},update:function(){return this._icon&&this._setPos(this._map.latLngToLayerPoint(this._latlng).round()),this},_initIcon:function(){var t=this.options,e=this._map,i=e.options.zoomAnimation&&e.options.markerZoomAnimation,n=i?"leaflet-zoom-animated":"leaflet-zoom-hide",s=t.icon.createIcon(this._icon),a=!1;s!==this._icon&&(this._icon&&this._removeIcon(),a=!0,t.title&&(s.title=t.title),t.alt&&(s.alt=t.alt)),o.DomUtil.addClass(s,n),t.keyboard&&(s.tabIndex="0"),this._icon=s,this._initInteraction(),t.riseOnHover&&o.DomEvent.on(s,"mouseover",this._bringToFront,this).on(s,"mouseout",this._resetZIndex,this);var r=t.icon.createShadow(this._shadow),h=!1;r!==this._shadow&&(this._removeShadow(),h=!0),r&&o.DomUtil.addClass(r,n),this._shadow=r,t.opacity<1&&this._updateOpacity();var l=this._map._panes;a&&l.markerPane.appendChild(this._icon),r&&h&&l.shadowPane.appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&o.DomEvent.off(this._icon,"mouseover",this._bringToFront).off(this._icon,"mouseout",this._resetZIndex),this._map._panes.markerPane.removeChild(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&this._map._panes.shadowPane.removeChild(this._shadow),this._shadow=null},_setPos:function(t){o.DomUtil.setPosition(this._icon,t),this._shadow&&o.DomUtil.setPosition(this._shadow,t),this._zIndex=t.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(t){this._icon.style.zIndex=this._zIndex+t},_animateZoom:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).round();this._setPos(e)},_initInteraction:function(){if(this.options.clickable){var t=this._icon,e=["dblclick","mousedown","mouseover","mouseout","contextmenu"];o.DomUtil.addClass(t,"leaflet-clickable"),o.DomEvent.on(t,"click",this._onMouseClick,this),o.DomEvent.on(t,"keypress",this._onKeyPress,this);for(var i=0;i<e.length;i++)o.DomEvent.on(t,e[i],this._fireMouseEvent,this);o.Handler.MarkerDrag&&(this.dragging=new o.Handler.MarkerDrag(this),this.options.draggable&&this.dragging.enable())}},_onMouseClick:function(t){var e=this.dragging&&this.dragging.moved();(this.hasEventListeners(t.type)||e)&&o.DomEvent.stopPropagation(t),e||(this.dragging&&this.dragging._enabled||!this._map.dragging||!this._map.dragging.moved())&&this.fire(t.type,{originalEvent:t,latlng:this._latlng})},_onKeyPress:function(t){13===t.keyCode&&this.fire("click",{originalEvent:t,latlng:this._latlng})},_fireMouseEvent:function(t){this.fire(t.type,{originalEvent:t,latlng:this._latlng}),"contextmenu"===t.type&&this.hasEventListeners(t.type)&&o.DomEvent.preventDefault(t),"mousedown"!==t.type?o.DomEvent.stopPropagation(t):o.DomEvent.preventDefault(t)},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},_updateOpacity:function(){o.DomUtil.setOpacity(this._icon,this.options.opacity),this._shadow&&o.DomUtil.setOpacity(this._shadow,this.options.opacity)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)}}),o.marker=function(t,e){return new o.Marker(t,e)},o.DivIcon=o.Icon.extend({options:{iconSize:[12,12],className:"leaflet-div-icon",html:!1},createIcon:function(t){var i=t&&"DIV"===t.tagName?t:e.createElement("div"),n=this.options;return n.html!==!1?i.innerHTML=n.html:i.innerHTML="",n.bgPos&&(i.style.backgroundPosition=-n.bgPos.x+"px "+-n.bgPos.y+"px"),this._setIconStyles(i,"icon"),i},createShadow:function(){return null}}),o.divIcon=function(t){return new o.DivIcon(t)},o.Map.mergeOptions({closePopupOnClick:!0}),o.Popup=o.Class.extend({includes:o.Mixin.Events,options:{minWidth:50,maxWidth:300,autoPan:!0,closeButton:!0,offset:[0,7],autoPanPadding:[5,5],keepInView:!1,className:"",zoomAnimation:!0},initialize:function(t,e){o.setOptions(this,t),this._source=e,this._animated=o.Browser.any3d&&this.options.zoomAnimation,this._isOpen=!1},onAdd:function(t){this._map=t,this._container||this._initLayout();var e=t.options.fadeAnimation;e&&o.DomUtil.setOpacity(this._container,0),t._panes.popupPane.appendChild(this._container),t.on(this._getEvents(),this),this.update(),e&&o.DomUtil.setOpacity(this._container,1),this.fire("open"),t.fire("popupopen",{popup:this}),this._source&&this._source.fire("popupopen",{popup:this})},addTo:function(t){return t.addLayer(this),this},openOn:function(t){return t.openPopup(this),this},onRemove:function(t){t._panes.popupPane.removeChild(this._container),o.Util.falseFn(this._container.offsetWidth),t.off(this._getEvents(),this),t.options.fadeAnimation&&o.DomUtil.setOpacity(this._container,0),this._map=null,this.fire("close"),t.fire("popupclose",{popup:this}),this._source&&this._source.fire("popupclose",{popup:this})},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=o.latLng(t),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(t){return this._content=t,this.update(),this},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},_getEvents:function(){var t={viewreset:this._updatePosition};return this._animated&&(t.zoomanim=this._zoomAnimation),("closeOnClick"in this.options?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(t.preclick=this._close),this.options.keepInView&&(t.moveend=this._adjustPan),t},_close:function(){this._map&&this._map.closePopup(this)},_initLayout:function(){var t,e="leaflet-popup",i=e+" "+this.options.className+" leaflet-zoom-"+(this._animated?"animated":"hide"),n=this._container=o.DomUtil.create("div",i);this.options.closeButton&&(t=this._closeButton=o.DomUtil.create("a",e+"-close-button",n),t.href="#close",t.innerHTML="&#215;",o.DomEvent.disableClickPropagation(t),o.DomEvent.on(t,"click",this._onCloseButtonClick,this));var s=this._wrapper=o.DomUtil.create("div",e+"-content-wrapper",n);o.DomEvent.disableClickPropagation(s),this._contentNode=o.DomUtil.create("div",e+"-content",s),o.DomEvent.disableScrollPropagation(this._contentNode),o.DomEvent.on(s,"contextmenu",o.DomEvent.stopPropagation),this._tipContainer=o.DomUtil.create("div",e+"-tip-container",n),this._tip=o.DomUtil.create("div",e+"-tip",this._tipContainer)},_updateContent:function(){if(this._content){if("string"==typeof this._content)this._contentNode.innerHTML=this._content;else{for(;this._contentNode.hasChildNodes();)this._contentNode.removeChild(this._contentNode.firstChild);this._contentNode.appendChild(this._content)}this.fire("contentupdate")}},_updateLayout:function(){var t=this._contentNode,e=t.style;e.width="",e.whiteSpace="nowrap";var i=t.offsetWidth;i=Math.min(i,this.options.maxWidth),i=Math.max(i,this.options.minWidth),e.width=i+1+"px",e.whiteSpace="",e.height="";var n=t.offsetHeight,s=this.options.maxHeight,a="leaflet-popup-scrolled";s&&n>s?(e.height=s+"px",o.DomUtil.addClass(t,a)):o.DomUtil.removeClass(t,a),this._containerWidth=this._container.offsetWidth},_updatePosition:function(){if(this._map){var t=this._map.latLngToLayerPoint(this._latlng),e=this._animated,i=o.point(this.options.offset);e&&o.DomUtil.setPosition(this._container,t),this._containerBottom=-i.y-(e?0:t.y),this._containerLeft=-Math.round(this._containerWidth/2)+i.x+(e?0:t.x),this._container.style.bottom=this._containerBottom+"px",this._container.style.left=this._containerLeft+"px"}},_zoomAnimation:function(t){var e=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center);o.DomUtil.setPosition(this._container,e)},_adjustPan:function(){if(this.options.autoPan){var t=this._map,e=this._container.offsetHeight,i=this._containerWidth,n=new o.Point(this._containerLeft,-e-this._containerBottom);this._animated&&n._add(o.DomUtil.getPosition(this._container));var s=t.layerPointToContainerPoint(n),a=o.point(this.options.autoPanPadding),r=o.point(this.options.autoPanPaddingTopLeft||a),h=o.point(this.options.autoPanPaddingBottomRight||a),l=t.getSize(),u=0,c=0;s.x+i+h.x>l.x&&(u=s.x+i-l.x+h.x),s.x-u-r.x<0&&(u=s.x-r.x),s.y+e+h.y>l.y&&(c=s.y+e-l.y+h.y),s.y-c-r.y<0&&(c=s.y-r.y),(u||c)&&t.fire("autopanstart").panBy([u,c])}},_onCloseButtonClick:function(t){this._close(),o.DomEvent.stop(t)}}),o.popup=function(t,e){return new o.Popup(t,e)},o.Map.include({openPopup:function(t,e,i){if(this.closePopup(),!(t instanceof o.Popup)){var n=t;t=new o.Popup(i).setLatLng(e).setContent(n)}return t._isOpen=!0,this._popup=t,this.addLayer(t)},closePopup:function(t){return t&&t!==this._popup||(t=this._popup,this._popup=null),t&&(this.removeLayer(t),t._isOpen=!1),this}}),o.Marker.include({openPopup:function(){return this._popup&&this._map&&!this._map.hasLayer(this._popup)&&(this._popup.setLatLng(this._latlng),this._map.openPopup(this._popup)),this},closePopup:function(){return this._popup&&this._popup._close(),this},togglePopup:function(){return this._popup&&(this._popup._isOpen?this.closePopup():this.openPopup()),this},bindPopup:function(t,e){var i=o.point(this.options.icon.options.popupAnchor||[0,0]);return i=i.add(o.Popup.prototype.options.offset),e&&e.offset&&(i=i.add(e.offset)),e=o.extend({offset:i},e),this._popupHandlersAdded||(this.on("click",this.togglePopup,this).on("remove",this.closePopup,this).on("move",this._movePopup,this),this._popupHandlersAdded=!0),t instanceof o.Popup?(o.setOptions(t,e),this._popup=t,t._source=this):this._popup=new o.Popup(e,this).setContent(t),this},setPopupContent:function(t){return this._popup&&this._popup.setContent(t),this},unbindPopup:function(){return this._popup&&(this._popup=null,this.off("click",this.togglePopup,this).off("remove",this.closePopup,this).off("move",this._movePopup,this),this._popupHandlersAdded=!1),this},getPopup:function(){return this._popup},_movePopup:function(t){this._popup.setLatLng(t.latlng)}}),o.LayerGroup=o.Class.extend({initialize:function(t){this._layers={};var e,i;if(t)for(e=0,i=t.length;i>e;e++)this.addLayer(t[e])},addLayer:function(t){var e=this.getLayerId(t);return this._layers[e]=t,this._map&&this._map.addLayer(t),this},removeLayer:function(t){var e=t in this._layers?t:this.getLayerId(t);return this._map&&this._layers[e]&&this._map.removeLayer(this._layers[e]),delete this._layers[e],this},hasLayer:function(t){return t?t in this._layers||this.getLayerId(t)in this._layers:!1},clearLayers:function(){return this.eachLayer(this.removeLayer,this),this},invoke:function(t){var e,i,n=Array.prototype.slice.call(arguments,1);for(e in this._layers)i=this._layers[e],i[t]&&i[t].apply(i,n);return this},onAdd:function(t){this._map=t,this.eachLayer(t.addLayer,t)},onRemove:function(t){this.eachLayer(t.removeLayer,t),this._map=null},addTo:function(t){return t.addLayer(this),this},eachLayer:function(t,e){for(var i in this._layers)t.call(e,this._layers[i]);return this},getLayer:function(t){return this._layers[t]},getLayers:function(){var t=[];for(var e in this._layers)t.push(this._layers[e]);return t},setZIndex:function(t){return this.invoke("setZIndex",t)},getLayerId:function(t){return o.stamp(t)}}),o.layerGroup=function(t){return new o.LayerGroup(t)},o.FeatureGroup=o.LayerGroup.extend({includes:o.Mixin.Events,statics:{EVENTS:"click dblclick mouseover mouseout mousemove contextmenu popupopen popupclose"},addLayer:function(t){return this.hasLayer(t)?this:("on"in t&&t.on(o.FeatureGroup.EVENTS,this._propagateEvent,this),o.LayerGroup.prototype.addLayer.call(this,t),this._popupContent&&t.bindPopup&&t.bindPopup(this._popupContent,this._popupOptions),this.fire("layeradd",{layer:t}))},removeLayer:function(t){return this.hasLayer(t)?(t in this._layers&&(t=this._layers[t]),"off"in t&&t.off(o.FeatureGroup.EVENTS,this._propagateEvent,this),o.LayerGroup.prototype.removeLayer.call(this,t),this._popupContent&&this.invoke("unbindPopup"),this.fire("layerremove",{layer:t})):this},bindPopup:function(t,e){return this._popupContent=t,this._popupOptions=e,this.invoke("bindPopup",t,e)},openPopup:function(t){for(var e in this._layers){this._layers[e].openPopup(t);break}return this},setStyle:function(t){return this.invoke("setStyle",t)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var t=new o.LatLngBounds;return this.eachLayer(function(e){t.extend(e instanceof o.Marker?e.getLatLng():e.getBounds())}),t},_propagateEvent:function(t){t=o.extend({layer:t.target,target:this},t),this.fire(t.type,t)}}),o.featureGroup=function(t){return new o.FeatureGroup(t)},o.Path=o.Class.extend({includes:[o.Mixin.Events],statics:{CLIP_PADDING:function(){var e=o.Browser.mobile?1280:2e3,i=(e/Math.max(t.outerWidth,t.outerHeight)-1)/2;return Math.max(0,Math.min(.5,i))}()},options:{stroke:!0,color:"#0033ff",dashArray:null,lineCap:null,lineJoin:null,weight:5,opacity:.5,fill:!1,fillColor:null,fillOpacity:.2,clickable:!0},initialize:function(t){o.setOptions(this,t)},onAdd:function(t){this._map=t,this._container||(this._initElements(),this._initEvents()),this.projectLatlngs(),this._updatePath(),this._container&&this._map._pathRoot.appendChild(this._container),this.fire("add"),t.on({viewreset:this.projectLatlngs,moveend:this._updatePath},this)},addTo:function(t){return t.addLayer(this),this},onRemove:function(t){t._pathRoot.removeChild(this._container),this.fire("remove"),this._map=null,o.Browser.vml&&(this._container=null,this._stroke=null,this._fill=null),t.off({viewreset:this.projectLatlngs,moveend:this._updatePath},this)},projectLatlngs:function(){},setStyle:function(t){return o.setOptions(this,t),this._container&&this._updateStyle(),this},redraw:function(){return this._map&&(this.projectLatlngs(),this._updatePath()),this}}),o.Map.include({_updatePathViewport:function(){var t=o.Path.CLIP_PADDING,e=this.getSize(),i=o.DomUtil.getPosition(this._mapPane),n=i.multiplyBy(-1)._subtract(e.multiplyBy(t)._round()),s=n.add(e.multiplyBy(1+2*t)._round());this._pathViewport=new o.Bounds(n,s)}}),o.Path.SVG_NS="http://www.w3.org/2000/svg",o.Browser.svg=!(!e.createElementNS||!e.createElementNS(o.Path.SVG_NS,"svg").createSVGRect),o.Path=o.Path.extend({statics:{SVG:o.Browser.svg},bringToFront:function(){var t=this._map._pathRoot,e=this._container;return e&&t.lastChild!==e&&t.appendChild(e),this},bringToBack:function(){var t=this._map._pathRoot,e=this._container,i=t.firstChild;return e&&i!==e&&t.insertBefore(e,i),this},getPathString:function(){},_createElement:function(t){return e.createElementNS(o.Path.SVG_NS,t)},_initElements:function(){this._map._initPathRoot(),this._initPath(),this._initStyle()},_initPath:function(){this._container=this._createElement("g"),this._path=this._createElement("path"),this.options.className&&o.DomUtil.addClass(this._path,this.options.className),this._container.appendChild(this._path)},_initStyle:function(){this.options.stroke&&(this._path.setAttribute("stroke-linejoin","round"),this._path.setAttribute("stroke-linecap","round")),this.options.fill&&this._path.setAttribute("fill-rule","evenodd"),this.options.pointerEvents&&this._path.setAttribute("pointer-events",this.options.pointerEvents),this.options.clickable||this.options.pointerEvents||this._path.setAttribute("pointer-events","none"),this._updateStyle()},_updateStyle:function(){this.options.stroke?(this._path.setAttribute("stroke",this.options.color),this._path.setAttribute("stroke-opacity",this.options.opacity),this._path.setAttribute("stroke-width",this.options.weight),this.options.dashArray?this._path.setAttribute("stroke-dasharray",this.options.dashArray):this._path.removeAttribute("stroke-dasharray"),this.options.lineCap&&this._path.setAttribute("stroke-linecap",this.options.lineCap),this.options.lineJoin&&this._path.setAttribute("stroke-linejoin",this.options.lineJoin)):this._path.setAttribute("stroke","none"),this.options.fill?(this._path.setAttribute("fill",this.options.fillColor||this.options.color),this._path.setAttribute("fill-opacity",this.options.fillOpacity)):this._path.setAttribute("fill","none")},_updatePath:function(){var t=this.getPathString();t||(t="M0 0"),this._path.setAttribute("d",t)},_initEvents:function(){if(this.options.clickable){(o.Browser.svg||!o.Browser.vml)&&o.DomUtil.addClass(this._path,"leaflet-clickable"),o.DomEvent.on(this._container,"click",this._onMouseClick,this);for(var t=["dblclick","mousedown","mouseover","mouseout","mousemove","contextmenu"],e=0;e<t.length;e++)o.DomEvent.on(this._container,t[e],this._fireMouseEvent,this)}},_onMouseClick:function(t){this._map.dragging&&this._map.dragging.moved()||this._fireMouseEvent(t)},_fireMouseEvent:function(t){if(this._map&&this.hasEventListeners(t.type)){var e=this._map,i=e.mouseEventToContainerPoint(t),n=e.containerPointToLayerPoint(i),s=e.layerPointToLatLng(n);this.fire(t.type,{latlng:s,layerPoint:n,containerPoint:i,originalEvent:t}),"contextmenu"===t.type&&o.DomEvent.preventDefault(t),"mousemove"!==t.type&&o.DomEvent.stopPropagation(t)}}}),o.Map.include({_initPathRoot:function(){this._pathRoot||(this._pathRoot=o.Path.prototype._createElement("svg"),this._panes.overlayPane.appendChild(this._pathRoot),this.options.zoomAnimation&&o.Browser.any3d?(o.DomUtil.addClass(this._pathRoot,"leaflet-zoom-animated"),
	this.on({zoomanim:this._animatePathZoom,zoomend:this._endPathZoom})):o.DomUtil.addClass(this._pathRoot,"leaflet-zoom-hide"),this.on("moveend",this._updateSvgViewport),this._updateSvgViewport())},_animatePathZoom:function(t){var e=this.getZoomScale(t.zoom),i=this._getCenterOffset(t.center)._multiplyBy(-e)._add(this._pathViewport.min);this._pathRoot.style[o.DomUtil.TRANSFORM]=o.DomUtil.getTranslateString(i)+" scale("+e+") ",this._pathZooming=!0},_endPathZoom:function(){this._pathZooming=!1},_updateSvgViewport:function(){if(!this._pathZooming){this._updatePathViewport();var t=this._pathViewport,e=t.min,i=t.max,n=i.x-e.x,s=i.y-e.y,a=this._pathRoot,r=this._panes.overlayPane;o.Browser.mobileWebkit&&r.removeChild(a),o.DomUtil.setPosition(a,e),a.setAttribute("width",n),a.setAttribute("height",s),a.setAttribute("viewBox",[e.x,e.y,n,s].join(" ")),o.Browser.mobileWebkit&&r.appendChild(a)}}}),o.Path.include({bindPopup:function(t,e){return t instanceof o.Popup?this._popup=t:((!this._popup||e)&&(this._popup=new o.Popup(e,this)),this._popup.setContent(t)),this._popupHandlersAdded||(this.on("click",this._openPopup,this).on("remove",this.closePopup,this),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this._popup=null,this.off("click",this._openPopup).off("remove",this.closePopup),this._popupHandlersAdded=!1),this},openPopup:function(t){return this._popup&&(t=t||this._latlng||this._latlngs[Math.floor(this._latlngs.length/2)],this._openPopup({latlng:t})),this},closePopup:function(){return this._popup&&this._popup._close(),this},_openPopup:function(t){this._popup.setLatLng(t.latlng),this._map.openPopup(this._popup)}}),o.Browser.vml=!o.Browser.svg&&function(){try{var t=e.createElement("div");t.innerHTML='<v:shape adj="1"/>';var i=t.firstChild;return i.style.behavior="url(#default#VML)",i&&"object"==typeof i.adj}catch(n){return!1}}(),o.Path=o.Browser.svg||!o.Browser.vml?o.Path:o.Path.extend({statics:{VML:!0,CLIP_PADDING:.02},_createElement:function(){try{return e.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(t){return e.createElement("<lvml:"+t+' class="lvml">')}}catch(t){return function(t){return e.createElement("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}}(),_initPath:function(){var t=this._container=this._createElement("shape");o.DomUtil.addClass(t,"leaflet-vml-shape"+(this.options.className?" "+this.options.className:"")),this.options.clickable&&o.DomUtil.addClass(t,"leaflet-clickable"),t.coordsize="1 1",this._path=this._createElement("path"),t.appendChild(this._path),this._map._pathRoot.appendChild(t)},_initStyle:function(){this._updateStyle()},_updateStyle:function(){var t=this._stroke,e=this._fill,i=this.options,n=this._container;n.stroked=i.stroke,n.filled=i.fill,i.stroke?(t||(t=this._stroke=this._createElement("stroke"),t.endcap="round",n.appendChild(t)),t.weight=i.weight+"px",t.color=i.color,t.opacity=i.opacity,i.dashArray?t.dashStyle=o.Util.isArray(i.dashArray)?i.dashArray.join(" "):i.dashArray.replace(/( *, *)/g," "):t.dashStyle="",i.lineCap&&(t.endcap=i.lineCap.replace("butt","flat")),i.lineJoin&&(t.joinstyle=i.lineJoin)):t&&(n.removeChild(t),this._stroke=null),i.fill?(e||(e=this._fill=this._createElement("fill"),n.appendChild(e)),e.color=i.fillColor||i.color,e.opacity=i.fillOpacity):e&&(n.removeChild(e),this._fill=null)},_updatePath:function(){var t=this._container.style;t.display="none",this._path.v=this.getPathString()+" ",t.display=""}}),o.Map.include(o.Browser.svg||!o.Browser.vml?{}:{_initPathRoot:function(){if(!this._pathRoot){var t=this._pathRoot=e.createElement("div");t.className="leaflet-vml-container",this._panes.overlayPane.appendChild(t),this.on("moveend",this._updatePathViewport),this._updatePathViewport()}}}),o.Browser.canvas=function(){return!!e.createElement("canvas").getContext}(),o.Path=o.Path.SVG&&!t.L_PREFER_CANVAS||!o.Browser.canvas?o.Path:o.Path.extend({statics:{CANVAS:!0,SVG:!1},redraw:function(){return this._map&&(this.projectLatlngs(),this._requestUpdate()),this},setStyle:function(t){return o.setOptions(this,t),this._map&&(this._updateStyle(),this._requestUpdate()),this},onRemove:function(t){t.off("viewreset",this.projectLatlngs,this).off("moveend",this._updatePath,this),this.options.clickable&&(this._map.off("click",this._onClick,this),this._map.off("mousemove",this._onMouseMove,this)),this._requestUpdate(),this.fire("remove"),this._map=null},_requestUpdate:function(){this._map&&!o.Path._updateRequest&&(o.Path._updateRequest=o.Util.requestAnimFrame(this._fireMapMoveEnd,this._map))},_fireMapMoveEnd:function(){o.Path._updateRequest=null,this.fire("moveend")},_initElements:function(){this._map._initPathRoot(),this._ctx=this._map._canvasCtx},_updateStyle:function(){var t=this.options;t.stroke&&(this._ctx.lineWidth=t.weight,this._ctx.strokeStyle=t.color),t.fill&&(this._ctx.fillStyle=t.fillColor||t.color),t.lineCap&&(this._ctx.lineCap=t.lineCap),t.lineJoin&&(this._ctx.lineJoin=t.lineJoin)},_drawPath:function(){var t,e,i,n,s,a;for(this._ctx.beginPath(),t=0,i=this._parts.length;i>t;t++){for(e=0,n=this._parts[t].length;n>e;e++)s=this._parts[t][e],a=(0===e?"move":"line")+"To",this._ctx[a](s.x,s.y);this instanceof o.Polygon&&this._ctx.closePath()}},_checkIfEmpty:function(){return!this._parts.length},_updatePath:function(){if(!this._checkIfEmpty()){var t=this._ctx,e=this.options;this._drawPath(),t.save(),this._updateStyle(),e.fill&&(t.globalAlpha=e.fillOpacity,t.fill(e.fillRule||"evenodd")),e.stroke&&(t.globalAlpha=e.opacity,t.stroke()),t.restore()}},_initEvents:function(){this.options.clickable&&(this._map.on("mousemove",this._onMouseMove,this),this._map.on("click dblclick contextmenu",this._fireMouseEvent,this))},_fireMouseEvent:function(t){this._containsPoint(t.layerPoint)&&this.fire(t.type,t)},_onMouseMove:function(t){this._map&&!this._map._animatingZoom&&(this._containsPoint(t.layerPoint)?(this._ctx.canvas.style.cursor="pointer",this._mouseInside=!0,this.fire("mouseover",t)):this._mouseInside&&(this._ctx.canvas.style.cursor="",this._mouseInside=!1,this.fire("mouseout",t)))}}),o.Map.include(o.Path.SVG&&!t.L_PREFER_CANVAS||!o.Browser.canvas?{}:{_initPathRoot:function(){var t,i=this._pathRoot;i||(i=this._pathRoot=e.createElement("canvas"),i.style.position="absolute",t=this._canvasCtx=i.getContext("2d"),t.lineCap="round",t.lineJoin="round",this._panes.overlayPane.appendChild(i),this.options.zoomAnimation&&(this._pathRoot.className="leaflet-zoom-animated",this.on("zoomanim",this._animatePathZoom),this.on("zoomend",this._endPathZoom)),this.on("moveend",this._updateCanvasViewport),this._updateCanvasViewport())},_updateCanvasViewport:function(){if(!this._pathZooming){this._updatePathViewport();var t=this._pathViewport,e=t.min,i=t.max.subtract(e),n=this._pathRoot;o.DomUtil.setPosition(n,e),n.width=i.x,n.height=i.y,n.getContext("2d").translate(-e.x,-e.y)}}}),o.LineUtil={simplify:function(t,e){if(!e||!t.length)return t.slice();var i=e*e;return t=this._reducePoints(t,i),t=this._simplifyDP(t,i)},pointToSegmentDistance:function(t,e,i){return Math.sqrt(this._sqClosestPointOnSegment(t,e,i,!0))},closestPointOnSegment:function(t,e,i){return this._sqClosestPointOnSegment(t,e,i)},_simplifyDP:function(t,e){var n=t.length,o=typeof Uint8Array!=i+""?Uint8Array:Array,s=new o(n);s[0]=s[n-1]=1,this._simplifyDPStep(t,s,e,0,n-1);var a,r=[];for(a=0;n>a;a++)s[a]&&r.push(t[a]);return r},_simplifyDPStep:function(t,e,i,n,o){var s,a,r,h=0;for(a=n+1;o-1>=a;a++)r=this._sqClosestPointOnSegment(t[a],t[n],t[o],!0),r>h&&(s=a,h=r);h>i&&(e[s]=1,this._simplifyDPStep(t,e,i,n,s),this._simplifyDPStep(t,e,i,s,o))},_reducePoints:function(t,e){for(var i=[t[0]],n=1,o=0,s=t.length;s>n;n++)this._sqDist(t[n],t[o])>e&&(i.push(t[n]),o=n);return s-1>o&&i.push(t[s-1]),i},clipSegment:function(t,e,i,n){var o,s,a,r=n?this._lastCode:this._getBitCode(t,i),h=this._getBitCode(e,i);for(this._lastCode=h;;){if(!(r|h))return[t,e];if(r&h)return!1;o=r||h,s=this._getEdgeIntersection(t,e,o,i),a=this._getBitCode(s,i),o===r?(t=s,r=a):(e=s,h=a)}},_getEdgeIntersection:function(t,e,i,n){var s=e.x-t.x,a=e.y-t.y,r=n.min,h=n.max;return 8&i?new o.Point(t.x+s*(h.y-t.y)/a,h.y):4&i?new o.Point(t.x+s*(r.y-t.y)/a,r.y):2&i?new o.Point(h.x,t.y+a*(h.x-t.x)/s):1&i?new o.Point(r.x,t.y+a*(r.x-t.x)/s):void 0},_getBitCode:function(t,e){var i=0;return t.x<e.min.x?i|=1:t.x>e.max.x&&(i|=2),t.y<e.min.y?i|=4:t.y>e.max.y&&(i|=8),i},_sqDist:function(t,e){var i=e.x-t.x,n=e.y-t.y;return i*i+n*n},_sqClosestPointOnSegment:function(t,e,i,n){var s,a=e.x,r=e.y,h=i.x-a,l=i.y-r,u=h*h+l*l;return u>0&&(s=((t.x-a)*h+(t.y-r)*l)/u,s>1?(a=i.x,r=i.y):s>0&&(a+=h*s,r+=l*s)),h=t.x-a,l=t.y-r,n?h*h+l*l:new o.Point(a,r)}},o.Polyline=o.Path.extend({initialize:function(t,e){o.Path.prototype.initialize.call(this,e),this._latlngs=this._convertLatLngs(t)},options:{smoothFactor:1,noClip:!1},projectLatlngs:function(){this._originalPoints=[];for(var t=0,e=this._latlngs.length;e>t;t++)this._originalPoints[t]=this._map.latLngToLayerPoint(this._latlngs[t])},getPathString:function(){for(var t=0,e=this._parts.length,i="";e>t;t++)i+=this._getPathPartStr(this._parts[t]);return i},getLatLngs:function(){return this._latlngs},setLatLngs:function(t){return this._latlngs=this._convertLatLngs(t),this.redraw()},addLatLng:function(t){return this._latlngs.push(o.latLng(t)),this.redraw()},spliceLatLngs:function(){var t=[].splice.apply(this._latlngs,arguments);return this._convertLatLngs(this._latlngs,!0),this.redraw(),t},closestLayerPoint:function(t){for(var e,i,n=1/0,s=this._parts,a=null,r=0,h=s.length;h>r;r++)for(var l=s[r],u=1,c=l.length;c>u;u++){e=l[u-1],i=l[u];var d=o.LineUtil._sqClosestPointOnSegment(t,e,i,!0);n>d&&(n=d,a=o.LineUtil._sqClosestPointOnSegment(t,e,i))}return a&&(a.distance=Math.sqrt(n)),a},getBounds:function(){return new o.LatLngBounds(this.getLatLngs())},_convertLatLngs:function(t,e){var i,n,s=e?t:[];for(i=0,n=t.length;n>i;i++){if(o.Util.isArray(t[i])&&"number"!=typeof t[i][0])return;s[i]=o.latLng(t[i])}return s},_initEvents:function(){o.Path.prototype._initEvents.call(this)},_getPathPartStr:function(t){for(var e,i=o.Path.VML,n=0,s=t.length,a="";s>n;n++)e=t[n],i&&e._round(),a+=(n?"L":"M")+e.x+" "+e.y;return a},_clipPoints:function(){var t,e,i,n=this._originalPoints,s=n.length;if(this.options.noClip)return void(this._parts=[n]);this._parts=[];var a=this._parts,r=this._map._pathViewport,h=o.LineUtil;for(t=0,e=0;s-1>t;t++)i=h.clipSegment(n[t],n[t+1],r,t),i&&(a[e]=a[e]||[],a[e].push(i[0]),(i[1]!==n[t+1]||t===s-2)&&(a[e].push(i[1]),e++))},_simplifyPoints:function(){for(var t=this._parts,e=o.LineUtil,i=0,n=t.length;n>i;i++)t[i]=e.simplify(t[i],this.options.smoothFactor)},_updatePath:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),o.Path.prototype._updatePath.call(this))}}),o.polyline=function(t,e){return new o.Polyline(t,e)},o.PolyUtil={},o.PolyUtil.clipPolygon=function(t,e){var i,n,s,a,r,h,l,u,c,d=[1,4,2,8],p=o.LineUtil;for(n=0,l=t.length;l>n;n++)t[n]._code=p._getBitCode(t[n],e);for(a=0;4>a;a++){for(u=d[a],i=[],n=0,l=t.length,s=l-1;l>n;s=n++)r=t[n],h=t[s],r._code&u?h._code&u||(c=p._getEdgeIntersection(h,r,u,e),c._code=p._getBitCode(c,e),i.push(c)):(h._code&u&&(c=p._getEdgeIntersection(h,r,u,e),c._code=p._getBitCode(c,e),i.push(c)),i.push(r));t=i}return t},o.Polygon=o.Polyline.extend({options:{fill:!0},initialize:function(t,e){o.Polyline.prototype.initialize.call(this,t,e),this._initWithHoles(t)},_initWithHoles:function(t){var e,i,n;if(t&&o.Util.isArray(t[0])&&"number"!=typeof t[0][0])for(this._latlngs=this._convertLatLngs(t[0]),this._holes=t.slice(1),e=0,i=this._holes.length;i>e;e++)n=this._holes[e]=this._convertLatLngs(this._holes[e]),n[0].equals(n[n.length-1])&&n.pop();t=this._latlngs,t.length>=2&&t[0].equals(t[t.length-1])&&t.pop()},projectLatlngs:function(){if(o.Polyline.prototype.projectLatlngs.call(this),this._holePoints=[],this._holes){var t,e,i,n;for(t=0,i=this._holes.length;i>t;t++)for(this._holePoints[t]=[],e=0,n=this._holes[t].length;n>e;e++)this._holePoints[t][e]=this._map.latLngToLayerPoint(this._holes[t][e])}},setLatLngs:function(t){return t&&o.Util.isArray(t[0])&&"number"!=typeof t[0][0]?(this._initWithHoles(t),this.redraw()):o.Polyline.prototype.setLatLngs.call(this,t)},_clipPoints:function(){var t=this._originalPoints,e=[];if(this._parts=[t].concat(this._holePoints),!this.options.noClip){for(var i=0,n=this._parts.length;n>i;i++){var s=o.PolyUtil.clipPolygon(this._parts[i],this._map._pathViewport);s.length&&e.push(s)}this._parts=e}},_getPathPartStr:function(t){var e=o.Polyline.prototype._getPathPartStr.call(this,t);return e+(o.Browser.svg?"z":"x")}}),o.polygon=function(t,e){return new o.Polygon(t,e)},function(){function t(t){return o.FeatureGroup.extend({initialize:function(t,e){this._layers={},this._options=e,this.setLatLngs(t)},setLatLngs:function(e){var i=0,n=e.length;for(this.eachLayer(function(t){n>i?t.setLatLngs(e[i++]):this.removeLayer(t)},this);n>i;)this.addLayer(new t(e[i++],this._options));return this},getLatLngs:function(){var t=[];return this.eachLayer(function(e){t.push(e.getLatLngs())}),t}})}o.MultiPolyline=t(o.Polyline),o.MultiPolygon=t(o.Polygon),o.multiPolyline=function(t,e){return new o.MultiPolyline(t,e)},o.multiPolygon=function(t,e){return new o.MultiPolygon(t,e)}}(),o.Rectangle=o.Polygon.extend({initialize:function(t,e){o.Polygon.prototype.initialize.call(this,this._boundsToLatLngs(t),e)},setBounds:function(t){this.setLatLngs(this._boundsToLatLngs(t))},_boundsToLatLngs:function(t){return t=o.latLngBounds(t),[t.getSouthWest(),t.getNorthWest(),t.getNorthEast(),t.getSouthEast()]}}),o.rectangle=function(t,e){return new o.Rectangle(t,e)},o.Circle=o.Path.extend({initialize:function(t,e,i){o.Path.prototype.initialize.call(this,i),this._latlng=o.latLng(t),this._mRadius=e},options:{fill:!0},setLatLng:function(t){return this._latlng=o.latLng(t),this.redraw()},setRadius:function(t){return this._mRadius=t,this.redraw()},projectLatlngs:function(){var t=this._getLngRadius(),e=this._latlng,i=this._map.latLngToLayerPoint([e.lat,e.lng-t]);this._point=this._map.latLngToLayerPoint(e),this._radius=Math.max(this._point.x-i.x,1)},getBounds:function(){var t=this._getLngRadius(),e=this._mRadius/40075017*360,i=this._latlng;return new o.LatLngBounds([i.lat-e,i.lng-t],[i.lat+e,i.lng+t])},getLatLng:function(){return this._latlng},getPathString:function(){var t=this._point,e=this._radius;return this._checkIfEmpty()?"":o.Browser.svg?"M"+t.x+","+(t.y-e)+"A"+e+","+e+",0,1,1,"+(t.x-.1)+","+(t.y-e)+" z":(t._round(),e=Math.round(e),"AL "+t.x+","+t.y+" "+e+","+e+" 0,23592600")},getRadius:function(){return this._mRadius},_getLatRadius:function(){return this._mRadius/40075017*360},_getLngRadius:function(){return this._getLatRadius()/Math.cos(o.LatLng.DEG_TO_RAD*this._latlng.lat)},_checkIfEmpty:function(){if(!this._map)return!1;var t=this._map._pathViewport,e=this._radius,i=this._point;return i.x-e>t.max.x||i.y-e>t.max.y||i.x+e<t.min.x||i.y+e<t.min.y}}),o.circle=function(t,e,i){return new o.Circle(t,e,i)},o.CircleMarker=o.Circle.extend({options:{radius:10,weight:2},initialize:function(t,e){o.Circle.prototype.initialize.call(this,t,null,e),this._radius=this.options.radius},projectLatlngs:function(){this._point=this._map.latLngToLayerPoint(this._latlng)},_updateStyle:function(){o.Circle.prototype._updateStyle.call(this),this.setRadius(this.options.radius)},setLatLng:function(t){return o.Circle.prototype.setLatLng.call(this,t),this._popup&&this._popup._isOpen&&this._popup.setLatLng(t),this},setRadius:function(t){return this.options.radius=this._radius=t,this.redraw()},getRadius:function(){return this._radius}}),o.circleMarker=function(t,e){return new o.CircleMarker(t,e)},o.Polyline.include(o.Path.CANVAS?{_containsPoint:function(t,e){var i,n,s,a,r,h,l,u=this.options.weight/2;for(o.Browser.touch&&(u+=10),i=0,a=this._parts.length;a>i;i++)for(l=this._parts[i],n=0,r=l.length,s=r-1;r>n;s=n++)if((e||0!==n)&&(h=o.LineUtil.pointToSegmentDistance(t,l[s],l[n]),u>=h))return!0;return!1}}:{}),o.Polygon.include(o.Path.CANVAS?{_containsPoint:function(t){var e,i,n,s,a,r,h,l,u=!1;if(o.Polyline.prototype._containsPoint.call(this,t,!0))return!0;for(s=0,h=this._parts.length;h>s;s++)for(e=this._parts[s],a=0,l=e.length,r=l-1;l>a;r=a++)i=e[a],n=e[r],i.y>t.y!=n.y>t.y&&t.x<(n.x-i.x)*(t.y-i.y)/(n.y-i.y)+i.x&&(u=!u);return u}}:{}),o.Circle.include(o.Path.CANVAS?{_drawPath:function(){var t=this._point;this._ctx.beginPath(),this._ctx.arc(t.x,t.y,this._radius,0,2*Math.PI,!1)},_containsPoint:function(t){var e=this._point,i=this.options.stroke?this.options.weight/2:0;return t.distanceTo(e)<=this._radius+i}}:{}),o.CircleMarker.include(o.Path.CANVAS?{_updateStyle:function(){o.Path.prototype._updateStyle.call(this)}}:{}),o.GeoJSON=o.FeatureGroup.extend({initialize:function(t,e){o.setOptions(this,e),this._layers={},t&&this.addData(t)},addData:function(t){var e,i,n,s=o.Util.isArray(t)?t:t.features;if(s){for(e=0,i=s.length;i>e;e++)n=s[e],(n.geometries||n.geometry||n.features||n.coordinates)&&this.addData(s[e]);return this}var a=this.options;if(!a.filter||a.filter(t)){var r=o.GeoJSON.geometryToLayer(t,a.pointToLayer,a.coordsToLatLng,a);return r.feature=o.GeoJSON.asFeature(t),r.defaultOptions=r.options,this.resetStyle(r),a.onEachFeature&&a.onEachFeature(t,r),this.addLayer(r)}},resetStyle:function(t){var e=this.options.style;e&&(o.Util.extend(t.options,t.defaultOptions),this._setLayerStyle(t,e))},setStyle:function(t){this.eachLayer(function(e){this._setLayerStyle(e,t)},this)},_setLayerStyle:function(t,e){"function"==typeof e&&(e=e(t.feature)),t.setStyle&&t.setStyle(e)}}),o.extend(o.GeoJSON,{geometryToLayer:function(t,e,i,n){var s,a,r,h,l="Feature"===t.type?t.geometry:t,u=l.coordinates,c=[];switch(i=i||this.coordsToLatLng,l.type){case"Point":return s=i(u),e?e(t,s):new o.Marker(s);case"MultiPoint":for(r=0,h=u.length;h>r;r++)s=i(u[r]),c.push(e?e(t,s):new o.Marker(s));return new o.FeatureGroup(c);case"LineString":return a=this.coordsToLatLngs(u,0,i),new o.Polyline(a,n);case"Polygon":if(2===u.length&&!u[1].length)throw new Error("Invalid GeoJSON object.");return a=this.coordsToLatLngs(u,1,i),new o.Polygon(a,n);case"MultiLineString":return a=this.coordsToLatLngs(u,1,i),new o.MultiPolyline(a,n);case"MultiPolygon":return a=this.coordsToLatLngs(u,2,i),new o.MultiPolygon(a,n);case"GeometryCollection":for(r=0,h=l.geometries.length;h>r;r++)c.push(this.geometryToLayer({geometry:l.geometries[r],type:"Feature",properties:t.properties},e,i,n));return new o.FeatureGroup(c);default:throw new Error("Invalid GeoJSON object.")}},coordsToLatLng:function(t){return new o.LatLng(t[1],t[0],t[2])},coordsToLatLngs:function(t,e,i){var n,o,s,a=[];for(o=0,s=t.length;s>o;o++)n=e?this.coordsToLatLngs(t[o],e-1,i):(i||this.coordsToLatLng)(t[o]),a.push(n);return a},latLngToCoords:function(t){var e=[t.lng,t.lat];return t.alt!==i&&e.push(t.alt),e},latLngsToCoords:function(t){for(var e=[],i=0,n=t.length;n>i;i++)e.push(o.GeoJSON.latLngToCoords(t[i]));return e},getFeature:function(t,e){return t.feature?o.extend({},t.feature,{geometry:e}):o.GeoJSON.asFeature(e)},asFeature:function(t){return"Feature"===t.type?t:{type:"Feature",properties:{},geometry:t}}});var a={toGeoJSON:function(){return o.GeoJSON.getFeature(this,{type:"Point",coordinates:o.GeoJSON.latLngToCoords(this.getLatLng())})}};o.Marker.include(a),o.Circle.include(a),o.CircleMarker.include(a),o.Polyline.include({toGeoJSON:function(){return o.GeoJSON.getFeature(this,{type:"LineString",coordinates:o.GeoJSON.latLngsToCoords(this.getLatLngs())})}}),o.Polygon.include({toGeoJSON:function(){var t,e,i,n=[o.GeoJSON.latLngsToCoords(this.getLatLngs())];if(n[0].push(n[0][0]),this._holes)for(t=0,e=this._holes.length;e>t;t++)i=o.GeoJSON.latLngsToCoords(this._holes[t]),i.push(i[0]),n.push(i);return o.GeoJSON.getFeature(this,{type:"Polygon",coordinates:n})}}),function(){function t(t){return function(){var e=[];return this.eachLayer(function(t){e.push(t.toGeoJSON().geometry.coordinates)}),o.GeoJSON.getFeature(this,{type:t,coordinates:e})}}o.MultiPolyline.include({toGeoJSON:t("MultiLineString")}),o.MultiPolygon.include({toGeoJSON:t("MultiPolygon")}),o.LayerGroup.include({toGeoJSON:function(){var e,i=this.feature&&this.feature.geometry,n=[];if(i&&"MultiPoint"===i.type)return t("MultiPoint").call(this);var s=i&&"GeometryCollection"===i.type;return this.eachLayer(function(t){t.toGeoJSON&&(e=t.toGeoJSON(),n.push(s?e.geometry:o.GeoJSON.asFeature(e)))}),s?o.GeoJSON.getFeature(this,{geometries:n,type:"GeometryCollection"}):{type:"FeatureCollection",features:n}}})}(),o.geoJson=function(t,e){return new o.GeoJSON(t,e)},o.DomEvent={addListener:function(t,e,i,n){var s,a,r,h=o.stamp(i),l="_leaflet_"+e+h;return t[l]?this:(s=function(e){return i.call(n||t,e||o.DomEvent._getEvent())},o.Browser.pointer&&0===e.indexOf("touch")?this.addPointerListener(t,e,s,h):(o.Browser.touch&&"dblclick"===e&&this.addDoubleTapListener&&this.addDoubleTapListener(t,s,h),"addEventListener"in t?"mousewheel"===e?(t.addEventListener("DOMMouseScroll",s,!1),t.addEventListener(e,s,!1)):"mouseenter"===e||"mouseleave"===e?(a=s,r="mouseenter"===e?"mouseover":"mouseout",s=function(e){return o.DomEvent._checkMouse(t,e)?a(e):void 0},t.addEventListener(r,s,!1)):"click"===e&&o.Browser.android?(a=s,s=function(t){return o.DomEvent._filterClick(t,a)},t.addEventListener(e,s,!1)):t.addEventListener(e,s,!1):"attachEvent"in t&&t.attachEvent("on"+e,s),t[l]=s,this))},removeListener:function(t,e,i){var n=o.stamp(i),s="_leaflet_"+e+n,a=t[s];return a?(o.Browser.pointer&&0===e.indexOf("touch")?this.removePointerListener(t,e,n):o.Browser.touch&&"dblclick"===e&&this.removeDoubleTapListener?this.removeDoubleTapListener(t,n):"removeEventListener"in t?"mousewheel"===e?(t.removeEventListener("DOMMouseScroll",a,!1),t.removeEventListener(e,a,!1)):"mouseenter"===e||"mouseleave"===e?t.removeEventListener("mouseenter"===e?"mouseover":"mouseout",a,!1):t.removeEventListener(e,a,!1):"detachEvent"in t&&t.detachEvent("on"+e,a),t[s]=null,this):this},stopPropagation:function(t){return t.stopPropagation?t.stopPropagation():t.cancelBubble=!0,o.DomEvent._skipped(t),this},disableScrollPropagation:function(t){var e=o.DomEvent.stopPropagation;return o.DomEvent.on(t,"mousewheel",e).on(t,"MozMousePixelScroll",e)},disableClickPropagation:function(t){for(var e=o.DomEvent.stopPropagation,i=o.Draggable.START.length-1;i>=0;i--)o.DomEvent.on(t,o.Draggable.START[i],e);return o.DomEvent.on(t,"click",o.DomEvent._fakeStop).on(t,"dblclick",e)},preventDefault:function(t){return t.preventDefault?t.preventDefault():t.returnValue=!1,this},stop:function(t){return o.DomEvent.preventDefault(t).stopPropagation(t)},getMousePosition:function(t,e){if(!e)return new o.Point(t.clientX,t.clientY);var i=e.getBoundingClientRect();return new o.Point(t.clientX-i.left-e.clientLeft,t.clientY-i.top-e.clientTop)},getWheelDelta:function(t){var e=0;return t.wheelDelta&&(e=t.wheelDelta/120),t.detail&&(e=-t.detail/3),e},_skipEvents:{},_fakeStop:function(t){o.DomEvent._skipEvents[t.type]=!0},_skipped:function(t){var e=this._skipEvents[t.type];return this._skipEvents[t.type]=!1,e},_checkMouse:function(t,e){var i=e.relatedTarget;if(!i)return!0;try{for(;i&&i!==t;)i=i.parentNode}catch(n){return!1}return i!==t},_getEvent:function(){var e=t.event;if(!e)for(var i=arguments.callee.caller;i&&(e=i.arguments[0],!e||t.Event!==e.constructor);)i=i.caller;return e},_filterClick:function(t,e){var i=t.timeStamp||t.originalEvent.timeStamp,n=o.DomEvent._lastClick&&i-o.DomEvent._lastClick;return n&&n>100&&500>n||t.target._simulatedClick&&!t._simulated?void o.DomEvent.stop(t):(o.DomEvent._lastClick=i,e(t))}},o.DomEvent.on=o.DomEvent.addListener,o.DomEvent.off=o.DomEvent.removeListener,o.Draggable=o.Class.extend({includes:o.Mixin.Events,statics:{START:o.Browser.touch?["touchstart","mousedown"]:["mousedown"],END:{mousedown:"mouseup",touchstart:"touchend",pointerdown:"touchend",MSPointerDown:"touchend"},MOVE:{mousedown:"mousemove",touchstart:"touchmove",pointerdown:"touchmove",MSPointerDown:"touchmove"}},initialize:function(t,e){this._element=t,this._dragStartTarget=e||t},enable:function(){if(!this._enabled){for(var t=o.Draggable.START.length-1;t>=0;t--)o.DomEvent.on(this._dragStartTarget,o.Draggable.START[t],this._onDown,this);this._enabled=!0}},disable:function(){if(this._enabled){for(var t=o.Draggable.START.length-1;t>=0;t--)o.DomEvent.off(this._dragStartTarget,o.Draggable.START[t],this._onDown,this);this._enabled=!1,this._moved=!1}},_onDown:function(t){if(this._moved=!1,!t.shiftKey&&(1===t.which||1===t.button||t.touches)&&(o.DomEvent.stopPropagation(t),!o.Draggable._disabled&&(o.DomUtil.disableImageDrag(),o.DomUtil.disableTextSelection(),!this._moving))){var i=t.touches?t.touches[0]:t;this._startPoint=new o.Point(i.clientX,i.clientY),this._startPos=this._newPos=o.DomUtil.getPosition(this._element),o.DomEvent.on(e,o.Draggable.MOVE[t.type],this._onMove,this).on(e,o.Draggable.END[t.type],this._onUp,this)}},_onMove:function(t){if(t.touches&&t.touches.length>1)return void(this._moved=!0);var i=t.touches&&1===t.touches.length?t.touches[0]:t,n=new o.Point(i.clientX,i.clientY),s=n.subtract(this._startPoint);(s.x||s.y)&&(o.Browser.touch&&Math.abs(s.x)+Math.abs(s.y)<3||(o.DomEvent.preventDefault(t),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=o.DomUtil.getPosition(this._element).subtract(s),o.DomUtil.addClass(e.body,"leaflet-dragging"),this._lastTarget=t.target||t.srcElement,o.DomUtil.addClass(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(s),this._moving=!0,o.Util.cancelAnimFrame(this._animRequest),this._animRequest=o.Util.requestAnimFrame(this._updatePosition,this,!0,this._dragStartTarget)))},_updatePosition:function(){this.fire("predrag"),o.DomUtil.setPosition(this._element,this._newPos),this.fire("drag")},_onUp:function(){o.DomUtil.removeClass(e.body,"leaflet-dragging"),this._lastTarget&&(o.DomUtil.removeClass(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null);for(var t in o.Draggable.MOVE)o.DomEvent.off(e,o.Draggable.MOVE[t],this._onMove).off(e,o.Draggable.END[t],this._onUp);o.DomUtil.enableImageDrag(),o.DomUtil.enableTextSelection(),this._moved&&this._moving&&(o.Util.cancelAnimFrame(this._animRequest),this.fire("dragend",{distance:this._newPos.distanceTo(this._startPos)})),this._moving=!1}}),o.Handler=o.Class.extend({initialize:function(t){this._map=t},enable:function(){this._enabled||(this._enabled=!0,this.addHooks())},disable:function(){this._enabled&&(this._enabled=!1,this.removeHooks())},enabled:function(){return!!this._enabled}}),o.Map.mergeOptions({dragging:!0,inertia:!o.Browser.android23,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,inertiaThreshold:o.Browser.touch?32:18,easeLinearity:.25,worldCopyJump:!1}),o.Map.Drag=o.Handler.extend({addHooks:function(){if(!this._draggable){var t=this._map;this._draggable=new o.Draggable(t._mapPane,t._container),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),t.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDrag,this),t.on("viewreset",this._onViewReset,this),t.whenReady(this._onViewReset,this))}this._draggable.enable()},removeHooks:function(){this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},_onDragStart:function(){var t=this._map;t._panAnim&&t._panAnim.stop(),t.fire("movestart").fire("dragstart"),t.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(){if(this._map.options.inertia){var t=this._lastTime=+new Date,e=this._lastPos=this._draggable._newPos;this._positions.push(e),this._times.push(t),t-this._times[0]>200&&(this._positions.shift(),this._times.shift())}this._map.fire("move").fire("drag")},_onViewReset:function(){var t=this._map.getSize()._divideBy(2),e=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=e.subtract(t).x,this._worldWidth=this._map.project([0,180]).x},_onPreDrag:function(){var t=this._worldWidth,e=Math.round(t/2),i=this._initialWorldOffset,n=this._draggable._newPos.x,o=(n-e+i)%t+e-i,s=(n+e+i)%t-e-i,a=Math.abs(o+i)<Math.abs(s+i)?o:s;this._draggable._newPos.x=a},_onDragEnd:function(t){var e=this._map,i=e.options,n=+new Date-this._lastTime,s=!i.inertia||n>i.inertiaThreshold||!this._positions[0];if(e.fire("dragend",t),s)e.fire("moveend");else{var a=this._lastPos.subtract(this._positions[0]),r=(this._lastTime+n-this._times[0])/1e3,h=i.easeLinearity,l=a.multiplyBy(h/r),u=l.distanceTo([0,0]),c=Math.min(i.inertiaMaxSpeed,u),d=l.multiplyBy(c/u),p=c/(i.inertiaDeceleration*h),_=d.multiplyBy(-p/2).round();_.x&&_.y?(_=e._limitOffset(_,e.options.maxBounds),o.Util.requestAnimFrame(function(){e.panBy(_,{duration:p,easeLinearity:h,noMoveStart:!0})})):e.fire("moveend")}}}),o.Map.addInitHook("addHandler","dragging",o.Map.Drag),o.Map.mergeOptions({doubleClickZoom:!0}),o.Map.DoubleClickZoom=o.Handler.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(t){var e=this._map,i=e.getZoom()+(t.originalEvent.shiftKey?-1:1);"center"===e.options.doubleClickZoom?e.setZoom(i):e.setZoomAround(t.containerPoint,i)}}),o.Map.addInitHook("addHandler","doubleClickZoom",o.Map.DoubleClickZoom),o.Map.mergeOptions({scrollWheelZoom:!0}),o.Map.ScrollWheelZoom=o.Handler.extend({addHooks:function(){o.DomEvent.on(this._map._container,"mousewheel",this._onWheelScroll,this),o.DomEvent.on(this._map._container,"MozMousePixelScroll",o.DomEvent.preventDefault),this._delta=0},removeHooks:function(){o.DomEvent.off(this._map._container,"mousewheel",this._onWheelScroll),o.DomEvent.off(this._map._container,"MozMousePixelScroll",o.DomEvent.preventDefault)},_onWheelScroll:function(t){var e=o.DomEvent.getWheelDelta(t);this._delta+=e,this._lastMousePos=this._map.mouseEventToContainerPoint(t),this._startTime||(this._startTime=+new Date);var i=Math.max(40-(+new Date-this._startTime),0);clearTimeout(this._timer),this._timer=setTimeout(o.bind(this._performZoom,this),i),o.DomEvent.preventDefault(t),o.DomEvent.stopPropagation(t)},_performZoom:function(){var t=this._map,e=this._delta,i=t.getZoom();e=e>0?Math.ceil(e):Math.floor(e),e=Math.max(Math.min(e,4),-4),e=t._limitZoom(i+e)-i,this._delta=0,this._startTime=null,e&&("center"===t.options.scrollWheelZoom?t.setZoom(i+e):t.setZoomAround(this._lastMousePos,i+e))}}),o.Map.addInitHook("addHandler","scrollWheelZoom",o.Map.ScrollWheelZoom),o.extend(o.DomEvent,{_touchstart:o.Browser.msPointer?"MSPointerDown":o.Browser.pointer?"pointerdown":"touchstart",_touchend:o.Browser.msPointer?"MSPointerUp":o.Browser.pointer?"pointerup":"touchend",addDoubleTapListener:function(t,i,n){function s(t){var e;if(o.Browser.pointer?(_.push(t.pointerId),e=_.length):e=t.touches.length,!(e>1)){var i=Date.now(),n=i-(r||i);h=t.touches?t.touches[0]:t,l=n>0&&u>=n,r=i}}function a(t){if(o.Browser.pointer){var e=_.indexOf(t.pointerId);if(-1===e)return;_.splice(e,1)}if(l){if(o.Browser.pointer){var n,s={};for(var a in h)n=h[a],"function"==typeof n?s[a]=n.bind(h):s[a]=n;h=s}h.type="dblclick",i(h),r=null}}var r,h,l=!1,u=250,c="_leaflet_",d=this._touchstart,p=this._touchend,_=[];t[c+d+n]=s,t[c+p+n]=a;var m=o.Browser.pointer?e.documentElement:t;return t.addEventListener(d,s,!1),m.addEventListener(p,a,!1),o.Browser.pointer&&m.addEventListener(o.DomEvent.POINTER_CANCEL,a,!1),this},removeDoubleTapListener:function(t,i){var n="_leaflet_";return t.removeEventListener(this._touchstart,t[n+this._touchstart+i],!1),(o.Browser.pointer?e.documentElement:t).removeEventListener(this._touchend,t[n+this._touchend+i],!1),o.Browser.pointer&&e.documentElement.removeEventListener(o.DomEvent.POINTER_CANCEL,t[n+this._touchend+i],!1),this}}),o.extend(o.DomEvent,{POINTER_DOWN:o.Browser.msPointer?"MSPointerDown":"pointerdown",POINTER_MOVE:o.Browser.msPointer?"MSPointerMove":"pointermove",POINTER_UP:o.Browser.msPointer?"MSPointerUp":"pointerup",POINTER_CANCEL:o.Browser.msPointer?"MSPointerCancel":"pointercancel",_pointers:[],_pointerDocumentListener:!1,addPointerListener:function(t,e,i,n){switch(e){case"touchstart":return this.addPointerListenerStart(t,e,i,n);
	case"touchend":return this.addPointerListenerEnd(t,e,i,n);case"touchmove":return this.addPointerListenerMove(t,e,i,n);default:throw"Unknown touch event type"}},addPointerListenerStart:function(t,i,n,s){var a="_leaflet_",r=this._pointers,h=function(t){"mouse"!==t.pointerType&&t.pointerType!==t.MSPOINTER_TYPE_MOUSE&&o.DomEvent.preventDefault(t);for(var e=!1,i=0;i<r.length;i++)if(r[i].pointerId===t.pointerId){e=!0;break}e||r.push(t),t.touches=r.slice(),t.changedTouches=[t],n(t)};if(t[a+"touchstart"+s]=h,t.addEventListener(this.POINTER_DOWN,h,!1),!this._pointerDocumentListener){var l=function(t){for(var e=0;e<r.length;e++)if(r[e].pointerId===t.pointerId){r.splice(e,1);break}};e.documentElement.addEventListener(this.POINTER_UP,l,!1),e.documentElement.addEventListener(this.POINTER_CANCEL,l,!1),this._pointerDocumentListener=!0}return this},addPointerListenerMove:function(t,e,i,n){function o(t){if(t.pointerType!==t.MSPOINTER_TYPE_MOUSE&&"mouse"!==t.pointerType||0!==t.buttons){for(var e=0;e<a.length;e++)if(a[e].pointerId===t.pointerId){a[e]=t;break}t.touches=a.slice(),t.changedTouches=[t],i(t)}}var s="_leaflet_",a=this._pointers;return t[s+"touchmove"+n]=o,t.addEventListener(this.POINTER_MOVE,o,!1),this},addPointerListenerEnd:function(t,e,i,n){var o="_leaflet_",s=this._pointers,a=function(t){for(var e=0;e<s.length;e++)if(s[e].pointerId===t.pointerId){s.splice(e,1);break}t.touches=s.slice(),t.changedTouches=[t],i(t)};return t[o+"touchend"+n]=a,t.addEventListener(this.POINTER_UP,a,!1),t.addEventListener(this.POINTER_CANCEL,a,!1),this},removePointerListener:function(t,e,i){var n="_leaflet_",o=t[n+e+i];switch(e){case"touchstart":t.removeEventListener(this.POINTER_DOWN,o,!1);break;case"touchmove":t.removeEventListener(this.POINTER_MOVE,o,!1);break;case"touchend":t.removeEventListener(this.POINTER_UP,o,!1),t.removeEventListener(this.POINTER_CANCEL,o,!1)}return this}}),o.Map.mergeOptions({touchZoom:o.Browser.touch&&!o.Browser.android23,bounceAtZoomLimits:!0}),o.Map.TouchZoom=o.Handler.extend({addHooks:function(){o.DomEvent.on(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){o.DomEvent.off(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(t){var i=this._map;if(t.touches&&2===t.touches.length&&!i._animatingZoom&&!this._zooming){var n=i.mouseEventToLayerPoint(t.touches[0]),s=i.mouseEventToLayerPoint(t.touches[1]),a=i._getCenterLayerPoint();this._startCenter=n.add(s)._divideBy(2),this._startDist=n.distanceTo(s),this._moved=!1,this._zooming=!0,this._centerOffset=a.subtract(this._startCenter),i._panAnim&&i._panAnim.stop(),o.DomEvent.on(e,"touchmove",this._onTouchMove,this).on(e,"touchend",this._onTouchEnd,this),o.DomEvent.preventDefault(t)}},_onTouchMove:function(t){var e=this._map;if(t.touches&&2===t.touches.length&&this._zooming){var i=e.mouseEventToLayerPoint(t.touches[0]),n=e.mouseEventToLayerPoint(t.touches[1]);this._scale=i.distanceTo(n)/this._startDist,this._delta=i._add(n)._divideBy(2)._subtract(this._startCenter),1!==this._scale&&(e.options.bounceAtZoomLimits||!(e.getZoom()===e.getMinZoom()&&this._scale<1||e.getZoom()===e.getMaxZoom()&&this._scale>1))&&(this._moved||(o.DomUtil.addClass(e._mapPane,"leaflet-touching"),e.fire("movestart").fire("zoomstart"),this._moved=!0),o.Util.cancelAnimFrame(this._animRequest),this._animRequest=o.Util.requestAnimFrame(this._updateOnMove,this,!0,this._map._container),o.DomEvent.preventDefault(t))}},_updateOnMove:function(){var t=this._map,e=this._getScaleOrigin(),i=t.layerPointToLatLng(e),n=t.getScaleZoom(this._scale);t._animateZoom(i,n,this._startCenter,this._scale,this._delta,!1,!0)},_onTouchEnd:function(){if(!this._moved||!this._zooming)return void(this._zooming=!1);var t=this._map;this._zooming=!1,o.DomUtil.removeClass(t._mapPane,"leaflet-touching"),o.Util.cancelAnimFrame(this._animRequest),o.DomEvent.off(e,"touchmove",this._onTouchMove).off(e,"touchend",this._onTouchEnd);var i=this._getScaleOrigin(),n=t.layerPointToLatLng(i),s=t.getZoom(),a=t.getScaleZoom(this._scale)-s,r=a>0?Math.ceil(a):Math.floor(a),h=t._limitZoom(s+r),l=t.getZoomScale(h)/this._scale;t._animateZoom(n,h,i,l)},_getScaleOrigin:function(){var t=this._centerOffset.subtract(this._delta).divideBy(this._scale);return this._startCenter.add(t)}}),o.Map.addInitHook("addHandler","touchZoom",o.Map.TouchZoom),o.Map.mergeOptions({tap:!0,tapTolerance:15}),o.Map.Tap=o.Handler.extend({addHooks:function(){o.DomEvent.on(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){o.DomEvent.off(this._map._container,"touchstart",this._onDown,this)},_onDown:function(t){if(t.touches){if(o.DomEvent.preventDefault(t),this._fireClick=!0,t.touches.length>1)return this._fireClick=!1,void clearTimeout(this._holdTimeout);var i=t.touches[0],n=i.target;this._startPos=this._newPos=new o.Point(i.clientX,i.clientY),n.tagName&&"a"===n.tagName.toLowerCase()&&o.DomUtil.addClass(n,"leaflet-active"),this._holdTimeout=setTimeout(o.bind(function(){this._isTapValid()&&(this._fireClick=!1,this._onUp(),this._simulateEvent("contextmenu",i))},this),1e3),o.DomEvent.on(e,"touchmove",this._onMove,this).on(e,"touchend",this._onUp,this)}},_onUp:function(t){if(clearTimeout(this._holdTimeout),o.DomEvent.off(e,"touchmove",this._onMove,this).off(e,"touchend",this._onUp,this),this._fireClick&&t&&t.changedTouches){var i=t.changedTouches[0],n=i.target;n&&n.tagName&&"a"===n.tagName.toLowerCase()&&o.DomUtil.removeClass(n,"leaflet-active"),this._isTapValid()&&this._simulateEvent("click",i)}},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_onMove:function(t){var e=t.touches[0];this._newPos=new o.Point(e.clientX,e.clientY)},_simulateEvent:function(i,n){var o=e.createEvent("MouseEvents");o._simulated=!0,n.target._simulatedClick=!0,o.initMouseEvent(i,!0,!0,t,1,n.screenX,n.screenY,n.clientX,n.clientY,!1,!1,!1,!1,0,null),n.target.dispatchEvent(o)}}),o.Browser.touch&&!o.Browser.pointer&&o.Map.addInitHook("addHandler","tap",o.Map.Tap),o.Map.mergeOptions({boxZoom:!0}),o.Map.BoxZoom=o.Handler.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane,this._moved=!1},addHooks:function(){o.DomEvent.on(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){o.DomEvent.off(this._container,"mousedown",this._onMouseDown),this._moved=!1},moved:function(){return this._moved},_onMouseDown:function(t){return this._moved=!1,!t.shiftKey||1!==t.which&&1!==t.button?!1:(o.DomUtil.disableTextSelection(),o.DomUtil.disableImageDrag(),this._startLayerPoint=this._map.mouseEventToLayerPoint(t),void o.DomEvent.on(e,"mousemove",this._onMouseMove,this).on(e,"mouseup",this._onMouseUp,this).on(e,"keydown",this._onKeyDown,this))},_onMouseMove:function(t){this._moved||(this._box=o.DomUtil.create("div","leaflet-zoom-box",this._pane),o.DomUtil.setPosition(this._box,this._startLayerPoint),this._container.style.cursor="crosshair",this._map.fire("boxzoomstart"));var e=this._startLayerPoint,i=this._box,n=this._map.mouseEventToLayerPoint(t),s=n.subtract(e),a=new o.Point(Math.min(n.x,e.x),Math.min(n.y,e.y));o.DomUtil.setPosition(i,a),this._moved=!0,i.style.width=Math.max(0,Math.abs(s.x)-4)+"px",i.style.height=Math.max(0,Math.abs(s.y)-4)+"px"},_finish:function(){this._moved&&(this._pane.removeChild(this._box),this._container.style.cursor=""),o.DomUtil.enableTextSelection(),o.DomUtil.enableImageDrag(),o.DomEvent.off(e,"mousemove",this._onMouseMove).off(e,"mouseup",this._onMouseUp).off(e,"keydown",this._onKeyDown)},_onMouseUp:function(t){this._finish();var e=this._map,i=e.mouseEventToLayerPoint(t);if(!this._startLayerPoint.equals(i)){var n=new o.LatLngBounds(e.layerPointToLatLng(this._startLayerPoint),e.layerPointToLatLng(i));e.fitBounds(n),e.fire("boxzoomend",{boxZoomBounds:n})}},_onKeyDown:function(t){27===t.keyCode&&this._finish()}}),o.Map.addInitHook("addHandler","boxZoom",o.Map.BoxZoom),o.Map.mergeOptions({keyboard:!0,keyboardPanOffset:80,keyboardZoomOffset:1}),o.Map.Keyboard=o.Handler.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,173]},initialize:function(t){this._map=t,this._setPanOffset(t.options.keyboardPanOffset),this._setZoomOffset(t.options.keyboardZoomOffset)},addHooks:function(){var t=this._map._container;-1===t.tabIndex&&(t.tabIndex="0"),o.DomEvent.on(t,"focus",this._onFocus,this).on(t,"blur",this._onBlur,this).on(t,"mousedown",this._onMouseDown,this),this._map.on("focus",this._addHooks,this).on("blur",this._removeHooks,this)},removeHooks:function(){this._removeHooks();var t=this._map._container;o.DomEvent.off(t,"focus",this._onFocus,this).off(t,"blur",this._onBlur,this).off(t,"mousedown",this._onMouseDown,this),this._map.off("focus",this._addHooks,this).off("blur",this._removeHooks,this)},_onMouseDown:function(){if(!this._focused){var i=e.body,n=e.documentElement,o=i.scrollTop||n.scrollTop,s=i.scrollLeft||n.scrollLeft;this._map._container.focus(),t.scrollTo(s,o)}},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanOffset:function(t){var e,i,n=this._panKeys={},o=this.keyCodes;for(e=0,i=o.left.length;i>e;e++)n[o.left[e]]=[-1*t,0];for(e=0,i=o.right.length;i>e;e++)n[o.right[e]]=[t,0];for(e=0,i=o.down.length;i>e;e++)n[o.down[e]]=[0,t];for(e=0,i=o.up.length;i>e;e++)n[o.up[e]]=[0,-1*t]},_setZoomOffset:function(t){var e,i,n=this._zoomKeys={},o=this.keyCodes;for(e=0,i=o.zoomIn.length;i>e;e++)n[o.zoomIn[e]]=t;for(e=0,i=o.zoomOut.length;i>e;e++)n[o.zoomOut[e]]=-t},_addHooks:function(){o.DomEvent.on(e,"keydown",this._onKeyDown,this)},_removeHooks:function(){o.DomEvent.off(e,"keydown",this._onKeyDown,this)},_onKeyDown:function(t){var e=t.keyCode,i=this._map;if(e in this._panKeys){if(i._panAnim&&i._panAnim._inProgress)return;i.panBy(this._panKeys[e]),i.options.maxBounds&&i.panInsideBounds(i.options.maxBounds)}else{if(!(e in this._zoomKeys))return;i.setZoom(i.getZoom()+this._zoomKeys[e])}o.DomEvent.stop(t)}}),o.Map.addInitHook("addHandler","keyboard",o.Map.Keyboard),o.Handler.MarkerDrag=o.Handler.extend({initialize:function(t){this._marker=t},addHooks:function(){var t=this._marker._icon;this._draggable||(this._draggable=new o.Draggable(t,t)),this._draggable.on("dragstart",this._onDragStart,this).on("drag",this._onDrag,this).on("dragend",this._onDragEnd,this),this._draggable.enable(),o.DomUtil.addClass(this._marker._icon,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off("dragstart",this._onDragStart,this).off("drag",this._onDrag,this).off("dragend",this._onDragEnd,this),this._draggable.disable(),o.DomUtil.removeClass(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_onDragStart:function(){this._marker.closePopup().fire("movestart").fire("dragstart")},_onDrag:function(){var t=this._marker,e=t._shadow,i=o.DomUtil.getPosition(t._icon),n=t._map.layerPointToLatLng(i);e&&o.DomUtil.setPosition(e,i),t._latlng=n,t.fire("move",{latlng:n}).fire("drag")},_onDragEnd:function(t){this._marker.fire("moveend").fire("dragend",t)}}),o.Control=o.Class.extend({options:{position:"topright"},initialize:function(t){o.setOptions(this,t)},getPosition:function(){return this.options.position},setPosition:function(t){var e=this._map;return e&&e.removeControl(this),this.options.position=t,e&&e.addControl(this),this},getContainer:function(){return this._container},addTo:function(t){this._map=t;var e=this._container=this.onAdd(t),i=this.getPosition(),n=t._controlCorners[i];return o.DomUtil.addClass(e,"leaflet-control"),-1!==i.indexOf("bottom")?n.insertBefore(e,n.firstChild):n.appendChild(e),this},removeFrom:function(t){var e=this.getPosition(),i=t._controlCorners[e];return i.removeChild(this._container),this._map=null,this.onRemove&&this.onRemove(t),this},_refocusOnMap:function(){this._map&&this._map.getContainer().focus()}}),o.control=function(t){return new o.Control(t)},o.Map.include({addControl:function(t){return t.addTo(this),this},removeControl:function(t){return t.removeFrom(this),this},_initControlPos:function(){function t(t,s){var a=i+t+" "+i+s;e[t+s]=o.DomUtil.create("div",a,n)}var e=this._controlCorners={},i="leaflet-",n=this._controlContainer=o.DomUtil.create("div",i+"control-container",this._container);t("top","left"),t("top","right"),t("bottom","left"),t("bottom","right")},_clearControlPos:function(){this._container.removeChild(this._controlContainer)}}),o.Control.Zoom=o.Control.extend({options:{position:"topleft",zoomInText:"+",zoomInTitle:"Zoom in",zoomOutText:"-",zoomOutTitle:"Zoom out"},onAdd:function(t){var e="leaflet-control-zoom",i=o.DomUtil.create("div",e+" leaflet-bar");return this._map=t,this._zoomInButton=this._createButton(this.options.zoomInText,this.options.zoomInTitle,e+"-in",i,this._zoomIn,this),this._zoomOutButton=this._createButton(this.options.zoomOutText,this.options.zoomOutTitle,e+"-out",i,this._zoomOut,this),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),i},onRemove:function(t){t.off("zoomend zoomlevelschange",this._updateDisabled,this)},_zoomIn:function(t){this._map.zoomIn(t.shiftKey?3:1)},_zoomOut:function(t){this._map.zoomOut(t.shiftKey?3:1)},_createButton:function(t,e,i,n,s,a){var r=o.DomUtil.create("a",i,n);r.innerHTML=t,r.href="#",r.title=e;var h=o.DomEvent.stopPropagation;return o.DomEvent.on(r,"click",h).on(r,"mousedown",h).on(r,"dblclick",h).on(r,"click",o.DomEvent.preventDefault).on(r,"click",s,a).on(r,"click",this._refocusOnMap,a),r},_updateDisabled:function(){var t=this._map,e="leaflet-disabled";o.DomUtil.removeClass(this._zoomInButton,e),o.DomUtil.removeClass(this._zoomOutButton,e),t._zoom===t.getMinZoom()&&o.DomUtil.addClass(this._zoomOutButton,e),t._zoom===t.getMaxZoom()&&o.DomUtil.addClass(this._zoomInButton,e)}}),o.Map.mergeOptions({zoomControl:!0}),o.Map.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new o.Control.Zoom,this.addControl(this.zoomControl))}),o.control.zoom=function(t){return new o.Control.Zoom(t)},o.Control.Attribution=o.Control.extend({options:{position:"bottomright",prefix:'<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'},initialize:function(t){o.setOptions(this,t),this._attributions={}},onAdd:function(t){this._container=o.DomUtil.create("div","leaflet-control-attribution"),o.DomEvent.disableClickPropagation(this._container);for(var e in t._layers)t._layers[e].getAttribution&&this.addAttribution(t._layers[e].getAttribution());return t.on("layeradd",this._onLayerAdd,this).on("layerremove",this._onLayerRemove,this),this._update(),this._container},onRemove:function(t){t.off("layeradd",this._onLayerAdd).off("layerremove",this._onLayerRemove)},setPrefix:function(t){return this.options.prefix=t,this._update(),this},addAttribution:function(t){return t?(this._attributions[t]||(this._attributions[t]=0),this._attributions[t]++,this._update(),this):void 0},removeAttribution:function(t){return t?(this._attributions[t]&&(this._attributions[t]--,this._update()),this):void 0},_update:function(){if(this._map){var t=[];for(var e in this._attributions)this._attributions[e]&&t.push(e);var i=[];this.options.prefix&&i.push(this.options.prefix),t.length&&i.push(t.join(", ")),this._container.innerHTML=i.join(" | ")}},_onLayerAdd:function(t){t.layer.getAttribution&&this.addAttribution(t.layer.getAttribution())},_onLayerRemove:function(t){t.layer.getAttribution&&this.removeAttribution(t.layer.getAttribution())}}),o.Map.mergeOptions({attributionControl:!0}),o.Map.addInitHook(function(){this.options.attributionControl&&(this.attributionControl=(new o.Control.Attribution).addTo(this))}),o.control.attribution=function(t){return new o.Control.Attribution(t)},o.Control.Scale=o.Control.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0,updateWhenIdle:!1},onAdd:function(t){this._map=t;var e="leaflet-control-scale",i=o.DomUtil.create("div",e),n=this.options;return this._addScales(n,e,i),t.on(n.updateWhenIdle?"moveend":"move",this._update,this),t.whenReady(this._update,this),i},onRemove:function(t){t.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(t,e,i){t.metric&&(this._mScale=o.DomUtil.create("div",e+"-line",i)),t.imperial&&(this._iScale=o.DomUtil.create("div",e+"-line",i))},_update:function(){var t=this._map.getBounds(),e=t.getCenter().lat,i=6378137*Math.PI*Math.cos(e*Math.PI/180),n=i*(t.getNorthEast().lng-t.getSouthWest().lng)/180,o=this._map.getSize(),s=this.options,a=0;o.x>0&&(a=n*(s.maxWidth/o.x)),this._updateScales(s,a)},_updateScales:function(t,e){t.metric&&e&&this._updateMetric(e),t.imperial&&e&&this._updateImperial(e)},_updateMetric:function(t){var e=this._getRoundNum(t);this._mScale.style.width=this._getScaleWidth(e/t)+"px",this._mScale.innerHTML=1e3>e?e+" m":e/1e3+" km"},_updateImperial:function(t){var e,i,n,o=3.2808399*t,s=this._iScale;o>5280?(e=o/5280,i=this._getRoundNum(e),s.style.width=this._getScaleWidth(i/e)+"px",s.innerHTML=i+" mi"):(n=this._getRoundNum(o),s.style.width=this._getScaleWidth(n/o)+"px",s.innerHTML=n+" ft")},_getScaleWidth:function(t){return Math.round(this.options.maxWidth*t)-10},_getRoundNum:function(t){var e=Math.pow(10,(Math.floor(t)+"").length-1),i=t/e;return i=i>=10?10:i>=5?5:i>=3?3:i>=2?2:1,e*i}}),o.control.scale=function(t){return new o.Control.Scale(t)},o.Control.Layers=o.Control.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0},initialize:function(t,e,i){o.setOptions(this,i),this._layers={},this._lastZIndex=0,this._handlingClick=!1;for(var n in t)this._addLayer(t[n],n);for(n in e)this._addLayer(e[n],n,!0)},onAdd:function(t){return this._initLayout(),this._update(),t.on("layeradd",this._onLayerChange,this).on("layerremove",this._onLayerChange,this),this._container},onRemove:function(t){t.off("layeradd",this._onLayerChange,this).off("layerremove",this._onLayerChange,this)},addBaseLayer:function(t,e){return this._addLayer(t,e),this._update(),this},addOverlay:function(t,e){return this._addLayer(t,e,!0),this._update(),this},removeLayer:function(t){var e=o.stamp(t);return delete this._layers[e],this._update(),this},_initLayout:function(){var t="leaflet-control-layers",e=this._container=o.DomUtil.create("div",t);e.setAttribute("aria-haspopup",!0),o.Browser.touch?o.DomEvent.on(e,"click",o.DomEvent.stopPropagation):o.DomEvent.disableClickPropagation(e).disableScrollPropagation(e);var i=this._form=o.DomUtil.create("form",t+"-list");if(this.options.collapsed){o.Browser.android||o.DomEvent.on(e,"mouseover",this._expand,this).on(e,"mouseout",this._collapse,this);var n=this._layersLink=o.DomUtil.create("a",t+"-toggle",e);n.href="#",n.title="Layers",o.Browser.touch?o.DomEvent.on(n,"click",o.DomEvent.stop).on(n,"click",this._expand,this):o.DomEvent.on(n,"focus",this._expand,this),o.DomEvent.on(i,"click",function(){setTimeout(o.bind(this._onInputClick,this),0)},this),this._map.on("click",this._collapse,this)}else this._expand();this._baseLayersList=o.DomUtil.create("div",t+"-base",i),this._separator=o.DomUtil.create("div",t+"-separator",i),this._overlaysList=o.DomUtil.create("div",t+"-overlays",i),e.appendChild(i)},_addLayer:function(t,e,i){var n=o.stamp(t);this._layers[n]={layer:t,name:e,overlay:i},this.options.autoZIndex&&t.setZIndex&&(this._lastZIndex++,t.setZIndex(this._lastZIndex))},_update:function(){if(this._container){this._baseLayersList.innerHTML="",this._overlaysList.innerHTML="";var t,e,i=!1,n=!1;for(t in this._layers)e=this._layers[t],this._addItem(e),n=n||e.overlay,i=i||!e.overlay;this._separator.style.display=n&&i?"":"none"}},_onLayerChange:function(t){var e=this._layers[o.stamp(t.layer)];if(e){this._handlingClick||this._update();var i=e.overlay?"layeradd"===t.type?"overlayadd":"overlayremove":"layeradd"===t.type?"baselayerchange":null;i&&this._map.fire(i,e)}},_createRadioElement:function(t,i){var n='<input type="radio" class="leaflet-control-layers-selector" name="'+t+'"';i&&(n+=' checked="checked"'),n+="/>";var o=e.createElement("div");return o.innerHTML=n,o.firstChild},_addItem:function(t){var i,n=e.createElement("label"),s=this._map.hasLayer(t.layer);t.overlay?(i=e.createElement("input"),i.type="checkbox",i.className="leaflet-control-layers-selector",i.defaultChecked=s):i=this._createRadioElement("leaflet-base-layers",s),i.layerId=o.stamp(t.layer),o.DomEvent.on(i,"click",this._onInputClick,this);var a=e.createElement("span");a.innerHTML=" "+t.name,n.appendChild(i),n.appendChild(a);var r=t.overlay?this._overlaysList:this._baseLayersList;return r.appendChild(n),n},_onInputClick:function(){var t,e,i,n=this._form.getElementsByTagName("input"),o=n.length;for(this._handlingClick=!0,t=0;o>t;t++)e=n[t],i=this._layers[e.layerId],e.checked&&!this._map.hasLayer(i.layer)?this._map.addLayer(i.layer):!e.checked&&this._map.hasLayer(i.layer)&&this._map.removeLayer(i.layer);this._handlingClick=!1,this._refocusOnMap()},_expand:function(){o.DomUtil.addClass(this._container,"leaflet-control-layers-expanded")},_collapse:function(){this._container.className=this._container.className.replace(" leaflet-control-layers-expanded","")}}),o.control.layers=function(t,e,i){return new o.Control.Layers(t,e,i)},o.PosAnimation=o.Class.extend({includes:o.Mixin.Events,run:function(t,e,i,n){this.stop(),this._el=t,this._inProgress=!0,this._newPos=e,this.fire("start"),t.style[o.DomUtil.TRANSITION]="all "+(i||.25)+"s cubic-bezier(0,0,"+(n||.5)+",1)",o.DomEvent.on(t,o.DomUtil.TRANSITION_END,this._onTransitionEnd,this),o.DomUtil.setPosition(t,e),o.Util.falseFn(t.offsetWidth),this._stepTimer=setInterval(o.bind(this._onStep,this),50)},stop:function(){this._inProgress&&(o.DomUtil.setPosition(this._el,this._getPos()),this._onTransitionEnd(),o.Util.falseFn(this._el.offsetWidth))},_onStep:function(){var t=this._getPos();return t?(this._el._leaflet_pos=t,void this.fire("step")):void this._onTransitionEnd()},_transformRe:/([-+]?(?:\d*\.)?\d+)\D*, ([-+]?(?:\d*\.)?\d+)\D*\)/,_getPos:function(){var e,i,n,s=this._el,a=t.getComputedStyle(s);if(o.Browser.any3d){if(n=a[o.DomUtil.TRANSFORM].match(this._transformRe),!n)return;e=parseFloat(n[1]),i=parseFloat(n[2])}else e=parseFloat(a.left),i=parseFloat(a.top);return new o.Point(e,i,!0)},_onTransitionEnd:function(){o.DomEvent.off(this._el,o.DomUtil.TRANSITION_END,this._onTransitionEnd,this),this._inProgress&&(this._inProgress=!1,this._el.style[o.DomUtil.TRANSITION]="",this._el._leaflet_pos=this._newPos,clearInterval(this._stepTimer),this.fire("step").fire("end"))}}),o.Map.include({setView:function(t,e,n){if(e=e===i?this._zoom:this._limitZoom(e),t=this._limitCenter(o.latLng(t),e,this.options.maxBounds),n=n||{},this._panAnim&&this._panAnim.stop(),this._loaded&&!n.reset&&n!==!0){n.animate!==i&&(n.zoom=o.extend({animate:n.animate},n.zoom),n.pan=o.extend({animate:n.animate},n.pan));var s=this._zoom!==e?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,e,n.zoom):this._tryAnimatedPan(t,n.pan);if(s)return clearTimeout(this._sizeTimer),this}return this._resetView(t,e),this},panBy:function(t,e){if(t=o.point(t).round(),e=e||{},!t.x&&!t.y)return this;if(this._panAnim||(this._panAnim=new o.PosAnimation,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),e.noMoveStart||this.fire("movestart"),e.animate!==!1){o.DomUtil.addClass(this._mapPane,"leaflet-pan-anim");var i=this._getMapPanePos().subtract(t);this._panAnim.run(this._mapPane,i,e.duration||.25,e.easeLinearity)}else this._rawPanBy(t),this.fire("move").fire("moveend");return this},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){o.DomUtil.removeClass(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(t,e){var i=this._getCenterOffset(t)._floor();return(e&&e.animate)===!0||this.getSize().contains(i)?(this.panBy(i,e),!0):!1}}),o.PosAnimation=o.DomUtil.TRANSITION?o.PosAnimation:o.PosAnimation.extend({run:function(t,e,i,n){this.stop(),this._el=t,this._inProgress=!0,this._duration=i||.25,this._easeOutPower=1/Math.max(n||.5,.2),this._startPos=o.DomUtil.getPosition(t),this._offset=e.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(),this._complete())},_animate:function(){this._animId=o.Util.requestAnimFrame(this._animate,this),this._step()},_step:function(){var t=+new Date-this._startTime,e=1e3*this._duration;e>t?this._runFrame(this._easeOut(t/e)):(this._runFrame(1),this._complete())},_runFrame:function(t){var e=this._startPos.add(this._offset.multiplyBy(t));o.DomUtil.setPosition(this._el,e),this.fire("step")},_complete:function(){o.Util.cancelAnimFrame(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),o.Map.mergeOptions({zoomAnimation:!0,zoomAnimationThreshold:4}),o.DomUtil.TRANSITION&&o.Map.addInitHook(function(){this._zoomAnimated=this.options.zoomAnimation&&o.DomUtil.TRANSITION&&o.Browser.any3d&&!o.Browser.android23&&!o.Browser.mobileOpera,this._zoomAnimated&&o.DomEvent.on(this._mapPane,o.DomUtil.TRANSITION_END,this._catchTransitionEnd,this)}),o.Map.include(o.DomUtil.TRANSITION?{_catchTransitionEnd:function(t){this._animatingZoom&&t.propertyName.indexOf("transform")>=0&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(t,e,i){if(this._animatingZoom)return!0;if(i=i||{},!this._zoomAnimated||i.animate===!1||this._nothingToAnimate()||Math.abs(e-this._zoom)>this.options.zoomAnimationThreshold)return!1;var n=this.getZoomScale(e),o=this._getCenterOffset(t)._divideBy(1-1/n),s=this._getCenterLayerPoint()._add(o);return i.animate===!0||this.getSize().contains(o)?(this.fire("movestart").fire("zoomstart"),this._animateZoom(t,e,s,n,null,!0),!0):!1},_animateZoom:function(t,e,i,n,s,a,r){r||(this._animatingZoom=!0),o.DomUtil.addClass(this._mapPane,"leaflet-zoom-anim"),this._animateToCenter=t,this._animateToZoom=e,o.Draggable&&(o.Draggable._disabled=!0),o.Util.requestAnimFrame(function(){this.fire("zoomanim",{center:t,zoom:e,origin:i,scale:n,delta:s,backwards:a}),setTimeout(o.bind(this._onZoomTransitionEnd,this),250)},this)},_onZoomTransitionEnd:function(){this._animatingZoom&&(this._animatingZoom=!1,o.DomUtil.removeClass(this._mapPane,"leaflet-zoom-anim"),o.Util.requestAnimFrame(function(){this._resetView(this._animateToCenter,this._animateToZoom,!0,!0),o.Draggable&&(o.Draggable._disabled=!1)},this))}}:{}),o.TileLayer.include({_animateZoom:function(t){this._animating||(this._animating=!0,this._prepareBgBuffer());var e=this._bgBuffer,i=o.DomUtil.TRANSFORM,n=t.delta?o.DomUtil.getTranslateString(t.delta):e.style[i],s=o.DomUtil.getScaleString(t.scale,t.origin);e.style[i]=t.backwards?s+" "+n:n+" "+s},_endZoomAnim:function(){var t=this._tileContainer,e=this._bgBuffer;t.style.visibility="",t.parentNode.appendChild(t),o.Util.falseFn(e.offsetWidth);var i=this._map.getZoom();(i>this.options.maxZoom||i<this.options.minZoom)&&this._clearBgBuffer(),this._animating=!1},_clearBgBuffer:function(){var t=this._map;!t||t._animatingZoom||t.touchZoom._zooming||(this._bgBuffer.innerHTML="",this._bgBuffer.style[o.DomUtil.TRANSFORM]="")},_prepareBgBuffer:function(){var t=this._tileContainer,e=this._bgBuffer,i=this._getLoadedTilesPercentage(e),n=this._getLoadedTilesPercentage(t);return e&&i>.5&&.5>n?(t.style.visibility="hidden",void this._stopLoadingImages(t)):(e.style.visibility="hidden",e.style[o.DomUtil.TRANSFORM]="",this._tileContainer=e,e=this._bgBuffer=t,this._stopLoadingImages(e),void clearTimeout(this._clearBgBufferTimer))},_getLoadedTilesPercentage:function(t){var e,i,n=t.getElementsByTagName("img"),o=0;for(e=0,i=n.length;i>e;e++)n[e].complete&&o++;return o/i},_stopLoadingImages:function(t){var e,i,n,s=Array.prototype.slice.call(t.getElementsByTagName("img"));for(e=0,i=s.length;i>e;e++)n=s[e],n.complete||(n.onload=o.Util.falseFn,n.onerror=o.Util.falseFn,n.src=o.Util.emptyImageUrl,n.parentNode.removeChild(n))}}),o.Map.include({_defaultLocateOptions:{watch:!1,setView:!1,maxZoom:1/0,timeout:1e4,maximumAge:0,enableHighAccuracy:!1},locate:function(t){if(t=this._locateOptions=o.extend(this._defaultLocateOptions,t),!navigator.geolocation)return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var e=o.bind(this._handleGeolocationResponse,this),i=o.bind(this._handleGeolocationError,this);return t.watch?this._locationWatchId=navigator.geolocation.watchPosition(e,i,t):navigator.geolocation.getCurrentPosition(e,i,t),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(t){var e=t.code,i=t.message||(1===e?"permission denied":2===e?"position unavailable":"timeout");this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:e,message:"Geolocation error: "+i+"."})},_handleGeolocationResponse:function(t){var e=t.coords.latitude,i=t.coords.longitude,n=new o.LatLng(e,i),s=180*t.coords.accuracy/40075017,a=s/Math.cos(o.LatLng.DEG_TO_RAD*e),r=o.latLngBounds([e-s,i-a],[e+s,i+a]),h=this._locateOptions;if(h.setView){var l=Math.min(this.getBoundsZoom(r),h.maxZoom);this.setView(n,l)}var u={latlng:n,bounds:r,timestamp:t.timestamp};for(var c in t.coords)"number"==typeof t.coords[c]&&(u[c]=t.coords[c]);this.fire("locationfound",u)}})}(window,document);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _app = __webpack_require__(203);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppComponent = {
	    controller: _app2.default,
	    template: '\n        <app-sidenav ng-if="$root.auth" id="app-sidenav" ng-class="{ \'no-sidenav\' : !$ctrl.getSidenav() }"></app-sidenav>\n        <div ng-class="{ \'no-login\' : !$root.auth, \'main\' : !$root.verify }">\n            <app-navbar ng-if="$root.auth"></app-navbar>\n            <app-breadcrumb ng-if="$root.auth"></app-breadcrumb>\n            <section class="main-section" ui-view></section>\n        </div>\n        <app-footer></app-footer>\n        <app-loading></app-loading>\n    '
	};
	
	exports.default = AppComponent;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(198);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var server = _config2.default.server;
	
	var Config = angular.module('app.config', []).constant('appName', 'probolivia') // prefijo del sistema para el Storage y Sessiones
	.constant('systemName', 'Ventanilla de Registros').constant('timeSessionExpired', _config2.default.timeSessionExpired) //Tiempo en minutos para que la sesión se cierre automáticamente si existe i$
	.constant('onbeforeunload', _config2.default.onbeforeunload).constant('debug', _config2.default.debug).constant('PageNoLogin', ['login', 'crear_cuenta', 'confirmarCuenta', 'verificacion', 'registroArtesano']) // Rutas que no requieren autenticación
	.constant('PageNoRedirectLogin', ['/certificacion/verificar', '/verificacion']) // urls que no se redireccionaran, ni verificara si tiene usuario al iniciar la pagina
	.constant('authUrl', server + '/autenticar/') // URL para autenticacion
	.constant('apiUrl', server + '/api/v1/') // Rest principal del sistema
	.constant('rdxUrl', _config2.default.rdxUrl) // URL la actualizacion de cuenta B.U.
	.constant('rdxUrljs', _config2.default.rdxUrljs) // Url del script js para crear rdx
	.constant('baseUrl', server + '/') // Ruta base
	.name;
	
	exports.default = Config;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppController = function () {
	    AppController.$inject = ["$rootScope", "$location", "Storage", "Auth", "PageNoLogin", "timeSessionExpired", "SidenavFactory", "$log", "PageNoRedirectLogin"];
	    function AppController($rootScope, $location, Storage, Auth, PageNoLogin, timeSessionExpired, SidenavFactory, $log, PageNoRedirectLogin) {
	        'ngInject';
	
	        _classCallCheck(this, AppController);
	
	        this.$rootScope = $rootScope;
	        this.$location = $location;
	        this.Auth = Auth;
	        this.Storage = Storage;
	        this.PageNoLogin = PageNoLogin;
	        this.PageNoRedirectLogin = PageNoRedirectLogin;
	        this.SidenavFactory = SidenavFactory;
	        this.timeSessionExpired = timeSessionExpired;
	        this.$log = $log;
	    }
	
	    _createClass(AppController, [{
	        key: '$onInit',
	        value: function $onInit() {
	
	            // this.$rootScope.auth = this.Auth.isAuthenticated(); // Descomentar cuando exista el backend
	            this.$rootScope.auth = this.Storage.existUser(); // Comentar cuando ya no se use el fake de autenticación
	
	            // Verificando si se está logueado
	            // this.$log.log('auth', this.$rootScope.auth);
	
	            if (this.PageNoRedirectLogin.indexOf(this.$location.path()) != -1) {
	                // console.log(this.$location);
	                this.Storage.set('path', this.$location.path().replace('/', ''));
	            } else {
	                if (this.$rootScope.auth) {
	                    this.Auth.timerSession();
	                } else {
	                    var path = this.$location.path();
	                    // this.$log.log('path', path);
	                    // this.$log.log('exist', this.exist(path));
	
	                    // Verificando si el path actual esa una página de excepción que no require autenticación
	                    if (!this.exist(path)) {
	                        if (path.length) {
	                            this.Storage.set('path', path.replace('/', ''));
	                        }
	                        this.$location.path('login');
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'exist',
	        value: function exist(path) {
	            var paths = this.PageNoLogin;
	            for (var i in paths) {
	                if (path.indexOf('/' + paths[i]) === 0 || path.indexOf('/' + paths[i] + '/') === 0) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    }, {
	        key: 'getSidenav',
	        value: function getSidenav() {
	            return this.SidenavFactory.getSidenav();
	        }
	    }]);
	
	    return AppController;
	}();
	
	exports.default = AppController;

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CommonConfig = function CommonConfig($httpProvider, $logProvider, $authProvider, authUrl, appName, DataServiceConfig, uibDatepickerPopupConfig, uibDatepickerConfig, formlyConfigProvider, debug, $compileProvider, cfpLoadingBarProvider) {
	    "ngInject";
	
	    // Habilitar los logs del sistema
	
	    $logProvider.debugEnabled(debug);
	
	    // Configurando parametros para autenticación con Satellizer
	    // Config url auth
	    $authProvider.loginUrl = authUrl;
	    // $authProvider.signupUrl = "http://api.com/auth/signup";
	    $authProvider.tokenName = "token";
	    $authProvider.tokenPrefix = appName;
	    // $httpProvider.defaults.headers.get = { 'Access-Control-Allow-Origin': '*' };
	    // $authProvider.authToken = 'Bearer';
	
	    // Configurando salida de respuesta del rest backend para el DataService
	    DataServiceConfig.filterResponse = function (response, Message) {
	        if (response.datos) {
	            response = response.datos;
	        } else {
	            if (!response.finalizado) {
	                Message.error(response.mensaje);
	                response = response.datos;
	            }
	        }
	        return response;
	    };
	    // para que en la descarga de archivo quite el unsafe
	    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|blob):/);
	    // Configurando datepicker
	    uibDatepickerPopupConfig.appendToBody = true;
	    uibDatepickerPopupConfig.clearText = 'Limpiar';
	    uibDatepickerPopupConfig.closeText = 'Cerrar';
	    uibDatepickerPopupConfig.currentText = 'Hoy';
	    uibDatepickerPopupConfig.onOpenFocus = false;
	    uibDatepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
	    uibDatepickerConfig.showWeeks = false;
	
	    // Configurando formly
	    formlyConfigProvider.setWrapper({
	        name: 'validation',
	        types: ['input', 'select', 'datepicker', 'textarea'],
	        template: "\n            <formly-transclude></formly-transclude>\n            <div class=\"form-error\" ng-messages=\"fc.$error\" ng-if=\"form.$submitted || options.formControl.$touched\">\n                <div ng-message=\"{{ ::name }}\" ng-repeat=\"(name, message) in ::options.validation.messages\" class=\"message\">{{ message(fc.$viewValue, fc.$modelValue, this)}}</div>\n            </div>\n        "
	    });
	
	    // Config loading
	    cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-spinner"><div class="loading-container"><span class="loading-text">Cargando</span> <span class="spinner-icon"></span></div></div>';
	};
	CommonConfig.$inject = ["$httpProvider", "$logProvider", "$authProvider", "authUrl", "appName", "DataServiceConfig", "uibDatepickerPopupConfig", "uibDatepickerConfig", "formlyConfigProvider", "debug", "$compileProvider", "cfpLoadingBarProvider"];
	
	exports.default = CommonConfig;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Importando css de las librerías del sistema
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(151);
	
	__webpack_require__(152);
	
	__webpack_require__(149);
	
	__webpack_require__(150);
	
	__webpack_require__(154);
	
	__webpack_require__(153);
	
	__webpack_require__(173);
	
	__webpack_require__(183);
	
	__webpack_require__(182);
	
	var _angularUiRouter = __webpack_require__(138);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _satellizer = __webpack_require__(660);
	
	var _satellizer2 = _interopRequireDefault(_satellizer);
	
	var _angularLoadingBar = __webpack_require__(129);
	
	var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);
	
	var _angularSanitize = __webpack_require__(135);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularResource = __webpack_require__(133);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularMessages = __webpack_require__(131);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _uiSelect = __webpack_require__(664);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _angularToastr = __webpack_require__(137);
	
	var _angularToastr2 = _interopRequireDefault(_angularToastr);
	
	__webpack_require__(77);
	
	__webpack_require__(126);
	
	__webpack_require__(200);
	
	__webpack_require__(127);
	
	__webpack_require__(125);
	
	__webpack_require__(542);
	
	__webpack_require__(547);
	
	var _angularUiValidate = __webpack_require__(140);
	
	var _angularUiValidate2 = _interopRequireDefault(_angularUiValidate);
	
	var _common = __webpack_require__(204);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _common3 = __webpack_require__(206);
	
	var _common4 = _interopRequireDefault(_common3);
	
	var _lang = __webpack_require__(290);
	
	var _lang2 = _interopRequireDefault(_lang);
	
	var _core = __webpack_require__(207);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _layout = __webpack_require__(297);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _pdf = __webpack_require__(557);
	
	var _pdf2 = _interopRequireDefault(_pdf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import 'tether'; // Tether (required for Bootstrap 4.x)
	
	
	// Importando dependencias
	var Common = angular.module('app.common', [_angularLoadingBar2.default, _angularSanitize2.default, _angularResource2.default, _angularMessages2.default, _satellizer2.default, 'angularFileUpload', 'formlyBootstrap', _angularToastr2.default, 'ngTable', 'leaflet-directive', _angularUiRouter2.default, _uiSelect2.default, _lang2.default, _core2.default, _layout2.default, _angularUiValidate2.default, 'ng.deviceDetector']).config(_common2.default).run(_common4.default)
	// Controlar state(url) previos para cada state, si no se define en un state trabajara normal
	.constant('statePrevs', {}).constant('PDFJS', _pdf2.default).name;exports.default = Common;

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var runBlock = function runBlock($rootScope, onbeforeunload, $transitions, statePrevs, formlyConfig, $anchorScroll, rdxUrljs) {
	    'ngInject';
	
	    //Fullscreen event and hack mozilla
	
	    function exitFullScreen() {
	        angular.element(document.body).removeClass('fullscreen');
	    }
	
	    angular.element(window.document).on('keyup', function (e) {
	        if (e.keyCode == 27) {
	            exitFullScreen();
	        }
	    });
	
	    document.addEventListener("mozfullscreenchange", function () {
	        if (!document.mozFullScreen) {
	            exitFullScreen();
	        }
	    }, false);
	
	    if (onbeforeunload) {
	        window.onbeforeunload = function () {
	            return '¿Está seguro/a de abandonar la página?.';
	        };
	    }
	    // $log.log('runCommon');
	    // $log.log(statePrevs);
	    for (var name in statePrevs) {
	        var prevs = statePrevs[name];
	        statePrevs[name] = {};
	        prevs.forEach(function (namePrev) {
	            statePrevs[name][namePrev] = !0;
	        });
	    }
	
	    $transitions.onStart({}, function (transition) {
	        if (transition.from().name != '' && statePrevs[transition.to().name] && !statePrevs[transition.to().name][transition.from().name]) {
	            // $log.log('abort')
	            transition.abort();
	        }
	    });
	
	    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';
	
	    $anchorScroll.yOffset = 60;
	
	    // inject rdx-banco-union
	    var scriptTag = angular.element(document.createElement('script'));
	    scriptTag.attr('charset', 'utf-8');
	    scriptTag.attr('src', rdxUrljs);
	    angular.element(document.body).append(scriptTag);
	    // console.log(scriptTag);
	    // console.log(rdx('214141235125','asdfasdf'));   
	};
	runBlock.$inject = ["$rootScope", "onbeforeunload", "$transitions", "statePrevs", "formlyConfig", "$anchorScroll", "rdxUrljs"];
	
	exports.default = runBlock;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _service = __webpack_require__(229);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _filter = __webpack_require__(209);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _interceptor = __webpack_require__(211);
	
	var _interceptor2 = _interopRequireDefault(_interceptor);
	
	var _vendorModule = __webpack_require__(543);
	
	var _vendorModule2 = _interopRequireDefault(_vendorModule);
	
	var _util = __webpack_require__(287);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Core = angular.module('app.core', [_vendorModule2.default, _interceptor2.default, _filter2.default, _service2.default, _util2.default]).name;
	
	exports.default = Core;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DatetimeFilter = function DatetimeFilter(Datetime) {
	    'ngInject';
	
	    return function (date, format) {
	
	        if (format) {
	            if (format == 'literal') {
	                return Datetime.dateLiteral(date);
	            }
	            if (format == 'year') {
	                return Datetime.now('YYYY');
	            }
	            if (format == 'timeLiteral') {
	                return Datetime.timeLiteral(date);
	            }
	            if (format == 'convert') {
	                return Datetime.toString(date);
	            }
	        }
	
	        return date;
	    };
	};
	DatetimeFilter.$inject = ["Datetime"];
	
	exports.default = DatetimeFilter;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datetime = __webpack_require__(208);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _text = __webpack_require__(210);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Filter = angular.module('app.filters', []).filter('datetime', _datetime2.default).filter('characters', _text2.default.characters).filter('splitcharacters', _text2.default.splitcharacters).filter('words', _text2.default.words).name;
	
	exports.default = Filter;

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TextFilter = {
	    characters: function characters() {
	        return function (input, chars, breakOnWord) {
	            if (isNaN(chars)) return input;
	            if (chars <= 0) return '';
	            if (input && input.length > chars) {
	                input = input.substring(0, chars).replace(/(<([^>]+)>)/ig, "");
	
	                if (!breakOnWord) {
	                    var lastspace = input.lastIndexOf(' ');
	                    //get last space
	                    if (lastspace !== -1) {
	                        input = input.substr(0, lastspace);
	                    }
	                } else {
	                    while (input.charAt(input.length - 1) === ' ') {
	                        input = input.substr(0, input.length - 1);
	                    }
	                }
	                return input + '…';
	            }
	            return input;
	        };
	    },
	    splitcharacters: function splitcharacters() {
	        return function (input, chars) {
	            if (isNaN(chars)) return input;
	            if (chars <= 0) return '';
	            if (input && input.length > chars) {
	                input = input.replace(/(<([^>]+)>)/ig, "");
	                var prefix = input.substring(0, chars / 2);
	                var postfix = input.substring(input.length - chars / 2, input.length);
	                return prefix + '...' + postfix;
	            }
	            return input;
	        };
	    },
	    words: function words() {
	        return function (input, words) {
	            if (isNaN(words)) return input;
	            if (words <= 0) return '';
	            if (input) {
	                input = input.replace(/(<([^>]+)>)/ig, "");
	                var inputWords = input.split(/\s+/);
	                if (inputWords.length > words) {
	                    input = inputWords.slice(0, words).join(' ') + '…';
	                }
	            }
	            return input;
	        };
	    }
	};
	
	exports.default = TextFilter;

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Interceptor = angular.module('app.interceptors', []).factory('AuthInterceptor', ["$q", "$injector", "timeSessionExpired", function ($q, $injector, timeSessionExpired) {
	    'ngInject';
	
	    return {
	        'request': function request(config) {
	
	            // Actualizando el tiempo de sesión de inactividad
	            if (angular.TIME) {
	                angular.TIME = timeSessionExpired * 60;
	            }
	
	            // Agregando cabecera para evitar ataque CSRF
	            // if(config.url.indexOf('http://test-routes.herokuapp.com') != -1) {
	            //     config.headers['x-csrf-token'] = 'lalalalala';
	            // }
	
	            return config;
	        },
	
	        'requestError': function requestError(rejection) {
	
	            return $q.reject(rejection);
	        },
	
	        'response': function response(_response) {
	            return _response;
	        },
	
	        'responseError': function responseError(rejection) {
	            // Cerrando sesión si no se tiene permisos de acceso
	            if (rejection.status === 403) {
	                var Auth = $injector.get('Auth');
	                Auth.logout();
	            }
	            return $q.reject(rejection);
	        }
	    };
	}]).config(["$httpProvider", function ($httpProvider) {
	    $httpProvider.interceptors.push('AuthInterceptor');
	}]).name;
	
	exports.default = Interceptor;

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArrayService = function () {
	    function ArrayService() {
	        "ngInject";
	
	        _classCallCheck(this, ArrayService);
	    }
	
	    _createClass(ArrayService, [{
	        key: "replace",
	        value: function replace(text, find, _replace) {
	            for (var i = 0, l = find.length, regex; i < l; i++) {
	                regex = new RegExp(find[i], "g");
	                text = text.replace(regex, _replace[i]);
	            }
	            return text;
	        }
	    }, {
	        key: "insert",
	        value: function insert(arr, index, item) {
	            return arr.splice(index, 0, item);
	        }
	    }]);
	
	    return ArrayService;
	}();
	
	exports.default = ArrayService;

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Config = function Config($httpProvider) {
	    'ngInject';
	
	    //initialize get if not there
	
	    if (!$httpProvider.defaults.headers.get) {
	        $httpProvider.defaults.headers.get = {};
	    }
	
	    // Answer edited to include suggestions from comments
	    // because previous version of code introduced browser-related errors
	
	    // //disable IE ajax request caching
	    // $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
	    // extra
	    $httpProvider.defaults.headers.get['Cache-Control'] = 'private, no-cache, no-store, must-revalidate';
	    $httpProvider.defaults.headers.get.Pragma = 'no-cache';
	};
	Config.$inject = ["$httpProvider"];
	
	exports.default = Config;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _httpCanceler = __webpack_require__(216);
	
	var _httpCanceler2 = _interopRequireDefault(_httpCanceler);
	
	var _data = __webpack_require__(215);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _data3 = __webpack_require__(213);
	
	var _data4 = _interopRequireDefault(_data3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Data = angular.module('app.data', []).constant('DataServiceConfig', {
	    filterResponse: null
	}).service('HTTPCanceler', _httpCanceler2.default).service('DataService', _data2.default).config(_data4.default).name;
	
	exports.default = Data;

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	/*eslint no-console: ["error", { allow: ["group", "dir", "groupEnd", "table"] }] */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataService = function () {
	  DataService.$inject = ["$http", "$q", "$location", "$sce", "DataServiceConfig", "HTTPCanceler", "Message", "Util", "apiUrl", "appName", "errorsLang", "debug", "$log", "Storage"];
	  function DataService($http, $q, $location, $sce, DataServiceConfig, HTTPCanceler, Message, Util, apiUrl, appName, errorsLang, debug, $log, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, DataService);
	
	    this.$http = $http;
	    this.$sce = $sce;
	    this.defer = $q.defer();
	    this.Message = Message;
	    this.Util = Util;
	    this.debug = debug;
	    this.DataServiceConfig = DataServiceConfig;
	    this.HTTPCanceler = HTTPCanceler;
	    this.canceler = this.HTTPCanceler.get(this.defer, this.appName);
	    this.apiUrl = apiUrl;
	    this.errorsLang = errorsLang;
	    this.appName = appName;
	    this.Storage = Storage;
	
	    this.PATERN_HOST = $location.protocol() == 'https' ? /(https:\/\/|www\.)\S+/i : /(http:\/\/|www\.)\S+/i;
	    this.$log = $log;
	  }
	
	  _createClass(DataService, [{
	    key: 'cancelRequest',
	    value: function cancelRequest() {
	      this.HTTPCanceler.cancel();
	      this.canceler = this.HTTPCanceler.get(this.defer, this.appName);
	      this.cancel = true;
	    }
	  }, {
	    key: 'getUrl',
	    value: function getUrl(url, id) {
	      id = typeof id == 'string' || typeof id == 'number' ? '' + id : (typeof id === 'undefined' ? 'undefined' : _typeof(id)) == 'object' && id.id ? '' + id.id : '';
	      if (url[url.length - 1] != '/' && id.length > 1) {
	        id = '/' + id;
	      }
	      return this.PATERN_HOST.test(url) ? url + id : this.apiUrl + url + id;
	    }
	  }, {
	    key: 'options',
	    value: function options(url) {
	      return this._http('get', url + '/fields');
	    }
	  }, {
	    key: 'get',
	    value: function get(url, id) {
	      return this._http('get', url, id);
	    }
	  }, {
	    key: 'post',
	    value: function post(url, data) {
	      return this._http('post', url, data);
	    }
	  }, {
	    key: 'put',
	    value: function put(url, data) {
	      return this._http('put', url, data);
	    }
	  }, {
	    key: 'patch',
	    value: function patch(url, data) {
	      return this._http('patch', url, data);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(url, id) {
	      return this._http('delete', url, id);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(url, id) {
	      return this.delete(url, id);
	    }
	  }, {
	    key: 'list',
	    value: function list(url, query) {
	      query = query ? '?' + this.Util.serialize(query) : '';
	      return this._http('get', url + query);
	    }
	  }, {
	    key: 'save',
	    value: function save(url, data) {
	      return this._http(data.id ? 'put' : 'post', url, data);
	    }
	  }, {
	    key: '_http',
	    value: function _http(method, url, data) {
	      var _this = this;
	
	      url = this.getUrl(url, data);
	
	      var setting = {
	        method: method,
	        url: url,
	        timeout: this.canceler.promise
	      };
	
	      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object' && Object.keys(data).length) {
	        delete data.id;
	        setting.data = data;
	      }
	
	      return this.$http(setting).then(function (response) {
	        return _this.filterResponse(response.data, { method: method, data: data, url: url });
	      }).catch(function (error) {
	        return _this.msgError(error);
	      });
	    }
	  }, {
	    key: 'pdf',
	    value: function pdf(url) {
	      var _this2 = this;
	
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      url = this.getDomain(url);
	      return this.$http.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
	        if (response.data) {
	          var file = new window.Blob([response.data], { type: 'application/pdf' });
	          var fileURL = window.URL.createObjectURL(file);
	          return _this2.$sce.trustAsResourceUrl(fileURL);
	        }
	        return null;
	      }).catch(function (error) {
	        return _this2.msgError(error);
	      });
	    }
	  }, {
	    key: 'file',
	    value: function file(url, type) {
	      var _this3 = this;
	
	      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      url = this.getUrl(url);
	      return this.$http.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
	        if (response.data) {
	          var file = new window.Blob([response.data], { type: type });
	          var fileURL = window.URL.createObjectURL(file);
	          return _this3.$sce.trustAsResourceUrl(fileURL);
	        }
	        return null;
	      }).catch(function (error) {
	        return _this3.msgError(error);
	      });
	    }
	  }, {
	    key: 'pdfO',
	    value: function pdfO(url) {
	      var _this4 = this;
	
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      url = this.getUrl(url, data);
	      return this.$http.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
	        if (response.data) {
	          var file = new window.Blob([response.data], { type: 'application/pdf' });
	          var fileURL = window.URL.createObjectURL(file);
	          //
	          //
	          //                  var fileName = "file_name.pdf";
	          //        var a = document.createElement("a");
	          //        document.body.appendChild(a);
	          //
	          //        var fileURL = window.URL.createObjectURL(file);
	          //        a.href = fileURL;
	          //        a.download = fileName;
	          //        a.click();
	
	
	          return _this4.$sce.trustAsResourceUrl(fileURL);
	        }
	        return null;
	      }).catch(function (error) {
	        return _this4.msgError(error);
	      });
	    }
	  }, {
	    key: 'pdfOfile',
	    value: function pdfOfile(url) {
	      var _this5 = this;
	
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      url = this.getUrl(url, data);
	      return this.$http.post(url, data, { responseType: 'arraybuffer' }).then(function (response) {
	        if (response.data) {
	          var file = new window.Blob([response.data], { type: 'application/pdf' });
	          var fileURL = window.URL.createObjectURL(file);
	          return fileURL;
	        }
	        return null;
	      }).catch(function (error) {
	        return _this5.msgError(error);
	      });
	    }
	  }, {
	    key: 'setFormly',
	    value: function setFormly(data) {
	      this.formly = data;
	    }
	  }, {
	    key: 'filterResponse',
	    value: function filterResponse(response, obj) {
	      if (this.debug) {
	        // console.group('Petición con DataService:');
	      }
	      if (obj.data) {
	        // this.$log.info('Params:', obj.data);
	      }
	      this.Storage.set('dateNow', response.fecha);
	      var data = response.datos || response;
	      if (this.debug) {
	        // console.dir(data);
	      }
	      if (this.Util.toType(data) == 'array') {
	        if (window.navigator.appName == 'Netscape') {
	          if (this.debug) {
	            // console.table(data);
	          }
	        } else {
	          if (this.debug) {
	            // console.table(data.map(item => [item]));
	          }
	        }
	      }
	      // console.groupEnd();
	      if (typeof this.DataServiceConfig.filterResponse == 'function') {
	        return this.DataServiceConfig.filterResponse(response, this.Message);
	      }
	      return response;
	    }
	  }, {
	    key: 'msgError',
	    value: function msgError(error) {
	      if (error && error.data && error.data.tipo && error.data.tipo === 'HttpError') return this.parseHttpError(error);
	      if (this.debug) {
	        // console.dir('Error:', error);
	        // console.groupEnd();
	      }
	      var statusErrors = [500, 404, 409, 403, 401, 400, 502, 412];
	
	      if (error.status === 408 || error.status === 504) {
	        return error;
	      } else if (this.errorsLang[error.status]) {
	        this.Message[statusErrors.indexOf(error.status) != -1 ? 'error' : 'warning'](error.data.mensaje && typeof error.data.mensaje == 'string' ? error.data.mensaje : this.parseError(error.data) || this.errorsLang[error.status], error.data.errors ? this.errorsLang.validation : null);
	      } else if (this.cancel) {
	        this.Message.warning(this.errorsLang.cancelRequest);
	        this.cancel = false;
	      } else {
	        var clientErrorMessage = null;
	        var clientErrorTitle = null;
	        if (error && error.data && error.data.datos && error.data.datos[0] && error.data.datos[0].error) {
	          clientErrorMessage = error.data.datos[0].error || error.data.mensaje;
	          clientErrorTitle = null;
	        } else if (error && error.data && error.data.mensaje) {
	          clientErrorMessage = error.data && error.data.errors ? this.parseError(error.data) : error.data.mensaje;
	          clientErrorTitle = error.data && error.data.errors ? error.data.mensaje : null;
	        }
	
	        this.Message.error(clientErrorMessage, clientErrorTitle);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'parseError',
	    value: function parseError(error) {
	      var message = [];
	      if (error) {
	        if (error.errors) {
	          if (error.detail || error.error) {
	            return error.detail || error.error;
	          }
	          if (Object.keys(error.errors).length === 0) {
	            return error;
	          }
	
	          error = error.errors;
	          for (var i in error) {
	            message.push('<strong>' + (error[i].label || i) + ':</strong> ' + (this.Util.toType(error[i].errors) == 'array' ? error[i].errors.join(', ') : error[i].errors));
	          }
	          return message.join('<br>');
	        } else if (error.errorType && error.errorType == 'ValidationError') {
	          error = error.property;
	          for (var _i in error) {
	            message.push('<strong>' + (error[_i].label || _i) + ':</strong> ' + (this.Util.toType(error[_i].errors) == 'array' ? error[_i].errors.join(', ') : error[_i].errors));
	          }
	          return message.join('<br>');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'parseHttpError',
	    value: function parseHttpError(error) {
	      this.Message.error(error.data.errores.map(function (e) {
	        return '' + e.error;
	      }).join('<br><br>'), error.data.mensaje);
	    }
	  }]);
	
	  return DataService;
	}();
	
	exports.default = DataService;

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HTTPCanceler = function () {
	    HTTPCanceler.$inject = ["$q"];
	    function HTTPCanceler($q) {
	        'ngInject';
	
	        _classCallCheck(this, HTTPCanceler);
	
	        this.$q = $q;
	        this.promisesToReject = {};
	        this.canceler = {};
	        this.inited = {};
	    }
	
	    _createClass(HTTPCanceler, [{
	        key: 'get',
	        value: function get(defer, namespace) {
	            namespace = namespace || 'default';
	            if (!this.promisesToReject[namespace]) {
	                this.promisesToReject[namespace] = [];
	                this.canceler[namespace] = null;
	                this.inited[namespace] = false;
	            }
	            if (defer) {
	                this.promisesToReject[namespace].push(defer);
	            }
	            //Create new defer in first time and when the promise was canceled before
	            if (!this.inited[namespace]) {
	                this.canceler[namespace] = this.$q.defer();
	                this.inited[namespace] = true;
	            }
	            return this.canceler[namespace];
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel(namespace) {
	            namespace = namespace || 'default';
	            angular.forEach(this.promisesToReject, function (promises, promiseNamespace) {
	                if (!this.canceler[promiseNamespace]) return;
	                if ('default' !== namespace && namespace != promiseNamespace) return;
	                this.canceler[promiseNamespace].resolve();
	                this.inited[promiseNamespace] = false;
	                // Reject namespace promises
	                angular.forEach(promises, function (defer) {
	                    defer.reject();
	                });
	                this.promisesToReject[promiseNamespace] = [];
	            });
	        }
	    }]);
	
	    return HTTPCanceler;
	}();
	
	exports.default = HTTPCanceler;

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DatetimeService = function () {
	    DatetimeService.$inject = ["Util", "ArrayUtil"];
	    function DatetimeService(Util, ArrayUtil) {
	        "ngInject";
	
	        _classCallCheck(this, DatetimeService);
	
	        this.Util = Util;
	        this.ArrayUtil = ArrayUtil;
	
	        this.formatDate = 'dd/MM/YYYY';
	        this.months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
	        this.days = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
	        this.dayslong = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
	    }
	
	    // TODO: Verificar si esto funciona
	
	
	    _createClass(DatetimeService, [{
	        key: 'date',
	        value: function date(_date, separator) {
	            _date = _date.split(separator || '-');
	            return new Date(_date[0], _date[1] - 1, _date[2]);
	        }
	    }, {
	        key: 'parse',
	        value: function parse(date, separator) {
	            return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join(separator || '-');
	        }
	    }, {
	        key: 'dateMonth',
	        value: function dateMonth() {
	            var date = new Date();
	            return new Date(date.getFullYear(), date.getMonth(), 1);
	        }
	    }, {
	        key: 'getPrevDateMonth',
	        value: function getPrevDateMonth(data) {
	            data = data || 1;
	            var date = new Date();
	            var day = date.getDate();
	            var month = date.getMonth();
	            var year = date.getFullYear();
	
	            if (day < data) {
	                month--;
	                if (month < 0) {
	                    month = 11;
	                    year--;
	                }
	            }
	            return new Date(year, month, data);
	        }
	    }, {
	        key: 'toString',
	        value: function toString(date) {
	            if (this.Util.toType(date) == 'string') {
	                var pos = date.indexOf('T');
	                if (pos != -1 && pos <= 10 && pos >= 8) {
	                    var fecha = date.substring(0, pos);
	                    if (!/[a-zA-Z]+/g.test(fecha) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(fecha)) {
	                        fecha = fecha.split('-');
	                        return this.format(new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]));
	                    }
	                }
	            } else {
	                if (this.Util.toType(date) == 'date') {
	                    return this.format(new Date(date));
	                }
	            }
	            return date;
	        }
	    }, {
	        key: 'toDate',
	        value: function toDate(string) {
	            if (this.Util.toType(string) == 'string') {
	                var pos = string.indexOf('T');
	                if (pos != -1 && pos <= 10 && pos >= 8) {
	                    var fecha = string.substring(0, pos);
	                    if (!/[a-zA-Z]+/g.test(fecha) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(fecha)) {
	                        fecha = fecha.split('-');
	                        return new Date(fecha[0], parseInt(fecha[1]) - 1, fecha[2]);
	                    }
	                }
	            }
	            return string;
	        }
	    }, {
	        key: 'isDate',
	        value: function isDate(date) {
	            if (this.Util.toType(date) == 'string') {
	                date = this.convert(date);
	            }
	            return this.isValid(date);
	        }
	    }, {
	        key: 'isValid',
	        value: function isValid(date) {
	            if (this.Util.toType(date) != 'date') return false;
	            return !isNaN(date.getTime());
	        }
	    }, {
	        key: 'isLessThan',
	        value: function isLessThan(date) {
	            return this.milliseconds(date) < new Date().getTime();
	        }
	    }, {
	        key: 'isLessThanDays',
	        value: function isLessThanDays(date, data) {
	            return this.milliseconds(date) > this.subtractDays(new Date(), data);
	        }
	    }, {
	        key: 'isGreaterThan',
	        value: function isGreaterThan(date) {
	            return this.milliseconds(date) > new Date().getTime();
	        }
	    }, {
	        key: 'isGreaterThanDays',
	        value: function isGreaterThanDays(date, data) {
	            return this.milliseconds(date) < this.addDays(new Date(), data);
	        }
	    }, {
	        key: 'addDays',
	        value: function addDays(date, days) {
	            return this.milliseconds(date) + (days || 0) * 24 * 60 * 60 * 1000;
	        }
	    }, {
	        key: 'subtractDays',
	        value: function subtractDays(date, days) {
	            return this.milliseconds(date) - (days || 0) * 24 * 60 * 60 * 1000;
	        }
	    }, {
	        key: 'diff',
	        value: function diff(date2, date1) {
	            return this.milliseconds(date2) - this.milliseconds(date1);
	        }
	    }, {
	        key: 'milliseconds',
	        value: function milliseconds(date) {
	            if (this.Util.toType(date) == 'string') {
	                date = this.convert(date);
	            }
	            return date.getTime();
	        }
	    }, {
	        key: 'convert',
	        value: function convert(date) {
	            date = date.split('/');
	            return this.formatDate == 'dd/MM/YYYY' ? new Date(date[2], date[1] - 1, date[0]) : this.formatDate == 'MM/dd/YYYY' ? new Date(date[2], date[0] - 1, date[1]) : new Date(date[0], date[1] - 1, date[2]);
	        }
	    }, {
	        key: 'setFormatDate',
	        value: function setFormatDate(format) {
	            this.formatDate = format;
	        }
	    }, {
	        key: 'now',
	        value: function now(format) {
	            return this.replace(new Date(), format || this.formatDate);
	        }
	    }, {
	        key: 'dateLiteral',
	        value: function dateLiteral(date) {
	            return this.format(date, 'dd de MMM del YYYY');
	        }
	    }, {
	        key: 'time',
	        value: function time(date) {
	            return this.format(date, 'HH:mm');
	        }
	    }, {
	        key: 'timeLiteral',
	        value: function timeLiteral(time, txt) {
	            var text = '';
	            if (typeof time == 'number') {
	                if (time === 0) {
	                    return '';
	                }
	                if (time < 60) {
	                    text = time + 's';
	                } else if (time < 3600) {
	                    text = Math.floor(time / 60) + 'm ' + (time % 60 > 0 ? time % 60 + 's' : '');
	                } else {
	                    text = Math.floor(time / 3600) + 'h ' + (time % 3600 > 0 ? Math.floor(time / 60) + 'm ' : '') + (time % 60 > 0 ? time % 60 + 's' : '');
	                }
	                return (txt || '') + text;
	            } else {
	                if (time.length === 0) {
	                    return '';
	                }
	                time = time.split(':');
	                var hours = time[0],
	                    minutes = time[1];
	
	                if (parseInt(hours) > 0) {
	                    text += parseInt(hours) + 'h ';
	                }
	                if (parseInt(minutes) > 0) {
	                    text += parseInt(minutes) + 'm ';
	                }
	                if (time.length == 3 && parseInt(time[2]) > 0) {
	                    text += parseInt(time[2]) + 's';
	                }
	
	                return (txt || '') + text;
	            }
	        }
	    }, {
	        key: 'getSeconds',
	        value: function getSeconds(time) {
	            time = time.split(':');
	            var hours = time[0],
	                minutes = time[1],
	                total = 0;
	
	            if (parseInt(hours) > 0) {
	                total += parseInt(hours) * 3600;
	            }
	            if (parseInt(minutes) > 0) {
	                total += parseInt(minutes) * 60;
	            }
	            if (time.length == 3 && parseInt(time[2]) > 0) {
	                total += parseInt(time[2]);
	            }
	
	            return total;
	        }
	    }, {
	        key: 'datetimeLiteral',
	        value: function datetimeLiteral(date) {
	            return this.format(date, 'dddd dd de MMM del YYYY a la(s) HH:mm');
	        }
	    }, {
	        key: 'format',
	        value: function format(date, _format) {
	            var d = new Date(date);
	            if (this.isDate(d)) {
	                return this.replace(d, _format || this.formatDate);
	            }
	            return date;
	        }
	    }, {
	        key: 'standar',
	        value: function standar(date, format) {
	            if (date) {
	                var type = this.Util.toType(date);
	                if (type == 'date') {
	                    return date;
	                }
	                var day, month, year;
	                if (type == 'string') {
	                    format = format || this.formatDate;
	                    var separator = date.indexOf('/') != -1 ? '/' : '-';
	                    date = date.split(separator);
	
	                    if (format == 'dd-MM-YYYY' || format == 'dd/MM/YYYY') {
	                        day = date[0];
	                        month = date[1] - 1;
	                        year = date[2];
	                    }
	
	                    if (format == 'MM-dd-YYYY' || format == 'MM/dd/YYYY') {
	                        day = date[1];
	                        month = date[0] - 1;
	                        year = date[2];
	                    }
	
	                    if (format == 'YYYY-MM-dd' || format == 'YYYY/MM/dd') {
	                        day = date[2];
	                        month = date[1] - 1;
	                        year = date[0];
	                    }
	
	                    if (format == 'YYYY-dd-MM' || format == 'YYYY/dd/MM') {
	                        day = date[1];
	                        month = date[2] - 1;
	                        year = date[0];
	                    }
	                }
	                return new Date(year, month, day);
	            }
	            return null;
	        }
	    }, {
	        key: 'replace',
	        value: function replace(date, format) {
	            format = format || this.formatDate;
	            date = this.standar(date, format);
	            var monthLiteral = format.indexOf('MMM') != -1;
	            return this.ArrayUtil.replace(format, ["dddd", "ddd", "dd", monthLiteral ? 'MMM' : 'MM', 'YYYY', 'HH', 'mm', 'ss'], [this.dayslong[date.getDay()], this.days[date.getDay()], (date.getDate() < 10 ? '0' : '') + date.getDate(), monthLiteral ? this.months[date.getMonth()] : (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1), date.getFullYear(), (date.getHours() < 10 ? '0' : '') + date.getHours(), (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(), (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()]);
	        }
	    }, {
	        key: 'last',
	        value: function last(date) {
	            var now = new Date();
	            var days = this.daysBetweenTwoDates(date, now);
	            if (days > 31) {
	                return this.dateLiteral(date);
	            } else {
	                if (days > 7) {
	                    var weeks = parseInt(days / 7);
	                    return 'Hace ' + weeks + ' semana' + (weeks > 1 ? 's' : '');
	                } else {
	                    if (days >= 1) {
	                        return this.format(date, 'ddd a la(s) HH:mm');
	                    } else {
	                        var hours = this.hoursBetweenTwoDates(date, now);
	                        if (this.isYesterday(date, hours)) {
	                            return 'Ayer a la(s) ' + this.time(date);
	                        } else {
	                            if (hours >= 1) {
	                                return 'Hace ' + hours + ' hora' + (hours > 1 ? 's' : '');
	                            } else {
	                                var minutes = this.minutesBetweenTwoDates(date, now);
	                                if (minutes >= 1) {
	                                    return 'Hace ' + minutes + ' minuto' + (minutes > 1 ? 's' : '');
	                                } else {
	                                    var seconds = this.secondsBetweenTwoDates(date, now);
	                                    return 'Hace ' + seconds + ' segundo' + (seconds > 1 ? 's' : '');
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'secondsBetweenTwoDates',
	        value: function secondsBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "s", absolute);
	        }
	    }, {
	        key: 'minutesBetweenTwoDates',
	        value: function minutesBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "i", absolute);
	        }
	    }, {
	        key: 'hoursBetweenTwoDates',
	        value: function hoursBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "h", absolute);
	        }
	    }, {
	        key: 'daysBetweenTwoDates',
	        value: function daysBetweenTwoDates(date1, date2, absolute) {
	            return this.betweenTwoDates(date1, date2, "d", absolute);
	        }
	    }, {
	        key: 'betweenTwoDates',
	        value: function betweenTwoDates(date1, date2, type, absolute) {
	            var types = { s: 1000, i: 60 * 1000, h: 60 * 60 * 1000, d: 24 * 60 * 60 * 1000 };
	            var diff = parseInt((this.standar(date2).getTime() - this.standar(date1).getTime()) / types[type]);
	
	            if (typeof absolute !== 'undefined' && absolute !== false) {
	                return Math.abs(diff);
	            }
	            return diff;
	        }
	    }, {
	        key: 'isYesterday',
	        value: function isYesterday(date, hours) {
	            if (this.isDate(date)) {
	                date = date.split(' ');
	                var time = date[1].split(':');
	                return hours >= parseInt(time[0]);
	            }
	            return false;
	        }
	    }, {
	        key: 'parseDate',
	        value: function parseDate(date) {
	            return [date.getDate(), date.getMonth() + 1, date.getFullYear()].join('/');
	        }
	    }, {
	        key: 'parseDateDjango',
	        value: function parseDateDjango(date) {
	            return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
	        }
	    }]);
	
	    return DatetimeService;
	}();
	
	exports.default = DatetimeService;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DemofiModalController = function () {
	    DemofiModalController.$inject = ["$scope", "Demofi", "Message", "$interval", "$q", "$http", "$uibModalInstance", "data", "DataService", "$log"];
	    function DemofiModalController($scope, Demofi, Message, $interval, $q, $http, $uibModalInstance, data, DataService, $log) {
	        'ngInject';
	
	        _classCallCheck(this, DemofiModalController);
	
	        this.$scope = $scope;
	        this.Demofi = Demofi;
	        this.Message = Message;
	        this.$interval = $interval;
	        this.$q = $q;
	        this.$http = $http;
	        this.$uibModalInstance = $uibModalInstance;
	        this.DataService = DataService;
	        this.$log = $log;
	
	        //   COMENZANDO CON LAS PANTALLAS
	        this.$scope.pin = undefined;
	        this.$scope.tokens = [];
	        this.$scope.certificados = [];
	        this.$scope.firmados = 0;
	        this.$scope.iniciado = false;
	        this.$scope.iniciando = false;
	        this.$scope.certificado_seleccionado = undefined;
	        this.$scope.solicitudes = data.solicitudes;
	        this.$scope.autenticado = false;
	        this.$scope.autenticando = false;
	        this.$scope.firmando = false;
	        this.$scope.demofi_ejecutandose = false;
	        this.$scope.token_conectado = false;
	        this.$scope.boton_autenticar_habilitado = false;
	        this.$scope.mostrar_progress = false;
	    }
	
	    _createClass(DemofiModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            // this.$log.log(this);
	            // introduciendo a todas las solicitudes un estado
	
	            this.$scope.solicitudes.forEach(function (it) {
	                it.estado = 'PENDIENTE';
	            });
	
	            this.$scope.iniciando = false;
	            this.verificarTokenConectado();
	            this.initInterval();
	        }
	    }, {
	        key: 'initInterval',
	        value: function initInterval() {
	            var _this = this;
	
	            this.idInterval = this.$interval(function () {
	                _this.verificarTokenConectado();
	            }, 2000);
	        }
	    }, {
	        key: 'cancelInterval',
	        value: function cancelInterval() {
	            if (this.idInterval) {
	                this.$interval.cancel(this.idInterval);
	                this.idInterval = undefined;
	            }
	        }
	    }, {
	        key: 'verificarTokenConectado',
	        value: function verificarTokenConectado() {
	            var _this2 = this;
	
	            if (this.$scope.iniciando === false) {
	                this.$scope.iniciando = true;
	                this.Demofi.listTokens().then(function (response) {
	                    // this.$log.log('verificarTokenConectado-then', response)
	                    _this2.$scope.iniciando = false;
	                    _this2.$scope.iniciado = true;
	                    _this2.$scope.demofi_ejecutandose = true;
	                    _this2.$scope.tokens = response.datos;
	                    _this2.$scope.token_conectado = response.datos.length > 0;
	                }).catch(function () {
	                    // this.$log.log('verificarTokenConectado-catch', error)
	                    _this2.$scope.iniciando = false;
	                    _this2.$scope.iniciado = true;
	                    _this2.$scope.token_conectado = false;
	                    _this2.$scope.demofi_ejecutandose = false;
	                });
	            }
	        }
	    }, {
	        key: 'autenticar',
	        value: function autenticar() {
	            var _this3 = this;
	
	            this.$scope.mostrar_progress = true;
	            this.$scope.autenticando = true;
	            this.cancelInterval();
	            this.Demofi.login(this.$scope.pin).then(function (respLogin) {
	                // this.$log.log(respLogin);:vsp
	                //
	                _this3.$scope.mostrar_progress = false;
	                _this3.$scope.autenticando = false;
	                if (respLogin.finalizado === true) {
	                    _this3.$scope.boton_autenticar_habilitado = false;
	
	                    // Obtener certificados
	                    _this3.$scope.autenticado = true;
	                    // Una ves autenticado actualizamos la lista de certificados
	                    _this3.Demofi.listCertificates().then(function (respCert) {
	                        _this3.$scope.certificados = respCert.datos;
	                        if (_this3.$scope.certificados[0]) {
	                            _this3.$scope.certificado_seleccionado = _this3.$scope.certificados[0];
	                        }
	                    });
	                }
	            }).catch(function (error) {
	                // this.$log.log(error);
	                _this3.$scope.mostrar_progress = false;
	                _this3.$scope.autenticando = false;
	                _this3.$scope.pin = undefined;
	                _this3.$scope.autenticado = false;
	                _this3.$scope.boton_autenticar_habilitado = true;
	                _this3.Message.warning(error.mensaje);
	                _this3.initInterval();
	            });
	        }
	    }, {
	        key: 'cancelar',
	        value: function cancelar() {
	            // Cerrando session con el token
	            this.Demofi.logout();
	            // .then(function (respLogin){});
	            this.cancel();
	            if (this.idInterval) this.$interval.cancel(this.idInterval);
	        }
	    }, {
	        key: 'descargarFirmarSubir',
	        value: function descargarFirmarSubir(solDoc, aliasSeleccionado) {
	            this.$scope.mostrar_progress = true;
	            var this_ = this;
	            return this.$q(function (resolve, reject) {
	                solDoc.estado = "DESCARGANDO";
	                this_.Demofi.getFileBase64(solDoc.url_source_pdf).then(function (base64Pdf) {
	                    // Descargar de pdf en base64 completada. Iniciando solicitud de PDF
	                    solDoc.pdf_base64 = base64Pdf;
	                    // solDoc.pdf_base64 = `data:text/html;base64,${base64Pdf}`;
	                    solDoc.estado = "FIRMANDO";
	                    this_.Demofi.sign(solDoc, aliasSeleccionado).then(function (respFirma) {
	                        // this_.$log.log('respFirma', respFirma)
	                        // Verificar si el archivo se pudo firmar
	                        if (respFirma.finalizado === false) {
	                            solDoc.estado = "ERROR_FIRMA";
	                            reject(respFirma);
	                            return;
	                        }
	                        solDoc.estado = "ACTUALIZANDO";
	                        // PDF firmado correctamente
	                        var dataPost = {
	                            codigo_archivo: solDoc.codigo_archivo,
	                            pdf_base64_signed: respFirma.datos.pdf_base64,
	                            certificado: respFirma.datos.certificado
	                        };
	                        var config = { headers: { Authorization: solDoc.authorization } };
	
	                        //                                        $http.post(solDoc.url_upload_pdf, dataPost).success(function (dataUploaded, status, headers, config)
	                        this_.$http.post(solDoc.url_upload_pdf, dataPost, config).then(function () {
	                            solDoc.estado = "ACTUALIZADO";
	                            resolve(respFirma);
	                            //                                        }).error(function (errorUpdate, status, header, config)
	                        }).catch(function (errorUpdate) {
	                            this_.$scope.mostrar_progress = false;
	                            solDoc.estado = "ERROR_ACTUALIZACION";
	                            reject(errorUpdate);
	                        });
	                    }).catch(function (error) {
	                        this_.$scope.mostrar_progress = false;
	                        solDoc.estado = "ERROR_FIRMA";
	                        reject(error);
	                    });
	                }).catch(function (error) {
	                    this_.$scope.mostrar_progress = false;
	                    solDoc.estado = "ERROR_DESCARGA";
	                    reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'firmar',
	        value: function firmar() {
	            // Obtener todos los documentos en blobs
	            var aliasSeleccionado = this.$scope.certificado_seleccionado.alias;
	            var certificadoFinValidez = this.$scope.certificado_seleccionado.finValidez;
	            var partesFecha = certificadoFinValidez.split('/');
	            var fechaFinValidez = new Date(partesFecha[2], partesFecha[1] - 1, partesFecha[0]);
	            var fechaActual = new Date();
	            var indice = 0;
	            this.$scope.firmando = true;
	            this.$scope.firmados = 0;
	            var firmadosConError = 0;
	            var respActualizaciones = [];
	            var ctrl = this;
	            this.$log.log('================', certificadoFinValidez, new Date(partesFecha[2], partesFecha[1] - 1, partesFecha[0]), Date());
	            if (fechaActual > fechaFinValidez) {
	                this.Message.error('La vigencia del certificado ha caducado, no puede firmar ningun documento.');
	                return;
	            }
	            var continuarOFinalizarFirma = function continuarOFinalizarFirma(respuestaActualizacion) {
	                respActualizaciones.push(respuestaActualizacion);
	
	                ctrl.$scope.firmados++;
	                if (indice + 1 >= ctrl.$scope.solicitudes.length) {
	                    ctrl.Demofi.logout();
	                    ctrl.$scope.firmando = false;
	                    ctrl.cancelInterval();
	                    ctrl.cancel(respActualizaciones);
	                } else {
	                    indice++;
	                    firmarDocumento();
	                }
	            };
	            var firmarDocumento = function firmarDocumento() {
	                ctrl.$log.log(ctrl);
	                ctrl.descargarFirmarSubir(ctrl.$scope.solicitudes[indice], aliasSeleccionado).then(continuarOFinalizarFirma).catch(function (error) {
	                    firmadosConError++;
	                    ctrl.$log.log(firmadosConError, error.data);
	                    ctrl.Message.error(error.data.mensaje);
	                    continuarOFinalizarFirma();
	                });
	            };
	            firmarDocumento();
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel(data) {
	            if (data) {
	                this.$uibModalInstance.close(data);
	            } else {
	                this.$uibModalInstance.dismiss();
	            }
	        }
	    }]);
	
	    return DemofiModalController;
	}();
	
	exports.default = DemofiModalController;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _demofi = __webpack_require__(220);
	
	var _demofi2 = _interopRequireDefault(_demofi);
	
	__webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Demofi = angular.module('app.demofi', []).service('Demofi', _demofi2.default).config(["$httpProvider", function ($httpProvider) {
	    $httpProvider.interceptors.push(function () {
	        'ngInject';
	
	        return {
	            'request': function request(config) {
	                if (config.isDemofi) {
	                    config.headers = { 'Accept': 'application/json' };
	                    // config.headers = { 'Accept': 'application/json, text/javascript, */*; q=0.01' };
	                    if (config.isDemofiSign) {
	                        config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
	                    }
	                }
	                return config;
	            }
	        };
	    });
	}]).name;
	
	exports.default = Demofi;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _demofiModal = __webpack_require__(562);
	
	var _demofiModal2 = _interopRequireDefault(_demofiModal);
	
	var _demofiModal3 = __webpack_require__(218);
	
	var _demofiModal4 = _interopRequireDefault(_demofiModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DemofiService = function () {
	    DemofiService.$inject = ["$log", "$q", "$http", "$compile", "Modal"];
	    function DemofiService($log, $q, $http, $compile, Modal) {
	        "ngInject";
	
	        _classCallCheck(this, DemofiService);
	
	        this.$log = $log;
	        this.$q = $q;
	        this.$http = $http;
	        this.$compile = $compile;
	        this.Modal = Modal;
	        //variables
	        this.url_demofi = 'https://localhost:3200';
	        this.req = {}; // variable para hacer las peticiones get
	    }
	
	    _createClass(DemofiService, [{
	        key: '$onInit',
	        value: function $onInit() {}
	
	        /**
	         * Muestra un dialogo para realizar la firma de documentos pdf y posteriormente 
	         * puede subir el documento firmado.
	         * solicitudes debe tener la siguiente forma:
	         * [
	         *      {
	         *              url_pdf:"http://localhost:5600/documentos/certificado.pdf",
	         *              nombre_archivo:"solicitudes_roe.pdf",
	         *              codigo_archivo:"asada-adas-a-fwq-rfqw-rqasa-wrqw"
	         *      }
	         * ] 
	         * @param {List Json} solicitudes Lista de documentos a firmar
	         */
	
	    }, {
	        key: 'openModal',
	        value: function openModal(solicitudes, config) {
	            return this.Modal.show({
	                template: _demofiModal2.default,
	                controller: _demofiModal4.default,
	                data: { solicitudes: solicitudes, config: config },
	                size: 'lg'
	            });
	        }
	    }, {
	        key: 'verificarServidor',
	        value: function verificarServidor() {
	            var w = 800;
	            var h = 400;
	            var y = window.outerHeight / 2 + window.screenY - h / 2;
	            var x = window.outerWidth / 2 + window.screenX - w / 2;
	            //            window.open("https://localhost:3200",'_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left='+x+', top='+y+', width='+w+', height='+h+', visible=none', ''); 
	            window.open(this.url_demofi, '_blank', 'toolbar=no,status=no,menubar=no,scrollbars=yes,left=' + x + ', top=' + y + ', width=' + w + ', height=' + h + ', visible=none', '');
	        }
	    }, {
	        key: 'listTokens',
	        value: function listTokens() {
	            this.req = {
	                method: 'GET',
	                url: this.url_demofi + '/tokens',
	                isDemofi: true
	            };
	
	            return this.initRequest(this.req);
	        }
	    }, {
	        key: 'login',
	        value: function login(pinToken) {
	            this.req = {
	                method: 'GET',
	                // method: 'POST',
	                url: this.url_demofi + '/start?pin=' + pinToken,
	                isDemofi: true
	                // data: { pin: pinToken },
	            };
	
	            return this.initRequest(this.req);
	        }
	    }, {
	        key: 'listCertificates',
	        value: function listCertificates() {
	            this.req = {
	                method: 'GET',
	                url: this.url_demofi + '/certs',
	                isDemofi: true
	            };
	            return this.initRequest(this.req);
	        }
	    }, {
	        key: 'sign',
	        value: function sign(solicitudFirma, aliasParaFirmar) {
	            var _this = this;
	
	            var dataSend = {
	                nombre_archivo: solicitudFirma.codigo_archivo,
	                pdf_base64: solicitudFirma.pdf_base64,
	                alias: aliasParaFirmar
	            };
	
	            this.req = {
	                method: 'POST',
	                url: this.url_demofi + '/sign',
	                isDemofi: true,
	                isDemofiSign: true,
	                data: dataSend
	            };
	
	            return this.$q(function (resolve, reject) {
	                _this.$http(_this.req).then(function (result) {
	                    resolve(result.data);
	                }).catch(function (error) {
	                    reject({ finalizado: false, mensaje: "Demofi no se esta ejecutando en su equipo" + error });
	                });
	            });
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.req = {
	                method: 'GET',
	                url: this.url_demofi + '/finish',
	                isDemofi: true
	            };
	
	            return this.initRequest(this.req);
	        }
	    }, {
	        key: 'initRequest',
	        value: function initRequest(req) {
	            var _this2 = this;
	
	            return this.$q(function (resolve, reject) {
	                _this2.$http(req).then(function (data) {
	                    // this.$log.log('exito initRequest', data)
	                    if (data.data.finalizado === false) {
	                        reject(data.data);
	                        return;
	                    }
	                    resolve(data.data);
	                }).catch(function (error) {
	                    // this.$log.log('catch initRequest', error)
	                    if (error) {
	                        //Message.error("Demofi no se esta ejecutando en su equipo");
	                        reject({ finalizado: false, mensaje: "Demofi no se esta ejecutando en su equipo" });
	                    } else {
	                        //Message.error("No se puede conectar con Demofi. Verifique que el programa se este ejecutando en su maquina.");
	                        reject({ finalizado: false, mensaje: "No se puede conectar con Demofi. Verifique que el programa se este ejecutando en su maquina." });
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'getFileBase64',
	        value: function getFileBase64(urlFile) {
	            var this_ = this;
	            return this.$q(function (resolve, reject) {
	                this_.$http.post(urlFile).then(function (respuesta) {
	                    resolve(respuesta.data.datos);
	                }).catch(function (error) {
	                    reject(error);
	                });
	            });
	        }
	    }]);
	
	    return DemofiService;
	}();
	
	exports.default = DemofiService;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _filter = __webpack_require__(222);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	__webpack_require__(156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function paste(obj, e) {
	    e.stopPropagation();
	    e.preventDefault();
	
	    var pastedData = void 0;
	    if (window.clipboardData && window.clipboardData.getData) {
	        // IE       
	        pastedData = window.clipboardData.getData('Text');
	    } else if (e.clipboardData && e.clipboardData.getData) {
	        pastedData = e.clipboardData.getData('text/plain');
	    }
	
	    if (typeof pastedData == 'string' && pastedData.length) {
	        pastedData = pastedData.trim();
	    }
	
	    if (obj.maxLength !== undefined) {
	        var maxLength = parseInt(obj.maxLength);
	        if (maxLength && maxLength > 0 && typeof maxLength == 'number') {
	            pastedData = pastedData.substring(0, maxLength);
	        }
	    }
	
	    return pastedData;
	}
	
	function setTextPaste(scope, ngModel, text) {
	    ngModel = ngModel.replace('$ctrl.', '');
	    var model = ngModel.split('.');
	    if (model.length > 1) {
	        if (model.length == 2) {
	            scope.$ctrl[model[0]][model[1]] = text;
	        } else if (model.length == 3) {
	            scope.$ctrl[model[0]][model[1]][model[2]] = text;
	        } else if (model.length == 4) {
	            scope.$ctrl[model[0]][model[1]][model[2]][model[3]] = text;
	        }
	    } else {
	        scope.$ctrl[ngModel] = text;
	    }
	}
	
	var Filter = angular.module('app.service.filter', []).service('Filter', _filter2.default).directive('integer', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.integer(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isInteger(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isInteger(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimal', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimal(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimal(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimal(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimalPositive', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimalPositive(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimalPositive(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimalPositive(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('decimalFormat', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.decimalFormat(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isDecimalFormat(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isDecimalFormat(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('numeric', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.numeric(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isNumeric(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isNumeric(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alpha', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alpha(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlpha(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlpha(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alphaNumeric', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alphaNumeric(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlphaNumeric(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlphaNumeric(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('alphaDash', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.alphaDash(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isAlphaDash(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isAlphaDash(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('passport', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.passport(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isPassport(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isPassport(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('phone', ["Filter", function (Filter) {
	    return function (scope, element, attr) {
	        element.bind("keydown", function (e) {
	            Filter.phone(e);
	        }).bind('paste', function (e) {
	            if (attr.trimPaste !== undefined) {
	                var text = paste(element[0], e);
	                scope.$apply(function () {
	                    text = Filter.isPhone(text) ? text : '';
	                    setTextPaste(scope, attr.ngModel, text);
	                });
	            } else {
	                setTimeout(function () {
	                    if (!Filter.isPhone(element[0].value)) {
	                        element[0].value = '';
	                    }
	                }, 1);
	            }
	        });
	    };
	}]).directive('uppercase', function () {
	    return {
	        require: 'ngModel',
	        link: function link(scope, element, attrs, ctrl) {
	            ctrl.$parsers.push(function (input) {
	                return input ? input.toUpperCase() : "";
	            });
	            element.css("text-transform", "uppercase");
	        }
	    };
	}).directive('nit', ["Filter", function (Filter) {
	    var $error = angular.element('<div class="md-error-nit">NIT inválido</div>');
	
	    return function (scope, element) {
	        element.bind("keydown", function (e) {
	            Filter.numeric(e);
	        }).bind("keyup", function () {
	            var isNit = Filter.isNit(element[0].value);
	            var $element = angular.element(element[0]).parent();
	            if (!isNit) {
	                $element.append($error);
	                $element.addClass('relative');
	            } else {
	                $error.remove();
	                $element.removeClass('relative');
	            }
	        }).bind('paste', function () {
	            setTimeout(function () {
	                if (!Filter.isNit(element[0].value)) {
	                    element[0].value = '';
	                }
	            }, 1);
	        });
	    };
	}]).directive('focusMe', ['$timeout', function ($timeout) {
	    return {
	        scope: { trigger: '@focusMe' },
	        link: function link(scope, element) {
	            scope.$watch('trigger', function (value) {
	                if (value === "true") {
	                    $timeout(function () {
	                        element[0].focus();
	                    });
	                }
	            });
	        }
	    };
	}]).directive('focusIf', ['$timeout', function ($timeout) {
	    function link($scope, $element, $attrs) {
	        var dom = $element[0];
	        if ($attrs.focusIf) {
	            $scope.$watch($attrs.focusIf, focus);
	        } else {
	            focus(true);
	        }
	        function focus(condition) {
	            if (condition) {
	                $timeout(function () {
	                    dom.focus();
	                }, $scope.$eval($attrs.focusDelay) || 0);
	            }
	        }
	    }
	    return {
	        restrict: 'A',
	        link: link
	    };
	}]).name;
	
	exports.default = Filter;

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FilterService = function () {
	    function FilterService() {
	        var _this = this;
	
	        _classCallCheck(this, FilterService);
	
	        this.exceptions = {
	            "integer": [46, 8, 9, 27, 13, 110, 173, 189, 109],
	            "natural": [46, 8, 9, 27, 13, 110, 190],
	            "decimal": [46, 8, 9, 27, 13, 110, 190, 173, 189, 109],
	            "decimal-positive": [46, 8, 9, 27, 13, 110, 190],
	            "numeric": [46, 8, 9, 27, 13],
	            "alpha": [46, 8, 9, 27, 13, 32],
	            "alpha_dash": [46, 8, 9, 27, 13, 32, 173, 189, 109]
	        };
	        this.exceptions.alpha_numeric = this.exceptions.alpha;
	        this.evaluate = {
	            numeric: function numeric(e) {
	                return (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105);
	            },
	            alpha: function alpha(e) {
	                return e.keyCode < 65 || e.keyCode > 90;
	            }
	        };
	        this.evaluate.integer = this.evaluate.numeric;
	        this.evaluate.decimal = this.evaluate.numeric;
	        this.evaluate.natural = this.evaluate.numeric;
	        this.evaluate['decimal-positive'] = this.evaluate.numeric;
	        this.evaluate.alpha_numeric = function (e) {
	            return _this.evaluate.alpha(e) && _this.evaluate.numeric(e);
	        };
	        this.evaluate.alpha_dash = this.evaluate.alpha_numeric;
	    }
	
	    _createClass(FilterService, [{
	        key: "$onInit",
	        value: function $onInit() {}
	    }, {
	        key: "nit",
	        value: function nit() {
	            var nit = {
	                verhoeff: function verhoeff(x, y) {
	                    var m = ['0123456789', '1234067895', '2340178956', '3401289567', '4012395678', '5987604321', '6598710432', '7659821043', '8765932104', '9876543210'];
	                    if (m[x] && m[x][y]) {
	                        return parseInt(m[x][y]);
	                    }
	                    return -1;
	                },
	
	                permutations: function permutations(x, y) {
	                    var m = ['0123456789', '1576283094', '5803796142', '8916043527', '9453126870', '4286573901', '2793806415', '7046913258'];
	                    if (m[x] && m[x][y]) {
	                        return parseInt(m[x][y]);
	                    }
	                    return -1;
	                },
	
	                evaluate: function evaluate(num) {
	                    var check = 0,
	                        x,
	                        y,
	                        z;
	
	                    if (typeof num == 'string' && isNaN(num)) {
	                        return false;
	                    }
	                    num = parseInt(num);
	                    for (var i = 0, l = num.toString().length; i < l; i++) {
	                        x = i % 8;
	                        y = num % 10;
	                        num = Math.floor(num / 10);
	                        z = nit.permutations(x, y);
	                        check = nit.verhoeff(check, z);
	                    }
	
	                    return check === 0;
	                }
	            };
	
	            return nit;
	        }
	    }, {
	        key: "filterBase",
	        value: function filterBase(e, type) {
	            if (e.altKey === true && e.keyCode >= 96 && e.keyCode <= 105) {
	                e.preventDefault();
	            }
	            if (this.exceptions[type].indexOf(e.keyCode) !== -1 || e.keyCode == 86 && e.ctrlKey === true || e.keyCode == 65 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
	                return;
	            }
	            if (this.evaluate[type](e)) {
	                if (type.indexOf('alpha') === 0) {
	                    if (!(e.key == 'ñ' || e.key == 'Ñ')) {
	                        e.preventDefault();
	                    }
	                } else {
	                    e.preventDefault();
	                }
	            }
	        }
	    }, {
	        key: "isNumber",
	        value: function isNumber(o) {
	            return typeof o === 'number' && isFinite(o);
	        }
	    }, {
	        key: "isFloat",
	        value: function isFloat(value) {
	            return value % 1 !== 0;
	        }
	    }, {
	        key: "integer",
	        value: function integer(e) {
	            this.filterBase(e, 'integer');
	        }
	    }, {
	        key: "isInteger",
	        value: function isInteger(value) {
	            if (/[a-zA-Z]+/g.test(value) || !/^-?[0-9.]*$/g.test(value)) {
	                return false;
	            }
	            value = this.convert(value);
	            if (value === 'NaN' || !this.isNumber(value)) {
	                return false;
	            }
	            return !this.isFloat(value);
	        }
	    }, {
	        key: "decimal",
	        value: function decimal(e) {
	            this.filterBase(e, 'decimal');
	        }
	    }, {
	        key: "isDecimal",
	        value: function isDecimal(value) {
	            if (/[a-zA-Z]+/g.test(value) || !/^-?[0-9.]+\,?[0-9]*$/g.test(value)) {
	                return false;
	            }
	            value = this.convert(value);
	            if (value === 'NaN') {
	                return false;
	            }
	            return this.isNumber(value);
	        }
	    }, {
	        key: "decimalPositive",
	        value: function decimalPositive(e) {
	            this.filterBase(e, 'decimal-positive');
	        }
	    }, {
	        key: "isDecimalPositive",
	        value: function isDecimalPositive(value) {
	            if (/[a-zA-Z]+/g.test(value) || !/^[0-9.]+\,?[0-9]*$/g.test(value)) {
	                return false;
	            }
	            value = this.convert(value);
	            if (value === 'NaN') {
	                return false;
	            }
	            return this.isNumber(value);
	        }
	    }, {
	        key: "decimalFormat",
	        value: function decimalFormat(e, cant) {
	            this.decimalPositive(e);
	
	            var valor = e.target.value;
	            var exceptions = [37, 39, 46, 8, 9];
	            var t = e.keyCode ? e.keyCode : e.which;
	            var target = e.target;
	            var regex = "^(\\d+(?:\\.?\\d{0," + (cant || 2) + "})?)?$";
	            regex = new RegExp(regex, 'g');
	
	            if (valor.match(/\./g)) {
	                if (t == 190 || t == 110) {
	                    e.preventDefault();
	                }
	                var char = t >= 96 && t <= 105 ? t - 96 : String.fromCharCode(t);
	                var newValue = valor.substring(0, target.selectionStart) + char + valor.substring(target.selectionEnd);
	                if (!regex.test(newValue) && exceptions.indexOf(t) == -1) {
	                    e.preventDefault();
	                }
	                // if (!/^(\d+(?:\.?\d{0,2})?)?$/g.test(newValue) && exceptions.indexOf(t) == -1) {
	                //     e.preventDefault();
	                // }
	            } else {
	                if (t == 190 || t == 110) {
	                    var decimal = valor.substring(target.selectionEnd);
	                    if (decimal.length > 2) {
	                        decimal = decimal.substring(0, 2);
	                        e.target.value = valor.substring(0, target.selectionStart) + '.' + decimal;
	                        e.preventDefault();
	                    }
	                    if (valor.length === 0) {
	                        e.target.value = '0';
	                    }
	                }
	            }
	        }
	    }, {
	        key: "isDecimalFormat",
	        value: function isDecimalFormat(value) {
	            return (/^(\d+(?:\.?\d{0,2})?)?$/g.test(value)
	            );
	        }
	    }, {
	        key: "natural",
	        value: function natural(e) {
	            this.filterBase(e, 'natural');
	        }
	    }, {
	        key: "isNatural",
	        value: function isNatural(value) {
	            if (/[a-zA-Z]+/g.test(value) || !/^[0-9]*$/g.test(value)) {
	                return false;
	            }
	            value = this.convert(value);
	            if (value === 'NaN' || !this.isNumber(value)) {
	                return false;
	            }
	            return !this.isFloat(value) && value >= 0;
	        }
	    }, {
	        key: "numeric",
	        value: function numeric(e) {
	            this.filterBase(e, 'numeric');
	        }
	    }, {
	        key: "isNumeric",
	        value: function isNumeric(value) {
	            return (/^([0-9])*$/.test(value)
	            );
	        }
	    }, {
	        key: "alpha",
	        value: function alpha(e) {
	            this.filterBase(e, 'alpha');
	        }
	    }, {
	        key: "isAlpha",
	        value: function isAlpha(value) {
	            return (/^[\u00D1\u00F1A-Z a-z]*$/.test(value)
	            );
	        }
	    }, {
	        key: "alphaNumeric",
	        value: function alphaNumeric(e) {
	            this.filterBase(e, 'alpha_numeric');
	        }
	    }, {
	        key: "isAlphaNumeric",
	        value: function isAlphaNumeric(value) {
	            return (/^[\u00D1\u00F1A-Z a-z0-9]*$/.test(value)
	            );
	        }
	    }, {
	        key: "alphaDash",
	        value: function alphaDash(e) {
	            this.filterBase(e, 'alpha_dash');
	        }
	    }, {
	        key: "isAlphaDash",
	        value: function isAlphaDash(value) {
	            return (/^[\u00D1\u00F1A-Z a-z-_0-9]*$/.test(value)
	            );
	        }
	    }, {
	        key: "passport",
	        value: function passport(e) {
	            var type = 'alpha_numeric';
	            if (e.altKey === true && e.keyCode >= 96 && e.keyCode <= 105) {
	                e.preventDefault();
	            }
	            if (this.exceptions[type].indexOf(e.keyCode) !== -1 || e.keyCode == 86 && e.ctrlKey === true || e.keyCode == 65 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
	                return;
	            }
	            if (this.evaluate[type](e)) {
	                if (!/[\u00D1\u00F1\-\.]/.test(e.key)) e.preventDefault();
	            }
	        }
	    }, {
	        key: "isPassport",
	        value: function isPassport(value) {
	            return (/^[\u00D1\u00F1A-Z a-z-_0-9 \.]*$/.test(value)
	            );
	        }
	    }, {
	        key: "phone",
	        value: function phone(e) {
	            var type = 'numeric';
	            if (e.altKey === true && e.keyCode >= 96 && e.keyCode <= 105) {
	                e.preventDefault();
	            }
	            if (this.exceptions[type].indexOf(e.keyCode) !== -1 || e.keyCode == 86 && e.ctrlKey === true || e.keyCode == 65 && e.ctrlKey === true || e.keyCode >= 35 && e.keyCode <= 39) {
	                return;
	            }
	            if (this.evaluate[type](e)) {
	                if (!/[\d()*+\- ]/.test(e.key)) e.preventDefault();
	            }
	        }
	    }, {
	        key: "isPhone",
	        value: function isPhone(value) {
	            return (/[\d()*+\- ]+/.test(value)
	            );
	            // return /^(?:(?:\(?(?:00|\+)([1-e]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(value);
	        }
	    }, {
	        key: "removeTagHTML",
	        value: function removeTagHTML(text) {
	            return text.replace(/<([^ >]+)[^>]*>.*?<\/\1>|<[^\/]+\/>/gi, "");
	        }
	    }, {
	        key: "empty",
	        value: function empty(value) {
	            return value === undefined || value === null || value.length === 0 || /^\s+$/.test(value);
	        }
	    }, {
	        key: "isEmail",
	        value: function isEmail(value) {
	            return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
	            );
	        }
	    }, {
	        key: "convert",
	        value: function convert(value) {
	            return parseFloat(isNaN(value) ? value.replace(/\./g, '').replace(',', '.') : value);
	        }
	    }, {
	        key: "isNit",
	        value: function isNit(value) {
	            return this.nit().evaluate(value);
	        }
	    }]);
	
	    return FilterService;
	}();
	
	exports.default = FilterService;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _message = __webpack_require__(224);
	
	var _message2 = _interopRequireDefault(_message);
	
	__webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Message = angular.module('app.message', []).service('Message', _message2.default).config(["toastrConfig", function (toastrConfig) {
	    angular.extend(toastrConfig, {
	        allowHtml: true,
	        closeButton: true,
	        extendedTimeOut: 2000,
	        progressBar: true,
	        tapToDismiss: false,
	        timeOut: 6000,
	        iconClasses: {
	            error: 'bg-danger',
	            info: 'bg-info',
	            success: 'bg-success',
	            warning: 'bg-warning'
	        }
	    });
	}]).name;
	
	exports.default = Message;

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessageService = function () {
	    MessageService.$inject = ["toastr", "$log"];
	    function MessageService(toastr, $log) {
	        "ngInject";
	
	        _classCallCheck(this, MessageService);
	
	        this.toastr = toastr;
	        this.$log = $log;
	    }
	
	    _createClass(MessageService, [{
	        key: 'success',
	        value: function success(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'La operación se realizó correctamente.',
	                title: title || 'Correcto',
	                type: 'success',
	                timeout: timeout,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'info',
	        value: function info(msg, title, timeout, callback) {
	            var data = {
	
	                message: msg || 'Revise la documentación.',
	                title: title || 'Información',
	                type: 'info',
	                timeout: timeout,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'error',
	        value: function error(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'Ocurrió un error al procesar su operación.',
	                title: title || 'Error',
	                type: 'error',
	                timeout: timeout,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: 'warning',
	        value: function warning(msg, title, timeout, callback) {
	            var data = {
	                message: msg || 'Ocurrió algo inesperado al procesar su operación.',
	                title: title || 'Advertencia',
	                type: 'warning',
	                timeout: timeout,
	                callback: callback
	            };
	
	            this._render(data);
	        }
	    }, {
	        key: '_render',
	        value: function _render(data) {
	            this.toastr[data.type](data.message, data.title);
	        }
	    }]);
	
	    return MessageService;
	}();
	
	exports.default = MessageService;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalController = function () {
	    ModalController.$inject = ["$uibModalInstance", "data", "title", "icon", "message", "labelOk", "labelCancel", "cancel", "eventCancel", "eventOk", "btnClose"];
	    function ModalController($uibModalInstance, data, title, icon, message, labelOk, labelCancel, cancel, eventCancel, eventOk, btnClose) {
	        'ngInject';
	
	        _classCallCheck(this, ModalController);
	
	        this.data = data;
	        this.title = title;
	        this.icon = icon;
	        this.message = message;
	        this.labelOk = labelOk;
	        this.eventCancel = eventCancel;
	        this.eventOk = eventOk;
	        this.labelCancel = labelCancel;
	        this.cancel = typeof cancel == 'undefined' ? true : cancel === '' ? true : cancel;
	        this.$uibModalInstance = $uibModalInstance;
	        this.btnClose = typeof btnClose == 'undefined' ? true : btnClose;
	    }
	
	    _createClass(ModalController, [{
	        key: 'ok',
	        value: function ok() {
	            this.$uibModalInstance.close(this.data);
	
	            if (typeof this.eventOk == 'function') {
	                this.eventOk();
	            }
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.$uibModalInstance.dismiss('cancel');
	
	            if (typeof this.eventCancel == 'function') {
	                this.eventCancel();
	            }
	        }
	    }]);
	
	    return ModalController;
	}();
	
	exports.default = ModalController;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _modal = __webpack_require__(227);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = angular.module('app.modal', []).service('Modal', _modal2.default).name;
	
	exports.default = Modal;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modal = __webpack_require__(225);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(563);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	var _pdfviewModal = __webpack_require__(228);
	
	var _pdfviewModal2 = _interopRequireDefault(_pdfviewModal);
	
	var _pdfviewModal3 = __webpack_require__(564);
	
	var _pdfviewModal4 = _interopRequireDefault(_pdfviewModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModalService = function () {
	    ModalService.$inject = ["$uibModal"];
	    function ModalService($uibModal) {
	        "ngInject";
	
	        _classCallCheck(this, ModalService);
	
	        this.$uibModal = $uibModal;
	    }
	
	    _createClass(ModalService, [{
	        key: 'show',
	        value: function show(config) {
	            var setting = {
	                animation: true,
	                ariaLabelledBy: 'modal-title',
	                ariaDescribedBy: 'modal-body',
	                template: config.template || _modal4.default,
	                controller: config.controller || _modal2.default,
	                controllerAs: '$ctrl',
	                size: config.size,
	                keyboard: typeof config.keyboard == 'undefined' ? true : config.keyboard,
	                backdrop: 'static',
	                resolve: {}
	            };
	
	            setData(config, setting, 'data');
	            setData(config, setting, 'title');
	            setData(config, setting, 'icon');
	            setData(config, setting, 'message');
	            setData(config, setting, 'labelOk');
	            setData(config, setting, 'labelCancel');
	            setData(config, setting, 'cancel');
	            setData(config, setting, 'eventCancel');
	            setData(config, setting, 'eventOk');
	            setData(config, setting, 'btnClose');
	
	            return this.$uibModal.open(setting);
	        }
	    }, {
	        key: 'alert',
	        value: function alert(message, callbackOk, title, icon, size) {
	            this.show({
	                title: title || 'Alerta',
	                icon: icon || 'bell',
	                message: message,
	                size: size || 'sm',
	                cancel: false,
	                eventOk: callbackOk,
	                keyboard: false,
	                btnClose: false
	            });
	        }
	    }, {
	        key: 'confirm',
	        value: function confirm(message, callbackOk, callbackCancel, title, labelOk, labelCancel, icon, size) {
	            var config = {
	                title: title || 'Confirmar',
	                icon: icon || 'warning',
	                message: message,
	                eventOk: callbackOk,
	                eventCancel: callbackCancel,
	                labelOk: labelOk,
	                labelCancel: labelCancel,
	                btnClose: false
	            };
	            if (typeof size == 'string') {
	                config.size = size;
	            }
	            this.show(config);
	        }
	    }, {
	        key: 'pdf',
	        value: function pdf(urlPdfFile, title, observaciones, firmador) {
	            var obj = {
	                urlPdf: urlPdfFile,
	                title: title,
	                observaciones: observaciones,
	                firmador: firmador
	            };
	
	            this.show({
	                template: _pdfviewModal4.default,
	                controller: _pdfviewModal2.default,
	                data: obj,
	                size: 'lg'
	            });
	        }
	    }]);
	
	    return ModalService;
	}();
	
	function setData(config, setting, data) {
	    setting.resolve[data] = function () {
	        return typeof config[data] == 'undefined' ? '' : config[data];
	    };
	}
	
	exports.default = ModalService;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PdfViewModalController = function () {
	  PdfViewModalController.$inject = ["$uibModalInstance", "data", "$sce", "DataService", "$log"];
	  function PdfViewModalController($uibModalInstance, data, $sce, DataService, $log) {
	    'ngInject';
	
	    _classCallCheck(this, PdfViewModalController);
	
	    this.item = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.DataService = DataService;
	    this.$log = $log;
	    this.loading = true;
	  }
	
	  _createClass(PdfViewModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      //var pdf = 'CONTENIDO_PDF_B64';
	      //this.urlPdf = this.$sce.trustAsResourceUrl('data:application/pdf;base64,' + pdf);
	      //var pdf = 'http://www.probolivia.gob.bo/Docs/proinfo/ConvenioInterinstitucional.pdf';
	
	      this.DataService.pdfO(this.item.urlPdf, {}).then(function (response) {
	        _this.$log.log('Documento Resp = ', response);
	        if (response) {
	          _this.$log.log('Documento = ', response);
	          _this.urlPdf = response;
	        }
	        _this.loading = false;
	      });
	
	      //    var pdf = 'http://mindesarrollo.demo.agetic.gob.bo/api/archivoPROBOLIVIA.pdf';
	      //    this.urlPdf = this.$sce.trustAsResourceUrl(pdf);
	      //    this.urlPdf = this.$sce.trustAsResourceUrl(this.fileURL);
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return PdfViewModalController;
	}();
	
	exports.default = PdfViewModalController;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * No se puede definir factories con las clases de EcmaScript 6, por lo cual se deben
	 * utilizar services para definir estos factories(factory), si se quieren factories 
	 * se deben condificar de la manera tradicional con la estructura:
	 * function () { return {} };
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _filter = __webpack_require__(221);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _data = __webpack_require__(214);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _storage = __webpack_require__(230);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _util = __webpack_require__(231);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _array = __webpack_require__(212);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _datetime = __webpack_require__(217);
	
	var _datetime2 = _interopRequireDefault(_datetime);
	
	var _message = __webpack_require__(223);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _modal = __webpack_require__(226);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _demofi = __webpack_require__(219);
	
	var _demofi2 = _interopRequireDefault(_demofi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Core = angular.module('app.services', [_filter2.default, _data2.default, _message2.default, _demofi2.default, _modal2.default]).service('Util', _util2.default).service('Storage', _storage2.default).service('ArrayUtil', _array2.default).service('Datetime', _datetime2.default).name;
	
	exports.default = Core;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StorageService = function () {
	    StorageService.$inject = ["$window", "appName"];
	    function StorageService($window, appName) {
	        'ngInject';
	
	        _classCallCheck(this, StorageService);
	
	        this.appName = appName || 'app';
	        this.$local = $window.localStorage;
	        this.$session = $window.sessionStorage;
	        this.$JSON = $window.JSON;
	    }
	
	    _createClass(StorageService, [{
	        key: 'setUser',
	        value: function setUser(user) {
	            this.set('user', user);
	        }
	    }, {
	        key: 'getUser',
	        value: function getUser() {
	            return this.get('user');
	        }
	    }, {
	        key: 'existUser',
	        value: function existUser() {
	            return this.exist('user');
	        }
	    }, {
	        key: 'removeUser',
	        value: function removeUser() {
	            this.remove('user');
	        }
	
	        // LocalStorage
	
	    }, {
	        key: 'set',
	        value: function set(key, value) {
	            this.$local.setItem(this.appName + '_' + key, this.$JSON.stringify(value));
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            var data = this.$local.getItem(this.appName + '_' + key);
	            try {
	                return this.$JSON.parse(data);
	            } catch (Exception) {
	                return data;
	            }
	        }
	    }, {
	        key: 'remove',
	        value: function remove(key) {
	            this.$local.removeItem(this.appName + '_' + key);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy(key) {
	            this.remove(key);
	        }
	    }, {
	        key: 'removeAll',
	        value: function removeAll() {
	            this.$local.clear();
	        }
	    }, {
	        key: 'exist',
	        value: function exist(key) {
	            var value = this.$local.getItem(this.appName + '_' + key);
	            return typeof value != 'undefined' && value != 'undefined' && value != null && value != 'null' && value != '[]';
	        }
	
	        // SessionStorage
	
	    }, {
	        key: 'setSession',
	        value: function setSession(key, value) {
	            this.$session.setItem(this.appName + '_' + key, this.$JSON.stringify(value));
	        }
	    }, {
	        key: 'getSession',
	        value: function getSession(key) {
	            return this.$JSON.parse(this.$session.getItem(this.appName + '_' + key));
	        }
	    }, {
	        key: 'removeSession',
	        value: function removeSession(key) {
	            this.$session.removeItem(this.appName + '_' + key);
	        }
	    }, {
	        key: 'existSession',
	        value: function existSession(key) {
	            var value = this.$session.getItem(this.appName + '_' + key);
	            return typeof value != 'undefined' && value != 'undefined' && value !== null && value != 'null' && value != '[]';
	        }
	
	        // Flash Data
	
	    }, {
	        key: 'getFlash',
	        value: function getFlash(key) {
	            if (this.exist(key)) {
	                var value = this.get(key);
	                this.remove(key);
	                return value;
	            }
	            return false;
	        }
	    }, {
	        key: 'flash',
	        value: function flash(key) {
	            this.getFlash(key);
	        }
	    }]);
	
	    return StorageService;
	}();
	
	exports.default = StorageService;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UtilService = function () {
	    UtilService.$inject = ["$injector", "$location", "$anchorScroll", "$log"];
	    function UtilService($injector, $location, $anchorScroll, $log) {
	        "ngInject";
	
	        _classCallCheck(this, UtilService);
	
	        this.$injector = $injector;
	        this.$location = $location;
	        this.$anchorScroll = $anchorScroll;
	        this.$log = $log;
	    }
	
	    _createClass(UtilService, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.tmpl_print = '\n            <!DOCTYPE html>\n            <html lang="en">\n            <head>\n                <meta charset="UTF-8"/>\n                <title>Document</title>\n                <style>{css}</style>\n            </head>\n            <body>{body}</body>\n            </html>';
	        }
	    }, {
	        key: 'toType',
	        value: function toType(obj) {
	            return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
	        }
	    }, {
	        key: 'isJson',
	        value: function isJson(text) {
	            return (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))
	            );
	        }
	    }, {
	        key: 'stripHTML',
	        value: function stripHTML(texto) {
	            return texto.replace(/(<([^>]+)>)/ig, "");
	        }
	    }, {
	        key: 'nano',
	        value: function nano(template, data) {
	            return template.replace(/\{([\w\.]*)\}/g, function (str, key) {
	                var keys = key.split("."),
	                    v = data[keys.shift()];
	                for (var i = 0, l = keys.length; i < l; i++) {
	                    v = v[keys[i]];
	                }return typeof v !== "undefined" && v !== null ? v : "";
	            });
	        }
	    }, {
	        key: 'print',
	        value: function print(html, css) {
	            var _this = this;
	
	            if (typeof css == 'string') {
	                angular.element.get(css, function (response) {
	                    var popup = window.open('', 'print');
	                    popup.document.write(_this.nano(_this.tmpl_print, { body: html, css: response }));
	                    popup.document.close();
	                    popup.focus();
	                    popup.print();
	                    popup.close();
	                });
	            } else {
	                var popup = window.open('', 'print');
	                popup.document.write(this.nano(this.tmpl_print, { body: html, css: css }));
	                popup.document.close();
	                popup.focus();
	                popup.print();
	                popup.close();
	            }
	
	            return true;
	        }
	
	        /**
	         * Función para crear una pausa para ejecutar una instrucción:
	         *  Ejemplo:
	         *
	         *  let funcionConDelay = this.Util.debounce(function() {
	         *      // ... lo que se quiere ejecutar con el retraso
	         *  }, 1000);
	         *
	         *  funcionConDelay(); // Ejecutando el retraso
	         */
	
	    }, {
	        key: 'debounce',
	        value: function debounce(func, wait, immediate) {
	            var timeout;
	            return function () {
	                var context = this,
	                    args = arguments;
	                var later = function later() {
	                    timeout = null;
	                    if (!immediate) func.apply(context, args);
	                };
	                var callNow = immediate && !timeout;
	                clearTimeout(timeout);
	                timeout = setTimeout(later, wait);
	                if (callNow) func.apply(context, args);
	            };
	        }
	    }, {
	        key: 'popup',
	        value: function popup(url) {
	            window.open(url, 'print');
	        }
	    }, {
	        key: 'fullscreen',
	        value: function fullscreen() {
	            if (!document.fullscreenElement && // alternative standard method
	            !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
	                // current working methods
	                if (document.documentElement.requestFullscreen) {
	                    document.documentElement.requestFullscreen();
	                } else if (document.documentElement.msRequestFullscreen) {
	                    document.documentElement.msRequestFullscreen();
	                } else if (document.documentElement.mozRequestFullScreen) {
	                    document.documentElement.mozRequestFullScreen();
	                } else if (document.documentElement.webkitRequestFullscreen) {
	                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	                }
	            } else {
	                if (document.exitFullscreen) {
	                    document.exitFullscreen();
	                } else if (document.msExitFullscreen) {
	                    document.msExitFullscreen();
	                } else if (document.mozCancelFullScreen) {
	                    document.mozCancelFullScreen();
	                } else if (document.webkitExitFullscreen) {
	                    document.webkitExitFullscreen();
	                }
	            }
	        }
	    }, {
	        key: 'size',
	        value: function size(obj) {
	            return Object.keys(obj).length;
	        }
	    }, {
	        key: 'serialize',
	        value: function serialize(json) {
	            var string = [];
	            for (var i in json) {
	                string.push(i + '=' + json[i]);
	            }
	            return string.join('&');
	        }
	    }, {
	        key: 'getMenuOption',
	        value: function getMenuOption(menu, url) {
	            for (var i in menu) {
	                if (typeof menu[i].submenu != 'undefined') {
	                    var pages = menu[i].submenu;
	                    for (var j in pages) {
	                        if (pages[j].url == url) {
	                            return [menu[i].label, pages[j].label];
	                        }
	                    }
	                }
	            }
	            for (var k in menu) {
	                if (menu[k].url == url) {
	                    return [menu[k].label, false];
	                }
	            }
	            return [false, false];
	        }
	    }, {
	        key: 'getKeys',
	        value: function getKeys(data) {
	            var types = {};
	
	            data.map(function (el) {
	                types[el.key] = el;
	            });
	
	            return types;
	        }
	
	        /**
	         * Public: funcion que retrasa la ejecucion de una funcion, y que al volverse a activar reinicia el timeout
	         * @param {Object} obj  objeto que guardara la referencia del intervalo
	         * @param {Integer} ms  tiempo en miliesgundos
	         * @param {Function} func funcion callback
	         * *
	         * Ejemplo
	         this.timer = {};
	         this.Util.funcDelay(this.timer, 1000, ()=> {
	           this.personalSave(form, per);
	         })
	         */
	
	    }, {
	        key: 'funcDelay',
	        value: function funcDelay(obj, ms, func) {
	            if (obj.timer_delay) clearTimeout(obj.timer_delay);
	
	            obj.timer_delay = setTimeout(function () {
	                obj.timer_delay = null;
	                func();
	            }, ms);
	        }
	    }, {
	        key: 'setTouchedForm',
	        value: function setTouchedForm(form, val, ignored, focusear) {
	            var focus, _funcRecursive;
	            // this.$log.log(form);
	            // this.$log.log(val, ignored);
	            if (ignored) {
	                focus = ignored.split(', ');
	                ignored = {};
	                focus.forEach(function (it) {
	                    ignored[it] = true;
	                });
	            } else {
	                ignored = {};
	            }
	            if (angular.isUndefined(val)) val = true;
	            focus = val && angular.isDefined(focusear);
	            // var visits = {};
	            // this.$log.log(visits);
	            _funcRecursive = function funcRecursive(form, val, ignored) {
	                form.$$controls.forEach(function (field) {
	                    // if (!visits[field.$name])
	                    // visits[field.$name] = 0;
	                    if (field.$name != '' && !ignored[field.$name]) {
	                        // visits[field.$name]++;
	                        if (field.$$controls) {
	                            _funcRecursive(field, val, ignored);
	                        } else {
	                            if (focus && field.$invalid) {
	                                // this.$log.log(field);
	                                var node = field.$$element[0];
	                                var x = node.contentEditable;
	                                node.contentEditable = true;
	                                if (node.disabled) {
	                                    node.disabled = false;
	                                    node.focus();
	                                    node.disabled = true;
	                                } else {
	                                    node.focus();
	                                }
	                                node.contentEditable = x;
	                                // this.$log.log(x, node);
	                                node = field.$$element.closest(focusear);
	                                if (node) {
	                                    // this.gotoAnchor(null, node);
	                                    node.classList.add('blink-container');
	                                    setTimeout(function () {
	                                        node.classList.remove('blink-container');
	                                    }, 5000);
	                                }
	
	                                // field.$$element.closest('div.form-group').focus();
	                                focus = !focus;
	                            }
	                            if (val) {
	                                field.$setTouched();
	                            } else {
	                                field.$setUntouched();
	                            }
	                        }
	                    }
	                });
	            };
	            _funcRecursive(form, val, ignored);
	        }
	    }, {
	        key: 'isValidForm',
	        value: function isValidForm(form, ignored) {
	            var resp, _funcRecursive2;
	            // this.$log.log(form);
	            // this.$log.log(val, ignored);
	            if (ignored) {
	                resp = ignored.split(', ');
	                ignored = {};
	                resp.forEach(function (it) {
	                    ignored[it] = true;
	                });
	            } else {
	                ignored = {};
	            }
	            resp = true;
	            // var visits = {};
	            // this.$log.log(visits);
	            _funcRecursive2 = function funcRecursive(form, ignored) {
	                form.$$controls.forEach(function (field) {
	                    // if (!visits[field.$name])
	                    // visits[field.$name] = 0;
	                    if (field.$name != '' && !ignored[field.$name]) {
	                        // visits[field.$name]++;
	                        if (field.$$controls) {
	                            _funcRecursive2(field, ignored);
	                        } else {
	                            if (field.$invalid) resp = false;
	                        }
	                    }
	                });
	            };
	            _funcRecursive2(form, ignored);
	            return resp;
	        }
	    }, {
	        key: 'id',
	        value: function id() {
	            var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	
	            var zero = '';
	            for (var i = 0, l = length; i < l; i++) {
	                zero += '0';
	            }
	            return (zero + (Math.random() * Math.pow(36, length) << 0).toString(36)).slice(-1 * length);
	        }
	    }, {
	        key: 'gotoAnchor',
	        value: function gotoAnchor(id) {
	            if (this.$location.hash() !== id) {
	                this.$location.hash(id);
	            } else {
	                this.$anchorScroll();
	            }
	            var el = document.querySelector('#' + id);
	            if (el) {
	                el.classList.add('blink-container');
	                setTimeout(function () {
	                    el.classList.remove('blink-container');
	                }, 8000);
	            }
	        }
	    }, {
	        key: 'generarRdxBancoUnion',
	        value: function generarRdxBancoUnion(cuenta, contrasena) {
	            return rdx(cuenta, contrasena); // eslint-disable-line no-undef
	        }
	    }]);
	
	    return UtilService;
	}();
	
	exports.default = UtilService;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(233);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _crudTable3 = __webpack_require__(565);
	
	var _crudTable4 = _interopRequireDefault(_crudTable3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CrudTableComponent = {
	    bindings: {
	        url: '<',
	        title: '<',
	        fields: '<',
	        fieldsCreate: '<',
	        fieldsUpdate: '<',
	        fieldsSave: '<',
	        fks: '<',
	        buttonsTop: '<',
	        buttons: '<',
	        checks: '<',
	        clases: '<',
	        queryExtra: '<',
	        noSorting: '=',
	        permission: '<',
	        modalController: '<',
	        modalTemplate: '<',
	        addModalTemplate: '<',
	        addModalController: '<',
	        editModalTemplate: '<',
	        editModalController: '<',
	        inline: '@',
	        editable: '@',
	        pagination: '@',
	        formly: '<',
	        data: '=',
	        callbackSave: '<',
	        hiddenFields: '<',
	        mergeFields: '<',
	        eventCreate: '<',
	        eventEdit: '<',
	        eventDelete: '<',
	        labels: '<',
	        delete: '<',
	        update: '<'
	    },
	    controller: _crudTable2.default,
	    template: _crudTable4.default
	};
	
	exports.default = CrudTableComponent;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _crudTableModal = __webpack_require__(234);
	
	var _crudTableModal2 = _interopRequireDefault(_crudTableModal);
	
	var _crudTableModal3 = __webpack_require__(566);
	
	var _crudTableModal4 = _interopRequireDefault(_crudTableModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableController = function () {
	    CrudTableController.$inject = ["$scope", "DataService", "NgTableParams", "Modal", "CrudTable", "Util", "ArrayUtil", "Message", "Datetime", "$log"];
	    function CrudTableController($scope, DataService, NgTableParams, Modal, CrudTable, Util, ArrayUtil, Message, Datetime, $log) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableController);
	
	        this.$scope = $scope;
	        this.DataService = DataService;
	        this.NgTableParams = NgTableParams;
	        this.Modal = Modal;
	        this.Message = Message;
	        this.Util = Util;
	        this.CrudTable = CrudTable;
	        this.ArrayUtil = ArrayUtil;
	        this.Datetime = Datetime;
	        this.$log = $log;
	
	        this.formlyDefault = [{
	            key: '',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }, {
	            key: 'updatedAt',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }, {
	            key: 'createdAt',
	            templateOptions: {
	                required: false
	            },
	            hideExpression: 'true'
	        }];
	
	        this.permissions = {
	            create: true,
	            read: true,
	            update: true,
	            delete: true,
	            print: false,
	            filter: true
	        };
	
	        this.options = {};
	    }
	
	    _createClass(CrudTableController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.getFields();
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                this.showFilter = false;
	            } else {
	                this.showFilter = true;
	            }
	
	            this.$scope.$on('refresh_crud_table', function (ev, url) {
	                if (url == _this.url) _this.refresh();
	            });
	        }
	    }, {
	        key: 'renderLabels',
	        value: function renderLabels(params) {
	            setTimeout(function () {
	                if (document.querySelector('.ng-table-counts')) {
	                    document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	                }
	                if (document.querySelector('.ng-table-pagination')) {
	                    document.querySelector('.ng-table-pagination').setAttribute('data-content', params.ini + ' al ' + params.end + ' de ' + params.total + ' Registros.');
	                }
	            }, 100);
	        }
	    }, {
	        key: 'addOptionSelected',
	        value: function addOptionSelected(data, options) {
	            for (var i in data) {
	                if (data[i].type == 'select') {
	                    var item = this.CrudTable.searchField(options, data[i].key);
	                    if (item) {
	                        this.ArrayUtil.insert(data[i].templateOptions.options, 0, {
	                            name: item.text || 'Seleccione',
	                            value: item.value || ''
	                        });
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'getFields',
	        value: function getFields() {
	            var _this2 = this;
	
	            if (this.data && this.data.formly && this.Util.toType(this.data.formly) == 'array') {
	                this.setDataFields(this.data.formly);
	            } else {
	                this.DataService.options(this.url).then(function (response) {
	                    _this2.setDataFields(response);
	                });
	            }
	        }
	    }, {
	        key: 'setDataFields',
	        value: function setDataFields() {
	            var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.fieldsData = this.CrudTable.filterFields(fields, this.fields);
	            this.idKey = this.CrudTable.getId(this.fieldsData);
	            this.formlyDefault[0].key = this.idKey;
	
	            if (this.formly && this.Util.toType(this.formly) == 'array') {
	                this.formly = this.CrudTable.addPropertiesFormly(this.formlyDefault, this.formly);
	            } else {
	                this.formly = this.formlyDefault;
	            }
	
	            this.fieldsData = this.CrudTable.addPropertiesFormly(this.fieldsData, this.formly);
	            this.addOptionSelected(this.fieldsData, this.optionSelected);
	            this.DataService.setFormly(this.fieldsData);
	
	            this.setHeaders(this.fieldsData);
	            if (this.editable) {
	                this.types = this.CrudTable.getKeys(this.fieldsData);
	            }
	            this.getData();
	
	            /**
	             * Campos para el formulario de adición
	             */
	            if (this.Util.toType(this.fieldsCreate) == 'array') {
	                this.fieldsCreate = this.CrudTable.filterFields(fields, this.fieldsCreate);
	                this.fieldsCreate = this.CrudTable.addPropertiesFormly(this.fieldsCreate, this.formly);
	            }
	
	            /**
	             * Campos para el formulario de actualización
	             */
	            if (this.Util.toType(this.fieldsUpdate) == 'array') {
	                this.fieldsUpdate = this.CrudTable.filterFields(fields, this.fieldsUpdate);
	                this.fieldsUpdate = this.CrudTable.addPropertiesFormly(this.fieldsUpdate, this.formly);
	            }
	
	            /**
	             * Campos para el formulario de adición/actualización
	             */
	            if (this.Util.toType(this.fieldsSave) == 'array') {
	                this.fieldsSave = this.CrudTable.filterFields(fields, this.fieldsSave);
	                this.fieldsSave = this.CrudTable.addPropertiesFormly(this.fieldsSave, this.formly);
	            }
	
	            if (this.permission) {
	                this.permissions = angular.merge(this.permissions, this.permission);
	            }
	        }
	    }, {
	        key: 'setHeaders',
	        value: function setHeaders(fields) {
	            var _this3 = this;
	
	            var headers = [{
	                field: "action",
	                title: "Acciones",
	                dataType: "command"
	            }];
	            var hiddenFields = this.Util.toType(this.hiddenFields) == 'array';
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                var _loop = function _loop() {
	                    var field = _step.value;
	                    sortable = field.key;
	
	                    if (_this3.noSorting !== undefined) {
	                        _this3.noSorting.forEach(function (it) {
	                            if (field.key == it) {
	                                sortable = '';
	                            }
	                        });
	                    }
	
	                    var config = {
	                        field: field.key,
	                        title: field.templateOptions.label,
	                        secondLabel: field.next && field.next.label ? field.next.label : '',
	                        headerTitle: field.templateOptions.label,
	                        sortable: sortable,
	                        show: hiddenFields ? _this3.hiddenFields.indexOf(field.key) === -1 && field.key != _this3.idKey : field.key != _this3.idKey
	                    };
	                    if (_this3.inline === undefined) {
	                        var filter = _defineProperty({}, field.key, field.templateOptions.type);
	                        // console.log('filter', filter);
	                        if (field.templateOptions.type == 'select' && field.templateOptions.options) {
	                            config.filterData = field.templateOptions.options;
	                        }
	                        config.filter = filter;
	                    }
	                    headers.push(config);
	                };
	
	                for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var sortable;
	
	                    _loop();
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.headers = headers;
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            this.getData();
	        }
	    }, {
	        key: 'getData',
	        value: function getData() {
	            var _this4 = this;
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                var data = { dataset: this.filterItems(this.data.list) };
	                var _config = {};
	                if (this.pagination === false || this.pagination === 'false') {
	                    _config.count = this.data.list.length;
	                    data.counts = [];
	                }
	
	                this.tableParams = new this.NgTableParams(_config, data);
	            } else {
	                this.tableParams = new this.NgTableParams({}, {
	                    getData: function getData(params) {
	                        var data = params.url();
	                        var query = {
	                            limit: data.count,
	                            page: data.page
	                        };
	                        var sort = _this4.getSorting(data);
	                        if (sort) {
	                            query.order = sort;
	                        }
	                        var filters = _this4.getFilters(data);
	                        if (filters.length) {
	                            if (filters[0].crudtable_search_term) {
	                                query.filter = filters[0].crudtable_search_term;
	                            } else {
	                                for (var i in filters) {
	                                    var key = Object.keys(filters[i])[0];
	                                    if (filters[i][key] && filters[i][key] !== null && filters[i][key] != 'null') {
	                                        query[key] = filters[i][key];
	                                    }
	                                }
	                                // query.filter = JSON.stringify(filters);
	                            }
	                        }
	
	                        if (_this4.queryExtra) {
	                            angular.extend(query, _this4.queryExtra);
	                        }
	
	                        return _this4.DataService.list(_this4.url, query).then(function (response) {
	                            if (response && (response.results || response.rows)) {
	                                params.total(response.count);
	                                _this4.emptyTable = response.count === 0;
	                                var items = _this4.filterItems(response.results || response.rows);
	                                _this4.renderLabels({
	                                    ini: (query.page - 1) * query.limit + 1,
	                                    end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                                    total: response.count
	                                });
	                                return items;
	                            }
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'getSorting',
	        value: function getSorting(params) {
	            for (var key in params) {
	                if (key.indexOf('sorting') != -1) {
	                    return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getFilters',
	        value: function getFilters(params) {
	            var filters = [];
	            for (var key in params) {
	                if (key.indexOf('filter') != -1) {
	                    filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	                }
	            }
	            return filters;
	        }
	    }, {
	        key: 'removeCorchete',
	        value: function removeCorchete(string, search) {
	            return string.replace(search + '[', '').replace(']', '');
	        }
	    }, {
	        key: 'filterItems',
	        value: function filterItems(data) {
	            data = angular.copy(data);
	            var fields = this.fields !== undefined;
	            var fks = this.fks !== undefined;
	            var relations = this.relations !== undefined;
	            var array = [];
	            for (var i in data) {
	                for (var j in data[i]) {
	                    if (fields && this.fields.indexOf(j) == -1) {
	                        delete data[i][j];
	                    } else {
	                        if (this.editable === undefined) {
	                            if (typeof data[i][j] == 'boolean') {
	                                data[i][j] = data[i][j] ? 'boolean_true' : 'boolean_false';
	                            } else if (relations && this.relations[j]) {
	                                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	                            } else if (fks && this.fks.indexOf(j) != -1) {
	                                if (this.Util.toType(data[i][j]) == 'array') {
	                                    var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                                    if (l > 1 && l == data[i][j].length) {
	                                        data[i][j] = 'Todos';
	                                    } else {
	                                        var text = [];
	                                        var _iteratorNormalCompletion2 = true;
	                                        var _didIteratorError2 = false;
	                                        var _iteratorError2 = undefined;
	
	                                        try {
	                                            for (var _iterator2 = data[i][j][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                                var e = _step2.value;
	
	                                                text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                                            }
	                                        } catch (err) {
	                                            _didIteratorError2 = true;
	                                            _iteratorError2 = err;
	                                        } finally {
	                                            try {
	                                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                                    _iterator2.return();
	                                                }
	                                            } finally {
	                                                if (_didIteratorError2) {
	                                                    throw _iteratorError2;
	                                                }
	                                            }
	                                        }
	
	                                        data[i][j] = text.join(', ');
	                                    }
	                                } else {
	                                    data[i][j + '_fk'] = data[i][j];
	                                    data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                                }
	                            } else if (this.Util.toType(data[i][j]) == 'array') {
	                                data[i][j] = data[i][j][0];
	                            }
	                            if (this.mergeFields && typeof this.mergeFields[j] == 'function') {
	                                data[i][j] = this.mergeFields[j](data[i]);
	                            }
	                        }
	                    }
	                }
	                array.push(this.orderItem(data[i], this.fieldsData, i));
	            }
	            return array;
	        }
	    }, {
	        key: 'orderItem',
	        value: function orderItem(data, fields, pos) {
	            if (fields === undefined || fields.length === 0) {
	                return data;
	            }
	
	            var item = {};
	            for (var i in fields) {
	                var _field = fields[i].key;
	                if (data[_field] !== undefined || data[_field + '_fk'] !== undefined) {
	                    if (this.editable) {
	                        if (typeof data[_field] == 'string' && !/[a-zA-Z]+/g.test(data[_field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[_field]) && data[_field].length == 10) {
	                            var date = data[_field].split('-');
	                            this.dataGrid[pos + '_' + _field] = new Date(date[0], date[1] - 1, date[2]);
	                        } else {
	                            this.dataGrid[pos + '_' + _field] = data[_field];
	                        }
	                        item[_field] = pos + '_' + _field;
	                    } else {
	                        if (item[_field + '_fk']) {
	                            item[_field + '_fk'] = data[_field];
	                        } else {
	                            item[_field] = data[_field];
	                        }
	                    }
	                }
	            }
	
	            return item;
	        }
	    }, {
	        key: 'add',
	        value: function add(item, editModalController, editModalTemplate) {
	            var _this5 = this;
	
	            if (typeof this.eventCreate == 'function') {
	                this.eventCreate();
	            } else {
	                var fields = null;
	                if (item) {
	                    fields = this.fieldsSave || this.fieldsUpdate || this.fieldsData;
	                } else {
	                    fields = this.fieldsSave || this.fieldsCreate || this.fieldsData;
	                }
	
	                var modalInstance = this.Modal.show({
	                    template: editModalTemplate || this.addModalTemplate || this.modalTemplate || _crudTableModal4.default,
	                    controller: editModalController || this.addModalController || this.modalController || _crudTableModal2.default,
	                    data: {
	                        fields: fields,
	                        url: this.url,
	                        title: this.ngTitle,
	                        idKey: this.idKey,
	                        item: item
	                    }
	                });
	
	                modalInstance.result.then(function (data) {
	                    if (data && data[_this5.idKey]) {
	                        _this5.Message.success();
	                        _this5.refresh();
	                    }
	                }, function (error) {
	                    _this5.$log.info('Modal dismissed at: ' + new Date(), error);
	                });
	            }
	        }
	    }, {
	        key: 'edit',
	        value: function edit(item) {
	            var _this6 = this;
	
	            if (typeof this.eventEdit == 'function') {
	                this.eventEdit(item);
	            } else {
	                if (this.data && this.data.list) {
	                    this.editItem = true;
	                    this.modelInline = angular.copy(this.filterById(item[this.idKey], this.data.list));
	                } else {
	                    this.DataService.get(this.url, item[this.idKey]).then(function (response) {
	                        if (response) {
	                            _this6.add(response, _this6.editModalController, _this6.editModalTemplate);
	                        }
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'editCancel',
	        value: function editCancel() {
	            this.editItem = false;
	            this.modelInline = this.resetModel(this.modelInline);
	            this.data.list.map(function (e) {
	                delete e.edit;
	                return e;
	            });
	        }
	    }, {
	        key: 'deleteRow',
	        value: function deleteRow(item) {
	            var _this7 = this;
	
	            if (typeof this.eventDelete == 'function') {
	                this.eventDelete(item);
	            } else {
	                this.Modal.confirm('¿Desea eliminar este registro?', function () {
	                    if (_this7.data && _this7.data.list) {
	                        if (_this7.data.urlUpdate) {
	                            var list = angular.copy(_this7.data.list);
	                            list.map(function (e) {
	                                e = _this7.CrudTable.cleanData(e);
	                                return e;
	                            });
	
	                            var pos = _this7.getIdPosition(list, item);
	                            if (pos !== -1) {
	                                list.splice(pos, 1);
	                                _this7.DataService.put(_this7.data.urlUpdate, list).then(function (response) {
	                                    if (response) {
	                                        _this7.data.list = response;
	                                        _this7.refresh();
	                                        if (typeof _this7.callbackDelete == 'function') {
	                                            _this7.callbackDelete(_this7.data.list);
	                                        }
	                                    }
	                                });
	                            }
	                        } else {
	                            var _pos = _this7.getIdPosition(_this7.data.list, item);
	                            if (_pos !== -1) {
	                                _this7.data.list.splice(_pos, 1);
	                                _this7.refresh();
	                            }
	                        }
	                        _this7.inlineOptions = false;
	                        _this7.itemSelected = null;
	                    } else {
	                        _this7.DataService.delete(_this7.url, item[_this7.idKey]).then(function () {
	                            _this7.Message.success('Su registro fue eliminado correctamente.');
	                            _this7.refresh();
	                        });
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'search',
	        value: function search() {
	            this.tableParams.filter({ 'crudtable_search_term': this.searchTerm });
	        }
	    }, {
	        key: 'cleanSearch',
	        value: function cleanSearch() {
	            this.searchTerm = '';
	            this.refresh();
	        }
	    }, {
	        key: 'getFieldClass',
	        value: function getFieldClass(row, col) {
	            if (this.clases && this.clases[col.field]) {
	                return this.clases[col.field](row, col);
	            } else {
	                return;
	            }
	        }
	    }, {
	        key: 'buttonEvent',
	        value: function buttonEvent(event, item, callback) {
	            if (typeof callback == 'function') {
	                callback(event, item);
	            }
	        }
	    }, {
	        key: 'buttonIf',
	        value: function buttonIf(event, item, callback) {
	            if (typeof callback == 'function') {
	                return callback(event, item);
	            } else {
	                return true;
	            }
	        }
	
	        // Form inline
	
	    }, {
	        key: 'saveFormInline',
	        value: function saveFormInline() {
	            var _this8 = this;
	
	            if (this.data && this.data.list && this.Util.toType(this.data.list) == 'array') {
	                if (this.formInline.$valid) {
	                    var data = this.modelInline;
	                    if (data[this.idKey] === undefined) {
	                        if (this.data.urlUpdate) {
	                            var list = angular.copy(this.data.list);
	                            list.map(function (e) {
	                                e = _this8.CrudTable.cleanData(e);
	                                return e;
	                            });
	                            list.push(data);
	                            this.DataService.put(this.data.urlUpdate, list).then(function (response) {
	                                if (response) {
	                                    _this8.data.list = response;
	                                    _this8.modelInline = _this8.resetModel(_this8.modelInline);
	                                    _this8.formInline.$submitted = false;
	                                    _this8.Util.setTouchedForm(_this8.formInline, false);
	                                    _this8.refresh();
	                                    if (typeof _this8.callbackSave == 'function') {
	                                        _this8.callbackSave(_this8.data.list);
	                                    }
	                                }
	                            });
	                        } else {
	                            data[this.idKey] = this.Util.id();
	                            data.new = true;
	                            this.data.list.push(data);
	                            this.modelInline = this.resetModel(this.modelInline);
	                            this.formInline.$submitted = false;
	                            this.Util.setTouchedForm(this.formInline, false);
	                            this.refresh();
	                        }
	                    } else {
	                        delete data.edit;
	                        this.editItem = false;
	                        if (this.data.urlUpdate) {
	                            var _list = angular.copy(this.data.list);
	                            _list.map(function (e) {
	                                e = _this8.CrudTable.cleanData(e);
	                                return e;
	                            });
	                            this.setItem(_list, data);
	                            this.DataService.put(this.data.urlUpdate, _list).then(function (response) {
	                                if (response) {
	                                    _this8.data.list = response;
	                                    _this8.modelInline = _this8.resetModel(_this8.modelInline);
	                                    _this8.formInline.$submitted = false;
	                                    _this8.Util.setTouchedForm(_this8.formInline, false);
	                                    _this8.refresh();
	                                    if (typeof _this8.callbackSave == 'function') {
	                                        _this8.callbackSave(_this8.data.list);
	                                    }
	                                }
	                            });
	                        } else {
	                            this.setItem(this.data.list, data);
	                            this.modelInline = this.resetModel(this.modelInline);
	                            this.formInline.$submitted = false;
	                            this.Util.setTouchedForm(this.formInline, false);
	                            this.refresh();
	                        }
	                        this.inlineOptions = false;
	                        this.itemSelected = null;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'resetModel',
	        value: function resetModel(model) {
	            var obj = {};
	            for (var key in model) {
	                var formly = this.CrudTable.searchField(this.fieldsData, key);
	                if (formly && formly.defaultValue) {
	                    obj[key] = formly.defaultValue;
	                }
	            }
	            return obj;
	        }
	    }, {
	        key: 'getIdPosition',
	        value: function getIdPosition(list, item) {
	            for (var i in list) {
	                if (list[i][this.idKey] == item[this.idKey]) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }, {
	        key: 'setItem',
	        value: function setItem(list, item) {
	            for (var i in list) {
	                if (list[i][this.idKey] == item[this.idKey]) {
	                    list[i] = item;
	                    break;
	                }
	            }
	        }
	    }, {
	        key: 'filterById',
	        value: function filterById(id, list) {
	            for (var i in list) {
	                if (list[i][this.idKey] == id) {
	                    return this.CrudTable.cleanData(list[i]);
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'selectRow',
	        value: function selectRow(row, list) {
	            var _this9 = this;
	
	            list.map(function (e, i) {
	                if (row[_this9.idKey] != list[i][_this9.idKey]) {
	                    delete list[i].edit;
	                }
	            });
	            if (row.edit) {
	                row.edit = false;
	                this.inlineOptions = false;
	                this.itemSelected = null;
	            } else {
	                row.edit = true;
	                this.inlineOptions = true;
	                this.itemSelected = row;
	            }
	        }
	    }, {
	        key: 'actionChecks',
	        value: function actionChecks() {
	            if (this.checks.cbButton) {
	                this.checks.cbButton(this.tableParams.data);
	            }
	        }
	    }, {
	        key: 'selectAllChecks',
	        value: function selectAllChecks() {
	            var _this10 = this;
	
	            this.tableParams.data.forEach(function (it) {
	                it.checked = _this10.modelSelectAllCheks;
	                if (_this10.checks.if && !_this10.checks.if(it)) {
	                    delete it.checked;
	                }
	            });
	        }
	    }, {
	        key: 'selectCheck',
	        value: function selectCheck(event, row) {
	            var _this11 = this;
	
	            var c = 0,
	                ct = 0;
	            this.tableParams.data.forEach(function (it) {
	                c += it.checked ? 1 : 0;
	                ct++;
	                if (_this11.checks.if && !_this11.checks.if(it)) {
	                    ct--;
	                }
	            });
	            this.modelSelectAllCheks = c == ct;
	
	            if (this.checks.cbCheck) {
	                this.checks.cbCheck(event, row);
	            }
	        }
	    }, {
	        key: 'checkIf',
	        value: function checkIf(row) {
	            if (this.checks.if) {
	                return this.checks.if(row);
	            } else {
	                return true;
	            }
	        }
	    }]);
	
	    return CrudTableController;
	}();
	
	exports.default = CrudTableController;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableModalController = function () {
	    CrudTableModalController.$inject = ["$scope", "$uibModalInstance", "data", "DataService", "$log"];
	    function CrudTableModalController($scope, $uibModalInstance, data, DataService, $log) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableModalController);
	
	        this.fields = data.fields;
	        this.url = data.url;
	        this.title = data.title;
	        this.idKey = data.idKey;
	        this.DataService = DataService;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$log = $log;
	
	        if (data.item) {
	            this.model = data.item;
	        }
	    }
	
	    _createClass(CrudTableModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.options = {
	                formState: {}
	            };
	        }
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this = this;
	
	            if (this.model[this.idKey]) {
	                this.model.id = this.model[this.idKey];
	            }
	            this.DataService.save(this.url, this.model).then(function (response) {
	                if (response) {
	                    _this.$uibModalInstance.close(response);
	                }
	            });
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }]);
	
	    return CrudTableModalController;
	}();
	
	exports.default = CrudTableModalController;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(232);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _crudTable3 = __webpack_require__(236);
	
	var _crudTable4 = _interopRequireDefault(_crudTable3);
	
	__webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CrudTableModule = angular.module('app.crud-table', []).service('CrudTable', _crudTable4.default).component('crudTable', _crudTable2.default).name;
	
	exports.default = CrudTableModule;

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';
	'use-strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CrudTableService = function () {
	    CrudTableService.$inject = ["Datetime"];
	    function CrudTableService(Datetime) {
	        'ngInject';
	
	        _classCallCheck(this, CrudTableService);
	
	        this.Datetime = Datetime;
	    }
	
	    _createClass(CrudTableService, [{
	        key: 'filterFields',
	        value: function filterFields(data, fields) {
	            if (typeof fields == 'undefined' || fields.length === 0) {
	                return data;
	            }
	            var filter = [];
	            for (var i in fields) {
	                var field = this.searchField(data, fields[i]);
	                if (field) {
	                    filter.push(field);
	                }
	            }
	            return filter;
	        }
	    }, {
	        key: 'searchField',
	        value: function searchField(fields, field) {
	            for (var i in fields) {
	                if (fields[i].key == field) {
	                    return fields[i];
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'searchFieldData',
	        value: function searchFieldData(fields, field) {
	            for (var i in fields) {
	                if (fields[i].key == field) {
	                    return fields[i].value;
	                }
	            }
	            return field;
	        }
	    }, {
	        key: 'addPropertiesFormly',
	        value: function addPropertiesFormly(data, formly) {
	            if (typeof formly == 'undefined' || formly.length === 0) {
	                return data;
	            }
	            for (var i in data) {
	                var field = this.searchField(formly, data[i].key);
	                if (field) {
	                    data[i] = angular.merge({}, data[i], field);
	                }
	            }
	            return data;
	        }
	    }, {
	        key: 'parseSave',
	        value: function parseSave(data, formly) {
	
	            var item = {};
	            for (var i in data) {
	                if (this.toType(data[i]) == 'date') {
	                    item[i] = this.Datetime.format(data[i], 'YYYY-MM-dd');
	                } else {
	                    if (typeof data[i] == 'string' && (data[i] == 'true' || data[i] == 'false')) {
	                        item[i] = item[i] == 'true';
	                    } else {
	                        item[i] = data[i];
	                    }
	                }
	            }
	            item.id = this.getId(item, formly);
	            return item;
	        }
	    }, {
	        key: 'getId',
	        value: function getId(formly, item) {
	            for (var i in formly) {
	                if (formly[i].templateOptions.label && formly[i].templateOptions.label == 'ID') {
	                    if (item) {
	                        return item[formly[i].key];
	                    } else {
	                        return formly[i].key;
	                    }
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getFkData',
	        value: function getFkData(fieldsData, key, value) {
	            fieldsData.filter(function (e) {
	                if (e.key == key && e.templateOptions.options) {
	                    e.templateOptions.options.filter(function (elem) {
	                        if (elem.value == value) {
	                            value = elem.name;
	                        }
	                    });
	                }
	            });
	            return value;
	        }
	    }, {
	        key: 'filterItem',
	        value: function filterItem(data) {
	            for (var i in data) {
	                if (typeof data[i] == 'string') {
	                    if (this.Datetime.isDate(new Date(data[i]))) {
	                        data[i] = new Date(data[i]);
	                    } else if (!/[a-zA-Z]+/g.test(data[i]) && /^-?[0-9.]+\:?[0-9]+\:?[0-9]*$/g.test(data[i]) && data[i].length == 8) {
	                        // data[i] = formatTime(data[i]);
	                    }
	                }
	            }
	            return data;
	        }
	    }, {
	        key: 'lengthOptions',
	        value: function lengthOptions(data, key) {
	            for (var i in data) {
	                if (data[i].key == key && data[i].templateOptions && data[i].templateOptions.options) {
	                    return data[i].templateOptions.options.length;
	                }
	            }
	            return 0;
	        }
	    }, {
	        key: 'cleanData',
	        value: function cleanData(item) {
	            for (var key in item) {
	                if (item[key + '_fk']) {
	                    item[key] = item[key + '_fk'];
	                    delete item[key + '_fk'];
	                }
	                if (item[key] == 'boolean_true') {
	                    item[key] = true;
	                } else if (item[key] == 'boolean_false') {
	                    item[key] = false;
	                } else {
	                    item[key] = this.Datetime.toDate(item[key]);
	                }
	            }
	            return item;
	        }
	    }]);
	
	    return CrudTableService;
	}();
	
	exports.default = CrudTableService;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _contacto = __webpack_require__(238);
	
	var _contacto2 = _interopRequireDefault(_contacto);
	
	var _contacto3 = __webpack_require__(567);
	
	var _contacto4 = _interopRequireDefault(_contacto3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './inputChips.scss';
	
	var formularioProductoComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        beforeAdd: '&',
	        onRemove: '&',
	        label: '@',
	        ngDisabled: '<',
	        ngUppercase: '<',
	        ngPlaceholder: '@',
	        idCertificacion: '<',
	        data: '<'
	    },
	    controller: _contacto2.default,
	    template: _contacto4.default
	};
	
	exports.default = formularioProductoComponent;

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ContactoController = function () {
	  ContactoController.$inject = ["$log", "$scope", "DataService", "Message", "Util", "Loading"];
	  function ContactoController($log, $scope, DataService, Message, Util, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ContactoController);
	
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.listaContactos = [];
	    this.dataContacto = {};
	    this.dataContacto.telefonos = [];
	    this.conf = {};
	    this.insertaNuevo = false;
	  }
	
	  _createClass(ContactoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.conf = this.data;
	      this.contactosLoad();
	    }
	  }, {
	    key: 'contactosLoad',
	    value: function contactosLoad() {
	      var _this = this;
	
	      this.DataService.get('certificaciones/' + this.idCertificacion + '/contactos').then(function (response) {
	        if (angular.isArray(response) && response.length > 0) {
	          _this.listaContactos = response;
	          _this.$log.log(_this.listaContactos);
	        }
	      });
	    }
	  }, {
	    key: 'contactoAdd',
	    value: function contactoAdd() {
	      this.insertaNuevo = true;
	    }
	  }, {
	    key: 'save',
	    value: function save(contacto_form) {
	      var _this2 = this;
	
	      if (contacto_form.$valid) {
	        var contacto = void 0;
	        contacto = angular.copy(this.dataContacto);
	        contacto.telefonos = this.dataContacto.telefonos.join('|');
	        this.$log.log("==================================================================");
	        this.$log.log(contacto);
	        this.DataService.save('certificaciones/' + this.idCertificacion + '/contactos/', contacto).then(function (response) {
	          _this2.$log.log("====================================responsillo==============================");
	          _this2.$log.log(response);
	          _this2.dataContacto.nombre_completo = null;
	          _this2.dataContacto.telefonos = [];
	          _this2.contactosLoad();
	          _this2.Util.setTouchedForm(contacto_form, false);
	          // this.insertaNuevo = false;
	          _this2.Message.success();
	        }).catch(function (error) {
	          _this2.$log.log(error);
	          _this2.Message.error('Ocurrió un error intentando guardar el contacto.');
	        });
	      } else {
	        this.Util.setTouchedForm(contacto_form);
	      }
	    }
	  }, {
	    key: 'contactoDel',
	    value: function contactoDel(index, item) {
	      var _this3 = this;
	
	      this.DataService.delete('certificaciones/' + this.idCertificacion + '/contactos/' + item.id_contacto).then(function (response) {
	        _this3.$log.log(response);
	        _this3.insertaNuevo = false;
	        _this3.listaContactos.splice(index, 1);
	        _this3.Message.success();
	      }).catch(function (error) {
	        _this3.$log.log(error);
	        _this3.Message.error('Ocurrió un error intentando eliminar el contacto.');
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	      // this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'beforeAddTel',
	    value: function beforeAddTel(text) {
	      var array = this.dataContacto.telefonos;
	      if (array.length >= 5) {
	        this.Message.warning('Solo puede añadir 5 teléfonos como máximo.');
	        return null;
	      }
	      if (text.length > 15) {
	        this.Message.warning("El número telefónico '" + text + "' no debe superar los 15 dígitos");
	      } else if (text.length < 5) {
	        this.Message.warning("El número telefónico '" + text + "' no debe ser inferior a los 5 caracteres");
	      } else if (!/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(text)) {
	        this.Message.warning("Introduzca un número de teléfono válido: " + text);
	      } else {
	        return text;
	      }
	      return null;
	    }
	  }]);
	
	  return ContactoController;
	}();
	
	exports.default = ContactoController;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _cuentaBeneficiario = __webpack_require__(240);
	
	var _cuentaBeneficiario2 = _interopRequireDefault(_cuentaBeneficiario);
	
	var _cuentaBeneficiario3 = __webpack_require__(568);
	
	var _cuentaBeneficiario4 = _interopRequireDefault(_cuentaBeneficiario3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cuentaBeneficiarioComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        beforeAdd: '&',
	        onRemove: '&',
	        label: '@',
	        ngDisabled: '<',
	        ngUppercase: '<',
	        ngPlaceholder: '@',
	        idCertificacion: '<',
	        conf: '<',
	        data: '<'
	    },
	    controller: _cuentaBeneficiario2.default,
	    template: _cuentaBeneficiario4.default
	};
	
	exports.default = cuentaBeneficiarioComponent;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CuentaBeneficiarioController = function () {
	  CuentaBeneficiarioController.$inject = ["$log", "$scope", "DataService", "Message", "Util", "Loading"];
	  function CuentaBeneficiarioController($log, $scope, DataService, Message, Util, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, CuentaBeneficiarioController);
	
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.listaProductos = [];
	    this.dataProducto = {};
	    this.conf = {};
	    this.cuenta = '';
	  }
	
	  _createClass(CuentaBeneficiarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarMoneda();
	      this.cargarTipoCuenta();
	      this.cargarDepartamentos();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      // this.insertaNuevo = false;
	    }
	  }, {
	    key: 'cargarMoneda',
	    value: function cargarMoneda() {
	      var _this = this;
	
	      var url = 'parametros/?grupo=CUENTA_MONEDA';
	      this.DataService.get(url).then(function (response) {
	        _this.monedas = response;
	      });
	    }
	  }, {
	    key: 'cargarTipoCuenta',
	    value: function cargarTipoCuenta() {
	      var _this2 = this;
	
	      var url = 'parametros/?grupo=TIPO_CUENTA';
	      this.DataService.get(url).then(function (response) {
	        _this2.tiposCuenta = response;
	      });
	    }
	  }, {
	    key: 'cargarDepartamentos',
	    value: function cargarDepartamentos() {
	      var _this3 = this;
	
	      var url = 'parametros/?grupo=DEPARTAMENTO_MEF';
	      this.DataService.get(url).then(function (response) {
	        if (response) {
	          _this3.departamentos = response;
	          _this3.departamentos = _this3.departamentos.filter(function (item) {
	            return item.sigla !== '99';
	          });
	        }
	      });
	    }
	  }]);
	
	  return CuentaBeneficiarioController;
	}();
	
	exports.default = CuentaBeneficiarioController;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _documentoIdentidad = __webpack_require__(242);
	
	var _documentoIdentidad2 = _interopRequireDefault(_documentoIdentidad);
	
	var _documentoIdentidad3 = __webpack_require__(569);
	
	var _documentoIdentidad4 = _interopRequireDefault(_documentoIdentidad3);
	
	__webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var documentoIdentidadComponent = {
	    bindings: {
	        ngModel: '=',
	        onlyCi: '@',
	        conf: '<',
	        url: '<',
	        callcackSearch: '<',
	        completo: '<',
	        departamentos: '<'
	    },
	    controller: _documentoIdentidad2.default,
	    template: _documentoIdentidad4.default
	};
	
	exports.default = documentoIdentidadComponent;

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocumentoIdentidadController = function () {
	  DocumentoIdentidadController.$inject = ["$scope", "DataService", "Datetime", "Message", "$log"];
	  function DocumentoIdentidadController($scope, DataService, Datetime, Message, $log) {
	    'ngInject';
	
	    _classCallCheck(this, DocumentoIdentidadController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.Message = Message;
	    this.$log = $log;
	    // this.init = false;
	  }
	
	  _createClass(DocumentoIdentidadController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!this.ngModel) this.ngModel = {};
	      this.initDefault('tipo_documento', 'CARNET_IDENTIDAD');
	    }
	  }, {
	    key: 'isCI',
	    value: function isCI() {
	      return this.ngModel.tipo_documento == 'CARNET_IDENTIDAD';
	    }
	  }, {
	    key: 'isFill',
	    value: function isFill() {
	      return this.ngModel.nombres && this.ngModel.primer_apellido;
	    }
	  }, {
	    key: 'initDefault',
	    value: function initDefault(key, val) {
	      if (!this.ngModel[key]) this.ngModel[key] = val;
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType() {
	      this.nombreDel();
	    }
	  }, {
	    key: 'nombreDel',
	    value: function nombreDel() {
	      delete this.ngModel.nombres;
	      delete this.ngModel.primer_apellido;
	      delete this.ngModel.segundo_apellido;
	      delete this.ngModel.id_persona;
	      delete this.ngModel.casada_apellido;
	      //delete this.ngModel.expedido_departamento;
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      return angular.isUndefined(this.ngModel.documento_identidad) || !this.Datetime.isDate(this.ngModel.fecha_nacimiento);
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      var _this = this;
	
	      // this.Message.loading("Buscando datos en el SEGIP, esta operación puede demorar.");
	      var ci, complemento, datos;
	      if (this.ngModel.documento_identidad.indexOf('-') !== -1) {
	        datos = this.ngModel.documento_identidad.split('-');
	        ci = datos[0];
	        complemento = datos[1];
	      } else {
	        ci = this.ngModel.documento_identidad;
	      }
	      // this.$log.log(ci,complemento,datos);
	
	      this.DataService.get('persona/servicio/segip/?ci=' + ci + '&fecha_nacimiento=' + this.Datetime.format(this.ngModel.fecha_nacimiento, 'YYYY/MM/dd') + (complemento ? '&complemento=' + complemento.toUpperCase() : '')).then(function (response) {
	        // this.$log.log(response);
	        _this.nombreDel();
	        if (response) {
	          _this.ngModel.primer_apellido = response.primer_apellido;
	          _this.ngModel.segundo_apellido = response.segundo_apellido;
	          _this.ngModel.nombres = response.nombres;
	          _this.ngModel.id_persona = response.id_persona;
	        }
	      });
	    }
	  }]);
	
	  return DocumentoIdentidadController;
	}();
	
	exports.default = DocumentoIdentidadController;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _documentoIdentidadContrastacion = __webpack_require__(244);
	
	var _documentoIdentidadContrastacion2 = _interopRequireDefault(_documentoIdentidadContrastacion);
	
	var _documentoIdentidadContrastacion3 = __webpack_require__(570);
	
	var _documentoIdentidadContrastacion4 = _interopRequireDefault(_documentoIdentidadContrastacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var documentoIdentidadContrastacionComponent = {
	    bindings: {
	        ngModel: '=',
	        onlyCi: '@',
	        conf: '<',
	        url: '<',
	        callcackSearch: '<',
	        completo: '<',
	        departamentos: '<'
	    },
	    controller: _documentoIdentidadContrastacion2.default,
	    template: _documentoIdentidadContrastacion4.default
	};
	
	exports.default = documentoIdentidadContrastacionComponent;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocumentoIdentidadContrastacionController = function () {
	  DocumentoIdentidadContrastacionController.$inject = ["$scope", "DataService", "Datetime", "Message", "$log"];
	  function DocumentoIdentidadContrastacionController($scope, DataService, Datetime, Message, $log) {
	    'ngInject';
	
	    _classCallCheck(this, DocumentoIdentidadContrastacionController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.Message = Message;
	    this.$log = $log;
	  }
	
	  _createClass(DocumentoIdentidadContrastacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!this.ngModel) this.ngModel = {};
	      this.initDefault('tipo_documento', 'CARNET_IDENTIDAD');
	    }
	  }, {
	    key: 'isCI',
	    value: function isCI() {
	      return this.ngModel.tipo_documento == 'CARNET_IDENTIDAD' || this.ngModel.tipo_documento == 'CARNET_EXTRANJERO';
	    }
	  }, {
	    key: 'isFill',
	    value: function isFill() {
	      return this.ngModel.id_persona;
	    }
	  }, {
	    key: 'initDefault',
	    value: function initDefault(key, val) {
	      if (!this.ngModel[key]) this.ngModel[key] = val;
	    }
	  }, {
	    key: 'changeType',
	    value: function changeType() {
	      this.nombreDel();
	    }
	  }, {
	    key: 'nombreDel',
	    value: function nombreDel() {
	      delete this.ngModel.id_persona;
	      if (this.ngModel.tipo_documento === 'PASAPORTE') {
	        delete this.ngModel.nombres;
	        delete this.ngModel.primer_apellido;
	        delete this.ngModel.segundo_apellido;
	        delete this.ngModel.casada_apellido;
	      }
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      return angular.isUndefined(this.ngModel.documento_identidad) || !this.Datetime.isDate(this.ngModel.fecha_nacimiento);
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      var _this = this;
	
	      var query = 'tipo_documento=' + this.ngModel.tipo_documento;
	      query = query + '&documento_identidad=' + this.ngModel.documento_identidad;
	      query = query + '&fecha_nacimiento=' + this.Datetime.format(this.ngModel.fecha_nacimiento, 'YYYY/MM/dd');
	      query = query + '&nombres=' + (this.ngModel.nombres || '');
	      query = query + '&primer_apellido=' + (this.ngModel.primer_apellido || '');
	      query = query + '&segundo_apellido=' + (this.ngModel.segundo_apellido || '');
	      this.DataService.get('persona/servicio/contrastar?' + query).then(function (response) {
	        delete _this.ngModel.id_persona;
	        if (response) {
	          _this.ngModel.primer_apellido = response.primer_apellido;
	          _this.ngModel.segundo_apellido = response.segundo_apellido;
	          _this.ngModel.nombres = response.nombres;
	          _this.ngModel.id_persona = response.id_persona;
	        }
	      });
	    }
	  }]);
	
	  return DocumentoIdentidadContrastacionController;
	}();
	
	exports.default = DocumentoIdentidadContrastacionController;

/***/ }),
/* 245 */
[679, 246, 571, 160],
/* 246 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdFileUploadController = function () {
	    MdFileUploadController.$inject = ["$scope", "FileUploader", "Message", "Util", "Loading", "Storage", "Auth", "baseUrl", "$log"];
	    function MdFileUploadController($scope, FileUploader, Message, Util, Loading, Storage, Auth, baseUrl, $log) {
	        'ngInject';
	
	        _classCallCheck(this, MdFileUploadController);
	
	        this.FileUploader = FileUploader;
	        this.Message = Message;
	        this.Util = Util;
	        this.baseUrl = baseUrl;
	        this.Loading = Loading;
	        this.Storage = Storage;
	        this.Auth = Auth;
	        this.$log = $log;
	        this.$scope = $scope;
	
	        this.charset = {
	            'xlsx': ['vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.openxmlformats'],
	            'xls': 'vnd.ms-excel',
	            'ods': 'x-vnd.oasis.opendocument.spreadsheet',
	            'rar': 'x-rar',
	            'pdf': 'pdf',
	            'csv': ['csv', 'vnd.ms-excel'],
	            'plain': 'plain',
	            'jpg': 'jpg',
	            'png': 'png',
	            'jpeg': 'jpeg',
	            'bmp': 'bmp',
	            'gif': 'gif'
	        };
	    }
	
	    _createClass(MdFileUploadController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.idFile = 'file-' + this.Util.id();
	            var log = this.$log;
	            var loading = this.Loading;
	
	            var uploader = this.$scope.uploader = new this.FileUploader({
	                url: this.url,
	                alias: this.name || 'file',
	                formData: this.form || []
	            });
	
	            // FILTERS
	
	            uploader.filters.push({
	                name: 'customFilter',
	                fn: function fn() /*item, {File|FileLikeObject}, options*/{
	                    return this.queue.length < 10;
	                }
	            });
	
	            if (this.types) {
	                uploader.filters.push({
	                    name: 'typesFilter',
	                    fn: function fn(item) {
	                        var valid = _this.isType(item, _this.types);
	                        if (!valid) {
	                            _this.Message.warning('Los formatos permitidos son: <strong>' + _this.types.replace(/^\|+|\|+$/gm, '').replace(/\|/, ', ') + '</strong>.', 'Formato de archivo inválido');
	                        }
	                        return valid;
	                    }
	                });
	            }
	
	            this.$log.log('Token', this.Storage.get('token'));
	
	            uploader.headers.Authorization = 'Bearer ' + this.Storage.get('token');
	
	            // CALLBACKS
	
	            uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
	                log.info('onWhenAddingFileFailed', item, filter, options);
	            };
	            uploader.onAfterAddingFile = function (fileItem) {
	                if (typeof _this.multiple == 'undefined' && uploader.queue.length > 1) {
	                    uploader.queue = uploader.queue.splice(1);
	                }
	                if (_this.onAfterAddingFile) {
	                    _this.onAfterAddingFile(fileItem);
	                }
	                log.info('onAfterAddingFile', fileItem);
	            };
	            uploader.onAfterAddingAll = function (addedFileItems) {
	                log.info('onAfterAddingAll', addedFileItems);
	            };
	            uploader.onBeforeUploadItem = function (item) {
	                if (_this.onBeforeUploadItem) {
	                    _this.onBeforeUploadItem(item);
	                }
	                for (var i in _this.form) {
	                    if (isNaN(i)) {
	                        var data = {};
	                        data[i] = _this.form[i];
	                        item.formData.push(data);
	                    }
	                }
	                log.info('onBeforeUploadItem', item);
	            };
	            uploader.onProgressItem = function (fileItem, progress) {
	                log.info('onProgressItem', fileItem, progress);
	            };
	            uploader.onProgressAll = function (progress) {
	                log.info('onProgressAll', progress);
	                loading.show('Cargando', true);
	            };
	            uploader.onSuccessItem = function (fileItem, response, status, headers) {
	                log.info('onSuccessItem', fileItem, response, status, headers);
	            };
	            uploader.onErrorItem = function (fileItem, response, status, headers) {
	                log.info('onErrorItem', fileItem, response, status, headers);
	            };
	            uploader.onCancelItem = function (fileItem, response, status, headers) {
	                log.info('onCancelItem', fileItem, response, status, headers);
	            };
	            uploader.onCompleteItem = function (fileItem, response, status, headers) {
	                if (_this.onCompleteItem) {
	                    _this.onCompleteItem(fileItem, response, status, headers, _this.reset);
	                }
	                log.info('onCompleteItem', fileItem, response, status, headers);
	                loading.show('Cargando', false);
	            };
	            uploader.onCompleteAll = function () {
	                if (_this.onCompleteAll) {
	                    _this.onCompleteAll(_this.reset);
	                }
	                log.info('onCompleteAll');
	                loading.hide();
	            };
	        }
	    }, {
	        key: 'isType',
	        value: function isType(item, types) {
	            var type = item.type.slice(item.type.lastIndexOf('/') + 1);
	            var extension = null;
	            if (item.name) {
	                extension = item.name.split('.');
	                extension = extension[extension.length - 1];
	
	                // Hack para firefox que carga un csv con charset text/plain
	                if ((type == 'plain' || type == 'download') && extension == 'csv') {
	                    return true;
	                }
	            }
	
	            for (var i in this.charset) {
	                if (this.Util.toType(this.charset[i]) == 'array') {
	                    var subtypes = this.charset[i];
	                    for (var j in subtypes) {
	                        if (types.indexOf(i) != -1 && type == subtypes[j]) {
	                            return true;
	                        }
	                    }
	                } else {
	                    if (types.indexOf(i) != -1 && type == this.charset[i]) {
	                        return true;
	                    }
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'isImage',
	        value: function isImage(item) {
	            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    }]);
	
	    return MdFileUploadController;
	}();
	
	exports.default = MdFileUploadController;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fileUpload = __webpack_require__(245);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.fileUpload.component', []).component('uiFileUpload', _fileUpload2.default).directive('ngThumb', ['$window', function ($window) {
	    var helper = {
	        support: !!($window.FileReader && $window.CanvasRenderingContext2D),
	        isFile: function isFile(item) {
	            return angular.isObject(item) && item instanceof $window.File;
	        },
	        isImage: function isImage(file) {
	            var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    };
	
	    return {
	        restrict: 'A',
	        template: '<canvas/>',
	        link: function link(scope, element, attributes) {
	            if (!helper.support) return;
	
	            var params = scope.$eval(attributes.ngThumb);
	
	            if (!helper.isFile(params.file)) return;
	            if (!helper.isImage(params.file)) return;
	
	            var canvas = element.find('canvas');
	            var reader = new window.FileReader();
	
	            reader.onload = onLoadFile;
	            reader.readAsDataURL(params.file);
	
	            function onLoadFile(event) {
	                var img = new window.Image();
	                img.onload = onLoadImage;
	                img.src = event.target.result;
	            }
	
	            function onLoadImage() {
	                var width = params.width || this.width / this.height * params.height;
	                var height = params.height || this.height / this.width * params.width;
	                canvas.attr({ width: width, height: height });
	                canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
	            }
	        }
	    };
	}]).name;
	
	exports.default = Components;

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdFileUploadAutorizacionController = function () {
	    MdFileUploadAutorizacionController.$inject = ["$scope", "Message", "Util", "Loading", "Storage", "Auth", "baseUrl", "$log"];
	    function MdFileUploadAutorizacionController($scope, Message, Util, Loading, Storage, Auth, baseUrl, $log) {
	        'ngInject';
	
	        _classCallCheck(this, MdFileUploadAutorizacionController);
	
	        this.Message = Message;
	        this.Util = Util;
	        this.baseUrl = baseUrl;
	        this.Loading = Loading;
	        this.Storage = Storage;
	        this.Auth = Auth;
	        this.$log = $log;
	        this.$scope = $scope;
	    }
	
	    _createClass(MdFileUploadAutorizacionController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.idFile = 'file-' + this.Util.id();
	            this.selectedImage = null;
	
	            this.$scope.deleteImg = function (param) {
	                var img = param.parentElement.parentElement.parentElement.getElementsByTagName('img')[0];
	                var findFile = param.parentElement.getElementsByTagName('input')[0];
	                findFile[0] = null;
	                findFile.value = '';
	                img.src = null;
	            };
	
	            this.$scope.readImage = function (param) {
	                var imagen = param.files[0];
	                var output = param.parentElement.parentElement.parentElement.getElementsByTagName('img')[0];
	                output.src = URL.createObjectURL(imagen);
	                output.onload = function () {
	                    URL.revokeObjectURL(output.src); // free memory
	                };
	            };
	            this.$scope.validImage = function (param) {
	                var _this = _this2;
	                var file = param.files[0];
	                var filereader = new FileReader();
	
	                filereader.onloadend = function (evt) {
	                    if (evt.target.readyState === FileReader.DONE) {
	                        // eslint-disable-next-line no-undef
	                        var uint = new Uint8Array(evt.target.result).subarray(0, 4);
	                        var bytes = [];
	                        uint.forEach(function (byte) {
	                            bytes.push(byte.toString(16));
	                        });
	                        var hex = bytes.join('').toUpperCase();
	                        var type = _this.$scope.getMimetype(hex);
	                        if (file.type !== type) {
	                            _this2.Message.error('La imagen no cumple el formato requerido (png, jpg, jpeg)');
	                        } else {
	                            _this.$scope.readImage(param);
	                        }
	                    }
	                };
	                // const blob = file.slice(0, 4);
	                filereader.readAsArrayBuffer(file);
	            };
	
	            this.$scope.getMimetype = function (sign) {
	                switch (sign) {
	                    case '89504E47':
	                        return 'image/png';
	                    case '47494638':
	                        return 'image/gif';
	                    case 'FFD8FFDB':
	                    case 'FFD8FFE0':
	                        return 'image/jpeg';
	                    default:
	                        return 'unknown';
	                }
	            };
	        }
	    }, {
	        key: 'isType',
	        value: function isType(item, types) {
	            var type = item.type.slice(item.type.lastIndexOf('/') + 1);
	            var extension = null;
	            if (item.name) {
	                extension = item.name.split('.');
	                extension = extension[extension.length - 1];
	
	                // Hack para firefox que carga un csv con charset text/plain
	                if ((type == 'plain' || type == 'download') && extension == 'csv') {
	                    return true;
	                }
	            }
	
	            for (var i in this.charset) {
	                if (this.Util.toType(this.charset[i]) == 'array') {
	                    var subtypes = this.charset[i];
	                    for (var j in subtypes) {
	                        if (types.indexOf(i) != -1 && type == subtypes[j]) {
	                            return true;
	                        }
	                    }
	                } else {
	                    if (types.indexOf(i) != -1 && type == this.charset[i]) {
	                        return true;
	                    }
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'isImage',
	        value: function isImage(item) {
	            var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
	            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	        }
	    }]);
	
	    return MdFileUploadAutorizacionController;
	}();
	
	exports.default = MdFileUploadAutorizacionController;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fileUploadAutorizacion = __webpack_require__(250);
	
	var _fileUploadAutorizacion2 = _interopRequireDefault(_fileUploadAutorizacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.fileUploadAutorizacion.component', []).component('uiFileUploadAutorizacion', _fileUploadAutorizacion2.default).name;
	
	exports.default = Components;

/***/ }),
/* 250 */
[679, 248, 572, 161],
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _numeroaLetras = __webpack_require__(261);
	
	var _numeroaLetras2 = _interopRequireDefault(_numeroaLetras);
	
	var _inputChips = __webpack_require__(256);
	
	var _inputChips2 = _interopRequireDefault(_inputChips);
	
	var _selectDate = __webpack_require__(264);
	
	var _selectDate2 = _interopRequireDefault(_selectDate);
	
	var _selectMunicipio = __webpack_require__(266);
	
	var _selectMunicipio2 = _interopRequireDefault(_selectMunicipio);
	
	var _localizacion = __webpack_require__(258);
	
	var _localizacion2 = _interopRequireDefault(_localizacion);
	
	var _documentoIdentidad = __webpack_require__(241);
	
	var _documentoIdentidad2 = _interopRequireDefault(_documentoIdentidad);
	
	var _documentoIdentidadContrastacion = __webpack_require__(243);
	
	var _documentoIdentidadContrastacion2 = _interopRequireDefault(_documentoIdentidadContrastacion);
	
	var _selectParametro = __webpack_require__(268);
	
	var _selectParametro2 = _interopRequireDefault(_selectParametro);
	
	var _uibSelect = __webpack_require__(270);
	
	var _uibSelect2 = _interopRequireDefault(_uibSelect);
	
	var _fileUpload = __webpack_require__(247);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _fileUpload3 = __webpack_require__(249);
	
	var _fileUpload4 = _interopRequireDefault(_fileUpload3);
	
	var _formularioProducto = __webpack_require__(254);
	
	var _formularioProducto2 = _interopRequireDefault(_formularioProducto);
	
	var _formularioBeneficiario = __webpack_require__(252);
	
	var _formularioBeneficiario2 = _interopRequireDefault(_formularioBeneficiario);
	
	var _contacto = __webpack_require__(237);
	
	var _contacto2 = _interopRequireDefault(_contacto);
	
	var _representante = __webpack_require__(262);
	
	var _representante2 = _interopRequireDefault(_representante);
	
	var _cuentaBeneficiario = __webpack_require__(239);
	
	var _cuentaBeneficiario2 = _interopRequireDefault(_cuentaBeneficiario);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialModule = angular.module('app.forms', [_fileUpload2.default, _fileUpload4.default]).service('numToWord', _numeroaLetras2.default).component('inputChips', _inputChips2.default).component('selectDate', _selectDate2.default).component('selectMunicipio', _selectMunicipio2.default).component('localizacion', _localizacion2.default).component('documentoIdentidad', _documentoIdentidad2.default).component('documentoIdentidadContrastacion', _documentoIdentidadContrastacion2.default).component('selectParametro', _selectParametro2.default).component('formularioProducto', _formularioProducto2.default).component('formularioContacto', _contacto2.default).component('formularioBeneficiario', _formularioBeneficiario2.default).component('formularioRepresentante', _representante2.default).component('formularioCuenta', _cuentaBeneficiario2.default).component('uibSelect', _uibSelect2.default).directive('apError', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $element.addClass('form-error');
	      var $parent = angular.element($element.closest('div.form-group'));
	      $scope.$watch(function () {
	        return $element[0].scrollHeight;
	      }, function (newValue) {
	        // $log.log(newValue);
	        $parent.removeClass('has-danger');
	        if (newValue) {
	          $parent.addClass('has-danger');
	        }
	      });
	      $scope.$on('$destroy', function () {
	        $parent.removeClass('has-danger');
	      });
	    }
	  };
	}).name;
	
	exports.default = MaterialModule;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _formularioBeneficiario = __webpack_require__(253);
	
	var _formularioBeneficiario2 = _interopRequireDefault(_formularioBeneficiario);
	
	var _formularioBeneficiario3 = __webpack_require__(573);
	
	var _formularioBeneficiario4 = _interopRequireDefault(_formularioBeneficiario3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './inputChips.scss';
	
	var formularioBeneficiarioComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        beforeAdd: '&',
	        onRemove: '&',
	        label: '@',
	        ngDisabled: '<',
	        ngUppercase: '<',
	        ngPlaceholder: '@',
	        idCertificacion: '<',
	        data: '<'
	    },
	    controller: _formularioBeneficiario2.default,
	    template: _formularioBeneficiario4.default
	};
	
	exports.default = formularioBeneficiarioComponent;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormularioBeneficiarioController = function () {
	  FormularioBeneficiarioController.$inject = ["$log", "$scope", "DataService", "Message", "Util", "Loading", "Modal", "Storage"];
	  function FormularioBeneficiarioController($log, $scope, DataService, Message, Util, Loading, Modal, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, FormularioBeneficiarioController);
	
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.listaProductos = [];
	    this.dataProducto = {};
	    this.conf = {};
	    this.insertaNuevo = false;
	    this.noExisteBeneficiario = false;
	  }
	
	  _createClass(FormularioBeneficiarioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.certificacion = this.data.certificacion;
	      this.unidad_productiva = this.data.unidad_productiva;
	      this.$log.log('=======================');
	      this.$log.log(this.conf);
	      this.tipoBeneficiario = false;
	      var usuarioAux = this.Storage.getUser();
	      this.mostrarCorrecciones = usuarioAux && usuarioAux.id_usuario === 4763 ? true : false;
	      this.cargarParametros();
	    }
	  }, {
	    key: 'verificarBeneficiario',
	    value: function verificarBeneficiario(event) {
	      var _this = this;
	
	      this.$log.log('=======================', event);
	      this.$log.log('verificarBeneficiario');
	      this.Modal.confirm('Se verificará la existencia del Beneficiario en el SIGEP. ¿Desea continuar?', function () {
	        var url = 'certificaciones/' + _this.certificacion.id_certificacion + '/beneficiario';
	        if (_this.tipoBeneficiario) url = url + '?tipo_beneficiario=' + _this.tipoBeneficiario;
	        _this.DataService.get(url).then(function (respuesta) {
	          if (respuesta) {
	            _this.unidad_productiva.beneficiario = respuesta.beneficiario;
	            _this.unidad_productiva.proceso = { beneficiario: { beneficiario: respuesta } };
	            _this.unidad_productiva.cuenta_validada = null;
	            _this.unidad_productiva.cuenta_estado = null;
	            _this.estadoDescripcion = null;
	            _this.$log.log('=======================');
	            _this.$log.log(respuesta);
	            _this.Storage.set('unidad_productiva', _this.unidad_productiva);
	          } else {
	            _this.noExisteBeneficiario = true;
	          }
	        });
	      });
	    }
	  }, {
	    key: 'crearBeneficiario',
	    value: function crearBeneficiario() {
	      var _this2 = this;
	
	      this.$log.log('=======================');
	      this.$log.log('verificarBeneficiario');
	      this.Modal.confirm('Se procederá a crear el Beneficiario en el SIGEP. ¿Desea continuar?', function () {
	        var datosEnviar = {};
	        if (_this2.tipoBeneficiario) datosEnviar = { tipoBeneficiario: _this2.tipoBeneficiario };
	        _this2.DataService.post('certificaciones/' + _this2.certificacion.id_certificacion + '/beneficiario', datosEnviar).then(function (respuesta) {
	          if (respuesta) {
	            _this2.$log.log('=======================');
	            _this2.$log.log(respuesta);
	            _this2.unidad_productiva.beneficiario = respuesta.beneficiario;
	            _this2.unidad_productiva.proceso = { beneficiario: { beneficiario: respuesta } };
	            _this2.unidad_productiva.cuenta_validada = null;
	            _this2.unidad_productiva.cuenta_estado = null;
	            _this2.estadoDescripcion = null;
	            _this2.Storage.set('unidad_productiva', _this2.unidad_productiva);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'asociarCuenta',
	    value: function asociarCuenta() {
	      var _this3 = this;
	
	      if (!this.unidad_productiva.beneficiario) {
	        this.Message.error('Primero debe buscar o crear el Beneficiario.');
	        return;
	      }
	      this.$log.log('=======================');
	      this.$log.log('asociarCuenta');
	      this.Modal.confirm('Se procederá a asociar el Beneficiario SIGEP con la cuenta Bancaria. ¿Desea continuar?', function () {
	        _this3.DataService.post('certificaciones/' + _this3.certificacion.id_certificacion + '/cuentaBancaria').then(function (respuesta) {
	          if (respuesta) {
	            _this3.$log.log('=======================');
	            _this3.$log.log(respuesta);
	            _this3.unidad_productiva.cuenta_validada = respuesta.estadoCuenta;
	            _this3.unidad_productiva.cuenta_estado = respuesta.estado;
	            _this3.estadoDescripcion = _this3.estados.filter(function (item) {
	              return item.sigla === _this3.unidad_productiva.cuenta_validada;
	            });
	            if (_this3.estadoDescripcion && _this3.estadoDescripcion[0]) _this3.estadoDescripcion = _this3.estadoDescripcion[0].nombre;else _this3.estadoDescripcion = null;
	            _this3.Storage.set('unidad_productiva', _this3.unidad_productiva);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'cargarParametros',
	    value: function cargarParametros() {
	      var _this4 = this;
	
	      var url = 'parametros/?grupo=CUENTA_MONEDA';
	      this.DataService.get(url).then(function (response) {
	        if (response) {
	          _this4.monedaDescripcion = response.filter(function (item) {
	            return item.sigla === _this4.unidad_productiva.cuenta_moneda;
	          });
	          if (_this4.monedaDescripcion && _this4.monedaDescripcion[0]) _this4.monedaDescripcion = _this4.monedaDescripcion[0].nombre;
	        }
	      });
	      var urlDep = 'parametros/?grupo=TIPO_CUENTA';
	      this.DataService.get(urlDep).then(function (response1) {
	        if (response1) {
	          _this4.tipoDescripcion = response1.filter(function (item) {
	            return item.sigla === _this4.unidad_productiva.cuenta_tipo;
	          });
	          if (_this4.tipoDescripcion && _this4.tipoDescripcion[0]) _this4.tipoDescripcion = _this4.tipoDescripcion[0].nombre;
	        }
	      });
	      var urlTipo = 'parametros/?grupo=DEPARTAMENTO_MEF';
	      this.DataService.get(urlTipo).then(function (response2) {
	        if (response2) {
	          _this4.departamentoDescripcion = response2.filter(function (item) {
	            return item.sigla === _this4.unidad_productiva.cuenta_departamento;
	          });
	          if (_this4.departamentoDescripcion && _this4.departamentoDescripcion[0]) _this4.departamentoDescripcion = _this4.departamentoDescripcion[0].nombre;
	        }
	      });
	      var urlEstado = 'parametros/?grupo=CUENTA_ESTADO';
	      this.DataService.get(urlEstado).then(function (response3) {
	        if (response3) {
	          _this4.estados = response3;
	          _this4.estadoDescripcion = response3.filter(function (item) {
	            return item.sigla === _this4.unidad_productiva.cuenta_validada;
	          });
	          if (_this4.estadoDescripcion && _this4.estadoDescripcion[0]) _this4.estadoDescripcion = _this4.estadoDescripcion[0].nombre;else _this4.estadoDescripcion = null;
	        }
	      });
	    }
	  }]);
	
	  return FormularioBeneficiarioController;
	}();
	
	exports.default = FormularioBeneficiarioController;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _formularioProducto = __webpack_require__(255);
	
	var _formularioProducto2 = _interopRequireDefault(_formularioProducto);
	
	var _formularioProducto3 = __webpack_require__(574);
	
	var _formularioProducto4 = _interopRequireDefault(_formularioProducto3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './inputChips.scss';
	
	var formularioProductoComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        beforeAdd: '&',
	        onRemove: '&',
	        label: '@',
	        ngDisabled: '<',
	        ngUppercase: '<',
	        ngPlaceholder: '@',
	        idCertificacion: '<',
	        data: '<'
	    },
	    controller: _formularioProducto2.default,
	    template: _formularioProducto4.default
	};
	
	exports.default = formularioProductoComponent;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _importarProdModal = __webpack_require__(440);
	
	var _importarProdModal2 = _interopRequireDefault(_importarProdModal);
	
	var _importarProdModal3 = __webpack_require__(639);
	
	var _importarProdModal4 = _interopRequireDefault(_importarProdModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormularioProductoController = function () {
	  FormularioProductoController.$inject = ["$log", "$scope", "DataService", "Message", "Util", "Loading", "Modal"];
	  function FormularioProductoController($log, $scope, DataService, Message, Util, Loading, Modal) {
	    'ngInject';
	
	    _classCallCheck(this, FormularioProductoController);
	
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.Modal = Modal;
	    this.listaProductos = [];
	    this.dataProducto = {};
	    this.conf = {};
	    this.insertaNuevo = false;
	  }
	
	  _createClass(FormularioProductoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.conf = this.data;
	      this.productosLoad();
	      this.DataService.get('certificaciones/' + this.idCertificacion).then(function (response) {
	        _this.form = angular.copy(response.certificacion.formulario);
	        _this.esRefrigerio = false;
	        _this.$log.log('esRefrigerio en llenado de formulario de PRODUCTOS');
	        if (_this.form.id_formulario === 10) {
	          _this.esRefrigerio = true;
	        }
	        _this.$log.log(_this.esRefrigerio);
	      });
	    }
	  }, {
	    key: 'productosLoad',
	    value: function productosLoad() {
	      var _this2 = this;
	
	      this.DataService.get('certificaciones/' + this.idCertificacion + '/productos').then(function (response) {
	        if (angular.isArray(response) && response.length > 0) {
	          _this2.listaProductos = response;
	          _this2.$log.log("===============listado===================");
	          _this2.$log.log(_this2.listaProductos);
	          _this2.$log.log(response);
	        }
	      });
	    }
	  }, {
	    key: 'productoAdd',
	    value: function productoAdd() {
	      this.insertaNuevo = true;
	    }
	  }, {
	    key: 'save',
	    value: function save(producto_form) {
	      var _this3 = this;
	
	      if (producto_form.$valid) {
	        this.$log.log('this.idCertificacion >>||<<');
	        this.$log.log(this.idCertificacion);
	        this.$log.log(producto_form);
	        var producto;
	        producto = this.dataProducto;
	        producto.principal = false;
	        producto.descripcion_actividad = 'sin descripcion';
	        producto.anio_inicio = 2000;
	        producto.cantidad_promedio = 0;
	        this.DataService.save('certificaciones/' + this.idCertificacion + '/productos/', producto).then(function (response) {
	          if (response) {
	            _this3.$log.log(response);
	            _this3.Message.success();
	            _this3.dataProducto = {};
	            _this3.productosLoad();
	            _this3.Util.setTouchedForm(producto_form, false);
	            _this3.insertaNuevo = false;
	          }
	        }).catch(function (error) {
	          _this3.$log.log(error);
	          _this3.Message.error('Ocurrió un error intentando guardar el producto.');
	        });
	      } else {
	        this.Util.setTouchedForm(producto_form);
	      }
	    }
	  }, {
	    key: 'productoBaja',
	    value: function productoBaja(index, item) {
	      var _this4 = this;
	
	      this.Modal.confirm('¿Esta seguro de que desea inactivar su producto?', function () {
	        _this4.DataService.put('certificaciones/' + _this4.idCertificacion + '/productos/' + item.id_producto, item).then(function (response) {
	          if (response) {
	            _this4.insertaNuevo = false;
	            _this4.productosLoad();
	            _this4.Message.success();
	          }
	        }).catch(function (error) {
	          _this4.$log.log(error);
	          _this4.Message.error('Ocurrió un error intentando guardar el producto.');
	        });
	      });
	    }
	  }, {
	    key: 'productoDel',
	    value: function productoDel(index, item) {
	      var _this5 = this;
	
	      this.DataService.delete('certificaciones/' + this.idCertificacion + '/productos/' + item.id_producto).then(function (response) {
	        _this5.$log.log('==================delete=====================');
	        _this5.$log.log(response);
	        _this5.insertaNuevo = false;
	        _this5.listaProductos.splice(index, 1);
	        _this5.Message.success();
	      }).catch(function (error) {
	        _this5.$log.log(error);
	        _this5.Message.error('Ocurrió un error intentando guardar el producto.');
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.insertaNuevo = false;
	      // this.$uibModalInstance.close();
	      // this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'productosImportar',
	    value: function productosImportar() {
	      this.Modal.show({
	        template: _importarProdModal4.default,
	        controller: _importarProdModal2.default,
	        data: this,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return FormularioProductoController;
	}();
	
	exports.default = FormularioProductoController;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inputChips = __webpack_require__(257);
	
	var _inputChips2 = _interopRequireDefault(_inputChips);
	
	var _inputChips3 = __webpack_require__(575);
	
	var _inputChips4 = _interopRequireDefault(_inputChips3);
	
	__webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputChipsComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        beforeAdd: '&',
	        onRemove: '&',
	        label: '@',
	        ngDisabled: '<',
	        ngUppercase: '<',
	        ngPlaceholder: '@'
	    },
	    controller: _inputChips2.default,
	    template: _inputChips4.default
	};
	
	exports.default = inputChipsComponent;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InputChipsController = function () {
	  InputChipsController.$inject = ["$scope", "$log", "Datetime"];
	  function InputChipsController($scope, $log, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, InputChipsController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.Datetime = Datetime;
	  }
	
	  _createClass(InputChipsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.ngPlaceholder = this.ngPlaceholder || 'Enter para añadir';
	      this.key = { tab: 9, enter: 13, esc: 27, space: 32, left: 37, up: 38, right: 39, down: 40, shift: 16, ctrl: 17, alt: 18, page_up: 33, page_down: 34, home: 36, end: 35, backspace: 8, delete: 46, command: 91 };
	      // this.$log.log(this);
	      this.keyAdd = this.key.enter;
	      this.keyTab = this.key.tab;
	      this.chips = {};
	      if (!this.ngModel) {
	        this.ngModel = [];
	      } else {
	        this.ngModel.forEach(function (it) {
	          _this.chips[it] = !0;
	        });
	      }
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        _this.chips_model = _this.ngModel.join('|');
	        // this.$log.log('change chips', this.ngModel, this.chips_model)
	      }, true);
	    }
	  }, {
	    key: 'onBlurChip',
	    value: function onBlurChip() {
	      //this.$log.log('blur',ev);
	      this.addChip();
	    }
	  }, {
	    key: 'keyChip',
	    value: function keyChip(ev) {
	      // this.$log.log(ev);
	      if (ev.keyCode == this.keyAdd) {
	        this.addChip();
	      }
	    }
	  }, {
	    key: 'addChip',
	    value: function addChip() {
	      // this.$log.log(ev);
	      // var chip = this.chip;asdf
	
	      if (this.chip && !this.chips[this.chip]) {
	        this.chips[this.chip] = !0;
	        if (this.beforeAdd) {
	          this.chip = this.beforeAdd({ $chip: this.chip });
	        }
	        if (this.chip != null) this.ngModel.push(this.chip);
	      }
	      this.chip = '';
	    }
	  }, {
	    key: 'remChip',
	    value: function remChip(i) {
	      if (!this.ngDisabled) {
	        delete this.chips[this.ngModel[i]];
	        this.ngModel.splice(i, 1);
	        if (this.onRemove) {
	          this.onRemove();
	        }
	      }
	    }
	
	    // editChip (ev, i) {
	    //   this.chip = this.ngModel[i];
	    //   this.$log.log(ev);
	    //   var $div = angular.element(angular.element(ev.target).closest('div'));
	    //   $div.children()[$div.children().length-1].focus();
	    //   this.remChip (i);
	    // }
	
	  }]);
	
	  return InputChipsController;
	}();
	
	exports.default = InputChipsController;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _localizacion = __webpack_require__(259);
	
	var _localizacion2 = _interopRequireDefault(_localizacion);
	
	var _localizacion3 = __webpack_require__(576);
	
	var _localizacion4 = _interopRequireDefault(_localizacion3);
	
	__webpack_require__(163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localizacionComponent = {
	    bindings: {
	        ngLabel: '<',
	        latitud: '=',
	        longitud: '=',
	        ngReguired: '<',
	        ngDisabled: '<',
	        maxPuntos: '<',
	        width: '<',
	        height: '<'
	    },
	    controller: _localizacion2.default,
	    template: _localizacion4.default
	};
	
	exports.default = localizacionComponent;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _localizacionModalController = __webpack_require__(260);
	
	var _localizacionModalController2 = _interopRequireDefault(_localizacionModalController);
	
	var _localizacionModal = __webpack_require__(577);
	
	var _localizacionModal2 = _interopRequireDefault(_localizacionModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalizacionController = function () {
	    LocalizacionController.$inject = ["$scope", "$log", "Datetime", "Modal"];
	    function LocalizacionController($scope, $log, Datetime, Modal) {
	        'ngInject';
	
	        _classCallCheck(this, LocalizacionController);
	
	        this.$scope = $scope;
	        this.$log = $log;
	        this.Datetime = Datetime;
	        this.Modal = Modal;
	    }
	
	    _createClass(LocalizacionController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$log.log(this);
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            this.Modal.show({
	                template: _localizacionModal2.default,
	                controller: _localizacionModalController2.default,
	                data: this.items,
	                size: 'md'
	            });
	        }
	    }]);
	
	    return LocalizacionController;
	}();
	
	exports.default = LocalizacionController;

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalizacionModalController = function () {
	    LocalizacionModalController.$inject = ["$uibModalInstance", "data"];
	    function LocalizacionModalController($uibModalInstance, data) {
	        'ngInject';
	
	        _classCallCheck(this, LocalizacionModalController);
	
	        this.data = data;
	        this.$uibModalInstance = $uibModalInstance;
	    }
	
	    _createClass(LocalizacionModalController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'ok',
	        value: function ok() {
	            this.$uibModalInstance.close(this.selected.item);
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }]);
	
	    return LocalizacionModalController;
	}();
	
	exports.default = LocalizacionModalController;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	// NumeroALetras
	// The MIT License (MIT)
	//
	// Copyright (c) 2015 Luis Alfredo Chee
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in all
	// copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	// SOFTWARE.
	//
	// @author Rodolfo Carmona
	// @contributor Jean (jpbadoino@gmail.com)
	/*************************************************************/
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NumeroALetras = function () {
	  function NumeroALetras() {
	    _classCallCheck(this, NumeroALetras);
	  }
	
	  _createClass(NumeroALetras, [{
	    key: 'Unidades',
	    value: function Unidades(num) {
	
	      switch (num) {
	        case 1:
	          return 'UN';
	        case 2:
	          return 'DOS';
	        case 3:
	          return 'TRES';
	        case 4:
	          return 'CUATRO';
	        case 5:
	          return 'CINCO';
	        case 6:
	          return 'SEIS';
	        case 7:
	          return 'SIETE';
	        case 8:
	          return 'OCHO';
	        case 9:
	          return 'NUEVE';
	      }
	
	      return '';
	    } //Unidades()
	
	  }, {
	    key: 'Decenas',
	    value: function Decenas(num) {
	      var decena, unidad;
	      decena = Math.floor(num / 10);
	      unidad = num - decena * 10;
	
	      switch (decena) {
	        case 1:
	          switch (unidad) {
	            case 0:
	              return 'DIEZ';
	            case 1:
	              return 'ONCE';
	            case 2:
	              return 'DOCE';
	            case 3:
	              return 'TRECE';
	            case 4:
	              return 'CATORCE';
	            case 5:
	              return 'QUINCE';
	            default:
	              return 'DIECI' + this.Unidades(unidad);
	          }
	        case 2:
	          switch (unidad) {
	            case 0:
	              return 'VEINTE';
	            default:
	              return 'VEINTI' + this.Unidades(unidad);
	          }
	        case 3:
	          return this.DecenasY('TREINTA', unidad);
	        case 4:
	          return this.DecenasY('CUARENTA', unidad);
	        case 5:
	          return this.DecenasY('CINCUENTA', unidad);
	        case 6:
	          return this.DecenasY('SESENTA', unidad);
	        case 7:
	          return this.DecenasY('SETENTA', unidad);
	        case 8:
	          return this.DecenasY('OCHENTA', unidad);
	        case 9:
	          return this.DecenasY('NOVENTA', unidad);
	        case 0:
	          return this.Unidades(unidad);
	      }
	    } //Unidades()
	
	  }, {
	    key: 'DecenasY',
	    value: function DecenasY(strSin, numUnidades) {
	      if (numUnidades > 0) return strSin + ' Y ' + this.Unidades(numUnidades);
	
	      return strSin;
	    } //DecenasY()
	
	  }, {
	    key: 'Centenas',
	    value: function Centenas(num) {
	      var centenas, decenas;
	      centenas = Math.floor(num / 100);
	      decenas = num - centenas * 100;
	
	      switch (centenas) {
	        case 1:
	          if (decenas > 0) return 'CIENTO ' + this.Decenas(decenas);
	          return 'CIEN';
	        case 2:
	          return 'DOSCIENTOS ' + this.Decenas(decenas);
	        case 3:
	          return 'TRESCIENTOS ' + this.Decenas(decenas);
	        case 4:
	          return 'CUATROCIENTOS ' + this.Decenas(decenas);
	        case 5:
	          return 'QUINIENTOS ' + this.Decenas(decenas);
	        case 6:
	          return 'SEISCIENTOS ' + this.Decenas(decenas);
	        case 7:
	          return 'SETECIENTOS ' + this.Decenas(decenas);
	        case 8:
	          return 'OCHOCIENTOS ' + this.Decenas(decenas);
	        case 9:
	          return 'NOVECIENTOS ' + this.Decenas(decenas);
	      }
	
	      return this.Decenas(decenas);
	    } //Centenas()
	
	  }, {
	    key: 'Seccion',
	    value: function Seccion(num, divisor, strSingular, strPlural) {
	      var cientos, resto, letras;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      letras = '';
	
	      if (cientos > 0) if (cientos > 1) letras = this.Centenas(cientos) + ' ' + strPlural;else letras = strSingular;
	
	      if (resto > 0) letras += '';
	
	      return letras;
	    } //Seccion()
	
	  }, {
	    key: 'Miles',
	    value: function Miles(num) {
	      var divisor, cientos, resto, strMiles, strCentenas;
	      divisor = 1000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strMiles = this.Seccion(num, divisor, 'UN MIL', 'MIL');
	      strCentenas = this.Centenas(resto);
	
	      if (strMiles == '') return strCentenas;
	
	      return strMiles + ' ' + strCentenas;
	    } //Miles()
	
	  }, {
	    key: 'Millones',
	    value: function Millones(num) {
	      var divisor, cientos, resto, strMillones, strMiles;
	      divisor = 1000000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strMillones = this.Seccion(num, divisor, 'UN MILLON', 'MILLONES');
	      strMiles = this.Miles(resto);
	
	      if (strMillones == '') return strMiles;
	
	      return strMillones + ' ' + strMiles;
	    } //Millones()
	
	  }, {
	    key: 'Billones',
	    value: function Billones(num) {
	      var divisor, cientos, resto, strBillones, strMillones;
	      divisor = 1000000000;
	      cientos = Math.floor(num / divisor);
	      resto = num - cientos * divisor;
	
	      strBillones = this.Seccion(num, divisor, 'UN BILLON', 'BILLONES');
	      strMillones = this.Millones(resto);
	
	      if (strBillones == '') return strMillones;
	
	      return strBillones + ' ' + strMillones;
	    } //Millones()
	
	  }, {
	    key: 'transformar',
	    value: function transformar(num) {
	      var data = {
	        numero: num,
	        enteros: Math.floor(num),
	        centavos: Math.round(num * 100) - Math.floor(num) * 100,
	        letrasCentavos: '',
	        letrasMonedaPlural: 'Bs.', //'PESOS', 'Dólares', 'Bolívares', 'etcs'
	        letrasMonedaSingular: 'Bs.', //'PESO', 'Dólar', 'Bolivar', 'etc'
	        letrasMonedaCentavoPlural: 'Ctvs.',
	        letrasMonedaCentavoSingular: 'ctv.'
	      };
	
	      // if (data.centavos > 0) {
	      //   data.letrasCentavos = 'CON ' + (function (){
	      //     if (data.centavos == 1)
	      //       return this.Billones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular;
	      //     else
	      //       return this.Billones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural;
	      //   })();
	      // }
	
	      if (data.enteros == 0) return 'CERO CON ' + data.centavos + '/100 ' + data.letrasMonedaPlural;
	      if (data.enteros == 1) return this.Billones(data.enteros) + ' CON ' + data.centavos + '/100 ' + data.letrasMonedaSingular;else return this.Billones(data.enteros) + ' CON ' + data.centavos + '/100 ' + data.letrasMonedaPlural;
	    } //NumeroALetras()
	
	  }]);
	
	  return NumeroALetras;
	}();
	
	exports.default = NumeroALetras;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _representante = __webpack_require__(263);
	
	var _representante2 = _interopRequireDefault(_representante);
	
	var _representante3 = __webpack_require__(578);
	
	var _representante4 = _interopRequireDefault(_representante3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './inputChips.scss';
	
	var representanteComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        beforeAdd: '&',
	        onRemove: '&',
	        label: '@',
	        ngDisabled: '<',
	        ngUppercase: '<',
	        ngPlaceholder: '@',
	        idCertificacion: '<',
	        data: '=',
	        conf: '<',
	        tieneMatricula: '<'
	    },
	    controller: _representante2.default,
	    template: _representante4.default
	};
	
	exports.default = representanteComponent;

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RepresentanteController = function () {
	  RepresentanteController.$inject = ["$log", "$scope", "DataService", "Message", "Util", "Loading"];
	  function RepresentanteController($log, $scope, DataService, Message, Util, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, RepresentanteController);
	
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.axs = {};
	    this.departamentos = [];
	    this.estadosCivil = [];
	    this.formatos = [];
	  }
	
	  _createClass(RepresentanteController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.get = {}; // variable que guarda respuestas de gets
	      this.axs = {
	        change_propietario: true, // evitara que se autoguarde por primera vez el representante y las veces q se asigne true
	        conf: {}
	      };
	      this.initJsonData();
	      this.cargarDepartamentosExpedido();
	      this.cargarEstadoCivil();
	      this.cargarFormatoInfo();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	      // this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'representanteChange',
	    value: function representanteChange(form) {
	      if (this.tieneMatricula) {
	        for (var k in this.data.hist_representantes) {
	          if (k != 'tipo_documento') {
	            delete this.data.hist_representantes[k];
	          }
	        }
	        this.data.hist_representantes.tipo_documento = this.data.propietario_representante == 'PROPIETARIO' ? 'CARNET_IDENTIDAD' : 'FUNDEMPRESA';
	        this.axs.change_propietario = true; // sw_propietario
	        this.Util.setTouchedForm(form, false);
	        this.axs.sw_propietario = this.data.propietario_representante == 'PROPIETARIO';
	        this.representantesRestore();
	      } else {
	        this.axs.change_propietario = false;
	        this.representanteUpd();
	      }
	    }
	  }, {
	    key: 'representantesRestore',
	    value: function representantesRestore() {
	      if (this.axs.rep_backup.propietario_representante == 'REPRESENTANTE' && this.data.propietario_representante == 'REPRESENTANTE') {
	        angular.extend(this.data.hist_representantes, this.axs.rep_backup.hist_representantes);
	      } else if (this.axs.rep_backup.propietario_representante == 'PROPIETARIO' && this.data.propietario_representante == 'PROPIETARIO') {
	        angular.extend(this.data.hist_representantes, this.axs.rep_backup.hist_representantes);
	      }
	    }
	  }, {
	    key: 'initJsonData',
	    value: function initJsonData() {
	      if (this.data.propietario_representante == 'PROPIETARIO' || this.data.propietario_representante == 'REPRESENTANTE' && !this.tiene_matricula) {
	        this.axs.change_propietario = false;
	      }
	      this.initDefault(this.data, 'propietario_representante', 'PROPIETARIO');
	      if (this.data.propietario_representante == 'PROPIETARIO') {
	        this.axs.sw_propietario = true;
	      }
	      if (this.data.propietario_representante == 'REPRESENTANTE' && !this.tiene_matricula) {
	        this.axs.sw_propietario = true;
	      }
	      this.axs.rep_backup = {
	        propietario_representante: angular.copy(this.data.propietario_representante),
	        hist_representantes: angular.copy(this.data.hist_representantes)
	      };
	    }
	  }, {
	    key: 'initDefault',
	    value: function initDefault(obj, key, val) {
	      if (!obj[key]) obj[key] = val;
	    }
	  }, {
	    key: 'cargarDepartamentosExpedido',
	    value: function cargarDepartamentosExpedido() {
	      var _this = this;
	
	      var url = 'parametros/?grupo=DEPARTAMENTO_MEF';
	      this.DataService.get(url).then(function (response) {
	        _this.departamentos = response;
	      });
	    }
	  }, {
	    key: 'cargarEstadoCivil',
	    value: function cargarEstadoCivil() {
	      var _this2 = this;
	
	      var url = 'parametros/?grupo=ESTADO_CIVIL';
	      this.DataService.get(url).then(function (response) {
	        _this2.estadosCivil = response;
	      });
	    }
	  }, {
	    key: 'cargarFormatoInfo',
	    value: function cargarFormatoInfo() {
	      var _this3 = this;
	
	      var url = 'parametros/?grupo=FORMATO_INF_MEF';
	      this.DataService.get(url).then(function (response) {
	        _this3.formatos = response;
	      });
	    }
	  }]);
	
	  return RepresentanteController;
	}();
	
	exports.default = RepresentanteController;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectDate = __webpack_require__(265);
	
	var _selectDate2 = _interopRequireDefault(_selectDate);
	
	var _selectDate3 = __webpack_require__(579);
	
	var _selectDate4 = _interopRequireDefault(_selectDate3);
	
	__webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectDateComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        label: '@',
	        ngDisabled: '<'
	    },
	    controller: _selectDate2.default,
	    template: _selectDate4.default
	};
	
	exports.default = selectDateComponent;

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectDateController = function () {
	  SelectDateController.$inject = ["$scope", "$log", "Datetime"];
	  function SelectDateController($scope, $log, Datetime) {
	    'ngInject';
	
	    _classCallCheck(this, SelectDateController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.Datetime = Datetime;
	  }
	
	  _createClass(SelectDateController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log('SelectDateController init');
	      // this.$log.log(this);
	      this.nowYear = new Date().getUTCFullYear();
	      this.$scope.$watch('$ctrl.ngModel', function () {
	        // this.$log.log('date', this.ngModel)
	        if (angular.isUndefined(_this.ngModel)) {
	          _this.day = null;
	          _this.month = null;
	          _this.year = null;
	        } else {
	          if (!_this.internal_change) {
	            var date = _this.ngModel;
	            if (typeof date == 'string') {
	              date = new Date(date);
	              _this.ngModel = new Date(_this.ngModel);
	            }
	            if (_this.Datetime.isDate(date)) {
	              _this.day = date.getUTCDate();
	              _this.month = date.getUTCMonth() + 1;
	              _this.year = date.getUTCFullYear();
	            }
	          }
	          delete _this.internal_change;
	        }
	      });
	      this.initMonths();
	      this.$scope.$watch('$ctrl.month', function (newValue, oldValue) {
	        if (newValue != oldValue) {
	          _this.changeDate('month');
	        }
	      });
	    }
	  }, {
	    key: 'initMonths',
	    value: function initMonths() {
	      var months = [];
	      for (var i = 0; i < 12; i++) {
	        months.push({
	          val: i + 1,
	          name: this.Datetime.months[i]
	        });
	      }
	      this.months = months;
	    }
	  }, {
	    key: 'changeDate',
	    value: function changeDate(prop) {
	      if (prop == 'day') {
	        if (!(0 < this.day && this.day < 32)) {
	          this.day = null;
	        }
	      }
	      // if (prop=='month') {
	      //
	      // }
	      if (prop == 'year') {
	        // this.$log.log('year', angular.copy(this.year))
	        if (this.year < this.nowYear - 120) {
	          this.year = null;
	        }
	        if (this.year > this.nowYear) {
	          this.year = null;
	        }
	        // this.$log.log('year', angular.copy(this.year))
	      }
	      if (this.year && this.month && this.day) {
	        this.internal_change = true;
	        this.ngModel = new Date(this.year, this.month - 1, this.day);
	      }
	    }
	  }]);
	
	  return SelectDateController;
	}();
	
	exports.default = SelectDateController;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectMunicipio = __webpack_require__(267);
	
	var _selectMunicipio2 = _interopRequireDefault(_selectMunicipio);
	
	var _selectMunicipio3 = __webpack_require__(580);
	
	var _selectMunicipio4 = _interopRequireDefault(_selectMunicipio3);
	
	__webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectMunicipioComponent = {
	    bindings: {
	        departamento: '=',
	        provincia: '=',
	        municipio: '=',
	        conf: '<'
	    },
	    controller: _selectMunicipio2.default,
	    template: _selectMunicipio4.default
	};
	
	exports.default = selectMunicipioComponent;

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectMunicipioController = function () {
	  SelectMunicipioController.$inject = ["$scope", "$log", "DataService"];
	  function SelectMunicipioController($scope, $log, DataService) {
	    'ngInject';
	
	    _classCallCheck(this, SelectMunicipioController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.DataService = DataService;
	  }
	
	  _createClass(SelectMunicipioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(this);
	
	      this.departamentosLoad();
	      this.init_provincias = this.provincia;
	      this.init_municipios = this.municipio;
	      this.$scope.$watch('$ctrl.departamento', function () {
	        // this.$log.log('departamentoChange', this);
	        if (_this.departamento) {
	          _this.provinciasLoad();
	        }
	      });
	      this.$scope.$watch('$ctrl.provincia', function () {
	        if (_this.provincia) {
	          _this.municipiosLoad();
	        }
	      });
	    }
	  }, {
	    key: 'departamentosLoad',
	    value: function departamentosLoad() {
	      var _this2 = this;
	
	      this.departamentos = [];
	      this.provincias = [];
	      this.municipios = [];
	
	      this.DataService.get('departamento').then(function (response) {
	        if (response) {
	          _this2.departamentos = response;
	        }
	      });
	    }
	  }, {
	    key: 'provinciasLoad',
	    value: function provinciasLoad() {
	      var _this3 = this;
	
	      this.provincias = [];
	      this.municipios = [];
	      if (!this.init_provincias) {
	        delete this.provincia;
	        delete this.municipio;
	      }
	      this.init_provincias = !1;
	
	      this.DataService.get('provincia/departamento/' + this.departamento).then(function (response) {
	        if (response) {
	          _this3.provincias = response;
	        }
	      });
	    }
	  }, {
	    key: 'municipiosLoad',
	    value: function municipiosLoad() {
	      var _this4 = this;
	
	      this.municipios = [];
	      if (!this.init_municipios) {
	        delete this.municipio;
	      }
	      this.init_municipios = !1;
	      this.DataService.get('municipio/provincia/' + this.provincia).then(function (response) {
	        if (response) {
	          _this4.municipios = response;
	        }
	      });
	    }
	  }]);
	
	  return SelectMunicipioController;
	}();
	
	exports.default = SelectMunicipioController;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectParametro = __webpack_require__(269);
	
	var _selectParametro2 = _interopRequireDefault(_selectParametro);
	
	var _selectParametro3 = __webpack_require__(581);
	
	var _selectParametro4 = _interopRequireDefault(_selectParametro3);
	
	__webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectParametroComponent = {
	    bindings: {
	        ngModel: '=',
	        ngRequired: '<',
	        ngDisabled: '<',
	        ngChange: '&',
	        parametro: '@',
	        filtro: '@',
	        query: '@',
	        typeSelect: '@',
	        keyText: '@',
	        label: '@',
	        opcional: '@'
	    },
	    controller: _selectParametro2.default,
	    template: _selectParametro4.default
	};
	
	exports.default = selectParametroComponent;

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectParametroController = function () {
	  SelectParametroController.$inject = ["DataService", "$log", "$scope"];
	  function SelectParametroController(DataService, $log, $scope) {
	    'ngInject';
	
	    _classCallCheck(this, SelectParametroController);
	
	    this.DataService = DataService;
	    this.$log = $log;
	    this.$scope = $scope;
	  }
	
	  _createClass(SelectParametroController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (!this.key) this.key = 'nombre';
	      if (!this.typeSelect) this.typeSelect = 'id';
	      var url = 'parametros/?grupo=' + this.parametro;
	      if (this.query) url += this.query;
	      this.DataService.get(url).then(function (response) {
	        _this.items = response;
	        //Quitando columna unidades para que el filtro se realice, segun observacion de G.E.
	        // Se realiza un filtrado para la adicion de OECAS Y OECOM en el caso de OTRAS ORGANIZACIONES PRODUCTIVAS
	        var filtro = [];
	        if (_this.filtro) {
	          filtro = _this.filtro.split('-');
	          if (filtro[0] == 'true') {
	            _this.items = _this.items.reduce(function (respuesta, item) {
	              if (filtro.indexOf(item.sigla) > 0) {
	                respuesta.push(item);
	              }
	              return respuesta;
	            }, []);
	          }
	        }
	
	        for (var i = 0; i < _this.items.length; i++) {
	          var obj = _this.items[i];
	          delete obj.grupo;
	        }
	        // this.$log.log(' ****************ARRAY de VALORES ***: ', this.items);
	        // si es opcional aniadimos un valor al combo que sera la bandera para no validar demas eventos
	        var isTrueSet = _this.opcional === 'true';
	        if (isTrueSet) {
	          _this.$log.log(' OPCIONAL***: ');
	          _this.items.unshift({
	            descripcion: 'Sin valor',
	            estado: 'estado',
	            id_parametro: null,
	            nombre: 'Ninguno',
	            order: 1,
	            sigla: 'Ninguno'
	          });
	        }
	      });
	
	      this.$scope.$watch('$ctrl.ngModel', function (newValue, oldValue) {
	        if (angular.toJson(newValue) != angular.toJson(oldValue)) {
	          _this.ngChange();
	        }
	      });
	    }
	  }]);
	
	  return SelectParametroController;
	}();
	
	exports.default = SelectParametroController;

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdSelectComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        disabled: '@',
	        ngRequired: '<',
	        ngDisabled: '<',
	        ngModel: '=',
	        ngModelOptions: '<',
	        items: '<',
	        groupBy: '@',
	        keyText: '@',
	        keyValue: '@',
	        ngTitle: '@',
	        placeholder: '@'
	    },
	    template: '\n    <div class="form-group" ng-if="!$ctrl.keyValue">\n        <label for="input" ng-if="$ctrl.label" ng-class="{\'ap-req\':$ctrl.required||$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <ui-select\n            ng-model="$ctrl.ngModel"\n            theme="bootstrap"\n            ng-required="$ctrl.required || $ctrl.ngRequired"\n            ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"\n            title="{{ $ctrl.ngTitle || \'Seleccione un \xEDtem\' }}">\n            <ui-select-match placeholder="{{ $ctrl.placeholder || \'Seleccione o busque un \xEDtem de la lista\' }}">\n                {{$select.selected[$ctrl.keyText||\'text\']}}\n            </ui-select-match>\n            <ui-select-choices group-by="$ctrl.groupBy" repeat="item in $ctrl.items | filter: $select.search">\n                <span ng-bind-html="item[$ctrl.keyText||\'text\'] | highlight: $select.search"></span>\n                <small ng-bind-html="item.code | highlight: $select.search"></small>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n    <div class="form-group" ng-if="$ctrl.keyValue">\n        <label for="input" ng-if="$ctrl.label" ng-class="{\'ap-req\':$ctrl.required||$ctrl.ngRequired}">{{ $ctrl.label }}</label>\n        <ui-select\n            ng-model="$ctrl.ngModel"\n            theme="bootstrap"\n            ng-required="$ctrl.required || $ctrl.ngRequired"\n            ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"\n            title="{{ $ctrl.ngTitle || \'Seleccione un \xEDtem\' }}">\n            <ui-select-match placeholder="{{ $ctrl.placeholder || \'Seleccione o busque un \xEDtem de la lista\' }}">\n                {{$select.selected[$ctrl.keyText||\'text\']}}\n            </ui-select-match>\n            <ui-select-choices group-by="$ctrl.groupBy" repeat="item[$ctrl.keyValue] as item in $ctrl.items | filter: $select.search">\n                <span ng-bind-html="item[$ctrl.keyText||\'text\'] | highlight: $select.search"></span>\n                <small ng-bind-html="item.code | highlight: $select.search"></small>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n    '
	};
	
	exports.default = MdSelectComponent;

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HelpService = function () {
	    HelpService.$inject = ["$window", "$document", "$compile"];
	    function HelpService($window, $document, $compile) {
	        'ngInject';
	
	        _classCallCheck(this, HelpService);
	
	        this.$window = $window;
	        this.$document = $document;
	        this.$compile = $compile;
	
	        this.template = '\n            <div class="ui-help-content">\n                <div class="ui-help-header">\n                    <i class="fa fa-question-circle"></i> <span class="ui-help-title"></span>\n                    <hr>\n                </div>\n                <div class="ui-help-body"><span class="ui-help-message"></span></div>\n            </div>';
	
	        this.fadeSleep = 500;
	    }
	
	    _createClass(HelpService, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'renderSleep',
	        value: function renderSleep(el) {
	            setTimeout(function () {
	                el.remove();
	            }, this.fadeSleep);
	        }
	    }, {
	        key: 'fadeOut',
	        value: function fadeOut(el) {
	            el.style.opacity = 1;
	
	            (function fade() {
	                if ((el.style.opacity -= .1) < 0) {
	                    el.style.display = "none";
	                } else {
	                    window.requestAnimationFrame(fade);
	                }
	            })();
	        }
	    }, {
	        key: 'fadeIn',
	        value: function fadeIn(el, display) {
	            el.style.opacity = 0;
	            el.style.display = display || "block";
	
	            (function fade() {
	                var val = parseFloat(el.style.opacity);
	
	                if (!((val += .1) > 1)) {
	                    el.style.opacity = val;
	                    window.requestAnimationFrame(fade);
	                }
	            })();
	        }
	    }, {
	        key: 'render',
	        value: function render($scope, title, message, idHelp, positionIn, classNew, width, fade) {
	            var _this = this;
	
	            if (fade) {
	                var helps = document.querySelectorAll('.ui-help-content');
	                if (helps.length) {
	                    for (var i in helps) {
	                        if (helps[i].classList) {
	                            this.fadeOut(helps[i]);
	                            this.renderSleep(helps[i]);
	                        }
	                    }
	                }
	            } else {
	                angular.element(document.querySelectorAll('.ui-help-content')).remove();
	            }
	            var element = angular.element(this.template)[0];
	            if (classNew) {
	                element.classList.add(classNew);
	            }
	            angular.element(document.body).append(element);
	            if (fade) {
	                element.classList.add('fade');
	                this.fadeIn(element);
	            }
	
	            if (typeof title != 'boolean') {
	                element.querySelector('.ui-help-title').innerHTML = title || 'Ayuda';
	            }
	            var content = this.$compile('<div>' + (message || 'Texto de ayuda') + '</div>')($scope);
	            angular.element(element.querySelector('.ui-help-message')).append(content);
	            var height = element.clientHeight;
	            if (width) {
	                element.style.width = width + 'px';
	            } else {
	                width = element.clientWidth;
	            }
	
	            if (idHelp === undefined || idHelp === null) {
	                element.classList.add('ui-help-center');
	                element.style.marginTop = -1 * (height / 2) - 20 + 'px';
	                element.style.marginLeft = -1 * (width / 2) + 'px';
	            } else {
	
	                this.renderPosition(element, idHelp, positionIn, height, width);
	
	                window.addEventListener('resize', function () {
	                    _this.renderPosition(element, idHelp, positionIn, height, width);
	                });
	            }
	
	            return element;
	        }
	    }, {
	        key: 'renderPosition',
	        value: function renderPosition(element, idHelp, positionIn, height, width) {
	            var position = null;
	            if (typeof idHelp == 'string') {
	                var elem = document.getElementById(idHelp);
	                if (elem) {
	                    position = elem.getBoundingClientRect();
	                } else {
	                    return false;
	                }
	            } else {
	                position = idHelp.getBoundingClientRect();
	            }
	            var heightWindow = this.$window.innerHeight;
	            var widthWindow = this.$window.innerWidth;
	            var posInitial = position;
	            var className = '';
	            var direction = positionIn || 'right';
	
	            if (direction == 'top') {
	                position = this.top(posInitial, height, width);
	                if (position.top < 0) {
	                    direction = 'bottom';
	                }
	            }
	            if (direction == 'right') {
	                position = this.right(posInitial, height);
	                if (position.left + width > widthWindow) {
	                    direction = 'left';
	                }
	            }
	            if (direction == 'bottom') {
	                position = this.bottom(posInitial, width);
	                if (position.top + height > heightWindow) {
	                    direction = 'top';
	                    position = this.top(posInitial, height, width);
	                }
	            }
	            if (direction == 'left') {
	                position = this.left(posInitial, height, width);
	                if (position.left < 0) {
	                    direction = 'right';
	                    position = this.right(posInitial, height);
	                }
	            }
	
	            className = direction;
	
	            if (direction == 'top') {
	                if (position.left + width > widthWindow) {
	                    position = this.top_left(posInitial, height, width);
	                    className = 'top-left';
	                } else {
	                    if (position.left < 0) {
	                        position = this.top_right(posInitial, height, width);
	                        className = 'top-right';
	                    }
	                }
	            }
	
	            if (direction == 'right') {
	                if (position.top + height > heightWindow) {
	                    position = this.right_top(posInitial, height);
	                    className = 'right-top';
	                } else {
	                    if (position.top < 0) {
	                        position = this.right_bottom(posInitial, width);
	                        className = 'right-bottom';
	                    }
	                }
	            }
	
	            if (direction == 'bottom') {
	                if (position.left + width > widthWindow) {
	                    position = this.bottom_left(posInitial, width);
	                    className = 'bottom-left';
	                } else {
	                    if (position.left < 0) {
	                        position = this.bottom_right(posInitial);
	                        className = 'bottom-right';
	                    }
	                }
	            }
	
	            if (direction == 'left') {
	                if (position.top + height > heightWindow) {
	                    position = this.left_top(posInitial, height, width);
	                    className = 'left-top';
	                } else {
	                    if (position.top < 0) {
	                        position = this.left_bottom(posInitial, width);
	                        className = 'left-bottom';
	                    }
	                }
	            }
	
	            // console.log('H:', height, 'W:', width, 'HW', heightWindow, 'WW', widthWindow);
	            // console.log('INITIAL:', posInitial, 'END:', position, 'POSITION', className, 'ELEMENT', element);
	
	            element.classList.remove('top');
	            element.classList.remove('right');
	            element.classList.remove('bottom');
	            element.classList.remove('left');
	            element.classList.remove('top-left');
	            element.classList.remove('top-right');
	            element.classList.remove('right-top');
	            element.classList.remove('right-bottom');
	            element.classList.remove('bottom-left');
	            element.classList.remove('bottom-right');
	            element.classList.remove('left-top');
	            element.classList.remove('left-bottom');
	            element.classList.add(className);
	            element.style.top = position.top + 'px';
	            element.style.left = position.left + 'px';
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy(element, fade) {
	            if (element) {
	                if (fade) {
	                    this.fadeOut(element);
	                    setTimeout(function () {
	                        element.remove();
	                    }, this.fadeSleep);
	                } else {
	                    element.remove();
	                }
	            }
	        }
	    }, {
	        key: 'top',
	        value: function top(position, height, width) {
	            return {
	                top: position.top - height - 12,
	                left: position.left - (width / 2 - position.width / 2)
	            };
	        }
	    }, {
	        key: 'top_right',
	        value: function top_right(position, height) {
	            return {
	                top: position.top - height - 12,
	                left: position.left + position.width / 2 - 20
	            };
	        }
	    }, {
	        key: 'top_left',
	        value: function top_left(position, height, width) {
	            return {
	                top: position.top - height - 12,
	                left: position.left + position.width / 2 + 20 - width
	            };
	        }
	    }, {
	        key: 'right',
	        value: function right(position, height) {
	            return {
	                top: position.top - (height / 2 - position.height / 2),
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'right_top',
	        value: function right_top(position, height) {
	            return {
	                top: position.top + position.height / 2 - height + 20,
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'right_bottom',
	        value: function right_bottom(position) {
	            return {
	                top: position.top + position.height / 2 - 20,
	                left: position.left + position.width + 12
	            };
	        }
	    }, {
	        key: 'bottom',
	        value: function bottom(position, width) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left - (width / 2 - position.width / 2)
	            };
	        }
	    }, {
	        key: 'bottom_right',
	        value: function bottom_right(position) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left + position.width / 2 - 20
	            };
	        }
	    }, {
	        key: 'bottom_left',
	        value: function bottom_left(position, width) {
	            return {
	                top: position.top + position.height + 12,
	                left: position.left + position.width / 2 + 20 - width
	            };
	        }
	    }, {
	        key: 'left',
	        value: function left(position, height, width) {
	            return {
	                top: position.top - (height / 2 - position.height / 2),
	                left: position.left - width - 12
	            };
	        }
	    }, {
	        key: 'left_top',
	        value: function left_top(position, height, width) {
	            return {
	                top: position.top + position.height / 2 - height + 20,
	                left: position.left - width - 12
	            };
	        }
	    }, {
	        key: 'left_bottom',
	        value: function left_bottom(position, width) {
	            return {
	                top: position.top + position.height / 2 - 20,
	                left: position.left - width - 12
	            };
	        }
	    }]);
	
	    return HelpService;
	}();
	
	exports.default = HelpService;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _help = __webpack_require__(273);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var help = {
	    bindings: {
	        message: '<',
	        title: '<',
	        position: '@',
	        direction: '@',
	        idHelp: '@'
	    },
	    template: '\n        <span class="ui-help" ng-if="$ctrl.message" id-help ng-mouseover="$ctrl.hoverIn()" ng-mouseleave="$ctrl.hoverOut()">\n            <i class="fa fa-question-circle"></i>\n        </span>\n    ',
	    controller: _help2.default
	};
	
	exports.default = help;

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HelpComponent = function () {
	    HelpComponent.$inject = ["$scope", "$rootScope", "HelpPopup"];
	    function HelpComponent($scope, $rootScope, HelpPopup) {
	        'ngInject';
	
	        _classCallCheck(this, HelpComponent);
	
	        this.$rootScope = $rootScope;
	        this.HelpPopup = HelpPopup;
	        this.$scope = $scope;
	    }
	
	    _createClass(HelpComponent, [{
	        key: '$onInit',
	        value: function $onInit() {
	
	            this.$element = null;
	
	            this.idHelp = null;
	
	            this.$rootScope.$on('$stateChangeStart', function () /*event, toState, toParams, fromState, fromParams*/{
	                if (this.$element) {
	                    this.$element.remove();
	                }
	            });
	        }
	    }, {
	        key: 'hoverIn',
	        value: function hoverIn() {
	            this.$element = this.HelpPopup.render(this.$scope, this.title, this.message, this.idHelp, this.position || this.direction);
	        }
	    }, {
	        key: 'hoverOut',
	        value: function hoverOut() {
	            this.HelpPopup.destroy(this.$element);
	        }
	    }]);
	
	    return HelpComponent;
	}();
	
	exports.default = HelpComponent;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _help = __webpack_require__(272);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _helpPopup = __webpack_require__(271);
	
	var _helpPopup2 = _interopRequireDefault(_helpPopup);
	
	var _tourHelp = __webpack_require__(277);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	__webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpModule = angular.module('angular-help', [_tourHelp2.default]).directive('idHelp', ['Util', function (Util) {
	    return {
	        link: function link(scope, element /*, attrs*/) {
	            var id = 'ui-help-' + Util.id();
	            element[0].setAttribute('id', id);
	            scope.$ctrl.idHelp = id;
	        }
	    };
	}]).service('HelpPopup', _helpPopup2.default).component('uiHelp', _help2.default).name;
	
	exports.default = HelpModule;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tourHelp = __webpack_require__(276);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tourhelp = {
	    bindings: {
	        tour: '<',
	        tourEnd: '<',
	        tourLabel: '<'
	    },
	    template: '',
	    controller: _tourHelp2.default
	};
	
	exports.default = Tourhelp;

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TourHelpController = function () {
	    TourHelpController.$inject = ["$scope", "$rootScope", "$window", "$document", "HelpPopup"];
	    function TourHelpController($scope, $rootScope, $window, $document, HelpPopup) {
	        'ngInject';
	
	        _classCallCheck(this, TourHelpController);
	
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$window = $window;
	        this.$document = $document;
	        this.HelpPopup = HelpPopup;
	    }
	
	    _createClass(TourHelpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$element = null;
	            this.position = 0;
	
	            this.tmplFinish = '<button class="btn btn-primary" ng-click="$ctrl.finish()"><i class="fa fa-check-circle"></i> ' + (this.tourLabel && this.tourLabel.end ? this.tourLabel.end : 'Terminar') + '</button>';
	
	            if (this.tour && this.tour.length) {
	                this.step();
	            }
	        }
	    }, {
	        key: 'renderButton',
	        value: function renderButton(setting) {
	            return ['<button type="button" class="btn ' + (setting.className || '') + '" ng-click="' + (setting.onClick || '') + '">', setting.icon && setting.icon.length ? '<i class="fa fa-' + setting.icon + '"></i>' : '', setting.label, '</button>'].join(' ');
	        }
	    }, {
	        key: 'step',
	        value: function step() {
	            var buttons = '<div class="tour-help-buttons">';
	            if (this.position > 0 && (this.tour[this.position].btnPrev === undefined || this.tour[this.position].btnPrev)) {
	                buttons += this.renderButton({
	                    label: this.tour[this.position].labelPrev || 'Anterior',
	                    icon: this.tour[this.position].iconPrev || 'angle-double-left',
	                    className: this.tour[this.position].classPrev || '',
	                    onClick: '$ctrl.prev()'
	                });
	            }
	            if (this.position < this.tour.length - 1 && (this.tour[this.position].btnNext === undefined || this.tour[this.position].btnNext)) {
	                buttons += this.renderButton({
	                    label: this.tour[this.position].labelNext || 'Siguiente',
	                    icon: this.tour[this.position].iconNext || 'angle-double-right',
	                    className: this.tour[this.position].classNext || '',
	                    onClick: '$ctrl.next()'
	                });
	            }
	            if (this.tour[this.position].btnFinish === undefined || this.tour[this.position].btnFinish) {
	                buttons += this.tmplFinish;
	            }
	            buttons += '</div>';
	            this.$element = this.HelpPopup.render(this.$scope, this.tour[this.position].title, this.tour[this.position].text + buttons, this.tour[this.position].id, this.tour[this.position].position || 'bottom', 'tour-popup', this.tour[this.position].width, true);
	            if (this.$element) {
	                this.drawBackdrop(this.tour[this.position].id, this.$element);
	            }
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            var _this = this;
	
	            if (typeof this.tour[this.position].next == 'function') {
	                this.tour[this.position].next();
	            }
	            this.position++;
	            setTimeout(function () {
	                _this.step();
	            }, this.tour[this.position].sleepShow || 0);
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            var _this2 = this;
	
	            if (typeof this.tour[this.position].prev == 'function') {
	                this.tour[this.position].prev();
	            }
	            this.position--;
	            setTimeout(function () {
	                _this2.step();
	            }, this.tour[this.position].sleepPrev || 0);
	        }
	    }, {
	        key: 'finish',
	        value: function finish() {
	            if (typeof this.tourEnd == 'function') {
	                this.tourEnd();
	            }
	            this.HelpPopup.destroy(this.$element, true);
	            this.destroyBackdrop();
	        }
	    }, {
	        key: 'destroyBackdrop',
	        value: function destroyBackdrop() {
	            angular.element(document.querySelectorAll('.tour-help-backdrop')).remove();
	        }
	    }, {
	        key: 'drawBackdrop',
	        value: function drawBackdrop(id, $help) {
	            var _this3 = this;
	
	            this.destroyBackdrop();
	
	            if (id) {
	                var pos = this.getPosition(id, $help);
	
	                this.createDiv(pos.top, 'top');
	                this.createDiv(pos.right, 'right');
	                this.createDiv(pos.bottom, 'bottom');
	                this.createDiv(pos.left, 'left');
	                this.createDiv({
	                    top: this.transform(pos.elem.top - pos.body.top),
	                    left: this.transform(pos.elem.left),
	                    height: this.transform(pos.elem.height),
	                    width: this.transform(pos.elem.width)
	                }, 'tour-transparent');
	
	                window.addEventListener('resize', function () {
	                    var pos = _this3.getPosition(id, $help);
	                    if (pos) {
	                        _this3.changePosition(pos.top, 'top');
	                        _this3.changePosition(pos.right, 'right');
	                        _this3.changePosition(pos.bottom, 'bottom');
	                        _this3.changePosition(pos.left, 'left');
	                        _this3.changePosition({
	                            top: _this3.transform(pos.elem.top - pos.body.top),
	                            left: _this3.transform(pos.elem.left),
	                            height: _this3.transform(pos.elem.height),
	                            width: _this3.transform(pos.elem.width)
	                        }, 'tour-transparent');
	                    }
	                });
	            } else {
	                var body = document.body.getBoundingClientRect();
	                this.createDiv({
	                    top: 0,
	                    left: 0,
	                    height: this.transform(body.height),
	                    width: this.transform(body.width)
	                }, 'tour-transparent-center');
	
	                window.addEventListener('resize', function () {
	                    var body = document.body.getBoundingClientRect();
	                    _this3.changePosition({
	                        top: 0,
	                        left: 0,
	                        height: _this3.transform(body.height),
	                        width: _this3.transform(body.width)
	                    }, 'tour-transparent-center');
	                });
	            }
	        }
	    }, {
	        key: 'getPosition',
	        value: function getPosition(id, $help) {
	            var body = document.body.getBoundingClientRect();
	            var elem = null;
	            if (typeof id == 'string' && id.length) {
	                elem = document.querySelector('#' + id);
	                if (elem) {
	                    elem = elem.getBoundingClientRect();
	                } else {
	                    return false;
	                }
	            } else {
	                elem = id.getBoundingClientRect();
	            }
	
	            var position = {
	                elem: elem,
	                body: body
	            };
	
	            position.top = {
	                top: 0,
	                left: 0,
	                height: this.transform(elem.top - body.top),
	                width: this.transform(body.width)
	            };
	            position.right = {
	                top: this.transform(elem.top - body.top),
	                left: this.transform(elem.right),
	                height: this.transform(elem.height),
	                width: this.transform(body.width - elem.right)
	            };
	            position.bottom = {
	                top: this.transform(elem.top + elem.height - body.top),
	                left: this.transform(0),
	                height: this.transform(body.height - (elem.top + elem.height - body.top)),
	                width: this.transform(body.width)
	            };
	            position.left = {
	                top: this.transform(elem.top - body.top),
	                left: this.transform(0),
	                height: this.transform(elem.height),
	                width: this.transform(elem.left)
	            };
	
	            if (elem.top + elem.height > body.height) {
	                var scrollY = elem.top + elem.height - body.height;
	                $help.css('top', parseInt($help.css('top')) - (scrollY + 30));
	                window.scrollTo(0, scrollY + 30 - body.top);
	                // bottom.height = this.transform(30);
	            }
	
	            return position;
	        }
	    }, {
	        key: 'transform',
	        value: function transform(number) {
	            return parseFloat(number).toFixed(2) + "px";
	        }
	    }, {
	        key: 'changePosition',
	        value: function changePosition(css, className) {
	            this.setCss(document.querySelector('.tour-help-backdrop.' + className), css);
	        }
	    }, {
	        key: 'createDiv',
	        value: function createDiv(css, className) {
	            var div = document.createElement('div');
	            div.className = "tour-help-backdrop";
	            if (className) {
	                div.classList.add(className);
	            }
	            this.setCss(div, css);
	            document.body.appendChild(div);
	        }
	    }, {
	        key: 'setCss',
	        value: function setCss(obj, data) {
	            if (obj) {
	                for (var i in data) {
	                    obj.style[i] = data[i];
	                }
	            }
	        }
	    }]);
	
	    return TourHelpController;
	}();
	
	exports.default = TourHelpController;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tourHelp = __webpack_require__(275);
	
	var _tourHelp2 = _interopRequireDefault(_tourHelp);
	
	__webpack_require__(168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TourHelpModule = angular.module('angular-tour-help', []).component('uiTourHelp', _tourHelp2.default).name;
	
	exports.default = TourHelpModule;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mdInput = __webpack_require__(280);
	
	var _mdInput2 = _interopRequireDefault(_mdInput);
	
	var _mdTextarea = __webpack_require__(283);
	
	var _mdTextarea2 = _interopRequireDefault(_mdTextarea);
	
	var _mdSelect = __webpack_require__(282);
	
	var _mdSelect2 = _interopRequireDefault(_mdSelect);
	
	var _mdEventLabel = __webpack_require__(279);
	
	var _mdEventLabel2 = _interopRequireDefault(_mdEventLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MaterialModule = angular.module('app.material', []).component('mdInput', _mdInput2.default).component('mdTextarea', _mdTextarea2.default).component('mdSelect', _mdSelect2.default).directive('mdEventLabel', function () {
	    return new _mdEventLabel2.default();
	}).name;
	
	exports.default = MaterialModule;

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdEventLabel = function () {
	    function MdEventLabel() {
	        _classCallCheck(this, MdEventLabel);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(MdEventLabel, [{
	        key: 'link',
	        value: function link($scope, $elem) {
	            if ($scope.$ctrl.required === undefined && $scope.$ctrl.ngRequired === undefined) {
	                var $input = $elem.find('input');
	                if ($input.length === 0) {
	                    $input = $elem.find('textarea');
	                }
	                if ($input.length) {
	                    $input.addClass('not-required');
	                    $input.on('focus', function () {
	                        $input.removeClass('not-required');
	                    }).on('blur', function () {
	                        $input[$input.val().length ? 'removeClass' : 'addClass']('not-required');
	                    });
	                } else {
	                    setTimeout(function () {
	                        $input = $elem.find('input');
	                        $input.on('focus', function () {
	                            $input.parent().addClass('not-required-select').parent().addClass('md-focus');
	                        }).on('blur', function () {
	                            setTimeout(function () {
	                                $input.parent()[$input.parent()[0].querySelector('.ui-select-match-text').innerHTML.length ? 'addClass' : 'removeClass']('not-required-select').parent().removeClass('md-focus');
	                            }, 1);
	                        });
	                    }, 1000);
	                }
	            }
	        }
	    }]);
	
	    return MdEventLabel;
	}();
	
	exports.default = MdEventLabel;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mdInput = __webpack_require__(281);
	
	var _mdInput2 = _interopRequireDefault(_mdInput);
	
	__webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdInputComponent = {
	    bindings: {
	        label: '@',
	        type: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        readonly: '@',
	        ngReadonly: '@',
	        ngModel: '=',
	        ngClick: '<',
	        ngChange: '<',
	        ngModelOptions: '<',
	        value: '<',
	        ngValue: '<',
	        ngDefault: '<'
	    },
	    template: '\n    <div class="md-form-group" md-event-label>\n        <input ng-required="$ctrl.required || $ctrl.ngRequired" \n               ng-disabled="$ctrl.disabled || $ctrl.ngDisabled" \n               ng-readonly="$ctrl.readonly || $ctrl.ngReadonly" \n               ng-model="$ctrl.ngModel" \n               ng-click="$ctrl.ngClick" \n               ng-change="$ctrl.ngChange" \n               ng-model-options="$ctrl.ngModelOptions"\n               ng-placeholder="$ctrl.placeholder"\n               type="{{ $ctrl.type || \'text\' }}"\n               $ctrl.ngValue || $ctrl.ngDefault || $ctrl.value || \'\'>\n        <label class="md-control-label" for="input">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    ',
	    controller: _mdInput2.default
	};
	
	exports.default = MdInputComponent;

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdInputController = function () {
	    function MdInputController() {
	        _classCallCheck(this, MdInputController);
	    }
	
	    _createClass(MdInputController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }]);
	
	    return MdInputController;
	}();
	
	exports.default = MdInputController;

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdSelectComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        ngModel: '=',
	        ngChange: '<',
	        ngModelOptions: '<',
	        items: '<'
	    },
	    template: '\n    <div class="md-form-group">\n        <select ng-required="$ctrl.required || $ctrl.ngRequired" \n                ng-disabled="$ctrl.disabled || $ctrl.ngDisabled"  \n                ng-model="$ctrl.ngModel" \n                ng-change="$ctrl.ngChange" \n                ng-model-options="$ctrl.ngModelOptions">\n            <option value="{{ item.value }}" ng-if="item.value" ng-repeat="item in $ctrl.items">{{item.text}}</option>\n        </select>\n        <label class="md-control-label" for="select">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    '
	};
	
	exports.default = MdSelectComponent;

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MdTextareaComponent = {
	    bindings: {
	        label: '@',
	        required: '@',
	        ngRequired: '@',
	        disabled: '@',
	        ngDisabled: '@',
	        readonly: '@',
	        ngReadonly: '@',
	        ngModel: '=',
	        ngClick: '<',
	        ngChange: '<',
	        ngModelOptions: '<',
	        value: '<',
	        ngValue: '<',
	        ngDefault: '<'
	    },
	    template: '\n    <div class="md-form-group" md-event-label>\n        <textarea ng-required="$ctrl.required || $ctrl.ngRequired" \n                  ng-disabled="$ctrl.disabled || $ctrl.ngDisabled" \n                  ng-readonly="$ctrl.readonly || $ctrl.ngReadonly" \n                  ng-model="$ctrl.ngModel" \n                  ng-click="$ctrl.ngClick" \n                  ng-change="$ctrl.ngChange" \n                  ng-model-options="$ctrl.ngModelOptions"\n                  ng-placeholder="$ctrl.placeholder">{{ $ctrl.ngValue || $ctrl.ngDefault || $ctrl.value || \'\' }}</textarea>\n        <label class="md-control-label" for="textarea">{{ $ctrl.label }}</label>\n        <i class="md-bar"></i>\n    </div>\n    '
	};
	
	exports.default = MdTextareaComponent;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pageTimeline = __webpack_require__(285);
	
	var _pageTimeline2 = _interopRequireDefault(_pageTimeline);
	
	var _pageTimeline3 = __webpack_require__(582);
	
	var _pageTimeline4 = _interopRequireDefault(_pageTimeline3);
	
	__webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageTimelineComponent = {
	    bindings: {
	        ngModel: '=',
	        representante: '=',
	        ngRequired: '<',
	        beforeAdd: '&',
	        onRemove: '&',
	        label: '@',
	        ngDisabled: '<',
	        ngUppercase: '<',
	        ngPlaceholder: '@',
	        hiddenField: '@'
	    },
	    controller: _pageTimeline2.default,
	    template: _pageTimeline4.default
	};
	
	exports.default = pageTimelineComponent;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TimelineController = function () {
	  TimelineController.$inject = ["$scope", "DataService", "Datetime", "Message", "$log", "Util", "Storage"];
	  function TimelineController($scope, DataService, Datetime, Message, $log, Util, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, TimelineController);
	
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Datetime = Datetime;
	    this.Message = Message;
	    this.$log = $log;
	    this.Util = Util;
	    this.Storage = Storage;
	  }
	
	  _createClass(TimelineController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.$log.log("Componente timeline*******************");
	      if (!this.ngModel) {
	        this.ngModel = {};
	      }
	    }
	  }]);
	
	  return TimelineController;
	}();
	
	exports.default = TimelineController;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pageTimeline = __webpack_require__(284);
	
	var _pageTimeline2 = _interopRequireDefault(_pageTimeline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTimelineModule = angular.module('app.page-timeline', []).component('pageTimeline', _pageTimeline2.default).name;
	
	exports.default = PageTimelineModule;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _crudTable = __webpack_require__(235);
	
	var _crudTable2 = _interopRequireDefault(_crudTable);
	
	var _material = __webpack_require__(278);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _forms = __webpack_require__(251);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _help = __webpack_require__(274);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _timeline = __webpack_require__(286);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.util', [_crudTable2.default, _material2.default, _forms2.default, _help2.default, _timeline2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Errors = {
	    '401': 'No se pudo realizar la operación.',
	    '412': 'No se pudo realizar la operación.',
	    '403': 'Su sesión ha caducado o no tiene los permisos necesarios.',
	    '404': 'No existe el recurso solicitado.',
	    '407': 'Necesita configurar su Proxy para poder usar el sistema.',
	    '408': 'El servidor no responde intente más tarde.',
	    '409': 'Los datos no son válidos',
	    '410': 'El recurso solicitado ya no está disponible y no lo estará de nuevo.',
	    '500': 'Se produjo un error en el servidor, inténtelo más tarde.',
	    '502': 'El sistema no está disponible en estos momentos, inténtelo más tarde.',
	    '503': 'El sistema se encuentra en mantenimiento en estos momentos, vuelva a intentarlo más tarde por favor.',
	    // '504': 'Gateway timeout - Tiempo de espera agota.', // Esto debe ser implementado en el frontend para reintentar las peticiones
	    'connection': 'No se pudo establecer conexión con el servidor.',
	    'cancelRequest': 'Petición cancelada.',
	    'validation': 'Error de validación'
	};
	
	exports.default = Errors;

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Help = {
	    'codigoProducto': 'Identificador del producto en Mercado Virtual',
	    'codigoUnspsc': 'Código de Catálogo UNSPSC',
	    'codigoFicha': 'Código de la ficha',
	    'codigoNandina': 'Código NANDINA',
	    'nombreProducto': 'Nombre del producto',
	    'capacidadProduccionMensual': 'Capacidad de Producción Mensual',
	    'precioUnitario': 'Precio por unidad',
	    'posicionArancelaria': 'Posicion arancelaria',
	    'color': 'Se aplica a productos que pueden ser caracterizados por color. Ejemplo: prendas de vestir.',
	    'talla': 'Se aplica a productos que se fabrican por tallas. Ejemplo: textiles, prendas de vestir.',
	    'peso': 'Se aplica a productos cuantificables en Kilogramos, litros, etc. Por ejemplo: productos alimenticios.',
	    'medidas': 'Se aplica a productos, cuyas dimensiones (alto, ancho, fondo) pueden medirse. Por ejemplo: 30 cm x 25 cm x  3 cm.',
	    'marca': 'Este campo es obligatorio si es que a futuro solicitará certificado Hecho en Bolivia para el producto',
	    'nombre_comercial': 'Registre un nombre descriptivo que permita identificar de forma clara al producto. Ejemplo: Silla unipersonal de melamina y estructura metálica'
	};
	
	exports.default = Help;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _errors = __webpack_require__(288);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _help = __webpack_require__(289);
	
	var _help2 = _interopRequireDefault(_help);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lang = angular.module('app.lang', []).constant('errorsLang', _errors2.default).constant('helpLang', _help2.default).run(["$rootScope", "errorsLang", "helpLang", function ($rootScope, errorsLang, helpLang) {
	    "ngInject";
	
	    $rootScope.lang = {
	        errorsLang: errorsLang,
	        helpLang: helpLang
	    };
	}]).name;
	
	exports.default = Lang;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _breadcrumb = __webpack_require__(292);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	__webpack_require__(176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreadcrumbComponent = {
	    template: '\n        <ol class="breadcrumb">\n            <li class="breadcrumb-item"><i class="fa fa-home"></i> <a href="/">Inicio</a></li>\n            <li class="breadcrumb-item" ng-if="$ctrl.getParent()">{{$ctrl.getParent()}}</li>\n            <li class="breadcrumb-item active" ng-if="$ctrl.getCurrent()">{{$ctrl.getCurrent()}}</li>\n        </ol>\n    ',
	    controller: _breadcrumb2.default
	};
	
	exports.default = BreadcrumbComponent;

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BreadcrumbController = function () {
	    BreadcrumbController.$inject = ["Storage", "$location", "BreadcrumbFactory", "Util"];
	    function BreadcrumbController(Storage, $location, BreadcrumbFactory, Util) {
	        'ngInject';
	
	        _classCallCheck(this, BreadcrumbController);
	
	        this.Storage = Storage;
	        this.$location = $location;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.Util = Util;
	    }
	
	    _createClass(BreadcrumbController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (this.Storage.exist('menu')) {
	                var page = this.Util.getMenuOption(this.Storage.get('menu'), this.$location.path().replace('/', ''));
	                this.BreadcrumbFactory.setParent(page[0]);
	                this.BreadcrumbFactory.setCurrent(page[1]);
	            }
	        }
	    }, {
	        key: 'getParent',
	        value: function getParent() {
	            return this.BreadcrumbFactory.getParent();
	        }
	    }, {
	        key: 'getCurrent',
	        value: function getCurrent() {
	            return this.BreadcrumbFactory.getCurrent();
	        }
	    }]);
	
	    return BreadcrumbController;
	}();
	
	exports.default = BreadcrumbController;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var BreadcrumbFactory = function BreadcrumbFactory() {
	    var _this = this;
	
	    var factory = {
	        parent: '',
	        current: '',
	        setParent: function setParent(parent) {
	            _this.parent = parent;
	        },
	        setCurrent: function setCurrent(current) {
	            _this.current = current;
	        },
	        getParent: function getParent() {
	            return _this.parent;
	        },
	        getCurrent: function getCurrent() {
	            return _this.current;
	        }
	    };
	
	    return factory;
	};
	
	exports.default = BreadcrumbFactory;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _breadcrumb = __webpack_require__(291);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _breadcrumb3 = __webpack_require__(293);
	
	var _breadcrumb4 = _interopRequireDefault(_breadcrumb3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = angular.module('app.breadcrumb', []).factory('BreadcrumbFactory', _breadcrumb4.default).component('appBreadcrumb', _breadcrumb2.default).name;
	
	exports.default = Breadcrumb;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _footer = __webpack_require__(296);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterComponent = {
	    template: '\n        <footer class="footer text-info">\n            <div class="footer-left">{{ $ctrl.version }}</div>\n            <div class="footer-right">Agetic {{ $ctrl.year }}</div>\n        </footer>\n    ',
	    controller: _footer2.default
	};
	
	exports.default = FooterComponent;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _package = __webpack_require__(199);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FooterController = function () {
	    function FooterController() {
	        _classCallCheck(this, FooterController);
	    }
	
	    _createClass(FooterController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var date = new Date();
	            this.version = 'v' + _package2.default.version;
	            this.year = date.getFullYear();
	        }
	    }]);
	
	    return FooterController;
	}();
	
	exports.default = FooterController;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(9);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _sidenav = __webpack_require__(307);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _breadcrumb = __webpack_require__(294);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _loading = __webpack_require__(300);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _navbar = __webpack_require__(302);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _footer = __webpack_require__(295);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = _angular2.default.module('app.layout', [_sidenav2.default, _breadcrumb2.default, _loading2.default]).component('appNavbar', _navbar2.default).component('appFooter', _footer2.default).name;
	
	exports.default = Layout;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loading = __webpack_require__(299);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	__webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadingComponent = {
	    template: '\n        <div class="loading">Loading</div>\n    ',
	    controller: _loading2.default
	};
	
	exports.default = LoadingComponent;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoadingController = function () {
	    function LoadingController() {
	        // this.DataService = DataService;
	
	        _classCallCheck(this, LoadingController);
	    }
	
	    _createClass(LoadingController, [{
	        key: 'cancelRequest',
	        value: function cancelRequest() {
	            // this.DataService.cancelRequest();
	        }
	    }]);
	
	    return LoadingController;
	}();
	
	exports.default = LoadingController;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loading = __webpack_require__(298);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _loading3 = __webpack_require__(301);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loading = angular.module('app.loading', []).component('appLoading', _loading2.default).service('Loading', _loading4.default).name;
	
	exports.default = Loading;

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoadingService = function () {
	    LoadingService.$inject = ["cfpLoadingBar"];
	    function LoadingService(cfpLoadingBar) {
	        'ngInject';
	
	        _classCallCheck(this, LoadingService);
	
	        this.cfpLoadingBar = cfpLoadingBar;
	    }
	
	    _createClass(LoadingService, [{
	        key: 'show',
	        value: function show(message, locked) {
	            this.cfpLoadingBar.start();
	            document.querySelector('#loading-bar-spinner .loading-text').innerHTML = message || 'Cargando';
	
	            if (locked) {
	                document.querySelector('#loading-bar-spinner').classList.add('screen-locked');
	            } else {
	                document.querySelector('#loading-bar-spinner').classList.remove('screen-locked');
	            }
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.cfpLoadingBar.complete();
	            document.querySelector('#loading-bar-spinner .loading-text').innerHTML = 'Cargando';
	            document.querySelector('#loading-bar-spinner').classList.remove('screen-locked');
	        }
	    }]);
	
	    return LoadingService;
	}();
	
	exports.default = LoadingService;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _navbar = __webpack_require__(583);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbarController = __webpack_require__(303);
	
	var _navbarController2 = _interopRequireDefault(_navbarController);
	
	__webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarComponent = {
	    bindings: {},
	    template: _navbar2.default,
	    controller: _navbarController2.default
	};
	
	exports.default = NavbarComponent;

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarController = function () {
	    NavbarController.$inject = ["$state", "Util", "Auth", "$log", "Sidenav"];
	    function NavbarController($state, Util, Auth, $log, Sidenav) {
	        "ngInject";
	
	        _classCallCheck(this, NavbarController);
	
	        this.$state = $state;
	        this.Util = Util;
	        this.Auth = Auth;
	        this.$log = $log;
	        this.Sidenav = Sidenav;
	    }
	
	    _createClass(NavbarController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.empresas = [{ value: 1, text: '1232123 - Empresa uno' }, { value: 2, text: '1232124 - Empresa dos' }];
	        }
	    }, {
	        key: 'toggleSidenav',
	        value: function toggleSidenav() {
	            document.querySelector('#app-sidenav').classList.toggle('sidenav-close');
	        }
	    }, {
	        key: 'fullscreen',
	        value: function fullscreen() {
	            document.querySelector('body').classList.toggle('fullscreen');
	            this.Util.fullscreen();
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            this.$state.reload();
	        }
	    }, {
	        key: 'toggled',
	        value: function toggled(open) {
	            this.$log.log('open', open);
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.Auth.logout();
	        }
	    }, {
	        key: 'miCuenta',
	        value: function miCuenta() {
	            this.Sidenav.path("micuenta");
	        }
	    }]);
	
	    return NavbarController;
	}();
	
	exports.default = NavbarController;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(181);
	
	var _sidenav = __webpack_require__(584);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _sidenav3 = __webpack_require__(305);
	
	var _sidenav4 = _interopRequireDefault(_sidenav3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidenavComponent = {
	    bindings: {},
	    template: _sidenav2.default,
	    controller: _sidenav4.default
	};
	
	exports.default = SidenavComponent;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SidenavController = function () {
	    SidenavController.$inject = ["$location", "Storage", "Util", "BreadcrumbFactory", "SidenavFactory", "systemName", "Auth"];
	    function SidenavController($location, Storage, Util, BreadcrumbFactory, SidenavFactory, systemName, Auth) {
	        "ngInject";
	
	        _classCallCheck(this, SidenavController);
	
	        this.$location = $location;
	        this.Storage = Storage;
	        this.Util = Util;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.SidenavFactory = SidenavFactory;
	        this.Auth = Auth;
	        this.systemName = systemName;
	    }
	
	    _createClass(SidenavController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var color = ['success-second', 'success', 'danger', 'warning', 'primary'];
	
	            this.url = this.$location.path().replace('/', '');
	
	            if (this.Auth.isAuthenticated()) {
	                this.SidenavFactory.setUser(this.Storage.getUser());
	                this.SidenavFactory.setMenu(this.Storage.get('menu'));
	                this.SidenavFactory.setVisible(this.Storage.get('visible'));
	                this.SidenavFactory.setSidenav(this.Storage.get('sidenav'));
	            }
	            this.menu = this.SidenavFactory.getMenu();
	            this.Storage.set('menu', this.menu);
	
	            this.SidenavFactory.userColor = color[parseInt(Math.random() * color.length)];
	
	            window.setTimeout(function () {
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.parentNode.parentNode.previousElementSibling.dispatchEvent(new window.Event('click'));
	                }
	            }, 1000);
	        }
	    }, {
	        key: 'send',
	        value: function send(url, submenu) {
	            if (typeof submenu == 'undefined') {
	                if (this.Storage.exist('menu')) {
	                    var page = this.Util.getMenuOption(this.Storage.get('menu'), url);
	                    this.BreadcrumbFactory.setParent(page[0]);
	                    this.BreadcrumbFactory.setCurrent(page[1]);
	                }
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.classList.remove('active');
	                }
	                el = document.querySelector('#sidenav-menu .sidenav-submenu-item[data-url=' + url + ']');
	                if (el) {
	                    el.classList.add('active');
	                }
	                this.$location.path(url);
	            }
	        }
	    }, {
	        key: 'getColor',
	        value: function getColor() {
	            return this.SidenavFactory.userColor;
	        }
	    }, {
	        key: 'getName',
	        value: function getName() {
	            var user = this.SidenavFactory.getUser();
	            if (user) {
	                user = user.usuario || user.username;
	                if (user && user.split('@').length > 1) {
	                    user = user.split('@')[0];
	                }
	                return user;
	            }
	            return "";
	        }
	    }, {
	        key: 'getEmail',
	        value: function getEmail() {
	            return this.SidenavFactory.getUser().email;
	        }
	    }, {
	        key: 'getInitial',
	        value: function getInitial() {
	            var firstName;
	            if (this.SidenavFactory.getUser().usuario) {
	                firstName = this.SidenavFactory.getUser().usuario;
	                return firstName.length ? firstName[0].toUpperCase() : '?';
	            } else if (this.SidenavFactory.getUser().username) {
	                firstName = this.SidenavFactory.getUser().username;
	                return firstName.length ? firstName[0].toUpperCase() : '?';
	            }
	            return '?';
	        }
	    }, {
	        key: 'getMenu',
	        value: function getMenu() {
	            return this.SidenavFactory.getMenu();
	        }
	    }, {
	        key: 'getVisible',
	        value: function getVisible() {
	            return this.SidenavFactory.getVisible();
	        }
	    }, {
	        key: 'getSidenav',
	        value: function getSidenav() {
	            return this.SidenavFactory.getSidenav();
	        }
	    }, {
	        key: 'setVisible',
	        value: function setVisible(visible) {
	            this.Storage.set('visible', visible);
	            this.SidenavFactory.setVisible(visible);
	        }
	    }, {
	        key: 'setSidenav',
	        value: function setSidenav(sidenav) {
	            this.Storage.set('sidenav', sidenav);
	            this.SidenavFactory.setSidenav(sidenav);
	        }
	    }]);
	
	    return SidenavController;
	}();
	
	exports.default = SidenavController;

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SidenavFactory = function SidenavFactory() {
	
	    var factory = {
	        user: {
	            id: '',
	            first_name: '',
	            last_name: '',
	            cargo: '',
	            email: '',
	            photo: '',
	            nit: '',
	            user: ''
	        },
	        userColor: '',
	        menu: [],
	        rol: '',
	        visible: true,
	        sidenav: true,
	        getMenu: function getMenu() {
	            return this.menu;
	        },
	        setMenu: function setMenu(menu) {
	            this.menu = menu;
	        },
	        getUser: function getUser() {
	            return this.user;
	        },
	        setUser: function setUser(user) {
	            this.user = user;
	        },
	        getRol: function getRol() {
	            return this.rol;
	        },
	        setRol: function setRol(rol) {
	            this.rol = rol;
	        },
	        getVisible: function getVisible() {
	            return this.visible;
	        },
	        setVisible: function setVisible(visible) {
	            this.visible = visible;
	        },
	        getSidenav: function getSidenav() {
	            return this.sidenav;
	        },
	        setSidenav: function setSidenav(sidenav) {
	            this.sidenav = sidenav;
	        }
	    };
	
	    return factory;
	};
	
	exports.default = SidenavFactory;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _sidenav = __webpack_require__(304);
	
	var _sidenav2 = _interopRequireDefault(_sidenav);
	
	var _sidenav3 = __webpack_require__(308);
	
	var _sidenav4 = _interopRequireDefault(_sidenav3);
	
	var _sidenav5 = __webpack_require__(306);
	
	var _sidenav6 = _interopRequireDefault(_sidenav5);
	
	var _toggleMenu = __webpack_require__(309);
	
	var _toggleMenu2 = _interopRequireDefault(_toggleMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sidenav = angular.module('app.sidenav', []).service('Sidenav', _sidenav4.default).component('appSidenav', _sidenav2.default).directive('toggleMenu', function () {
	    return new _toggleMenu2.default();
	}).factory('SidenavFactory', _sidenav6.default).name;
	
	exports.default = Sidenav;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SidenavService = function () {
	    SidenavService.$inject = ["$location"];
	    function SidenavService($location) {
	        'ngInject';
	
	        _classCallCheck(this, SidenavService);
	
	        this.$location = $location;
	    }
	
	    _createClass(SidenavService, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'path',
	        value: function path(url) {
	            this.$location.path(url);
	
	            setTimeout(function () {
	                var origin = null;
	                var el = document.querySelector('#sidenav-menu .sidenav-submenu-item.active');
	                if (el) {
	                    el.classList.remove('active');
	                    origin = el.parentNode.parentNode.previousElementSibling.getAttribute('data-url');
	                }
	
	                el = document.querySelector('#sidenav-menu .sidenav-submenu-item[data-url=' + url + ']');
	                if (el) {
	                    el.classList.add('active');
	                    el = el.parentNode.parentNode.previousElementSibling;
	                    if (el.getAttribute('data-url') != origin) {
	                        el.dispatchEvent(new window.Event('click'));
	                    }
	                }
	            }, 100);
	        }
	    }]);
	
	    return SidenavService;
	}();
	
	exports.default = SidenavService;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ToggleMenu = function () {
	    function ToggleMenu() {
	        _classCallCheck(this, ToggleMenu);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(ToggleMenu, [{
	        key: 'link',
	        value: function link($scope, $elem) {
	            $elem.on('click', function (e) {
	                e.preventDefault();
	
	                var $submenu = $elem.next();
	                var $items = $submenu.find('a');
	
	                if ($items.length) {
	                    if ($elem.parent().hasClass('sidenav-open')) {
	                        $elem.next().css('height', 0);
	                        $elem.parent().removeClass('sidenav-open');
	                        $elem.removeClass('active');
	                    } else {
	                        angular.forEach(document.querySelectorAll('#sidenav-menu .sidenav-open'), function (el) {
	                            el.querySelector('ul').style.height = 0;
	                            el.classList.remove('sidenav-open');
	                            el.querySelector('.active').classList.remove('active');
	                        });
	                        $submenu.css('height', $items.length * $items[0].offsetHeight + 20 + 'px');
	                        $elem.parent().addClass('sidenav-open');
	                        $elem.addClass('active');
	                    }
	                }
	            });
	        }
	    }]);
	
	    return ToggleMenu;
	}();
	
	exports.default = ToggleMenu;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(317);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _micuenta = __webpack_require__(325);
	
	var _micuenta2 = _interopRequireDefault(_micuenta);
	
	var _login = __webpack_require__(322);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _user = __webpack_require__(405);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _proboliviaAdm = __webpack_require__(356);
	
	var _proboliviaAdm2 = _interopRequireDefault(_proboliviaAdm);
	
	var _promueveAdm = __webpack_require__(384);
	
	var _promueveAdm2 = _interopRequireDefault(_promueveAdm);
	
	var _selloboliviaAdm = __webpack_require__(398);
	
	var _selloboliviaAdm2 = _interopRequireDefault(_selloboliviaAdm);
	
	var _certificacionVerificacion = __webpack_require__(313);
	
	var _certificacionVerificacion2 = _interopRequireDefault(_certificacionVerificacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Admin = angular.module('app.admin', [_dashboard2.default, _login2.default, _user2.default, _proboliviaAdm2.default, _promueveAdm2.default, _selloboliviaAdm2.default, _certificacionVerificacion2.default, _micuenta2.default]).name;
	
	exports.default = Admin;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _certificacionVerificacion = __webpack_require__(312);
	
	var _certificacionVerificacion2 = _interopRequireDefault(_certificacionVerificacion);
	
	var _certificacionVerificacion3 = __webpack_require__(585);
	
	var _certificacionVerificacion4 = _interopRequireDefault(_certificacionVerificacion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerificacionCertificacionComponent = {
	    bindings: {},
	    controller: _certificacionVerificacion2.default,
	    template: _certificacionVerificacion4.default
	};
	
	exports.default = VerificacionCertificacionComponent;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VerificacionCertificacionController = function () {
	  VerificacionCertificacionController.$inject = ["$scope", "$log", "$rootScope", "Storage", "DataService", "$location", "$sce", "baseUrl", "$window", "PDFJS", "deviceDetector"];
	  function VerificacionCertificacionController($scope, $log, $rootScope, Storage, DataService, $location, $sce, baseUrl, $window, PDFJS, deviceDetector) {
	    'ngInject';
	
	    _classCallCheck(this, VerificacionCertificacionController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.$rootScope = $rootScope;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.$sce = $sce;
	    this.baseUrl = baseUrl;
	    this.$window = $window;
	    this.PDFJS = PDFJS;
	    this.deviceDetector = deviceDetector;
	  }
	
	  _createClass(VerificacionCertificacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(this);
	      // this.$log.log(this.$state.params);
	      // this.titulo = 'Nombre de página';
	      this.urlPdf = null;
	      this.mostrarData = false;
	      this.loading = true;
	      this.codigo = this.$location.search().codigo;
	      this.hash = "";
	      this.android = false;
	      this.urlEdge = false;
	      this.showPdf = false;
	
	      // para no mostrar los sidenav en esta pantalla
	      this.auth_backup = angular.copy(this.$rootScope.auth);
	      this.$rootScope.auth = null;
	      this.$rootScope.verify = true;
	      this.$scope.$on('$destroy', function () {
	        _this.$rootScope.auth = angular.copy(_this.auth_backup);
	      });
	
	      this.cargarDatos();
	
	      // const sideNav = angular.element('#app-sidenav');
	      // // sideNav.addClass('ng-hide');
	      // this.$log.log(sideNav);
	
	      // this.isCorrecto = false;
	      // //get para identificar datos del certificado
	    }
	  }, {
	    key: 'cargarDatos',
	    value: function cargarDatos() {
	      var _this2 = this;
	
	      this.DataService.post(this.baseUrl + 'certificacion/datos?codigo=' + this.codigo).then(function (response) {
	        if (response) {
	          var direccion_total = [],
	              cod_cert = void 0;
	          var unidad_productiva = response.producto.unidad_productiva;
	          // para unir la direccion total
	          if (unidad_productiva.hist_sucursales && unidad_productiva.hist_sucursales.length) {
	            direccion_total.push(unidad_productiva.hist_sucursales["0"].zona);
	            direccion_total.push(unidad_productiva.hist_sucursales["0"].avenida_calle);
	            if (unidad_productiva.hist_sucursales["0"].numero) {
	              direccion_total.push('Nro. ' + unidad_productiva.hist_sucursales["0"].numero);
	            }
	            unidad_productiva.hist_sucursales["0"].direccion_total = direccion_total.join(' ');
	          }
	          // variable para mostrar los datos
	          _this2.$scope.data = {
	            razon_social: unidad_productiva.razon_social,
	            nombre_completo: unidad_productiva.hist_representantes.nombre_completo,
	            // documento_identidad: unidad_productiva.hist_representantes.documento_identidad,
	            // departamento: unidad_productiva.hist_sucursales["0"].departamento,
	            // municipio: unidad_productiva.hist_sucursales["0"].municipio,
	            // direccion_total: unidad_productiva.hist_sucursales["0"].direccion_total,
	            nombre_producto: response.producto.nombre_producto,
	            img64: response.producto.ver_imagen_producto
	          };
	
	          // agarra la fecha del certificado PM o del sello en el caso de que lo tenga
	          _this2.$scope.data._fecha_aprobacion = response._fecha_aprobacion;
	          _this2.$scope.data._fecha_fin = response._fecha_fin;
	          if (response && response.producto.sello_bolivia) {
	            _this2.$scope.data._fecha_aprobacion = response.producto.sello_bolivia.certificacion._fecha_aprobacion;
	            _this2.$scope.data._fecha_fin = response.producto.sello_bolivia.certificacion._fecha_fin;
	          }
	
	          //jalaremos el certificado SHB si es que ese es el caso
	          cod_cert = _this2.codigo;
	          if (response && response.producto.sello_bolivia) {
	            cod_cert = response.producto.sello_bolivia.certificacion.codigo_certificado;
	            _this2.hash = cod_cert;
	            _this2.urlEdge = _this2.baseUrl + 'certificacion/verificar/movil?codigo=' + _this2.hash;
	            _this2.canvas();
	            _this2.showPdf = true;
	          } else {
	            _this2.hash = cod_cert;
	            _this2.urlEdge = _this2.baseUrl + 'certificacion/verificar/movil?codigo=' + _this2.hash;
	            _this2.canvas();
	            _this2.showPdf = true;
	          }
	          _this2.DataService.pdfO(_this2.baseUrl + 'certificacion/verificar?codigo=' + cod_cert).then(function (pdf) {
	            _this2.mostrarData = true;
	            if (pdf) {
	              _this2.urlPdf = pdf;
	            }
	          });
	        }
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: 'descargarCertificado',
	    value: function descargarCertificado() {
	      var ruta = this.baseUrl + 'certificaciones/generar_certificado' + '?codigo=' + this.codigo;
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          var fileName = "certificado_generado.pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	        }
	      });
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'canvas',
	    value: function canvas() {
	      if (this.deviceDetector.device == "android") {
	        this.android = true;
	      }
	      var url = this.baseUrl + 'certificacion/verificar/movil?codigo=' + this.hash;
	      var loadingTask = this.PDFJS.getDocument(url);
	      loadingTask.promise.then(function (pdf) {
	        // console.log('PDF loaded');
	        var pageNumber = 1;
	        pdf.getPage(pageNumber).then(function (page) {
	          // console.log('Page loaded');
	          var scale = 1;
	          var viewport = page.getViewport(scale);
	          // Preparando las dimenciones para el canvas
	          var canvas = document.getElementById('the-canvas');
	          var context = canvas.getContext('2d');
	          canvas.height = viewport.height;
	          canvas.width = viewport.width;
	          canvas.style = "width:100%; height:100%;";
	
	          // Mostrando el pdf en el canvas
	          var renderContext = {
	            canvasContext: context,
	            viewport: viewport
	          };
	          var renderTask = page.render(renderContext);
	          renderTask.then(function () {
	            // console.log('Page rendered');
	          });
	        });
	        // }, function (reason) {
	      }, function () {
	        // Error al cargar
	        // console.log(reason);
	      });
	    }
	  }]);
	
	  return VerificacionCertificacionController;
	}();
	
	exports.default = VerificacionCertificacionController;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _certificacionVerificacion = __webpack_require__(311);
	
	var _certificacionVerificacion2 = _interopRequireDefault(_certificacionVerificacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// modulo para verificacion de certificacion PM y SHB
	var Verificacion = angular.module('app.certificacion.verificacion', []).component('certificacionVerificacion', _certificacionVerificacion2.default).config(["$stateProvider", "$urlRouterProvider", "deviceDetectorProvider", function ($stateProvider, $urlRouterProvider, deviceDetectorProvider) {
	  deviceDetectorProvider.addCustom("My_Custom_Detector", { or: ["\\bChrome\\b", "\\bFirefox\\b", "\\bSafari\\b"] });
	  $stateProvider.state('certificacionVerificacion', {
	    url: '/certificacion/verificar',
	    component: 'certificacionVerificacion'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Verificacion;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// import template from './dashboard.html';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(315);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardComponent = {
	    template: '',
	    controller: _dashboard2.default
	};exports.default = DashboardComponent;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dashboardModalController = __webpack_require__(316);
	
	var _dashboardModalController2 = _interopRequireDefault(_dashboardModalController);
	
	var _dashboardModal = __webpack_require__(586);
	
	var _dashboardModal2 = _interopRequireDefault(_dashboardModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardController = function () {
	    DashboardController.$inject = ["apiUrl", "Message", "Modal", "$log", "Auth"];
	    function DashboardController(apiUrl, Message, Modal, $log, Auth) {
	        'ngInject';
	
	        _classCallCheck(this, DashboardController);
	
	        this.dt = new Date();
	        this.Message = Message;
	        this.Modal = Modal;
	        this.apiUrl = apiUrl;
	        this.$log = $log;
	        this.Auth = Auth;
	    }
	
	    _createClass(DashboardController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (!this.Auth.isAuthenticated()) {
	                this.Auth.logout();
	            }
	            this.items = [{ value: 1, text: 'Item uno' }, { value: 2, text: 'Item dos' }, { value: 3, text: 'Item tres' }, { value: 4, text: 'Item cuatro' }, { value: 5, text: 'Item cinco' }];
	
	            this.opened = false;
	
	            this.dateOptions = {
	                maxDate: new Date(2020, 5, 22),
	                minDate: new Date(),
	                startingDay: 1,
	                showWeeks: false
	            };
	
	            this.tabs = [{ title: 'Título dinámico 1', content: 'Contenido dinámico 1' }, { title: 'Título dinámico 2', content: 'Contenido dinámico 2', disabled: true }];
	
	            this.mytime = new Date();
	        }
	
	        // Abrir datepicker
	
	    }, {
	        key: 'open',
	        value: function open() {
	            this.opened = true;
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal() {
	            var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	            this.Modal.show({
	                template: _dashboardModal2.default,
	                controller: _dashboardModalController2.default,
	                data: this.items,
	                size: size
	            });
	        }
	    }, {
	        key: 'openMessage',
	        value: function openMessage(type) {
	            this.Message[type]();
	        }
	    }, {
	        key: 'openAlert',
	        value: function openAlert() {
	            this.Modal.alert('¡Hola mundo!');
	        }
	    }, {
	        key: 'openConfirm',
	        value: function openConfirm() {
	            var _this = this;
	
	            this.Modal.confirm('¿Está seguro/a de continuar?', function () {
	                _this.Modal.alert("Hola!!!");
	            });
	        }
	    }]);
	
	    return DashboardController;
	}();
	
	exports.default = DashboardController;

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardModalController = function () {
	    DashboardModalController.$inject = ["$uibModalInstance", "data"];
	    function DashboardModalController($uibModalInstance, data) {
	        'ngInject';
	
	        _classCallCheck(this, DashboardModalController);
	
	        this.items = data;
	        this.$uibModalInstance = $uibModalInstance;
	    }
	
	    _createClass(DashboardModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.selected = {
	                item: this.items[0]
	            };
	        }
	    }, {
	        key: 'ok',
	        value: function ok() {
	            this.$uibModalInstance.close(this.selected.item);
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }]);
	
	    return DashboardModalController;
	}();
	
	exports.default = DashboardModalController;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _dashboard = __webpack_require__(314);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dashboard = angular.module('app.admin.dashboard', []).component('appDashboard', _dashboard2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('dashboard', {
	        url: '/',
	        component: 'appDashboard'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Dashboard;

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = function () {
	    AuthService.$inject = ["$http", "DataService", "$auth", "$location", "$rootScope", "$uibModalStack", "Storage", "SidenavFactory", "BreadcrumbFactory", "Util", "timeSessionExpired", "Message", "$log", "baseUrl"];
	    function AuthService($http, DataService, $auth, $location, $rootScope, $uibModalStack, Storage, SidenavFactory, BreadcrumbFactory, Util, timeSessionExpired, Message, $log, baseUrl) {
	        "ngInject";
	
	        _classCallCheck(this, AuthService);
	
	        this.$http = $http;
	        this.DataService = DataService;
	        this.$auth = $auth;
	        this.$rootScope = $rootScope;
	        this.$uibModalStack = $uibModalStack;
	        this.$location = $location;
	        this.Storage = Storage;
	        this.Util = Util;
	        this.Message = Message;
	        this.$log = $log;
	        this.SidenavFactory = SidenavFactory;
	        this.BreadcrumbFactory = BreadcrumbFactory;
	        this.timeSessionExpired = timeSessionExpired;
	        this.baseUrl = baseUrl;
	    }
	
	    _createClass(AuthService, [{
	        key: 'signin',
	        value: function signin(data) {
	            var _this = this;
	
	            this.$auth.login(data).then(function (response) {
	
	                var user = response.data.user;
	                var menu = response.data.menu;
	                var rol = user.id_rol;
	                var pathRedirect = response.data.menuEntrar;
	                user.pathLogin = data.pathLogin || 'login';
	                user.nit = data.nit;
	                _this.$rootScope.auth = true;
	                // Set user
	                user.pathInicio = pathRedirect;
	                _this.SidenavFactory.setUser(user);
	                _this.Storage.setUser(user);
	
	                if (!user.nit) {
	                    menu = menu.filter(function (it) {
	                        if (it.id_menu != 10) return it;
	                    });
	                }
	                if (!user.nit && rol === 4) {
	                    _this.Storage.set('upSinNit', true);
	                    menu = menu.filter(function (it) {
	                        if (it.id_menu !== 41 && it.id_menu !== 44) return it;
	                    });
	                }
	
	                // Set Menu
	                _this.SidenavFactory.setMenu(menu);
	                _this.Storage.set('menu', _this.SidenavFactory.getMenu());
	
	                // Set rol
	                _this.SidenavFactory.setRol(rol);
	                _this.Storage.set('rol', _this.SidenavFactory.getRol());
	
	                // Validaciones para el usuario EMPRESARIO
	                if (user.estado == 'ACTIVO') {
	                    pathRedirect = response.data.menuEntrar ? response.data.menuEntrar : 'matricula';
	                    data.menu = true;
	                    data.sidenav = true;
	                }
	
	                if (user.estado == 'PENDIENTE') {
	                    if (user.id_rol === 4) {
	                        pathRedirect = 'inscripcion';
	                    } else {
	                        pathRedirect = 'inscripcion';
	                    }
	                }
	
	                // Set Visible
	                _this.SidenavFactory.setVisible(data.menu === undefined ? true : data.menu);
	                _this.Storage.set('visible', _this.SidenavFactory.getVisible());
	
	                // Set Sidenav
	                _this.SidenavFactory.setSidenav(data.sidenav === undefined ? true : data.sidenav);
	                _this.Storage.set('sidenav', _this.SidenavFactory.getSidenav());
	
	                var path = pathRedirect || _this.Storage.get('path');
	
	                if (path) {
	                    var route = path.replace('/', '');
	
	                    // Set breadcrumb
	                    var page = _this.Util.getMenuOption(_this.Storage.get('menu'), route);
	                    _this.BreadcrumbFactory.setParent(page[0]);
	                    _this.BreadcrumbFactory.setCurrent(page[1]);
	                }
	
	                _this.timerSession();
	
	                // Redirect to dashboard
	                _this.$location.path(path && path.indexOf('login') == -1 ? path : data.path || '/');
	            }).catch(function (error) {
	                if (error.data && error.data.mensaje) {
	                    _this.Message.error(error.data.mensaje);
	                } else if (error && error.status === -1) {
	                    _this.Message.error('No se pudo establecer conexión con el servidor.');
	                } else {
	                    _this.Message.error('Los datos ingresados son incorrectos o su cuenta no está registrada.');
	                }
	            });
	        }
	    }, {
	        key: 'timerSession',
	        value: function timerSession() {
	            // Definiendo el tiempo en el que dura una sesión sin actividad
	            angular.TIME = this.timeSessionExpired * 60;
	            var ctrl = this;
	            angular.sessionInterval = window.setInterval(function () {
	                angular.TIME--;
	                if (angular.TIME <= 0) {
	                    angular.expired = true;
	                    ctrl.logout();
	                }
	            }, 1000);
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            var _this2 = this;
	
	            var pathLogin = 'login';
	            if (this.Storage.existUser() && this.Storage.getUser() && this.Storage.getUser().pathLogin) {
	                pathLogin = this.Storage.getUser().pathLogin;
	            }
	
	            this.DataService.get(this.baseUrl + 'api_v3/logout').then(function () {
	                return _this2.$auth.logout();
	            }).then(function () {
	                if (angular.sessionInterval) {
	                    window.clearInterval(angular.sessionInterval);
	                    angular.sessionInterval = null;
	                }
	                setTimeout(function () {
	                    _this2.$uibModalStack.dismissAll('Cerrando sesión');
	                }, 1000);
	                _this2.Storage.removeUser();
	                _this2.Storage.remove('menu');
	                _this2.Storage.remove('visible');
	                _this2.Storage.remove('rol');
	                _this2.Storage.remove('sidenav');
	                _this2.Storage.remove('token');
	                _this2.Storage.remove('path');
	                // Eliminando información de Probolivia
	                _this2.Storage.remove('formulario');
	                _this2.Storage.remove('matricula');
	                _this2.Storage.remove('matriculas');
	                _this2.Storage.remove('datos_matricula');
	                _this2.Storage.remove('certificacion');
	                _this2.Storage.remove('unidad_productiva');
	                // Eliminando información de Promueve
	                _this2.Storage.remove('matriculaPromueve');
	                _this2.Storage.remove('matriculasPromueve');
	                _this2.Storage.remove('producto');
	                _this2.Storage.removeAll();
	                _this2.SidenavFactory.setUser({});
	                _this2.SidenavFactory.setMenu([]);
	                _this2.SidenavFactory.setVisible(false);
	                if (angular.expired) {
	                    _this2.Storage.set('expired', true);
	                    delete angular.expired;
	                }
	
	                _this2.$location.path(pathLogin);
	            });
	        }
	    }, {
	        key: 'isAuthenticated',
	        value: function isAuthenticated() {
	            return this.$auth.isAuthenticated();
	        }
	    }]);
	
	    return AuthService;
	}();
	
	exports.default = AuthService;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(83);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _loginAdmin = __webpack_require__(587);
	
	var _loginAdmin2 = _interopRequireDefault(_loginAdmin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginAdminComponent = {
	    bindings: {},
	    controller: _login2.default,
	    template: _loginAdmin2.default
	};
	
	exports.default = LoginAdminComponent;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(83);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(588);
	
	var _login4 = _interopRequireDefault(_login3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginComponent = {
	    bindings: {},
	    controller: _login2.default,
	    template: _login4.default
	};
	
	exports.default = LoginComponent;

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProgramaModalController = function () {
	  ProgramaModalController.$inject = ["$uibModalInstance", "data", "$log", "$scope", "DataService", "Message", "Util", "Loading", "Sidenav", "baseUrl", "$location"];
	  function ProgramaModalController($uibModalInstance, data, $log, $scope, DataService, Message, Util, Loading, Sidenav, baseUrl, $location) {
	    'ngInject';
	
	    _classCallCheck(this, ProgramaModalController);
	
	    this.data = data;
	    this.conf = data.conf;
	    this.onSave = data.onSave;
	    this.id_certificacion = data.id_certificacion;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.Sidenav = Sidenav;
	    this.baseUrl = baseUrl;
	    this.$location = $location;
	  }
	
	  _createClass(ProgramaModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$log.log("Data recibido = ", this.data);
	      this.sinPersona = true;
	      if (this.$location.path() === '/loginAdmin') {
	        this.sinPersona = false;
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'enviar',
	    value: function enviar() {
	      var _this = this;
	
	      this.$log.log("--> Enviamos los datos");
	      //    this.DataService.put(`ong/${this.data.id_ong}/enviar`)
	      var obj = {
	        usuario: this.email,
	        sinPersona: this.sinPersona
	      };
	      this.DataService.post(this.baseUrl + 'usuarios/restore', obj).then(function (response) {
	        if (response) {
	          _this.$uibModalInstance.close();
	          _this.Message.success("Se envío un correo a: " + _this.email + "");
	          //        this.Sidenav.path("login");
	          _this.$uibModalInstance.close();
	        }
	      });
	    }
	  }]);
	
	  return ProgramaModalController;
	}();
	
	exports.default = ProgramaModalController;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(320);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _loginAdmin = __webpack_require__(319);
	
	var _loginAdmin2 = _interopRequireDefault(_loginAdmin);
	
	var _auth = __webpack_require__(318);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	__webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Login = angular.module('app.login', []).service('Auth', _auth2.default).component('appAdminLogin', _login2.default).component('appAdminLoginAdmin', _loginAdmin2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('login', {
	        url: '/login',
	        component: 'appAdminLogin'
	    }).state('loginAdmin', {
	        url: '/loginAdmin',
	        component: 'appAdminLoginAdmin'
	    }).state('logout', {
	        url: '/logout',
	        controller: ["Auth", function controller(Auth) {
	            Auth.logout();
	        }]
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Login;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _micuenta = __webpack_require__(590);
	
	var _micuenta2 = _interopRequireDefault(_micuenta);
	
	var _micuenta3 = __webpack_require__(324);
	
	var _micuenta4 = _interopRequireDefault(_micuenta3);
	
	__webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardComponent = {
	    template: _micuenta2.default,
	    controller: _micuenta4.default
	};
	
	exports.default = DashboardComponent;

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MicuentaController = function () {
	  MicuentaController.$inject = ["apiUrl", "Message", "Modal", "$log", "Storage", "DataService", "Sidenav", "baseUrl"];
	  function MicuentaController(apiUrl, Message, Modal, $log, Storage, DataService, Sidenav, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, MicuentaController);
	
	    this.dt = new Date();
	    this.Message = Message;
	    this.Modal = Modal;
	    this.apiUrl = apiUrl;
	    this.$log = $log;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Sidenav = Sidenav;
	    this.baseUrl = baseUrl;
	  }
	
	  _createClass(MicuentaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.usuario = this.Storage.getUser();
	      this.isPass = true;
	      this.isCoinciden = false;
	      this.autChange = false;
	      if (angular.isUndefined(this.usuario.nit)) {
	        this.autChange = true;
	      } else {
	        this.autChange = false;
	      }
	    }
	  }, {
	    key: 'validarCampos',
	    value: function validarCampos(data) {
	      //    this.$log.log('validar campos = ', data);
	      if (angular.isDefined(data)) {
	        if (data.length < 8) {
	          //no mostramos mensaje
	          return true;
	        } else {
	          return false;
	        }
	      }
	    }
	  }, {
	    key: 'coincidenciaCampos',
	    value: function coincidenciaCampos() {
	      if (this.validarCampos(this.contrasenaNueva)) {
	        return;
	      }
	      if (this.validarCampos(this.contrasenaConfirmacion)) {
	        return;
	      }
	      if (this.contrasenaNueva === this.contrasenaConfirmacion) {
	        this.isCoinciden = true;
	      } else {
	        this.isCoinciden = false;
	      }
	    }
	  }, {
	    key: 'cambiarContrasena',
	    value: function cambiarContrasena() {
	      var _this = this;
	
	      var obj = {
	        "contrasena": this.contrasena,
	        "contrasena_nueva": this.contrasenaNueva
	      };
	      this.DataService.put('mypass', obj).then(function (response) {
	        if (response) {
	          // this.$log.log('Respuesta ---- ', response);
	          // this.Sidenav.path("bandeja");
	          _this.Message.success('Su contraseña fue cambiada correctamente.');
	        }
	      });
	    }
	  }, {
	    key: 'cambiarCorreo',
	    value: function cambiarCorreo() {
	      var _this2 = this;
	
	      var obj = {
	        "correo_nuevo": this.nuevoCorreo
	      };
	      this.DataService.put(this.baseUrl + 'api_v3/cambiar_correo', obj).then(function (response) {
	        if (response) {
	          _this2.Message.success('Su correo fue cambiado correctamente.');
	
	          // ACTUALIZA LA INFORMACION PARA EL FRONT
	          _this2.usuario.email = _this2.nuevoCorreo;
	          var user = _this2.Storage.getUser();
	          user.email = _this2.nuevoCorreo;
	          _this2.Storage.setUser(user);
	          _this2.nuevoCorreo = '';
	        }
	      });
	    }
	  }, {
	    key: 'openMessage',
	    value: function openMessage(type) {
	      this.Message[type]();
	    }
	  }, {
	    key: 'openAlert',
	    value: function openAlert() {
	      this.Modal.alert('¡Hola mundo!');
	    }
	  }, {
	    key: 'openConfirm',
	    value: function openConfirm() {
	      var _this3 = this;
	
	      this.Modal.confirm('¿Está seguro/a de continuar?', function () {
	        _this3.Modal.alert("Hola!!!");
	      });
	    }
	  }]);
	
	  return MicuentaController;
	}();
	
	exports.default = MicuentaController;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _micuenta = __webpack_require__(323);
	
	var _micuenta2 = _interopRequireDefault(_micuenta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Micuenta = angular.module('app.miecuenta', []).component('appMicuenta', _micuenta2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('micuenta', {
	        url: '/micuenta',
	        component: 'appMicuenta'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Micuenta;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bancoUnion = __webpack_require__(327);
	
	var _bancoUnion2 = _interopRequireDefault(_bancoUnion);
	
	var _bancoUnion3 = __webpack_require__(591);
	
	var _bancoUnion4 = _interopRequireDefault(_bancoUnion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BancoUnionComponent = {
	    bindings: {},
	    controller: _bancoUnion2.default,
	    template: _bancoUnion4.default
	};
	
	exports.default = BancoUnionComponent;

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	// import modalControllerC from './registro.artesano.modal.controller.js';
	// import modalTemplateC from './registro.artesano.modal.html';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BancoUnionController = function () {
	  BancoUnionController.$inject = ["$log", "Modal", "Storage", "$http", "Sidenav", "Util", "DataService", "Message", "rdxUrl"];
	  function BancoUnionController($log, Modal, Storage, $http, Sidenav, Util, DataService, Message, rdxUrl) {
	    'ngInject';
	
	    _classCallCheck(this, BancoUnionController);
	
	    this.$log = $log;
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.$http = $http;
	    this.Sidenav = Sidenav;
	    this.Util = Util;
	    this.Message = Message;
	    this.rdxUrl = rdxUrl;
	    this.data = {}; //datos de formluario
	  }
	
	  _createClass(BancoUnionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      // this.$log.log(this);
	      this.loadConfForm();
	    }
	  }, {
	    key: 'loadConfForm',
	    value: function loadConfForm() {
	      this.conf = {
	        nro_cuenta: {
	          visible: true,
	          // label: 'Nro. de cuenta',
	          label: 'N° de Usuario o Tarjeta ',
	          requerido: true
	        },
	        contrasena: {
	          visible: true,
	          // label: 'Contraseña',
	          label: 'Clave de Acceso',
	          requerido: true
	        },
	        rdx: {
	          visible: true,
	          label: 'Código RDX generado',
	          requerido: true,
	          disabled: true
	        }
	      };
	    }
	
	    // atras() {
	
	    // }
	
	  }, {
	    key: 'enviar',
	    value: function enviar(form) {
	      var _this = this;
	
	      // console.log(form);
	      if (form.$valid) {
	        this.Modal.confirm('¿Esta seguro de enviar los datos?', function () {
	          var dataSend = {
	            usuario: _this.data.nro_cuenta,
	            clave: _this.data.contrasena,
	            rdx: _this.Util.generarRdxBancoUnion(_this.data.nro_cuenta, _this.data.contrasena)
	          };
	          // this.$http.post(this.rdxUrl, dataSend)
	          _this.DataService.post('banco_union/pagos', dataSend).then(function (response) {
	            if (response) {
	              this.Message.success();
	            }
	          });
	        });
	      } else {
	        this.Message.warning('Debe corregir los errores de los campos marcados con rojo.');
	      }
	    }
	  }]);
	
	  return BancoUnionController;
	}();
	
	exports.default = BancoUnionController;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bancoUnion = __webpack_require__(326);
	
	var _bancoUnion2 = _interopRequireDefault(_bancoUnion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BancoUnion = angular.module('app.banco-union', []).component('bancoUnion', _bancoUnion2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('actualizarBancoUnion', {
	    url: '/actualizarBancoUnion',
	    component: 'bancoUnion'
	  }).state('actualizarBancoUnionPromueve', {
	    url: '/actualizarBancoUnionPromueve',
	    component: 'bancoUnion'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = BancoUnion;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _confirmar = __webpack_require__(330);
	
	var _confirmar2 = _interopRequireDefault(_confirmar);
	
	var _confirmar3 = __webpack_require__(592);
	
	var _confirmar4 = _interopRequireDefault(_confirmar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmarCuentaComponent = {
	    bindings: {},
	    controller: _confirmar2.default,
	    template: _confirmar4.default
	};
	
	exports.default = ConfirmarCuentaComponent;

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	'use strict';
	
	// import modalControllerC from './registro.artesano.modal.controller.js';
	// import modalTemplateC from './registro.artesano.modal.html';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfirmarController = function () {
	  ConfirmarController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Auth", "$location", "Util", "Message", "authUrl", "$http", "Sidenav", "baseUrl"];
	  function ConfirmarController(NgTableParams, $log, Modal, Storage, DataService, Auth, $location, Util, Message, authUrl, $http, Sidenav, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, ConfirmarController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Auth = Auth;
	    this.$location = $location;
	    this.Util = Util;
	    this.Message = Message;
	    this.$http = $http;
	    this.baseUrl = baseUrl;
	    this.Sidenav = Sidenav;
	  }
	
	  _createClass(ConfirmarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      this.isContrasenaIgual = false;
	      this.isContrasenaMinor = true;
	
	      //has-value has-success has-warning
	      this.cssInput = 'has-value';
	      this.cssInput1 = 'has-value';
	      this.cantidadCaracteres = 8;
	
	      //datos de registro por get
	      this.codigo = this.$location.search().codigo;
	      this.nombreUsuario = this.$location.search().usuario;
	    }
	  }, {
	    key: 'cleanEstiloGenero',
	    value: function cleanEstiloGenero() {
	      this.isGeneroOk = true;
	    }
	  }, {
	    key: 'compararContrasenas',
	    value: function compararContrasenas() {
	      //validaciones
	      if (angular.isUndefined(this.usuario.contrasena) || this.usuario.contrasena === '') {
	        //        || (angular.isUndefined(this.usuario.contrasenaConfirmacion)) || (this.usuario.contrasenaConfirmacion === '')
	        this.isContrasenaIgual = false;
	        this.cssInput = 'has-value';
	        this.cssInput1 = 'has-value';
	        return;
	      }
	
	      if (angular.isDefined(this.usuario.contrasena)) {
	
	        if (this.usuario.contrasena.length < this.cantidadCaracteres) {
	          this.cssInput = 'has-warning';
	          return;
	        }
	      }
	
	      if (angular.isDefined(this.usuario.contrasenaConfirmacion)) {
	        if (this.usuario.contrasenaConfirmacion.length < this.cantidadCaracteres) {
	          this.cssInput1 = 'has-warning';
	          return;
	        }
	      }
	      //validaion de contrasenas
	      if (this.usuario.contrasena === this.usuario.contrasenaConfirmacion) {
	        this.isContrasenaIgual = true;
	        this.cssInput = 'has-success';
	        this.cssInput1 = 'has-success';
	      } else {
	        this.isContrasenaIgual = false;
	        this.cssInput = 'has-value';
	        this.cssInput1 = 'has-value';
	      }
	    }
	  }, {
	    key: 'actualizarContrasena',
	    value: function actualizarContrasena() {
	      var _this = this;
	
	      this.$log.log('actualizamos contrasena:');
	      var obj = {
	        "usuario": this.nombreUsuario,
	        "codigo": this.codigo,
	        "contrasena": this.usuario.contrasena
	      };
	      this.$log.log('Objeto para actualizar:', obj);
	      this.DataService.post(this.baseUrl + 'usuarios/activar', obj).then(function (response) {
	        if (response) {
	          _this.$log.log('respuesta del post:', response);
	
	          //        this.Sidenav.path("login");
	          //logueamos al usuario
	
	          _this.usuariologin = {};
	          _this.usuariologin.usuario = _this.nombreUsuario;
	          //        this.usuariologin.usuario = response.email;
	          _this.usuariologin.email = response.email;
	          _this.usuariologin.tipo = response.esOperador ? 'OPERADOR' : null;
	          _this.usuariologin.path = 'dashboard', _this.usuariologin.pathLogin = response.esOperador ? 'loginAdmin' : '';
	          _this.usuariologin.menu = false, _this.usuariologin.sidenav = false, _this.usuariologin.contrasena = _this.usuario.contrasena;
	
	          _this.$log.log('enviaando a autenticacion: ', _this.usuariologin);
	
	          _this.Auth.signin(_this.usuariologin);
	        }
	      });
	    }
	  }]);
	
	  return ConfirmarController;
	}();
	
	exports.default = ConfirmarController;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _confirmar = __webpack_require__(329);
	
	var _confirmar2 = _interopRequireDefault(_confirmar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmarCue = angular.module('app.confirmar', []).component('confirmarCuenta', _confirmar2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('confirmarCuenta', {
	    url: '/confirmarCuenta',
	    component: 'confirmarCuenta'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = ConfirmarCue;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _correcciones = __webpack_require__(333);
	
	var _correcciones2 = _interopRequireDefault(_correcciones);
	
	var _correcciones3 = __webpack_require__(593);
	
	var _correcciones4 = _interopRequireDefault(_correcciones3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CorreccionesComponent = {
	    bindings: {},
	    controller: _correcciones2.default,
	    template: _correcciones4.default
	};
	
	exports.default = CorreccionesComponent;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict';
	//import modalController from './parametros.modal.controller.js';
	//import modalTemplate from './parametros.modal.html';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CorreccionesController = function () {
	  CorreccionesController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Util", "Message", "$state"];
	  function CorreccionesController(NgTableParams, $log, Modal, Storage, DataService, Util, Message, $state) {
	    'ngInject';
	
	    _classCallCheck(this, CorreccionesController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Message = Message;
	    this.$state = $state;
	  }
	
	  _createClass(CorreccionesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	
	      this.titulo = 'Nombre de página';
	      this.tim = {};
	      this.cargarTabla();
	      //Borrando Storage en: 'On init'
	
	      this.Storage.remove('certificacion');
	      this.Storage.remove('unidad_productiva');
	      this.Storage.remove('sw_detalle_certificacion');
	    }
	  }, {
	    key: 'changeFilter',
	    value: function changeFilter() {
	      var _this = this;
	
	      if (this.tableParams) {
	        this.Util.funcDelay(this.tim, 1000, function () {
	          _this.tableParams.reload();
	        });
	      }
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      this.tableParams = new this.NgTableParams({ count: 10 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this2.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this2.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	          query.ambito = "PROBOLIVIA";
	          query.filter = _this2.filtro_bandeja || '';
	          return _this2.DataService.list('certificaciones', query).then(function (response) {
	            if (response) {
	              _this2.$log.log('RESPUESTA CERTIFICACIONES ===== ', response);
	              params.total(response.count);
	              var items = _this2.filterItems(response.rows);
	              _this2.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'enviarFirma',
	    value: function enviarFirma() {
	      for (var i = 0; i < this.listado.length; i++) {
	        var obj = this.listado[i];
	        if (obj.isRowSelected) {
	          this.$log.log('Seleccionado = ', obj.organizacion);
	        }
	      }
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(item) {
	      item.isRowSelected = !item.isRowSelected;
	    }
	  }, {
	    key: 'regenerarCertificado',
	    value: function regenerarCertificado(item) {
	      var _this3 = this;
	
	      this.Modal.confirm('¿Desea regenerar este certificado?', function () {
	        var parametros = {
	          regenerar: true,
	          devolver: true
	        };
	        var ruta = 'certificaciones/generar_certificado/' + item.certificacion.id_certificacion;
	        var nombre = "certificado";
	        _this3.DataService.pdfOfile(ruta, parametros).then(function (response) {
	          if (response) {
	            nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	            var fileName = "" + nombre + ".pdf";
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.href = response;
	            a.download = fileName;
	            a.click();
	            _this3.Message.success('Su documento está siendo descargado.');
	          }
	        });
	      });
	    }
	  }, {
	    key: 'regenerarReporte',
	    value: function regenerarReporte(item) {
	      var _this4 = this;
	
	      this.Modal.confirm('¿Desea regenerar este reporte?', function () {
	        var parametros = {
	          regenerar: true,
	          devolver: true
	        };
	        var ruta = 'certificaciones/' + item.certificacion.id_certificacion + '/reporte';
	        var nombre = "reporte";
	        _this4.DataService.pdfOfile(ruta, parametros).then(function (response) {
	          if (response) {
	            nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	            var fileName = "" + nombre + ".pdf";
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.href = response;
	            a.download = fileName;
	            a.click();
	            _this4.Message.success('Su documento está siendo descargado.');
	          }
	        });
	      });
	    }
	  }, {
	    key: 'anularEliminar',
	    value: function anularEliminar(item) {
	      var _this5 = this;
	
	      this.$log.log('Anular = ', item);
	
	      this.Modal.confirm('Al eliminar este registro no podrá recuperar la información asociada. ¿Está seguro/a de continuar?', function () {
	        _this5.DataService.post('certificaciones/' + item.certificacion.id_certificacion + '/anular', {}).then(function (response) {
	          if (response) {
	            _this5.Message.success('Se procesó la acción correctamente.');
	            _this5.cargarTabla();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'descargarPdf',
	    value: function descargarPdf(ruta, nombre) {
	      var _this6 = this;
	
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //        let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "" + nombre + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	          _this6.Message.success('Su documento esta siendo descargado.');
	        }
	      });
	    }
	  }, {
	    key: 'verPdfTabla',
	    value: function verPdfTabla(certificacion) {
	      certificacion;
	      //    var ruta = `certificaciones/` + certificacion.certificacion.id_certificacion + '/reporte';
	      //    if (certificacion.certificacion.estado == 'APROBADO') {
	      //      ruta = `certificaciones/mostrar_reporte/` + certificacion.certificacion.id_certificacion
	      //    }
	      //
	      //    if (this.esEdge()) {
	      //      this.descargarPdf(ruta, 'formulario_generado');
	      //    } else {
	      //      this.DataService.pdfO(ruta, {})
	      //      .then((response) => {
	      //        if (response) {
	      //          var obj = {
	      //            "urlPdf": response
	      //          };
	      //          this.Modal.show({
	      //            template: modalTemplate,
	      //            controller: modalController,
	      //            data: obj,
	      //            size: 'extra-large'
	      //          });
	      //        }
	      //      });
	      //    }
	    }
	  }, {
	    key: 'veCertificadoTabla',
	    value: function veCertificadoTabla(certificacion) {
	      certificacion;
	      //    var ruta = `certificaciones/generar_certificado/` + certificacion.certificacion.id_certificacion;
	      //    if (certificacion.certificacion.estado == 'APROBADO') {
	      //      ruta = `certificaciones/mostrar_certificado/` + certificacion.certificacion.id_certificacion;
	      //    }
	      //    if (this.esEdge()) {
	      //      this.descargarPdf(ruta, 'certificado_generado');
	      //    } else {
	      //      this.DataService.pdfO(ruta, {})
	      //      .then((response) => {
	      //        if (response) {
	      //          var obj = {
	      //            "urlPdf": response
	      //          };
	      //          this.Modal.show({
	      //            template: modalTemplate,
	      //            controller: modalController,
	      //            data: obj,
	      //            size: 'extra-large'
	      //          });
	      //        }
	      //      });
	      //    }
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'procesar',
	    value: function procesar(nombre) {
	      return nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace('DECLARACIÓN JURADA PARA LA ', '');
	    }
	  }, {
	    key: 'getUsuarioReg',
	    value: function getUsuarioReg(item) {
	
	      var usuarioReg = '';
	      if (item.unidad_productiva.nit === null || angular.isUndefined(item.unidad_productiva.nit)) {
	        usuarioReg = item.unidad_productiva.usuario.usuarios_roles[0].fid_rol === 4 ? '' + item.unidad_productiva.razon_social : item.unidad_productiva.usuario.email;
	      } else {
	        usuarioReg = item.unidad_productiva.usuario.usuarios_roles[0].fid_rol === 4 ? item.unidad_productiva.nit + ' - ' + item.unidad_productiva.razon_social : item.unidad_productiva.usuario.email;
	      }
	      return usuarioReg;
	    }
	  }]);
	
	  return CorreccionesController;
	}();
	
	exports.default = CorreccionesController;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _correcciones = __webpack_require__(332);
	
	var _correcciones2 = _interopRequireDefault(_correcciones);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Correcciones = angular.module('app.correcciones', []).component('correcciones', _correcciones2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('correcciones', {
	    url: '/correcciones',
	    component: 'correcciones'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Correcciones;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ddjj = __webpack_require__(336);
	
	var _ddjj2 = _interopRequireDefault(_ddjj);
	
	var _ddjj3 = __webpack_require__(594);
	
	var _ddjj4 = _interopRequireDefault(_ddjj3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DdjjComponent = {
	    bindings: {},
	    controller: _ddjj2.default,
	    template: _ddjj4.default
	};
	
	exports.default = DdjjComponent;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ddjjdetalleModalController = __webpack_require__(13);
	
	var _ddjjdetalleModalController2 = _interopRequireDefault(_ddjjdetalleModalController);
	
	var _ddjjdetalleModal = __webpack_require__(14);
	
	var _ddjjdetalleModal2 = _interopRequireDefault(_ddjjdetalleModal);
	
	var _historialModalController = __webpack_require__(84);
	
	var _historialModalController2 = _interopRequireDefault(_historialModalController);
	
	var _historialModal = __webpack_require__(93);
	
	var _historialModal2 = _interopRequireDefault(_historialModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjController = function () {
	  DdjjController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "$location", "Util", "$window", "Message"];
	  function DdjjController(NgTableParams, $log, Modal, Storage, DataService, $location, Util, $window, Message) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.Util = Util;
	    this.$window = $window;
	    this.Message = Message;
	  }
	
	  _createClass(DdjjController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      this.tim = {};
	      this.cargarTabla();
	      //Borrando Storage en: 'On init'
	
	      this.Storage.remove('certificacion');
	      this.Storage.remove('unidad_productiva');
	      this.Storage.remove('sw_detalle_certificacion');
	    }
	  }, {
	    key: 'changeFilter',
	    value: function changeFilter() {
	      var _this = this;
	
	      if (this.tableParams) {
	        this.Util.funcDelay(this.tim, 1000, function () {
	          _this.tableParams.reload();
	        });
	      }
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      this.tableParams = new this.NgTableParams({ count: 10 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this2.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this2.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	          query.ambito = "PROBOLIVIA";
	          query.filter = _this2.filtro_bandeja || '';
	          return _this2.DataService.list('certificaciones', query).then(function (response) {
	            if (response) {
	              _this2.$log.log('RESPUESTA CERTIFICACIONES ===== ', response);
	              params.total(response.count);
	              var items = _this2.filterItems(response.rows);
	              _this2.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'enviarFirma',
	    value: function enviarFirma() {
	      for (var i = 0; i < this.listado.length; i++) {
	        var obj = this.listado[i];
	        if (obj.isRowSelected) {
	          this.$log.log('Seleccionado = ', obj.organizacion);
	        }
	      }
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(item) {
	      item.isRowSelected = !item.isRowSelected;
	    }
	  }, {
	    key: 'irDetalle',
	    value: function irDetalle(item) {
	      var _this3 = this;
	
	      this.$log.log('RESPUESTA CERTIFICACIONES = ', item);
	      this.DataService.get('certificaciones/' + item.certificacion.id_certificacion).then(function (response) {
	        _this3.$location.path('declaracionDetalle');
	        response.certificacion.monto_sugerido = response.pago;
	        _this3.Storage.set('certificacion', response.certificacion);
	        _this3.Storage.set('unidad_productiva', response.unidad_productiva);
	        _this3.Storage.set('sw_detalle_certificacion', true);
	      });
	    }
	
	    //filtrado en grid
	
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'descargarPdf',
	    value: function descargarPdf(ruta, nombre) {
	      var _this4 = this;
	
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //        let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "" + nombre + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	          _this4.Message.success('Su documento esta siendo descargado.');
	        }
	      });
	    }
	  }, {
	    key: 'verPdfTabla',
	    value: function verPdfTabla(certificacion) {
	      var _this5 = this;
	
	      var ruta = 'certificaciones/' + certificacion.certificacion.id_certificacion + '/reporte';
	      if (certificacion.certificacion.estado == 'APROBADO') {
	        ruta = 'certificaciones/mostrar_reporte/' + certificacion.certificacion.id_certificacion;
	      }
	
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'formulario_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this5.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'veCertificadoTabla',
	    value: function veCertificadoTabla(certificacion) {
	      var _this6 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + certificacion.certificacion.id_certificacion;
	      if (certificacion.certificacion.estado == 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + certificacion.certificacion.id_certificacion;
	      }
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'certificado_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this6.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'verHistorial',
	    value: function verHistorial(item) {
	      this.Modal.show({
	        template: _historialModal2.default,
	        controller: _historialModalController2.default,
	        data: {
	          id_certificacion: item.certificacion.id_certificacion,
	          representante: item.unidad_productiva.persona_representante.nombre_completo
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'procesar',
	    value: function procesar(nombre) {
	      return nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace('DECLARACIÓN JURADA PARA LA ', '');
	    }
	  }, {
	    key: 'getUsuarioReg',
	    value: function getUsuarioReg(item) {
	      var usuarioReg = '';
	      if (item.unidad_productiva.nit === null || angular.isUndefined(item.unidad_productiva.nit)) {
	        usuarioReg = item.unidad_productiva.usuario.usuarios_roles[0].fid_rol === 4 ? '' + item.unidad_productiva.razon_social : item.unidad_productiva.usuario.email;
	      } else {
	        usuarioReg = item.unidad_productiva.usuario.usuarios_roles[0].fid_rol === 4 ? item.unidad_productiva.nit + ' - ' + item.unidad_productiva.razon_social : item.unidad_productiva.usuario.email;
	      }
	
	      return usuarioReg;
	    }
	  }]);
	
	  return DdjjController;
	}();
	
	exports.default = DdjjController;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ddjj = __webpack_require__(335);
	
	var _ddjj2 = _interopRequireDefault(_ddjj);
	
	var _ddjjdetalle = __webpack_require__(340);
	
	var _ddjjdetalle2 = _interopRequireDefault(_ddjjdetalle);
	
	var _ddjjacreditar = __webpack_require__(338);
	
	var _ddjjacreditar2 = _interopRequireDefault(_ddjjacreditar);
	
	__webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ddjj = angular.module('app.ddjj', []).component('appDdjjcom', _ddjj2.default).component('appDdjjdetallecom', _ddjjdetalle2.default).component('appDdjjacreditarcom', _ddjjacreditar2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('ddjj', {
	        url: '/declaracionesJuradas',
	        component: 'appDdjjcom'
	    }).state('ddjjcompo', {
	        url: '/declaracionDetalle',
	        component: 'appDdjjdetallecom'
	    }).state('ddjjcompoa', {
	        url: '/declaracionAcreditar',
	        component: 'appDdjjacreditarcom'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Ddjj;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ddjjacreditar = __webpack_require__(339);
	
	var _ddjjacreditar2 = _interopRequireDefault(_ddjjacreditar);
	
	var _ddjjacreditar3 = __webpack_require__(595);
	
	var _ddjjacreditar4 = _interopRequireDefault(_ddjjacreditar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DdjjacreditarComponent = {
	    bindings: {},
	    controller: _ddjjacreditar2.default,
	    template: _ddjjacreditar4.default
	};
	
	exports.default = DdjjacreditarComponent;

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjacreditarController = function () {
	  DdjjacreditarController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Sidenav", "$sce", "Util", "Message", "$window", "Loading", "$state"];
	  function DdjjacreditarController(NgTableParams, $log, Modal, Storage, DataService, Sidenav, $sce, Util, Message, $window, Loading, $state) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjacreditarController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Sidenav = Sidenav;
	    this.$sce = $sce;
	    this.Util = Util;
	    this.Message = Message;
	    this.$window = $window;
	    this.Loading = Loading;
	    this.$state = $state;
	  }
	
	  _createClass(DdjjacreditarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.Loading.show('Cargando', true);
	      this.$log.log(this);
	      this.titulo = 'Nombre de página';
	      this.unidad_productiva = this.Storage.get('unidad_productiva');
	      //---------------
	      this.DataService.get('certificaciones/' + this.Storage.get('certificacion').id_certificacion).then(function (response) {
	        if (response) {
	          _this.certificacion = response.certificacion;
	          _this.datos_factura = response.datos_factura;
	          _this.datos_factura.fecha_factura = new Date(_this.datos_factura.fecha_factura);
	          if (angular.isDefined(response.pago)) {
	            _this.monto = response.pago;
	          } else {
	            _this.monto = _this.certificacion.pagos[0].monto;
	          }
	          //----------------
	          _this.usuario_ddjj_con_nit = _this.unidad_productiva.usuario.nit != null;
	          if (_this.certificacion.estado === 'APROBADO') {
	            _this.cargarPdfCertificado(_this.certificacion.id_certificacion);
	          }
	          _this.rubro = _this.Storage.get('rubro');
	          _this.deposito = {};
	          _this.initConf();
	          _this.depositoLoad();
	        }
	      });
	    }
	  }, {
	    key: 'cargarPdfCertificado',
	    value: function cargarPdfCertificado(idCertificacion) {
	      var _this2 = this;
	
	      this.$log.log('---id certificaicon pdf = ' + idCertificacion);
	
	      var ruta = 'certificaciones/generar_certificado/' + idCertificacion;
	      if (this.certificacion.estado === 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + this.certificacion.id_certificacion;
	      }
	      this.$log.log('Url de descarga = ', ruta);
	      this.DataService.pdfO(ruta, {}).then(function (response) {
	        _this2.$log.log('Documento XXX = ', response);
	        if (response) {
	          _this2.$log.log('Documento = ', response);
	          _this2.urlPdf = response;
	          _this2.Message.success("El certificado se generó correctamente.");
	        }
	      });
	      if (this.esEdge()) {
	        this.descargarCertificado();
	      }
	    }
	  }, {
	    key: 'descargarCertificado',
	    value: function descargarCertificado() {
	      var _this3 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + this.certificacion.id_certificacion;
	      if (this.certificacion.estado === 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + this.certificacion.id_certificacion;
	      }
	      this.$log.log('Url de descarga file = ', ruta);
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          var nombreEmpresa = angular.copy(_this3.unidad_productiva.razon_social);
	          nombreEmpresa = nombreEmpresa.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //        let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "certificado_" + nombreEmpresa + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	        }
	      });
	    }
	  }, {
	    key: 'volver',
	    value: function volver() {
	      //    if (this.certificacion.estado === 'APROBADO') {
	      //      this.Sidenav.path('declaracionesJuradas');
	      //    } else {
	      //      this.Sidenav.path('declaracionDetalle');
	      //    }
	      this.Sidenav.path('declaracionesJuradas');
	    }
	  }, {
	    key: 'depositoLoad',
	    value: function depositoLoad() {
	      var _this4 = this;
	
	      this.DataService.get('certificaciones/' + this.certificacion.id_certificacion + '/pagos').then(function (response) {
	        _this4.initConfFechaDepositoDate();
	        if (angular.isArray(response) && response.length > 0) {
	          _this4.pagos = response;
	          response.forEach(function (it) {
	            it.fecha_deposito = new Date(it.fecha_deposito);
	          });
	          _this4.deposito = response[0];
	        }
	      });
	    }
	  }, {
	    key: 'finalizarAcreditacion',
	    value: function finalizarAcreditacion(form) {
	      var _this5 = this;
	
	      if (angular.isUndefined(this.datos_factura.numero_autorizacion) || angular.isUndefined(this.datos_factura.nro_factura) || angular.isUndefined(this.datos_factura.fecha_factura)) {
	        this.Message.error("Debe llenar los datos de facturación.");
	        return;
	      }
	      //Confirmacion antes de finalizar
	      this.Modal.confirm('¿Está seguro/a de aprobar?', function () {
	        //Validamos si no hay deposito y el usuario tiene NIT
	        // if (angular.isUndefined(this.deposito.id_pago) && this.usuario_ddjj_con_nit) {
	        //   this.Message.error("El usuario no llenó datos de depósito. Aún no puede finalizar la acreditación.");
	        //   return;
	        // }
	        //Finalizamos acreditacion
	        var pago;
	        form = form.depositos_form;
	        if (form.$valid) {
	          pago = angular.copy(_this5.deposito);
	          pago.factura_razon_social = _this5.certificacion.nombre_razon_social;
	          pago.nit = _this5.certificacion.nit;
	          if (_this5.certificacion.estado == 'PENDIENTE_PAGO') {
	            _this5.DataService.put('certificaciones/' + _this5.certificacion.id_certificacion + '/pagar/', pago).then(function (response) {
	              if (response) {
	                _this5.finalizar();
	                _this5.certificacion.estado = 'PAGADO';
	              }
	            });
	          } else if (_this5.certificacion.estado == 'PAGADO') {
	            _this5.finalizar();
	          }
	        } else {
	          if (_this5.usuario_ddjj_con_nit) {
	            _this5.Message.warning('El depósito debe ser llenado por el usuario que hizo la declaración.');
	          } else {
	            _this5.Util.setTouchedForm(form, true, null, true);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'finalizar',
	    value: function finalizar() {
	      var _this6 = this;
	
	      this.$log.log('---Realizamos la aprobacion');
	      var obj = {
	        fecha_factura: this.datos_factura.fecha_factura,
	        numero_autorizacion: this.datos_factura.numero_autorizacion,
	        nro_factura: this.datos_factura.nro_factura,
	        nombre_razon_social: this.datos_factura.nombre_razon_social,
	        nit: this.datos_factura.nit
	      };
	      this.DataService.put('certificaciones/' + this.certificacion.id_certificacion + '/aprobar/', obj).then(function (response) {
	        if (response) {
	          _this6.$log.log('Respuesta aprobacion***= ', response);
	
	          _this6.cargarPdfCertificado(_this6.certificacion.id_certificacion);
	          //this.Sidenav.path('declaracionesJuradas');
	          _this6.certificacion.estado = 'APROBADO';
	          // this.$state.reload();
	          _this6.recargaDatosAprobado();
	        }
	      });
	    }
	  }, {
	    key: 'recargaDatosAprobado',
	    value: function recargaDatosAprobado() {
	      var _this7 = this;
	
	      this.DataService.get('certificaciones/' + this.Storage.get('certificacion').id_certificacion).then(function (response) {
	        if (response) {
	          _this7.certificacion = response.certificacion;
	          _this7.datos_factura = response.datos_factura;
	          _this7.datos_factura.fecha_factura = new Date(_this7.datos_factura.fecha_factura);
	          if (angular.isDefined(response.pago)) {
	            _this7.monto = response.pago;
	          } else {
	            _this7.monto = _this7.certificacion.pagos[0].monto;
	          }
	          //----------------
	          _this7.usuario_ddjj_con_nit = _this7.unidad_productiva.usuario.nit != null;
	          _this7.rubro = _this7.Storage.get('rubro');
	          _this7.deposito = {};
	          _this7.initConf();
	          _this7.depositoLoad();
	        }
	      });
	    }
	  }, {
	    key: 'validateFechaDeposito',
	    value: function validateFechaDeposito(form) {
	      if (this.deposito.fecha_deposito) {
	        form.fecha_deposito.$setValidity('min_date', !(this.deposito.fecha_deposito < this.conf.pag.fecha_deposito.options.minDate));
	        form.fecha_deposito.$setValidity('max_date', !(this.deposito.fecha_deposito > this.conf.pag.fecha_deposito.options.maxDate));
	      }
	    }
	  }, {
	    key: 'validateFechaFactura',
	    value: function validateFechaFactura(form) {
	      if (this.certificacion.fecha_factura) {
	        form.fecha_factura.$setValidity('min_date', !(this.certificacion.fecha_factura < this.conf.fac.fecha_factura.options.minDate));
	        form.fecha_factura.$setValidity('max_date', !(this.certificacion.fecha_factura > this.conf.fac.fecha_factura.options.maxDate));
	      }
	    }
	  }, {
	    key: 'habilitarFac',
	    value: function habilitarFac() {
	      // return (this.certificacion.estado === 'PENDIENTE_PAGO' && !this.usuario_ddjj_con_nit) || (this.certificacion.estado === 'PAGADO');
	      return this.certificacion.estado === 'PENDIENTE_PAGO' || this.certificacion.estado === 'PAGADO';
	    }
	  }, {
	    key: 'initConf',
	    value: function initConf() {
	      this.conf = {
	        fac: angular.copy(this.certificacion.formulario.secciones[0].factura),
	        pag: angular.copy(this.certificacion.formulario.secciones[0].pagos)
	      };
	      this.$log.log('--- Conf factura = ', this.conf);
	      this.conf.fac.fecha_factura.requerido = true;
	      this.conf.fac.numero_autorizacion.requerido = true;
	      this.conf.fac.numero_factura.requerido = true;
	      delete this.certificacion.formulario.secciones;
	    }
	  }, {
	    key: 'initConfFechaDepositoDate',
	    value: function initConfFechaDepositoDate() {
	      var xdate = new Date(this.Storage.get('dateNow'));
	      this.conf.pag.fecha_deposito.options = {
	        maxDate: xdate,
	        minDate: new Date(xdate.getFullYear() - 1, xdate.getMonth(), xdate.getDate()),
	        startingDay: 1
	        // showWeeks: false
	      };
	      this.conf.fac.fecha_factura.options = angular.copy(this.conf.pag.fecha_deposito.options);
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }]);
	
	  return DdjjacreditarController;
	}();
	
	exports.default = DdjjacreditarController;

/***/ }),
/* 340 */
[680, 341, 596],
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ddjjdetalleModalController = __webpack_require__(13);
	
	var _ddjjdetalleModalController2 = _interopRequireDefault(_ddjjdetalleModalController);
	
	var _ddjjdetalleModal = __webpack_require__(14);
	
	var _ddjjdetalleModal2 = _interopRequireDefault(_ddjjdetalleModal);
	
	var _ddjjdetalleModalObsController = __webpack_require__(342);
	
	var _ddjjdetalleModalObsController2 = _interopRequireDefault(_ddjjdetalleModalObsController);
	
	var _ddjjdetalleModalObs = __webpack_require__(597);
	
	var _ddjjdetalleModalObs2 = _interopRequireDefault(_ddjjdetalleModalObs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjdetalleController = function () {
	  DdjjdetalleController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Sidenav", "$window", "Loading", "Message", "$state"];
	  function DdjjdetalleController(NgTableParams, $log, Modal, Storage, DataService, Sidenav, $window, Loading, Message, $state) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjdetalleController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Sidenav = Sidenav;
	    this.$window = $window;
	    this.Loading = Loading;
	    this.Message = Message;
	    this.$state = $state;
	  }
	
	  _createClass(DdjjdetalleController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.Loading.show('Cargando', true);
	      var cargar_vista = true;
	      this.titulo = 'Nombre de página';
	      this.isDdjj = true;
	      //    this.isActEconomica = false;
	      this.isCategorizacion = true;
	      this.item = {};
	      this.item2 = {};
	
	      this.unidad_productiva = this.Storage.get('unidad_productiva');
	
	      this.certificacion = this.Storage.get('certificacion');
	
	      this.datosCert = { unidad_productiva: this.unidad_productiva, certificacion: this.certificacion };
	
	      if (this.certificacion && this.certificacion.fecha_vigencia_anterior) {
	        this.fechaVigenciaAnterior = new Date(this.certificacion.fecha_vigencia_anterior);
	      }
	
	      if (this.Storage.get('sw_detalle_certificacion') && (this.certificacion.estado == 'PENDIENTE_PAGO' || this.certificacion.estado == 'PAGADO')) {
	        this.Storage.remove('sw_detalle_certificacion');
	        cargar_vista = false;
	      }
	      if (cargar_vista) {
	        if (angular.isDefined(this.certificacion.observaciones_secciones) && this.certificacion.observaciones_secciones !== null) {
	          var observacionesSecciones = this.certificacion.observaciones_secciones.split("#");
	          this.$log.log('Observaciones secciones = ', observacionesSecciones);
	          for (var j = 0; j < observacionesSecciones.length; j++) {
	
	            var obj = observacionesSecciones[j];
	            if (obj.indexOf('registro') > 0) {
	              this.isDdjj = false;
	            } else if (obj.indexOf('ategorizaci') > 0) {
	              this.isCategorizacion = false;
	            }
	          }
	        }
	        //filtro
	
	        if (this.certificacion.formulario.tipo === 'ICAP') {
	          this.cargarServicios(this.certificacion.id_certificacion);
	        } else {
	          this.cargarCaeb();
	          this.cargarActividadesEconomicas(this.certificacion.id_certificacion);
	        }
	
	        //      this.cargarPagos(this.certificacion.id_certificacion);
	
	        if (this.certificacion.estado === 'APROBADO') {
	          this.Ddjj = true;
	          this.isCategorizacion = true;
	        }
	      } else {
	        this.siguiente();
	      }
	    }
	  }, {
	    key: 'cargarCaeb',
	    value: function cargarCaeb() {
	      var _this = this;
	
	      var padre;
	      this.listadoCaeb = [];
	      this.DataService.get('clasificadores/subclases').then(function (response) {
	        _this.$log.log(_this);
	        if (response) {
	          _this.getListadoCaeb = response;
	          _this.getListadoCaeb.forEach(function (it) {
	            it.xdescripcion = it.codigo.toLowerCase() + ' - ' + it.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	            padre = it.padre;
	            it.xdescripcion2 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	            padre = padre.padre;
	            it.xdescripcion3 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	            padre = padre.padre;
	            it.xdescripcion4 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	            padre = padre.padre;
	            it.xdescripcion5 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	          });
	          _this.refreshResult();
	        }
	      });
	    }
	  }, {
	    key: 'refreshResult',
	    value: function refreshResult(textSearch) {
	      var arrCaebs;
	      if (this.getListadoCaeb) {
	        // this.$log.log('textSearch='+textSearch);
	        arrCaebs = angular.copy(this.getListadoCaeb);
	        if (textSearch) {
	          textSearch = textSearch.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	          arrCaebs = arrCaebs.filter(function (it) {
	            return it.xdescripcion.indexOf(textSearch) != -1 || it.xdescripcion5.indexOf(textSearch) != -1 || it.xdescripcion4.indexOf(textSearch) != -1 || it.xdescripcion3.indexOf(textSearch) != -1 || it.xdescripcion2.indexOf(textSearch) != -1;
	          });
	        }
	        if (arrCaebs.length > 20) {
	          arrCaebs = arrCaebs.splice(0, 20);
	        }
	        this.listadoCaeb = arrCaebs;
	      }
	    }
	  }, {
	    key: 'cargarCaebByid',
	    value: function cargarCaebByid(posicion, idCaeb) {
	      var _this2 = this;
	
	      if (idCaeb !== null && angular.isDefined(idCaeb)) {
	        this.DataService.get('clasificadores/' + idCaeb).then(function (response) {
	          if (response) {
	            _this2.$log.log('Caeb by id resp = ', response);
	            // 1 = item2.selected
	            if (posicion === 1) {
	              _this2.item.selected = response;
	            } else {
	              _this2.item2.selected = response;
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'cargarServicios',
	    value: function cargarServicios(idCertificacion) {
	      var _this3 = this;
	
	      this.DataService.get('certificaciones/' + idCertificacion + '/ddjj_servicios').then(function (response) {
	        if (response) {
	          _this3.servicios = response;
	        }
	      });
	    }
	  }, {
	    key: 'cargarActividadesEconomicas',
	    value: function cargarActividadesEconomicas(idCertificacion) {
	      var _this4 = this;
	
	      this.DataService.get('certificaciones/' + idCertificacion + '/actividades_economicas/').then(function (response) {
	        if (response) {
	          //        this.$log.log('RESPUESTAAAA---actividades economicas', response);
	          _this4.actividadesEconomicas = response;
	          for (var i = 0; i < _this4.actividadesEconomicas.length; i++) {
	            var oo = _this4.actividadesEconomicas[i];
	            _this4.cargarCaebByid(i + 1, oo.fid_parametro_caeb);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'cargarPagos',
	    value: function cargarPagos(idCertificacion) {
	      var _this5 = this;
	
	      this.DataService.get('certificaciones/' + idCertificacion + '/pagos/').then(function (response) {
	        if (response) {
	          _this5.pagos = response;
	        }
	      });
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'verPdf',
	    value: function verPdf() {
	      var _this6 = this;
	
	      this.$log.log('---Vemos pdf');
	      var ruta = 'certificaciones/' + this.certificacion.id_certificacion + '/reporte';
	      if (this.certificacion.estado == 'APROBADO') {
	        ruta = 'certificaciones/mostrar_reporte/' + this.certificacion.id_certificacion;
	      }
	
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'reporte_generado');
	      } else {
	
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this6.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'descargarPdf',
	    value: function descargarPdf(ruta, nombre) {
	      var _this7 = this;
	
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "" + nombre + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	          _this7.Message.success('Su documento esta siendo descargado.');
	        }
	      });
	    }
	  }, {
	    key: 'observar',
	    value: function observar() {
	      //    this.Modal.confirm('¿Está seguro/a de continuar?', () => {
	      //      this.$log.log('---Realizamos la observacion');
	      //    });
	
	      var arrayObs = [];
	
	      if (!this.isDdjj) {
	        arrayObs.push("Declaración jurada para el registro y acreditación nacional.");
	      }
	      if (!this.isSeccionCaebOk()) {
	        //      this.certificacion.formulario.tipo !== 'PROVEEDOR'
	        arrayObs.push("Actividad económica (CAEB).");
	      }
	      if (!this.isCategorizacion) {
	        arrayObs.push("Categorización.");
	      }
	
	      this.Modal.show({
	        template: _ddjjdetalleModalObs2.default,
	        controller: _ddjjdetalleModalObsController2.default,
	        data: {
	          "arrayObs": arrayObs,
	          "id_certificacion": this.certificacion.id_certificacion
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'observarAguinaldo',
	    value: function observarAguinaldo() {
	      var arrayObs = [];
	      if (!this.isDdjj) {
	        arrayObs.push("Declaración jurada para el registro y acreditación nacional.");
	      }
	      if (!this.isSeccionCaebOk()) {
	        //      this.certificacion.formulario.tipo !== 'PROVEEDOR'
	        arrayObs.push("Actividad económica (CAEB).");
	      }
	      if (!this.isCategorizacion) {
	        arrayObs.push("Categorización.");
	      }
	
	      this.Modal.show({
	        template: _ddjjdetalleModalObs2.default,
	        controller: _ddjjdetalleModalObsController2.default,
	        data: {
	          "arrayObs": arrayObs,
	          "id_certificacion": this.certificacion.id_certificacion,
	          "tipo_formulario": this.certificacion.formulario.tipo,
	          "estado_certificado": this.certificacion.estado
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'observarRefrigerio',
	    value: function observarRefrigerio() {
	      var arrayObs = [];
	      if (!this.isDdjj) {
	        arrayObs.push("Declaración jurada para el registro y acreditación nacional.");
	      }
	      if (!this.isSeccionCaebOk()) {
	        //      this.certificacion.formulario.tipo !== 'PROVEEDOR'
	        arrayObs.push("Actividad económica (CAEB).");
	      }
	      if (!this.isCategorizacion) {
	        arrayObs.push("Categorización.");
	      }
	
	      this.Modal.show({
	        template: _ddjjdetalleModalObs2.default,
	        controller: _ddjjdetalleModalObsController2.default,
	        data: {
	          "arrayObs": arrayObs,
	          "id_certificacion": this.certificacion.id_certificacion,
	          "tipo_formulario": this.certificacion.formulario.tipo,
	          "estado_certificado": this.certificacion.estado
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'aprobar',
	    value: function aprobar() {
	      var _this8 = this;
	
	      if (this.certificacion.fid_certificacion_origen === null && this.certificacion.tipo === 'RENOVACION' || this.certificacion.fid_certificacion_origen === null && this.certificacion.tipo === 'RENOVACION_EXPIRADA') {
	
	        if (!this.fechaVigenciaAnterior) {
	          this.Message.error("Debe ingresar la 'Fecha de Vigencia del Anterior Certificado'.");
	          return;
	        }
	      }
	
	      //Comentando metodo de aprobar, por si se aprueba en esta instancia
	      this.Modal.confirm('¿Está seguro/a de continuar?', function () {
	        //Almacenamos el RUBRO si es distinto de ICAP
	        if (_this8.certificacion.formulario.tipo !== 'ICAP') {
	          _this8.Storage.set('rubro', _this8.item.selected.padre.padre.padre.descripcion);
	        }
	
	        var objEnviar = {
	          fecha_vigencia_anterior: _this8.fechaVigenciaAnterior
	        };
	
	        //Pasamos a pantalla, en la siguiente pantalla se aprueba
	        if (_this8.isDdjj && _this8.isSeccionCaebOk() && _this8.isCategorizacion) {
	          _this8.DataService.put('certificaciones/' + _this8.certificacion.id_certificacion + '/notificar', objEnviar).then(function (response) {
	            if (response) {
	              response.certificacion.monto_sugerido = response.pago;
	              _this8.Storage.set('certificacion', response.certificacion);
	              _this8.Storage.set('unidad_productiva', response.unidad_productiva);
	              _this8.siguiente();
	            }
	          });
	        } else {
	          _this8.Message.error("Debe seleccionar/aprobar todas las secciones antes de pasar a la siguiente pantalla.");
	        }
	      });
	    }
	  }, {
	    key: 'aprobarAguinaldo',
	    value: function aprobarAguinaldo() {
	      var _this9 = this;
	
	      this.Modal.confirm('¿Está seguro/a de continuar?', function () {
	        _this9.DataService.put('certificaciones/' + _this9.certificacion.id_certificacion + '/aprobarAguinaldo', {}).then(function (response) {
	          if (response) {
	            _this9.Storage.set('certificacion', response.certificacion);
	            _this9.Storage.set('unidad_productiva', response.unidad_productiva);
	            _this9.$state.reload();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'aprobarRefrigerio',
	    value: function aprobarRefrigerio() {
	      var _this10 = this;
	
	      this.Modal.confirm('¿Está seguro/a de continuar?', function () {
	        _this10.DataService.put('certificaciones/' + _this10.certificacion.id_certificacion + '/aprobarRefrigerio', {}).then(function (response) {
	          if (response) {
	            _this10.Storage.set('certificacion', response.certificacion);
	            _this10.Storage.set('unidad_productiva', response.unidad_productiva);
	            _this10.$state.reload();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'volver',
	    value: function volver() {
	      this.Sidenav.path('declaracionesJuradas');
	    }
	  }, {
	    key: 'siguiente',
	    value: function siguiente() {
	      this.Sidenav.path('declaracionAcreditar');
	    }
	  }, {
	    key: 'asignarCaeb',
	    value: function asignarCaeb(producto, caeb) {
	      var _this11 = this;
	
	      this.$log.log('Producto a actualizar= ', producto);
	      this.$log.log('CAEB SELECT= ', caeb);
	      var obj = {
	        id_caeb: caeb.id_caeb
	      };
	
	      this.DataService.put('certificaciones/' + this.certificacion.id_certificacion + '/actividades_economicas/' + producto.id_producto + '/caeb', obj).then(function (response) {
	        if (response) {
	          _this11.$log.log('Respuesta* ACTUALIZAR CAEB= ', response);
	        }
	      });
	    }
	  }, {
	    key: 'isSeccionCaebOk',
	    value: function isSeccionCaebOk() {
	      //Si es ICAP no validamos CAEB
	      if (this.certificacion.formulario.tipo === 'ICAP' || this.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' || this.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO') {
	        return true;
	      }
	      //Validamos CAEB
	      if (angular.isDefined(this.actividadesEconomicas)) {
	        var nro = this.actividadesEconomicas.length;
	        if (nro === 1) {
	          return angular.isDefined(this.item.selected);
	        } else if (nro === 2) {
	          return angular.isDefined(this.item.selected) && angular.isDefined(this.item2.selected);
	        } else {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'actualizarDdjj',
	    value: function actualizarDdjj() {
	      this.isDdjj = !this.isDdjj;
	    }
	    //  actualizarActEconomica() {
	    //    this.isActEconomica = !this.isActEconomica;
	    //  }
	
	  }, {
	    key: 'actualizarCategorizacion',
	    value: function actualizarCategorizacion() {
	      this.isCategorizacion = !this.isCategorizacion;
	    }
	  }]);
	
	  return DdjjdetalleController;
	}();
	
	exports.default = DdjjdetalleController;

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjdetalleobsModalController = function () {
	  DdjjdetalleobsModalController.$inject = ["$uibModalInstance", "data", "$sce", "$log", "DataService", "$state", "$location"];
	  function DdjjdetalleobsModalController($uibModalInstance, data, $sce, $log, DataService, $state, $location) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjdetalleobsModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.$state = $state;
	    this.$location = $location;
	    // this.Loading = Loading;
	  }
	
	  _createClass(DdjjdetalleobsModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      // this.Loading.show('Cargando', true);
	      this.tipo_formulario = this.items.tipo_formulario;
	      this.estado_certificado = this.items.estado_certificado;
	      this.selected = {
	        item: this.items[0]
	      };
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      var obj = {
	        "observaciones_secciones": this.items.arrayObs,
	        "observaciones": this.observacion
	      };
	      if (this.tipo_formulario === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' || this.tipo_formulario === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO' && this.estado_certificado === 'APROBADO_ENVIADO') {
	        obj.esProductoObservado = true;
	      }
	      this.DataService.put('certificaciones/' + this.items.id_certificacion + '/observar/', obj).then(function (response) {
	        if (response) {
	          _this.$location.path('declaracionesJuradas');
	          _this.$uibModalInstance.close(_this.selected.item);
	        }
	      });
	
	      this.$uibModalInstance.close(this.selected.item);
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return DdjjdetalleobsModalController;
	}();
	
	exports.default = DdjjdetalleobsModalController;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _duplicados = __webpack_require__(344);
	
	var _duplicados2 = _interopRequireDefault(_duplicados);
	
	var _duplicados3 = __webpack_require__(598);
	
	var _duplicados4 = _interopRequireDefault(_duplicados3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DuplicadosComponent = {
	    bindings: {},
	    controller: _duplicados2.default,
	    template: _duplicados4.default
	};
	
	exports.default = DuplicadosComponent;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	//import modalController from '../../../admin/probolivia/ddjj/ddjjdetalle.modal.controller.js';
	//import modalTemplate from '../../../admin/probolivia/ddjj/ddjjdetalle.modal.html';
	//
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _duplicadosModalController = __webpack_require__(345);
	
	var _duplicadosModalController2 = _interopRequireDefault(_duplicadosModalController);
	
	var _duplicadosModal = __webpack_require__(599);
	
	var _duplicadosModal2 = _interopRequireDefault(_duplicadosModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DuplicadosController = function () {
	  DuplicadosController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "$location", "Util", "Message", "$window", "Sidenav"];
	  function DuplicadosController(NgTableParams, $log, Modal, Storage, DataService, $location, Util, Message, $window, Sidenav) {
	    'ngInject';
	
	    _classCallCheck(this, DuplicadosController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.Util = Util;
	    this.Message = Message;
	    this.$window = $window;
	    this.Sidenav = Sidenav;
	  }
	
	  _createClass(DuplicadosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      //    cargamos tabla
	      this.tim = {};
	      this.cargarTabla();
	      //Revisamo si hay nit para el user logueado
	      this.usuario = this.Storage.getUser();
	      if (angular.isDefined(this.usuario.nit) && this.usuario.nit !== null && this.usuario.nit !== 'null') {
	        this.isTieneNit = true;
	      } else {
	        this.isTieneNit = false;
	      }
	    }
	  }, {
	    key: 'changeFilter',
	    value: function changeFilter() {
	      var _this = this;
	
	      if (this.tableParams) {
	        this.Util.funcDelay(this.tim, 1000, function () {
	          _this.tableParams.reload();
	        });
	      }
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      this.tableParams = new this.NgTableParams({ count: 10 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this2.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this2.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	          query.ambito = "PROBOLIVIA";
	          query.creadas = 'TECNICO';
	          query.filter = _this2.filtro_bandeja || '';
	          return _this2.DataService.list('certificaciones?duplicados=true', query).then(function (response) {
	
	            _this2.$log.log('lista de duplicados = ', response);
	
	            if (response) {
	              params.total(response.count);
	              var items = _this2.filterItems(response.rows);
	              _this2.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'duplicar',
	    value: function duplicar(item) {
	      this.$log.log('duplicar = ', item);
	      this.Modal.show({
	        template: _duplicadosModal2.default,
	        controller: _duplicadosModalController2.default,
	        data: { id_certificacion: item.certificacion.id_certificacion },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'eliminar',
	    value: function eliminar(item) {
	      var _this3 = this;
	
	      this.Modal.confirm('Al eliminar esta declaración, no podrá recuperar la información ingresada. ¿Desea eliminar el registro?', function () {
	        _this3.$log.log('Eliminamos = ', item);
	        _this3.DataService.delete('certificaciones/' + item.certificacion.id_certificacion).then(function () {
	          _this3.Message.success('Su registro fue eliminado correctamente.');
	          _this3.refresh();
	        });
	      });
	    }
	  }, {
	    key: 'procesar',
	    value: function procesar(nombre) {
	      return nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace('DECLARACIÓN JURADA PARA LA ', '');
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'irDetalle',
	    value: function irDetalle() {
	      this.Sidenav.path('declaracionDetalle');
	    }
	
	    //filtrado en grid
	
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'aprobarDuplicado',
	    value: function aprobarDuplicado(item) {
	      var _this4 = this;
	
	      this.$log.log('Aprobar duplicados = ', item);
	      this.DataService.get("certificaciones/" + item.certificacion.fid_certificacion_origen + "/duplicados/" + item.certificacion.lote_duplicado).then(function (response) {
	        if (response) {
	          _this4.$log.log('Vamos a ruta de  acreditacion de duplis = ', response);
	          _this4.Storage.set('certificacion', response.certificacion);
	          _this4.Storage.set('unidad_productiva', response.unidad_productiva);
	          _this4.Storage.set('datos_factura', response.datos_factura);
	          _this4.Storage.set('pagos', response.pagos);
	          _this4.Storage.set('duplicados', response.duplicados);
	          _this4.Storage.set('lote_duplicado', item.certificacion.lote_duplicado);
	          _this4.Sidenav.path("duplicarAcreditar");
	        }
	      });
	    }
	  }]);
	
	  return DuplicadosController;
	}();
	
	exports.default = DuplicadosController;

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DuplicadosModalController = function () {
	  DuplicadosModalController.$inject = ["$uibModalInstance", "data", "DataService", "$log", "$state", "Storage", "Loading"];
	  function DuplicadosModalController($uibModalInstance, data, DataService, $log, $state, Storage, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, DuplicadosModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.DataService = DataService;
	    this.$log = $log;
	    this.$state = $state;
	    this.Storage = Storage;
	    this.Loading = Loading;
	  }
	
	  _createClass(DuplicadosModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.Loading.show('Cargando', true);
	      this.selected = {
	        item: this.items[0]
	      };
	      //    this.urlPdf = this.items.urlPdf;
	
	      var xdate = new Date();
	      if (this.Storage.exist('dateNow')) xdate = new Date(this.Storage.get('dateNow'));
	
	      this.conf = {
	        maxDate: xdate,
	        minDate: new Date(xdate.getFullYear() - 1, xdate.getMonth(), xdate.getDate()),
	        startingDay: 1
	        // showWeeks: false
	      };
	    }
	  }, {
	    key: 'validateFechaDeposito',
	    value: function validateFechaDeposito(form) {
	      if (this.obj.fecha_deposito) {
	        form.fecha_deposito.$setValidity('min_date', !(this.obj.fecha_deposito < this.conf.minDate));
	        form.fecha_deposito.$setValidity('max_date', !(this.obj.fecha_deposito > this.conf.maxDate));
	      }
	    }
	  }, {
	    key: 'solicitar',
	    value: function solicitar() {
	      var _this = this;
	
	      this.$log.log('Solicitando duplicado', this.obj);
	
	      this.DataService.post('certificaciones/' + this.items.id_certificacion + '/duplicar', this.obj).then(function (response) {
	        if (response) {
	          _this.$state.reload();
	          _this.$uibModalInstance.close(_this.selected.item);
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return DuplicadosModalController;
	}();
	
	exports.default = DuplicadosModalController;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _duplicados = __webpack_require__(343);
	
	var _duplicados2 = _interopRequireDefault(_duplicados);
	
	var _duplicaracreditar = __webpack_require__(347);
	
	var _duplicaracreditar2 = _interopRequireDefault(_duplicaracreditar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Duplicados = angular.module('app.duplicados', []).component('bandejaDuplicados', _duplicados2.default).component('duplicarAcreditar', _duplicaracreditar2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('bandejaDuplicados', {
	    url: '/bandejaDuplicados',
	    component: 'bandejaDuplicados'
	  }).state('duplicarAcreditar', {
	    url: '/duplicarAcreditar',
	    component: 'duplicarAcreditar'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Duplicados;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _duplicaracreditar = __webpack_require__(348);
	
	var _duplicaracreditar2 = _interopRequireDefault(_duplicaracreditar);
	
	var _duplicaracreditar3 = __webpack_require__(600);
	
	var _duplicaracreditar4 = _interopRequireDefault(_duplicaracreditar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DuplicaracreditarComponent = {
	    bindings: {},
	    controller: _duplicaracreditar2.default,
	    template: _duplicaracreditar4.default
	};
	
	exports.default = DuplicaracreditarComponent;

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DuplicaracreditarController = function () {
	  DuplicaracreditarController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Sidenav", "$sce", "Util", "Message", "$window", "Loading"];
	  function DuplicaracreditarController(NgTableParams, $log, Modal, Storage, DataService, Sidenav, $sce, Util, Message, $window, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, DuplicaracreditarController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Sidenav = Sidenav;
	    this.$sce = $sce;
	    this.Util = Util;
	    this.Message = Message;
	    this.$window = $window;
	    this.Loading = Loading;
	  }
	
	  _createClass(DuplicaracreditarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.Loading.show('Cargando', true);
	      this.$log.log(this);
	      this.titulo = 'Nombre de página';
	      this.unidad_productiva = this.Storage.get('unidad_productiva');
	      this.certificacion = this.Storage.get('certificacion');
	      this.datos_factura = this.Storage.get('datos_factura');
	      this.datos_factura.fecha_factura = new Date(this.datos_factura.fecha_factura);
	
	      this.pagos = this.Storage.get('pagos');
	      this.duplicados = this.Storage.get('duplicados');
	      this.lote_duplicado = this.Storage.get('lote_duplicado');
	
	      this.$log.log('-CERTIFICACION = ', this.certificacion);
	      this.$log.log('-UNIDAD PRODUCTIVA = ', this.unidad_productiva);
	      this.$log.log('-DUPLICADOS = ', this.duplicados);
	
	      this.usuario_ddjj_con_nit = this.unidad_productiva.usuario.nit != null;
	      this.monto = this.pagos[0].monto;
	
	      if (this.duplicados.length > 0) {
	        this.certificacion.estado = this.duplicados[0].estado;
	        if (this.certificacion.estado === 'APROBADO' || this.certificacion.estado === 'PAGADO') {
	
	          if (angular.isUndefined(this.datos_factura.numero_autorizacion) || angular.isUndefined(this.datos_factura.nro_factura) || angular.isUndefined(this.datos_factura.fecha_factura)) {
	            this.certificadoDuplicado = false;
	          } else {
	            this.cargarPdfCertificado(this.duplicados[0].id_certificacion, this.duplicados[0].estado);
	          }
	        }
	      }
	
	      //---------------
	      this.DataService.get('certificaciones/' + this.Storage.get('certificacion').id_certificacion).then(function (response) {
	        if (response) {
	
	          _this.rubro = _this.Storage.get('rubro');
	          _this.deposito = {};
	          _this.initConf();
	          _this.depositoLoad(_this.pagos);
	        }
	      });
	    }
	  }, {
	    key: 'cargarPdfCertificado',
	    value: function cargarPdfCertificado(idCertificacion, estado) {
	      var _this2 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + idCertificacion;
	      if (estado === 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + idCertificacion;
	      }
	      this.$log.log('Url de descarga = ', ruta);
	      this.DataService.pdfO(ruta, {}).then(function (response) {
	        if (response) {
	          _this2.$log.log('Documento = ', response);
	          _this2.urlPdf = response;
	          // this.Message.success("El certificado se generó correctamente.");
	          _this2.certificadoDuplicado = true;
	          //       this.$window.navigator.msSaveOrOpenBlob(response, 'PdfGenerado' + '.pdf');
	          //        var fileName = "file_name.pdf";
	          //        var a = document.createElement("a");
	          //        document.body.appendChild(a);
	          //        var file = new Blob([response.datos], {type: 'application/pdf'});
	          //        var fileURL = window.URL.createObjectURL(file);
	          //        a.href = fileURL;
	          //        a.download = fileName;
	          //        a.click();
	        }
	      });
	    }
	  }, {
	    key: 'descargarCertificado',
	    value: function descargarCertificado(duplicado) {
	      var _this3 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + duplicado.id_certificacion;
	      if (duplicado.estado === 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + duplicado.id_certificacion;
	      }
	      this.$log.log('Url de descarga file = ', ruta);
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          var nombreEmpresa = angular.copy(_this3.unidad_productiva.razon_social);
	          nombreEmpresa = nombreEmpresa.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //        let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "certificado_" + nombreEmpresa + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	        }
	      });
	    }
	  }, {
	    key: 'volver',
	    value: function volver() {
	      this.Sidenav.path('bandejaDuplicados');
	    }
	  }, {
	    key: 'depositoLoad',
	    value: function depositoLoad(response) {
	      this.initConfFechaDepositoDate();
	      if (angular.isArray(response) && response.length > 0) {
	        response.forEach(function (it) {
	          it.fecha_deposito = new Date(it.fecha_deposito);
	        });
	        this.deposito = response[0];
	      }
	    }
	  }, {
	    key: 'finalizarAcreditacion',
	    value: function finalizarAcreditacion(form) {
	      var _this4 = this;
	
	      form;
	      var obj = {
	        fecha_factura: this.datos_factura.fecha_factura,
	        numero_autorizacion: this.datos_factura.numero_autorizacion,
	        nro_factura: this.datos_factura.nro_factura,
	        nombre_razon_social: this.datos_factura.nombre_razon_social,
	        nit: this.datos_factura.nit,
	        lote_duplicado: this.lote_duplicado
	      };
	
	      this.$log.log('- Objeto finalizar = ', obj);
	      if (angular.isUndefined(this.datos_factura.numero_autorizacion) || angular.isUndefined(this.datos_factura.nro_factura) || angular.isUndefined(this.datos_factura.fecha_factura)) {
	        this.Message.error("Debe llenar los datos de facturación.");
	        return;
	      }
	      //Confirmacion antes de finalizar
	      this.Modal.confirm('¿Está seguro/a de finalizar?', function () {
	
	        _this4.DataService.put('certificaciones/' + _this4.certificacion.id_certificacion + '/duplicados/', obj).then(function (response) {
	          if (response) {
	            _this4.Message.success("Se realizó la aprobación correctamente.");
	            _this4.certificacion = response.certificacion;
	            if (response.duplicados.length > 0) {
	              if (_this4.certificacion.estado === 'APROBADO' || _this4.certificacion.estado === 'PAGADO') {
	                _this4.cargarPdfCertificado(response.duplicados[0].id_certificacion, response.duplicados[0].estado);
	              }
	            }
	            //          this.Sidenav.path('bandejaDuplicados');
	          }
	        });
	
	        //      //Validamos si no hay deposito y el usuario tiene NIT
	        //      if (angular.isUndefined(this.deposito.id_pago) && this.usuario_ddjj_con_nit) {
	        //        this.Message.error("El usuario no lleno datos de depósito. Aún no puede finalizar la acreditación.");
	        //        return;
	        //      }
	        //      //Finalizamos acreditacion
	        //      var pago;
	        //      form = form.depositos_form;
	        //      if (form.$valid) {
	        //        pago = angular.copy(this.deposito);
	        //        pago.factura_razon_social = this.certificacion.nombre_razon_social;
	        //        pago.nit = this.certificacion.nit;
	        //        if (this.certificacion.estado == 'PENDIENTE_PAGO') {
	        //          this.DataService.put(`certificaciones/${this.certificacion.id_certificacion}/pagar/`, pago)
	        //          .then(response => {
	        //            if (response) {
	        //              this.finalizar();
	        //            }
	        //          })
	        //        } else if (this.certificacion.estado == 'PAGADO') {
	        //          this.finalizar();
	        //        }
	        //      } else {
	        //        if (this.usuario_ddjj_con_nit) {
	        //          this.Message.warning('El depósito debe ser llenado por el usuario que hizo la declaración.')
	        //        } else {
	        //          this.Util.setTouchedForm(form, true, null, true);
	        //        }
	        //      }
	      });
	    }
	  }, {
	    key: 'finalizar',
	    value: function finalizar() {
	      this.$log.log('---Realizamos la aprobacion de duplicacion');
	
	      var obj = {
	        fecha_factura: this.datos_factura.fecha_factura,
	        numero_autorizacion: this.datos_factura.numero_autorizacion,
	        nro_factura: this.datos_factura.nro_factura,
	        nombre_razon_social: this.datos_factura.nombre_razon_social,
	        nit: this.datos_factura.nit
	      };
	
	      this.$log.log('-Objeto a enviar = ', obj);
	
	      //    this.DataService.put('certificaciones/' + this.certificacion.id_certificacion + '/aprobar/', obj)
	      //    .then(response => {
	      //      if (response) {
	      //        this.$log.log('Respuesta aprobacion***= ', response);
	      //
	      //        this.certificacion.estado = 'APROBADO';
	      //
	      //      }
	      //    });
	    }
	  }, {
	    key: 'validateFechaDeposito',
	    value: function validateFechaDeposito(form) {
	      if (this.deposito.fecha_deposito) {
	        form.fecha_deposito.$setValidity('min_date', !(this.deposito.fecha_deposito < this.conf.pag.fecha_deposito.options.minDate));
	        form.fecha_deposito.$setValidity('max_date', !(this.deposito.fecha_deposito > this.conf.pag.fecha_deposito.options.maxDate));
	      }
	    }
	  }, {
	    key: 'validateFechaFactura',
	    value: function validateFechaFactura(form) {
	      if (this.certificacion.fecha_factura) {
	        form.fecha_factura.$setValidity('min_date', !(this.certificacion.fecha_factura < this.conf.fac.fecha_factura.options.minDate));
	        form.fecha_factura.$setValidity('max_date', !(this.certificacion.fecha_factura > this.conf.fac.fecha_factura.options.maxDate));
	      }
	    }
	  }, {
	    key: 'habilitarFac',
	    value: function habilitarFac() {
	      return this.certificacion.estado === 'PENDIENTE_PAGO' && !this.usuario_ddjj_con_nit || this.certificacion.estado === 'PAGADO';
	    }
	  }, {
	    key: 'initConf',
	    value: function initConf() {
	      this.conf = {
	        fac: angular.copy(this.certificacion.formulario.secciones[0].factura),
	        pag: angular.copy(this.certificacion.formulario.secciones[0].pagos)
	      };
	
	      this.$log.log('--- Conf factura = ', this.conf);
	
	      this.conf.fac.fecha_factura.requerido = true;
	      this.conf.fac.numero_autorizacion.requerido = true;
	      //emulamos datos de factura NRO BORRAR
	
	
	      this.conf.fac.numero_factura.requerido = true;
	      //    this.conf.fac.numero_factura.visible = true;
	      //    this.conf.fac.numero_factura.label = 'Nro Factura';
	      //    this.conf.fac.numero_factura.min_length = 2;
	      this.conf.fac.numero_factura.max_length = 8;
	
	      delete this.certificacion.formulario.secciones;
	    }
	  }, {
	    key: 'initConfFechaDepositoDate',
	    value: function initConfFechaDepositoDate() {
	      var xdate = new Date(this.Storage.get('dateNow'));
	      this.conf.pag.fecha_deposito.options = {
	        maxDate: xdate,
	        minDate: new Date(xdate.getFullYear() - 1, xdate.getMonth(), xdate.getDate()),
	        startingDay: 1
	        // showWeeks: false
	      };
	      this.conf.fac.fecha_factura.options = angular.copy(this.conf.pag.fecha_deposito.options);
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'cambiarTab',
	    value: function cambiarTab(duplicado) {
	      this.$log.log("Cambiamos de tab****", duplicado);
	      this.cargarPdfCertificado(duplicado.id_certificacion, duplicado.estado);
	    }
	  }]);
	
	  return DuplicaracreditarController;
	}();
	
	exports.default = DuplicaracreditarController;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _migrados = __webpack_require__(350);
	
	var _migrados2 = _interopRequireDefault(_migrados);
	
	var _migrados3 = __webpack_require__(601);
	
	var _migrados4 = _interopRequireDefault(_migrados3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MigradosComponent = {
	    bindings: {},
	    controller: _migrados2.default,
	    template: _migrados4.default
	};
	
	exports.default = MigradosComponent;

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MigradosController = function () {
	  MigradosController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "$location", "Util", "$window", "Message"];
	  function MigradosController(NgTableParams, $log, Modal, Storage, DataService, $location, Util, $window, Message) {
	    'ngInject';
	
	    _classCallCheck(this, MigradosController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.Util = Util;
	    this.$window = $window;
	    this.Message = Message;
	  }
	
	  _createClass(MigradosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      this.tim = {};
	      this.cargarTabla();
	      //Borrando Storage en: 'On init'
	
	      this.Storage.remove('certificacion');
	      this.Storage.remove('unidad_productiva');
	      this.Storage.remove('sw_detalle_certificacion');
	    }
	  }, {
	    key: 'changeFilter',
	    value: function changeFilter() {
	      var _this = this;
	
	      if (this.tableParams) {
	        this.Util.funcDelay(this.tim, 1000, function () {
	          _this.tableParams.reload();
	        });
	      }
	    }
	  }, {
	    key: 'verPdfTabla',
	    value: function verPdfTabla(item) {
	      this.$log.log("-------------", item);
	      this.Modal.pdf('certificaciones/' + item.certificacion.id_certificacion + '/reporte', 'Certificado');
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      this.tableParams = new this.NgTableParams({ count: 10 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this2.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this2.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	          query.ambito = "PROBOLIVIA";
	          query.migrado = true;
	          query.filter = _this2.filtro_bandeja || '';
	          return _this2.DataService.list('certificaciones', query).then(function (response) {
	            if (response) {
	              _this2.$log.log('RESPUESTA CERTIFICACIONES ===== ', response);
	              params.total(response.count);
	              var items = _this2.filterItems(response.rows);
	              _this2.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'toggleSelection',
	    value: function toggleSelection(item) {
	      item.isRowSelected = !item.isRowSelected;
	    }
	
	    //filtrado en grid
	
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'procesar',
	    value: function procesar(nombre) {
	      return nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace('DECLARACIÓN JURADA PARA LA ', '');
	    }
	  }, {
	    key: 'getUsuarioReg',
	    value: function getUsuarioReg(item) {
	      var usuarioReg = '';
	      if (item.unidad_productiva.nit === null || angular.isUndefined(item.unidad_productiva.nit)) {
	        usuarioReg = item.unidad_productiva.usuario.usuarios_roles[0].fid_rol === 4 ? '' + item.unidad_productiva.razon_social : item.unidad_productiva.usuario.email;
	      } else {
	        usuarioReg = item.unidad_productiva.usuario.usuarios_roles[0].fid_rol === 4 ? item.unidad_productiva.nit + ' - ' + item.unidad_productiva.razon_social : item.unidad_productiva.usuario.email;
	      }
	
	      return usuarioReg;
	    }
	  }]);
	
	  return MigradosController;
	}();
	
	exports.default = MigradosController;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _migrados = __webpack_require__(349);
	
	var _migrados2 = _interopRequireDefault(_migrados);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var migrados = angular.module('app.migrados', []).component('migrados', _migrados2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('migrados', {
	        url: '/migrados',
	        component: 'migrados'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = migrados;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parametros = __webpack_require__(353);
	
	var _parametros2 = _interopRequireDefault(_parametros);
	
	var _parametros3 = __webpack_require__(602);
	
	var _parametros4 = _interopRequireDefault(_parametros3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ParametrosComponent = {
	    bindings: {},
	    controller: _parametros2.default,
	    template: _parametros4.default
	};
	
	exports.default = ParametrosComponent;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parametrosModalController = __webpack_require__(354);
	
	var _parametrosModalController2 = _interopRequireDefault(_parametrosModalController);
	
	var _parametrosModal = __webpack_require__(603);
	
	var _parametrosModal2 = _interopRequireDefault(_parametrosModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ParametrosController = function () {
	  ParametrosController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Util", "Message", "$state"];
	  function ParametrosController(NgTableParams, $log, Modal, Storage, DataService, Util, Message, $state) {
	    'ngInject';
	
	    _classCallCheck(this, ParametrosController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Message = Message;
	    this.$state = $state;
	  }
	
	  _createClass(ParametrosController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      this.grupo = '';
	      this.cargarParametros('UNIDAD_MEDIDA');
	    }
	  }, {
	    key: 'cargarParametros',
	    value: function cargarParametros(grupo) {
	      var _this = this;
	
	      this.grupo = grupo;
	      //    this.DataService.get("parametros/?grupo=UNIDAD_MEDIDA")
	      this.DataService.get("parametros/?grupo=" + grupo).then(function (response) {
	        if (response) {
	          _this.tableParams1 = new _this.NgTableParams({ count: 10 }, { dataset: response });
	        }
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      this.Modal.show({
	        template: _parametrosModal2.default,
	        controller: _parametrosModalController2.default,
	        data: {
	          grupo: this.grupo,
	          objeto: undefined
	        }
	      });
	    }
	  }, {
	    key: 'editar',
	    value: function editar(item) {
	      this.Modal.show({
	        template: _parametrosModal2.default,
	        controller: _parametrosModalController2.default,
	        data: {
	          grupo: this.grupo,
	          objeto: angular.copy(item)
	        }
	      });
	    }
	  }, {
	    key: 'eliminar',
	    value: function eliminar(item) {
	      var _this2 = this;
	
	      this.Modal.confirm('¿Desea eliminar este registro?', function () {
	        _this2.DataService.delete('parametros/', item.id_parametro).then(function () {
	          _this2.Message.success('Su registro fue eliminado correctamente.');
	          _this2.$state.reload();
	        });
	      });
	    }
	  }]);
	
	  return ParametrosController;
	}();
	
	exports.default = ParametrosController;

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ParametrosModalController = function () {
	  ParametrosModalController.$inject = ["$uibModalInstance", "data", "$sce", "DataService", "$log", "Message", "$state"];
	  function ParametrosModalController($uibModalInstance, data, $sce, DataService, $log, Message, $state) {
	    'ngInject';
	
	    _classCallCheck(this, ParametrosModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.DataService = DataService;
	    this.$log = $log;
	    this.Message = Message;
	    this.$state = $state;
	  }
	
	  _createClass(ParametrosModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.selected = {
	        item: this.items[0]
	      };
	      this.$log.log('Objeto que llega = ', this.items);
	      this.isEdicion = true;
	
	      if (angular.isUndefined(this.items.objeto)) {
	        this.isEdicion = false;
	      }
	      this.parametro = this.items.objeto;
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      if (this.isEdicion) {
	        this.DataService.put('parametros/' + this.parametro.id_parametro, this.parametro).then(function (response) {
	          if (response) {
	            _this.$log.log('Respuesta  ACTUALIZAR PARAMETRO= ', response);
	            _this.$uibModalInstance.close(_this.selected.item);
	            _this.Message.success("Registro actualizado correctamente.");
	            _this.$state.reload();
	          }
	        });
	      } else {
	        this.parametro.grupo = this.items.grupo;
	        this.DataService.post('parametros/', this.parametro).then(function (response) {
	          if (response) {
	            _this.$log.log('Respuesta  AGREGAR PARAMETRO= ', response);
	            _this.$uibModalInstance.close(_this.selected.item);
	            _this.Message.success("Registro actualizado correctamente.");
	            _this.$state.reload();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return ParametrosModalController;
	}();
	
	exports.default = ParametrosModalController;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parametros = __webpack_require__(352);
	
	var _parametros2 = _interopRequireDefault(_parametros);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Parametros = angular.module('app.parametros', []).component('appParametros', _parametros2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('configuracion', {
	        url: '/configuracion',
	        component: 'appParametros'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Parametros;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bancoUnion = __webpack_require__(328);
	
	var _bancoUnion2 = _interopRequireDefault(_bancoUnion);
	
	var _ddjj = __webpack_require__(337);
	
	var _ddjj2 = _interopRequireDefault(_ddjj);
	
	var _registroArtesano = __webpack_require__(361);
	
	var _registroArtesano2 = _interopRequireDefault(_registroArtesano);
	
	var _confirmar = __webpack_require__(331);
	
	var _confirmar2 = _interopRequireDefault(_confirmar);
	
	var _verificacion = __webpack_require__(367);
	
	var _verificacion2 = _interopRequireDefault(_verificacion);
	
	var _parametros = __webpack_require__(355);
	
	var _parametros2 = _interopRequireDefault(_parametros);
	
	var _duplicados = __webpack_require__(346);
	
	var _duplicados2 = _interopRequireDefault(_duplicados);
	
	var _correcciones = __webpack_require__(334);
	
	var _correcciones2 = _interopRequireDefault(_correcciones);
	
	var _solicitudesFirma = __webpack_require__(364);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	var _migrados = __webpack_require__(351);
	
	var _migrados2 = _interopRequireDefault(_migrados);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Admin = angular.module('app.adm.probolivia', [_bancoUnion2.default, _ddjj2.default, _registroArtesano2.default, _confirmar2.default, _verificacion2.default, _parametros2.default, _duplicados2.default, _correcciones2.default, _solicitudesFirma2.default, _migrados2.default]).name;
	
	exports.default = Admin;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _registroArtesano = __webpack_require__(358);
	
	var _registroArtesano2 = _interopRequireDefault(_registroArtesano);
	
	var _registroArtesano3 = __webpack_require__(604);
	
	var _registroArtesano4 = _interopRequireDefault(_registroArtesano3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistroArtesanoComponent = {
	    bindings: {},
	    controller: _registroArtesano2.default,
	    template: _registroArtesano4.default
	};
	
	exports.default = RegistroArtesanoComponent;

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegistroArtesanoController = function () {
	  RegistroArtesanoController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Auth", "$location", "Util", "Message", "authUrl", "baseUrl", "$http", "Sidenav"];
	  function RegistroArtesanoController(NgTableParams, $log, Modal, Storage, DataService, Auth, $location, Util, Message, authUrl, baseUrl, $http, Sidenav) {
	    'ngInject';
	
	    _classCallCheck(this, RegistroArtesanoController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Auth = Auth;
	    this.$location = $location;
	    this.Util = Util;
	    this.Message = Message;
	    this.$http = $http;
	    this.baseUrl = baseUrl;
	    this.Sidenav = Sidenav;
	  }
	
	  _createClass(RegistroArtesanoController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.titulo = 'Nombre de página';
	      this.isGeneroOk = true;
	      this.isTipoOk = true;
	      this.isContrasenaOk = false;
	
	      this.cantidadCaracteres = 8;
	      this.codigo = this.$location.search().codigo;
	      if (this.codigo) {
	        this.DataService.post(this.baseUrl + 'certificaciones/verificarUsuario' + '?codigo=' + this.codigo, {}).then(function (response) {
	          if (response) {
	            _this.codigoCoincide = true;
	            _this.usuario = {
	              email: response.correo
	            };
	          }
	        });
	      }
	    }
	  }, {
	    key: 'cleanEstiloGenero',
	    value: function cleanEstiloGenero() {
	      this.isGeneroOk = true;
	    }
	  }, {
	    key: 'cleanEstiloTipo',
	    value: function cleanEstiloTipo() {
	      this.isTipoOk = true;
	    }
	  }, {
	    key: 'registrarUsuario',
	    value: function registrarUsuario() {
	      var _this2 = this;
	
	      //    if (angular.isUndefined(this.usuario.tipo)) {
	      //      this.Message.warning("Debe seleccionar tipo de usuario");
	      //      this.isTipoOk = false;
	      //      return;
	      //    }
	      if (angular.isUndefined(this.usuario.email)) {
	        this.Message.warning("Debe seleccionar un correo electrónico");
	        return;
	      }
	      if (angular.isUndefined(this.usuario.contrasena)) {
	        this.Message.warning("Debe seleccionar una contraseña");
	        return;
	      }
	      if (this.usuario.contrasena.length < this.cantidadCaracteres || this.usuario.contrasenaConfirmacion.length < this.cantidadCaracteres) {
	        this.Message.warning("Debe seleccionar una contraseña con " + this.cantidadCaracteres + " caracteres por lo menos.");
	        return;
	      }
	      if (this.usuario.contrasena !== this.usuario.contrasenaConfirmacion) {
	        this.Message.warning("Su confirmación de contraseña no coincide. Por favor, revise sus datos.");
	        return;
	      }
	      this.usuario.usuario = this.usuario.email;
	      //    this.usuario.tipo = this.usuario.tipo;
	      this.usuario.path = 'dashboard', this.usuario.pathLogin = 'login', this.usuario.menu = false, this.usuario.sidenav = false;
	      this.$log.log(this.usuario);
	      // this.Storage.set('usuarioartesano', this.usuario);
	      if (this.codigo && this.codigoCoincide) {
	        this.usuario.codigo_creacion = this.codigo;
	      }
	
	      this.DataService.post(this.baseUrl + 'crear_cuenta/', this.usuario).then(function (response) {
	        if (response) {
	          _this2.Auth.signin(_this2.usuario);
	        }
	      });
	    }
	  }, {
	    key: 'validarInputs',
	    value: function validarInputs() {
	      this.isContrasenaOk = false;
	
	      if (angular.isUndefined(this.usuario.contrasena)) {
	        this.mensaje1 = '';
	        return;
	      }
	
	      if (this.usuario.contrasena.length < this.cantidadCaracteres) {
	        this.mensaje1 = 'La contraseña debe tener como mínimo ' + this.cantidadCaracteres + ' dígitos';
	        return;
	      }
	
	      this.mensaje1 = '';
	
	      if (angular.isUndefined(this.usuario.contrasenaConfirmacion)) {
	        this.mensaje2 = '';
	        return;
	      }
	      if (this.usuario.contrasenaConfirmacion.length < this.cantidadCaracteres) {
	        this.mensaje2 = 'La confirmación de contraseña debe tener como mínimo ' + this.cantidadCaracteres + ' dígitos';
	        return;
	      }
	      this.mensaje2 = '';
	
	      if (this.usuario.contrasena === this.usuario.contrasenaConfirmacion) {
	        this.isContrasenaOk = true;
	      }
	    }
	  }, {
	    key: 'volverLogin',
	    value: function volverLogin() {
	      var _this3 = this;
	
	      this.Modal.confirm('¿Desea volver al inicio de sesión?', function () {
	        _this3.Sidenav.path("login");
	      });
	    }
	  }]);
	
	  return RegistroArtesanoController;
	}();
	
	exports.default = RegistroArtesanoController;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _registroArtesanoModal = __webpack_require__(360);
	
	var _registroArtesanoModal2 = _interopRequireDefault(_registroArtesanoModal);
	
	var _registroArtesanoModal3 = __webpack_require__(605);
	
	var _registroArtesanoModal4 = _interopRequireDefault(_registroArtesanoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistroArtesanoModalComponent = {
	    bindings: {},
	    controller: _registroArtesanoModal2.default,
	    template: _registroArtesanoModal4.default
	};
	
	exports.default = RegistroArtesanoModalComponent;

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodigoRegArtModalController = function () {
	  CodigoRegArtModalController.$inject = ["$uibModalInstance", "data", "Modal", "Auth", "DataService", "$location", "Storage", "SidenavFactory", "Message"];
	  function CodigoRegArtModalController($uibModalInstance, data, Modal, Auth, DataService, $location, Storage, SidenavFactory, Message) {
	    'ngInject';
	
	    _classCallCheck(this, CodigoRegArtModalController);
	
	    this.items = data;
	    this.usuario = data.usuario;
	    this.correo = data.correo;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$location = $location;
	    this.Modal = Modal;
	    this.Auth = Auth;
	    this.DataService = DataService;
	    this.SidenavFactory = SidenavFactory;
	    this.Storage = Storage;
	    this.Message = Message;
	  }
	
	  _createClass(CodigoRegArtModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.focus = true;
	    }
	  }, {
	    key: 'confirmar',
	    value: function confirmar() {
	      var _this = this;
	
	      this.DataService.put('usuarios/' + this.items.id_usuario + '/confirmar', {
	        email: this.items.correo,
	        codigo_activacion: this.codigo_activacion
	      }).then(function (response) {
	        if (response) {
	          //                let menu = response.menu;
	          //                let user = response.user;
	          //
	          //                this.SidenavFactory.setUser(user);
	          //                this.Storage.setUser(user);
	          //
	          //                this.SidenavFactory.setMenu(menu);
	          //                this.Storage.set('menu', menu);
	          //
	          //                this.SidenavFactory.setVisible(true);
	          //                this.Storage.set('visible', true);
	          //
	          //                this.SidenavFactory.setSidenav(true);
	          //                this.Storage.set('sidenav', true);
	          //                this.$uibModalInstance.close();
	          //                this.$location.path('matricula');
	          //
	          //                this.Message.success('Su registro se completó satisfactoriamente.');
	          _this.Auth.signin({
	            usuario: _this.items.email,
	            contrasena: _this.items.contrasena,
	            path: 'empresa',
	            pathLogin: 'login',
	            menu: false,
	            sidenav: false
	          });
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      var _this2 = this;
	
	      this.focus = false;
	      this.Modal.confirm('¿Realmente quiere cancelar su registro?', function () {
	        _this2.$uibModalInstance.dismiss('cancel');
	        //            this.Auth.logout();
	      }, null, null, 'SI', 'NO');
	    }
	  }, {
	    key: 'reenviarCorreo',
	    value: function reenviarCorreo() {}
	  }, {
	    key: 'editarCorreo',
	    value: function editarCorreo() {}
	  }]);
	
	  return CodigoRegArtModalController;
	}();
	
	exports.default = CodigoRegArtModalController;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registroArtesano = __webpack_require__(357);
	
	var _registroArtesano2 = _interopRequireDefault(_registroArtesano);
	
	var _registroArtesanoModal = __webpack_require__(359);
	
	var _registroArtesanoModal2 = _interopRequireDefault(_registroArtesanoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistroArt = angular.module('app.registro', []).component('registroArtesano', _registroArtesano2.default).component('registroArtesanoModal', _registroArtesanoModal2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('registroArtesano', {
	    url: '/registroArtesano',
	    component: 'registroArtesano'
	  }).state('confirmacion', {
	    url: '/confirmacion',
	    component: 'registroArtesanoModal'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = RegistroArt;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _solicitudesFirma = __webpack_require__(363);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	var _solicitudesFirma3 = __webpack_require__(606);
	
	var _solicitudesFirma4 = _interopRequireDefault(_solicitudesFirma3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudesFirmaPROComponent = {
	  bindings: {},
	  controller: _solicitudesFirma2.default,
	  template: _solicitudesFirma4.default
	};
	
	exports.default = SolicitudesFirmaPROComponent;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _historialModalController = __webpack_require__(84);
	
	var _historialModalController2 = _interopRequireDefault(_historialModalController);
	
	var _historialModal = __webpack_require__(93);
	
	var _historialModal2 = _interopRequireDefault(_historialModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SolicitudesFirmaPROController = function () {
	  SolicitudesFirmaPROController.$inject = ["$scope", "$log", "Message", "Modal", "DataService", "Storage", "$location", "baseUrl", "Demofi"];
	  function SolicitudesFirmaPROController($scope, $log, Message, Modal, DataService, Storage, $location, baseUrl, Demofi) {
	    'ngInject';
	
	    _classCallCheck(this, SolicitudesFirmaPROController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.Message = Message;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.$location = $location;
	    this.baseUrl = baseUrl;
	    this.DataService = DataService;
	    this.Demofi = Demofi;
	    this.noSorting = ['usuario_aprobacion', 'nit', 'persona_representante', 'tipo'];
	  }
	
	  _createClass(SolicitudesFirmaPROController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarTabla();
	      // this.Demofi.openModal([]);
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        'PENDIENTE': 'primary',
	        'FIRMADO': 'success'
	      };
	      this.solicitudes = {
	        url: 'certificaciones/documentos/firmar',
	        queryExtra: { ambito: 'PROBOLIVIA' },
	        data: {
	          formly: [{
	            key: 'id_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'fid_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'formulario',
	            type: 'input',
	            templateOptions: {
	              label: 'Formulario',
	              type: 'text'
	            }
	          }, {
	            key: 'razon_social',
	            type: 'input',
	            templateOptions: {
	              label: 'Razón social',
	              type: 'text'
	            }
	          }, {
	            key: 'matricula_comercio',
	            type: 'input',
	            templateOptions: {
	              label: 'Matrícula',
	              type: 'text'
	            }
	          }, {
	            key: 'nit',
	            type: 'input',
	            templateOptions: {
	              label: 'NIT',
	              type: 'text'
	            }
	          }, {
	            key: 'persona_representante',
	            type: 'input',
	            templateOptions: {
	              label: 'REPRESENTANTE/PROPIETARIO',
	              type: 'text'
	            }
	          }, {
	            key: 'tipo',
	            type: 'text',
	            templateOptions: {
	              label: 'Tipo',
	              type: 'hidden'
	            }
	          }, {
	            key: 'estado_firma',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              "options": [{
	                "value": "FIRMADO",
	                "name": "FIRMADO"
	              }, {
	                "value": "PENDIENTE",
	                "name": "PENDIENTE"
	              }]
	            }
	          }, {
	            key: '_fecha_aprobacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de aprobación',
	              type: 'date'
	            }
	          }, {
	            key: 'usuario_aprobacion',
	            templateOptions: {
	              label: 'Usuario de aprobación',
	              type: 'hidden'
	            }
	          }]
	        },
	        fields: ['id_certificacion', 'fid_unidad_productiva', 'formulario', 'razon_social', 'nit', 'persona_representante', 'unidad_productiva.matricula_comercio', 'estado_firma', 'tipo', 'fid_formulario', '_fecha_aprobacion', 'usuario_aprobacion'],
	        hiddenFields: ['id_certificacion', 'fid_unidad_productiva'],
	        fks: ['fid_formulario'],
	        permission: {
	          create: false,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        checks: {
	          label: 'Firmar solicitudes',
	          if: function _if(item) {
	            return item.estado_firma == 'PENDIENTE';
	          },
	          cbButton: function cbButton(rows) {
	            var docSolicitudes = [];
	            var sol = void 0;
	            rows.forEach(function (it) {
	              if (it.checked) {
	                sol = {
	                  url_source_pdf: _this.DataService.getUrl('certificaciones/' + it.id_certificacion + '/documento_firmar'),
	                  url_upload_pdf: _this.DataService.getUrl('certificaciones/' + it.id_certificacion + '/firma'),
	                  nombre_archivo: 'Certificaci\xF3n ' + it.razon_social, // nombre
	                  codigo_archivo: '' + it.id_certificacion, // id de certificación
	                  authorization: 'Bearer ' + _this.Storage.get('token') // token
	                };
	                docSolicitudes.push(sol);
	              }
	            });
	
	            if (docSolicitudes.length) {
	              // ---------------------------------------  FIRMAR SOLICITUDES ----------------------------------------
	              // console.log(docSolicitudes);
	              // console.log(JSON.stringify(docSolicitudes, null, 2))
	              _this.Demofi.openModal(docSolicitudes).result.then(function (data) {
	                _this.$log.log('THEN modal', data);
	                _this.$scope.$broadcast('refresh_crud_table', _this.solicitudes.url);
	              });
	            } else {
	              _this.Message.warning("Debe seleccionar por lo menos un documento");
	            }
	          }
	        },
	        buttons: [{
	          //icon: 'eye',
	          icon: 'file-pdf-o',
	          tooltip: 'Ver pdf reporte',
	          onclick: function onclick(ev, item) {
	            // this.$log.log(ev, item);
	            _this.Modal.pdf('certificaciones/mostrar_reporte/' + item.id_certificacion);
	          }
	        }, {
	          // icon: 'file-pdf-o',
	          icon: 'file',
	          tooltip: 'Ver certificacion',
	          onclick: function onclick(ev, item) {
	            _this.$log.log('*************************++MOSTRAR CERTIFICADO: ', ev, item);
	            //            this.Modal.pdf(`certificaciones/${item.id_certificacion}/reporte`, 'Certificación');
	            //            this.Modal.pdf('certificaciones/mostrar_certificado/'+item.id_certificacion, 'Certificación');
	
	
	            _this.Modal.pdf('certificaciones/mostrar_certificado/' + item.id_certificacion);
	
	            //            this.Modal.pdf(`certificaciones/generar_certificado/` + item.id_certificacion, 'Certificación');
	            //            var ruta = `certificaciones/generar_certificado/` + certificacion.certificacion.id_certificacion;
	          }
	        }, {
	          icon: 'line-chart',
	          tooltip: 'Ver historial',
	          onclick: function onclick(ev, item) {
	            _this.$log.log('item........', item.persona_representante);
	            _this.Modal.show({
	              template: _historialModal2.default,
	              controller: _historialModalController2.default,
	              data: {
	                id_certificacion: item.id_certificacion,
	                representante: item.persona_representante
	              },
	              size: 'lg'
	            });
	          }
	        }],
	        clases: {
	          'estado_firma': function estado_firma(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado_firma]];
	          }
	        }
	      };
	    }
	  }, {
	    key: 'verDetalleSolicitud',
	    value: function verDetalleSolicitud(item) {
	      this.Storage.set('print_prod', item);
	      this.$location.path('impProductoPromueve');
	    }
	  }]);
	
	  return SolicitudesFirmaPROController;
	}();
	
	exports.default = SolicitudesFirmaPROController;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _solicitudesFirma = __webpack_require__(362);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudesFirmaProbolivia = angular.module('app.adm.probolivia.solicitudesfirma', []).component('appProboliviaSolicitudesFirma', _solicitudesFirma2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('solicitudesFirmaPRO', {
	                url: '/solicitudesFirmaPRO',
	                component: 'appProboliviaSolicitudesFirma'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = SolicitudesFirmaProbolivia;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _verificacion = __webpack_require__(366);
	
	var _verificacion2 = _interopRequireDefault(_verificacion);
	
	var _verificacion3 = __webpack_require__(607);
	
	var _verificacion4 = _interopRequireDefault(_verificacion3);
	
	__webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerificacionComponent = {
	    bindings: {},
	    controller: _verificacion2.default,
	    template: _verificacion4.default
	};
	
	exports.default = VerificacionComponent;

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	'use strict';
	
	// import modalControllerC from './registro.artesano.modal.controller.js';
	// import modalTemplateC from './registro.artesano.modal.html';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VerificacionController = function () {
	  VerificacionController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Auth", "$location", "Util", "Message", "authUrl", "$http", "Sidenav", "$sce", "baseUrl", "$window"];
	  function VerificacionController(NgTableParams, $log, Modal, Storage, DataService, Auth, $location, Util, Message, authUrl, $http, Sidenav, $sce, baseUrl, $window) {
	    'ngInject';
	
	    _classCallCheck(this, VerificacionController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Auth = Auth;
	    this.$location = $location;
	    this.Util = Util;
	    this.Message = Message;
	    this.$http = $http;
	    this.Sidenav = Sidenav;
	    this.$sce = $sce;
	    this.baseUrl = baseUrl;
	    this.$window = $window;
	  }
	
	  _createClass(VerificacionController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.titulo = 'Nombre de página';
	      this.codigo = this.$location.search().codigo;
	      this.isCorrecto = false;
	      //get para identificar datos del certificado
	
	      this.DataService.post(this.baseUrl + 'certificaciones/datos_certificado' + '?codigo=' + this.codigo, {}).then(function (response) {
	        if (response) {
	          _this.informacion = response;
	
	          //get pdf
	          _this.DataService.pdfO(_this.baseUrl + 'certificaciones/generar_certificado' + '?codigo=' + _this.codigo, {}).then(function (response) {
	            if (response) {
	              _this.urlPdf = response;
	              _this.isCorrecto = true;
	              _this.mostrarData = true;
	              _this.$log.log('numero', _this.informacion.ubicacion.numero);
	              if (angular.isUndefined(_this.informacion.ubicacion.numero) || _this.informacion.ubicacion.numero === null) {
	                _this.isNro = false;
	              } else {
	                _this.isNro = true;
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'descargarCertificado',
	    value: function descargarCertificado() {
	      var ruta = this.baseUrl + 'certificaciones/generar_certificado' + '?codigo=' + this.codigo;
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          var fileName = "certificado_generado.pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	        }
	      });
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }]);
	
	  return VerificacionController;
	}();
	
	exports.default = VerificacionController;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _verificacion = __webpack_require__(365);
	
	var _verificacion2 = _interopRequireDefault(_verificacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Verificacion = angular.module('app.verificacion', []).component('verificacion', _verificacion2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('verificacion', {
	    url: '/verificacion',
	    component: 'verificacion'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Verificacion;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _certificacion_prom = __webpack_require__(369);
	
	var _certificacion_prom2 = _interopRequireDefault(_certificacion_prom);
	
	var _certificacion_prom_producto = __webpack_require__(608);
	
	var _certificacion_prom_producto2 = _interopRequireDefault(_certificacion_prom_producto);
	
	__webpack_require__(188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DdjjCertProdComponent = {
	  bindings: {},
	  controller: _certificacion_prom2.default,
	  template: _certificacion_prom_producto2.default
	};
	
	exports.default = DdjjCertProdComponent;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ddjjdetalleModalObsController = __webpack_require__(372);
	
	var _ddjjdetalleModalObsController2 = _interopRequireDefault(_ddjjdetalleModalObsController);
	
	var _ddjjdetalleModalObs = __webpack_require__(610);
	
	var _ddjjdetalleModalObs2 = _interopRequireDefault(_ddjjdetalleModalObs);
	
	var _changeTipoModal = __webpack_require__(371);
	
	var _changeTipoModal2 = _interopRequireDefault(_changeTipoModal);
	
	var _changeTipoModal3 = __webpack_require__(609);
	
	var _changeTipoModal4 = _interopRequireDefault(_changeTipoModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CertificacionProdController = function () {
	  CertificacionProdController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "$location", "$sce"];
	  function CertificacionProdController(NgTableParams, $log, Modal, Storage, DataService, $location, $sce) {
	    'ngInject';
	
	    _classCallCheck(this, CertificacionProdController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.$sce = $sce;
	    this.cshb = true;
	    this.ts = null;
	  }
	
	  _createClass(CertificacionProdController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      this.prod = this.Storage.get('cert_prod');
	      this.getTipoSello(this.prod.tipoSello);
	      this.nombres_insumos_nacionales = this.prod.insumos.map(function (x) {
	        return x.descripcion;
	      }).join(", ");
	      this.$log.log('Ingresandoooooooooooooooo', this.prod);
	    }
	  }, {
	    key: 'getTipoSello',
	    value: function getTipoSello(tipoSello) {
	      if (tipoSello === 1) {
	        this.ts = 'ORO';
	      } else if (tipoSello === 2) {
	        this.ts = 'PLATA';
	      } else {
	        this.ts = 'BRONCE';
	      }
	    }
	  }, {
	    key: 'verDDJJProducto',
	    value: function verDDJJProducto() {
	      this.Modal.pdf("certificacion_promueve/" + this.prod.unidad_productiva.id_unidad_productiva + "/certificacion/" + this.prod.id_producto + "/ddjj_pdf");
	    }
	  }, {
	    key: 'changeTipoSHB',
	    value: function changeTipoSHB() {
	      this.Modal.show({
	        template: _changeTipoModal4.default,
	        controller: _changeTipoModal2.default,
	        data: {
	          titulo: "Cambiar a sello tipo PLATA",
	          accion: "CAMBIAR",
	          detalle_campo: "ingrese la justificación para la modificación del tipo de sello",
	          id_producto: this.prod.id_producto,
	          id_unidad_productiva: this.prod.fid_unidad_productiva,
	          id_certificacion: this.prod.certificacion.id_certificacion
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'volver',
	    value: function volver() {
	      this.$log.log('---Volvemos');
	      this.$location.path('declaracionesJuradasPromueve');
	    }
	  }, {
	    key: 'aprobar',
	    value: function aprobar() {
	      var _this = this;
	
	      this.Modal.confirm('¿Está seguro/a de aprobar la solicitud?', function () {
	        _this.$log.log('---Realizamos la aprobacion');
	        var obj = {
	          idCertificacion: _this.prod.certificacion.id_certificacion,
	          idProducto: _this.prod.id_producto
	        };
	
	        // var ruta = 'certificacion_promueve/' + this.prod.fid_unidad_productiva + '/producto/evaluacion_solicitud';
	        var ruta = 'certificacionesSHB/aprobar';
	        _this.DataService.put(ruta, obj).then(function (response) {
	          if (response) {
	            _this.$log.log('Respuesta***= ', response);
	            _this.$location.path('declaracionesJuradasPromueve');
	          }
	        });
	      });
	      //    this.$location.path('aprobProductoPromueve');
	    }
	  }, {
	    key: 'isTipo',
	    value: function isTipo(tipo) {
	      return this.prod.certificacion.formulario.tipo === tipo;
	    }
	  }, {
	    key: 'rechazar',
	    value: function rechazar() {
	      this.Modal.show({
	        template: _ddjjdetalleModalObs2.default,
	        controller: _ddjjdetalleModalObsController2.default,
	        data: {
	          prefijo: 'rechazar',
	          titulo: "Rechazar",
	          accion: "RECHAZADO",
	          detalle_campo: "Ingresar el motivo por el cual se rechaza la solicitud",
	          id_producto: this.prod.id_producto,
	          id_certificacion: this.prod.certificacion.id_certificacion,
	          id_unidad_productiva: this.prod.fid_unidad_productiva
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'observar',
	    value: function observar() {
	      this.Modal.show({
	        template: _ddjjdetalleModalObs2.default,
	        controller: _ddjjdetalleModalObsController2.default,
	        data: {
	          prefijo: 'observar',
	          titulo: "Observar",
	          accion: "OBSERVADO",
	          detalle_campo: "INGRESAR OBSERVACIÓN",
	          id_certificacion: this.prod.certificacion.id_certificacion,
	          id_producto: this.prod.id_producto,
	          id_unidad_productiva: this.prod.fid_unidad_productiva
	        },
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return CertificacionProdController;
	}();
	
	exports.default = CertificacionProdController;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _certificacion_prom = __webpack_require__(368);
	
	var _certificacion_prom2 = _interopRequireDefault(_certificacion_prom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DdjjProd = angular.module('app.ddjj_prodpromueve', []).component('appDdjjProdPromuevecom', _certificacion_prom2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('ddjj_prod_promueve', {
	                url: '/decDdjjProductoPromueve',
	                component: 'appDdjjProdPromuevecom'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = DdjjProd;

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjProddetalleobsModalController = function () {
	  DdjjProddetalleobsModalController.$inject = ["$uibModalInstance", "data", "$sce", "$log", "DataService", "$state", "$location"];
	  function DdjjProddetalleobsModalController($uibModalInstance, data, $sce, $log, DataService, $state, $location) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjProddetalleobsModalController);
	
	    this.data = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.$state = $state;
	    this.$location = $location;
	  }
	
	  _createClass(DdjjProddetalleobsModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      var obj = {
	        idCertificacion: this.data.id_certificacion,
	        idProducto: this.data.id_producto,
	        motivo: this.observacion
	      };
	
	      var ruta = 'certificacionesSHB/cambiar';
	      this.DataService.put(ruta, obj).then(function (response) {
	        if (response) {
	          _this.$uibModalInstance.close();
	          _this.$log.log('Respuesta***= ', response);
	          _this.$location.path('declaracionesJuradasPromueve');
	        }
	      });
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return DdjjProddetalleobsModalController;
	}();
	
	exports.default = DdjjProddetalleobsModalController;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjProddetalleobsModalController = function () {
	  DdjjProddetalleobsModalController.$inject = ["$uibModalInstance", "data", "$sce", "$log", "DataService", "$state", "$location"];
	  function DdjjProddetalleobsModalController($uibModalInstance, data, $sce, $log, DataService, $state, $location) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjProddetalleobsModalController);
	
	    this.data = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.$state = $state;
	    this.$location = $location;
	  }
	
	  _createClass(DdjjProddetalleobsModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      var request = {
	        idProducto: this.data.id_producto,
	        idCertificacion: this.data.id_certificacion,
	        observacion: this.observacion
	      };
	
	      // var ruta = 'certificacion_promueve/'+this.data.id_unidad_productiva+'/producto/evaluacion_solicitud';
	      var ruta = 'certificacionesSHB/' + this.data.prefijo;
	      this.DataService.put(ruta, request).then(function (response) {
	        if (response) {
	          _this.$uibModalInstance.close();
	          _this.$location.path('declaracionesJuradasPromueve');
	        }
	      });
	
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return DdjjProddetalleobsModalController;
	}();
	
	exports.default = DdjjProddetalleobsModalController;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ddjj_promueve = __webpack_require__(375);
	
	var _ddjj_promueve2 = _interopRequireDefault(_ddjj_promueve);
	
	var _ddjj_promueve3 = __webpack_require__(611);
	
	var _ddjj_promueve4 = _interopRequireDefault(_ddjj_promueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DdjjPromueveComponent = {
	  bindings: {},
	  controller: _ddjj_promueve2.default,
	  template: _ddjj_promueve4.default
	};
	
	exports.default = DdjjPromueveComponent;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _ddjj = __webpack_require__(373);
	
	var _ddjj2 = _interopRequireDefault(_ddjj);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ddjj = angular.module('app.ddjjpromueve', []).component('appDdjjPromuevecom', _ddjj2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('ddjj_promueve', {
	                url: '/declaracionesJuradasPromueve',
	                component: 'appDdjjPromuevecom'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Ddjj;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _historialModalController = __webpack_require__(376);
	
	var _historialModalController2 = _interopRequireDefault(_historialModalController);
	
	var _historialModal = __webpack_require__(612);
	
	var _historialModal2 = _interopRequireDefault(_historialModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjPromueveController = function () {
	  DdjjPromueveController.$inject = ["$log", "Modal", "Storage", "$location", "baseUrl"];
	  function DdjjPromueveController($log, Modal, Storage, $location, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjPromueveController);
	
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.$location = $location;
	    this.baseUrl = baseUrl;
	  }
	
	  _createClass(DdjjPromueveController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        'NUEVO': 'default',
	        'PENDIENTE': 'primary',
	        'APROBADO': 'success',
	        'PENDIENTE_PAGO': 'warning',
	        'OBSERVADO': 'warning',
	        'RECHAZADO': 'danger',
	        'PAGADO': 'default'
	      };
	      this.solicitudes = {
	        url: 'certificacion_promueve/certificaciones/solicitudes',
	        queryExtra: { origenBandeja: 'solicitudes' },
	        data: {
	          formly: [//id_sello_bolivia, razon_social, estado
	          {
	            key: 'id_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'id producto',
	              type: 'number'
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'data',
	            type: 'input',
	            templateOptions: {
	              label: 'data',
	              type: 'number'
	            }
	          }, {
	            key: 'ruta_imagen',
	            type: 'archive',
	            templateOptions: {
	              label: 'Foto',
	              type: 'img'
	            }
	          }, {
	            key: 'razon_social',
	            type: 'input',
	            templateOptions: {
	              label: 'Razón social',
	              type: 'text'
	            }
	          }, {
	            key: 'matricula_comercio',
	            type: 'input',
	            templateOptions: {
	              label: 'Matrícula',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Producto',
	              type: 'text'
	            }
	          }, {
	            key: 'estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{
	                "value": "PENDIENTE",
	                "name": "PENDIENTE"
	              }, {
	                "value": "APROBADO",
	                "name": "APROBADO"
	              }, {
	                "value": "OBSERVADO",
	                "name": "OBSERVADO"
	              }, {
	                "value": "RECHAZADO",
	                "name": "RECHAZADO"
	              }]
	            }
	          }, {
	            key: 'nro_secuencia',
	            type: 'input',
	            templateOptions: {
	              label: 'MEFP',
	              type: 'text'
	            },
	            class: 'text-center',
	            next: {
	              key: 'nro_solicitud',
	              label: 'Secuencia | Solicitud'
	            }
	          }, {
	            key: 'nro_solicitud',
	            type: 'input',
	            templateOptions: {
	              label: '# solicitud',
	              type: 'Number'
	            }
	          }, {
	            key: 'fecha_envio',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha envío',
	              type: 'date'
	            },
	            class: 'text-center'
	          }, {
	            key: 'fecha_aprobacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha evaluación',
	              type: 'date'
	            },
	            class: 'text-center'
	          }, {
	            key: 'observacion',
	            type: 'input',
	            templateOptions: {
	              label: '',
	              type: 'text'
	            }
	          }]
	        },
	        fields: ['id_unidad_productiva', 'id_producto', 'data', 'ruta_imagen', 'razon_social', 'matricula_comercio', 'nombre_producto', 'estado', 'fid_formulario', 'fecha_envio', 'fecha_aprobacion', 'nro_secuencia', 'nro_solicitud', 'observacion'],
	        hiddenFields: ['id_unidad_productiva', 'id_producto', 'data', 'nro_solicitud', 'observacion'],
	        fks: ['fid_formulario'],
	        permission: {
	          create: false,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        buttons: [
	        // {
	        //   icon: 'file-pdf-o',
	        //   tooltip: 'Ver pdf del producto',
	        //   onclick: (ev, item) => {
	        //     // this.$log.log(ev, item);
	        //     this.Modal.pdf("certisficacion_promueve/" + item.id_unidad_productiva + "/certificacion/" + item.id_producto + "/ddjj_pdf", null, item.estado==='RECHAZADO'?item.observaciones:null);
	        //   }
	        // },
	        {
	          if: function _if(ev, item) {
	            return ['APROBADO', 'RECHAZADO', 'OBSERVADO'].includes(item.estado);
	          },
	          icon: 'eye',
	          tooltip: 'Ver detalles de producto',
	          onclick: function onclick(ev, item) {
	            if (item.estado == 'APROBADO') {
	              item.observacion = '';
	            }
	            _this.Modal.pdf("certificacion_promueve/" + item.id_unidad_productiva + "/certificacion/" + item.id_producto + "/ddjj_pdf", null, item.observacion);
	          }
	        }, {
	          icon: 'eye',
	          tooltip: 'Ver detalles de solicitud',
	          if: function _if(ev, item) {
	            return item.estado === 'PENDIENTE';
	          },
	          onclick: function onclick(ev, item) {
	            item.insumos = item.data.insumos;
	            angular.merge(item, item.data);
	            delete item.data;
	            _this.Storage.set('cert_prod', item);
	            _this.$location.path('decDdjjProductoPromueve');
	          }
	        }, {
	          icon: 'line-chart',
	          tooltip: 'Ver historial del producto',
	          // if: (ev, item) => {
	          //   return item.estado==='PENDIENTE';
	          // },
	          onclick: function onclick(ev, item) {
	            _this.Modal.show({
	              template: _historialModal2.default,
	              controller: _historialModalController2.default,
	              data: {
	                id_producto: item.id_producto
	              },
	              size: 'lg'
	            });
	          }
	        }],
	        clases: {
	          'estado': function estado(item) {
	            return ['badge', 'badge-' + colors[item.estado]];
	          }
	        }
	      };
	    }
	  }, {
	    key: 'verDetalleSolicitud',
	    value: function verDetalleSolicitud(item) {
	      this.Storage.set('print_prod', item);
	      this.$location.path('impProductoPromueve');
	    }
	  }]);
	
	  return DdjjPromueveController;
	}();
	
	exports.default = DdjjPromueveController;

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HistorialModalController = function () {
	  HistorialModalController.$inject = ["NgTableParams", "DataService", "Storage", "Sidenav", "Modal", "$log", "Util", "$uibModalInstance", "$filter", "data"];
	  function HistorialModalController(NgTableParams, DataService, Storage, Sidenav, Modal, $log, Util, $uibModalInstance, $filter, data) {
	    'ngInject';
	
	    _classCallCheck(this, HistorialModalController);
	
	    this.NgTableParams = NgTableParams;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.Sidenav = Sidenav;
	    this.$log = $log;
	    this.Util = Util;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$filter = $filter;
	    this.data = data;
	  }
	
	  _createClass(HistorialModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.id_producto = this.data.id_producto;
	
	      this.DataService.get('certificacion_promueve/' + this.id_producto + '/historial').then(function (response) {
	        _this.Tiempos = response;
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	    }
	  }]);
	
	  return HistorialModalController;
	}();
	
	exports.default = HistorialModalController;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _impresion_prom = __webpack_require__(378);
	
	var _impresion_prom2 = _interopRequireDefault(_impresion_prom);
	
	var _impresion_prom_producto = __webpack_require__(613);
	
	var _impresion_prom_producto2 = _interopRequireDefault(_impresion_prom_producto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImpProdComponent = {
	  bindings: {},
	  controller: _impresion_prom2.default,
	  template: _impresion_prom_producto2.default
	};
	
	exports.default = ImpProdComponent;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pagorechazoModalObsController = __webpack_require__(380);
	
	var _pagorechazoModalObsController2 = _interopRequireDefault(_pagorechazoModalObsController);
	
	var _pagorechazoModalObs = __webpack_require__(614);
	
	var _pagorechazoModalObs2 = _interopRequireDefault(_pagorechazoModalObs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImpresionProdController = function () {
	  ImpresionProdController.$inject = ["$log", "Modal", "Storage", "DataService", "Message", "$location", "$window", "Loading"];
	  function ImpresionProdController($log, Modal, Storage, DataService, Message, $location, $window, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ImpresionProdController);
	
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.$window = $window;
	    this.Message = Message;
	    this.Loading = Loading;
	  }
	
	  _createClass(ImpresionProdController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.Loading.show('Cargando', true);
	
	      this.solicitud = this.Storage.get('print_prod');
	      this.requiredFields = true;
	      this.ddjjPdf = null;
	
	      var url = 'certificacion_promueve/' + this.solicitud.id_unidad_productiva + '/certificacion/' + this.solicitud.id_producto + '/ddjj_pdf';
	      this.DataService.pdfO(url, {}).then(function (response) {
	        if (response) {
	          _this.ddjjPdf = response;
	          _this.$log.log("FINALIZADO");
	        }
	        _this.Loading.hide();
	      });
	    }
	  }, {
	    key: 'atras',
	    value: function atras() {
	      this.$location.path('certificaciones');
	    }
	  }, {
	    key: 'imprimir',
	    value: function imprimir(producto) {
	      var printwWindow = this.$window.open(producto.pdf_certificado);
	      printwWindow.print();
	
	      var this_ = this;
	      setTimeout(function () {
	        this_.confirmarImpresion(producto);
	      }, 2000);
	    }
	  }, {
	    key: 'confirmarImpresion',
	    value: function confirmarImpresion(cert) {
	      var this_ = this;
	      this.Modal.confirm('¿La impresión se realizó correctamente?', function () {
	        this_.$log.log('---Realizamos la aprobacion');
	        var obj = {
	          id_producto: cert.certificacion.producto.id_producto
	        };
	
	        this_.DataService.put('certificacion_promueve/' + this_.solicitud.unidad_productiva.id_unidad_productiva + '/producto/imprimir_certificado', obj).then(function (response) {
	          if (response) {
	            cert.certificacion.impreso = true;
	          }
	        });
	      }, null, "Confirmar impresión", "SI", "NO", "print");
	    }
	
	    // Deprecado: 18/02/2022
	
	  }, {
	    key: 'registrarFactura_deprecated',
	    value: function registrarFactura_deprecated(form) {
	      if (form.$valid) {
	        var this_ = this;
	        var productos = [];
	        var id_certificacion = null;
	        if (this_.solicitud.certificaciones_pagos.length > 0) {
	          this_.solicitud.certificaciones_pagos.forEach(function (certificacion) {
	            productos.push(certificacion.certificacion.producto.id_producto);
	            id_certificacion = certificacion.fid_certificacion;
	          });
	        }
	        var obj = {
	          nro_autorizacion: this.numero_autorizacion,
	          nro_factura: this.numero_factura,
	          fecha_factura: this.fecha_factura,
	          codigo_control: this.codigo_control,
	          nit: this.solicitud.unidad_productiva.nit,
	          id_pago: this.solicitud.id_pago,
	          productos: productos,
	          id_certificacion: id_certificacion
	        };
	        this_.DataService.put('certificacion_promueve/pagos/finalizar', obj).then(function (response) {
	          if (response) {
	            this_.$location.path('certificaciones');
	          }
	        });
	      } else {
	        form.$setSubmitted();
	      }
	    }
	  }, {
	    key: 'aprobar',
	    value: function aprobar(form) {
	      var _this2 = this;
	
	      this.requiredFields = true;
	      if (form.$valid && this.numero_autorizacion && this.numero_factura && this.fecha_factura) {
	        this.Modal.confirm('¿Está seguro/a de aprobar la solicitud?', function () {
	          var this_ = _this2;
	          var id_certificacion = _this2.getIdCertificacion();
	
	          if (id_certificacion) {
	            var obj = {
	              nro_autorizacion: _this2.numero_autorizacion,
	              nro_factura: _this2.numero_factura,
	              fecha_factura: _this2.fecha_factura,
	              nit: _this2.solicitud.nit,
	              id_pago: _this2.solicitud.id_pago,
	              id_certificacion: id_certificacion
	            };
	            this_.DataService.put('certificacion_promueve/pagos/finalizar', obj).then(function (response) {
	              if (response) {
	                _this2.Message.success('La certificación ha sido aprobado satisfactoriamente', 'información');
	                this_.$location.path('certificaciones');
	              }
	            });
	          } else {
	            _this2.Message.error('No es posible identificar a la certificación actual');
	          }
	        });
	      } else {
	        form.$setSubmitted();
	      }
	    }
	  }, {
	    key: 'rechazar',
	    value: function rechazar() {
	      this.requiredFields = false;
	      this.Modal.show({
	        template: _pagorechazoModalObs2.default,
	        controller: _pagorechazoModalObsController2.default,
	        data: {
	          prefijo: 'rechazar',
	          titulo: "Rechazar",
	          accion: "RECHAZADO",
	          detalle_campo: "Ingresar el motivo por el cual se rechaza la solicitud de certificación",
	          id_pago: this.solicitud.id_pago,
	          id_certificacion: this.getIdCertificacion()
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'getIdCertificacion',
	    value: function getIdCertificacion() {
	      return this.solicitud.id_certificacion;
	    }
	  }]);
	
	  return ImpresionProdController;
	}();
	
	exports.default = ImpresionProdController;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _impresion_prom = __webpack_require__(377);
	
	var _impresion_prom2 = _interopRequireDefault(_impresion_prom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AprobProd = angular.module('impresion_prom.module', []).component('appImpProdPromuevecom', _impresion_prom2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('apro_prod_promueve', {
	                url: '/impProductoPromueve',
	                component: 'appImpProdPromuevecom'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = AprobProd;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PagoRechazoModalController = function () {
	  PagoRechazoModalController.$inject = ["$uibModalInstance", "data", "$sce", "$log", "DataService", "Message", "$state", "$location"];
	  function PagoRechazoModalController($uibModalInstance, data, $sce, $log, DataService, Message, $state, $location) {
	    'ngInject';
	
	    _classCallCheck(this, PagoRechazoModalController);
	
	    this.data = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$sce = $sce;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.$state = $state;
	    this.$location = $location;
	    this.Message = Message;
	  }
	
	  _createClass(PagoRechazoModalController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      var dataRequest = {
	        id_pago: this.data.id_pago,
	        id_certificacion: this.data.id_certificacion,
	        observacion: this.observacion
	      };
	
	      var ruta = 'certificacion_promueve/pagos/rechazar';
	      this.DataService.put(ruta, dataRequest).then(function (response) {
	        if (response) {
	          _this.$uibModalInstance.close();
	          _this.Message.success('El rechazo de la certificación se ha procesado satisfactoriamente', 'Notificación');
	          _this.$location.path('certificaciones');
	        }
	      });
	
	      this.$uibModalInstance.close();
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return PagoRechazoModalController;
	}();
	
	exports.default = PagoRechazoModalController;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pagos_promueve = __webpack_require__(383);
	
	var _pagos_promueve2 = _interopRequireDefault(_pagos_promueve);
	
	var _pagos_promueve3 = __webpack_require__(615);
	
	var _pagos_promueve4 = _interopRequireDefault(_pagos_promueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PagosPromueveComponent = {
	  bindings: {},
	  controller: _pagos_promueve2.default,
	  template: _pagos_promueve4.default
	};
	
	exports.default = PagosPromueveComponent;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _pagos = __webpack_require__(381);
	
	var _pagos2 = _interopRequireDefault(_pagos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pagos = angular.module('app.pagospromueve', []).component('appPagosPromuevecom', _pagos2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('pagos_promueve', {
	                url: '/certificaciones',
	                component: 'appPagosPromuevecom'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Pagos;

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	// import modalControllerHistorial from './historial.modal.controller.js';
	// import modalTemplateHistorial from './historial.modal.html';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PagosPromueveController = function () {
	  PagosPromueveController.$inject = ["$log", "Modal", "Storage", "$location", "baseUrl"];
	  function PagosPromueveController($log, Modal, Storage, $location, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, PagosPromueveController);
	
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.$location = $location;
	    this.baseUrl = baseUrl;
	  }
	
	  _createClass(PagosPromueveController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        'RENOVACION': 'success',
	        'REGISTRO': 'info-second'
	      };
	      this.solicitudes = {
	        url: 'certificacion_promueve/certificaciones/impresiones',
	        data: {
	          formly: [{
	            key: 'id_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'id producto',
	              type: 'number'
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'id_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'Certificación',
	              type: 'number'
	            }
	          }, {
	            key: 'id_pago',
	            type: 'input',
	            templateOptions: {
	              label: 'Pago',
	              type: 'number'
	            }
	          }, {
	            key: 'certificacion_pago_estado',
	            type: 'input',
	            templateOptions: {
	              label: 'pago estado',
	              type: 'text'
	            }
	          }, {
	            key: 'data',
	            type: 'input',
	            templateOptions: {
	              label: 'data',
	              type: 'number'
	            }
	          }, {
	            key: 'ruta_imagen',
	            type: 'archive',
	            templateOptions: {
	              label: 'Foto',
	              type: 'img'
	            }
	          }, {
	            key: 'razon_social',
	            type: 'input',
	            templateOptions: {
	              label: 'Razón social',
	              type: 'text'
	            }
	          }, {
	            key: 'nit',
	            type: 'input',
	            templateOptions: {
	              label: 'NIT',
	              type: 'text'
	            }
	          }, {
	            key: 'matricula_comercio',
	            type: 'input',
	            templateOptions: {
	              label: 'Matrícula',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Producto',
	              type: 'text'
	            }
	          }, {
	            key: 'nro_secuencia',
	            type: 'input',
	            templateOptions: {
	              label: 'MEFP',
	              type: 'text'
	            },
	            class: 'text-center',
	            next: {
	              key: 'nro_solicitud',
	              label: 'Secuencia | Solicitud'
	            }
	          }, {
	            key: 'nro_solicitud',
	            type: 'input',
	            templateOptions: {
	              label: '# solicitud',
	              type: 'Number'
	            }
	          }, {
	            key: 'pago_fecha_envio',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha envío',
	              type: 'date'
	            },
	            class: 'text-center'
	          }, {
	            key: 'tipo',
	            type: 'select',
	            templateOptions: {
	              label: 'Tipo',
	              type: 'select',
	              options: [{
	                "value": "RENOVACION",
	                "name": "RENOVACIÓN"
	              }, {
	                "value": "REGISTRO",
	                "name": "REGISTRO"
	              }]
	            }
	          }]
	        },
	        fields: ['id_unidad_productiva', 'id_producto', 'id_certificacion', 'id_pago', 'data', 'ruta_imagen', 'nit', 'razon_social', 'matricula_comercio', 'nombre_producto', 'pago_fecha_envio', 'tipo', 'nro_secuencia', 'nro_solicitud', 'certificacion_pago_estado'],
	        hiddenFields: ['id_unidad_productiva', 'id_producto', 'id_certificacion', 'id_pago', 'data', 'nro_solicitud', 'certificacion_pago_estado'],
	        fks: ['fid_formulario'],
	        permission: {
	          create: false,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver detalles del producto y depósito',
	          onclick: function onclick(ev, item) {
	            _this.verDetalleSolicitud(item);
	          }
	        }],
	        clases: {
	          'tipo': function tipo(item) {
	            return ['badge', 'badge-' + colors[item.tipo]];
	          }
	        }
	      };
	    }
	  }, {
	    key: 'verDetalleSolicitud',
	    value: function verDetalleSolicitud(item) {
	      var data_form = {
	        id_certificacion: item.id_certificacion,
	        id_producto: item.id_producto,
	        id_unidad_productiva: item.id_unidad_productiva,
	        id_pago: item.id_pago,
	        certificacion_pago_estado: item.certificacion_pago_estado,
	        nit: item.nit,
	        razon_social: item.razon_social,
	        nombre_producto: item.nombre_producto,
	        deposito: item.data.deposito,
	        factura: item.data.factura
	      };
	      this.Storage.set('print_prod', data_form);
	      this.$location.path('impProductoPromueve');
	    }
	  }]);
	
	  return PagosPromueveController;
	}();
	
	exports.default = PagosPromueveController;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ddjj = __webpack_require__(374);
	
	var _ddjj2 = _interopRequireDefault(_ddjj);
	
	var _certificacion_prom = __webpack_require__(370);
	
	var _certificacion_prom2 = _interopRequireDefault(_certificacion_prom);
	
	var _rechazados = __webpack_require__(386);
	
	var _rechazados2 = _interopRequireDefault(_rechazados);
	
	var _impresion_prom = __webpack_require__(379);
	
	var _impresion_prom2 = _interopRequireDefault(_impresion_prom);
	
	var _pagos = __webpack_require__(382);
	
	var _pagos2 = _interopRequireDefault(_pagos);
	
	var _solicitudesFirma = __webpack_require__(390);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Admin = angular.module('app.adm.promueve', [_ddjj2.default, _certificacion_prom2.default, _rechazados2.default, _impresion_prom2.default, _pagos2.default, _solicitudesFirma2.default]).name;
	
	exports.default = Admin;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rechazados_promueve = __webpack_require__(387);
	
	var _rechazados_promueve2 = _interopRequireDefault(_rechazados_promueve);
	
	var _rechazados_promueve3 = __webpack_require__(616);
	
	var _rechazados_promueve4 = _interopRequireDefault(_rechazados_promueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RechazadosPromueveComponent = {
	  bindings: {},
	  controller: _rechazados_promueve2.default,
	  template: _rechazados_promueve4.default
	};
	
	exports.default = RechazadosPromueveComponent;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _rechazados = __webpack_require__(385);
	
	var _rechazados2 = _interopRequireDefault(_rechazados);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ddjj = angular.module('app.rechazados_promueve', []).component('appRechazadosImpPromuevecom', _rechazados2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('rechazados_imp_promueve', {
	                url: '/tramitesConcluidos',
	                component: 'appRechazadosImpPromuevecom'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Ddjj;

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjPromueveController = function () {
	  DdjjPromueveController.$inject = ["$log", "Modal", "Storage", "$location", "baseUrl"];
	  function DdjjPromueveController($log, Modal, Storage, $location, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjPromueveController);
	
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.$location = $location;
	    this.baseUrl = baseUrl;
	  }
	
	  _createClass(DdjjPromueveController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        'APROBADO': 'success',
	        'RECHAZADO': 'danger',
	        'ANULADO': 'info'
	      };
	      var coloresRenovacion = {
	        'RENOVACION': 'success-second',
	        'REGISTRO': 'info-second'
	      };
	      this.solicitudes = {
	        url: 'certificacion_promueve/certificaciones/solicitudes',
	        queryExtra: { origenBandeja: 'rechazados' },
	        data: {
	          formly: [{
	            key: 'id_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'id producto',
	              type: 'number'
	            }
	          }, {
	            key: 'id_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'id certificacion',
	              type: 'number'
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'data',
	            type: 'input',
	            templateOptions: {
	              label: 'data',
	              type: 'number'
	            }
	          }, {
	            key: 'ruta_imagen',
	            type: 'archive',
	            templateOptions: {
	              label: 'Foto',
	              type: 'img'
	            }
	          }, {
	            key: 'razon_social',
	            type: 'input',
	            templateOptions: {
	              label: 'Razón social',
	              type: 'text'
	            }
	          }, {
	            key: 'matricula_comercio',
	            type: 'input',
	            templateOptions: {
	              label: 'Matrícula',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Producto',
	              type: 'text'
	            }
	          }, {
	            key: 'estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              options: [{
	                "value": "RECHAZADO",
	                "name": "RECHAZADO"
	              }, {
	                "value": "APROBADO",
	                "name": "APROBADO"
	              }, {
	                "value": "ANULADO",
	                "name": "ANULADO"
	              }]
	            }
	          }, {
	            key: 'nro_secuencia',
	            type: 'input',
	            templateOptions: {
	              label: 'MEFP',
	              type: 'text'
	            },
	            class: 'text-center',
	            next: {
	              key: 'nro_solicitud',
	              label: 'Secuencia | Solicitud'
	            }
	          }, {
	            key: 'nro_solicitud',
	            type: 'input',
	            templateOptions: {
	              label: 'Solicitud MEFP',
	              type: 'text'
	            }
	          }, {
	            key: 'fecha_envio',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha envío',
	              type: 'date'
	            },
	            class: 'text-center'
	          }, {
	            key: 'fecha_aprobacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha evaluación',
	              type: 'date'
	            },
	            class: 'text-center'
	          }, {
	            key: 'tipo',
	            type: 'select',
	            templateOptions: {
	              label: 'Tipo',
	              type: 'select',
	              options: [{
	                "value": "RENOVACION",
	                "name": "RENOVACIÓN"
	              }, {
	                "value": "REGISTRO",
	                "name": "REGISTRO"
	              }]
	            }
	          }, {
	            key: 'observacion',
	            type: 'input',
	            templateOptions: {
	              label: '',
	              type: 'text'
	            }
	          }]
	        },
	        fields: ['id_unidad_productiva', 'id_producto', 'id_certificacion', 'data', 'ruta_imagen', 'razon_social', 'matricula_comercio', 'cuce', 'nombre_producto', 'estado', 'fid_formulario', 'fecha_envio', 'fecha_aprobacion', 'tipo', 'nro_secuencia', 'nro_solicitud', 'observacion'],
	        hiddenFields: ['id_unidad_productiva', 'id_producto', 'id_certificacion', 'data', 'nro_solicitud', 'observacion'],
	        fks: ['fid_formulario'],
	        permission: {
	          create: false,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver detalles de producto',
	          onclick: function onclick(ev, item) {
	            if (item.estado == 'APROBADO') {
	              item.observacion = '';
	            }
	            _this.Modal.pdf("certificacion_promueve/" + item.id_unidad_productiva + "/certificacion/" + item.id_producto + "/ddjj_pdf", null, item.observacion);
	          }
	        }, {
	          if: function _if(ev, item) {
	            return item.estado === 'APROBADO';
	          },
	          icon: 'file-pdf-o',
	          tooltip: 'Ver certificado',
	          onclick: function onclick(ev, item) {
	            _this.Modal.pdf('certificaciones/documento/' + item.id_certificacion, 'Certificación');
	          }
	        }],
	        clases: {
	          'estado': function estado(item) {
	            return ['badge', 'badge-' + colors[item.estado]];
	          },
	          'tipo': function tipo(item) {
	            return ['badge', 'badge-' + coloresRenovacion[item.tipo]];
	          }
	        }
	      };
	    }
	  }, {
	    key: 'verDetalleSolicitud',
	    value: function verDetalleSolicitud(item) {
	      this.Storage.set('print_prod', item);
	      this.$location.path('impProductoPromueve');
	    }
	  }]);
	
	  return DdjjPromueveController;
	}();
	
	exports.default = DdjjPromueveController;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _solicitudesFirma = __webpack_require__(389);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	var _solicitudesFirma3 = __webpack_require__(617);
	
	var _solicitudesFirma4 = _interopRequireDefault(_solicitudesFirma3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudesFirmaProComponent = {
	  bindings: {},
	  controller: _solicitudesFirma2.default,
	  template: _solicitudesFirma4.default
	};
	
	exports.default = SolicitudesFirmaProComponent;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SolicitudesFirmaSHBController = function () {
	  SolicitudesFirmaSHBController.$inject = ["$scope", "$log", "Message", "Modal", "DataService", "Storage", "$location", "baseUrl", "Demofi"];
	  function SolicitudesFirmaSHBController($scope, $log, Message, Modal, DataService, Storage, $location, baseUrl, Demofi) {
	    'ngInject';
	
	    _classCallCheck(this, SolicitudesFirmaSHBController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.Message = Message;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.$location = $location;
	    this.baseUrl = baseUrl;
	    this.DataService = DataService;
	    this.Demofi = Demofi;
	  }
	
	  _createClass(SolicitudesFirmaSHBController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarTabla();
	      // this.Demofi.openModal([]);
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        'PENDIENTE': 'primary',
	        'FIRMADO': 'success'
	      };
	      //http://localhost:4000/api/v1/certificacion_promueve/certificaciones/solicitudes/firma
	      this.solicitudes = {
	        url: 'certificacion_promueve/certificaciones/solicitudes/firma',
	        //queryExtra: {estado:'APROBADO'},
	        data: {
	          formly: [{
	            key: 'id_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'id_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'id producto',
	              type: 'number'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Nombre del Producto',
	              type: 'text'
	            }
	          }, {
	            key: 'estado_firma',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              "options": [{
	                "value": "FIRMADO",
	                "name": "FIRMADO"
	              }, {
	                "value": "PENDIENTE",
	                "name": "PENDIENTE"
	              }]
	            }
	          }, {
	            key: '_fecha_creacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de creación',
	              type: 'date'
	            }
	          }, {
	            key: 'fid_formulario',
	            type: 'select',
	            templateOptions: {
	              label: 'Tipo producto',
	              type: 'select',
	              "options": [{
	                "value": 3,
	                "name": "BIEN PRODUCIDO"
	              }, {
	                "value": 4,
	                "name": "COSTO BRUTO"
	              }]
	            }
	          }]
	        },
	        fields: ['id_certificacion', 'id_unidad_productiva', 'id_producto', 'nombre_producto', 'estado_firma', '_fecha_creacion', 'fid_formulario'],
	        hiddenFields: ['id_producto', 'id_certificacion', 'id_unidad_productiva'],
	        fks: ['fid_certificacion', 'fid_formulario'],
	        permission: {
	          create: false,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        // checks: {
	        //   label: 'Firmar solicitudes',
	        //   if: (item) => { return item.estado_firma=='PENDIENTE';},
	        //   // cbCheck: () => {
	        //   //   this.$log.log('Event check');
	        //   // },
	        //   cbButton: rows => {
	        //     const docSolicitudes = [];
	        //     let sol;
	        //     // this.$log.log('Event butoon', rows, this.Demofi);
	        //     rows.forEach( it => {
	        //       if (it.checked) {
	        //         sol = {
	        //           url_source_pdf: this.DataService.getUrl(`certificaciones_promueve/${it.id_certificacion}/documento_firmar`),
	        //           url_upload_pdf: this.DataService.getUrl(`certificaciones_promueve/firma/actualizar/`),
	        //           nombre_archivo: `Producto ${it.nombre_producto}`, // nombre del producto
	        //           codigo_archivo: `${it.id_certificacion}`, // id de certificacion
	        //           authorization: `Bearer ${this.Storage.get('token')}`, // token
	        //         };
	        //         docSolicitudes.push(sol);
	        //       }
	        //     })
	
	        //     if (docSolicitudes.length) {
	        //       // ---------------------------------------  FIRMAR SOLICITUDES ----------------------------------------
	        //       // console.log(docSolicitudes);
	        //       // console.log(JSON.stringify(docSolicitudes, null, 2))
	        //       this.Demofi.openModal(docSolicitudes).result
	        //       .then( data => {
	        //         this.$log.log('THEN modal', data);
	        //         this.$scope.$broadcast('refresh_crud_table', this.solicitudes.url)
	        //       })
	        //     } else {
	        //       this.Message.warning("Debe seleccionar por lo menos un documento");
	        //     }
	        //   }
	        // },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver pdf del producto',
	          onclick: function onclick(ev, item) {
	            _this.$log.log(ev, item);
	            _this.Modal.pdf('certificacion_promueve/' + item.id_unidad_productiva + '/certificacion/' + item.id_producto + '/ddjj_pdf');
	          }
	        }, {
	          icon: 'file-pdf-o',
	          tooltip: 'Ver certificacion',
	          onclick: function onclick(ev, item) {
	            // this.$log.log(ev, item);
	            _this.Modal.pdf('certificaciones/documento/' + item.id_certificacion, 'Certificación');
	          }
	        }],
	        clases: {
	          'estado_firma': function estado_firma(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado_firma]];
	          }
	        }
	      };
	    }
	  }, {
	    key: 'verDetalleSolicitud',
	    value: function verDetalleSolicitud(item) {
	      this.Storage.set('print_prod', item);
	      this.$location.path('impProductoPromueve');
	    }
	  }]);
	
	  return SolicitudesFirmaSHBController;
	}();
	
	exports.default = SolicitudesFirmaSHBController;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _solicitudesFirma = __webpack_require__(388);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudesFirma = angular.module('app.adm.promueve.solicitudesfirma', []).component('appPromueveSolicitudesFirma', _solicitudesFirma2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('solicitudesFirmaPro', {
	                url: '/solicitudesFirmaPro',
	                component: 'appPromueveSolicitudesFirma'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = SolicitudesFirma;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ddjj = __webpack_require__(392);
	
	var _ddjj2 = _interopRequireDefault(_ddjj);
	
	var _ddjj3 = __webpack_require__(618);
	
	var _ddjj4 = _interopRequireDefault(_ddjj3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudesPromueveComponent = {
	  bindings: {},
	  controller: _ddjj2.default,
	  template: _ddjj4.default
	};
	
	exports.default = SolicitudesPromueveComponent;

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjSelloboliviaController = function () {
	  DdjjSelloboliviaController.$inject = ["Modal", "Storage", "$location", "baseUrl"];
	  function DdjjSelloboliviaController(Modal, Storage, $location, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjSelloboliviaController);
	
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.$location = $location;
	    this.baseUrl = baseUrl;
	    this.noSorting = [];
	  }
	
	  _createClass(DdjjSelloboliviaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        'PENDIENTE': 'primary',
	        'APROBADO': 'success',
	        'OBSERVADO': 'warning',
	        'RECHAZADO': 'danger'
	      };
	      this.solicitudes = {
	        url: 'cert_sello_bolivia/solicitudes',
	        data: {
	          formly: [{
	            key: 'id_sello_bolivia',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'id_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'ID cert',
	              type: 'number'
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'id_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'id producto',
	              type: 'number'
	            }
	          }, {
	            key: 'extra',
	            type: 'input',
	            templateOptions: {
	              label: 'Fid caeb',
	              type: 'number'
	            }
	          }, {
	            key: 'razon_social',
	            type: 'input',
	            templateOptions: {
	              label: 'Razón social',
	              type: 'text'
	            }
	          }, {
	            key: 'matricula_comercio',
	            type: 'input',
	            templateOptions: {
	              label: 'Matrícula',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Producto',
	              type: 'text'
	            }
	          }, {
	            key: 'ddjj_estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              "options": [{
	                "value": "PENDIENTE",
	                "name": "PENDIENTE"
	              }, {
	                "value": "APROBADO",
	                "name": "APROBADO"
	              }, {
	                "value": "OBSERVADO",
	                "name": "OBSERVADO"
	              }, {
	                "value": "RECHAZADO",
	                "name": "RECHAZADO"
	              }]
	            }
	          }, {
	            key: '_fecha_envio',
	            type: 'datepicker',
	            class: 'text-center',
	            templateOptions: {
	              label: 'Fecha envío',
	              type: 'date'
	            }
	          }, {
	            key: 'ddjj_fecha_aprobacion',
	            type: 'datepicker',
	            class: 'text-center',
	            templateOptions: {
	              label: 'Fecha evaluación',
	              type: 'date'
	            }
	          }, {
	            key: 'nro_secuencia',
	            type: 'input',
	            templateOptions: {
	              label: 'MEFP',
	              type: 'text'
	            },
	            class: 'text-center',
	            next: {
	              key: 'nro_solicitud',
	              label: 'Secuencia | Solicitud'
	            }
	          }, {
	            key: 'nro_solicitud',
	            type: 'input',
	            templateOptions: {
	              label: '',
	              type: 'text'
	            }
	          }, {
	            key: 'ddjj_observacion',
	            type: 'input',
	            templateOptions: {
	              label: '',
	              type: 'text'
	            }
	          }]
	        },
	        fields: ['id_sello_bolivia', 'id_certificacion', 'id_unidad_productiva', 'id_producto', 'extra', 'razon_social', 'matricula_comercio', 'nombre_producto', 'ddjj_estado', 'fid_formulario', '_fecha_envio', 'ddjj_fecha_aprobacion', 'nro_secuencia', 'nro_solicitud', 'ddjj_observacion'],
	        hiddenFields: ['id_sello_bolivia', 'id_certificacion', 'id_unidad_productiva', 'id_producto', 'extra', 'nro_solicitud', 'ddjj_observacion'],
	        fks: ['fid_formulario'],
	        permission: {
	          create: false,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver pdf del producto',
	          if: function _if(ev, item) {
	            return item.ddjj_estado === 'APROBADO';
	          },
	          onclick: function onclick(ev, item) {
	            _this.Modal.pdf('cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/' + item.id_sello_bolivia);
	          }
	        }, {
	          icon: 'eye',
	          tooltip: 'Ver pdf del producto',
	          if: function _if(ev, item) {
	            return ['OBSERVADO', 'RECHAZADO'].includes(item.ddjj_estado);
	          },
	          onclick: function onclick(ev, item) {
	            _this.Modal.pdf('cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/' + item.id_sello_bolivia, null, item.ddjj_observacion);
	          }
	        }, {
	          icon: 'file-pdf-o',
	          tooltip: 'Ver certificacion',
	          if: function _if(ev, item) {
	            return item.ddjj_estado === 'APROBADO';
	          },
	          onclick: function onclick(ev, item) {
	            _this.Modal.pdf('certificaciones/documento/' + item.id_certificacion, 'Autorización');
	            // this.Modal.pdf(`cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/${item.id_sello_bolivia}/previsualizar_certificado`);
	          }
	        }, {
	          icon: 'eye',
	          tooltip: 'Ver detalles de solicitud',
	          if: function _if(ev, item) {
	            return item.ddjj_estado === 'PENDIENTE';
	            // return (item.ddjj_estado==='PENDIENTE' || item.ddjj_estado==='OBSERVADO'); // REQ
	          },
	          onclick: function onclick(ev, item) {
	            item = angular.extend(item, item.extra);
	            delete item.extra;
	            _this.Storage.set('selloBolivia', item);
	            _this.$location.path('detalleSolicitudSello');
	          }
	        }],
	        clases: {
	          'ddjj_estado': function ddjj_estado(item) {
	            return ['badge', 'badge-' + colors[item.ddjj_estado]];
	          }
	        }
	      };
	    }
	  }, {
	    key: 'verDetalleSolicitud',
	    value: function verDetalleSolicitud(item) {
	      this.Storage.set('print_prod', item);
	      this.$location.path('impProductoPromueve');
	    }
	  }]);
	
	  return DdjjSelloboliviaController;
	}();
	
	exports.default = DdjjSelloboliviaController;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _ddjj = __webpack_require__(391);
	
	var _ddjj2 = _interopRequireDefault(_ddjj);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ddjj = angular.module('app.adm.sellobolivia.ddjj', []).component('appSelloboliviaDdjj', _ddjj2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('autorizaciones', {
	                url: '/autorizaciones',
	                component: 'appSelloboliviaDdjj'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Ddjj;

/***/ }),
/* 394 */
[680, 395, 619],
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// import modalController from './ddjjdetalle.modal.controller.js';
	// import modalTemplate from './ddjjdetalle.modal.html';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ddjjdetalleModalObsController = __webpack_require__(396);
	
	var _ddjjdetalleModalObsController2 = _interopRequireDefault(_ddjjdetalleModalObsController);
	
	var _ddjjdetalleModalObs = __webpack_require__(620);
	
	var _ddjjdetalleModalObs2 = _interopRequireDefault(_ddjjdetalleModalObs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjdetalleController = function () {
	  DdjjdetalleController.$inject = ["Message", "$scope", "$log", "Modal", "Storage", "DataService", "Sidenav", "$window", "Loading"];
	  function DdjjdetalleController(Message, $scope, $log, Modal, Storage, DataService, Sidenav, $window, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjdetalleController);
	
	    this.Message = Message;
	    this.$scope = $scope;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Sidenav = Sidenav;
	    this.$window = $window;
	    this.Loading = Loading;
	  }
	
	  _createClass(DdjjdetalleController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(this)
	      this.Loading.show('Cargando', true);
	      this.data = this.Storage.get('selloBolivia');
	      if (!this.data && !angular.isObject(this.data)) {
	        this.volver();
	      }
	
	      this.urls = {};
	      this.caeb = {};
	      var this_ = this;
	
	      this.DataService.pdfO('cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/' + this.data.id_sello_bolivia).then(function (response) {
	        if (response) {
	          _this.urls.producto = response;
	          _this.iframe_url = response;
	          this_.Loading.hide();
	          // this.cargarCertificado();
	        }
	      });
	
	      if (this.data.ddjj_estado == 'PENDIENTE') {
	        // this.cargarCaeb();
	      }
	      if (this.data.fid_caeb) {
	        this.cargarCaebByid(this.data.fid_caeb);
	      }
	
	      this.$scope.$on('app_adm_sello_modal_obs_success', function () {
	        _this.volver();
	      });
	    }
	  }, {
	    key: 'asignarCaeb',
	    value: function asignarCaeb(caeb) {
	      var _this2 = this;
	
	      var data = { id_caeb: caeb.id_caeb };
	      this.DataService.put('certificaciones/' + this.data.id_certificacion + '/actividades_economicas/' + this.data.id_producto + '/caeb', data).then(function (response) {
	        if (response) {
	          _this2.data.fid_caeb = caeb.id_caeb;
	          _this2.Storage.set('selloBolivia', _this2.data);
	        }
	      });
	    }
	  }, {
	    key: 'cargarCaebByid',
	    value: function cargarCaebByid(idCaeb) {
	      var _this3 = this;
	
	      if (idCaeb !== null && angular.isDefined(idCaeb)) {
	        this.DataService.get('clasificadores/' + idCaeb).then(function (response) {
	          if (response) {
	            _this3.caeb.selected = response;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'cargarCaeb',
	    value: function cargarCaeb() {
	      var _this4 = this;
	
	      var padre;
	      this.listadoCaeb = [];
	      this.DataService.get('clasificadores/subclases').then(function (response) {
	        _this4.$log.log(_this4);
	        if (response) {
	          _this4.getListadoCaeb = response;
	          _this4.getListadoCaeb.forEach(function (it) {
	            it.xdescripcion = it.codigo.toLowerCase() + ' - ' + it.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	            padre = it.padre;
	            it.xdescripcion2 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	            padre = padre.padre;
	            it.xdescripcion3 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	            padre = padre.padre;
	            it.xdescripcion4 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	            padre = padre.padre;
	            it.xdescripcion5 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	          });
	          _this4.refreshResult();
	        }
	      });
	    }
	  }, {
	    key: 'refreshResult',
	    value: function refreshResult(textSearch) {
	      var arrCaebs;
	      if (this.getListadoCaeb) {
	        // this.$log.log('textSearch='+textSearch);
	        arrCaebs = angular.copy(this.getListadoCaeb);
	        if (textSearch) {
	          textSearch = textSearch.toLowerCase().replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
	          arrCaebs = arrCaebs.filter(function (it) {
	            return it.xdescripcion.indexOf(textSearch) != -1 || it.xdescripcion5.indexOf(textSearch) != -1 || it.xdescripcion4.indexOf(textSearch) != -1 || it.xdescripcion3.indexOf(textSearch) != -1 || it.xdescripcion2.indexOf(textSearch) != -1;
	          });
	        }
	        if (arrCaebs.length > 20) {
	          arrCaebs = arrCaebs.splice(0, 20);
	        }
	        this.listadoCaeb = arrCaebs;
	      }
	    }
	  }, {
	    key: 'cargarCertificado',
	    value: function cargarCertificado() {
	      var _this5 = this;
	
	      this.DataService.pdfO('cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/' + this.data.id_sello_bolivia + '/previsualizar_certificado').then(function (response) {
	        if (response) {
	          _this5.urls.certificado = response;
	          // this.data.estado = 'APROBADO';
	          // this.Storage.Set('selloBolivia', this.data);
	          // this.iframe_url = response;
	          // this.urls.sw = true;
	        }
	      });
	    }
	  }, {
	    key: 'changePdf',
	    value: function changePdf() {
	      if (this.urls.sw) {
	        this.urls.sw = false;
	        this.iframe_url = this.urls.producto;
	      } else {
	        this.urls.sw = true;
	        this.iframe_url = this.urls.certificado;
	      }
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'descargarPdf',
	    value: function descargarPdf(ruta, nombre) {
	      var _this6 = this;
	
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "" + nombre + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	          _this6.Message.success('Su documento esta siendo descargado.');
	        }
	      });
	    }
	  }, {
	    key: 'isEstado',
	    value: function isEstado(cad) {
	      cad = cad.split(', ');
	      for (var i = 0; i < cad.length; i++) {
	        if (cad[i] === this.data.ddjj_estado) return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'descargarCertificado',
	    value: function descargarCertificado() {
	      var _this7 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + this.certificacion.id_certificacion;
	      if (this.certificacion.ddjj_estado === 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + this.certificacion.id_certificacion;
	      }
	      this.$log.log('Url de descarga file = ', ruta);
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          var nombreEmpresa = angular.copy(_this7.unidad_productiva.razon_social);
	          nombreEmpresa = nombreEmpresa.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //        let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "certificado_" + nombreEmpresa + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	        }
	      });
	    }
	  }, {
	    key: 'observar',
	    value: function observar(rechazar) {
	      this.data.accion = rechazar || 0;
	      this.Modal.show({
	        template: _ddjjdetalleModalObs2.default,
	        controller: _ddjjdetalleModalObsController2.default,
	        data: this.data,
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'aprobar',
	    value: function aprobar() {
	      var _this8 = this;
	
	      // this.$log.log('aprobar sello');
	      //Comentando metodo de aprobar, por si se aprueba en esta instancia
	      if (angular.isDefined(this.data.fid_caeb)) {
	        this.Modal.confirm('¿Está seguro de aprobar el producto?', function () {
	          var dataEnv = {
	            estado: 'APROBADO',
	            id_sello_bolivia: _this8.data.id_sello_bolivia,
	            fid_caeb: _this8.data.fid_caeb, // REQ
	            observacion: ''
	          };
	          _this8.DataService.put('cert_sello_bolivia/evaluar_shb', dataEnv).then(function (response) {
	            if (response) {
	              _this8.Message.success();
	              _this8.data.ddjj_estado = 'APROBADO';
	              _this8.Storage.set('selloBolivia', _this8.data);
	            }
	          });
	        });
	      } else {
	        this.Message.error("Debe seleccionar el CAEB para poder aprobar");
	      }
	    }
	  }, {
	    key: 'volver',
	    value: function volver() {
	      this.Sidenav.path('autorizaciones');
	    }
	  }]);
	
	  return DdjjdetalleController;
	}();
	
	exports.default = DdjjdetalleController;

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DdjjdetalleobsModalController = function () {
	  DdjjdetalleobsModalController.$inject = ["$rootScope", "$uibModalInstance", "data", "$log", "DataService"];
	  function DdjjdetalleobsModalController($rootScope, $uibModalInstance, data, $log, DataService) {
	    'ngInject';
	
	    _classCallCheck(this, DdjjdetalleobsModalController);
	
	    this.$rootScope = $rootScope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.data = data;
	    this.$log = $log;
	    this.DataService = DataService;
	    // this.Loading = Loading;
	  }
	
	  _createClass(DdjjdetalleobsModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.$log.log(this);
	      // this.Loading.show('Cargando', true);
	      // this.selected = {
	      //   item: this.items[0]
	      // };
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      var dataEnv = {
	        estado: this.data.accion ? 'RECHAZADO' : 'OBSERVADO',
	        id_sello_bolivia: this.data.id_sello_bolivia,
	        observacion: this.observacion
	      };
	
	      this.DataService.put('cert_sello_bolivia/evaluar_shb', dataEnv).then(function (response) {
	        if (response) {
	          _this.cancel();
	          _this.$rootScope.$broadcast('app_adm_sello_modal_obs_success');
	          // this.siguiente();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return DdjjdetalleobsModalController;
	}();
	
	exports.default = DdjjdetalleobsModalController;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _ddjjdetalle = __webpack_require__(394);
	
	var _ddjjdetalle2 = _interopRequireDefault(_ddjjdetalle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ddjj = angular.module('app.adm.sellobolivia.ddjjdetalle', []).component('appSelloboliviaDdjjDetalle', _ddjjdetalle2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('detalleSolicitudSello', {
	                url: '/detalleSolicitudSello',
	                component: 'appSelloboliviaDdjjDetalle'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Ddjj;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// import DdjjPromueve from './ddjj/ddjj.module';
	// import DdjjProductoPromueve from './certificacion/certificacion_prom.module';
	// import RechazadosPromueve from './rechazados/rechazados.module';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ddjjdetalle = __webpack_require__(397);
	
	var _ddjjdetalle2 = _interopRequireDefault(_ddjjdetalle);
	
	var _ddjj = __webpack_require__(393);
	
	var _ddjj2 = _interopRequireDefault(_ddjj);
	
	var _solicitudesFirma = __webpack_require__(401);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Admin = angular.module('app.adm.sellobolivia', [
	// DdjjPromueve,
	// DdjjProductoPromueve,
	// RechazadosPromueve,
	_ddjjdetalle2.default, _solicitudesFirma2.default, _ddjj2.default]).name;exports.default = Admin;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _solicitudesFirma = __webpack_require__(400);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	var _solicitudesFirma3 = __webpack_require__(621);
	
	var _solicitudesFirma4 = _interopRequireDefault(_solicitudesFirma3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudesFirmaSHBComponent = {
	  bindings: {},
	  controller: _solicitudesFirma2.default,
	  template: _solicitudesFirma4.default
	};
	
	exports.default = SolicitudesFirmaSHBComponent;

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SolicitudesFirmaSHBController = function () {
	  SolicitudesFirmaSHBController.$inject = ["$scope", "$log", "Message", "Modal", "DataService", "Storage", "$location", "baseUrl", "Demofi"];
	  function SolicitudesFirmaSHBController($scope, $log, Message, Modal, DataService, Storage, $location, baseUrl, Demofi) {
	    'ngInject';
	
	    _classCallCheck(this, SolicitudesFirmaSHBController);
	
	    this.$scope = $scope;
	    this.$log = $log;
	    this.Message = Message;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.$location = $location;
	    this.baseUrl = baseUrl;
	    this.DataService = DataService;
	    this.Demofi = Demofi;
	  }
	
	  _createClass(SolicitudesFirmaSHBController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.cargarTabla();
	      // this.Demofi.openModal([]);
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this = this;
	
	      var colors = {
	        'PENDIENTE': 'primary',
	        'FIRMADO': 'success'
	      };
	      this.solicitudes = {
	        url: 'cert_sello_bolivia/shb/firma/solicitudes',
	        queryExtra: { estado: 'APROBADO' },
	        data: {
	          formly: [//id_sello_bolivia, razon_social, estado
	          {
	            key: 'id_sello_bolivia',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'id_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'Id certificacion',
	              type: 'number'
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'id_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'id producto',
	              type: 'number'
	            }
	          }, {
	            key: 'razon_social',
	            type: 'input',
	            templateOptions: {
	              label: 'Razón social',
	              type: 'text'
	            }
	          }, {
	            key: 'matricula_comercio',
	            type: 'input',
	            templateOptions: {
	              label: 'Matrícula',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Producto',
	              type: 'text'
	            }
	          }, {
	            key: 'estado_firma',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              "options": [{
	                "value": "FIRMADO",
	                "name": "FIRMADO"
	              }, {
	                "value": "PENDIENTE",
	                "name": "PENDIENTE"
	              }]
	            }
	          },
	          // {
	          //   key: 'nit',
	          //   type: 'input',
	          //   templateOptions: {
	          //     label: 'Nit',
	          //     type: 'text'
	          //   }
	          // },
	          {
	            key: 'fid_formulario',
	            type: 'select',
	            templateOptions: {
	              label: 'Tipo producto',
	              type: 'select',
	              options: [{
	                "value": 3,
	                "name": "BIEN PRODUCIDO"
	              }, {
	                "value": 4,
	                "name": "COSTO BRUTO"
	              }, {
	                "value": 8,
	                "name": "SHB_PRODUCTO"
	              }]
	            }
	          }, {
	            key: '_fecha_creacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de creación',
	              type: 'date'
	            }
	          }]
	        },
	        fields: ['id_sello_bolivia', 'id_certificacion', 'id_unidad_productiva', 'id_producto', 'razon_social', 'matricula_comercio', 'nombre_producto', 'estado_firma', 'fid_formulario', '_fecha_creacion'],
	        hiddenFields: ['id_sello_bolivia', 'id_certificacion', 'id_unidad_productiva', 'id_producto'],
	        fks: ['fid_formulario'],
	        permission: {
	          create: false,
	          update: false,
	          delete: false,
	          filter: false
	        },
	        // checks: {
	        //   label: 'Firmar solicitudes',
	        //   if: (item) => { return item.estado_firma=='PENDIENTE';},
	        //   // cbCheck: () => {
	        //   //   this.$log.log('Event check');
	        //   // },
	        //   cbButton: rows => {
	        //     const docSolicitudes = [];
	        //     let sol;
	        //     // this.$log.log('Event butoon', rows, this.Demofi);
	        //     rows.forEach( it => {
	        //       if (it.checked) {
	        //         sol = {
	        //           url_source_pdf: this.DataService.getUrl(`cert_sello_bolivia/shb/firma/documento/${it.id_sello_bolivia}`),
	        //           url_upload_pdf: this.DataService.getUrl(`cert_sello_bolivia/shb/firma/actualizar/`),
	        //           nombre_archivo: `Producto ${it.nombre_producto}`, // nombre del producto
	        //           codigo_archivo: `${it.id_sello_bolivia}`, // id de sello bolivia
	        //           authorization: `Bearer ${this.Storage.get('token')}`, // token
	        //         };
	        //         docSolicitudes.push(sol);
	        //       }
	        //     })
	
	        //     if (docSolicitudes.length) {
	        //       // ---------------------------------------  FIRMAR SOLICITUDES ----------------------------------------
	        //       // console.log(docSolicitudes);
	        //       // console.log(JSON.stringify(docSolicitudes, null, 2))
	        //       this.Demofi.openModal(docSolicitudes).result
	        //       .then( data => {
	        //         this.$log.log('THEN modal', data);
	        //         this.$scope.$broadcast('refresh_crud_table', this.solicitudes.url)
	        //       })
	        //     } else {
	        //       this.Message.warning("Debe seleccionar por lo menos un documento");
	        //     }
	        //   }
	        // },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver pdf del producto',
	          onclick: function onclick(ev, item) {
	            // this.$log.log(ev, item);
	            _this.Modal.pdf('cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/' + item.id_sello_bolivia);
	          }
	        }, {
	          icon: 'file-pdf-o',
	          tooltip: 'Ver certificacion',
	          onclick: function onclick(ev, item) {
	            // this.$log.log(ev, item);
	            _this.Modal.pdf('certificaciones/documento/' + item.id_certificacion, 'Certificación');
	          }
	        }],
	        clases: {
	          'estado_firma': function estado_firma(item) {
	            // this.$log.log(item);
	            return ['badge', 'badge-' + colors[item.estado_firma]];
	          }
	        }
	      };
	    }
	  }, {
	    key: 'verDetalleSolicitud',
	    value: function verDetalleSolicitud(item) {
	      this.Storage.set('print_prod', item);
	      this.$location.path('impProductoPromueve');
	    }
	  }]);
	
	  return SolicitudesFirmaSHBController;
	}();
	
	exports.default = SolicitudesFirmaSHBController;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _solicitudesFirma = __webpack_require__(399);
	
	var _solicitudesFirma2 = _interopRequireDefault(_solicitudesFirma);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudesFirma = angular.module('app.adm.sellobolivia.solicitudesfirma', []).component('appSelloboliviaSolicitudesFirma', _solicitudesFirma2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	        $stateProvider.state('solicitudesFirmaSHB', {
	                url: '/solicitudesFirmaSHB',
	                component: 'appSelloboliviaSolicitudesFirma'
	        });
	        $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = SolicitudesFirma;

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserAgregarController = function () {
	  UserAgregarController.$inject = ["$uibModalInstance", "data", "$log", "DataService", "Message", "$state"];
	  function UserAgregarController($uibModalInstance, data, $log, DataService, Message, $state) {
	    'ngInject';
	
	    _classCallCheck(this, UserAgregarController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.$state = $state;
	  }
	
	  _createClass(UserAgregarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.selected = {
	        item: this.items[0]
	      };
	      this.estados = ['ACTIVO', 'INACTIVO'];
	      this.$log.log('Datos obtenidos enviados = ', this.items);
	      this.tituloPagina = 'Agregando Usuario';
	      if (this.items.esEdicion) {
	        this.tituloPagina = 'Editando Usuario';
	        this.usuario = this.items.usuario;
	        this.usuario.fid_rol = this.usuario.usuarios_roles.fid_rol;
	      }
	      //Roles
	      this.cargarRoles();
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      if (angular.isUndefined(this.usuario)) {
	        var type = "warning";
	        this.Message[type]("Debe llenar la información del formulario.");
	        return;
	      }
	      this.usuario.fid_persona = this.data.usuario.id_persona;
	      this.$log.log(this.usuario);
	      if (!this.usuario.id_usuario && !this.usuario.fid_persona) {
	        this.Message.error("Debe validar los datos de la persona. Presione el botón 'VALIDAR'.");
	        return;
	      }
	      this.$log.log('ID de persona seleccionada = ', this.usuario.fid_persona);
	      //validacion de campos vacios
	      //objeto a enviar
	      var obj = {
	        "usuario": this.usuario
	      };
	      if (this.items.esEdicion) {
	        this.$log.log('Editamos  usuario ->' + 'usuarios/' + this.usuario.id_usuario);
	        this.DataService.put('usuarios/' + this.usuario.id_usuario, obj).then(function (response) {
	          if (response) {
	            _this.$log.log('Respuesta***= ', response);
	            _this.items.refresh;
	            _this.$state.reload();
	            _this.$uibModalInstance.close(_this.selected.item);
	          }
	        });
	      } else {
	        this.$log.log('Agregamos  usuario');
	        this.DataService.post('usuarios/', obj).then(function (response) {
	          if (response) {
	            _this.$log.log('Respuesta a***= ', response);
	            _this.items.refresh;
	            _this.$state.reload();
	            _this.$uibModalInstance.close(_this.selected.item);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'validar',
	    value: function validar() {
	      this.$log.log('*VALIDANDO DATOS CONTRA SEGIP---', this.usuario);
	    }
	  }, {
	    key: 'cargarRoles',
	    value: function cargarRoles() {
	      var _this2 = this;
	
	      this.DataService.get('roles').then(function (response) {
	        if (response) {
	          _this2.roles = response;
	        }
	      });
	    }
	  }]);
	
	  return UserAgregarController;
	}();
	
	exports.default = UserAgregarController;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(404);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _user3 = __webpack_require__(623);
	
	var _user4 = _interopRequireDefault(_user3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserComponent = {
	    bindings: {},
	    controller: _user2.default,
	    template: _user4.default
	};
	
	exports.default = UserComponent;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _userAgregarController = __webpack_require__(402);
	
	var _userAgregarController2 = _interopRequireDefault(_userAgregarController);
	
	var _userAgregar = __webpack_require__(622);
	
	var _userAgregar2 = _interopRequireDefault(_userAgregar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserController = function () {
	  UserController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "Util", "Message"];
	  function UserController(NgTableParams, $log, Modal, Storage, DataService, Util, Message) {
	    'ngInject';
	
	    _classCallCheck(this, UserController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Util = Util;
	    this.Message = Message;
	  }
	
	  _createClass(UserController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      this.cargarUsuarios();
	    }
	  }, {
	    key: 'cargarUsuarios',
	    value: function cargarUsuarios() {
	      var _this = this;
	
	      this.tableParams = new this.NgTableParams({ count: 25 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	
	          _this.$log.log('data:', data);
	          return _this.DataService.list("usuarios", query).then(function (response) {
	
	            _this.$log.log('***Respuesta: ', response);
	
	            if (response) {
	              params.total(response.count);
	              var items = _this.filterItems(response.rows);
	              _this.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	      //      }
	      //    });
	    }
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'reenviarCorreo',
	    value: function reenviarCorreo(usuario) {
	      var _this2 = this;
	
	      this.Modal.confirm('¿Está seguro/a de enviar el correo?', function () {
	        var url = "usuarios/reenviar";
	        var obj = {
	          usuario: { id_usuario: usuario.id_usuario }
	        };
	        _this2.DataService.post(url, obj).then(function (response) {
	          if (response) {
	            _this2.Message.success("Se envío el correo correctamente.");
	          }
	        });
	      });
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarUsuarios();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      this.Modal.show({
	        template: _userAgregar2.default,
	        controller: _userAgregarController2.default,
	        data: '',
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'verEditar',
	    value: function verEditar(usuario) {
	      this.$log.log('*vemos antes de editar: ', usuario);
	      var items = {
	        "usuario": angular.copy(usuario),
	        "esEdicion": true,
	        "refresh": this.refresh()
	      };
	      this.Modal.show({
	        template: _userAgregar2.default,
	        controller: _userAgregarController2.default,
	        data: items,
	        size: 'lg'
	      });
	    }
	  }]);
	
	  return UserController;
	}();
	
	exports.default = UserController;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _user = __webpack_require__(403);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.user', []).component('appAdminUser', _user2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('user', {
	        url: '/usuarios',
	        component: 'appAdminUser'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _admin = __webpack_require__(310);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _probolivia = __webpack_require__(445);
	
	var _probolivia2 = _interopRequireDefault(_probolivia);
	
	var _promueve = __webpack_require__(471);
	
	var _promueve2 = _interopRequireDefault(_promueve);
	
	var _sellobolivia = __webpack_require__(478);
	
	var _sellobolivia2 = _interopRequireDefault(_sellobolivia);
	
	var _reporteEmp = __webpack_require__(474);
	
	var _reporteEmp2 = _interopRequireDefault(_reporteEmp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.components', [_admin2.default, _probolivia2.default, _promueve2.default, _sellobolivia2.default, _reporteEmp2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Artesano = angular.module('app.artesano', []).name;
	
	exports.default = Artesano;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandejaAguinaldo = __webpack_require__(409);
	
	var _bandejaAguinaldo2 = _interopRequireDefault(_bandejaAguinaldo);
	
	var _bandejaAguinaldo3 = __webpack_require__(624);
	
	var _bandejaAguinaldo4 = _interopRequireDefault(_bandejaAguinaldo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaAguinaldoComponent = {
	    bindings: {},
	    controller: _bandejaAguinaldo2.default,
	    template: _bandejaAguinaldo4.default
	};
	
	exports.default = BandejaAguinaldoComponent;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ddjjdetalleModalController = __webpack_require__(13);
	
	var _ddjjdetalleModalController2 = _interopRequireDefault(_ddjjdetalleModalController);
	
	var _ddjjdetalleModal = __webpack_require__(14);
	
	var _ddjjdetalleModal2 = _interopRequireDefault(_ddjjdetalleModal);
	
	var _bandejaPagoModalController = __webpack_require__(45);
	
	var _bandejaPagoModalController2 = _interopRequireDefault(_bandejaPagoModalController);
	
	var _bandejaPagoModal = __webpack_require__(47);
	
	var _bandejaPagoModal2 = _interopRequireDefault(_bandejaPagoModal);
	
	var _duplicarModalController = __webpack_require__(27);
	
	var _duplicarModalController2 = _interopRequireDefault(_duplicarModalController);
	
	var _duplicarModal = __webpack_require__(31);
	
	var _duplicarModal2 = _interopRequireDefault(_duplicarModal);
	
	var _bandejaProductoModalController = __webpack_require__(46);
	
	var _bandejaProductoModalController2 = _interopRequireDefault(_bandejaProductoModalController);
	
	var _bandejaProductoModal = __webpack_require__(48);
	
	var _bandejaProductoModal2 = _interopRequireDefault(_bandejaProductoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaController = function () {
	  BandejaController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "$location", "Util", "Message", "$window"];
	  function BandejaController(NgTableParams, $log, Modal, Storage, DataService, $location, Util, Message, $window) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.Util = Util;
	    this.Message = Message;
	    this.$window = $window;
	  }
	
	  _createClass(BandejaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      //cargamos tabla
	      this.tim = {};
	      this.cargarTabla();
	      //Revisamo si hay nit para el user logueado
	      this.usuario = this.Storage.getUser();
	      if (angular.isDefined(this.usuario.nit) && this.usuario.nit !== null && this.usuario.nit !== 'null') {
	        this.isTieneNit = true;
	      } else {
	        this.isTieneNit = false;
	      }
	    }
	  }, {
	    key: 'changeFilter',
	    value: function changeFilter() {
	      var _this = this;
	
	      if (this.tableParams) {
	        this.Util.funcDelay(this.tim, 1000, function () {
	          _this.tableParams.reload();
	        });
	      }
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      this.tableParams = new this.NgTableParams({ count: 10 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this2.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this2.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	          query.ambito = "PROBOLIVIA";
	          query.creadas = 'TECNICO';
	          query.filter = _this2.filtro_bandeja || '';
	          return _this2.DataService.list('certificaciones_aguinaldo', query).then(function (response) {
	            _this2.$log.log('Seleccionado = ', response);
	
	            if (response) {
	              params.total(response.count);
	              var items = _this2.filterItems(response.rows);
	              _this2.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'editar',
	    value: function editar(item) {
	      //this.$log.log(item);    
	      this.Storage.setSession('certificacion', item.certificacion.id_certificacion);
	      this.$location.path('registro');
	    }
	  }, {
	    key: 'editarProductos',
	    value: function editarProductos(item) {
	      var _this3 = this;
	
	      if (item.certificacion.estado === 'APROBADO') {
	        this.Modal.confirm('Al editar productos, su Certificación volverá a un estado de PENDIENTE de revisión hasta que un técnico la revise. ¿Desea continuar?', function () {
	          _this3.abrirModal(item);
	        });
	      } else {
	        this.abrirModal(item);
	      }
	    }
	  }, {
	    key: 'abrirModal',
	    value: function abrirModal(item) {
	      var _this4 = this;
	
	      if (item.certificacion.estado === 'PRODUCTOS_OBSERVADOS') {
	        this.Modal.show({
	          template: _bandejaProductoModal2.default,
	          controller: _bandejaProductoModalController2.default,
	          data: item,
	          size: 'lg'
	        });
	      } else {
	        this.$log.log('certificaciones/' + item.certificacion.id_certificacion + '/editarProducto');
	        this.DataService.put('certificaciones/' + item.certificacion.id_certificacion + '/editarProducto').then(function (respuesta) {
	          if (respuesta) {
	            _this4.Message.success('Su registro se encuentra Pendiente de Aprobación.');
	            _this4.$log.log('***Datos de la certificación***', item);
	            _this4.Modal.show({
	              template: _bandejaProductoModal2.default,
	              controller: _bandejaProductoModalController2.default,
	              data: item,
	              size: 'lg'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'eliminar',
	    value: function eliminar(item) {
	      var _this5 = this;
	
	      this.Modal.confirm('Al eliminar esta declaración, no podrá recuperar la información ingresada. ¿Desea eliminar el registro?', function () {
	        _this5.$log.log('Eliminamos = ', item);
	        _this5.DataService.delete('certificaciones/' + item.certificacion.id_certificacion).then(function () {
	          _this5.Message.success('Su registro fue eliminado correctamente.');
	          _this5.refresh();
	        });
	      });
	    }
	  }, {
	    key: 'duplicar',
	    value: function duplicar(item) {
	      this.$log.log('duplicar = ', item);
	      this.Modal.show({
	        template: _duplicarModal2.default,
	        controller: _duplicarModalController2.default,
	        data: { id_certificacion: item.certificacion.id_certificacion },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'procesar',
	    value: function procesar(nombre) {
	      return nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace("ICAP''s", "ICAP's").replace('DECLARACIÓN JURADA PARA LA ', '');
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'irDetalle',
	    value: function irDetalle() {
	      this.$location.path('declaracionDetalle');
	    }
	
	    //filtrado en grid
	
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'verPdfTabla',
	    value: function verPdfTabla(certificacion) {
	      var _this6 = this;
	
	      var ruta = 'certificaciones/' + certificacion.certificacion.id_certificacion + '/reporte';
	      if (certificacion.certificacion.estado == 'APROBADO' && !certificacion.certificacion.migrado) {
	        ruta = 'certificaciones/mostrar_reporte/' + certificacion.certificacion.id_certificacion;
	      }
	
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'reporte_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this6.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'datosPago',
	    value: function datosPago(certificacion) {
	      this.$log.log('***Datos del pago***', certificacion);
	      this.Modal.show({
	        template: _bandejaPagoModal2.default,
	        controller: _bandejaPagoModalController2.default,
	        data: { id_certificacion: certificacion.certificacion.id_certificacion },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'veCertificadoTabla',
	    value: function veCertificadoTabla(certificacion) {
	      var _this7 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + certificacion.certificacion.id_certificacion;
	      if (certificacion.certificacion.estado == 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + certificacion.certificacion.id_certificacion;
	      }
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'certificado_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this7.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'descargarPdf',
	    value: function descargarPdf(ruta, nombre) {
	      var _this8 = this;
	
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "" + nombre + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	          _this8.Message.success('Su documento esta siendo descargado.');
	        }
	      });
	    }
	  }]);
	
	  return BandejaController;
	}();
	
	exports.default = BandejaController;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bandejaAguinaldo = __webpack_require__(408);
	
	var _bandejaAguinaldo2 = _interopRequireDefault(_bandejaAguinaldo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaAguinaldo = angular.module('app.bandejaAguinaldo', []).component('appBandejaAguinaldoCom', _bandejaAguinaldo2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('bandejaAguinaldo', {
	    url: '/bandejaAguinaldo',
	    component: 'appBandejaAguinaldoCom'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	exports.default = BandejaAguinaldo;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandeja = __webpack_require__(412);
	
	var _bandeja2 = _interopRequireDefault(_bandeja);
	
	var _bandeja3 = __webpack_require__(625);
	
	var _bandeja4 = _interopRequireDefault(_bandeja3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaComponent = {
	    bindings: {},
	    controller: _bandeja2.default,
	    template: _bandeja4.default
	};
	
	exports.default = BandejaComponent;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ddjjdetalleModalController = __webpack_require__(13);
	
	var _ddjjdetalleModalController2 = _interopRequireDefault(_ddjjdetalleModalController);
	
	var _ddjjdetalleModal = __webpack_require__(14);
	
	var _ddjjdetalleModal2 = _interopRequireDefault(_ddjjdetalleModal);
	
	var _bandejaPagoModalController = __webpack_require__(45);
	
	var _bandejaPagoModalController2 = _interopRequireDefault(_bandejaPagoModalController);
	
	var _bandejaPagoModal = __webpack_require__(47);
	
	var _bandejaPagoModal2 = _interopRequireDefault(_bandejaPagoModal);
	
	var _duplicarModalController = __webpack_require__(27);
	
	var _duplicarModalController2 = _interopRequireDefault(_duplicarModalController);
	
	var _duplicarModal = __webpack_require__(31);
	
	var _duplicarModal2 = _interopRequireDefault(_duplicarModal);
	
	var _bandejaProductoModalController = __webpack_require__(46);
	
	var _bandejaProductoModalController2 = _interopRequireDefault(_bandejaProductoModalController);
	
	var _bandejaProductoModal = __webpack_require__(48);
	
	var _bandejaProductoModal2 = _interopRequireDefault(_bandejaProductoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaController = function () {
	  BandejaController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "$location", "Util", "Message", "$window"];
	  function BandejaController(NgTableParams, $log, Modal, Storage, DataService, $location, Util, Message, $window) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.Util = Util;
	    this.Message = Message;
	    this.$window = $window;
	  }
	
	  _createClass(BandejaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      //cargamos tabla
	      this.tim = {};
	      this.cargarTabla();
	      //Revisamo si hay nit para el user logueado
	      this.usuario = this.Storage.getUser();
	      if (angular.isDefined(this.usuario.nit) && this.usuario.nit !== null && this.usuario.nit !== 'null') {
	        this.isTieneNit = true;
	      } else {
	        this.isTieneNit = false;
	      }
	    }
	  }, {
	    key: 'changeFilter',
	    value: function changeFilter() {
	      var _this = this;
	
	      if (this.tableParams) {
	        this.Util.funcDelay(this.tim, 1000, function () {
	          _this.tableParams.reload();
	        });
	      }
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      this.tableParams = new this.NgTableParams({ count: 10 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this2.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this2.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	          query.ambito = "PROBOLIVIA";
	          query.creadas = 'TECNICO';
	          query.filter = _this2.filtro_bandeja || '';
	          return _this2.DataService.list('certificaciones', query).then(function (response) {
	
	            _this2.$log.log('Seleccionado = ', response);
	
	            if (response) {
	              params.total(response.count);
	              var items = _this2.filterItems(response.rows);
	              _this2.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'editar',
	    value: function editar(item) {
	      // this.$log.log(item)
	      this.Storage.setSession('certificacion', item.certificacion.id_certificacion);
	      this.$location.path('registro');
	    }
	  }, {
	    key: 'editarProductos',
	    value: function editarProductos(item) {
	      var _this3 = this;
	
	      if (item.certificacion.estado === 'APROBADO') {
	        this.Modal.confirm('Al editar productos, su Certificación volverá a un estado de PENDIENTE de revisión hasta que un técnico la revise. ¿Desea continuar?', function () {
	          _this3.abrirModal(item);
	        });
	      } else {
	        this.abrirModal(item);
	      }
	    }
	  }, {
	    key: 'abrirModal',
	    value: function abrirModal(item) {
	      var _this4 = this;
	
	      if (item.certificacion.estado === 'PRODUCTOS_OBSERVADOS') {
	        this.Modal.show({
	          template: _bandejaProductoModal2.default,
	          controller: _bandejaProductoModalController2.default,
	          data: item,
	          size: 'lg'
	        });
	      } else {
	        this.DataService.put('certificaciones/' + item.certificacion.id_certificacion + '/editarProducto').then(function (respuesta) {
	          if (respuesta) {
	            _this4.Message.success('Su registro se encuentra Pendiente de Aprobación.');
	            _this4.$log.log('***Datos de la certificación***', item);
	            _this4.Modal.show({
	              template: _bandejaProductoModal2.default,
	              controller: _bandejaProductoModalController2.default,
	              data: item,
	              size: 'lg'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'eliminar',
	    value: function eliminar(item) {
	      var _this5 = this;
	
	      this.Modal.confirm('Al eliminar esta declaración, no podrá recuperar la información ingresada. ¿Desea eliminar el registro?', function () {
	        _this5.$log.log('Eliminamos = ', item);
	        _this5.DataService.delete('certificaciones/' + item.certificacion.id_certificacion).then(function () {
	          _this5.Message.success('Su registro fue eliminado correctamente.');
	          _this5.refresh();
	        });
	      });
	    }
	  }, {
	    key: 'duplicar',
	    value: function duplicar(item) {
	      this.$log.log('duplicar = ', item);
	      this.Modal.show({
	        template: _duplicarModal2.default,
	        controller: _duplicarModalController2.default,
	        data: { id_certificacion: item.certificacion.id_certificacion },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'procesar',
	    value: function procesar(nombre) {
	      return nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace("ICAP''s", "ICAP's").replace('DECLARACIÓN JURADA PARA LA ', '');
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'irDetalle',
	    value: function irDetalle() {
	      this.$location.path('declaracionDetalle');
	    }
	
	    //filtrado en grid
	
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'verPdfTabla',
	    value: function verPdfTabla(certificacion) {
	      var _this6 = this;
	
	      var ruta = 'certificaciones/' + certificacion.certificacion.id_certificacion + '/reporte';
	      if (certificacion.certificacion.estado == 'APROBADO' && !certificacion.certificacion.migrado) {
	        ruta = 'certificaciones/mostrar_reporte/' + certificacion.certificacion.id_certificacion;
	      }
	
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'reporte_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this6.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'datosPago',
	    value: function datosPago(certificacion) {
	      this.$log.log('***Datos del pago***', certificacion);
	      this.Modal.show({
	        template: _bandejaPagoModal2.default,
	        controller: _bandejaPagoModalController2.default,
	        data: { id_certificacion: certificacion.certificacion.id_certificacion },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'veCertificadoTabla',
	    value: function veCertificadoTabla(certificacion) {
	      var _this7 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + certificacion.certificacion.id_certificacion;
	      if (certificacion.certificacion.estado == 'APROBADO') {
	
	        ruta = 'certificaciones/mostrar_certificado/' + certificacion.certificacion.id_certificacion;
	      }
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'certificado_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this7.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'descargarPdf',
	    value: function descargarPdf(ruta, nombre) {
	      var _this8 = this;
	
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "" + nombre + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	          _this8.Message.success('Su documento esta siendo descargado.');
	        }
	      });
	    }
	  }]);
	
	  return BandejaController;
	}();
	
	exports.default = BandejaController;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bandeja = __webpack_require__(411);
	
	var _bandeja2 = _interopRequireDefault(_bandeja);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bandeja = angular.module('app.bandeja', []).component('appBandejacom', _bandeja2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('bandeja', {
	    url: '/bandeja',
	    component: 'appBandejacom'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	exports.default = Bandeja;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandejaRefrigerio = __webpack_require__(415);
	
	var _bandejaRefrigerio2 = _interopRequireDefault(_bandejaRefrigerio);
	
	var _bandejaRefrigerio3 = __webpack_require__(626);
	
	var _bandejaRefrigerio4 = _interopRequireDefault(_bandejaRefrigerio3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaRerigerioComponent = {
	    bindings: {},
	    controller: _bandejaRefrigerio2.default,
	    template: _bandejaRefrigerio4.default
	};
	exports.default = BandejaRerigerioComponent;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ddjjdetalleModalController = __webpack_require__(13);
	
	var _ddjjdetalleModalController2 = _interopRequireDefault(_ddjjdetalleModalController);
	
	var _ddjjdetalleModal = __webpack_require__(14);
	
	var _ddjjdetalleModal2 = _interopRequireDefault(_ddjjdetalleModal);
	
	var _bandejaPagoModalController = __webpack_require__(45);
	
	var _bandejaPagoModalController2 = _interopRequireDefault(_bandejaPagoModalController);
	
	var _bandejaPagoModal = __webpack_require__(47);
	
	var _bandejaPagoModal2 = _interopRequireDefault(_bandejaPagoModal);
	
	var _duplicarModalController = __webpack_require__(27);
	
	var _duplicarModalController2 = _interopRequireDefault(_duplicarModalController);
	
	var _duplicarModal = __webpack_require__(31);
	
	var _duplicarModal2 = _interopRequireDefault(_duplicarModal);
	
	var _bandejaProductoModalController = __webpack_require__(46);
	
	var _bandejaProductoModalController2 = _interopRequireDefault(_bandejaProductoModalController);
	
	var _bandejaProductoModal = __webpack_require__(48);
	
	var _bandejaProductoModal2 = _interopRequireDefault(_bandejaProductoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaRerigerioController = function () {
	  BandejaRerigerioController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "$location", "Util", "Message", "$window"];
	  function BandejaRerigerioController(NgTableParams, $log, Modal, Storage, DataService, $location, Util, Message, $window) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaRerigerioController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.Util = Util;
	    this.Message = Message;
	    this.$window = $window;
	  }
	
	  _createClass(BandejaRerigerioController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      //cargamos tabla
	      this.tim = {};
	      this.cargarTabla();
	      //Revisamo si hay nit para el user logueado
	      this.usuario = this.Storage.getUser();
	      if (angular.isDefined(this.usuario.nit) && this.usuario.nit !== null && this.usuario.nit !== 'null') {
	        this.isTieneNit = true;
	      } else {
	        this.isTieneNit = false;
	      }
	    }
	  }, {
	    key: 'changeFilter',
	    value: function changeFilter() {
	      var _this = this;
	
	      if (this.tableParams) {
	        this.Util.funcDelay(this.tim, 1000, function () {
	          _this.tableParams.reload();
	        });
	      }
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      this.tableParams = new this.NgTableParams({ count: 10 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this2.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this2.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	          query.ambito = "PROBOLIVIA";
	          query.creadas = 'TECNICO';
	          query.filter = _this2.filtro_bandeja || '';
	          return _this2.DataService.list('certificaciones_refrigerio', query).then(function (response) {
	            _this2.$log.log('Seleccionado = ', response);
	            if (response) {
	              params.total(response.count);
	              var items = _this2.filterItems(response.rows);
	              _this2.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'editar',
	    value: function editar(item) {
	      // this.$log.log(item)
	      this.Storage.setSession('certificacion', item.certificacion.id_certificacion);
	      this.$location.path('registro');
	    }
	  }, {
	    key: 'editarProductos',
	    value: function editarProductos(item) {
	      var _this3 = this;
	
	      if (item.certificacion.estado === 'APROBADO') {
	        this.Modal.confirm('Al editar productos, su Certificación volverá a un estado de PENDIENTE de revisión hasta que un técnico la revise. ¿Desea continuar?', function () {
	          _this3.abrirModal(item);
	        });
	      } else {
	        this.abrirModal(item);
	      }
	    }
	  }, {
	    key: 'abrirModal',
	    value: function abrirModal(item) {
	      var _this4 = this;
	
	      if (item.certificacion.estado === 'PRODUCTOS_OBSERVADOS') {
	        this.Modal.show({
	          template: _bandejaProductoModal2.default,
	          controller: _bandejaProductoModalController2.default,
	          data: item,
	          size: 'lg'
	        });
	      } else {
	        this.DataService.put('certificaciones/' + item.certificacion.id_certificacion + '/editarProducto').then(function (respuesta) {
	          if (respuesta) {
	            _this4.Message.success('Su registro se encuentra Pendiente de Aprobación.');
	            _this4.$log.log('***Datos de la certificación***', item);
	            _this4.Modal.show({
	              template: _bandejaProductoModal2.default,
	              controller: _bandejaProductoModalController2.default,
	              data: item,
	              size: 'lg'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'eliminar',
	    value: function eliminar(item) {
	      var _this5 = this;
	
	      this.Modal.confirm('Al eliminar esta declaración, no podrá recuperar la información ingresada. ¿Desea eliminar el registro?', function () {
	        _this5.$log.log('Eliminamos = ', item);
	        _this5.DataService.delete('certificaciones/' + item.certificacion.id_certificacion).then(function () {
	          _this5.Message.success('Su registro fue eliminado correctamente.');
	          _this5.refresh();
	        });
	      });
	    }
	  }, {
	    key: 'duplicar',
	    value: function duplicar(item) {
	      this.$log.log('duplicar = ', item);
	      this.Modal.show({
	        template: _duplicarModal2.default,
	        controller: _duplicarModalController2.default,
	        data: { id_certificacion: item.certificacion.id_certificacion },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'procesar',
	    value: function procesar(nombre) {
	      return nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace("ICAP''s", "ICAP's").replace('DECLARACIÓN JURADA PARA LA ', '');
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'irDetalle',
	    value: function irDetalle() {
	      this.$location.path('declaracionDetalle');
	    }
	
	    //filtrado en grid
	
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	  }, {
	    key: 'verPdfTabla',
	    value: function verPdfTabla(certificacion) {
	      var _this6 = this;
	
	      var ruta = 'certificaciones/' + certificacion.certificacion.id_certificacion + '/reporte';
	      if (certificacion.certificacion.estado == 'APROBADO' && !certificacion.certificacion.migrado) {
	        ruta = 'certificaciones/mostrar_reporte/' + certificacion.certificacion.id_certificacion;
	      }
	
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'reporte_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this6.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'datosPago',
	    value: function datosPago(certificacion) {
	      this.$log.log('***Datos del pago***', certificacion);
	      this.Modal.show({
	        template: _bandejaPagoModal2.default,
	        controller: _bandejaPagoModalController2.default,
	        data: { id_certificacion: certificacion.certificacion.id_certificacion },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'veCertificadoTabla',
	    value: function veCertificadoTabla(certificacion) {
	      var _this7 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + certificacion.certificacion.id_certificacion;
	      if (certificacion.certificacion.estado == 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + certificacion.certificacion.id_certificacion;
	      }
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'certificado_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this7.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'descargarPdf',
	    value: function descargarPdf(ruta, nombre) {
	      var _this8 = this;
	
	      this.DataService.pdfOfile(ruta, {}).then(function (response) {
	        if (response) {
	          nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_'); //todos los caracteres
	          //let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	          var fileName = "" + nombre + ".pdf";
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	          _this8.Message.success('Su documento esta siendo descargado.');
	        }
	      });
	    }
	  }]);
	
	  return BandejaRerigerioController;
	}();
	
	exports.default = BandejaRerigerioController;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bandejaRefrigerio = __webpack_require__(414);
	
	var _bandejaRefrigerio2 = _interopRequireDefault(_bandejaRefrigerio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaRefrigerio = angular.module('app.bandejaRefrigerio', []).component('appBandejaRefrigerioCom', _bandejaRefrigerio2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('bandejaRefrigerio', {
	    url: '/bandejaRefrigerio',
	    component: 'appBandejaRefrigerioCom'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	exports.default = BandejaRefrigerio;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _certificadoEmp = __webpack_require__(418);
	
	var _certificadoEmp2 = _interopRequireDefault(_certificadoEmp);
	
	var _certificadoEmp3 = __webpack_require__(627);
	
	var _certificadoEmp4 = _interopRequireDefault(_certificadoEmp3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CertificadoComponent = {
	    bindings: {},
	    controller: _certificadoEmp2.default,
	    template: _certificadoEmp4.default
	};
	
	exports.default = CertificadoComponent;

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CertificadoEmpController = function () {
	    CertificadoEmpController.$inject = ["DataService", "Storage", "Sidenav", "Modal", "$log"];
	    function CertificadoEmpController(DataService, Storage, Sidenav, Modal, $log) {
	        'ngInject';
	
	        _classCallCheck(this, CertificadoEmpController);
	
	        this.DataService = DataService;
	        this.Storage = Storage;
	        this.Modal = Modal;
	        this.Sidenav = Sidenav;
	        this.$log = $log;
	
	        this.usuario = this.Storage.getUser();
	    }
	
	    _createClass(CertificadoEmpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            // this.DataService.get('certificados?ambito=PROBOLIVIA')
	            // .then(response => {
	            //     if (response) {
	            this.certificados = [{ nombre: 'Certificado 1' }, { nombre: 'Certificado 1' }];
	            //     }
	            // });
	        }
	    }, {
	        key: 'seleccionar',
	        value: function seleccionar(certificado) {
	            var _this = this;
	
	            this.Modal.confirm('¿Realmente desea <strong>crear</strong> este certificado para su matrícula?', function () {
	                _this.Storage.set('form', certificado);
	                _this.Sidenav.path('registro');
	            });
	        }
	    }, {
	        key: 'atras',
	        value: function atras() {
	            this.Storage.remove('form');
	            this.Sidenav.path('matricula');
	        }
	    }]);
	
	    return CertificadoEmpController;
	}();
	
	exports.default = CertificadoEmpController;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _certificadoEmp = __webpack_require__(417);
	
	var _certificadoEmp2 = _interopRequireDefault(_certificadoEmp);
	
	__webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.emp.certificado', []).component('appEmpCertificado', _certificadoEmp2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('certificado', {
	        url: '/certificado',
	        component: 'appEmpCertificado'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _duplicar = __webpack_require__(421);
	
	var _duplicar2 = _interopRequireDefault(_duplicar);
	
	var _duplicar3 = __webpack_require__(628);
	
	var _duplicar4 = _interopRequireDefault(_duplicar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DuplicarComponent = {
	    bindings: {},
	    controller: _duplicar2.default,
	    template: _duplicar4.default
	};
	
	exports.default = DuplicarComponent;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	//
	
	
	var _ddjjdetalleModalController = __webpack_require__(13);
	
	var _ddjjdetalleModalController2 = _interopRequireDefault(_ddjjdetalleModalController);
	
	var _ddjjdetalleModal = __webpack_require__(14);
	
	var _ddjjdetalleModal2 = _interopRequireDefault(_ddjjdetalleModal);
	
	var _duplicarModalController = __webpack_require__(27);
	
	var _duplicarModalController2 = _interopRequireDefault(_duplicarModalController);
	
	var _duplicarModal = __webpack_require__(31);
	
	var _duplicarModal2 = _interopRequireDefault(_duplicarModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DuplicarController = function () {
	  DuplicarController.$inject = ["NgTableParams", "$log", "Modal", "Storage", "DataService", "$location", "Util", "Message", "$window"];
	  function DuplicarController(NgTableParams, $log, Modal, Storage, DataService, $location, Util, Message, $window) {
	    'ngInject';
	
	    _classCallCheck(this, DuplicarController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.$location = $location;
	    this.Util = Util;
	    this.Message = Message;
	    this.$window = $window;
	  }
	
	  _createClass(DuplicarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.titulo = 'Nombre de página';
	      //    cargamos tabla
	      this.tim = {};
	      this.cargarTabla();
	      //Revisamo si hay nit para el user logueado
	      this.usuario = this.Storage.getUser();
	      if (angular.isDefined(this.usuario.nit) && this.usuario.nit !== null && this.usuario.nit !== 'null') {
	        this.isTieneNit = true;
	      } else {
	        this.isTieneNit = false;
	      }
	    }
	  }, {
	    key: 'changeFilter',
	    value: function changeFilter() {
	      var _this = this;
	
	      if (this.tableParams) {
	        this.Util.funcDelay(this.tim, 1000, function () {
	          _this.tableParams.reload();
	        });
	      }
	    }
	  }, {
	    key: 'esEdge',
	    value: function esEdge() {
	      var userAgent = this.$window.navigator.userAgent;
	      var ieEDGE = userAgent.match(/Edge/g);
	      var ie = userAgent.match(/.NET/g); // IE 11+
	      var oldIE = userAgent.match(/MSIE/g);
	      return ie || oldIE || ieEDGE;
	    }
	  }, {
	    key: 'cargarTabla',
	    value: function cargarTabla() {
	      var _this2 = this;
	
	      this.tableParams = new this.NgTableParams({ count: 10 }, {
	        getData: function getData(params) {
	          var data = params.url();
	
	          var query = {
	            limit: data.count,
	            page: data.page
	          };
	          var sort = _this2.getSorting(data);
	          if (sort) {
	            query.order = sort;
	          }
	          var filters = _this2.getFilters(data);
	          if (filters.length) {
	            if (filters[0].crudtable_search_term) {
	              query.filter = filters[0].crudtable_search_term;
	            } else {
	              for (var i in filters) {
	                var key = Object.keys(filters[i])[0];
	                query[key] = filters[i][key];
	              }
	              // query.filter = JSON.stringify(filters);
	            }
	          }
	          query.ambito = "PROBOLIVIA";
	          query.creadas = 'TECNICO';
	          query.filter = _this2.filtro_bandeja || '';
	          return _this2.DataService.list('certificaciones?aprobados=true', query).then(function (response) {
	
	            _this2.$log.log('Seleccionado = ', response);
	
	            if (response) {
	              params.total(response.count);
	              var items = _this2.filterItems(response.rows);
	              _this2.renderLabels({
	                ini: (query.page - 1) * query.limit + 1,
	                end: query.page * query.limit < response.count ? query.page * query.limit : response.count,
	                total: response.count
	              });
	              return items;
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'duplicar',
	    value: function duplicar(item) {
	      this.$log.log('duplicar = ', item);
	      this.Modal.show({
	        template: _duplicarModal2.default,
	        controller: _duplicarModalController2.default,
	        data: { id_certificacion: item.certificacion.id_certificacion },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'eliminar',
	    value: function eliminar(item) {
	      var _this3 = this;
	
	      this.Modal.confirm('Al eliminar esta declaración, no podrá recuperar la información ingresada. ¿Desea eliminar el registro?', function () {
	        _this3.$log.log('Eliminamos = ', item);
	        _this3.DataService.delete('certificaciones/' + item.certificacion.id_certificacion).then(function () {
	          _this3.Message.success('Su registro fue eliminado correctamente.');
	          _this3.refresh();
	        });
	      });
	    }
	  }, {
	    key: 'procesar',
	    value: function procesar(nombre) {
	      return nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace('DECLARACIÓN JURADA PARA LA ', '');
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.cargarTabla();
	    }
	  }, {
	    key: 'cleanSearch',
	    value: function cleanSearch() {
	      this.searchTerm = '';
	      this.refresh();
	    }
	  }, {
	    key: 'irDetalle',
	    value: function irDetalle() {
	      this.$location.path('declaracionDetalle');
	    }
	
	    //filtrado en grid
	
	  }, {
	    key: 'orderItem',
	    value: function orderItem(data, fields, pos) {
	      if (fields === undefined || fields.length === 0) {
	        return data;
	      }
	      var item = {};
	      for (var i in fields) {
	        var field = fields[i].key;
	        if (data[field] !== undefined) {
	          if (this.editable) {
	            if (typeof data[field] == 'string' && !/[a-zA-Z]+/g.test(data[field]) && /^-?[0-9.]+\-?[0-9]+\-?[0-9]*$/g.test(data[field]) && data[field].length == 10) {
	              var date = data[field].split('-');
	              this.dataGrid[pos + '_' + field] = new Date(date[0], date[1] - 1, date[2]);
	            } else {
	              this.dataGrid[pos + '_' + field] = data[field];
	            }
	            item[field] = pos + '_' + field;
	          } else {
	            item[field] = data[field];
	          }
	        }
	      }
	      return item;
	    }
	  }, {
	    key: 'removeCorchete',
	    value: function removeCorchete(string, search) {
	      return string.replace(search + '[', '').replace(']', '');
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(params) {
	      //        setTimeout(() => {
	      //            document.querySelector('.ng-table-counts').setAttribute('data-content', 'Filas: ');
	      //            document.querySelector('.ng-table-pagination').setAttribute('data-content', `${params.ini} al ${params.end} de ${params.total} Registros.`);
	      //            document.querySelector('.ng-table-filters .filter:last-child').setAttribute('data-content', 'Acciones');
	      //        }, 100);
	      params;
	    }
	  }, {
	    key: 'filterItems',
	    value: function filterItems(data) {
	      var fields = this.fields !== undefined;
	      var fks = this.fks !== undefined;
	      var relations = this.relations !== undefined;
	      var array = [];
	      for (var i in data) {
	        for (var j in data[i]) {
	          if (fields && this.fields.indexOf(j) == -1) {
	            delete data[i][j];
	          } else {
	            if (this.editable === undefined) {
	              if (typeof data[i][j] == 'boolean') {
	                data[i][j] = data[i][j] ? 'check_circle_success' : 'check_circle_gray';
	              } else if (relations && this.relations[j]) {
	                data[i][j] = this.CrudTable.searchFieldData(this.relations[j], data[i][j]);
	              } else if (fks && this.fks.indexOf(j) != -1) {
	                if (this.Util.toType(data[i][j]) == 'array') {
	                  var l = this.CrudTable.lengthOptions(this.fieldsData, j);
	                  if (l > 1 && l == data[i][j].length) {
	                    data[i][j] = 'Todos';
	                  } else {
	                    var text = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                      for (var _iterator = data[i][j][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var e = _step.value;
	
	                        text.push(this.CrudTable.getFkData(this.fieldsData, j, e));
	                      }
	                    } catch (err) {
	                      _didIteratorError = true;
	                      _iteratorError = err;
	                    } finally {
	                      try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                          _iterator.return();
	                        }
	                      } finally {
	                        if (_didIteratorError) {
	                          throw _iteratorError;
	                        }
	                      }
	                    }
	
	                    data[i][j] = text.join(', ');
	                  }
	                } else {
	                  data[i][j] = this.CrudTable.getFkData(this.fieldsData, j, data[i][j]);
	                }
	              } else if (this.Util.toType(data[i][j]) == 'array') {
	                data[i][j] = data[i][j][0];
	              }
	            }
	          }
	        }
	        array.push(this.orderItem(data[i], this.fieldsData, i));
	      }
	      return array;
	    }
	  }, {
	    key: 'getSorting',
	    value: function getSorting(params) {
	      for (var key in params) {
	        if (key.indexOf('sorting') != -1) {
	          return (params[key] == 'desc' ? "-" : "") + this.removeCorchete(key, 'sorting');
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters(params) {
	      var filters = [];
	      for (var key in params) {
	        if (key.indexOf('filter') != -1) {
	          filters.push(_defineProperty({}, this.removeCorchete(key, 'filter'), params[key]));
	        }
	      }
	      return filters;
	    }
	
	    //  verPdfTabla(certificacion) {
	    //    var ruta = `certificaciones/` + certificacion.certificacion.id_certificacion + '/reporte';
	    //    if (certificacion.certificacion.estado == 'APROBADO') {
	    //      ruta = `certificaciones/mostrar_reporte/` + certificacion.certificacion.id_certificacion
	    //    }
	    //
	    //    if (this.esEdge()) {
	    //      this.descargarPdf(ruta, 'reporte_generado');
	    //    } else {
	    //      this.DataService.pdfO(ruta, {})
	    //      .then((response) => {
	    //        if (response) {
	    //          var obj = {
	    //            "urlPdf": response
	    //          };
	    //          this.Modal.show({
	    //            template: modalTemplate,
	    //            controller: modalController,
	    //            data: obj,
	    //            size: 'extra-large'
	    //          });
	    //        }
	    //      });
	    //    }
	    //
	    //  }
	
	    //  datosPago(certificacion) {
	    //    this.$log.log('***Datos del pago***', certificacion);
	    //    this.Modal.show({
	    //      template: modalpagoTemplate,
	    //      controller: modalpagoController,
	    //      data: {id_certificacion: certificacion.certificacion.id_certificacion},
	    //      size: 'lg'
	    //    });
	    //
	    //  }
	
	  }, {
	    key: 'veCertificadoTabla',
	    value: function veCertificadoTabla(certificacion) {
	      var _this4 = this;
	
	      var ruta = 'certificaciones/generar_certificado/' + certificacion.certificacion.id_certificacion;
	      if (certificacion.certificacion.estado == 'APROBADO') {
	        ruta = 'certificaciones/mostrar_certificado/' + certificacion.certificacion.id_certificacion;
	      }
	      if (this.esEdge()) {
	        this.descargarPdf(ruta, 'certificado_generado');
	      } else {
	        this.DataService.pdfO(ruta, {}).then(function (response) {
	          if (response) {
	            var obj = {
	              "urlPdf": response
	            };
	            _this4.Modal.show({
	              template: _ddjjdetalleModal2.default,
	              controller: _ddjjdetalleModalController2.default,
	              data: obj,
	              size: 'extra-large'
	            });
	          }
	        });
	      }
	    }
	
	    //  descargarPdf(ruta, nombre) {
	    //    this.DataService.pdfOfile(ruta, {})
	    //    .then((response) => {
	    //      if (response) {
	    //        nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_');//todos los caracteres
	    //        //let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
	    //        var fileName = "" + nombre + ".pdf";
	    //        var a = document.createElement("a");
	    //        document.body.appendChild(a);
	    //        a.href = response;
	    //        a.download = fileName;
	    //        a.click();
	    //        this.Message.success('Su documento esta siendo descargado.');
	    //      }
	    //    });
	    //  }
	
	  }]);
	
	  return DuplicarController;
	}();
	
	exports.default = DuplicarController;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _duplicar = __webpack_require__(420);
	
	var _duplicar2 = _interopRequireDefault(_duplicar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Duplicacion = angular.module('app.duplicado', []).component('duplicado', _duplicar2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('duplicado', {
	    url: '/duplicado',
	    component: 'duplicado'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Duplicacion;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inscripcionEmp = __webpack_require__(433);
	
	var _inscripcionEmp2 = _interopRequireDefault(_inscripcionEmp);
	
	var _matriculaEmp = __webpack_require__(437);
	
	var _matriculaEmp2 = _interopRequireDefault(_matriculaEmp);
	
	var _registroEmp = __webpack_require__(443);
	
	var _registroEmp2 = _interopRequireDefault(_registroEmp);
	
	var _formularioEmp = __webpack_require__(427);
	
	var _formularioEmp2 = _interopRequireDefault(_formularioEmp);
	
	var _certificadoEmp = __webpack_require__(419);
	
	var _certificadoEmp2 = _interopRequireDefault(_certificadoEmp);
	
	var _bandeja = __webpack_require__(413);
	
	var _bandeja2 = _interopRequireDefault(_bandeja);
	
	var _duplicar = __webpack_require__(422);
	
	var _duplicar2 = _interopRequireDefault(_duplicar);
	
	var _bandejaAguinaldo = __webpack_require__(410);
	
	var _bandejaAguinaldo2 = _interopRequireDefault(_bandejaAguinaldo);
	
	var _bandejaRefrigerio = __webpack_require__(416);
	
	var _bandejaRefrigerio2 = _interopRequireDefault(_bandejaRefrigerio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empresario = angular.module('app.empresario', [_inscripcionEmp2.default, _registroEmp2.default, _matriculaEmp2.default, _formularioEmp2.default, _certificadoEmp2.default, _bandeja2.default, _duplicar2.default, _bandejaAguinaldo2.default, _bandejaRefrigerio2.default]).name;
	
	exports.default = Empresario;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _formularioEmp = __webpack_require__(425);
	
	var _formularioEmp2 = _interopRequireDefault(_formularioEmp);
	
	var _formularioEmp3 = __webpack_require__(629);
	
	var _formularioEmp4 = _interopRequireDefault(_formularioEmp3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormularioComponent = {
	    bindings: {},
	    controller: _formularioEmp2.default,
	    template: _formularioEmp4.default
	};
	
	exports.default = FormularioComponent;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formularioEmpModalController = __webpack_require__(426);
	
	var _formularioEmpModalController2 = _interopRequireDefault(_formularioEmpModalController);
	
	var _formularioEmpModal = __webpack_require__(630);
	
	var _formularioEmpModal2 = _interopRequireDefault(_formularioEmpModal);
	
	var _formularioEmpRegModalController = __webpack_require__(428);
	
	var _formularioEmpRegModalController2 = _interopRequireDefault(_formularioEmpRegModalController);
	
	var _formularioEmpRegModal = __webpack_require__(631);
	
	var _formularioEmpRegModal2 = _interopRequireDefault(_formularioEmpRegModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormularioEmpController = function () {
	  FormularioEmpController.$inject = ["DataService", "Storage", "Sidenav", "Modal", "$log", "apiUrl"];
	  function FormularioEmpController(DataService, Storage, Sidenav, Modal, $log, apiUrl) {
	    'ngInject';
	
	    _classCallCheck(this, FormularioEmpController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.Sidenav = Sidenav;
	    this.$log = $log;
	    this.apiUrl = apiUrl;
	    this.usuario = this.Storage.getUser();
	  }
	
	  _createClass(FormularioEmpController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      try {
	        var colors = ['primary', 'success', 'warning', 'danger', 'success-second', 'info-second'];
	        this.matricula = this.Storage.get('matricula');
	        this.show_actualizar_matricula = this.Storage.get('not_found_matricula');
	        this.show_button_back = this.usuario.nit != null;
	
	        // if (!this.matricula) {
	        //   this.Sidenav.path('matricula');
	        // }
	        var urlAux = 'formularios?ambito=PROBOLIVIA';
	
	        this.esAguinaldo = false;
	        this.$log.log('es__Aguinaldo');
	        this.$log.log(this.Storage.get('esAguinaldo'));
	        if (this.Storage.get('esAguinaldo')) {
	          this.esAguinaldo = true;
	          urlAux = urlAux + '&id_formulario=9';
	        }
	
	        this.esRefrigerio = false;
	        this.$log.log('es__Refrigerio');
	        this.$log.log(this.Storage.get('esRefrigerio'));
	        if (this.Storage.get('esRefrigerio')) {
	          this.esRefrigerio = true;
	          urlAux = urlAux + '&id_formulario=10';
	        }
	        this.DataService.get(urlAux).then(function (response) {
	          if (response) {
	            _this.formularios = response.map(function (el, index) {
	              el.nombre = el.nombre.replace('DECLARACIÓN JURADA PARA EL REGISTRO Y ACREDITACIÓN NACIONAL DE', '').replace("ICAP''s", "ICAP's");
	              el.nombre = el.nombre.replace('DECLARACIÓN JURADA PARA LA ', '');
	              el.color = colors[index];
	              return el;
	            });
	          }
	        });
	      } catch (error) {
	        this.$log.log(error);
	      }
	    }
	  }, {
	    key: 'seleccionar',
	    value: function seleccionar(formulario) {
	      var _this2 = this;
	
	      var preg, data;
	      if (formulario.estado === 'ACTIVO') {
	        preg = 'Clic en <strong>aceptar</strong> para crear la declaración jurada.';
	        if (this.matricula) {
	          '\xBFRealmente desea <strong>crear</strong> este formulario de <strong>Declaraci\xF3n Jurada</strong> para la matr\xEDcula: <strong>' + this.matricula.matricula + ' - ' + this.matricula.razon_social + '</strong>?';
	        }
	        this.Modal.confirm(preg, function () {
	          data = {};
	          data.fid_formulario = formulario.id_formulario;
	          if (_this2.matricula) {
	            data.matricula_comercio = _this2.matricula.matricula;
	          }
	          _this2.DataService.post('certificaciones', data).then(function (response) {
	            if (response) {
	              _this2.Storage.setSession('certificacion', response.certificacion.id_certificacion);
	              _this2.Sidenav.path('registro');
	            }
	          });
	        });
	      } else {
	        var fecha = new Date(formulario.fecha_inicio);
	        preg = 'El formulario ' + formulario.nombre + ' estará disponible desde el ' + fecha.getDate() + '/' + (fecha.getMonth() + 1 < 10 ? '0' : '') + (fecha.getMonth() + 1) + '/' + fecha.getFullYear() + '.';
	        this.Modal.alert(preg, null, "Información", null, 'md');
	      }
	    }
	  }, {
	    key: 'seleccionarOpcion',
	    value: function seleccionarOpcion(formulario) {
	
	      var preg;
	      if (formulario.estado === 'ACTIVO') {
	        var data = {};
	
	        data.fid_formulario = formulario.id_formulario;
	        if (this.matricula) {
	          data.matricula_comercio = this.matricula.matricula;
	        }
	        this.Modal.show({
	          template: _formularioEmpRegModal2.default,
	          controller: _formularioEmpRegModalController2.default,
	          data: data,
	          size: 'medium'
	        });
	      } else {
	        var fecha = new Date(formulario.fecha_inicio);
	        preg = 'El formulario ' + formulario.nombre + ' estará disponible desde el ' + fecha.getDate() + '/' + (fecha.getMonth() + 1 < 10 ? '0' : '') + (fecha.getMonth() + 1) + '/' + fecha.getFullYear() + '.';
	        this.Modal.alert(preg, null, "Información", null, 'md');
	      }
	    }
	  }, {
	    key: 'atras',
	    value: function atras() {
	      this.Storage.remove('formulario');
	      this.Sidenav.path('matricula');
	    }
	  }, {
	    key: 'verTablaCostos',
	    value: function verTablaCostos() {
	      this.Modal.show({
	        template: _formularioEmpModal2.default,
	        controller: _formularioEmpModalController2.default,
	        data: {},
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'descargarManual',
	    value: function descargarManual(tipoDocumento) {
	      var _this3 = this;
	
	      this.$log.log("Descargamos manual de usuario*** ", tipoDocumento);
	      var urlDownload = this.apiUrl + 'certificaciones/descargas?formulario=' + tipoDocumento;
	      this.$log.log("Descargamos manual de usuario*** ", urlDownload);
	      //var urlDownload = `${this.apiUrl}probolivia/${idOng}/descargas/?tipo=ruta_marco_cooperacion`;
	      this.DataService.pdfOfile(urlDownload, {}).then(function (response) {
	        if (response) {
	          var fileName = 'guia-' + tipoDocumento.toLowerCase() + '.pdf';
	          var a = document.createElement("a");
	          document.body.appendChild(a);
	          a.href = response;
	          a.download = fileName;
	          a.click();
	          _this3.Message.success('Su documento está siendo descargado.');
	        }
	      });
	    }
	  }]);
	
	  return FormularioEmpController;
	}();
	
	exports.default = FormularioEmpController;

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodigoRegArtModalController = function () {
	  CodigoRegArtModalController.$inject = ["$uibModalInstance", "data", "Modal", "Auth", "DataService", "$location", "Storage", "SidenavFactory", "Message", "$log"];
	  function CodigoRegArtModalController($uibModalInstance, data, Modal, Auth, DataService, $location, Storage, SidenavFactory, Message, $log) {
	    'ngInject';
	
	    _classCallCheck(this, CodigoRegArtModalController);
	
	    this.items = data;
	    this.usuario = data.usuario;
	    this.correo = data.correo;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$location = $location;
	    this.Modal = Modal;
	    this.Auth = Auth;
	    this.DataService = DataService;
	    this.SidenavFactory = SidenavFactory;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.$log = $log;
	  }
	
	  _createClass(CodigoRegArtModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.focus = true;
	      this.nroCuenta = '';
	      this.DataService.get('escalas_pagos?ambito=PROBOLIVIA').then(function (response) {
	        if (response) {
	          _this.escalas = response;
	          if (angular.isDefined(_this.escalas) && _this.escalas.length > 1) {
	            _this.nroCuenta = _this.escalas[0].formulario.nro_cuenta;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.focus = false;
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return CodigoRegArtModalController;
	}();
	
	exports.default = CodigoRegArtModalController;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _formularioEmp = __webpack_require__(424);
	
	var _formularioEmp2 = _interopRequireDefault(_formularioEmp);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.emp.formulario', []).component('appEmpFormulario', _formularioEmp2.default).config(["$stateProvider", "$urlRouterProvider", "statePrevs", function ($stateProvider, $urlRouterProvider, statePrevs) {
	    statePrevs['formulario'] = ['matricula', 'matriculaAguinaldo', 'matriculaRefrigerio']; //solo puede venir de matricula
	    $stateProvider.state('formulario', {
	        url: '/formulario',
	        component: 'appEmpFormulario'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formularioModalRecuperar = __webpack_require__(632);
	
	var _formularioModalRecuperar2 = _interopRequireDefault(_formularioModalRecuperar);
	
	var _formularioModalRecuperar3 = __webpack_require__(429);
	
	var _formularioModalRecuperar4 = _interopRequireDefault(_formularioModalRecuperar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodigoRegArtModalController = function () {
	  CodigoRegArtModalController.$inject = ["$uibModalInstance", "data", "Modal", "Auth", "DataService", "$location", "Storage", "SidenavFactory", "Message", "$log", "Sidenav"];
	  function CodigoRegArtModalController($uibModalInstance, data, Modal, Auth, DataService, $location, Storage, SidenavFactory, Message, $log, Sidenav) {
	    'ngInject';
	
	    _classCallCheck(this, CodigoRegArtModalController);
	
	    this.items = data;
	    this.usuario = data.usuario;
	    this.correo = data.correo;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$location = $location;
	    this.Modal = Modal;
	    this.Auth = Auth;
	    this.DataService = DataService;
	    this.SidenavFactory = SidenavFactory;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.$log = $log;
	    this.Sidenav = Sidenav;
	  }
	
	  _createClass(CodigoRegArtModalController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.focus = true;
	      this.$log.log('--->Modal pregunta', this.items);
	      this.esRefrigerio = false;
	      this.$log.log('es__Refrigerio');
	      this.$log.log(this.Storage.get('esRefrigerio'));
	      if (this.Storage.get('esRefrigerio')) {
	        this.esRefrigerio = true;
	      }
	    }
	  }, {
	    key: "renovacion",
	    value: function renovacion() {
	      var _this = this;
	
	      this.items.tipo = 'RENOVACION';
	      this.DataService.post("certificaciones", this.items).then(function (response) {
	        if (response) {
	          _this.Storage.setSession('certificacion', response.certificacion.id_certificacion);
	          _this.Sidenav.path('registro');
	          _this.$uibModalInstance.dismiss('cancel');
	        }
	      });
	    }
	  }, {
	    key: "nuevo",
	    value: function nuevo() {
	      var _this2 = this;
	
	      if (this.esRefrigerio) {
	        var data = {};
	        data.fid_formulario = 10;
	
	        this.DataService.get("certificaciones/verificar/aguinaldo").then(function (response) {
	          _this2.$log.log('verifica si tiene un formulario de aguinaldo vigente  APROBADO O APROBADO_ENVIADO');
	          _this2.$log.log(response);
	          if (response === true) {
	            _this2.Modal.show({
	              template: _formularioModalRecuperar2.default,
	              controller: _formularioModalRecuperar4.default,
	              data: data,
	              size: 'medium'
	            });
	            _this2.$uibModalInstance.dismiss('cancel');
	          } else {
	            _this2.items.tipo = 'REGISTRO';
	            _this2.DataService.post("certificaciones", _this2.items).then(function (response) {
	              if (response) {
	                _this2.Storage.setSession('certificacion', response.certificacion.id_certificacion);
	                _this2.Sidenav.path('registro');
	                _this2.$uibModalInstance.dismiss('cancel');
	              }
	            });
	          }
	        });
	      } else {
	        this.items.tipo = 'REGISTRO';
	        this.DataService.post("certificaciones", this.items).then(function (response) {
	          if (response) {
	            _this2.$log.log(response);
	            _this2.Storage.setSession('certificacion', response.certificacion.id_certificacion);
	            _this2.Sidenav.path('registro');
	            _this2.$uibModalInstance.dismiss('cancel');
	          }
	        });
	      }
	    }
	  }, {
	    key: "nuevo1",
	    value: function nuevo1() {
	      var _this3 = this;
	
	      this.items.tipo = 'REGISTRO';
	      this.DataService.post("certificaciones", this.items).then(function (response) {
	        if (response) {
	          _this3.Storage.setSession('certificacion', response.certificacion.id_certificacion);
	          _this3.Sidenav.path('registro');
	          _this3.$uibModalInstance.dismiss('cancel');
	        }
	      });
	    }
	  }, {
	    key: "cancel",
	    value: function cancel() {
	      this.focus = false;
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return CodigoRegArtModalController;
	}();
	
	exports.default = CodigoRegArtModalController;

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodigoRegArtModalController = function () {
	  CodigoRegArtModalController.$inject = ["$uibModalInstance", "data", "Modal", "Auth", "DataService", "$location", "Storage", "SidenavFactory", "Message", "$log", "Sidenav"];
	  function CodigoRegArtModalController($uibModalInstance, data, Modal, Auth, DataService, $location, Storage, SidenavFactory, Message, $log, Sidenav) {
	
	    'ngInject';
	
	    _classCallCheck(this, CodigoRegArtModalController);
	
	    this.items = data;
	    this.usuario = data.usuario;
	    this.correo = data.correo;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$location = $location;
	    this.Modal = Modal;
	    this.Auth = Auth;
	    this.DataService = DataService;
	    this.SidenavFactory = SidenavFactory;
	    this.Storage = Storage;
	    this.Message = Message;
	    this.$log = $log;
	    this.Sidenav = Sidenav;
	  }
	
	  _createClass(CodigoRegArtModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.focus = true;
	      this.$log.log('--->Modal pregunta', this.items);
	    }
	  }, {
	    key: 'nuevo1',
	    value: function nuevo1() {
	      var _this = this;
	
	      this.items.tipo = 'REGISTRO';
	      this.DataService.post('certificaciones', this.items).then(function (response) {
	        if (response) {
	          _this.$log.log('DATOS DE RESPONSE NUEVO');
	          _this.$log.log(response);
	          _this.Storage.setSession('certificacion', response.certificacion.id_certificacion);
	          _this.Sidenav.path('registro');
	          _this.$uibModalInstance.dismiss('cancel');
	        }
	      });
	    }
	  }, {
	    key: 'recuperar2',
	    value: function recuperar2() {
	      var _this2 = this;
	
	      this.items.tipo = 'REGISTRO';
	      this.DataService.post('certificaciones/refrigerio/recuperar').then(function (response) {
	        if (response) {
	          _this2.$log.log('Recupera formulario de aguinaldo  APROBADO  RESPONSE');
	          _this2.$log.log(response);
	          _this2.Storage.setSession('certificacion', response.certificacion.id_certificacion);
	          _this2.Sidenav.path('registro');
	          _this2.$uibModalInstance.dismiss('cancel');
	        }
	      });
	    }
	  }, {
	    key: 'cancel1',
	    value: function cancel1() {
	      this.focus = false;
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return CodigoRegArtModalController;
	}();
	
	exports.default = CodigoRegArtModalController;

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CodigoEmpModalController = function () {
	    CodigoEmpModalController.$inject = ["$uibModalInstance", "data", "Modal", "Auth", "DataService", "$location", "Storage", "SidenavFactory", "Message"];
	    function CodigoEmpModalController($uibModalInstance, data, Modal, Auth, DataService, $location, Storage, SidenavFactory, Message) {
	        'ngInject';
	
	        _classCallCheck(this, CodigoEmpModalController);
	
	        this.items = data;
	        this.usuario = data.usuario;
	        this.correo = data.correo;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$location = $location;
	        this.Modal = Modal;
	        this.Auth = Auth;
	        this.DataService = DataService;
	        this.SidenavFactory = SidenavFactory;
	        this.Storage = Storage;
	        this.Message = Message;
	    }
	
	    _createClass(CodigoEmpModalController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.focus = true;
	        }
	    }, {
	        key: 'confirmar',
	        value: function confirmar() {
	            var _this = this;
	
	            this.DataService.put('usuarios/' + this.usuario.id_usuario + '/confirmar', {
	                email: this.correo,
	                codigo_activacion: this.codigo_activacion
	            }).then(function (response) {
	                if (response) {
	                    var menu = response.menu;
	                    var user = response.user;
	                    user.pathInicio = response.menuEntrar;
	                    _this.SidenavFactory.setUser(user);
	                    _this.Storage.setUser(user);
	
	                    if (!user.nit) {
	                        menu = menu.filter(function (it) {
	                            if (it.id_menu != 10) return it;
	                        });
	                    }
	                    if (!user.nit && user.id_rol === 4) {
	                        _this.Storage.set('upSinNit', true);
	                        menu = menu.filter(function (it) {
	                            if (it.id_menu !== 41 && it.id_menu !== 44) return it;
	                        });
	                    }
	                    _this.SidenavFactory.setMenu(menu);
	                    _this.Storage.set('menu', menu);
	
	                    _this.SidenavFactory.setVisible(true);
	                    _this.Storage.set('visible', true);
	
	                    _this.SidenavFactory.setSidenav(true);
	                    _this.Storage.set('sidenav', true);
	                    _this.$uibModalInstance.close();
	                    _this.$location.path('matricula');
	
	                    _this.Message.success('Su registro se completó satisfactoriamente.');
	                }
	            });
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            var _this2 = this;
	
	            this.focus = false;
	            this.Modal.confirm('¿Realmente quiere cancelar su registro?', function () {
	                _this2.$uibModalInstance.dismiss('cancel');
	                _this2.Auth.logout();
	            }, null, null, 'SI', 'NO');
	        }
	    }]);
	
	    return CodigoEmpModalController;
	}();
	
	exports.default = CodigoEmpModalController;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inscripcionEmp = __webpack_require__(432);
	
	var _inscripcionEmp2 = _interopRequireDefault(_inscripcionEmp);
	
	var _inscripcionEmp3 = __webpack_require__(634);
	
	var _inscripcionEmp4 = _interopRequireDefault(_inscripcionEmp3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InscripcionComponent = {
	    bindings: {},
	    controller: _inscripcionEmp2.default,
	    template: _inscripcionEmp4.default
	};
	
	exports.default = InscripcionComponent;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _terminosEmpModalController = __webpack_require__(434);
	
	var _terminosEmpModalController2 = _interopRequireDefault(_terminosEmpModalController);
	
	var _terminosEmpModal = __webpack_require__(635);
	
	var _terminosEmpModal2 = _interopRequireDefault(_terminosEmpModal);
	
	var _codigoActivacionEmpModalController = __webpack_require__(430);
	
	var _codigoActivacionEmpModalController2 = _interopRequireDefault(_codigoActivacionEmpModalController);
	
	var _codigoActivacionEmpModal = __webpack_require__(633);
	
	var _codigoActivacionEmpModal2 = _interopRequireDefault(_codigoActivacionEmpModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InscripcionEmpController = function () {
	    InscripcionEmpController.$inject = ["Modal", "Auth", "DataService", "Storage", "SidenavFactory", "Message"];
	    function InscripcionEmpController(Modal, Auth, DataService, Storage, SidenavFactory, Message) {
	        'ngInject';
	
	        _classCallCheck(this, InscripcionEmpController);
	
	        this.Modal = Modal;
	        this.Auth = Auth;
	        this.Storage = Storage;
	        this.Message = Message;
	        this.DataService = DataService;
	        this.SidenavFactory = SidenavFactory;
	
	        this.usuario = this.Storage.getUser();
	        this.correo = this.usuario.email;
	    }
	
	    _createClass(InscripcionEmpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.autofocus = true;
	        }
	    }, {
	        key: 'verTerminos',
	        value: function verTerminos() {
	            this.Modal.show({
	                template: _terminosEmpModal2.default,
	                controller: _terminosEmpModalController2.default,
	                data: {},
	                size: 'lg'
	            });
	        }
	    }, {
	        key: 'registrar',
	        value: function registrar() {
	            var _this = this;
	
	            this.DataService.put('usuarios/' + this.usuario.id_usuario + '/confirmar_correo', {
	                email: this.correo
	            }).then(function (response) {
	                if (response) {
	                    // this.Message.success('¡Correo electrónico registrado!');
	                    _this.Modal.show({
	                        template: _codigoActivacionEmpModal2.default,
	                        controller: _codigoActivacionEmpModalController2.default,
	                        data: {
	                            correo: _this.correo,
	                            usuario: _this.usuario
	                        },
	                        keyboard: false
	                    });
	                }
	            });
	        }
	    }]);
	
	    return InscripcionEmpController;
	}();
	
	exports.default = InscripcionEmpController;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _inscripcionEmp = __webpack_require__(431);
	
	var _inscripcionEmp2 = _interopRequireDefault(_inscripcionEmp);
	
	__webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.emp.inscripcion', []).component('appEmpInscripcion', _inscripcionEmp2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('inscripcion', {
	        url: '/inscripcion',
	        component: 'appEmpInscripcion'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TerminosEmpModalController = function () {
	    TerminosEmpModalController.$inject = ["$uibModalInstance", "data"];
	    function TerminosEmpModalController($uibModalInstance, data) {
	        'ngInject';
	
	        _classCallCheck(this, TerminosEmpModalController);
	
	        this.items = data;
	        this.$uibModalInstance = $uibModalInstance;
	    }
	
	    _createClass(TerminosEmpModalController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'ok',
	        value: function ok() {
	            this.$uibModalInstance.close(this.selected.item);
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$uibModalInstance.dismiss('cancel');
	        }
	    }]);
	
	    return TerminosEmpModalController;
	}();
	
	exports.default = TerminosEmpModalController;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculaEmp = __webpack_require__(436);
	
	var _matriculaEmp2 = _interopRequireDefault(_matriculaEmp);
	
	var _matriculaEmp3 = __webpack_require__(636);
	
	var _matriculaEmp4 = _interopRequireDefault(_matriculaEmp3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatriculaComponent = {
	    bindings: {},
	    controller: _matriculaEmp2.default,
	    template: _matriculaEmp4.default
	};
	
	exports.default = MatriculaComponent;

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MatriculaEmpController = function () {
	  MatriculaEmpController.$inject = ["DataService", "Storage", "Sidenav", "$log", "Message", "Modal", "$location"];
	  function MatriculaEmpController(DataService, Storage, Sidenav, $log, Message, Modal, $location) {
	    'ngInject';
	
	    _classCallCheck(this, MatriculaEmpController);
	
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Sidenav = Sidenav;
	    this.$log = $log;
	    this.Modal = Modal;
	    this.Message = Message;
	    this.$location = $location;
	
	    this.usuario = this.Storage.getUser();
	  }
	
	  _createClass(MatriculaEmpController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.Storage.set('esAguinaldo', false);
	      if (this.$location.path() === '/matriculaAguinaldo') {
	        this.Storage.set('esAguinaldo', true);
	      }
	      this.Storage.set('esRefrigerio', false);
	      if (this.$location.path() === '/matriculaRefrigerio') {
	        this.Storage.set('esRefrigerio', true);
	      }
	
	      // this.$log.log(this);
	      if (this.usuario.nit == null) {
	        // si no tiene nit se ira directo a formularios
	        this.Sidenav.path('formulario');
	        this.Storage.remove('not_found_matricula');
	      } else {
	        this.Modal.confirm('', function () {
	          _this.DataService.get('servicios/matriculas/' + _this.usuario.nit).then(function (response) {
	            if (response) {
	              _this.$log.log('****CANTIDAD DE MATRICULAS = ', response);
	              if (angular.isArray(response.matriculas) && response.matriculas.length > 0) {
	                _this.matriculas = response.matriculas;
	                _this.Storage.remove('not_found_matricula');
	              } else {
	                _this.Storage.set('not_found_matricula', true);
	                _this.seleccionar();
	                //Mensaje al no tener matriculas
	                _this.Message.warning(response.mensaje);
	              }
	            }
	          });
	        }, function () {
	          _this.$log.log('--------------');
	          _this.Storage.remove('not_found_matricula');
	          _this.seleccionar();
	        }, '¿Cuenta usted con matrícula de comercio?', 'SI', 'NO', ' ');
	      }
	    }
	  }, {
	    key: 'seleccionar',
	    value: function seleccionar(matricula) {
	      this.$log.log(this.Storage.get('esRefrigerio'));
	      this.Storage.set('matricula', matricula);
	      this.Sidenav.path('formulario');
	    }
	  }]);
	
	  return MatriculaEmpController;
	}();
	
	exports.default = MatriculaEmpController;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculaEmp = __webpack_require__(435);
	
	var _matriculaEmp2 = _interopRequireDefault(_matriculaEmp);
	
	__webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.emp.matricula', []).component('appEmpMatricula', _matriculaEmp2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('matricula', {
	        url: '/matricula',
	        component: 'appEmpMatricula'
	    }).state('matriculaAguinaldo', {
	        url: '/matriculaAguinaldo',
	        component: 'appEmpMatricula'
	    }).state('matriculaRefrigerio', {
	        url: '/matriculaRefrigerio',
	        component: 'appEmpMatricula'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardModalController = function () {
	  DashboardModalController.$inject = ["$uibModalInstance", "data", "$log", "Sidenav", "DataService", "Storage"];
	  function DashboardModalController($uibModalInstance, data, $log, Sidenav, DataService, Storage) {
	    'ngInject';
	
	    _classCallCheck(this, DashboardModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.Sidenav = Sidenav;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.Storage = Storage;
	  }
	
	  _createClass(DashboardModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.user = this.Storage.getUser();
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      //realizar actualizacion
	      var obj = {};
	      this.DataService.put('certificaciones/' + this.items.id_certificacion + '/enviar/', obj).then(function (response) {
	        if (response) {
	          _this.Sidenav.path('bandeja');
	          _this.$uibModalInstance.close();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return DashboardModalController;
	}();
	
	exports.default = DashboardModalController;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImportarModalController = function () {
	  ImportarModalController.$inject = ["$uibModalInstance", "data", "$log", "$scope", "DataService", "Message", "Util"];
	  function ImportarModalController($uibModalInstance, data, $log, $scope, DataService, Message, Util) {
	    'ngInject';
	
	    _classCallCheck(this, ImportarModalController);
	
	    this.data = data;
	    this.conf = data.conf;
	    this.onSave = data.onSave;
	    this.id_certificacion = data.id_certificacion;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	  }
	
	  _createClass(ImportarModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(angular.copy(this.data));
	      this.$log.log(this);
	      this.$log.log("id_certificacion");
	      this.$log.log(this.data.certificacion.id_certificacion);
	      this.url = {
	        importar: this.DataService.getUrl('certificaciones/' + this.data.certificacion.id_certificacion + '/activos_productivos/importar')
	      };
	
	      this.DataService.file('ejemplo_activos_productivos', 'application/csv').then(function (response) {
	        _this.url.csv = response;
	      });
	
	      this.csv = {
	        onCompleteItem: function onCompleteItem(fileItem, response, status /*, headers, reset*/) {
	          // this.$log.log(fileItem, response, status, headers, reset);
	          if (status === 200) {
	            _this.data.activosLoad();
	            _this.Message.success("El archivo CSV se importó satisfactoriamente.");
	            _this.cancel();
	            // if(response.finalizado === true) {
	            //     vm.errors = null;
	            //     vm.success = true;
	            //     mostrarCamposOcultos();
	            //     // setTimeout(function () {
	            //     //     angular.element('#btn-refresh-crudtable').click();
	            //     // }, 1000);
	            //     vm.cancel();
	            //
	            //     $state.reload();
	            //     Storage.set('id_sucursal', vm.data.id_sucursal);
	            // } else { // finalizado con errores
	            //     setTimeout(function () {
	            //         angular.element('#btn-refresh-crudtable').click();
	            //     }, 500);
	            //     vm.tabs = [true, true, false];
	            //     vm.selectedIndex = vm.max - 1;
	            //     vm.upload = false;
	            //     vm.tipo_error = response.datos.tipo_error;
	            //     vm.errors = response.datos.errores;
	            // }
	          } else {
	            _this.Message.error(response.mensaje ? response.mensaje : 'Ocurrió un error desconocido al importar.');
	            // reset();
	            // vm.cancel();
	            // prev();
	          }
	        }
	      };
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	      // this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'onAfterAddingFile',
	    value: function onAfterAddingFile() {
	      // var $content = angular.element('#file-upload-step2');
	      // setTimeout(function () {
	      //     $content.parent().scrollTop($content.height());
	      // }, 100);
	    }
	  }]);
	
	  return ImportarModalController;
	}();
	
	exports.default = ImportarModalController;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImportarModalPController = function () {
	  ImportarModalPController.$inject = ["$uibModalInstance", "data", "$log", "$scope", "DataService", "Message", "Util"];
	  function ImportarModalPController($uibModalInstance, data, $log, $scope, DataService, Message, Util) {
	    'ngInject';
	
	    _classCallCheck(this, ImportarModalPController);
	
	    this.data = data;
	    this.conf = data.conf;
	    this.onSave = data.onSave;
	    //this.id_certificacion = data.id_certificacion;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	  }
	
	  _createClass(ImportarModalPController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(angular.copy(this.data));
	      this.$log.log(this);
	      this.$log.log("idCertificacion");
	      this.$log.log(this.data.idCertificacion);
	      this.url = {
	        importar: this.DataService.getUrl('certificaciones/' + this.data.idCertificacion + '/productos/importar/csv')
	      };
	
	      this.DataService.file('ejemplo_productos', 'application/csv').then(function (response) {
	        _this.url.csv = response;
	      });
	
	      this.csv = {
	        onCompleteItem: function onCompleteItem(fileItem, response, status /*, headers, reset*/) {
	          //this.$log.log(fileItem, response, status, headers, reset);
	          if (status === 200) {
	            _this.data.productosLoad();
	            _this.Message.success("El archivo CSV se importó satisfactoriamente.");
	            _this.cancel();
	            // if(response.finalizado === true) {
	            //     vm.errors = null;
	            //     vm.success = true;
	            //     mostrarCamposOcultos();
	            //     // setTimeout(function () {
	            //     //     angular.element('#btn-refresh-crudtable').click();
	            //     // }, 1000);
	            //     vm.cancel();
	            //
	            //     $state.reload();
	            //     Storage.set('id_sucursal', vm.data.id_sucursal);
	            // } else { // finalizado con errores
	            //     setTimeout(function () {
	            //         angular.element('#btn-refresh-crudtable').click();
	            //     }, 500);
	            //     vm.tabs = [true, true, false];
	            //     vm.selectedIndex = vm.max - 1;
	            //     vm.upload = false;
	            //     vm.tipo_error = response.datos.tipo_error;
	            //     vm.errors = response.datos.errores;
	            // }
	          } else {
	            _this.Message.error(response.mensaje ? response.mensaje : 'Ocurrió un error desconocido al importar.');
	            // reset();
	            // vm.cancel();
	            // prev();
	          }
	        }
	      };
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	      // this.$uibModalInstance.dismiss('cancel');
	    }
	  }, {
	    key: 'onAfterAddingFile',
	    value: function onAfterAddingFile() {
	      // var $content = angular.element('#file-upload-step2');
	      // setTimeout(function () {
	      //     $content.parent().scrollTop($content.height());
	      // }, 100);
	    }
	  }]);
	
	  return ImportarModalPController;
	}();
	
	exports.default = ImportarModalPController;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _registroEmp = __webpack_require__(640);
	
	var _registroEmp2 = _interopRequireDefault(_registroEmp);
	
	var _registroEmp3 = __webpack_require__(442);
	
	var _registroEmp4 = _interopRequireDefault(_registroEmp3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistroComponent = {
	    template: _registroEmp2.default,
	    controller: _registroEmp4.default
	};
	
	exports.default = RegistroComponent;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fundempresaModal = __webpack_require__(85);
	
	var _fundempresaModal2 = _interopRequireDefault(_fundempresaModal);
	
	var _fundempresaModal3 = __webpack_require__(94);
	
	var _fundempresaModal4 = _interopRequireDefault(_fundempresaModal3);
	
	var _declaracionEmpModal = __webpack_require__(438);
	
	var _declaracionEmpModal2 = _interopRequireDefault(_declaracionEmpModal);
	
	var _declaracionEmpModal3 = __webpack_require__(637);
	
	var _declaracionEmpModal4 = _interopRequireDefault(_declaracionEmpModal3);
	
	var _importarEmpModal = __webpack_require__(439);
	
	var _importarEmpModal2 = _interopRequireDefault(_importarEmpModal);
	
	var _importarEmpModal3 = __webpack_require__(638);
	
	var _importarEmpModal4 = _interopRequireDefault(_importarEmpModal3);
	
	var _ubicacionEmpModal = __webpack_require__(444);
	
	var _ubicacionEmpModal2 = _interopRequireDefault(_ubicacionEmpModal);
	
	var _ubicacionEmpModal3 = __webpack_require__(641);
	
	var _ubicacionEmpModal4 = _interopRequireDefault(_ubicacionEmpModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegistroController = function () {
	  RegistroController.$inject = ["DataService", "Message", "Storage", "Sidenav", "Modal", "$log", "$scope", "Util", "$timeout", "numToWord", "Loading"];
	  function RegistroController(DataService, Message, Storage, Sidenav, Modal, $log, $scope, Util, $timeout, numToWord, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, RegistroController);
	
	    this.year_now = new Date().getFullYear();
	    this.Message = Message;
	    this.Storage = Storage;
	    this.Modal = Modal;
	    this.DataService = DataService;
	    this.$log = $log;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    this.Sidenav = Sidenav;
	    this.Util = Util;
	    this.numToWord = numToWord;
	    this.nombre = 'PAGINA INICIAL *** ';
	    this.Loading = Loading;
	    this.ambito = 'test';
	    this.guardandoProducto = false;
	    this.esRefrigerio = false;
	  }
	
	  _createClass(RegistroController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.Loading.show('Cargando', false);
	      this.$log.log("******Datos del certificado");
	      this.$log.log(this);
	      this.certificacion = this.Storage.getSession('certificacion');
	      this.user = this.Storage.getUser();
	      this.isCorreoOk = true;
	
	      if (angular.isUndefined(this.certificacion)) {
	        this.Sidenav.path('formulario');
	      }
	
	      this.get = {}; // variable que guarda respuestas de gets
	      this.time_autoguardado = 1500;
	      this.axs = {
	        change_propietario: true, // evitara que se autoguarde por primera vez el representante y las veces q se asigne true
	        init_productos: false, // evitara que se autoguarde al cargar por primera vez
	        item_activo: {},
	        activos: { // para paginacion de activos
	          page: 1,
	          limit: 10,
	          limit_options: [10, 15, 25],
	          order: '-_fecha_modificacion'
	        },
	        item_deposito: {},
	        conf: {}
	      };
	      // alerts del formulario
	      this.$log.log('>>>>>>>>>>>>>>>>>>>< this.certificacion');
	      this.$log.log(this.certificacion);
	      this.msjs = {
	        requireds: 'Los campos que tienen <span class="ap-req">(</span> ) son obligatorios.',
	        ubi_add: 'Clic en el bot\xF3n m\xE1s para registrar una nueva ubicaci\xF3n.',
	        ubi_req: 'Tiene que registrar al menos una ubicaci\xF3n.',
	        act_eco2_op: 'La actividad econ\xF3mica secundaria es opcional',
	        cob_zero: 'Debe seleccionar al menos un departamento.',
	        act_pro_add: 'Haga Click en el bot\xF3n "+" si desea guardar el registro actual. Si desea importar un archivo CSV, haga Click en el bot\xF3n "Importar CSV"',
	        act_pro_imp: 'Si desea importar un archivo CSV, haga Click en el bot\xF3n "Importar CSV"',
	        rec_personal: 'Debe llenar la secci\xF3n de Recursos Humanos.'
	      };
	      // variable para guardar los timer_delay
	      this.tim = {
	        emp: {},
	        rep: {},
	        act_eco: { 1: {}, 2: {} },
	        activos_load: {},
	        rec: {},
	        cob: {},
	        ser1: {},
	        ser2: {}
	      };
	
	      this.DataService.get('certificaciones/' + this.certificacion).then(function (response) {
	        if (response) {
	          _this.year_now = new Date(_this.Storage.get('dateNow')).getFullYear();
	          _this.tiene_matricula = response.unidad_productiva.hist_empresa != null;
	          _this.data = response.unidad_productiva;
	          // if(this.data.nit == null){
	          //   this.data.fid_par_tipo_societario = 245;
	          // }
	
	          _this.data.anios_experiencia = "";
	          _this.form = angular.copy(response.certificacion.formulario);
	          _this.form.nombre = _this.form.nombre.replace("ICAP''s", "ICAP's");
	          _this.certificacion = response.certificacion;
	          _this.usuario_ddjj_con_nit = response.unidad_productiva.usuario.nit != null;
	          delete response.certificacion.formulario;
	          _this.initJsonData();
	          _this.initJsonConf();
	          if (_this.tiene_matricula) {
	            _this.representantesLoad();
	          }
	          _this.ubicacionesLoad();
	          if (!_this.isForm('ICAP')) {
	            _this.productosLoad();
	          }
	          if (_this.isForm('UNIDAD_PRODUCTIVA') || _this.isForm('ARTESANO') || _this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO')) {
	            _this.activosLoad();
	          }
	          _this.esAguinaldo = false;
	          if (_this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO') || _this.isForm('PROVEEDOR_NACIONAL_PAGO_REFRIGERIO')) {
	            if (_this.esRolTecnico()) {
	              _this.esTecnicoAguinaldo = true;
	            }
	            _this.esAguinaldo = true;
	            _this.msjs.ubi_req = 'Registre la ubicaci\xF3n principal de su empresa.';
	          }
	
	          if (_this.isForm('ICAP')) {
	            _this.coberturasLoad();
	            _this.serviciosLoad();
	            _this.serviciosPadresLoad();
	            _this.serviciosInit();
	          }
	          _this.$scope.$watch('$ctrl.data.hist_representantes', function (newValue, oldValue) {
	            if (angular.toJson(newValue) != angular.toJson(oldValue)) {
	              _this.representanteUpd();
	            }
	          }, true);
	        } else {
	          _this.atras();
	        }
	        _this.esRefrigerio = false;
	        if (_this.form.id_formulario === 10) {
	          _this.esRefrigerio = true;
	        }
	        _this.$log.log(_this.esRefrigerio);
	      });
	    }
	  }, {
	    key: 'initJsonData',
	    value: function initJsonData() {
	      this.data.ubicaciones = [];
	      if (this.data.propietario_representante == 'PROPIETARIO' || this.data.propietario_representante == 'REPRESENTANTE' && !this.tiene_matricula) {
	        this.axs.change_propietario = false;
	      }
	      if (this.isForm('UNIDAD_PRODUCTIVA') || this.isForm('ARTESANO')) {
	        //      this.initDefault(this.data, 'tipo_actividad_economica', 'TRANSFORMACION');
	      }
	      this.initDefault(this.data, 'propietario_representante', 'PROPIETARIO');
	      if (this.data.propietario_representante == 'PROPIETARIO') {
	        this.axs.sw_propietario = true;
	      }
	      if (this.data.propietario_representante == 'REPRESENTANTE' && !this.tiene_matricula) {
	        this.axs.sw_propietario = true;
	      }
	      this.axs.rep_backup = {
	        propietario_representante: angular.copy(this.data.propietario_representante),
	        hist_representantes: angular.copy(this.data.hist_representantes)
	      };
	
	      if (this.certificacion.estado == 'NUEVO') {
	        if (this.data.ingresos_anuales_venta == 0) {
	          delete this.data.ingresos_anuales_venta;
	        }
	        if (this.data.importaciones_anuales == 0) {
	          delete this.data.importaciones_anuales;
	        }
	        if (this.data.exportaciones_anuales_venta == 0) {
	          delete this.data.exportaciones_anuales_venta;
	        }
	        if (this.data.patrimonio_creacion == 0) {
	          delete this.data.patrimonio_creacion;
	        }
	      }
	
	      this.data.activos_productivos = [];
	    }
	  }, {
	    key: 'initDefault',
	    value: function initDefault(obj, key, val) {
	      if (!obj[key]) obj[key] = val;
	    }
	  }, {
	    key: 'initJsonConf',
	    value: function initJsonConf() {
	      var keys, k, sec;
	
	      keys = {
	        'empresa': 'emp',
	        'representante': 'rep',
	        'ubicacion': 'ubi',
	        'actividad': 'act_eco',
	        'recursos_humanos': 'rec',
	        'activos_productivos': 'act_pro',
	        'informacion_financiera': 'inf',
	        'servicios': 'ser',
	        'cobertura_servicios': 'cob',
	        'producto': 'prod',
	        'contacto': 'cont',
	        'representante_aguinaldo': 'rep_agui',
	        'cuenta_bancaria': 'cuenta'
	      };
	
	      this.conf = {};
	      this.alert = {};
	
	      for (k in this.form.secciones[0]) {
	        this.conf[keys[k]] = this.form.secciones[0][k];
	      }
	      delete this.form.secciones;
	
	      if (!/NUEVO|OBSERVADO/.test(this.certificacion.estado)) {
	        for (sec in this.conf) {
	          for (k in this.conf[sec]) {
	            if (angular.isObject(this.conf[sec][k])) this.conf[sec][k].disabled = true;
	          }
	        }
	      }
	      if (!this.tiene_matricula) {
	        if (this.conf.emp.nit) delete this.conf.emp.nit.disabled;
	        if (this.conf.emp.razon_social) delete this.conf.emp.razon_social.disabled;
	        if (this.conf.emp.matricula_comercio) delete this.conf.emp.matricula_comercio.disabled;
	        if (this.conf.emp.fid_par_tipo_societario) delete this.conf.emp.fid_par_tipo_societario.disabled;
	      } else {
	        if (this.conf.emp.nit) this.conf.emp.nit.disabled = true;
	        if (this.conf.emp.razon_social) this.conf.emp.razon_social.disabled = true;
	        if (this.conf.emp.matricula_comercio) this.conf.emp.matricula_comercio.disabled = true;
	        if (this.conf.emp.fid_par_tipo_societario) this.conf.emp.fid_par_tipo_societario.disabled = true;
	      }
	      if (this.data.tipo_actividad_economica_secundaria) {
	        this.axs.conf.prod_2 = true;
	      }
	
	      if (!this.usuario_ddjj_con_nit && this.user.id_rol != 2) {
	        // si el usuario no tiene nit y no es un tecnico_probolivia, ocultaremos nit y matricula
	        //      if (this.conf.emp.nit)
	        //        this.conf.emp.nit.visible = false;
	        //      if (this.conf.emp.matricula_comercio)
	        //        this.conf.emp.matricula_comercio.visible = false;
	      }
	      if (this.usuario_ddjj_con_nit && this.user.id_rol != 2 && !this.tiene_matricula) {}
	      // si el usuario tiene nit y no es un tecnico_probolivia, y no tiene matricula, ocultaremos matricula
	      //      if (this.conf.emp.matricula_comercio)
	      //        this.conf.emp.matricula_comercio.visible = false;
	
	
	      // visibilidad del area de la actividad economica 2
	      if (this.conf.act_eco) this.conf.act_eco.visible2 = true;
	      var sw = false;
	      if (this.conf.act_eco) {
	        if (this.conf.act_eco.anio_inicio2) sw = sw || this.conf.act_eco.anio_inicio2.visible;
	        if (this.conf.act_eco.cantidad_promedio2) sw = sw || this.conf.act_eco.cantidad_promedio2.visible;
	        if (this.conf.act_eco.descripcion_actividad2) sw = sw || this.conf.act_eco.descripcion_actividad2.visible;
	        if (this.conf.act_eco.fid_par_unidad_medida2) sw = sw || this.conf.act_eco.fid_par_unidad_medida2.visible;
	        if (this.conf.act_eco.nombre_producto2) sw = sw || this.conf.act_eco.nombre_producto2.visible;
	        if (this.conf.act_eco.unidad_medida2) sw = sw || this.conf.act_eco.unidad_medida2.visible;
	        if (this.conf.emp.tipo_actividad_economica_secundaria) sw = sw || this.conf.emp.tipo_actividad_economica_secundaria.visible;
	      }
	      if (this.conf.act_eco) this.conf.act_eco.visible2 = sw;
	
	      // Ocultando Secciones para aguinaldo con NIT
	      if (this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO') && (this.usuario_ddjj_con_nit || this.esRolTecnico())) {}
	      // this.conf.act_pro.sec_visible = false;
	      // this.conf.inf.sec_visible = false;
	      // this.conf.rec.sec_visible = false;
	
	      // this.$log.log(this.conf);
	      // this.$log.log(JSON.stringify(this.conf, null, 2));
	    }
	  }, {
	    key: 'masInformacion',
	    value: function masInformacion() {
	      this.Modal.show({
	        template: _fundempresaModal4.default,
	        controller: _fundempresaModal2.default,
	        data: {
	          empresa: this.data
	        },
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'esRolTecnico',
	    value: function esRolTecnico() {
	      if (this.user.id_rol === 2 || this.user.id_rol === 5) return true;
	      return false;
	    }
	  }, {
	    key: 'empresaUpd',
	    value: function empresaUpd() {
	      var _this2 = this;
	
	      //escucahra el watch de fid_par_tipo_organizacion y fid_par_tipo_societario
	      // en caso de sin matricula escucha nombre de la empresa matricula y nit
	      this.Util.funcDelay(this.tim.emp, this.time_autoguardado, function () {
	        _this2.empresaSave(_this2.$scope.registro_form.empresa_form, true);
	      });
	    }
	  }, {
	    key: 'empresaSave',
	    value: function empresaSave(form, apply) {
	      // this.$log.log(form);
	      if (form.$valid) {
	        var data = {};
	
	        //Validando que se envie siempre email-sitioweb
	        if (this.data.sitio_web === '') {
	          this.data.sitio_web = null;
	        }
	        if (this.data.correo_electronico === '') {
	          this.data.correo_electronico = null;
	        }
	        this.objCopy(data, this.data, 'sitio_web');
	        this.objCopy(data, this.data, 'correo_electronico');
	
	        //Si el tipo de ORG es 195, entonces enviamos el texto de la descripcion OTROS
	        if (this.data.fid_par_tipo_organizacion === 195) {
	          this.objCopy(data, this.data, 'tipo_organizacion_otro');
	        }
	
	        if (!this.tiene_matricula) {
	          this.objCopy(data, this.data, 'razon_social, matricula_comercio, nit');
	        }
	
	        if (!this.isForm('ARTESANO')) {
	          this.objCopy(data, this.data, 'fid_par_tipo_societario');
	        }
	        if (this.isForm('UNIDAD_PRODUCTIVA') || this.isForm('ARTESANO') || this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO') || this.isForm('PROVEEDOR_NACIONAL_PAGO_REFRIGERIO')) {
	          this.objCopy(data, this.data, 'fid_par_tipo_organizacion, personeria_juridica, tipo_actividad_economica, tipo_actividad_economica_secundaria');
	          this.axs.conf.prod_2 = this.data.tipo_actividad_economica_secundaria != null || this.data.producto2.id_producto;
	        }
	        if (this.isForm('ICAP')) {
	          this.objCopy(data, this.data, 'anios_experiencia');
	        }
	
	        if (this.isForm('SHB_UNIDAD')) {
	          this.objCopy(data, this.data, 'fid_par_tipo_organizacion, personeria_juridica, tipo_actividad_economica');
	        }
	
	        this.DataService.put('certificaciones/' + this.certificacion.id_certificacion, { unidad_productiva: data });
	      } else {
	        this.Util.setTouchedForm(form);
	        if (apply) {
	          this.$scope.$apply();
	        }
	      }
	    }
	  }, {
	    key: 'representantesLoad',
	    value: function representantesLoad() {
	      var _this3 = this;
	
	      this.DataService.get('servicios/representantes/' + this.data.matricula_comercio).then(function (response) {
	        if (response) {
	          response.forEach(function (it) {
	            it.ci_nombre = it.nro_documento + ' - ' + it.nombre_completo;
	          });
	          _this3.get.representantes = response;
	          if (_this3.axs.rep_backup.hist_representantes) {
	            var representante = {
	              codigo_tipo_documento: _this3.axs.rep_backup.hist_representantes.complemento_documento,
	              nro_documento: _this3.axs.rep_backup.hist_representantes.documento_identidad,
	              nombre_completo: _this3.axs.rep_backup.hist_representantes.nombre_completo,
	              ci_nombre: _this3.axs.rep_backup.hist_representantes.documento_identidad + ' - ' + _this3.axs.rep_backup.hist_representantes.nombre_completo
	              // tipo_vinculo: this.axs.rep_backup.hist_representantes.tipo_vinculo
	            };
	            for (var i = 0; i < _this3.get.representantes.length; i++) {
	              var copy = angular.copy(_this3.get.representantes[i]);
	              delete copy.tipo_vinculo;
	              // this.$log.log(copy, representante);
	              if (angular.equals(copy, representante)) {
	                _this3.data.hist_representantes.representante = _this3.get.representantes[i];
	                _this3.axs.rep_backup.hist_representantes.representante = _this3.get.representantes[i];
	              }
	            }
	          }
	        }
	      });
	    }
	  }, {
	    key: 'representantesRestore',
	    value: function representantesRestore() {
	
	      if (this.axs.rep_backup.propietario_representante == 'REPRESENTANTE' && this.data.propietario_representante == 'REPRESENTANTE') {
	        angular.extend(this.data.hist_representantes, this.axs.rep_backup.hist_representantes);
	        // this.$log.log('entra rep')
	      } else if (this.axs.rep_backup.propietario_representante == 'PROPIETARIO' && this.data.propietario_representante == 'PROPIETARIO') {
	        // this.$log.log('entra pro')
	        angular.extend(this.data.hist_representantes, this.axs.rep_backup.hist_representantes);
	      }
	    }
	  }, {
	    key: 'representanteChange',
	    value: function representanteChange(form) {
	      // this.$log.log(this.tiene_matricula);
	      if (this.tiene_matricula) {
	        for (var k in this.data.hist_representantes) {
	          if (k != 'tipo_documento') {
	            delete this.data.hist_representantes[k];
	          }
	        }
	        this.data.hist_representantes.tipo_documento = this.data.propietario_representante == 'PROPIETARIO' ? 'CARNET_IDENTIDAD' : 'FUNDEMPRESA';
	        this.axs.change_propietario = true;
	        this.Util.setTouchedForm(form, false);
	        this.axs.sw_propietario = this.data.propietario_representante == 'PROPIETARIO';
	        this.representantesRestore();
	      } else {
	        this.axs.change_propietario = false;
	        this.representanteUpd();
	      }
	      // this.$log.log(this.axs, this.data.propietario_representante);
	      // this.$log.log(this.data.hist_representantes);
	    }
	  }, {
	    key: 'representanteUpd',
	    value: function representanteUpd() {
	      var _this4 = this;
	
	      //escucahra el watch de hist_representantes
	      // this.$log.log('representanteUpd');
	      if (!this.axs.change_propietario) {
	        this.Util.funcDelay(this.tim.rep, this.time_autoguardado, function () {
	          _this4.representanteSave(_this4.$scope.registro_form.representante_form);
	        });
	      }
	      delete this.axs.change_propietario;
	    }
	  }, {
	    key: 'representanteSave',
	    value: function representanteSave(form) {
	      var _this5 = this;
	
	      var data = {},
	          sw = false;
	      this.objCopy(data, this.data, ['propietario_representante', 'hist_representantes']);
	      if (data.hist_representantes.representante) {
	        angular.extend(data.hist_representantes, data.hist_representantes.representante);
	        data.hist_representantes.documento_identidad = data.hist_representantes.representante.nro_documento;
	      }
	      // this.$log.log(form);
	      var ignorar;
	      if (data.hist_representantes.tipo_documento == 'FUNDEMPRESA') {
	        ignorar = 'doc_identidad_form';
	      } else {
	        ignorar = 'rep_legal_form';
	      }
	
	      if (this.Util.isValidForm(form, ignorar)) {
	        if (data.hist_representantes.representante) {
	          delete data.hist_representantes.id_persona;
	          delete data.hist_representantes.representante;
	          delete data.hist_representantes.documento_identidad;
	        }
	        if ((data.hist_representantes.tipo_documento == 'CARNET_IDENTIDAD' || data.hist_representantes.tipo_documento == 'CARNET_EXTRANJERO') && !data.hist_representantes.id_persona) {
	          sw = 'L';
	        }
	        if (typeof sw != 'string') {
	          this.DataService.put('certificaciones/' + this.certificacion.id_certificacion, { unidad_productiva: data }).then(function (response) {
	            if (response) {
	              // this.Message.success('Se guardó el registro correctamente.');
	              // this.axs.change_propietario = true;   //se comento porque no autoguardaa despues de autoguardar
	              angular.extend(_this5.data.hist_representantes, response.unidad_productiva.hist_representantes);
	              _this5.axs.rep_backup = {
	                propietario_representante: angular.copy(_this5.data.propietario_representante),
	                hist_representantes: angular.copy(_this5.data.hist_representantes)
	              };
	              _this5.axs.rep_backup.hist_representantes.representante = _this5.data.hist_representantes.representante;
	            }
	          });
	        }
	      } else {
	        this.Util.setTouchedForm(form, true, ignorar);
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'ubicacionesLoad',
	    value: function ubicacionesLoad() {
	      var _this6 = this;
	
	      this.DataService.get('certificaciones/' + this.certificacion.id_certificacion + '/ubicaciones').then(function (response) {
	        if (angular.isArray(response) && response.length > 0) {
	          _this6.data.ubicaciones = response;
	        }
	      });
	    }
	  }, {
	    key: 'ubicacionesAddUpd',
	    value: function ubicacionesAddUpd(i, item) {
	      var _this7 = this;
	
	      this.Modal.show({
	        template: _ubicacionEmpModal4.default,
	        controller: _ubicacionEmpModal2.default,
	        data: { data: angular.copy(item) || {}, tipo_formulario: this.form.tipo, conf: this.conf.ubi, id_certificacion: this.certificacion.id_certificacion, onSave: function onSave() {
	            _this7.ubicacionesLoad();
	          } },
	        size: 'extra-large'
	      });
	    }
	  }, {
	    key: 'ubicacionesDel',
	    value: function ubicacionesDel(i, item) {
	      var _this8 = this;
	
	      this.Modal.confirm('¿Desea eliminar este registro?', function () {
	        _this8.DataService.delete('certificaciones/' + _this8.certificacion.id_certificacion + '/ubicaciones/' + item.id_ubicacion_unidad_productiva).then(function (response) {
	          if (response) {
	            _this8.data.ubicaciones.splice(i, 1);
	            _this8.Message.success();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'productosLoad',
	    value: function productosLoad() {
	      var _this9 = this;
	
	      this.DataService.get('certificaciones/' + this.certificacion.id_certificacion + '/actividades_economicas').then(function (response) {
	        if (angular.isArray(response)) {
	          if (response.length == 0) response.push({});
	          if (response.length == 1) response.push({});
	
	          if (response[0].principal) {
	            _this9.data.producto1 = response[0];
	            _this9.data.producto2 = response[1];
	          } else {
	            _this9.data.producto1 = response[1];
	            _this9.data.producto2 = response[0];
	          }
	
	          if (_this9.data.producto2.id_producto) {
	            _this9.axs.conf.prod_2 = true;
	          }
	        }
	        _this9.axs.init_productos = true;
	      });
	    }
	  }, {
	    key: 'productosUpd',
	    value: function productosUpd(form, i, it) {
	      var _this10 = this;
	
	      this.Util.funcDelay(this.tim.act_eco[i], this.time_autoguardado, function () {
	        _this10.productosSave(form, i, it);
	      });
	    }
	  }, {
	    key: 'productosSave',
	    value: function productosSave(form, i) {
	      var _this11 = this;
	
	      var required, save, it;
	      it = this.data['producto' + i];
	      // this.$log.log(form);
	      if (angular.isUndefined(it.id_producto)) {
	        it.principal = i == 1;
	      }
	      required = it.descripcion_actividad || it.nombre_producto || it.anio_inicio || it.cantidad_promedio || it.fid_par_unidad_medida;
	      save = it.descripcion_actividad && it.nombre_producto && it.anio_inicio && it.cantidad_promedio && it.fid_par_unidad_medida;
	      if (this.isForm('ARTESANO')) {
	        required = required || it.fid_par_clasificacion_artesanal;
	        save = save && it.fid_par_clasificacion_artesanal;
	      }
	      this.axs.conf.prod_2 = required && !it.principal;
	      form.anio_inicio.$setValidity('min_year', it.anio_inicio ? !(parseInt(it.anio_inicio) < 1825) : true);
	      form.anio_inicio.$setValidity('max_year', it.anio_inicio ? !(parseInt(it.anio_inicio) > this.year_now) : true);
	
	      if (form.$valid && save && !this.guardandoProducto) {
	        if (it.id_producto) it.id = it.id_producto;else this.guardandoProducto = true;
	        this.DataService.save('certificaciones/' + this.certificacion.id_certificacion + '/actividades_economicas/', it).then(function (response) {
	          _this11.guardandoProducto = false;
	          if (response) {
	            // this.Message.success('Se guardó el registro correctamente.');
	            angular.extend(it, response);
	            _this11.empresaUpd();
	          }
	        });
	      } else {
	        this.Util.setTouchedForm(form);
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'productosDel',
	    value: function productosDel(i) {
	      var _this12 = this;
	
	      var it = this.data['producto' + i];
	      // this.$log.log(from, it);
	      this.Modal.confirm('¿Desea eliminar este registro?', function () {
	        if (it && it.id_producto) {
	          _this12.DataService.delete('certificaciones/' + _this12.certificacion.id_certificacion + '/actividades_economicas/' + it.id_producto).then(function (response) {
	            if (response) {
	              _this12.productosLoad();
	              _this12.data.tipo_actividad_economica_secundaria = null;
	              _this12.empresaSave(_this12.$scope.registro_form.empresa_form);
	              _this12.Message.success('Su registro fue eliminado correctamente.');
	            }
	          });
	        } else {
	          _this12.productosLoad();
	          _this12.data.tipo_actividad_economica_secundaria = null;
	          _this12.empresaSave(_this12.$scope.registro_form.empresa_form);
	        }
	      });
	    }
	  }, {
	    key: 'personalUpd',
	    value: function personalUpd() {
	      var _this13 = this;
	
	      this.Util.funcDelay(this.tim.rec, this.time_autoguardado, function () {
	        _this13.personalSave(_this13.$scope.registro_form.personal_form);
	      });
	    }
	  }, {
	    key: 'personalSave',
	    value: function personalSave(form) {
	      var _this14 = this;
	
	      var data = {};
	      // this.$log.log(form)
	      if (form.$valid) {
	        data.personal_hombres_permanente = parseInt(this.data.personal_hombres_permanente);
	        data.personal_hombres_eventual = parseInt(this.data.personal_hombres_eventual);
	        data.personal_hombres_familiar = parseInt(this.data.personal_hombres_familiar);
	        data.personal_hombres_discapacitados = parseInt(this.data.personal_hombres_discapacitados);
	        data.personal_mujeres_permanente = parseInt(this.data.personal_mujeres_permanente);
	        data.personal_mujeres_eventual = parseInt(this.data.personal_mujeres_eventual);
	        data.personal_mujeres_familiar = parseInt(this.data.personal_mujeres_familiar);
	        data.personal_mujeres_discapacitados = parseInt(this.data.personal_mujeres_discapacitados);
	        //validaciones front
	
	        if (data.personal_hombres_permanente === 0 && data.personal_mujeres_permanente === 0 && data.personal_hombres_discapacitados === 0 && data.personal_mujeres_discapacitados === 0) {
	          this.Message.error('Tiene que ingresar personal permanente o personal con discapacidad.');
	          return;
	        }
	
	        //enviamos a backend
	        this.DataService.put('certificaciones/' + this.certificacion.id_certificacion, { unidad_productiva: data }).then(function (response) {
	          if (response) {
	            // this.Message.success('Se guardó el registro correctamente.');
	
	            _this14.objCopy(_this14.data, response.unidad_productiva, ['personal_hombres_total', 'personal_mujeres_total', 'personal_hombres_permanente', 'personal_hombres_eventual', 'personal_hombres_familiar', 'personal_hombres_discapacitados', 'personal_mujeres_permanente', 'personal_mujeres_eventual', 'personal_mujeres_familiar', 'personal_mujeres_discapacitados']);
	          }
	        });
	      } else {
	        this.Util.setTouchedForm(form);
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'activosLoad',
	    value: function activosLoad() {
	      var _this15 = this;
	
	      if (this.axs.activos.page < 1) {
	        1;
	        this.axs.activos.page = 1;
	      }
	      if (this.axs.activos.total_pages < this.axs.activos.page) {
	        this.axs.activos.page = this.axs.activos.total_pages;
	      }
	      this.DataService.get('certificaciones/' + this.certificacion.id_certificacion + '/activos_productivos?limit=' + this.axs.activos.limit + '&page=' + this.axs.activos.page + '&order=' + this.axs.activos.order + '&filter=' + (this.axs.activos.filter || '')).then(function (response) {
	        if (response) {
	          _this15.data.activos_productivos = response.rows;
	          _this15.axs.activos.count = response.count;
	          _this15.axs.activos.total_pages = parseInt(response.count / _this15.axs.activos.limit);
	          _this15.axs.activos.max_length_pages = ('' + _this15.axs.activos.total_pages).length;
	          if (response.count == 0 || response.count % _this15.axs.activos.limit > 0) {
	            _this15.axs.activos.total_pages++;
	          }
	          _this15.axs.activos.total = response.total;
	        }
	      });
	    }
	  }, {
	    key: 'activosPageSelect',
	    value: function activosPageSelect(ev) {
	      // this.$log.log(ev);
	      if (ev.target) {
	        ev.target.select();
	      }
	    }
	  }, {
	    key: 'activosPagUpd',
	    value: function activosPagUpd(op) {
	      var _this16 = this;
	
	      // this.$log.log('activosPagUpd', op)
	      if (op == 'page') {
	        this.Util.funcDelay(this.tim.activos_load, 1000, function () {
	          _this16.activosLoad();
	        });
	      } else {
	        switch (op) {
	          case 'aa':
	            this.axs.activos.page = 1;
	            break;
	          case 'a':
	            this.axs.activos.page--;
	            break;
	          case 's':
	            this.axs.activos.page++;
	            break;
	          case 'ss':
	            this.axs.activos.page = this.axs.activos.total_pages;
	            break;
	          case 'l':
	            this.axs.activos.page = 1;
	            break;
	        }
	        this.activosLoad();
	      }
	    }
	  }, {
	    key: 'activosImportar',
	    value: function activosImportar() {
	      this.Modal.show({
	        template: _importarEmpModal4.default,
	        controller: _importarEmpModal2.default,
	        data: this,
	        size: 'lg'
	      });
	    }
	  }, {
	    key: 'activosUpd',
	    value: function activosUpd(i, it) {
	      this.axs.item_activo = angular.copy(it);
	    }
	  }, {
	    key: 'activosUpdCancel',
	    value: function activosUpdCancel(form) {
	      this.axs.item_activo = {};
	      this.Util.setTouchedForm(form, false);
	    }
	  }, {
	    key: 'activosTotalUpd',
	    value: function activosTotalUpd() {
	      var it = this.axs.item_activo;
	      it.total = it.cantidad && it.precio_unitario ? this.round(it.cantidad * angular.copy(it.precio_unitario)) : null;
	    }
	  }, {
	    key: 'activosSave',
	    value: function activosSave(form) {
	      var _this17 = this;
	
	      angular.element(document.querySelector("#cantidad-message")).removeClass("hidden-message");
	      angular.element(document.querySelector("#descripcion-message")).removeClass("hidden-message");
	      angular.element(document.querySelector("#marca-message")).removeClass("hidden-message");
	      angular.element(document.querySelector("#precio_unitario-message")).removeClass("hidden-message");
	      angular.element(document.querySelector("#total-message")).removeClass("hidden-message");
	
	      var it = this.axs.item_activo;
	      if (form.$valid) {
	        if (it.id_activo_productivo) it.id = it.id_activo_productivo;
	        this.DataService.save('certificaciones/' + this.certificacion.id_certificacion + '/activos_productivos/', it).then(function (response) {
	          if (response) {
	            // this.Message.success('Se guardó el registro correctamente.');
	            _this17.activosLoad();
	            _this17.axs.item_activo = {};
	            _this17.Util.setTouchedForm(form, false);
	          }
	        });
	      } else {
	        this.Util.setTouchedForm(form);
	      }
	    }
	  }, {
	    key: 'activosBlur',
	    value: function activosBlur(name) {
	      this.$log.log(name);
	      // this.$log.log(angular.element(document.querySelector(`#${name}`)).addClass("hidden-message"));
	      angular.element(document.querySelector("#cantidad-message")).addClass("hidden-message");
	      angular.element(document.querySelector("#descripcion-message")).addClass("hidden-message");
	      angular.element(document.querySelector("#marca-message")).addClass("hidden-message");
	      angular.element(document.querySelector("#precio_unitario-message")).addClass("hidden-message");
	      angular.element(document.querySelector("#total-message")).addClass("hidden-message");
	
	      //Si se ingreso los campos, la lista esta vacia y el cliente se olvido presionar + , vamos a agregarlo a la lista
	      //    if(angular.isDefined(this.data.activos_productivos)){
	      //      if( angular.isDefined(this.axs) && angular.isDefined(this.axs.item_activo)){
	      //        if(  angular.isDefined(this.axs.item_activo.cantidad) && angular.isDefined(this.axs.item_activo.descripcion) && angular.isDefined(this.axs.item_activo.marca) && angular.isDefined(this.axs.item_activo.precio_unitario) && angular.isDefined(this.axs.item_activo.total)
	      //        && this.axs.item_activo.cantidad !== null && this.axs.item_activo.descripcion!==null && this.axs.item_activo.marca !==null && this.axs.item_activo.precio_unitario !==null && this.axs.item_activo.total !==null
	      //        ){
	      //          if(this.data.activos_productivos.length<=0){
	      //            this.activosSave(form);
	      //          }
	      //        }
	      //      }
	      //    }
	    }
	  }, {
	    key: 'round',
	    value: function round(num) {
	      return parseFloat(num).toFixed(2);
	    }
	  }, {
	    key: 'activosDel',
	    value: function activosDel(i, it) {
	      var _this18 = this;
	
	      if (it.id_activo_productivo) {
	        this.Modal.confirm('¿Desea eliminar este registro?', function () {
	          _this18.DataService.delete('certificaciones/' + _this18.certificacion.id_certificacion + '/activos_productivos/' + it.id_activo_productivo).then(function (response) {
	            if (response) {
	              if (_this18.data.activos_productivos.length == 1 && _this18.axs.activos.total_pages > 1) {
	                _this18.axs.activos.total_pages--;
	              }
	              _this18.activosLoad();
	              _this18.Message.success('Su registro fue eliminado correctamente.');
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'informacionValidityMax',
	    value: function informacionValidityMax(field) {
	      var num = this.data[field];
	      this.$scope.registro_form.informacion_form[field].$setValidity('max_num', true);
	      if (num) {
	        this.$scope.registro_form.informacion_form[field].$setValidity('max_num', !(parseFloat(num) > 9999999999.99));
	      }
	    }
	    // Mod form reg setValidity maxnum a informacion
	
	  }, {
	    key: 'informacionSave',
	    value: function informacionSave(form, openModalDeclaracion) {
	      var _this19 = this;
	
	      var dataUni = {
	        ingresos_anuales_venta: this.data.ingresos_anuales_venta || '0'
	      };
	      if (this.isForm('UNIDAD_PRODUCTIVA') || this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' || this.isForm('PROVEEDOR_NACIONAL_PAGO_REFRIGERIO'))) {
	        dataUni.exportaciones_anuales_venta = this.data.exportaciones_anuales_venta || '0';
	        dataUni.patrimonio_creacion = this.data.patrimonio_creacion || '0';
	        if (this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' || this.isForm('PROVEEDOR_NACIONAL_PAGO_REFRIGERIO'))) {
	          dataUni.cuenta = this.data.cuenta;
	          dataUni.cuenta_moneda = this.data.cuenta_moneda;
	          dataUni.cuenta_tipo = this.data.cuenta_tipo;
	          dataUni.cuenta_departamento = this.data.cuenta_departamento;
	        }
	      } else if (this.isForm('ARTESANO')) {
	        dataUni.exportaciones_anuales_venta = this.data.exportaciones_anuales_venta || '0';
	      } else if (this.isForm('PROVEEDOR')) {
	        dataUni.importaciones_anuales = this.data.importaciones_anuales || '0';
	      }
	      if (form.$valid) {
	        this.DataService.put('certificaciones/' + this.certificacion.id_certificacion, { unidad_productiva: dataUni }).then(function (response) {
	          if (response) {
	            // this.Message.success('Se guardó los datos correctamente.');
	            _this19.data.ingresos_anuales_venta = response.unidad_productiva.ingresos_anuales_venta;
	            _this19.data.exportaciones_anuales_venta = response.unidad_productiva.exportaciones_anuales_venta;
	            _this19.data.patrimonio_creacion = response.unidad_productiva.patrimonio_creacion;
	            if (openModalDeclaracion) {
	              _this19.abrirModalDeclaracion();
	            }
	          }
	        });
	      }
	    }
	  }, {
	    key: 'coberturasLoad',
	    value: function coberturasLoad() {
	      var _this20 = this;
	
	      this.DataService.get('departamento').then(function (response) {
	        if (response) {
	          var obj = {},
	              xobj = {};
	          (_this20.data.cobertura_departamento || []).forEach(function (it) {
	            obj[it] = true;
	          });
	          response.forEach(function (it) {
	            if (obj[it.id]) it.selected = true;
	            if (!xobj[it.abreviacion]) xobj[it.abreviacion] = it;
	          });
	          response = [];
	          // ordenamos para que sea mas facil pickear
	          ['LP', 'CBBA', 'SC', 'OR', 'PT', 'CH', 'BN', 'PD', 'TJ'].forEach(function (abr) {
	            response.push(xobj[abr]);
	          });
	          _this20.get.departamentos = response;
	        }
	      });
	    }
	  }, {
	    key: 'coberturasUpd',
	    value: function coberturasUpd() {
	      var _this21 = this;
	
	      this.Util.funcDelay(this.tim.cob, this.time_autoguardado, function () {
	        _this21.coberturasSave();
	      });
	    }
	  }, {
	    key: 'coberturasSave',
	    value: function coberturasSave() {
	      var _this22 = this;
	
	      // this.$log.log('oh tomamos')
	      var data = [];
	      this.get.departamentos.forEach(function (it) {
	        if (it.selected) data.push(it.id);
	      });
	      // this.$log.log(data)
	      this.DataService.put('certificaciones/' + this.certificacion.id_certificacion, { unidad_productiva: { cobertura_departamento: data } }).then(function (response) {
	        if (response) {
	          _this22.data.cobertura_departamento = response.unidad_productiva.cobertura_departamento;
	          //         this.Message.success('Se guardó el registro correctamente.');
	        }
	      });
	    }
	  }, {
	    key: 'serviciosInit',
	    value: function serviciosInit() {
	      var _this23 = this;
	
	      this.$scope.$watch('$ctrl.data.servicio1.fid_par_servicio_p', function (newValue, oldValue) {
	        if (_this23.axs.init_servicios1 && newValue && newValue != oldValue) {
	          _this23.serviciosHijosLoad(newValue, 1, true);
	        }
	      });
	      this.$scope.$watch('$ctrl.data.servicio2.fid_par_servicio_p', function (newValue, oldValue) {
	        if (_this23.axs.init_servicios2 && newValue && newValue != oldValue) {
	          _this23.serviciosHijosLoad(newValue, 2, true);
	        }
	      });
	      this.$scope.$watch('$ctrl.data.servicio1.fid_par_servicio', function (newValue, oldValue) {
	        if (_this23.axs.init_servicios1 && newValue && newValue != oldValue) {
	          _this23.serviciosUpd(1);
	        }
	      });
	      this.$scope.$watch('$ctrl.data.servicio2.fid_par_servicio', function (newValue, oldValue) {
	        if (_this23.axs.init_servicios2 && newValue && newValue != oldValue) {
	          _this23.serviciosUpd(2);
	        }
	      });
	    }
	  }, {
	    key: 'serviciosLoad',
	    value: function serviciosLoad() {
	      var _this24 = this;
	
	      this.axs.init_servicios1 = false;
	      this.axs.init_servicios2 = false;
	      this.DataService.get('certificaciones/' + this.certificacion.id_certificacion + '/ddjj_servicios').then(function (response) {
	        if (angular.isArray(response)) {
	          if (response.length == 0) response.push({});
	          if (response.length == 1) response.push({});
	
	          if (response[0].principal) {
	            _this24.data.servicio1 = response[0];
	            _this24.data.servicio2 = response[1];
	          } else {
	            _this24.data.servicio1 = response[1];
	            _this24.data.servicio2 = response[0];
	          }
	          if (_this24.data.servicio1.id_ddjj_servicio) {
	            _this24.serviciosInitServ(1);
	          } else {
	            _this24.axs.init_servicios1 = true;
	          }
	
	          if (_this24.data.servicio2.id_ddjj_servicio) {
	            _this24.axs.conf.serv_2 = true;
	            _this24.serviciosInitServ(2);
	          } else {
	            _this24.axs.conf.serv_2 = false;
	            _this24.axs.init_servicios2 = true;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'serviciosInitServ',
	    value: function serviciosInitServ(i) {
	      var it = this.data['servicio' + i];
	      it.fid_par_servicio_p = it.servicio.fid_parametro_padre;
	      delete it.servicio;
	      this.serviciosHijosLoad(it.fid_par_servicio_p, i);
	    }
	  }, {
	    key: 'serviciosPadresLoad',
	    value: function serviciosPadresLoad() {
	      var _this25 = this;
	
	      this.DataService.get('parametros/?grupo=SERVICIO').then(function (response) {
	        if (response) {
	          response.forEach(function (it) {
	            it.parent_nom_formated = it.parametro_padre.orden + '. ' + it.parametro_padre.nombre;
	            it.nom_formated = it.parametro_padre.orden + '.' + it.orden + '. ' + it.nombre;
	          });
	          _this25.get.servicios = response;
	        }
	      });
	    }
	  }, {
	    key: 'serviciosHijosLoad',
	    value: function serviciosHijosLoad(id, i, upd) {
	      var _this26 = this;
	
	      var form = this.$scope.registro_form['servicios_form' + i];
	      this.get['servicios' + i] = [];
	      // form.servicio1p.$setValidity('repetido', !(this.data.servicio1.id_p==this.data.servicio2.id_p));
	      if (this.axs['init_servicios' + i]) {
	        form.fid_par_servicio_p.$setValidity('repetido', this.data.servicio1.fid_par_servicio_p != this.data.servicio2.fid_par_servicio_p);
	      }
	      this.DataService.get('parametros/?grupo=SERVICIO&fid_parametro_padre=' + id).then(function (response) {
	        if (response) {
	          _this26.get['servicios' + i] = response;
	          if (upd) {
	            _this26.data['servicio' + i].fid_par_servicio = null;
	            _this26.serviciosUpd(i);
	          } else {
	            _this26.axs['init_servicios' + i] = true;
	          }
	        }
	      });
	    }
	  }, {
	    key: 'serviciosUpd',
	    value: function serviciosUpd(i) {
	      var _this27 = this;
	
	      this.Util.funcDelay(this.tim['ser' + i], this.time_autoguardado, function () {
	        _this27.serviciosSave(_this27.$scope.registro_form['servicios_form' + i], i);
	      });
	    }
	  }, {
	    key: 'serviciosSave',
	    value: function serviciosSave(form, i) {
	      var required, save, it;
	      it = this.data['servicio' + i];
	      // this.$log.log(form);
	      if (angular.isUndefined(it.id_ddjj_servicio)) {
	        it.principal = i == 1;
	      }
	      if (i == 2) {
	        required = it.fid_par_servicio_p || it.fid_par_servicio || it.descripcion;
	        this.axs.conf.serv_2 = required && !it.principal;
	      }
	      save = it.fid_par_servicio_p && it.fid_par_servicio && it.descripcion;
	
	      if (form.$valid && save) {
	        if (it.id_ddjj_servicio) it.id = it.id_ddjj_servicio;
	        this.DataService.save('certificaciones/' + this.certificacion.id_certificacion + '/ddjj_servicios/', it).then(function (response) {
	          if (response) {
	            // this.Message.success('Se guardó el registro correctamente.');
	            angular.extend(it, response);
	          }
	        });
	      } else {
	        this.Util.setTouchedForm(form);
	        this.$scope.$apply();
	      }
	    }
	  }, {
	    key: 'serviciosSwap',
	    value: function serviciosSwap() {
	      var _this28 = this;
	
	      this.Modal.confirm('¿Desea convertir el servicio secundario a servicio principal?', function () {
	        var it = _this28.data.servicio1;
	        it.principal = false;
	        if (it.id_ddjj_servicio) it.id = it.id_ddjj_servicio;
	        _this28.DataService.save('certificaciones/' + _this28.certificacion.id_certificacion + '/ddjj_servicios/', it).then(function (response) {
	          if (response) {
	            it = _this28.data.servicio2;
	            it.principal = true;
	            if (it.id_ddjj_servicio) it.id = it.id_ddjj_servicio;
	            return _this28.DataService.save('certificaciones/' + _this28.certificacion.id_certificacion + '/ddjj_servicios/', it);
	          }
	        }).then(function (response) {
	          if (response) {
	            _this28.serviciosRefresh();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'serviciosRefresh',
	    value: function serviciosRefresh() {
	      this.$scope.registro_form.servicios_form1.fid_par_servicio_p.$setValidity('repetido', true);
	      this.$scope.registro_form.servicios_form2.fid_par_servicio_p.$setValidity('repetido', true);
	      this.serviciosLoad();
	    }
	  }, {
	    key: 'serviciosDel',
	    value: function serviciosDel(i) {
	      var _this29 = this;
	
	      var it = this.data['servicio' + i];
	      this.Modal.confirm('¿Desea eliminar este registro?', function () {
	        if (it && it.id_ddjj_servicio) {
	          _this29.DataService.delete('certificaciones/' + _this29.certificacion.id_certificacion + '/ddjj_servicios/' + it.id_ddjj_servicio).then(function (response) {
	            if (response) {
	              _this29.Message.success('Su registro fue eliminado correctamente.');
	              _this29.serviciosRefresh();
	            }
	          });
	        } else {
	          _this29.Message.success('Su registro fue eliminado correctamente.');
	          _this29.serviciosRefresh();
	        }
	      });
	    }
	  }, {
	    key: 'isForm',
	    value: function isForm(x) {
	      // ['UNIDAD_PRODUCTIVA','PROVEEDOR','ICAP','ARTESANO'][x-1]
	      if (this.form) {
	        return this.form.tipo == x;
	      }
	      return;
	    }
	  }, {
	    key: 'objCopy',
	    value: function objCopy(obj, obj2, keys) {
	      if (typeof keys == 'string') keys = keys.split(', ');
	      keys.forEach(function (k) {
	        obj[k] = angular.copy(obj2[k]);
	      });
	    }
	  }, {
	    key: 'abrirModalDeclaracion',
	    value: function abrirModalDeclaracion() {
	      var _this30 = this;
	
	      this.DataService.post('certificaciones/' + this.certificacion.id_certificacion + '/validar').then(function (response) {
	        if (response) {
	          _this30.Modal.show({
	            template: _declaracionEmpModal4.default,
	            controller: _declaracionEmpModal2.default,
	            data: { "numero_dias": _this30.form.plazo_dias,
	              "cuenta_banco": _this30.form.nro_cuenta,
	              "id_certificacion": _this30.certificacion.id_certificacion,
	              "tipo_formulario": _this30.form.tipo
	            },
	            size: 'lg'
	          });
	        }
	      });
	    }
	  }, {
	    key: 'declarar',
	    value: function declarar(form) {
	      var _this31 = this;
	
	      //validacion de tipo de actividad economica
	      //validar que haya activos productivos
	      if (!this.isForm('SHB_UNIDAD')) {
	        if (angular.isUndefined(this.data.activos_productivos) && !this.isForm('PROVEEDOR') && !this.isForm('ICAP')) {
	          this.Message.error('Debe llenar información en Activos Productivos');
	          return;
	        }
	        // var esAguinaldoSinNit = this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO');
	        // if ((this.data.activos_productivos.length <= 0) && !esAguinaldoSinNit && !this.esRolTecnico()) {
	        //   this.Message.error('Debe llenar información en Activos Productivos1.');
	        //   return;
	        // } else
	        if (this.data.activos_productivos.length <= 0 && !this.isForm('PROVEEDOR') && !this.isForm('ICAP') && !this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO') && !this.isForm('PROVEEDOR_NACIONAL_PAGO_REFRIGERIO')) {
	          this.Message.error('Debe llenar información en Activos Productivos.');
	          return;
	        }
	        //Proceso de declarar
	        if ((this.data.tipo_actividad_economica === null || angular.isUndefined(this.data.tipo_actividad_economica)) && this.isForm('UNIDAD_PRODUCTIVA')) {
	          this.Message.error('Debe seleccionar el tipo de actividad económica: \'Transformación\' o \'Servicios\' ');
	        }
	      }
	      this.$log.log("=======================datat =======================", this.data);
	      // this.$log.log("**id_certificacion: "+this.certificacion.id_certificacion);
	      var ignorar = 'depositos_form, activos_form, producto_form, contacto_form';
	      if (this.data.hist_representantes.tipo_documento == 'FUNDEMPRESA') {
	        ignorar += ', doc_identidad_form';
	      } else {
	        ignorar += ', rep_legal_form';
	      }
	      // this.$log.log(form)
	      if (this.Util.isValidForm(form, ignorar)) {
	        if (this.isForm('SHB_UNIDAD')) {
	          this.DataService.post('certificaciones/' + this.certificacion.id_certificacion + '/validar').then(function (response) {
	            if (response) {
	              return _this31.DataService.get('cert_sello_bolivia/productos_shb/' + _this31.data.id_unidad_productiva);
	            }
	            return;
	          }).then(function (response) {
	            if (response && response.results) {
	              _this31.Storage.set('matriculaPromueve', { id_unidad_productiva: _this31.data.id_unidad_productiva });
	              _this31.Storage.set('producto', { id_producto: response.results[0].id_producto });
	              _this31.Sidenav.path('certificacion');
	            }
	          });
	        } else {
	          if (this.isForm('ICAP') || this.isForm('PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO') || this.isForm('PROVEEDOR_NACIONAL_PAGO_REFRIGERIO')) {
	            this.abrirModalDeclaracion();
	            this.DataService.put('certificaciones/' + this.certificacion.id_certificacion, { unidad_productiva: this.data }).then(function (response) {
	              if (response) {
	                _this31.$log.log("guardo correctamente");
	                return;
	              }
	            });
	          } else {
	            this.informacionSave(form.informacion_form, true);
	          }
	        }
	      } else {
	        this.Util.setTouchedForm(form, true, ignorar, '.ap-form');
	        if (form.tipo_actividad_economica_secundaria && form.tipo_actividad_economica_secundaria.$error.required) {
	          this.Message.error(this.conf.emp.tipo_actividad_economica_secundaria.label + ' es requerido.');
	        }
	      }
	    }
	  }, {
	    key: 'atras',
	    value: function atras() {
	      if (this.isForm('SHB_UNIDAD')) {
	        this.Sidenav.path('bandejaSello');
	      } else {
	        this.Sidenav.path('bandeja');
	      }
	    }
	  }, {
	    key: 'validateMailKeyup',
	    value: function validateMailKeyup() {
	
	      this.$log.log("MAIL = ", this.data.correo_electronico);
	
	      if (angular.isUndefined(this.data.correo_electronico) || this.data.correo_electronico === '') {
	        //    if (angular.isUndefined(this.data.correo_electronico) ) {
	        this.isCorreoOk = true;
	        return;
	      }
	      if (this.isValidEmail(this.data.correo_electronico)) {
	        this.isCorreoOk = true;
	      } else {
	        this.isCorreoOk = false;
	      }
	    }
	  }, {
	    key: 'isValidEmail',
	    value: function isValidEmail(mail) {
	      return (/^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail)
	      );
	    }
	  }]);
	
	  return RegistroController;
	}();
	
	exports.default = RegistroController;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _registroEmp = __webpack_require__(441);
	
	var _registroEmp2 = _interopRequireDefault(_registroEmp);
	
	__webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Registro = angular.module('app.emp.registro', []).component('appEmpRegistro', _registroEmp2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('registro', {
	        url: '/registro',
	        component: 'appEmpRegistro'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = Registro;

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UbicacionModalController = function () {
	  UbicacionModalController.$inject = ["$uibModalInstance", "data", "$log", "$scope", "DataService", "Message", "Util", "Loading"];
	  function UbicacionModalController($uibModalInstance, data, $log, $scope, DataService, Message, Util, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, UbicacionModalController);
	
	    this.tipo_formulario = data.tipo_formulario;
	    this.data = data.data;
	    this.conf = data.conf;
	    this.onSave = data.onSave;
	    this.id_certificacion = data.id_certificacion;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$log = $log;
	    this.$scope = $scope;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	    this.Loading = Loading;
	  }
	
	  _createClass(UbicacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(angular.copy(this.data));
	      // this.$log.log(this);
	
	      if (this.data.id_ubicacion_unidad_productiva) {
	        if (this.data.telefonos) {
	          this.data.telefonos = this.data.telefonos.split('|');
	        }
	        this.data.latitud = parseFloat(this.data.latitud);
	        this.data.longitud = parseFloat(this.data.longitud);
	      }
	
	      if (this.data.latitud && this.data.longitud) {
	        this.center = {
	          lat: this.data.latitud,
	          lng: this.data.longitud,
	          zoom: 17
	        };
	        this.markers = [{
	          lat: this.data.latitud,
	          lng: this.data.longitud
	        }];
	      } else {
	        // centrear en bolivia
	        this.center = {
	          lat: -17.07778960654538,
	          lng: -424.00634765625,
	          zoom: 6
	        };
	        this.markers = [];
	      }
	
	      this.events_leaflet = {
	        map: {
	          enable: ['dblclick'],
	          logic: 'emit'
	        },
	        markers: {
	          enable: ['dblclick'],
	          logic: 'emit'
	        }
	      };
	
	      this.$scope.$on('leafletDirectiveMap.dblclick', function (event, args) {
	        // this.$log.log(event, args);
	        var ev = args.leafletEvent;
	
	        if (_this.markers.length == 0) {
	          _this.data.latitud = ev.latlng.wrap().lat;
	          _this.data.longitud = ev.latlng.wrap().lng;
	          _this.markers.push({
	            lat: ev.latlng.lat,
	            lng: ev.latlng.lng
	          });
	          _this.legend = {
	            position: 'bottomleft',
	            colors: ['#c0c0c0', '#d8d8d8'],
	            labels: ['<b>Latitud: </b>' + _this.data.latitud, '<b>Longitud: </b>' + _this.data.longitud]
	          };
	        } else {
	          _this.data.latitud = ev.latlng.wrap().lat;
	          _this.data.longitud = ev.latlng.wrap().lng;
	          _this.markers = [];
	          _this.markers.push({
	            lat: ev.latlng.lat,
	            lng: ev.latlng.lng
	          });
	          _this.legend = {
	            position: 'bottomleft',
	            colors: ['#c0c0c0', '#d8d8d8'],
	            labels: ['<b>Latitud: </b>' + _this.data.latitud, '<b>Longitud: </b>' + _this.data.longitud]
	          };
	        }
	      });
	      this.$scope.$on('leafletDirectiveMarker.dblclick', function (event, args) {
	        // this.$log.log(event, args);
	        _this.markers.splice(args.modelName, 1);
	        _this.data.latitud = null;
	        _this.data.longitud = null;
	      });
	
	      this.$scope.$watch('$ctrl.data.fid_departamento', function (newValue, oldValue) {
	        if (newValue != oldValue) {
	          _this.cambiarUbicacion();
	        }
	      });
	      //Datos de mapa legend
	      //    angular.extend(this.$scope, {
	      //
	      //      legend: {
	      //        position: 'topleft',
	      //        colors: ['#c0c0c0', '#d8d8d8'],
	      //        labels: [this.data.longitud, '464564646']
	      //      },
	      //      defaults: {
	      //        tileLayer: "http://{s}.tile.opencyclemap.org/cycle/{z}/{x}/{y}.png",
	      //        scrollWheelZoom: false
	      //      }
	      //    });
	
	      this.legend = {
	        position: 'bottomleft',
	        colors: ['#c0c0c0', '#d8d8d8'],
	        labels: ['', '']
	      };
	    }
	  }, {
	    key: 'beforeAddTel',
	    value: function beforeAddTel(text) {
	      var array = this.data.telefonos;
	      if (array.length >= 5) {
	        this.Message.warning('Solo puede añadir 5 teléfonos como máximo.');
	        return null;
	      }
	      if (text.length > 15) {
	        this.Message.warning("El número telefónico '" + text + "' no debe superar los 15 dígitos");
	      } else if (text.length < 5) {
	        this.Message.warning("El número telefónico '" + text + "' no debe ser inferior a los 5 caracteres");
	      } else if (!/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(text)) {
	        this.Message.warning("Introduzca un número de teléfono válido: " + text);
	      } else {
	        return text;
	      }
	      return null;
	    }
	  }, {
	    key: 'cambiarUbicacion',
	    value: function cambiarUbicacion() {
	      if (this.data.fid_departamento === 1) {
	        this.center = {
	          lat: -19.044594137783026,
	          lng: -65.26608467102051,
	          zoom: 12
	        };
	      } else if (this.data.fid_departamento === 2) {
	        this.center = {
	          lat: -16.50390771403709,
	          lng: -68.15780639648432,
	          zoom: 9
	        };
	      } else if (this.data.fid_departamento === 3) {
	        this.center = {
	          lat: -17.38602663946904,
	          lng: -66.16636276245112,
	          zoom: 9
	        };
	      } else if (this.data.fid_departamento === 4) {
	        this.center = {
	          lat: -17.96273099440687,
	          lng: -67.11204528808588,
	          zoom: 12
	        };
	      } else if (this.data.fid_departamento === 5) {
	        this.center = {
	          lat: -19.57661180504041,
	          lng: -65.76004028320312,
	          zoom: 12
	        };
	      } else if (this.data.fid_departamento === 6) {
	        this.center = {
	          lat: -21.527022546356232,
	          lng: -64.73213195800781,
	          zoom: 12
	        };
	      } else if (this.data.fid_departamento === 7) {
	        this.center = {
	          lat: -17.781381818516973,
	          lng: -63.179969787597656,
	          zoom: 11
	        };
	      } else if (this.data.fid_departamento === 8) {
	        this.center = {
	          lat: -14.833965277394848,
	          lng: -64.9020767211914,
	          zoom: 13
	        };
	      } else if (this.data.fid_departamento === 9) {
	        this.center = {
	          lat: -11.02561877903247,
	          lng: -68.76583099365234,
	          zoom: 13
	        };
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save(form) {
	      var _this2 = this;
	
	      var data = angular.copy(this.data);
	      data.telefonos = data.telefonos.join('|');
	      if (data.telefonos == '') {
	        data.telefonos = null;
	      }
	      this.$log.log("Informacion a enviar =  ", data);
	
	      if (data.avenida_calle === '') {
	        data.avenida_calle = null;
	      }
	      if (data.avenida_calle_referencia === '') {
	        data.avenida_calle_referencia = null;
	      }
	      if (data.numero === '') {
	        data.numero = null;
	      }
	      if (data.piso === '') {
	        data.piso = null;
	      }
	      if (data.edificio === '') {
	        data.edificio = null;
	      }
	
	      if (this.tipo_formulario === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' && (!data.latitud || !data.longitud)) {
	        this.Message.error('Debe registrar la latitud y longitud de la ubicación. Haga doble clic en el mapa para añadir la latitud y longitud.');
	        return;
	      }
	      // this.$log.log(form);
	
	      if (data.id_ubicacion_unidad_productiva) data.id = data.id_ubicacion_unidad_productiva;
	      if (form.$valid) {
	        this.Loading.show('Cargando', true);
	        this.DataService.save('certificaciones/' + this.id_certificacion + '/ubicaciones/', data).then(function (response) {
	          if (response) {
	            // this.$log.log(this);
	            _this2.Message.success();
	            _this2.onSave();
	            _this2.cancel();
	            _this2.Loading.show('Cargando', false);
	          }
	        });
	      } else {
	        this.Util.setTouchedForm(form);
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	      // this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return UbicacionModalController;
	}();
	
	exports.default = UbicacionModalController;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _empresario = __webpack_require__(423);
	
	var _empresario2 = _interopRequireDefault(_empresario);
	
	var _artesano = __webpack_require__(407);
	
	var _artesano2 = _interopRequireDefault(_artesano);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.probolivia', [_empresario2.default, _artesano2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Artesano = angular.module('app.promueve.artesano', []).name;
	
	exports.default = Artesano;

/***/ }),
/* 447 */
[681, 448, 642],
/* 448 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormularioEmpController = function () {
	    FormularioEmpController.$inject = ["$scope", "$q", "DataService", "Storage", "Sidenav", "Modal", "Message", "apiUrl", "baseUrl", "Filter", "Util", "helpLang", "errorsLang", "$log"];
	    function FormularioEmpController($scope, $q, DataService, Storage, Sidenav, Modal, Message, apiUrl, baseUrl, Filter, Util, helpLang, errorsLang, $log) {
	        'ngInject';
	
	        _classCallCheck(this, FormularioEmpController);
	
	        this.$scope = $scope;
	        this.DataService = DataService;
	        this.Storage = Storage;
	        this.Modal = Modal;
	        this.apiUrl = apiUrl;
	        this.baseUrl = baseUrl;
	        this.Sidenav = Sidenav;
	        this.Message = Message;
	        this.Util = Util;
	        this.Filter = Filter;
	        this.$q = $q;
	        this.errorsLang = errorsLang;
	        this.helpLang = helpLang;
	        this.$log = $log;
	
	        this.usuario = this.Storage.getUser();
	
	        this.renderInsumos = false;
	        this.renderPagos = false;
	
	        this.btnSave = false;
	        this.btnSend = false;
	
	        this.inputsRequired = ['nombre_producto', 'capacidad_prod_mensual', 'precio_unitario', 'tipo_comercio', 'desc_produccion'];
	
	        this.opcionesLugar = [{
	            key: 'ETIQUETAS',
	            label: 'Etiquetas'
	        }, {
	            key: 'ENVASES',
	            label: 'Envases'
	        }, {
	            key: 'CARTELES',
	            label: 'Carteles'
	        }, {
	            key: 'VIDEOS',
	            label: 'Videos'
	        }, {
	            key: 'PELICULAS',
	            label: 'Películas'
	        }, {
	            key: 'OTROS',
	            label: 'Otros'
	        }];
	        this.lugaresSeleccionados = {};
	    }
	
	    _createClass(FormularioEmpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.certificacion = this.Storage.get('matricula_seleccionada');
	
	            this.matricula = this.Storage.get('matriculaPromueve');
	
	            this.producto = {
	                id_producto: 25
	            };
	
	            this.$scope.$on('app_sello_modal_success', function () {
	                _this2.atras();
	            });
	
	            // this.urlUpload = `${this.apiUrl}certificacion_promueve/${this.certificacion.id_unidad_productiva}/producto/${this.producto.id_producto}/guardar-foto`;
	
	            this.insumos = {
	                permission: {
	                    filter: false
	                },
	                data: {
	                    formly: [{
	                        key: 'id_insumo',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'ID'
	                        }
	                    }, {
	                        key: 'tipo_item',
	                        type: 'select',
	                        templateOptions: {
	                            label: 'Ítem',
	                            placeholder: 'Nombre de ítem',
	                            required: true,
	                            options: [{
	                                "value": "MATERIA_PRIMA_DIRECTA",
	                                "name": "Materia prima directa"
	                            }, {
	                                "value": "MATERIA_PRIMA_INDIRECTA",
	                                "name": "Materia prima indirecta"
	                            }, {
	                                "value": "MANO_OBRA",
	                                "name": "Mano de obra"
	                            }, {
	                                "value": "OTROS_COSTOS",
	                                "name": "Otros costos"
	                            }],
	                            onChange: function onChange(value, options, _this) {
	                                if (value == 'MANO_OBRA') {
	                                    _this.model.nacional = true;
	                                    _this.model.unidad = 700;
	                                    _this.model.unidad_medida = 'Personas';
	                                } else {
	                                    _this.model.unidad = null;
	                                    _this.model.unidad_medida = '';
	                                }
	                            }
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."'
	                            }
	                        }
	                    }, {
	                        key: 'descripcion',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Descripción',
	                            placeholder: 'Descripción',
	                            required: true,
	                            maxlength: 100
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."',
	                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
	                            }
	                        }
	                    }, {
	                        key: 'cantidad',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Cantidad',
	                            placeholder: 'Cantidad',
	                            required: true,
	                            onKeydown: function onKeydown(value, options, _this, event) {
	                                _this2.Filter.decimalFormat(event, 10);
	                            },
	                            onKeyup: function onKeyup(value, options, _this) {
	                                _this2.calcularTotalInsumo(_this.model);
	                            },
	                            maxlength: 7
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."',
	                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
	                            }
	                        }
	                    }, {
	                        key: 'unidad',
	                        type: 'select',
	                        templateOptions: {
	                            label: 'Unidad de medida',
	                            placeholder: 'Unidad de medida',
	                            required: true,
	                            options: []
	                            // onChange: (value, options, _this, e) => {
	                            //     console.log(value, options, _this);
	                            // }
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."'
	                            }
	                        },
	                        hideExpression: "model.unidad == '700' && model.unidad_medida == 'Personas'"
	                    }, {
	                        key: 'unidad_medida',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Otra unidad',
	                            placeholder: 'Escriba la unidad de medida',
	                            required: true
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."'
	                            }
	                        },
	                        hideExpression: "model.unidad != '700'",
	                        expressionProperties: {
	                            "templateOptions.disabled": "model.unidad == '700' && model.unidad_medida == 'Personas'"
	                        }
	                    }, {
	                        key: 'valor',
	                        type: 'input',
	                        templateOptions: {
	                            type: 'text',
	                            label: 'Valor (bs.)',
	                            placeholder: 'Valor (bs.)',
	                            required: true,
	                            onKeydown: function onKeydown(value, options, _this, event) {
	                                _this2.Filter.decimalFormat(event, 10);
	                            },
	                            onKeyup: function onKeyup(value, options, _this) {
	                                _this2.calcularTotalInsumo(_this.model);
	                            },
	                            maxlength: 10
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."',
	                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
	                            }
	                        }
	                    }, {
	                        key: 'total',
	                        type: 'input',
	                        templateOptions: {
	                            type: 'text',
	                            label: 'Total(bs)',
	                            placeholder: 'Total(bs)',
	                            required: true,
	                            onKeydown: function onKeydown(value, options, _this, event) {
	                                _this2.Filter.decimalFormat(event);
	                            },
	                            maxlength: 24,
	                            disabled: true
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."',
	                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
	                            }
	                        }
	                    }, {
	                        key: 'nacional',
	                        type: 'radio',
	                        defaultValue: true,
	                        templateOptions: {
	                            label: 'Producto nacional',
	                            options: [{ 'value': true, 'name': 'Es nacional' }, { 'value': false, 'name': 'Es extranjero' }]
	                        },
	                        expressionProperties: {
	                            "templateOptions.options": function templateOptionsOptions(value, options, _this) {
	                                if (_this.model.tipo_item == 'MANO_OBRA') {
	                                    return [{ 'value': true, 'name': 'Es nacional' }];
	                                } else {
	                                    return [{ 'value': true, 'name': 'Es nacional' }, { 'value': false, 'name': 'Es extranjero' }];
	                                }
	                            }
	                        }
	                    }],
	                    list: [],
	                    urlUpdate: ''
	                },
	                fks: ['tipo_item', 'unidad'],
	                // fields: ['id_insumo', 'tipo_item', 'descripcion', 'cantidad', 'unidad', 'unidad_medida', 'valor', 'total', 'nacional']
	                hiddenFields: ['unidad_medida'],
	                mergeFields: {
	                    unidad: function unidad(item) {
	                        if (item.unidad == 'Otros') {
	                            return item.unidad_medida;
	                        }
	                        return item.unidad;
	                    }
	                }
	            };
	            this.cargarData();
	
	            this.total = {
	                save: function save(list) {
	                    _this2.$log.log('list update', list);
	                    var total = 0;
	                    list.map(function (e) {
	                        total += parseFloat(e.total);
	                    });
	                    _this2.data.total_costo_bruto = total;
	
	                    var valor = 0;
	                    list.map(function (e) {
	                        valor += parseFloat(e.valor);
	                    });
	                    _this2.data.total_valor_costo_bruto = valor;
	
	                    _this2.guardarForm();
	                }
	            };
	        }
	    }, {
	        key: 'calcularTotalInsumo',
	        value: function calcularTotalInsumo(model) {
	            var cantidad = model.cantidad ? parseFloat(model.cantidad) : 0;
	            var valor = model.valor ? parseFloat(model.valor) : 0;
	            model.total = (cantidad * valor).toFixed(2);
	        }
	    }, {
	        key: 'cargarData',
	        value: function cargarData() {
	            var _this3 = this;
	
	            this.unidades_comercio = [{
	                id_parametro: 'NACIONAL',
	                nombre: 'NACIONAL'
	            }, {
	                id_parametro: 'EXTRANJERO',
	                nombre: 'EXTRANJERO'
	            }, {
	                id_parametro: 'NACIONAL_Y_EXTRANJERO',
	                nombre: 'NACIONAL Y EXTRANJERO'
	            }];
	
	            var idCertificacion = this.Storage.get('editCertificacion');
	            if (idCertificacion) {
	                this.DataService.get('cert_sello_bolivia/solicitarAutorizacion/' + idCertificacion).then(function (response) {
	                    if (response) {
	                        _this3.data = response;
	
	                        var productoData = Object.assign({}, _this3.data.producto);
	                        _this3.data = Object.assign(_this3.data, productoData);
	
	                        if (_this3.data.autorizacionSHB && _this3.data.autorizacionSHB.ubicacionASHB) {
	                            var ubicacionesSeleccionadas = _this3.data.autorizacionSHB.ubicacionASHB.split(',');
	                            for (var i = 0; i <= ubicacionesSeleccionadas.length - 1; i++) {
	                                _this3.lugaresSeleccionados[ubicacionesSeleccionadas[i].trim()] = true;
	                            }
	                        }
	                        _this3.data.medicamento = _this3.data.producto.medicamento === null ? '' : _this3.data.producto.medicamento.toString();
	                        _this3.data.insumos = (_this3.data.produccionBien || []).map(function (item) {
	                            var tmpObj = {};
	                            tmpObj.cantidad = item.cantidad.toString();
	                            tmpObj.descripcion = item.descripcion.toString();
	                            tmpObj.id_insumo = Math.floor(Math.random() * 1000000).toString();
	                            tmpObj.nacional = item.produccionNacional;
	                            tmpObj.new = true;
	                            tmpObj.tipo_item = item.tipoItem;
	                            tmpObj.total = item.total.toString();
	                            tmpObj.unidad = item.codigoUnidadMedida;
	                            tmpObj.unidad_medida = item.otrosUnidadMedida ? item.otrosUnidadMedida.toString() : "";
	                            tmpObj.valor = item.valor.toString();
	                            return tmpObj;
	                        });
	
	                        for (var j = 0; j <= _this3.data.insumos.length - 1; j++) {
	                            _this3.data.insumos[j].unidad = _this3.data.insumos[j].unidad.toString();
	                        }
	
	                        _this3.insumos.data.list = _this3.data.insumos;
	
	                        // Cargar imagenes
	                        var imagenes = document.getElementsByClassName('previewImagenes');
	
	                        if (_this3.data.imagenProducto) {
	                            imagenes[0].src = _this3.data.imagenProducto;
	                        }
	
	                        if (_this3.data.imagenUbicacionSello) {
	                            imagenes[1].src = _this3.data.imagenUbicacionSello;
	                        }
	
	                        if (_this3.data.imagenEtiqueta) {
	                            imagenes[2].src = _this3.data.imagenEtiqueta;
	                        }
	                        _this3.cargarUnidades();
	                    } else {
	                        _this3.Sidenav.path('bandejaSello');
	                    }
	                });
	            } else {
	                this.data = {};
	                this.data.insumos = [];
	                this.insumos.data.list = this.data.insumos;
	                this.cargarUnidades();
	            }
	
	            this.DataService.get('certificacion_promueve/producto/unidades_peso').then(function (response) {
	                response.unshift({ id_parametro: null, nombre: 'Ninguno' });
	                _this3.unidades_peso = response;
	                _this3.$scope.$watch('$ctrl.data.fid_par_unidadMedida', function (newValue, oldValue) {
	                    if (angular.toJson(newValue) != angular.toJson(oldValue)) {
	                        if (newValue != 700) {
	                            _this3.guardarForm();
	                        }
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'guardarData',
	        value: function guardarData() {
	            var _this4 = this;
	
	            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'TEMPORAL';
	
	            try {
	                if (this.data && this.data.unidadmedidapeso === 700) {
	                    if ((this.data.otrosUnidadMedida || '').trim().length === 0) {
	                        this.Message.error('Selecciono otra unidad de medida pero le falta colocar el detalle de esa seleccion');
	                        return;
	                    }
	                }
	                var data = {};
	                data.nroSecuencia = null;
	                data.nroSolicitud = null;
	                data.proveedor = {
	                    idCertificado: this.certificacion.id_certificacion
	                };
	                data.producto = Object.assign({}, this.data);
	                if (data.producto) {
	                    data.producto.peso = parseFloat(data.producto.peso);
	                    data.producto.precioUnitario = parseInt(data.producto.precioUnitario);
	                    data.producto.capacidadProduccionMensual = parseInt(data.producto.capacidadProduccionMensual);
	                    data.producto.medicamento = typeof data.producto.medicamento === 'undefined' || data.producto.medicamento === '' ? null : data.producto.medicamento === 'true';
	                    delete data.producto.finalizado;
	                    delete data.producto.mensaje;
	                    delete data.producto.datos;
	                    delete data.producto.fecha;
	                    delete data.producto.pagos;
	                    delete data.producto.insumos;
	                }
	
	                delete data.producto.autorizacionSHB;
	                delete data.producto.producto;
	                delete data.producto.proveedor;
	
	                if (this.data && this.data.insumos) {
	                    data.produccionBien = this.data.insumos;
	                } else {
	                    data.produccionBien = null;
	                }
	
	                if (Array.isArray(data.produccionBien)) {
	                    data.produccionBien = data.produccionBien.map(function (item) {
	                        var objTmp = {};
	
	                        objTmp.idInsumo = Math.floor(Math.random() * 1000000), objTmp.tipoItem = item.tipo_item, objTmp.descripcion = item.descripcion, objTmp.cantidad = parseFloat(item.cantidad), objTmp.codigoUnidadMedida = parseInt(item.unidad), objTmp.otrosUnidadMedida = item.unidad_medida, objTmp.valor = parseInt(item.valor), objTmp.total = parseFloat(item.total), objTmp.produccionNacional = item.nacional;
	
	                        return objTmp;
	                    });
	                }
	
	                data.producto.codigoProducto = null;
	                data.producto.codigoUnspsc = null;
	                data.producto.codigoFicha = null;
	                data.producto.codigoNandina = null;
	                data.producto.posicionArancelaria = null;
	
	                var images = document.getElementsByClassName('imagenes');
	
	                this.getBase64(images[0]).then(function (response) {
	                    if (!response) {
	                        data.producto.imagenProducto = !images[0].parentElement.parentElement.parentElement.getElementsByTagName('img')[0].src.includes('null') ? _this4.data.imagenProducto : null;
	                    } else {
	                        data.producto.imagenProducto = response;
	                    }
	                    return _this4.getBase64(images[1]);
	                }).then(function (response) {
	                    if (!response) {
	                        data.producto.imagenUbicacionSello = !images[1].parentElement.parentElement.parentElement.getElementsByTagName('img')[0].src.includes('null') ? _this4.data.imagenUbicacionSello : null;
	                    } else {
	                        data.producto.imagenUbicacionSello = response;
	                    }
	                    return _this4.getBase64(images[2]);
	                }).then(function (response) {
	                    if (!response) {
	                        data.producto.imagenEtiqueta = !images[2].parentElement.parentElement.parentElement.getElementsByTagName('img')[0].src.includes('null') ? _this4.data.imagenEtiqueta : null;
	                    } else {
	                        data.producto.imagenEtiqueta = response;
	                    }
	
	                    var ubicaciones = '';
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = Object.entries(_this4.lugaresSeleccionados)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var _step$value = _slicedToArray(_step.value, 2),
	                                key = _step$value[0],
	                                value = _step$value[1];
	
	                            if (value) {
	                                ubicaciones += key + ', ';
	                            }
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	
	                    if (ubicaciones.length > 0) {
	                        ubicaciones = ubicaciones.trim();
	                        ubicaciones = ubicaciones.substring(0, ubicaciones.length - 1);
	                    }
	
	                    data.autorizacionSHB = {
	                        ubicacionASHB: ubicaciones,
	                        otroUbicacionASHB: _this4.data.autorizacionSHB && _this4.data.autorizacionSHB.otroUbicacionASHB ? _this4.data.autorizacionSHB.otroUbicacionASHB : null
	                    };
	
	                    var idCertificacion = _this4.Storage.get('editCertificacion');
	                    if (type === 'SUBMIT') {
	                        _this4.btnSave = true;
	                        _this4.btnSend = true;
	                        if (idCertificacion) {
	                            var _validarImagenes = _this4.validarImagenes(data.producto, true),
	                                error = _validarImagenes.error;
	
	                            if (error) {
	                                _this4.Message.error(error, 'Error de validación');
	                                _this4.btnSave = false;
	                                _this4.btnSend = false;
	                                return;
	                            }
	                            _this4.DataService.put('cert_sello_bolivia/solicitarAutorizacion/' + idCertificacion + '/enviar', data).then(function (response) {
	                                if (response) {
	                                    _this4.Message.success('La operación se realizo correctamente');
	                                    _this4.Sidenav.path('bandejaSello');
	                                } else {
	                                    _this4.btnSave = false;
	                                    _this4.btnSend = false;
	                                }
	                            });
	                        } else {
	                            _this4.DataService.post('cert_sello_bolivia/solicitarAutorizacion', data).then(function (response) {
	                                if (response) {
	                                    idCertificacion = response.id_certificacion;
	                                    _this4.Storage.set('editCertificacion', idCertificacion);
	
	                                    var _validarImagenes2 = _this4.validarImagenes(data.producto, true),
	                                        _error = _validarImagenes2.error;
	
	                                    if (_error) {
	                                        _this4.Message.error(_error, 'Error de validación');
	                                        _this4.btnSave = false;
	                                        _this4.btnSend = false;
	                                        return;
	                                    }
	                                    _this4.DataService.put('cert_sello_bolivia/solicitarAutorizacion/' + idCertificacion + '/enviar', data).then(function (data) {
	                                        if (data) {
	                                            _this4.Message.success('La operación se realizo correctamente');
	                                            _this4.Sidenav.path('bandejaSello');
	                                        } else {
	                                            _this4.btnSave = false;
	                                            _this4.btnSend = false;
	                                        }
	                                    });
	                                } else {
	                                    _this4.btnSave = false;
	                                    _this4.btnSend = false;
	                                }
	                            });
	                        }
	                    } else {
	                        _this4.btnSave = true;
	                        _this4.btnSend = true;
	                        if (idCertificacion) {
	                            var _validarImagenes3 = _this4.validarImagenes(data.producto),
	                                _error2 = _validarImagenes3.error;
	
	                            if (_error2) {
	                                _this4.Message.error(_error2, 'Error de validación');
	                                _this4.btnSave = false;
	                                _this4.btnSend = false;
	                                return;
	                            }
	                            _this4.DataService.put('cert_sello_bolivia/solicitarAutorizacion/' + idCertificacion, data).then(function (response) {
	                                if (response) {
	                                    _this4.Message.success('Su certificacion ha sido actualizado exitosamente');
	                                    _this4.Sidenav.path('bandejaSello');
	                                } else {
	                                    _this4.btnSave = false;
	                                    _this4.btnSend = false;
	                                }
	                            });
	                        } else {
	                            _this4.DataService.post('cert_sello_bolivia/solicitarAutorizacion', data).then(function (response) {
	                                if (response) {
	                                    _this4.Message.success('Su certificacion se guardo temporalmente de manera exitosa.');
	                                    _this4.Sidenav.path('bandejaSello');
	                                } else {
	                                    _this4.btnSave = false;
	                                    _this4.btnSend = false;
	                                }
	                            });
	                        }
	                    }
	                });
	            } catch (error) {
	                this.btnSave = false;
	                this.btnSend = false;
	            }
	        }
	    }, {
	        key: 'cargarUnidades',
	        value: function cargarUnidades() {
	            var _this5 = this;
	
	            this.DataService.get('parametros/?grupo=UNIDAD_MEDIDA').then(function (response) {
	                if (response) {
	                    var items = [];
	                    var _iteratorNormalCompletion2 = true;
	                    var _didIteratorError2 = false;
	                    var _iteratorError2 = undefined;
	
	                    try {
	                        for (var _iterator2 = response[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                            var el = _step2.value;
	
	                            items.push({ value: el.id_parametro + "", name: el.nombre });
	                        }
	                    } catch (err) {
	                        _didIteratorError2 = true;
	                        _iteratorError2 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	                        } finally {
	                            if (_didIteratorError2) {
	                                throw _iteratorError2;
	                            }
	                        }
	                    }
	
	                    _this5.insumos.data.formly[4].templateOptions.options = items;
	
	                    _this5.renderInsumos = true;
	                    _this5.renderPagos = true;
	                }
	            });
	        }
	    }, {
	        key: 'guardarForm',
	        value: function guardarForm() {
	            if (this.data) {
	                // if (this.data.nombre_producto && this.data.color && this.data.capacidad_prod_mensual && this.data.precio_unitario) { //jloza
	                // if (this.isNotArrayEmpty(this.inputsRequired)) { //oguti
	                var data = angular.copy(this.data);
	
	                data.total_costo_bruto = data.total_costo_bruto || 0;
	                data.total_valor_costo_bruto = data.total_valor_costo_bruto || 0;
	                data.total_distribucion_nacional = 0;
	                data.total_distribucion_extranjera = 0;
	
	                delete data.pagos;
	                delete data.insumos;
	                delete data.certificacion;
	                delete data.unidad_productiva;
	
	                this.DataService.put('certificacion_promueve/' + this.certificacion.id_unidad_productiva + '/producto', data);
	                // }
	            }
	        }
	    }, {
	        key: 'isNotArrayEmpty',
	        value: function isNotArrayEmpty(array) {
	            for (var i in array) {
	                if (this.Filter.empty(this.data[array[i]])) {
	                    return false;
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: 'declarar',
	        value: function declarar() {
	            this.guardarData('SUBMIT');
	        }
	    }, {
	        key: 'getBase64',
	        value: function getBase64(imagen) {
	            var defer = this.$q.defer();
	            (function () {
	                if (imagen && imagen.files[0]) {
	                    var reader = new FileReader();
	                    reader.readAsDataURL(imagen.files[0]);
	                    reader.onload = function () {
	                        defer.resolve(reader.result);
	                    };
	                } else {
	                    defer.resolve(null);
	                }
	            })(imagen);
	            return defer.promise;
	        }
	    }, {
	        key: 'validarInsumos',
	        value: function validarInsumos() {
	            var arr = this.insumos.data.list;
	            var sw, materia_prima_directa, materia_prima_indirecta, mano_obra, otros;
	            for (var i = 0; i < arr.length && !sw; i++) {
	                materia_prima_directa = materia_prima_directa || arr[i].tipoItem == 'MATERIA_PRIMA_DIRECTA';
	                materia_prima_indirecta = materia_prima_indirecta || arr[i].tipoItem == 'MATERIA_PRIMA_INDIRECTA';
	                mano_obra = mano_obra || arr[i].tipoItem == 'MANO_OBRA';
	                otros = otros || arr[i].tipoItem == 'OTROS_COSTOS';
	                sw = materia_prima_indirecta && materia_prima_directa && mano_obra && otros;
	            }
	            return !sw;
	        }
	    }, {
	        key: 'validarImagenes',
	        value: function validarImagenes(producto, required) {
	            if (required) {
	                if (!producto.imagenProducto) return { error: 'Se requiere la imagen del producto' };
	                if (!producto.imagenEtiqueta) return { error: 'Se requiere la imagen de la etiqueta' };
	                if (!producto.imagenUbicacionSello) return { error: 'Se requiere la imagen de la unicación del sello' };
	            }
	            if (producto.imagenProducto && !(producto.imagenProducto.startsWith('data:image/jpeg') || producto.imagenProducto.startsWith('data:image/jpg') || producto.imagenProducto.startsWith('data:image/png') || producto.imagenProducto.startsWith('http'))) {
	                return { error: 'Error en el formato de la imagen del producto. Debe seleccionar una imagen de tipo JPG o PNG' };
	            }
	            if (producto.imagenEtiqueta && !(producto.imagenEtiqueta.startsWith('data:image/jpeg') || producto.imagenEtiqueta.startsWith('data:image/jpg') || producto.imagenEtiqueta.startsWith('data:image/png') || producto.imagenEtiqueta.startsWith('http'))) {
	                return { error: 'Error en el formato de la imagen de la etiqueta. Debe seleccionar una imagen de tipo JPG o PNG' };
	            }
	            if (producto.imagenUbicacionSello && !(producto.imagenUbicacionSello.startsWith('data:image/jpeg') || producto.imagenUbicacionSello.startsWith('data:image/jpg') || producto.imagenUbicacionSello.startsWith('data:image/png') || producto.imagenUbicacionSello.startsWith('http'))) {
	                return { error: 'Error en el formato de la imagen de la ubicación del sello. Debe seleccionar una imagen de tipo JPG o PNG' };
	            }
	            return { error: null };
	        }
	    }, {
	        key: 'limpiarDependenciaUbicacion',
	        value: function limpiarDependenciaUbicacion(key, value) {
	            if (key === 'OTROS' && !value) {
	                this.data.autorizacionSHB.otroUbicacionASHB = '';
	            }
	        }
	    }]);
	
	    return FormularioEmpController;
	}();
	
	exports.default = FormularioEmpController;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _certificacionPromueve = __webpack_require__(447);
	
	var _certificacionPromueve2 = _interopRequireDefault(_certificacionPromueve);
	
	__webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.promueve.autorizacion', []).component('appPromueveAutorizacion', _certificacionPromueve2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('autorizacion', {
	        url: '/autorizacion',
	        component: 'appPromueveAutorizacion'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandejaPromueve = __webpack_require__(451);
	
	var _bandejaPromueve2 = _interopRequireDefault(_bandejaPromueve);
	
	var _bandejaPromueve3 = __webpack_require__(643);
	
	var _bandejaPromueve4 = _interopRequireDefault(_bandejaPromueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaComponent = {
	    bindings: {},
	    controller: _bandejaPromueve2.default,
	    template: _bandejaPromueve4.default
	};
	
	exports.default = BandejaComponent;

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaController = function () {
	  BandejaController.$inject = ["NgTableParams", "$log", "$scope", "Modal", "Storage", "DataService", "Sidenav", "Util", "Message", "$location"];
	  function BandejaController(NgTableParams, $log, $scope, Modal, Storage, DataService, Sidenav, Util, Message, $location) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.$scope = $scope;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Sidenav = Sidenav;
	    this.Util = Util;
	    this.$location = $location;
	    this.Message = Message;
	
	    this.usuario = this.Storage.getUser();
	  }
	
	  _createClass(BandejaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.Storage.remove('matriculaPromueve');
	      this.Storage.remove('producto');
	      var colors = {
	        'NUEVO': 'default',
	        'PENDIENTE': 'primary',
	        'APROBADO': 'success',
	        'PENDIENTE_PAGO': 'warning',
	        'OBSERVADO': 'warning',
	        'RECHAZADO': 'danger',
	        'PAGADO': 'default'
	      };
	
	      this.solicitudes = {
	        url: 'certificacion_promueve/' + this.usuario.id_usuario + '/productos',
	        data: {
	          formly: [{
	            key: 'id_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'ruta_imagen',
	            type: 'archive',
	            templateOptions: {
	              label: 'Foto',
	              type: 'img'
	            }
	          }, {
	            key: 'matricula_comercio',
	            type: 'input',
	            templateOptions: {
	              label: 'Matrícula',
	              type: 'text'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Nombre producto',
	              type: 'text'
	            }
	          }, {
	            key: 'ddjj_estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              "options": [{
	                "value": "NUEVO",
	                "name": "NUEVO"
	              }, {
	                "value": "PENDIENTE",
	                "name": "PENDIENTE"
	              }, {
	                "value": "APROBADO",
	                "name": "APROBADO"
	              }, {
	                "value": "OBSERVADO",
	                "name": "OBSERVADO"
	              }, {
	                "value": "RECHAZADO",
	                "name": "RECHAZADO"
	              }]
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'razon_social',
	            type: 'input',
	            templateOptions: {
	              label: 'Razón social',
	              type: 'text'
	            }
	          }, {
	            key: 'matricula_comercio',
	            type: 'input',
	            templateOptions: {
	              label: 'Matrícula de comercio',
	              type: 'text'
	            }
	          }, {
	            key: '_fecha_envio',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha envío',
	              type: 'date'
	            }
	          }, {
	            key: 'ddjj_fecha_aprobacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha evaluación',
	              type: 'date'
	            }
	          }, {
	            key: 'ddjj_observacion',
	            type: 'input',
	            templateOptions: {
	              label: '',
	              type: 'text'
	            }
	          }]
	        },
	        fields: ['id_producto', 'id_unidad_productiva', 'razon_social', 'ruta_imagen', 'matricula_comercio', 'nombre_producto', 'fid_formulario', 'ddjj_estado', '_fecha_envio', 'ddjj_fecha_aprobacion', 'ddjj_observacion'],
	        hiddenFields: ['id_unidad_productiva', 'razon_social', 'ddjj_observacion'],
	        fks: ['fid_formulario'],
	        permission: {
	          filter: false,
	          delete: false,
	          create: false,
	          update: false
	        },
	        eventEdit: function eventEdit(item) {
	          _this.Storage.set('matriculaPromueve', { id_unidad_productiva: item.id_unidad_productiva, razon_social: item.razon_social });
	          _this.Storage.set('producto', { id_producto: item.id_producto });
	          _this.Sidenav.path('certificacion');
	        },
	        eventCreate: function eventCreate() {
	          _this.Sidenav.path('matriculaPromueve');
	        },
	        eventDelete: function eventDelete(item) {
	          _this.Modal.confirm('¿Desea eliminar este registro?', function () {
	            _this.DataService.delete('certificacion_promueve/producto/' + item.id_producto).then(function (response) {
	              if (response) {
	                _this.Message.success();
	                _this.$scope.$broadcast('refresh_crud_table', 'certificacion_promueve/' + _this.usuario.id_usuario + '/productos');
	              }
	            });
	          });
	        },
	        labels: {
	          // create: 'Nuevo registro'
	          create: 'Declarar Producto'
	        },
	        // update: {
	        //   key: 'estado', // key del registro con el cual se comparará el valor para mostrar/ocultar el botón actualizar
	        //   states: {
	        //     'NUEVO': true,
	        //     'ENVIADO': false,
	        //     'OBSERVADO': true,
	        //     'APROBADO': false
	        //   }
	        // },
	        update: false,
	        delete: false,
	        // delete: {
	        //   key: 'estado', // key del registro con el cual se comparará el valor para mostrar/ocultar el botón eliminar
	        //   states: {
	        //     'NUEVO': true,
	        //     'ENVIADO': false,
	        //     'OBSERVADO': false,
	        //     'APROBADO': false
	        //   }
	        // },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver detalles de solicitud',
	          if: function _if(ev, item) {
	            return ['PENDIENTE', 'OBSERVADO', 'RECHAZADO', 'APROBADO'].includes(item.ddjj_estado);
	          },
	          onclick: function onclick(ev, item) {
	            if (['RECHAZADO', 'OBSERVADO'].includes(item.ddjj_estado)) {
	              _this.Modal.pdf("certificacion_promueve/" + item.id_unidad_productiva + "/certificacion/" + item.id_producto + "/ddjj_pdf", null, item.ddjj_observacion);
	            } else {
	              _this.Modal.pdf("certificacion_promueve/" + item.id_unidad_productiva + "/certificacion/" + item.id_producto + "/ddjj_pdf");
	            }
	          }
	        }],
	        clases: {
	          'ddjj_estado': function ddjj_estado(row) {
	            return ['badge', 'badge-' + colors[row.ddjj_estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return BandejaController;
	}();
	
	exports.default = BandejaController;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bandejaPromueve = __webpack_require__(450);
	
	var _bandejaPromueve2 = _interopRequireDefault(_bandejaPromueve);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bandeja = angular.module('app.promueve.bandeja', []).component('appBandejaPromueve', _bandejaPromueve2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('bandejaPromueve', {
	    url: '/bandejaPromueve',
	    component: 'appBandejaPromueve'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	exports.default = Bandeja;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandejaCertPromueve = __webpack_require__(454);
	
	var _bandejaCertPromueve2 = _interopRequireDefault(_bandejaCertPromueve);
	
	var _bandejaCertPromueve3 = __webpack_require__(644);
	
	var _bandejaCertPromueve4 = _interopRequireDefault(_bandejaCertPromueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaComponent = {
	    bindings: {},
	    controller: _bandejaCertPromueve2.default,
	    template: _bandejaCertPromueve4.default
	};
	
	exports.default = BandejaComponent;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaController = function () {
	  BandejaController.$inject = ["NgTableParams", "$log", "$scope", "Modal", "Storage", "DataService", "Sidenav", "Util", "Message"];
	  function BandejaController(NgTableParams, $log, $scope, Modal, Storage, DataService, Sidenav, Util, Message) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaController);
	
	    this.NgTableParams = NgTableParams;
	    this.$log = $log;
	    this.$scope = $scope;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Sidenav = Sidenav;
	    this.Util = Util;
	    this.Message = Message;
	
	    this.usuario = this.Storage.getUser();
	  }
	
	  _createClass(BandejaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.Storage.remove('matriculaPromueve');
	      this.Storage.remove('producto');
	      var colors = {
	        'PENDIENTE': 'primary',
	        'APROBADO': 'success',
	        'RECHAZADO': 'danger',
	        'ANULADO': 'info'
	      };
	      this.$log.log('id usuario', this);
	      this.solicitudes = {
	        url: 'certificacion_promueve/' + this.usuario.nit + '/firmados',
	        data: {
	          formly: [//id_producto, nombre_producto, estado
	          {
	            key: 'id_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'imagen_producto',
	            type: 'archive',
	            templateOptions: {
	              label: 'Foto',
	              type: 'img'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Nombre producto',
	              type: 'text'
	            }
	          }, {
	            key: 'pago_estado',
	            type: 'input',
	            templateOptions: {
	              label: 'Estado',
	              type: 'hidden'
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'id_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'id certificacion',
	              type: 'number'
	            }
	          }, {
	            key: 'nro_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'N° certificación',
	              type: 'number'
	            }
	          }, {
	            key: 'pago_fecha_aprobacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha de aprobación',
	              type: 'date'
	            }
	          }]
	        },
	        fields: ['id_producto', 'id_unidad_productiva', 'id_certificacion', 'imagen_producto', 'nombre_producto', 'pago_estado', 'nro_certificacion', 'pago_fecha_aprobacion'],
	        hiddenFields: ['id_unidad_productiva', 'id_producto', 'id_certificacion'],
	        //fks: ['fid_formulario'],
	        permission: {
	          filter: false,
	          create: false,
	          delete: false,
	          update: false
	        },
	        eventEdit: function eventEdit(item) {
	          _this.Storage.set('matriculaPromueve', { id_unidad_productiva: item.id_unidad_productiva, razon_social: item.razon_social });
	          _this.Storage.set('producto', { id_producto: item.id_producto });
	          _this.Sidenav.path('certificacion');
	        },
	        eventCreate: function eventCreate() {
	          //this.Sidenav.path('matriculaPromueve');
	          _this.Sidenav.path('solicitud_certificacion');
	        },
	        // eventDelete: item => {
	        //   this.Modal.confirm('¿Desea eliminar este registro?', () => {
	        //     this.DataService.delete(`certificacion_promueve/producto/${item.id_producto}`)
	        //     .then( response => {
	        //       if (response) {
	        //         this.Message.success();
	        //         this.$scope.$broadcast('refresh_crud_table', `certificacion_promueve/${this.usuario.id_usuario}/productos`);
	        //       }
	        //     })
	        //   });
	        // },
	        labels: {
	          create: 'Solicitud y pago de certificados'
	        },
	        update: {
	          key: 'estado_firma', // key del registro con el cual se comparará el valor para mostrar/ocultar el botón actualizar
	          states: {
	            'NUEVO': true,
	            'ENVIADO': false,
	            'OBSERVADO': true,
	            'APROBADO': false
	          }
	        },
	        delete: {
	          key: 'estado', // key del registro con el cual se comparará el valor para mostrar/ocultar el botón eliminar
	          states: {
	            'NUEVO': true,
	            'ENVIADO': false,
	            'OBSERVADO': false,
	            'APROBADO': false
	          }
	        },
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver detalles de solicitud',
	
	          onclick: function onclick(ev, item) {
	            //this.Modal.pdf("certificacion_promueve/" + item.id_unidad_productiva + "/certificacion/" + item.id_producto + "/ddjj_pdf", null, item.estado==='RECHAZADO'?item.observaciones:null);
	            _this.Modal.pdf('certificacion_promueve/' + item.id_unidad_productiva + '/certificacion/' + item.id_producto + '/ddjj_pdf');
	          }
	        }, {
	          icon: 'file',
	          tooltip: 'Ver certificado',
	          if: function _if(ev, item) {
	            return item.pago_estado === 'APROBADO';
	          },
	          onclick: function onclick(ev, item) {
	            //this.Modal.pdf(`certificaciones/documento/${item.data.certificacion.id_certificacion}`);
	            _this.Modal.pdf('certificaciones/documento/' + item.id_certificacion, 'Certificación');
	          }
	        }],
	        clases: {
	          'pago_estado': function pago_estado(row) {
	            // this.$log.log(row);
	            return ['badge', 'badge-' + colors[row.pago_estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return BandejaController;
	}();
	
	exports.default = BandejaController;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bandejaCertPromueve = __webpack_require__(453);
	
	var _bandejaCertPromueve2 = _interopRequireDefault(_bandejaCertPromueve);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaCertificaciones = angular.module('app.promueve.bandeja.cert', []).component('appBandejaCertificacionesPromueve', _bandejaCertPromueve2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('bandejaCertificacionesPromueve', {
	    //url: '/bandejaCertificaciones',
	    url: '/solicitud',
	    component: 'appBandejaCertificacionesPromueve'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	exports.default = BandejaCertificaciones;

/***/ }),
/* 456 */
[681, 457, 645],
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _declaracionEmpModal = __webpack_require__(459);
	
	var _declaracionEmpModal2 = _interopRequireDefault(_declaracionEmpModal);
	
	var _declaracionEmpModal3 = __webpack_require__(646);
	
	var _declaracionEmpModal4 = _interopRequireDefault(_declaracionEmpModal3);
	
	var _fundempresaModal = __webpack_require__(85);
	
	var _fundempresaModal2 = _interopRequireDefault(_fundempresaModal);
	
	var _fundempresaModal3 = __webpack_require__(94);
	
	var _fundempresaModal4 = _interopRequireDefault(_fundempresaModal3);
	
	var _selloModal = __webpack_require__(480);
	
	var _selloModal2 = _interopRequireDefault(_selloModal);
	
	var _selloModal3 = __webpack_require__(653);
	
	var _selloModal4 = _interopRequireDefault(_selloModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormularioEmpController = function () {
	    FormularioEmpController.$inject = ["$scope", "DataService", "Storage", "Sidenav", "Modal", "Message", "apiUrl", "baseUrl", "Filter", "Util", "helpLang", "errorsLang", "$log"];
	    function FormularioEmpController($scope, DataService, Storage, Sidenav, Modal, Message, apiUrl, baseUrl, Filter, Util, helpLang, errorsLang, $log) {
	        'ngInject';
	
	        _classCallCheck(this, FormularioEmpController);
	
	        this.$scope = $scope;
	        this.DataService = DataService;
	        this.Storage = Storage;
	        this.Modal = Modal;
	        this.apiUrl = apiUrl;
	        this.baseUrl = baseUrl;
	        this.Sidenav = Sidenav;
	        this.Message = Message;
	        this.Util = Util;
	        this.Filter = Filter;
	        this.errorsLang = errorsLang;
	        this.helpLang = helpLang;
	        this.$log = $log;
	
	        this.usuario = this.Storage.getUser();
	
	        this.renderInsumos = false;
	        this.renderPagos = false;
	
	        this.inputsRequired = ['nombre_producto', 'capacidad_prod_mensual', 'precio_unitario', 'tipo_comercio', 'desc_produccion'];
	    }
	
	    _createClass(FormularioEmpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.matricula = this.Storage.get('matriculaPromueve');
	            if (!this.matricula) {
	                this.Sidenav.path('matriculaPromueve');
	            }
	
	            this.producto = this.Storage.get('producto');
	            if (!this.producto) {
	                this.Sidenav.path('producto');
	            }
	
	            this.$scope.$on('app_sello_modal_success', function () {
	                _this2.atras();
	            });
	
	            this.cargarData();
	
	            this.urlUpload = this.apiUrl + 'certificacion_promueve/' + this.matricula.id_unidad_productiva + '/producto/' + this.producto.id_producto + '/guardar-foto';
	
	            this.insumos = {
	                permission: {
	                    filter: false
	                },
	                data: {
	                    formly: [{
	                        key: 'id_insumo',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'ID'
	                        }
	                    }, {
	                        key: 'tipo_item',
	                        type: 'select',
	                        templateOptions: {
	                            label: 'Ítem',
	                            placeholder: 'Nombre de ítem',
	                            required: true,
	                            options: [{
	                                "value": "MATERIALES",
	                                "name": "Materiales e insumos"
	                            }, {
	                                "value": "MANO_OBRA",
	                                "name": "Mano de obra"
	                            }, {
	                                "value": "OTROS_COSTOS",
	                                "name": "Otros costos"
	                            }],
	                            onChange: function onChange(value, options, _this) {
	                                if (value == 'MANO_OBRA') {
	                                    _this.model.nacional = true;
	                                    _this.model.unidad = 700;
	                                    _this.model.unidad_medida = 'Personas';
	                                } else {
	                                    _this.model.unidad = null;
	                                    _this.model.unidad_medida = '';
	                                }
	                            }
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."'
	                            }
	                        }
	                    }, {
	                        key: 'descripcion',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Descripción',
	                            placeholder: 'Descripción',
	                            required: true,
	                            maxlength: 255
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."',
	                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
	                            }
	                        }
	                    }, {
	                        key: 'cantidad',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Cantidad',
	                            placeholder: 'Cantidad',
	                            required: true,
	                            onKeydown: function onKeydown(value, options, _this, event) {
	                                _this2.Filter.decimalFormat(event, 10);
	                            },
	                            onKeyup: function onKeyup(value, options, _this) {
	                                _this2.calcularTotalInsumo(_this.model);
	                            },
	                            maxlength: 17
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."',
	                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
	                            }
	                        }
	                    }, {
	                        key: 'unidad',
	                        type: 'select',
	                        templateOptions: {
	                            label: 'Unidad de medida',
	                            placeholder: 'Unidad de medida',
	                            required: true,
	                            options: []
	                            // onChange: (value, options, _this, e) => {
	                            //     console.log(value, options, _this);
	                            // }
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."'
	                            }
	                        },
	                        hideExpression: "model.unidad == '700' && model.unidad_medida == 'Personas'"
	                    }, {
	                        key: 'unidad_medida',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Otra unidad',
	                            placeholder: 'Escriba la unidad de medida',
	                            required: true
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."'
	                            }
	                        },
	                        hideExpression: "model.unidad != '700'",
	                        expressionProperties: {
	                            "templateOptions.disabled": "model.unidad == '700' && model.unidad_medida == 'Personas'"
	                        }
	                    }, {
	                        key: 'valor',
	                        type: 'input',
	                        templateOptions: {
	                            type: 'text',
	                            label: 'Valor (bs.)',
	                            placeholder: 'Valor (bs.)',
	                            required: true,
	                            onKeydown: function onKeydown(value, options, _this, event) {
	                                _this2.Filter.decimalFormat(event, 10);
	                            },
	                            onKeyup: function onKeyup(value, options, _this) {
	                                _this2.calcularTotalInsumo(_this.model);
	                            },
	                            maxlength: 20
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."',
	                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
	                            }
	                        }
	                    }, {
	                        key: 'total',
	                        type: 'input',
	                        templateOptions: {
	                            type: 'text',
	                            label: 'Total(bs)',
	                            placeholder: 'Total(bs)',
	                            required: true,
	                            onKeydown: function onKeydown(value, options, _this, event) {
	                                _this2.Filter.decimalFormat(event);
	                            },
	                            maxlength: 24,
	                            disabled: true
	                        },
	                        validation: {
	                            messages: {
	                                required: 'to.label + " es obligatorio."',
	                                maxlength: '"Solo puede tener " + to.maxlength + " caracteres como máximo."'
	                            }
	                        }
	                    }, {
	                        key: 'nacional',
	                        type: 'radio',
	                        defaultValue: true,
	                        templateOptions: {
	                            label: 'Producto nacional',
	                            options: [{ 'value': true, 'name': 'Es nacional' }, { 'value': false, 'name': 'Es extranjero' }]
	                        },
	                        expressionProperties: {
	                            "templateOptions.options": function templateOptionsOptions(value, options, _this) {
	                                if (_this.model.tipo_item == 'MANO_OBRA') {
	                                    return [{ 'value': true, 'name': 'Es nacional' }];
	                                } else {
	                                    return [{ 'value': true, 'name': 'Es nacional' }, { 'value': false, 'name': 'Es extranjero' }];
	                                }
	                            }
	                        }
	                    }],
	                    list: [],
	                    urlUpdate: 'certificacion_promueve/' + this.matricula.id_unidad_productiva + '/producto/' + this.producto.id_producto + '/insumos'
	                },
	                fks: ['tipo_item', 'unidad'],
	                // fields: ['id_insumo', 'tipo_item', 'descripcion', 'cantidad', 'unidad', 'unidad_medida', 'valor', 'total', 'nacional']
	                hiddenFields: ['unidad_medida'],
	                mergeFields: {
	                    unidad: function unidad(item) {
	                        if (item.unidad == 'Otros') {
	                            return item.unidad_medida;
	                        }
	                        return item.unidad;
	                    }
	                }
	            };
	
	            this.photo = {
	                url: this.urlUpload,
	                textUpload: this.textUpload,
	                onCompleteItem: function onCompleteItem(fileItem, response, status /*, headers, reset*/) {
	                    if (status === 200) {
	                        if (response.finalizado && response.datos && response.datos.nombre_archivo) {
	                            _this2.data.imagen_producto = response.datos.nombre_archivo;
	                            _this2.urlImage = _this2.baseUrl + 'promueve/productos/' + _this2.data.imagen_producto;
	                        }
	                    } else {
	                        _this2.Message.error(response.mensaje || _this2.errorsLang[status] || 'Ocurrió un error desconocido.');
	                    }
	                }
	            };
	
	            this.total = {
	                save: function save(list) {
	                    _this2.$log.log('list update', list);
	                    var total = 0;
	                    list.map(function (e) {
	                        total += parseFloat(e.total);
	                    });
	                    _this2.data.total_costo_bruto = total;
	
	                    var valor = 0;
	                    list.map(function (e) {
	                        valor += parseFloat(e.valor);
	                    });
	                    _this2.data.total_valor_costo_bruto = valor;
	
	                    _this2.guardarForm();
	                }
	            };
	        }
	    }, {
	        key: 'calcularTotalInsumo',
	        value: function calcularTotalInsumo(model) {
	            var cantidad = model.cantidad ? parseFloat(model.cantidad) : 0;
	            var valor = model.valor ? parseFloat(model.valor) : 0;
	            model.total = (cantidad * valor).toFixed(2);
	        }
	    }, {
	        key: 'cargarData',
	        value: function cargarData() {
	            var _this3 = this;
	
	            this.DataService.get('certificacion_promueve/' + this.matricula.id_unidad_productiva + '/producto/' + this.producto.id_producto).then(function (response) {
	                if (response) {
	                    _this3.data = response;
	
	                    _this3.data.insumos = _this3.data.insumos || [];
	                    _this3.data.pagos = _this3.data.certificacion && _this3.data.certificacion.pagos || [];
	
	                    _this3.insumos.data.list = _this3.data.insumos;
	
	                    if (_this3.data.imagen_producto) {
	                        _this3.urlImage = _this3.baseUrl + 'promueve/productos/' + _this3.data.imagen_producto;
	                    }
	
	                    // if (!this.data.shb) {
	                    //    this.inputsRequired.push('color');
	                    // }
	
	                    _this3.cargarUbicaciones();
	                    _this3.cargarUnidades();
	                } else {
	                    _this3.Sidenav.path('matriculaPromueve');
	                }
	            });
	
	            this.DataService.get('certificacion_promueve/producto/unidades_peso').then(function (response) {
	                response.unshift({ id_parametro: null, nombre: 'Ninguno' });
	                _this3.unidades_peso = response;
	                _this3.$scope.$watch('$ctrl.data.fid_par_unidad_medida', function (newValue, oldValue) {
	                    if (angular.toJson(newValue) != angular.toJson(oldValue)) {
	                        if (newValue != 700) {
	                            _this3.guardarForm();
	                        }
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'cargarUnidades',
	        value: function cargarUnidades() {
	            var _this4 = this;
	
	            this.DataService.get('parametros/?grupo=UNIDAD_MEDIDA').then(function (response) {
	                if (response) {
	                    var items = [];
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = response[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var el = _step.value;
	
	                            items.push({ value: el.id_parametro + "", name: el.nombre });
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	
	                    _this4.insumos.data.formly[4].templateOptions.options = items;
	
	                    _this4.renderInsumos = true;
	                    _this4.renderPagos = true;
	                }
	            });
	        }
	    }, {
	        key: 'cargarUbicaciones',
	        value: function cargarUbicaciones() {
	            var list = this.data.unidad_productiva.ubicaciones;
	            var ubicaciones = [];
	            for (var i in list) {
	                ubicaciones.push({
	                    html: '\n                    <p class="' + (!list[i].zona ? 'ng-hide' : '') + '"><strong>Zona:</strong> ' + list[i].zona + '</p>\n                    <p class="' + (!list[i].avenida_calle ? 'ng-hide' : '') + '"><strong>Avenida/calle:</strong> ' + list[i].avenida_calle + '</p>\n                    <p class="' + (!list[i].avenida_calle_referencia ? 'ng-hide' : '') + '"><strong>Avenida/calle de referencia:</strong> ' + list[i].avenida_calle_referencia + '</p>\n                    <p class="' + (!list[i].numero ? 'ng-hide' : '') + '"><strong>N\xFAmero:</strong> ' + list[i].numero + '</p>\n                    <p class="' + (!list[i].edificio ? 'ng-hide' : '') + '"><strong>Edificio:</strong> ' + list[i].edificio + '</p>\n                    <p class="' + (!list[i].piso ? 'ng-hide' : '') + '"><strong>Piso:</strong> ' + list[i].piso + '</p>\n                    <p class="' + (!list[i].telefonos ? 'ng-hide' : '') + '"><strong>Tel\xE9fonos:</strong> ' + list[i].telefonos + '</p>\n                    <p class="' + (!list[i].correo ? 'ng-hide' : '') + '"><strong>Correo:</strong> ' + list[i].correo + '</p>\n                    <p class="' + (!list[i].latitud ? 'ng-hide' : '') + '"><strong>Latitud:</strong> ' + list[i].latitud + '</p>\n                    <p class="' + (!list[i].longitud ? 'ng-hide' : '') + '"><strong>Longitud:</strong> ' + list[i].longitud + '</p>\n                '
	                });
	            }
	            this.ubicaciones = ubicaciones;
	        }
	    }, {
	        key: 'cambiarImagen',
	        value: function cambiarImagen() {
	            this.urlImage = null;
	        }
	    }, {
	        key: 'eliminarImagen',
	        value: function eliminarImagen() {
	            this.urlImage = null;
	            this.data.imagen_producto = null;
	        }
	    }, {
	        key: 'cancelarCambioImagen',
	        value: function cancelarCambioImagen() {
	            if (this.data) {
	                this.urlImage = this.baseUrl + 'promueve/productos/' + this.data.imagen_producto;
	            }
	        }
	    }, {
	        key: 'guardarForm',
	        value: function guardarForm() {
	            if (this.data) {
	                // if (this.data.nombre_producto && this.data.color && this.data.capacidad_prod_mensual && this.data.precio_unitario) { //jloza
	                // if (this.isNotArrayEmpty(this.inputsRequired)) { //oguti
	                var data = angular.copy(this.data);
	
	                data.total_costo_bruto = data.total_costo_bruto || 0;
	                data.total_valor_costo_bruto = data.total_valor_costo_bruto || 0;
	                data.total_distribucion_nacional = 0;
	                data.total_distribucion_extranjera = 0;
	
	                delete data.pagos;
	                delete data.insumos;
	                delete data.certificacion;
	                delete data.unidad_productiva;
	
	                this.DataService.put('certificacion_promueve/' + this.matricula.id_unidad_productiva + '/producto', data);
	                // }
	            }
	        }
	    }, {
	        key: 'isNotArrayEmpty',
	        value: function isNotArrayEmpty(array) {
	            for (var i in array) {
	                if (this.Filter.empty(this.data[array[i]])) {
	                    return false;
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: 'declarar',
	        value: function declarar() {
	            if (this.isNotArrayEmpty(this.inputsRequired)) {
	                if (!this.data.shb && this.Filter.empty(this.data.color) && this.Filter.empty(this.data.talla) && this.Filter.empty(this.data.peso) && this.Filter.empty(this.data.medidas)) {
	                    this.Message.warning('Debe llenar al menos uno de estos datos: <strong>color, talla, medida o peso</strong>.');
	                    this.Util.gotoAnchor('descripcion-producto-otros');
	                } else if (this.data.peso && this.Filter.empty(this.data.fid_par_unidad_medida) || this.data.fid_par_unidad_medida == 700 && !this.data.unidad_medida) {
	                    this.Message.warning('Debe llenar la unidad de medida');
	                    this.Util.gotoAnchor('descripcion-producto-otros');
	                } else if (this.data.fid_par_unidad_medida && !this.data.peso) {
	                    this.Message.warning('Debe llenar el campo peso o dejar en ninguno la unidad de medida del peso');
	                    this.Util.gotoAnchor('descripcion-producto-otros');
	                } else if (!this.data.imagen_producto) {
	                    this.Message.warning('Debe agregar la <strong>imagen</strong> del producto.');
	                    this.Util.gotoAnchor('imagen-producto');
	                    // } else if (this.insumos.data.list.length === 0 && !this.data.shb) {
	                    //     this.Message.warning('Debe tener por lo menos un <strong>insumo</strong> registrado.');
	                    //     this.Util.gotoAnchor('lista-insumos');
	                } else if (!this.data.shb && this.validarInsumos()) {
	                    this.Message.warning('Debe registrar al menos un insumo de cada tipo: materia prima, mano de obra y otro.');
	                    this.Util.gotoAnchor('lista-insumos');
	                } else {
	                    if (this.data.shb) {
	                        this.Modal.show({
	                            template: _selloModal4.default,
	                            controller: _selloModal2.default,
	                            data: {
	                                producto: {
	                                    id_producto: this.data.id_producto,
	                                    nombre_producto: this.data.nombre_producto,
	                                    lugar_sello: this.data.lugar_sello,
	                                    id_unidad_productiva: this.data.unidad_productiva.id_unidad_productiva,
	                                    razon_social: this.data.unidad_productiva.razon_social,
	                                    fid_formulario: this.data.certificacion.formulario.tipo,
	                                    _fecha_creacion: this.data._fecha_creacion
	                                }
	                            },
	                            size: 'lg'
	                        });
	                    } else {
	                        this.Modal.show({
	                            template: _declaracionEmpModal4.default,
	                            controller: _declaracionEmpModal2.default,
	                            data: {
	                                "data": this.data,
	                                "id_unidad_productiva": this.matricula.id_unidad_productiva
	                            },
	                            size: 'lg'
	                        });
	                    }
	                }
	            } else {
	                if (this.Filter.empty(this.data.nombre_producto)) {
	                    this.Util.gotoAnchor('nombre-producto');
	                } else if (this.Filter.empty(this.data.precio_unitario) || this.Filter.empty(this.data.tipo_comercio)) {
	                    this.Util.gotoAnchor('descripcion-producto-comercializacion');
	                } else if (this.Filter.empty(this.data.capacidad_prod_mensual) || this.Filter.empty(this.data.desc_produccion)) {
	                    this.Util.gotoAnchor('descripcion-producto');
	                } else {
	                    this.Util.gotoAnchor('descripcion-producto-otros');
	                }
	            }
	        }
	    }, {
	        key: 'validarInsumos',
	        value: function validarInsumos() {
	            var arr = this.insumos.data.list;
	            var sw = void 0,
	                material = void 0,
	                mano_obra = void 0,
	                otros = void 0;
	            for (var i = 0; i < arr.length && !sw; i++) {
	                material = material || arr[i].tipo_item == 'MATERIALES';
	                mano_obra = mano_obra || arr[i].tipo_item == 'MANO_OBRA';
	                otros = otros || arr[i].tipo_item == 'OTROS_COSTOS';
	                sw = material && mano_obra && otros;
	            }
	            return !sw;
	        }
	    }, {
	        key: 'masInformacion',
	        value: function masInformacion() {
	            this.Modal.show({
	                template: _fundempresaModal4.default,
	                controller: _fundempresaModal2.default,
	                data: {
	                    empresa: this.data.unidad_productiva
	                },
	                size: 'lg'
	            });
	        }
	    }, {
	        key: 'atras',
	        value: function atras() {
	            if (this.data.shb) {
	                this.Sidenav.path('bandejaSello');
	            } else {
	                this.Sidenav.path('tramite');
	            }
	        }
	    }]);
	
	    return FormularioEmpController;
	}();
	
	exports.default = FormularioEmpController;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _certificacionPromueve = __webpack_require__(456);
	
	var _certificacionPromueve2 = _interopRequireDefault(_certificacionPromueve);
	
	__webpack_require__(195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.promueve.certificacion', []).component('appPromueveCertificacion', _certificacionPromueve2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('certificacion', {
	        url: '/certificacion',
	        component: 'appPromueveCertificacion'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DashboardModalController = function () {
	  DashboardModalController.$inject = ["$uibModalInstance", "data", "$log", "Sidenav", "DataService", "CrudTable", "Message"];
	  function DashboardModalController($uibModalInstance, data, $log, Sidenav, DataService, CrudTable, Message) {
	    'ngInject';
	
	    _classCallCheck(this, DashboardModalController);
	
	    this.items = data;
	    this.$uibModalInstance = $uibModalInstance;
	    this.Sidenav = Sidenav;
	    this.Message = Message;
	    this.$log = $log;
	    this.DataService = DataService;
	
	    this.data = angular.copy(data.data);
	    this.id_unidad_productiva = data.id_unidad_productiva;
	  }
	
	  _createClass(DashboardModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      // this.$log.log(this);
	      this.items.numero_dias = 2;
	    }
	  }, {
	    key: 'ok',
	    value: function ok() {
	      var _this = this;
	
	      this.data.total_costo_bruto = this.data.total_costo_bruto || 0;
	      this.data.total_valor_costo_bruto = this.data.total_valor_costo_bruto || 0;
	      this.data.total_distribucion_nacional = 0;
	      this.data.total_distribucion_extranjera = 0;
	
	      delete this.data.pagos;
	      delete this.data.insumos;
	      delete this.data.certificacion;
	      delete this.data.unidad_productiva;
	
	      //realizar actualizacion
	      this.DataService.put('certificacion_promueve/' + this.id_unidad_productiva + '/producto/' + this.data.id_producto + '/enviar', this.data).then(function (response) {
	        if (response) {
	          // this.$log.log('Respuesta update certificacion= ', response);
	          _this.Message.success("Su solicitud fue enviada correctamente.");
	          _this.Sidenav.path('bandejaPromueve');
	          _this.$uibModalInstance.close();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return DashboardModalController;
	}();
	
	exports.default = DashboardModalController;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculaPromueve = __webpack_require__(463);
	
	var _matriculaPromueve2 = _interopRequireDefault(_matriculaPromueve);
	
	var _tramitePromueve = __webpack_require__(470);
	
	var _tramitePromueve2 = _interopRequireDefault(_tramitePromueve);
	
	var _certificacionPromueve = __webpack_require__(458);
	
	var _certificacionPromueve2 = _interopRequireDefault(_certificacionPromueve);
	
	var _certificacionPromueve3 = __webpack_require__(449);
	
	var _certificacionPromueve4 = _interopRequireDefault(_certificacionPromueve3);
	
	var _bandejaPromueve = __webpack_require__(452);
	
	var _bandejaPromueve2 = _interopRequireDefault(_bandejaPromueve);
	
	var _bandejaCertPromueve = __webpack_require__(455);
	
	var _bandejaCertPromueve2 = _interopRequireDefault(_bandejaCertPromueve);
	
	var _solicitudPromueve = __webpack_require__(467);
	
	var _solicitudPromueve2 = _interopRequireDefault(_solicitudPromueve);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Empresario = angular.module('app.promueve.empresario', [_matriculaPromueve2.default, _tramitePromueve2.default, _certificacionPromueve2.default, _certificacionPromueve4.default, _bandejaPromueve2.default, _solicitudPromueve2.default, _bandejaCertPromueve2.default]).name;
	
	exports.default = Empresario;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculaPromueve = __webpack_require__(462);
	
	var _matriculaPromueve2 = _interopRequireDefault(_matriculaPromueve);
	
	var _matriculaPromueve3 = __webpack_require__(647);
	
	var _matriculaPromueve4 = _interopRequireDefault(_matriculaPromueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatriculaComponent = {
	    bindings: {},
	    controller: _matriculaPromueve2.default,
	    template: _matriculaPromueve4.default
	};
	
	exports.default = MatriculaComponent;

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MatriculaEmpController = function () {
	    MatriculaEmpController.$inject = ["DataService", "Storage", "Modal", "Sidenav", "MatriculaPromueve", "$log"];
	    function MatriculaEmpController(DataService, Storage, Modal, Sidenav, MatriculaPromueve, $log) {
	        'ngInject';
	
	        _classCallCheck(this, MatriculaEmpController);
	
	        this.DataService = DataService;
	        this.Storage = Storage;
	        this.Modal = Modal;
	        this.Sidenav = Sidenav;
	        this.MatriculaPromueve = MatriculaPromueve;
	        this.$log = $log;
	    }
	
	    _createClass(MatriculaEmpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.MatriculaPromueve.init().then(function (success) {
	                if (success == 'ONE') {
	                    _this.Sidenav.path('tramite');
	                }
	                _this.matriculas = _this.Storage.get('matriculasPromueve');
	            }).catch(function (error) {
	                if (error == 'LENGTH') {
	                    _this.Sidenav.path('bandeja');
	                } else if (error == 'NULL') {
	                    _this.Modal.alert('Debe tener por lo menos una certificación aprobada en ProBolivia para continuar o <br />usted no está habilitado para realizar su registro debido a que no realiza procesos de transformación.', function () {
	                        _this.Sidenav.path('bandeja');
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'seleccionar',
	        value: function seleccionar(matricula) {
	            this.$log.log(matricula);
	            this.Storage.set('matriculaPromueve', matricula);
	            this.Sidenav.path('tramite');
	        }
	    }]);
	
	    return MatriculaEmpController;
	}();
	
	exports.default = MatriculaEmpController;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _matriculaPromueve = __webpack_require__(461);
	
	var _matriculaPromueve2 = _interopRequireDefault(_matriculaPromueve);
	
	var _matriculaPromueve3 = __webpack_require__(464);
	
	var _matriculaPromueve4 = _interopRequireDefault(_matriculaPromueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.promueve.matricula', []).component('appPromueveMatricula', _matriculaPromueve2.default).service('MatriculaPromueve', _matriculaPromueve4.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('matriculaPromueve', {
	        url: '/matriculaPromueve',
	        component: 'appPromueveMatricula'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MatriculaPromueve = function () {
	    MatriculaPromueve.$inject = ["Storage", "Sidenav", "DataService", "$q"];
	    function MatriculaPromueve(Storage, Sidenav, DataService, $q) {
	        'ngInject';
	
	        _classCallCheck(this, MatriculaPromueve);
	
	        this.Storage = Storage;
	        this.Sidenav = Sidenav;
	        this.$q = $q;
	        this.DataService = DataService;
	
	        this.usuario = this.Storage.getUser();
	    }
	
	    _createClass(MatriculaPromueve, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            var defered = this.$q.defer();
	            var promise = defered.promise;
	
	            this.Storage.remove('matriculaPromueve');
	
	            this.DataService.get('certificacion_promueve/up_certificadas/' + this.usuario.id_usuario).then(function (response) {
	                if (response) {
	                    if (response.length === 0) {
	                        defered.reject('LENGTH');
	                    } else {
	                        if (response.length == 1) {
	                            _this.Storage.set('matriculaPromueve', response[0]);
	                            defered.resolve('ONE');
	                        }
	                    }
	                    _this.matriculas = response;
	                    _this.Storage.set('matriculasPromueve', _this.matriculas);
	                    defered.resolve(true);
	                } else {
	                    defered.reject('NULL');
	                }
	            });
	
	            return promise;
	        }
	    }]);
	
	    return MatriculaPromueve;
	}();
	
	exports.default = MatriculaPromueve;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _solicitudPromueve = __webpack_require__(466);
	
	var _solicitudPromueve2 = _interopRequireDefault(_solicitudPromueve);
	
	var _solicitudPromueve3 = __webpack_require__(648);
	
	var _solicitudPromueve4 = _interopRequireDefault(_solicitudPromueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudComponent = {
	    bindings: {},
	    controller: _solicitudPromueve2.default,
	    template: _solicitudPromueve4.default
	};
	
	exports.default = SolicitudComponent;

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SolicitudController = function () {
	    SolicitudController.$inject = ["Storage", "Message", "Filter", "Util", "Sidenav", "$state", "MatriculaPromueve", "DataService", "Datetime", "$log", "Modal", "$location"];
	    function SolicitudController(Storage, Message, Filter, Util, Sidenav, $state, MatriculaPromueve, DataService, Datetime, $log, Modal, $location) {
	        'ngInject';
	
	        _classCallCheck(this, SolicitudController);
	
	        this.Storage = Storage;
	        this.Message = Message;
	        this.Filter = Filter;
	        this.Sidenav = Sidenav;
	        this.Util = Util;
	        this.DataService = DataService;
	        this.Datetime = Datetime;
	        this.Modal = Modal;
	        this.$state = $state;
	        this.$location = $location;
	        this.MatriculaPromueve = MatriculaPromueve;
	        this.$log = $log;
	
	        this.mostrarSolicitudes = false;
	        this.mostrarMatriculas = null;
	        this.error = false;
	
	        this.usuario = this.Storage.getUser();
	
	        this.tipoProducto = {
	            'BIEN_PRODUCIDO': 'Bien producido',
	            'COSTO_BRUTO': 'Costo bruto'
	        };
	    }
	
	    _createClass(SolicitudController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.MatriculaPromueve.init().then(function (success) {
	                if (success == 'ONE') {
	                    _this.initSolicitud();
	                } else {
	                    _this.initMatriculas();
	                }
	                var xdate = new Date(_this.Storage.get('dateNow'));
	                _this.dateOptions = {
	                    maxDate: xdate,
	                    minDate: new Date(xdate.getFullYear() - 1, xdate.getMonth(), xdate.getDate()),
	                    startingDay: 1
	                    // showWeeks: false
	                };
	            }).catch(function () {
	                _this.Message.warning('Debe registrar sus productos en Pro Bolivia, luego registrar un producto en Promueve para poder ingresar a esta opción.');
	                _this.Sidenav.path('bandeja');
	            });
	        }
	    }, {
	        key: 'validateFechaDeposito',
	        value: function validateFechaDeposito(form) {
	            if (this.fecha_deposito) {
	                form.fecha_deposito.$setValidity('min_date', !(this.fecha_deposito < this.dateOptions.minDate));
	                form.fecha_deposito.$setValidity('max_date', !(this.fecha_deposito > this.dateOptions.maxDate));
	            }
	        }
	    }, {
	        key: 'initSolicitud',
	        value: function initSolicitud() {
	            var _this2 = this;
	
	            this.mostrarSolicitudes = true;
	            this.matricula = this.Storage.get('matriculaPromueve');
	
	            this.DataService.get('certificacion_promueve/' + this.usuario.nit + '/productos_aprobados').then(function (response) {
	                if (response && _this2.Util.toType(response) == 'array') {
	                    _this2.pendientes = response;
	                } else {
	                    _this2.pendientes = [];
	                }
	            });
	        }
	    }, {
	        key: 'initMatriculas',
	        value: function initMatriculas() {
	            this.mostrarMatriculas = true;
	            this.matriculas = this.Storage.get('matriculasPromueve');
	        }
	    }, {
	        key: 'selectAll',
	        value: function selectAll() {
	            var _this3 = this;
	
	            this.pendientes.map(function (el) {
	                el.select = !!_this3.checkSelectAll;
	                return el;
	            });
	        }
	    }, {
	        key: 'isSelectAll',
	        value: function isSelectAll() {
	            if (this.pendientes) {
	                this.checkSelectAll = this.pendientes.length == this.pendientes.filter(function (el) {
	                    return el.select;
	                }).length;
	            }
	        }
	    }, {
	        key: 'totalPago',
	        value: function totalPago() {
	            var total = 0;
	            if (this.pendientes) {
	                this.pendientes.map(function (el) {
	                    if (el.select) {
	                        total += parseFloat(el.certificacion.costo_certificacion);
	                    }
	                });
	            }
	            return total;
	        }
	    }, {
	        key: 'enviar',
	        value: function enviar() {
	            var _this4 = this;
	
	            if (this.Filter.empty(this.codigo_boleta) || this.Filter.empty(this.fecha_deposito)) {
	                this.Util.gotoAnchor('deposito-tramite');
	            } else {
	                var solicitudes = this.pendientes.filter(function (el) {
	                    return el.select;
	                });
	                if (solicitudes.length === 0) {
	                    this.Message.warning('Debe seleccionar por lo menos un producto para solicitar una certificación.');
	                    this.Util.gotoAnchor('lista-producto');
	                } else {
	                    if (solicitudes.filter(function (el) {
	                        return _this4.Filter.empty(el.cuce);
	                    }).length === 0) {
	                        var productos = [];
	                        solicitudes.map(function (el) {
	                            productos.push({ id_producto: el.id_producto, cuce: el.cuce });
	                        });
	
	                        var data = {
	                            deposito: {
	                                codigo_boleta: this.codigo_boleta,
	                                fecha_deposito: this.Datetime.format(this.fecha_deposito),
	                                monto: this.totalPago()
	                            },
	                            factura: {
	                                razon_social: this.matricula.razon_social,
	                                nit_ci: this.usuario.nit
	                            },
	                            productos: productos
	                        };
	
	                        //this.Modal.confirm("A partir del envío de estos datos, podrá recoger su certificado de las oficinas de Promueve Bolivia en 24 horas",
	                        this.Modal.confirm("A partir del envío de estos datos, se le notificará la generación de su certificado digital vía correo electrónico", function () {
	                            _this4.DataService.post('certificacion_promueve/' + _this4.matricula.id_unidad_productiva + '/certificacion/enviar', data).then(function (response) {
	                                if (response) {
	                                    _this4.Message.success('¡Solicitud(es) enviada(s)!');
	                                    //this.$state.reload();
	                                    _this4.$location.path('/solicitud');
	                                }
	                            });
	                        }, null, null, 'Enviar', null, 'n');
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'seleccionar',
	        value: function seleccionar(matricula) {
	            this.mostrarMatriculas = false;
	            this.Storage.set('matriculaPromueve', matricula);
	            this.initSolicitud();
	        }
	    }, {
	        key: 'atras',
	        value: function atras() {
	            this.mostrarSolicitudes = false;
	            this.mostrarMatriculas = true;
	        }
	    }]);
	
	    return SolicitudController;
	}();
	
	exports.default = SolicitudController;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _solicitudPromueve = __webpack_require__(465);
	
	var _solicitudPromueve2 = _interopRequireDefault(_solicitudPromueve);
	
	__webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.promueve.solicitud', []).component('appPromueveSolicitud', _solicitudPromueve2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('solicitud', {
	        // url: '/solicitud',
	        url: '/solicitud_certificacion',
	        component: 'appPromueveSolicitud'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tramitePromueve = __webpack_require__(469);
	
	var _tramitePromueve2 = _interopRequireDefault(_tramitePromueve);
	
	var _tramitePromueve3 = __webpack_require__(649);
	
	var _tramitePromueve4 = _interopRequireDefault(_tramitePromueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TramiteComponent = {
	    bindings: {},
	    controller: _tramitePromueve2.default,
	    template: _tramitePromueve4.default
	};
	
	exports.default = TramiteComponent;

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormularioEmpController = function () {
	    FormularioEmpController.$inject = ["DataService", "Storage", "Sidenav", "Modal", "$log", "Loading"];
	    function FormularioEmpController(DataService, Storage, Sidenav, Modal, $log, Loading) {
	        'ngInject';
	
	        _classCallCheck(this, FormularioEmpController);
	
	        this.DataService = DataService;
	        this.Storage = Storage;
	        this.Modal = Modal;
	        this.Sidenav = Sidenav;
	        this.Loading = Loading;
	        this.$log = $log;
	
	        this.usuario = this.Storage.getUser();
	    }
	
	    _createClass(FormularioEmpController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.Storage.remove('producto');
	            this.matricula = this.Storage.get('matriculaPromueve');
	            if (!this.matricula) {
	                this.Sidenav.path('matriculaPromueve');
	            }
	
	            this.tramites = [{
	                'id_tramite': 'BIEN_PRODUCIDO',
	                'nombre': 'BIEN PRODUCIDO'
	            }, {
	                'id_tramite': 'COSTO_BRUTO',
	                'nombre': 'COSTO BRUTO'
	            }];
	        }
	    }, {
	        key: 'seleccionar',
	        value: function seleccionar(tramite) {
	            var _this = this;
	
	            this.Modal.confirm('¿Realmente desea crear este trámite?', function () {
	                _this.Loading.show('Creando nuevo trámite', true);
	                _this.DataService.post('certificacion_promueve/' + _this.matricula.id_unidad_productiva + '/producto', {
	                    tipo_producto: tramite.id_tramite,
	                    nombre_producto: tramite.nombre
	                }).then(function (response) {
	                    if (response) {
	                        _this.Loading.show(null, false);
	                        _this.Storage.set('producto', response);
	                        _this.Sidenav.path('certificacion');
	                    }
	                });
	            });
	        }
	    }]);
	
	    return FormularioEmpController;
	}();
	
	exports.default = FormularioEmpController;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tramitePromueve = __webpack_require__(468);
	
	var _tramitePromueve2 = _interopRequireDefault(_tramitePromueve);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.promueve.tramite', []).component('appPromueveTramite', _tramitePromueve2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('tramite', {
	        url: '/tramite',
	        component: 'appPromueveTramite'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _empresario = __webpack_require__(460);
	
	var _empresario2 = _interopRequireDefault(_empresario);
	
	var _artesano = __webpack_require__(446);
	
	var _artesano2 = _interopRequireDefault(_artesano);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.promueve', [_empresario2.default, _artesano2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reporteEmp = __webpack_require__(473);
	
	var _reporteEmp2 = _interopRequireDefault(_reporteEmp);
	
	var _reporteEmp3 = __webpack_require__(650);
	
	var _reporteEmp4 = _interopRequireDefault(_reporteEmp3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReporteComponent = {
	  bindings: {},
	  controller: _reporteEmp2.default,
	  template: _reporteEmp4.default
	};
	
	exports.default = ReporteComponent;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReporteEmpController = function () {
	  ReporteEmpController.$inject = ["$filter", "$location", "Datetime", "DataService", "Storage", "Loading"];
	  function ReporteEmpController($filter, $location, Datetime, DataService, Storage, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, ReporteEmpController);
	
	    this.$filter = $filter;
	    this.Datetime = Datetime;
	    this.DataService = DataService;
	    this.Storage = Storage;
	    this.Loading = Loading;
	
	    // Verificar si tiene acceso al menu.
	    var menu = Storage.get('menu');
	    menu = $filter('filter')(menu, { 'label': 'REPORTES' });
	    if (menu[0]) {
	      menu = $filter('filter')(menu[0].submenu, { 'url': 'descargacsv' });
	    }
	    if (!menu[0]) {
	      $location.path('/bandeja');
	    }
	    this.rol = Storage.get('rol');
	  }
	
	  _createClass(ReporteEmpController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.fecha = new Date();
	      this.dt1 = {
	        opened: false,
	        options: {
	          maxDate: new Date(),
	          minDate: new Date(1979, 0, 1),
	          startingDay: 1,
	          showWeeks: false
	        }
	      };
	      // this.dt1.options.maxDate.setDate(this.dt1.options.maxDate.getDate()-1);
	      this.dt2 = {
	        opened: false,
	        options: {
	          maxDate: new Date(),
	          minDate: new Date(1979, 0, 1),
	          startingDay: 1,
	          showWeeks: false
	        }
	      };
	
	      this.promueves = [{ valor: 'PROMUEVE', texto: 'PROMUEVE' }, { valor: 'SHB', texto: 'SELLO HECHO EN BOLIVIA' }];
	      this.ambito = this.promueves[0];
	    }
	
	    // Abrir datepicker
	
	  }, {
	    key: 'dt1Open',
	    value: function dt1Open() {
	      this.dt1.opened = true;
	    }
	  }, {
	    key: 'dt1Change',
	    value: function dt1Change() {
	      this.dt2.options.minDate = new Date(this.dt1.value);
	      // this.dt2.options.minDate.setDate(this.dt2.options.minDate.getDate()+1);
	    }
	  }, {
	    key: 'dt2Open',
	    value: function dt2Open() {
	      this.dt2.opened = true;
	    }
	  }, {
	    key: 'dt2Change',
	    value: function dt2Change() {
	      this.dt1.options.maxDate = new Date(this.dt2.value);
	      // this.dt1.options.maxDate.setDate(this.dt1.options.maxDate.getDate()-1);
	    }
	  }, {
	    key: 'descargarCsv',
	    value: function descargarCsv(form) {
	      var _this = this;
	
	      form.$setDirty();
	      if (form.$error && form.$error.required) {
	        for (var i in form.$error.required) {
	          if (form.$error.required[i].$setTouched) {
	            form.$error.required[i].$setTouched();
	          }
	        }
	      }
	      if (this.dt1.value && this.dt2.value) {
	        var url = this.rol == 2 ? 'reporteprobolivia' : 'reportepromueve';
	        var datos = {};
	        datos.desde = this.$filter('date')(this.dt1.value, 'dd/MM/yyyy');
	        datos.hasta = this.$filter('date')(this.dt2.value, 'dd/MM/yyyy');
	        if (this.rol == 3) {
	          datos.ambito = this.ambito.valor;
	        }
	        datos.incluyeMigrados = this.incluyeMigrados;
	        this.Loading.show('Generando archivo', true);
	        this.DataService.file(url, 'text/csv', datos).then(function (resp) {
	          var a = document.createElement('a');
	          a.href = resp;
	          a.download = _this.rol == 2 ? 'probolivia' : 'promueve';
	          if (datos.ambito == 'SHB') {
	            a.download += '_shb';
	          }
	          a.download += '_' + _this.$filter('date')(_this.fecha, 'yyyyMMddhhmmss') + '.csv';
	          a.target = "_blank";
	          document.body.appendChild(a);
	          a.click();
	          _this.Loading.hide();
	          angular.element(a).remove();
	        });
	      }
	    }
	
	    /**
	     * isMayor - verificar si la fecha1 es mayor a la fecha2
	     *
	     * @param  {string} val1 fecha1
	     * @param  {string} val2 fecha2
	     * @return {boolean}     true si falta un parametro
	     */
	
	  }, {
	    key: 'isMayorIgual',
	    value: function isMayorIgual(val1, val2) {
	      if (!val1 || !val2) {
	        return true;
	      }
	      var f1 = this.Datetime.isValid(val1) ? val1 : this.$$toDate(val1, '/');
	      var f2 = this.Datetime.isValid(val2) ? val2 : this.$$toDate(val2, '/');
	      return f1 >= f2;
	    }
	  }, {
	    key: '$$toDate',
	    value: function $$toDate(date, separator) {
	      date = date.split(separator || '-');
	      return new Date(date[2], date[1] - 1, date[0]);
	    }
	  }]);
	
	  return ReporteEmpController;
	}();
	
	exports.default = ReporteEmpController;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reporteEmp = __webpack_require__(472);
	
	var _reporteEmp2 = _interopRequireDefault(_reporteEmp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './reporte.emp.css';
	
	var User = angular.module('app.emp.reporte', []).component('appEmpReporte', _reporteEmp2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('reporte', {
	    url: '/descargacsv',
	    component: 'appEmpReporte'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandejaSellobolivia = __webpack_require__(476);
	
	var _bandejaSellobolivia2 = _interopRequireDefault(_bandejaSellobolivia);
	
	var _bandejaSellobolivia3 = __webpack_require__(651);
	
	var _bandejaSellobolivia4 = _interopRequireDefault(_bandejaSellobolivia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BandejaComponent = {
	    bindings: {},
	    controller: _bandejaSellobolivia2.default,
	    template: _bandejaSellobolivia4.default
	};
	
	exports.default = BandejaComponent;

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	'use strict';
	
	// html y controlador para el caso PB-PM-SHB
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BandejaController = function () {
	  BandejaController.$inject = ["$scope", "NgTableParams", "Modal", "Storage", "DataService", "Sidenav", "Util", "Message", "baseUrl"];
	  function BandejaController($scope, NgTableParams, Modal, Storage, DataService, Sidenav, Util, Message, baseUrl) {
	    'ngInject';
	
	    _classCallCheck(this, BandejaController);
	
	    this.$scope = $scope;
	    this.NgTableParams = NgTableParams;
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.DataService = DataService;
	    this.Sidenav = Sidenav;
	    this.Util = Util;
	    this.Message = Message;
	    this.baseUrl = baseUrl;
	
	    this.usuario = this.Storage.getUser();
	  }
	
	  _createClass(BandejaController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.Storage.remove('editCertificacion');
	      this.Storage.remove('matricula_seleccionada');
	      var colors = {
	        'NUEVO': 'default',
	        'PENDIENTE': 'primary',
	        'APROBADO': 'success',
	        'PENDIENTE_PAGO': 'warning',
	        'OBSERVADO': 'warning',
	        'RECHAZADO': 'danger',
	        'PAGADO': 'default'
	      };
	
	      this.$scope.$on('app_sello_modal_success', function () {
	        _this.$scope.$broadcast('refresh_crud_table', 'cert_sello_bolivia/sellos');
	      });
	
	      var descargar_img_sello = false;
	      this.DataService.get('cert_sello_bolivia/sellos?limit=1&estado=APROBADO').then(function (response) {
	        if (response && response.results.length) {
	          descargar_img_sello = true;
	          // this.$scope.$apply();
	        }
	      });
	
	      this.solicitudes = {
	        url: 'cert_sello_bolivia/sellos',
	        data: {
	          formly: [{
	            key: 'id_sello_bolivia',
	            type: 'input',
	            templateOptions: {
	              label: 'ID',
	              type: 'number'
	            }
	          }, {
	            key: 'id_certificacion',
	            type: 'input',
	            templateOptions: {
	              label: 'id certificacion',
	              type: 'number'
	            }
	          }, {
	            key: 'id_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: 'Unidad productiva',
	              type: 'number'
	            }
	          }, {
	            key: 'ddjj_certificacion_unidad_productiva',
	            type: 'input',
	            templateOptions: {
	              label: '',
	              type: 'number'
	            }
	          }, {
	            key: 'ddjj_estado',
	            type: 'select',
	            templateOptions: {
	              label: 'Estado',
	              type: 'select',
	              "options": [{
	                "value": "NUEVO",
	                "name": "NUEVO"
	              }, {
	                "value": "PENDIENTE",
	                "name": "PENDIENTE"
	              }, {
	                "value": "APROBADO",
	                "name": "APROBADO"
	              }, {
	                "value": "OBSERVADO",
	                "name": "OBSERVADO"
	              }, {
	                "value": "RECHAZADO",
	                "name": "RECHAZADO"
	              }]
	            }
	          }, {
	            key: '_fecha_envio',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha envío',
	              type: 'date'
	            }
	          }, {
	            key: 'ddjj_fecha_aprobacion',
	            type: 'datepicker',
	            templateOptions: {
	              label: 'Fecha evaluación',
	              type: 'date'
	            }
	          }, {
	            key: 'ruta_imagen',
	            type: 'archive',
	            templateOptions: {
	              label: 'Foto',
	              type: 'img'
	            }
	          }, {
	            key: 'nombre_producto',
	            type: 'input',
	            templateOptions: {
	              label: 'Nombre producto',
	              type: 'text'
	            }
	          }, {
	            key: 'nro_secuencia',
	            type: 'input',
	            templateOptions: {
	              label: 'MEFP',
	              type: 'text'
	            },
	            class: 'text-center',
	            next: {
	              key: 'nro_solicitud',
	              label: 'Secuencia | Solicitud'
	            }
	          }, {
	            key: 'nro_solicitud',
	            type: 'input',
	            templateOptions: {
	              label: '',
	              type: 'text'
	            }
	          }, {
	            key: 'ddjj_observacion',
	            type: 'input',
	            templateOptions: {
	              label: '',
	              type: 'text'
	            }
	          }]
	        },
	        fields: ['id_sello_bolivia', 'id_certificacion', 'id_unidad_productiva', 'id_producto', 'ddjj_certificacion_unidad_productiva', 'ruta_imagen', 'nombre_producto', 'ddjj_estado', '_fecha_envio', 'ddjj_fecha_aprobacion', 'nro_secuencia', 'nro_solicitud', 'ddjj_observacion'],
	        hiddenFields: ['id_sello_bolivia', 'id_certificacion', 'id_unidad_productiva', 'id_producto', 'ddjj_certificacion_unidad_productiva', 'nro_solicitud', 'ddjj_observacion'],
	        permission: {
	          create: false,
	          delete: false,
	          filter: false
	        },
	        eventEdit: function eventEdit(item) {
	          _this.Storage.set('editCertificacion', item.id_certificacion);
	          _this.Storage.set('matricula_seleccionada', { id_certificacion: item.ddjj_certificacion_unidad_productiva });
	          _this.Sidenav.path('autorizacion');
	        },
	        eventCreate: function eventCreate() {
	          _this.Sidenav.path('nuevoRegistroSello');
	        },
	        eventDelete: function eventDelete(item) {
	          _this.Modal.confirm('¿Desea eliminar este registro?', function () {
	            _this.DataService.delete('cert_sello_bolivia/shb/' + item.id_producto).then(function (response) {
	              if (response) {
	                _this.Message.success();
	                _this.$scope.$broadcast('refresh_crud_table', 'cert_sello_bolivia/sellos');
	              }
	            });
	          });
	        },
	        labels: {
	          create: 'Nuevo registro'
	        },
	        update: {
	          key: 'ddjj_estado', // key del registro con el cual se comparará el valor para mostrar/ocultar el botón actualizar
	          states: {
	            'NUEVO': true,
	            'PENDIENTE': false,
	            'OBSERVADO': true,
	            'APROBADO': false,
	            'RECHAZADO': false
	          }
	        },
	        delete: {
	          key: 'estado', // key del registro con el cual se comparará el valor para mostrar/ocultar el botón eliminar
	          states: {
	            'NUEVO': true,
	            'PENDIENTE': false,
	            'OBSERVADO': false,
	            'APROBADO': false
	          }
	        },
	        buttonsTop: [{
	          icon: 'download',
	          label: 'Manual de sello',
	          tooltip: 'Descargar manual de uso de sello',
	          onclick: function onclick() {
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.href = _this.baseUrl + 'manual/uso/shb';
	            a.target = '_blank';
	            a.download = 'Manual de uso de sello Hecho en Bolivia.pdf';
	            a.click();
	            a.parentNode.removeChild(a);
	          }
	        }, {
	          icon: 'download',
	          label: 'Imagen',
	          tooltip: 'Descargar imagen Sello Hecho en Bolivia',
	          if: function _if() {
	            return descargar_img_sello;
	          },
	          onclick: function onclick() {
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.href = _this.baseUrl + 'assets/sello.png';
	            a.download = 'Imagen de sello Hecho en Bolivia.png';
	            a.target = '_blank';
	            a.click();
	            a.parentNode.removeChild(a);
	          }
	        }],
	        buttons: [{
	          icon: 'eye',
	          tooltip: 'Ver detalles de solicitud',
	          if: function _if(ev, item) {
	            return ['PENDIENTE', 'APROBADO', 'RECHAZADO', 'OBSERVADO'].includes(item.ddjj_estado);
	          },
	          onclick: function onclick(ev, item) {
	            if (['RECHAZADO', 'OBSERVADO'].includes(item.ddjj_estado)) {
	              _this.Modal.pdf('cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/' + item.id_sello_bolivia, null, item.ddjj_observacion);
	            } else {
	              _this.Modal.pdf('cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/' + item.id_sello_bolivia);
	            }
	          }
	        }, {
	          icon: 'file-pdf-o',
	          tooltip: 'Ver detalles',
	          if: function _if(ev, item) {
	            return item.ddjj_estado == 'APROBADO';
	          },
	          onclick: function onclick(ev, item) {
	            // this.DataService.get(`certificaciones/firma/${item.id_certificacion}`)
	            // .then( response => {
	            //   const firmadores = response.map( it => { return {
	            //       nombre: it.nombreComunSubject,
	            //       organizacion: it.organizacionSubject,
	            //       emisor: `${it.nombreComunIssuer} - ${it.nombreComunIssuer}`,
	            //   }})
	            //   return this.Modal.pdf(`${this.baseUrl}certificacion/verificar?codigo=${item.codigo_archivo}`, null, null, firmadores[0]);
	            // })
	            _this.Modal.pdf('certificaciones/documento/' + item.id_certificacion, 'Autorización');
	          }
	        }],
	        clases: {
	          'ddjj_estado': function ddjj_estado(row) {
	            return ['badge', 'badge-' + colors[row.ddjj_estado]];
	          }
	        }
	      };
	    }
	  }]);
	
	  return BandejaController;
	}();
	
	exports.default = BandejaController;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bandejaSellobolivia = __webpack_require__(475);
	
	var _bandejaSellobolivia2 = _interopRequireDefault(_bandejaSellobolivia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bandeja = angular.module('app.sellobolivia.bandeja', []).component('appBandejaSello', _bandejaSellobolivia2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  $stateProvider.state('bandejaSello', {
	    url: '/bandejaSello',
	    component: 'appBandejaSello'
	  });
	  $urlRouterProvider.otherwise('/');
	}]).name;
	exports.default = Bandeja;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Deshabilitando SOLICITUDES NUEVAS DE SHB a solicitud de SENAVEX porque se migrará a
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bandejaSellobolivia = __webpack_require__(477);
	
	var _bandejaSellobolivia2 = _interopRequireDefault(_bandejaSellobolivia);
	
	var _solicitudSellobolivia = __webpack_require__(483);
	
	var _solicitudSellobolivia2 = _interopRequireDefault(_solicitudSellobolivia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Components = angular.module('app.sellobolivia', [_bandejaSellobolivia2.default, _solicitudSellobolivia2.default]).name;
	
	exports.default = Components;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CertificacionModalController = function () {
	  CertificacionModalController.$inject = ["$uibModalInstance", "data", "$log", "$scope", "DataService", "Message", "Util", "Loading", "Modal", "Storage", "Sidenav"];
	  function CertificacionModalController($uibModalInstance, data, $log, $scope, DataService, Message, Util, Loading, Modal, Storage, Sidenav) {
	    'ngInject';
	
	    _classCallCheck(this, CertificacionModalController);
	
	    this.producto = data.producto;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Util = Util;
	    this.Loading = Loading;
	    this.opciones_lugar = ['Etiquetas', 'Envases', 'Carteles', 'Videos', 'Películas'];
	    this.Modal = Modal;
	    this.Storage = Storage;
	    this.Sidenav = Sidenav;
	    this.usuario = this.Storage.getUser();
	  }
	
	  _createClass(CertificacionModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(angular.copy(this.data));
	      // this.$log.log(this);
	      this.modo_solo_shb = true;
	      this.unidades = [];
	      this.DataService.get('cert_sello_bolivia/unidades').then(function (response) {
	        if (response && response.results.length) {
	          // this.cargarConfCertificados();
	          _this.unidades = response.results;
	        } else {
	          /*
	          this.modo_solo_shb = 1;
	          if (this.usuario.nit) {
	              this.DataService.get(`servicios/matriculas/${this.usuario.nit}`)
	              .then(response => {
	                  if (response && response.matriculas && response.matriculas.length) {
	                      this.matriculas = response.matriculas;
	                  }
	              });
	          }
	          */
	        }
	      });
	    }
	  }, {
	    key: 'crearSolicitudSello',
	    value: function crearSolicitudSello(item) {
	      var _this2 = this;
	
	      this.$log.log(item);
	      this.Modal.confirm('Usted va a crear una solicitud de sello Hecho en Bolivia para un nuevo producto, ¿desea continuar?', function () {
	        _this2.DataService.post('certificacion_promueve/' + item.id_unidad_productiva + '/producto', {
	          tipo_producto: 'BIEN_PRODUCIDO',
	          nombre_producto: 'PRODUCTO PARA SELLO',
	          shb: true
	        }).then(function (response) {
	          if (response) {
	            _this2.Storage.set('matriculaPromueve', { id_unidad_productiva: item.id_unidad_productiva });
	            _this2.Storage.set('producto', response);
	            _this2.Sidenav.path('certificacion');
	            _this2.cancel();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'crearSolicitud',
	    value: function crearSolicitud(matricula) {
	      // crear form 7
	      var matriculaSeleccionada = this.unidades.find(function (item) {
	        return item.nit_matricula === matricula;
	      });
	      this.Storage.set('matricula_seleccionada', matriculaSeleccionada);
	      this.Sidenav.path('autorizacion');
	      this.cancel();
	    }
	  }, {
	    key: 'aceptar',
	    value: function aceptar() {
	      this.$uibModalInstance.close();
	      this.Sidenav.path('matricula');
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	      if (!this.Storage.get('matricula_seleccionada')) {
	        this.Sidenav.path('bandejaSello');
	      }
	    }
	  }]);
	
	  return CertificacionModalController;
	}();
	
	exports.default = CertificacionModalController;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelloModalController = function () {
	  SelloModalController.$inject = ["$rootScope", "$uibModalInstance", "data", "$log", "DataService", "Message", "Loading"];
	  function SelloModalController($rootScope, $uibModalInstance, data, $log, DataService, Message, Loading) {
	    'ngInject';
	
	    _classCallCheck(this, SelloModalController);
	
	    this.producto = data.producto;
	    this.$rootScope = $rootScope;
	    this.$uibModalInstance = $uibModalInstance;
	    this.$log = $log;
	    this.DataService = DataService;
	    this.Message = Message;
	    this.Loading = Loading;
	    this.opciones_lugar = ['Etiquetas', 'Envases', 'Carteles', 'Videos', 'Películas'];
	  }
	
	  _createClass(SelloModalController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      // this.$log.log(angular.copy(this.data));
	      // this.$log.log(this);
	
	      if (this.producto.lugar_sello) {
	        this.producto.lugar_sello = this.producto.lugar_sello.split('|');
	        this.opciones_lugar.forEach(function (it, i) {
	          if (_this.producto.lugar_sello.indexOf(it) + 1) {
	            _this.producto['lugar_sello' + i] = true;
	          }
	        });
	        if (!(this.opciones_lugar.indexOf(this.producto.lugar_sello[this.producto.lugar_sello.length - 1]) + 1)) {
	          this.producto.lugar_sello_otro = this.producto.lugar_sello[this.producto.lugar_sello.length - 1];
	        }
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;
	
	      // this.$log.log(form);
	      var data = {};
	      data.id_producto = this.producto.id_producto;
	      data.lugar_sello = [];
	      this.opciones_lugar.forEach(function (it, i) {
	        if (_this2.producto['lugar_sello' + i]) {
	          data.lugar_sello.push(it);
	        }
	      });
	      if (this.producto.lugar_sello_otro) {
	        data.lugar_sello.push(this.producto.lugar_sello_otro);
	      }
	
	      if (data.lugar_sello.length) {
	        data.lugar_sello = data.lugar_sello.join('|');
	        this.Loading.show('Cargando', true);
	        this.DataService.post('cert_sello_bolivia/generar_sello_de_promueve', data).then(function (response) {
	          if (response) {
	            _this2.Message.success();
	            _this2.cancel();
	            _this2.Loading.show('Cargando', false);
	            _this2.$rootScope.$broadcast('app_sello_modal_success');
	          }
	        });
	      } else {
	        this.Message.error('Debe especificar al menos un lugar de aplicación del sello.');
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.$uibModalInstance.close();
	      // this.$uibModalInstance.dismiss('cancel');
	    }
	  }]);
	
	  return SelloModalController;
	}();
	
	exports.default = SelloModalController;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _solicitudSellobolivia = __webpack_require__(482);
	
	var _solicitudSellobolivia2 = _interopRequireDefault(_solicitudSellobolivia);
	
	var _solicitudSellobolivia3 = __webpack_require__(654);
	
	var _solicitudSellobolivia4 = _interopRequireDefault(_solicitudSellobolivia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolicitudComponent = {
	    bindings: {},
	    controller: _solicitudSellobolivia2.default,
	    template: _solicitudSellobolivia4.default
	};
	
	exports.default = SolicitudComponent;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// html y controlador para el caso PB-PM-SHB
	// html y controlador para los casos PB-SHB y SHB 
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _autorizacionModal = __webpack_require__(479);
	
	var _autorizacionModal2 = _interopRequireDefault(_autorizacionModal);
	
	var _autorizacionModal3 = __webpack_require__(652);
	
	var _autorizacionModal4 = _interopRequireDefault(_autorizacionModal3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SolicitudController = function () {
	    SolicitudController.$inject = ["$scope", "Storage", "Message", "Filter", "Util", "Sidenav", "$state", "MatriculaPromueve", "DataService", "Datetime", "$log", "Modal"];
	    function SolicitudController($scope, Storage, Message, Filter, Util, Sidenav, $state, MatriculaPromueve, DataService, Datetime, $log, Modal) {
	        'ngInject';
	
	        _classCallCheck(this, SolicitudController);
	
	        this.$scope = $scope;
	        this.Storage = Storage;
	        this.Message = Message;
	        this.Filter = Filter;
	        this.Sidenav = Sidenav;
	        this.Util = Util;
	        this.DataService = DataService;
	        this.Datetime = Datetime;
	        this.Modal = Modal;
	        this.$state = $state;
	        this.MatriculaPromueve = MatriculaPromueve;
	        this.$log = $log;
	
	        this.mostrarSolicitudes = false;
	        this.mostrarMatriculas = null;
	        this.error = false;
	
	        this.usuario = this.Storage.getUser();
	
	        /**
	         * Casos
	         * caso 1: shb
	         * caso 2: pb-shb
	         * caso 3: pb-pm-shb
	         */
	        this.productos = [];
	    }
	
	    _createClass(SolicitudController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.Storage.remove('editCertificacion');
	            this.Storage.remove('matricula_seleccionada');
	            this.$scope.$on('app_sello_modal_success', function () {
	                _this.$scope.$broadcast('refresh_crud_table', 'cert_sello_bolivia/productos_sin_shb/' + _this.usuario.id_usuario);
	            });
	
	            this.Modal.show({
	                template: _autorizacionModal4.default,
	                controller: _autorizacionModal2.default,
	                data: {
	                    producto: null
	                },
	                size: 'lg'
	            });
	
	            this.DataService.get('cert_sello_bolivia/productos_sin_shb/' + this.usuario.id_usuario).then(function (response) {
	                if (response && response.results) {
	                    _this.cargarConfProductos();
	                    _this.productos = response.results;
	                }
	            });
	        }
	    }, {
	        key: 'irBandeja',
	        value: function irBandeja() {
	            this.Sidenav.path('bandejaSello');
	        }
	    }, {
	        key: 'cargarConfProductos',
	        value: function cargarConfProductos() {
	            var _this2 = this;
	
	            this.confProd = {
	                url: 'cert_sello_bolivia/productos_sin_shb/' + this.usuario.id_usuario,
	                queryExtra: { estado: 'APROBADO' },
	                data: {
	                    formly: [//id_producto, nombre_producto, estado
	                    {
	                        key: 'id_producto',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'ID',
	                            type: 'number'
	                        }
	                    }, {
	                        key: 'nombre_producto',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Nombre producto',
	                            type: 'text'
	                        }
	                    }, {
	                        key: 'fid_formulario',
	                        type: 'select',
	                        templateOptions: {
	                            label: 'Tipo producto',
	                            type: 'select',
	                            "options": [{
	                                "value": 3,
	                                "name": "BIEN PRODUCIDO"
	                            }, {
	                                "value": 4,
	                                "name": "COSTO BRUTO"
	                            }]
	                        }
	                    }, {
	                        key: 'nit',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Nit',
	                            type: 'text'
	                        }
	                    }, {
	                        key: 'id_unidad_productiva',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Unidad productiva',
	                            type: 'number'
	                        }
	                    }, {
	                        key: 'razon_social',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Razón social',
	                            type: 'text'
	                        }
	                    }, {
	                        key: 'matricula_comercio',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Matrícula de comercio',
	                            type: 'text'
	                        }
	                    }, {
	                        key: '_fecha_creacion',
	                        type: 'datepicker',
	                        templateOptions: {
	                            label: 'Fecha de creación',
	                            type: 'date'
	                        }
	                    }, {
	                        key: 'observaciones',
	                        type: 'input',
	                        templateOptions: {
	                            label: 'Observaciones',
	                            type: 'text'
	                        }
	                    }]
	                },
	                fields: ['id_producto', 'id_unidad_productiva', 'razon_social', 'nombre_producto', 'fid_formulario', '_fecha_creacion', 'observaciones'],
	                permission: {
	                    update: false,
	                    create: true,
	                    delete: false,
	                    filter: false
	                },
	                eventCreate: function eventCreate(ev, item) {
	                    _this2.Modal.show({
	                        template: _autorizacionModal4.default,
	                        controller: _autorizacionModal2.default,
	                        data: {
	                            producto: item
	                        },
	                        size: 'lg'
	                    });
	                },
	                labels: {
	                    emptyTable: 'No existen productos de promueve, debe registrar nuevos productos',
	                    create: 'Solicitar sello para un nuevo producto'
	                },
	                hiddenFields: ['id_unidad_productiva', 'observaciones'],
	                fks: ['fid_formulario'],
	                buttons: [{
	                    icon: 'eye',
	                    tooltip: 'Ver detalles de producto',
	                    onclick: function onclick(ev, item) {
	                        _this2.Modal.pdf("certificacion_promueve/" + item.id_unidad_productiva + "/certificacion/" + item.id_producto + "/ddjj_pdf", null, item.estado === 'RECHAZADO' ? item.observaciones : null);
	                    }
	                }]
	            };
	        }
	    }]);
	
	    return SolicitudController;
	}();
	
	exports.default = SolicitudController;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _solicitudSellobolivia = __webpack_require__(481);
	
	var _solicitudSellobolivia2 = _interopRequireDefault(_solicitudSellobolivia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var User = angular.module('app.sellobolivia.solicitud', []).component('appSelloboliviaSolicitud', _solicitudSellobolivia2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    $stateProvider.state('nuevoRegistroSello', {
	        url: '/nuevoRegistroSello',
	        component: 'appSelloboliviaSolicitud'
	    });
	    $urlRouterProvider.otherwise('/');
	}]).name;
	
	exports.default = User;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	    PDFObject v2.0.201604172
	    https://github.com/pipwerks/PDFObject
	    Copyright (c) 2008-2016 Philip Hutchison
	    MIT-style license: http://pipwerks.mit-license.org/
	    UMD module pattern from https://github.com/umdjs/umd/blob/master/templates/returnExports.js
	*/
	(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
	        module.exports = factory();
	    } else {
	        root.PDFObject = factory();
	    }
	})(undefined, function () {
	    "use strict";
	    if (typeof window === "undefined" || typeof navigator === "undefined") {
	        return false;
	    }var pdfobjectversion = "2.0.201604172",
	        supportsPDFs,
	        createAXO,
	        isIE,
	        supportsPdfMimeType = typeof navigator.mimeTypes["application/pdf"] !== "undefined",
	        supportsPdfActiveX,
	        buildFragmentString,
	        log,
	        embedError,
	        _embed,
	        getTargetElement,
	        generatePDFJSiframe,
	        isIOS = function () {
	        return (/iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())
	        );
	    }(),
	        generateEmbedElement;createAXO = function createAXO(type) {
	        var ax;try {
	            ax = new ActiveXObject(type);
	        } catch (e) {
	            ax = null;
	        }return ax;
	    };isIE = function isIE() {
	        return !!(window.ActiveXObject || "ActiveXObject" in window);
	    };supportsPdfActiveX = function supportsPdfActiveX() {
	        return !!(createAXO("AcroPDF.PDF") || createAXO("PDF.PdfCtrl"));
	    };supportsPDFs = supportsPdfMimeType || isIE() && supportsPdfActiveX();buildFragmentString = function buildFragmentString(pdfParams) {
	        var string = "",
	            prop;if (pdfParams) {
	            for (prop in pdfParams) {
	                if (pdfParams.hasOwnProperty(prop)) {
	                    string += encodeURIComponent(prop) + "=" + encodeURIComponent(pdfParams[prop]) + "&";
	                }
	            }if (string) {
	                string = "#" + string;string = string.slice(0, string.length - 1);
	            }
	        }return string;
	    };log = function log(msg) {
	        if (typeof console !== "undefined" && console.log) {
	            console.log("[PDFObject] " + msg);
	        }
	    };embedError = function embedError(msg) {
	        log(msg);return false;
	    };getTargetElement = function getTargetElement(targetSelector) {
	        var targetNode = document.body;if (typeof targetSelector === "string") {
	            targetNode = document.querySelector(targetSelector);
	        } else if (typeof jQuery !== "undefined" && targetSelector instanceof jQuery && targetSelector.length) {
	            targetNode = targetSelector.get(0);
	        } else if (typeof targetSelector.nodeType !== "undefined" && targetSelector.nodeType === 1) {
	            targetNode = targetSelector;
	        }return targetNode;
	    };generatePDFJSiframe = function generatePDFJSiframe(targetNode, url, pdfOpenFragment, PDFJS_URL, id) {
	        var fullURL = PDFJS_URL + "?file=" + encodeURIComponent(url) + pdfOpenFragment;var scrollfix = isIOS ? "-webkit-overflow-scrolling: touch; overflow-y: scroll; " : "overflow: hidden; ";var iframe = "<div style='" + scrollfix + "position: absolute; top: 0; right: 0; bottom: 0; left: 0;'><iframe  " + id + " src='" + fullURL + "' style='border: none; width: 100%; height: 100%;' frameborder='0'></iframe></div>";targetNode.className += " pdfobject-container";targetNode.style.position = "relative";targetNode.style.overflow = "auto";targetNode.innerHTML = iframe;return targetNode.getElementsByTagName("iframe")[0];
	    };generateEmbedElement = function generateEmbedElement(targetNode, targetSelector, url, pdfOpenFragment, width, height, id) {
	        var style = "";if (targetSelector && targetSelector !== document.body) {
	            style = "width: " + width + "; height: " + height + ";";
	        } else {
	            style = "position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%;";
	        }targetNode.className += " pdfobject-container";targetNode.innerHTML = "<embed " + id + " class='pdfobject' src='" + url + pdfOpenFragment + "' type='application/pdf' style='overflow: auto; " + style + "'/>";return targetNode.getElementsByTagName("embed")[0];
	    };_embed = function embed(url, targetSelector, options) {
	        if (typeof url !== "string") {
	            return embedError("URL is not valid");
	        }targetSelector = typeof targetSelector !== "undefined" ? targetSelector : false;options = typeof options !== "undefined" ? options : {};var id = options.id && typeof options.id === "string" ? "id='" + options.id + "'" : "",
	            page = options.page ? options.page : false,
	            pdfOpenParams = options.pdfOpenParams ? options.pdfOpenParams : {},
	            fallbackLink = typeof options.fallbackLink !== "undefined" ? options.fallbackLink : true,
	            width = options.width ? options.width : "100%",
	            height = options.height ? options.height : "100%",
	            forcePDFJS = typeof options.forcePDFJS === "boolean" ? options.forcePDFJS : false,
	            PDFJS_URL = options.PDFJS_URL ? options.PDFJS_URL : false,
	            targetNode = getTargetElement(targetSelector),
	            fallbackHTML = "",
	            pdfOpenFragment = "",
	            fallbackHTML_default = "<p>This browser does not support inline PDFs. Please download the PDF to view it: <a href='[url]'>Download PDF</a></p>";if (!targetNode) {
	            return embedError("Target element cannot be determined");
	        }if (page) {
	            pdfOpenParams.page = page;
	        }pdfOpenFragment = buildFragmentString(pdfOpenParams);if (forcePDFJS && PDFJS_URL) {
	            return generatePDFJSiframe(targetNode, url, pdfOpenFragment, PDFJS_URL, id);
	        } else if (supportsPDFs) {
	            return generateEmbedElement(targetNode, targetSelector, url, pdfOpenFragment, width, height, id);
	        } else {
	            if (PDFJS_URL) {
	                return generatePDFJSiframe(targetNode, url, pdfOpenFragment, PDFJS_URL, id);
	            } else if (fallbackLink) {
	                fallbackHTML = typeof fallbackLink === "string" ? fallbackLink : fallbackHTML_default;targetNode.innerHTML = fallbackHTML.replace(/\[url\]/g, url);
	            }return embedError("This browser does not support embedded PDFs");
	        }
	    };return { embed: function embed(a, b, c) {
	            return _embed(a, b, c);
	        }, pdfobjectversion: function () {
	            return pdfobjectversion;
	        }(), supportsPDFs: function () {
	            return supportsPDFs;
	        }() };
	});

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex']).constant('uibAccordionConfig', {
	  closeOthers: true
	}).controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function (openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function (group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function (groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function (event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function (group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function () {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function () {
	  return {
	    require: '^uibAccordion', // We need this directive to be inside an accordion
	    transclude: true, // It transcludes the contents of the directive into the template
	    restrict: 'A',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@', // Interpolate the heading attribute onto this scope
	      panelClass: '@?', // Ditto with panelClass
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function controller() {
	      this.setHeading = function (element) {
	        this.heading = element;
	      };
	    },
	    link: function link(scope, element, attrs, accordionCtrl) {
	      element.addClass('panel');
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass || 'panel-default';
	      scope.$watch('isOpen', function (value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function ($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	
	      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      scope.headingId = id + '-tab';
	      scope.panelId = id + '-panel';
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function () {
	  return {
	    transclude: true, // Grab the contents to be used as the heading
	    template: '', // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function link(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function () {
	  return {
	    require: '^uibAccordionGroup',
	    link: function link(scope, element, attrs, controller) {
	      scope.$watch(function () {
	        return controller[attrs.uibAccordionTransclude];
	      }, function (heading) {
	        if (heading) {
	          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
	          elem.html('');
	          elem.append(heading);
	        }
	      });
	    }
	  };
	
	  function getHeaderSelectors() {
	    return 'uib-accordion-header,' + 'data-uib-accordion-header,' + 'x-uib-accordion-header,' + 'uib\\:accordion-header,' + '[uib-accordion-header],' + '[data-uib-accordion-header],' + '[x-uib-accordion-header]';
	  }
	});

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(492);
	__webpack_require__(514);
	__webpack_require__(523);
	__webpack_require__(524);
	__webpack_require__(485);
	
	var MODULE_NAME = 'ui.bootstrap.module.accordion';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.accordion', 'uib/template/accordion/accordion.html', 'uib/template/accordion/accordion-group.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.alert', []).controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function ($scope, $element, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	  $element.addClass('alert');
	  $attrs.$set('role', 'alert');
	  if ($scope.closeable) {
	    $element.addClass('alert-dismissible');
	  }
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ? $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function () {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}]).directive('uibAlert', function () {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    restrict: 'A',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/alert/alert.html';
	    },
	    transclude: true,
	    scope: {
	      close: '&'
	    }
	  };
	});

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(525);
	__webpack_require__(487);
	
	var MODULE_NAME = 'ui.bootstrap.module.alert';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.alert', 'uib/template/alert/alert.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.buttons', []).constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	}).controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}]).directive('uibBtnRadio', ['$parse', function ($parse) {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function link(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	      var uncheckableExpr = $parse(attrs.uibUncheckable);
	
	      element.find('input').css({ display: 'none' });
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function () {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function () {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	
	      if (attrs.uibUncheckable) {
	        scope.$watch(uncheckableExpr, function (uncheckable) {
	          attrs.$set('uncheckable', uncheckable ? '' : undefined);
	        });
	      }
	    }
	  };
	}]).directive('uibBtnCheckbox', function () {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function link(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      element.find('input').css({ display: 'none' });
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function () {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function () {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function () {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(489);
	
	var MODULE_NAME = 'ui.bootstrap.module.buttons';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.buttons']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.collapse', []).directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
	  var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	  return {
	    link: function link(scope, element, attrs) {
	      var expandingExpr = $parse(attrs.expanding),
	          expandedExpr = $parse(attrs.expanded),
	          collapsingExpr = $parse(attrs.collapsing),
	          collapsedExpr = $parse(attrs.collapsed),
	          horizontal = false,
	          css = {},
	          cssTo = {};
	
	      init();
	
	      function init() {
	        horizontal = !!('horizontal' in attrs);
	        if (horizontal) {
	          css = {
	            width: ''
	          };
	          cssTo = { width: '0' };
	        } else {
	          css = {
	            height: ''
	          };
	          cssTo = { height: '0' };
	        }
	        if (!scope.$eval(attrs.uibCollapse)) {
	          element.addClass('in').addClass('collapse').attr('aria-expanded', true).attr('aria-hidden', false).css(css);
	        }
	      }
	
	      function getScrollFromElement(element) {
	        if (horizontal) {
	          return { width: element.scrollWidth + 'px' };
	        }
	        return { height: element.scrollHeight + 'px' };
	      }
	
	      function expand() {
	        if (element.hasClass('collapse') && element.hasClass('in')) {
	          return;
	        }
	
	        $q.resolve(expandingExpr(scope)).then(function () {
	          element.removeClass('collapse').addClass('collapsing').attr('aria-expanded', true).attr('aria-hidden', false);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              addClass: 'in',
	              easing: 'ease',
	              css: {
	                overflow: 'hidden'
	              },
	              to: getScrollFromElement(element[0])
	            }).start()['finally'](expandDone);
	          } else {
	            $animate.addClass(element, 'in', {
	              css: {
	                overflow: 'hidden'
	              },
	              to: getScrollFromElement(element[0])
	            }).then(expandDone);
	          }
	        }, angular.noop);
	      }
	
	      function expandDone() {
	        element.removeClass('collapsing').addClass('collapse').css(css);
	        expandedExpr(scope);
	      }
	
	      function collapse() {
	        if (!element.hasClass('collapse') && !element.hasClass('in')) {
	          return collapseDone();
	        }
	
	        $q.resolve(collapsingExpr(scope)).then(function () {
	          element
	          // IMPORTANT: The width must be set before adding "collapsing" class.
	          // Otherwise, the browser attempts to animate from width 0 (in
	          // collapsing class) to the given width here.
	          .css(getScrollFromElement(element[0]))
	          // initially all panel collapse have the collapse class, this removal
	          // prevents the animation from jumping to collapsed state
	          .removeClass('collapse').addClass('collapsing').attr('aria-expanded', false).attr('aria-hidden', true);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: 'in',
	              to: cssTo
	            }).start()['finally'](collapseDone);
	          } else {
	            $animate.removeClass(element, 'in', {
	              to: cssTo
	            }).then(collapseDone);
	          }
	        }, angular.noop);
	      }
	
	      function collapseDone() {
	        element.css(cssTo); // Required so that collapse works when animation is disabled
	        element.removeClass('collapsing').addClass('collapse');
	        collapsedExpr(scope);
	      }
	
	      scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
	        if (shouldCollapse) {
	          collapse();
	        } else {
	          expand();
	        }
	      });
	    }
	  };
	}]);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(491);
	
	var MODULE_NAME = 'ui.bootstrap.module.collapse';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.collapse']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.dateparser', []).service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function ($log, $locale, dateFilter, orderByFilter, filterFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function () {
	    localeId = $locale.id;
	
	    this.parsers = {};
	    this.formatters = {};
	
	    formatCodeToRegex = [{
	      key: 'yyyy',
	      regex: '\\d{4}',
	      apply: function apply(value) {
	        this.year = +value;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'yyyy');
	      }
	    }, {
	      key: 'yy',
	      regex: '\\d{2}',
	      apply: function apply(value) {
	        value = +value;this.year = value < 69 ? value + 2000 : value + 1900;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'yy');
	      }
	    }, {
	      key: 'y',
	      regex: '\\d{1,4}',
	      apply: function apply(value) {
	        this.year = +value;
	      },
	      formatter: function formatter(date) {
	        var _date = new Date();
	        _date.setFullYear(Math.abs(date.getFullYear()));
	        return dateFilter(_date, 'y');
	      }
	    }, {
	      key: 'M!',
	      regex: '0?[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        var value = date.getMonth();
	        if (/^[0-9]$/.test(value)) {
	          return dateFilter(date, 'MM');
	        }
	
	        return dateFilter(date, 'M');
	      }
	    }, {
	      key: 'MMMM',
	      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	      apply: function apply(value) {
	        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MMMM');
	      }
	    }, {
	      key: 'MMM',
	      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	      apply: function apply(value) {
	        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MMM');
	      }
	    }, {
	      key: 'MM',
	      regex: '0[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'MM');
	      }
	    }, {
	      key: 'M',
	      regex: '[1-9]|1[0-2]',
	      apply: function apply(value) {
	        this.month = value - 1;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'M');
	      }
	    }, {
	      key: 'd!',
	      regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        var value = date.getDate();
	        if (/^[1-9]$/.test(value)) {
	          return dateFilter(date, 'dd');
	        }
	
	        return dateFilter(date, 'd');
	      }
	    }, {
	      key: 'dd',
	      regex: '[0-2][0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'dd');
	      }
	    }, {
	      key: 'd',
	      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	      apply: function apply(value) {
	        this.date = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'd');
	      }
	    }, {
	      key: 'EEEE',
	      regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'EEEE');
	      }
	    }, {
	      key: 'EEE',
	      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'EEE');
	      }
	    }, {
	      key: 'HH',
	      regex: '(?:0|1)[0-9]|2[0-3]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'HH');
	      }
	    }, {
	      key: 'hh',
	      regex: '0[0-9]|1[0-2]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'hh');
	      }
	    }, {
	      key: 'H',
	      regex: '1?[0-9]|2[0-3]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'H');
	      }
	    }, {
	      key: 'h',
	      regex: '[0-9]|1[0-2]',
	      apply: function apply(value) {
	        this.hours = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'h');
	      }
	    }, {
	      key: 'mm',
	      regex: '[0-5][0-9]',
	      apply: function apply(value) {
	        this.minutes = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'mm');
	      }
	    }, {
	      key: 'm',
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function apply(value) {
	        this.minutes = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'm');
	      }
	    }, {
	      key: 'sss',
	      regex: '[0-9][0-9][0-9]',
	      apply: function apply(value) {
	        this.milliseconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'sss');
	      }
	    }, {
	      key: 'ss',
	      regex: '[0-5][0-9]',
	      apply: function apply(value) {
	        this.seconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'ss');
	      }
	    }, {
	      key: 's',
	      regex: '[0-9]|[1-5][0-9]',
	      apply: function apply(value) {
	        this.seconds = +value;
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 's');
	      }
	    }, {
	      key: 'a',
	      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	      apply: function apply(value) {
	        if (this.hours === 12) {
	          this.hours = 0;
	        }
	
	        if (value === 'PM') {
	          this.hours += 12;
	        }
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'a');
	      }
	    }, {
	      key: 'Z',
	      regex: '[+-]\\d{4}',
	      apply: function apply(value) {
	        var matches = value.match(/([+-])(\d{2})(\d{2})/),
	            sign = matches[1],
	            hours = matches[2],
	            minutes = matches[3];
	        this.hours += toInt(sign + hours);
	        this.minutes += toInt(sign + minutes);
	      },
	      formatter: function formatter(date) {
	        return dateFilter(date, 'Z');
	      }
	    }, {
	      key: 'ww',
	      regex: '[0-4][0-9]|5[0-3]',
	      formatter: function formatter(date) {
	        return dateFilter(date, 'ww');
	      }
	    }, {
	      key: 'w',
	      regex: '[0-9]|[1-4][0-9]|5[0-3]',
	      formatter: function formatter(date) {
	        return dateFilter(date, 'w');
	      }
	    }, {
	      key: 'GGGG',
	      regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GGGG');
	      }
	    }, {
	      key: 'GGG',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GGG');
	      }
	    }, {
	      key: 'GG',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'GG');
	      }
	    }, {
	      key: 'G',
	      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	      formatter: function formatter(date) {
	        return dateFilter(date, 'G');
	      }
	    }];
	
	    if (angular.version.major >= 1 && angular.version.minor > 4) {
	      formatCodeToRegex.push({
	        key: 'LLLL',
	        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
	        apply: function apply(value) {
	          this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value);
	        },
	        formatter: function formatter(date) {
	          return dateFilter(date, 'LLLL');
	        }
	      });
	    }
	  };
	
	  this.init();
	
	  function getFormatCodeToRegex(key) {
	    return filterFilter(formatCodeToRegex, { key: key }, true)[0];
	  }
	
	  this.getParser = function (key) {
	    var f = getFormatCodeToRegex(key);
	    return f && f.apply || null;
	  };
	
	  this.overrideParser = function (key, parser) {
	    var f = getFormatCodeToRegex(key);
	    if (f && angular.isFunction(parser)) {
	      this.parsers = {};
	      f.apply = parser;
	    }
	  }.bind(this);
	
	  function createParser(format) {
	    var map = [],
	        regex = format.split('');
	
	    // check for literal values
	    var quoteIndex = format.indexOf('\'');
	    if (quoteIndex > -1) {
	      var inLiteral = false;
	      format = format.split('');
	      for (var i = quoteIndex; i < format.length; i++) {
	        if (inLiteral) {
	          if (format[i] === '\'') {
	            if (i + 1 < format.length && format[i + 1] === '\'') {
	              // escaped single quote
	              format[i + 1] = '$';
	              regex[i + 1] = '';
	            } else {
	              // end of literal
	              regex[i] = '';
	              inLiteral = false;
	            }
	          }
	          format[i] = '$';
	        } else {
	          if (format[i] === '\'') {
	            // start of literal
	            format[i] = '$';
	            regex[i] = '';
	            inLiteral = true;
	          }
	        }
	      }
	
	      format = format.join('');
	    }
	
	    angular.forEach(formatCodeToRegex, function (data) {
	      var index = format.indexOf(data.key);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({
	          index: index,
	          key: data.key,
	          apply: data.apply,
	          matcher: data.regex
	        });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  function createFormatter(format) {
	    var formatters = [];
	    var i = 0;
	    var formatter, literalIdx;
	    while (i < format.length) {
	      if (angular.isNumber(literalIdx)) {
	        if (format.charAt(i) === '\'') {
	          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
	            formatters.push(constructLiteralFormatter(format, literalIdx, i));
	            literalIdx = null;
	          }
	        } else if (i === format.length) {
	          while (literalIdx < format.length) {
	            formatter = constructFormatterFromIdx(format, literalIdx);
	            formatters.push(formatter);
	            literalIdx = formatter.endIdx;
	          }
	        }
	
	        i++;
	        continue;
	      }
	
	      if (format.charAt(i) === '\'') {
	        literalIdx = i;
	        i++;
	        continue;
	      }
	
	      formatter = constructFormatterFromIdx(format, i);
	
	      formatters.push(formatter.parser);
	      i = formatter.endIdx;
	    }
	
	    return formatters;
	  }
	
	  function constructLiteralFormatter(format, literalIdx, endIdx) {
	    return function () {
	      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
	    };
	  }
	
	  function constructFormatterFromIdx(format, i) {
	    var currentPosStr = format.substr(i);
	    for (var j = 0; j < formatCodeToRegex.length; j++) {
	      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
	        var data = formatCodeToRegex[j];
	        return {
	          endIdx: i + data.key.length,
	          parser: data.formatter
	        };
	      }
	    }
	
	    return {
	      endIdx: i + 1,
	      parser: function parser() {
	        return currentPosStr.charAt(0);
	      }
	    };
	  }
	
	  this.filter = function (date, format) {
	    if (!angular.isDate(date) || isNaN(date) || !format) {
	      return '';
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.formatters[format]) {
	      this.formatters[format] = createFormatter(format);
	    }
	
	    var formatters = this.formatters[format];
	
	    return formatters.reduce(function (str, formatter) {
	      return str + formatter(date);
	    }, '');
	  };
	
	  this.parse = function (input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format, 'apply');
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex),
	        tzOffset = false;
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i - 1];
	        if (mapper.matcher === 'Z') {
	          tzOffset = true;
	        }
	
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      var datesetter = tzOffset ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear;
	      var timesetter = tzOffset ? Date.prototype.setUTCHours : Date.prototype.setHours;
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	          dt = new Date(baseDate);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours, fields.minutes, fields.seconds, fields.milliseconds);
	        } else {
	          dt = new Date(0);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours || 0, fields.minutes || 0, fields.seconds || 0, fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	  this.toTimezone = toTimezone;
	  this.fromTimezone = fromTimezone;
	  this.timezoneToOffset = timezoneToOffset;
	  this.addDateMinutes = addDateMinutes;
	  this.convertTimezoneToLocal = convertTimezoneToLocal;
	
	  function toTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	  }
	
	  function fromTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	  }
	
	  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
	  function timezoneToOffset(timezone, fallback) {
	    timezone = timezone.replace(/:/g, '');
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	  }
	}]);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(493);
	
	var MODULE_NAME = 'ui.bootstrap.module.dateparser';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.dateparser']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module("ngLocale", [], ["$provide", function ($provide) {
	  var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
	  $provide.value("$locale", {
	    "DATETIME_FORMATS": {
	      "AMPMS": ["a. m.", "p. m."],
	      "DAY": ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"],
	      "ERANAMES": ["antes de Cristo", "despu\xE9s de Cristo"],
	      "ERAS": ["a. C.", "d. C."],
	      "FIRSTDAYOFWEEK": 0,
	      "MONTH": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
	      "SHORTDAY": ["dom.", "lun.", "mar.", "mi\xE9.", "jue.", "vie.", "s\xE1b."],
	      "SHORTMONTH": ["ene.", "feb.", "mar.", "abr.", "may.", "jun.", "jul.", "ago.", "sept.", "oct.", "nov.", "dic."],
	      "STANDALONEMONTH": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
	      "WEEKENDRANGE": [5, 6],
	      "fullDate": "EEEE, d 'de' MMMM 'de' y",
	      "longDate": "d 'de' MMMM 'de' y",
	      "medium": "d MMM y H:mm:ss",
	      "mediumDate": "d MMM y",
	      "mediumTime": "H:mm:ss",
	      "short": "d/M/yy H:mm",
	      "shortDate": "d/M/yy",
	      "shortTime": "H:mm"
	    },
	    "NUMBER_FORMATS": {
	      "CURRENCY_SYM": "\u20AC",
	      "DECIMAL_SEP": ",",
	      "GROUP_SEP": ".",
	      "PATTERNS": [{
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      }, {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "\xA0\xA4",
	        "posPre": "",
	        "posSuf": "\xA0\xA4"
	      }]
	    },
	    "id": "es-es",
	    "localeID": "es_ES",
	    "pluralCat": function pluralCat(n, opt_precision) {
	      if (n == 1) {
	        return PLURAL_CATEGORY.ONE;
	      }return PLURAL_CATEGORY.OTHER;
	    }
	  });
	}]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass']).value('$datepickerSuppressError', false).value('$datepickerLiteralWarning', true).constant('uibDatepickerConfig', {
	  datepickerMode: 'day',
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  maxDate: null,
	  maxMode: 'year',
	  minDate: null,
	  minMode: 'day',
	  monthColumns: 3,
	  ngModelOptions: {},
	  shortcutPropagation: false,
	  showWeeks: true,
	  yearColumns: 5,
	  yearRows: 4
	}).controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser', function ($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop },
	      // nullModelCtrl;
	  ngModelOptions = {},
	      watchListeners = [];
	
	  $element.addClass('uib-datepicker');
	  $attrs.$set('role', 'application');
	
	  if (!$scope.datepickerOptions) {
	    $scope.datepickerOptions = {};
	  }
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  ['customClass', 'dateDisabled', 'datepickerMode', 'formatDay', 'formatDayHeader', 'formatDayTitle', 'formatMonth', 'formatMonthTitle', 'formatYear', 'maxDate', 'maxMode', 'minDate', 'minMode', 'monthColumns', 'showWeeks', 'shortcutPropagation', 'startingDay', 'yearColumns', 'yearRows'].forEach(function (key) {
	    switch (key) {
	      case 'customClass':
	      case 'dateDisabled':
	        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	        break;
	      case 'datepickerMode':
	        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ? $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	        break;
	      case 'formatDay':
	      case 'formatDayHeader':
	      case 'formatDayTitle':
	      case 'formatMonth':
	      case 'formatMonthTitle':
	      case 'formatYear':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $interpolate($scope.datepickerOptions[key])($scope.$parent) : datepickerConfig[key];
	        break;
	      case 'monthColumns':
	      case 'showWeeks':
	      case 'shortcutPropagation':
	      case 'yearColumns':
	      case 'yearRows':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $scope.datepickerOptions[key] : datepickerConfig[key];
	        break;
	      case 'startingDay':
	        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	          self.startingDay = $scope.datepickerOptions.startingDay;
	        } else if (angular.isNumber(datepickerConfig.startingDay)) {
	          self.startingDay = datepickerConfig.startingDay;
	        } else {
	          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	        }
	
	        break;
	      case 'maxDate':
	      case 'minDate':
	        $scope.$watch('datepickerOptions.' + key, function (value) {
	          if (value) {
	            if (angular.isDate(value)) {
	              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
	            } else {
	              if ($datepickerLiteralWarning) {
	                $log.warn('Literal date support has been deprecated, please switch to date object usage');
	              }
	
	              self[key] = new Date(dateFilter(value, 'medium'));
	            }
	          } else {
	            self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) : null;
	          }
	
	          self.refreshView();
	        });
	
	        break;
	      case 'maxMode':
	      case 'minMode':
	        if ($scope.datepickerOptions[key]) {
	          $scope.$watch(function () {
	            return $scope.datepickerOptions[key];
	          }, function (value) {
	            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
	            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	              $scope.datepickerMode = self[key];
	              $scope.datepickerOptions.datepickerMode = self[key];
	            }
	          });
	        } else {
	          self[key] = $scope[key] = datepickerConfig[key] || null;
	        }
	
	        break;
	    }
	  });
	
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if (angular.isDefined($attrs.ngDisabled)) {
	    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
	      $scope.disabled = disabled;
	      self.refreshView();
	    }));
	  }
	
	  $scope.isActive = function (dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function (ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelOptions = extractOptions(ngModelCtrl);
	
	    if ($scope.datepickerOptions.initDate) {
	      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
	      $scope.$watch('datepickerOptions.initDate', function (initDate) {
	        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
	          self.refreshView();
	        }
	      });
	    } else {
	      self.activeDate = new Date();
	    }
	
	    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
	    this.activeDate = !isNaN(date) ? dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) : dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	
	    ngModelCtrl.$render = function () {
	      self.render();
	    };
	  };
	
	  this.render = function () {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function () {
	    if (this.element) {
	      $scope.selectedDt = null;
	      this._refreshView();
	      if ($scope.activeDt) {
	        $scope.activeDateId = $scope.activeDt.uid;
	      }
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setValidity('dateDisabled', !date || this.element && !this.isDisabled(date));
	    }
	  };
	
	  this.createDateObject = function (date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
	    var today = new Date();
	    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	    var time = this.compare(date, today);
	    var dt = {
	      date: date,
	      label: dateParser.filter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      past: time < 0,
	      current: time === 0,
	      future: time > 0,
	      customClass: this.customClass(date) || null
	    };
	
	    if (model && this.compare(date, model) === 0) {
	      $scope.selectedDt = dt;
	    }
	
	    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	      $scope.activeDt = dt;
	    }
	
	    return dt;
	  };
	
	  this.isDisabled = function (date) {
	    return $scope.disabled || this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
	  };
	
	  this.customClass = function (date) {
	    return $scope.customClass({ date: date, mode: $scope.datepickerMode });
	  };
	
	  // Split array into smaller arrays
	  this.split = function (arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function (date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);
	
	      $scope.$emit('uib:datepicker.mode');
	    }
	
	    $scope.$broadcast('uib:datepicker.focus');
	  };
	
	  $scope.move = function (direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function (direction) {
	    direction = direction || 1;
	
	    if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {
	      return;
	    }
	
	    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);
	
	    $scope.$emit('uib:datepicker.mode');
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function focusElement() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function (evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	
	  $element.on('keydown', function (evt) {
	    $scope.$apply(function () {
	      $scope.keydown(evt);
	    });
	  });
	
	  $scope.$on('$destroy', function () {
	    //Clear all watch listeners on destroy
	    while (watchListeners.length) {
	      watchListeners.shift()();
	    }
	  });
	
	  function setMode(mode) {
	    $scope.datepickerMode = mode;
	    $scope.datepickerOptions.datepickerMode = mode;
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) {
	      // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = ngModelCtrl.$options || $scope.datepickerOptions.ngModelOptions || datepickerConfig.ngModelOptions || {};
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else {
	      // in angular >=1.6 $options is always present
	      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
	      var timezone = ngModelCtrl.$options.getOption('timezone') || ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) || (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);
	
	      // values passed to createChild override existing values
	      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
	      .createChild(datepickerConfig.ngModelOptions) // lowest precedence
	      .createChild($scope.datepickerOptions.ngModelOptions).createChild(ngModelCtrl.$options) // highest precedence
	      .createChild({ timezone: timezone }); // to keep from squashing a non-null value
	    }
	
	    return ngModelOptions;
	  }
	}]).controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function (ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function (startDate, n) {
	    var dates = new Array(n),
	        current = new Date(startDate),
	        i = 0,
	        date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function () {
	    var year = this.activeDate.getFullYear(),
	        month = this.activeDate.getMonth(),
	        firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	        numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,
	        firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-week calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function (date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 7;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}]).controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function (ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function () {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, this.monthColumns);
	    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
	  };
	
	  this.compare = function (date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - this.monthColumns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + this.monthColumns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}]).controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
	  var columns, range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function () {
	    columns = this.yearColumns;
	    range = this.yearRows * columns;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function () {
	    var years = new Array(range),
	        date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, columns);
	    scope.columns = columns;
	  };
	
	  this.compare = function (date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function (key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - columns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + columns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? -1 : 1) * range;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}]).directive('uibDatepicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerOptions: '=?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    restrict: 'A',
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	}).directive('uibDaypicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/day.html';
	    },
	    require: ['^uibDatepicker', 'uibDaypicker'],
	    restrict: 'A',
	    controller: 'UibDaypickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	}).directive('uibMonthpicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/month.html';
	    },
	    require: ['^uibDatepicker', 'uibMonthpicker'],
	    restrict: 'A',
	    controller: 'UibMonthpickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	          monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	}).directive('uibYearpicker', function () {
	  return {
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/year.html';
	    },
	    require: ['^uibDatepicker', 'uibYearpicker'],
	    restrict: 'A',
	    controller: 'UibYearpickerController',
	    link: function link(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(80);
	module.exports = __webpack_require__(86);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(86);
	__webpack_require__(28);
	__webpack_require__(530);
	__webpack_require__(499);
	
	var MODULE_NAME = 'ui.bootstrap.module.datepickerPopup';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.datepickerPopup', 'uib/template/datepickerPopup/popup.html', 'ui.bootstrap.module.datepicker']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(80);
	__webpack_require__(26);
	__webpack_require__(171);
	module.exports = __webpack_require__(497);

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position']).value('$datepickerPopupLiteralWarning', true).constant('uibDatepickerPopupConfig', {
	  altInputFormats: [],
	  appendToBody: false,
	  clearText: 'Clear',
	  closeOnDateSelection: true,
	  closeText: 'Done',
	  currentText: 'Today',
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
	  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  onOpenFocus: true,
	  showButtonBar: true,
	  placement: 'auto bottom-left'
	}).controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning', function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
	  var cache = {},
	      isHtml5DateInput = false;
	  var dateFormat,
	      closeOnDateSelection,
	      appendToBody,
	      onOpenFocus,
	      datepickerPopupTemplateUrl,
	      datepickerTemplateUrl,
	      popupEl,
	      datepickerEl,
	      scrollParentEl,
	      ngModel,
	      ngModelOptions,
	      $popup,
	      altInputFormats,
	      watchListeners = [];
	
	  this.init = function (_ngModel_) {
	    ngModel = _ngModel_;
	    ngModelOptions = extractOptions(ngModel);
	    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ? $scope.$parent.$eval($attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ? $scope.$parent.$eval($attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ? $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ? $attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ? $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	    altInputFormats = angular.isDefined($attrs.altInputFormats) ? $scope.$parent.$eval($attrs.altInputFormats) : datepickerPopupConfig.altInputFormats;
	
	    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ? $scope.$parent.$eval($attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[$attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
	        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	        // Invalidate the $modelValue to ensure that formatters re-run
	        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	        if (newDateFormat !== dateFormat) {
	          dateFormat = newDateFormat;
	          ngModel.$modelValue = null;
	
	          if (!dateFormat) {
	            throw new Error('uibDatepickerPopup must have a date format specified.');
	          }
	        }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (!$scope.datepickerOptions) {
	      $scope.datepickerOptions = {};
	    }
	
	    if (isHtml5DateInput) {
	      if ($attrs.type === 'month') {
	        $scope.datepickerOptions.datepickerMode = 'month';
	        $scope.datepickerOptions.minMode = 'month';
	      }
	    }
	
	    datepickerEl.attr('datepicker-options', 'datepickerOptions');
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function (value) {
	        if (ngModel.$isEmpty(value)) {
	          $scope.date = value;
	          return value;
	        }
	
	        if (angular.isNumber(value)) {
	          value = new Date(value);
	        }
	
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	
	        return dateParser.filter($scope.date, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function (value) {
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function () {
	      $scope.date = parseDateString(ngModel.$viewValue);
	    });
	
	    $element.on('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)($scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      $element.after($popup);
	    }
	
	    $scope.$on('$destroy', function () {
	      if ($scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          $scope.$apply(function () {
	            $scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      $element.off('keydown', inputKeydownBind);
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });
	  };
	
	  $scope.getText = function (key) {
	    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  $scope.isDisabled = function (date) {
	    if (date === 'today') {
	      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	    }
	
	    var dates = {};
	    angular.forEach(['minDate', 'maxDate'], function (key) {
	      if (!$scope.datepickerOptions[key]) {
	        dates[key] = null;
	      } else if (angular.isDate($scope.datepickerOptions[key])) {
	        dates[key] = new Date($scope.datepickerOptions[key]);
	      } else {
	        if ($datepickerPopupLiteralWarning) {
	          $log.warn('Literal date support has been deprecated, please switch to date object usage');
	        }
	
	        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
	      }
	    });
	
	    return $scope.datepickerOptions && dates.minDate && $scope.compare(date, dates.minDate) < 0 || dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
	  };
	
	  $scope.compare = function (date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	  };
	
	  // Inner change
	  $scope.dateSelection = function (dt) {
	    $scope.date = dt;
	    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    $element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.keydown = function (evt) {
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.select = function (date, evt) {
	    evt.stopPropagation();
	
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate($scope.date)) {
	        date = new Date($scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	    $scope.dateSelection(date);
	  };
	
	  $scope.close = function (evt) {
	    evt.stopPropagation();
	
	    $scope.isOpen = false;
	    $element[0].focus();
	  };
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if ($attrs.ngDisabled) {
	    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
	      $scope.disabled = disabled;
	    }));
	  }
	
	  $scope.$watch('isOpen', function (value) {
	    if (value) {
	      if (!$scope.disabled) {
	        $timeout(function () {
	          positionPopup();
	
	          if (onOpenFocus) {
	            $scope.$broadcast('uib:datepicker.focus');
	          }
	
	          $document.on('click', documentClickBind);
	
	          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	          if (appendToBody || $position.parsePlacement(placement)[2]) {
	            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	            if (scrollParentEl) {
	              scrollParentEl.on('scroll', positionPopup);
	            }
	          } else {
	            scrollParentEl = null;
	          }
	
	          angular.element($window).on('resize', positionPopup);
	        }, 0, false);
	      } else {
	        $scope.isOpen = false;
	      }
	    } else {
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function ($1) {
	      return '-' + $1.toLowerCase();
	    });
	  }
	
	  function parseDateString(viewValue) {
	    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	    if (isNaN(date)) {
	      for (var i = 0; i < altInputFormats.length; i++) {
	        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	        if (!isNaN(date)) {
	          return date;
	        }
	      }
	    }
	    return date;
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    }
	
	    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    }
	
	    if (angular.isString(viewValue)) {
	      var date = parseDateString(viewValue);
	      if (!isNaN(date)) {
	        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
	      }
	    }
	
	    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!$attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	
	    if (!value) {
	      return true;
	    }
	
	    if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    }
	
	    if (angular.isString(value)) {
	      return !isNaN(parseDateString(value));
	    }
	
	    return false;
	  }
	
	  function documentClickBind(event) {
	    if (!$scope.isOpen && $scope.disabled) {
	      return;
	    }
	
	    var popup = $popup[0];
	    var dpContainsTarget = $element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      $scope.$apply(function () {
	        $scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && $scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function () {
	        $scope.isOpen = false;
	      });
	      $element[0].focus();
	    } else if (evt.which === 40 && !$scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function () {
	        $scope.isOpen = true;
	      });
	    }
	  }
	
	  function positionPopup() {
	    if ($scope.isOpen) {
	      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	      var position = $position.positionElements($element, dpElement, placement, appendToBody);
	      dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
	      if (dpElement.hasClass('uib-position-measure')) {
	        dpElement.removeClass('uib-position-measure');
	      }
	    }
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) {
	      // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = angular.isObject(ngModelCtrl.$options) ? ngModelCtrl.$options : {
	        timezone: null
	      };
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else {
	      // in angular >=1.6 $options is always present
	      ngModelOptions = ngModelCtrl.$options;
	    }
	
	    return ngModelOptions;
	  }
	
	  $scope.$on('uib:datepicker.mode', function () {
	    $timeout(positionPopup, 0, false);
	  });
	}]).directive('uibDatepickerPopup', function () {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      datepickerOptions: '=?',
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@'
	    },
	    link: function link(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	          ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	}).directive('uibDatepickerPopupWrap', function () {
	  return {
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
	    }
	  };
	});

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position']).constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	}).service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function ($document, $rootScope, $$multiMap) {
	  var openScope = null;
	  var openedContainers = $$multiMap.createNew();
	
	  this.isOnlyOpen = function (dropdownScope, appendTo) {
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openDropdown = openedDropdowns.reduce(function (toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (openDropdown) {
	        return openedDropdowns.length === 1;
	      }
	    }
	
	    return false;
	  };
	
	  this.open = function (dropdownScope, element, appendTo) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openedScopes = openedDropdowns.map(function (dropdown) {
	        return dropdown.scope;
	      });
	      if (openedScopes.indexOf(dropdownScope) === -1) {
	        openedContainers.put(appendTo, {
	          scope: dropdownScope
	        });
	      }
	    } else {
	      openedContainers.put(appendTo, {
	        scope: dropdownScope
	      });
	    }
	  };
	
	  this.close = function (dropdownScope, element, appendTo) {
	    if (openScope === dropdownScope) {
	      $document.off('click', closeDropdown);
	      $document.off('keydown', this.keybindFilter);
	      openScope = null;
	    }
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var dropdownToClose = openedDropdowns.reduce(function (toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (dropdownToClose) {
	        openedContainers.remove(appendTo, dropdownToClose);
	      }
	    }
	  };
	
	  var closeDropdown = function closeDropdown(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope || !openScope.isOpen) {
	      return;
	    }
	
	    if (evt && openScope.getAutoClose() === 'disabled') {
	      return;
	    }
	
	    if (evt && evt.which === 3) {
	      return;
	    }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.focusToggleElement();
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  this.keybindFilter = function (evt) {
	    if (!openScope) {
	      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    var toggleElement = openScope.getToggleElement();
	    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
	    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}]).controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	      scope = $scope.$new(),
	      // create a child scope so we are not polluting original one
	  templateScope,
	      appendToOpenClass = dropdownConfig.appendToOpenClass,
	      openClass = dropdownConfig.openClass,
	      getIsOpen,
	      setIsOpen = angular.noop,
	      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	      keynavEnabled = false,
	      selectedOption = null,
	      body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function () {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function (value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	  };
	
	  this.toggle = function (open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function () {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function () {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function () {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function () {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function () {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function (keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	    angular.element(self.dropdownMenu).find('a') : $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40:
	        {
	          if (!angular.isNumber(self.selectedOption)) {
	            self.selectedOption = 0;
	          } else {
	            self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
	          }
	          break;
	        }
	      case 38:
	        {
	          if (!angular.isNumber(self.selectedOption)) {
	            self.selectedOption = elems.length - 1;
	          } else {
	            self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
	          }
	          break;
	        }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function () {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function () {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  function removeDropdownMenu() {
	    $element.append(self.dropdownMenu);
	  }
	
	  scope.$watch('isOpen', function (isOpen, wasOpen) {
	    var appendTo = null,
	        appendToBody = false;
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendToBody)) {
	      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
	      if (appendToBodyValue !== false) {
	        appendToBody = true;
	      }
	    }
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      if (isOpen) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', removeDropdownMenu);
	      } else {
	        $element.off('$destroy', removeDropdownMenu);
	        removeDropdownMenu();
	      }
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	          css,
	          rightalign,
	          scrollbarPadding,
	          scrollbarWidth = 0;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        scrollbarPadding = $position.scrollbarPadding(appendTo);
	
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          scrollbarWidth = scrollbarPadding.scrollbarWidth;
	        }
	
	        css.right = window.innerWidth - scrollbarWidth - (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth - (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
	    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
	    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);
	
	    if (hasOpenClass === !isOpen) {
	      var toggleClass;
	      if (appendTo) {
	        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
	      } else {
	        toggleClass = isOpen ? 'addClass' : 'removeClass';
	      }
	      $animate[toggleClass](openContainer, dropdownOpenClass).then(function () {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function (dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	            $document.on('keydown', uibDropdownService.keybindFilter);
	          });
	        });
	      } else {
	        $document.on('keydown', uibDropdownService.keybindFilter);
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope, $element, appendTo);
	    } else {
	      uibDropdownService.close(scope, $element, appendTo);
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	}]).directive('uibDropdown', function () {
	  return {
	    controller: 'UibDropdownController',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	}).directive('uibDropdownMenu', function () {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	}).directive('uibDropdownToggle', function () {
	  return {
	    require: '?^uibDropdown',
	    link: function link(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function toggleDropdown(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function () {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.on('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function () {
	        element.off('click', toggleDropdown);
	      });
	    }
	  };
	});

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(87);
	__webpack_require__(28);
	__webpack_require__(500);
	
	var MODULE_NAME = 'ui.bootstrap.module.dropdown';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.dropdown']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 502 */
[682, 501],
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(504);
	
	var MODULE_NAME = 'ui.bootstrap.module.isClass';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.isClass']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	'use strict';
	
	// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass', []).directive('uibIsClass', ['$animate', function ($animate) {
	  //                    11111111          22222222
	  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	  //                    11111111           22222222
	  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
	
	  var dataPerTracked = {};
	
	  return {
	    restrict: 'A',
	    compile: function compile(tElement, tAttrs) {
	      var linkedScopes = [];
	      var instances = [];
	      var expToData = {};
	      var lastActivated = null;
	      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	      var onExp = onExpMatches[2];
	      var expsStr = onExpMatches[1];
	      var exps = expsStr.split(',');
	
	      return linkFn;
	
	      function linkFn(scope, element, attrs) {
	        linkedScopes.push(scope);
	        instances.push({
	          scope: scope,
	          element: element
	        });
	
	        exps.forEach(function (exp, k) {
	          addForExp(exp, scope);
	        });
	
	        scope.$on('$destroy', removeScope);
	      }
	
	      function addForExp(exp, scope) {
	        var matches = exp.match(IS_REGEXP);
	        var clazz = scope.$eval(matches[1]);
	        var compareWithExp = matches[2];
	        var data = expToData[exp];
	        if (!data) {
	          var watchFn = function watchFn(compareWithVal) {
	            var newActivated = null;
	            instances.some(function (instance) {
	              var thisVal = instance.scope.$eval(onExp);
	              if (thisVal === compareWithVal) {
	                newActivated = instance;
	                return true;
	              }
	            });
	            if (data.lastActivated !== newActivated) {
	              if (data.lastActivated) {
	                $animate.removeClass(data.lastActivated.element, clazz);
	              }
	              if (newActivated) {
	                $animate.addClass(newActivated.element, clazz);
	              }
	              data.lastActivated = newActivated;
	            }
	          };
	          expToData[exp] = data = {
	            lastActivated: null,
	            scope: scope,
	            watchFn: watchFn,
	            compareWithExp: compareWithExp,
	            watcher: scope.$watch(compareWithExp, watchFn)
	          };
	        }
	        data.watchFn(scope.$eval(compareWithExp));
	      }
	
	      function removeScope(e) {
	        var removedScope = e.targetScope;
	        var index = linkedScopes.indexOf(removedScope);
	        linkedScopes.splice(index, 1);
	        instances.splice(index, 1);
	        if (linkedScopes.length) {
	          var newWatchScope = linkedScopes[0];
	          angular.forEach(expToData, function (data) {
	            if (data.scope === removedScope) {
	              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	              data.scope = newWatchScope;
	            }
	          });
	        } else {
	          expToData = {};
	        }
	      }
	    }
	  };
	}]);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(87);
	__webpack_require__(28);
	__webpack_require__(88);
	__webpack_require__(531);
	__webpack_require__(507);
	
	var MODULE_NAME = 'ui.bootstrap.module.modal';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.modal', 'uib/template/modal/window.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 506 */
[682, 505],
/* 507 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	.provider('$uibResolve', function () {
	  var resolve = this;
	  this.resolver = null;
	
	  this.setResolver = function (resolver) {
	    this.resolver = resolver;
	  };
	
	  this.$get = ['$injector', '$q', function ($injector, $q) {
	    var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	    return {
	      resolve: function resolve(invocables, locals, parent, self) {
	        if (resolver) {
	          return resolver.resolve(invocables, locals, parent, self);
	        }
	
	        var promises = [];
	
	        angular.forEach(invocables, function (value) {
	          if (angular.isFunction(value) || angular.isArray(value)) {
	            promises.push($q.resolve($injector.invoke(value)));
	          } else if (angular.isString(value)) {
	            promises.push($q.resolve($injector.get(value)));
	          } else {
	            promises.push($q.resolve(value));
	          }
	        });
	
	        return $q.all(promises).then(function (resolves) {
	          var resolveObj = {};
	          var resolveIter = 0;
	          angular.forEach(invocables, function (value, key) {
	            resolveObj[key] = resolves[resolveIter++];
	          });
	
	          return resolveObj;
	        });
	      }
	    };
	  }];
	})
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	.directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack', function ($animate, $injector, $modalStack) {
	  return {
	    restrict: 'A',
	    compile: function compile(tElement, tAttrs) {
	      tElement.addClass(tAttrs.backdropClass);
	      return linkFn;
	    }
	  };
	
	  function linkFn(scope, element, attrs) {
	    if (attrs.modalInClass) {
	      $animate.addClass(element, attrs.modalInClass);
	
	      scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	        var done = setIsAsync();
	        if (scope.modalOptions.animation) {
	          $animate.removeClass(element, attrs.modalInClass).then(done);
	        } else {
	          done();
	        }
	      });
	    }
	  }
	}]).directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document', function ($modalStack, $q, $animateCss, $document) {
	  return {
	    scope: {
	      index: '@'
	    },
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function templateUrl(tElement, tAttrs) {
	      return tAttrs.templateUrl || 'uib/template/modal/window.html';
	    },
	    link: function link(scope, element, attrs) {
	      element.addClass(attrs.windowTopClass || '');
	      scope.size = attrs.size;
	
	      scope.close = function (evt) {
	        var modal = $modalStack.getTop();
	        if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && evt.target === evt.currentTarget) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          $modalStack.dismiss(modal.key, 'backdrop click');
	        }
	      };
	
	      // moved from template to fix issue #2280
	      element.on('click', scope.close);
	
	      // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	      // We can detect that by using this property in the template associated with this directive and then use
	      // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	      scope.$isRendered = true;
	
	      // Deferred object that will be resolved when this modal is rendered.
	      var modalRenderDeferObj = $q.defer();
	      // Resolve render promise post-digest
	      scope.$$postDigest(function () {
	        modalRenderDeferObj.resolve();
	      });
	
	      modalRenderDeferObj.promise.then(function () {
	        var animationPromise = null;
	
	        if (attrs.modalInClass) {
	          animationPromise = $animateCss(element, {
	            addClass: attrs.modalInClass
	          }).start();
	
	          scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
	            var done = setIsAsync();
	            $animateCss(element, {
	              removeClass: attrs.modalInClass
	            }).start().then(done);
	          });
	        }
	
	        $q.when(animationPromise).then(function () {
	          // Notify {@link $modalStack} that modal is rendered.
	          var modal = $modalStack.getTop();
	          if (modal) {
	            $modalStack.modalRendered(modal.key);
	          }
	
	          /**
	           * If something within the freshly-opened modal already has focus (perhaps via a
	           * directive that causes focus) then there's no need to try to focus anything.
	           */
	          if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	            var inputWithAutofocus = element[0].querySelector('[autofocus]');
	            /**
	             * Auto-focusing of a freshly-opened modal element causes any child elements
	             * with the autofocus attribute to lose focus. This is an issue on touch
	             * based devices which will show and then hide the onscreen keyboard.
	             * Attempts to refocus the autofocus element via JavaScript will not reopen
	             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	             * the modal element if the modal does not contain an autofocus element.
	             */
	            if (inputWithAutofocus) {
	              inputWithAutofocus.focus();
	            } else {
	              element[0].focus();
	            }
	          }
	        });
	      });
	    }
	  };
	}]).directive('uibModalAnimationClass', function () {
	  return {
	    compile: function compile(tElement, tAttrs) {
	      if (tAttrs.modalAnimation) {
	        tElement.addClass(tAttrs.uibModalAnimationClass);
	      }
	    }
	  };
	}).directive('uibModalTransclude', ['$animate', function ($animate) {
	  return {
	    link: function link(scope, element, attrs, controller, transclude) {
	      transclude(scope.$parent, function (clone) {
	        element.empty();
	        $animate.enter(clone, element);
	      });
	    }
	  };
	}]).factory('$uibModalStack', ['$animate', '$animateCss', '$document', '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition', function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	  var OPENED_MODAL_CLASS = 'modal-open';
	
	  var backdropDomEl, backdropScope;
	  var openedWindows = $$stackedMap.createNew();
	  var openedClasses = $$multiMap.createNew();
	  var $modalStack = {
	    NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	  };
	  var topModalIndex = 0;
	  var previousTopOpenedModal = null;
	  var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	  //Modal focus behavior
	  var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' + 'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' + 'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	  var scrollbarPadding;
	  var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	  // TODO: extract into common dependency with tooltip
	  function snake_case(name) {
	    var separator = '-';
	    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  function isVisible(element) {
	    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
	  }
	
	  function backdropIndex() {
	    var topBackdropIndex = -1;
	    var opened = openedWindows.keys();
	    for (var i = 0; i < opened.length; i++) {
	      if (openedWindows.get(opened[i]).value.backdrop) {
	        topBackdropIndex = i;
	      }
	    }
	
	    // If any backdrop exist, ensure that it's index is always
	    // right below the top modal
	    if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	      topBackdropIndex = topModalIndex;
	    }
	    return topBackdropIndex;
	  }
	
	  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
	    if (backdropScope) {
	      backdropScope.index = newBackdropIndex;
	    }
	  });
	
	  function removeModalWindow(modalInstance, elementToReceiveFocus) {
	    var modalWindow = openedWindows.get(modalInstance).value;
	    var appendToElement = modalWindow.appendTo;
	
	    //clean up the stack
	    openedWindows.remove(modalInstance);
	    previousTopOpenedModal = openedWindows.top();
	    if (previousTopOpenedModal) {
	      topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	    }
	
	    removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
	      var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	      openedClasses.remove(modalBodyClass, modalInstance);
	      var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	      appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	      if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	        if (scrollbarPadding.originalRight) {
	          appendToElement.css({ paddingRight: scrollbarPadding.originalRight + 'px' });
	        } else {
	          appendToElement.css({ paddingRight: '' });
	        }
	        scrollbarPadding = null;
	      }
	      toggleTopWindowClass(true);
	    }, modalWindow.closedDeferred);
	    checkRemoveBackdrop();
	
	    //move focus to specified element if available, or else to body
	    if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	      elementToReceiveFocus.focus();
	    } else if (appendToElement.focus) {
	      appendToElement.focus();
	    }
	  }
	
	  // Add or remove "windowTopClass" from the top window in the stack
	  function toggleTopWindowClass(toggleSwitch) {
	    var modalWindow;
	
	    if (openedWindows.length() > 0) {
	      modalWindow = openedWindows.top().value;
	      modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	    }
	  }
	
	  function checkRemoveBackdrop() {
	    //remove backdrop if no longer needed
	    if (backdropDomEl && backdropIndex() === -1) {
	      var backdropScopeRef = backdropScope;
	      removeAfterAnimate(backdropDomEl, backdropScope, function () {
	        backdropScopeRef = null;
	      });
	      backdropDomEl = undefined;
	      backdropScope = undefined;
	    }
	  }
	
	  function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	    var asyncDeferred;
	    var asyncPromise = null;
	    var setIsAsync = function setIsAsync() {
	      if (!asyncDeferred) {
	        asyncDeferred = $q.defer();
	        asyncPromise = asyncDeferred.promise;
	      }
	
	      return function asyncDone() {
	        asyncDeferred.resolve();
	      };
	    };
	    scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	    // Note that it's intentional that asyncPromise might be null.
	    // That's when setIsAsync has not been called during the
	    // NOW_CLOSING_EVENT broadcast.
	    return $q.when(asyncPromise).then(afterAnimating);
	
	    function afterAnimating() {
	      if (afterAnimating.done) {
	        return;
	      }
	      afterAnimating.done = true;
	
	      $animate.leave(domEl).then(function () {
	        if (done) {
	          done();
	        }
	
	        domEl.remove();
	        if (closedDeferred) {
	          closedDeferred.resolve();
	        }
	      });
	
	      scope.$destroy();
	    }
	  }
	
	  $document.on('keydown', keydownListener);
	
	  $rootScope.$on('$destroy', function () {
	    $document.off('keydown', keydownListener);
	  });
	
	  function keydownListener(evt) {
	    if (evt.isDefaultPrevented()) {
	      return evt;
	    }
	
	    var modal = openedWindows.top();
	    if (modal) {
	      switch (evt.which) {
	        case 27:
	          {
	            if (modal.value.keyboard) {
	              evt.preventDefault();
	              $rootScope.$apply(function () {
	                $modalStack.dismiss(modal.key, 'escape key press');
	              });
	            }
	            break;
	          }
	        case 9:
	          {
	            var list = $modalStack.loadFocusElementList(modal);
	            var focusChanged = false;
	            if (evt.shiftKey) {
	              if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                focusChanged = $modalStack.focusLastFocusableElement(list);
	              }
	            } else {
	              if ($modalStack.isFocusInLastItem(evt, list)) {
	                focusChanged = $modalStack.focusFirstFocusableElement(list);
	              }
	            }
	
	            if (focusChanged) {
	              evt.preventDefault();
	              evt.stopPropagation();
	            }
	
	            break;
	          }
	      }
	    }
	  }
	
	  $modalStack.open = function (modalInstance, modal) {
	    var modalOpener = $document[0].activeElement,
	        modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	    toggleTopWindowClass(false);
	
	    // Store the current top first, to determine what index we ought to use
	    // for the current top modal
	    previousTopOpenedModal = openedWindows.top();
	
	    openedWindows.add(modalInstance, {
	      deferred: modal.deferred,
	      renderDeferred: modal.renderDeferred,
	      closedDeferred: modal.closedDeferred,
	      modalScope: modal.scope,
	      backdrop: modal.backdrop,
	      keyboard: modal.keyboard,
	      openedClass: modal.openedClass,
	      windowTopClass: modal.windowTopClass,
	      animation: modal.animation,
	      appendTo: modal.appendTo
	    });
	
	    openedClasses.put(modalBodyClass, modalInstance);
	
	    var appendToElement = modal.appendTo,
	        currBackdropIndex = backdropIndex();
	
	    if (currBackdropIndex >= 0 && !backdropDomEl) {
	      backdropScope = $rootScope.$new(true);
	      backdropScope.modalOptions = modal;
	      backdropScope.index = currBackdropIndex;
	      backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	      backdropDomEl.attr({
	        'class': 'modal-backdrop',
	        'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	        'uib-modal-animation-class': 'fade',
	        'modal-in-class': 'in'
	      });
	      if (modal.backdropClass) {
	        backdropDomEl.addClass(modal.backdropClass);
	      }
	
	      if (modal.animation) {
	        backdropDomEl.attr('modal-animation', 'true');
	      }
	      $compile(backdropDomEl)(backdropScope);
	      $animate.enter(backdropDomEl, appendToElement);
	      if ($uibPosition.isScrollable(appendToElement)) {
	        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          appendToElement.css({ paddingRight: scrollbarPadding.right + 'px' });
	        }
	      }
	    }
	
	    var content;
	    if (modal.component) {
	      content = document.createElement(snake_case(modal.component.name));
	      content = angular.element(content);
	      content.attr({
	        resolve: '$resolve',
	        'modal-instance': '$uibModalInstance',
	        close: '$close($value)',
	        dismiss: '$dismiss($value)'
	      });
	    } else {
	      content = modal.content;
	    }
	
	    // Set the top modal index based on the index of the previous top modal
	    topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	    var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	    angularDomEl.attr({
	      'class': 'modal',
	      'template-url': modal.windowTemplateUrl,
	      'window-top-class': modal.windowTopClass,
	      'role': 'dialog',
	      'aria-labelledby': modal.ariaLabelledBy,
	      'aria-describedby': modal.ariaDescribedBy,
	      'size': modal.size,
	      'index': topModalIndex,
	      'animate': 'animate',
	      'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	      'tabindex': -1,
	      'uib-modal-animation-class': 'fade',
	      'modal-in-class': 'in'
	    }).append(content);
	    if (modal.windowClass) {
	      angularDomEl.addClass(modal.windowClass);
	    }
	
	    if (modal.animation) {
	      angularDomEl.attr('modal-animation', 'true');
	    }
	
	    appendToElement.addClass(modalBodyClass);
	    if (modal.scope) {
	      // we need to explicitly add the modal index to the modal scope
	      // because it is needed by ngStyle to compute the zIndex property.
	      modal.scope.$$topModalIndex = topModalIndex;
	    }
	    $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	    openedWindows.top().value.modalDomEl = angularDomEl;
	    openedWindows.top().value.modalOpener = modalOpener;
	
	    applyAriaHidden(angularDomEl);
	
	    function applyAriaHidden(el) {
	      if (!el || el[0].tagName === 'BODY') {
	        return;
	      }
	
	      getSiblings(el).forEach(function (sibling) {
	        var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	            ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	        if (!ariaHiddenCount) {
	          ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	        }
	
	        sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	        sibling.setAttribute('aria-hidden', 'true');
	      });
	
	      return applyAriaHidden(el.parent());
	
	      function getSiblings(el) {
	        var children = el.parent() ? el.parent().children() : [];
	
	        return Array.prototype.filter.call(children, function (child) {
	          return child !== el[0];
	        });
	      }
	    }
	  };
	
	  function broadcastClosing(modalWindow, resultOrReason, closing) {
	    return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	  }
	
	  function unhideBackgroundElements() {
	    Array.prototype.forEach.call(document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'), function (hiddenEl) {
	      var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	          newHiddenCount = ariaHiddenCount - 1;
	      hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	      if (!newHiddenCount) {
	        hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	        hiddenEl.removeAttribute('aria-hidden');
	      }
	    });
	  }
	
	  $modalStack.close = function (modalInstance, result) {
	    var modalWindow = openedWindows.get(modalInstance);
	    unhideBackgroundElements();
	    if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	      modalWindow.value.deferred.resolve(result);
	      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	      return true;
	    }
	
	    return !modalWindow;
	  };
	
	  $modalStack.dismiss = function (modalInstance, reason) {
	    var modalWindow = openedWindows.get(modalInstance);
	    unhideBackgroundElements();
	    if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	      modalWindow.value.deferred.reject(reason);
	      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	      return true;
	    }
	    return !modalWindow;
	  };
	
	  $modalStack.dismissAll = function (reason) {
	    var topModal = this.getTop();
	    while (topModal && this.dismiss(topModal.key, reason)) {
	      topModal = this.getTop();
	    }
	  };
	
	  $modalStack.getTop = function () {
	    return openedWindows.top();
	  };
	
	  $modalStack.modalRendered = function (modalInstance) {
	    var modalWindow = openedWindows.get(modalInstance);
	    if (modalWindow) {
	      modalWindow.value.renderDeferred.resolve();
	    }
	  };
	
	  $modalStack.focusFirstFocusableElement = function (list) {
	    if (list.length > 0) {
	      list[0].focus();
	      return true;
	    }
	    return false;
	  };
	
	  $modalStack.focusLastFocusableElement = function (list) {
	    if (list.length > 0) {
	      list[list.length - 1].focus();
	      return true;
	    }
	    return false;
	  };
	
	  $modalStack.isModalFocused = function (evt, modalWindow) {
	    if (evt && modalWindow) {
	      var modalDomEl = modalWindow.value.modalDomEl;
	      if (modalDomEl && modalDomEl.length) {
	        return (evt.target || evt.srcElement) === modalDomEl[0];
	      }
	    }
	    return false;
	  };
	
	  $modalStack.isFocusInFirstItem = function (evt, list) {
	    if (list.length > 0) {
	      return (evt.target || evt.srcElement) === list[0];
	    }
	    return false;
	  };
	
	  $modalStack.isFocusInLastItem = function (evt, list) {
	    if (list.length > 0) {
	      return (evt.target || evt.srcElement) === list[list.length - 1];
	    }
	    return false;
	  };
	
	  $modalStack.loadFocusElementList = function (modalWindow) {
	    if (modalWindow) {
	      var modalDomE1 = modalWindow.value.modalDomEl;
	      if (modalDomE1 && modalDomE1.length) {
	        var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	        return elements ? Array.prototype.filter.call(elements, function (element) {
	          return isVisible(element);
	        }) : elements;
	      }
	    }
	  };
	
	  return $modalStack;
	}]).provider('$uibModal', function () {
	  var $modalProvider = {
	    options: {
	      animation: true,
	      backdrop: true, //can also be false or 'static'
	      keyboard: true
	    },
	    $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack', function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	      var $modal = {};
	
	      function getTemplatePromise(options) {
	        return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);
	      }
	
	      var promiseChain = null;
	      $modal.getPromiseChain = function () {
	        return promiseChain;
	      };
	
	      $modal.open = function (modalOptions) {
	        var modalResultDeferred = $q.defer();
	        var modalOpenedDeferred = $q.defer();
	        var modalClosedDeferred = $q.defer();
	        var modalRenderDeferred = $q.defer();
	
	        //prepare an instance of a modal to be injected into controllers and returned to a caller
	        var modalInstance = {
	          result: modalResultDeferred.promise,
	          opened: modalOpenedDeferred.promise,
	          closed: modalClosedDeferred.promise,
	          rendered: modalRenderDeferred.promise,
	          close: function close(result) {
	            return $modalStack.close(modalInstance, result);
	          },
	          dismiss: function dismiss(reason) {
	            return $modalStack.dismiss(modalInstance, reason);
	          }
	        };
	
	        //merge and clean up options
	        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	        modalOptions.resolve = modalOptions.resolve || {};
	        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	        if (!modalOptions.appendTo.length) {
	          throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	        }
	
	        //verify options
	        if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	          throw new Error('One of component or template or templateUrl options is required.');
	        }
	
	        var templateAndResolvePromise;
	        if (modalOptions.component) {
	          templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	        } else {
	          templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	        }
	
	        function resolveWithTemplate() {
	          return templateAndResolvePromise;
	        }
	
	        // Wait for the resolution of the existing promise chain.
	        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	        // Then add to $modalStack and resolve opened.
	        // Finally clean up the chain variable if no subsequent modal has overwritten it.
	        var samePromise;
	        samePromise = promiseChain = $q.all([promiseChain]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {
	          var providedScope = modalOptions.scope || $rootScope;
	
	          var modalScope = providedScope.$new();
	          modalScope.$close = modalInstance.close;
	          modalScope.$dismiss = modalInstance.dismiss;
	
	          modalScope.$on('$destroy', function () {
	            if (!modalScope.$$uibDestructionScheduled) {
	              modalScope.$dismiss('$uibUnscheduledDestruction');
	            }
	          });
	
	          var modal = {
	            scope: modalScope,
	            deferred: modalResultDeferred,
	            renderDeferred: modalRenderDeferred,
	            closedDeferred: modalClosedDeferred,
	            animation: modalOptions.animation,
	            backdrop: modalOptions.backdrop,
	            keyboard: modalOptions.keyboard,
	            backdropClass: modalOptions.backdropClass,
	            windowTopClass: modalOptions.windowTopClass,
	            windowClass: modalOptions.windowClass,
	            windowTemplateUrl: modalOptions.windowTemplateUrl,
	            ariaLabelledBy: modalOptions.ariaLabelledBy,
	            ariaDescribedBy: modalOptions.ariaDescribedBy,
	            size: modalOptions.size,
	            openedClass: modalOptions.openedClass,
	            appendTo: modalOptions.appendTo
	          };
	
	          var component = {};
	          var ctrlInstance,
	              ctrlInstantiate,
	              ctrlLocals = {};
	
	          if (modalOptions.component) {
	            constructLocals(component, false, true, false);
	            component.name = modalOptions.component;
	            modal.component = component;
	          } else if (modalOptions.controller) {
	            constructLocals(ctrlLocals, true, false, true);
	
	            // the third param will make the controller instantiate later,private api
	            // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	            ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	            if (modalOptions.controllerAs && modalOptions.bindToController) {
	              ctrlInstance = ctrlInstantiate.instance;
	              ctrlInstance.$close = modalScope.$close;
	              ctrlInstance.$dismiss = modalScope.$dismiss;
	              angular.extend(ctrlInstance, {
	                $resolve: ctrlLocals.$scope.$resolve
	              }, providedScope);
	            }
	
	            ctrlInstance = ctrlInstantiate();
	
	            if (angular.isFunction(ctrlInstance.$onInit)) {
	              ctrlInstance.$onInit();
	            }
	          }
	
	          if (!modalOptions.component) {
	            modal.content = tplAndVars[0];
	          }
	
	          $modalStack.open(modalInstance, modal);
	          modalOpenedDeferred.resolve(true);
	
	          function constructLocals(obj, template, instanceOnScope, injectable) {
	            obj.$scope = modalScope;
	            obj.$scope.$resolve = {};
	            if (instanceOnScope) {
	              obj.$scope.$uibModalInstance = modalInstance;
	            } else {
	              obj.$uibModalInstance = modalInstance;
	            }
	
	            var resolves = template ? tplAndVars[1] : tplAndVars;
	            angular.forEach(resolves, function (value, key) {
	              if (injectable) {
	                obj[key] = value;
	              }
	
	              obj.$scope.$resolve[key] = value;
	            });
	          }
	        }, function resolveError(reason) {
	          modalOpenedDeferred.reject(reason);
	          modalResultDeferred.reject(reason);
	        })['finally'](function () {
	          if (promiseChain === samePromise) {
	            promiseChain = null;
	          }
	        });
	
	        return modalInstance;
	      };
	
	      return $modal;
	    }]
	  };
	
	  return $modalProvider;
	});

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	.factory('$$multiMap', function () {
	  return {
	    createNew: function createNew() {
	      var map = {};
	
	      return {
	        entries: function entries() {
	          return Object.keys(map).map(function (key) {
	            return {
	              key: key,
	              value: map[key]
	            };
	          });
	        },
	        get: function get(key) {
	          return map[key];
	        },
	        hasKey: function hasKey(key) {
	          return !!map[key];
	        },
	        keys: function keys() {
	          return Object.keys(map);
	        },
	        put: function put(key, value) {
	          if (!map[key]) {
	            map[key] = [];
	          }
	
	          map[key].push(value);
	        },
	        remove: function remove(key, value) {
	          var values = map[key];
	
	          if (!values) {
	            return;
	          }
	
	          var idx = values.indexOf(value);
	
	          if (idx !== -1) {
	            values.splice(idx, 1);
	          }
	
	          if (!values.length) {
	            delete map[key];
	          }
	        }
	      };
	    }
	  };
	});

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(89);
	__webpack_require__(534);
	__webpack_require__(532);
	__webpack_require__(533);
	__webpack_require__(511);
	
	var MODULE_NAME = 'ui.bootstrap.module.popover';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.popover', 'uib/template/popover/popover.html', 'uib/template/popover/popover-html.html', 'uib/template/popover/popover-template.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(81);
	module.exports = __webpack_require__(509);

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip']).directive('uibPopoverTemplatePopup', function () {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/popover/popover-template.html'
	  };
	}).directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}]).directive('uibPopoverHtmlPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', uibTitle: '@' },
	    templateUrl: 'uib/template/popover/popover-html.html'
	  };
	}).directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}]).directive('uibPopoverPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', content: '@' },
	    templateUrl: 'uib/template/popover/popover.html'
	  };
	}).directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	.factory('$uibPosition', ['$document', '$window', function ($document, $window) {
	  /**
	   * Used by scrollbarWidth() function to cache scrollbar's width.
	   * Do not access this variable directly, use scrollbarWidth() instead.
	   */
	  var SCROLLBAR_WIDTH;
	  /**
	   * scrollbar on body and html element in IE and Edge overlay
	   * content and should be considered 0 width.
	   */
	  var BODY_SCROLLBAR_WIDTH;
	  var OVERFLOW_REGEX = {
	    normal: /(auto|scroll)/,
	    hidden: /(auto|scroll|hidden)/
	  };
	  var PLACEMENT_REGEX = {
	    auto: /\s?auto?\s?/i,
	    primary: /^(top|bottom|left|right)$/,
	    secondary: /^(top|bottom|left|right|center)$/,
	    vertical: /^(top|bottom)$/
	  };
	  var BODY_REGEX = /(HTML|BODY)/;
	
	  return {
	
	    /**
	     * Provides a raw DOM element from a jQuery/jQLite element.
	     *
	     * @param {element} elem - The element to convert.
	     *
	     * @returns {element} A HTML element.
	     */
	    getRawNode: function getRawNode(elem) {
	      return elem.nodeName ? elem : elem[0] || elem;
	    },
	
	    /**
	     * Provides a parsed number for a style property.  Strips
	     * units and casts invalid numbers to 0.
	     *
	     * @param {string} value - The style value to parse.
	     *
	     * @returns {number} A valid number.
	     */
	    parseStyle: function parseStyle(value) {
	      value = parseFloat(value);
	      return isFinite(value) ? value : 0;
	    },
	
	    /**
	     * Provides the closest positioned ancestor.
	     *
	     * @param {element} element - The element to get the offest parent for.
	     *
	     * @returns {element} The closest positioned ancestor.
	     */
	    offsetParent: function offsetParent(elem) {
	      elem = this.getRawNode(elem);
	
	      var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	      function isStaticPositioned(el) {
	        return ($window.getComputedStyle(el).position || 'static') === 'static';
	      }
	
	      while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	        offsetParent = offsetParent.offsetParent;
	      }
	
	      return offsetParent || $document[0].documentElement;
	    },
	
	    /**
	     * Provides the scrollbar width, concept from TWBS measureScrollbar()
	     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	     * In IE and Edge, scollbar on body and html element overlay and should
	     * return a width of 0.
	     *
	     * @returns {number} The width of the browser scollbar.
	     */
	    scrollbarWidth: function scrollbarWidth(isBody) {
	      if (isBody) {
	        if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	          var bodyElem = $document.find('body');
	          bodyElem.addClass('uib-position-body-scrollbar-measure');
	          BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	          BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	          bodyElem.removeClass('uib-position-body-scrollbar-measure');
	        }
	        return BODY_SCROLLBAR_WIDTH;
	      }
	
	      if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	        var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	        $document.find('body').append(scrollElem);
	        SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	        SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	        scrollElem.remove();
	      }
	
	      return SCROLLBAR_WIDTH;
	    },
	
	    /**
	     * Provides the padding required on an element to replace the scrollbar.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	     *     <li>**widthOverflow**: whether the the width is overflowing</li>
	     *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	     *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	     *     <li>**heightOverflow**: whether the the height is overflowing</li>
	     *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	     *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	     *   </ul>
	     */
	    scrollbarPadding: function scrollbarPadding(elem) {
	      elem = this.getRawNode(elem);
	
	      var elemStyle = $window.getComputedStyle(elem);
	      var paddingRight = this.parseStyle(elemStyle.paddingRight);
	      var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	      var scrollParent = this.scrollParent(elem, false, true);
	      var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	      return {
	        scrollbarWidth: scrollbarWidth,
	        widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	        right: paddingRight + scrollbarWidth,
	        originalRight: paddingRight,
	        heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	        bottom: paddingBottom + scrollbarWidth,
	        originalBottom: paddingBottom
	      };
	    },
	
	    /**
	     * Checks to see if the element is scrollable.
	     *
	     * @param {element} elem - The element to check.
	     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	     *   default is false.
	     *
	     * @returns {boolean} Whether the element is scrollable.
	     */
	    isScrollable: function isScrollable(elem, includeHidden) {
	      elem = this.getRawNode(elem);
	
	      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	      var elemStyle = $window.getComputedStyle(elem);
	      return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	    },
	
	    /**
	     * Provides the closest scrollable ancestor.
	     * A port of the jQuery UI scrollParent method:
	     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	     *
	     * @param {element} elem - The element to find the scroll parent of.
	     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	     *   default is false.
	     * @param {boolean=} [includeSelf=false] - Should the element being passed be
	     * included in the scrollable llokup.
	     *
	     * @returns {element} A HTML element.
	     */
	    scrollParent: function scrollParent(elem, includeHidden, includeSelf) {
	      elem = this.getRawNode(elem);
	
	      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	      var documentEl = $document[0].documentElement;
	      var elemStyle = $window.getComputedStyle(elem);
	      if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	        return elem;
	      }
	      var excludeStatic = elemStyle.position === 'absolute';
	      var scrollParent = elem.parentElement || documentEl;
	
	      if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	        return documentEl;
	      }
	
	      while (scrollParent.parentElement && scrollParent !== documentEl) {
	        var spStyle = $window.getComputedStyle(scrollParent);
	        if (excludeStatic && spStyle.position !== 'static') {
	          excludeStatic = false;
	        }
	
	        if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	          break;
	        }
	        scrollParent = scrollParent.parentElement;
	      }
	
	      return scrollParent;
	    },
	
	    /**
	     * Provides read-only equivalent of jQuery's position function:
	     * http://api.jquery.com/position/ - distance to closest positioned
	     * ancestor.  Does not account for margins by default like jQuery position.
	     *
	     * @param {element} elem - The element to caclulate the position on.
	     * @param {boolean=} [includeMargins=false] - Should margins be accounted
	     * for, default is false.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**width**: the width of the element</li>
	     *     <li>**height**: the height of the element</li>
	     *     <li>**top**: distance to top edge of offset parent</li>
	     *     <li>**left**: distance to left edge of offset parent</li>
	     *   </ul>
	     */
	    position: function position(elem, includeMagins) {
	      elem = this.getRawNode(elem);
	
	      var elemOffset = this.offset(elem);
	      if (includeMagins) {
	        var elemStyle = $window.getComputedStyle(elem);
	        elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	        elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	      }
	      var parent = this.offsetParent(elem);
	      var parentOffset = { top: 0, left: 0 };
	
	      if (parent !== $document[0].documentElement) {
	        parentOffset = this.offset(parent);
	        parentOffset.top += parent.clientTop - parent.scrollTop;
	        parentOffset.left += parent.clientLeft - parent.scrollLeft;
	      }
	
	      return {
	        width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	        height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	        top: Math.round(elemOffset.top - parentOffset.top),
	        left: Math.round(elemOffset.left - parentOffset.left)
	      };
	    },
	
	    /**
	     * Provides read-only equivalent of jQuery's offset function:
	     * http://api.jquery.com/offset/ - distance to viewport.  Does
	     * not account for borders, margins, or padding on the body
	     * element.
	     *
	     * @param {element} elem - The element to calculate the offset on.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**width**: the width of the element</li>
	     *     <li>**height**: the height of the element</li>
	     *     <li>**top**: distance to top edge of viewport</li>
	     *     <li>**right**: distance to bottom edge of viewport</li>
	     *   </ul>
	     */
	    offset: function offset(elem) {
	      elem = this.getRawNode(elem);
	
	      var elemBCR = elem.getBoundingClientRect();
	      return {
	        width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	        height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	        top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	        left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	      };
	    },
	
	    /**
	     * Provides offset distance to the closest scrollable ancestor
	     * or viewport.  Accounts for border and scrollbar width.
	     *
	     * Right and bottom dimensions represent the distance to the
	     * respective edge of the viewport element.  If the element
	     * edge extends beyond the viewport, a negative value will be
	     * reported.
	     *
	     * @param {element} elem - The element to get the viewport offset for.
	     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	     * of the first scrollable element, default is false.
	     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	     * be accounted for, default is true.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**top**: distance to the top content edge of viewport element</li>
	     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	     *     <li>**left**: distance to the left content edge of viewport element</li>
	     *     <li>**right**: distance to the right content edge of viewport element</li>
	     *   </ul>
	     */
	    viewportOffset: function viewportOffset(elem, useDocument, includePadding) {
	      elem = this.getRawNode(elem);
	      includePadding = includePadding !== false ? true : false;
	
	      var elemBCR = elem.getBoundingClientRect();
	      var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };
	
	      var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	      var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	      offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	      offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	      if (offsetParent === $document[0].documentElement) {
	        offsetBCR.top += $window.pageYOffset;
	        offsetBCR.left += $window.pageXOffset;
	      }
	      offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	      offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	      if (includePadding) {
	        var offsetParentStyle = $window.getComputedStyle(offsetParent);
	        offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	        offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	        offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	        offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	      }
	
	      return {
	        top: Math.round(elemBCR.top - offsetBCR.top),
	        bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	        left: Math.round(elemBCR.left - offsetBCR.left),
	        right: Math.round(offsetBCR.right - elemBCR.right)
	      };
	    },
	
	    /**
	     * Provides an array of placement values parsed from a placement string.
	     * Along with the 'auto' indicator, supported placement strings are:
	     *   <ul>
	     *     <li>top: element on top, horizontally centered on host element.</li>
	     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	     *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	     *     <li>left: element on left, vertically centered on host element.</li>
	     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	     *     <li>right: element on right, vertically centered on host element.</li>
	     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	     *   </ul>
	     * A placement string with an 'auto' indicator is expected to be
	     * space separated from the placement, i.e: 'auto bottom-left'  If
	     * the primary and secondary placement values do not match 'top,
	     * bottom, left, right' then 'top' will be the primary placement and
	     * 'center' will be the secondary placement.  If 'auto' is passed, true
	     * will be returned as the 3rd value of the array.
	     *
	     * @param {string} placement - The placement string to parse.
	     *
	     * @returns {array} An array with the following values
	     * <ul>
	     *   <li>**[0]**: The primary placement.</li>
	     *   <li>**[1]**: The secondary placement.</li>
	     *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	     * </ul>
	     */
	    parsePlacement: function parsePlacement(placement) {
	      var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	      if (autoPlace) {
	        placement = placement.replace(PLACEMENT_REGEX.auto, '');
	      }
	
	      placement = placement.split('-');
	
	      placement[0] = placement[0] || 'top';
	      if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	        placement[0] = 'top';
	      }
	
	      placement[1] = placement[1] || 'center';
	      if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	        placement[1] = 'center';
	      }
	
	      if (autoPlace) {
	        placement[2] = true;
	      } else {
	        placement[2] = false;
	      }
	
	      return placement;
	    },
	
	    /**
	     * Provides coordinates for an element to be positioned relative to
	     * another element.  Passing 'auto' as part of the placement parameter
	     * will enable smart placement - where the element fits. i.e:
	     * 'auto left-top' will check to see if there is enough space to the left
	     * of the hostElem to fit the targetElem, if not place right (same for secondary
	     * top placement).  Available space is calculated using the viewportOffset
	     * function.
	     *
	     * @param {element} hostElem - The element to position against.
	     * @param {element} targetElem - The element to position.
	     * @param {string=} [placement=top] - The placement for the targetElem,
	     *   default is 'top'. 'center' is assumed as secondary placement for
	     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	     *   <ul>
	     *     <li>top</li>
	     *     <li>top-right</li>
	     *     <li>top-left</li>
	     *     <li>bottom</li>
	     *     <li>bottom-left</li>
	     *     <li>bottom-right</li>
	     *     <li>left</li>
	     *     <li>left-top</li>
	     *     <li>left-bottom</li>
	     *     <li>right</li>
	     *     <li>right-top</li>
	     *     <li>right-bottom</li>
	     *   </ul>
	     * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	     *   be calculated from the body element, default is false.
	     *
	     * @returns {object} An object with the following properties:
	     *   <ul>
	     *     <li>**top**: Value for targetElem top.</li>
	     *     <li>**left**: Value for targetElem left.</li>
	     *     <li>**placement**: The resolved placement.</li>
	     *   </ul>
	     */
	    positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {
	      hostElem = this.getRawNode(hostElem);
	      targetElem = this.getRawNode(targetElem);
	
	      // need to read from prop to support tests.
	      var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	      var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	      placement = this.parsePlacement(placement);
	
	      var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	      var targetElemPos = { top: 0, left: 0, placement: '' };
	
	      if (placement[2]) {
	        var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	        var targetElemStyle = $window.getComputedStyle(targetElem);
	        var adjustedSize = {
	          width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	          height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	        };
	
	        placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' : placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' : placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' : placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' : placement[0];
	
	        placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' : placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' : placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' : placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' : placement[1];
	
	        if (placement[1] === 'center') {
	          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	              placement[1] = 'left';
	            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	              placement[1] = 'right';
	            }
	          } else {
	            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	              placement[1] = 'top';
	            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	              placement[1] = 'bottom';
	            }
	          }
	        }
	      }
	
	      switch (placement[0]) {
	        case 'top':
	          targetElemPos.top = hostElemPos.top - targetHeight;
	          break;
	        case 'bottom':
	          targetElemPos.top = hostElemPos.top + hostElemPos.height;
	          break;
	        case 'left':
	          targetElemPos.left = hostElemPos.left - targetWidth;
	          break;
	        case 'right':
	          targetElemPos.left = hostElemPos.left + hostElemPos.width;
	          break;
	      }
	
	      switch (placement[1]) {
	        case 'top':
	          targetElemPos.top = hostElemPos.top;
	          break;
	        case 'bottom':
	          targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	          break;
	        case 'left':
	          targetElemPos.left = hostElemPos.left;
	          break;
	        case 'right':
	          targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	          break;
	        case 'center':
	          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	          } else {
	            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	          }
	          break;
	      }
	
	      targetElemPos.top = Math.round(targetElemPos.top);
	      targetElemPos.left = Math.round(targetElemPos.left);
	      targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	      return targetElemPos;
	    },
	
	    /**
	     * Provides a way to adjust the top positioning after first
	     * render to correctly align element to top after content
	     * rendering causes resized element height
	     *
	     * @param {array} placementClasses - The array of strings of classes
	     * element should have.
	     * @param {object} containerPosition - The object with container
	     * position information
	     * @param {number} initialHeight - The initial height for the elem.
	     * @param {number} currentHeight - The current height for the elem.
	     */
	    adjustTop: function adjustTop(placementClasses, containerPosition, initialHeight, currentHeight) {
	      if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	        return {
	          top: containerPosition.top - currentHeight + 'px'
	        };
	      }
	    },
	
	    /**
	     * Provides a way for positioning tooltip & dropdown
	     * arrows when using placement options beyond the standard
	     * left, right, top, or bottom.
	     *
	     * @param {element} elem - The tooltip/dropdown element.
	     * @param {string} placement - The placement for the elem.
	     */
	    positionArrow: function positionArrow(elem, placement) {
	      elem = this.getRawNode(elem);
	
	      var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	      if (!innerElem) {
	        return;
	      }
	
	      var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	      var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	      if (!arrowElem) {
	        return;
	      }
	
	      var arrowCss = {
	        top: '',
	        bottom: '',
	        left: '',
	        right: ''
	      };
	
	      placement = this.parsePlacement(placement);
	      if (placement[1] === 'center') {
	        // no adjustment necessary - just reset styles
	        angular.element(arrowElem).css(arrowCss);
	        return;
	      }
	
	      var borderProp = 'border-' + placement[0] + '-width';
	      var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	      var borderRadiusProp = 'border-';
	      if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	        borderRadiusProp += placement[0] + '-' + placement[1];
	      } else {
	        borderRadiusProp += placement[1] + '-' + placement[0];
	      }
	      borderRadiusProp += '-radius';
	      var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	      switch (placement[0]) {
	        case 'top':
	          arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'bottom':
	          arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'left':
	          arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	          break;
	        case 'right':
	          arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	          break;
	      }
	
	      arrowCss[placement[1]] = borderRadius;
	
	      angular.element(arrowElem).css(arrowCss);
	    }
	  };
	}]);

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	.factory('$$stackedMap', function () {
	  return {
	    createNew: function createNew() {
	      var stack = [];
	
	      return {
	        add: function add(key, value) {
	          stack.push({
	            key: key,
	            value: value
	          });
	        },
	        get: function get(key) {
	          for (var i = 0; i < stack.length; i++) {
	            if (key === stack[i].key) {
	              return stack[i];
	            }
	          }
	        },
	        keys: function keys() {
	          var keys = [];
	          for (var i = 0; i < stack.length; i++) {
	            keys.push(stack[i].key);
	          }
	          return keys;
	        },
	        top: function top() {
	          return stack[stack.length - 1];
	        },
	        remove: function remove(key) {
	          var idx = -1;
	          for (var i = 0; i < stack.length; i++) {
	            if (key === stack[i].key) {
	              idx = i;
	              break;
	            }
	          }
	          return stack.splice(idx, 1)[0];
	        },
	        removeTop: function removeTop() {
	          return stack.pop();
	        },
	        length: function length() {
	          return stack.length;
	        }
	      };
	    }
	  };
	});

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(515);
	
	var MODULE_NAME = 'ui.bootstrap.module.tabindex';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tabindex']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.tabindex', []).directive('uibTabindexToggle', function () {
	  return {
	    restrict: 'A',
	    link: function link(scope, elem, attrs) {
	      attrs.$observe('disabled', function (disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(535);
	__webpack_require__(536);
	__webpack_require__(517);
	
	var MODULE_NAME = 'ui.bootstrap.module.tabs';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.tabs', 'uib/template/tabs/tab.html', 'uib/template/tabs/tabset.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.tabs', []).controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	      oldIndex;
	  ctrl.tabs = [];
	
	  ctrl.select = function (index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt,
	          $selectedIndex: index
	        });
	        if (evt && evt.isDefaultPrevented()) {
	          return;
	        }
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	      } else if (!selected && angular.isDefined(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	    ctrl.tabs.sort(function (t1, t2) {
	      if (t1.index > t2.index) {
	        return 1;
	      }
	
	      if (t1.index < t2.index) {
	        return -1;
	      }
	
	      return 0;
	    });
	
	    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index;
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].tab === tab) {
	        index = i;
	        break;
	      }
	    }
	
	    if (ctrl.tabs[index].index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ? index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function (val) {
	    if (angular.isDefined(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function () {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}]).directive('uibTabset', function () {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	    },
	    link: function link(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	}).directive('uibTab', ['$parse', function ($parse) {
	  return {
	    require: '^uibTabset',
	    replace: true,
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	      //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function controller() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function link(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function (value) {
	          scope.disabled = !!value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {
	            return t.index;
	          })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function (evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function () {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}]).directive('uibTabHeadingTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^uibTab',
	    link: function link(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	}).directive('uibTabContentTransclude', function () {
	  return {
	    restrict: 'A',
	    require: '^uibTabset',
	    link: function link(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function (contents) {
	        angular.forEach(contents, function (node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (node.hasAttribute('uib-tab-heading') || node.hasAttribute('data-uib-tab-heading') || node.hasAttribute('x-uib-tab-heading') || node.tagName.toLowerCase() === 'uib-tab-heading' || node.tagName.toLowerCase() === 'data-uib-tab-heading' || node.tagName.toLowerCase() === 'x-uib-tab-heading' || node.tagName.toLowerCase() === 'uib:tab-heading');
	  }
	});

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(537);
	__webpack_require__(520);
	
	var MODULE_NAME = 'ui.bootstrap.module.timepicker';
	
	angular.module(MODULE_NAME, ['ui.bootstrap.timepicker', 'uib/template/timepicker/timepicker.html']);
	
	module.exports = MODULE_NAME;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(172);
	module.exports = __webpack_require__(518);

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('ui.bootstrap.timepicker', []).constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  secondStep: 1,
	  showMeridian: true,
	  showSeconds: false,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true,
	  templateUrl: 'uib/template/timepicker/timepicker.html'
	}).controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
	  var selected = new Date(),
	      watchers = [],
	      ngModelCtrl = { $setViewValue: angular.noop },
	      // nullModelCtrl
	  meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
	      padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function (ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function (modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1),
	        secondsInputEl = inputs.eq(2);
	
	    hoursModelCtrl = hoursInputEl.controller('ngModel');
	    minutesModelCtrl = minutesInputEl.controller('ngModel');
	    secondsModelCtrl = secondsInputEl.controller('ngModel');
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
	      hourStep = +value;
	    }));
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
	      minuteStep = +value;
	    }));
	  }
	
	  var min;
	  watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  }));
	
	  var max;
	  watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  }));
	
	  var disabled = false;
	  if ($attrs.ngDisabled) {
	    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
	      disabled = value;
	    }));
	  }
	
	  $scope.noIncrementHours = function () {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementHours = function () {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementMinutes = function () {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementMinutes = function () {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementSeconds = function () {
	    var incrementedSelected = addSeconds(selected, secondStep);
	    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementSeconds = function () {
	    var decrementedSelected = addSeconds(selected, -secondStep);
	    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noToggleMeridian = function () {
	    if (selected.getHours() < 12) {
	      return disabled || addMinutes(selected, 12 * 60) > max;
	    }
	
	    return disabled || addMinutes(selected, -12 * 60) < min;
	  };
	
	  var secondStep = timepickerConfig.secondStep;
	  if ($attrs.secondStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
	      secondStep = +value;
	    }));
	  }
	
	  $scope.showSeconds = timepickerConfig.showSeconds;
	  if ($attrs.showSeconds) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
	      $scope.showSeconds = !!value;
	    }));
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(),
	            minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    }));
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = +$scope.hours;
	    var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;
	    if (!valid || $scope.hours === '') {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = +$scope.minutes;
	    var valid = minutes >= 0 && minutes < 60;
	    if (!valid || $scope.minutes === '') {
	      return undefined;
	    }
	    return minutes;
	  }
	
	  function getSecondsFromTemplate() {
	    var seconds = +$scope.seconds;
	    return seconds >= 0 && seconds < 60 ? seconds : undefined;
	  }
	
	  function pad(value, noPad) {
	    if (value === null) {
	      return '';
	    }
	
	    return angular.isDefined(value) && value.toString().length < 2 && !noPad ? '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    var isScrollingUp = function isScrollingUp(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	      return e.detail || delta > 0;
	    };
	
	    hoursInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      }
	      e.preventDefault();
	    });
	
	    minutesInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      }
	      e.preventDefault();
	    });
	
	    secondsInputEl.on('mousewheel wheel', function (e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	      }
	      e.preventDefault();
	    });
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    hoursInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementHours();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementHours();
	          $scope.$apply();
	        }
	      }
	    });
	
	    minutesInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementMinutes();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementMinutes();
	          $scope.$apply();
	        }
	      }
	    });
	
	    secondsInputEl.on('keydown', function (e) {
	      if (!disabled) {
	        if (e.which === 38) {
	          // up
	          e.preventDefault();
	          $scope.incrementSeconds();
	          $scope.$apply();
	        } else if (e.which === 40) {
	          // down
	          e.preventDefault();
	          $scope.decrementSeconds();
	          $scope.$apply();
	        }
	      }
	    });
	  };
	
	  this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      $scope.updateSeconds = angular.noop;
	      return;
	    }
	
	    var invalidate = function invalidate(invalidHours, invalidMinutes, invalidSeconds) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	        if (hoursModelCtrl) {
	          hoursModelCtrl.$setValidity('hours', false);
	        }
	      }
	
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	        if (minutesModelCtrl) {
	          minutesModelCtrl.$setValidity('minutes', false);
	        }
	      }
	
	      if (angular.isDefined(invalidSeconds)) {
	        $scope.invalidSeconds = invalidSeconds;
	        if (secondsModelCtrl) {
	          secondsModelCtrl.$setValidity('seconds', false);
	        }
	      }
	    };
	
	    $scope.updateHours = function () {
	      var hours = getHoursFromTemplate(),
	          minutes = getMinutesFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.on('blur', function (e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.hours === null || $scope.hours === '') {
	        invalidate(true);
	      } else if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function () {
	          $scope.hours = pad($scope.hours, !padHours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function () {
	      var minutes = getMinutesFromTemplate(),
	          hours = getHoursFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.on('blur', function (e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.minutes === null) {
	        invalidate(undefined, true);
	      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function () {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	    $scope.updateSeconds = function () {
	      var seconds = getSecondsFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(seconds)) {
	        selected.setSeconds(seconds);
	        refresh('s');
	      } else {
	        invalidate(undefined, undefined, true);
	      }
	    };
	
	    secondsInputEl.on('blur', function (e) {
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
	        $scope.$apply(function () {
	          $scope.seconds = pad($scope.seconds);
	        });
	      }
	    });
	  };
	
	  this.render = function () {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    if (hoursModelCtrl) {
	      hoursModelCtrl.$setValidity('hours', true);
	    }
	
	    if (minutesModelCtrl) {
	      minutesModelCtrl.$setValidity('minutes', true);
	    }
	
	    if (secondsModelCtrl) {
	      secondsModelCtrl.$setValidity('seconds', true);
	    }
	
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	    $scope.invalidSeconds = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    if (!ngModelCtrl.$modelValue) {
	      $scope.hours = null;
	      $scope.minutes = null;
	      $scope.seconds = null;
	      $scope.meridian = meridians[0];
	    } else {
	      var hours = selected.getHours(),
	          minutes = selected.getMinutes(),
	          seconds = selected.getSeconds();
	
	      if ($scope.showMeridian) {
	        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	      }
	
	      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
	      if (keyboardChange !== 'm') {
	        $scope.minutes = pad(minutes);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	
	      if (keyboardChange !== 's') {
	        $scope.seconds = pad(seconds);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	    }
	  }
	
	  function addSecondsToSelected(seconds) {
	    selected = addSeconds(selected, seconds);
	    refresh();
	  }
	
	  function addMinutes(selected, minutes) {
	    return addSeconds(selected, minutes * 60);
	  }
	
	  function addSeconds(date, seconds) {
	    var dt = new Date(date.getTime() + seconds * 1000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	    return newDate;
	  }
	
	  function modelIsEmpty() {
	    return ($scope.hours === null || $scope.hours === '') && ($scope.minutes === null || $scope.minutes === '') && (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function () {
	    if (!$scope.noIncrementHours()) {
	      addSecondsToSelected(hourStep * 60 * 60);
	    }
	  };
	
	  $scope.decrementHours = function () {
	    if (!$scope.noDecrementHours()) {
	      addSecondsToSelected(-hourStep * 60 * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function () {
	    if (!$scope.noIncrementMinutes()) {
	      addSecondsToSelected(minuteStep * 60);
	    }
	  };
	
	  $scope.decrementMinutes = function () {
	    if (!$scope.noDecrementMinutes()) {
	      addSecondsToSelected(-minuteStep * 60);
	    }
	  };
	
	  $scope.incrementSeconds = function () {
	    if (!$scope.noIncrementSeconds()) {
	      addSecondsToSelected(secondStep);
	    }
	  };
	
	  $scope.decrementSeconds = function () {
	    if (!$scope.noDecrementSeconds()) {
	      addSecondsToSelected(-secondStep);
	    }
	  };
	
	  $scope.toggleMeridian = function () {
	    var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	    if (!$scope.noToggleMeridian()) {
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	      } else {
	        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	      }
	    }
	  };
	
	  $scope.blur = function () {
	    ngModelCtrl.$setTouched();
	  };
	
	  $scope.$on('$destroy', function () {
	    while (watchers.length) {
	      watchers.shift()();
	    }
	  });
	}]).directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
	  return {
	    require: ['uibTimepicker', '?^ngModel'],
	    restrict: 'A',
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    scope: {},
	    templateUrl: function templateUrl(element, attrs) {
	      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	    },
	    link: function link(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0],
	          ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(26);
	__webpack_require__(81);
	module.exports = __webpack_require__(89);

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function () {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
	  this.options = function (value) {
	    angular.extend(globalOptions, value);
	  };
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function (letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function () {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function (trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template = '<div ' + directiveName + '-popup ' + 'uib-title="' + startSym + 'title' + endSym + '" ' + (options.useContentExp ? 'content-exp="contentExp()" ' : 'content="' + startSym + 'content' + endSym + '" ') + 'origin-scope="origScope" ' + 'class="uib-position-measure ' + prefix + '" ' + 'tooltip-animation-class="fade"' + 'uib-tooltip-classes ' + 'ng-class="{ in: isOpen }" ' + '>' + '</div>';
	
	      return {
	        compile: function compile(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function positionTooltip() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) {
	                return;
	              }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function () {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function () {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function () {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function () {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function () {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function (val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function (val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(scope.$watch(contentParse, function (val) {
	                  ttScope.content = val;
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  }
	                }));
	
	                observers.push(tooltipLinkedScope.$watch(function () {
	                  if (!repositionScheduled) {
	                    repositionScheduled = true;
	                    tooltipLinkedScope.$$postDigest(function () {
	                      repositionScheduled = false;
	                      if (ttScope && ttScope.isOpen) {
	                        positionTooltip();
	                      }
	                    });
	                  }
	                }));
	              } else {
	                observers.push(attrs.$observe(ttType, function (val) {
	                  ttScope.content = val;
	                  if (!val && ttScope.isOpen) {
	                    hide();
	                  } else {
	                    positionTooltip();
	                  }
	                }));
	              }
	
	              observers.push(attrs.$observe(prefix + 'Title', function (val) {
	                ttScope.title = val;
	                if (ttScope.isOpen) {
	                  positionTooltip();
	                }
	              }));
	
	              observers.push(attrs.$observe(prefix + 'Placement', function (val) {
	                ttScope.placement = val ? val : options.placement;
	                if (ttScope.isOpen) {
	                  positionTooltip();
	                }
	              }));
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function (observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function unregisterTriggers() {
	              triggers.show.forEach(function (trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function (trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [],
	                  hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function (key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function (trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', ['$animate', '$sce', '$compile', '$templateRequest', function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function link(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	          currentScope,
	          previousElement,
	          currentElement;
	
	      var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function () {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function (response) {
	            if (thisChangeId !== changeCounter) {
	              return;
	            }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function (clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function () {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}]).directive('uibTooltipPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	}).directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}]).directive('uibTooltipTemplatePopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	}).directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]).directive('uibTooltipHtmlPopup', function () {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	}).directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion-group.html", "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" + "  <h4 class=\"panel-title\">\n" + "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" + "  </h4>\n" + "</div>\n" + "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" + "  <div class=\"panel-body\" ng-transclude></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion.html", "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	}]);

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/alert/alert.html", "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" + "  <span aria-hidden=\"true\">&times;</span>\n" + "  <span class=\"sr-only\">Close</span>\n" + "</button>\n" + "<div ng-transclude></div>\n" + "");
	}]);

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/datepicker.html", "<div ng-switch=\"datepickerMode\">\n" + "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" + "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" + "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/day.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></button></th>\n" + "    </tr>\n" + "    <tr>\n" + "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" + "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/month.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/year.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"fa fa-angle-double-right\"></i><span class=\"sr-only\">next</span></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepickerPopup/popup.html", "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" + "  <li ng-transclude></li>\n" + "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" + "    <span class=\"btn-group pull-left\">\n" + "      <button type=\"button\" md-effect class=\"btn btn-sm btn-primary uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" + "      <button type=\"button\" md-effect class=\"btn btn-sm btn-default uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" + "    </span>\n" + "    <button type=\"button\" md-effect class=\"btn btn-sm btn-default pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" + "  </li>\n" + "</ul>\n" + "");
	}]);

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html", "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" + "");
	}]);

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-html.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-template.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\"\n" + "      uib-tooltip-template-transclude=\"contentExp()\"\n" + "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover.html", "<div class=\"arrow\"></div>\n" + "\n" + "<div class=\"popover-inner\">\n" + "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" + "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tab.html", "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" + "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" + "</li>\n" + "");
	}]);

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tabset.html", "<div>\n" + "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" + "  <div class=\"tab-content\">\n" + "    <div class=\"tab-pane\"\n" + "         ng-repeat=\"tab in tabset.tabs\"\n" + "         ng-class=\"{active: tabset.active === tab.index}\"\n" + "         uib-tab-content-transclude=\"tab\">\n" + "    </div>\n" + "  </div>\n" + "</div>\n" + "");
	}]);

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/timepicker/timepicker.html", "<table class=\"uib-timepicker\">\n" + "  <tbody>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"fa fa-angle-up\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "    <tr>\n" + "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" + "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" + "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" + "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" + "    </tr>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"fa fa-angle-down\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
	}]);

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" + "");
	}]);

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" + "");
	}]);

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	"use strict";
	
	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html", "<div class=\"tooltip-arrow\"></div>\n" + "<div class=\"tooltip-inner\"\n" + "  uib-tooltip-template-transclude=\"contentExp()\"\n" + "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" + "");
	}]);

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Formly = angular.module('vendor.formly', []).run(["formlyConfig", "formlyValidationMessages", function (formlyConfig, formlyValidationMessages) {
	    'ngInject';
	    /* Datepicker */
	
	    var attributes = ['date-disabled', 'custom-class', 'show-weeks', 'starting-day', 'init-date', 'min-mode', 'max-mode', 'format-day', 'format-month', 'format-year', 'format-day-header', 'format-day-title', 'format-month-title', 'year-range', 'shortcut-propagation', 'datepicker-popup', 'show-button-bar', 'current-text', 'clear-text', 'close-text', 'close-on-date-selection', 'datepicker-append-to-body'];
	
	    var bindings = ['datepicker-mode', 'min-date', 'max-date'];
	
	    var ngModelAttrs = {};
	
	    angular.forEach(attributes, function (attr) {
	        ngModelAttrs[camelize(attr)] = { attribute: attr };
	    });
	
	    angular.forEach(bindings, function (binding) {
	        ngModelAttrs[camelize(binding)] = { bound: binding };
	    });
	
	    formlyConfig.setType({
	        name: 'datepicker',
	        template: '\n                <p class="input-group">\n                    <input  type="text"\n                            id="{{::id}}"\n                            name="{{::id}}"\n                            ng-model="model[options.key]"\n                            class="form-control"\n                            ng-click="datepicker.open($event)"\n                            uib-datepicker-popup="{{to.datepickerOptions.format}}"\n                            is-open="datepicker.opened"\n                            datepicker-options="to.datepickerOptions" />\n                    <span class="input-group-btn">\n                        <button type="button" class="btn btn-default" ng-click="datepicker.open($event)" ng-disabled="to.disabled"><i class="fa fa-calendar"></i></button>\n                    </span>\n                </p>\n            ',
	        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	        defaultOptions: {
	            ngModelAttrs: ngModelAttrs,
	            templateOptions: {
	                datepickerOptions: {
	                    format: 'dd/MM/yyyy',
	                    initDate: new Date()
	                }
	            }
	        },
	        controller: ['$scope', function ($scope) {
	            $scope.datepicker = {};
	            $scope.datepicker.opened = false;
	
	            $scope.datepicker.open = function ($event) {
	                $scope.datepicker.opened = !$scope.datepicker.opened;
	            };
	        }]
	    });
	
	    /* timepicker */
	
	    ngModelAttrs = {};
	
	    angular.forEach(['meridians', 'readonly-input', 'mousewheel', 'arrowkeys'], function (attr) {
	        ngModelAttrs[camelize(attr)] = { attribute: attr };
	    });
	
	    angular.forEach(['hour-step', 'minute-step', 'show-meridian'], function (binding) {
	        ngModelAttrs[camelize(binding)] = { bound: binding };
	    });
	
	    formlyConfig.setType({
	        name: 'timepicker',
	        template: '<timepicker ng-model="model[options.key]"></timepicker>',
	        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
	        defaultOptions: {
	            ngModelAttrs: ngModelAttrs,
	            templateOptions: {
	                datepickerOptions: {}
	            }
	        }
	    });
	
	    function camelize(string) {
	        string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
	            return chr ? chr.toUpperCase() : '';
	        });
	
	        return string.replace(/^([A-Z])/, function (match, chr) {
	            return chr ? chr.toLowerCase() : '';
	        });
	    }
	
	    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';
	
	    formlyValidationMessages.addStringMessage('required', 'El campo es obligatorio');
	}]).name;
	
	exports.default = Formly;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function webpackUniversalModuleDefinition(root, factory) {
	    if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory(__webpack_require__(9));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["ng-table"] = factory(require("angular"));else root["ng-table"] = factory(root["angular"]);
	})(undefined, function (__WEBPACK_EXTERNAL_MODULE_0__) {
	    return (/******/function (modules) {
	            // webpackBootstrap
	            /******/ // The module cache
	            /******/var installedModules = {};
	            /******/
	            /******/ // The require function
	            /******/function __webpack_require__(moduleId) {
	                /******/
	                /******/ // Check if module is in cache
	                /******/if (installedModules[moduleId])
	                    /******/return installedModules[moduleId].exports;
	                /******/
	                /******/ // Create a new module (and put it into the cache)
	                /******/var module = installedModules[moduleId] = {
	                    /******/i: moduleId,
	                    /******/l: false,
	                    /******/exports: {}
	                    /******/ };
	                /******/
	                /******/ // Execute the module function
	                /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	                /******/
	                /******/ // Flag the module as loaded
	                /******/module.l = true;
	                /******/
	                /******/ // Return the exports of the module
	                /******/return module.exports;
	                /******/
	            }
	            /******/
	            /******/
	            /******/ // expose the modules object (__webpack_modules__)
	            /******/__webpack_require__.m = modules;
	            /******/
	            /******/ // expose the module cache
	            /******/__webpack_require__.c = installedModules;
	            /******/
	            /******/ // identity function for calling harmory imports with the correct context
	            /******/__webpack_require__.i = function (value) {
	                return value;
	            };
	            /******/
	            /******/ // define getter function for harmory exports
	            /******/__webpack_require__.d = function (exports, name, getter) {
	                /******/if (!__webpack_require__.o(exports, name)) {
	                    /******/Object.defineProperty(exports, name, {
	                        /******/configurable: false,
	                        /******/enumerable: true,
	                        /******/get: getter
	                        /******/ });
	                    /******/
	                }
	                /******/
	            };
	            /******/
	            /******/ // getDefaultExport function for compatibility with non-harmony modules
	            /******/__webpack_require__.n = function (module) {
	                /******/var getter = module && module.__esModule ?
	                /******/function getDefault() {
	                    return module['default'];
	                } :
	                /******/function getModuleExports() {
	                    return module;
	                };
	                /******/__webpack_require__.d(getter, 'a', getter);
	                /******/return getter;
	                /******/
	            };
	            /******/
	            /******/ // Object.prototype.hasOwnProperty.call
	            /******/__webpack_require__.o = function (object, property) {
	                return Object.prototype.hasOwnProperty.call(object, property);
	            };
	            /******/
	            /******/ // __webpack_public_path__
	            /******/__webpack_require__.p = "";
	            /******/
	            /******/ // Load entry module and return exports
	            /******/return __webpack_require__(__webpack_require__.s = 51);
	            /******/
	        }(
	        /************************************************************************/
	        /******/[
	        /* 0 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************!*\
	          !*** external "angular" ***!
	          \**************************/
	        /***/function (module, exports) {
	
	            module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	            /***/
	        },
	        /* 1 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************!*\
	          !*** ./src/core/index.ts ***!
	          \***************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var angular = __webpack_require__( /*! angular */0);
	            var data_1 = __webpack_require__( /*! ./data */3);
	            var grouping_1 = __webpack_require__( /*! ./grouping */37);
	            var ngTableDefaults_1 = __webpack_require__( /*! ./ngTableDefaults */7);
	            var ngTableSettings_1 = __webpack_require__( /*! ./ngTableSettings */10);
	            var ngTableParams_1 = __webpack_require__( /*! ./ngTableParams */9);
	            var ngTableEventsChannel_1 = __webpack_require__( /*! ./ngTableEventsChannel */8);
	            var ngTableCoreModule = angular.module('ngTable-core', []).provider('ngTableDefaultGetData', data_1.NgTableDefaultGetDataProvider).factory('ngTableDefaultGetGroups', grouping_1.ngTableDefaultGetGroups).value('ngTableDefaults', ngTableDefaults_1.ngTableDefaults).service('ngTableEventsChannel', ngTableEventsChannel_1.NgTableEventsChannel).service('ngTableSettings', ngTableSettings_1.NgTableSettings).run(ngTableParams_1.NgTableParams.init);
	            exports.ngTableCoreModule = ngTableCoreModule;
	            // note: if you are using ES6 or typescript prefer:
	            // import { NgTableParams } from 'ng-table';
	            ngTableCoreModule.value('NgTableParams', ngTableParams_1.NgTableParams);
	            var ngTableDefaults_2 = __webpack_require__( /*! ./ngTableDefaults */7);
	            exports.IDefaults = ngTableDefaults_2.IDefaults;
	            __export(__webpack_require__( /*! ./ngTableEventsChannel */8));
	            var ngTableSettings_2 = __webpack_require__( /*! ./ngTableSettings */10);
	            exports.ISettings = ngTableSettings_2.ISettings;
	            __export(__webpack_require__( /*! ./ngTableParams */9));
	            __export(__webpack_require__( /*! ./data */3));
	            __export(__webpack_require__( /*! ./filtering */36));
	            __export(__webpack_require__( /*! ./grouping/publicExports */39));
	            __export(__webpack_require__( /*! ./paging */40));
	            __export(__webpack_require__( /*! ./sorting */41));
	
	            /***/
	        },
	        /* 2 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************!*\
	          !*** ./src/browser/index.ts ***!
	          \******************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var angular = __webpack_require__( /*! angular */0);
	            var ngTable_directive_1 = __webpack_require__( /*! ./ngTable.directive */13);
	            var ngTableColumn_1 = __webpack_require__( /*! ./ngTableColumn */14);
	            var ngTableColumnsBinding_directive_1 = __webpack_require__( /*! ./ngTableColumnsBinding.directive */15);
	            var ngTableController_1 = __webpack_require__( /*! ./ngTableController */16);
	            exports.NgTableController = ngTableController_1.NgTableController;
	            var ngTableDynamic_directive_1 = __webpack_require__( /*! ./ngTableDynamic.directive */17);
	            var ngTableFilterConfig_1 = __webpack_require__( /*! ./ngTableFilterConfig */18);
	            exports.NgTableFilterConfigProvider = ngTableFilterConfig_1.NgTableFilterConfigProvider;
	            exports.NgTableFilterConfig = ngTableFilterConfig_1.NgTableFilterConfig;
	            var ngTableFilterRow_directive_1 = __webpack_require__( /*! ./ngTableFilterRow.directive */19);
	            var ngTableFilterRowController_1 = __webpack_require__( /*! ./ngTableFilterRowController */20);
	            var ngTableGroupRow_directive_1 = __webpack_require__( /*! ./ngTableGroupRow.directive */21);
	            var ngTableGroupRowController_1 = __webpack_require__( /*! ./ngTableGroupRowController */22);
	            var ngTablePagination_directive_1 = __webpack_require__( /*! ./ngTablePagination.directive */23);
	            var ngTableSelectFilterDs_directive_1 = __webpack_require__( /*! ./ngTableSelectFilterDs.directive */24);
	            var ngTableSorterRow_directive_1 = __webpack_require__( /*! ./ngTableSorterRow.directive */25);
	            var ngTableSorterRowController_1 = __webpack_require__( /*! ./ngTableSorterRowController */26);
	            __webpack_require__( /*! ./filters/number.html */43);
	            __webpack_require__( /*! ./filters/select.html */45);
	            __webpack_require__( /*! ./filters/select-multiple.html */44);
	            __webpack_require__( /*! ./filters/text.html */46);
	            __webpack_require__( /*! ./filters/date.html */52);
	            __webpack_require__( /*! ./filters/img.html */53);
	            __webpack_require__( /*! ./filters/hidden.html */54);
	            __webpack_require__( /*! ./pager.html */49);
	            __webpack_require__( /*! ./header.html */48);
	            var ngTableBrowserModule = angular.module('ngTable-browser', []).directive('ngTable', ngTable_directive_1.ngTable).service('ngTableColumn', ngTableColumn_1.NgTableColumn).directive('ngTableColumnsBinding', ngTableColumnsBinding_directive_1.ngTableColumnsBinding).controller('ngTableController', ngTableController_1.NgTableController).directive('ngTableDynamic', ngTableDynamic_directive_1.ngTableDynamic).provider('ngTableFilterConfig', ngTableFilterConfig_1.NgTableFilterConfigProvider).directive('ngTableFilterRow', ngTableFilterRow_directive_1.ngTableFilterRow).controller('ngTableFilterRowController', ngTableFilterRowController_1.NgTableFilterRowController).directive('ngTableGroupRow', ngTableGroupRow_directive_1.ngTableGroupRow).controller('ngTableGroupRowController', ngTableGroupRowController_1.NgTableGroupRowController).directive('ngTablePagination', ngTablePagination_directive_1.ngTablePagination).directive('ngTableSelectFilterDs', ngTableSelectFilterDs_directive_1.ngTableSelectFilterDs).directive('ngTableSorterRow', ngTableSorterRow_directive_1.ngTableSorterRow).controller('ngTableSorterRowController', ngTableSorterRowController_1.NgTableSorterRowController);
	            exports.ngTableBrowserModule = ngTableBrowserModule;
	            __export(__webpack_require__( /*! ./public-interfaces */27));
	
	            /***/
	        },
	        /* 3 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************!*\
	          !*** ./src/core/data/index.ts ***!
	          \********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./dataSettings */28));
	            __export(__webpack_require__( /*! ./getData */29));
	            __export(__webpack_require__( /*! ./interceptor */30));
	            __export(__webpack_require__( /*! ./ngTableDefaultGetData */31));
	            __export(__webpack_require__( /*! ./results */32));
	
	            /***/
	        },
	        /* 4 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/core/grouping/getGroup.ts ***!
	          \***************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 5 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/core/grouping/groupSettings.ts ***!
	          \********************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 6 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*******************************************!*\
	          !*** ./src/core/grouping/groupingFunc.ts ***!
	          \*******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 7 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/ngTableDefaults.ts ***!
	          \*************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Default values for ngTable
	             */
	
	            exports.ngTableDefaults = {
	                params: {},
	                settings: {}
	            };
	
	            /***/
	        },
	        /* 8 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/core/ngTableEventsChannel.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var NgTableEventsChannel = function () {
	                function NgTableEventsChannel($rootScope) {
	                    this.$rootScope = $rootScope;
	                    var events = this;
	                    events = this.addTableParamsEvent('afterCreated', events);
	                    events = this.addTableParamsEvent('afterReloadData', events);
	                    events = this.addTableParamsEvent('datasetChanged', events);
	                    events = this.addTableParamsEvent('pagesChanged', events);
	                    events = this.addTableParamsEvent('afterDataFiltered', events);
	                    events = this.addTableParamsEvent('afterDataSorted', events);
	                }
	                NgTableEventsChannel.prototype.addTableParamsEvent = function (eventName, target) {
	                    var fnName = eventName.charAt(0).toUpperCase() + eventName.substring(1);
	                    var event = (_a = {}, _a['on' + fnName] = this.createEventSubscriptionFn(eventName), _a['publish' + fnName] = this.createPublishEventFn(eventName), _a);
	                    return ng1.extend(target, event);
	                    var _a;
	                };
	                NgTableEventsChannel.prototype.createPublishEventFn = function (eventName) {
	                    var _this = this;
	                    return function () {
	                        var args = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            args[_i - 0] = arguments[_i];
	                        }
	                        (_a = _this.$rootScope).$broadcast.apply(_a, ['ngTable:' + eventName].concat(args));
	                        var _a;
	                    };
	                };
	                NgTableEventsChannel.prototype.createEventSubscriptionFn = function (eventName) {
	                    var _this = this;
	                    return function (handler, eventSelectorOrScope, eventSelector) {
	                        var actualEvtSelector;
	                        var scope = _this.$rootScope;
	                        if (isScopeLike(eventSelectorOrScope)) {
	                            scope = eventSelectorOrScope;
	                            actualEvtSelector = createEventSelectorFn(eventSelector);
	                        } else {
	                            actualEvtSelector = createEventSelectorFn(eventSelectorOrScope);
	                        }
	                        return scope.$on('ngTable:' + eventName, function (event, params) {
	                            var eventArgs = [];
	                            for (var _i = 2; _i < arguments.length; _i++) {
	                                eventArgs[_i - 2] = arguments[_i];
	                            }
	                            // don't send events published by the internal NgTableParams created by ngTableController
	                            if (params.isNullInstance) return;
	                            var fnArgs = [params].concat(eventArgs);
	                            if (actualEvtSelector.apply(this, fnArgs)) {
	                                handler.apply(this, fnArgs);
	                            }
	                        });
	                    };
	                    function createEventSelectorFn(eventSelector) {
	                        if (!eventSelector) {
	                            return function (publisher) {
	                                return true;
	                            };
	                        } else if (isEventSelectorFunc(eventSelector)) {
	                            return eventSelector;
	                        } else {
	                            // shorthand for subscriber to only receive events from a specific publisher instance
	                            return function (publisher) {
	                                return publisher === eventSelector;
	                            };
	                        }
	                    }
	                    function isEventSelectorFunc(val) {
	                        return typeof val === 'function';
	                    }
	                    function isScopeLike(val) {
	                        return val && typeof val.$new === 'function';
	                    }
	                };
	                NgTableEventsChannel.$inject = ['$rootScope'];
	                return NgTableEventsChannel;
	            }();
	            exports.NgTableEventsChannel = NgTableEventsChannel;
	
	            /***/
	        },
	        /* 9 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/core/ngTableParams.ts ***!
	          \***********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var util_1 = __webpack_require__( /*! ./util */11);
	            /**
	             * @private
	             */
	            function isNumber(n) {
	                return !isNaN(parseFloat(n)) && isFinite(n);
	            }
	            /**
	             * Parameters manager for an ngTable directive
	             */
	            var NgTableParams = function () {
	                function NgTableParams(baseParameters, baseSettings) {
	                    var _this = this;
	                    /**
	                     * The page of data rows currently being displayed in the table
	                     */
	                    this.data = [];
	                    this.defaultSettings = NgTableParams.ngTableSettings.createDefaults();
	                    this.isCommittedDataset = false;
	                    this.initialEvents = [];
	                    this._params = {
	                        page: 1,
	                        count: 10,
	                        filter: {},
	                        sorting: {},
	                        group: {}
	                    };
	                    this._settings = this.defaultSettings;
	                    // the ngTableController "needs" to create a dummy/null instance and it's important to know whether an instance
	                    // is one of these
	                    if (typeof baseParameters === "boolean") {
	                        this.isNullInstance = true;
	                    }
	                    this.reloadPages = function () {
	                        var currentPages;
	                        return function () {
	                            var oldPages = currentPages;
	                            var newPages = _this.generatePagesArray(_this.page(), _this.total(), _this.count());
	                            if (!ng1.equals(oldPages, newPages)) {
	                                currentPages = newPages;
	                                NgTableParams.ngTableEventsChannel.publishPagesChanged(_this, newPages, oldPages);
	                            }
	                        };
	                    }();
	                    ng1.extend(this._params, NgTableParams.ngTableDefaults.params);
	                    this.settings(baseSettings);
	                    this.parameters(baseParameters, true);
	                    NgTableParams.ngTableEventsChannel.publishAfterCreated(this);
	                    // run events during construction after the initial create event. That way a consumer
	                    // can subscribe to all events for a table without "dropping" an event
	                    ng1.forEach(this.initialEvents, function (event) {
	                        event();
	                    });
	                    this.initialEvents = null;
	                }
	                NgTableParams.prototype.count = function (count) {
	                    // reset to first page because can be blank page
	                    return count !== undefined ? this.parameters({
	                        'count': count,
	                        'page': 1
	                    }) : this._params.count;
	                };
	                NgTableParams.prototype.filter = function (filter) {
	                    if (filter != null && (typeof filter === 'undefined' ? 'undefined' : _typeof(filter)) === 'object') {
	                        return this.parameters({
	                            'filter': filter,
	                            'page': 1
	                        });
	                    } else if (filter === true) {
	                        var keys = Object.keys(this._params.filter);
	                        var significantFilter = {};
	                        for (var i = 0; i < keys.length; i++) {
	                            var filterValue = this._params.filter[keys[i]];
	                            if (filterValue != null && filterValue !== '') {
	                                significantFilter[keys[i]] = filterValue;
	                            }
	                        }
	                        return significantFilter;
	                    } else {
	                        return this._params.filter;
	                    }
	                };
	                /**
	                 * Generate array of pages.
	                 * When no arguments supplied, the current parameter state of this `NgTableParams` instance will be used
	                 * @param currentPage Which page must be active
	                 * @param totalItems  Total quantity of items
	                 * @param pageSize    Quantity of items on page
	                 * @param maxBlocks   Quantity of blocks for pagination
	                 * @returns Array of pages
	                 */
	                NgTableParams.prototype.generatePagesArray = function (currentPage, totalItems, pageSize, maxBlocks) {
	                    if (!arguments.length) {
	                        currentPage = this.page();
	                        totalItems = this.total();
	                        pageSize = this.count();
	                    }
	                    var maxPage, maxPivotPages, minPage, numPages;
	                    maxBlocks = maxBlocks && maxBlocks < 6 ? 6 : maxBlocks;
	                    var pages = [];
	                    numPages = Math.ceil(totalItems / pageSize);
	                    if (numPages > 1) {
	                        pages.push({
	                            type: 'prev',
	                            number: Math.max(1, currentPage - 1),
	                            active: currentPage > 1
	                        });
	                        pages.push({
	                            type: 'first',
	                            number: 1,
	                            active: currentPage > 1,
	                            current: currentPage === 1
	                        });
	                        maxPivotPages = Math.round((this._settings.paginationMaxBlocks - this._settings.paginationMinBlocks) / 2);
	                        minPage = Math.max(2, currentPage - maxPivotPages);
	                        maxPage = Math.min(numPages - 1, currentPage + maxPivotPages * 2 - (currentPage - minPage));
	                        minPage = Math.max(2, minPage - (maxPivotPages * 2 - (maxPage - minPage)));
	                        var i = minPage;
	                        while (i <= maxPage) {
	                            if (i === minPage && i !== 2 || i === maxPage && i !== numPages - 1) {
	                                pages.push({
	                                    type: 'more',
	                                    active: false
	                                });
	                            } else {
	                                pages.push({
	                                    type: 'page',
	                                    number: i,
	                                    active: currentPage !== i,
	                                    current: currentPage === i
	                                });
	                            }
	                            i++;
	                        }
	                        pages.push({
	                            type: 'last',
	                            number: numPages,
	                            active: currentPage !== numPages,
	                            current: currentPage === numPages
	                        });
	                        pages.push({
	                            type: 'next',
	                            number: Math.min(numPages, currentPage + 1),
	                            active: currentPage < numPages
	                        });
	                    }
	                    return pages;
	                };
	                NgTableParams.prototype.group = function (group, sortDirection) {
	                    if (group === undefined) {
	                        return this._params.group;
	                    }
	                    var newParameters = {
	                        page: 1
	                    };
	                    if (util_1.isGroupingFun(group) && sortDirection !== undefined) {
	                        group.sortDirection = sortDirection;
	                        newParameters.group = group;
	                    } else if (typeof group === 'string' && sortDirection !== undefined) {
	                        newParameters.group = (_a = {}, _a[group] = sortDirection, _a);
	                    } else {
	                        newParameters.group = group;
	                    }
	                    this.parameters(newParameters);
	                    return this;
	                    var _a;
	                };
	                /**
	                 * Returns true when an attempt to `reload` the current `parameter` values have resulted in a failure.
	                 * This method will continue to return true until the `reload` is successfully called or when the
	                 * `parameter` values have changed
	                 */
	                NgTableParams.prototype.hasErrorState = function () {
	                    return !!(this.errParamsMemento && ng1.equals(this.errParamsMemento, this.createComparableParams()));
	                };
	                /**
	                 * Returns true if `filter` has significant filter value(s) (any value except null, undefined, or empty string),
	                 * otherwise false
	                 */
	                NgTableParams.prototype.hasFilter = function () {
	                    return Object.keys(this.filter(true)).length > 0;
	                };
	                /**
	                 * Return true when a change to `filters` require the `reload` method
	                 * to be run so as to ensure the data presented to the user reflects these filters
	                 */
	                NgTableParams.prototype.hasFilterChanges = function () {
	                    var previousFilter = this.prevParamsMemento && this.prevParamsMemento.params.filter;
	                    return !ng1.equals(this._params.filter, previousFilter) || this.hasGlobalSearchFieldChanges();
	                };
	                NgTableParams.prototype.hasGroup = function (group, sortDirection) {
	                    if (group == null) {
	                        return util_1.isGroupingFun(this._params.group) || Object.keys(this._params.group).length > 0;
	                    }
	                    if (util_1.isGroupingFun(group)) {
	                        if (sortDirection == null) {
	                            return this._params.group === group;
	                        } else {
	                            return this._params.group === group && group.sortDirection === sortDirection;
	                        }
	                    } else {
	                        if (sortDirection == null) {
	                            return Object.keys(this._params.group).indexOf(group) !== -1;
	                        } else {
	                            return this._params.group[group] === sortDirection;
	                        }
	                    }
	                };
	                /**
	                 * Return true when a change to this instance should require the `reload` method
	                 * to be run so as to ensure the data rows presented to the user reflects the current state.
	                 *
	                 * Note that this method will return false when the `reload` method has run but fails. In this case
	                 * `hasErrorState` will return true.
	                 *
	                 * The built-in `ngTable` directives will watch for when this function returns true and will then call
	                 * the `reload` method to load its data rows
	                 */
	                NgTableParams.prototype.isDataReloadRequired = function () {
	                    // note: using != as want to treat null and undefined the same
	                    return !this.isCommittedDataset || !ng1.equals(this.createComparableParams(), this.prevParamsMemento) || this.hasGlobalSearchFieldChanges();
	                };
	                /**
	                 * Returns true if sorting by the field supplied. Where direction supplied
	                 * the field must also be sorted by that direction to return true
	                 */
	                NgTableParams.prototype.isSortBy = function (field, direction) {
	                    if (direction !== undefined) {
	                        return this._params.sorting[field] !== undefined && this._params.sorting[field] == direction;
	                    } else {
	                        return this._params.sorting[field] !== undefined;
	                    }
	                };
	                /**
	                 * Returns sorting values in a format that can be consumed by the angular `$orderBy` filter service
	                 */
	                NgTableParams.prototype.orderBy = function () {
	                    return util_1.convertSortToOrderBy(this._params.sorting);
	                };
	                NgTableParams.prototype.page = function (page) {
	                    return page !== undefined ? this.parameters({
	                        'page': page
	                    }) : this._params.page;
	                };
	                NgTableParams.prototype.parameters = function (newParameters, parseParamsFromUrl) {
	                    parseParamsFromUrl = parseParamsFromUrl || false;
	                    if ((typeof newParameters === 'undefined' ? 'undefined' : _typeof(newParameters)) !== undefined) {
	                        for (var key in newParameters) {
	                            var value = newParameters[key];
	                            if (parseParamsFromUrl && key.indexOf('[') >= 0) {
	                                var keys = key.split(/\[(.*)\]/).reverse();
	                                var lastKey = '';
	                                for (var i = 0, len = keys.length; i < len; i++) {
	                                    var name = keys[i];
	                                    if (name !== '') {
	                                        var v = value;
	                                        value = {};
	                                        value[lastKey = name] = isNumber(v) ? parseFloat(v) : v;
	                                    }
	                                }
	                                if (lastKey === 'sorting') {
	                                    this._params[lastKey] = {};
	                                }
	                                this._params[lastKey] = ng1.extend(this._params[lastKey] || {}, value[lastKey]);
	                            } else {
	                                if (key === 'group') {
	                                    this._params[key] = this.parseGroup(newParameters[key]);
	                                } else {
	                                    this._params[key] = isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key];
	                                }
	                            }
	                        }
	                        this.log('ngTable: set parameters', this._params);
	                        return this;
	                    }
	                    return this._params;
	                };
	                /**
	                 * Trigger a reload of the data rows
	                 */
	                NgTableParams.prototype.reload = function () {
	                    var _this = this;
	                    var pData = null;
	                    this._settings.$loading = true;
	                    this.prevParamsMemento = ng1.copy(this.createComparableParams());
	                    this.isCommittedDataset = true;
	                    if (this.hasGroup()) {
	                        pData = this.runInterceptorPipeline(NgTableParams.$q.when(this._settings.getGroups(this)));
	                    } else {
	                        var fn = this._settings.getData;
	                        pData = this.runInterceptorPipeline(NgTableParams.$q.when(fn(this)));
	                    }
	                    this.log('ngTable: reload data');
	                    var oldData = this.data;
	                    return pData.then(function (data) {
	                        _this._settings.$loading = false;
	                        _this.errParamsMemento = null;
	                        _this.data = data;
	                        // note: I think it makes sense to publish this event even when data === oldData
	                        // subscribers can always set a filter to only receive the event when data !== oldData
	                        NgTableParams.ngTableEventsChannel.publishAfterReloadData(_this, data, oldData);
	                        _this.reloadPages();
	                        return data;
	                    }).catch(function (reason) {
	                        _this.errParamsMemento = _this.prevParamsMemento;
	                        // "rethrow"
	                        return NgTableParams.$q.reject(reason);
	                    });
	                };
	                NgTableParams.prototype.settings = function (newSettings) {
	                    var _this = this;
	                    if (ng1.isDefined(newSettings)) {
	                        var settings = NgTableParams.ngTableSettings.merge(this._settings, newSettings);
	                        var originalDataset_1 = this._settings.dataset;
	                        this._settings = settings;
	                        // note: using != as want null and undefined to be treated the same
	                        var hasDatasetChanged = newSettings.hasOwnProperty('dataset') && newSettings.dataset != originalDataset_1;
	                        if (hasDatasetChanged) {
	                            if (this.isCommittedDataset) {
	                                this.page(1); // reset page as a new dataset has been supplied
	                            }
	                            this.isCommittedDataset = false;
	                            var fireEvent = function fireEvent() {
	                                NgTableParams.ngTableEventsChannel.publishDatasetChanged(_this, newSettings.dataset, originalDataset_1);
	                            };
	                            if (this.initialEvents) {
	                                this.initialEvents.push(fireEvent);
	                            } else {
	                                fireEvent();
	                            }
	                        }
	                        this.log('ngTable: set settings', this._settings);
	                        return this;
	                    }
	                    return this._settings;
	                };
	                NgTableParams.prototype.sorting = function (sorting, direction) {
	                    if (typeof sorting === 'string') {
	                        this.parameters({
	                            'sorting': (_a = {}, _a[sorting] = direction, _a)
	                        });
	                        return this;
	                    }
	                    return sorting !== undefined ? this.parameters({
	                        'sorting': sorting
	                    }) : this._params.sorting;
	                    var _a;
	                };
	                NgTableParams.prototype.total = function (total) {
	                    return total !== undefined ? this.settings({
	                        'total': total
	                    }) : this._settings.total;
	                };
	                /**
	                 * Returns the current parameter values uri-encoded. Set `asString` to
	                 * true for the parameters to be returned as an array of strings of the form 'paramName=value'
	                 * otherwise parameters returned as a key-value object
	                 */
	                NgTableParams.prototype.url = function (asString) {
	                    // this function is an example of Typescript gone bad!!
	                    asString = asString || false;
	                    var pairs = asString ? [] : {};
	                    for (var key in this._params) {
	                        if (this._params.hasOwnProperty(key)) {
	                            var item = this._params[key],
	                                name = encodeURIComponent(key);
	                            if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === "object") {
	                                for (var subkey in item) {
	                                    if (isSignificantValue(item[subkey], key)) {
	                                        var pname = name + "[" + encodeURIComponent(subkey) + "]";
	                                        collectValue(item[subkey], pname);
	                                    }
	                                }
	                            } else if (!ng1.isFunction(item) && isSignificantValue(item, key)) {
	                                collectValue(item, name);
	                            }
	                        }
	                    }
	                    return pairs;
	                    function collectValue(value, key) {
	                        if (isArray(pairs)) {
	                            pairs.push(key + "=" + encodeURIComponent(value));
	                        } else {
	                            pairs[key] = encodeURIComponent(value);
	                        }
	                    }
	                    function isArray(pairs) {
	                        return asString;
	                    }
	                    function isSignificantValue(value, key) {
	                        return key === "group" ? true : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== undefined && value !== "";
	                    }
	                };
	                NgTableParams.prototype.createComparableParams = function () {
	                    var group = this._params.group;
	                    return {
	                        params: this._params,
	                        groupSortDirection: util_1.isGroupingFun(group) ? group.sortDirection : undefined
	                    };
	                };
	                NgTableParams.prototype.hasGlobalSearchFieldChanges = function () {
	                    var currentVal = this._params.filter && this._params.filter['$'];
	                    var previousVal = this.prevParamsMemento && this.prevParamsMemento.params.filter && this.prevParamsMemento.params.filter['$'];
	                    return !ng1.equals(currentVal, previousVal);
	                };
	                NgTableParams.prototype.log = function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i - 0] = arguments[_i];
	                    }
	                    if (this._settings.debugMode && NgTableParams.$log.debug) {
	                        (_a = NgTableParams.$log).debug.apply(_a, args);
	                    }
	                    var _a;
	                };
	                NgTableParams.prototype.parseGroup = function (group) {
	                    var defaultSort = this._settings.groupOptions && this._settings.groupOptions.defaultSort;
	                    if (!group) {
	                        return group;
	                    } else if (util_1.isGroupingFun(group)) {
	                        if (group.sortDirection == null) {
	                            group.sortDirection = defaultSort;
	                        }
	                        return group;
	                    } else if ((typeof group === 'undefined' ? 'undefined' : _typeof(group)) === 'object') {
	                        for (var key in group) {
	                            if (group[key] == null) {
	                                group[key] = defaultSort;
	                            }
	                        }
	                        return group;
	                    } else {
	                        return _a = {}, _a[group] = defaultSort, _a;
	                    }
	                    var _a;
	                };
	                NgTableParams.prototype.runInterceptorPipeline = function (fetchedData) {
	                    var _this = this;
	                    var interceptors = this._settings.interceptors || [];
	                    return interceptors.reduce(function (result, interceptor) {
	                        var thenFn = interceptor.response && interceptor.response.bind(interceptor) || NgTableParams.$q.when;
	                        var rejectFn = interceptor.responseError && interceptor.responseError.bind(interceptor) || NgTableParams.$q.reject;
	                        return result.then(function (data) {
	                            return thenFn(data, _this);
	                        }, function (reason) {
	                            return rejectFn(reason, _this);
	                        });
	                    }, fetchedData);
	                };
	                NgTableParams.init = function ($q, $log, ngTableDefaults, ngTableEventsChannel, ngTableSettings) {
	                    NgTableParams.$q = $q;
	                    NgTableParams.$log = $log;
	                    NgTableParams.ngTableDefaults = ngTableDefaults;
	                    NgTableParams.ngTableEventsChannel = ngTableEventsChannel;
	                    NgTableParams.ngTableSettings = ngTableSettings;
	                };
	                return NgTableParams;
	            }();
	            exports.NgTableParams = NgTableParams;
	            NgTableParams.init.$inject = ['$q', '$log', 'ngTableDefaults', 'ngTableEventsChannel', 'ngTableSettings'];
	
	            /***/
	        },
	        /* 10 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/ngTableSettings.ts ***!
	          \*************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * @private
	             */
	            var NgTableSettings = function () {
	                function NgTableSettings(ngTableDefaults, ngTableDefaultGetData, ngTableDefaultGetGroups) {
	                    var _this = this;
	                    this.ngTableDefaults = ngTableDefaults;
	                    this.ngTableDefaultGetData = ngTableDefaultGetData;
	                    this.ngTableDefaultGetGroups = ngTableDefaultGetGroups;
	                    this.defaults = {
	                        $loading: false,
	                        dataset: null,
	                        total: 0,
	                        defaultSort: 'desc',
	                        counts: [10, 25, 50, 100],
	                        filterOptions: {
	                            filterComparator: undefined,
	                            filterDelay: 500,
	                            filterDelayThreshold: 10000,
	                            filterFilterName: undefined,
	                            filterFn: undefined,
	                            filterLayout: 'stack'
	                        },
	                        getData: function getData(params) {
	                            return _this.ngTableDefaultGetData(params.settings().dataset, params);
	                        },
	                        getGroups: this.ngTableDefaultGetGroups,
	                        groupOptions: {
	                            defaultSort: 'asc',
	                            isExpanded: true
	                        },
	                        interceptors: [],
	                        paginationMaxBlocks: 11,
	                        paginationMinBlocks: 5,
	                        sortingIndicator: 'span'
	                    };
	                }
	                NgTableSettings.prototype.createDefaults = function () {
	                    return this.merge(this.defaults, this.ngTableDefaults.settings);
	                };
	                NgTableSettings.prototype.merge = function (existing, newSettings) {
	                    newSettings = ng1.extend({}, newSettings);
	                    if (newSettings.filterOptions) {
	                        newSettings.filterOptions = ng1.extend({}, existing.filterOptions || {}, newSettings.filterOptions);
	                    }
	                    if (newSettings.groupOptions) {
	                        newSettings.groupOptions = ng1.extend({}, existing.groupOptions || {}, newSettings.groupOptions);
	                    }
	                    if (ng1.isArray(newSettings.dataset)) {
	                        //auto-set the total from passed in dataset
	                        newSettings.total = newSettings.dataset.length;
	                    }
	                    var results = ng1.extend({}, existing, newSettings);
	                    if (ng1.isArray(newSettings.dataset)) {
	                        this.optimizeFilterDelay(results);
	                    }
	                    return ng1.extend({}, existing, newSettings);
	                };
	                NgTableSettings.prototype.optimizeFilterDelay = function (settings) {
	                    // don't debounce by default filter input when working with small synchronous datasets
	                    if (settings.filterOptions.filterDelay === this.defaults.filterOptions.filterDelay && settings.total <= settings.filterOptions.filterDelayThreshold && settings.getData === this.defaults.getData) {
	                        settings.filterOptions.filterDelay = 0;
	                    }
	                };
	                NgTableSettings.$inject = ['ngTableDefaults', 'ngTableDefaultGetData', 'ngTableDefaultGetGroups'];
	                return NgTableSettings;
	            }();
	            exports.NgTableSettings = NgTableSettings;
	
	            /***/
	        },
	        /* 11 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************!*\
	          !*** ./src/core/util.ts ***!
	          \**************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	            /**
	             * @private
	             */
	
	            function convertSortToOrderBy(sorting) {
	                var result = [];
	                for (var column in sorting) {
	                    result.push((sorting[column] === "asc" ? "+" : "-") + column);
	                }
	                return result;
	            }
	            exports.convertSortToOrderBy = convertSortToOrderBy;
	            /**
	             * @private
	             */
	            function isGroupingFun(val) {
	                return typeof val === 'function';
	            }
	            exports.isGroupingFun = isGroupingFun;
	
	            /***/
	        },,
	        /* 12 */
	        /* 13 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/ngTable.directive.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTable.$inject = ['$q', '$parse'];
	            /**
	             * Directive that instantiates {@link NgTableController NgTableController}.
	             * @ngdoc directive
	             * @name ngTable
	             * @example
	             *
	             * ```html
	             * <table ng-table="$ctrl.tableParams" show-filter="true" class="table table-bordered">
	             *  <tr ng-repeat="user in $data">
	             *      <td data-title="'Name'" sortable="'name'" filter="{ 'name': 'text' }">
	             *          {{user.name}}
	             *      </td>
	             *      <td data-title="'Age'" sortable="'age'" filter="{ 'age': 'text' }">
	             *          {{user.age}}
	             *      </td>
	             *  </tr>
	             * </table>
	             * ```
	             */
	            function ngTable($q, $parse) {
	                return {
	                    restrict: 'A',
	                    priority: 1001,
	                    scope: true,
	                    controller: 'ngTableController',
	                    compile: function compile(element) {
	                        var columns = [],
	                            i = 0,
	                            dataRow,
	                            groupRow;
	                        var rows = [];
	                        ng1.forEach(element.find('tr'), function (tr) {
	                            rows.push(ng1.element(tr));
	                        });
	                        dataRow = rows.filter(function (tr) {
	                            return !tr.hasClass('ng-table-group');
	                        })[0];
	                        groupRow = rows.filter(function (tr) {
	                            return tr.hasClass('ng-table-group');
	                        })[0];
	                        if (!dataRow) {
	                            return undefined;
	                        }
	                        ng1.forEach(dataRow.find('td'), function (item) {
	                            var el = ng1.element(item);
	                            if (el.attr('ignore-cell') && 'true' === el.attr('ignore-cell')) {
	                                return;
	                            }
	                            var getAttrValue = function getAttrValue(attr) {
	                                return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                            };
	                            var setAttrValue = function setAttrValue(attr, value) {
	                                if (el.attr('x-data-' + attr)) {
	                                    el.attr('x-data-' + attr, value);
	                                } else if (el.attr('data' + attr)) {
	                                    el.attr('data' + attr, value);
	                                } else {
	                                    el.attr(attr, value);
	                                }
	                            };
	                            var parsedAttribute = function parsedAttribute(attr) {
	                                var expr = getAttrValue(attr);
	                                if (!expr) {
	                                    return undefined;
	                                }
	                                var localValue;
	                                var getter = function getter(context) {
	                                    if (localValue !== undefined) {
	                                        return localValue;
	                                    }
	                                    return $parse(expr)(context);
	                                };
	                                getter.assign = function ($scope, value) {
	                                    var parsedExpr = $parse(expr);
	                                    if (parsedExpr.assign) {
	                                        // we should be writing back to the parent scope as this is where the expression
	                                        // came from
	                                        parsedExpr.assign($scope.$parent, value);
	                                    } else {
	                                        localValue = value;
	                                    }
	                                };
	                                return getter;
	                            };
	                            var titleExpr = getAttrValue('title-alt') || getAttrValue('title');
	                            if (titleExpr) {
	                                el.attr('data-title-text', '{{' + titleExpr + '}}'); // this used in responsive table
	                            }
	                            // NOTE TO MAINTAINERS: if you add extra fields to a $column be sure to extend ngTableColumn with
	                            // a corresponding "safe" default
	                            columns.push({
	                                id: i++,
	                                title: parsedAttribute('title'),
	                                titleAlt: parsedAttribute('title-alt'),
	                                headerTitle: parsedAttribute('header-title'),
	                                sortable: parsedAttribute('sortable'),
	                                'class': parsedAttribute('header-class'),
	                                filter: parsedAttribute('filter'),
	                                groupable: parsedAttribute('groupable'),
	                                headerTemplateURL: parsedAttribute('header'),
	                                filterData: parsedAttribute('filter-data'),
	                                show: el.attr("ng-if") ? parsedAttribute('ng-if') : undefined
	                            });
	                            if (groupRow || el.attr("ng-if")) {
	                                // change ng-if to bind to our column definition which we know will be writable
	                                // because this will potentially increase the $watch count, only do so if we already have an
	                                // ng-if or when we definitely need to change visibility of the columns.
	                                // currently only ngTableGroupRow directive needs to change visibility
	                                setAttrValue('ng-if', '$columns[' + (columns.length - 1) + '].show(this)');
	                            }
	                        });
	                        return function (scope, element, attrs, controller) {
	                            scope.$columns = columns = controller.buildColumns(columns);
	                            controller.setupBindingsToInternalScope(attrs.ngTable);
	                            controller.loadFilterData(columns);
	                            controller.compileDirectiveTemplates();
	                        };
	                    }
	                };
	            }
	            exports.ngTable = ngTable;
	
	            /***/
	        },
	        /* 14 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************!*\
	          !*** ./src/browser/ngTableColumn.ts ***!
	          \**************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * @private
	             */
	            function isScopeLike(object) {
	                return object != null && ng1.isFunction(object.$new);
	            }
	            /**
	             * @private
	             * Service to construct a $column definition used by {@link ngTable ngTable} directive
	             */
	            var NgTableColumn = function () {
	                function NgTableColumn() {}
	                /**
	                 * Creates a $column for use within a header template
	                 *
	                 * @param column the initial definition for $column to build
	                 * @param defaultScope the $scope to supply to the $column getter methods when not supplied by caller
	                 * @param columns a reference to the $columns array to make available on the context supplied to the
	                 * $column getter methods
	                 */
	                NgTableColumn.prototype.buildColumn = function (column, defaultScope, columns) {
	                    // note: we're not modifying the original column object. This helps to avoid unintended side affects
	                    var extendedCol = Object.create(column);
	                    var defaults = this.createDefaults();
	                    var _loop_1 = function _loop_1(prop) {
	                        if (extendedCol[prop] === undefined) {
	                            extendedCol[prop] = defaults[prop];
	                        }
	                        if (!ng1.isFunction(extendedCol[prop])) {
	                            // wrap raw field values with "getter" functions
	                            // - this is to ensure consistency with how ngTable.compile builds columns
	                            // - note that the original column object is being "proxied"; this is important
	                            //   as it ensure that any changes to the original object will be returned by the "getter"
	                            var getterSetter = function getterSetter() {
	                                if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                    getterSetter.assign(null, arguments[0]);
	                                } else {
	                                    return column[prop];
	                                }
	                            };
	                            getterSetter.assign = function ($scope, value) {
	                                column[prop] = value;
	                            };
	                            extendedCol[prop] = getterSetter;
	                        }
	                        // satisfy the arguments expected by the function returned by parsedAttribute in the ngTable directive
	                        var getterFn = extendedCol[prop];
	                        extendedCol[prop] = function () {
	                            if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                getterFn.assign(defaultScope, arguments[0]);
	                            } else {
	                                var scope = arguments[0] || defaultScope;
	                                var context = Object.create(scope);
	                                ng1.extend(context, {
	                                    $column: extendedCol,
	                                    $columns: columns
	                                });
	                                return getterFn.call(column, context);
	                            }
	                        };
	                        if (getterFn.assign) {
	                            extendedCol[prop].assign = getterFn.assign;
	                        } else {
	                            var wrappedGetterFn_1 = extendedCol[prop];
	                            var localValue_1;
	                            var getterSetter = function getterSetter() {
	                                if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                                    getterSetter.assign(null, arguments[0]);
	                                } else {
	                                    return localValue_1 != undefined ? localValue_1 : wrappedGetterFn_1.apply(extendedCol, arguments);
	                                }
	                            };
	                            getterSetter.assign = function ($scope, value) {
	                                localValue_1 = value;
	                            };
	                            extendedCol[prop] = getterSetter;
	                        }
	                    };
	                    for (var prop in defaults) {
	                        _loop_1(prop);
	                    }
	                    return extendedCol;
	                };
	                NgTableColumn.prototype.createDefaults = function () {
	                    return {
	                        'class': this.createGetterSetter(''),
	                        filter: this.createGetterSetter(false),
	                        groupable: this.createGetterSetter(false),
	                        filterData: ng1.noop,
	                        headerTemplateURL: this.createGetterSetter(false),
	                        headerTitle: this.createGetterSetter(''),
	                        sortable: this.createGetterSetter(false),
	                        show: this.createGetterSetter(true),
	                        title: this.createGetterSetter(''),
	                        titleAlt: this.createGetterSetter('')
	                    };
	                };
	                NgTableColumn.prototype.createGetterSetter = function (initialValue) {
	                    var value = initialValue;
	                    var getterSetter = function getterSetter() {
	                        if (arguments.length === 1 && !isScopeLike(arguments[0])) {
	                            getterSetter.assign(null, arguments[0]);
	                        } else {
	                            return value;
	                        }
	                    };
	                    getterSetter.assign = function ($scope, newValue) {
	                        value = newValue;
	                    };
	                    return getterSetter;
	                };
	                NgTableColumn.$inject = [];
	                return NgTableColumn;
	            }();
	            exports.NgTableColumn = NgTableColumn;
	
	            /***/
	        },
	        /* 15 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************************!*\
	          !*** ./src/browser/ngTableColumnsBinding.directive.ts ***!
	          \********************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            ngTableColumnsBinding.$inject = ["$parse"];
	            /**
	             * One-way data binds the $columns array generated by ngTable/ngTableDynamic to the specified
	             * expression.
	             * This allows the $columns array created for the table to be accessed outside of the html table
	             * markup.
	             *
	             * @ngdoc directive
	             *
	             * @example
	             * ```html
	             * <table ng-table="$ctrl.tableParams" class="table" ng-table-columns-binding="$ctlr.tableColumns">
	             * ```
	             */
	            function ngTableColumnsBinding($parse) {
	                var directive = {
	                    restrict: 'A',
	                    link: linkFn
	                };
	                return directive;
	                function linkFn($scope, $element, $attrs) {
	                    var setter = $parse($attrs.ngTableColumnsBinding).assign;
	                    if (setter) {
	                        $scope.$watch('$columns', function (newColumns) {
	                            var shallowClone = (newColumns || []).slice(0);
	                            setter($scope, shallowClone);
	                        });
	                    }
	                }
	            }
	            exports.ngTableColumnsBinding = ngTableColumnsBinding;
	
	            /***/
	        },
	        /* 16 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/ngTableController.ts ***!
	          \******************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var core_1 = __webpack_require__( /*! ../core */1);
	            /**
	             * The controller for the {@link ngTable ngTable} and {@link ngTableDynamic ngTableDynamic} directives
	             */
	            var NgTableController = function () {
	                function NgTableController($scope, $timeout, $parse, $compile, $attrs, $element, $document, ngTableColumn, ngTableEventsChannel) {
	                    this.$scope = $scope;
	                    this.$parse = $parse;
	                    this.$compile = $compile;
	                    this.$attrs = $attrs;
	                    this.$element = $element;
	                    this.$document = $document;
	                    this.ngTableColumn = ngTableColumn;
	                    this.ngTableEventsChannel = ngTableEventsChannel;
	                    var isFirstTimeLoad = true;
	                    $scope.$filterRow = { disabled: false };
	                    $scope.$loading = false;
	                    // until such times as the directive uses an isolated scope, we need to ensure that the check for
	                    // the params field only consults the "own properties" of the $scope. This is to avoid seeing the params
	                    // field on a $scope higher up in the prototype chain
	                    if (!$scope.hasOwnProperty("params")) {
	                        $scope.params = new core_1.NgTableParams(true);
	                    }
	                    this.delayFilter = function () {
	                        var timer;
	                        return function (callback, ms) {
	                            $timeout.cancel(timer);
	                            timer = $timeout(callback, ms);
	                        };
	                    }();
	                    // watch for when a new NgTableParams is bound to the scope
	                    // CRITICAL: the watch must be for reference and NOT value equality; this is because NgTableParams maintains
	                    // the current data page as a field. Checking this for value equality would be terrible for performance
	                    // and potentially cause an error if the items in that array has circular references
	                    this.$scope.$watch('params', function (newParams, oldParams) {
	                        if (newParams === oldParams || !newParams) {
	                            return;
	                        }
	                        newParams.reload();
	                    }, false);
	                    this.subscribeToTableEvents();
	                }
	                Object.defineProperty(NgTableController.prototype, "hasVisibleFilterColumn", {
	                    get: function get() {
	                        var _this = this;
	                        if (!this.$scope.$columns) return false;
	                        return this.some(this.$scope.$columns, function ($column) {
	                            return $column.show(_this.$scope) && !!$column.filter(_this.$scope);
	                        });
	                    },
	                    enumerable: true,
	                    configurable: true
	                });
	                NgTableController.prototype.onDataReloadStatusChange = function (newStatus /*, oldStatus*/) {
	                    if (!newStatus || this.$scope.params.hasErrorState()) {
	                        return;
	                    }
	                    var currentParams = this.$scope.params;
	                    var filterOptions = currentParams.settings().filterOptions;
	                    if (currentParams.hasFilterChanges()) {
	                        var applyFilter = function applyFilter() {
	                            currentParams.page(1);
	                            currentParams.reload();
	                        };
	                        if (filterOptions.filterDelay) {
	                            this.delayFilter(applyFilter, filterOptions.filterDelay);
	                        } else {
	                            applyFilter();
	                        }
	                    } else {
	                        currentParams.reload();
	                    }
	                };
	                NgTableController.prototype.compileDirectiveTemplates = function () {
	                    if (!this.$element.hasClass('ng-table')) {
	                        this.$scope.templates = {
	                            header: this.$attrs.templateHeader ? this.$attrs.templateHeader : 'ng-table/header.html',
	                            pagination: this.$attrs.templatePagination ? this.$attrs.templatePagination : 'ng-table/pager.html'
	                        };
	                        // console.log('this.$element', this.$element);
	                        this.$element.addClass('ng-table');
	                        var headerTemplate = null;
	                        // $element.find('> thead').length === 0 doesn't work on jqlite
	                        var theadFound_1 = false;
	                        ng1.forEach(this.$element.children(), function (e) {
	                            if (e.tagName === 'THEAD') {
	                                theadFound_1 = true;
	                            }
	                        });
	                        if (!theadFound_1) {
	                            headerTemplate = ng1.element('<thead ng-include="templates.header"></thead>', this.$document);
	                            if (this.$element.find('table').length) {
	                                this.$element.find('table').prepend(headerTemplate);
	                            } else {
	                                this.$element.prepend(headerTemplate);
	                            }
	                        }
	                        var paginationTemplate = ng1.element('<div ng-table-pagination="params" template-url="templates.pagination"></div>', this.$document);
	                        this.$element.after(paginationTemplate);
	                        if (headerTemplate) {
	                            this.$compile(headerTemplate)(this.$scope);
	                        }
	                        this.$compile(paginationTemplate)(this.$scope);
	                    }
	                };
	                NgTableController.prototype.loadFilterData = function ($columns) {
	                    var _this = this;
	                    ng1.forEach($columns, function ($column) {
	                        var result = $column.filterData(_this.$scope);
	                        if (!result) {
	                            delete $column.filterData;
	                            return undefined;
	                        }
	                        if (isPromiseLike(result)) {
	                            delete $column.filterData;
	                            return result.then(function (data) {
	                                // our deferred can eventually return arrays, functions and objects
	                                if (!ng1.isArray(data) && !ng1.isFunction(data) && !ng1.isObject(data)) {
	                                    // if none of the above was found - we just want an empty array
	                                    data = [];
	                                }
	                                $column.data = data;
	                            });
	                        } else {
	                            return $column.data = result;
	                        }
	                    });
	                    function isPromiseLike(val) {
	                        return val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && typeof val.then === 'function';
	                    }
	                };
	                NgTableController.prototype.buildColumns = function (columns) {
	                    var _this = this;
	                    // todo: use strictNullChecks and remove guard clause
	                    var result = [];
	                    (columns || []).forEach(function (col) {
	                        result.push(_this.ngTableColumn.buildColumn(col, _this.$scope, result));
	                    });
	                    return result;
	                };
	                NgTableController.prototype.parseNgTableDynamicExpr = function (attr) {
	                    if (!attr || attr.indexOf(" with ") > -1) {
	                        var parts = attr.split(/\s+with\s+/);
	                        return {
	                            tableParams: parts[0],
	                            columns: parts[1]
	                        };
	                    } else {
	                        throw new Error('Parse error (expected example: ng-table-dynamic=\'tableParams with cols\')');
	                    }
	                };
	                NgTableController.prototype.setupBindingsToInternalScope = function (tableParamsExpr) {
	                    // note: this we're setting up watches to simulate angular's isolated scope bindings
	                    var _this = this;
	                    // note: is REALLY important to watch for a change to the ngTableParams *reference* rather than
	                    // $watch for value equivalence. This is because ngTableParams references the current page of data as
	                    // a field and it's important not to watch this
	                    this.$scope.$watch(tableParamsExpr, function (params) {
	                        if (params === undefined) {
	                            return;
	                        }
	                        _this.$scope.params = params;
	                    }, false);
	                    this.setupFilterRowBindingsToInternalScope();
	                    this.setupGroupRowBindingsToInternalScope();
	                };
	                NgTableController.prototype.setupFilterRowBindingsToInternalScope = function () {
	                    var _this = this;
	                    if (this.$attrs.showFilter) {
	                        this.$scope.$parent.$watch(this.$attrs.showFilter, function (value) {
	                            _this.$scope.show_filter = value;
	                        });
	                    } else {
	                        this.$scope.$watch(function () {
	                            return _this.hasVisibleFilterColumn;
	                        }, function (value) {
	                            _this.$scope.show_filter = value;
	                        });
	                    }
	                    if (this.$attrs.disableFilter) {
	                        this.$scope.$parent.$watch(this.$attrs.disableFilter, function (value) {
	                            _this.$scope.$filterRow.disabled = value;
	                        });
	                    }
	                };
	                NgTableController.prototype.setupGroupRowBindingsToInternalScope = function () {
	                    var _this = this;
	                    this.$scope.$groupRow = { show: false };
	                    if (this.$attrs.showGroup) {
	                        var showGroupGetter_1 = this.$parse(this.$attrs.showGroup);
	                        this.$scope.$parent.$watch(showGroupGetter_1, function (value) {
	                            _this.$scope.$groupRow.show = value;
	                        });
	                        if (showGroupGetter_1.assign) {
	                            // setup two-way databinding thus allowing ngTableGrowRow to assign to the showGroup expression
	                            this.$scope.$watch('$groupRow.show', function (value) {
	                                showGroupGetter_1.assign(_this.$scope.$parent, value);
	                            });
	                        }
	                    } else {
	                        this.$scope.$watch('params.hasGroup()', function (newValue) {
	                            _this.$scope.$groupRow.show = newValue;
	                        });
	                    }
	                };
	                NgTableController.prototype.getVisibleColumns = function () {
	                    var _this = this;
	                    return (this.$scope.$columns || []).filter(function (c) {
	                        return c.show(_this.$scope);
	                    });
	                };
	                NgTableController.prototype.subscribeToTableEvents = function () {
	                    var _this = this;
	                    this.$scope.$watch('params.isDataReloadRequired()', function (newStatus /*, oldStatus*/) {
	                        _this.onDataReloadStatusChange(newStatus);
	                    });
	                    this.ngTableEventsChannel.onAfterReloadData(function (params, newDatapage) {
	                        var visibleColumns = _this.getVisibleColumns();
	                        if (params.hasGroup()) {
	                            _this.$scope.$groups = newDatapage || [];
	                            _this.$scope.$groups.visibleColumnCount = visibleColumns.length;
	                        } else {
	                            _this.$scope.$data = newDatapage || [];
	                            _this.$scope.$data.visibleColumnCount = visibleColumns.length;
	                        }
	                    }, this.$scope, function (publisher) {
	                        return _this.$scope.params === publisher;
	                    });
	                    this.ngTableEventsChannel.onPagesChanged(function (params, newPages) {
	                        _this.$scope.pages = newPages;
	                    }, this.$scope, function (publisher) {
	                        return _this.$scope.params === publisher;
	                    });
	                };
	                NgTableController.prototype.some = function (array, predicate) {
	                    var found = false;
	                    for (var i = 0; i < array.length; i++) {
	                        var obj = array[i];
	                        if (predicate(obj)) {
	                            found = true;
	                            break;
	                        }
	                    }
	                    return found;
	                };
	                NgTableController.$inject = ['$scope', '$timeout', '$parse', '$compile', '$attrs', '$element', '$document', 'ngTableColumn', 'ngTableEventsChannel'];
	                return NgTableController;
	            }();
	            exports.NgTableController = NgTableController;
	
	            /***/
	        },
	        /* 17 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************************!*\
	          !*** ./src/browser/ngTableDynamic.directive.ts ***!
	          \*************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTableDynamic.$inject = [];
	            /**
	             * A dynamic version of the {@link ngTable ngTable} directive that accepts a dynamic list of columns
	             * definitions to render
	             * @ngdoc directive
	             *
	             * @example
	             * ```html
	             * <table ng-table-dynamic="$ctrl.tableParams with $ctrl.cols" class="table">
	             *  <tr ng-repeat="row in $data">
	             *    <td ng-repeat="col in $columns">{{row[col.field]}}</td>
	             *  </tr>
	             * </table>
	             * ```
	             */
	            function ngTableDynamic() {
	                return {
	                    restrict: 'A',
	                    priority: 1001,
	                    scope: true,
	                    controller: 'ngTableController',
	                    compile: function compile(tElement) {
	                        var row;
	                        // IE 8 fix :not(.ng-table-group) selector
	                        ng1.forEach(tElement.find('tr'), function (tr) {
	                            tr = ng1.element(tr);
	                            if (!tr.hasClass('ng-table-group') && !row) {
	                                row = tr;
	                            }
	                        });
	                        if (!row) {
	                            return undefined;
	                        }
	                        ng1.forEach(row.find('td'), function (item) {
	                            var el = ng1.element(item);
	                            var getAttrValue = function getAttrValue(attr) {
	                                return el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr);
	                            };
	                            // this used in responsive table
	                            var titleExpr = getAttrValue('title');
	                            if (!titleExpr) {
	                                el.attr('data-title-text', '{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}');
	                            }
	                            var showExpr = el.attr('ng-if');
	                            if (!showExpr) {
	                                el.attr('ng-if', '$columns[$index].show(this)');
	                            }
	                        });
	                        return function (scope, element, attrs, controller) {
	                            var expr = controller.parseNgTableDynamicExpr(attrs.ngTableDynamic);
	                            controller.setupBindingsToInternalScope(expr.tableParams);
	                            controller.compileDirectiveTemplates();
	                            scope.$watchCollection(expr.columns, function (newCols /*, oldCols*/) {
	                                scope.$columns = controller.buildColumns(newCols);
	                                controller.loadFilterData(scope.$columns);
	                            });
	                        };
	                    }
	                };
	            }
	            exports.ngTableDynamic = ngTableDynamic;
	
	            /***/
	        },
	        /* 18 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/browser/ngTableFilterConfig.ts ***!
	          \********************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * The angular provider used to configure the behaviour of the `NgTableFilterConfig` service.
	             */
	            var NgTableFilterConfigProvider = function () {
	                function NgTableFilterConfigProvider($injector) {
	                    var _this = this;
	                    this.defaultConfig = {
	                        defaultBaseUrl: 'ng-table/filters/',
	                        defaultExt: '.html',
	                        aliasUrls: {}
	                    };
	                    this.$get = function () {
	                        return $injector.instantiate(NgTableFilterConfig, { config: ng1.copy(_this.config) });
	                    };
	                    this.$get.$inject = [];
	                    this.resetConfigs();
	                }
	                /**
	                 * Reset back to factory defaults the config values that `NgTableFilterConfig` service will use
	                 */
	                NgTableFilterConfigProvider.prototype.resetConfigs = function () {
	                    this.config = this.defaultConfig;
	                };
	                /**
	                 * Set the config values used by `NgTableFilterConfig` service
	                 */
	                NgTableFilterConfigProvider.prototype.setConfig = function (customConfig) {
	                    var mergeConfig = ng1.extend({}, this.config, customConfig);
	                    mergeConfig.aliasUrls = ng1.extend({}, this.config.aliasUrls, customConfig.aliasUrls);
	                    this.config = mergeConfig;
	                };
	                NgTableFilterConfigProvider.$inject = ['$injector'];
	                return NgTableFilterConfigProvider;
	            }();
	            exports.NgTableFilterConfigProvider = NgTableFilterConfigProvider;
	            /**
	             * Exposes configuration values and methods used to return the location of the html
	             * templates used to render the filter row of an ng-table directive
	             */
	            var NgTableFilterConfig = function () {
	                function NgTableFilterConfig(
	                /**
	                 * Readonly copy of the final values used to configure the service.
	                 */
	                config) {
	                    this.config = config;
	                }
	                /**
	                 * Return the url of the html filter template registered with the alias supplied
	                 */
	                NgTableFilterConfig.prototype.getUrlForAlias = function (aliasName, filterKey) {
	                    return this.config.aliasUrls[aliasName] || this.config.defaultBaseUrl + aliasName + this.config.defaultExt;
	                };
	                /**
	                 * Return the url of the html filter template for the supplied definition and key.
	                 * For more information see the documentation for {@link IFilterTemplateMap}
	                 */
	                NgTableFilterConfig.prototype.getTemplateUrl = function (filterDef, filterKey) {
	                    var filterName;
	                    if (typeof filterDef !== 'string') {
	                        filterName = filterDef.id;
	                    } else {
	                        filterName = filterDef;
	                    }
	                    if (filterName.indexOf('/') !== -1) {
	                        return filterName;
	                    }
	                    return this.getUrlForAlias(filterName, filterKey);
	                };
	                NgTableFilterConfig.$inject = ['config'];
	                return NgTableFilterConfig;
	            }();
	            exports.NgTableFilterConfig = NgTableFilterConfig;
	
	            /***/
	        },
	        /* 19 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableFilterRow.directive.ts ***!
	          \***************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./filterRow.html */42);
	            ngTableFilterRow.$inject = [];
	            /**
	             * directive that renders the filter header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-filter-row></ng-table-filter-row>
	             * ```
	             */
	            function ngTableFilterRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableFilterRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableFilterRow = ngTableFilterRow;
	
	            /***/
	        },
	        /* 20 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableFilterRowController.ts ***!
	          \***************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Controller for the {@link ngTableFilterRow ngTableFilterRow} directive
	             */
	
	            var NgTableFilterRowController = function () {
	                function NgTableFilterRowController($scope, ngTableFilterConfig) {
	                    this.config = ngTableFilterConfig;
	                    // todo: stop doing this. Why?
	                    // * scope inheritance makes it hard to know how supplies functions
	                    // * scope is not a concept in angular 2
	                    // make function available to filter templates
	                    $scope.getFilterPlaceholderValue = this.getFilterPlaceholderValue.bind(this);
	                }
	                NgTableFilterRowController.prototype.getFilterCellCss = function (filter, layout) {
	                    if (layout !== 'horizontal') {
	                        return 's12';
	                    }
	                    var size = Object.keys(filter).length;
	                    var width = parseInt((12 / size).toString(), 10);
	                    return 's' + width;
	                };
	                NgTableFilterRowController.prototype.getFilterPlaceholderValue = function (filterDef, filterKey) {
	                    if (typeof filterDef === 'string') {
	                        return '';
	                    } else {
	                        return filterDef.placeholder;
	                    }
	                };
	                NgTableFilterRowController.$inject = ['$scope', 'ngTableFilterConfig'];
	                return NgTableFilterRowController;
	            }();
	            exports.NgTableFilterRowController = NgTableFilterRowController;
	
	            /***/
	        },
	        /* 21 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/ngTableGroupRow.directive.ts ***!
	          \**************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./groupRow.html */47);
	            ngTableGroupRow.$inject = [];
	            /**
	             * directive that renders the group header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-group-row></ng-table-group-row>
	             * ```
	             */
	            function ngTableGroupRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableGroupRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableGroupRow = ngTableGroupRow;
	
	            /***/
	        },
	        /* 22 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/ngTableGroupRowController.ts ***!
	          \**************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	            /**
	             * Controller for the {@link ngTableGroupRow ngTableGroupRow} directive
	             */
	
	            var NgTableGroupRowController = function () {
	                function NgTableGroupRowController($scope) {
	                    var _this = this;
	                    this.$scope = $scope;
	                    this.groupFns = [];
	                    $scope.$watch('params.group()', function (newGrouping) {
	                        _this.setGroup(newGrouping);
	                    }, true);
	                }
	                NgTableGroupRowController.prototype.getGroupables = function () {
	                    var _this = this;
	                    var groupableCols = this.$scope.$columns.filter(function ($column) {
	                        return !!$column.groupable(_this.$scope);
	                    });
	                    return this.groupFns.concat(groupableCols);
	                };
	                NgTableGroupRowController.prototype.getGroupTitle = function (group) {
	                    return this.isGroupingFunc(group) ? group.title : group.title(this.$scope);
	                };
	                NgTableGroupRowController.prototype.getVisibleColumns = function () {
	                    var _this = this;
	                    return this.$scope.$columns.filter(function ($column) {
	                        return $column.show(_this.$scope);
	                    });
	                };
	                NgTableGroupRowController.prototype.groupBy = function (group) {
	                    if (this.isSelectedGroup(group)) {
	                        this.changeSortDirection();
	                    } else {
	                        if (this.isGroupingFunc(group)) {
	                            this.$scope.params.group(group);
	                        } else {
	                            // it's OK, we know that groupable will return a string
	                            // this is guaranteed by getGroupables returning only
	                            // columns that return (truthy) strings
	                            this.$scope.params.group(group.groupable(this.$scope));
	                        }
	                    }
	                };
	                NgTableGroupRowController.prototype.isSelectedGroup = function (group) {
	                    if (this.isGroupingFunc(group)) {
	                        return group === this.$scope.$selGroup;
	                    } else {
	                        return group.groupable(this.$scope) === this.$scope.$selGroup;
	                    }
	                };
	                NgTableGroupRowController.prototype.toggleDetail = function () {
	                    this.$scope.params.settings().groupOptions.isExpanded = !this.$scope.params.settings().groupOptions.isExpanded;
	                    return this.$scope.params.reload();
	                };
	                NgTableGroupRowController.prototype.changeSortDirection = function () {
	                    var newDirection;
	                    if (this.$scope.params.hasGroup(this.$scope.$selGroup, 'asc')) {
	                        newDirection = 'desc';
	                    } else if (this.$scope.params.hasGroup(this.$scope.$selGroup, 'desc')) {
	                        newDirection = '';
	                    } else {
	                        newDirection = 'asc';
	                    }
	                    this.$scope.params.group(this.$scope.$selGroup, newDirection);
	                };
	                NgTableGroupRowController.prototype.findGroupColumn = function (groupKey) {
	                    var _this = this;
	                    return this.$scope.$columns.filter(function ($column) {
	                        return $column.groupable(_this.$scope) === groupKey;
	                    })[0];
	                };
	                NgTableGroupRowController.prototype.isGroupingFunc = function (val) {
	                    return typeof val === 'function';
	                };
	                NgTableGroupRowController.prototype.setGroup = function (grouping) {
	                    var existingGroupCol = this.findGroupColumn(this.$scope.$selGroup);
	                    if (existingGroupCol && existingGroupCol.show.assign) {
	                        existingGroupCol.show.assign(this.$scope, true);
	                    }
	                    if (this.isGroupingFunc(grouping)) {
	                        this.groupFns = [grouping];
	                        this.$scope.$selGroup = grouping;
	                        this.$scope.$selGroupTitle = grouping.title;
	                    } else {
	                        // note: currently only one group is implemented
	                        var groupKey = Object.keys(grouping || {})[0];
	                        var groupedColumn = this.findGroupColumn(groupKey);
	                        if (groupedColumn) {
	                            this.$scope.$selGroupTitle = groupedColumn.title(this.$scope);
	                            this.$scope.$selGroup = groupKey;
	                            if (groupedColumn.show.assign) {
	                                groupedColumn.show.assign(this.$scope, false);
	                            }
	                        }
	                    }
	                };
	                NgTableGroupRowController.$inject = ['$scope'];
	                return NgTableGroupRowController;
	            }();
	            exports.NgTableGroupRowController = NgTableGroupRowController;
	
	            /***/
	        },
	        /* 23 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!****************************************************!*\
	          !*** ./src/browser/ngTablePagination.directive.ts ***!
	          \****************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            ngTablePagination.$inject = ['$compile', '$document', 'ngTableEventsChannel'];
	            /**
	             * Directive that renders the table pagination controls
	             * @ngdoc directive
	             */
	            function ngTablePagination($compile, $document, ngTableEventsChannel) {
	                return {
	                    restrict: 'A',
	                    scope: {
	                        'params': '=ngTablePagination',
	                        'templateUrl': '='
	                    },
	                    replace: false,
	                    link: function link(scope, element /*, attrs*/) {
	                        ngTableEventsChannel.onAfterReloadData(function (pubParams) {
	                            scope.pages = pubParams.generatePagesArray();
	                        }, scope, function (pubParams) {
	                            return pubParams === scope.params;
	                        });
	                        scope.$watch('templateUrl', function (templateUrl) {
	                            if (templateUrl === undefined) {
	                                return;
	                            }
	                            var template = ng1.element('<div ng-include="templateUrl"></div>', $document);
	                            element.append(template);
	                            $compile(template)(scope);
	                        });
	                    }
	                };
	            }
	            exports.ngTablePagination = ngTablePagination;
	
	            /***/
	        },
	        /* 24 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************************!*\
	          !*** ./src/browser/ngTableSelectFilterDs.directive.ts ***!
	          \********************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            ngTableSelectFilterDs.$inject = [];
	            /**
	             * Takes the array returned by $column.filterData and makes it available as `$selectData` on the `$scope`.
	             *
	             * The resulting `$selectData` array will contain an extra item that is suitable to represent the user
	             * "deselecting" an item from a `<select>` tag
	             *
	             * This directive is is focused on providing a datasource to an `ngOptions` directive
	             */
	            function ngTableSelectFilterDs() {
	                // note: not using isolated or child scope "by design"
	                // this is to allow this directive to be combined with other directives that do
	                var directive = {
	                    restrict: 'A',
	                    controller: NgTableSelectFilterDsController
	                };
	                return directive;
	            }
	            exports.ngTableSelectFilterDs = ngTableSelectFilterDs;
	            /**
	             * @private
	             */
	            var NgTableSelectFilterDsController = function () {
	                function NgTableSelectFilterDsController($scope, $parse, $attrs, $q) {
	                    var _this = this;
	                    this.$scope = $scope;
	                    this.$attrs = $attrs;
	                    this.$q = $q;
	                    this.$column = $parse($attrs.ngTableSelectFilterDs)($scope);
	                    $scope.$watch(function () {
	                        return _this.$column && _this.$column.data;
	                    }, function () {
	                        _this.bindDataSource();
	                    });
	                }
	                NgTableSelectFilterDsController.prototype.bindDataSource = function () {
	                    var _this = this;
	                    this.getSelectListData(this.$column).then(function (data) {
	                        if (data && !_this.hasEmptyOption(data)) {
	                            // data.unshift({ value: '', name: 'Seleccione' });
	                        }
	                        data = data || [];
	                        _this.$scope.$selectData = data;
	                    });
	                };
	                NgTableSelectFilterDsController.prototype.hasEmptyOption = function (data) {
	                    var isMatch;
	                    for (var i = 0; i < data.length; i++) {
	                        var item = data[i];
	                        if (item && item.id === '') {
	                            isMatch = true;
	                            break;
	                        }
	                    }
	                    return isMatch;
	                };
	                NgTableSelectFilterDsController.prototype.getSelectListData = function ($column) {
	                    var dataInput = $column.data;
	                    if (dataInput instanceof Array) {
	                        return this.$q.when(dataInput);
	                    } else {
	                        return this.$q.when(dataInput && dataInput());
	                    }
	                };
	                NgTableSelectFilterDsController.$inject = ['$scope', '$parse', '$attrs', '$q'];
	                return NgTableSelectFilterDsController;
	            }();
	            exports.NgTableSelectFilterDsController = NgTableSelectFilterDsController;
	
	            /***/
	        },
	        /* 25 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableSorterRow.directive.ts ***!
	          \***************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var templateUrl = __webpack_require__( /*! ./sorterRow.html */50);
	            ngTableSorterRow.$inject = [];
	            /**
	             * directive that renders the sorting header row for a table
	             * @ngdoc directive
	             * @example
	             * ```html
	             * <ng-table-sorter-row></ng-table-sorter-row>
	             * ```
	             */
	            function ngTableSorterRow() {
	                var directive = {
	                    restrict: 'E',
	                    replace: true,
	                    templateUrl: templateUrl,
	                    scope: true,
	                    controller: 'ngTableSorterRowController',
	                    controllerAs: '$ctrl'
	                };
	                return directive;
	            }
	            exports.ngTableSorterRow = ngTableSorterRow;
	
	            /***/
	        },
	        /* 26 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************************!*\
	          !*** ./src/browser/ngTableSorterRowController.ts ***!
	          \***************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	            /**
	             * Controller for the {@link ngTableSorterRow ngTableSorterRow} directive
	             */
	
	            var NgTableSorterRowController = function () {
	                function NgTableSorterRowController($scope) {
	                    this.$scope = $scope;
	                }
	                NgTableSorterRowController.prototype.sortBy = function ($column, event) {
	                    var parsedSortable = $column.sortable && $column.sortable();
	                    if (!parsedSortable || typeof parsedSortable !== 'string') {
	                        return;
	                    } else {
	                        var defaultSort = this.$scope.params.settings().defaultSort;
	                        var inverseSort = defaultSort === 'asc' ? 'desc' : 'asc';
	                        var sorting = this.$scope.params.sorting() && this.$scope.params.sorting()[parsedSortable] && this.$scope.params.sorting()[parsedSortable] === defaultSort;
	                        var sortingParams = event.ctrlKey || event.metaKey ? this.$scope.params.sorting() : {};
	                        sortingParams[parsedSortable] = sorting ? inverseSort : defaultSort;
	                        this.$scope.params.parameters({
	                            sorting: sortingParams
	                        });
	                    }
	                };
	                NgTableSorterRowController.$inject = ['$scope'];
	                return NgTableSorterRowController;
	            }();
	            exports.NgTableSorterRowController = NgTableSorterRowController;
	
	            /***/
	        },
	        /* 27 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/browser/public-interfaces.ts ***!
	          \******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 28 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/core/data/dataSettings.ts ***!
	          \***************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 29 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/data/getData.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 30 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************!*\
	          !*** ./src/core/data/interceptor.ts ***!
	          \**************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 31 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************************!*\
	          !*** ./src/core/data/ngTableDefaultGetData.ts ***!
	          \************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            /**
	             * ngTable: Table + Angular JS
	             *
	             * @author Vitalii Savchuk <esvit666@gmail.com>
	             * @url https://github.com/esvit/ng-table/
	             * @license New BSD License <http://creativecommons.org/licenses/BSD/>
	             */
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            /**
	             * Implementation of the {@link IDefaultGetDataProvider} interface
	             */
	            var NgTableDefaultGetDataProvider = function () {
	                function NgTableDefaultGetDataProvider() {
	                    /**
	                     * The name of a angular filter that knows how to apply the values returned by
	                     * `NgTableParams.filter()` to restrict an array of data.
	                     * (defaults to the angular `filter` filter service)
	                     */
	                    this.filterFilterName = 'filter';
	                    /**
	                     * The name of a angular filter that knows how to apply the values returned by
	                    * `NgTableParams.orderBy()` to sort an array of data.
	                    * (defaults to the angular `orderBy` filter service)
	                    */
	                    this.sortingFilterName = 'orderBy';
	                    var provider = this;
	                    this.$get = ngTableDefaultGetData;
	                    ngTableDefaultGetData.$inject = ['$filter', 'ngTableEventsChannel'];
	                    function ngTableDefaultGetData($filter, ngTableEventsChannel) {
	                        var defaultDataOptions = { applyFilter: true, applySort: true, applyPaging: true };
	                        getData.applyPaging = applyPaging;
	                        getData.getFilterFn = getFilterFn;
	                        getData.getOrderByFn = getOrderByFn;
	                        return getData;
	                        function getFilterFn(params) {
	                            var filterOptions = params.settings().filterOptions;
	                            if (ng1.isFunction(filterOptions.filterFn)) {
	                                return filterOptions.filterFn;
	                            } else {
	                                return $filter(filterOptions.filterFilterName || provider.filterFilterName);
	                            }
	                        }
	                        function getOrderByFn(params) {
	                            return $filter(provider.sortingFilterName);
	                        }
	                        function applyFilter(data, params) {
	                            if (!params.hasFilter()) {
	                                return data;
	                            }
	                            var filter = params.filter(true);
	                            var filterKeys = Object.keys(filter);
	                            var parsedFilter = filterKeys.reduce(function (result, key) {
	                                result = setPath(result, filter[key], key);
	                                return result;
	                            }, {});
	                            var filterFn = getFilterFn(params);
	                            return filterFn.call(params, data, parsedFilter, params.settings().filterOptions.filterComparator);
	                        }
	                        function applyPaging(data, params) {
	                            var pagedData = data.slice((params.page() - 1) * params.count(), params.page() * params.count());
	                            params.total(data.length); // set total for recalc pagination
	                            return pagedData;
	                        }
	                        function applySort(data, params) {
	                            var orderBy = params.orderBy();
	                            var orderByFn = getOrderByFn(params);
	                            return orderBy.length ? orderByFn(data, orderBy) : data;
	                        }
	                        function getData(data, params) {
	                            if (data == null) {
	                                return [];
	                            }
	                            var options = ng1.extend({}, defaultDataOptions, params.settings().dataOptions);
	                            var fData = options.applyFilter ? applyFilter(data, params) : data;
	                            ngTableEventsChannel.publishAfterDataFiltered(params, fData);
	                            var orderedData = options.applySort ? applySort(fData, params) : fData;
	                            ngTableEventsChannel.publishAfterDataSorted(params, orderedData);
	                            return options.applyPaging ? applyPaging(orderedData, params) : orderedData;
	                        }
	                        // Sets the value at any depth in a nested object based on the path
	                        // note: adapted from: underscore-contrib#setPath
	                        function setPath(obj, value, path) {
	                            var keys = path.split('.');
	                            var ret = obj;
	                            var lastKey = keys[keys.length - 1];
	                            var target = ret;
	                            var parentPathKeys = keys.slice(0, keys.length - 1);
	                            parentPathKeys.forEach(function (key) {
	                                if (!target.hasOwnProperty(key)) {
	                                    target[key] = {};
	                                }
	                                target = target[key];
	                            });
	                            target[lastKey] = value;
	                            return ret;
	                        }
	                    }
	                }
	                return NgTableDefaultGetDataProvider;
	            }();
	            exports.NgTableDefaultGetDataProvider = NgTableDefaultGetDataProvider;
	
	            /***/
	        },
	        /* 32 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/data/results.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 33 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************************!*\
	          !*** ./src/core/filtering/filterComparator.ts ***!
	          \************************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 34 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************!*\
	          !*** ./src/core/filtering/filterFunc.ts ***!
	          \******************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 35 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************************!*\
	          !*** ./src/core/filtering/filterSettings.ts ***!
	          \**********************************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 36 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*************************************!*\
	          !*** ./src/core/filtering/index.ts ***!
	          \*************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./filterComparator */33));
	            __export(__webpack_require__( /*! ./filterFunc */34));
	            __export(__webpack_require__( /*! ./filterSettings */35));
	
	            /***/
	        },
	        /* 37 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/core/grouping/index.ts ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./getGroup */4));
	            __export(__webpack_require__( /*! ./groupingFunc */6));
	            __export(__webpack_require__( /*! ./groupSettings */5));
	            __export(__webpack_require__( /*! ./ngTableDefaultGetGroups */38));
	
	            /***/
	        },
	        /* 38 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************************************************!*\
	          !*** ./src/core/grouping/ngTableDefaultGetGroups.ts ***!
	          \******************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            var ng1 = __webpack_require__( /*! angular */0);
	            var util_1 = __webpack_require__( /*! ../util */11);
	            ngTableDefaultGetGroups.$inject = ['$q', 'ngTableDefaultGetData'];
	            /**
	             * Implementation of the {@link IDefaultGetData IDefaultGetData} interface
	             *
	             * @ngdoc service
	             */
	            function ngTableDefaultGetGroups($q, ngTableDefaultGetData) {
	                return getGroups;
	                function getGroups(params) {
	                    var group = params.group();
	                    var groupFn;
	                    var sortDirection = undefined;
	                    if (util_1.isGroupingFun(group)) {
	                        groupFn = group;
	                        sortDirection = group.sortDirection;
	                    } else {
	                        // currently support for only one group implemented
	                        var groupField_1 = Object.keys(group)[0];
	                        sortDirection = group[groupField_1];
	                        groupFn = function groupFn(item) {
	                            return getPath(item, groupField_1);
	                        };
	                    }
	                    var settings = params.settings();
	                    var originalDataOptions = settings.dataOptions;
	                    settings.dataOptions = { applyPaging: false };
	                    var getData = settings.getData;
	                    var gotData = $q.when(getData(params));
	                    return gotData.then(function (data) {
	                        var groups = {};
	                        ng1.forEach(data, function (item) {
	                            var groupName = groupFn(item);
	                            groups[groupName] = groups[groupName] || {
	                                data: [],
	                                $hideRows: !settings.groupOptions.isExpanded,
	                                value: groupName
	                            };
	                            groups[groupName].data.push(item);
	                        });
	                        var result = [];
	                        for (var i in groups) {
	                            result.push(groups[i]);
	                        }
	                        if (sortDirection) {
	                            var orderByFn = ngTableDefaultGetData.getOrderByFn();
	                            var orderBy = util_1.convertSortToOrderBy({
	                                value: sortDirection
	                            });
	                            result = orderByFn(result, orderBy);
	                        }
	                        return ngTableDefaultGetData.applyPaging(result, params);
	                    }).finally(function () {
	                        // restore the real options
	                        settings.dataOptions = originalDataOptions;
	                    });
	                }
	            }
	            exports.ngTableDefaultGetGroups = ngTableDefaultGetGroups;
	            /**
	             * @private
	             */
	            function getPath(obj, ks) {
	                // origianl source https://github.com/documentcloud/underscore-contrib
	                var keys;
	                if (typeof ks === "string") {
	                    keys = ks.split(".");
	                } else {
	                    keys = ks;
	                }
	                // If we have reached an undefined property
	                // then stop executing and return undefined
	                if (obj === undefined) return void 0;
	                // If the path array has no more elements, we've reached
	                // the intended property and return its value
	                if (keys.length === 0) return obj;
	                // If we still have elements in the path array and the current
	                // value is null, stop executing and return undefined
	                if (obj === null) return void 0;
	                return getPath(obj[keys[0]], keys.slice(1));
	            }
	
	            /***/
	        },
	        /* 39 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************************!*\
	          !*** ./src/core/grouping/publicExports.ts ***!
	          \********************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            __export(__webpack_require__( /*! ./getGroup */4));
	            __export(__webpack_require__( /*! ./groupingFunc */6));
	            __export(__webpack_require__( /*! ./groupSettings */5));
	
	            /***/
	        },
	        /* 40 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**********************************!*\
	          !*** ./src/core/paging/index.ts ***!
	          \**********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 41 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/core/sorting/index.ts ***!
	          \***********************************/
	        /***/function (module, exports) {
	
	            "use strict";
	            "use strict";
	
	            /***/
	        },
	        /* 42 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/browser/filterRow.html ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filterRow.html';
	            var html = "<tr ng-show=\"show_filter\" class=\"ng-table-filters\">\n    <th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=\"$column.show(this)\" class=\"filter {{$column.class(this)}}\"\n        ng-class=\"params.settings().filterOptions.filterLayout === 'horizontal' ? 'filter-horizontal' : ''\">\n        <div ng-repeat=\"(name, filter) in $column.filter(this)\" ng-include=\"$ctrl.config.getTemplateUrl(filter)\" class=\"filter-cell\"\n             ng-class=\"[$ctrl.getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? 'last' : '']\">\n        </div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 43 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*****************************************!*\
	          !*** ./src/browser/filters/number.html ***!
	          \*****************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/number.html';
	            var html = "<input type=\"number\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 44 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!**************************************************!*\
	          !*** ./src/browser/filters/select-multiple.html ***!
	          \**************************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/select-multiple.html';
	            var html = "<select ng-options=\"data.value as data.name for data in $column.data\"\n        ng-disabled=\"$filterRow.disabled\"\n        multiple ng-multiple=\"true\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select-multiple form-control\" name=\"{{name}}\">\n</select>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 45 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*****************************************!*\
	          !*** ./src/browser/filters/select.html ***!
	          \*****************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/select.html';
	            var html = "<select ng-options=\"data.value as data.name for data in $selectData\"\n        ng-table-select-filter-ds=\"$column\"\n        ng-disabled=\"$filterRow.disabled\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select form-control\" name=\"{{name}}\">\n    <option value=\"\">TODOS</option>\n</select>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 46 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/browser/filters/text.html ***!
	          \***************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/text.html';
	            var html = "<input type=\"text\" name=\"{{name}}\" ng-disabled=\"$filterRow.disabled\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\"\n       placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 47 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***********************************!*\
	          !*** ./src/browser/groupRow.html ***!
	          \***********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/groupRow.html';
	            var html = "<tr ng-if=\"params.hasGroup()\" ng-show=\"$groupRow.show\" class=\"ng-table-group-header\">\n    <th colspan=\"{{$ctrl.getVisibleColumns().length}}\" class=\"sortable\" ng-class=\"{\n                    'sort-asc': params.hasGroup($selGroup, 'asc'),\n                    'sort-desc':params.hasGroup($selGroup, 'desc')\n                  }\">\n        <a href=\"\" ng-click=\"isSelectorOpen = !isSelectorOpen\" class=\"ng-table-group-selector\">\n            <strong class=\"sort-indicator\">{{$selGroupTitle}}</strong>\n            <button class=\"btn btn-default btn-xs ng-table-group-close\"\n                    ng-click=\"$groupRow.show = false; $event.preventDefault(); $event.stopPropagation();\">\n                <span class=\"glyphicon glyphicon-remove\"></span>\n            </button>\n            <button class=\"btn btn-default btn-xs ng-table-group-toggle\"\n                    ng-click=\"$ctrl.toggleDetail(); $event.preventDefault(); $event.stopPropagation();\">\n                <span class=\"glyphicon\" ng-class=\"{\n                    'glyphicon-resize-small': params.settings().groupOptions.isExpanded,\n                    'glyphicon-resize-full': !params.settings().groupOptions.isExpanded\n                }\"></span>\n            </button>\n        </a>\n        <div class=\"list-group\" ng-if=\"isSelectorOpen\">\n            <a href=\"\" class=\"list-group-item\" ng-repeat=\"group in $ctrl.getGroupables()\" ng-click=\"$ctrl.groupBy(group)\">\n                <strong>{{ $ctrl.getGroupTitle(group)}}</strong>\n                <strong ng-class=\"$ctrl.isSelectedGroup(group) && 'sort-indicator'\"></strong>\n            </a>\n        </div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 48 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*********************************!*\
	          !*** ./src/browser/header.html ***!
	          \*********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/header.html';
	            var html = "<ng-table-group-row></ng-table-group-row>\n<ng-table-sorter-row></ng-table-sorter-row>\n<ng-table-filter-row></ng-table-filter-row>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 49 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!********************************!*\
	          !*** ./src/browser/pager.html ***!
	          \********************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/pager.html';
	            var html = "<div class=\"ng-cloak ng-table-pager\" ng-if=\"params.data.length\">\n    <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n        <button ng-repeat=\"count in params.settings().counts\" type=\"button\"\n                ng-class=\"{'active':params.count() == count}\"\n                ng-click=\"params.count(count)\" class=\"btn btn-default\">\n            <span ng-bind=\"count\"></span>\n        </button>\n    </div>\n    <ul ng-if=\"pages.length\" class=\"pagination ng-table-pagination\">\n        <li class=\"page-item\" ng-class=\"{'disabled': !page.active && !page.current, 'active': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n            <a class=\"page-link\" ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">&laquo;</a>\n            <a class=\"page-link\" ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n            <a class=\"page-link\" ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\"><span ng-bind=\"page.number\"></span></a>\n            <a class=\"page-link\" ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">&raquo;</a>\n        </li>\n    </ul>\n</div>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 50 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!************************************!*\
	          !*** ./src/browser/sorterRow.html ***!
	          \************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/sorterRow.html';
	            var html = "<tr class=\"ng-table-sort-header\">\n    <th title=\"{{$column.headerTitle(this)}}\"\n        ng-repeat=\"$column in $columns\"\n        ng-class=\"{\n                    'sortable': $column.sortable(this),\n                    'sort-asc': params.sorting()[$column.sortable(this)]=='asc',\n                    'sort-desc': params.sorting()[$column.sortable(this)]=='desc'\n                  }\"\n        ng-click=\"$ctrl.sortBy($column, $event)\"\n        ng-if=\"$column.show(this)\"\n        ng-init=\"template = $column.headerTemplateURL(this)\"\n        class=\"header {{$column.class(this)}}\">\n        <div ng-if=\"!template\" style=\"font-size: 0.85rem; \" class=\"ng-table-header\" ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'div'}\">\n            <span ng-bind=\"$column.title(this)\" ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'span'}\"></span>\n  <br/> <span ng-bind=\"$column.secondLabel\"></span>      </div>\n        <div ng-if=\"template\" ng-include=\"template\"></div>\n    </th>\n</tr>\n";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 51 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!******************!*\
	          !*** ./index.ts ***!
	          \******************/
	        /***/function (module, exports, __webpack_require__) {
	
	            "use strict";
	            "use strict";
	
	            function __export(m) {
	                for (var p in m) {
	                    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	                }
	            }
	            var ng1 = __webpack_require__( /*! angular */0);
	            var core_1 = __webpack_require__( /*! ./src/core */1);
	            var browser_1 = __webpack_require__( /*! ./src/browser */2);
	            var ngTableModule = ng1.module('ngTable', [core_1.ngTableCoreModule.name, browser_1.ngTableBrowserModule.name]);
	            exports.ngTableModule = ngTableModule;
	            __export(__webpack_require__( /*! ./src/core */1));
	            __export(__webpack_require__( /*! ./src/browser */2));
	
	            /***/
	        },
	        /* 52 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!***************************************!*\
	          !*** ./src/browser/filters/date.html ***!
	          \***************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/date.html';
	            var html = "";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 53 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*****************************************!*\
	          !*** ./src/browser/filters/img.html ***!
	          \*****************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/img.html';
	            var html = "";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        },
	        /* 54 */
	        /* unknown exports provided */
	        /* all exports used */
	        /*!*****************************************!*\
	          !*** ./src/browser/filters/hidden.html ***!
	          \*****************************************/
	        /***/function (module, exports, __webpack_require__) {
	
	            var path = 'ng-table/filters/hidden.html';
	            var html = "";
	            var angular = __webpack_require__( /*! angular */0);
	            angular.module('ng').run(['$templateCache', function (c) {
	                c.put(path, html);
	            }]);
	            module.exports = path;
	
	            /***/
	        }
	        /******/])
	    );
	});
	//# sourceMappingURL=ng-table.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)(module)))

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Cargando elementos de bootstrap que se usarán en el sistema
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _datepicker = __webpack_require__(496);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _datepickerPopup = __webpack_require__(498);
	
	var _datepickerPopup2 = _interopRequireDefault(_datepickerPopup);
	
	var _dropdown = __webpack_require__(502);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _accordion = __webpack_require__(486);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _alert = __webpack_require__(488);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _buttons = __webpack_require__(490);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _modal = __webpack_require__(506);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _popover = __webpack_require__(510);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _tabs = __webpack_require__(516);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _timepicker = __webpack_require__(519);
	
	var _timepicker2 = _interopRequireDefault(_timepicker);
	
	var _tooltip = __webpack_require__(521);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _waves = __webpack_require__(546);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	var _formly = __webpack_require__(541);
	
	var _formly2 = _interopRequireDefault(_formly);
	
	var _PdfObject = __webpack_require__(484);
	
	var _PdfObject2 = _interopRequireDefault(_PdfObject);
	
	__webpack_require__(174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Vendor = angular.module('app.vendor', [_datepicker2.default, _datepickerPopup2.default, _dropdown2.default, _accordion2.default, _alert2.default, _buttons2.default, _modal2.default, _popover2.default, _tabs2.default, _timepicker2.default, _tooltip2.default, _waves2.default, _formly2.default]).directive('ngPdfObject', function () {
	    return {
	        replace: 'true',
	        scope: {
	            url: "@url",
	            height: "@height",
	            width: "@width"
	        },
	        template: '<div id="pdf"><div>',
	        link: function link(scope, elem, attrs) {
	            var options = {
	                pdfOpenParams: {
	                    pagemode: "thumbs",
	                    navpanes: 0,
	                    toolbar: 0,
	                    statusbar: 0,
	                    view: "FitV"
	                }
	            };
	            var myPDF = _PdfObject2.default.embed(scope.url, "#pdf", options);
	            var el = document.querySelector("#results");
	            // el.setAttribute("class", (myPDF) ? "success" : "fail");
	            // el.innerHTML = (myPDF) ? "PDFObject successfully added an &lt;embed> element to the page!" : "Uh-oh, the embed didn't work.";
	        }
	    };
	}).name;exports.default = Vendor;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _waves = __webpack_require__(545);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MdEffect = function () {
	    function MdEffect() {
	        _classCallCheck(this, MdEffect);
	
	        this.restrict = 'A';
	    }
	
	    _createClass(MdEffect, [{
	        key: 'link',
	        value: function link($scope, $elem, $attr) {
	            var className = ['waves-light'];
	            if ($attr.mdEffect.length) {
	                var array = $attr.mdEffect.split(' ');
	                if (array.length > 1) {
	                    className = array;
	                } else {
	                    className = [$attr.mdEffect];
	                }
	            }
	            if ($attr.class.indexOf('btn-secondary') != -1 || $attr.class.indexOf('btn-default') != -1) {
	                className = [];
	            }
	            _waves2.default.attach($elem, className);
	            _waves2.default.init();
	        }
	    }]);
	
	    return MdEffect;
	}();
	
	exports.default = MdEffect;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Waves v0.7.5
	 * http://fian.my.id/Waves
	 *
	 * Copyright 2014-2016 Alfiana E. Sibuea and other contributors
	 * Released under the MIT license
	 * https://github.com/fians/Waves/blob/master/LICENSE
	 */
	
	;(function (window, factory) {
	    'use strict';
	
	    // AMD. Register as an anonymous module.  Wrap in function so we have access
	    // to root via `this`.
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return factory.apply(window);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	
	    // Node. Does not work with strict CommonJS, but only CommonJS-like
	    // environments that support module.exports, like Node.
	    else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	            module.exports = factory.call(window);
	        }
	
	        // Browser globals.
	        else {
	                window.Waves = factory.call(window);
	            }
	})((typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' ? global : undefined, function () {
	    'use strict';
	
	    var Waves = Waves || {};
	    var $$ = document.querySelectorAll.bind(document);
	    var toString = Object.prototype.toString;
	    var isTouchAvailable = 'ontouchstart' in window;
	
	    // Find exact position of element
	    function isWindow(obj) {
	        return obj !== null && obj === obj.window;
	    }
	
	    function getWindow(elem) {
	        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
	    }
	
	    function isObject(value) {
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	        return type === 'function' || type === 'object' && !!value;
	    }
	
	    function isDOMNode(obj) {
	        return isObject(obj) && obj.nodeType > 0;
	    }
	
	    function getWavesElements(nodes) {
	        var stringRepr = toString.call(nodes);
	
	        if (stringRepr === '[object String]') {
	            return $$(nodes);
	        } else if (isObject(nodes) && /^\[object (Array|HTMLCollection|NodeList|Object)\]$/.test(stringRepr) && nodes.hasOwnProperty('length')) {
	            return nodes;
	        } else if (isDOMNode(nodes)) {
	            return [nodes];
	        }
	
	        return [];
	    }
	
	    function offset(elem) {
	        var docElem,
	            win,
	            box = { top: 0, left: 0 },
	            doc = elem && elem.ownerDocument;
	
	        docElem = doc.documentElement;
	
	        if (_typeof(elem.getBoundingClientRect) !== ( true ? 'undefined' : _typeof(undefined))) {
	            box = elem.getBoundingClientRect();
	        }
	        win = getWindow(doc);
	        return {
	            top: box.top + win.pageYOffset - docElem.clientTop,
	            left: box.left + win.pageXOffset - docElem.clientLeft
	        };
	    }
	
	    function convertStyle(styleObj) {
	        var style = '';
	
	        for (var prop in styleObj) {
	            if (styleObj.hasOwnProperty(prop)) {
	                style += prop + ':' + styleObj[prop] + ';';
	            }
	        }
	
	        return style;
	    }
	
	    var Effect = {
	
	        // Effect duration
	        duration: 750,
	
	        // Effect delay (check for scroll before showing effect)
	        delay: 200,
	
	        show: function show(e, element, velocity) {
	
	            // Disable right click
	            if (e.button === 2) {
	                return false;
	            }
	
	            element = element || this;
	
	            // Create ripple
	            var ripple = document.createElement('div');
	            ripple.className = 'waves-ripple waves-rippling';
	            element.appendChild(ripple);
	
	            // Get click coordinate and element width
	            var pos = offset(element);
	            var relativeY = 0;
	            var relativeX = 0;
	            // Support for touch devices
	            if ('touches' in e && e.touches.length) {
	                relativeY = e.touches[0].pageY - pos.top;
	                relativeX = e.touches[0].pageX - pos.left;
	            }
	            //Normal case
	            else {
	                    relativeY = e.pageY - pos.top;
	                    relativeX = e.pageX - pos.left;
	                }
	            // Support for synthetic events
	            relativeX = relativeX >= 0 ? relativeX : 0;
	            relativeY = relativeY >= 0 ? relativeY : 0;
	
	            var scale = 'scale(' + element.clientWidth / 100 * 3 + ')';
	            var translate = 'translate(0,0)';
	
	            if (velocity) {
	                translate = 'translate(' + velocity.x + 'px, ' + velocity.y + 'px)';
	            }
	
	            // Attach data to element
	            ripple.setAttribute('data-hold', Date.now());
	            ripple.setAttribute('data-x', relativeX);
	            ripple.setAttribute('data-y', relativeY);
	            ripple.setAttribute('data-scale', scale);
	            ripple.setAttribute('data-translate', translate);
	
	            // Set ripple position
	            var rippleStyle = {
	                top: relativeY + 'px',
	                left: relativeX + 'px'
	            };
	
	            ripple.classList.add('waves-notransition');
	            ripple.setAttribute('style', convertStyle(rippleStyle));
	            ripple.classList.remove('waves-notransition');
	
	            // Scale the ripple
	            rippleStyle['-webkit-transform'] = scale + ' ' + translate;
	            rippleStyle['-moz-transform'] = scale + ' ' + translate;
	            rippleStyle['-ms-transform'] = scale + ' ' + translate;
	            rippleStyle['-o-transform'] = scale + ' ' + translate;
	            rippleStyle.transform = scale + ' ' + translate;
	            rippleStyle.opacity = '1';
	
	            var duration = e.type === 'mousemove' ? 2500 : Effect.duration;
	            rippleStyle['-webkit-transition-duration'] = duration + 'ms';
	            rippleStyle['-moz-transition-duration'] = duration + 'ms';
	            rippleStyle['-o-transition-duration'] = duration + 'ms';
	            rippleStyle['transition-duration'] = duration + 'ms';
	
	            ripple.setAttribute('style', convertStyle(rippleStyle));
	        },
	
	        hide: function hide(e, element) {
	            element = element || this;
	
	            var ripples = element.getElementsByClassName('waves-rippling');
	
	            for (var i = 0, len = ripples.length; i < len; i++) {
	                removeRipple(e, element, ripples[i]);
	            }
	        }
	    };
	
	    /**
	     * Collection of wrapper for HTML element that only have single tag
	     * like <input> and <img>
	     */
	    var TagWrapper = {
	
	        // Wrap <input> tag so it can perform the effect
	        input: function input(element) {
	
	            var parent = element.parentNode;
	
	            // If input already have parent just pass through
	            if (parent.tagName.toLowerCase() === 'i' && parent.classList.contains('waves-effect')) {
	                return;
	            }
	
	            // Put element class and style to the specified parent
	            var wrapper = document.createElement('i');
	            wrapper.className = element.className + ' waves-input-wrapper';
	            element.className = 'waves-button-input';
	
	            // Put element as child
	            parent.replaceChild(wrapper, element);
	            wrapper.appendChild(element);
	
	            // Apply element color and background color to wrapper
	            var elementStyle = window.getComputedStyle(element, null);
	            var color = elementStyle.color;
	            var backgroundColor = elementStyle.backgroundColor;
	
	            wrapper.setAttribute('style', 'color:' + color + ';background:' + backgroundColor);
	            element.setAttribute('style', 'background-color:rgba(0,0,0,0);');
	        },
	
	        // Wrap <img> tag so it can perform the effect
	        img: function img(element) {
	
	            var parent = element.parentNode;
	
	            // If input already have parent just pass through
	            if (parent.tagName.toLowerCase() === 'i' && parent.classList.contains('waves-effect')) {
	                return;
	            }
	
	            // Put element as child
	            var wrapper = document.createElement('i');
	            parent.replaceChild(wrapper, element);
	            wrapper.appendChild(element);
	        }
	    };
	
	    /**
	     * Hide the effect and remove the ripple. Must be
	     * a separate function to pass the JSLint...
	     */
	    function removeRipple(e, el, ripple) {
	
	        // Check if the ripple still exist
	        if (!ripple) {
	            return;
	        }
	
	        ripple.classList.remove('waves-rippling');
	
	        var relativeX = ripple.getAttribute('data-x');
	        var relativeY = ripple.getAttribute('data-y');
	        var scale = ripple.getAttribute('data-scale');
	        var translate = ripple.getAttribute('data-translate');
	
	        // Get delay beetween mousedown and mouse leave
	        var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
	        var delay = 350 - diff;
	
	        if (delay < 0) {
	            delay = 0;
	        }
	
	        if (e.type === 'mousemove') {
	            delay = 150;
	        }
	
	        // Fade out ripple after delay
	        var duration = e.type === 'mousemove' ? 2500 : Effect.duration;
	
	        setTimeout(function () {
	
	            var style = {
	                top: relativeY + 'px',
	                left: relativeX + 'px',
	                opacity: '0',
	
	                // Duration
	                '-webkit-transition-duration': duration + 'ms',
	                '-moz-transition-duration': duration + 'ms',
	                '-o-transition-duration': duration + 'ms',
	                'transition-duration': duration + 'ms',
	                '-webkit-transform': scale + ' ' + translate,
	                '-moz-transform': scale + ' ' + translate,
	                '-ms-transform': scale + ' ' + translate,
	                '-o-transform': scale + ' ' + translate,
	                'transform': scale + ' ' + translate
	            };
	
	            ripple.setAttribute('style', convertStyle(style));
	
	            setTimeout(function () {
	                try {
	                    el.removeChild(ripple);
	                } catch (e) {
	                    return false;
	                }
	            }, duration);
	        }, delay);
	    }
	
	    /**
	     * Disable mousedown event for 500ms during and after touch
	     */
	    var TouchHandler = {
	
	        /* uses an integer rather than bool so there's no issues with
	         * needing to clear timeouts if another touch event occurred
	         * within the 500ms. Cannot mouseup between touchstart and
	         * touchend, nor in the 500ms after touchend. */
	        touches: 0,
	
	        allowEvent: function allowEvent(e) {
	
	            var allow = true;
	
	            if (/^(mousedown|mousemove)$/.test(e.type) && TouchHandler.touches) {
	                allow = false;
	            }
	
	            return allow;
	        },
	        registerEvent: function registerEvent(e) {
	            var eType = e.type;
	
	            if (eType === 'touchstart') {
	
	                TouchHandler.touches += 1; // push
	            } else if (/^(touchend|touchcancel)$/.test(eType)) {
	
	                setTimeout(function () {
	                    if (TouchHandler.touches) {
	                        TouchHandler.touches -= 1; // pop after 500ms
	                    }
	                }, 500);
	            }
	        }
	    };
	
	    /**
	     * Delegated click handler for .waves-effect element.
	     * returns null when .waves-effect element not in "click tree"
	     */
	    function getWavesEffectElement(e) {
	
	        if (TouchHandler.allowEvent(e) === false) {
	            return null;
	        }
	
	        var element = null;
	        var target = e.target || e.srcElement;
	
	        while (target.parentElement) {
	            if (!(target instanceof SVGElement) && target.classList.contains('waves-effect')) {
	                element = target;
	                break;
	            }
	            target = target.parentElement;
	        }
	
	        return element;
	    }
	
	    /**
	     * Bubble the click and show effect if .waves-effect elem was found
	     */
	    function showEffect(e) {
	
	        // Disable effect if element has "disabled" property on it
	        // In some cases, the event is not triggered by the current element
	        // if (e.target.getAttribute('disabled') !== null) {
	        //     return;
	        // }
	
	        var element = getWavesEffectElement(e);
	
	        if (element !== null) {
	
	            // Make it sure the element has either disabled property, disabled attribute or 'disabled' class
	            if (element.disabled || element.getAttribute('disabled') || element.classList.contains('disabled')) {
	                return;
	            }
	
	            TouchHandler.registerEvent(e);
	
	            if (e.type === 'touchstart' && Effect.delay) {
	
	                var hidden = false;
	
	                var timer = setTimeout(function () {
	                    timer = null;
	                    Effect.show(e, element);
	                }, Effect.delay);
	
	                var hideEffect = function hideEffect(hideEvent) {
	
	                    // if touch hasn't moved, and effect not yet started: start effect now
	                    if (timer) {
	                        clearTimeout(timer);
	                        timer = null;
	                        Effect.show(e, element);
	                    }
	                    if (!hidden) {
	                        hidden = true;
	                        Effect.hide(hideEvent, element);
	                    }
	                };
	
	                var touchMove = function touchMove(moveEvent) {
	                    if (timer) {
	                        clearTimeout(timer);
	                        timer = null;
	                    }
	                    hideEffect(moveEvent);
	                };
	
	                element.addEventListener('touchmove', touchMove, false);
	                element.addEventListener('touchend', hideEffect, false);
	                element.addEventListener('touchcancel', hideEffect, false);
	            } else {
	
	                Effect.show(e, element);
	
	                if (isTouchAvailable) {
	                    element.addEventListener('touchend', Effect.hide, false);
	                    element.addEventListener('touchcancel', Effect.hide, false);
	                }
	
	                element.addEventListener('mouseup', Effect.hide, false);
	                element.addEventListener('mouseleave', Effect.hide, false);
	            }
	        }
	    }
	
	    Waves.init = function (options) {
	        var body = document.body;
	
	        options = options || {};
	
	        if ('duration' in options) {
	            Effect.duration = options.duration;
	        }
	
	        if ('delay' in options) {
	            Effect.delay = options.delay;
	        }
	
	        if (isTouchAvailable) {
	            body.addEventListener('touchstart', showEffect, false);
	            body.addEventListener('touchcancel', TouchHandler.registerEvent, false);
	            body.addEventListener('touchend', TouchHandler.registerEvent, false);
	        }
	
	        body.addEventListener('mousedown', showEffect, false);
	    };
	
	    /**
	     * Attach Waves to dynamically loaded inputs, or add .waves-effect and other
	     * waves classes to a set of elements. Set drag to true if the ripple mouseover
	     * or skimming effect should be applied to the elements.
	     */
	    Waves.attach = function (elements, classes) {
	
	        elements = getWavesElements(elements);
	
	        if (toString.call(classes) === '[object Array]') {
	            classes = classes.join(' ');
	        }
	
	        classes = classes ? ' ' + classes : '';
	
	        var element, tagName;
	
	        for (var i = 0, len = elements.length; i < len; i++) {
	
	            element = elements[i];
	            tagName = element.tagName.toLowerCase();
	
	            if (['input', 'img'].indexOf(tagName) !== -1) {
	                TagWrapper[tagName](element);
	                element = element.parentElement;
	            }
	
	            if (element.className.indexOf('waves-effect') === -1) {
	                element.className += ' waves-effect' + classes;
	            }
	        }
	    };
	
	    /**
	     * Cause a ripple to appear in an element via code.
	     */
	    Waves.ripple = function (elements, options) {
	        elements = getWavesElements(elements);
	        var elementsLen = elements.length;
	
	        options = options || {};
	        options.wait = options.wait || 0;
	        options.position = options.position || null; // default = centre of element
	
	
	        if (elementsLen) {
	            var element,
	                pos,
	                off,
	                centre = {},
	                i = 0;
	            var mousedown = {
	                type: 'mousedown',
	                button: 1
	            };
	            var hideRipple = function hideRipple(mouseup, element) {
	                return function () {
	                    Effect.hide(mouseup, element);
	                };
	            };
	
	            for (; i < elementsLen; i++) {
	                element = elements[i];
	                pos = options.position || {
	                    x: element.clientWidth / 2,
	                    y: element.clientHeight / 2
	                };
	
	                off = offset(element);
	                centre.x = off.left + pos.x;
	                centre.y = off.top + pos.y;
	
	                mousedown.pageX = centre.x;
	                mousedown.pageY = centre.y;
	
	                Effect.show(mousedown, element);
	
	                if (options.wait >= 0 && options.wait !== null) {
	                    var mouseup = {
	                        type: 'mouseup',
	                        button: 1
	                    };
	
	                    setTimeout(hideRipple(mouseup, element), options.wait);
	                }
	            }
	        }
	    };
	
	    /**
	     * Remove all ripples from an element.
	     */
	    Waves.calm = function (elements) {
	        elements = getWavesElements(elements);
	        var mouseup = {
	            type: 'mouseup',
	            button: 1
	        };
	
	        for (var i = 0, len = elements.length; i < len; i++) {
	            Effect.hide(mouseup, elements[i]);
	        }
	    };
	
	    /**
	     * Deprecated API fallback
	     */
	    Waves.displayEffect = function (options) {
	        console.error('Waves.displayEffect() has been deprecated and will be removed in future version. Please use Waves.init() to initialize Waves effect');
	        Waves.init(options);
	    };
	
	    return Waves;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _waves = __webpack_require__(544);
	
	var _waves2 = _interopRequireDefault(_waves);
	
	__webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Waves = angular.module('vendor.waves', []).directive('mdEffect', function () {
	    return new _waves2.default();
	}).name;
	
	exports.default = Waves;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(655);
	__webpack_require__(548);
	module.exports = 'ng.deviceDetector';

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	(function (angular) {
	    "use strict";
	
	    var BROWSERS = {
	        CHROME: "chrome",
	        FIREFOX: "firefox",
	        SAFARI: "safari",
	        OPERA: "opera",
	        IE: "ie",
	        MS_EDGE: "ms-edge",
	        FB_MESSENGER: "fb-messenger",
	        CORDOVA: "cordova",
	        UNKNOWN: "unknown"
	    };
	
	    var DEVICES = {
	        ANDROID: "android",
	        I_PAD: "ipad",
	        IPHONE: "iphone",
	        I_POD: "ipod",
	        BLACKBERRY: "blackberry",
	        FIREFOX_OS: "firefox-os",
	        CHROME_BOOK: "chrome-book",
	        WINDOWS_PHONE: "windows-phone",
	        PS4: "ps4",
	        VITA: "vita",
	        CHROMECAST: "chromecast",
	        APPLE_TV: "apple-tv",
	        GOOGLE_TV: "google-tv",
	        UNKNOWN: "unknown"
	    };
	
	    var OS = {
	        WINDOWS: "windows",
	        MAC: "mac",
	        IOS: "ios",
	        ANDROID: "android",
	        LINUX: "linux",
	        UNIX: "unix",
	        FIREFOX_OS: "firefox-os",
	        CHROME_OS: "chrome-os",
	        WINDOWS_PHONE: "windows-phone",
	        UNKNOWN: "unknown"
	    };
	
	    var OS_VERSIONS = {
	        WINDOWS_3_11: "windows-3-11",
	        WINDOWS_95: "windows-95",
	        WINDOWS_ME: "windows-me",
	        WINDOWS_98: "windows-98",
	        WINDOWS_CE: "windows-ce",
	        WINDOWS_2000: "windows-2000",
	        WINDOWS_XP: "windows-xp",
	        WINDOWS_SERVER_2003: "windows-server-2003",
	        WINDOWS_VISTA: "windows-vista",
	        WINDOWS_7: "windows-7",
	        WINDOWS_8_1: "windows-8-1",
	        WINDOWS_8: "windows-8",
	        WINDOWS_10: "windows-10",
	        WINDOWS_PHONE_7_5: "windows-phone-7-5",
	        WINDOWS_PHONE_8_1: "windows-phone-8-1",
	        WINDOWS_PHONE_10: "windows-phone-10",
	        WINDOWS_NT_4_0: "windows-nt-4-0",
	        MACOSX_15: "mac-os-x-15",
	        MACOSX_14: "mac-os-x-14",
	        MACOSX_13: "mac-os-x-13",
	        MACOSX_12: "mac-os-x-12",
	        MACOSX_11: "mac-os-x-11",
	        MACOSX_10: "mac-os-x-10",
	        MACOSX_9: "mac-os-x-9",
	        MACOSX_8: "mac-os-x-8",
	        MACOSX_7: "mac-os-x-7",
	        MACOSX_6: "mac-os-x-6",
	        MACOSX_5: "mac-os-x-5",
	        MACOSX_4: "mac-os-x-4",
	        MACOSX_3: "mac-os-x-3",
	        MACOSX_2: "mac-os-x-2",
	        MACOSX: "mac-os-x",
	        UNKNOWN: "unknown"
	    };
	
	    var OS_RE = {
	        WINDOWS: {and: [{or: [/\bWindows|(Win\d\d)\b/, /\bWin 9x\b/]}, {not: /\bWindows Phone\b/}]},
	        MAC: {and: [/\bMac OS\b/, {not: /Windows Phone/}]},
	        IOS: {and: [{or: [/\biPad\b/, /\biPhone\b/, /\biPod\b/]}, {not: /Windows Phone/}]},
	        ANDROID: {and: [/\bAndroid\b/, {not: /Windows Phone/}]},
	        LINUX: /\bLinux\b/,
	        UNIX: /\bUNIX\b/,
	        FIREFOX_OS: {and: [/\bFirefox\b/, /Mobile\b/]},
	        CHROME_OS: /\bCrOS\b/,
	        WINDOWS_PHONE: {or: [/\bIEMobile\b/, /\bWindows Phone\b/]},
	        PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
	        VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
	    };
	
	    var BROWSERS_RE = {
	        CHROME: {and: [{or: [/\bChrome\b/, /\bCriOS\b/]}, {not: {or: [/\bOPR\b/, /\bEdge\b/, /\bCordova\b/]}}]},
	        FIREFOX: {and: [{or: [/\bFirefox\b/, /\bFxiOS\b/]}, {not: /\bCordova\b/}]},
	        SAFARI: {and: [/^((?!CriOS).)*\Safari\b.*$/, {not: {or: [/\bOPR\b/, /\bEdge\b/, /Windows Phone/, /\bCordova\b/,/\bChrome\b/]}}]},
	        OPERA: {or: [/Opera\b/, /\bOPR\b/]},
	        IE: {or: [/\bMSIE\b/, /\bTrident\b/, /^Mozilla\/5\.0 \(Windows NT 10\.0; Win64; x64\)$/]},
	        MS_EDGE: {or: [/\bEdge\b/]},
	        PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
	        VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/,
	        CORDOVA: /\bCordova\b/,
	        FB_MESSENGER: /\bFBAN\/MessengerForiOS\b/
	    };
	
	    var DEVICES_RE = {
	        ANDROID: {and: [/\bAndroid\b/, {not: /Windows Phone/}]},
	        I_PAD: /\biPad\b/,
	        IPHONE: {and: [/\biPhone\b/, {not: /Windows Phone/}]},
	        I_POD: /\biPod\b/,
	        BLACKBERRY: /\bblackberry\b/,
	        FIREFOX_OS: {and: [/\bFirefox\b/, /\bMobile\b/]},
	        CHROME_BOOK: /\bCrOS\b/,
	        WINDOWS_PHONE: {or: [/\bIEMobile\b/, /\bWindows Phone\b/]},
	        PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
	        CHROMECAST: /\bCrKey\b/,
	        APPLE_TV: /^iTunes-AppleTV\/4.1$/,
	        GOOGLE_TV: /\bGoogleTV\b/,
	        VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
	    };
	
	    var OS_VERSIONS_RE = {
	        WINDOWS_3_11: /Win16/,
	        WINDOWS_95: /(Windows 95|Win95|Windows_95)/,
	        WINDOWS_ME: /(Win 9x 4.90|Windows ME)/,
	        WINDOWS_98: /(Windows 98|Win98)/,
	        WINDOWS_CE: /Windows CE/,
	        WINDOWS_2000: /(Windows NT 5.0|Windows 2000)/,
	        WINDOWS_XP: /(Windows NT 5.1|Windows XP)/,
	        WINDOWS_SERVER_2003: /Windows NT 5.2/,
	        WINDOWS_VISTA: /Windows NT 6.0/,
	        WINDOWS_7: /(Windows 7|Windows NT 6.1)/,
	        WINDOWS_8_1: /(Windows 8.1|Windows NT 6.3)/,
	        WINDOWS_8: /(Windows 8|Windows NT 6.2)/,
	        WINDOWS_10: /(Windows NT 10.0)/,
	        WINDOWS_PHONE_7_5: /(Windows Phone OS 7.5)/,
	        WINDOWS_PHONE_8_1: /(Windows Phone 8.1)/,
	        WINDOWS_PHONE_10: /(Windows Phone 10)/,
	        WINDOWS_NT_4_0: {and: [/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/, {not: /Windows NT 10.0/}]},
	        MACOSX: /(MAC OS X\s*[^ 0-9])/,
	        MACOSX_3: /(Darwin 10.3|Mac OS X 10.3)/,
	        MACOSX_4: /(Darwin 10.4|Mac OS X 10.4)/,
	        MACOSX_5: /(Mac OS X 10.5)/,
	        MACOSX_6: /(Mac OS X 10.6)/,
	        MACOSX_7: /(Mac OS X 10.7)/,
	        MACOSX_8: /(Mac OS X 10.8)/,
	        MACOSX_9: /(Mac OS X 10.9)/,
	        MACOSX_10: /(Mac OS X 10.10)/,
	        MACOSX_11: /(Mac OS X 10.11)/,
	        MACOSX_12: /(Mac OS X 10.12)/,
	        MACOSX_13: /(Mac OS X 10.13)/,
	        MACOSX_14: /(Mac OS X 10.14)/,
	        MACOSX_15: /(Mac OS X 10.15)/
	    };
	
	    var BROWSER_VERSIONS_RE_MAP = {
	        CHROME: [/\bChrome\/([\d\.]+)\b/, /\bCriOS\/([\d\.]+)\b/],
	        FIREFOX: [/\bFirefox\/([\d\.]+)\b/, /\bFxiOS\/([\d\.]+)\b/],
	        SAFARI: /\bVersion\/([\d\.]+)\b/,
	        OPERA: [/\bVersion\/([\d\.]+)\b/, /\bOPR\/([\d\.]+)\b/],
	        IE: [/\bMSIE ([\d\.]+\w?)\b/, /\brv:([\d\.]+\w?)\b/],
	        CORDOVA: /\bCordova\/([\d\.]+)\b/,
	        MS_EDGE: /\bEdge\/([\d\.]+)\b/
	    };
	
	    var BROWSER_VERSIONS_RE = Object.keys(BROWSER_VERSIONS_RE_MAP).reduce(function (obj, key) {
	        obj[BROWSERS[key]] = BROWSER_VERSIONS_RE_MAP[key];
	        return obj;
	    }, {});
	
	    angular.module("ng.deviceDetector", ["reTree"])
	        .constant("OS_RE", OS_RE)
	
	        .constant("BROWSERS_RE", BROWSERS_RE)
	
	        .constant("DEVICES_RE", DEVICES_RE)
	
	        .constant("OS_VERSIONS_RE", OS_VERSIONS_RE)
	
	        .constant("BROWSER_VERSIONS_RE_MAP", BROWSER_VERSIONS_RE_MAP)
	
	        .constant("BROWSER_VERSIONS_RE", BROWSER_VERSIONS_RE)
	
	        .constant("BROWSERS", BROWSERS)
	
	        .constant("DEVICES", DEVICES)
	
	        .constant("OS", OS)
	
	        .constant("OS_VERSIONS", OS_VERSIONS)
	        
	        .service("detectUtils", ["deviceDetector", "DEVICES", "BROWSERS", "OS",
	            function (deviceDetector, DEVICES, BROWSERS, OS) {
	                var deviceInfo = deviceDetector;
	
	                this.isMobile = function () {
	                    return deviceInfo.device !== 'unknown';
	                };
	
	                this.isAndroid = function () {
	                    return (deviceInfo.device === DEVICES.ANDROID || deviceInfo.OS === OS.ANDROID);
	                };
	
	                this.isIOS = function () {
	                    return (deviceInfo.os === OS.IOS || deviceInfo.device === DEVICES.I_POD || deviceInfo.device === DEVICES.IPHONE);
	                };
	            }
	        ])
	        .provider("deviceDetector", function () {
	                var customDetectors = [];
	                this.addCustom = function (customDetectorName, customDetectorRE) {
	                    customDetectors.push({name: customDetectorName, re: customDetectorRE});
	                };
	                this.$get = [
	                    "$window", 
	                    "DEVICES", 
	                    "BROWSERS", 
	                    "OS", 
	                    "OS_VERSIONS", 
	                    "reTree",
	                    "OS_RE",
	                    "BROWSERS_RE",
	                    "DEVICES_RE",
	                    "OS_VERSIONS_RE",
	                    "BROWSER_VERSIONS_RE_MAP",
	                    "BROWSER_VERSIONS_RE",
	                    function (
	                        $window, 
	                        DEVICES, 
	                        BROWSERS, 
	                        OS, 
	                        OS_VERSIONS, 
	                        reTree,
	                        OS_RE,
	                        BROWSERS_RE,
	                        DEVICES_RE,
	                        OS_VERSIONS_RE,
	                        BROWSER_VERSIONS_RE_MAP,
	                        BROWSER_VERSIONS_RE
	                    ) {
	                    /* ES5 polyfills Start*/
	
	                    // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
	                    if (!Object.keys) {
	                        Object.keys = (function () {
	                            'use strict';
	                            var hasOwnProperty = Object.prototype.hasOwnProperty,
	                                hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
	                                dontEnums = [
	                                    'toString',
	                                    'toLocaleString',
	                                    'valueOf',
	                                    'hasOwnProperty',
	                                    'isPrototypeOf',
	                                    'propertyIsEnumerable',
	                                    'constructor'
	                                ],
	                                dontEnumsLength = dontEnums.length;
	
	                            return function (obj) {
	                                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
	                                    throw new TypeError('Object.keys called on non-object');
	                                }
	
	                                var result = [], prop, i;
	
	                                for (prop in obj) {
	                                    if (hasOwnProperty.call(obj, prop)) {
	                                        result.push(prop);
	                                    }
	                                }
	
	                                if (hasDontEnumBug) {
	                                    for (i = 0; i < dontEnumsLength; i++) {
	                                        if (hasOwnProperty.call(obj, dontEnums[i])) {
	                                            result.push(dontEnums[i]);
	                                        }
	                                    }
	                                }
	                                return result;
	                            };
	                        }());
	                    }
	
	                    // Production steps of ECMA-262, Edition 5, 15.4.4.21
	                    // Reference: http://es5.github.io/#x15.4.4.21
	                    if (!Array.prototype.reduce) {
	                        Array.prototype.reduce = function (callback /*, initialValue*/) {
	                            'use strict';
	                            if (this == null) {
	                                throw new TypeError('Array.prototype.reduce called on null or undefined');
	                            }
	                            if (typeof callback !== 'function') {
	                                throw new TypeError(callback + ' is not a function');
	                            }
	                            var t = Object(this), len = t.length >>> 0, k = 0, value;
	                            if (arguments.length == 2) {
	                                value = arguments[1];
	                            } else {
	                                while (k < len && !(k in t)) {
	                                    k++;
	                                }
	                                if (k >= len) {
	                                    throw new TypeError('Reduce of empty array with no initial value');
	                                }
	                                value = t[k++];
	                            }
	                            for (; k < len; k++) {
	                                if (k in t) {
	                                    value = callback(value, t[k], k, t);
	                                }
	                            }
	                            return value;
	                        };
	                    }
	                    /* ES5 polyfills End*/
	
	                    var ua = $window.navigator.userAgent;
	
	                    var deviceInfo = {
	                        raw: {
	                            userAgent: ua,
	                            os: {},
	                            browser: {},
	                            device: {}
	                        }
	                    };
	
	                    deviceInfo.raw.os = Object.keys(OS).reduce(function (obj, item) {
	                        obj[OS[item]] = reTree.test(ua, OS_RE[item]);
	                        return obj;
	                    }, {});
	
	                    deviceInfo.raw.browser = Object.keys(BROWSERS).reduce(function (obj, item) {
	                        obj[BROWSERS[item]] = reTree.test(ua, BROWSERS_RE[item]);
	                        return obj;
	                    }, {});
	
	                    deviceInfo.raw.device = Object.keys(DEVICES).reduce(function (obj, item) {
	                        obj[DEVICES[item]] = reTree.test(ua, DEVICES_RE[item]);
	                        return obj;
	                    }, {});
	
	                    deviceInfo.raw.os_version = Object.keys(OS_VERSIONS).reduce(function (obj, item) {
	                        obj[OS_VERSIONS[item]] = reTree.test(ua, OS_VERSIONS_RE[item]);
	                        return obj;
	                    }, {});
	
	                    deviceInfo.os = [
	                        OS.WINDOWS,
	                        OS.IOS,
	                        OS.MAC,
	                        OS.ANDROID,
	                        OS.LINUX,
	                        OS.UNIX,
	                        OS.FIREFOX_OS,
	                        OS.CHROME_OS,
	                        OS.WINDOWS_PHONE
	                    ].reduce(function (previousValue, currentValue) {
	                        return (previousValue === OS.UNKNOWN && deviceInfo.raw.os[currentValue]) ? currentValue : previousValue;
	                    }, OS.UNKNOWN);
	
	                    deviceInfo.browser = [
	                        BROWSERS.CHROME,
	                        BROWSERS.FIREFOX,
	                        BROWSERS.SAFARI,
	                        BROWSERS.OPERA,
	                        BROWSERS.IE,
	                        BROWSERS.MS_EDGE,
	                        BROWSERS.CORDOVA,
	                        BROWSERS.FB_MESSENGER
	                    ].reduce(function (previousValue, currentValue) {
	                        return (previousValue === BROWSERS.UNKNOWN && deviceInfo.raw.browser[currentValue]) ? currentValue : previousValue;
	                    }, BROWSERS.UNKNOWN);
	
	                    deviceInfo.device = [
	                        DEVICES.ANDROID,
	                        DEVICES.I_PAD,
	                        DEVICES.IPHONE,
	                        DEVICES.I_POD,
	                        DEVICES.BLACKBERRY,
	                        DEVICES.FIREFOX_OS,
	                        DEVICES.CHROME_BOOK,
	                        DEVICES.WINDOWS_PHONE,
	                        DEVICES.PS4,
	                        DEVICES.CHROMECAST,
	                        DEVICES.APPLE_TV,
	                        DEVICES.GOOGLE_TV,
	                        DEVICES.VITA
	                    ].reduce(function (previousValue, currentValue) {
	                        return (previousValue === DEVICES.UNKNOWN && deviceInfo.raw.device[currentValue]) ? currentValue : previousValue;
	                    }, DEVICES.UNKNOWN);
	
	                    deviceInfo.os_version = [
	                        OS_VERSIONS.WINDOWS_3_11,
	                        OS_VERSIONS.WINDOWS_95,
	                        OS_VERSIONS.WINDOWS_ME,
	                        OS_VERSIONS.WINDOWS_98,
	                        OS_VERSIONS.WINDOWS_CE,
	                        OS_VERSIONS.WINDOWS_2000,
	                        OS_VERSIONS.WINDOWS_XP,
	                        OS_VERSIONS.WINDOWS_SERVER_2003,
	                        OS_VERSIONS.WINDOWS_VISTA,
	                        OS_VERSIONS.WINDOWS_7,
	                        OS_VERSIONS.WINDOWS_8_1,
	                        OS_VERSIONS.WINDOWS_8,
	                        OS_VERSIONS.WINDOWS_10,
	                        OS_VERSIONS.WINDOWS_PHONE_7_5,
	                        OS_VERSIONS.WINDOWS_PHONE_8_1,
	                        OS_VERSIONS.WINDOWS_PHONE_10,
	                        OS_VERSIONS.WINDOWS_NT_4_0,
	                        OS_VERSIONS.MACOSX,
	                        OS_VERSIONS.MACOSX_3,
	                        OS_VERSIONS.MACOSX_4,
	                        OS_VERSIONS.MACOSX_5,
	                        OS_VERSIONS.MACOSX_6,
	                        OS_VERSIONS.MACOSX_7,
	                        OS_VERSIONS.MACOSX_8,
	                        OS_VERSIONS.MACOSX_9,
	                        OS_VERSIONS.MACOSX_10,
	                        OS_VERSIONS.MACOSX_11,
	                        OS_VERSIONS.MACOSX_12,
	                        OS_VERSIONS.MACOSX_13,
	                        OS_VERSIONS.MACOSX_14,
	                        OS_VERSIONS.MACOSX_15
	                    ].reduce(function (previousValue, currentValue) {
	                        return (previousValue === OS_VERSIONS.UNKNOWN && deviceInfo.raw.os_version[currentValue]) ? currentValue : previousValue;
	                    }, OS_VERSIONS.UNKNOWN);
	
	                    deviceInfo.browser_version = "0";
	                    if (deviceInfo.browser !== BROWSERS.UNKNOWN) {
	                        var re = BROWSER_VERSIONS_RE[deviceInfo.browser];
	                        var res = reTree.exec(ua, re);
	                        if (!!res) {
	                            deviceInfo.browser_version = res[1];
	                        }
	                    }
	
	                    deviceInfo.isMobile = function () {
	                        return [
	                            DEVICES.ANDROID,
	                            DEVICES.I_PAD,
	                            DEVICES.IPHONE,
	                            DEVICES.I_POD,
	                            DEVICES.BLACKBERRY,
	                            DEVICES.FIREFOX_OS,
	                            DEVICES.WINDOWS_PHONE,
	                            DEVICES.VITA
	                        ].some(function (item) {
	                            return deviceInfo.device == item;
	                        });
	                    };
	
	                    deviceInfo.isTablet = function () {
	                        return [
	                            DEVICES.I_PAD,
	                            DEVICES.FIREFOX_OS
	                        ].some(function (item) {
	                            return deviceInfo.device == item;
	                        });
	                    };
	
	                    deviceInfo.isDesktop = function () {
	                        return [
	                            DEVICES.PS4,
	                            DEVICES.CHROME_BOOK,
	                            DEVICES.UNKNOWN
	                        ].some(function (item) {
	                            return deviceInfo.device == item;
	                        });
	                    };
	
	                    deviceInfo.custom = customDetectors.reduce(function (custom, customDetector) {
	                        custom[customDetector.name] = reTree.test(ua, customDetector.re);
	                        return custom;
	                    }, {});
	                    return deviceInfo;
	                }];
	            }
	        )
	        .directive('deviceDetector', ["deviceDetector", function (deviceDetector) {
	            function customClassName(name) {
	                return 'is-' + name.toLowerCase().replace(/[^0-9a-z]+/g, '-');
	            }
	
	            return {
	                restrict: "A",
	                link: function (scope, elm/*, attrs*/) {
	                    elm.addClass('os-' + deviceDetector.os);
	                    elm.addClass('browser-' + deviceDetector.browser);
	                    elm.addClass('device-' + deviceDetector.device);
	                    elm.toggleClass('is-mobile', deviceDetector.isMobile());
	                    elm.toggleClass('is-tablet', deviceDetector.isTablet());
	                    elm.toggleClass('is-desktop', deviceDetector.isDesktop());
	                    Object.keys(deviceDetector.custom).forEach(function (customKey) {
	                        elm.toggleClass(customClassName(customKey), deviceDetector.custom[customKey]);
	                    });
	                }
	            };
	        }]);
	})(angular);


/***/ }),
/* 549 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 550 */
/***/ (function(module, exports) {

	'use strict';
	
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(29);
	var trees   = __webpack_require__(555);
	var adler32 = __webpack_require__(90);
	var crc32   = __webpack_require__(91);
	var msg     = __webpack_require__(92);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 552 */
/***/ (function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(29);
	var adler32       = __webpack_require__(90);
	var crc32         = __webpack_require__(91);
	var inflate_fast  = __webpack_require__(552);
	var inflate_table = __webpack_require__(554);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(29);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(29);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, Buffer) {/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/build/pdf", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/build/pdf"] = factory();
		else
			root["pdfjs-dist/build/pdf"] = root.pdfjsDistBuildPdf = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __w_pdfjs_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__w_pdfjs_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__w_pdfjs_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
	/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__w_pdfjs_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__w_pdfjs_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 75);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__w_pdfjs_require__(76);
	
	var _streams_polyfill = __w_pdfjs_require__(116);
	
	var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
	var NativeImageDecoding = {
	  NONE: 'none',
	  DECODE: 'decode',
	  DISPLAY: 'display'
	};
	var TextRenderingMode = {
	  FILL: 0,
	  STROKE: 1,
	  FILL_STROKE: 2,
	  INVISIBLE: 3,
	  FILL_ADD_TO_PATH: 4,
	  STROKE_ADD_TO_PATH: 5,
	  FILL_STROKE_ADD_TO_PATH: 6,
	  ADD_TO_PATH: 7,
	  FILL_STROKE_MASK: 3,
	  ADD_TO_PATH_FLAG: 4
	};
	var ImageKind = {
	  GRAYSCALE_1BPP: 1,
	  RGB_24BPP: 2,
	  RGBA_32BPP: 3
	};
	var AnnotationType = {
	  TEXT: 1,
	  LINK: 2,
	  FREETEXT: 3,
	  LINE: 4,
	  SQUARE: 5,
	  CIRCLE: 6,
	  POLYGON: 7,
	  POLYLINE: 8,
	  HIGHLIGHT: 9,
	  UNDERLINE: 10,
	  SQUIGGLY: 11,
	  STRIKEOUT: 12,
	  STAMP: 13,
	  CARET: 14,
	  INK: 15,
	  POPUP: 16,
	  FILEATTACHMENT: 17,
	  SOUND: 18,
	  MOVIE: 19,
	  WIDGET: 20,
	  SCREEN: 21,
	  PRINTERMARK: 22,
	  TRAPNET: 23,
	  WATERMARK: 24,
	  THREED: 25,
	  REDACT: 26
	};
	var AnnotationFlag = {
	  INVISIBLE: 0x01,
	  HIDDEN: 0x02,
	  PRINT: 0x04,
	  NOZOOM: 0x08,
	  NOROTATE: 0x10,
	  NOVIEW: 0x20,
	  READONLY: 0x40,
	  LOCKED: 0x80,
	  TOGGLENOVIEW: 0x100,
	  LOCKEDCONTENTS: 0x200
	};
	var AnnotationFieldFlag = {
	  READONLY: 0x0000001,
	  REQUIRED: 0x0000002,
	  NOEXPORT: 0x0000004,
	  MULTILINE: 0x0001000,
	  PASSWORD: 0x0002000,
	  NOTOGGLETOOFF: 0x0004000,
	  RADIO: 0x0008000,
	  PUSHBUTTON: 0x0010000,
	  COMBO: 0x0020000,
	  EDIT: 0x0040000,
	  SORT: 0x0080000,
	  FILESELECT: 0x0100000,
	  MULTISELECT: 0x0200000,
	  DONOTSPELLCHECK: 0x0400000,
	  DONOTSCROLL: 0x0800000,
	  COMB: 0x1000000,
	  RICHTEXT: 0x2000000,
	  RADIOSINUNISON: 0x2000000,
	  COMMITONSELCHANGE: 0x4000000
	};
	var AnnotationBorderStyleType = {
	  SOLID: 1,
	  DASHED: 2,
	  BEVELED: 3,
	  INSET: 4,
	  UNDERLINE: 5
	};
	var StreamType = {
	  UNKNOWN: 0,
	  FLATE: 1,
	  LZW: 2,
	  DCT: 3,
	  JPX: 4,
	  JBIG: 5,
	  A85: 6,
	  AHX: 7,
	  CCF: 8,
	  RL: 9
	};
	var FontType = {
	  UNKNOWN: 0,
	  TYPE1: 1,
	  TYPE1C: 2,
	  CIDFONTTYPE0: 3,
	  CIDFONTTYPE0C: 4,
	  TRUETYPE: 5,
	  CIDFONTTYPE2: 6,
	  TYPE3: 7,
	  OPENTYPE: 8,
	  TYPE0: 9,
	  MMTYPE1: 10
	};
	var VERBOSITY_LEVELS = {
	  errors: 0,
	  warnings: 1,
	  infos: 5
	};
	var CMapCompressionType = {
	  NONE: 0,
	  BINARY: 1,
	  STREAM: 2
	};
	var OPS = {
	  dependency: 1,
	  setLineWidth: 2,
	  setLineCap: 3,
	  setLineJoin: 4,
	  setMiterLimit: 5,
	  setDash: 6,
	  setRenderingIntent: 7,
	  setFlatness: 8,
	  setGState: 9,
	  save: 10,
	  restore: 11,
	  transform: 12,
	  moveTo: 13,
	  lineTo: 14,
	  curveTo: 15,
	  curveTo2: 16,
	  curveTo3: 17,
	  closePath: 18,
	  rectangle: 19,
	  stroke: 20,
	  closeStroke: 21,
	  fill: 22,
	  eoFill: 23,
	  fillStroke: 24,
	  eoFillStroke: 25,
	  closeFillStroke: 26,
	  closeEOFillStroke: 27,
	  endPath: 28,
	  clip: 29,
	  eoClip: 30,
	  beginText: 31,
	  endText: 32,
	  setCharSpacing: 33,
	  setWordSpacing: 34,
	  setHScale: 35,
	  setLeading: 36,
	  setFont: 37,
	  setTextRenderingMode: 38,
	  setTextRise: 39,
	  moveText: 40,
	  setLeadingMoveText: 41,
	  setTextMatrix: 42,
	  nextLine: 43,
	  showText: 44,
	  showSpacedText: 45,
	  nextLineShowText: 46,
	  nextLineSetSpacingShowText: 47,
	  setCharWidth: 48,
	  setCharWidthAndBounds: 49,
	  setStrokeColorSpace: 50,
	  setFillColorSpace: 51,
	  setStrokeColor: 52,
	  setStrokeColorN: 53,
	  setFillColor: 54,
	  setFillColorN: 55,
	  setStrokeGray: 56,
	  setFillGray: 57,
	  setStrokeRGBColor: 58,
	  setFillRGBColor: 59,
	  setStrokeCMYKColor: 60,
	  setFillCMYKColor: 61,
	  shadingFill: 62,
	  beginInlineImage: 63,
	  beginImageData: 64,
	  endInlineImage: 65,
	  paintXObject: 66,
	  markPoint: 67,
	  markPointProps: 68,
	  beginMarkedContent: 69,
	  beginMarkedContentProps: 70,
	  endMarkedContent: 71,
	  beginCompat: 72,
	  endCompat: 73,
	  paintFormXObjectBegin: 74,
	  paintFormXObjectEnd: 75,
	  beginGroup: 76,
	  endGroup: 77,
	  beginAnnotations: 78,
	  endAnnotations: 79,
	  beginAnnotation: 80,
	  endAnnotation: 81,
	  paintJpegXObject: 82,
	  paintImageMaskXObject: 83,
	  paintImageMaskXObjectGroup: 84,
	  paintImageXObject: 85,
	  paintInlineImageXObject: 86,
	  paintInlineImageXObjectGroup: 87,
	  paintImageXObjectRepeat: 88,
	  paintImageMaskXObjectRepeat: 89,
	  paintSolidColorImageMask: 90,
	  constructPath: 91
	};
	var verbosity = VERBOSITY_LEVELS.warnings;
	function setVerbosityLevel(level) {
	  verbosity = level;
	}
	function getVerbosityLevel() {
	  return verbosity;
	}
	function info(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.infos) {
	    console.log('Info: ' + msg);
	  }
	}
	function warn(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.warnings) {
	    console.log('Warning: ' + msg);
	  }
	}
	function deprecated(details) {
	  console.log('Deprecated API usage: ' + details);
	}
	function unreachable(msg) {
	  throw new Error(msg);
	}
	function assert(cond, msg) {
	  if (!cond) {
	    unreachable(msg);
	  }
	}
	var UNSUPPORTED_FEATURES = {
	  unknown: 'unknown',
	  forms: 'forms',
	  javaScript: 'javaScript',
	  smask: 'smask',
	  shadingPattern: 'shadingPattern',
	  font: 'font'
	};
	function isSameOrigin(baseUrl, otherUrl) {
	  try {
	    var base = new URL(baseUrl);
	    if (!base.origin || base.origin === 'null') {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	  var other = new URL(otherUrl, base);
	  return base.origin === other.origin;
	}
	function isValidProtocol(url) {
	  if (!url) {
	    return false;
	  }
	  switch (url.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'mailto:':
	    case 'tel:':
	      return true;
	    default:
	      return false;
	  }
	}
	function createValidAbsoluteUrl(url, baseUrl) {
	  if (!url) {
	    return null;
	  }
	  try {
	    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
	    if (isValidProtocol(absoluteUrl)) {
	      return absoluteUrl;
	    }
	  } catch (ex) {}
	  return null;
	}
	function shadow(obj, prop, value) {
	  Object.defineProperty(obj, prop, {
	    value: value,
	    enumerable: true,
	    configurable: true,
	    writable: false
	  });
	  return value;
	}
	function getLookupTableFactory(initializer) {
	  var lookup;
	  return function () {
	    if (initializer) {
	      lookup = Object.create(null);
	      initializer(lookup);
	      initializer = null;
	    }
	    return lookup;
	  };
	}
	var PasswordResponses = {
	  NEED_PASSWORD: 1,
	  INCORRECT_PASSWORD: 2
	};
	var PasswordException = function PasswordExceptionClosure() {
	  function PasswordException(msg, code) {
	    this.name = 'PasswordException';
	    this.message = msg;
	    this.code = code;
	  }
	  PasswordException.prototype = new Error();
	  PasswordException.constructor = PasswordException;
	  return PasswordException;
	}();
	var UnknownErrorException = function UnknownErrorExceptionClosure() {
	  function UnknownErrorException(msg, details) {
	    this.name = 'UnknownErrorException';
	    this.message = msg;
	    this.details = details;
	  }
	  UnknownErrorException.prototype = new Error();
	  UnknownErrorException.constructor = UnknownErrorException;
	  return UnknownErrorException;
	}();
	var InvalidPDFException = function InvalidPDFExceptionClosure() {
	  function InvalidPDFException(msg) {
	    this.name = 'InvalidPDFException';
	    this.message = msg;
	  }
	  InvalidPDFException.prototype = new Error();
	  InvalidPDFException.constructor = InvalidPDFException;
	  return InvalidPDFException;
	}();
	var MissingPDFException = function MissingPDFExceptionClosure() {
	  function MissingPDFException(msg) {
	    this.name = 'MissingPDFException';
	    this.message = msg;
	  }
	  MissingPDFException.prototype = new Error();
	  MissingPDFException.constructor = MissingPDFException;
	  return MissingPDFException;
	}();
	var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
	  function UnexpectedResponseException(msg, status) {
	    this.name = 'UnexpectedResponseException';
	    this.message = msg;
	    this.status = status;
	  }
	  UnexpectedResponseException.prototype = new Error();
	  UnexpectedResponseException.constructor = UnexpectedResponseException;
	  return UnexpectedResponseException;
	}();
	var NotImplementedException = function NotImplementedExceptionClosure() {
	  function NotImplementedException(msg) {
	    this.message = msg;
	  }
	  NotImplementedException.prototype = new Error();
	  NotImplementedException.prototype.name = 'NotImplementedException';
	  NotImplementedException.constructor = NotImplementedException;
	  return NotImplementedException;
	}();
	var MissingDataException = function MissingDataExceptionClosure() {
	  function MissingDataException(begin, end) {
	    this.begin = begin;
	    this.end = end;
	    this.message = 'Missing data [' + begin + ', ' + end + ')';
	  }
	  MissingDataException.prototype = new Error();
	  MissingDataException.prototype.name = 'MissingDataException';
	  MissingDataException.constructor = MissingDataException;
	  return MissingDataException;
	}();
	var XRefParseException = function XRefParseExceptionClosure() {
	  function XRefParseException(msg) {
	    this.message = msg;
	  }
	  XRefParseException.prototype = new Error();
	  XRefParseException.prototype.name = 'XRefParseException';
	  XRefParseException.constructor = XRefParseException;
	  return XRefParseException;
	}();
	var FormatError = function FormatErrorClosure() {
	  function FormatError(msg) {
	    this.message = msg;
	  }
	  FormatError.prototype = new Error();
	  FormatError.prototype.name = 'FormatError';
	  FormatError.constructor = FormatError;
	  return FormatError;
	}();
	var AbortException = function AbortExceptionClosure() {
	  function AbortException(msg) {
	    this.name = 'AbortException';
	    this.message = msg;
	  }
	  AbortException.prototype = new Error();
	  AbortException.constructor = AbortException;
	  return AbortException;
	}();
	var NullCharactersRegExp = /\x00/g;
	function removeNullCharacters(str) {
	  if (typeof str !== 'string') {
	    warn('The argument for removeNullCharacters must be a string.');
	    return str;
	  }
	  return str.replace(NullCharactersRegExp, '');
	}
	function bytesToString(bytes) {
	  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
	  var length = bytes.length;
	  var MAX_ARGUMENT_COUNT = 8192;
	  if (length < MAX_ARGUMENT_COUNT) {
	    return String.fromCharCode.apply(null, bytes);
	  }
	  var strBuf = [];
	  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
	    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
	    var chunk = bytes.subarray(i, chunkEnd);
	    strBuf.push(String.fromCharCode.apply(null, chunk));
	  }
	  return strBuf.join('');
	}
	function stringToBytes(str) {
	  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
	  var length = str.length;
	  var bytes = new Uint8Array(length);
	  for (var i = 0; i < length; ++i) {
	    bytes[i] = str.charCodeAt(i) & 0xFF;
	  }
	  return bytes;
	}
	function arrayByteLength(arr) {
	  if (arr.length !== undefined) {
	    return arr.length;
	  }
	  assert(arr.byteLength !== undefined);
	  return arr.byteLength;
	}
	function arraysToBytes(arr) {
	  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
	    return arr[0];
	  }
	  var resultLength = 0;
	  var i,
	      ii = arr.length;
	  var item, itemLength;
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    itemLength = arrayByteLength(item);
	    resultLength += itemLength;
	  }
	  var pos = 0;
	  var data = new Uint8Array(resultLength);
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    if (!(item instanceof Uint8Array)) {
	      if (typeof item === 'string') {
	        item = stringToBytes(item);
	      } else {
	        item = new Uint8Array(item);
	      }
	    }
	    itemLength = item.byteLength;
	    data.set(item, pos);
	    pos += itemLength;
	  }
	  return data;
	}
	function string32(value) {
	  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
	}
	function log2(x) {
	  var n = 1,
	      i = 0;
	  while (x > n) {
	    n <<= 1;
	    i++;
	  }
	  return i;
	}
	function readInt8(data, start) {
	  return data[start] << 24 >> 24;
	}
	function readUint16(data, offset) {
	  return data[offset] << 8 | data[offset + 1];
	}
	function readUint32(data, offset) {
	  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
	}
	function isLittleEndian() {
	  var buffer8 = new Uint8Array(4);
	  buffer8[0] = 1;
	  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
	  return view32[0] === 1;
	}
	function isEvalSupported() {
	  try {
	    new Function('');
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
	var Util = function UtilClosure() {
	  function Util() {}
	  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
	  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
	    rgbBuf[1] = r;
	    rgbBuf[3] = g;
	    rgbBuf[5] = b;
	    return rgbBuf.join('');
	  };
	  Util.transform = function Util_transform(m1, m2) {
	    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
	  };
	  Util.applyTransform = function Util_applyTransform(p, m) {
	    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
	    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
	    return [xt, yt];
	  };
	  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
	    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
	    return [xt, yt];
	  };
	  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
	    var p1 = Util.applyTransform(r, m);
	    var p2 = Util.applyTransform(r.slice(2, 4), m);
	    var p3 = Util.applyTransform([r[0], r[3]], m);
	    var p4 = Util.applyTransform([r[2], r[1]], m);
	    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
	  };
	  Util.inverseTransform = function Util_inverseTransform(m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
	  };
	  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
	    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
	  };
	  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
	    var transpose = [m[0], m[2], m[1], m[3]];
	    var a = m[0] * transpose[0] + m[1] * transpose[2];
	    var b = m[0] * transpose[1] + m[1] * transpose[3];
	    var c = m[2] * transpose[0] + m[3] * transpose[2];
	    var d = m[2] * transpose[1] + m[3] * transpose[3];
	    var first = (a + d) / 2;
	    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
	    var sx = first + second || 1;
	    var sy = first - second || 1;
	    return [Math.sqrt(sx), Math.sqrt(sy)];
	  };
	  Util.normalizeRect = function Util_normalizeRect(rect) {
	    var r = rect.slice(0);
	    if (rect[0] > rect[2]) {
	      r[0] = rect[2];
	      r[2] = rect[0];
	    }
	    if (rect[1] > rect[3]) {
	      r[1] = rect[3];
	      r[3] = rect[1];
	    }
	    return r;
	  };
	  Util.intersect = function Util_intersect(rect1, rect2) {
	    function compare(a, b) {
	      return a - b;
	    }
	    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
	        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
	        result = [];
	    rect1 = Util.normalizeRect(rect1);
	    rect2 = Util.normalizeRect(rect2);
	    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
	      result[0] = orderedX[1];
	      result[2] = orderedX[2];
	    } else {
	      return false;
	    }
	    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
	      result[1] = orderedY[1];
	      result[3] = orderedY[2];
	    } else {
	      return false;
	    }
	    return result;
	  };
	  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
	  Util.toRoman = function Util_toRoman(number, lowerCase) {
	    assert(Number.isInteger(number) && number > 0, 'The number should be a positive integer.');
	    var pos,
	        romanBuf = [];
	    while (number >= 1000) {
	      number -= 1000;
	      romanBuf.push('M');
	    }
	    pos = number / 100 | 0;
	    number %= 100;
	    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
	    pos = number / 10 | 0;
	    number %= 10;
	    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
	    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
	    var romanStr = romanBuf.join('');
	    return lowerCase ? romanStr.toLowerCase() : romanStr;
	  };
	  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
	    Array.prototype.push.apply(arr1, arr2);
	  };
	  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
	    Array.prototype.unshift.apply(arr1, arr2);
	  };
	  Util.extendObj = function extendObj(obj1, obj2) {
	    for (var key in obj2) {
	      obj1[key] = obj2[key];
	    }
	  };
	  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
	    while (dict && !dict.has(name)) {
	      dict = dict.get('Parent');
	    }
	    if (!dict) {
	      return null;
	    }
	    return getArray ? dict.getArray(name) : dict.get(name);
	  };
	  Util.inherit = function Util_inherit(sub, base, prototype) {
	    sub.prototype = Object.create(base.prototype);
	    sub.prototype.constructor = sub;
	    for (var prop in prototype) {
	      sub.prototype[prop] = prototype[prop];
	    }
	  };
	  Util.loadScript = function Util_loadScript(src, callback) {
	    var script = document.createElement('script');
	    var loaded = false;
	    script.setAttribute('src', src);
	    if (callback) {
	      script.onload = function () {
	        if (!loaded) {
	          callback();
	        }
	        loaded = true;
	      };
	    }
	    document.getElementsByTagName('head')[0].appendChild(script);
	  };
	  return Util;
	}();
	var PageViewport = function PageViewportClosure() {
	  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
	    this.viewBox = viewBox;
	    this.scale = scale;
	    this.rotation = rotation;
	    this.offsetX = offsetX;
	    this.offsetY = offsetY;
	    var centerX = (viewBox[2] + viewBox[0]) / 2;
	    var centerY = (viewBox[3] + viewBox[1]) / 2;
	    var rotateA, rotateB, rotateC, rotateD;
	    rotation = rotation % 360;
	    rotation = rotation < 0 ? rotation + 360 : rotation;
	    switch (rotation) {
	      case 180:
	        rotateA = -1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = 1;
	        break;
	      case 90:
	        rotateA = 0;
	        rotateB = 1;
	        rotateC = 1;
	        rotateD = 0;
	        break;
	      case 270:
	        rotateA = 0;
	        rotateB = -1;
	        rotateC = -1;
	        rotateD = 0;
	        break;
	      default:
	        rotateA = 1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = -1;
	        break;
	    }
	    if (dontFlip) {
	      rotateC = -rotateC;
	      rotateD = -rotateD;
	    }
	    var offsetCanvasX, offsetCanvasY;
	    var width, height;
	    if (rotateA === 0) {
	      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
	      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
	      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
	    } else {
	      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
	      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
	      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
	    }
	    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
	    this.width = width;
	    this.height = height;
	    this.fontScale = scale;
	  }
	  PageViewport.prototype = {
	    clone: function PageViewPort_clone(args) {
	      args = args || {};
	      var scale = 'scale' in args ? args.scale : this.scale;
	      var rotation = 'rotation' in args ? args.rotation : this.rotation;
	      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
	    },
	    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
	      return Util.applyTransform([x, y], this.transform);
	    },
	    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
	      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
	      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
	      return [tl[0], tl[1], br[0], br[1]];
	    },
	    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
	      return Util.applyInverseTransform([x, y], this.transform);
	    }
	  };
	  return PageViewport;
	}();
	var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
	function stringToPDFString(str) {
	  var i,
	      n = str.length,
	      strBuf = [];
	  if (str[0] === '\xFE' && str[1] === '\xFF') {
	    for (i = 2; i < n; i += 2) {
	      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
	    }
	  } else {
	    for (i = 0; i < n; ++i) {
	      var code = PDFStringTranslateTable[str.charCodeAt(i)];
	      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
	    }
	  }
	  return strBuf.join('');
	}
	function stringToUTF8String(str) {
	  return decodeURIComponent(escape(str));
	}
	function utf8StringToString(str) {
	  return unescape(encodeURIComponent(str));
	}
	function isEmptyObj(obj) {
	  for (var key in obj) {
	    return false;
	  }
	  return true;
	}
	function isBool(v) {
	  return typeof v === 'boolean';
	}
	function isNum(v) {
	  return typeof v === 'number';
	}
	function isString(v) {
	  return typeof v === 'string';
	}
	function isArrayBuffer(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
	}
	function isSpace(ch) {
	  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
	}
	function isNodeJS() {
	  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
	}
	function createPromiseCapability() {
	  var capability = {};
	  capability.promise = new Promise(function (resolve, reject) {
	    capability.resolve = resolve;
	    capability.reject = reject;
	  });
	  return capability;
	}
	var StatTimer = function StatTimerClosure() {
	  function rpad(str, pad, length) {
	    while (str.length < length) {
	      str += pad;
	    }
	    return str;
	  }
	  function StatTimer() {
	    this.started = Object.create(null);
	    this.times = [];
	    this.enabled = true;
	  }
	  StatTimer.prototype = {
	    time: function StatTimer_time(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (name in this.started) {
	        warn('Timer is already running for ' + name);
	      }
	      this.started[name] = Date.now();
	    },
	    timeEnd: function StatTimer_timeEnd(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (!(name in this.started)) {
	        warn('Timer has not been started for ' + name);
	      }
	      this.times.push({
	        'name': name,
	        'start': this.started[name],
	        'end': Date.now()
	      });
	      delete this.started[name];
	    },
	    toString: function StatTimer_toString() {
	      var i, ii;
	      var times = this.times;
	      var out = '';
	      var longest = 0;
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var name = times[i]['name'];
	        if (name.length > longest) {
	          longest = name.length;
	        }
	      }
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var span = times[i];
	        var duration = span.end - span.start;
	        out += rpad(span['name'], ' ', longest) + ' ' + duration + 'ms\n';
	      }
	      return out;
	    }
	  };
	  return StatTimer;
	}();
	var createBlob = function createBlob(data, contentType) {
	  if (typeof Blob !== 'undefined') {
	    return new Blob([data], { type: contentType });
	  }
	  throw new Error('The "Blob" constructor is not supported.');
	};
	var createObjectURL = function createObjectURLClosure() {
	  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  return function createObjectURL(data, contentType) {
	    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (!forceDataSchema && URL.createObjectURL) {
	      var blob = createBlob(data, contentType);
	      return URL.createObjectURL(blob);
	    }
	    var buffer = 'data:' + contentType + ';base64,';
	    for (var i = 0, ii = data.length; i < ii; i += 3) {
	      var b1 = data[i] & 0xFF;
	      var b2 = data[i + 1] & 0xFF;
	      var b3 = data[i + 2] & 0xFF;
	      var d1 = b1 >> 2,
	          d2 = (b1 & 3) << 4 | b2 >> 4;
	      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
	      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
	    }
	    return buffer;
	  };
	}();
	function resolveCall(fn, args) {
	  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!fn) {
	    return Promise.resolve(undefined);
	  }
	  return new Promise(function (resolve, reject) {
	    resolve(fn.apply(thisArg, args));
	  });
	}
	function wrapReason(reason) {
	  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
	    return reason;
	  }
	  switch (reason.name) {
	    case 'AbortException':
	      return new AbortException(reason.message);
	    case 'MissingPDFException':
	      return new MissingPDFException(reason.message);
	    case 'UnexpectedResponseException':
	      return new UnexpectedResponseException(reason.message, reason.status);
	    default:
	      return new UnknownErrorException(reason.message, reason.details);
	  }
	}
	function makeReasonSerializable(reason) {
	  if (!(reason instanceof Error) || reason instanceof AbortException || reason instanceof MissingPDFException || reason instanceof UnexpectedResponseException || reason instanceof UnknownErrorException) {
	    return reason;
	  }
	  return new UnknownErrorException(reason.message, reason.toString());
	}
	function resolveOrReject(capability, success, reason) {
	  if (success) {
	    capability.resolve();
	  } else {
	    capability.reject(reason);
	  }
	}
	function finalize(promise) {
	  return Promise.resolve(promise).catch(function () {});
	}
	function MessageHandler(sourceName, targetName, comObj) {
	  var _this = this;
	
	  this.sourceName = sourceName;
	  this.targetName = targetName;
	  this.comObj = comObj;
	  this.callbackId = 1;
	  this.streamId = 1;
	  this.postMessageTransfers = true;
	  this.streamSinks = Object.create(null);
	  this.streamControllers = Object.create(null);
	  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
	  var ah = this.actionHandler = Object.create(null);
	  this._onComObjOnMessage = function (event) {
	    var data = event.data;
	    if (data.targetName !== _this.sourceName) {
	      return;
	    }
	    if (data.stream) {
	      _this._processStreamMessage(data);
	    } else if (data.isReply) {
	      var callbackId = data.callbackId;
	      if (data.callbackId in callbacksCapabilities) {
	        var callback = callbacksCapabilities[callbackId];
	        delete callbacksCapabilities[callbackId];
	        if ('error' in data) {
	          callback.reject(wrapReason(data.error));
	        } else {
	          callback.resolve(data.data);
	        }
	      } else {
	        throw new Error('Cannot resolve callback ' + callbackId);
	      }
	    } else if (data.action in ah) {
	      var action = ah[data.action];
	      if (data.callbackId) {
	        var _sourceName = _this.sourceName;
	        var _targetName = data.sourceName;
	        Promise.resolve().then(function () {
	          return action[0].call(action[1], data.data);
	        }).then(function (result) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            data: result
	          });
	        }, function (reason) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            error: makeReasonSerializable(reason)
	          });
	        });
	      } else if (data.streamId) {
	        _this._createStreamSink(data);
	      } else {
	        action[0].call(action[1], data.data);
	      }
	    } else {
	      throw new Error('Unknown action from worker: ' + data.action);
	    }
	  };
	  comObj.addEventListener('message', this._onComObjOnMessage);
	}
	MessageHandler.prototype = {
	  on: function on(actionName, handler, scope) {
	    var ah = this.actionHandler;
	    if (ah[actionName]) {
	      throw new Error('There is already an actionName called "' + actionName + '"');
	    }
	    ah[actionName] = [handler, scope];
	  },
	  send: function send(actionName, data, transfers) {
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data
	    };
	    this.postMessage(message, transfers);
	  },
	  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
	    var callbackId = this.callbackId++;
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data,
	      callbackId: callbackId
	    };
	    var capability = createPromiseCapability();
	    this.callbacksCapabilities[callbackId] = capability;
	    try {
	      this.postMessage(message, transfers);
	    } catch (e) {
	      capability.reject(e);
	    }
	    return capability.promise;
	  },
	  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
	    var _this2 = this;
	
	    var streamId = this.streamId++;
	    var sourceName = this.sourceName;
	    var targetName = this.targetName;
	    return new _streams_polyfill.ReadableStream({
	      start: function start(controller) {
	        var startCapability = createPromiseCapability();
	        _this2.streamControllers[streamId] = {
	          controller: controller,
	          startCall: startCapability,
	          isClosed: false
	        };
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          action: actionName,
	          streamId: streamId,
	          data: data,
	          desiredSize: controller.desiredSize
	        });
	        return startCapability.promise;
	      },
	      pull: function pull(controller) {
	        var pullCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].pullCall = pullCapability;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'pull',
	          streamId: streamId,
	          desiredSize: controller.desiredSize
	        });
	        return pullCapability.promise;
	      },
	      cancel: function cancel(reason) {
	        var cancelCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].cancelCall = cancelCapability;
	        _this2.streamControllers[streamId].isClosed = true;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'cancel',
	          reason: reason,
	          streamId: streamId
	        });
	        return cancelCapability.promise;
	      }
	    }, queueingStrategy);
	  },
	  _createStreamSink: function _createStreamSink(data) {
	    var _this3 = this;
	
	    var self = this;
	    var action = this.actionHandler[data.action];
	    var streamId = data.streamId;
	    var desiredSize = data.desiredSize;
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var capability = createPromiseCapability();
	    var sendStreamRequest = function sendStreamRequest(_ref) {
	      var stream = _ref.stream,
	          chunk = _ref.chunk,
	          transfers = _ref.transfers,
	          success = _ref.success,
	          reason = _ref.reason;
	
	      _this3.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        streamId: streamId,
	        chunk: chunk,
	        success: success,
	        reason: reason
	      }, transfers);
	    };
	    var streamSink = {
	      enqueue: function enqueue(chunk) {
	        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var transfers = arguments[2];
	
	        if (this.isCancelled) {
	          return;
	        }
	        var lastDesiredSize = this.desiredSize;
	        this.desiredSize -= size;
	        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
	          this.sinkCapability = createPromiseCapability();
	          this.ready = this.sinkCapability.promise;
	        }
	        sendStreamRequest({
	          stream: 'enqueue',
	          chunk: chunk,
	          transfers: transfers
	        });
	      },
	      close: function close() {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({ stream: 'close' });
	        delete self.streamSinks[streamId];
	      },
	      error: function error(reason) {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({
	          stream: 'error',
	          reason: reason
	        });
	      },
	
	      sinkCapability: capability,
	      onPull: null,
	      onCancel: null,
	      isCancelled: false,
	      desiredSize: desiredSize,
	      ready: null
	    };
	    streamSink.sinkCapability.resolve();
	    streamSink.ready = streamSink.sinkCapability.promise;
	    this.streamSinks[streamId] = streamSink;
	    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: true
	      });
	    }, function (reason) {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: false,
	        reason: reason
	      });
	    });
	  },
	  _processStreamMessage: function _processStreamMessage(data) {
	    var _this4 = this;
	
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var streamId = data.streamId;
	    var sendStreamResponse = function sendStreamResponse(_ref2) {
	      var stream = _ref2.stream,
	          success = _ref2.success,
	          reason = _ref2.reason;
	
	      _this4.comObj.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        success: success,
	        streamId: streamId,
	        reason: reason
	      });
	    };
	    var deleteStreamController = function deleteStreamController() {
	      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
	        return capability && finalize(capability.promise);
	      })).then(function () {
	        delete _this4.streamControllers[data.streamId];
	      });
	    };
	    switch (data.stream) {
	      case 'start_complete':
	        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull_complete':
	        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull':
	        if (!this.streamSinks[data.streamId]) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	          break;
	        }
	        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
	          this.streamSinks[data.streamId].sinkCapability.resolve();
	        }
	        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
	        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        break;
	      case 'enqueue':
	        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
	        if (!this.streamControllers[data.streamId].isClosed) {
	          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
	        }
	        break;
	      case 'close':
	        assert(this.streamControllers[data.streamId], 'close should have stream controller');
	        if (this.streamControllers[data.streamId].isClosed) {
	          break;
	        }
	        this.streamControllers[data.streamId].isClosed = true;
	        this.streamControllers[data.streamId].controller.close();
	        deleteStreamController();
	        break;
	      case 'error':
	        assert(this.streamControllers[data.streamId], 'error should have stream controller');
	        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel_complete':
	        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel':
	        if (!this.streamSinks[data.streamId]) {
	          break;
	        }
	        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
	        this.streamSinks[data.streamId].isCancelled = true;
	        delete this.streamSinks[data.streamId];
	        break;
	      default:
	        throw new Error('Unexpected stream case');
	    }
	  },
	  postMessage: function postMessage(message, transfers) {
	    if (transfers && this.postMessageTransfers) {
	      this.comObj.postMessage(message, transfers);
	    } else {
	      this.comObj.postMessage(message);
	    }
	  },
	  destroy: function destroy() {
	    this.comObj.removeEventListener('message', this._onComObjOnMessage);
	  }
	};
	function loadJpegStream(id, imageUrl, objs) {
	  var img = new Image();
	  img.onload = function loadJpegStream_onloadClosure() {
	    objs.resolve(id, img);
	  };
	  img.onerror = function loadJpegStream_onerrorClosure() {
	    objs.resolve(id, null);
	    warn('Error during JPEG image loading');
	  };
	  img.src = imageUrl;
	}
	exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
	exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
	exports.OPS = OPS;
	exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
	exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
	exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
	exports.AnnotationFieldFlag = AnnotationFieldFlag;
	exports.AnnotationFlag = AnnotationFlag;
	exports.AnnotationType = AnnotationType;
	exports.FontType = FontType;
	exports.ImageKind = ImageKind;
	exports.CMapCompressionType = CMapCompressionType;
	exports.AbortException = AbortException;
	exports.InvalidPDFException = InvalidPDFException;
	exports.MessageHandler = MessageHandler;
	exports.MissingDataException = MissingDataException;
	exports.MissingPDFException = MissingPDFException;
	exports.NativeImageDecoding = NativeImageDecoding;
	exports.NotImplementedException = NotImplementedException;
	exports.PageViewport = PageViewport;
	exports.PasswordException = PasswordException;
	exports.PasswordResponses = PasswordResponses;
	exports.StatTimer = StatTimer;
	exports.StreamType = StreamType;
	exports.TextRenderingMode = TextRenderingMode;
	exports.UnexpectedResponseException = UnexpectedResponseException;
	exports.UnknownErrorException = UnknownErrorException;
	exports.Util = Util;
	exports.XRefParseException = XRefParseException;
	exports.FormatError = FormatError;
	exports.arrayByteLength = arrayByteLength;
	exports.arraysToBytes = arraysToBytes;
	exports.assert = assert;
	exports.bytesToString = bytesToString;
	exports.createBlob = createBlob;
	exports.createPromiseCapability = createPromiseCapability;
	exports.createObjectURL = createObjectURL;
	exports.deprecated = deprecated;
	exports.getLookupTableFactory = getLookupTableFactory;
	exports.getVerbosityLevel = getVerbosityLevel;
	exports.info = info;
	exports.isArrayBuffer = isArrayBuffer;
	exports.isBool = isBool;
	exports.isEmptyObj = isEmptyObj;
	exports.isNum = isNum;
	exports.isString = isString;
	exports.isSpace = isSpace;
	exports.isNodeJS = isNodeJS;
	exports.isSameOrigin = isSameOrigin;
	exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
	exports.isLittleEndian = isLittleEndian;
	exports.isEvalSupported = isEvalSupported;
	exports.loadJpegStream = loadJpegStream;
	exports.log2 = log2;
	exports.readInt8 = readInt8;
	exports.readUint16 = readUint16;
	exports.readUint32 = readUint32;
	exports.removeNullCharacters = removeNullCharacters;
	exports.ReadableStream = _streams_polyfill.ReadableStream;
	exports.setVerbosityLevel = setVerbosityLevel;
	exports.shadow = shadow;
	exports.string32 = string32;
	exports.stringToBytes = stringToBytes;
	exports.stringToPDFString = stringToPDFString;
	exports.stringToUTF8String = stringToUTF8String;
	exports.utf8StringToString = utf8StringToString;
	exports.warn = warn;
	exports.unreachable = unreachable;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if (typeof __g == 'number') __g = global;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function (it) {
	  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var store = __w_pdfjs_require__(51)('wks');
	var uid = __w_pdfjs_require__(16);
	var _Symbol = __w_pdfjs_require__(1).Symbol;
	var USE_SYMBOL = typeof _Symbol == 'function';
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
	};
	$exports.store = store;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var core = __w_pdfjs_require__(4);
	var hide = __w_pdfjs_require__(6);
	var redefine = __w_pdfjs_require__(14);
	var ctx = __w_pdfjs_require__(11);
	var PROTOTYPE = 'prototype';
	var $export = function $export(type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    own = !IS_FORCED && target && target[key] !== undefined;
	    out = (own ? target : source)[key];
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if (target) redefine(target, key, out, type & $export.U);
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	$export.F = 1;
	$export.G = 2;
	$export.S = 4;
	$export.P = 8;
	$export.B = 16;
	$export.W = 32;
	$export.U = 64;
	$export.R = 128;
	module.exports = $export;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var dP = __w_pdfjs_require__(13);
	var createDesc = __w_pdfjs_require__(27);
	module.exports = __w_pdfjs_require__(8) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(2);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = !__w_pdfjs_require__(9)(function () {
	  return Object.defineProperty({}, 'a', {
	    get: function get() {
	      return 7;
	    }
	  }).a != 7;
	});
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var aFunction = __w_pdfjs_require__(22);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1:
	      return function (a) {
	        return fn.call(that, a);
	      };
	    case 2:
	      return function (a, b) {
	        return fn.call(that, a, b);
	      };
	    case 3:
	      return function (a, b, c) {
	        return fn.call(that, a, b, c);
	      };
	  }
	  return function () {
	    return fn.apply(that, arguments);
	  };
	};
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(17);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
	};
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(7);
	var IE8_DOM_DEFINE = __w_pdfjs_require__(45);
	var toPrimitive = __w_pdfjs_require__(33);
	var dP = Object.defineProperty;
	exports.f = __w_pdfjs_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) {}
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var hide = __w_pdfjs_require__(6);
	var has = __w_pdfjs_require__(10);
	var SRC = __w_pdfjs_require__(16)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	__w_pdfjs_require__(4).inspectSource = function (it) {
	  return $toString.call(it);
	};
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isValidUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = exports.CustomStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _global_scope = __w_pdfjs_require__(20);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
	var SVG_NS = 'http://www.w3.org/2000/svg';
	
	var DOMCanvasFactory = function () {
	  function DOMCanvasFactory() {
	    _classCallCheck(this, DOMCanvasFactory);
	  }
	
	  _createClass(DOMCanvasFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = width;
	      canvas.height = height;
	      return {
	        canvas: canvas,
	        context: context
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset(canvasAndContext, width, height) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      canvasAndContext.canvas.width = width;
	      canvasAndContext.canvas.height = height;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(canvasAndContext) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      canvasAndContext.canvas.width = 0;
	      canvasAndContext.canvas.height = 0;
	      canvasAndContext.canvas = null;
	      canvasAndContext.context = null;
	    }
	  }]);
	
	  return DOMCanvasFactory;
	}();
	
	var DOMCMapReaderFactory = function () {
	  function DOMCMapReaderFactory(_ref) {
	    var _ref$baseUrl = _ref.baseUrl,
	        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
	        _ref$isCompressed = _ref.isCompressed,
	        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;
	
	    _classCallCheck(this, DOMCMapReaderFactory);
	
	    this.baseUrl = baseUrl;
	    this.isCompressed = isCompressed;
	  }
	
	  _createClass(DOMCMapReaderFactory, [{
	    key: 'fetch',
	    value: function fetch(_ref2) {
	      var _this = this;
	
	      var name = _ref2.name;
	
	      if (!this.baseUrl) {
	        return Promise.reject(new Error('CMap baseUrl must be specified, ' + 'see "PDFJS.cMapUrl" (and also "PDFJS.cMapPacked").'));
	      }
	      if (!name) {
	        return Promise.reject(new Error('CMap name must be specified.'));
	      }
	      return new Promise(function (resolve, reject) {
	        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
	        var request = new XMLHttpRequest();
	        request.open('GET', url, true);
	        if (_this.isCompressed) {
	          request.responseType = 'arraybuffer';
	        }
	        request.onreadystatechange = function () {
	          if (request.readyState !== XMLHttpRequest.DONE) {
	            return;
	          }
	          if (request.status === 200 || request.status === 0) {
	            var data = void 0;
	            if (_this.isCompressed && request.response) {
	              data = new Uint8Array(request.response);
	            } else if (!_this.isCompressed && request.responseText) {
	              data = (0, _util.stringToBytes)(request.responseText);
	            }
	            if (data) {
	              resolve({
	                cMapData: data,
	                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
	              });
	              return;
	            }
	          }
	          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
	        };
	        request.send(null);
	      });
	    }
	  }]);
	
	  return DOMCMapReaderFactory;
	}();
	
	var DOMSVGFactory = function () {
	  function DOMSVGFactory() {
	    _classCallCheck(this, DOMSVGFactory);
	  }
	
	  _createClass(DOMSVGFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions');
	      var svg = document.createElementNS(SVG_NS, 'svg:svg');
	      svg.setAttribute('version', '1.1');
	      svg.setAttribute('width', width + 'px');
	      svg.setAttribute('height', height + 'px');
	      svg.setAttribute('preserveAspectRatio', 'none');
	      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
	      return svg;
	    }
	  }, {
	    key: 'createElement',
	    value: function createElement(type) {
	      (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type');
	      return document.createElementNS(SVG_NS, type);
	    }
	  }]);
	
	  return DOMSVGFactory;
	}();
	
	var CustomStyle = function CustomStyleClosure() {
	  var prefixes = ['ms', 'Moz', 'Webkit', 'O'];
	  var _cache = Object.create(null);
	  function CustomStyle() {}
	  CustomStyle.getProp = function get(propName, element) {
	    if (arguments.length === 1 && typeof _cache[propName] === 'string') {
	      return _cache[propName];
	    }
	    element = element || document.documentElement;
	    var style = element.style,
	        prefixed,
	        uPropName;
	    if (typeof style[propName] === 'string') {
	      return _cache[propName] = propName;
	    }
	    uPropName = propName.charAt(0).toUpperCase() + propName.slice(1);
	    for (var i = 0, l = prefixes.length; i < l; i++) {
	      prefixed = prefixes[i] + uPropName;
	      if (typeof style[prefixed] === 'string') {
	        return _cache[propName] = prefixed;
	      }
	    }
	    return _cache[propName] = 'undefined';
	  };
	  CustomStyle.setProp = function set(propName, element, str) {
	    var prop = this.getProp(propName);
	    if (prop !== 'undefined') {
	      element.style[prop] = str;
	    }
	  };
	  return CustomStyle;
	}();
	var RenderingCancelledException = function RenderingCancelledException() {
	  function RenderingCancelledException(msg, type) {
	    this.message = msg;
	    this.type = type;
	  }
	  RenderingCancelledException.prototype = new Error();
	  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
	  RenderingCancelledException.constructor = RenderingCancelledException;
	  return RenderingCancelledException;
	}();
	var LinkTarget = {
	  NONE: 0,
	  SELF: 1,
	  BLANK: 2,
	  PARENT: 3,
	  TOP: 4
	};
	var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
	function addLinkAttributes(link, params) {
	  var url = params && params.url;
	  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
	  if (url) {
	    var target = params.target;
	    if (typeof target === 'undefined') {
	      target = getDefaultSetting('externalLinkTarget');
	    }
	    link.target = LinkTargetStringMap[target];
	    var rel = params.rel;
	    if (typeof rel === 'undefined') {
	      rel = getDefaultSetting('externalLinkRel');
	    }
	    link.rel = rel;
	  }
	}
	function getFilenameFromUrl(url) {
	  var anchor = url.indexOf('#');
	  var query = url.indexOf('?');
	  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
	  return url.substring(url.lastIndexOf('/', end) + 1, end);
	}
	function getDefaultSetting(id) {
	  var globalSettings = _global_scope2.default.PDFJS;
	  switch (id) {
	    case 'pdfBug':
	      return globalSettings ? globalSettings.pdfBug : false;
	    case 'disableAutoFetch':
	      return globalSettings ? globalSettings.disableAutoFetch : false;
	    case 'disableStream':
	      return globalSettings ? globalSettings.disableStream : false;
	    case 'disableRange':
	      return globalSettings ? globalSettings.disableRange : false;
	    case 'disableFontFace':
	      return globalSettings ? globalSettings.disableFontFace : false;
	    case 'disableCreateObjectURL':
	      return globalSettings ? globalSettings.disableCreateObjectURL : false;
	    case 'disableWebGL':
	      return globalSettings ? globalSettings.disableWebGL : true;
	    case 'cMapUrl':
	      return globalSettings ? globalSettings.cMapUrl : null;
	    case 'cMapPacked':
	      return globalSettings ? globalSettings.cMapPacked : false;
	    case 'postMessageTransfers':
	      return globalSettings ? globalSettings.postMessageTransfers : true;
	    case 'workerPort':
	      return globalSettings ? globalSettings.workerPort : null;
	    case 'workerSrc':
	      return globalSettings ? globalSettings.workerSrc : null;
	    case 'disableWorker':
	      return globalSettings ? globalSettings.disableWorker : false;
	    case 'maxImageSize':
	      return globalSettings ? globalSettings.maxImageSize : -1;
	    case 'imageResourcesPath':
	      return globalSettings ? globalSettings.imageResourcesPath : '';
	    case 'isEvalSupported':
	      return globalSettings ? globalSettings.isEvalSupported : true;
	    case 'externalLinkTarget':
	      if (!globalSettings) {
	        return LinkTarget.NONE;
	      }
	      switch (globalSettings.externalLinkTarget) {
	        case LinkTarget.NONE:
	        case LinkTarget.SELF:
	        case LinkTarget.BLANK:
	        case LinkTarget.PARENT:
	        case LinkTarget.TOP:
	          return globalSettings.externalLinkTarget;
	      }
	      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
	      globalSettings.externalLinkTarget = LinkTarget.NONE;
	      return LinkTarget.NONE;
	    case 'externalLinkRel':
	      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
	    case 'enableStats':
	      return !!(globalSettings && globalSettings.enableStats);
	    case 'pdfjsNext':
	      return !!(globalSettings && globalSettings.pdfjsNext);
	    default:
	      throw new Error('Unknown default setting: ' + id);
	  }
	}
	function isExternalLinkTargetSet() {
	  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
	  switch (externalLinkTarget) {
	    case LinkTarget.NONE:
	      return false;
	    case LinkTarget.SELF:
	    case LinkTarget.BLANK:
	    case LinkTarget.PARENT:
	    case LinkTarget.TOP:
	      return true;
	  }
	}
	function isValidUrl(url, allowRelative) {
	  (0, _util.deprecated)('isValidUrl(), please use createValidAbsoluteUrl() instead.');
	  var baseUrl = allowRelative ? 'http://example.com' : null;
	  return (0, _util.createValidAbsoluteUrl)(url, baseUrl) !== null;
	}
	exports.CustomStyle = CustomStyle;
	exports.RenderingCancelledException = RenderingCancelledException;
	exports.addLinkAttributes = addLinkAttributes;
	exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
	exports.isValidUrl = isValidUrl;
	exports.getFilenameFromUrl = getFilenameFromUrl;
	exports.LinkTarget = LinkTarget;
	exports.getDefaultSetting = getDefaultSetting;
	exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
	exports.DOMCanvasFactory = DOMCanvasFactory;
	exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
	exports.DOMSVGFactory = DOMSVGFactory;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var defined = __w_pdfjs_require__(35);
	module.exports = function (it) {
	  return Object(defined(it));
	};
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = {};
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : {};
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = false;
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var redefine = __w_pdfjs_require__(14);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    redefine(target, key, src[key], safe);
	  }return target;
	};
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
	    throw TypeError(name + ': incorrect invocation!');
	  }
	  return it;
	};
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toString = {}.toString;
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var def = __w_pdfjs_require__(13).f;
	var has = __w_pdfjs_require__(10);
	var TAG = __w_pdfjs_require__(3)('toStringTag');
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
	    configurable: true,
	    value: tag
	  });
	};
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var IObject = __w_pdfjs_require__(34);
	var defined = __w_pdfjs_require__(35);
	module.exports = function (it) {
	  return IObject(defined(it));
	};
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(17);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(25);
	var TAG = __w_pdfjs_require__(3)('toStringTag');
	var ARG = cof(function () {
	  return arguments;
	}()) == 'Arguments';
	var tryGet = function tryGet(it, key) {
	  try {
	    return it[key];
	  } catch (e) {}
	};
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(11);
	var call = __w_pdfjs_require__(98);
	var isArrayIter = __w_pdfjs_require__(53);
	var anObject = __w_pdfjs_require__(7);
	var toLength = __w_pdfjs_require__(12);
	var getIterFn = __w_pdfjs_require__(57);
	var BREAK = {};
	var RETURN = {};
	var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () {
	    return iterable;
	  } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	_exports.BREAK = BREAK;
	_exports.RETURN = RETURN;
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(2);
	var document = __w_pdfjs_require__(1).document;
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(2);
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(25);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var shared = __w_pdfjs_require__(51)('keys');
	var uid = __w_pdfjs_require__(16);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $keys = __w_pdfjs_require__(49);
	var enumBugKeys = __w_pdfjs_require__(37);
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(11);
	var IObject = __w_pdfjs_require__(34);
	var toObject = __w_pdfjs_require__(18);
	var toLength = __w_pdfjs_require__(12);
	var asc = __w_pdfjs_require__(82);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (; length > index; index++) {
	      if (NO_HOLES || index in self) {
	        val = self[index];
	        res = f(val, index, O);
	        if (TYPE) {
	          if (IS_MAP) result[index] = res;else if (res) switch (TYPE) {
	            case 3:
	              return true;
	            case 5:
	              return val;
	            case 6:
	              return index;
	            case 2:
	              result.push(val);
	          } else if (IS_EVERY) return false;
	        }
	      }
	    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(7);
	var aFunction = __w_pdfjs_require__(22);
	var SPECIES = __w_pdfjs_require__(3)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ITERATOR = __w_pdfjs_require__(3)('iterator');
	var SAFE_CLOSING = false;
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () {
	    SAFE_CLOSING = true;
	  };
	  Array.from(riter, function () {
	    throw 2;
	  });
	} catch (e) {}
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () {
	      return { done: safe = true };
	    };
	    arr[ITERATOR] = function () {
	      return iter;
	    };
	    exec(arr);
	  } catch (e) {}
	  return safe;
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var aFunction = __w_pdfjs_require__(22);
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var META = __w_pdfjs_require__(16)('meta');
	var isObject = __w_pdfjs_require__(2);
	var has = __w_pdfjs_require__(10);
	var setDesc = __w_pdfjs_require__(13).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__w_pdfjs_require__(9)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function setMeta(it) {
	  setDesc(it, META, {
	    value: {
	      i: 'O' + ++id,
	      w: {}
	    }
	  });
	};
	var fastKey = function fastKey(it, create) {
	  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    if (!isExtensible(it)) return 'F';
	    if (!create) return 'E';
	    setMeta(it);
	  }
	  return it[META].i;
	};
	var getWeak = function getWeak(it, create) {
	  if (!has(it, META)) {
	    if (!isExtensible(it)) return true;
	    if (!create) return false;
	    setMeta(it);
	  }
	  return it[META].w;
	};
	var onFreeze = function onFreeze(it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateResponseStatus = exports.validateRangeRequestCapabilities = exports.createResponseStatusError = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	function validateRangeRequestCapabilities(_ref) {
	  var getResponseHeader = _ref.getResponseHeader,
	      isHttp = _ref.isHttp,
	      rangeChunkSize = _ref.rangeChunkSize,
	      disableRange = _ref.disableRange;
	
	  (0, _util.assert)(rangeChunkSize > 0);
	  var returnValues = {
	    allowRangeRequests: false,
	    suggestedLength: undefined
	  };
	  if (disableRange || !isHttp) {
	    return returnValues;
	  }
	  if (getResponseHeader('Accept-Ranges') !== 'bytes') {
	    return returnValues;
	  }
	  var contentEncoding = getResponseHeader('Content-Encoding') || 'identity';
	  if (contentEncoding !== 'identity') {
	    return returnValues;
	  }
	  var length = parseInt(getResponseHeader('Content-Length'), 10);
	  if (!Number.isInteger(length)) {
	    return returnValues;
	  }
	  returnValues.suggestedLength = length;
	  if (length <= 2 * rangeChunkSize) {
	    return returnValues;
	  }
	  returnValues.allowRangeRequests = true;
	  return returnValues;
	}
	function createResponseStatusError(status, url) {
	  if (status === 404 || status === 0 && /^file:/.test(url)) {
	    return new _util.MissingPDFException('Missing PDF "' + url + '".');
	  }
	  return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
	}
	function validateResponseStatus(status) {
	  return status === 200 || status === 206;
	}
	exports.createResponseStatusError = createResponseStatusError;
	exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
	exports.validateResponseStatus = validateResponseStatus;
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = !__w_pdfjs_require__(8) && !__w_pdfjs_require__(9)(function () {
	  return Object.defineProperty(__w_pdfjs_require__(32)('div'), 'a', {
	    get: function get() {
	      return 7;
	    }
	  }).a != 7;
	});
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var hide = __w_pdfjs_require__(6);
	var uid = __w_pdfjs_require__(16);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(17);
	var toLength = __w_pdfjs_require__(12);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $keys = __w_pdfjs_require__(49);
	var hiddenKeys = __w_pdfjs_require__(37).concat('length', 'prototype');
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var has = __w_pdfjs_require__(10);
	var toIObject = __w_pdfjs_require__(28);
	var arrayIndexOf = __w_pdfjs_require__(50)(false);
	var IE_PROTO = __w_pdfjs_require__(36)('IE_PROTO');
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) {
	    if (key != IE_PROTO) has(O, key) && result.push(key);
	  }while (names.length > i) {
	    if (has(O, key = names[i++])) {
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	  }return result;
	};
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toIObject = __w_pdfjs_require__(28);
	var toLength = __w_pdfjs_require__(12);
	var toAbsoluteIndex = __w_pdfjs_require__(29);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      if (value != value) return true;
	    } else for (; length > index; index++) {
	      if (IS_INCLUDES || index in O) {
	        if (O[index] === el) return IS_INCLUDES || index || 0;
	      }
	    }return !IS_INCLUDES && -1;
	  };
	};
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var core = __w_pdfjs_require__(4);
	var global = __w_pdfjs_require__(1);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __w_pdfjs_require__(21) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toObject = __w_pdfjs_require__(18);
	var toAbsoluteIndex = __w_pdfjs_require__(29);
	var toLength = __w_pdfjs_require__(12);
	module.exports = function fill(value) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) {
	    O[index++] = value;
	  }return O;
	};
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var Iterators = __w_pdfjs_require__(19);
	var ITERATOR = __w_pdfjs_require__(3)('iterator');
	var ArrayProto = Array.prototype;
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(7);
	var dPs = __w_pdfjs_require__(81);
	var enumBugKeys = __w_pdfjs_require__(37);
	var IE_PROTO = __w_pdfjs_require__(36)('IE_PROTO');
	var Empty = function Empty() {};
	var PROTOTYPE = 'prototype';
	var _createDict = function createDict() {
	  var iframe = __w_pdfjs_require__(32)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __w_pdfjs_require__(55).appendChild(iframe);
	  iframe.src = 'javascript:';
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  _createDict = iframeDocument.F;
	  while (i--) {
	    delete _createDict[PROTOTYPE][enumBugKeys[i]];
	  }return _createDict();
	};
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    result[IE_PROTO] = O;
	  } else result = _createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var document = __w_pdfjs_require__(1).document;
	module.exports = document && document.documentElement;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var has = __w_pdfjs_require__(10);
	var toObject = __w_pdfjs_require__(18);
	var IE_PROTO = __w_pdfjs_require__(36)('IE_PROTO');
	var ObjectProto = Object.prototype;
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  }
	  return O instanceof Object ? ObjectProto : null;
	};
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var classof = __w_pdfjs_require__(30);
	var ITERATOR = __w_pdfjs_require__(3)('iterator');
	var Iterators = __w_pdfjs_require__(19);
	module.exports = __w_pdfjs_require__(4).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
	};
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var addToUnscopables = __w_pdfjs_require__(85);
	var step = __w_pdfjs_require__(86);
	var Iterators = __w_pdfjs_require__(19);
	var toIObject = __w_pdfjs_require__(28);
	module.exports = __w_pdfjs_require__(59)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated);
	  this._i = 0;
	  this._k = kind;
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	Iterators.Arguments = Iterators.Array;
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var LIBRARY = __w_pdfjs_require__(21);
	var $export = __w_pdfjs_require__(5);
	var redefine = __w_pdfjs_require__(14);
	var hide = __w_pdfjs_require__(6);
	var Iterators = __w_pdfjs_require__(19);
	var $iterCreate = __w_pdfjs_require__(87);
	var setToStringTag = __w_pdfjs_require__(26);
	var getPrototypeOf = __w_pdfjs_require__(56);
	var ITERATOR = __w_pdfjs_require__(3)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys());
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	var returnThis = function returnThis() {
	  return this;
	};
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function getMethod(kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS:
	        return function keys() {
	          return new Constructor(this, kind);
	        };
	      case VALUES:
	        return function values() {
	          return new Constructor(this, kind);
	        };
	    }
	    return function entries() {
	      return new Constructor(this, kind);
	    };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      setToStringTag(IteratorPrototype, TAG, true);
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() {
	      return $native.call(this);
	    };
	  }
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var dP = __w_pdfjs_require__(13);
	var DESCRIPTORS = __w_pdfjs_require__(8);
	var SPECIES = __w_pdfjs_require__(3)('species');
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function get() {
	      return this;
	    }
	  });
	};
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pIE = __w_pdfjs_require__(62);
	var createDesc = __w_pdfjs_require__(27);
	var toIObject = __w_pdfjs_require__(28);
	var toPrimitive = __w_pdfjs_require__(33);
	var has = __w_pdfjs_require__(10);
	var IE8_DOM_DEFINE = __w_pdfjs_require__(45);
	var gOPD = Object.getOwnPropertyDescriptor;
	exports.f = __w_pdfjs_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) {}
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	exports.f = {}.propertyIsEnumerable;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var classof = __w_pdfjs_require__(30);
	var test = {};
	test[__w_pdfjs_require__(3)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __w_pdfjs_require__(14)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $iterators = __w_pdfjs_require__(58);
	var getKeys = __w_pdfjs_require__(38);
	var redefine = __w_pdfjs_require__(14);
	var global = __w_pdfjs_require__(1);
	var hide = __w_pdfjs_require__(6);
	var Iterators = __w_pdfjs_require__(19);
	var wks = __w_pdfjs_require__(3);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	var DOMIterables = {
	  CSSRuleList: true,
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true,
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true,
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) {
	      if (!proto[key]) redefine(proto, key, $iterators[key], true);
	    }
	  }
	}
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var ctx = __w_pdfjs_require__(11);
	var invoke = __w_pdfjs_require__(99);
	var html = __w_pdfjs_require__(55);
	var cel = __w_pdfjs_require__(32);
	var global = __w_pdfjs_require__(1);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function run() {
	  var id = +this;
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function listener(event) {
	  run.call(event.data);
	};
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) {
	      args.push(arguments[i++]);
	    }queue[++counter] = function () {
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  if (__w_pdfjs_require__(25)(process) == 'process') {
	    defer = function defer(id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  } else if (Dispatch && Dispatch.now) {
	    defer = function defer(id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function defer(id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function defer(id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  } else {
	    defer = function defer(id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (exec) {
	  try {
	    return {
	      e: false,
	      v: exec()
	    };
	  } catch (e) {
	    return {
	      e: true,
	      v: e
	    };
	  }
	};
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(7);
	var isObject = __w_pdfjs_require__(2);
	var newPromiseCapability = __w_pdfjs_require__(42);
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(2);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.build = exports.version = exports._UnsupportedManager = exports.setPDFNetworkStreamClass = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(15);
	
	var _font_loader = __w_pdfjs_require__(119);
	
	var _canvas = __w_pdfjs_require__(120);
	
	var _global_scope = __w_pdfjs_require__(20);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	var _metadata = __w_pdfjs_require__(71);
	
	var _transport_stream = __w_pdfjs_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_RANGE_CHUNK_SIZE = 65536;
	var isWorkerDisabled = false;
	var workerSrc;
	var isPostMessageTransfersDisabled = false;
	var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
	var fakeWorkerFilesLoader = null;
	var useRequireEnsure = false;
	{
	  if (typeof window === 'undefined') {
	    isWorkerDisabled = true;
	    if (false) {
	      require.ensure = require('node-ensure');
	    }
	    useRequireEnsure = true;
	  } else if (true) {
	    useRequireEnsure = true;
	  }
	  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
	    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
	  }
	  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
	  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
	    __webpack_require__.e/* nsure */(1, function () {
	      var worker;
	      worker = __webpack_require__(558);
	      callback(worker.WorkerMessageHandler);
	    });
	  } : dynamicLoaderSupported ? function (callback) {
	    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
	      callback(worker.WorkerMessageHandler);
	    });
	  } : null;
	}
	var PDFNetworkStream;
	function setPDFNetworkStreamClass(cls) {
	  PDFNetworkStream = cls;
	}
	function getDocument(src, pdfDataRangeTransport, passwordCallback, progressCallback) {
	  var task = new PDFDocumentLoadingTask();
	  if (arguments.length > 1) {
	    (0, _util.deprecated)('getDocument is called with pdfDataRangeTransport, ' + 'passwordCallback or progressCallback argument');
	  }
	  if (pdfDataRangeTransport) {
	    if (!(pdfDataRangeTransport instanceof PDFDataRangeTransport)) {
	      pdfDataRangeTransport = Object.create(pdfDataRangeTransport);
	      pdfDataRangeTransport.length = src.length;
	      pdfDataRangeTransport.initialData = src.initialData;
	      if (!pdfDataRangeTransport.abort) {
	        pdfDataRangeTransport.abort = function () {};
	      }
	    }
	    src = Object.create(src);
	    src.range = pdfDataRangeTransport;
	  }
	  task.onPassword = passwordCallback || null;
	  task.onProgress = progressCallback || null;
	  var source;
	  if (typeof src === 'string') {
	    source = { url: src };
	  } else if ((0, _util.isArrayBuffer)(src)) {
	    source = { data: src };
	  } else if (src instanceof PDFDataRangeTransport) {
	    source = { range: src };
	  } else {
	    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
	      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
	    }
	    if (!src.url && !src.data && !src.range) {
	      throw new Error('Invalid parameter object: need either .data, .range or .url');
	    }
	    source = src;
	  }
	  var params = {};
	  var rangeTransport = null;
	  var worker = null;
	  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
	  for (var key in source) {
	    if (key === 'url' && typeof window !== 'undefined') {
	      params[key] = new URL(source[key], window.location).href;
	      continue;
	    } else if (key === 'range') {
	      rangeTransport = source[key];
	      continue;
	    } else if (key === 'worker') {
	      worker = source[key];
	      continue;
	    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
	      var pdfBytes = source[key];
	      if (typeof pdfBytes === 'string') {
	        params[key] = (0, _util.stringToBytes)(pdfBytes);
	      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else {
	        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
	      }
	      continue;
	    } else if (key === 'CMapReaderFactory') {
	      CMapReaderFactory = source[key];
	      continue;
	    }
	    params[key] = source[key];
	  }
	  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
	  params.ignoreErrors = params.stopAtErrors !== true;
	  if (params.disableNativeImageDecoder !== undefined) {
	    (0, _util.deprecated)('parameter disableNativeImageDecoder, ' + 'use nativeImageDecoderSupport instead');
	  }
	  params.nativeImageDecoderSupport = params.nativeImageDecoderSupport || (params.disableNativeImageDecoder === true ? _util.NativeImageDecoding.NONE : _util.NativeImageDecoding.DECODE);
	  if (params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DECODE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DISPLAY) {
	    (0, _util.warn)('Invalid parameter nativeImageDecoderSupport: ' + 'need a state of enum {NativeImageDecoding}');
	    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
	  }
	  if (!worker) {
	    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
	    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
	    task._worker = worker;
	  }
	  var docId = task.docId;
	  worker.promise.then(function () {
	    if (task.destroyed) {
	      throw new Error('Loading aborted');
	    }
	    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
	      if (task.destroyed) {
	        throw new Error('Loading aborted');
	      }
	      var networkStream = void 0;
	      if (rangeTransport) {
	        networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
	      } else if (!params.data) {
	        networkStream = new PDFNetworkStream({
	          source: params,
	          disableRange: (0, _dom_utils.getDefaultSetting)('disableRange')
	        });
	      }
	      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
	      messageHandler.postMessageTransfers = worker.postMessageTransfers;
	      var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
	      task._transport = transport;
	      messageHandler.send('Ready', null);
	    });
	  }).catch(task._capability.reject);
	  return task;
	}
	function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
	  if (worker.destroyed) {
	    return Promise.reject(new Error('Worker was destroyed'));
	  }
	  var apiVersion = '1.10.100';
	  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
	  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
	  source.chunkedViewerLoading = !!pdfDataRangeTransport;
	  if (pdfDataRangeTransport) {
	    source.length = pdfDataRangeTransport.length;
	    source.initialData = pdfDataRangeTransport.initialData;
	  }
	  return worker.messageHandler.sendWithPromise('GetDocRequest', {
	    docId: docId,
	    apiVersion: apiVersion,
	    source: {
	      data: source.data,
	      url: source.url,
	      password: source.password,
	      disableAutoFetch: source.disableAutoFetch,
	      rangeChunkSize: source.rangeChunkSize,
	      length: source.length
	    },
	    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
	    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
	    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
	    docBaseUrl: source.docBaseUrl,
	    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
	    ignoreErrors: source.ignoreErrors,
	    isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported')
	  }).then(function (workerId) {
	    if (worker.destroyed) {
	      throw new Error('Worker was destroyed');
	    }
	    return workerId;
	  });
	}
	var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
	  var nextDocumentId = 0;
	  function PDFDocumentLoadingTask() {
	    this._capability = (0, _util.createPromiseCapability)();
	    this._transport = null;
	    this._worker = null;
	    this.docId = 'd' + nextDocumentId++;
	    this.destroyed = false;
	    this.onPassword = null;
	    this.onProgress = null;
	    this.onUnsupportedFeature = null;
	  }
	  PDFDocumentLoadingTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    destroy: function destroy() {
	      var _this = this;
	
	      this.destroyed = true;
	      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
	      return transportDestroyed.then(function () {
	        _this._transport = null;
	        if (_this._worker) {
	          _this._worker.destroy();
	          _this._worker = null;
	        }
	      });
	    },
	
	    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return PDFDocumentLoadingTask;
	}();
	var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
	  function PDFDataRangeTransport(length, initialData) {
	    this.length = length;
	    this.initialData = initialData;
	    this._rangeListeners = [];
	    this._progressListeners = [];
	    this._progressiveReadListeners = [];
	    this._readyCapability = (0, _util.createPromiseCapability)();
	  }
	  PDFDataRangeTransport.prototype = {
	    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
	      this._rangeListeners.push(listener);
	    },
	    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
	      this._progressListeners.push(listener);
	    },
	    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
	      this._progressiveReadListeners.push(listener);
	    },
	    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
	      var listeners = this._rangeListeners;
	      for (var i = 0, n = listeners.length; i < n; ++i) {
	        listeners[i](begin, chunk);
	      }
	    },
	    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
	      var _this2 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this2._progressListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](loaded);
	        }
	      });
	    },
	    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
	      var _this3 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this3._progressiveReadListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](chunk);
	        }
	      });
	    },
	    transportReady: function PDFDataRangeTransport_transportReady() {
	      this._readyCapability.resolve();
	    },
	    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
	      throw new Error('Abstract method PDFDataRangeTransport.requestDataRange');
	    },
	    abort: function PDFDataRangeTransport_abort() {}
	  };
	  return PDFDataRangeTransport;
	}();
	var PDFDocumentProxy = function PDFDocumentProxyClosure() {
	  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
	    this.pdfInfo = pdfInfo;
	    this.transport = transport;
	    this.loadingTask = loadingTask;
	  }
	  PDFDocumentProxy.prototype = {
	    get numPages() {
	      return this.pdfInfo.numPages;
	    },
	    get fingerprint() {
	      return this.pdfInfo.fingerprint;
	    },
	    getPage: function PDFDocumentProxy_getPage(pageNumber) {
	      return this.transport.getPage(pageNumber);
	    },
	    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
	      return this.transport.getPageIndex(ref);
	    },
	    getDestinations: function PDFDocumentProxy_getDestinations() {
	      return this.transport.getDestinations();
	    },
	    getDestination: function PDFDocumentProxy_getDestination(id) {
	      return this.transport.getDestination(id);
	    },
	    getPageLabels: function PDFDocumentProxy_getPageLabels() {
	      return this.transport.getPageLabels();
	    },
	    getPageMode: function getPageMode() {
	      return this.transport.getPageMode();
	    },
	
	    getAttachments: function PDFDocumentProxy_getAttachments() {
	      return this.transport.getAttachments();
	    },
	    getJavaScript: function PDFDocumentProxy_getJavaScript() {
	      return this.transport.getJavaScript();
	    },
	    getOutline: function PDFDocumentProxy_getOutline() {
	      return this.transport.getOutline();
	    },
	    getMetadata: function PDFDocumentProxy_getMetadata() {
	      return this.transport.getMetadata();
	    },
	    getData: function PDFDocumentProxy_getData() {
	      return this.transport.getData();
	    },
	    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
	      return this.transport.downloadInfoCapability.promise;
	    },
	    getStats: function PDFDocumentProxy_getStats() {
	      return this.transport.getStats();
	    },
	    cleanup: function PDFDocumentProxy_cleanup() {
	      this.transport.startCleanup();
	    },
	    destroy: function PDFDocumentProxy_destroy() {
	      return this.loadingTask.destroy();
	    }
	  };
	  return PDFDocumentProxy;
	}();
	var PDFPageProxy = function PDFPageProxyClosure() {
	  function PDFPageProxy(pageIndex, pageInfo, transport) {
	    this.pageIndex = pageIndex;
	    this.pageInfo = pageInfo;
	    this.transport = transport;
	    this.stats = new _util.StatTimer();
	    this.stats.enabled = (0, _dom_utils.getDefaultSetting)('enableStats');
	    this.commonObjs = transport.commonObjs;
	    this.objs = new PDFObjects();
	    this.cleanupAfterRender = false;
	    this.pendingCleanup = false;
	    this.intentStates = Object.create(null);
	    this.destroyed = false;
	  }
	  PDFPageProxy.prototype = {
	    get pageNumber() {
	      return this.pageIndex + 1;
	    },
	    get rotate() {
	      return this.pageInfo.rotate;
	    },
	    get ref() {
	      return this.pageInfo.ref;
	    },
	    get userUnit() {
	      return this.pageInfo.userUnit;
	    },
	    get view() {
	      return this.pageInfo.view;
	    },
	    getViewport: function PDFPageProxy_getViewport(scale, rotate) {
	      if (arguments.length < 2) {
	        rotate = this.rotate;
	      }
	      return new _util.PageViewport(this.view, scale, rotate, 0, 0);
	    },
	    getAnnotations: function PDFPageProxy_getAnnotations(params) {
	      var intent = params && params.intent || null;
	      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
	        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
	        this.annotationsIntent = intent;
	      }
	      return this.annotationsPromise;
	    },
	    render: function PDFPageProxy_render(params) {
	      var _this4 = this;
	
	      var stats = this.stats;
	      stats.time('Overall');
	      this.pendingCleanup = false;
	      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
	      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      if (!intentState.displayReadyCapability) {
	        intentState.receivingOperatorList = true;
	        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.stats.time('Page Request');
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageNumber - 1,
	          intent: renderingIntent,
	          renderInteractiveForms: params.renderInteractiveForms === true
	        });
	      }
	      var complete = function complete(error) {
	        var i = intentState.renderTasks.indexOf(internalRenderTask);
	        if (i >= 0) {
	          intentState.renderTasks.splice(i, 1);
	        }
	        if (_this4.cleanupAfterRender) {
	          _this4.pendingCleanup = true;
	        }
	        _this4._tryCleanup();
	        if (error) {
	          internalRenderTask.capability.reject(error);
	        } else {
	          internalRenderTask.capability.resolve();
	        }
	        stats.timeEnd('Rendering');
	        stats.timeEnd('Overall');
	      };
	      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory);
	      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
	      if (!intentState.renderTasks) {
	        intentState.renderTasks = [];
	      }
	      intentState.renderTasks.push(internalRenderTask);
	      var renderTask = internalRenderTask.task;
	      if (params.continueCallback) {
	        (0, _util.deprecated)('render is used with continueCallback parameter');
	        renderTask.onContinue = params.continueCallback;
	      }
	      intentState.displayReadyCapability.promise.then(function (transparency) {
	        if (_this4.pendingCleanup) {
	          complete();
	          return;
	        }
	        stats.time('Rendering');
	        internalRenderTask.initializeGraphics(transparency);
	        internalRenderTask.operatorListChanged();
	      }).catch(complete);
	      return renderTask;
	    },
	    getOperatorList: function PDFPageProxy_getOperatorList() {
	      function operatorListChanged() {
	        if (intentState.operatorList.lastChunk) {
	          intentState.opListReadCapability.resolve(intentState.operatorList);
	          var i = intentState.renderTasks.indexOf(opListTask);
	          if (i >= 0) {
	            intentState.renderTasks.splice(i, 1);
	          }
	        }
	      }
	      var renderingIntent = 'oplist';
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      var opListTask;
	      if (!intentState.opListReadCapability) {
	        opListTask = {};
	        opListTask.operatorListChanged = operatorListChanged;
	        intentState.receivingOperatorList = true;
	        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
	        intentState.renderTasks = [];
	        intentState.renderTasks.push(opListTask);
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageIndex,
	          intent: renderingIntent
	        });
	      }
	      return intentState.opListReadCapability.promise;
	    },
	    streamTextContent: function streamTextContent() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var TEXT_CONTENT_CHUNK_SIZE = 100;
	      return this.transport.messageHandler.sendWithStream('GetTextContent', {
	        pageIndex: this.pageNumber - 1,
	        normalizeWhitespace: params.normalizeWhitespace === true,
	        combineTextItems: params.disableCombineTextItems !== true
	      }, {
	        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
	        size: function size(textContent) {
	          return textContent.items.length;
	        }
	      });
	    },
	
	    getTextContent: function PDFPageProxy_getTextContent(params) {
	      params = params || {};
	      var readableStream = this.streamTextContent(params);
	      return new Promise(function (resolve, reject) {
	        function pump() {
	          reader.read().then(function (_ref) {
	            var value = _ref.value,
	                done = _ref.done;
	
	            if (done) {
	              resolve(textContent);
	              return;
	            }
	            _util.Util.extendObj(textContent.styles, value.styles);
	            _util.Util.appendToArray(textContent.items, value.items);
	            pump();
	          }, reject);
	        }
	        var reader = readableStream.getReader();
	        var textContent = {
	          items: [],
	          styles: Object.create(null)
	        };
	        pump();
	      });
	    },
	    _destroy: function PDFPageProxy_destroy() {
	      this.destroyed = true;
	      this.transport.pageCache[this.pageIndex] = null;
	      var waitOn = [];
	      Object.keys(this.intentStates).forEach(function (intent) {
	        if (intent === 'oplist') {
	          return;
	        }
	        var intentState = this.intentStates[intent];
	        intentState.renderTasks.forEach(function (renderTask) {
	          var renderCompleted = renderTask.capability.promise.catch(function () {});
	          waitOn.push(renderCompleted);
	          renderTask.cancel();
	        });
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	      return Promise.all(waitOn);
	    },
	    destroy: function destroy() {
	      (0, _util.deprecated)('page destroy method, use cleanup() instead');
	      this.cleanup();
	    },
	
	    cleanup: function PDFPageProxy_cleanup() {
	      this.pendingCleanup = true;
	      this._tryCleanup();
	    },
	    _tryCleanup: function PDFPageProxy_tryCleanup() {
	      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
	        var intentState = this.intentStates[intent];
	        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
	      }, this)) {
	        return;
	      }
	      Object.keys(this.intentStates).forEach(function (intent) {
	        delete this.intentStates[intent];
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	    },
	    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
	      var intentState = this.intentStates[intent];
	      if (intentState.displayReadyCapability) {
	        intentState.displayReadyCapability.resolve(transparency);
	      }
	    },
	    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
	      var intentState = this.intentStates[intent];
	      var i, ii;
	      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
	        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
	        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
	      }
	      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
	      for (i = 0; i < intentState.renderTasks.length; i++) {
	        intentState.renderTasks[i].operatorListChanged();
	      }
	      if (operatorListChunk.lastChunk) {
	        intentState.receivingOperatorList = false;
	        this._tryCleanup();
	      }
	    }
	  };
	  return PDFPageProxy;
	}();
	
	var LoopbackPort = function () {
	  function LoopbackPort(defer) {
	    _classCallCheck(this, LoopbackPort);
	
	    this._listeners = [];
	    this._defer = defer;
	    this._deferred = Promise.resolve(undefined);
	  }
	
	  _createClass(LoopbackPort, [{
	    key: 'postMessage',
	    value: function postMessage(obj, transfers) {
	      var _this5 = this;
	
	      function cloneValue(value) {
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
	          return value;
	        }
	        if (cloned.has(value)) {
	          return cloned.get(value);
	        }
	        var result;
	        var buffer;
	        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
	          var transferable = transfers && transfers.indexOf(buffer) >= 0;
	          if (value === buffer) {
	            result = value;
	          } else if (transferable) {
	            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
	          } else {
	            result = new value.constructor(value);
	          }
	          cloned.set(value, result);
	          return result;
	        }
	        result = Array.isArray(value) ? [] : {};
	        cloned.set(value, result);
	        for (var i in value) {
	          var desc,
	              p = value;
	          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
	            p = Object.getPrototypeOf(p);
	          }
	          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
	            continue;
	          }
	          result[i] = cloneValue(desc.value);
	        }
	        return result;
	      }
	      if (!this._defer) {
	        this._listeners.forEach(function (listener) {
	          listener.call(this, { data: obj });
	        }, this);
	        return;
	      }
	      var cloned = new WeakMap();
	      var e = { data: cloneValue(obj) };
	      this._deferred.then(function () {
	        _this5._listeners.forEach(function (listener) {
	          listener.call(this, e);
	        }, _this5);
	      });
	    }
	  }, {
	    key: 'addEventListener',
	    value: function addEventListener(name, listener) {
	      this._listeners.push(listener);
	    }
	  }, {
	    key: 'removeEventListener',
	    value: function removeEventListener(name, listener) {
	      var i = this._listeners.indexOf(listener);
	      this._listeners.splice(i, 1);
	    }
	  }, {
	    key: 'terminate',
	    value: function terminate() {
	      this._listeners = [];
	    }
	  }]);
	
	  return LoopbackPort;
	}();
	
	var PDFWorker = function PDFWorkerClosure() {
	  var nextFakeWorkerId = 0;
	  function getWorkerSrc() {
	    if (typeof workerSrc !== 'undefined') {
	      return workerSrc;
	    }
	    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
	      return (0, _dom_utils.getDefaultSetting)('workerSrc');
	    }
	    if (pdfjsFilePath) {
	      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
	    }
	    throw new Error('No PDFJS.workerSrc specified');
	  }
	  var fakeWorkerFilesLoadedCapability = void 0;
	  function setupFakeWorkerGlobal() {
	    var WorkerMessageHandler;
	    if (fakeWorkerFilesLoadedCapability) {
	      return fakeWorkerFilesLoadedCapability.promise;
	    }
	    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
	    var loader = fakeWorkerFilesLoader || function (callback) {
	      _util.Util.loadScript(getWorkerSrc(), function () {
	        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
	      });
	    };
	    loader(fakeWorkerFilesLoadedCapability.resolve);
	    return fakeWorkerFilesLoadedCapability.promise;
	  }
	  function createCDNWrapper(url) {
	    var wrapper = 'importScripts(\'' + url + '\');';
	    return URL.createObjectURL(new Blob([wrapper]));
	  }
	  var pdfWorkerPorts = new WeakMap();
	  function PDFWorker(name, port) {
	    if (port && pdfWorkerPorts.has(port)) {
	      throw new Error('Cannot use more than one PDFWorker per port');
	    }
	    this.name = name;
	    this.destroyed = false;
	    this.postMessageTransfers = true;
	    this._readyCapability = (0, _util.createPromiseCapability)();
	    this._port = null;
	    this._webWorker = null;
	    this._messageHandler = null;
	    if (port) {
	      pdfWorkerPorts.set(port, this);
	      this._initializeFromPort(port);
	      return;
	    }
	    this._initialize();
	  }
	  PDFWorker.prototype = {
	    get promise() {
	      return this._readyCapability.promise;
	    },
	    get port() {
	      return this._port;
	    },
	    get messageHandler() {
	      return this._messageHandler;
	    },
	    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
	      this._port = port;
	      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
	      this._messageHandler.on('ready', function () {});
	      this._readyCapability.resolve();
	    },
	    _initialize: function PDFWorker_initialize() {
	      var _this6 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
	        var workerSrc = getWorkerSrc();
	        try {
	          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
	            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
	          }
	          var worker = new Worker(workerSrc);
	          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
	          var terminateEarly = function terminateEarly() {
	            worker.removeEventListener('error', onWorkerError);
	            messageHandler.destroy();
	            worker.terminate();
	            if (_this6.destroyed) {
	              _this6._readyCapability.reject(new Error('Worker was destroyed'));
	            } else {
	              _this6._setupFakeWorker();
	            }
	          };
	          var onWorkerError = function onWorkerError() {
	            if (!_this6._webWorker) {
	              terminateEarly();
	            }
	          };
	          worker.addEventListener('error', onWorkerError);
	          messageHandler.on('test', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            var supportTypedArray = data && data.supportTypedArray;
	            if (supportTypedArray) {
	              _this6._messageHandler = messageHandler;
	              _this6._port = worker;
	              _this6._webWorker = worker;
	              if (!data.supportTransfers) {
	                _this6.postMessageTransfers = false;
	                isPostMessageTransfersDisabled = true;
	              }
	              _this6._readyCapability.resolve();
	              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
	            } else {
	              _this6._setupFakeWorker();
	              messageHandler.destroy();
	              worker.terminate();
	            }
	          });
	          messageHandler.on('console_log', function (data) {
	            console.log.apply(console, data);
	          });
	          messageHandler.on('console_error', function (data) {
	            console.error.apply(console, data);
	          });
	          messageHandler.on('ready', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            try {
	              sendTest();
	            } catch (e) {
	              _this6._setupFakeWorker();
	            }
	          });
	          var sendTest = function sendTest() {
	            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
	            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
	            try {
	              messageHandler.send('test', testObj, [testObj.buffer]);
	            } catch (ex) {
	              (0, _util.info)('Cannot use postMessage transfers');
	              testObj[0] = 0;
	              messageHandler.send('test', testObj);
	            }
	          };
	          sendTest();
	          return;
	        } catch (e) {
	          (0, _util.info)('The worker has been disabled.');
	        }
	      }
	      this._setupFakeWorker();
	    },
	    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
	      var _this7 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
	        (0, _util.warn)('Setting up fake worker.');
	        isWorkerDisabled = true;
	      }
	      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
	        if (_this7.destroyed) {
	          _this7._readyCapability.reject(new Error('Worker was destroyed'));
	          return;
	        }
	        var isTypedArraysPresent = Uint8Array !== Float32Array;
	        var port = new LoopbackPort(isTypedArraysPresent);
	        _this7._port = port;
	        var id = 'fake' + nextFakeWorkerId++;
	        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
	        WorkerMessageHandler.setup(workerHandler, port);
	        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
	        _this7._messageHandler = messageHandler;
	        _this7._readyCapability.resolve();
	      });
	    },
	    destroy: function PDFWorker_destroy() {
	      this.destroyed = true;
	      if (this._webWorker) {
	        this._webWorker.terminate();
	        this._webWorker = null;
	      }
	      pdfWorkerPorts.delete(this._port);
	      this._port = null;
	      if (this._messageHandler) {
	        this._messageHandler.destroy();
	        this._messageHandler = null;
	      }
	    }
	  };
	  PDFWorker.fromPort = function (port) {
	    if (pdfWorkerPorts.has(port)) {
	      return pdfWorkerPorts.get(port);
	    }
	    return new PDFWorker(null, port);
	  };
	  return PDFWorker;
	}();
	var WorkerTransport = function WorkerTransportClosure() {
	  function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
	    this.messageHandler = messageHandler;
	    this.loadingTask = loadingTask;
	    this.commonObjs = new PDFObjects();
	    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
	    this.CMapReaderFactory = new CMapReaderFactory({
	      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
	      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
	    });
	    this.destroyed = false;
	    this.destroyCapability = null;
	    this._passwordCapability = null;
	    this._networkStream = networkStream;
	    this._fullReader = null;
	    this._lastProgress = null;
	    this.pageCache = [];
	    this.pagePromises = [];
	    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
	    this.setupMessageHandler();
	  }
	  WorkerTransport.prototype = {
	    destroy: function WorkerTransport_destroy() {
	      var _this8 = this;
	
	      if (this.destroyCapability) {
	        return this.destroyCapability.promise;
	      }
	      this.destroyed = true;
	      this.destroyCapability = (0, _util.createPromiseCapability)();
	      if (this._passwordCapability) {
	        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
	      }
	      var waitOn = [];
	      this.pageCache.forEach(function (page) {
	        if (page) {
	          waitOn.push(page._destroy());
	        }
	      });
	      this.pageCache = [];
	      this.pagePromises = [];
	      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
	      waitOn.push(terminated);
	      Promise.all(waitOn).then(function () {
	        _this8.fontLoader.clear();
	        if (_this8._networkStream) {
	          _this8._networkStream.cancelAllRequests();
	        }
	        if (_this8.messageHandler) {
	          _this8.messageHandler.destroy();
	          _this8.messageHandler = null;
	        }
	        _this8.destroyCapability.resolve();
	      }, this.destroyCapability.reject);
	      return this.destroyCapability.promise;
	    },
	    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
	      var messageHandler = this.messageHandler;
	      var loadingTask = this.loadingTask;
	      messageHandler.on('GetReader', function (data, sink) {
	        var _this9 = this;
	
	        (0, _util.assert)(this._networkStream);
	        this._fullReader = this._networkStream.getFullReader();
	        this._fullReader.onProgress = function (evt) {
	          _this9._lastProgress = {
	            loaded: evt.loaded,
	            total: evt.total
	          };
	        };
	        sink.onPull = function () {
	          _this9._fullReader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _this9._fullReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('ReaderHeadersReady', function (data) {
	        var _this10 = this;
	
	        var headersCapability = (0, _util.createPromiseCapability)();
	        var fullReader = this._fullReader;
	        fullReader.headersReady.then(function () {
	          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
	            if (_this10._lastProgress) {
	              var _loadingTask = _this10.loadingTask;
	              if (_loadingTask.onProgress) {
	                _loadingTask.onProgress(_this10._lastProgress);
	              }
	            }
	            fullReader.onProgress = function (evt) {
	              var loadingTask = _this10.loadingTask;
	              if (loadingTask.onProgress) {
	                loadingTask.onProgress({
	                  loaded: evt.loaded,
	                  total: evt.total
	                });
	              }
	            };
	          }
	          headersCapability.resolve({
	            isStreamingSupported: fullReader.isStreamingSupported,
	            isRangeSupported: fullReader.isRangeSupported,
	            contentLength: fullReader.contentLength
	          });
	        }, headersCapability.reject);
	        return headersCapability.promise;
	      }, this);
	      messageHandler.on('GetRangeReader', function (data, sink) {
	        (0, _util.assert)(this._networkStream);
	        var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
	        sink.onPull = function () {
	          _rangeReader.read().then(function (_ref3) {
	            var value = _ref3.value,
	                done = _ref3.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _rangeReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('GetDoc', function transportDoc(data) {
	        var pdfInfo = data.pdfInfo;
	        this.numPages = data.pdfInfo.numPages;
	        var loadingTask = this.loadingTask;
	        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
	        this.pdfDocument = pdfDocument;
	        loadingTask._capability.resolve(pdfDocument);
	      }, this);
	      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
	        var _this11 = this;
	
	        this._passwordCapability = (0, _util.createPromiseCapability)();
	        if (loadingTask.onPassword) {
	          var updatePassword = function updatePassword(password) {
	            _this11._passwordCapability.resolve({ password: password });
	          };
	          loadingTask.onPassword(updatePassword, exception.code);
	        } else {
	          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
	        }
	        return this._passwordCapability.promise;
	      }, this);
	      messageHandler.on('PasswordException', function transportPasswordException(exception) {
	        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
	      }, this);
	      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
	        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
	      }, this);
	      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
	        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
	      }, this);
	      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
	        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
	      }, this);
	      messageHandler.on('UnknownError', function transportUnknownError(exception) {
	        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
	      }, this);
	      messageHandler.on('DataLoaded', function transportPage(data) {
	        this.downloadInfoCapability.resolve(data);
	      }, this);
	      messageHandler.on('PDFManagerReady', function transportPage(data) {}, this);
	      messageHandler.on('StartRenderPage', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page.stats.timeEnd('Page Request');
	        page._startRenderPage(data.transparency, data.intent);
	      }, this);
	      messageHandler.on('RenderPageChunk', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page._renderPageChunk(data.operatorList, data.intent);
	      }, this);
	      messageHandler.on('commonobj', function transportObj(data) {
	        var _this12 = this;
	
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var type = data[1];
	        if (this.commonObjs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'Font':
	            var exportedData = data[2];
	            if ('error' in exportedData) {
	              var exportedError = exportedData.error;
	              (0, _util.warn)('Error during font loading: ' + exportedError);
	              this.commonObjs.resolve(id, exportedError);
	              break;
	            }
	            var fontRegistry = null;
	            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.FontInspector && _global_scope2.default['FontInspector'].enabled) {
	              fontRegistry = {
	                registerFont: function registerFont(font, url) {
	                  _global_scope2.default['FontInspector'].fontAdded(font, url);
	                }
	              };
	            }
	            var font = new _font_loader.FontFaceObject(exportedData, {
	              isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
	              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	              fontRegistry: fontRegistry
	            });
	            var fontReady = function fontReady(fontObjs) {
	              _this12.commonObjs.resolve(id, font);
	            };
	            this.fontLoader.bind([font], fontReady);
	            break;
	          case 'FontPath':
	            this.commonObjs.resolve(id, data[2]);
	            break;
	          default:
	            throw new Error('Got unknown common object type ' + type);
	        }
	      }, this);
	      messageHandler.on('obj', function transportObj(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var pageIndex = data[1];
	        var type = data[2];
	        var pageProxy = this.pageCache[pageIndex];
	        var imageData;
	        if (pageProxy.objs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'JpegStream':
	            imageData = data[3];
	            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
	            break;
	          case 'Image':
	            imageData = data[3];
	            pageProxy.objs.resolve(id, imageData);
	            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
	            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
	              pageProxy.cleanupAfterRender = true;
	            }
	            break;
	          default:
	            throw new Error('Got unknown object type ' + type);
	        }
	      }, this);
	      messageHandler.on('DocProgress', function transportDocProgress(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onProgress) {
	          loadingTask.onProgress({
	            loaded: data.loaded,
	            total: data.total
	          });
	        }
	      }, this);
	      messageHandler.on('PageError', function transportError(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageNum - 1];
	        var intentState = page.intentStates[data.intent];
	        if (intentState.displayReadyCapability) {
	          intentState.displayReadyCapability.reject(data.error);
	        } else {
	          throw new Error(data.error);
	        }
	        if (intentState.operatorList) {
	          intentState.operatorList.lastChunk = true;
	          for (var i = 0; i < intentState.renderTasks.length; i++) {
	            intentState.renderTasks[i].operatorListChanged();
	          }
	        }
	      }, this);
	      messageHandler.on('UnsupportedFeature', function transportUnsupportedFeature(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var featureId = data.featureId;
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onUnsupportedFeature) {
	          loadingTask.onUnsupportedFeature(featureId);
	        }
	        _UnsupportedManager.notify(featureId);
	      }, this);
	      messageHandler.on('JpegDecode', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        if (typeof document === 'undefined') {
	          return Promise.reject(new Error('"document" is not defined.'));
	        }
	        var imageUrl = data[0];
	        var components = data[1];
	        if (components !== 3 && components !== 1) {
	          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
	        }
	        return new Promise(function (resolve, reject) {
	          var img = new Image();
	          img.onload = function () {
	            var width = img.width;
	            var height = img.height;
	            var size = width * height;
	            var rgbaLength = size * 4;
	            var buf = new Uint8Array(size * components);
	            var tmpCanvas = document.createElement('canvas');
	            tmpCanvas.width = width;
	            tmpCanvas.height = height;
	            var tmpCtx = tmpCanvas.getContext('2d');
	            tmpCtx.drawImage(img, 0, 0);
	            var data = tmpCtx.getImageData(0, 0, width, height).data;
	            var i, j;
	            if (components === 3) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
	                buf[j] = data[i];
	                buf[j + 1] = data[i + 1];
	                buf[j + 2] = data[i + 2];
	              }
	            } else if (components === 1) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
	                buf[j] = data[i];
	              }
	            }
	            resolve({
	              data: buf,
	              width: width,
	              height: height
	            });
	          };
	          img.onerror = function () {
	            reject(new Error('JpegDecode failed to load image'));
	          };
	          img.src = imageUrl;
	        });
	      }, this);
	      messageHandler.on('FetchBuiltInCMap', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        return this.CMapReaderFactory.fetch({ name: data.name });
	      }, this);
	    },
	    getData: function WorkerTransport_getData() {
	      return this.messageHandler.sendWithPromise('GetData', null);
	    },
	    getPage: function WorkerTransport_getPage(pageNumber, capability) {
	      var _this13 = this;
	
	      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
	        return Promise.reject(new Error('Invalid page request'));
	      }
	      var pageIndex = pageNumber - 1;
	      if (pageIndex in this.pagePromises) {
	        return this.pagePromises[pageIndex];
	      }
	      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
	        if (_this13.destroyed) {
	          throw new Error('Transport destroyed');
	        }
	        var page = new PDFPageProxy(pageIndex, pageInfo, _this13);
	        _this13.pageCache[pageIndex] = page;
	        return page;
	      });
	      this.pagePromises[pageIndex] = promise;
	      return promise;
	    },
	    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
	      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
	        return Promise.reject(new Error(reason));
	      });
	    },
	    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
	      return this.messageHandler.sendWithPromise('GetAnnotations', {
	        pageIndex: pageIndex,
	        intent: intent
	      });
	    },
	    getDestinations: function WorkerTransport_getDestinations() {
	      return this.messageHandler.sendWithPromise('GetDestinations', null);
	    },
	    getDestination: function WorkerTransport_getDestination(id) {
	      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
	    },
	    getPageLabels: function WorkerTransport_getPageLabels() {
	      return this.messageHandler.sendWithPromise('GetPageLabels', null);
	    },
	    getPageMode: function getPageMode() {
	      return this.messageHandler.sendWithPromise('GetPageMode', null);
	    },
	
	    getAttachments: function WorkerTransport_getAttachments() {
	      return this.messageHandler.sendWithPromise('GetAttachments', null);
	    },
	    getJavaScript: function WorkerTransport_getJavaScript() {
	      return this.messageHandler.sendWithPromise('GetJavaScript', null);
	    },
	    getOutline: function WorkerTransport_getOutline() {
	      return this.messageHandler.sendWithPromise('GetOutline', null);
	    },
	    getMetadata: function WorkerTransport_getMetadata() {
	      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function transportMetadata(results) {
	        return {
	          info: results[0],
	          metadata: results[1] ? new _metadata.Metadata(results[1]) : null
	        };
	      });
	    },
	    getStats: function WorkerTransport_getStats() {
	      return this.messageHandler.sendWithPromise('GetStats', null);
	    },
	    startCleanup: function WorkerTransport_startCleanup() {
	      var _this14 = this;
	
	      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
	        for (var i = 0, ii = _this14.pageCache.length; i < ii; i++) {
	          var page = _this14.pageCache[i];
	          if (page) {
	            page.cleanup();
	          }
	        }
	        _this14.commonObjs.clear();
	        _this14.fontLoader.clear();
	      });
	    }
	  };
	  return WorkerTransport;
	}();
	var PDFObjects = function PDFObjectsClosure() {
	  function PDFObjects() {
	    this.objs = Object.create(null);
	  }
	  PDFObjects.prototype = {
	    ensureObj: function PDFObjects_ensureObj(objId) {
	      if (this.objs[objId]) {
	        return this.objs[objId];
	      }
	      var obj = {
	        capability: (0, _util.createPromiseCapability)(),
	        data: null,
	        resolved: false
	      };
	      this.objs[objId] = obj;
	      return obj;
	    },
	    get: function PDFObjects_get(objId, callback) {
	      if (callback) {
	        this.ensureObj(objId).capability.promise.then(callback);
	        return null;
	      }
	      var obj = this.objs[objId];
	      if (!obj || !obj.resolved) {
	        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
	      }
	      return obj.data;
	    },
	    resolve: function PDFObjects_resolve(objId, data) {
	      var obj = this.ensureObj(objId);
	      obj.resolved = true;
	      obj.data = data;
	      obj.capability.resolve(data);
	    },
	    isResolved: function PDFObjects_isResolved(objId) {
	      var objs = this.objs;
	      if (!objs[objId]) {
	        return false;
	      }
	      return objs[objId].resolved;
	    },
	    hasData: function PDFObjects_hasData(objId) {
	      return this.isResolved(objId);
	    },
	    getData: function PDFObjects_getData(objId) {
	      var objs = this.objs;
	      if (!objs[objId] || !objs[objId].resolved) {
	        return null;
	      }
	      return objs[objId].data;
	    },
	    clear: function PDFObjects_clear() {
	      this.objs = Object.create(null);
	    }
	  };
	  return PDFObjects;
	}();
	var RenderTask = function RenderTaskClosure() {
	  function RenderTask(internalRenderTask) {
	    this._internalRenderTask = internalRenderTask;
	    this.onContinue = null;
	  }
	  RenderTask.prototype = {
	    get promise() {
	      return this._internalRenderTask.capability.promise;
	    },
	    cancel: function RenderTask_cancel() {
	      this._internalRenderTask.cancel();
	    },
	    then: function RenderTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return RenderTask;
	}();
	var InternalRenderTask = function InternalRenderTaskClosure() {
	  var canvasInRendering = new WeakMap();
	  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory) {
	    this.callback = callback;
	    this.params = params;
	    this.objs = objs;
	    this.commonObjs = commonObjs;
	    this.operatorListIdx = null;
	    this.operatorList = operatorList;
	    this.pageNumber = pageNumber;
	    this.canvasFactory = canvasFactory;
	    this.running = false;
	    this.graphicsReadyCallback = null;
	    this.graphicsReady = false;
	    this.useRequestAnimationFrame = false;
	    this.cancelled = false;
	    this.capability = (0, _util.createPromiseCapability)();
	    this.task = new RenderTask(this);
	    this._continueBound = this._continue.bind(this);
	    this._scheduleNextBound = this._scheduleNext.bind(this);
	    this._nextBound = this._next.bind(this);
	    this._canvas = params.canvasContext.canvas;
	  }
	  InternalRenderTask.prototype = {
	    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
	      if (this._canvas) {
	        if (canvasInRendering.has(this._canvas)) {
	          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
	        }
	        canvasInRendering.set(this._canvas, this);
	      }
	      if (this.cancelled) {
	        return;
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.StepperManager && _global_scope2.default.StepperManager.enabled) {
	        this.stepper = _global_scope2.default.StepperManager.create(this.pageNumber - 1);
	        this.stepper.init(this.operatorList);
	        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
	      }
	      var params = this.params;
	      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, params.imageLayer);
	      this.gfx.beginDrawing({
	        transform: params.transform,
	        viewport: params.viewport,
	        transparency: transparency,
	        background: params.background
	      });
	      this.operatorListIdx = 0;
	      this.graphicsReady = true;
	      if (this.graphicsReadyCallback) {
	        this.graphicsReadyCallback();
	      }
	    },
	    cancel: function InternalRenderTask_cancel() {
	      this.running = false;
	      this.cancelled = true;
	      if (this._canvas) {
	        canvasInRendering.delete(this._canvas);
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfjsNext')) {
	        this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
	      } else {
	        this.callback('cancelled');
	      }
	    },
	    operatorListChanged: function InternalRenderTask_operatorListChanged() {
	      if (!this.graphicsReady) {
	        if (!this.graphicsReadyCallback) {
	          this.graphicsReadyCallback = this._continueBound;
	        }
	        return;
	      }
	      if (this.stepper) {
	        this.stepper.updateOperatorList(this.operatorList);
	      }
	      if (this.running) {
	        return;
	      }
	      this._continue();
	    },
	    _continue: function InternalRenderTask__continue() {
	      this.running = true;
	      if (this.cancelled) {
	        return;
	      }
	      if (this.task.onContinue) {
	        this.task.onContinue(this._scheduleNextBound);
	      } else {
	        this._scheduleNext();
	      }
	    },
	    _scheduleNext: function InternalRenderTask__scheduleNext() {
	      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
	        window.requestAnimationFrame(this._nextBound);
	      } else {
	        Promise.resolve(undefined).then(this._nextBound);
	      }
	    },
	    _next: function InternalRenderTask__next() {
	      if (this.cancelled) {
	        return;
	      }
	      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
	      if (this.operatorListIdx === this.operatorList.argsArray.length) {
	        this.running = false;
	        if (this.operatorList.lastChunk) {
	          this.gfx.endDrawing();
	          if (this._canvas) {
	            canvasInRendering.delete(this._canvas);
	          }
	          this.callback();
	        }
	      }
	    }
	  };
	  return InternalRenderTask;
	}();
	var _UnsupportedManager = function UnsupportedManagerClosure() {
	  var listeners = [];
	  return {
	    listen: function listen(cb) {
	      (0, _util.deprecated)('Global UnsupportedManager.listen is used: ' + ' use PDFDocumentLoadingTask.onUnsupportedFeature instead');
	      listeners.push(cb);
	    },
	    notify: function notify(featureId) {
	      for (var i = 0, ii = listeners.length; i < ii; i++) {
	        listeners[i](featureId);
	      }
	    }
	  };
	}();
	var version, build;
	{
	  exports.version = version = '1.10.100';
	  exports.build = build = 'ea29ec83';
	}
	exports.getDocument = getDocument;
	exports.LoopbackPort = LoopbackPort;
	exports.PDFDataRangeTransport = PDFDataRangeTransport;
	exports.PDFWorker = PDFWorker;
	exports.PDFDocumentProxy = PDFDocumentProxy;
	exports.PDFPageProxy = PDFPageProxy;
	exports.setPDFNetworkStreamClass = setPDFNetworkStreamClass;
	exports._UnsupportedManager = _UnsupportedManager;
	exports.version = version;
	exports.build = build;
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebGLUtils = undefined;
	
	var _dom_utils = __w_pdfjs_require__(15);
	
	var _util = __w_pdfjs_require__(0);
	
	var WebGLUtils = function WebGLUtilsClosure() {
	  function loadShader(gl, code, shaderType) {
	    var shader = gl.createShader(shaderType);
	    gl.shaderSource(shader, code);
	    gl.compileShader(shader);
	    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
	    if (!compiled) {
	      var errorMsg = gl.getShaderInfoLog(shader);
	      throw new Error('Error during shader compilation: ' + errorMsg);
	    }
	    return shader;
	  }
	  function createVertexShader(gl, code) {
	    return loadShader(gl, code, gl.VERTEX_SHADER);
	  }
	  function createFragmentShader(gl, code) {
	    return loadShader(gl, code, gl.FRAGMENT_SHADER);
	  }
	  function createProgram(gl, shaders) {
	    var program = gl.createProgram();
	    for (var i = 0, ii = shaders.length; i < ii; ++i) {
	      gl.attachShader(program, shaders[i]);
	    }
	    gl.linkProgram(program);
	    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
	    if (!linked) {
	      var errorMsg = gl.getProgramInfoLog(program);
	      throw new Error('Error during program linking: ' + errorMsg);
	    }
	    return program;
	  }
	  function createTexture(gl, image, textureId) {
	    gl.activeTexture(textureId);
	    var texture = gl.createTexture();
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
	    return texture;
	  }
	  var currentGL, currentCanvas;
	  function generateGL() {
	    if (currentGL) {
	      return;
	    }
	    currentCanvas = document.createElement('canvas');
	    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
	  }
	  var smaskVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec2 a_texCoord;                                    \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_texCoord = a_texCoord;                                    \
	  }                                                             ';
	  var smaskFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  uniform vec4 u_backdrop;                                      \
	  uniform int u_subtype;                                        \
	  uniform sampler2D u_image;                                    \
	  uniform sampler2D u_mask;                                     \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec4 imageColor = texture2D(u_image, v_texCoord);           \
	    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
	    if (u_backdrop.a > 0.0) {                                   \
	      maskColor.rgb = maskColor.rgb * maskColor.a +             \
	                      u_backdrop.rgb * (1.0 - maskColor.a);     \
	    }                                                           \
	    float lum;                                                  \
	    if (u_subtype == 0) {                                       \
	      lum = maskColor.a;                                        \
	    } else {                                                    \
	      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
	            maskColor.b * 0.11;                                 \
	    }                                                           \
	    imageColor.a *= lum;                                        \
	    imageColor.rgb *= imageColor.a;                             \
	    gl_FragColor = imageColor;                                  \
	  }                                                             ';
	  var smaskCache = null;
	  function initSmaskGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
	    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
	    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
	    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
	    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
	    var texCoordBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(texCoordLocation);
	    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.uniform1i(texLayerLocation, 0);
	    gl.uniform1i(texMaskLocation, 1);
	    smaskCache = cache;
	  }
	  function composeSMask(layer, mask, properties) {
	    var width = layer.width,
	        height = layer.height;
	    if (!smaskCache) {
	      initSmaskGL();
	    }
	    var cache = smaskCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    if (properties.backdrop) {
	      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
	    } else {
	      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
	    }
	    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
	    var texture = createTexture(gl, layer, gl.TEXTURE0);
	    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
	    var buffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.clearColor(0, 0, 0, 0);
	    gl.enable(gl.BLEND);
	    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    gl.drawArrays(gl.TRIANGLES, 0, 6);
	    gl.flush();
	    gl.deleteTexture(texture);
	    gl.deleteTexture(maskTexture);
	    gl.deleteBuffer(buffer);
	    return canvas;
	  }
	  var figuresVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec3 a_color;                                       \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	  uniform vec2 u_scale;                                         \
	  uniform vec2 u_offset;                                        \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    vec2 position = (a_position + u_offset) * u_scale;          \
	    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_color = vec4(a_color / 255.0, 1.0);                       \
	  }                                                             ';
	  var figuresFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    gl_FragColor = v_color;                                     \
	  }                                                             ';
	  var figuresCache = null;
	  function initFiguresGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
	    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
	    figuresCache = cache;
	  }
	  function drawFigures(width, height, backgroundColor, figures, context) {
	    if (!figuresCache) {
	      initFiguresGL();
	    }
	    var cache = figuresCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    var count = 0;
	    var i, ii, rows;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      switch (figures[i].type) {
	        case 'lattice':
	          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
	          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
	          break;
	        case 'triangles':
	          count += figures[i].coords.length;
	          break;
	      }
	    }
	    var coords = new Float32Array(count * 2);
	    var colors = new Uint8Array(count * 3);
	    var coordsMap = context.coords,
	        colorsMap = context.colors;
	    var pIndex = 0,
	        cIndex = 0;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      var figure = figures[i],
	          ps = figure.coords,
	          cs = figure.colors;
	      switch (figure.type) {
	        case 'lattice':
	          var cols = figure.verticesPerRow;
	          rows = ps.length / cols | 0;
	          for (var row = 1; row < rows; row++) {
	            var offset = row * cols + 1;
	            for (var col = 1; col < cols; col++, offset++) {
	              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
	              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
	              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
	              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
	              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
	              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
	              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
	              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
	              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
	              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
	              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
	              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
	              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
	              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
	              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
	              coords[pIndex + 6] = coords[pIndex + 2];
	              coords[pIndex + 7] = coords[pIndex + 3];
	              coords[pIndex + 8] = coords[pIndex + 4];
	              coords[pIndex + 9] = coords[pIndex + 5];
	              coords[pIndex + 10] = coordsMap[ps[offset]];
	              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
	              colors[cIndex + 9] = colors[cIndex + 3];
	              colors[cIndex + 10] = colors[cIndex + 4];
	              colors[cIndex + 11] = colors[cIndex + 5];
	              colors[cIndex + 12] = colors[cIndex + 6];
	              colors[cIndex + 13] = colors[cIndex + 7];
	              colors[cIndex + 14] = colors[cIndex + 8];
	              colors[cIndex + 15] = colorsMap[cs[offset]];
	              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
	              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
	              pIndex += 12;
	              cIndex += 18;
	            }
	          }
	          break;
	        case 'triangles':
	          for (var j = 0, jj = ps.length; j < jj; j++) {
	            coords[pIndex] = coordsMap[ps[j]];
	            coords[pIndex + 1] = coordsMap[ps[j] + 1];
	            colors[cIndex] = colorsMap[cs[j]];
	            colors[cIndex + 1] = colorsMap[cs[j] + 1];
	            colors[cIndex + 2] = colorsMap[cs[j] + 2];
	            pIndex += 2;
	            cIndex += 3;
	          }
	          break;
	      }
	    }
	    if (backgroundColor) {
	      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
	    } else {
	      gl.clearColor(0, 0, 0, 0);
	    }
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    var coordsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    var colorsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.colorLocation);
	    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
	    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
	    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
	    gl.drawArrays(gl.TRIANGLES, 0, count);
	    gl.flush();
	    gl.deleteBuffer(coordsBuffer);
	    gl.deleteBuffer(colorsBuffer);
	    return canvas;
	  }
	  function cleanup() {
	    if (smaskCache && smaskCache.canvas) {
	      smaskCache.canvas.width = 0;
	      smaskCache.canvas.height = 0;
	    }
	    if (figuresCache && figuresCache.canvas) {
	      figuresCache.canvas.width = 0;
	      figuresCache.canvas.height = 0;
	    }
	    smaskCache = null;
	    figuresCache = null;
	  }
	  return {
	    get isEnabled() {
	      if ((0, _dom_utils.getDefaultSetting)('disableWebGL')) {
	        return false;
	      }
	      var enabled = false;
	      try {
	        generateGL();
	        enabled = !!currentGL;
	      } catch (e) {}
	      return (0, _util.shadow)(this, 'isEnabled', enabled);
	    },
	    composeSMask: composeSMask,
	    drawFigures: drawFigures,
	    clear: cleanup
	  };
	}();
	exports.WebGLUtils = WebGLUtils;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Metadata = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _xml_parser = __w_pdfjs_require__(122);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Metadata = function () {
	  function Metadata(data) {
	    _classCallCheck(this, Metadata);
	
	    (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string');
	    data = this._repair(data);
	    var parser = new _xml_parser.SimpleXMLParser();
	    var xmlDocument = parser.parseFromString(data);
	    this._metadata = Object.create(null);
	    if (xmlDocument) {
	      this._parse(xmlDocument);
	    }
	  }
	
	  _createClass(Metadata, [{
	    key: '_repair',
	    value: function _repair(data) {
	      return data.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
	        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
	          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
	        });
	        var chars = '';
	        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
	          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
	          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
	            chars += String.fromCharCode(code);
	          } else {
	            chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
	          }
	        }
	        return '>' + chars;
	      });
	    }
	  }, {
	    key: '_parse',
	    value: function _parse(xmlDocument) {
	      var rdf = xmlDocument.documentElement;
	      if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	        rdf = rdf.firstChild;
	        while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	          rdf = rdf.nextSibling;
	        }
	      }
	      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
	      if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
	        return;
	      }
	      var children = rdf.childNodes;
	      for (var i = 0, ii = children.length; i < ii; i++) {
	        var desc = children[i];
	        if (desc.nodeName.toLowerCase() !== 'rdf:description') {
	          continue;
	        }
	        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
	          if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
	            var entry = desc.childNodes[j];
	            var name = entry.nodeName.toLowerCase();
	            this._metadata[name] = entry.textContent.trim();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this._metadata[name] || null;
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      return this._metadata;
	    }
	  }, {
	    key: 'has',
	    value: function has(name) {
	      return typeof this._metadata[name] !== 'undefined';
	    }
	  }, {
	    key: 'metadata',
	    get: function get() {
	      (0, _util.deprecated)('`metadata` getter; use `getAll()` instead.');
	      return this.getAll();
	    }
	  }]);
	
	  return Metadata;
	}();
	
	exports.Metadata = Metadata;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnnotationLayer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dom_utils = __w_pdfjs_require__(15);
	
	var _util = __w_pdfjs_require__(0);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnnotationElementFactory = function () {
	  function AnnotationElementFactory() {
	    _classCallCheck(this, AnnotationElementFactory);
	  }
	
	  _createClass(AnnotationElementFactory, null, [{
	    key: 'create',
	    value: function create(parameters) {
	      var subtype = parameters.data.annotationType;
	      switch (subtype) {
	        case _util.AnnotationType.LINK:
	          return new LinkAnnotationElement(parameters);
	        case _util.AnnotationType.TEXT:
	          return new TextAnnotationElement(parameters);
	        case _util.AnnotationType.WIDGET:
	          var fieldType = parameters.data.fieldType;
	          switch (fieldType) {
	            case 'Tx':
	              return new TextWidgetAnnotationElement(parameters);
	            case 'Btn':
	              if (parameters.data.radioButton) {
	                return new RadioButtonWidgetAnnotationElement(parameters);
	              } else if (parameters.data.checkBox) {
	                return new CheckboxWidgetAnnotationElement(parameters);
	              }
	              (0, _util.warn)('Unimplemented button widget annotation: pushbutton');
	              break;
	            case 'Ch':
	              return new ChoiceWidgetAnnotationElement(parameters);
	          }
	          return new WidgetAnnotationElement(parameters);
	        case _util.AnnotationType.POPUP:
	          return new PopupAnnotationElement(parameters);
	        case _util.AnnotationType.LINE:
	          return new LineAnnotationElement(parameters);
	        case _util.AnnotationType.SQUARE:
	          return new SquareAnnotationElement(parameters);
	        case _util.AnnotationType.CIRCLE:
	          return new CircleAnnotationElement(parameters);
	        case _util.AnnotationType.POLYLINE:
	          return new PolylineAnnotationElement(parameters);
	        case _util.AnnotationType.POLYGON:
	          return new PolygonAnnotationElement(parameters);
	        case _util.AnnotationType.HIGHLIGHT:
	          return new HighlightAnnotationElement(parameters);
	        case _util.AnnotationType.UNDERLINE:
	          return new UnderlineAnnotationElement(parameters);
	        case _util.AnnotationType.SQUIGGLY:
	          return new SquigglyAnnotationElement(parameters);
	        case _util.AnnotationType.STRIKEOUT:
	          return new StrikeOutAnnotationElement(parameters);
	        case _util.AnnotationType.STAMP:
	          return new StampAnnotationElement(parameters);
	        case _util.AnnotationType.FILEATTACHMENT:
	          return new FileAttachmentAnnotationElement(parameters);
	        default:
	          return new AnnotationElement(parameters);
	      }
	    }
	  }]);
	
	  return AnnotationElementFactory;
	}();
	
	var AnnotationElement = function () {
	  function AnnotationElement(parameters) {
	    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    _classCallCheck(this, AnnotationElement);
	
	    this.isRenderable = isRenderable;
	    this.data = parameters.data;
	    this.layer = parameters.layer;
	    this.page = parameters.page;
	    this.viewport = parameters.viewport;
	    this.linkService = parameters.linkService;
	    this.downloadManager = parameters.downloadManager;
	    this.imageResourcesPath = parameters.imageResourcesPath;
	    this.renderInteractiveForms = parameters.renderInteractiveForms;
	    this.svgFactory = parameters.svgFactory;
	    if (isRenderable) {
	      this.container = this._createContainer(ignoreBorder);
	    }
	  }
	
	  _createClass(AnnotationElement, [{
	    key: '_createContainer',
	    value: function _createContainer() {
	      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var data = this.data,
	          page = this.page,
	          viewport = this.viewport;
	      var container = document.createElement('section');
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      container.setAttribute('data-annotation-id', data.id);
	      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
	      _dom_utils.CustomStyle.setProp('transform', container, 'matrix(' + viewport.transform.join(',') + ')');
	      _dom_utils.CustomStyle.setProp('transformOrigin', container, -rect[0] + 'px ' + -rect[1] + 'px');
	      if (!ignoreBorder && data.borderStyle.width > 0) {
	        container.style.borderWidth = data.borderStyle.width + 'px';
	        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
	          width = width - 2 * data.borderStyle.width;
	          height = height - 2 * data.borderStyle.width;
	        }
	        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
	        var verticalRadius = data.borderStyle.verticalCornerRadius;
	        if (horizontalRadius > 0 || verticalRadius > 0) {
	          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
	          _dom_utils.CustomStyle.setProp('borderRadius', container, radius);
	        }
	        switch (data.borderStyle.style) {
	          case _util.AnnotationBorderStyleType.SOLID:
	            container.style.borderStyle = 'solid';
	            break;
	          case _util.AnnotationBorderStyleType.DASHED:
	            container.style.borderStyle = 'dashed';
	            break;
	          case _util.AnnotationBorderStyleType.BEVELED:
	            (0, _util.warn)('Unimplemented border style: beveled');
	            break;
	          case _util.AnnotationBorderStyleType.INSET:
	            (0, _util.warn)('Unimplemented border style: inset');
	            break;
	          case _util.AnnotationBorderStyleType.UNDERLINE:
	            container.style.borderBottomStyle = 'solid';
	            break;
	          default:
	            break;
	        }
	        if (data.color) {
	          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
	        } else {
	          container.style.borderWidth = 0;
	        }
	      }
	      container.style.left = rect[0] + 'px';
	      container.style.top = rect[1] + 'px';
	      container.style.width = width + 'px';
	      container.style.height = height + 'px';
	      return container;
	    }
	  }, {
	    key: '_createPopup',
	    value: function _createPopup(container, trigger, data) {
	      if (!trigger) {
	        trigger = document.createElement('div');
	        trigger.style.height = container.style.height;
	        trigger.style.width = container.style.width;
	        container.appendChild(trigger);
	      }
	      var popupElement = new PopupElement({
	        container: container,
	        trigger: trigger,
	        color: data.color,
	        title: data.title,
	        contents: data.contents,
	        hideWrapper: true
	      });
	      var popup = popupElement.render();
	      popup.style.left = container.style.width;
	      container.appendChild(popup);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      throw new Error('Abstract method `AnnotationElement.render` called');
	    }
	  }]);
	
	  return AnnotationElement;
	}();
	
	var LinkAnnotationElement = function (_AnnotationElement) {
	  _inherits(LinkAnnotationElement, _AnnotationElement);
	
	  function LinkAnnotationElement(parameters) {
	    _classCallCheck(this, LinkAnnotationElement);
	
	    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
	    return _possibleConstructorReturn(this, (LinkAnnotationElement.__proto__ || Object.getPrototypeOf(LinkAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(LinkAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'linkAnnotation';
	      var link = document.createElement('a');
	      (0, _dom_utils.addLinkAttributes)(link, {
	        url: this.data.url,
	        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
	      });
	      if (!this.data.url) {
	        if (this.data.action) {
	          this._bindNamedAction(link, this.data.action);
	        } else {
	          this._bindLink(link, this.data.dest);
	        }
	      }
	      this.container.appendChild(link);
	      return this.container;
	    }
	  }, {
	    key: '_bindLink',
	    value: function _bindLink(link, destination) {
	      var _this2 = this;
	
	      link.href = this.linkService.getDestinationHash(destination);
	      link.onclick = function () {
	        if (destination) {
	          _this2.linkService.navigateTo(destination);
	        }
	        return false;
	      };
	      if (destination) {
	        link.className = 'internalLink';
	      }
	    }
	  }, {
	    key: '_bindNamedAction',
	    value: function _bindNamedAction(link, action) {
	      var _this3 = this;
	
	      link.href = this.linkService.getAnchorUrl('');
	      link.onclick = function () {
	        _this3.linkService.executeNamedAction(action);
	        return false;
	      };
	      link.className = 'internalLink';
	    }
	  }]);
	
	  return LinkAnnotationElement;
	}(AnnotationElement);
	
	var TextAnnotationElement = function (_AnnotationElement2) {
	  _inherits(TextAnnotationElement, _AnnotationElement2);
	
	  function TextAnnotationElement(parameters) {
	    _classCallCheck(this, TextAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (TextAnnotationElement.__proto__ || Object.getPrototypeOf(TextAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(TextAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'textAnnotation';
	      var image = document.createElement('img');
	      image.style.height = this.container.style.height;
	      image.style.width = this.container.style.width;
	      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
	      image.alt = '[{{type}} Annotation]';
	      image.dataset.l10nId = 'text_annotation_type';
	      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, image, this.data);
	      }
	      this.container.appendChild(image);
	      return this.container;
	    }
	  }]);
	
	  return TextAnnotationElement;
	}(AnnotationElement);
	
	var WidgetAnnotationElement = function (_AnnotationElement3) {
	  _inherits(WidgetAnnotationElement, _AnnotationElement3);
	
	  function WidgetAnnotationElement() {
	    _classCallCheck(this, WidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (WidgetAnnotationElement.__proto__ || Object.getPrototypeOf(WidgetAnnotationElement)).apply(this, arguments));
	  }
	
	  _createClass(WidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      return this.container;
	    }
	  }]);
	
	  return WidgetAnnotationElement;
	}(AnnotationElement);
	
	var TextWidgetAnnotationElement = function (_WidgetAnnotationElem) {
	  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);
	
	  function TextWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, TextWidgetAnnotationElement);
	
	    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
	    return _possibleConstructorReturn(this, (TextWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(TextWidgetAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(TextWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var TEXT_ALIGNMENT = ['left', 'center', 'right'];
	      this.container.className = 'textWidgetAnnotation';
	      var element = null;
	      if (this.renderInteractiveForms) {
	        if (this.data.multiLine) {
	          element = document.createElement('textarea');
	          element.textContent = this.data.fieldValue;
	        } else {
	          element = document.createElement('input');
	          element.type = 'text';
	          element.setAttribute('value', this.data.fieldValue);
	        }
	        element.disabled = this.data.readOnly;
	        if (this.data.maxLen !== null) {
	          element.maxLength = this.data.maxLen;
	        }
	        if (this.data.comb) {
	          var fieldWidth = this.data.rect[2] - this.data.rect[0];
	          var combWidth = fieldWidth / this.data.maxLen;
	          element.classList.add('comb');
	          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
	        }
	      } else {
	        element = document.createElement('div');
	        element.textContent = this.data.fieldValue;
	        element.style.verticalAlign = 'middle';
	        element.style.display = 'table-cell';
	        var font = null;
	        if (this.data.fontRefName) {
	          font = this.page.commonObjs.getData(this.data.fontRefName);
	        }
	        this._setTextStyle(element, font);
	      }
	      if (this.data.textAlignment !== null) {
	        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }, {
	    key: '_setTextStyle',
	    value: function _setTextStyle(element, font) {
	      var style = element.style;
	      style.fontSize = this.data.fontSize + 'px';
	      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
	      if (!font) {
	        return;
	      }
	      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
	      style.fontStyle = font.italic ? 'italic' : 'normal';
	      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
	      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
	      style.fontFamily = fontFamily + fallbackName;
	    }
	  }]);
	
	  return TextWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var CheckboxWidgetAnnotationElement = function (_WidgetAnnotationElem2) {
	  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);
	
	  function CheckboxWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, CheckboxWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (CheckboxWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(CheckboxWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(CheckboxWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'buttonWidgetAnnotation checkBox';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'checkbox';
	      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }]);
	
	  return CheckboxWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var RadioButtonWidgetAnnotationElement = function (_WidgetAnnotationElem3) {
	  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);
	
	  function RadioButtonWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, RadioButtonWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (RadioButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(RadioButtonWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(RadioButtonWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'buttonWidgetAnnotation radioButton';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'radio';
	      element.name = this.data.fieldName;
	      if (this.data.fieldValue === this.data.buttonValue) {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  }]);
	
	  return RadioButtonWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var ChoiceWidgetAnnotationElement = function (_WidgetAnnotationElem4) {
	  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);
	
	  function ChoiceWidgetAnnotationElement(parameters) {
	    _classCallCheck(this, ChoiceWidgetAnnotationElement);
	
	    return _possibleConstructorReturn(this, (ChoiceWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
	  }
	
	  _createClass(ChoiceWidgetAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'choiceWidgetAnnotation';
	      var selectElement = document.createElement('select');
	      selectElement.disabled = this.data.readOnly;
	      if (!this.data.combo) {
	        selectElement.size = this.data.options.length;
	        if (this.data.multiSelect) {
	          selectElement.multiple = true;
	        }
	      }
	      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
	        var option = this.data.options[i];
	        var optionElement = document.createElement('option');
	        optionElement.textContent = option.displayValue;
	        optionElement.value = option.exportValue;
	        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
	          optionElement.setAttribute('selected', true);
	        }
	        selectElement.appendChild(optionElement);
	      }
	      this.container.appendChild(selectElement);
	      return this.container;
	    }
	  }]);
	
	  return ChoiceWidgetAnnotationElement;
	}(WidgetAnnotationElement);
	
	var PopupAnnotationElement = function (_AnnotationElement4) {
	  _inherits(PopupAnnotationElement, _AnnotationElement4);
	
	  function PopupAnnotationElement(parameters) {
	    _classCallCheck(this, PopupAnnotationElement);
	
	    var isRenderable = !!(parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (PopupAnnotationElement.__proto__ || Object.getPrototypeOf(PopupAnnotationElement)).call(this, parameters, isRenderable));
	  }
	
	  _createClass(PopupAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      var IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon'];
	      this.container.className = 'popupAnnotation';
	      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
	        return this.container;
	      }
	      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
	      var parentElement = this.layer.querySelector(selector);
	      if (!parentElement) {
	        return this.container;
	      }
	      var popup = new PopupElement({
	        container: this.container,
	        trigger: parentElement,
	        color: this.data.color,
	        title: this.data.title,
	        contents: this.data.contents
	      });
	      var parentLeft = parseFloat(parentElement.style.left);
	      var parentWidth = parseFloat(parentElement.style.width);
	      _dom_utils.CustomStyle.setProp('transformOrigin', this.container, -(parentLeft + parentWidth) + 'px -' + parentElement.style.top);
	      this.container.style.left = parentLeft + parentWidth + 'px';
	      this.container.appendChild(popup.render());
	      return this.container;
	    }
	  }]);
	
	  return PopupAnnotationElement;
	}(AnnotationElement);
	
	var PopupElement = function () {
	  function PopupElement(parameters) {
	    _classCallCheck(this, PopupElement);
	
	    this.container = parameters.container;
	    this.trigger = parameters.trigger;
	    this.color = parameters.color;
	    this.title = parameters.title;
	    this.contents = parameters.contents;
	    this.hideWrapper = parameters.hideWrapper || false;
	    this.pinned = false;
	  }
	
	  _createClass(PopupElement, [{
	    key: 'render',
	    value: function render() {
	      var BACKGROUND_ENLIGHT = 0.7;
	      var wrapper = document.createElement('div');
	      wrapper.className = 'popupWrapper';
	      this.hideElement = this.hideWrapper ? wrapper : this.container;
	      this.hideElement.setAttribute('hidden', true);
	      var popup = document.createElement('div');
	      popup.className = 'popup';
	      var color = this.color;
	      if (color) {
	        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
	        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
	        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
	        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
	      }
	      var contents = this._formatContents(this.contents);
	      var title = document.createElement('h1');
	      title.textContent = this.title;
	      this.trigger.addEventListener('click', this._toggle.bind(this));
	      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
	      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
	      popup.addEventListener('click', this._hide.bind(this, true));
	      popup.appendChild(title);
	      popup.appendChild(contents);
	      wrapper.appendChild(popup);
	      return wrapper;
	    }
	  }, {
	    key: '_formatContents',
	    value: function _formatContents(contents) {
	      var p = document.createElement('p');
	      var lines = contents.split(/(?:\r\n?|\n)/);
	      for (var i = 0, ii = lines.length; i < ii; ++i) {
	        var line = lines[i];
	        p.appendChild(document.createTextNode(line));
	        if (i < ii - 1) {
	          p.appendChild(document.createElement('br'));
	        }
	      }
	      return p;
	    }
	  }, {
	    key: '_toggle',
	    value: function _toggle() {
	      if (this.pinned) {
	        this._hide(true);
	      } else {
	        this._show(true);
	      }
	    }
	  }, {
	    key: '_show',
	    value: function _show() {
	      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (pin) {
	        this.pinned = true;
	      }
	      if (this.hideElement.hasAttribute('hidden')) {
	        this.hideElement.removeAttribute('hidden');
	        this.container.style.zIndex += 1;
	      }
	    }
	  }, {
	    key: '_hide',
	    value: function _hide() {
	      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (unpin) {
	        this.pinned = false;
	      }
	      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
	        this.hideElement.setAttribute('hidden', true);
	        this.container.style.zIndex -= 1;
	      }
	    }
	  }]);
	
	  return PopupElement;
	}();
	
	var LineAnnotationElement = function (_AnnotationElement5) {
	  _inherits(LineAnnotationElement, _AnnotationElement5);
	
	  function LineAnnotationElement(parameters) {
	    _classCallCheck(this, LineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (LineAnnotationElement.__proto__ || Object.getPrototypeOf(LineAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(LineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'lineAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var line = this.svgFactory.createElement('svg:line');
	      line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0]);
	      line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1]);
	      line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2]);
	      line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3]);
	      line.setAttribute('stroke-width', data.borderStyle.width);
	      line.setAttribute('stroke', 'transparent');
	      svg.appendChild(line);
	      this.container.append(svg);
	      this._createPopup(this.container, line, data);
	      return this.container;
	    }
	  }]);
	
	  return LineAnnotationElement;
	}(AnnotationElement);
	
	var SquareAnnotationElement = function (_AnnotationElement6) {
	  _inherits(SquareAnnotationElement, _AnnotationElement6);
	
	  function SquareAnnotationElement(parameters) {
	    _classCallCheck(this, SquareAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (SquareAnnotationElement.__proto__ || Object.getPrototypeOf(SquareAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(SquareAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'squareAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var borderWidth = data.borderStyle.width;
	      var square = this.svgFactory.createElement('svg:rect');
	      square.setAttribute('x', borderWidth / 2);
	      square.setAttribute('y', borderWidth / 2);
	      square.setAttribute('width', width - borderWidth);
	      square.setAttribute('height', height - borderWidth);
	      square.setAttribute('stroke-width', borderWidth);
	      square.setAttribute('stroke', 'transparent');
	      square.setAttribute('fill', 'none');
	      svg.appendChild(square);
	      this.container.append(svg);
	      this._createPopup(this.container, square, data);
	      return this.container;
	    }
	  }]);
	
	  return SquareAnnotationElement;
	}(AnnotationElement);
	
	var CircleAnnotationElement = function (_AnnotationElement7) {
	  _inherits(CircleAnnotationElement, _AnnotationElement7);
	
	  function CircleAnnotationElement(parameters) {
	    _classCallCheck(this, CircleAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (CircleAnnotationElement.__proto__ || Object.getPrototypeOf(CircleAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(CircleAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'circleAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var borderWidth = data.borderStyle.width;
	      var circle = this.svgFactory.createElement('svg:ellipse');
	      circle.setAttribute('cx', width / 2);
	      circle.setAttribute('cy', height / 2);
	      circle.setAttribute('rx', width / 2 - borderWidth / 2);
	      circle.setAttribute('ry', height / 2 - borderWidth / 2);
	      circle.setAttribute('stroke-width', borderWidth);
	      circle.setAttribute('stroke', 'transparent');
	      circle.setAttribute('fill', 'none');
	      svg.appendChild(circle);
	      this.container.append(svg);
	      this._createPopup(this.container, circle, data);
	      return this.container;
	    }
	  }]);
	
	  return CircleAnnotationElement;
	}(AnnotationElement);
	
	var PolylineAnnotationElement = function (_AnnotationElement8) {
	  _inherits(PolylineAnnotationElement, _AnnotationElement8);
	
	  function PolylineAnnotationElement(parameters) {
	    _classCallCheck(this, PolylineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	
	    var _this14 = _possibleConstructorReturn(this, (PolylineAnnotationElement.__proto__ || Object.getPrototypeOf(PolylineAnnotationElement)).call(this, parameters, isRenderable, true));
	
	    _this14.containerClassName = 'polylineAnnotation';
	    _this14.svgElementName = 'svg:polyline';
	    return _this14;
	  }
	
	  _createClass(PolylineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = this.containerClassName;
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = this.svgFactory.create(width, height);
	      var vertices = data.vertices;
	      var points = [];
	      for (var i = 0, ii = vertices.length; i < ii; i++) {
	        var x = vertices[i].x - data.rect[0];
	        var y = data.rect[3] - vertices[i].y;
	        points.push(x + ',' + y);
	      }
	      points = points.join(' ');
	      var borderWidth = data.borderStyle.width;
	      var polyline = this.svgFactory.createElement(this.svgElementName);
	      polyline.setAttribute('points', points);
	      polyline.setAttribute('stroke-width', borderWidth);
	      polyline.setAttribute('stroke', 'transparent');
	      polyline.setAttribute('fill', 'none');
	      svg.appendChild(polyline);
	      this.container.append(svg);
	      this._createPopup(this.container, polyline, data);
	      return this.container;
	    }
	  }]);
	
	  return PolylineAnnotationElement;
	}(AnnotationElement);
	
	var PolygonAnnotationElement = function (_PolylineAnnotationEl) {
	  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);
	
	  function PolygonAnnotationElement(parameters) {
	    _classCallCheck(this, PolygonAnnotationElement);
	
	    var _this15 = _possibleConstructorReturn(this, (PolygonAnnotationElement.__proto__ || Object.getPrototypeOf(PolygonAnnotationElement)).call(this, parameters));
	
	    _this15.containerClassName = 'polygonAnnotation';
	    _this15.svgElementName = 'svg:polygon';
	    return _this15;
	  }
	
	  return PolygonAnnotationElement;
	}(PolylineAnnotationElement);
	
	var HighlightAnnotationElement = function (_AnnotationElement9) {
	  _inherits(HighlightAnnotationElement, _AnnotationElement9);
	
	  function HighlightAnnotationElement(parameters) {
	    _classCallCheck(this, HighlightAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (HighlightAnnotationElement.__proto__ || Object.getPrototypeOf(HighlightAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(HighlightAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'highlightAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return HighlightAnnotationElement;
	}(AnnotationElement);
	
	var UnderlineAnnotationElement = function (_AnnotationElement10) {
	  _inherits(UnderlineAnnotationElement, _AnnotationElement10);
	
	  function UnderlineAnnotationElement(parameters) {
	    _classCallCheck(this, UnderlineAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (UnderlineAnnotationElement.__proto__ || Object.getPrototypeOf(UnderlineAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(UnderlineAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'underlineAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return UnderlineAnnotationElement;
	}(AnnotationElement);
	
	var SquigglyAnnotationElement = function (_AnnotationElement11) {
	  _inherits(SquigglyAnnotationElement, _AnnotationElement11);
	
	  function SquigglyAnnotationElement(parameters) {
	    _classCallCheck(this, SquigglyAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (SquigglyAnnotationElement.__proto__ || Object.getPrototypeOf(SquigglyAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(SquigglyAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'squigglyAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return SquigglyAnnotationElement;
	}(AnnotationElement);
	
	var StrikeOutAnnotationElement = function (_AnnotationElement12) {
	  _inherits(StrikeOutAnnotationElement, _AnnotationElement12);
	
	  function StrikeOutAnnotationElement(parameters) {
	    _classCallCheck(this, StrikeOutAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (StrikeOutAnnotationElement.__proto__ || Object.getPrototypeOf(StrikeOutAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(StrikeOutAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'strikeoutAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return StrikeOutAnnotationElement;
	}(AnnotationElement);
	
	var StampAnnotationElement = function (_AnnotationElement13) {
	  _inherits(StampAnnotationElement, _AnnotationElement13);
	
	  function StampAnnotationElement(parameters) {
	    _classCallCheck(this, StampAnnotationElement);
	
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    return _possibleConstructorReturn(this, (StampAnnotationElement.__proto__ || Object.getPrototypeOf(StampAnnotationElement)).call(this, parameters, isRenderable, true));
	  }
	
	  _createClass(StampAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'stampAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  }]);
	
	  return StampAnnotationElement;
	}(AnnotationElement);
	
	var FileAttachmentAnnotationElement = function (_AnnotationElement14) {
	  _inherits(FileAttachmentAnnotationElement, _AnnotationElement14);
	
	  function FileAttachmentAnnotationElement(parameters) {
	    _classCallCheck(this, FileAttachmentAnnotationElement);
	
	    var _this21 = _possibleConstructorReturn(this, (FileAttachmentAnnotationElement.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotationElement)).call(this, parameters, true));
	
	    var file = _this21.data.file;
	    _this21.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
	    _this21.content = file.content;
	    _this21.linkService.onFileAttachmentAnnotation({
	      id: (0, _util.stringToPDFString)(file.filename),
	      filename: file.filename,
	      content: file.content
	    });
	    return _this21;
	  }
	
	  _createClass(FileAttachmentAnnotationElement, [{
	    key: 'render',
	    value: function render() {
	      this.container.className = 'fileAttachmentAnnotation';
	      var trigger = document.createElement('div');
	      trigger.style.height = this.container.style.height;
	      trigger.style.width = this.container.style.width;
	      trigger.addEventListener('dblclick', this._download.bind(this));
	      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
	        this._createPopup(this.container, trigger, this.data);
	      }
	      this.container.appendChild(trigger);
	      return this.container;
	    }
	  }, {
	    key: '_download',
	    value: function _download() {
	      if (!this.downloadManager) {
	        (0, _util.warn)('Download cannot be started due to unavailable download manager');
	        return;
	      }
	      this.downloadManager.downloadData(this.content, this.filename, '');
	    }
	  }]);
	
	  return FileAttachmentAnnotationElement;
	}(AnnotationElement);
	
	var AnnotationLayer = function () {
	  function AnnotationLayer() {
	    _classCallCheck(this, AnnotationLayer);
	  }
	
	  _createClass(AnnotationLayer, null, [{
	    key: 'render',
	    value: function render(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        if (!data) {
	          continue;
	        }
	        var element = AnnotationElementFactory.create({
	          data: data,
	          layer: parameters.div,
	          page: parameters.page,
	          viewport: parameters.viewport,
	          linkService: parameters.linkService,
	          downloadManager: parameters.downloadManager,
	          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
	          renderInteractiveForms: parameters.renderInteractiveForms || false,
	          svgFactory: new _dom_utils.DOMSVGFactory()
	        });
	        if (element.isRenderable) {
	          parameters.div.appendChild(element.render());
	        }
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
	        if (element) {
	          _dom_utils.CustomStyle.setProp('transform', element, 'matrix(' + parameters.viewport.transform.join(',') + ')');
	        }
	      }
	      parameters.div.removeAttribute('hidden');
	    }
	  }]);
	
	  return AnnotationLayer;
	}();
	
	exports.AnnotationLayer = AnnotationLayer;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderTextLayer = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(15);
	
	var renderTextLayer = function renderTextLayerClosure() {
	  var MAX_TEXT_DIVS_TO_RENDER = 100000;
	  var NonWhitespaceRegexp = /\S/;
	  function isAllWhitespace(str) {
	    return !NonWhitespaceRegexp.test(str);
	  }
	  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
	  function appendText(task, geom, styles) {
	    var textDiv = document.createElement('div');
	    var textDivProperties = {
	      style: null,
	      angle: 0,
	      canvasWidth: 0,
	      isWhitespace: false,
	      originalTransform: null,
	      paddingBottom: 0,
	      paddingLeft: 0,
	      paddingRight: 0,
	      paddingTop: 0,
	      scale: 1
	    };
	    task._textDivs.push(textDiv);
	    if (isAllWhitespace(geom.str)) {
	      textDivProperties.isWhitespace = true;
	      task._textDivProperties.set(textDiv, textDivProperties);
	      return;
	    }
	    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
	    var angle = Math.atan2(tx[1], tx[0]);
	    var style = styles[geom.fontName];
	    if (style.vertical) {
	      angle += Math.PI / 2;
	    }
	    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
	    var fontAscent = fontHeight;
	    if (style.ascent) {
	      fontAscent = style.ascent * fontAscent;
	    } else if (style.descent) {
	      fontAscent = (1 + style.descent) * fontAscent;
	    }
	    var left;
	    var top;
	    if (angle === 0) {
	      left = tx[4];
	      top = tx[5] - fontAscent;
	    } else {
	      left = tx[4] + fontAscent * Math.sin(angle);
	      top = tx[5] - fontAscent * Math.cos(angle);
	    }
	    styleBuf[1] = left;
	    styleBuf[3] = top;
	    styleBuf[5] = fontHeight;
	    styleBuf[7] = style.fontFamily;
	    textDivProperties.style = styleBuf.join('');
	    textDiv.setAttribute('style', textDivProperties.style);
	    textDiv.textContent = geom.str;
	    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
	      textDiv.dataset.fontName = geom.fontName;
	    }
	    if (angle !== 0) {
	      textDivProperties.angle = angle * (180 / Math.PI);
	    }
	    if (geom.str.length > 1) {
	      if (style.vertical) {
	        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
	      } else {
	        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
	      }
	    }
	    task._textDivProperties.set(textDiv, textDivProperties);
	    if (task._textContentStream) {
	      task._layoutText(textDiv);
	    }
	    if (task._enhanceTextSelection) {
	      var angleCos = 1,
	          angleSin = 0;
	      if (angle !== 0) {
	        angleCos = Math.cos(angle);
	        angleSin = Math.sin(angle);
	      }
	      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
	      var divHeight = fontHeight;
	      var m, b;
	      if (angle !== 0) {
	        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
	        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
	      } else {
	        b = [left, top, left + divWidth, top + divHeight];
	      }
	      task._bounds.push({
	        left: b[0],
	        top: b[1],
	        right: b[2],
	        bottom: b[3],
	        div: textDiv,
	        size: [divWidth, divHeight],
	        m: m
	      });
	    }
	  }
	  function render(task) {
	    if (task._canceled) {
	      return;
	    }
	    var textDivs = task._textDivs;
	    var capability = task._capability;
	    var textDivsLength = textDivs.length;
	    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
	      task._renderingDone = true;
	      capability.resolve();
	      return;
	    }
	    if (!task._textContentStream) {
	      for (var i = 0; i < textDivsLength; i++) {
	        task._layoutText(textDivs[i]);
	      }
	    }
	    task._renderingDone = true;
	    capability.resolve();
	  }
	  function expand(task) {
	    var bounds = task._bounds;
	    var viewport = task._viewport;
	    var expanded = expandBounds(viewport.width, viewport.height, bounds);
	    for (var i = 0; i < expanded.length; i++) {
	      var div = bounds[i].div;
	      var divProperties = task._textDivProperties.get(div);
	      if (divProperties.angle === 0) {
	        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
	        divProperties.paddingTop = bounds[i].top - expanded[i].top;
	        divProperties.paddingRight = expanded[i].right - bounds[i].right;
	        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
	        task._textDivProperties.set(div, divProperties);
	        continue;
	      }
	      var e = expanded[i],
	          b = bounds[i];
	      var m = b.m,
	          c = m[0],
	          s = m[1];
	      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
	      var ts = new Float64Array(64);
	      points.forEach(function (p, i) {
	        var t = _util.Util.applyTransform(p, m);
	        ts[i + 0] = c && (e.left - t[0]) / c;
	        ts[i + 4] = s && (e.top - t[1]) / s;
	        ts[i + 8] = c && (e.right - t[0]) / c;
	        ts[i + 12] = s && (e.bottom - t[1]) / s;
	        ts[i + 16] = s && (e.left - t[0]) / -s;
	        ts[i + 20] = c && (e.top - t[1]) / c;
	        ts[i + 24] = s && (e.right - t[0]) / -s;
	        ts[i + 28] = c && (e.bottom - t[1]) / c;
	        ts[i + 32] = c && (e.left - t[0]) / -c;
	        ts[i + 36] = s && (e.top - t[1]) / -s;
	        ts[i + 40] = c && (e.right - t[0]) / -c;
	        ts[i + 44] = s && (e.bottom - t[1]) / -s;
	        ts[i + 48] = s && (e.left - t[0]) / s;
	        ts[i + 52] = c && (e.top - t[1]) / -c;
	        ts[i + 56] = s && (e.right - t[0]) / s;
	        ts[i + 60] = c && (e.bottom - t[1]) / -c;
	      });
	      var findPositiveMin = function findPositiveMin(ts, offset, count) {
	        var result = 0;
	        for (var i = 0; i < count; i++) {
	          var t = ts[offset++];
	          if (t > 0) {
	            result = result ? Math.min(t, result) : t;
	          }
	        }
	        return result;
	      };
	      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
	      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
	      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
	      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
	      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
	      task._textDivProperties.set(div, divProperties);
	    }
	  }
	  function expandBounds(width, height, boxes) {
	    var bounds = boxes.map(function (box, i) {
	      return {
	        x1: box.left,
	        y1: box.top,
	        x2: box.right,
	        y2: box.bottom,
	        index: i,
	        x1New: undefined,
	        x2New: undefined
	      };
	    });
	    expandBoundsLTR(width, bounds);
	    var expanded = new Array(boxes.length);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i] = {
	        left: b.x1New,
	        top: 0,
	        right: b.x2New,
	        bottom: 0
	      };
	    });
	    boxes.map(function (box, i) {
	      var e = expanded[i],
	          b = bounds[i];
	      b.x1 = box.top;
	      b.y1 = width - e.right;
	      b.x2 = box.bottom;
	      b.y2 = width - e.left;
	      b.index = i;
	      b.x1New = undefined;
	      b.x2New = undefined;
	    });
	    expandBoundsLTR(height, bounds);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i].top = b.x1New;
	      expanded[i].bottom = b.x2New;
	    });
	    return expanded;
	  }
	  function expandBoundsLTR(width, bounds) {
	    bounds.sort(function (a, b) {
	      return a.x1 - b.x1 || a.index - b.index;
	    });
	    var fakeBoundary = {
	      x1: -Infinity,
	      y1: -Infinity,
	      x2: 0,
	      y2: Infinity,
	      index: -1,
	      x1New: 0,
	      x2New: 0
	    };
	    var horizon = [{
	      start: -Infinity,
	      end: Infinity,
	      boundary: fakeBoundary
	    }];
	    bounds.forEach(function (boundary) {
	      var i = 0;
	      while (i < horizon.length && horizon[i].end <= boundary.y1) {
	        i++;
	      }
	      var j = horizon.length - 1;
	      while (j >= 0 && horizon[j].start >= boundary.y2) {
	        j--;
	      }
	      var horizonPart, affectedBoundary;
	      var q,
	          k,
	          maxXNew = -Infinity;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var xNew;
	        if (affectedBoundary.x2 > boundary.x1) {
	          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
	        } else if (affectedBoundary.x2New === undefined) {
	          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
	        } else {
	          xNew = affectedBoundary.x2New;
	        }
	        if (xNew > maxXNew) {
	          maxXNew = xNew;
	        }
	      }
	      boundary.x1New = maxXNew;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New === undefined) {
	          if (affectedBoundary.x2 > boundary.x1) {
	            if (affectedBoundary.index > boundary.index) {
	              affectedBoundary.x2New = affectedBoundary.x2;
	            }
	          } else {
	            affectedBoundary.x2New = maxXNew;
	          }
	        } else if (affectedBoundary.x2New > maxXNew) {
	          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
	        }
	      }
	      var changedHorizon = [],
	          lastBoundary = null;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
	        if (lastBoundary === useBoundary) {
	          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
	        } else {
	          changedHorizon.push({
	            start: horizonPart.start,
	            end: horizonPart.end,
	            boundary: useBoundary
	          });
	          lastBoundary = useBoundary;
	        }
	      }
	      if (horizon[i].start < boundary.y1) {
	        changedHorizon[0].start = boundary.y1;
	        changedHorizon.unshift({
	          start: horizon[i].start,
	          end: boundary.y1,
	          boundary: horizon[i].boundary
	        });
	      }
	      if (boundary.y2 < horizon[j].end) {
	        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
	        changedHorizon.push({
	          start: boundary.y2,
	          end: horizon[j].end,
	          boundary: horizon[j].boundary
	        });
	      }
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New !== undefined) {
	          continue;
	        }
	        var used = false;
	        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = 0; !used && k < changedHorizon.length; k++) {
	          used = changedHorizon[k].boundary === affectedBoundary;
	        }
	        if (!used) {
	          affectedBoundary.x2New = maxXNew;
	        }
	      }
	      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
	    });
	    horizon.forEach(function (horizonPart) {
	      var affectedBoundary = horizonPart.boundary;
	      if (affectedBoundary.x2New === undefined) {
	        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
	      }
	    });
	  }
	  function TextLayerRenderTask(_ref) {
	    var textContent = _ref.textContent,
	        textContentStream = _ref.textContentStream,
	        container = _ref.container,
	        viewport = _ref.viewport,
	        textDivs = _ref.textDivs,
	        textContentItemsStr = _ref.textContentItemsStr,
	        enhanceTextSelection = _ref.enhanceTextSelection;
	
	    this._textContent = textContent;
	    this._textContentStream = textContentStream;
	    this._container = container;
	    this._viewport = viewport;
	    this._textDivs = textDivs || [];
	    this._textContentItemsStr = textContentItemsStr || [];
	    this._enhanceTextSelection = !!enhanceTextSelection;
	    this._reader = null;
	    this._layoutTextLastFontSize = null;
	    this._layoutTextLastFontFamily = null;
	    this._layoutTextCtx = null;
	    this._textDivProperties = new WeakMap();
	    this._renderingDone = false;
	    this._canceled = false;
	    this._capability = (0, _util.createPromiseCapability)();
	    this._renderTimer = null;
	    this._bounds = [];
	  }
	  TextLayerRenderTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    cancel: function TextLayer_cancel() {
	      if (this._reader) {
	        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
	        this._reader = null;
	      }
	      this._canceled = true;
	      if (this._renderTimer !== null) {
	        clearTimeout(this._renderTimer);
	        this._renderTimer = null;
	      }
	      this._capability.reject('canceled');
	    },
	    _processItems: function _processItems(items, styleCache) {
	      for (var i = 0, len = items.length; i < len; i++) {
	        this._textContentItemsStr.push(items[i].str);
	        appendText(this, items[i], styleCache);
	      }
	    },
	    _layoutText: function _layoutText(textDiv) {
	      var textLayerFrag = this._container;
	      var textDivProperties = this._textDivProperties.get(textDiv);
	      if (textDivProperties.isWhitespace) {
	        return;
	      }
	      var fontSize = textDiv.style.fontSize;
	      var fontFamily = textDiv.style.fontFamily;
	      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
	        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
	        this._lastFontSize = fontSize;
	        this._lastFontFamily = fontFamily;
	      }
	      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
	      var transform = '';
	      if (textDivProperties.canvasWidth !== 0 && width > 0) {
	        textDivProperties.scale = textDivProperties.canvasWidth / width;
	        transform = 'scaleX(' + textDivProperties.scale + ')';
	      }
	      if (textDivProperties.angle !== 0) {
	        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
	      }
	      if (transform !== '') {
	        textDivProperties.originalTransform = transform;
	        _dom_utils.CustomStyle.setProp('transform', textDiv, transform);
	      }
	      this._textDivProperties.set(textDiv, textDivProperties);
	      textLayerFrag.appendChild(textDiv);
	    },
	
	    _render: function TextLayer_render(timeout) {
	      var _this = this;
	
	      var capability = (0, _util.createPromiseCapability)();
	      var styleCache = Object.create(null);
	      var canvas = document.createElement('canvas');
	      canvas.mozOpaque = true;
	      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
	      if (this._textContent) {
	        var textItems = this._textContent.items;
	        var textStyles = this._textContent.styles;
	        this._processItems(textItems, textStyles);
	        capability.resolve();
	      } else if (this._textContentStream) {
	        var pump = function pump() {
	          _this._reader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              capability.resolve();
	              return;
	            }
	            _util.Util.extendObj(styleCache, value.styles);
	            _this._processItems(value.items, styleCache);
	            pump();
	          }, capability.reject);
	        };
	        this._reader = this._textContentStream.getReader();
	        pump();
	      } else {
	        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
	      }
	      capability.promise.then(function () {
	        styleCache = null;
	        if (!timeout) {
	          render(_this);
	        } else {
	          _this._renderTimer = setTimeout(function () {
	            render(_this);
	            _this._renderTimer = null;
	          }, timeout);
	        }
	      }, this._capability.reject);
	    },
	    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
	      if (!this._enhanceTextSelection || !this._renderingDone) {
	        return;
	      }
	      if (this._bounds !== null) {
	        expand(this);
	        this._bounds = null;
	      }
	      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
	        var div = this._textDivs[i];
	        var divProperties = this._textDivProperties.get(div);
	        if (divProperties.isWhitespace) {
	          continue;
	        }
	        if (expandDivs) {
	          var transform = '',
	              padding = '';
	          if (divProperties.scale !== 1) {
	            transform = 'scaleX(' + divProperties.scale + ')';
	          }
	          if (divProperties.angle !== 0) {
	            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
	          }
	          if (divProperties.paddingLeft !== 0) {
	            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
	            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
	          }
	          if (divProperties.paddingTop !== 0) {
	            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
	            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
	          }
	          if (divProperties.paddingRight !== 0) {
	            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
	          }
	          if (divProperties.paddingBottom !== 0) {
	            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
	          }
	          if (padding !== '') {
	            div.setAttribute('style', divProperties.style + padding);
	          }
	          if (transform !== '') {
	            _dom_utils.CustomStyle.setProp('transform', div, transform);
	          }
	        } else {
	          div.style.padding = 0;
	          _dom_utils.CustomStyle.setProp('transform', div, divProperties.originalTransform || '');
	        }
	      }
	    }
	  };
	  function renderTextLayer(renderParameters) {
	    var task = new TextLayerRenderTask({
	      textContent: renderParameters.textContent,
	      textContentStream: renderParameters.textContentStream,
	      container: renderParameters.container,
	      viewport: renderParameters.viewport,
	      textDivs: renderParameters.textDivs,
	      textContentItemsStr: renderParameters.textContentItemsStr,
	      enhanceTextSelection: renderParameters.enhanceTextSelection
	    });
	    task._render(renderParameters.timeout);
	    return task;
	  }
	  return renderTextLayer;
	}();
	exports.renderTextLayer = renderTextLayer;
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(15);
	
	var SVGGraphics = function SVGGraphics() {
	  throw new Error('Not implemented: SVGGraphics');
	};
	{
	  var SVG_DEFAULTS = {
	    fontStyle: 'normal',
	    fontWeight: 'normal',
	    fillColor: '#000000'
	  };
	  var convertImgDataToPng = function convertImgDataToPngClosure() {
	    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
	    var CHUNK_WRAPPER_SIZE = 12;
	    var crcTable = new Int32Array(256);
	    for (var i = 0; i < 256; i++) {
	      var c = i;
	      for (var h = 0; h < 8; h++) {
	        if (c & 1) {
	          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
	        } else {
	          c = c >> 1 & 0x7fffffff;
	        }
	      }
	      crcTable[i] = c;
	    }
	    function crc32(data, start, end) {
	      var crc = -1;
	      for (var i = start; i < end; i++) {
	        var a = (crc ^ data[i]) & 0xff;
	        var b = crcTable[a];
	        crc = crc >>> 8 ^ b;
	      }
	      return crc ^ -1;
	    }
	    function writePngChunk(type, body, data, offset) {
	      var p = offset;
	      var len = body.length;
	      data[p] = len >> 24 & 0xff;
	      data[p + 1] = len >> 16 & 0xff;
	      data[p + 2] = len >> 8 & 0xff;
	      data[p + 3] = len & 0xff;
	      p += 4;
	      data[p] = type.charCodeAt(0) & 0xff;
	      data[p + 1] = type.charCodeAt(1) & 0xff;
	      data[p + 2] = type.charCodeAt(2) & 0xff;
	      data[p + 3] = type.charCodeAt(3) & 0xff;
	      p += 4;
	      data.set(body, p);
	      p += body.length;
	      var crc = crc32(data, offset + 4, p);
	      data[p] = crc >> 24 & 0xff;
	      data[p + 1] = crc >> 16 & 0xff;
	      data[p + 2] = crc >> 8 & 0xff;
	      data[p + 3] = crc & 0xff;
	    }
	    function adler32(data, start, end) {
	      var a = 1;
	      var b = 0;
	      for (var i = start; i < end; ++i) {
	        a = (a + (data[i] & 0xff)) % 65521;
	        b = (b + a) % 65521;
	      }
	      return b << 16 | a;
	    }
	    function deflateSync(literals) {
	      if (!(0, _util.isNodeJS)()) {
	        return deflateSyncUncompressed(literals);
	      }
	      try {
	        var input;
	        if (parseInt(process.versions.node) >= 8) {
	          input = literals;
	        } else {
	          input = new Buffer(literals);
	        }
	        var output = __webpack_require__(148).deflateSync(input, { level: 9 });
	        return output instanceof Uint8Array ? output : new Uint8Array(output);
	      } catch (e) {
	        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
	      }
	      return deflateSyncUncompressed(literals);
	    }
	    function deflateSyncUncompressed(literals) {
	      var len = literals.length;
	      var maxBlockLength = 0xFFFF;
	      var deflateBlocks = Math.ceil(len / maxBlockLength);
	      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
	      var pi = 0;
	      idat[pi++] = 0x78;
	      idat[pi++] = 0x9c;
	      var pos = 0;
	      while (len > maxBlockLength) {
	        idat[pi++] = 0x00;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0x00;
	        idat[pi++] = 0x00;
	        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
	        pi += maxBlockLength;
	        pos += maxBlockLength;
	        len -= maxBlockLength;
	      }
	      idat[pi++] = 0x01;
	      idat[pi++] = len & 0xff;
	      idat[pi++] = len >> 8 & 0xff;
	      idat[pi++] = ~len & 0xffff & 0xff;
	      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
	      idat.set(literals.subarray(pos), pi);
	      pi += literals.length - pos;
	      var adler = adler32(literals, 0, literals.length);
	      idat[pi++] = adler >> 24 & 0xff;
	      idat[pi++] = adler >> 16 & 0xff;
	      idat[pi++] = adler >> 8 & 0xff;
	      idat[pi++] = adler & 0xff;
	      return idat;
	    }
	    function encode(imgData, kind, forceDataSchema) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var bitDepth, colorType, lineSize;
	      var bytes = imgData.data;
	      switch (kind) {
	        case _util.ImageKind.GRAYSCALE_1BPP:
	          colorType = 0;
	          bitDepth = 1;
	          lineSize = width + 7 >> 3;
	          break;
	        case _util.ImageKind.RGB_24BPP:
	          colorType = 2;
	          bitDepth = 8;
	          lineSize = width * 3;
	          break;
	        case _util.ImageKind.RGBA_32BPP:
	          colorType = 6;
	          bitDepth = 8;
	          lineSize = width * 4;
	          break;
	        default:
	          throw new Error('invalid format');
	      }
	      var literals = new Uint8Array((1 + lineSize) * height);
	      var offsetLiterals = 0,
	          offsetBytes = 0;
	      var y, i;
	      for (y = 0; y < height; ++y) {
	        literals[offsetLiterals++] = 0;
	        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
	        offsetBytes += lineSize;
	        offsetLiterals += lineSize;
	      }
	      if (kind === _util.ImageKind.GRAYSCALE_1BPP) {
	        offsetLiterals = 0;
	        for (y = 0; y < height; y++) {
	          offsetLiterals++;
	          for (i = 0; i < lineSize; i++) {
	            literals[offsetLiterals++] ^= 0xFF;
	          }
	        }
	      }
	      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
	      var idat = deflateSync(literals);
	      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
	      var data = new Uint8Array(pngLength);
	      var offset = 0;
	      data.set(PNG_HEADER, offset);
	      offset += PNG_HEADER.length;
	      writePngChunk('IHDR', ihdr, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
	      writePngChunk('IDATA', idat, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + idat.length;
	      writePngChunk('IEND', new Uint8Array(0), data, offset);
	      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
	    }
	    return function convertImgDataToPng(imgData, forceDataSchema) {
	      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
	      return encode(imgData, kind, forceDataSchema);
	    };
	  }();
	  var SVGExtraState = function SVGExtraStateClosure() {
	    function SVGExtraState() {
	      this.fontSizeScale = 1;
	      this.fontWeight = SVG_DEFAULTS.fontWeight;
	      this.fontSize = 0;
	      this.textMatrix = _util.IDENTITY_MATRIX;
	      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	      this.leading = 0;
	      this.x = 0;
	      this.y = 0;
	      this.lineX = 0;
	      this.lineY = 0;
	      this.charSpacing = 0;
	      this.wordSpacing = 0;
	      this.textHScale = 1;
	      this.textRise = 0;
	      this.fillColor = SVG_DEFAULTS.fillColor;
	      this.strokeColor = '#000000';
	      this.fillAlpha = 1;
	      this.strokeAlpha = 1;
	      this.lineWidth = 1;
	      this.lineJoin = '';
	      this.lineCap = '';
	      this.miterLimit = 0;
	      this.dashArray = [];
	      this.dashPhase = 0;
	      this.dependencies = [];
	      this.activeClipUrl = null;
	      this.clipGroup = null;
	      this.maskId = '';
	    }
	    SVGExtraState.prototype = {
	      clone: function SVGExtraState_clone() {
	        return Object.create(this);
	      },
	      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
	        this.x = x;
	        this.y = y;
	      }
	    };
	    return SVGExtraState;
	  }();
	  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
	    function opListToTree(opList) {
	      var opTree = [];
	      var tmp = [];
	      var opListLen = opList.length;
	      for (var x = 0; x < opListLen; x++) {
	        if (opList[x].fn === 'save') {
	          opTree.push({
	            'fnId': 92,
	            'fn': 'group',
	            'items': []
	          });
	          tmp.push(opTree);
	          opTree = opTree[opTree.length - 1].items;
	          continue;
	        }
	        if (opList[x].fn === 'restore') {
	          opTree = tmp.pop();
	        } else {
	          opTree.push(opList[x]);
	        }
	      }
	      return opTree;
	    }
	    function pf(value) {
	      if (Number.isInteger(value)) {
	        return value.toString();
	      }
	      var s = value.toFixed(10);
	      var i = s.length - 1;
	      if (s[i] !== '0') {
	        return s;
	      }
	      do {
	        i--;
	      } while (s[i] === '0');
	      return s.substr(0, s[i] === '.' ? i : i + 1);
	    }
	    function pm(m) {
	      if (m[4] === 0 && m[5] === 0) {
	        if (m[1] === 0 && m[2] === 0) {
	          if (m[0] === 1 && m[3] === 1) {
	            return '';
	          }
	          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
	        }
	        if (m[0] === m[3] && m[1] === -m[2]) {
	          var a = Math.acos(m[0]) * 180 / Math.PI;
	          return 'rotate(' + pf(a) + ')';
	        }
	      } else {
	        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
	          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	        }
	      }
	      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	    }
	    function SVGGraphics(commonObjs, objs, forceDataSchema) {
	      this.svgFactory = new _dom_utils.DOMSVGFactory();
	      this.current = new SVGExtraState();
	      this.transformMatrix = _util.IDENTITY_MATRIX;
	      this.transformStack = [];
	      this.extraStack = [];
	      this.commonObjs = commonObjs;
	      this.objs = objs;
	      this.pendingClip = null;
	      this.pendingEOFill = false;
	      this.embedFonts = false;
	      this.embeddedFonts = Object.create(null);
	      this.cssStyle = null;
	      this.forceDataSchema = !!forceDataSchema;
	    }
	    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
	    var XLINK_NS = 'http://www.w3.org/1999/xlink';
	    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	    var clipCount = 0;
	    var maskCount = 0;
	    SVGGraphics.prototype = {
	      save: function SVGGraphics_save() {
	        this.transformStack.push(this.transformMatrix);
	        var old = this.current;
	        this.extraStack.push(old);
	        this.current = old.clone();
	      },
	      restore: function SVGGraphics_restore() {
	        this.transformMatrix = this.transformStack.pop();
	        this.current = this.extraStack.pop();
	        this.pendingClip = null;
	        this.tgrp = null;
	      },
	      group: function SVGGraphics_group(items) {
	        this.save();
	        this.executeOpTree(items);
	        this.restore();
	      },
	      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
	        var _this = this;
	
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var argsArray = operatorList.argsArray;
	        for (var i = 0; i < fnArrayLen; i++) {
	          if (_util.OPS.dependency === fnArray[i]) {
	            var deps = argsArray[i];
	            for (var n = 0, nn = deps.length; n < nn; n++) {
	              var obj = deps[n];
	              var common = obj.substring(0, 2) === 'g_';
	              var promise;
	              if (common) {
	                promise = new Promise(function (resolve) {
	                  _this.commonObjs.get(obj, resolve);
	                });
	              } else {
	                promise = new Promise(function (resolve) {
	                  _this.objs.get(obj, resolve);
	                });
	              }
	              this.current.dependencies.push(promise);
	            }
	          }
	        }
	        return Promise.all(this.current.dependencies);
	      },
	      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
	        var transformMatrix = [a, b, c, d, e, f];
	        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
	        this.tgrp = null;
	      },
	      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
	        var _this2 = this;
	
	        this.viewport = viewport;
	        var svgElement = this._initialize(viewport);
	        return this.loadDependencies(operatorList).then(function () {
	          _this2.transformMatrix = _util.IDENTITY_MATRIX;
	          var opTree = _this2.convertOpList(operatorList);
	          _this2.executeOpTree(opTree);
	          return svgElement;
	        });
	      },
	      convertOpList: function SVGGraphics_convertOpList(operatorList) {
	        var argsArray = operatorList.argsArray;
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var REVOPS = [];
	        var opList = [];
	        for (var op in _util.OPS) {
	          REVOPS[_util.OPS[op]] = op;
	        }
	        for (var x = 0; x < fnArrayLen; x++) {
	          var fnId = fnArray[x];
	          opList.push({
	            'fnId': fnId,
	            'fn': REVOPS[fnId],
	            'args': argsArray[x]
	          });
	        }
	        return opListToTree(opList);
	      },
	      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
	        var opTreeLen = opTree.length;
	        for (var x = 0; x < opTreeLen; x++) {
	          var fn = opTree[x].fn;
	          var fnId = opTree[x].fnId;
	          var args = opTree[x].args;
	          switch (fnId | 0) {
	            case _util.OPS.beginText:
	              this.beginText();
	              break;
	            case _util.OPS.setLeading:
	              this.setLeading(args);
	              break;
	            case _util.OPS.setLeadingMoveText:
	              this.setLeadingMoveText(args[0], args[1]);
	              break;
	            case _util.OPS.setFont:
	              this.setFont(args);
	              break;
	            case _util.OPS.showText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.showSpacedText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.endText:
	              this.endText();
	              break;
	            case _util.OPS.moveText:
	              this.moveText(args[0], args[1]);
	              break;
	            case _util.OPS.setCharSpacing:
	              this.setCharSpacing(args[0]);
	              break;
	            case _util.OPS.setWordSpacing:
	              this.setWordSpacing(args[0]);
	              break;
	            case _util.OPS.setHScale:
	              this.setHScale(args[0]);
	              break;
	            case _util.OPS.setTextMatrix:
	              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.setTextRise:
	              this.setTextRise(args[0]);
	              break;
	            case _util.OPS.setLineWidth:
	              this.setLineWidth(args[0]);
	              break;
	            case _util.OPS.setLineJoin:
	              this.setLineJoin(args[0]);
	              break;
	            case _util.OPS.setLineCap:
	              this.setLineCap(args[0]);
	              break;
	            case _util.OPS.setMiterLimit:
	              this.setMiterLimit(args[0]);
	              break;
	            case _util.OPS.setFillRGBColor:
	              this.setFillRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setStrokeRGBColor:
	              this.setStrokeRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setDash:
	              this.setDash(args[0], args[1]);
	              break;
	            case _util.OPS.setGState:
	              this.setGState(args[0]);
	              break;
	            case _util.OPS.fill:
	              this.fill();
	              break;
	            case _util.OPS.eoFill:
	              this.eoFill();
	              break;
	            case _util.OPS.stroke:
	              this.stroke();
	              break;
	            case _util.OPS.fillStroke:
	              this.fillStroke();
	              break;
	            case _util.OPS.eoFillStroke:
	              this.eoFillStroke();
	              break;
	            case _util.OPS.clip:
	              this.clip('nonzero');
	              break;
	            case _util.OPS.eoClip:
	              this.clip('evenodd');
	              break;
	            case _util.OPS.paintSolidColorImageMask:
	              this.paintSolidColorImageMask();
	              break;
	            case _util.OPS.paintJpegXObject:
	              this.paintJpegXObject(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.paintImageXObject:
	              this.paintImageXObject(args[0]);
	              break;
	            case _util.OPS.paintInlineImageXObject:
	              this.paintInlineImageXObject(args[0]);
	              break;
	            case _util.OPS.paintImageMaskXObject:
	              this.paintImageMaskXObject(args[0]);
	              break;
	            case _util.OPS.paintFormXObjectBegin:
	              this.paintFormXObjectBegin(args[0], args[1]);
	              break;
	            case _util.OPS.paintFormXObjectEnd:
	              this.paintFormXObjectEnd();
	              break;
	            case _util.OPS.closePath:
	              this.closePath();
	              break;
	            case _util.OPS.closeStroke:
	              this.closeStroke();
	              break;
	            case _util.OPS.closeFillStroke:
	              this.closeFillStroke();
	              break;
	            case _util.OPS.nextLine:
	              this.nextLine();
	              break;
	            case _util.OPS.transform:
	              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.constructPath:
	              this.constructPath(args[0], args[1]);
	              break;
	            case _util.OPS.endPath:
	              this.endPath();
	              break;
	            case 92:
	              this.group(opTree[x].items);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented operator ' + fn);
	              break;
	          }
	        }
	      },
	      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
	        this.current.wordSpacing = wordSpacing;
	      },
	      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
	        this.current.charSpacing = charSpacing;
	      },
	      nextLine: function SVGGraphics_nextLine() {
	        this.moveText(0, this.current.leading);
	      },
	      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
	        var current = this.current;
	        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        current.xcoords = [];
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.txtElement = this.svgFactory.createElement('svg:text');
	        current.txtElement.appendChild(current.tspan);
	      },
	      beginText: function SVGGraphics_beginText() {
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        this.current.textMatrix = _util.IDENTITY_MATRIX;
	        this.current.lineMatrix = _util.IDENTITY_MATRIX;
	        this.current.tspan = this.svgFactory.createElement('svg:tspan');
	        this.current.txtElement = this.svgFactory.createElement('svg:text');
	        this.current.txtgrp = this.svgFactory.createElement('svg:g');
	        this.current.xcoords = [];
	      },
	      moveText: function SVGGraphics_moveText(x, y) {
	        var current = this.current;
	        this.current.x = this.current.lineX += x;
	        this.current.y = this.current.lineY += y;
	        current.xcoords = [];
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	      },
	      showText: function SVGGraphics_showText(glyphs) {
	        var current = this.current;
	        var font = current.font;
	        var fontSize = current.fontSize;
	        if (fontSize === 0) {
	          return;
	        }
	        var charSpacing = current.charSpacing;
	        var wordSpacing = current.wordSpacing;
	        var fontDirection = current.fontDirection;
	        var textHScale = current.textHScale * fontDirection;
	        var glyphsLength = glyphs.length;
	        var vertical = font.vertical;
	        var widthAdvanceScale = fontSize * current.fontMatrix[0];
	        var x = 0,
	            i;
	        for (i = 0; i < glyphsLength; ++i) {
	          var glyph = glyphs[i];
	          if (glyph === null) {
	            x += fontDirection * wordSpacing;
	            continue;
	          } else if ((0, _util.isNum)(glyph)) {
	            x += -glyph * fontSize * 0.001;
	            continue;
	          }
	          var width = glyph.width;
	          var character = glyph.fontChar;
	          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	          if (!glyph.isInFont && !font.missingFile) {
	            x += charWidth;
	            continue;
	          }
	          current.xcoords.push(current.x + x * textHScale);
	          current.tspan.textContent += character;
	          x += charWidth;
	        }
	        if (vertical) {
	          current.y -= x * textHScale;
	        } else {
	          current.x += x * textHScale;
	        }
	        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
	          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
	        }
	        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
	          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
	        }
	        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
	          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
	        }
	        var textMatrix = current.textMatrix;
	        if (current.textRise !== 0) {
	          textMatrix = textMatrix.slice();
	          textMatrix[5] += current.textRise;
	        }
	        current.txtElement.setAttributeNS(null, 'transform', pm(textMatrix) + ' scale(1, -1)');
	        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
	        current.txtElement.appendChild(current.tspan);
	        current.txtgrp.appendChild(current.txtElement);
	        this._ensureTransformGroup().appendChild(current.txtElement);
	      },
	      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
	        this.setLeading(-y);
	        this.moveText(x, y);
	      },
	      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
	        if (!this.cssStyle) {
	          this.cssStyle = this.svgFactory.createElement('svg:style');
	          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
	          this.defs.appendChild(this.cssStyle);
	        }
	        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
	        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
	      },
	      setFont: function SVGGraphics_setFont(details) {
	        var current = this.current;
	        var fontObj = this.commonObjs.get(details[0]);
	        var size = details[1];
	        this.current.font = fontObj;
	        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
	          this.addFontStyle(fontObj);
	          this.embeddedFonts[fontObj.loadedName] = fontObj;
	        }
	        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
	        var italic = fontObj.italic ? 'italic' : 'normal';
	        if (size < 0) {
	          size = -size;
	          current.fontDirection = -1;
	        } else {
	          current.fontDirection = 1;
	        }
	        current.fontSize = size;
	        current.fontFamily = fontObj.loadedName;
	        current.fontWeight = bold;
	        current.fontStyle = italic;
	        current.tspan = this.svgFactory.createElement('svg:tspan');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.xcoords = [];
	      },
	      endText: function SVGGraphics_endText() {},
	      setLineWidth: function SVGGraphics_setLineWidth(width) {
	        this.current.lineWidth = width;
	      },
	      setLineCap: function SVGGraphics_setLineCap(style) {
	        this.current.lineCap = LINE_CAP_STYLES[style];
	      },
	      setLineJoin: function SVGGraphics_setLineJoin(style) {
	        this.current.lineJoin = LINE_JOIN_STYLES[style];
	      },
	      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
	        this.current.miterLimit = limit;
	      },
	      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
	        this.current.strokeAlpha = strokeAlpha;
	      },
	      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.strokeColor = color;
	      },
	      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
	        this.current.fillAlpha = fillAlpha;
	      },
	      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.fillColor = color;
	        this.current.tspan = this.svgFactory.createElement('svg:tspan');
	        this.current.xcoords = [];
	      },
	      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
	        this.current.dashArray = dashArray;
	        this.current.dashPhase = dashPhase;
	      },
	      constructPath: function SVGGraphics_constructPath(ops, args) {
	        var current = this.current;
	        var x = current.x,
	            y = current.y;
	        current.path = this.svgFactory.createElement('svg:path');
	        var d = [];
	        var opLength = ops.length;
	        for (var i = 0, j = 0; i < opLength; i++) {
	          switch (ops[i] | 0) {
	            case _util.OPS.rectangle:
	              x = args[j++];
	              y = args[j++];
	              var width = args[j++];
	              var height = args[j++];
	              var xw = x + width;
	              var yh = y + height;
	              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
	              break;
	            case _util.OPS.moveTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('M', pf(x), pf(y));
	              break;
	            case _util.OPS.lineTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('L', pf(x), pf(y));
	              break;
	            case _util.OPS.curveTo:
	              x = args[j + 4];
	              y = args[j + 5];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
	              j += 6;
	              break;
	            case _util.OPS.curveTo2:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
	              j += 4;
	              break;
	            case _util.OPS.curveTo3:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
	              j += 4;
	              break;
	            case _util.OPS.closePath:
	              d.push('Z');
	              break;
	          }
	        }
	        current.path.setAttributeNS(null, 'd', d.join(' '));
	        current.path.setAttributeNS(null, 'fill', 'none');
	        this._ensureTransformGroup().appendChild(current.path);
	        current.element = current.path;
	        current.setCurrentPoint(x, y);
	      },
	      endPath: function SVGGraphics_endPath() {
	        if (!this.pendingClip) {
	          return;
	        }
	        var current = this.current;
	        var clipId = 'clippath' + clipCount;
	        clipCount++;
	        var clipPath = this.svgFactory.createElement('svg:clipPath');
	        clipPath.setAttributeNS(null, 'id', clipId);
	        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	        var clipElement = current.element.cloneNode();
	        if (this.pendingClip === 'evenodd') {
	          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
	        } else {
	          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
	        }
	        this.pendingClip = null;
	        clipPath.appendChild(clipElement);
	        this.defs.appendChild(clipPath);
	        if (current.activeClipUrl) {
	          current.clipGroup = null;
	          this.extraStack.forEach(function (prev) {
	            prev.clipGroup = null;
	          });
	        }
	        current.activeClipUrl = 'url(#' + clipId + ')';
	        this.tgrp = null;
	      },
	      clip: function SVGGraphics_clip(type) {
	        this.pendingClip = type;
	      },
	      closePath: function SVGGraphics_closePath() {
	        var current = this.current;
	        var d = current.path.getAttributeNS(null, 'd');
	        d += 'Z';
	        current.path.setAttributeNS(null, 'd', d);
	      },
	      setLeading: function SVGGraphics_setLeading(leading) {
	        this.current.leading = -leading;
	      },
	      setTextRise: function SVGGraphics_setTextRise(textRise) {
	        this.current.textRise = textRise;
	      },
	      setHScale: function SVGGraphics_setHScale(scale) {
	        this.current.textHScale = scale / 100;
	      },
	      setGState: function SVGGraphics_setGState(states) {
	        for (var i = 0, ii = states.length; i < ii; i++) {
	          var state = states[i];
	          var key = state[0];
	          var value = state[1];
	          switch (key) {
	            case 'LW':
	              this.setLineWidth(value);
	              break;
	            case 'LC':
	              this.setLineCap(value);
	              break;
	            case 'LJ':
	              this.setLineJoin(value);
	              break;
	            case 'ML':
	              this.setMiterLimit(value);
	              break;
	            case 'D':
	              this.setDash(value[0], value[1]);
	              break;
	            case 'Font':
	              this.setFont(value);
	              break;
	            case 'CA':
	              this.setStrokeAlpha(value);
	              break;
	            case 'ca':
	              this.setFillAlpha(value);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented graphic state ' + key);
	              break;
	          }
	        }
	      },
	      fill: function SVGGraphics_fill() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'fill', current.fillColor);
	        current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
	      },
	      stroke: function SVGGraphics_stroke() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'stroke', current.strokeColor);
	        current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
	        current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
	        current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
	        current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
	        current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
	        current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
	        current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
	        current.element.setAttributeNS(null, 'fill', 'none');
	      },
	      eoFill: function SVGGraphics_eoFill() {
	        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        this.fill();
	      },
	      fillStroke: function SVGGraphics_fillStroke() {
	        this.stroke();
	        this.fill();
	      },
	      eoFillStroke: function SVGGraphics_eoFillStroke() {
	        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        this.fillStroke();
	      },
	      closeStroke: function SVGGraphics_closeStroke() {
	        this.closePath();
	        this.stroke();
	      },
	      closeFillStroke: function SVGGraphics_closeFillStroke() {
	        this.closePath();
	        this.fillStroke();
	      },
	      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
	        var current = this.current;
	        var rect = this.svgFactory.createElement('svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', '1px');
	        rect.setAttributeNS(null, 'height', '1px');
	        rect.setAttributeNS(null, 'fill', current.fillColor);
	        this._ensureTransformGroup().appendChild(rect);
	      },
	      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
	        var imgObj = this.objs.get(objId);
	        var imgEl = this.svgFactory.createElement('svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
	        imgEl.setAttributeNS(null, 'width', pf(w));
	        imgEl.setAttributeNS(null, 'height', pf(h));
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-h));
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
	        this._ensureTransformGroup().appendChild(imgEl);
	      },
	      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
	        var imgData = this.objs.get(objId);
	        if (!imgData) {
	          (0, _util.warn)('Dependent image isn\'t ready yet');
	          return;
	        }
	        this.paintInlineImageXObject(imgData);
	      },
	      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
	        var width = imgData.width;
	        var height = imgData.height;
	        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema);
	        var cliprect = this.svgFactory.createElement('svg:rect');
	        cliprect.setAttributeNS(null, 'x', '0');
	        cliprect.setAttributeNS(null, 'y', '0');
	        cliprect.setAttributeNS(null, 'width', pf(width));
	        cliprect.setAttributeNS(null, 'height', pf(height));
	        this.current.element = cliprect;
	        this.clip('nonzero');
	        var imgEl = this.svgFactory.createElement('svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-height));
	        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
	        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
	        if (mask) {
	          mask.appendChild(imgEl);
	        } else {
	          this._ensureTransformGroup().appendChild(imgEl);
	        }
	      },
	      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
	        var current = this.current;
	        var width = imgData.width;
	        var height = imgData.height;
	        var fillColor = current.fillColor;
	        current.maskId = 'mask' + maskCount++;
	        var mask = this.svgFactory.createElement('svg:mask');
	        mask.setAttributeNS(null, 'id', current.maskId);
	        var rect = this.svgFactory.createElement('svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', pf(width));
	        rect.setAttributeNS(null, 'height', pf(height));
	        rect.setAttributeNS(null, 'fill', fillColor);
	        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
	        this.defs.appendChild(mask);
	        this._ensureTransformGroup().appendChild(rect);
	        this.paintInlineImageXObject(imgData, mask);
	      },
	      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
	        if (Array.isArray(matrix) && matrix.length === 6) {
	          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	        }
	        if (Array.isArray(bbox) && bbox.length === 4) {
	          var width = bbox[2] - bbox[0];
	          var height = bbox[3] - bbox[1];
	          var cliprect = this.svgFactory.createElement('svg:rect');
	          cliprect.setAttributeNS(null, 'x', bbox[0]);
	          cliprect.setAttributeNS(null, 'y', bbox[1]);
	          cliprect.setAttributeNS(null, 'width', pf(width));
	          cliprect.setAttributeNS(null, 'height', pf(height));
	          this.current.element = cliprect;
	          this.clip('nonzero');
	          this.endPath();
	        }
	      },
	      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
	      _initialize: function _initialize(viewport) {
	        var svg = this.svgFactory.create(viewport.width, viewport.height);
	        var definitions = this.svgFactory.createElement('svg:defs');
	        svg.appendChild(definitions);
	        this.defs = definitions;
	        var rootGroup = this.svgFactory.createElement('svg:g');
	        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
	        svg.appendChild(rootGroup);
	        this.svg = rootGroup;
	        return svg;
	      },
	
	      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
	        if (!this.current.clipGroup) {
	          var clipGroup = this.svgFactory.createElement('svg:g');
	          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
	          this.svg.appendChild(clipGroup);
	          this.current.clipGroup = clipGroup;
	        }
	        return this.current.clipGroup;
	      },
	      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
	        if (!this.tgrp) {
	          this.tgrp = this.svgFactory.createElement('svg:g');
	          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	          if (this.current.activeClipUrl) {
	            this._ensureClipGroup().appendChild(this.tgrp);
	          } else {
	            this.svg.appendChild(this.tgrp);
	          }
	        }
	        return this.tgrp;
	      }
	    };
	    return SVGGraphics;
	  }();
	}
	exports.SVGGraphics = SVGGraphics;
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pdfjsVersion = '1.10.100';
	var pdfjsBuild = 'ea29ec83';
	var pdfjsSharedUtil = __w_pdfjs_require__(0);
	var pdfjsDisplayGlobal = __w_pdfjs_require__(118);
	var pdfjsDisplayAPI = __w_pdfjs_require__(69);
	var pdfjsDisplayTextLayer = __w_pdfjs_require__(73);
	var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(72);
	var pdfjsDisplayDOMUtils = __w_pdfjs_require__(15);
	var pdfjsDisplaySVG = __w_pdfjs_require__(74);
	{
	  if (pdfjsSharedUtil.isNodeJS()) {
	    var PDFNodeStream = __w_pdfjs_require__(124).PDFNodeStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFNodeStream);
	  } else if (typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined') {
	    var PDFFetchStream = __w_pdfjs_require__(125).PDFFetchStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFFetchStream);
	  } else {
	    var PDFNetworkStream = __w_pdfjs_require__(126).PDFNetworkStream;
	    pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFNetworkStream);
	  }
	}
	exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
	exports.build = pdfjsDisplayAPI.build;
	exports.version = pdfjsDisplayAPI.version;
	exports.getDocument = pdfjsDisplayAPI.getDocument;
	exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
	exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
	exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
	exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
	exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
	exports.CustomStyle = pdfjsDisplayDOMUtils.CustomStyle;
	exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
	exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
	exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
	exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
	exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
	exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
	exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
	exports.OPS = pdfjsSharedUtil.OPS;
	exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
	exports.isValidUrl = pdfjsDisplayDOMUtils.isValidUrl;
	exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
	exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
	exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
	exports.shadow = pdfjsSharedUtil.shadow;
	exports.createBlob = pdfjsSharedUtil.createBlob;
	exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
	exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
	exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
	exports.StatTimer = pdfjsSharedUtil.StatTimer;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = __w_pdfjs_require__(20);
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
	  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
	  var isChrome = userAgent.indexOf('Chrom') >= 0;
	  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isOpera = userAgent.indexOf('Opera') >= 0;
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkTypedArrayCompatibility() {
	    if (typeof Uint8ClampedArray === 'undefined') {
	      globalScope.Uint8ClampedArray = __w_pdfjs_require__(77);
	    }
	    if (typeof Uint8Array !== 'undefined') {
	      if (typeof Uint8Array.prototype.subarray === 'undefined') {
	        Uint8Array.prototype.subarray = function subarray(start, end) {
	          return new Uint8Array(this.slice(start, end));
	        };
	        Float32Array.prototype.subarray = function subarray(start, end) {
	          return new Float32Array(this.slice(start, end));
	        };
	      }
	      if (typeof Float64Array === 'undefined') {
	        globalScope.Float64Array = Float32Array;
	      }
	      return;
	    }
	    function subarray(start, end) {
	      return new TypedArray(this.slice(start, end));
	    }
	    function setArrayOffset(array, offset) {
	      if (arguments.length < 2) {
	        offset = 0;
	      }
	      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
	        this[offset] = array[i] & 0xFF;
	      }
	    }
	    function Uint32ArrayView(buffer, length) {
	      this.buffer = buffer;
	      this.byteLength = buffer.length;
	      this.length = length;
	      ensureUint32ArrayViewProps(this.length);
	    }
	    Uint32ArrayView.prototype = Object.create(null);
	    var uint32ArrayViewSetters = 0;
	    function createUint32ArrayProp(index) {
	      return {
	        get: function get() {
	          var buffer = this.buffer,
	              offset = index << 2;
	          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
	        },
	        set: function set(value) {
	          var buffer = this.buffer,
	              offset = index << 2;
	          buffer[offset] = value & 255;
	          buffer[offset + 1] = value >> 8 & 255;
	          buffer[offset + 2] = value >> 16 & 255;
	          buffer[offset + 3] = value >>> 24 & 255;
	        }
	      };
	    }
	    function ensureUint32ArrayViewProps(length) {
	      while (uint32ArrayViewSetters < length) {
	        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
	        uint32ArrayViewSetters++;
	      }
	    }
	    function TypedArray(arg1) {
	      var result, i, n;
	      if (typeof arg1 === 'number') {
	        result = [];
	        for (i = 0; i < arg1; ++i) {
	          result[i] = 0;
	        }
	      } else if ('slice' in arg1) {
	        result = arg1.slice(0);
	      } else {
	        result = [];
	        for (i = 0, n = arg1.length; i < n; ++i) {
	          result[i] = arg1[i];
	        }
	      }
	      result.subarray = subarray;
	      result.buffer = result;
	      result.byteLength = result.length;
	      result.set = setArrayOffset;
	      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
	        result.buffer = arg1.buffer;
	      }
	      return result;
	    }
	    globalScope.Uint8Array = TypedArray;
	    globalScope.Int8Array = TypedArray;
	    globalScope.Int32Array = TypedArray;
	    globalScope.Uint16Array = TypedArray;
	    globalScope.Float32Array = TypedArray;
	    globalScope.Float64Array = TypedArray;
	    globalScope.Uint32Array = function () {
	      if (arguments.length === 3) {
	        if (arguments[1] !== 0) {
	          throw new Error('offset !== 0 is not supported');
	        }
	        return new Uint32ArrayView(arguments[0], arguments[2]);
	      }
	      return TypedArray.apply(this, arguments);
	    };
	  })();
	  (function canvasPixelArrayBuffer() {
	    if (!hasDOM || !window.CanvasPixelArray) {
	      return;
	    }
	    var cpaProto = window.CanvasPixelArray.prototype;
	    if ('buffer' in cpaProto) {
	      return;
	    }
	    Object.defineProperty(cpaProto, 'buffer', {
	      get: function get() {
	        return this;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	    Object.defineProperty(cpaProto, 'byteLength', {
	      get: function get() {
	        return this.length;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	  })();
	  (function normalizeURLObject() {
	    if (!globalScope.URL) {
	      globalScope.URL = globalScope.webkitURL;
	    }
	  })();
	  (function checkObjectDefinePropertyCompatibility() {
	    if (typeof Object.defineProperty !== 'undefined') {
	      var definePropertyPossible = true;
	      try {
	        if (hasDOM) {
	          Object.defineProperty(new Image(), 'id', { value: 'test' });
	        }
	        var Test = function Test() {};
	        Test.prototype = {
	          get id() {}
	        };
	        Object.defineProperty(new Test(), 'id', {
	          value: '',
	          configurable: true,
	          enumerable: true,
	          writable: false
	        });
	      } catch (e) {
	        definePropertyPossible = false;
	      }
	      if (definePropertyPossible) {
	        return;
	      }
	    }
	    Object.defineProperty = function objectDefineProperty(obj, name, def) {
	      delete obj[name];
	      if ('get' in def) {
	        obj.__defineGetter__(name, def['get']);
	      }
	      if ('set' in def) {
	        obj.__defineSetter__(name, def['set']);
	      }
	      if ('value' in def) {
	        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
	          this.__defineGetter__(name, function objectDefinePropertyGetter() {
	            return value;
	          });
	          return value;
	        });
	        obj[name] = def.value;
	      }
	    };
	  })();
	  (function checkXMLHttpRequestResponseCompatibility() {
	    if (typeof XMLHttpRequest === 'undefined') {
	      return;
	    }
	    var xhrPrototype = XMLHttpRequest.prototype;
	    var xhr = new XMLHttpRequest();
	    if (!('overrideMimeType' in xhr)) {
	      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
	        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
	      });
	    }
	    if ('responseType' in xhr) {
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'responseType', {
	      get: function xmlHttpRequestGetResponseType() {
	        return this._responseType || 'text';
	      },
	      set: function xmlHttpRequestSetResponseType(value) {
	        if (value === 'text' || value === 'arraybuffer') {
	          this._responseType = value;
	          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
	            this.overrideMimeType('text/plain; charset=x-user-defined');
	          }
	        }
	      }
	    });
	    if (typeof VBArray !== 'undefined') {
	      Object.defineProperty(xhrPrototype, 'response', {
	        get: function xmlHttpRequestResponseGet() {
	          if (this.responseType === 'arraybuffer') {
	            return new Uint8Array(new VBArray(this.responseBody).toArray());
	          }
	          return this.responseText;
	        }
	      });
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'response', {
	      get: function xmlHttpRequestResponseGet() {
	        if (this.responseType !== 'arraybuffer') {
	          return this.responseText;
	        }
	        var text = this.responseText;
	        var i,
	            n = text.length;
	        var result = new Uint8Array(n);
	        for (i = 0; i < n; ++i) {
	          result[i] = text.charCodeAt(i) & 0xFF;
	        }
	        return result.buffer;
	      }
	    });
	  })();
	  (function checkWindowBtoaCompatibility() {
	    if ('btoa' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.btoa = function (chars) {
	      var buffer = '';
	      var i, n;
	      for (i = 0, n = chars.length; i < n; i += 3) {
	        var b1 = chars.charCodeAt(i) & 0xFF;
	        var b2 = chars.charCodeAt(i + 1) & 0xFF;
	        var b3 = chars.charCodeAt(i + 2) & 0xFF;
	        var d1 = b1 >> 2,
	            d2 = (b1 & 3) << 4 | b2 >> 4;
	        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	        var d4 = i + 2 < n ? b3 & 0x3F : 64;
	        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
	      }
	      return buffer;
	    };
	  })();
	  (function checkWindowAtobCompatibility() {
	    if ('atob' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.atob = function (input) {
	      input = input.replace(/=+$/, '');
	      if (input.length % 4 === 1) {
	        throw new Error('bad atob input');
	      }
	      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	        buffer = digits.indexOf(buffer);
	      }
	      return output;
	    };
	  })();
	  (function checkFunctionPrototypeBindCompatibility() {
	    if (typeof Function.prototype.bind !== 'undefined') {
	      return;
	    }
	    Function.prototype.bind = function functionPrototypeBind(obj) {
	      var fn = this,
	          headArgs = Array.prototype.slice.call(arguments, 1);
	      var bound = function functionPrototypeBindBound() {
	        var args = headArgs.concat(Array.prototype.slice.call(arguments));
	        return fn.apply(obj, args);
	      };
	      return bound;
	    };
	  })();
	  (function checkDatasetProperty() {
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('dataset' in div) {
	      return;
	    }
	    Object.defineProperty(HTMLElement.prototype, 'dataset', {
	      get: function get() {
	        if (this._dataset) {
	          return this._dataset;
	        }
	        var dataset = {};
	        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
	          var attribute = this.attributes[j];
	          if (attribute.name.substring(0, 5) !== 'data-') {
	            continue;
	          }
	          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
	            return ch.toUpperCase();
	          });
	          dataset[key] = attribute.value;
	        }
	        Object.defineProperty(this, '_dataset', {
	          value: dataset,
	          writable: false,
	          enumerable: false
	        });
	        return dataset;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkClassListProperty() {
	    function changeList(element, itemName, add, remove) {
	      var s = element.className || '';
	      var list = s.split(/\s+/g);
	      if (list[0] === '') {
	        list.shift();
	      }
	      var index = list.indexOf(itemName);
	      if (index < 0 && add) {
	        list.push(itemName);
	      }
	      if (index >= 0 && remove) {
	        list.splice(index, 1);
	      }
	      element.className = list.join(' ');
	      return index >= 0;
	    }
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('classList' in div) {
	      return;
	    }
	    var classListPrototype = {
	      add: function add(name) {
	        changeList(this.element, name, true, false);
	      },
	      contains: function contains(name) {
	        return changeList(this.element, name, false, false);
	      },
	      remove: function remove(name) {
	        changeList(this.element, name, false, true);
	      },
	      toggle: function toggle(name) {
	        changeList(this.element, name, true, true);
	      }
	    };
	    Object.defineProperty(HTMLElement.prototype, 'classList', {
	      get: function get() {
	        if (this._classList) {
	          return this._classList;
	        }
	        var classList = Object.create(classListPrototype, {
	          element: {
	            value: this,
	            writable: false,
	            enumerable: true
	          }
	        });
	        Object.defineProperty(this, '_classList', {
	          value: classList,
	          writable: false,
	          enumerable: false
	        });
	        return classList;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkWorkerConsoleCompatibility() {
	    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
	      return;
	    }
	    var consoleTimer = {};
	    var workerConsole = {
	      log: function log() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_log',
	          data: args
	        });
	      },
	      error: function error() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_error',
	          data: args
	        });
	      },
	      time: function time(name) {
	        consoleTimer[name] = Date.now();
	      },
	      timeEnd: function timeEnd(name) {
	        var time = consoleTimer[name];
	        if (!time) {
	          throw new Error('Unknown timer name ' + name);
	        }
	        this.log('Timer:', name, Date.now() - time);
	      }
	    };
	    globalScope.console = workerConsole;
	  })();
	  (function checkConsoleCompatibility() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!('console' in window)) {
	      window.console = {
	        log: function log() {},
	        error: function error() {},
	        warn: function warn() {}
	      };
	      return;
	    }
	    if (!('bind' in console.log)) {
	      console.log = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.log);
	      console.error = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.error);
	      console.warn = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.warn);
	      return;
	    }
	  })();
	  (function checkOnClickCompatibility() {
	    function ignoreIfTargetDisabled(event) {
	      if (isDisabled(event.target)) {
	        event.stopPropagation();
	      }
	    }
	    function isDisabled(node) {
	      return node.disabled || node.parentNode && isDisabled(node.parentNode);
	    }
	    if (isOpera) {
	      document.addEventListener('click', ignoreIfTargetDisabled, true);
	    }
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkHistoryManipulation() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!history.pushState || isAndroidPre3) {
	      PDFJS.disableHistory = true;
	    }
	  })();
	  (function checkSetPresenceInImageData() {
	    if (!hasDOM) {
	      return;
	    }
	    if (window.CanvasPixelArray) {
	      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
	        window.CanvasPixelArray.prototype.set = function (arr) {
	          for (var i = 0, ii = this.length; i < ii; i++) {
	            this[i] = arr[i];
	          }
	        };
	      }
	    } else {
	      var polyfill = false,
	          versionMatch;
	      if (isChrome) {
	        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
	      } else if (isAndroid) {
	        polyfill = isAndroidPre5;
	      } else if (isSafari) {
	        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
	        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
	      }
	      if (polyfill) {
	        var contextPrototype = window.CanvasRenderingContext2D.prototype;
	        var createImageData = contextPrototype.createImageData;
	        contextPrototype.createImageData = function (w, h) {
	          var imageData = createImageData.call(this, w, h);
	          imageData.data.set = function (arr) {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	              this[i] = arr[i];
	            }
	          };
	          return imageData;
	        };
	        contextPrototype = null;
	      }
	    }
	  })();
	  (function checkRequestAnimationFrame() {
	    function installFakeAnimationFrameFunctions() {
	      window.requestAnimationFrame = function (callback) {
	        return window.setTimeout(callback, 20);
	      };
	      window.cancelAnimationFrame = function (timeoutID) {
	        window.clearTimeout(timeoutID);
	      };
	    }
	    if (!hasDOM) {
	      return;
	    }
	    if (isIOS) {
	      installFakeAnimationFrameFunctions();
	      return;
	    }
	    if ('requestAnimationFrame' in window) {
	      return;
	    }
	    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
	    if (window.requestAnimationFrame) {
	      return;
	    }
	    installFakeAnimationFrameFunctions();
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkInputTypeNumberAssign() {
	    if (!hasDOM) {
	      return;
	    }
	    var el = document.createElement('input');
	    try {
	      el.type = 'number';
	    } catch (ex) {
	      var inputProto = el.constructor.prototype;
	      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
	      Object.defineProperty(inputProto, 'type', {
	        get: function get() {
	          return typeProperty.get.call(this);
	        },
	        set: function set(value) {
	          typeProperty.set.call(this, value === 'number' ? 'text' : value);
	        },
	
	        enumerable: true,
	        configurable: true
	      });
	    }
	  })();
	  (function checkDocumentReadyState() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!document.attachEvent) {
	      return;
	    }
	    var documentProto = document.constructor.prototype;
	    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
	    Object.defineProperty(documentProto, 'readyState', {
	      get: function get() {
	        var value = readyStateProto.get.call(this);
	        return value === 'interactive' ? 'loading' : value;
	      },
	      set: function set(value) {
	        readyStateProto.set.call(this, value);
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkNumberIsNaN() {
	    if (Number.isNaN) {
	      return;
	    }
	    Number.isNaN = __w_pdfjs_require__(89);
	  })();
	  (function checkNumberIsInteger() {
	    if (Number.isInteger) {
	      return;
	    }
	    Number.isInteger = __w_pdfjs_require__(91);
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      return;
	    }
	    globalScope.Promise = __w_pdfjs_require__(94);
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    globalScope.WeakMap = __w_pdfjs_require__(104);
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(value) {
	        clear.call(this);
	        parse.call(this, value);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, value + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, value, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (value[0] === '?') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (value[0] === '#') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	          case 'blob':
	            try {
	              return new JURL(this._schemeData).origin || 'null';
	            } catch (_) {}
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	}
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(78);
	module.exports = __w_pdfjs_require__(4).Uint8ClampedArray;
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(79)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (__w_pdfjs_require__(8)) {
	  var LIBRARY = __w_pdfjs_require__(21);
	  var global = __w_pdfjs_require__(1);
	  var fails = __w_pdfjs_require__(9);
	  var $export = __w_pdfjs_require__(5);
	  var $typed = __w_pdfjs_require__(46);
	  var $buffer = __w_pdfjs_require__(80);
	  var ctx = __w_pdfjs_require__(11);
	  var anInstance = __w_pdfjs_require__(24);
	  var propertyDesc = __w_pdfjs_require__(27);
	  var hide = __w_pdfjs_require__(6);
	  var redefineAll = __w_pdfjs_require__(23);
	  var toInteger = __w_pdfjs_require__(17);
	  var toLength = __w_pdfjs_require__(12);
	  var toIndex = __w_pdfjs_require__(47);
	  var toAbsoluteIndex = __w_pdfjs_require__(29);
	  var toPrimitive = __w_pdfjs_require__(33);
	  var has = __w_pdfjs_require__(10);
	  var classof = __w_pdfjs_require__(30);
	  var isObject = __w_pdfjs_require__(2);
	  var toObject = __w_pdfjs_require__(18);
	  var isArrayIter = __w_pdfjs_require__(53);
	  var create = __w_pdfjs_require__(54);
	  var getPrototypeOf = __w_pdfjs_require__(56);
	  var gOPN = __w_pdfjs_require__(48).f;
	  var getIterFn = __w_pdfjs_require__(57);
	  var uid = __w_pdfjs_require__(16);
	  var wks = __w_pdfjs_require__(3);
	  var createArrayMethod = __w_pdfjs_require__(39);
	  var createArrayIncludes = __w_pdfjs_require__(50);
	  var speciesConstructor = __w_pdfjs_require__(40);
	  var ArrayIterators = __w_pdfjs_require__(58);
	  var Iterators = __w_pdfjs_require__(19);
	  var $iterDetect = __w_pdfjs_require__(41);
	  var setSpecies = __w_pdfjs_require__(60);
	  var arrayFill = __w_pdfjs_require__(52);
	  var arrayCopyWithin = __w_pdfjs_require__(88);
	  var $DP = __w_pdfjs_require__(13);
	  var $GOPD = __w_pdfjs_require__(61);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	  var LITTLE_ENDIAN = fails(function () {
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	  var toOffset = function toOffset(it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	  var validate = function validate(it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	  var allocate = function allocate(C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    }
	    return new C(length);
	  };
	  var speciesFromList = function speciesFromList(O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	  var fromList = function fromList(C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) {
	      result[index] = list[index++];
	    }return result;
	  };
	  var addGetter = function addGetter(it, key, internal) {
	    dP(it, key, {
	      get: function get() {
	        return this._d[internal];
	      }
	    });
	  };
	  var $from = function from(source) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      }
	      O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	  var $of = function of() {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) {
	      result[index] = arguments[index++];
	    }return result;
	  };
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
	    arrayToLocaleString.call(new Uint8Array(1));
	  });
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	  var proto = {
	    copyWithin: function copyWithin(target, start) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value) {
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) {
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement) {
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn) {
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn) {
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      }
	      return that;
	    },
	    some: function some(callbackfn) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
	    }
	  };
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	  var $set = function set(arrayLike) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) {
	      this[offset + index] = src[index++];
	    }
	  };
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	  var isTAIndex = function isTAIndex(target, key) {
	    return isObject(target) && target[TYPED_ARRAY] && (typeof key === 'undefined' ? 'undefined' : _typeof(key)) != 'symbol' && key in target && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set') && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
	      target[key] = desc.value;
	      return target;
	    }
	    return dP(target, key, desc);
	  };
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	  if (fails(function () {
	    arrayToString.call({});
	  })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function constructor() {},
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function get() {
	      return this[TYPED_ARRAY];
	    }
	  });
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function getter(that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function setter(that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function addElement(that, index) {
	      dP(that, index, {
	        get: function get() {
	          return getter(this, index);
	        },
	        set: function set(value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) {
	          addElement(that, index++);
	        }
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1);
	    }) || !$iterDetect(function (iter) {
	      new TypedArray();
	      new TypedArray(null);
	      new TypedArray(1.5);
	      new TypedArray(iter);
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function get() {
	          return NAME;
	        }
	      });
	    }
	    O[NAME] = TypedArray;
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	    $export($export.S, NAME, { BYTES_PER_ELEMENT: BYTES });
	    $export($export.S + $export.F * fails(function () {
	      Base.of.call(TypedArray, 1);
	    }), NAME, {
	      from: $from,
	      of: $of
	    });
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	    $export($export.P, NAME, proto);
	    setSpecies(NAME);
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () {};
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var DESCRIPTORS = __w_pdfjs_require__(8);
	var LIBRARY = __w_pdfjs_require__(21);
	var $typed = __w_pdfjs_require__(46);
	var hide = __w_pdfjs_require__(6);
	var redefineAll = __w_pdfjs_require__(23);
	var fails = __w_pdfjs_require__(9);
	var anInstance = __w_pdfjs_require__(24);
	var toInteger = __w_pdfjs_require__(17);
	var toLength = __w_pdfjs_require__(12);
	var toIndex = __w_pdfjs_require__(47);
	var gOPN = __w_pdfjs_require__(48).f;
	var dP = __w_pdfjs_require__(13).f;
	var arrayFill = __w_pdfjs_require__(52);
	var setToStringTag = __w_pdfjs_require__(26);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  if (value != value || value === Infinity) {
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, {
	    get: function get() {
	      return this[internal];
	    }
	  });
	}
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) {
	    store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	  }
	}
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1);
	  }) || fails(function () {
	    new $ArrayBuffer();
	    new $ArrayBuffer(1.5);
	    new $ArrayBuffer(NaN);
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var dP = __w_pdfjs_require__(13);
	var anObject = __w_pdfjs_require__(7);
	var getKeys = __w_pdfjs_require__(38);
	module.exports = __w_pdfjs_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) {
	    dP.f(O, P = keys[i++], Properties[P]);
	  }return O;
	};
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var speciesConstructor = __w_pdfjs_require__(83);
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(2);
	var isArray = __w_pdfjs_require__(84);
	var SPECIES = __w_pdfjs_require__(3)('species');
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  }
	  return C === undefined ? Array : C;
	};
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var cof = __w_pdfjs_require__(25);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var UNSCOPABLES = __w_pdfjs_require__(3)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __w_pdfjs_require__(6)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (done, value) {
	  return {
	    value: value,
	    done: !!done
	  };
	};
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var create = __w_pdfjs_require__(54);
	var descriptor = __w_pdfjs_require__(27);
	var setToStringTag = __w_pdfjs_require__(26);
	var IteratorPrototype = {};
	__w_pdfjs_require__(6)(IteratorPrototype, __w_pdfjs_require__(3)('iterator'), function () {
	  return this;
	});
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toObject = __w_pdfjs_require__(18);
	var toAbsoluteIndex = __w_pdfjs_require__(29);
	var toLength = __w_pdfjs_require__(12);
	module.exports = [].copyWithin || function copyWithin(target, start) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];else delete O[to];
	    to += inc;
	    from += inc;
	  }
	  return O;
	};
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(90);
	module.exports = __w_pdfjs_require__(4).Number.isNaN;
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(5);
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    return number != number;
	  }
	});
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(92);
	module.exports = __w_pdfjs_require__(4).Number.isInteger;
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(5);
	$export($export.S, 'Number', { isInteger: __w_pdfjs_require__(93) });
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(2);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(63);
	__w_pdfjs_require__(95);
	__w_pdfjs_require__(64);
	__w_pdfjs_require__(97);
	__w_pdfjs_require__(102);
	__w_pdfjs_require__(103);
	module.exports = __w_pdfjs_require__(4).Promise;
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $at = __w_pdfjs_require__(96)(true);
	__w_pdfjs_require__(59)(String, 'String', function (iterated) {
	  this._t = String(iterated);
	  this._i = 0;
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return {
	    value: undefined,
	    done: true
	  };
	  point = $at(O, index);
	  this._i += point.length;
	  return {
	    value: point,
	    done: false
	  };
	});
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var toInteger = __w_pdfjs_require__(17);
	var defined = __w_pdfjs_require__(35);
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var LIBRARY = __w_pdfjs_require__(21);
	var global = __w_pdfjs_require__(1);
	var ctx = __w_pdfjs_require__(11);
	var classof = __w_pdfjs_require__(30);
	var $export = __w_pdfjs_require__(5);
	var isObject = __w_pdfjs_require__(2);
	var aFunction = __w_pdfjs_require__(22);
	var anInstance = __w_pdfjs_require__(24);
	var forOf = __w_pdfjs_require__(31);
	var speciesConstructor = __w_pdfjs_require__(40);
	var task = __w_pdfjs_require__(65).set;
	var microtask = __w_pdfjs_require__(100)();
	var newPromiseCapabilityModule = __w_pdfjs_require__(42);
	var perform = __w_pdfjs_require__(66);
	var userAgent = __w_pdfjs_require__(101);
	var promiseResolve = __w_pdfjs_require__(67);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function empty() {};
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	var USE_NATIVE = !!function () {
	  try {
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__w_pdfjs_require__(3)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) {}
	}();
	var isThenable = function isThenable(it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function notify(promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function run(reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) {
	      run(chain[i++]);
	    }promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function onUnhandled(promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({
	            promise: promise,
	            reason: value
	          });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    }
	    promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function isUnhandled(promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function onHandleUnhandled(promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({
	        promise: promise,
	        reason: promise._v
	      });
	    }
	  });
	};
	var $reject = function $reject(value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise;
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function $resolve(value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise;
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = {
	          _w: promise,
	          _d: false
	        };
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({
	      _w: promise,
	      _d: false
	    }, e);
	  }
	};
	if (!USE_NATIVE) {
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor) {
	    this._c = [];
	    this._a = undefined;
	    this._s = 0;
	    this._d = false;
	    this._v = undefined;
	    this._h = 0;
	    this._n = false;
	  };
	  Internal.prototype = __w_pdfjs_require__(23)($Promise.prototype, {
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    'catch': function _catch(onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function OwnPromiseCapability() {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
	    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
	  };
	}
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__w_pdfjs_require__(26)($Promise, PROMISE);
	__w_pdfjs_require__(60)(PROMISE);
	Wrapper = __w_pdfjs_require__(4)[PROMISE];
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __w_pdfjs_require__(41)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var anObject = __w_pdfjs_require__(7);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0:
	      return un ? fn() : fn.call(that);
	    case 1:
	      return un ? fn(args[0]) : fn.call(that, args[0]);
	    case 2:
	      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
	    case 3:
	      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
	    case 4:
	      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
	  }
	  return fn.apply(that, args);
	};
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var macrotask = __w_pdfjs_require__(65).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __w_pdfjs_require__(25)(process) == 'process';
	module.exports = function () {
	  var head, last, notify;
	  var flush = function flush() {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();else last = undefined;
	        throw e;
	      }
	    }
	    last = undefined;
	    if (parent) parent.enter();
	  };
	  if (isNode) {
	    notify = function notify() {
	      process.nextTick(flush);
	    };
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true });
	    notify = function notify() {
	      node.data = toggle = !toggle;
	    };
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve(undefined);
	    notify = function notify() {
	      promise.then(flush);
	    };
	  } else {
	    notify = function notify() {
	      macrotask.call(global, flush);
	    };
	  }
	  return function (fn) {
	    var task = {
	      fn: fn,
	      next: undefined
	    };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    }
	    last = task;
	  };
	};
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var navigator = global.navigator;
	module.exports = navigator && navigator.userAgent || '';
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(5);
	var core = __w_pdfjs_require__(4);
	var global = __w_pdfjs_require__(1);
	var speciesConstructor = __w_pdfjs_require__(40);
	var promiseResolve = __w_pdfjs_require__(67);
	$export($export.P + $export.R, 'Promise', {
	  'finally': function _finally(onFinally) {
	    var C = speciesConstructor(this, core.Promise || global.Promise);
	    var isFunction = typeof onFinally == 'function';
	    return this.then(isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () {
	        return x;
	      });
	    } : onFinally, isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () {
	        throw e;
	      });
	    } : onFinally);
	  }
	});
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(5);
	var newPromiseCapability = __w_pdfjs_require__(42);
	var perform = __w_pdfjs_require__(66);
	$export($export.S, 'Promise', {
	  'try': function _try(callbackfn) {
	    var promiseCapability = newPromiseCapability.f(this);
	    var result = perform(callbackfn);
	    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	    return promiseCapability.promise;
	  }
	});
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(63);
	__w_pdfjs_require__(64);
	__w_pdfjs_require__(105);
	__w_pdfjs_require__(112);
	__w_pdfjs_require__(114);
	module.exports = __w_pdfjs_require__(4).WeakMap;
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var each = __w_pdfjs_require__(39)(0);
	var redefine = __w_pdfjs_require__(14);
	var meta = __w_pdfjs_require__(43);
	var assign = __w_pdfjs_require__(106);
	var weak = __w_pdfjs_require__(108);
	var isObject = __w_pdfjs_require__(2);
	var fails = __w_pdfjs_require__(9);
	var validate = __w_pdfjs_require__(68);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	var wrapper = function wrapper(get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	var methods = {
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	var $WeakMap = module.exports = __w_pdfjs_require__(109)(WEAK_MAP, wrapper, methods, weak, true, true);
	if (fails(function () {
	  return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
	})) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      }
	      return method.call(this, a, b);
	    });
	  });
	}
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var getKeys = __w_pdfjs_require__(38);
	var gOPS = __w_pdfjs_require__(107);
	var pIE = __w_pdfjs_require__(62);
	var toObject = __w_pdfjs_require__(18);
	var IObject = __w_pdfjs_require__(34);
	var $assign = Object.assign;
	module.exports = !$assign || __w_pdfjs_require__(9)(function () {
	  var A = {};
	  var B = {};
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) {
	    B[k] = k;
	  });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) {
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	    }
	  }
	  return T;
	} : $assign;
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	exports.f = Object.getOwnPropertySymbols;
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var redefineAll = __w_pdfjs_require__(23);
	var getWeak = __w_pdfjs_require__(43).getWeak;
	var anObject = __w_pdfjs_require__(7);
	var isObject = __w_pdfjs_require__(2);
	var anInstance = __w_pdfjs_require__(24);
	var forOf = __w_pdfjs_require__(31);
	var createArrayMethod = __w_pdfjs_require__(39);
	var $has = __w_pdfjs_require__(10);
	var validate = __w_pdfjs_require__(68);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function UncaughtFrozenStore() {
	  this.a = [];
	};
	var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function get(key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function has(key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function set(key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;else this.a.push([key, value]);
	  },
	  'delete': function _delete(key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	module.exports = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;
	      that._i = id++;
	      that._l = undefined;
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      'delete': function _delete(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var global = __w_pdfjs_require__(1);
	var $export = __w_pdfjs_require__(5);
	var redefine = __w_pdfjs_require__(14);
	var redefineAll = __w_pdfjs_require__(23);
	var meta = __w_pdfjs_require__(43);
	var forOf = __w_pdfjs_require__(31);
	var anInstance = __w_pdfjs_require__(24);
	var isObject = __w_pdfjs_require__(2);
	var fails = __w_pdfjs_require__(9);
	var $iterDetect = __w_pdfjs_require__(41);
	var setToStringTag = __w_pdfjs_require__(26);
	var inheritIfRequired = __w_pdfjs_require__(110);
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function fixMethod(KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY, KEY == 'delete' ? function (a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'has' ? function has(a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'get' ? function get(a) {
	      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'add' ? function add(a) {
	      fn.call(this, a === 0 ? 0 : a);
	      return this;
	    } : function set(a, b) {
	      fn.call(this, a === 0 ? 0 : a, b);
	      return this;
	    });
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    var THROWS_ON_PRIMITIVES = fails(function () {
	      instance.has(1);
	    });
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
	      new C(iter);
	    });
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      var $instance = new C();
	      var index = 5;
	      while (index--) {
	        $instance[ADDER](index, index);
	      }return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	  setToStringTag(C, NAME);
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	  return C;
	};
	
	/***/ }),
	/* 110 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(2);
	var setPrototypeOf = __w_pdfjs_require__(111).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  }
	  return that;
	};
	
	/***/ }),
	/* 111 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isObject = __w_pdfjs_require__(2);
	var anObject = __w_pdfjs_require__(7);
	var check = function check(O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? function (test, buggy, set) {
	    try {
	      set = __w_pdfjs_require__(11)(Function.call, __w_pdfjs_require__(61).f(Object.prototype, '__proto__').set, 2);
	      set(test, []);
	      buggy = !(test instanceof Array);
	    } catch (e) {
	      buggy = true;
	    }
	    return function setPrototypeOf(O, proto) {
	      check(O, proto);
	      if (buggy) O.__proto__ = proto;else set(O, proto);
	      return O;
	    };
	  }({}, false) : undefined),
	  check: check
	};
	
	/***/ }),
	/* 112 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(113)('WeakMap');
	
	/***/ }),
	/* 113 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(5);
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, {
	    of: function of() {
	      var length = arguments.length;
	      var A = new Array(length);
	      while (length--) {
	        A[length] = arguments[length];
	      }return new this(A);
	    }
	  });
	};
	
	/***/ }),
	/* 114 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	__w_pdfjs_require__(115)('WeakMap');
	
	/***/ }),
	/* 115 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var $export = __w_pdfjs_require__(5);
	var aFunction = __w_pdfjs_require__(22);
	var ctx = __w_pdfjs_require__(11);
	var forOf = __w_pdfjs_require__(31);
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, {
	    from: function from(source) {
	      var mapFn = arguments[1];
	      var mapping, A, n, cb;
	      aFunction(this);
	      mapping = mapFn !== undefined;
	      if (mapping) aFunction(mapFn);
	      if (source == undefined) return new this();
	      A = [];
	      if (mapping) {
	        n = 0;
	        cb = ctx(mapFn, arguments[2], 2);
	        forOf(source, false, function (nextItem) {
	          A.push(cb(nextItem, n++));
	        });
	      } else {
	        forOf(source, false, A.push, A);
	      }
	      return new this(A);
	    }
	  });
	};
	
	/***/ }),
	/* 116 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isReadableStreamSupported = false;
	if (typeof ReadableStream !== 'undefined') {
	  try {
	    new ReadableStream({
	      start: function start(controller) {
	        controller.close();
	      }
	    });
	    isReadableStreamSupported = true;
	  } catch (e) {}
	}
	if (isReadableStreamSupported) {
	  exports.ReadableStream = ReadableStream;
	} else {
	  exports.ReadableStream = __w_pdfjs_require__(117).ReadableStream;
	}
	
	/***/ }),
	/* 117 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (e, a) {
	  for (var i in a) {
	    e[i] = a[i];
	  }
	})(exports, function (modules) {
	  var installedModules = {};
	  function __w_pdfjs_require__(moduleId) {
	    if (installedModules[moduleId]) return installedModules[moduleId].exports;
	    var module = installedModules[moduleId] = {
	      i: moduleId,
	      l: false,
	      exports: {}
	    };
	    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	    module.l = true;
	    return module.exports;
	  }
	  __w_pdfjs_require__.m = modules;
	  __w_pdfjs_require__.c = installedModules;
	  __w_pdfjs_require__.i = function (value) {
	    return value;
	  };
	  __w_pdfjs_require__.d = function (exports, name, getter) {
	    if (!__w_pdfjs_require__.o(exports, name)) {
	      Object.defineProperty(exports, name, {
	        configurable: false,
	        enumerable: true,
	        get: getter
	      });
	    }
	  };
	  __w_pdfjs_require__.n = function (module) {
	    var getter = module && module.__esModule ? function getDefault() {
	      return module['default'];
	    } : function getModuleExports() {
	      return module;
	    };
	    __w_pdfjs_require__.d(getter, 'a', getter);
	    return getter;
	  };
	  __w_pdfjs_require__.o = function (object, property) {
	    return Object.prototype.hasOwnProperty.call(object, property);
	  };
	  __w_pdfjs_require__.p = "";
	  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
	}([function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	  };
	  var _require = __w_pdfjs_require__(1),
	      assert = _require.assert;
	  function IsPropertyKey(argument) {
	    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
	  }
	  exports.typeIsObject = function (x) {
	    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
	  };
	  exports.createDataProperty = function (o, p, v) {
	    assert(exports.typeIsObject(o));
	    Object.defineProperty(o, p, {
	      value: v,
	      writable: true,
	      enumerable: true,
	      configurable: true
	    });
	  };
	  exports.createArrayFromList = function (elements) {
	    return elements.slice();
	  };
	  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
	    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
	  };
	  exports.CreateIterResultObject = function (value, done) {
	    assert(typeof done === 'boolean');
	    var obj = {};
	    Object.defineProperty(obj, 'value', {
	      value: value,
	      enumerable: true,
	      writable: true,
	      configurable: true
	    });
	    Object.defineProperty(obj, 'done', {
	      value: done,
	      enumerable: true,
	      writable: true,
	      configurable: true
	    });
	    return obj;
	  };
	  exports.IsFiniteNonNegativeNumber = function (v) {
	    if (Number.isNaN(v)) {
	      return false;
	    }
	    if (v === Infinity) {
	      return false;
	    }
	    if (v < 0) {
	      return false;
	    }
	    return true;
	  };
	  function Call(F, V, args) {
	    if (typeof F !== 'function') {
	      throw new TypeError('Argument is not a function');
	    }
	    return Function.prototype.apply.call(F, V, args);
	  }
	  exports.InvokeOrNoop = function (O, P, args) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    var method = O[P];
	    if (method === undefined) {
	      return undefined;
	    }
	    return Call(method, O, args);
	  };
	  exports.PromiseInvokeOrNoop = function (O, P, args) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    try {
	      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
	    } catch (returnValueE) {
	      return Promise.reject(returnValueE);
	    }
	  };
	  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    assert(Array.isArray(argsF));
	    var method = void 0;
	    try {
	      method = O[P];
	    } catch (methodE) {
	      return Promise.reject(methodE);
	    }
	    if (method === undefined) {
	      return F.apply(null, argsF);
	    }
	    try {
	      return Promise.resolve(Call(method, O, args));
	    } catch (e) {
	      return Promise.reject(e);
	    }
	  };
	  exports.TransferArrayBuffer = function (O) {
	    return O.slice();
	  };
	  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
	    highWaterMark = Number(highWaterMark);
	    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
	      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
	    }
	    return highWaterMark;
	  };
	  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
	    if (size !== undefined && typeof size !== 'function') {
	      throw new TypeError('size property of a queuing strategy must be a function');
	    }
	    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
	    return {
	      size: size,
	      highWaterMark: highWaterMark
	    };
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  function rethrowAssertionErrorRejection(e) {
	    if (e && e.constructor === AssertionError) {
	      setTimeout(function () {
	        throw e;
	      }, 0);
	    }
	  }
	  function AssertionError(message) {
	    this.name = 'AssertionError';
	    this.message = message || '';
	    this.stack = new Error().stack;
	  }
	  AssertionError.prototype = Object.create(Error.prototype);
	  AssertionError.prototype.constructor = AssertionError;
	  function assert(value, message) {
	    if (!value) {
	      throw new AssertionError(message);
	    }
	  }
	  module.exports = {
	    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
	    AssertionError: AssertionError,
	    assert: assert
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(0),
	      InvokeOrNoop = _require.InvokeOrNoop,
	      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	      typeIsObject = _require.typeIsObject;
	  var _require2 = __w_pdfjs_require__(1),
	      assert = _require2.assert,
	      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
	  var _require3 = __w_pdfjs_require__(3),
	      DequeueValue = _require3.DequeueValue,
	      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
	      PeekQueueValue = _require3.PeekQueueValue,
	      ResetQueue = _require3.ResetQueue;
	  var WritableStream = function () {
	    function WritableStream() {
	      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          size = _ref.size,
	          _ref$highWaterMark = _ref.highWaterMark,
	          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
	      _classCallCheck(this, WritableStream);
	      this._state = 'writable';
	      this._storedError = undefined;
	      this._writer = undefined;
	      this._writableStreamController = undefined;
	      this._writeRequests = [];
	      this._inFlightWriteRequest = undefined;
	      this._closeRequest = undefined;
	      this._inFlightCloseRequest = undefined;
	      this._pendingAbortRequest = undefined;
	      this._backpressure = false;
	      var type = underlyingSink.type;
	      if (type !== undefined) {
	        throw new RangeError('Invalid type is specified');
	      }
	      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
	      this._writableStreamController.__startSteps();
	    }
	    _createClass(WritableStream, [{
	      key: 'abort',
	      value: function abort(reason) {
	        if (IsWritableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('abort'));
	        }
	        if (IsWritableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
	        }
	        return WritableStreamAbort(this, reason);
	      }
	    }, {
	      key: 'getWriter',
	      value: function getWriter() {
	        if (IsWritableStream(this) === false) {
	          throw streamBrandCheckException('getWriter');
	        }
	        return AcquireWritableStreamDefaultWriter(this);
	      }
	    }, {
	      key: 'locked',
	      get: function get() {
	        if (IsWritableStream(this) === false) {
	          throw streamBrandCheckException('locked');
	        }
	        return IsWritableStreamLocked(this);
	      }
	    }]);
	    return WritableStream;
	  }();
	  module.exports = {
	    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
	    IsWritableStream: IsWritableStream,
	    IsWritableStreamLocked: IsWritableStreamLocked,
	    WritableStream: WritableStream,
	    WritableStreamAbort: WritableStreamAbort,
	    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
	    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
	    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
	    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
	    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
	  };
	  function AcquireWritableStreamDefaultWriter(stream) {
	    return new WritableStreamDefaultWriter(stream);
	  }
	  function IsWritableStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function IsWritableStreamLocked(stream) {
	    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
	    if (stream._writer === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamAbort(stream, reason) {
	    var state = stream._state;
	    if (state === 'closed') {
	      return Promise.resolve(undefined);
	    }
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    var error = new TypeError('Requested to abort');
	    if (stream._pendingAbortRequest !== undefined) {
	      return Promise.reject(error);
	    }
	    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
	    var wasAlreadyErroring = false;
	    if (state === 'erroring') {
	      wasAlreadyErroring = true;
	      reason = undefined;
	    }
	    var promise = new Promise(function (resolve, reject) {
	      stream._pendingAbortRequest = {
	        _resolve: resolve,
	        _reject: reject,
	        _reason: reason,
	        _wasAlreadyErroring: wasAlreadyErroring
	      };
	    });
	    if (wasAlreadyErroring === false) {
	      WritableStreamStartErroring(stream, error);
	    }
	    return promise;
	  }
	  function WritableStreamAddWriteRequest(stream) {
	    assert(IsWritableStreamLocked(stream) === true);
	    assert(stream._state === 'writable');
	    var promise = new Promise(function (resolve, reject) {
	      var writeRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._writeRequests.push(writeRequest);
	    });
	    return promise;
	  }
	  function WritableStreamDealWithRejection(stream, error) {
	    var state = stream._state;
	    if (state === 'writable') {
	      WritableStreamStartErroring(stream, error);
	      return;
	    }
	    assert(state === 'erroring');
	    WritableStreamFinishErroring(stream);
	  }
	  function WritableStreamStartErroring(stream, reason) {
	    assert(stream._storedError === undefined, 'stream._storedError === undefined');
	    assert(stream._state === 'writable', 'state must be writable');
	    var controller = stream._writableStreamController;
	    assert(controller !== undefined, 'controller must not be undefined');
	    stream._state = 'erroring';
	    stream._storedError = reason;
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
	    }
	    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
	      WritableStreamFinishErroring(stream);
	    }
	  }
	  function WritableStreamFinishErroring(stream) {
	    assert(stream._state === 'erroring', 'stream._state === erroring');
	    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
	    stream._state = 'errored';
	    stream._writableStreamController.__errorSteps();
	    var storedError = stream._storedError;
	    for (var i = 0; i < stream._writeRequests.length; i++) {
	      var writeRequest = stream._writeRequests[i];
	      writeRequest._reject(storedError);
	    }
	    stream._writeRequests = [];
	    if (stream._pendingAbortRequest === undefined) {
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	      return;
	    }
	    var abortRequest = stream._pendingAbortRequest;
	    stream._pendingAbortRequest = undefined;
	    if (abortRequest._wasAlreadyErroring === true) {
	      abortRequest._reject(storedError);
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	      return;
	    }
	    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
	    promise.then(function () {
	      abortRequest._resolve();
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    }, function (reason) {
	      abortRequest._reject(reason);
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    });
	  }
	  function WritableStreamFinishInFlightWrite(stream) {
	    assert(stream._inFlightWriteRequest !== undefined);
	    stream._inFlightWriteRequest._resolve(undefined);
	    stream._inFlightWriteRequest = undefined;
	  }
	  function WritableStreamFinishInFlightWriteWithError(stream, error) {
	    assert(stream._inFlightWriteRequest !== undefined);
	    stream._inFlightWriteRequest._reject(error);
	    stream._inFlightWriteRequest = undefined;
	    assert(stream._state === 'writable' || stream._state === 'erroring');
	    WritableStreamDealWithRejection(stream, error);
	  }
	  function WritableStreamFinishInFlightClose(stream) {
	    assert(stream._inFlightCloseRequest !== undefined);
	    stream._inFlightCloseRequest._resolve(undefined);
	    stream._inFlightCloseRequest = undefined;
	    var state = stream._state;
	    assert(state === 'writable' || state === 'erroring');
	    if (state === 'erroring') {
	      stream._storedError = undefined;
	      if (stream._pendingAbortRequest !== undefined) {
	        stream._pendingAbortRequest._resolve();
	        stream._pendingAbortRequest = undefined;
	      }
	    }
	    stream._state = 'closed';
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      defaultWriterClosedPromiseResolve(writer);
	    }
	    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
	    assert(stream._storedError === undefined, 'stream._storedError === undefined');
	  }
	  function WritableStreamFinishInFlightCloseWithError(stream, error) {
	    assert(stream._inFlightCloseRequest !== undefined);
	    stream._inFlightCloseRequest._reject(error);
	    stream._inFlightCloseRequest = undefined;
	    assert(stream._state === 'writable' || stream._state === 'erroring');
	    if (stream._pendingAbortRequest !== undefined) {
	      stream._pendingAbortRequest._reject(error);
	      stream._pendingAbortRequest = undefined;
	    }
	    WritableStreamDealWithRejection(stream, error);
	  }
	  function WritableStreamCloseQueuedOrInFlight(stream) {
	    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamHasOperationMarkedInFlight(stream) {
	    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamMarkCloseRequestInFlight(stream) {
	    assert(stream._inFlightCloseRequest === undefined);
	    assert(stream._closeRequest !== undefined);
	    stream._inFlightCloseRequest = stream._closeRequest;
	    stream._closeRequest = undefined;
	  }
	  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
	    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
	    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
	    stream._inFlightWriteRequest = stream._writeRequests.shift();
	  }
	  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
	    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
	    if (stream._closeRequest !== undefined) {
	      assert(stream._inFlightCloseRequest === undefined);
	      stream._closeRequest._reject(stream._storedError);
	      stream._closeRequest = undefined;
	    }
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      defaultWriterClosedPromiseReject(writer, stream._storedError);
	      writer._closedPromise.catch(function () {});
	    }
	  }
	  function WritableStreamUpdateBackpressure(stream, backpressure) {
	    assert(stream._state === 'writable');
	    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	    var writer = stream._writer;
	    if (writer !== undefined && backpressure !== stream._backpressure) {
	      if (backpressure === true) {
	        defaultWriterReadyPromiseReset(writer);
	      } else {
	        assert(backpressure === false);
	        defaultWriterReadyPromiseResolve(writer);
	      }
	    }
	    stream._backpressure = backpressure;
	  }
	  var WritableStreamDefaultWriter = function () {
	    function WritableStreamDefaultWriter(stream) {
	      _classCallCheck(this, WritableStreamDefaultWriter);
	      if (IsWritableStream(stream) === false) {
	        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
	      }
	      if (IsWritableStreamLocked(stream) === true) {
	        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
	      }
	      this._ownerWritableStream = stream;
	      stream._writer = this;
	      var state = stream._state;
	      if (state === 'writable') {
	        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
	          defaultWriterReadyPromiseInitialize(this);
	        } else {
	          defaultWriterReadyPromiseInitializeAsResolved(this);
	        }
	        defaultWriterClosedPromiseInitialize(this);
	      } else if (state === 'erroring') {
	        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
	        this._readyPromise.catch(function () {});
	        defaultWriterClosedPromiseInitialize(this);
	      } else if (state === 'closed') {
	        defaultWriterReadyPromiseInitializeAsResolved(this);
	        defaultWriterClosedPromiseInitializeAsResolved(this);
	      } else {
	        assert(state === 'errored', 'state must be errored');
	        var storedError = stream._storedError;
	        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
	        this._readyPromise.catch(function () {});
	        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
	        this._closedPromise.catch(function () {});
	      }
	    }
	    _createClass(WritableStreamDefaultWriter, [{
	      key: 'abort',
	      value: function abort(reason) {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('abort'));
	        }
	        if (this._ownerWritableStream === undefined) {
	          return Promise.reject(defaultWriterLockException('abort'));
	        }
	        return WritableStreamDefaultWriterAbort(this, reason);
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('close'));
	        }
	        var stream = this._ownerWritableStream;
	        if (stream === undefined) {
	          return Promise.reject(defaultWriterLockException('close'));
	        }
	        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
	          return Promise.reject(new TypeError('cannot close an already-closing stream'));
	        }
	        return WritableStreamDefaultWriterClose(this);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          throw defaultWriterBrandCheckException('releaseLock');
	        }
	        var stream = this._ownerWritableStream;
	        if (stream === undefined) {
	          return;
	        }
	        assert(stream._writer !== undefined);
	        WritableStreamDefaultWriterRelease(this);
	      }
	    }, {
	      key: 'write',
	      value: function write(chunk) {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('write'));
	        }
	        if (this._ownerWritableStream === undefined) {
	          return Promise.reject(defaultWriterLockException('write to'));
	        }
	        return WritableStreamDefaultWriterWrite(this, chunk);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          throw defaultWriterBrandCheckException('desiredSize');
	        }
	        if (this._ownerWritableStream === undefined) {
	          throw defaultWriterLockException('desiredSize');
	        }
	        return WritableStreamDefaultWriterGetDesiredSize(this);
	      }
	    }, {
	      key: 'ready',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('ready'));
	        }
	        return this._readyPromise;
	      }
	    }]);
	    return WritableStreamDefaultWriter;
	  }();
	  function IsWritableStreamDefaultWriter(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamDefaultWriterAbort(writer, reason) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    return WritableStreamAbort(stream, reason);
	  }
	  function WritableStreamDefaultWriterClose(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var state = stream._state;
	    if (state === 'closed' || state === 'errored') {
	      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
	    }
	    assert(state === 'writable' || state === 'erroring');
	    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	    var promise = new Promise(function (resolve, reject) {
	      var closeRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._closeRequest = closeRequest;
	    });
	    if (stream._backpressure === true && state === 'writable') {
	      defaultWriterReadyPromiseResolve(writer);
	    }
	    WritableStreamDefaultControllerClose(stream._writableStreamController);
	    return promise;
	  }
	  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var state = stream._state;
	    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	      return Promise.resolve();
	    }
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(state === 'writable' || state === 'erroring');
	    return WritableStreamDefaultWriterClose(writer);
	  }
	  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
	    if (writer._closedPromiseState === 'pending') {
	      defaultWriterClosedPromiseReject(writer, error);
	    } else {
	      defaultWriterClosedPromiseResetToRejected(writer, error);
	    }
	    writer._closedPromise.catch(function () {});
	  }
	  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
	    if (writer._readyPromiseState === 'pending') {
	      defaultWriterReadyPromiseReject(writer, error);
	    } else {
	      defaultWriterReadyPromiseResetToRejected(writer, error);
	    }
	    writer._readyPromise.catch(function () {});
	  }
	  function WritableStreamDefaultWriterGetDesiredSize(writer) {
	    var stream = writer._ownerWritableStream;
	    var state = stream._state;
	    if (state === 'errored' || state === 'erroring') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
	  }
	  function WritableStreamDefaultWriterRelease(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    assert(stream._writer === writer);
	    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
	    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
	    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
	    stream._writer = undefined;
	    writer._ownerWritableStream = undefined;
	  }
	  function WritableStreamDefaultWriterWrite(writer, chunk) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var controller = stream._writableStreamController;
	    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
	    if (stream !== writer._ownerWritableStream) {
	      return Promise.reject(defaultWriterLockException('write to'));
	    }
	    var state = stream._state;
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
	    }
	    if (state === 'erroring') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(state === 'writable');
	    var promise = WritableStreamAddWriteRequest(stream);
	    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
	    return promise;
	  }
	  var WritableStreamDefaultController = function () {
	    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
	      _classCallCheck(this, WritableStreamDefaultController);
	      if (IsWritableStream(stream) === false) {
	        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
	      }
	      if (stream._writableStreamController !== undefined) {
	        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
	      }
	      this._controlledWritableStream = stream;
	      this._underlyingSink = underlyingSink;
	      this._queue = undefined;
	      this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._started = false;
	      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	      this._strategySize = normalizedStrategy.size;
	      this._strategyHWM = normalizedStrategy.highWaterMark;
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	    _createClass(WritableStreamDefaultController, [{
	      key: 'error',
	      value: function error(e) {
	        if (IsWritableStreamDefaultController(this) === false) {
	          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
	        }
	        var state = this._controlledWritableStream._state;
	        if (state !== 'writable') {
	          return;
	        }
	        WritableStreamDefaultControllerError(this, e);
	      }
	    }, {
	      key: '__abortSteps',
	      value: function __abortSteps(reason) {
	        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
	      }
	    }, {
	      key: '__errorSteps',
	      value: function __errorSteps() {
	        ResetQueue(this);
	      }
	    }, {
	      key: '__startSteps',
	      value: function __startSteps() {
	        var _this = this;
	        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
	        var stream = this._controlledWritableStream;
	        Promise.resolve(startResult).then(function () {
	          assert(stream._state === 'writable' || stream._state === 'erroring');
	          _this._started = true;
	          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
	        }, function (r) {
	          assert(stream._state === 'writable' || stream._state === 'erroring');
	          _this._started = true;
	          WritableStreamDealWithRejection(stream, r);
	        }).catch(rethrowAssertionErrorRejection);
	      }
	    }]);
	    return WritableStreamDefaultController;
	  }();
	  function WritableStreamDefaultControllerClose(controller) {
	    EnqueueValueWithSize(controller, 'close', 0);
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }
	  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
	    var strategySize = controller._strategySize;
	    if (strategySize === undefined) {
	      return 1;
	    }
	    try {
	      return strategySize(chunk);
	    } catch (chunkSizeE) {
	      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	      return 1;
	    }
	  }
	  function WritableStreamDefaultControllerGetDesiredSize(controller) {
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
	    var writeRecord = { chunk: chunk };
	    try {
	      EnqueueValueWithSize(controller, writeRecord, chunkSize);
	    } catch (enqueueE) {
	      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	      return;
	    }
	    var stream = controller._controlledWritableStream;
	    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }
	  function IsWritableStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
	    var stream = controller._controlledWritableStream;
	    if (controller._started === false) {
	      return;
	    }
	    if (stream._inFlightWriteRequest !== undefined) {
	      return;
	    }
	    var state = stream._state;
	    if (state === 'closed' || state === 'errored') {
	      return;
	    }
	    if (state === 'erroring') {
	      WritableStreamFinishErroring(stream);
	      return;
	    }
	    if (controller._queue.length === 0) {
	      return;
	    }
	    var writeRecord = PeekQueueValue(controller);
	    if (writeRecord === 'close') {
	      WritableStreamDefaultControllerProcessClose(controller);
	    } else {
	      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
	    }
	  }
	  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
	    if (controller._controlledWritableStream._state === 'writable') {
	      WritableStreamDefaultControllerError(controller, error);
	    }
	  }
	  function WritableStreamDefaultControllerProcessClose(controller) {
	    var stream = controller._controlledWritableStream;
	    WritableStreamMarkCloseRequestInFlight(stream);
	    DequeueValue(controller);
	    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
	    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
	    sinkClosePromise.then(function () {
	      WritableStreamFinishInFlightClose(stream);
	    }, function (reason) {
	      WritableStreamFinishInFlightCloseWithError(stream, reason);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
	    var stream = controller._controlledWritableStream;
	    WritableStreamMarkFirstWriteRequestInFlight(stream);
	    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
	    sinkWritePromise.then(function () {
	      WritableStreamFinishInFlightWrite(stream);
	      var state = stream._state;
	      assert(state === 'writable' || state === 'erroring');
	      DequeueValue(controller);
	      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
	        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	        WritableStreamUpdateBackpressure(stream, backpressure);
	      }
	      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	    }, function (reason) {
	      WritableStreamFinishInFlightWriteWithError(stream, reason);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	  function WritableStreamDefaultControllerGetBackpressure(controller) {
	    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
	    return desiredSize <= 0;
	  }
	  function WritableStreamDefaultControllerError(controller, error) {
	    var stream = controller._controlledWritableStream;
	    assert(stream._state === 'writable');
	    WritableStreamStartErroring(stream, error);
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
	  }
	  function defaultWriterBrandCheckException(name) {
	    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
	  }
	  function defaultWriterLockException(name) {
	    return new TypeError('Cannot ' + name + ' a stream using a released writer');
	  }
	  function defaultWriterClosedPromiseInitialize(writer) {
	    writer._closedPromise = new Promise(function (resolve, reject) {
	      writer._closedPromise_resolve = resolve;
	      writer._closedPromise_reject = reject;
	      writer._closedPromiseState = 'pending';
	    });
	  }
	  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
	    writer._closedPromise = Promise.reject(reason);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
	    writer._closedPromise = Promise.resolve(undefined);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'resolved';
	  }
	  function defaultWriterClosedPromiseReject(writer, reason) {
	    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	    writer._closedPromise_reject(reason);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
	    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
	    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
	    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
	    writer._closedPromise = Promise.reject(reason);
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseResolve(writer) {
	    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	    writer._closedPromise_resolve(undefined);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'resolved';
	  }
	  function defaultWriterReadyPromiseInitialize(writer) {
	    writer._readyPromise = new Promise(function (resolve, reject) {
	      writer._readyPromise_resolve = resolve;
	      writer._readyPromise_reject = reject;
	    });
	    writer._readyPromiseState = 'pending';
	  }
	  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
	    writer._readyPromise = Promise.reject(reason);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
	    writer._readyPromise = Promise.resolve(undefined);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'fulfilled';
	  }
	  function defaultWriterReadyPromiseReject(writer, reason) {
	    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	    writer._readyPromise_reject(reason);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseReset(writer) {
	    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	    writer._readyPromise = new Promise(function (resolve, reject) {
	      writer._readyPromise_resolve = resolve;
	      writer._readyPromise_reject = reject;
	    });
	    writer._readyPromiseState = 'pending';
	  }
	  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
	    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	    writer._readyPromise = Promise.reject(reason);
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseResolve(writer) {
	    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	    writer._readyPromise_resolve(undefined);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'fulfilled';
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _require = __w_pdfjs_require__(0),
	      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
	  var _require2 = __w_pdfjs_require__(1),
	      assert = _require2.assert;
	  exports.DequeueValue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
	    var pair = container._queue.shift();
	    container._queueTotalSize -= pair.size;
	    if (container._queueTotalSize < 0) {
	      container._queueTotalSize = 0;
	    }
	    return pair.value;
	  };
	  exports.EnqueueValueWithSize = function (container, value, size) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
	    size = Number(size);
	    if (!IsFiniteNonNegativeNumber(size)) {
	      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
	    }
	    container._queue.push({
	      value: value,
	      size: size
	    });
	    container._queueTotalSize += size;
	  };
	  exports.PeekQueueValue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
	    var pair = container._queue[0];
	    return pair.value;
	  };
	  exports.ResetQueue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    container._queue = [];
	    container._queueTotalSize = 0;
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(0),
	      ArrayBufferCopy = _require.ArrayBufferCopy,
	      CreateIterResultObject = _require.CreateIterResultObject,
	      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
	      InvokeOrNoop = _require.InvokeOrNoop,
	      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	      TransferArrayBuffer = _require.TransferArrayBuffer,
	      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
	  var _require2 = __w_pdfjs_require__(0),
	      createArrayFromList = _require2.createArrayFromList,
	      createDataProperty = _require2.createDataProperty,
	      typeIsObject = _require2.typeIsObject;
	  var _require3 = __w_pdfjs_require__(1),
	      assert = _require3.assert,
	      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
	  var _require4 = __w_pdfjs_require__(3),
	      DequeueValue = _require4.DequeueValue,
	      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
	      ResetQueue = _require4.ResetQueue;
	  var _require5 = __w_pdfjs_require__(2),
	      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
	      IsWritableStream = _require5.IsWritableStream,
	      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
	      WritableStreamAbort = _require5.WritableStreamAbort,
	      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
	      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
	      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
	      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
	  var ReadableStream = function () {
	    function ReadableStream() {
	      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          size = _ref.size,
	          highWaterMark = _ref.highWaterMark;
	      _classCallCheck(this, ReadableStream);
	      this._state = 'readable';
	      this._reader = undefined;
	      this._storedError = undefined;
	      this._disturbed = false;
	      this._readableStreamController = undefined;
	      var type = underlyingSource.type;
	      var typeString = String(type);
	      if (typeString === 'bytes') {
	        if (highWaterMark === undefined) {
	          highWaterMark = 0;
	        }
	        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
	      } else if (type === undefined) {
	        if (highWaterMark === undefined) {
	          highWaterMark = 1;
	        }
	        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
	      } else {
	        throw new RangeError('Invalid type is specified');
	      }
	    }
	    _createClass(ReadableStream, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (IsReadableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('cancel'));
	        }
	        if (IsReadableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
	        }
	        return ReadableStreamCancel(this, reason);
	      }
	    }, {
	      key: 'getReader',
	      value: function getReader() {
	        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            mode = _ref2.mode;
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('getReader');
	        }
	        if (mode === undefined) {
	          return AcquireReadableStreamDefaultReader(this);
	        }
	        mode = String(mode);
	        if (mode === 'byob') {
	          return AcquireReadableStreamBYOBReader(this);
	        }
	        throw new RangeError('Invalid mode is specified');
	      }
	    }, {
	      key: 'pipeThrough',
	      value: function pipeThrough(_ref3, options) {
	        var writable = _ref3.writable,
	            readable = _ref3.readable;
	        var promise = this.pipeTo(writable, options);
	        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
	        return readable;
	      }
	    }, {
	      key: 'pipeTo',
	      value: function pipeTo(dest) {
	        var _this = this;
	        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	            preventClose = _ref4.preventClose,
	            preventAbort = _ref4.preventAbort,
	            preventCancel = _ref4.preventCancel;
	        if (IsReadableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('pipeTo'));
	        }
	        if (IsWritableStream(dest) === false) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
	        }
	        preventClose = Boolean(preventClose);
	        preventAbort = Boolean(preventAbort);
	        preventCancel = Boolean(preventCancel);
	        if (IsReadableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
	        }
	        if (IsWritableStreamLocked(dest) === true) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
	        }
	        var reader = AcquireReadableStreamDefaultReader(this);
	        var writer = AcquireWritableStreamDefaultWriter(dest);
	        var shuttingDown = false;
	        var currentWrite = Promise.resolve();
	        return new Promise(function (resolve, reject) {
	          function pipeLoop() {
	            currentWrite = Promise.resolve();
	            if (shuttingDown === true) {
	              return Promise.resolve();
	            }
	            return writer._readyPromise.then(function () {
	              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
	                var value = _ref5.value,
	                    done = _ref5.done;
	                if (done === true) {
	                  return;
	                }
	                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
	              });
	            }).then(pipeLoop);
	          }
	          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
	            if (preventAbort === false) {
	              shutdownWithAction(function () {
	                return WritableStreamAbort(dest, storedError);
	              }, true, storedError);
	            } else {
	              shutdown(true, storedError);
	            }
	          });
	          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
	            if (preventCancel === false) {
	              shutdownWithAction(function () {
	                return ReadableStreamCancel(_this, storedError);
	              }, true, storedError);
	            } else {
	              shutdown(true, storedError);
	            }
	          });
	          isOrBecomesClosed(_this, reader._closedPromise, function () {
	            if (preventClose === false) {
	              shutdownWithAction(function () {
	                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
	              });
	            } else {
	              shutdown();
	            }
	          });
	          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
	            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
	            if (preventCancel === false) {
	              shutdownWithAction(function () {
	                return ReadableStreamCancel(_this, destClosed);
	              }, true, destClosed);
	            } else {
	              shutdown(true, destClosed);
	            }
	          }
	          pipeLoop().catch(function (err) {
	            currentWrite = Promise.resolve();
	            rethrowAssertionErrorRejection(err);
	          });
	          function waitForWritesToFinish() {
	            var oldCurrentWrite = currentWrite;
	            return currentWrite.then(function () {
	              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
	            });
	          }
	          function isOrBecomesErrored(stream, promise, action) {
	            if (stream._state === 'errored') {
	              action(stream._storedError);
	            } else {
	              promise.catch(action).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function isOrBecomesClosed(stream, promise, action) {
	            if (stream._state === 'closed') {
	              action();
	            } else {
	              promise.then(action).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function shutdownWithAction(action, originalIsError, originalError) {
	            if (shuttingDown === true) {
	              return;
	            }
	            shuttingDown = true;
	            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	              waitForWritesToFinish().then(doTheRest);
	            } else {
	              doTheRest();
	            }
	            function doTheRest() {
	              action().then(function () {
	                return finalize(originalIsError, originalError);
	              }, function (newError) {
	                return finalize(true, newError);
	              }).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function shutdown(isError, error) {
	            if (shuttingDown === true) {
	              return;
	            }
	            shuttingDown = true;
	            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	              waitForWritesToFinish().then(function () {
	                return finalize(isError, error);
	              }).catch(rethrowAssertionErrorRejection);
	            } else {
	              finalize(isError, error);
	            }
	          }
	          function finalize(isError, error) {
	            WritableStreamDefaultWriterRelease(writer);
	            ReadableStreamReaderGenericRelease(reader);
	            if (isError) {
	              reject(error);
	            } else {
	              resolve(undefined);
	            }
	          }
	        });
	      }
	    }, {
	      key: 'tee',
	      value: function tee() {
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('tee');
	        }
	        var branches = ReadableStreamTee(this, false);
	        return createArrayFromList(branches);
	      }
	    }, {
	      key: 'locked',
	      get: function get() {
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('locked');
	        }
	        return IsReadableStreamLocked(this);
	      }
	    }]);
	    return ReadableStream;
	  }();
	  module.exports = {
	    ReadableStream: ReadableStream,
	    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
	    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
	    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
	    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
	    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
	  };
	  function AcquireReadableStreamBYOBReader(stream) {
	    return new ReadableStreamBYOBReader(stream);
	  }
	  function AcquireReadableStreamDefaultReader(stream) {
	    return new ReadableStreamDefaultReader(stream);
	  }
	  function IsReadableStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamDisturbed(stream) {
	    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
	    return stream._disturbed;
	  }
	  function IsReadableStreamLocked(stream) {
	    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
	    if (stream._reader === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamTee(stream, cloneForBranch2) {
	    assert(IsReadableStream(stream) === true);
	    assert(typeof cloneForBranch2 === 'boolean');
	    var reader = AcquireReadableStreamDefaultReader(stream);
	    var teeState = {
	      closedOrErrored: false,
	      canceled1: false,
	      canceled2: false,
	      reason1: undefined,
	      reason2: undefined
	    };
	    teeState.promise = new Promise(function (resolve) {
	      teeState._resolve = resolve;
	    });
	    var pull = create_ReadableStreamTeePullFunction();
	    pull._reader = reader;
	    pull._teeState = teeState;
	    pull._cloneForBranch2 = cloneForBranch2;
	    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
	    cancel1._stream = stream;
	    cancel1._teeState = teeState;
	    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
	    cancel2._stream = stream;
	    cancel2._teeState = teeState;
	    var underlyingSource1 = Object.create(Object.prototype);
	    createDataProperty(underlyingSource1, 'pull', pull);
	    createDataProperty(underlyingSource1, 'cancel', cancel1);
	    var branch1Stream = new ReadableStream(underlyingSource1);
	    var underlyingSource2 = Object.create(Object.prototype);
	    createDataProperty(underlyingSource2, 'pull', pull);
	    createDataProperty(underlyingSource2, 'cancel', cancel2);
	    var branch2Stream = new ReadableStream(underlyingSource2);
	    pull._branch1 = branch1Stream._readableStreamController;
	    pull._branch2 = branch2Stream._readableStreamController;
	    reader._closedPromise.catch(function (r) {
	      if (teeState.closedOrErrored === true) {
	        return;
	      }
	      ReadableStreamDefaultControllerError(pull._branch1, r);
	      ReadableStreamDefaultControllerError(pull._branch2, r);
	      teeState.closedOrErrored = true;
	    });
	    return [branch1Stream, branch2Stream];
	  }
	  function create_ReadableStreamTeePullFunction() {
	    function f() {
	      var reader = f._reader,
	          branch1 = f._branch1,
	          branch2 = f._branch2,
	          teeState = f._teeState;
	      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
	        assert(typeIsObject(result));
	        var value = result.value;
	        var done = result.done;
	        assert(typeof done === 'boolean');
	        if (done === true && teeState.closedOrErrored === false) {
	          if (teeState.canceled1 === false) {
	            ReadableStreamDefaultControllerClose(branch1);
	          }
	          if (teeState.canceled2 === false) {
	            ReadableStreamDefaultControllerClose(branch2);
	          }
	          teeState.closedOrErrored = true;
	        }
	        if (teeState.closedOrErrored === true) {
	          return;
	        }
	        var value1 = value;
	        var value2 = value;
	        if (teeState.canceled1 === false) {
	          ReadableStreamDefaultControllerEnqueue(branch1, value1);
	        }
	        if (teeState.canceled2 === false) {
	          ReadableStreamDefaultControllerEnqueue(branch2, value2);
	        }
	      });
	    }
	    return f;
	  }
	  function create_ReadableStreamTeeBranch1CancelFunction() {
	    function f(reason) {
	      var stream = f._stream,
	          teeState = f._teeState;
	      teeState.canceled1 = true;
	      teeState.reason1 = reason;
	      if (teeState.canceled2 === true) {
	        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	        var cancelResult = ReadableStreamCancel(stream, compositeReason);
	        teeState._resolve(cancelResult);
	      }
	      return teeState.promise;
	    }
	    return f;
	  }
	  function create_ReadableStreamTeeBranch2CancelFunction() {
	    function f(reason) {
	      var stream = f._stream,
	          teeState = f._teeState;
	      teeState.canceled2 = true;
	      teeState.reason2 = reason;
	      if (teeState.canceled1 === true) {
	        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	        var cancelResult = ReadableStreamCancel(stream, compositeReason);
	        teeState._resolve(cancelResult);
	      }
	      return teeState.promise;
	    }
	    return f;
	  }
	  function ReadableStreamAddReadIntoRequest(stream) {
	    assert(IsReadableStreamBYOBReader(stream._reader) === true);
	    assert(stream._state === 'readable' || stream._state === 'closed');
	    var promise = new Promise(function (resolve, reject) {
	      var readIntoRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._reader._readIntoRequests.push(readIntoRequest);
	    });
	    return promise;
	  }
	  function ReadableStreamAddReadRequest(stream) {
	    assert(IsReadableStreamDefaultReader(stream._reader) === true);
	    assert(stream._state === 'readable');
	    var promise = new Promise(function (resolve, reject) {
	      var readRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._reader._readRequests.push(readRequest);
	    });
	    return promise;
	  }
	  function ReadableStreamCancel(stream, reason) {
	    stream._disturbed = true;
	    if (stream._state === 'closed') {
	      return Promise.resolve(undefined);
	    }
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    ReadableStreamClose(stream);
	    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
	    return sourceCancelPromise.then(function () {
	      return undefined;
	    });
	  }
	  function ReadableStreamClose(stream) {
	    assert(stream._state === 'readable');
	    stream._state = 'closed';
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return undefined;
	    }
	    if (IsReadableStreamDefaultReader(reader) === true) {
	      for (var i = 0; i < reader._readRequests.length; i++) {
	        var _resolve = reader._readRequests[i]._resolve;
	        _resolve(CreateIterResultObject(undefined, true));
	      }
	      reader._readRequests = [];
	    }
	    defaultReaderClosedPromiseResolve(reader);
	    return undefined;
	  }
	  function ReadableStreamError(stream, e) {
	    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
	    assert(stream._state === 'readable', 'state must be readable');
	    stream._state = 'errored';
	    stream._storedError = e;
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return undefined;
	    }
	    if (IsReadableStreamDefaultReader(reader) === true) {
	      for (var i = 0; i < reader._readRequests.length; i++) {
	        var readRequest = reader._readRequests[i];
	        readRequest._reject(e);
	      }
	      reader._readRequests = [];
	    } else {
	      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
	      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
	        var readIntoRequest = reader._readIntoRequests[_i];
	        readIntoRequest._reject(e);
	      }
	      reader._readIntoRequests = [];
	    }
	    defaultReaderClosedPromiseReject(reader, e);
	    reader._closedPromise.catch(function () {});
	  }
	  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
	    var reader = stream._reader;
	    assert(reader._readIntoRequests.length > 0);
	    var readIntoRequest = reader._readIntoRequests.shift();
	    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
	  }
	  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
	    var reader = stream._reader;
	    assert(reader._readRequests.length > 0);
	    var readRequest = reader._readRequests.shift();
	    readRequest._resolve(CreateIterResultObject(chunk, done));
	  }
	  function ReadableStreamGetNumReadIntoRequests(stream) {
	    return stream._reader._readIntoRequests.length;
	  }
	  function ReadableStreamGetNumReadRequests(stream) {
	    return stream._reader._readRequests.length;
	  }
	  function ReadableStreamHasBYOBReader(stream) {
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return false;
	    }
	    if (IsReadableStreamBYOBReader(reader) === false) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamHasDefaultReader(stream) {
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return false;
	    }
	    if (IsReadableStreamDefaultReader(reader) === false) {
	      return false;
	    }
	    return true;
	  }
	  var ReadableStreamDefaultReader = function () {
	    function ReadableStreamDefaultReader(stream) {
	      _classCallCheck(this, ReadableStreamDefaultReader);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
	      }
	      if (IsReadableStreamLocked(stream) === true) {
	        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	      }
	      ReadableStreamReaderGenericInitialize(this, stream);
	      this._readRequests = [];
	    }
	    _createClass(ReadableStreamDefaultReader, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('cancel'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('cancel'));
	        }
	        return ReadableStreamReaderGenericCancel(this, reason);
	      }
	    }, {
	      key: 'read',
	      value: function read() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('read'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('read from'));
	        }
	        return ReadableStreamDefaultReaderRead(this);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          throw defaultReaderBrandCheckException('releaseLock');
	        }
	        if (this._ownerReadableStream === undefined) {
	          return;
	        }
	        if (this._readRequests.length > 0) {
	          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	        }
	        ReadableStreamReaderGenericRelease(this);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }]);
	    return ReadableStreamDefaultReader;
	  }();
	  var ReadableStreamBYOBReader = function () {
	    function ReadableStreamBYOBReader(stream) {
	      _classCallCheck(this, ReadableStreamBYOBReader);
	      if (!IsReadableStream(stream)) {
	        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
	      }
	      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
	        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
	      }
	      if (IsReadableStreamLocked(stream)) {
	        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	      }
	      ReadableStreamReaderGenericInitialize(this, stream);
	      this._readIntoRequests = [];
	    }
	    _createClass(ReadableStreamBYOBReader, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('cancel'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('cancel'));
	        }
	        return ReadableStreamReaderGenericCancel(this, reason);
	      }
	    }, {
	      key: 'read',
	      value: function read(view) {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('read'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('read from'));
	        }
	        if (!ArrayBuffer.isView(view)) {
	          return Promise.reject(new TypeError('view must be an array buffer view'));
	        }
	        if (view.byteLength === 0) {
	          return Promise.reject(new TypeError('view must have non-zero byteLength'));
	        }
	        return ReadableStreamBYOBReaderRead(this, view);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (!IsReadableStreamBYOBReader(this)) {
	          throw byobReaderBrandCheckException('releaseLock');
	        }
	        if (this._ownerReadableStream === undefined) {
	          return;
	        }
	        if (this._readIntoRequests.length > 0) {
	          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	        }
	        ReadableStreamReaderGenericRelease(this);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }]);
	    return ReadableStreamBYOBReader;
	  }();
	  function IsReadableStreamBYOBReader(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamDefaultReader(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamReaderGenericInitialize(reader, stream) {
	    reader._ownerReadableStream = stream;
	    stream._reader = reader;
	    if (stream._state === 'readable') {
	      defaultReaderClosedPromiseInitialize(reader);
	    } else if (stream._state === 'closed') {
	      defaultReaderClosedPromiseInitializeAsResolved(reader);
	    } else {
	      assert(stream._state === 'errored', 'state must be errored');
	      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
	      reader._closedPromise.catch(function () {});
	    }
	  }
	  function ReadableStreamReaderGenericCancel(reader, reason) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    return ReadableStreamCancel(stream, reason);
	  }
	  function ReadableStreamReaderGenericRelease(reader) {
	    assert(reader._ownerReadableStream !== undefined);
	    assert(reader._ownerReadableStream._reader === reader);
	    if (reader._ownerReadableStream._state === 'readable') {
	      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	    } else {
	      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	    }
	    reader._closedPromise.catch(function () {});
	    reader._ownerReadableStream._reader = undefined;
	    reader._ownerReadableStream = undefined;
	  }
	  function ReadableStreamBYOBReaderRead(reader, view) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    stream._disturbed = true;
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
	  }
	  function ReadableStreamDefaultReaderRead(reader) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    stream._disturbed = true;
	    if (stream._state === 'closed') {
	      return Promise.resolve(CreateIterResultObject(undefined, true));
	    }
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(stream._state === 'readable');
	    return stream._readableStreamController.__pullSteps();
	  }
	  var ReadableStreamDefaultController = function () {
	    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
	      _classCallCheck(this, ReadableStreamDefaultController);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
	      }
	      if (stream._readableStreamController !== undefined) {
	        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
	      }
	      this._controlledReadableStream = stream;
	      this._underlyingSource = underlyingSource;
	      this._queue = undefined;
	      this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._started = false;
	      this._closeRequested = false;
	      this._pullAgain = false;
	      this._pulling = false;
	      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	      this._strategySize = normalizedStrategy.size;
	      this._strategyHWM = normalizedStrategy.highWaterMark;
	      var controller = this;
	      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
	      Promise.resolve(startResult).then(function () {
	        controller._started = true;
	        assert(controller._pulling === false);
	        assert(controller._pullAgain === false);
	        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	      }, function (r) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
	      }).catch(rethrowAssertionErrorRejection);
	    }
	    _createClass(ReadableStreamDefaultController, [{
	      key: 'close',
	      value: function close() {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('close');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('The stream has already been closed; do not close it again!');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	        }
	        ReadableStreamDefaultControllerClose(this);
	      }
	    }, {
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('enqueue');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('stream is closed or draining');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	        }
	        return ReadableStreamDefaultControllerEnqueue(this, chunk);
	      }
	    }, {
	      key: 'error',
	      value: function error(e) {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('error');
	        }
	        var stream = this._controlledReadableStream;
	        if (stream._state !== 'readable') {
	          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	        }
	        ReadableStreamDefaultControllerError(this, e);
	      }
	    }, {
	      key: '__cancelSteps',
	      value: function __cancelSteps(reason) {
	        ResetQueue(this);
	        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
	      }
	    }, {
	      key: '__pullSteps',
	      value: function __pullSteps() {
	        var stream = this._controlledReadableStream;
	        if (this._queue.length > 0) {
	          var chunk = DequeueValue(this);
	          if (this._closeRequested === true && this._queue.length === 0) {
	            ReadableStreamClose(stream);
	          } else {
	            ReadableStreamDefaultControllerCallPullIfNeeded(this);
	          }
	          return Promise.resolve(CreateIterResultObject(chunk, false));
	        }
	        var pendingPromise = ReadableStreamAddReadRequest(stream);
	        ReadableStreamDefaultControllerCallPullIfNeeded(this);
	        return pendingPromise;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('desiredSize');
	        }
	        return ReadableStreamDefaultControllerGetDesiredSize(this);
	      }
	    }]);
	    return ReadableStreamDefaultController;
	  }();
	  function IsReadableStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
	    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
	    if (shouldPull === false) {
	      return undefined;
	    }
	    if (controller._pulling === true) {
	      controller._pullAgain = true;
	      return undefined;
	    }
	    assert(controller._pullAgain === false);
	    controller._pulling = true;
	    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
	    pullPromise.then(function () {
	      controller._pulling = false;
	      if (controller._pullAgain === true) {
	        controller._pullAgain = false;
	        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	      }
	      return undefined;
	    }, function (e) {
	      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
	    }).catch(rethrowAssertionErrorRejection);
	    return undefined;
	  }
	  function ReadableStreamDefaultControllerShouldCallPull(controller) {
	    var stream = controller._controlledReadableStream;
	    if (stream._state === 'closed' || stream._state === 'errored') {
	      return false;
	    }
	    if (controller._closeRequested === true) {
	      return false;
	    }
	    if (controller._started === false) {
	      return false;
	    }
	    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      return true;
	    }
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	    if (desiredSize > 0) {
	      return true;
	    }
	    return false;
	  }
	  function ReadableStreamDefaultControllerClose(controller) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    controller._closeRequested = true;
	    if (controller._queue.length === 0) {
	      ReadableStreamClose(stream);
	    }
	  }
	  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      ReadableStreamFulfillReadRequest(stream, chunk, false);
	    } else {
	      var chunkSize = 1;
	      if (controller._strategySize !== undefined) {
	        var strategySize = controller._strategySize;
	        try {
	          chunkSize = strategySize(chunk);
	        } catch (chunkSizeE) {
	          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	          throw chunkSizeE;
	        }
	      }
	      try {
	        EnqueueValueWithSize(controller, chunk, chunkSize);
	      } catch (enqueueE) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	        throw enqueueE;
	      }
	    }
	    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	    return undefined;
	  }
	  function ReadableStreamDefaultControllerError(controller, e) {
	    var stream = controller._controlledReadableStream;
	    assert(stream._state === 'readable');
	    ResetQueue(controller);
	    ReadableStreamError(stream, e);
	  }
	  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
	    if (controller._controlledReadableStream._state === 'readable') {
	      ReadableStreamDefaultControllerError(controller, e);
	    }
	  }
	  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
	    var stream = controller._controlledReadableStream;
	    var state = stream._state;
	    if (state === 'errored') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  var ReadableStreamBYOBRequest = function () {
	    function ReadableStreamBYOBRequest(controller, view) {
	      _classCallCheck(this, ReadableStreamBYOBRequest);
	      this._associatedReadableByteStreamController = controller;
	      this._view = view;
	    }
	    _createClass(ReadableStreamBYOBRequest, [{
	      key: 'respond',
	      value: function respond(bytesWritten) {
	        if (IsReadableStreamBYOBRequest(this) === false) {
	          throw byobRequestBrandCheckException('respond');
	        }
	        if (this._associatedReadableByteStreamController === undefined) {
	          throw new TypeError('This BYOB request has been invalidated');
	        }
	        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
	      }
	    }, {
	      key: 'respondWithNewView',
	      value: function respondWithNewView(view) {
	        if (IsReadableStreamBYOBRequest(this) === false) {
	          throw byobRequestBrandCheckException('respond');
	        }
	        if (this._associatedReadableByteStreamController === undefined) {
	          throw new TypeError('This BYOB request has been invalidated');
	        }
	        if (!ArrayBuffer.isView(view)) {
	          throw new TypeError('You can only respond with array buffer views');
	        }
	        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
	      }
	    }, {
	      key: 'view',
	      get: function get() {
	        return this._view;
	      }
	    }]);
	    return ReadableStreamBYOBRequest;
	  }();
	  var ReadableByteStreamController = function () {
	    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
	      _classCallCheck(this, ReadableByteStreamController);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
	      }
	      if (stream._readableStreamController !== undefined) {
	        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
	      }
	      this._controlledReadableStream = stream;
	      this._underlyingByteSource = underlyingByteSource;
	      this._pullAgain = false;
	      this._pulling = false;
	      ReadableByteStreamControllerClearPendingPullIntos(this);
	      this._queue = this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._closeRequested = false;
	      this._started = false;
	      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
	      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
	      if (autoAllocateChunkSize !== undefined) {
	        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
	          throw new RangeError('autoAllocateChunkSize must be a positive integer');
	        }
	      }
	      this._autoAllocateChunkSize = autoAllocateChunkSize;
	      this._pendingPullIntos = [];
	      var controller = this;
	      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
	      Promise.resolve(startResult).then(function () {
	        controller._started = true;
	        assert(controller._pulling === false);
	        assert(controller._pullAgain === false);
	        ReadableByteStreamControllerCallPullIfNeeded(controller);
	      }, function (r) {
	        if (stream._state === 'readable') {
	          ReadableByteStreamControllerError(controller, r);
	        }
	      }).catch(rethrowAssertionErrorRejection);
	    }
	    _createClass(ReadableByteStreamController, [{
	      key: 'close',
	      value: function close() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('close');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('The stream has already been closed; do not close it again!');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	        }
	        ReadableByteStreamControllerClose(this);
	      }
	    }, {
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('enqueue');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('stream is closed or draining');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	        }
	        if (!ArrayBuffer.isView(chunk)) {
	          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
	        }
	        ReadableByteStreamControllerEnqueue(this, chunk);
	      }
	    }, {
	      key: 'error',
	      value: function error(e) {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('error');
	        }
	        var stream = this._controlledReadableStream;
	        if (stream._state !== 'readable') {
	          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	        }
	        ReadableByteStreamControllerError(this, e);
	      }
	    }, {
	      key: '__cancelSteps',
	      value: function __cancelSteps(reason) {
	        if (this._pendingPullIntos.length > 0) {
	          var firstDescriptor = this._pendingPullIntos[0];
	          firstDescriptor.bytesFilled = 0;
	        }
	        ResetQueue(this);
	        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
	      }
	    }, {
	      key: '__pullSteps',
	      value: function __pullSteps() {
	        var stream = this._controlledReadableStream;
	        assert(ReadableStreamHasDefaultReader(stream) === true);
	        if (this._queueTotalSize > 0) {
	          assert(ReadableStreamGetNumReadRequests(stream) === 0);
	          var entry = this._queue.shift();
	          this._queueTotalSize -= entry.byteLength;
	          ReadableByteStreamControllerHandleQueueDrain(this);
	          var view = void 0;
	          try {
	            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
	          } catch (viewE) {
	            return Promise.reject(viewE);
	          }
	          return Promise.resolve(CreateIterResultObject(view, false));
	        }
	        var autoAllocateChunkSize = this._autoAllocateChunkSize;
	        if (autoAllocateChunkSize !== undefined) {
	          var buffer = void 0;
	          try {
	            buffer = new ArrayBuffer(autoAllocateChunkSize);
	          } catch (bufferE) {
	            return Promise.reject(bufferE);
	          }
	          var pullIntoDescriptor = {
	            buffer: buffer,
	            byteOffset: 0,
	            byteLength: autoAllocateChunkSize,
	            bytesFilled: 0,
	            elementSize: 1,
	            ctor: Uint8Array,
	            readerType: 'default'
	          };
	          this._pendingPullIntos.push(pullIntoDescriptor);
	        }
	        var promise = ReadableStreamAddReadRequest(stream);
	        ReadableByteStreamControllerCallPullIfNeeded(this);
	        return promise;
	      }
	    }, {
	      key: 'byobRequest',
	      get: function get() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('byobRequest');
	        }
	        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
	          var firstDescriptor = this._pendingPullIntos[0];
	          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
	          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
	        }
	        return this._byobRequest;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('desiredSize');
	        }
	        return ReadableByteStreamControllerGetDesiredSize(this);
	      }
	    }]);
	    return ReadableByteStreamController;
	  }();
	  function IsReadableByteStreamController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamBYOBRequest(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
	    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
	    if (shouldPull === false) {
	      return undefined;
	    }
	    if (controller._pulling === true) {
	      controller._pullAgain = true;
	      return undefined;
	    }
	    assert(controller._pullAgain === false);
	    controller._pulling = true;
	    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
	    pullPromise.then(function () {
	      controller._pulling = false;
	      if (controller._pullAgain === true) {
	        controller._pullAgain = false;
	        ReadableByteStreamControllerCallPullIfNeeded(controller);
	      }
	    }, function (e) {
	      if (controller._controlledReadableStream._state === 'readable') {
	        ReadableByteStreamControllerError(controller, e);
	      }
	    }).catch(rethrowAssertionErrorRejection);
	    return undefined;
	  }
	  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    controller._pendingPullIntos = [];
	  }
	  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
	    assert(stream._state !== 'errored', 'state must not be errored');
	    var done = false;
	    if (stream._state === 'closed') {
	      assert(pullIntoDescriptor.bytesFilled === 0);
	      done = true;
	    }
	    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	    if (pullIntoDescriptor.readerType === 'default') {
	      ReadableStreamFulfillReadRequest(stream, filledView, done);
	    } else {
	      assert(pullIntoDescriptor.readerType === 'byob');
	      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
	    }
	  }
	  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
	    var bytesFilled = pullIntoDescriptor.bytesFilled;
	    var elementSize = pullIntoDescriptor.elementSize;
	    assert(bytesFilled <= pullIntoDescriptor.byteLength);
	    assert(bytesFilled % elementSize === 0);
	    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
	  }
	  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
	    controller._queue.push({
	      buffer: buffer,
	      byteOffset: byteOffset,
	      byteLength: byteLength
	    });
	    controller._queueTotalSize += byteLength;
	  }
	  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
	    var elementSize = pullIntoDescriptor.elementSize;
	    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
	    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
	    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
	    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
	    var totalBytesToCopyRemaining = maxBytesToCopy;
	    var ready = false;
	    if (maxAlignedBytes > currentAlignedBytes) {
	      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
	      ready = true;
	    }
	    var queue = controller._queue;
	    while (totalBytesToCopyRemaining > 0) {
	      var headOfQueue = queue[0];
	      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
	      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
	      if (headOfQueue.byteLength === bytesToCopy) {
	        queue.shift();
	      } else {
	        headOfQueue.byteOffset += bytesToCopy;
	        headOfQueue.byteLength -= bytesToCopy;
	      }
	      controller._queueTotalSize -= bytesToCopy;
	      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
	      totalBytesToCopyRemaining -= bytesToCopy;
	    }
	    if (ready === false) {
	      assert(controller._queueTotalSize === 0, 'queue must be empty');
	      assert(pullIntoDescriptor.bytesFilled > 0);
	      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
	    }
	    return ready;
	  }
	  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
	    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    pullIntoDescriptor.bytesFilled += size;
	  }
	  function ReadableByteStreamControllerHandleQueueDrain(controller) {
	    assert(controller._controlledReadableStream._state === 'readable');
	    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
	      ReadableStreamClose(controller._controlledReadableStream);
	    } else {
	      ReadableByteStreamControllerCallPullIfNeeded(controller);
	    }
	  }
	  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
	    if (controller._byobRequest === undefined) {
	      return;
	    }
	    controller._byobRequest._associatedReadableByteStreamController = undefined;
	    controller._byobRequest._view = undefined;
	    controller._byobRequest = undefined;
	  }
	  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
	    assert(controller._closeRequested === false);
	    while (controller._pendingPullIntos.length > 0) {
	      if (controller._queueTotalSize === 0) {
	        return;
	      }
	      var pullIntoDescriptor = controller._pendingPullIntos[0];
	      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	        ReadableByteStreamControllerShiftPendingPullInto(controller);
	        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	      }
	    }
	  }
	  function ReadableByteStreamControllerPullInto(controller, view) {
	    var stream = controller._controlledReadableStream;
	    var elementSize = 1;
	    if (view.constructor !== DataView) {
	      elementSize = view.constructor.BYTES_PER_ELEMENT;
	    }
	    var ctor = view.constructor;
	    var pullIntoDescriptor = {
	      buffer: view.buffer,
	      byteOffset: view.byteOffset,
	      byteLength: view.byteLength,
	      bytesFilled: 0,
	      elementSize: elementSize,
	      ctor: ctor,
	      readerType: 'byob'
	    };
	    if (controller._pendingPullIntos.length > 0) {
	      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	      controller._pendingPullIntos.push(pullIntoDescriptor);
	      return ReadableStreamAddReadIntoRequest(stream);
	    }
	    if (stream._state === 'closed') {
	      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
	      return Promise.resolve(CreateIterResultObject(emptyView, true));
	    }
	    if (controller._queueTotalSize > 0) {
	      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	        ReadableByteStreamControllerHandleQueueDrain(controller);
	        return Promise.resolve(CreateIterResultObject(filledView, false));
	      }
	      if (controller._closeRequested === true) {
	        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	        ReadableByteStreamControllerError(controller, e);
	        return Promise.reject(e);
	      }
	    }
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    controller._pendingPullIntos.push(pullIntoDescriptor);
	    var promise = ReadableStreamAddReadIntoRequest(stream);
	    ReadableByteStreamControllerCallPullIfNeeded(controller);
	    return promise;
	  }
	  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
	    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
	    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
	    var stream = controller._controlledReadableStream;
	    if (ReadableStreamHasBYOBReader(stream) === true) {
	      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
	        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
	      }
	    }
	  }
	  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
	    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
	      throw new RangeError('bytesWritten out of range');
	    }
	    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
	    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
	      return;
	    }
	    ReadableByteStreamControllerShiftPendingPullInto(controller);
	    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
	    if (remainderSize > 0) {
	      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
	    }
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    pullIntoDescriptor.bytesFilled -= remainderSize;
	    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	  }
	  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
	    var firstDescriptor = controller._pendingPullIntos[0];
	    var stream = controller._controlledReadableStream;
	    if (stream._state === 'closed') {
	      if (bytesWritten !== 0) {
	        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
	      }
	      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
	    } else {
	      assert(stream._state === 'readable');
	      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
	    }
	  }
	  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
	    var descriptor = controller._pendingPullIntos.shift();
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    return descriptor;
	  }
	  function ReadableByteStreamControllerShouldCallPull(controller) {
	    var stream = controller._controlledReadableStream;
	    if (stream._state !== 'readable') {
	      return false;
	    }
	    if (controller._closeRequested === true) {
	      return false;
	    }
	    if (controller._started === false) {
	      return false;
	    }
	    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      return true;
	    }
	    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	      return true;
	    }
	    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
	      return true;
	    }
	    return false;
	  }
	  function ReadableByteStreamControllerClose(controller) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    if (controller._queueTotalSize > 0) {
	      controller._closeRequested = true;
	      return;
	    }
	    if (controller._pendingPullIntos.length > 0) {
	      var firstPendingPullInto = controller._pendingPullIntos[0];
	      if (firstPendingPullInto.bytesFilled > 0) {
	        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	        ReadableByteStreamControllerError(controller, e);
	        throw e;
	      }
	    }
	    ReadableStreamClose(stream);
	  }
	  function ReadableByteStreamControllerEnqueue(controller, chunk) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    var buffer = chunk.buffer;
	    var byteOffset = chunk.byteOffset;
	    var byteLength = chunk.byteLength;
	    var transferredBuffer = TransferArrayBuffer(buffer);
	    if (ReadableStreamHasDefaultReader(stream) === true) {
	      if (ReadableStreamGetNumReadRequests(stream) === 0) {
	        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	      } else {
	        assert(controller._queue.length === 0);
	        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
	        ReadableStreamFulfillReadRequest(stream, transferredView, false);
	      }
	    } else if (ReadableStreamHasBYOBReader(stream) === true) {
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	    } else {
	      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	    }
	  }
	  function ReadableByteStreamControllerError(controller, e) {
	    var stream = controller._controlledReadableStream;
	    assert(stream._state === 'readable');
	    ReadableByteStreamControllerClearPendingPullIntos(controller);
	    ResetQueue(controller);
	    ReadableStreamError(stream, e);
	  }
	  function ReadableByteStreamControllerGetDesiredSize(controller) {
	    var stream = controller._controlledReadableStream;
	    var state = stream._state;
	    if (state === 'errored') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
	    bytesWritten = Number(bytesWritten);
	    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
	      throw new RangeError('bytesWritten must be a finite');
	    }
	    assert(controller._pendingPullIntos.length > 0);
	    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
	  }
	  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
	    assert(controller._pendingPullIntos.length > 0);
	    var firstDescriptor = controller._pendingPullIntos[0];
	    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
	      throw new RangeError('The region specified by view does not match byobRequest');
	    }
	    if (firstDescriptor.byteLength !== view.byteLength) {
	      throw new RangeError('The buffer of view has different capacity than byobRequest');
	    }
	    firstDescriptor.buffer = view.buffer;
	    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
	  }
	  function readerLockException(name) {
	    return new TypeError('Cannot ' + name + ' a stream using a released reader');
	  }
	  function defaultReaderBrandCheckException(name) {
	    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
	  }
	  function defaultReaderClosedPromiseInitialize(reader) {
	    reader._closedPromise = new Promise(function (resolve, reject) {
	      reader._closedPromise_resolve = resolve;
	      reader._closedPromise_reject = reject;
	    });
	  }
	  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
	    reader._closedPromise = Promise.reject(reason);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
	    reader._closedPromise = Promise.resolve(undefined);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseReject(reader, reason) {
	    assert(reader._closedPromise_resolve !== undefined);
	    assert(reader._closedPromise_reject !== undefined);
	    reader._closedPromise_reject(reason);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
	    assert(reader._closedPromise_resolve === undefined);
	    assert(reader._closedPromise_reject === undefined);
	    reader._closedPromise = Promise.reject(reason);
	  }
	  function defaultReaderClosedPromiseResolve(reader) {
	    assert(reader._closedPromise_resolve !== undefined);
	    assert(reader._closedPromise_reject !== undefined);
	    reader._closedPromise_resolve(undefined);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function byobReaderBrandCheckException(name) {
	    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
	  }
	  function defaultControllerBrandCheckException(name) {
	    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
	  }
	  function byobRequestBrandCheckException(name) {
	    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
	  }
	  function byteStreamControllerBrandCheckException(name) {
	    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
	  }
	  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
	    try {
	      Promise.prototype.then.call(promise, undefined, function () {});
	    } catch (e) {}
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var transformStream = __w_pdfjs_require__(6);
	  var readableStream = __w_pdfjs_require__(4);
	  var writableStream = __w_pdfjs_require__(2);
	  exports.TransformStream = transformStream.TransformStream;
	  exports.ReadableStream = readableStream.ReadableStream;
	  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
	  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
	  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
	  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
	  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
	  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
	  exports.IsWritableStream = writableStream.IsWritableStream;
	  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
	  exports.WritableStream = writableStream.WritableStream;
	  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
	  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
	  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
	  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
	  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(1),
	      assert = _require.assert;
	  var _require2 = __w_pdfjs_require__(0),
	      InvokeOrNoop = _require2.InvokeOrNoop,
	      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
	      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
	      typeIsObject = _require2.typeIsObject;
	  var _require3 = __w_pdfjs_require__(4),
	      ReadableStream = _require3.ReadableStream,
	      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
	      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
	      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
	      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
	  var _require4 = __w_pdfjs_require__(2),
	      WritableStream = _require4.WritableStream,
	      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
	  function TransformStreamCloseReadable(transformStream) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    if (transformStream._readableClosed === true) {
	      throw new TypeError('Readable side is already closed');
	    }
	    TransformStreamCloseReadableInternal(transformStream);
	  }
	  function TransformStreamEnqueueToReadable(transformStream, chunk) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    if (transformStream._readableClosed === true) {
	      throw new TypeError('Readable side is already closed');
	    }
	    var controller = transformStream._readableController;
	    try {
	      ReadableStreamDefaultControllerEnqueue(controller, chunk);
	    } catch (e) {
	      transformStream._readableClosed = true;
	      TransformStreamErrorIfNeeded(transformStream, e);
	      throw transformStream._storedError;
	    }
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	    var maybeBackpressure = desiredSize <= 0;
	    if (maybeBackpressure === true && transformStream._backpressure === false) {
	      TransformStreamSetBackpressure(transformStream, true);
	    }
	  }
	  function TransformStreamError(transformStream, e) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    TransformStreamErrorInternal(transformStream, e);
	  }
	  function TransformStreamCloseReadableInternal(transformStream) {
	    assert(transformStream._errored === false);
	    assert(transformStream._readableClosed === false);
	    try {
	      ReadableStreamDefaultControllerClose(transformStream._readableController);
	    } catch (e) {
	      assert(false);
	    }
	    transformStream._readableClosed = true;
	  }
	  function TransformStreamErrorIfNeeded(transformStream, e) {
	    if (transformStream._errored === false) {
	      TransformStreamErrorInternal(transformStream, e);
	    }
	  }
	  function TransformStreamErrorInternal(transformStream, e) {
	    assert(transformStream._errored === false);
	    transformStream._errored = true;
	    transformStream._storedError = e;
	    if (transformStream._writableDone === false) {
	      WritableStreamDefaultControllerError(transformStream._writableController, e);
	    }
	    if (transformStream._readableClosed === false) {
	      ReadableStreamDefaultControllerError(transformStream._readableController, e);
	    }
	  }
	  function TransformStreamReadableReadyPromise(transformStream) {
	    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	    if (transformStream._backpressure === false) {
	      return Promise.resolve();
	    }
	    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
	    return transformStream._backpressureChangePromise;
	  }
	  function TransformStreamSetBackpressure(transformStream, backpressure) {
	    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
	    if (transformStream._backpressureChangePromise !== undefined) {
	      transformStream._backpressureChangePromise_resolve(backpressure);
	    }
	    transformStream._backpressureChangePromise = new Promise(function (resolve) {
	      transformStream._backpressureChangePromise_resolve = resolve;
	    });
	    transformStream._backpressureChangePromise.then(function (resolution) {
	      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
	    });
	    transformStream._backpressure = backpressure;
	  }
	  function TransformStreamDefaultTransform(chunk, transformStreamController) {
	    var transformStream = transformStreamController._controlledTransformStream;
	    TransformStreamEnqueueToReadable(transformStream, chunk);
	    return Promise.resolve();
	  }
	  function TransformStreamTransform(transformStream, chunk) {
	    assert(transformStream._errored === false);
	    assert(transformStream._transforming === false);
	    assert(transformStream._backpressure === false);
	    transformStream._transforming = true;
	    var transformer = transformStream._transformer;
	    var controller = transformStream._transformStreamController;
	    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
	    return transformPromise.then(function () {
	      transformStream._transforming = false;
	      return TransformStreamReadableReadyPromise(transformStream);
	    }, function (e) {
	      TransformStreamErrorIfNeeded(transformStream, e);
	      return Promise.reject(e);
	    });
	  }
	  function IsTransformStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
	      return false;
	    }
	    return true;
	  }
	  function IsTransformStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  var TransformStreamSink = function () {
	    function TransformStreamSink(transformStream, startPromise) {
	      _classCallCheck(this, TransformStreamSink);
	      this._transformStream = transformStream;
	      this._startPromise = startPromise;
	    }
	    _createClass(TransformStreamSink, [{
	      key: 'start',
	      value: function start(c) {
	        var transformStream = this._transformStream;
	        transformStream._writableController = c;
	        return this._startPromise.then(function () {
	          return TransformStreamReadableReadyPromise(transformStream);
	        });
	      }
	    }, {
	      key: 'write',
	      value: function write(chunk) {
	        var transformStream = this._transformStream;
	        return TransformStreamTransform(transformStream, chunk);
	      }
	    }, {
	      key: 'abort',
	      value: function abort() {
	        var transformStream = this._transformStream;
	        transformStream._writableDone = true;
	        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        var transformStream = this._transformStream;
	        assert(transformStream._transforming === false);
	        transformStream._writableDone = true;
	        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
	        return flushPromise.then(function () {
	          if (transformStream._errored === true) {
	            return Promise.reject(transformStream._storedError);
	          }
	          if (transformStream._readableClosed === false) {
	            TransformStreamCloseReadableInternal(transformStream);
	          }
	          return Promise.resolve();
	        }).catch(function (r) {
	          TransformStreamErrorIfNeeded(transformStream, r);
	          return Promise.reject(transformStream._storedError);
	        });
	      }
	    }]);
	    return TransformStreamSink;
	  }();
	  var TransformStreamSource = function () {
	    function TransformStreamSource(transformStream, startPromise) {
	      _classCallCheck(this, TransformStreamSource);
	      this._transformStream = transformStream;
	      this._startPromise = startPromise;
	    }
	    _createClass(TransformStreamSource, [{
	      key: 'start',
	      value: function start(c) {
	        var transformStream = this._transformStream;
	        transformStream._readableController = c;
	        return this._startPromise.then(function () {
	          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	          if (transformStream._backpressure === true) {
	            return Promise.resolve();
	          }
	          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
	          return transformStream._backpressureChangePromise;
	        });
	      }
	    }, {
	      key: 'pull',
	      value: function pull() {
	        var transformStream = this._transformStream;
	        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
	        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	        TransformStreamSetBackpressure(transformStream, false);
	        return transformStream._backpressureChangePromise;
	      }
	    }, {
	      key: 'cancel',
	      value: function cancel() {
	        var transformStream = this._transformStream;
	        transformStream._readableClosed = true;
	        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
	      }
	    }]);
	    return TransformStreamSource;
	  }();
	  var TransformStreamDefaultController = function () {
	    function TransformStreamDefaultController(transformStream) {
	      _classCallCheck(this, TransformStreamDefaultController);
	      if (IsTransformStream(transformStream) === false) {
	        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
	      }
	      if (transformStream._transformStreamController !== undefined) {
	        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
	      }
	      this._controlledTransformStream = transformStream;
	    }
	    _createClass(TransformStreamDefaultController, [{
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('enqueue');
	        }
	        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('close');
	        }
	        TransformStreamCloseReadable(this._controlledTransformStream);
	      }
	    }, {
	      key: 'error',
	      value: function error(reason) {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('error');
	        }
	        TransformStreamError(this._controlledTransformStream, reason);
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('desiredSize');
	        }
	        var transformStream = this._controlledTransformStream;
	        var readableController = transformStream._readableController;
	        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
	      }
	    }]);
	    return TransformStreamDefaultController;
	  }();
	  var TransformStream = function () {
	    function TransformStream() {
	      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      _classCallCheck(this, TransformStream);
	      this._transformer = transformer;
	      var readableStrategy = transformer.readableStrategy,
	          writableStrategy = transformer.writableStrategy;
	      this._transforming = false;
	      this._errored = false;
	      this._storedError = undefined;
	      this._writableController = undefined;
	      this._readableController = undefined;
	      this._transformStreamController = undefined;
	      this._writableDone = false;
	      this._readableClosed = false;
	      this._backpressure = undefined;
	      this._backpressureChangePromise = undefined;
	      this._backpressureChangePromise_resolve = undefined;
	      this._transformStreamController = new TransformStreamDefaultController(this);
	      var startPromise_resolve = void 0;
	      var startPromise = new Promise(function (resolve) {
	        startPromise_resolve = resolve;
	      });
	      var source = new TransformStreamSource(this, startPromise);
	      this._readable = new ReadableStream(source, readableStrategy);
	      var sink = new TransformStreamSink(this, startPromise);
	      this._writable = new WritableStream(sink, writableStrategy);
	      assert(this._writableController !== undefined);
	      assert(this._readableController !== undefined);
	      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
	      TransformStreamSetBackpressure(this, desiredSize <= 0);
	      var transformStream = this;
	      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
	      startPromise_resolve(startResult);
	      startPromise.catch(function (e) {
	        if (transformStream._errored === false) {
	          transformStream._errored = true;
	          transformStream._storedError = e;
	        }
	      });
	    }
	    _createClass(TransformStream, [{
	      key: 'readable',
	      get: function get() {
	        if (IsTransformStream(this) === false) {
	          throw streamBrandCheckException('readable');
	        }
	        return this._readable;
	      }
	    }, {
	      key: 'writable',
	      get: function get() {
	        if (IsTransformStream(this) === false) {
	          throw streamBrandCheckException('writable');
	        }
	        return this._writable;
	      }
	    }]);
	    return TransformStream;
	  }();
	  module.exports = { TransformStream: TransformStream };
	  function defaultControllerBrandCheckException(name) {
	    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  module.exports = __w_pdfjs_require__(5);
	}]));
	
	/***/ }),
	/* 118 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFJS = exports.globalScope = undefined;
	
	var _api = __w_pdfjs_require__(69);
	
	var _dom_utils = __w_pdfjs_require__(15);
	
	var _util = __w_pdfjs_require__(0);
	
	var _annotation_layer = __w_pdfjs_require__(72);
	
	var _global_scope = __w_pdfjs_require__(20);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	var _metadata = __w_pdfjs_require__(71);
	
	var _text_layer = __w_pdfjs_require__(73);
	
	var _svg = __w_pdfjs_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!_global_scope2.default.PDFJS) {
	  _global_scope2.default.PDFJS = {};
	}
	var PDFJS = _global_scope2.default.PDFJS;
	{
	  PDFJS.version = '1.10.100';
	  PDFJS.build = 'ea29ec83';
	}
	PDFJS.pdfBug = false;
	if (PDFJS.verbosity !== undefined) {
	  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
	}
	delete PDFJS.verbosity;
	Object.defineProperty(PDFJS, 'verbosity', {
	  get: function get() {
	    return (0, _util.getVerbosityLevel)();
	  },
	  set: function set(level) {
	    (0, _util.setVerbosityLevel)(level);
	  },
	
	  enumerable: true,
	  configurable: true
	});
	PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
	PDFJS.OPS = _util.OPS;
	PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
	PDFJS.isValidUrl = _dom_utils.isValidUrl;
	PDFJS.shadow = _util.shadow;
	PDFJS.createBlob = _util.createBlob;
	PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
	  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
	};
	Object.defineProperty(PDFJS, 'isLittleEndian', {
	  configurable: true,
	  get: function PDFJS_isLittleEndian() {
	    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
	  }
	});
	PDFJS.removeNullCharacters = _util.removeNullCharacters;
	PDFJS.PasswordResponses = _util.PasswordResponses;
	PDFJS.PasswordException = _util.PasswordException;
	PDFJS.UnknownErrorException = _util.UnknownErrorException;
	PDFJS.InvalidPDFException = _util.InvalidPDFException;
	PDFJS.MissingPDFException = _util.MissingPDFException;
	PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
	PDFJS.Util = _util.Util;
	PDFJS.PageViewport = _util.PageViewport;
	PDFJS.createPromiseCapability = _util.createPromiseCapability;
	PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
	PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
	PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
	PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
	PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
	PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
	PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
	PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
	PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
	PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
	PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
	PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
	PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
	PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
	PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
	PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
	PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
	PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
	PDFJS.pdfjsNext = PDFJS.pdfjsNext === undefined ? false : PDFJS.pdfjsNext;
	{
	  var savedOpenExternalLinksInNewWindow = PDFJS.openExternalLinksInNewWindow;
	  delete PDFJS.openExternalLinksInNewWindow;
	  Object.defineProperty(PDFJS, 'openExternalLinksInNewWindow', {
	    get: function get() {
	      return PDFJS.externalLinkTarget === _dom_utils.LinkTarget.BLANK;
	    },
	    set: function set(value) {
	      if (value) {
	        (0, _util.deprecated)('PDFJS.openExternalLinksInNewWindow, please use ' + '"PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK" instead.');
	      }
	      if (PDFJS.externalLinkTarget !== _dom_utils.LinkTarget.NONE) {
	        (0, _util.warn)('PDFJS.externalLinkTarget is already initialized');
	        return;
	      }
	      PDFJS.externalLinkTarget = value ? _dom_utils.LinkTarget.BLANK : _dom_utils.LinkTarget.NONE;
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	  if (savedOpenExternalLinksInNewWindow) {
	    PDFJS.openExternalLinksInNewWindow = savedOpenExternalLinksInNewWindow;
	  }
	}
	PDFJS.getDocument = _api.getDocument;
	PDFJS.LoopbackPort = _api.LoopbackPort;
	PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
	PDFJS.PDFWorker = _api.PDFWorker;
	PDFJS.hasCanvasTypedArrays = true;
	PDFJS.CustomStyle = _dom_utils.CustomStyle;
	PDFJS.LinkTarget = _dom_utils.LinkTarget;
	PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
	PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
	PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
	PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
	PDFJS.renderTextLayer = _text_layer.renderTextLayer;
	PDFJS.Metadata = _metadata.Metadata;
	PDFJS.SVGGraphics = _svg.SVGGraphics;
	PDFJS.UnsupportedManager = _api._UnsupportedManager;
	exports.globalScope = _global_scope2.default;
	exports.PDFJS = PDFJS;
	
	/***/ }),
	/* 119 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontLoader = exports.FontFaceObject = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	function FontLoader(docId) {
	  this.docId = docId;
	  this.styleElement = null;
	  this.nativeFontFaces = [];
	  this.loadTestFontId = 0;
	  this.loadingContext = {
	    requests: [],
	    nextRequestId: 0
	  };
	}
	FontLoader.prototype = {
	  insertRule: function fontLoaderInsertRule(rule) {
	    var styleElement = this.styleElement;
	    if (!styleElement) {
	      styleElement = this.styleElement = document.createElement('style');
	      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
	      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
	    }
	    var styleSheet = styleElement.sheet;
	    styleSheet.insertRule(rule, styleSheet.cssRules.length);
	  },
	  clear: function fontLoaderClear() {
	    if (this.styleElement) {
	      this.styleElement.remove();
	      this.styleElement = null;
	    }
	    this.nativeFontFaces.forEach(function (nativeFontFace) {
	      document.fonts.delete(nativeFontFace);
	    });
	    this.nativeFontFaces.length = 0;
	  }
	};
	{
	  var getLoadTestFont = function getLoadTestFont() {
	    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
	  };
	  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
	    get: function get() {
	      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
	    },
	
	    configurable: true
	  });
	  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
	    this.nativeFontFaces.push(nativeFontFace);
	    document.fonts.add(nativeFontFace);
	  };
	  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
	    var rules = [];
	    var fontsToLoad = [];
	    var fontLoadPromises = [];
	    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
	      return nativeFontFace.loaded.catch(function (e) {
	        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
	      });
	    };
	    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
	    for (var i = 0, ii = fonts.length; i < ii; i++) {
	      var font = fonts[i];
	      if (font.attached || font.loading === false) {
	        continue;
	      }
	      font.attached = true;
	      if (isFontLoadingAPISupported) {
	        var nativeFontFace = font.createNativeFontFace();
	        if (nativeFontFace) {
	          this.addNativeFontFace(nativeFontFace);
	          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
	        }
	      } else {
	        var rule = font.createFontFaceRule();
	        if (rule) {
	          this.insertRule(rule);
	          rules.push(rule);
	          fontsToLoad.push(font);
	        }
	      }
	    }
	    var request = this.queueLoadingCallback(callback);
	    if (isFontLoadingAPISupported) {
	      Promise.all(fontLoadPromises).then(function () {
	        request.complete();
	      });
	    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
	      this.prepareFontLoadEvent(rules, fontsToLoad, request);
	    } else {
	      request.complete();
	    }
	  };
	  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
	    function LoadLoader_completeRequest() {
	      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
	      request.end = Date.now();
	      while (context.requests.length > 0 && context.requests[0].end) {
	        var otherRequest = context.requests.shift();
	        setTimeout(otherRequest.callback, 0);
	      }
	    }
	    var context = this.loadingContext;
	    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
	    var request = {
	      id: requestId,
	      complete: LoadLoader_completeRequest,
	      callback: callback,
	      started: Date.now()
	    };
	    context.requests.push(request);
	    return request;
	  };
	  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
	    function int32(data, offset) {
	      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
	    }
	    function spliceString(s, offset, remove, insert) {
	      var chunk1 = s.substr(0, offset);
	      var chunk2 = s.substr(offset + remove);
	      return chunk1 + insert + chunk2;
	    }
	    var i, ii;
	    var canvas = document.createElement('canvas');
	    canvas.width = 1;
	    canvas.height = 1;
	    var ctx = canvas.getContext('2d');
	    var called = 0;
	    function isFontReady(name, callback) {
	      called++;
	      if (called > 30) {
	        (0, _util.warn)('Load test font never loaded.');
	        callback();
	        return;
	      }
	      ctx.font = '30px ' + name;
	      ctx.fillText('.', 0, 20);
	      var imageData = ctx.getImageData(0, 0, 1, 1);
	      if (imageData.data[3] > 0) {
	        callback();
	        return;
	      }
	      setTimeout(isFontReady.bind(null, name, callback));
	    }
	    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
	    var data = this.loadTestFont;
	    var COMMENT_OFFSET = 976;
	    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
	    var CFF_CHECKSUM_OFFSET = 16;
	    var XXXX_VALUE = 0x58585858;
	    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
	    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
	    }
	    if (i < loadTestFontId.length) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
	    }
	    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
	    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
	    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
	    this.insertRule(rule);
	    var names = [];
	    for (i = 0, ii = fonts.length; i < ii; i++) {
	      names.push(fonts[i].loadedName);
	    }
	    names.push(loadTestFontId);
	    var div = document.createElement('div');
	    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
	    for (i = 0, ii = names.length; i < ii; ++i) {
	      var span = document.createElement('span');
	      span.textContent = 'Hi';
	      span.style.fontFamily = names[i];
	      div.appendChild(span);
	    }
	    document.body.appendChild(div);
	    isFontReady(loadTestFontId, function () {
	      document.body.removeChild(div);
	      request.complete();
	    });
	  };
	}
	{
	  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
	}
	{
	  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
	    if (typeof navigator === 'undefined') {
	      return true;
	    }
	    var supported = false;
	    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
	    if (m && m[1] >= 14) {
	      supported = true;
	    }
	    return supported;
	  };
	  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
	    get: function get() {
	      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	}
	var IsEvalSupportedCached = {
	  get value() {
	    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
	  }
	};
	var FontFaceObject = function FontFaceObjectClosure() {
	  function FontFaceObject(translatedData, options) {
	    this.compiledGlyphs = Object.create(null);
	    for (var i in translatedData) {
	      this[i] = translatedData[i];
	    }
	    this.options = options;
	  }
	  FontFaceObject.prototype = {
	    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this);
	      }
	      return nativeFontFace;
	    },
	    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
	      var fontName = this.loadedName;
	      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
	      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this, url);
	      }
	      return rule;
	    },
	    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
	      if (!(character in this.compiledGlyphs)) {
	        var cmds = objs.get(this.loadedName + '_path_' + character);
	        var current, i, len;
	        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
	          var args,
	              js = '';
	          for (i = 0, len = cmds.length; i < len; i++) {
	            current = cmds[i];
	            if (current.args !== undefined) {
	              args = current.args.join(',');
	            } else {
	              args = '';
	            }
	            js += 'c.' + current.cmd + '(' + args + ');\n';
	          }
	          this.compiledGlyphs[character] = new Function('c', 'size', js);
	        } else {
	          this.compiledGlyphs[character] = function (c, size) {
	            for (i = 0, len = cmds.length; i < len; i++) {
	              current = cmds[i];
	              if (current.cmd === 'scale') {
	                current.args = [size, -size];
	              }
	              c[current.cmd].apply(c, current.args);
	            }
	          };
	        }
	      }
	      return this.compiledGlyphs[character];
	    }
	  };
	  return FontFaceObject;
	}();
	exports.FontFaceObject = FontFaceObject;
	exports.FontLoader = FontLoader;
	
	/***/ }),
	/* 120 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CanvasGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _pattern_helper = __w_pdfjs_require__(121);
	
	var _webgl = __w_pdfjs_require__(70);
	
	var MIN_FONT_SIZE = 16;
	var MAX_FONT_SIZE = 100;
	var MAX_GROUP_SIZE = 4096;
	var MIN_WIDTH_FACTOR = 0.65;
	var COMPILE_TYPE3_GLYPHS = true;
	var MAX_SIZE_TO_COMPILE = 1000;
	var FULL_CHUNK_HEIGHT = 16;
	var IsLittleEndianCached = {
	  get value() {
	    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
	  }
	};
	function addContextCurrentTransform(ctx) {
	  if (!ctx.mozCurrentTransform) {
	    ctx._originalSave = ctx.save;
	    ctx._originalRestore = ctx.restore;
	    ctx._originalRotate = ctx.rotate;
	    ctx._originalScale = ctx.scale;
	    ctx._originalTranslate = ctx.translate;
	    ctx._originalTransform = ctx.transform;
	    ctx._originalSetTransform = ctx.setTransform;
	    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
	    ctx._transformStack = [];
	    Object.defineProperty(ctx, 'mozCurrentTransform', {
	      get: function getCurrentTransform() {
	        return this._transformMatrix;
	      }
	    });
	    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
	      get: function getCurrentTransformInverse() {
	        var m = this._transformMatrix;
	        var a = m[0],
	            b = m[1],
	            c = m[2],
	            d = m[3],
	            e = m[4],
	            f = m[5];
	        var ad_bc = a * d - b * c;
	        var bc_ad = b * c - a * d;
	        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
	      }
	    });
	    ctx.save = function ctxSave() {
	      var old = this._transformMatrix;
	      this._transformStack.push(old);
	      this._transformMatrix = old.slice(0, 6);
	      this._originalSave();
	    };
	    ctx.restore = function ctxRestore() {
	      var prev = this._transformStack.pop();
	      if (prev) {
	        this._transformMatrix = prev;
	        this._originalRestore();
	      }
	    };
	    ctx.translate = function ctxTranslate(x, y) {
	      var m = this._transformMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	      this._originalTranslate(x, y);
	    };
	    ctx.scale = function ctxScale(x, y) {
	      var m = this._transformMatrix;
	      m[0] = m[0] * x;
	      m[1] = m[1] * x;
	      m[2] = m[2] * y;
	      m[3] = m[3] * y;
	      this._originalScale(x, y);
	    };
	    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
	      ctx._originalTransform(a, b, c, d, e, f);
	    };
	    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
	      this._transformMatrix = [a, b, c, d, e, f];
	      ctx._originalSetTransform(a, b, c, d, e, f);
	    };
	    ctx.rotate = function ctxRotate(angle) {
	      var cosValue = Math.cos(angle);
	      var sinValue = Math.sin(angle);
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
	      this._originalRotate(angle);
	    };
	  }
	}
	var CachedCanvases = function CachedCanvasesClosure() {
	  function CachedCanvases(canvasFactory) {
	    this.canvasFactory = canvasFactory;
	    this.cache = Object.create(null);
	  }
	  CachedCanvases.prototype = {
	    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
	      var canvasEntry;
	      if (this.cache[id] !== undefined) {
	        canvasEntry = this.cache[id];
	        this.canvasFactory.reset(canvasEntry, width, height);
	        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
	      } else {
	        canvasEntry = this.canvasFactory.create(width, height);
	        this.cache[id] = canvasEntry;
	      }
	      if (trackTransform) {
	        addContextCurrentTransform(canvasEntry.context);
	      }
	      return canvasEntry;
	    },
	    clear: function clear() {
	      for (var id in this.cache) {
	        var canvasEntry = this.cache[id];
	        this.canvasFactory.destroy(canvasEntry);
	        delete this.cache[id];
	      }
	    }
	  };
	  return CachedCanvases;
	}();
	function compileType3Glyph(imgData) {
	  var POINT_TO_PROCESS_LIMIT = 1000;
	  var width = imgData.width,
	      height = imgData.height;
	  var i,
	      j,
	      j0,
	      width1 = width + 1;
	  var points = new Uint8Array(width1 * (height + 1));
	  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
	  var lineSize = width + 7 & ~7,
	      data0 = imgData.data;
	  var data = new Uint8Array(lineSize * height),
	      pos = 0,
	      ii;
	  for (i = 0, ii = data0.length; i < ii; i++) {
	    var mask = 128,
	        elem = data0[i];
	    while (mask > 0) {
	      data[pos++] = elem & mask ? 0 : 255;
	      mask >>= 1;
	    }
	  }
	  var count = 0;
	  pos = 0;
	  if (data[pos] !== 0) {
	    points[0] = 1;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j] = data[pos] ? 2 : 1;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j] = 2;
	    ++count;
	  }
	  for (i = 1; i < height; i++) {
	    pos = i * lineSize;
	    j0 = i * width1;
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0] = data[pos] ? 1 : 8;
	      ++count;
	    }
	    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
	    for (j = 1; j < width; j++) {
	      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
	      if (POINT_TYPES[sum]) {
	        points[j0 + j] = POINT_TYPES[sum];
	        ++count;
	      }
	      pos++;
	    }
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0 + j] = data[pos] ? 2 : 4;
	      ++count;
	    }
	    if (count > POINT_TO_PROCESS_LIMIT) {
	      return null;
	    }
	  }
	  pos = lineSize * (height - 1);
	  j0 = i * width1;
	  if (data[pos] !== 0) {
	    points[j0] = 8;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j0 + j] = data[pos] ? 4 : 8;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j0 + j] = 4;
	    ++count;
	  }
	  if (count > POINT_TO_PROCESS_LIMIT) {
	    return null;
	  }
	  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
	  var outlines = [];
	  for (i = 0; count && i <= height; i++) {
	    var p = i * width1;
	    var end = p + width;
	    while (p < end && !points[p]) {
	      p++;
	    }
	    if (p === end) {
	      continue;
	    }
	    var coords = [p % width1, i];
	    var type = points[p],
	        p0 = p,
	        pp;
	    do {
	      var step = steps[type];
	      do {
	        p += step;
	      } while (!points[p]);
	      pp = points[p];
	      if (pp !== 5 && pp !== 10) {
	        type = pp;
	        points[p] = 0;
	      } else {
	        type = pp & 0x33 * type >> 4;
	        points[p] &= type >> 2 | type << 2;
	      }
	      coords.push(p % width1);
	      coords.push(p / width1 | 0);
	      --count;
	    } while (p0 !== p);
	    outlines.push(coords);
	    --i;
	  }
	  var drawOutline = function drawOutline(c) {
	    c.save();
	    c.scale(1 / width, -1 / height);
	    c.translate(0, -height);
	    c.beginPath();
	    for (var i = 0, ii = outlines.length; i < ii; i++) {
	      var o = outlines[i];
	      c.moveTo(o[0], o[1]);
	      for (var j = 2, jj = o.length; j < jj; j += 2) {
	        c.lineTo(o[j], o[j + 1]);
	      }
	    }
	    c.fill();
	    c.beginPath();
	    c.restore();
	  };
	  return drawOutline;
	}
	var CanvasExtraState = function CanvasExtraStateClosure() {
	  function CanvasExtraState() {
	    this.alphaIsShape = false;
	    this.fontSize = 0;
	    this.fontSizeScale = 1;
	    this.textMatrix = _util.IDENTITY_MATRIX;
	    this.textMatrixScale = 1;
	    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	    this.leading = 0;
	    this.x = 0;
	    this.y = 0;
	    this.lineX = 0;
	    this.lineY = 0;
	    this.charSpacing = 0;
	    this.wordSpacing = 0;
	    this.textHScale = 1;
	    this.textRenderingMode = _util.TextRenderingMode.FILL;
	    this.textRise = 0;
	    this.fillColor = '#000000';
	    this.strokeColor = '#000000';
	    this.patternFill = false;
	    this.fillAlpha = 1;
	    this.strokeAlpha = 1;
	    this.lineWidth = 1;
	    this.activeSMask = null;
	    this.resumeSMaskCtx = null;
	  }
	  CanvasExtraState.prototype = {
	    clone: function CanvasExtraState_clone() {
	      return Object.create(this);
	    },
	    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
	      this.x = x;
	      this.y = y;
	    }
	  };
	  return CanvasExtraState;
	}();
	var CanvasGraphics = function CanvasGraphicsClosure() {
	  var EXECUTION_TIME = 15;
	  var EXECUTION_STEPS = 10;
	  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer) {
	    this.ctx = canvasCtx;
	    this.current = new CanvasExtraState();
	    this.stateStack = [];
	    this.pendingClip = null;
	    this.pendingEOFill = false;
	    this.res = null;
	    this.xobjs = null;
	    this.commonObjs = commonObjs;
	    this.objs = objs;
	    this.canvasFactory = canvasFactory;
	    this.imageLayer = imageLayer;
	    this.groupStack = [];
	    this.processingType3 = null;
	    this.baseTransform = null;
	    this.baseTransformStack = [];
	    this.groupLevel = 0;
	    this.smaskStack = [];
	    this.smaskCounter = 0;
	    this.tempSMask = null;
	    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
	    if (canvasCtx) {
	      addContextCurrentTransform(canvasCtx);
	    }
	    this.cachedGetSinglePixelWidth = null;
	  }
	  function putBinaryImageData(ctx, imgData) {
	    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
	      ctx.putImageData(imgData, 0, 0);
	      return;
	    }
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0,
	        destPos;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    var i, j, thisChunkHeight, elemsInThisChunk;
	    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
	      var srcLength = src.byteLength;
	      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
	      var dest32DataLength = dest32.length;
	      var fullSrcDiff = width + 7 >> 3;
	      var white = 0xFFFFFFFF;
	      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
	      for (i = 0; i < totalChunks; i++) {
	        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	        destPos = 0;
	        for (j = 0; j < thisChunkHeight; j++) {
	          var srcDiff = srcLength - srcPos;
	          var k = 0;
	          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
	          var kEndUnrolled = kEnd & ~7;
	          var mask = 0;
	          var srcByte = 0;
	          for (; k < kEndUnrolled; k += 8) {
	            srcByte = src[srcPos++];
	            dest32[destPos++] = srcByte & 128 ? white : black;
	            dest32[destPos++] = srcByte & 64 ? white : black;
	            dest32[destPos++] = srcByte & 32 ? white : black;
	            dest32[destPos++] = srcByte & 16 ? white : black;
	            dest32[destPos++] = srcByte & 8 ? white : black;
	            dest32[destPos++] = srcByte & 4 ? white : black;
	            dest32[destPos++] = srcByte & 2 ? white : black;
	            dest32[destPos++] = srcByte & 1 ? white : black;
	          }
	          for (; k < kEnd; k++) {
	            if (mask === 0) {
	              srcByte = src[srcPos++];
	              mask = 128;
	            }
	            dest32[destPos++] = srcByte & mask ? white : black;
	            mask >>= 1;
	          }
	        }
	        while (destPos < dest32DataLength) {
	          dest32[destPos++] = 0;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
	      j = 0;
	      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
	      for (i = 0; i < fullChunks; i++) {
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        srcPos += elemsInThisChunk;
	        ctx.putImageData(chunkImgData, 0, j);
	        j += FULL_CHUNK_HEIGHT;
	      }
	      if (i < totalChunks) {
	        elemsInThisChunk = width * partialChunkHeight * 4;
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        ctx.putImageData(chunkImgData, 0, j);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
	      thisChunkHeight = FULL_CHUNK_HEIGHT;
	      elemsInThisChunk = width * thisChunkHeight;
	      for (i = 0; i < totalChunks; i++) {
	        if (i >= fullChunks) {
	          thisChunkHeight = partialChunkHeight;
	          elemsInThisChunk = width * thisChunkHeight;
	        }
	        destPos = 0;
	        for (j = elemsInThisChunk; j--;) {
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = 255;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else {
	      throw new Error('bad image kind: ' + imgData.kind);
	    }
	  }
	  function putBinaryImageMask(ctx, imgData) {
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    for (var i = 0; i < totalChunks; i++) {
	      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	      var destPos = 3;
	      for (var j = 0; j < thisChunkHeight; j++) {
	        var mask = 0;
	        for (var k = 0; k < width; k++) {
	          if (!mask) {
	            var elem = src[srcPos++];
	            mask = 128;
	          }
	          dest[destPos] = elem & mask ? 0 : 255;
	          destPos += 4;
	          mask >>= 1;
	        }
	      }
	      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	    }
	  }
	  function copyCtxState(sourceCtx, destCtx) {
	    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
	    for (var i = 0, ii = properties.length; i < ii; i++) {
	      var property = properties[i];
	      if (sourceCtx[property] !== undefined) {
	        destCtx[property] = sourceCtx[property];
	      }
	    }
	    if (sourceCtx.setLineDash !== undefined) {
	      destCtx.setLineDash(sourceCtx.getLineDash());
	      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
	    }
	  }
	  function resetCtxToDefault(ctx) {
	    ctx.strokeStyle = '#000000';
	    ctx.fillStyle = '#000000';
	    ctx.fillRule = 'nonzero';
	    ctx.globalAlpha = 1;
	    ctx.lineWidth = 1;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 10;
	    ctx.globalCompositeOperation = 'source-over';
	    ctx.font = '10px sans-serif';
	    if (ctx.setLineDash !== undefined) {
	      ctx.setLineDash([]);
	      ctx.lineDashOffset = 0;
	    }
	  }
	  function composeSMaskBackdrop(bytes, r0, g0, b0) {
	    var length = bytes.length;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = bytes[i];
	      if (alpha === 0) {
	        bytes[i - 3] = r0;
	        bytes[i - 2] = g0;
	        bytes[i - 1] = b0;
	      } else if (alpha < 255) {
	        var alpha_ = 255 - alpha;
	        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
	        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
	        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
	      }
	    }
	  }
	  function composeSMaskAlpha(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    var scale = 1 / 255;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
	      layerData[i] = layerData[i] * alpha * scale | 0;
	    }
	  }
	  function composeSMaskLuminosity(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    for (var i = 3; i < length; i += 4) {
	      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
	      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
	    }
	  }
	  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
	    var hasBackdrop = !!backdrop;
	    var r0 = hasBackdrop ? backdrop[0] : 0;
	    var g0 = hasBackdrop ? backdrop[1] : 0;
	    var b0 = hasBackdrop ? backdrop[2] : 0;
	    var composeFn;
	    if (subtype === 'Luminosity') {
	      composeFn = composeSMaskLuminosity;
	    } else {
	      composeFn = composeSMaskAlpha;
	    }
	    var PIXELS_TO_PROCESS = 1048576;
	    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
	    for (var row = 0; row < height; row += chunkSize) {
	      var chunkHeight = Math.min(chunkSize, height - row);
	      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
	      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
	      if (hasBackdrop) {
	        composeSMaskBackdrop(maskData.data, r0, g0, b0);
	      }
	      composeFn(maskData.data, layerData.data, transferMap);
	      maskCtx.putImageData(layerData, 0, row);
	    }
	  }
	  function composeSMask(ctx, smask, layerCtx) {
	    var mask = smask.canvas;
	    var maskCtx = smask.context;
	    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
	    var backdrop = smask.backdrop || null;
	    if (!smask.transferMap && _webgl.WebGLUtils.isEnabled) {
	      var composed = _webgl.WebGLUtils.composeSMask(layerCtx.canvas, mask, {
	        subtype: smask.subtype,
	        backdrop: backdrop
	      });
	      ctx.setTransform(1, 0, 0, 1, 0, 0);
	      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
	      return;
	    }
	    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
	    ctx.drawImage(mask, 0, 0);
	  }
	  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	  var NORMAL_CLIP = {};
	  var EO_CLIP = {};
	  CanvasGraphics.prototype = {
	    beginDrawing: function beginDrawing(_ref) {
	      var transform = _ref.transform,
	          viewport = _ref.viewport,
	          transparency = _ref.transparency,
	          _ref$background = _ref.background,
	          background = _ref$background === undefined ? null : _ref$background;
	
	      var width = this.ctx.canvas.width;
	      var height = this.ctx.canvas.height;
	      this.ctx.save();
	      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
	      this.ctx.fillRect(0, 0, width, height);
	      this.ctx.restore();
	      if (transparency) {
	        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
	        this.compositeCtx = this.ctx;
	        this.transparentCanvas = transparentCanvas.canvas;
	        this.ctx = transparentCanvas.context;
	        this.ctx.save();
	        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
	      }
	      this.ctx.save();
	      resetCtxToDefault(this.ctx);
	      if (transform) {
	        this.ctx.transform.apply(this.ctx, transform);
	      }
	      this.ctx.transform.apply(this.ctx, viewport.transform);
	      this.baseTransform = this.ctx.mozCurrentTransform.slice();
	      if (this.imageLayer) {
	        this.imageLayer.beginLayout();
	      }
	    },
	
	    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
	      var argsArray = operatorList.argsArray;
	      var fnArray = operatorList.fnArray;
	      var i = executionStartIdx || 0;
	      var argsArrayLen = argsArray.length;
	      if (argsArrayLen === i) {
	        return i;
	      }
	      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
	      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
	      var steps = 0;
	      var commonObjs = this.commonObjs;
	      var objs = this.objs;
	      var fnId;
	      while (true) {
	        if (stepper !== undefined && i === stepper.nextBreakPoint) {
	          stepper.breakIt(i, continueCallback);
	          return i;
	        }
	        fnId = fnArray[i];
	        if (fnId !== _util.OPS.dependency) {
	          this[fnId].apply(this, argsArray[i]);
	        } else {
	          var deps = argsArray[i];
	          for (var n = 0, nn = deps.length; n < nn; n++) {
	            var depObjId = deps[n];
	            var common = depObjId[0] === 'g' && depObjId[1] === '_';
	            var objsPool = common ? commonObjs : objs;
	            if (!objsPool.isResolved(depObjId)) {
	              objsPool.get(depObjId, continueCallback);
	              return i;
	            }
	          }
	        }
	        i++;
	        if (i === argsArrayLen) {
	          return i;
	        }
	        if (chunkOperations && ++steps > EXECUTION_STEPS) {
	          if (Date.now() > endTime) {
	            continueCallback();
	            return i;
	          }
	          steps = 0;
	        }
	      }
	    },
	    endDrawing: function CanvasGraphics_endDrawing() {
	      if (this.current.activeSMask !== null) {
	        this.endSMaskGroup();
	      }
	      this.ctx.restore();
	      if (this.transparentCanvas) {
	        this.ctx = this.compositeCtx;
	        this.ctx.save();
	        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
	        this.ctx.drawImage(this.transparentCanvas, 0, 0);
	        this.ctx.restore();
	        this.transparentCanvas = null;
	      }
	      this.cachedCanvases.clear();
	      _webgl.WebGLUtils.clear();
	      if (this.imageLayer) {
	        this.imageLayer.endLayout();
	      }
	    },
	    setLineWidth: function CanvasGraphics_setLineWidth(width) {
	      this.current.lineWidth = width;
	      this.ctx.lineWidth = width;
	    },
	    setLineCap: function CanvasGraphics_setLineCap(style) {
	      this.ctx.lineCap = LINE_CAP_STYLES[style];
	    },
	    setLineJoin: function CanvasGraphics_setLineJoin(style) {
	      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
	    },
	    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
	      this.ctx.miterLimit = limit;
	    },
	    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
	      var ctx = this.ctx;
	      if (ctx.setLineDash !== undefined) {
	        ctx.setLineDash(dashArray);
	        ctx.lineDashOffset = dashPhase;
	      }
	    },
	    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
	    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
	    setGState: function CanvasGraphics_setGState(states) {
	      for (var i = 0, ii = states.length; i < ii; i++) {
	        var state = states[i];
	        var key = state[0];
	        var value = state[1];
	        switch (key) {
	          case 'LW':
	            this.setLineWidth(value);
	            break;
	          case 'LC':
	            this.setLineCap(value);
	            break;
	          case 'LJ':
	            this.setLineJoin(value);
	            break;
	          case 'ML':
	            this.setMiterLimit(value);
	            break;
	          case 'D':
	            this.setDash(value[0], value[1]);
	            break;
	          case 'RI':
	            this.setRenderingIntent(value);
	            break;
	          case 'FL':
	            this.setFlatness(value);
	            break;
	          case 'Font':
	            this.setFont(value[0], value[1]);
	            break;
	          case 'CA':
	            this.current.strokeAlpha = state[1];
	            break;
	          case 'ca':
	            this.current.fillAlpha = state[1];
	            this.ctx.globalAlpha = state[1];
	            break;
	          case 'BM':
	            this.ctx.globalCompositeOperation = value;
	            break;
	          case 'SMask':
	            if (this.current.activeSMask) {
	              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
	                this.suspendSMaskGroup();
	              } else {
	                this.endSMaskGroup();
	              }
	            }
	            this.current.activeSMask = value ? this.tempSMask : null;
	            if (this.current.activeSMask) {
	              this.beginSMaskGroup();
	            }
	            this.tempSMask = null;
	            break;
	        }
	      }
	    },
	    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
	      var activeSMask = this.current.activeSMask;
	      var drawnWidth = activeSMask.canvas.width;
	      var drawnHeight = activeSMask.canvas.height;
	      var cacheId = 'smaskGroupAt' + this.groupLevel;
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var currentCtx = this.ctx;
	      var currentTransform = currentCtx.mozCurrentTransform;
	      this.ctx.save();
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
	      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
	      this.ctx.restore();
	      this.ctx.save();
	      copyCtxState(groupCtx, this.ctx);
	      this.current.resumeSMaskCtx = groupCtx;
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	      groupCtx.save();
	      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
	      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
	      groupCtx.restore();
	    },
	    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.current.resumeSMaskCtx;
	      var currentCtx = this.ctx;
	      this.ctx = groupCtx;
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
	      this.ctx.restore();
	      copyCtxState(groupCtx, this.ctx);
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	    },
	    save: function CanvasGraphics_save() {
	      this.ctx.save();
	      var old = this.current;
	      this.stateStack.push(old);
	      this.current = old.clone();
	      this.current.resumeSMaskCtx = null;
	    },
	    restore: function CanvasGraphics_restore() {
	      if (this.current.resumeSMaskCtx) {
	        this.resumeSMaskGroup();
	      }
	      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
	        this.endSMaskGroup();
	      }
	      if (this.stateStack.length !== 0) {
	        this.current = this.stateStack.pop();
	        this.ctx.restore();
	        this.pendingClip = null;
	        this.cachedGetSinglePixelWidth = null;
	      }
	    },
	    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
	      this.ctx.transform(a, b, c, d, e, f);
	      this.cachedGetSinglePixelWidth = null;
	    },
	    constructPath: function CanvasGraphics_constructPath(ops, args) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var x = current.x,
	          y = current.y;
	      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
	        switch (ops[i] | 0) {
	          case _util.OPS.rectangle:
	            x = args[j++];
	            y = args[j++];
	            var width = args[j++];
	            var height = args[j++];
	            if (width === 0) {
	              width = this.getSinglePixelWidth();
	            }
	            if (height === 0) {
	              height = this.getSinglePixelWidth();
	            }
	            var xw = x + width;
	            var yh = y + height;
	            this.ctx.moveTo(x, y);
	            this.ctx.lineTo(xw, y);
	            this.ctx.lineTo(xw, yh);
	            this.ctx.lineTo(x, yh);
	            this.ctx.lineTo(x, y);
	            this.ctx.closePath();
	            break;
	          case _util.OPS.moveTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.moveTo(x, y);
	            break;
	          case _util.OPS.lineTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.lineTo(x, y);
	            break;
	          case _util.OPS.curveTo:
	            x = args[j + 4];
	            y = args[j + 5];
	            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
	            j += 6;
	            break;
	          case _util.OPS.curveTo2:
	            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
	            x = args[j + 2];
	            y = args[j + 3];
	            j += 4;
	            break;
	          case _util.OPS.curveTo3:
	            x = args[j + 2];
	            y = args[j + 3];
	            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
	            j += 4;
	            break;
	          case _util.OPS.closePath:
	            ctx.closePath();
	            break;
	        }
	      }
	      current.setCurrentPoint(x, y);
	    },
	    closePath: function CanvasGraphics_closePath() {
	      this.ctx.closePath();
	    },
	    stroke: function CanvasGraphics_stroke(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var strokeColor = this.current.strokeColor;
	      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
	      ctx.globalAlpha = this.current.strokeAlpha;
	      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
	        ctx.save();
	        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
	        ctx.stroke();
	        ctx.restore();
	      } else {
	        ctx.stroke();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	      ctx.globalAlpha = this.current.fillAlpha;
	    },
	    closeStroke: function CanvasGraphics_closeStroke() {
	      this.closePath();
	      this.stroke();
	    },
	    fill: function CanvasGraphics_fill(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var needRestore = false;
	      if (isPatternFill) {
	        ctx.save();
	        if (this.baseTransform) {
	          ctx.setTransform.apply(ctx, this.baseTransform);
	        }
	        ctx.fillStyle = fillColor.getPattern(ctx, this);
	        needRestore = true;
	      }
	      if (this.pendingEOFill) {
	        ctx.fill('evenodd');
	        this.pendingEOFill = false;
	      } else {
	        ctx.fill();
	      }
	      if (needRestore) {
	        ctx.restore();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	    },
	    eoFill: function CanvasGraphics_eoFill() {
	      this.pendingEOFill = true;
	      this.fill();
	    },
	    fillStroke: function CanvasGraphics_fillStroke() {
	      this.fill(false);
	      this.stroke(false);
	      this.consumePath();
	    },
	    eoFillStroke: function CanvasGraphics_eoFillStroke() {
	      this.pendingEOFill = true;
	      this.fillStroke();
	    },
	    closeFillStroke: function CanvasGraphics_closeFillStroke() {
	      this.closePath();
	      this.fillStroke();
	    },
	    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
	      this.pendingEOFill = true;
	      this.closePath();
	      this.fillStroke();
	    },
	    endPath: function CanvasGraphics_endPath() {
	      this.consumePath();
	    },
	    clip: function CanvasGraphics_clip() {
	      this.pendingClip = NORMAL_CLIP;
	    },
	    eoClip: function CanvasGraphics_eoClip() {
	      this.pendingClip = EO_CLIP;
	    },
	    beginText: function CanvasGraphics_beginText() {
	      this.current.textMatrix = _util.IDENTITY_MATRIX;
	      this.current.textMatrixScale = 1;
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    endText: function CanvasGraphics_endText() {
	      var paths = this.pendingTextPaths;
	      var ctx = this.ctx;
	      if (paths === undefined) {
	        ctx.beginPath();
	        return;
	      }
	      ctx.save();
	      ctx.beginPath();
	      for (var i = 0; i < paths.length; i++) {
	        var path = paths[i];
	        ctx.setTransform.apply(ctx, path.transform);
	        ctx.translate(path.x, path.y);
	        path.addToPath(ctx, path.fontSize);
	      }
	      ctx.restore();
	      ctx.clip();
	      ctx.beginPath();
	      delete this.pendingTextPaths;
	    },
	    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
	      this.current.charSpacing = spacing;
	    },
	    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
	      this.current.wordSpacing = spacing;
	    },
	    setHScale: function CanvasGraphics_setHScale(scale) {
	      this.current.textHScale = scale / 100;
	    },
	    setLeading: function CanvasGraphics_setLeading(leading) {
	      this.current.leading = -leading;
	    },
	    setFont: function CanvasGraphics_setFont(fontRefName, size) {
	      var fontObj = this.commonObjs.get(fontRefName);
	      var current = this.current;
	      if (!fontObj) {
	        throw new Error('Can\'t find font for ' + fontRefName);
	      }
	      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
	        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
	      }
	      if (size < 0) {
	        size = -size;
	        current.fontDirection = -1;
	      } else {
	        current.fontDirection = 1;
	      }
	      this.current.font = fontObj;
	      this.current.fontSize = size;
	      if (fontObj.isType3Font) {
	        return;
	      }
	      var name = fontObj.loadedName || 'sans-serif';
	      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
	      var italic = fontObj.italic ? 'italic' : 'normal';
	      var typeface = '"' + name + '", ' + fontObj.fallbackName;
	      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
	      this.current.fontSizeScale = size / browserFontSize;
	      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
	      this.ctx.font = rule;
	    },
	    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
	      this.current.textRenderingMode = mode;
	    },
	    setTextRise: function CanvasGraphics_setTextRise(rise) {
	      this.current.textRise = rise;
	    },
	    moveText: function CanvasGraphics_moveText(x, y) {
	      this.current.x = this.current.lineX += x;
	      this.current.y = this.current.lineY += y;
	    },
	    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
	      this.setLeading(-y);
	      this.moveText(x, y);
	    },
	    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
	      this.current.textMatrix = [a, b, c, d, e, f];
	      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    nextLine: function CanvasGraphics_nextLine() {
	      this.moveText(0, this.current.leading);
	    },
	    paintChar: function CanvasGraphics_paintChar(character, x, y) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var textRenderingMode = current.textRenderingMode;
	      var fontSize = current.fontSize / current.fontSizeScale;
	      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
	      var addToPath;
	      if (font.disableFontFace || isAddToPathSet) {
	        addToPath = font.getPathGenerator(this.commonObjs, character);
	      }
	      if (font.disableFontFace) {
	        ctx.save();
	        ctx.translate(x, y);
	        ctx.beginPath();
	        addToPath(ctx, fontSize);
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fill();
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.stroke();
	        }
	        ctx.restore();
	      } else {
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fillText(character, x, y);
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.strokeText(character, x, y);
	        }
	      }
	      if (isAddToPathSet) {
	        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
	        paths.push({
	          transform: ctx.mozCurrentTransform,
	          x: x,
	          y: y,
	          fontSize: fontSize,
	          addToPath: addToPath
	        });
	      }
	    },
	    get isFontSubpixelAAEnabled() {
	      var ctx = this.canvasFactory.create(10, 10).context;
	      ctx.scale(1.5, 1);
	      ctx.fillText('I', 0, 10);
	      var data = ctx.getImageData(0, 0, 10, 10).data;
	      var enabled = false;
	      for (var i = 3; i < data.length; i += 4) {
	        if (data[i] > 0 && data[i] < 255) {
	          enabled = true;
	          break;
	        }
	      }
	      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
	    },
	    showText: function CanvasGraphics_showText(glyphs) {
	      var current = this.current;
	      var font = current.font;
	      if (font.isType3Font) {
	        return this.showType3Text(glyphs);
	      }
	      var fontSize = current.fontSize;
	      if (fontSize === 0) {
	        return;
	      }
	      var ctx = this.ctx;
	      var fontSizeScale = current.fontSizeScale;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var fontDirection = current.fontDirection;
	      var textHScale = current.textHScale * fontDirection;
	      var glyphsLength = glyphs.length;
	      var vertical = font.vertical;
	      var spacingDir = vertical ? 1 : -1;
	      var defaultVMetrics = font.defaultVMetrics;
	      var widthAdvanceScale = fontSize * current.fontMatrix[0];
	      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y + current.textRise);
	      if (current.patternFill) {
	        ctx.fillStyle = current.fillColor.getPattern(ctx, this);
	      }
	      if (fontDirection > 0) {
	        ctx.scale(textHScale, -1);
	      } else {
	        ctx.scale(textHScale, 1);
	      }
	      var lineWidth = current.lineWidth;
	      var scale = current.textMatrixScale;
	      if (scale === 0 || lineWidth === 0) {
	        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          this.cachedGetSinglePixelWidth = null;
	          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
	        }
	      } else {
	        lineWidth /= scale;
	      }
	      if (fontSizeScale !== 1.0) {
	        ctx.scale(fontSizeScale, fontSizeScale);
	        lineWidth /= fontSizeScale;
	      }
	      ctx.lineWidth = lineWidth;
	      var x = 0,
	          i;
	      for (i = 0; i < glyphsLength; ++i) {
	        var glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          x += spacingDir * glyph * fontSize / 1000;
	          continue;
	        }
	        var restoreNeeded = false;
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var character = glyph.fontChar;
	        var accent = glyph.accent;
	        var scaledX, scaledY, scaledAccentX, scaledAccentY;
	        var width = glyph.width;
	        if (vertical) {
	          var vmetric, vx, vy;
	          vmetric = glyph.vmetric || defaultVMetrics;
	          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
	          vx = -vx * widthAdvanceScale;
	          vy = vmetric[2] * widthAdvanceScale;
	          width = vmetric ? -vmetric[0] : width;
	          scaledX = vx / fontSizeScale;
	          scaledY = (x + vy) / fontSizeScale;
	        } else {
	          scaledX = x / fontSizeScale;
	          scaledY = 0;
	        }
	        if (font.remeasure && width > 0) {
	          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
	          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
	            var characterScaleX = width / measuredWidth;
	            restoreNeeded = true;
	            ctx.save();
	            ctx.scale(characterScaleX, 1);
	            scaledX /= characterScaleX;
	          } else if (width !== measuredWidth) {
	            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
	          }
	        }
	        if (glyph.isInFont || font.missingFile) {
	          if (simpleFillText && !accent) {
	            ctx.fillText(character, scaledX, scaledY);
	          } else {
	            this.paintChar(character, scaledX, scaledY);
	            if (accent) {
	              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
	              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
	              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY);
	            }
	          }
	        }
	        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	        x += charWidth;
	        if (restoreNeeded) {
	          ctx.restore();
	        }
	      }
	      if (vertical) {
	        current.y -= x * textHScale;
	      } else {
	        current.x += x * textHScale;
	      }
	      ctx.restore();
	    },
	    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var fontSize = current.fontSize;
	      var fontDirection = current.fontDirection;
	      var spacingDir = font.vertical ? 1 : -1;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var textHScale = current.textHScale * fontDirection;
	      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
	      var glyphsLength = glyphs.length;
	      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
	      var i, glyph, width, spacingLength;
	      if (isTextInvisible || fontSize === 0) {
	        return;
	      }
	      this.cachedGetSinglePixelWidth = null;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y);
	      ctx.scale(textHScale, fontDirection);
	      for (i = 0; i < glyphsLength; ++i) {
	        glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          spacingLength = spacingDir * glyph * fontSize / 1000;
	          this.ctx.translate(spacingLength, 0);
	          current.x += spacingLength * textHScale;
	          continue;
	        }
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var operatorList = font.charProcOperatorList[glyph.operatorListId];
	        if (!operatorList) {
	          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
	          continue;
	        }
	        this.processingType3 = glyph;
	        this.save();
	        ctx.scale(fontSize, fontSize);
	        ctx.transform.apply(ctx, fontMatrix);
	        this.executeOperatorList(operatorList);
	        this.restore();
	        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
	        width = transformed[0] * fontSize + spacing;
	        ctx.translate(width, 0);
	        current.x += width * textHScale;
	      }
	      ctx.restore();
	      this.processingType3 = null;
	    },
	    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
	    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
	      this.ctx.rect(llx, lly, urx - llx, ury - lly);
	      this.clip();
	      this.endPath();
	    },
	    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
	      var _this = this;
	
	      var pattern;
	      if (IR[0] === 'TilingPattern') {
	        var color = IR[1];
	        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
	        var canvasGraphicsFactory = {
	          createCanvasGraphics: function createCanvasGraphics(ctx) {
	            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
	          }
	        };
	        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
	      } else {
	        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
	      }
	      return pattern;
	    },
	    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
	      this.current.strokeColor = this.getColorN_Pattern(arguments);
	    },
	    setFillColorN: function CanvasGraphics_setFillColorN() {
	      this.current.fillColor = this.getColorN_Pattern(arguments);
	      this.current.patternFill = true;
	    },
	    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.strokeStyle = color;
	      this.current.strokeColor = color;
	    },
	    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.fillStyle = color;
	      this.current.fillColor = color;
	      this.current.patternFill = false;
	    },
	    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
	      var ctx = this.ctx;
	      this.save();
	      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
	      ctx.fillStyle = pattern.getPattern(ctx, this, true);
	      var inv = ctx.mozCurrentTransformInverse;
	      if (inv) {
	        var canvas = ctx.canvas;
	        var width = canvas.width;
	        var height = canvas.height;
	        var bl = _util.Util.applyTransform([0, 0], inv);
	        var br = _util.Util.applyTransform([0, height], inv);
	        var ul = _util.Util.applyTransform([width, 0], inv);
	        var ur = _util.Util.applyTransform([width, height], inv);
	        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
	        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
	        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
	        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
	        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
	      } else {
	        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
	      }
	      this.restore();
	    },
	    beginInlineImage: function CanvasGraphics_beginInlineImage() {
	      throw new Error('Should not call beginInlineImage');
	    },
	    beginImageData: function CanvasGraphics_beginImageData() {
	      throw new Error('Should not call beginImageData');
	    },
	    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
	      this.save();
	      this.baseTransformStack.push(this.baseTransform);
	      if (Array.isArray(matrix) && matrix.length === 6) {
	        this.transform.apply(this, matrix);
	      }
	      this.baseTransform = this.ctx.mozCurrentTransform;
	      if (Array.isArray(bbox) && bbox.length === 4) {
	        var width = bbox[2] - bbox[0];
	        var height = bbox[3] - bbox[1];
	        this.ctx.rect(bbox[0], bbox[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	    },
	    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
	      this.restore();
	      this.baseTransform = this.baseTransformStack.pop();
	    },
	    beginGroup: function CanvasGraphics_beginGroup(group) {
	      this.save();
	      var currentCtx = this.ctx;
	      if (!group.isolated) {
	        (0, _util.info)('TODO: Support non-isolated groups.');
	      }
	      if (group.knockout) {
	        (0, _util.warn)('Knockout groups not supported.');
	      }
	      var currentTransform = currentCtx.mozCurrentTransform;
	      if (group.matrix) {
	        currentCtx.transform.apply(currentCtx, group.matrix);
	      }
	      if (!group.bbox) {
	        throw new Error('Bounding box is required.');
	      }
	      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
	      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
	      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
	      var offsetX = Math.floor(bounds[0]);
	      var offsetY = Math.floor(bounds[1]);
	      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
	      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
	      var scaleX = 1,
	          scaleY = 1;
	      if (drawnWidth > MAX_GROUP_SIZE) {
	        scaleX = drawnWidth / MAX_GROUP_SIZE;
	        drawnWidth = MAX_GROUP_SIZE;
	      }
	      if (drawnHeight > MAX_GROUP_SIZE) {
	        scaleY = drawnHeight / MAX_GROUP_SIZE;
	        drawnHeight = MAX_GROUP_SIZE;
	      }
	      var cacheId = 'groupAt' + this.groupLevel;
	      if (group.smask) {
	        cacheId += '_smask_' + this.smaskCounter++ % 2;
	      }
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / scaleX, 1 / scaleY);
	      groupCtx.translate(-offsetX, -offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      if (group.smask) {
	        this.smaskStack.push({
	          canvas: scratchCanvas.canvas,
	          context: groupCtx,
	          offsetX: offsetX,
	          offsetY: offsetY,
	          scaleX: scaleX,
	          scaleY: scaleY,
	          subtype: group.smask.subtype,
	          backdrop: group.smask.backdrop,
	          transferMap: group.smask.transferMap || null,
	          startTransformInverse: null
	        });
	      } else {
	        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
	        currentCtx.translate(offsetX, offsetY);
	        currentCtx.scale(scaleX, scaleY);
	      }
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	      this.current.activeSMask = null;
	    },
	    endGroup: function CanvasGraphics_endGroup(group) {
	      this.groupLevel--;
	      var groupCtx = this.ctx;
	      this.ctx = this.groupStack.pop();
	      if (this.ctx.imageSmoothingEnabled !== undefined) {
	        this.ctx.imageSmoothingEnabled = false;
	      } else {
	        this.ctx.mozImageSmoothingEnabled = false;
	      }
	      if (group.smask) {
	        this.tempSMask = this.smaskStack.pop();
	      } else {
	        this.ctx.drawImage(groupCtx.canvas, 0, 0);
	      }
	      this.restore();
	    },
	    beginAnnotations: function CanvasGraphics_beginAnnotations() {
	      this.save();
	      if (this.baseTransform) {
	        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
	      }
	    },
	    endAnnotations: function CanvasGraphics_endAnnotations() {
	      this.restore();
	    },
	    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
	      this.save();
	      resetCtxToDefault(this.ctx);
	      this.current = new CanvasExtraState();
	      if (Array.isArray(rect) && rect.length === 4) {
	        var width = rect[2] - rect[0];
	        var height = rect[3] - rect[1];
	        this.ctx.rect(rect[0], rect[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	      this.transform.apply(this, transform);
	      this.transform.apply(this, matrix);
	    },
	    endAnnotation: function CanvasGraphics_endAnnotation() {
	      this.restore();
	    },
	    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
	      var domImage = this.objs.get(objId);
	      if (!domImage) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.save();
	      var ctx = this.ctx;
	      ctx.scale(1 / w, -1 / h);
	      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
	      if (this.imageLayer) {
	        var currentTransform = ctx.mozCurrentTransformInverse;
	        var position = this.getCanvasPosition(0, 0);
	        this.imageLayer.appendImage({
	          objId: objId,
	          left: position[0],
	          top: position[1],
	          width: w / currentTransform[0],
	          height: h / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
	      var ctx = this.ctx;
	      var width = img.width,
	          height = img.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var glyph = this.processingType3;
	      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
	        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
	          glyph.compiled = compileType3Glyph({
	            data: img.data,
	            width: width,
	            height: height
	          });
	        } else {
	          glyph.compiled = null;
	        }
	      }
	      if (glyph && glyph.compiled) {
	        glyph.compiled(ctx);
	        return;
	      }
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, img);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      this.paintInlineImageXObject(maskCanvas.canvas);
	    },
	    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, imgData);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      var ctx = this.ctx;
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        ctx.save();
	        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      for (var i = 0, ii = images.length; i < ii; i++) {
	        var image = images[i];
	        var width = image.width,
	            height = image.height;
	        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	        var maskCtx = maskCanvas.context;
	        maskCtx.save();
	        putBinaryImageMask(maskCtx, image);
	        maskCtx.globalCompositeOperation = 'source-in';
	        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	        maskCtx.fillRect(0, 0, width, height);
	        maskCtx.restore();
	        ctx.save();
	        ctx.transform.apply(ctx, image.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.paintInlineImageXObject(imgData);
	    },
	    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      var width = imgData.width;
	      var height = imgData.height;
	      var map = [];
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        map.push({
	          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
	          x: 0,
	          y: 0,
	          w: width,
	          h: height
	        });
	      }
	      this.paintInlineImageXObjectGroup(imgData, map);
	    },
	    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var ctx = this.ctx;
	      this.save();
	      ctx.scale(1 / width, -1 / height);
	      var currentTransform = ctx.mozCurrentTransformInverse;
	      var a = currentTransform[0],
	          b = currentTransform[1];
	      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
	      var c = currentTransform[2],
	          d = currentTransform[3];
	      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
	      var imgToPaint, tmpCanvas;
	      if (imgData instanceof HTMLElement || !imgData.data) {
	        imgToPaint = imgData;
	      } else {
	        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
	        var tmpCtx = tmpCanvas.context;
	        putBinaryImageData(tmpCtx, imgData);
	        imgToPaint = tmpCanvas.canvas;
	      }
	      var paintWidth = width,
	          paintHeight = height;
	      var tmpCanvasId = 'prescale1';
	      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
	        var newWidth = paintWidth,
	            newHeight = paintHeight;
	        if (widthScale > 2 && paintWidth > 1) {
	          newWidth = Math.ceil(paintWidth / 2);
	          widthScale /= paintWidth / newWidth;
	        }
	        if (heightScale > 2 && paintHeight > 1) {
	          newHeight = Math.ceil(paintHeight / 2);
	          heightScale /= paintHeight / newHeight;
	        }
	        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
	        tmpCtx = tmpCanvas.context;
	        tmpCtx.clearRect(0, 0, newWidth, newHeight);
	        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
	        imgToPaint = tmpCanvas.canvas;
	        paintWidth = newWidth;
	        paintHeight = newHeight;
	        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
	      }
	      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
	      if (this.imageLayer) {
	        var position = this.getCanvasPosition(0, -height);
	        this.imageLayer.appendImage({
	          imgData: imgData,
	          left: position[0],
	          top: position[1],
	          width: width / currentTransform[0],
	          height: height / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
	      var ctx = this.ctx;
	      var w = imgData.width;
	      var h = imgData.height;
	      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
	      var tmpCtx = tmpCanvas.context;
	      putBinaryImageData(tmpCtx, imgData);
	      for (var i = 0, ii = map.length; i < ii; i++) {
	        var entry = map[i];
	        ctx.save();
	        ctx.transform.apply(ctx, entry.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
	        if (this.imageLayer) {
	          var position = this.getCanvasPosition(entry.x, entry.y);
	          this.imageLayer.appendImage({
	            imgData: imgData,
	            left: position[0],
	            top: position[1],
	            width: w,
	            height: h
	          });
	        }
	        ctx.restore();
	      }
	    },
	    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
	      this.ctx.fillRect(0, 0, 1, 1);
	    },
	    paintXObject: function CanvasGraphics_paintXObject() {
	      (0, _util.warn)('Unsupported \'paintXObject\' command.');
	    },
	    markPoint: function CanvasGraphics_markPoint(tag) {},
	    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
	    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
	    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
	    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
	    beginCompat: function CanvasGraphics_beginCompat() {},
	    endCompat: function CanvasGraphics_endCompat() {},
	    consumePath: function CanvasGraphics_consumePath() {
	      var ctx = this.ctx;
	      if (this.pendingClip) {
	        if (this.pendingClip === EO_CLIP) {
	          ctx.clip('evenodd');
	        } else {
	          ctx.clip();
	        }
	        this.pendingClip = null;
	      }
	      ctx.beginPath();
	    },
	    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
	      if (this.cachedGetSinglePixelWidth === null) {
	        this.ctx.save();
	        var inverse = this.ctx.mozCurrentTransformInverse;
	        this.ctx.restore();
	        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
	      }
	      return this.cachedGetSinglePixelWidth;
	    },
	    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
	      var transform = this.ctx.mozCurrentTransform;
	      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
	    }
	  };
	  for (var op in _util.OPS) {
	    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
	  }
	  return CanvasGraphics;
	}();
	exports.CanvasGraphics = CanvasGraphics;
	
	/***/ }),
	/* 121 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TilingPattern = exports.getShadingPatternFromIR = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _webgl = __w_pdfjs_require__(70);
	
	var ShadingIRs = {};
	ShadingIRs.RadialAxial = {
	  fromIR: function RadialAxial_fromIR(raw) {
	    var type = raw[1];
	    var colorStops = raw[2];
	    var p0 = raw[3];
	    var p1 = raw[4];
	    var r0 = raw[5];
	    var r1 = raw[6];
	    return {
	      type: 'Pattern',
	      getPattern: function RadialAxial_getPattern(ctx) {
	        var grad;
	        if (type === 'axial') {
	          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
	        } else if (type === 'radial') {
	          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
	        }
	        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
	          var c = colorStops[i];
	          grad.addColorStop(c[0], c[1]);
	        }
	        return grad;
	      }
	    };
	  }
	};
	var createMeshCanvas = function createMeshCanvasClosure() {
	  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
	    var coords = context.coords,
	        colors = context.colors;
	    var bytes = data.data,
	        rowSize = data.width * 4;
	    var tmp;
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    if (coords[p2 + 1] > coords[p3 + 1]) {
	      tmp = p2;
	      p2 = p3;
	      p3 = tmp;
	      tmp = c2;
	      c2 = c3;
	      c3 = tmp;
	    }
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
	    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
	    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
	    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
	    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
	    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
	    if (y1 >= y3) {
	      return;
	    }
	    var c1r = colors[c1],
	        c1g = colors[c1 + 1],
	        c1b = colors[c1 + 2];
	    var c2r = colors[c2],
	        c2g = colors[c2 + 1],
	        c2b = colors[c2 + 2];
	    var c3r = colors[c3],
	        c3g = colors[c3 + 1],
	        c3b = colors[c3 + 2];
	    var minY = Math.round(y1),
	        maxY = Math.round(y3);
	    var xa, car, cag, cab;
	    var xb, cbr, cbg, cbb;
	    var k;
	    for (var y = minY; y <= maxY; y++) {
	      if (y < y2) {
	        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
	        xa = x1 - (x1 - x2) * k;
	        car = c1r - (c1r - c2r) * k;
	        cag = c1g - (c1g - c2g) * k;
	        cab = c1b - (c1b - c2b) * k;
	      } else {
	        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
	        xa = x2 - (x2 - x3) * k;
	        car = c2r - (c2r - c3r) * k;
	        cag = c2g - (c2g - c3g) * k;
	        cab = c2b - (c2b - c3b) * k;
	      }
	      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
	      xb = x1 - (x1 - x3) * k;
	      cbr = c1r - (c1r - c3r) * k;
	      cbg = c1g - (c1g - c3g) * k;
	      cbb = c1b - (c1b - c3b) * k;
	      var x1_ = Math.round(Math.min(xa, xb));
	      var x2_ = Math.round(Math.max(xa, xb));
	      var j = rowSize * y + x1_ * 4;
	      for (var x = x1_; x <= x2_; x++) {
	        k = (xa - x) / (xa - xb);
	        k = k < 0 ? 0 : k > 1 ? 1 : k;
	        bytes[j++] = car - (car - cbr) * k | 0;
	        bytes[j++] = cag - (cag - cbg) * k | 0;
	        bytes[j++] = cab - (cab - cbb) * k | 0;
	        bytes[j++] = 255;
	      }
	    }
	  }
	  function drawFigure(data, figure, context) {
	    var ps = figure.coords;
	    var cs = figure.colors;
	    var i, ii;
	    switch (figure.type) {
	      case 'lattice':
	        var verticesPerRow = figure.verticesPerRow;
	        var rows = Math.floor(ps.length / verticesPerRow) - 1;
	        var cols = verticesPerRow - 1;
	        for (i = 0; i < rows; i++) {
	          var q = i * verticesPerRow;
	          for (var j = 0; j < cols; j++, q++) {
	            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
	            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
	          }
	        }
	        break;
	      case 'triangles':
	        for (i = 0, ii = ps.length; i < ii; i += 3) {
	          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
	        }
	        break;
	      default:
	        throw new Error('illegal figure');
	    }
	  }
	  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases) {
	    var EXPECTED_SCALE = 1.1;
	    var MAX_PATTERN_SIZE = 3000;
	    var BORDER_SIZE = 2;
	    var offsetX = Math.floor(bounds[0]);
	    var offsetY = Math.floor(bounds[1]);
	    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
	    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
	    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var scaleX = boundsWidth / width;
	    var scaleY = boundsHeight / height;
	    var context = {
	      coords: coords,
	      colors: colors,
	      offsetX: -offsetX,
	      offsetY: -offsetY,
	      scaleX: 1 / scaleX,
	      scaleY: 1 / scaleY
	    };
	    var paddedWidth = width + BORDER_SIZE * 2;
	    var paddedHeight = height + BORDER_SIZE * 2;
	    var canvas, tmpCanvas, i, ii;
	    if (_webgl.WebGLUtils.isEnabled) {
	      canvas = _webgl.WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    } else {
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      var tmpCtx = tmpCanvas.context;
	      var data = tmpCtx.createImageData(width, height);
	      if (backgroundColor) {
	        var bytes = data.data;
	        for (i = 0, ii = bytes.length; i < ii; i += 4) {
	          bytes[i] = backgroundColor[0];
	          bytes[i + 1] = backgroundColor[1];
	          bytes[i + 2] = backgroundColor[2];
	          bytes[i + 3] = 255;
	        }
	      }
	      for (i = 0; i < figures.length; i++) {
	        drawFigure(data, figures[i], context);
	      }
	      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    }
	    return {
	      canvas: canvas,
	      offsetX: offsetX - BORDER_SIZE * scaleX,
	      offsetY: offsetY - BORDER_SIZE * scaleY,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	  return createMeshCanvas;
	}();
	ShadingIRs.Mesh = {
	  fromIR: function Mesh_fromIR(raw) {
	    var coords = raw[2];
	    var colors = raw[3];
	    var figures = raw[4];
	    var bounds = raw[5];
	    var matrix = raw[6];
	    var background = raw[8];
	    return {
	      type: 'Pattern',
	      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
	        var scale;
	        if (shadingFill) {
	          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
	        } else {
	          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
	          if (matrix) {
	            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
	            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
	          }
	        }
	        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases);
	        if (!shadingFill) {
	          ctx.setTransform.apply(ctx, owner.baseTransform);
	          if (matrix) {
	            ctx.transform.apply(ctx, matrix);
	          }
	        }
	        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
	        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
	        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
	      }
	    };
	  }
	};
	ShadingIRs.Dummy = {
	  fromIR: function Dummy_fromIR() {
	    return {
	      type: 'Pattern',
	      getPattern: function Dummy_fromIR_getPattern() {
	        return 'hotpink';
	      }
	    };
	  }
	};
	function getShadingPatternFromIR(raw) {
	  var shadingIR = ShadingIRs[raw[0]];
	  if (!shadingIR) {
	    throw new Error('Unknown IR type: ' + raw[0]);
	  }
	  return shadingIR.fromIR(raw);
	}
	var TilingPattern = function TilingPatternClosure() {
	  var PaintType = {
	    COLORED: 1,
	    UNCOLORED: 2
	  };
	  var MAX_PATTERN_SIZE = 3000;
	  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
	    this.operatorList = IR[2];
	    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
	    this.bbox = IR[4];
	    this.xstep = IR[5];
	    this.ystep = IR[6];
	    this.paintType = IR[7];
	    this.tilingType = IR[8];
	    this.color = color;
	    this.canvasGraphicsFactory = canvasGraphicsFactory;
	    this.baseTransform = baseTransform;
	    this.type = 'Pattern';
	    this.ctx = ctx;
	  }
	  TilingPattern.prototype = {
	    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
	      var operatorList = this.operatorList;
	      var bbox = this.bbox;
	      var xstep = this.xstep;
	      var ystep = this.ystep;
	      var paintType = this.paintType;
	      var tilingType = this.tilingType;
	      var color = this.color;
	      var canvasGraphicsFactory = this.canvasGraphicsFactory;
	      (0, _util.info)('TilingType: ' + tilingType);
	      var x0 = bbox[0],
	          y0 = bbox[1],
	          x1 = bbox[2],
	          y1 = bbox[3];
	      var topLeft = [x0, y0];
	      var botRight = [x0 + xstep, y0 + ystep];
	      var width = botRight[0] - topLeft[0];
	      var height = botRight[1] - topLeft[1];
	      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
	      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
	      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
	      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
	      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
	      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
	      var tmpCtx = tmpCanvas.context;
	      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
	      graphics.groupLevel = owner.groupLevel;
	      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
	      this.setScale(width, height, xstep, ystep);
	      this.transformToScale(graphics);
	      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
	      graphics.transform.apply(graphics, tmpTranslate);
	      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
	      graphics.executeOperatorList(operatorList);
	      return tmpCanvas.canvas;
	    },
	    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
	      this.scale = [width / xstep, height / ystep];
	    },
	    transformToScale: function TilingPattern_transformToScale(graphics) {
	      var scale = this.scale;
	      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
	      graphics.transform.apply(graphics, tmpScale);
	    },
	    scaleToContext: function TilingPattern_scaleToContext() {
	      var scale = this.scale;
	      this.ctx.scale(1 / scale[0], 1 / scale[1]);
	    },
	    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
	      if (Array.isArray(bbox) && bbox.length === 4) {
	        var bboxWidth = x1 - x0;
	        var bboxHeight = y1 - y0;
	        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
	        graphics.clip();
	        graphics.endPath();
	      }
	    },
	    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
	      var context = graphics.ctx,
	          current = graphics.current;
	      switch (paintType) {
	        case PaintType.COLORED:
	          var ctx = this.ctx;
	          context.fillStyle = ctx.fillStyle;
	          context.strokeStyle = ctx.strokeStyle;
	          current.fillColor = ctx.fillStyle;
	          current.strokeColor = ctx.strokeStyle;
	          break;
	        case PaintType.UNCOLORED:
	          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
	          context.fillStyle = cssColor;
	          context.strokeStyle = cssColor;
	          current.fillColor = cssColor;
	          current.strokeColor = cssColor;
	          break;
	        default:
	          throw new _util.FormatError('Unsupported paint type: ' + paintType);
	      }
	    },
	    getPattern: function TilingPattern_getPattern(ctx, owner) {
	      var temporaryPatternCanvas = this.createPatternCanvas(owner);
	      ctx = this.ctx;
	      ctx.setTransform.apply(ctx, this.baseTransform);
	      ctx.transform.apply(ctx, this.matrix);
	      this.scaleToContext();
	      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
	    }
	  };
	  return TilingPattern;
	}();
	exports.getShadingPatternFromIR = getShadingPatternFromIR;
	exports.TilingPattern = TilingPattern;
	
	/***/ }),
	/* 122 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var XMLParserErrorCode = {
	  NoError: 0,
	  EndOfDocument: -1,
	  UnterminatedCdat: -2,
	  UnterminatedXmlDeclaration: -3,
	  UnterminatedDoctypeDeclaration: -4,
	  UnterminatedComment: -5,
	  MalformedElement: -6,
	  OutOfMemory: -7,
	  UnterminatedAttributeValue: -8,
	  UnterminatedElement: -9,
	  ElementNeverBegun: -10
	};
	function isWhitespace(s, index) {
	  var ch = s[index];
	  return ch === ' ' || ch === '\n' || ch === '\r' || ch === '\t';
	}
	function isWhitespaceString(s) {
	  for (var i = 0, ii = s.length; i < ii; i++) {
	    if (!isWhitespace(s, i)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var XMLParserBase = function () {
	  function XMLParserBase() {
	    _classCallCheck(this, XMLParserBase);
	  }
	
	  _createClass(XMLParserBase, [{
	    key: '_resolveEntities',
	    value: function _resolveEntities(s) {
	      return s.replace(/&([^;]+);/g, function (all, entity) {
	        if (entity.substring(0, 2) === '#x') {
	          return String.fromCharCode(parseInt(entity.substring(2), 16));
	        } else if (entity.substring(0, 1) === '#') {
	          return String.fromCharCode(parseInt(entity.substring(1), 10));
	        }
	        switch (entity) {
	          case 'lt':
	            return '<';
	          case 'gt':
	            return '>';
	          case 'amp':
	            return '&';
	          case 'quot':
	            return '\"';
	        }
	        return this.onResolveEntity(entity);
	      });
	    }
	  }, {
	    key: '_parseContent',
	    value: function _parseContent(s, start) {
	      var pos = start,
	          name = void 0,
	          attributes = [];
	      function skipWs() {
	        while (pos < s.length && isWhitespace(s, pos)) {
	          ++pos;
	        }
	      }
	      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
	        ++pos;
	      }
	      name = s.substring(start, pos);
	      skipWs();
	      while (pos < s.length && s[pos] !== '>' && s[pos] !== '/' && s[pos] !== '?') {
	        skipWs();
	        var attrName = '',
	            attrValue = '';
	        while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '=') {
	          attrName += s[pos];
	          ++pos;
	        }
	        skipWs();
	        if (s[pos] !== '=') {
	          return null;
	        }
	        ++pos;
	        skipWs();
	        var attrEndChar = s[pos];
	        if (attrEndChar !== '\"' && attrEndChar !== '\'') {
	          return null;
	        }
	        var attrEndIndex = s.indexOf(attrEndChar, ++pos);
	        if (attrEndIndex < 0) {
	          return null;
	        }
	        attrValue = s.substring(pos, attrEndIndex);
	        attributes.push({
	          name: attrName,
	          value: this._resolveEntities(attrValue)
	        });
	        pos = attrEndIndex + 1;
	        skipWs();
	      }
	      return {
	        name: name,
	        attributes: attributes,
	        parsed: pos - start
	      };
	    }
	  }, {
	    key: '_parseProcessingInstruction',
	    value: function _parseProcessingInstruction(s, start) {
	      var pos = start,
	          name = void 0,
	          value = void 0;
	      function skipWs() {
	        while (pos < s.length && isWhitespace(s, pos)) {
	          ++pos;
	        }
	      }
	      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
	        ++pos;
	      }
	      name = s.substring(start, pos);
	      skipWs();
	      var attrStart = pos;
	      while (pos < s.length && (s[pos] !== '?' || s[pos + 1] !== '>')) {
	        ++pos;
	      }
	      value = s.substring(attrStart, pos);
	      return {
	        name: name,
	        value: value,
	        parsed: pos - start
	      };
	    }
	  }, {
	    key: 'parseXml',
	    value: function parseXml(s) {
	      var i = 0;
	      while (i < s.length) {
	        var ch = s[i];
	        var j = i;
	        if (ch === '<') {
	          ++j;
	          var ch2 = s[j];
	          var q = void 0;
	          switch (ch2) {
	            case '/':
	              ++j;
	              q = s.indexOf('>', j);
	              if (q < 0) {
	                this.onError(XMLParserErrorCode.UnterminatedElement);
	                return;
	              }
	              this.onEndElement(s.substring(j, q));
	              j = q + 1;
	              break;
	            case '?':
	              ++j;
	              var pi = this._parseProcessingInstruction(s, j);
	              if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== '?>') {
	                this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
	                return;
	              }
	              this.onPi(pi.name, pi.value);
	              j += pi.parsed + 2;
	              break;
	            case '!':
	              if (s.substring(j + 1, j + 3) === '--') {
	                q = s.indexOf('-->', j + 3);
	                if (q < 0) {
	                  this.onError(XMLParserErrorCode.UnterminatedComment);
	                  return;
	                }
	                this.onComment(s.substring(j + 3, q));
	                j = q + 3;
	              } else if (s.substring(j + 1, j + 8) === '[CDATA[') {
	                q = s.indexOf(']]>', j + 8);
	                if (q < 0) {
	                  this.onError(XMLParserErrorCode.UnterminatedCdat);
	                  return;
	                }
	                this.onCdata(s.substring(j + 8, q));
	                j = q + 3;
	              } else if (s.substring(j + 1, j + 8) === 'DOCTYPE') {
	                var q2 = s.indexOf('[', j + 8);
	                var complexDoctype = false;
	                q = s.indexOf('>', j + 8);
	                if (q < 0) {
	                  this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
	                  return;
	                }
	                if (q2 > 0 && q > q2) {
	                  q = s.indexOf(']>', j + 8);
	                  if (q < 0) {
	                    this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
	                    return;
	                  }
	                  complexDoctype = true;
	                }
	                var doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
	                this.onDoctype(doctypeContent);
	                j = q + (complexDoctype ? 2 : 1);
	              } else {
	                this.onError(XMLParserErrorCode.MalformedElement);
	                return;
	              }
	              break;
	            default:
	              var content = this._parseContent(s, j);
	              if (content === null) {
	                this.onError(XMLParserErrorCode.MalformedElement);
	                return;
	              }
	              var isClosed = false;
	              if (s.substring(j + content.parsed, j + content.parsed + 2) === '/>') {
	                isClosed = true;
	              } else if (s.substring(j + content.parsed, j + content.parsed + 1) !== '>') {
	                this.onError(XMLParserErrorCode.UnterminatedElement);
	                return;
	              }
	              this.onBeginElement(content.name, content.attributes, isClosed);
	              j += content.parsed + (isClosed ? 2 : 1);
	              break;
	          }
	        } else {
	          while (j < s.length && s[j] !== '<') {
	            j++;
	          }
	          var text = s.substring(i, j);
	          this.onText(this._resolveEntities(text));
	        }
	        i = j;
	      }
	    }
	  }, {
	    key: 'onResolveEntity',
	    value: function onResolveEntity(name) {
	      return '&' + name + ';';
	    }
	  }, {
	    key: 'onPi',
	    value: function onPi(name, value) {}
	  }, {
	    key: 'onComment',
	    value: function onComment(text) {}
	  }, {
	    key: 'onCdata',
	    value: function onCdata(text) {}
	  }, {
	    key: 'onDoctype',
	    value: function onDoctype(doctypeContent) {}
	  }, {
	    key: 'onText',
	    value: function onText(text) {}
	  }, {
	    key: 'onBeginElement',
	    value: function onBeginElement(name, attributes, isEmpty) {}
	  }, {
	    key: 'onEndElement',
	    value: function onEndElement(name) {}
	  }, {
	    key: 'onError',
	    value: function onError(code) {}
	  }]);
	
	  return XMLParserBase;
	}();
	
	var SimpleDOMNode = function () {
	  function SimpleDOMNode(nodeName, nodeValue) {
	    _classCallCheck(this, SimpleDOMNode);
	
	    this.nodeName = nodeName;
	    this.nodeValue = nodeValue;
	    Object.defineProperty(this, 'parentNode', {
	      value: null,
	      writable: true
	    });
	  }
	
	  _createClass(SimpleDOMNode, [{
	    key: 'hasChildNodes',
	    value: function hasChildNodes() {
	      return this.childNodes && this.childNodes.length > 0;
	    }
	  }, {
	    key: 'firstChild',
	    get: function get() {
	      return this.childNodes[0];
	    }
	  }, {
	    key: 'nextSibling',
	    get: function get() {
	      var index = this.parentNode.childNodes.indexOf(this);
	      return this.parentNode.childNodes[index + 1];
	    }
	  }, {
	    key: 'textContent',
	    get: function get() {
	      if (!this.childNodes) {
	        return this.nodeValue || '';
	      }
	      return this.childNodes.map(function (child) {
	        return child.textContent;
	      }).join('');
	    }
	  }]);
	
	  return SimpleDOMNode;
	}();
	
	var SimpleXMLParser = function (_XMLParserBase) {
	  _inherits(SimpleXMLParser, _XMLParserBase);
	
	  function SimpleXMLParser() {
	    _classCallCheck(this, SimpleXMLParser);
	
	    var _this = _possibleConstructorReturn(this, (SimpleXMLParser.__proto__ || Object.getPrototypeOf(SimpleXMLParser)).call(this));
	
	    _this._currentFragment = null;
	    _this._stack = null;
	    _this._errorCode = XMLParserErrorCode.NoError;
	    return _this;
	  }
	
	  _createClass(SimpleXMLParser, [{
	    key: 'parseFromString',
	    value: function parseFromString(data) {
	      this._currentFragment = [];
	      this._stack = [];
	      this._errorCode = XMLParserErrorCode.NoError;
	      this.parseXml(data);
	      if (this._errorCode !== XMLParserErrorCode.NoError) {
	        return undefined;
	      }
	
	      var _currentFragment = _slicedToArray(this._currentFragment, 1),
	          documentElement = _currentFragment[0];
	
	      return { documentElement: documentElement };
	    }
	  }, {
	    key: 'onResolveEntity',
	    value: function onResolveEntity(name) {
	      switch (name) {
	        case 'apos':
	          return '\'';
	      }
	      return _get(SimpleXMLParser.prototype.__proto__ || Object.getPrototypeOf(SimpleXMLParser.prototype), 'onResolveEntity', this).call(this, name);
	    }
	  }, {
	    key: 'onText',
	    value: function onText(text) {
	      if (isWhitespaceString(text)) {
	        return;
	      }
	      var node = new SimpleDOMNode('#text', text);
	      this._currentFragment.push(node);
	    }
	  }, {
	    key: 'onCdata',
	    value: function onCdata(text) {
	      var node = new SimpleDOMNode('#text', text);
	      this._currentFragment.push(node);
	    }
	  }, {
	    key: 'onBeginElement',
	    value: function onBeginElement(name, attributes, isEmpty) {
	      var node = new SimpleDOMNode(name);
	      node.childNodes = [];
	      this._currentFragment.push(node);
	      if (isEmpty) {
	        return;
	      }
	      this._stack.push(this._currentFragment);
	      this._currentFragment = node.childNodes;
	    }
	  }, {
	    key: 'onEndElement',
	    value: function onEndElement(name) {
	      this._currentFragment = this._stack.pop();
	      var lastElement = this._currentFragment[this._currentFragment.length - 1];
	      for (var i = 0, ii = lastElement.childNodes.length; i < ii; i++) {
	        lastElement.childNodes[i].parentNode = lastElement;
	      }
	    }
	  }, {
	    key: 'onError',
	    value: function onError(code) {
	      this._errorCode = code;
	    }
	  }]);
	
	  return SimpleXMLParser;
	}(XMLParserBase);
	
	exports.SimpleXMLParser = SimpleXMLParser;
	
	/***/ }),
	/* 123 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFDataTransportStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
	  function PDFDataTransportStream(params, pdfDataRangeTransport) {
	    var _this = this;
	
	    (0, _util.assert)(pdfDataRangeTransport);
	    this._queuedChunks = [];
	    var initialData = params.initialData;
	    if (initialData && initialData.length > 0) {
	      var buffer = new Uint8Array(initialData).buffer;
	      this._queuedChunks.push(buffer);
	    }
	    this._pdfDataRangeTransport = pdfDataRangeTransport;
	    this._isRangeSupported = !params.disableRange;
	    this._isStreamingSupported = !params.disableStream;
	    this._contentLength = params.length;
	    this._fullRequestReader = null;
	    this._rangeReaders = [];
	    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
	      _this._onReceiveData({
	        begin: begin,
	        chunk: chunk
	      });
	    });
	    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
	      _this._onProgress({ loaded: loaded });
	    });
	    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
	      _this._onReceiveData({ chunk: chunk });
	    });
	    this._pdfDataRangeTransport.transportReady();
	  }
	  PDFDataTransportStream.prototype = {
	    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
	      var buffer = new Uint8Array(args.chunk).buffer;
	      if (args.begin === undefined) {
	        if (this._fullRequestReader) {
	          this._fullRequestReader._enqueue(buffer);
	        } else {
	          this._queuedChunks.push(buffer);
	        }
	      } else {
	        var found = this._rangeReaders.some(function (rangeReader) {
	          if (rangeReader._begin !== args.begin) {
	            return false;
	          }
	          rangeReader._enqueue(buffer);
	          return true;
	        });
	        (0, _util.assert)(found);
	      }
	    },
	    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
	      if (this._rangeReaders.length > 0) {
	        var firstReader = this._rangeReaders[0];
	        if (firstReader.onProgress) {
	          firstReader.onProgress({ loaded: evt.loaded });
	        }
	      }
	    },
	    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
	      var i = this._rangeReaders.indexOf(reader);
	      if (i >= 0) {
	        this._rangeReaders.splice(i, 1);
	      }
	    },
	    getFullReader: function PDFDataTransportStream_getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      var queuedChunks = this._queuedChunks;
	      this._queuedChunks = null;
	      return new PDFDataTransportStreamReader(this, queuedChunks);
	    },
	    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
	      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
	      this._pdfDataRangeTransport.requestDataRange(begin, end);
	      this._rangeReaders.push(reader);
	      return reader;
	    },
	    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeReaders.slice(0);
	      readers.forEach(function (rangeReader) {
	        rangeReader.cancel(reason);
	      });
	      this._pdfDataRangeTransport.abort();
	    }
	  };
	  function PDFDataTransportStreamReader(stream, queuedChunks) {
	    this._stream = stream;
	    this._done = false;
	    this._queuedChunks = queuedChunks || [];
	    this._requests = [];
	    this._headersReady = Promise.resolve();
	    stream._fullRequestReader = this;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamReader.prototype = {
	    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length > 0) {
	        var requestCapability = this._requests.shift();
	        requestCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        return;
	      }
	      this._queuedChunks.push(chunk);
	    },
	    get headersReady() {
	      return this._headersReady;
	    },
	    get isRangeSupported() {
	      return this._stream._isRangeSupported;
	    },
	    get isStreamingSupported() {
	      return this._stream._isStreamingSupported;
	    },
	    get contentLength() {
	      return this._stream._contentLength;
	    },
	    read: function PDFDataTransportStreamReader_read() {
	      if (this._queuedChunks.length > 0) {
	        var chunk = this._queuedChunks.shift();
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	    }
	  };
	  function PDFDataTransportStreamRangeReader(stream, begin, end) {
	    this._stream = stream;
	    this._begin = begin;
	    this._end = end;
	    this._queuedChunk = null;
	    this._requests = [];
	    this._done = false;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamRangeReader.prototype = {
	    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length === 0) {
	        this._queuedChunk = chunk;
	      } else {
	        var requestsCapability = this._requests.shift();
	        requestsCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        this._requests.forEach(function (requestCapability) {
	          requestCapability.resolve({
	            value: undefined,
	            done: true
	          });
	        });
	        this._requests = [];
	      }
	      this._done = true;
	      this._stream._removeRangeReader(this);
	    },
	    get isStreamingSupported() {
	      return false;
	    },
	    read: function PDFDataTransportStreamRangeReader_read() {
	      if (this._queuedChunk) {
	        var chunk = this._queuedChunk;
	        this._queuedChunk = null;
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	      this._stream._removeRangeReader(this);
	    }
	  };
	  return PDFDataTransportStream;
	}();
	exports.PDFDataTransportStream = PDFDataTransportStream;
	
	/***/ }),
	/* 124 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFNodeStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(44);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var fs = __webpack_require__(673);
	var http = __webpack_require__(674);
	var https = __webpack_require__(675);
	var url = __webpack_require__(666);
	
	var PDFNodeStream = function () {
	  function PDFNodeStream(options) {
	    _classCallCheck(this, PDFNodeStream);
	
	    this.options = options;
	    this.source = options.source;
	    this.url = url.parse(this.source.url);
	    this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:';
	    this.isFsUrl = this.url.protocol === 'file:' || !this.url.host;
	    this.httpHeaders = this.isHttp && this.source.httpHeaders || {};
	    this._fullRequest = null;
	    this._rangeRequestReaders = [];
	  }
	
	  _createClass(PDFNodeStream, [{
	    key: 'getFullReader',
	    value: function getFullReader() {
	      (0, _util.assert)(!this._fullRequest);
	      this._fullRequest = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
	      return this._fullRequest;
	    }
	  }, {
	    key: 'getRangeReader',
	    value: function getRangeReader(start, end) {
	      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
	      this._rangeRequestReaders.push(rangeReader);
	      return rangeReader;
	    }
	  }, {
	    key: 'cancelAllRequests',
	    value: function cancelAllRequests(reason) {
	      if (this._fullRequest) {
	        this._fullRequest.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  }]);
	
	  return PDFNodeStream;
	}();
	
	var BaseFullReader = function () {
	  function BaseFullReader(stream) {
	    _classCallCheck(this, BaseFullReader);
	
	    this._url = stream.url;
	    this._done = false;
	    this._errored = false;
	    this._reason = null;
	    this.onProgress = null;
	    this._contentLength = stream.source.length;
	    this._loaded = 0;
	    this._disableRange = stream.options.disableRange || false;
	    this._rangeChunkSize = stream.source.rangeChunkSize;
	    if (!this._rangeChunkSize && !this._disableRange) {
	      this._disableRange = true;
	    }
	    this._isStreamingSupported = !stream.source.disableStream;
	    this._isRangeSupported = !stream.options.disableRange;
	    this._readableStream = null;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._headersCapability = (0, _util.createPromiseCapability)();
	  }
	
	  _createClass(BaseFullReader, [{
	    key: 'read',
	    value: function read() {
	      var _this = this;
	
	      return this._readCapability.promise.then(function () {
	        if (_this._done) {
	          return Promise.resolve({
	            value: undefined,
	            done: true
	          });
	        }
	        if (_this._errored) {
	          return Promise.reject(_this._reason);
	        }
	        var chunk = _this._readableStream.read();
	        if (chunk === null) {
	          _this._readCapability = (0, _util.createPromiseCapability)();
	          return _this.read();
	        }
	        _this._loaded += chunk.length;
	        if (_this.onProgress) {
	          _this.onProgress({
	            loaded: _this._loaded,
	            total: _this._contentLength
	          });
	        }
	        var buffer = new Uint8Array(chunk).buffer;
	        return Promise.resolve({
	          value: buffer,
	          done: false
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!this._readableStream) {
	        this._error(reason);
	        return;
	      }
	      this._readableStream.destroy(reason);
	    }
	  }, {
	    key: '_error',
	    value: function _error(reason) {
	      this._errored = true;
	      this._reason = reason;
	      this._readCapability.resolve();
	    }
	  }, {
	    key: '_setReadableStream',
	    value: function _setReadableStream(readableStream) {
	      var _this2 = this;
	
	      this._readableStream = readableStream;
	      readableStream.on('readable', function () {
	        _this2._readCapability.resolve();
	      });
	      readableStream.on('end', function () {
	        readableStream.destroy();
	        _this2._done = true;
	        _this2._readCapability.resolve();
	      });
	      readableStream.on('error', function (reason) {
	        _this2._error(reason);
	      });
	      if (!this._isStreamingSupported && this._isRangeSupported) {
	        this._error(new _util.AbortException('streaming is disabled'));
	      }
	      if (this._errored) {
	        this._readableStream.destroy(this._reason);
	      }
	    }
	  }, {
	    key: 'headersReady',
	    get: function get() {
	      return this._headersCapability.promise;
	    }
	  }, {
	    key: 'contentLength',
	    get: function get() {
	      return this._contentLength;
	    }
	  }, {
	    key: 'isRangeSupported',
	    get: function get() {
	      return this._isRangeSupported;
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return BaseFullReader;
	}();
	
	var BaseRangeReader = function () {
	  function BaseRangeReader(stream) {
	    _classCallCheck(this, BaseRangeReader);
	
	    this._url = stream.url;
	    this._done = false;
	    this._errored = false;
	    this._reason = null;
	    this.onProgress = null;
	    this._loaded = 0;
	    this._readableStream = null;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._isStreamingSupported = !stream.source.disableStream;
	  }
	
	  _createClass(BaseRangeReader, [{
	    key: 'read',
	    value: function read() {
	      var _this3 = this;
	
	      return this._readCapability.promise.then(function () {
	        if (_this3._done) {
	          return Promise.resolve({
	            value: undefined,
	            done: true
	          });
	        }
	        if (_this3._errored) {
	          return Promise.reject(_this3._reason);
	        }
	        var chunk = _this3._readableStream.read();
	        if (chunk === null) {
	          _this3._readCapability = (0, _util.createPromiseCapability)();
	          return _this3.read();
	        }
	        _this3._loaded += chunk.length;
	        if (_this3.onProgress) {
	          _this3.onProgress({ loaded: _this3._loaded });
	        }
	        var buffer = new Uint8Array(chunk).buffer;
	        return Promise.resolve({
	          value: buffer,
	          done: false
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (!this._readableStream) {
	        this._error(reason);
	        return;
	      }
	      this._readableStream.destroy(reason);
	    }
	  }, {
	    key: '_error',
	    value: function _error(reason) {
	      this._errored = true;
	      this._reason = reason;
	      this._readCapability.resolve();
	    }
	  }, {
	    key: '_setReadableStream',
	    value: function _setReadableStream(readableStream) {
	      var _this4 = this;
	
	      this._readableStream = readableStream;
	      readableStream.on('readable', function () {
	        _this4._readCapability.resolve();
	      });
	      readableStream.on('end', function () {
	        readableStream.destroy();
	        _this4._done = true;
	        _this4._readCapability.resolve();
	      });
	      readableStream.on('error', function (reason) {
	        _this4._error(reason);
	      });
	      if (this._errored) {
	        this._readableStream.destroy(this._reason);
	      }
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return BaseRangeReader;
	}();
	
	function createRequestOptions(url, headers) {
	  return {
	    protocol: url.protocol,
	    auth: url.auth,
	    host: url.hostname,
	    port: url.port,
	    path: url.path,
	    method: 'GET',
	    headers: headers
	  };
	}
	
	var PDFNodeStreamFullReader = function (_BaseFullReader) {
	  _inherits(PDFNodeStreamFullReader, _BaseFullReader);
	
	  function PDFNodeStreamFullReader(stream) {
	    _classCallCheck(this, PDFNodeStreamFullReader);
	
	    var _this5 = _possibleConstructorReturn(this, (PDFNodeStreamFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFullReader)).call(this, stream));
	
	    var handleResponse = function handleResponse(response) {
	      _this5._headersCapability.resolve();
	      _this5._setReadableStream(response);
	
	      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	        getResponseHeader: function getResponseHeader(name) {
	          return _this5._readableStream.headers[name.toLowerCase()];
	        },
	        isHttp: stream.isHttp,
	        rangeChunkSize: _this5._rangeChunkSize,
	        disableRange: _this5._disableRange
	      }),
	          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	          suggestedLength = _validateRangeRequest.suggestedLength;
	
	      if (allowRangeRequests) {
	        _this5._isRangeSupported = true;
	      }
	      _this5._contentLength = suggestedLength;
	    };
	    _this5._request = null;
	    if (_this5._url.protocol === 'http:') {
	      _this5._request = http.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
	    } else {
	      _this5._request = https.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
	    }
	    _this5._request.on('error', function (reason) {
	      _this5._errored = true;
	      _this5._reason = reason;
	      _this5._headersCapability.reject(reason);
	    });
	    _this5._request.end();
	    return _this5;
	  }
	
	  return PDFNodeStreamFullReader;
	}(BaseFullReader);
	
	var PDFNodeStreamRangeReader = function (_BaseRangeReader) {
	  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);
	
	  function PDFNodeStreamRangeReader(stream, start, end) {
	    _classCallCheck(this, PDFNodeStreamRangeReader);
	
	    var _this6 = _possibleConstructorReturn(this, (PDFNodeStreamRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamRangeReader)).call(this, stream));
	
	    _this6._httpHeaders = {};
	    for (var property in stream.httpHeaders) {
	      var value = stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      _this6._httpHeaders[property] = value;
	    }
	    _this6._httpHeaders['Range'] = 'bytes=' + start + '-' + (end - 1);
	    _this6._request = null;
	    if (_this6._url.protocol === 'http:') {
	      _this6._request = http.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
	        _this6._setReadableStream(response);
	      });
	    } else {
	      _this6._request = https.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
	        _this6._setReadableStream(response);
	      });
	    }
	    _this6._request.on('error', function (reason) {
	      _this6._errored = true;
	      _this6._reason = reason;
	    });
	    _this6._request.end();
	    return _this6;
	  }
	
	  return PDFNodeStreamRangeReader;
	}(BaseRangeReader);
	
	var PDFNodeStreamFsFullReader = function (_BaseFullReader2) {
	  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);
	
	  function PDFNodeStreamFsFullReader(stream) {
	    _classCallCheck(this, PDFNodeStreamFsFullReader);
	
	    var _this7 = _possibleConstructorReturn(this, (PDFNodeStreamFsFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsFullReader)).call(this, stream));
	
	    var path = decodeURI(_this7._url.path);
	    fs.lstat(path, function (error, stat) {
	      if (error) {
	        _this7._errored = true;
	        _this7._reason = error;
	        _this7._headersCapability.reject(error);
	        return;
	      }
	      _this7._contentLength = stat.size;
	      _this7._setReadableStream(fs.createReadStream(path));
	      _this7._headersCapability.resolve();
	    });
	    return _this7;
	  }
	
	  return PDFNodeStreamFsFullReader;
	}(BaseFullReader);
	
	var PDFNodeStreamFsRangeReader = function (_BaseRangeReader2) {
	  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);
	
	  function PDFNodeStreamFsRangeReader(stream, start, end) {
	    _classCallCheck(this, PDFNodeStreamFsRangeReader);
	
	    var _this8 = _possibleConstructorReturn(this, (PDFNodeStreamFsRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsRangeReader)).call(this, stream));
	
	    _this8._setReadableStream(fs.createReadStream(decodeURI(_this8._url.path), {
	      start: start,
	      end: end - 1
	    }));
	    return _this8;
	  }
	
	  return PDFNodeStreamFsRangeReader;
	}(BaseRangeReader);
	
	exports.PDFNodeStream = PDFNodeStream;
	
	/***/ }),
	/* 125 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFFetchStream = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(44);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createFetchOptions(headers, withCredentials) {
	  return {
	    method: 'GET',
	    headers: headers,
	    mode: 'cors',
	    credentials: withCredentials ? 'include' : 'same-origin',
	    redirect: 'follow'
	  };
	}
	
	var PDFFetchStream = function () {
	  function PDFFetchStream(options) {
	    _classCallCheck(this, PDFFetchStream);
	
	    this.options = options;
	    this.source = options.source;
	    this.isHttp = /^https?:/i.test(this.source.url);
	    this.httpHeaders = this.isHttp && this.source.httpHeaders || {};
	    this._fullRequestReader = null;
	    this._rangeRequestReaders = [];
	  }
	
	  _createClass(PDFFetchStream, [{
	    key: 'getFullReader',
	    value: function getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      this._fullRequestReader = new PDFFetchStreamReader(this);
	      return this._fullRequestReader;
	    }
	  }, {
	    key: 'getRangeReader',
	    value: function getRangeReader(begin, end) {
	      var reader = new PDFFetchStreamRangeReader(this, begin, end);
	      this._rangeRequestReaders.push(reader);
	      return reader;
	    }
	  }, {
	    key: 'cancelAllRequests',
	    value: function cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeRequestReaders.slice(0);
	      readers.forEach(function (reader) {
	        reader.cancel(reason);
	      });
	    }
	  }]);
	
	  return PDFFetchStream;
	}();
	
	var PDFFetchStreamReader = function () {
	  function PDFFetchStreamReader(stream) {
	    var _this = this;
	
	    _classCallCheck(this, PDFFetchStreamReader);
	
	    this._stream = stream;
	    this._reader = null;
	    this._loaded = 0;
	    this._withCredentials = stream.source.withCredentials;
	    this._contentLength = this._stream.source.length;
	    this._headersCapability = (0, _util.createPromiseCapability)();
	    this._disableRange = this._stream.options.disableRange;
	    this._rangeChunkSize = this._stream.source.rangeChunkSize;
	    if (!this._rangeChunkSize && !this._disableRange) {
	      this._disableRange = true;
	    }
	    this._isRangeSupported = !this._stream.options.disableRange;
	    this._isStreamingSupported = !this._stream.source.disableStream;
	    this._headers = new Headers();
	    for (var property in this._stream.httpHeaders) {
	      var value = this._stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      this._headers.append(property, value);
	    }
	    var url = this._stream.source.url;
	    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
	      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
	        throw (0, _network_utils.createResponseStatusError)(response.status, url);
	      }
	      _this._reader = response.body.getReader();
	      _this._headersCapability.resolve();
	
	      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	        getResponseHeader: function getResponseHeader(name) {
	          return response.headers.get(name);
	        },
	        isHttp: _this._stream.isHttp,
	        rangeChunkSize: _this._rangeChunkSize,
	        disableRange: _this._disableRange
	      }),
	          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	          suggestedLength = _validateRangeRequest.suggestedLength;
	
	      _this._contentLength = suggestedLength;
	      _this._isRangeSupported = allowRangeRequests;
	      if (!_this._isStreamingSupported && _this._isRangeSupported) {
	        _this.cancel(new _util.AbortException('streaming is disabled'));
	      }
	    }).catch(this._headersCapability.reject);
	    this.onProgress = null;
	  }
	
	  _createClass(PDFFetchStreamReader, [{
	    key: 'read',
	    value: function read() {
	      var _this2 = this;
	
	      return this._headersCapability.promise.then(function () {
	        return _this2._reader.read().then(function (_ref) {
	          var value = _ref.value,
	              done = _ref.done;
	
	          if (done) {
	            return Promise.resolve({
	              value: value,
	              done: done
	            });
	          }
	          _this2._loaded += value.byteLength;
	          if (_this2.onProgress) {
	            _this2.onProgress({
	              loaded: _this2._loaded,
	              total: _this2._contentLength
	            });
	          }
	          var buffer = new Uint8Array(value).buffer;
	          return Promise.resolve({
	            value: buffer,
	            done: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (this._reader) {
	        this._reader.cancel(reason);
	      }
	    }
	  }, {
	    key: 'headersReady',
	    get: function get() {
	      return this._headersCapability.promise;
	    }
	  }, {
	    key: 'contentLength',
	    get: function get() {
	      return this._contentLength;
	    }
	  }, {
	    key: 'isRangeSupported',
	    get: function get() {
	      return this._isRangeSupported;
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return PDFFetchStreamReader;
	}();
	
	var PDFFetchStreamRangeReader = function () {
	  function PDFFetchStreamRangeReader(stream, begin, end) {
	    var _this3 = this;
	
	    _classCallCheck(this, PDFFetchStreamRangeReader);
	
	    this._stream = stream;
	    this._reader = null;
	    this._loaded = 0;
	    this._withCredentials = stream.source.withCredentials;
	    this._readCapability = (0, _util.createPromiseCapability)();
	    this._isStreamingSupported = !stream.source.disableStream;
	    this._headers = new Headers();
	    for (var property in this._stream.httpHeaders) {
	      var value = this._stream.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      this._headers.append(property, value);
	    }
	    var rangeStr = begin + '-' + (end - 1);
	    this._headers.append('Range', 'bytes=' + rangeStr);
	    var url = this._stream.source.url;
	    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
	      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
	        throw (0, _network_utils.createResponseStatusError)(response.status, url);
	      }
	      _this3._readCapability.resolve();
	      _this3._reader = response.body.getReader();
	    });
	    this.onProgress = null;
	  }
	
	  _createClass(PDFFetchStreamRangeReader, [{
	    key: 'read',
	    value: function read() {
	      var _this4 = this;
	
	      return this._readCapability.promise.then(function () {
	        return _this4._reader.read().then(function (_ref2) {
	          var value = _ref2.value,
	              done = _ref2.done;
	
	          if (done) {
	            return Promise.resolve({
	              value: value,
	              done: done
	            });
	          }
	          _this4._loaded += value.byteLength;
	          if (_this4.onProgress) {
	            _this4.onProgress({ loaded: _this4._loaded });
	          }
	          var buffer = new Uint8Array(value).buffer;
	          return Promise.resolve({
	            value: buffer,
	            done: false
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel(reason) {
	      if (this._reader) {
	        this._reader.cancel(reason);
	      }
	    }
	  }, {
	    key: 'isStreamingSupported',
	    get: function get() {
	      return this._isStreamingSupported;
	    }
	  }]);
	
	  return PDFFetchStreamRangeReader;
	}();
	
	exports.PDFFetchStream = PDFFetchStream;
	
	/***/ }),
	/* 126 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetworkManager = exports.PDFNetworkStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _network_utils = __w_pdfjs_require__(44);
	
	var _global_scope = __w_pdfjs_require__(20);
	
	var _global_scope2 = _interopRequireDefault(_global_scope);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	var OK_RESPONSE = 200;
	var PARTIAL_CONTENT_RESPONSE = 206;
	function NetworkManager(url, args) {
	  this.url = url;
	  args = args || {};
	  this.isHttp = /^https?:/i.test(url);
	  this.httpHeaders = this.isHttp && args.httpHeaders || {};
	  this.withCredentials = args.withCredentials || false;
	  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
	    return new XMLHttpRequest();
	  };
	  this.currXhrId = 0;
	  this.pendingRequests = Object.create(null);
	  this.loadedRequests = Object.create(null);
	}
	function getArrayBuffer(xhr) {
	  var data = xhr.response;
	  if (typeof data !== 'string') {
	    return data;
	  }
	  var array = (0, _util.stringToBytes)(data);
	  return array.buffer;
	}
	var supportsMozChunked = function supportsMozChunkedClosure() {
	  try {
	    var x = new XMLHttpRequest();
	    x.open('GET', _global_scope2.default.location.href);
	    x.responseType = 'moz-chunked-arraybuffer';
	    return x.responseType === 'moz-chunked-arraybuffer';
	  } catch (e) {
	    return false;
	  }
	}();
	NetworkManager.prototype = {
	  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
	    var args = {
	      begin: begin,
	      end: end
	    };
	    for (var prop in listeners) {
	      args[prop] = listeners[prop];
	    }
	    return this.request(args);
	  },
	  requestFull: function NetworkManager_requestFull(listeners) {
	    return this.request(listeners);
	  },
	  request: function NetworkManager_request(args) {
	    var xhr = this.getXhr();
	    var xhrId = this.currXhrId++;
	    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
	    xhr.open('GET', this.url);
	    xhr.withCredentials = this.withCredentials;
	    for (var property in this.httpHeaders) {
	      var value = this.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      xhr.setRequestHeader(property, value);
	    }
	    if (this.isHttp && 'begin' in args && 'end' in args) {
	      var rangeStr = args.begin + '-' + (args.end - 1);
	      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
	      pendingRequest.expectedStatus = 206;
	    } else {
	      pendingRequest.expectedStatus = 200;
	    }
	    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
	    if (useMozChunkedLoading) {
	      xhr.responseType = 'moz-chunked-arraybuffer';
	      pendingRequest.onProgressiveData = args.onProgressiveData;
	      pendingRequest.mozChunked = true;
	    } else {
	      xhr.responseType = 'arraybuffer';
	    }
	    if (args.onError) {
	      xhr.onerror = function (evt) {
	        args.onError(xhr.status);
	      };
	    }
	    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
	    xhr.onprogress = this.onProgress.bind(this, xhrId);
	    pendingRequest.onHeadersReceived = args.onHeadersReceived;
	    pendingRequest.onDone = args.onDone;
	    pendingRequest.onError = args.onError;
	    pendingRequest.onProgress = args.onProgress;
	    xhr.send(null);
	    return xhrId;
	  },
	  onProgress: function NetworkManager_onProgress(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    if (pendingRequest.mozChunked) {
	      var chunk = getArrayBuffer(pendingRequest.xhr);
	      pendingRequest.onProgressiveData(chunk);
	    }
	    var onProgress = pendingRequest.onProgress;
	    if (onProgress) {
	      onProgress(evt);
	    }
	  },
	  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    var xhr = pendingRequest.xhr;
	    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
	      pendingRequest.onHeadersReceived();
	      delete pendingRequest.onHeadersReceived;
	    }
	    if (xhr.readyState !== 4) {
	      return;
	    }
	    if (!(xhrId in this.pendingRequests)) {
	      return;
	    }
	    delete this.pendingRequests[xhrId];
	    if (xhr.status === 0 && this.isHttp) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    var xhrStatus = xhr.status || OK_RESPONSE;
	    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
	    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    this.loadedRequests[xhrId] = true;
	    var chunk = getArrayBuffer(xhr);
	    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
	      var rangeHeader = xhr.getResponseHeader('Content-Range');
	      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
	      var begin = parseInt(matches[1], 10);
	      pendingRequest.onDone({
	        begin: begin,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onProgressiveData) {
	      pendingRequest.onDone(null);
	    } else if (chunk) {
	      pendingRequest.onDone({
	        begin: 0,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onError) {
	      pendingRequest.onError(xhr.status);
	    }
	  },
	  hasPendingRequests: function NetworkManager_hasPendingRequests() {
	    for (var xhrId in this.pendingRequests) {
	      return true;
	    }
	    return false;
	  },
	  getRequestXhr: function NetworkManager_getXhr(xhrId) {
	    return this.pendingRequests[xhrId].xhr;
	  },
	  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
	    return !!this.pendingRequests[xhrId].onProgressiveData;
	  },
	  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
	    return xhrId in this.pendingRequests;
	  },
	  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
	    return xhrId in this.loadedRequests;
	  },
	  abortAllRequests: function NetworkManager_abortAllRequests() {
	    for (var xhrId in this.pendingRequests) {
	      this.abortRequest(xhrId | 0);
	    }
	  },
	  abortRequest: function NetworkManager_abortRequest(xhrId) {
	    var xhr = this.pendingRequests[xhrId].xhr;
	    delete this.pendingRequests[xhrId];
	    xhr.abort();
	  }
	};
	function PDFNetworkStream(options) {
	  this._options = options;
	  var source = options.source;
	  this._manager = new NetworkManager(source.url, {
	    httpHeaders: source.httpHeaders,
	    withCredentials: source.withCredentials
	  });
	  this._rangeChunkSize = source.rangeChunkSize;
	  this._fullRequestReader = null;
	  this._rangeRequestReaders = [];
	}
	PDFNetworkStream.prototype = {
	  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
	    var i = this._rangeRequestReaders.indexOf(reader);
	    if (i >= 0) {
	      this._rangeRequestReaders.splice(i, 1);
	    }
	  },
	  getFullReader: function PDFNetworkStream_getFullReader() {
	    (0, _util.assert)(!this._fullRequestReader);
	    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._options);
	    return this._fullRequestReader;
	  },
	  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
	    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
	    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
	    this._rangeRequestReaders.push(reader);
	    return reader;
	  },
	  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
	    if (this._fullRequestReader) {
	      this._fullRequestReader.cancel(reason);
	    }
	    var readers = this._rangeRequestReaders.slice(0);
	    readers.forEach(function (reader) {
	      reader.cancel(reason);
	    });
	  }
	};
	function PDFNetworkStreamFullRequestReader(manager, options) {
	  this._manager = manager;
	  var source = options.source;
	  var args = {
	    onHeadersReceived: this._onHeadersReceived.bind(this),
	    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
	    onDone: this._onDone.bind(this),
	    onError: this._onError.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._url = source.url;
	  this._fullRequestId = manager.requestFull(args);
	  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
	  this._disableRange = options.disableRange || false;
	  this._contentLength = source.length;
	  this._rangeChunkSize = source.rangeChunkSize;
	  if (!this._rangeChunkSize && !this._disableRange) {
	    this._disableRange = true;
	  }
	  this._isStreamingSupported = false;
	  this._isRangeSupported = false;
	  this._cachedChunks = [];
	  this._requests = [];
	  this._done = false;
	  this._storedError = undefined;
	  this.onProgress = null;
	}
	PDFNetworkStreamFullRequestReader.prototype = {
	  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
	    var fullRequestXhrId = this._fullRequestId;
	    var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
	
	    var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
	      getResponseHeader: function getResponseHeader(name) {
	        return fullRequestXhr.getResponseHeader(name);
	      },
	      isHttp: this._manager.isHttp,
	      rangeChunkSize: this._rangeChunkSize,
	      disableRange: this._disableRange
	    }),
	        allowRangeRequests = _validateRangeRequest.allowRangeRequests,
	        suggestedLength = _validateRangeRequest.suggestedLength;
	
	    this._contentLength = suggestedLength || this._contentLength;
	    if (allowRangeRequests) {
	      this._isRangeSupported = true;
	    }
	    var networkManager = this._manager;
	    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
	      this._isStreamingSupported = true;
	    } else if (this._isRangeSupported) {
	      networkManager.abortRequest(fullRequestXhrId);
	    }
	    this._headersReceivedCapability.resolve();
	  },
	  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._cachedChunks.push(chunk);
	    }
	  },
	  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
	    if (args) {
	      this._onProgressiveData(args.chunk);
	    }
	    this._done = true;
	    if (this._cachedChunks.length > 0) {
	      return;
	    }
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	  },
	  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
	    var url = this._url;
	    var exception = (0, _network_utils.createResponseStatusError)(status, url);
	    this._storedError = exception;
	    this._headersReceivedCapability.reject(exception);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.reject(exception);
	    });
	    this._requests = [];
	    this._cachedChunks = [];
	  },
	  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
	    if (this.onProgress) {
	      this.onProgress({
	        loaded: data.loaded,
	        total: data.lengthComputable ? data.total : this._contentLength
	      });
	    }
	  },
	  get isRangeSupported() {
	    return this._isRangeSupported;
	  },
	  get isStreamingSupported() {
	    return this._isStreamingSupported;
	  },
	  get contentLength() {
	    return this._contentLength;
	  },
	  get headersReady() {
	    return this._headersReceivedCapability.promise;
	  },
	  read: function PDFNetworkStreamFullRequestReader_read() {
	    if (this._storedError) {
	      return Promise.reject(this._storedError);
	    }
	    if (this._cachedChunks.length > 0) {
	      var chunk = this._cachedChunks.shift();
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
	    this._done = true;
	    this._headersReceivedCapability.reject(reason);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._fullRequestId)) {
	      this._manager.abortRequest(this._fullRequestId);
	    }
	    this._fullRequestReader = null;
	  }
	};
	function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
	  this._manager = manager;
	  var args = {
	    onDone: this._onDone.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._requestId = manager.requestRange(begin, end, args);
	  this._requests = [];
	  this._queuedChunk = null;
	  this._done = false;
	  this.onProgress = null;
	  this.onClosed = null;
	}
	PDFNetworkStreamRangeRequestReader.prototype = {
	  _close: function PDFNetworkStreamRangeRequestReader_close() {
	    if (this.onClosed) {
	      this.onClosed(this);
	    }
	  },
	  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
	    var chunk = data.chunk;
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._queuedChunk = chunk;
	    }
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    this._close();
	  },
	  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
	    if (!this.isStreamingSupported && this.onProgress) {
	      this.onProgress({ loaded: evt.loaded });
	    }
	  },
	  get isStreamingSupported() {
	    return false;
	  },
	  read: function PDFNetworkStreamRangeRequestReader_read() {
	    if (this._queuedChunk !== null) {
	      var chunk = this._queuedChunk;
	      this._queuedChunk = null;
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._requestId)) {
	      this._manager.abortRequest(this._requestId);
	    }
	    this._close();
	  }
	};
	exports.PDFNetworkStream = PDFNetworkStream;
	exports.NetworkManager = NetworkManager;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=pdf.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), (function() { return this; }()), __webpack_require__(12).Buffer))

/***/ }),
/* 558 */,
/* 559 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 560 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(559);
	exports.encode = exports.stringify = __webpack_require__(560);


/***/ }),
/* 562 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"demofi-modal\">\n    <div class=\"modal-header\">\n        <h5 class=\"modal-title\"><i class=\"fa fa-shield\"></i> Firma de documentos</h5>\n        <!-- <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button> -->\n    </div>\n\n    <div class=\"modal-body\">\n        <!-- <div class=\"progress\" ng-hide=\"!mostrar_progress\">\n            <div class=\"progress-bar\" role=\"progressbar\" style=\"width: 25%\" aria-valuenow=\"35\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div>\n        </div> -->\n        <div ng-if=\"iniciado === false\">\n            Iniciando...\n        </div>\n        <div ng-if=\"iniciado === true\">\n            <div ng-if=\"demofi_ejecutandose\">\n                <span style=\"font-weight: bold\">Token</span>\n                <span ng-if=\"tokens.length == 0\">\n                    Ningún token conectado\n                </span>\n                <span ng-repeat=\"tokenName in tokens\">\n                    <span>{{tokenName}}</span>\n                </span>\n            </div>\n            <!-- <div class=\"alert alert-danger\" >\n                    <i class=\"fa fa-info-circle\" ap></i>\n                    <span>Ningún token conectado</span>\n                </div> -->\n            <div ng-if=\"!demofi_ejecutandose\" class=\"alert alert-warning\" ng-if=\"data.certificado === null\">\n                <i class=\"fa fa-warning\"></i> <span> Demofi no se está ejecutando en su equipo o no tiene agregado el certificado de seguridad en su navegador.</span>\n                <br/>\n                <ul>\n                    <li><span>Visite el siguiente enlace para su instalación y/o configuración. Presione <a target=\"_blank\" href=\"http://test.local.agetic.gob.bo/firmador/#\">aquí</a>. <help message=\"helpMessage.demofi_no_instalado\"></help></span>\n                    <li><span>Para verificar que el certificado de seguridad de Demofi se encuentra instalado. Presione <a href=\"#\" ng-click=\"$ctrl.Demofi.verificarServidor()\">aquí</a>.</span>\n                </ul>\n            </div>\n        </div>\n\n        <div class=\"row\">\n             <!-- <img src=\"../../../../../assets/images/certificate.png\" class=\"img-certificado\">  -->\n            <span class=\"img-certificado\"></span>\n            <!-- <img src=\"./certificate.png\" class=\"img-certificado\"> -->\n            <div class=\"col-md\">\n                <div class=\"form-group\">\n                    <label class=\"ap-req\">Pin:</label>\n                    <input name=\"pin\" type=\"password\" class=\"form-control\" ng-model=\"pin\" ng-disabled=\"!token_conectado\" required>\n                    <div ap-error ng-messages=\"activos_form.pin.$error\" role=\"alert\" ng-if=\"activos_form.pin.$touched\">\n                        <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                </div>\n                <uib-select name=\"certificado\" label=\"Certificado:\" ng-model=\"certificado_seleccionado\" items=\"certificados\"\n                    key-value=\"alias\" key-text=\"nombreComunSubject\" placeholder=\"Seleccione...\"\n                    ng-disabled=\"!autenticado\"></uib-select>\n            </div>\n            <div class=\"col-md-3 py-4\">\n                <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.autenticar()\" ng-disabled=\"!token_conectado||autenticado\">\n                    <i class=\"fa fa-shield\"></i> Autenticar\n                </button>\n            </div>\n        </div>\n\n        <ul class=\"list-group md-dense\">\n            <li class=\"list-group-item\" style=\"background: #0aa699; color:aliceblue;\">\n                <strong>{{solicitudes.length}} documento{{solicitudes.length===1?'':'s'}} para firmar </strong>\n                <span>&nbsp;{{firmados}} de {{solicitudes.length}} Firmados</span>\n            </li>\n            <li class=\"list-group-item\" ng-repeat=\"solicitud in solicitudes\">\n                <!-- <md-icon>picture_as_pdf</md-icon> -->\n                <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAFiElEQVR4XqWXbWyT1xXHf/f6sWPHjomz4MAoWYIQKlIDmdaMdqnQ6KRSZWsFnZREpZWqTBqVuvVNqkqh1eiE1G4UtVRVNSClUAmiRMqHaZkqVGlqK7WDDthGSYEy2pImC6BCDHGc+Hm5t34eR7ZMcEzwXzrStS2f8zv/c+/V8wjyYnBwUFO+6OrqWnPkyJEPKS0KAPr7+w+vX79+FbcgrTW2baOUYmRkJNHZ2bnu6NGjH80JoKen57OOjo4WN0lJCZENAKVwHMcDSKVSAIyOjo61t7e3nT59+jCzSFIozU0pW1z/9zB66BxCSs8BFzydTiOlpKGhIbZv376/Llu2rKUUwNwlBc7uP2G3/Yzxjb9mfGIC4TMAXCc8kEgkwvLly+N79+4dmA1CXj/HkhISANW3H6sqghz+luQ358An3c5zowA8iKampnh3d7cHURKgxOwLpxSowDc5lbVfqYIcpmnmGnIhVq5cGd+zZ89AY2NjS/kjmHZJNN+JTNrYFRUQiWKA50B1dTVXrlzhxIkT7rHm5MmTDA0NUVNTE9+5c+dAPB5vKmMEefke6IQg2LXz8cVqEdMAFRmg+vp6MoU8mHA47H0XDAZpaWmJt7a2PkJeGLcEoDXi7l8gmlciE9eQUmShfD78fn8ujwvkfnb3BeDBBDMq/xRAbh+Ev/wa+/0+HLIyDCPXsRvuOhQKuWsPRgihSzlQ2gkp4dL/UcNDEJQYf3mNq20dxKoiKMfxOg8EAp4jWms3XBc8mOtlcKs6eQzbdkg8/gzz39zB2LuvYz35EgagITcSCtblH8O8PjrEZLQantyK0bqKyjdfIXFmEIoUyrlawoHSIHKa+ZN/MPXjuwhXheGPbxH85d1YWzYy0fsxlRkIRVYyezEVzWncNG3eSxj8D87Q+YzlLxMC1B0/gT/8mcimZ0llIOwVdyK/OoVe3ozV1oEWoqC5sjeh+NsBkgt+iFzzK4wLI/D3XtSH72PVRql85x3M2j6sRYsJ7XqbCz9YRLz1XjCnyncAvx808MEAzuIG5m35Del/f8a1+XXYP2/D2LSD2P43MPp7kFfHGFv1U6zFS5COhSrLASEgGATThL1vwNn/ETAtJuqXYG/fT2VzC9FgAENr9Kvd2GvXM372FOk1DxKvW4CybXS+RnEAx3FmUgaC4JP4+rpxDuzC+NcxLj3UibX5dWIL6ghqB2FZOBMT2EqhAFa3EVnzANH0JNr9rcgGLzECDeEqxPBXGC/8lqvJJOmG24lcHmPi8Re4rbYGMZktqrUuhJ4YByBXaq4AlmUhgiF8x/8Jz3UxfM99iAc3EH/2YYY3bCT6o0b01CSW4zAHuZA374CWkoqtTzGeGCdQt5D40518u/p+jIceI2RbWFozFwkh3BGXBMjd3VgW6bXr8Pe/hx7o5etHf49/3SPE/EZBkjk6MPsm1G4IgYrFAHB+txnric0oNNVC4NcaR6n8ydA6v87S59eFQgqRzS3ELAAXP8DZdAx10QSJJ7+UueR2JrRtZx/DTBPh94NhoFOp7NoNIWCmQ2jwnp7U+fPFAbjwKfq9EexxEHDDJNH2dmRNDebZswRWrEAnk5hffIGIRvEvXcrkoUOYo6Mz/i8B23WgtrY4gEKjwQuKAMjmZmSmEyMcRgcCJHbtIrZtG5gmOpHAunwZZuZATYcudRXb0yGZKQUQiZA8eBDrzBnmvfii54Z2i09N4Xz3HY5lFX0F04CaDUBU+0V4CXAihzrDkUCmuHP8OBVKEfr8c0Jr15LavRs5bx46A1Cp9UzofENoEEXfDZvuWLh9w+3ph81T5pS6KCCdJ3aY7iCdhkAAB7KdA1pKNICUKL8frRQaCkJklFJK9qdSz19TqveGAEAVsJCyVXQKJjAM5Ob0PVvMrlB1tTzsAAAAAElFTkSuQmCC\" style=\"width: 25px; height: 30px;\">\n                <p class=\"my-0\">&nbsp;&nbsp;{{solicitud.nombre_archivo}}&nbsp;&nbsp;</p>\n                <strong>{{solicitud.estado}}</strong>\n            </li>\n        </ul>\n    </div>\n    <div class=\"modal-footer\">\n        <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancelar()\">\n            <i class=\"fa fa-close\"></i> Cancelar\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!autenticado||firmando\" ng-click=\"$ctrl.firmar()\">\n            <i class=\"fa fa-check\"></i> Firmar\n        </button>\n    </div>\n</div>\n"

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-{{ $ctrl.icon }}\" ng-if=\"$ctrl.icon\"></i> {{ $ctrl.title }}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-if=\"$ctrl.btnClose\" ng-click=\"$ctrl.close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <div ng-bind-html=\"$ctrl.message\" ng-if=\"$ctrl.message\"></div>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.close()\" ng-if=\"$ctrl.cancel\">\n        <i class=\"fa fa-close\"></i> {{ $ctrl.labelCancel || 'Cancelar'}}\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n        <i class=\"fa fa-check\"></i> {{ $ctrl.labelOk || 'Aceptar' }}\n    </button>\n</div>"

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	module.exports = "<style>\n.screen-locked {\n  position: absolute !important;\n  background-color: transparent !important;\n}\n</style>\n<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-file-pdf-o\"></i> {{$ctrl.item.title? $ctrl.item.title:'Declaración Jurada'}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n\n  <table class=\"table table-hover\" ng-if=\"$ctrl.item.firmador\">\n    <tr>\n      <td style=\"width:25%;\"><i class=\"fa fa-user-circle\"></i> <strong> Firmado por:</strong> </td>\n      <td>{{$ctrl.item.firmador.nombre}}</td>\n    </tr>\n    <tr>\n      <td style=\"width:25%;\"><i class=\"fa fa-building\"></i> <strong> Organización:</strong></td>\n      <td>{{$ctrl.item.firmador.organizacion}}</td>\n    </tr>\n    <tr>\n      <td style=\"width:25%;\"><i class=\"fa fa-vcard\"></i> <strong> Emisor:</strong></td>\n      <td>{{$ctrl.item.firmador.emisor}}</td>\n    </tr>\n  </table>\n  <div ng-if=\"$ctrl.loading\" id=\"loading-bar-spinner\" class=\"screen-locked\">\n    <div class=\"loading-container\">\n      <span class=\"loading-text text-primary\">Cargando...</span>\n      <span class=\"spinner-icon\"></span>\n    </div>\n  </div>\n  <div class=\"alert alert-danger\" ng-if=\"$ctrl.item.observaciones\">\n      <h5><i class=\"fa fa-warning\"></i> Observaciones:</h5>\n      {{ $ctrl.item.observaciones }}\n  </div>\n  <iframe ng-src=\"{{$ctrl.urlPdf}}\" style=\"width:100%; height:550px;\" frameborder=\"0\">\n    <p>Su navegador no soporta iframe</p>\n  </iframe>\n\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n    <i class=\"fa fa-check\"></i> Aceptar\n  </button>\n</div>\n"

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"crud-table\">\n    <div class=\"d-flex justify-content-between\" ng-if=\"!$ctrl.inline\">\n        <div class=\"btn-container p-2\">\n            <label class=\"custom-control custom-checkbox\" ng-if=\"$ctrl.checks\" uib-tooltip=\"Seleccionar todos\">\n                <input type=\"checkbox\" class=\"custom-control-input\" ng-change=\"$ctrl.selectAllChecks()\" ng-model=\"$ctrl.modelSelectAllCheks\">\n                <span class=\"custom-control-indicator\"></span>\n            </label>\n            <button class=\"btn btn-primary\" md-effect type=\"button\" ng-click=\"$ctrl.actionChecks()\" ng-if=\"$ctrl.checks\">\n                <i class=\"fa fa-{{$ctrl.checks.icon}}\" ng-if=\"$ctrl.checks.icon\"></i> {{$ctrl.checks.label || 'Checks.label'}}\n            </button>\n            <button class=\"btn btn-primary\" md-effect ng-click=\"$ctrl.add()\" type=\"button\" uib-tooltip=\"Agregar nuevo registro\" ng-if=\"$ctrl.permissions.create\">\n                <i class=\"fa fa-plus\"></i> {{ $ctrl.labels.create || 'Agregar' }}\n            </button>\n            <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\">\n                <i class=\"fa fa-refresh\"></i>\n            </button>\n            <button md-effect class=\"btn\" ng-class=\"button.class || 'btn-default'\" type=\"button\" ng-repeat=\"button in $ctrl.buttonsTop\" uib-tooltip=\"{{button.tooltip}}\" ng-click=\"button.onclick? button.onclick($event):true\" ng-if=\"button.if? button.if() : true\">\n                <i class=\"fa fa-{{button.icon}}\"></i> {{button.label}}\n            </button>\n        </div>\n        <form name=\"$ctrl.searchForm\" class=\"form-search p-2\" novalidate ng-submit=\"$ctrl.search()\" ng-if=\"$ctrl.permissions.filter\">\n            <div class=\"input-group\">\n                <span class=\"input-group-btn\" ng-if=\"$ctrl.searchTerm.length\">\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cleanSearch()\" uib-tooltip=\"Limpiar búsqueda\">\n                        <i class=\"fa fa-trash\"></i>\n                    </button>\n                </span>\n                <input type=\"text\" class=\"form-control\" placeholder=\"Escriba su búsqueda aquí\" name=\"searchTerm\" ng-model=\"$ctrl.searchTerm\" required />\n                <span class=\"input-group-btn\">\n                    <button class=\"btn btn-default\" type=\"submit\" ng-disabled=\"$ctrl.searchForm.$invalid\" uib-tooltip=\"Buscar en la tabla\">\n                        <i class=\"fa fa-search\"></i>\n                    </button>\n                </span>\n            </div>\n        </form>\n    </div>\n    <!-- <div ng-if=\"$ctrl.inlineOptions\" class=\"alert alert-info\">\n        <div ng-if=\"!$ctrl.editItem\">\n            <strong>Opciones: </strong>\n            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.edit()\" ng-if=\"$ctrl.permissions.update\" uib-tooltip=\"Editar la fila seleccionada\">\n                <i class=\"fa fa-edit\"></i> Editar\n            </button>\n            <button md-effect class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.delete()\" ng-if=\"$ctrl.permissions.delete\" uib-tooltip=\"Eliminar la fila seleccionada\">\n                <i class=\"fa fa-trash\"></i> Eliminar\n            </button>\n        </div>\n        <div ng-if=\"$ctrl.editItem\">\n            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.editCancel()\" ng-if=\"$ctrl.permissions.update\" uib-tooltip=\"Editar la fila seleccionada\">\n                <i class=\"fa fa-edit\"></i> Cancelar edición\n            </button>\n        </div>\n    </div> -->\n    <form ng-if=\"$ctrl.inline\" name=\"$ctrl.formInline\" ng-submit=\"$ctrl.saveFormInline()\" novalidate class=\"crud-table-form-inline\" ng-class=\"{'alert-info' : $ctrl.editItem }\">\n        <formly-form model=\"$ctrl.modelInline\" fields=\"$ctrl.fieldsData\" options=\"$ctrl.options\" form=\"$ctrl.formInline\">\n            <button md-effect type=\"submit\"  class=\"btn btn-primary submit-button\" uib-tooltip=\"Agregar a la lista\">\n                 <i class=\"fa fa-check\"></i>\n            </button>\n        </formly-form>\n    </form>\n    <div ng-class=\"{'edit-item-block' : $ctrl.editItem, 'crud-table-table-inline' : $ctrl.formInline }\" ng-hide=\"$ctrl.data.list && $ctrl.data.list.length == 0\">\n        <div ng-click=\"$ctrl.editCancel()\" class=\"edit-item-block-backdrop\"></div>\n        <div ng-table-dynamic=\"$ctrl.tableParams with $ctrl.headers\" show-filter=\"$ctrl.showFilter\" class=\"table-responsive\">\n            <table class=\"table table-striped table-hover ng-table\">\n                <tr ng-repeat=\"row in $data\" ng-class=\"{ 'edit-item' : row.edit }\" ng-click=\"$ctrl.selectRow(row, $data)\">\n                    <td ng-repeat=\"col in $columns\" ng-hide=\"\" style=\"vertical-align: middle;\">\n                        <div ng-switch on=\"row[col.field]\" ng-if=\"col.dataType !== 'command'\">\n                            <div ng-switch-when=\"boolean_true\" class=\"text-center\">\n                                <i class=\"fa fa-check-circle text-success\"></i>\n                            </div>\n                            <div ng-switch-when=\"boolean_false\" class=\"text-center\">\n                                <!-- <i class=\"fa fa-check-circle text-success\"></i> -->\n                            </div>\n                            <div ng-switch-default ng-class=\"$ctrl.getFieldClass(row, col)\" ng-if=\"($ctrl.fieldsData[$index-1].type=='archive' && $ctrl.fieldsData[$index-1].templateOptions.type=='img')\" class=\"container-img\">\n                                 <img ng-src=\"{{row[col.field]}}\" ng-if=\"row[col.field]\" width=\"90\" alt=\"img{{row['id_producto']}}\" style:\"width: 90px; max-height: 90px; object-fit: scale-down;\"/>\n                                 <span ng-if=\"!row[col.field]\">Sin imagen</span>\n                            </div>\n                            <div ng-switch-default ng-class=\"[$ctrl.getFieldClass(row, col), ($ctrl.fieldsData[$index-1] && $ctrl.fieldsData[$index-1].class && $ctrl.fieldsData[$index-1].class !== '') ? $ctrl.fieldsData[$index-1].class : null]\" ng-if=\"!($ctrl.fieldsData[$index-1].type=='archive' && $ctrl.fieldsData[$index-1].templateOptions.type=='img')\">\n                                {{ row[col.field] | datetime: 'convert' }}\n                                <span ng-if=\"($ctrl.fieldsData[$index-1].next && $ctrl.fieldsData[$index-1].next.key && $ctrl.fieldsData[$index-1].child.key !== '' && row[$ctrl.fieldsData[$index-1].next.key] !== null)\"><span class=\"text-info-second font-weight-medium\"> | </span> {{ row[$ctrl.fieldsData[$index-1].next.key] }}</span>\n                            </div>\n                        </div>\n\n                        <div ng-if=\"col.dataType === 'command'\" class=\"btn-actions\">\n                            <label class=\"custom-control custom-checkbox\" ng-if=\"$ctrl.checks && $ctrl.checkIf(row)\">\n                                <input type=\"checkbox\" class=\"custom-control-input\" ng-change=\"$ctrl.selectCheck(row)\" ng-model=\"row.checked\">\n                                <span class=\"custom-control-indicator\"></span>\n                            </label>\n                            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.edit(row)\" ng-if=\"($ctrl.permissions.update && $ctrl.update === undefined) || $ctrl.update.states[row[$ctrl.update.key]]\" uib-tooltip=\"Editar\">\n                                <i class=\"fa fa-edit\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.deleteRow(row)\" ng-if=\"($ctrl.permissions.delete && $ctrl.delete === undefined) || $ctrl.delete.states[row[$ctrl.delete.key]]\" uib-tooltip=\"Eliminar\">\n                                <i class=\"fa fa-trash\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.print($event, row)\" ng-if=\"$ctrl.permissions.print\" uib-tooltip=\"Imprimir\">\n                                <i class=\"fa fa-trash\"></i>\n                            </button>\n                            <button md-effect class=\"btn btn-sm\" ng-class=\"button.class || ['btn-default']\" type=\"button\" ng-repeat=\"button in $ctrl.buttons\" uib-tooltip=\"{{button.tooltip}}\" ng-click=\"$ctrl.buttonEvent($event, row, button.onclick)\" ng-if=\"$ctrl.buttonIf($event, row, button.if)\">\n                                <i class=\"fa fa-{{button.icon}}\"></i>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n        <div ng-if=\"$ctrl.emptyTable\" class=\"alert alert-warning\">\n            <i class=\"fa fa-warning\"></i> {{ $ctrl.labels.emptyTable || 'No existen registros' }}\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 566 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> Agregar/Editar {{ $ctrl.title }}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <formly-form model=\"$ctrl.model\" fields=\"$ctrl.fields\" options=\"$ctrl.options\" form=\"$ctrl.form\"></formly-form>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.form.$invalid\" ng-click=\"$ctrl.save()\">\n        <i class=\"fa fa-check\"></i> Guardar\n    </button>\n</div>"

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"alert alert-danger\" ng-if=\"$ctrl.listaContactos.length == 0 && $ctrl.insertaNuevo === false\">\n    <i class=\"fa fa-warn-circle\" ap></i>\n    <span>Tiene que registrar al menos un contacto</span>\n  </div>\n<ng-form name=\"contacto_form\" >\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title\">\n      Registro de Contactos\n    </h5>\n  </div>\n    <div class=\"row\">\n      <div class=\"col-md-9 form-group\" ng-if=\"$ctrl.conf.nombre_completo.visible\">\n        <label ng-class=\"{'ap-req':$ctrl.conf.nombre_completo.requerido}\">{{$ctrl.conf.nombre_completo.label}}:</label>\n        <input name=\"nombre_completo\" class=\"form-control\" ng-model=\"$ctrl.dataContacto.nombre_completo\" ng-maxlength=\"250\" maxlength=\"250\"\n              ng-required=\"$ctrl.conf.nombre_completo.requerido\" >\n        <div ap-error ng-if=\"$ctrl.dataContacto.nombre_completo.length>249\" role=\"alert\">Superó el límite de los caracteres</div>\n        <div ap-error ng-messages=\"contacto_form.nombre_completo.$error\" role=\"alert\" ng-if=\"contacto_form.nombre_completo.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n       <div class=\"form-group col-md-3\">\n            <input-chips name=\"telefonos\" \n            label=\"{{$ctrl.conf.telefonos.label}}:\" \n            ng-model=\"$ctrl.dataContacto.telefonos\" \n            ng-required=\"$ctrl.conf.telefonos.requerido\" \n            before-add=\"$ctrl.beforeAddTel($chip)\" \n            ng-disabled=\"$ctrl.conf.telefonos.disabled\">\n            </input-chips>\n            <div ap-error ng-messages=\"contacto_form.telefonos.$error\" role=\"alert\" ng-if=\"contacto_form.telefonos.$touched\">\n              <div ng-message=\"required\">El campo es requerido</div>\n            </div>\n          </div>\n      <!-- <leaflet width=\"100%\" height=\"380px\" lf-center=\"$ctrl.center\" markers=\"$ctrl.markers\"></leaflet> -->\n      <!--<leaflet width=\"100%\" height=\"380px\" event-broadcast=\"$ctrl.events_leaflet\" lf-center=\"$ctrl.center\" markers=\"$ctrl.markers\" legend = \"$ctrl.legend\" defaults=\"defaults\" ></leaflet>-->\n    </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.save(contacto_form)\">\n      <i class=\"fa fa-check\"></i> Guardar\n    </button>\n  </div>\n</ng-form>\n\n<div class=\"table-ap\" ng-if=\"$ctrl.listaContactos.length > 0\">\n  <table class=\"table\">\n    <thead>\n      <tr>\n        <th></th>\n        <th class=\"text-center\">Nro</th>\n        <th class=\"text-left\">{{$ctrl.conf.nombre_completo.label}}</th>\n        <th class=\"text-center\">{{$ctrl.conf.telefonos.label}}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in $ctrl.listaContactos\">\n        <td class=\"icon-group\">\n          <i class=\"fa fa-trash text-danger\" uib-tooltip=\"Eliminar contacto\" ng-click=\"$ctrl.contactoDel($index, item)\"></i>\n        </td>\n        <td class=\"table-ap-text text-center\">{{$index + 1}}</td>\n        <td class=\"table-ap-text text-left\">{{item.nombre_completo}}</td>\n        <td class=\"table-ap-text text-center\">{{item.telefonos.split('|').join('-')}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>"

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-warning\">\n  <i class=\"fa fa-info-circle\" ap></i>\n  <span>Debe registrar una Cuenta Bancaria en bolivianos del Banco Unión S.A. vinculada a su NIT, en esta cuenta serán abonados los pagos por ventas por concepto del Incentivo al Consumo de Productos Hechos en Bolivia.</span>\n</div>\n<ng-form name=\"cuenta_beneficiario_form\">\n  <div class=\"row\">\n    <div class=\"col-md-3 form-group\" ng-if=\"$ctrl.conf.cuenta.cuenta.visible\">\n      <label ng-class=\"{'ap-req':$ctrl.conf.cuenta.cuenta.requerido}\">{{$ctrl.conf.cuenta.cuenta.label}}:</label>\n      <input name=\"cuenta_beneficiario\" class=\"form-control\" decimal-format minlength=\"14\" maxlength=\"14\" class=\"form-control\"  \n      ng-model=\"$ctrl.data.cuenta\" ng-required=\"$ctrl.conf.cuenta.cuenta.requerido\">\n      <div ap-error ng-messages=\"cuenta_beneficiario_form.cuenta_beneficiario.$error\" role=\"alert\" ng-if=\"cuenta_beneficiario_form.cuenta_beneficiario.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n        <div ng-message=\"minlength\">El Número de Cuenta del Banco Union debe tener 14 dígitos.</div>\n        <div ng-message=\"maxlength\">El Número de Cuenta del Banco Union debe tener 14 dígitos.</div>\n      </div>\n    </div>\n    <div class=\"form-group col-md-3\">\n      <label ng-class=\"{'ap-req':$ctrl.conf.cuenta.cuenta_departamento.requerido}\">{{$ctrl.conf.cuenta.cuenta_departamento.label}}:</label>\n      <uib-select name=\"cuenta_departamento\" ng-model=\"$ctrl.data.cuenta_departamento\" \n        items=\"$ctrl.departamentos\" key-text=\"nombre\" key-value=\"sigla\" \n        placeholder=\"{{$ctrl.conf.cuenta.cuenta_departamento.label}}\" \n        ng-required=\"$ctrl.conf.cuenta.cuenta_departamento.requerido\" \n        ng-disabled=\"$ctrl.conf.cuenta.cuenta_departamento.disabled\"></uib-select>\n      <div ap-error ng-messages=\"cuenta_beneficiario_form.cuenta_departamento.$error\" role=\"alert\" ng-if=\"cuenta_beneficiario_form.cuenta_departamento.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n    <div class=\"form-group col-md-3\">\n      <label ng-class=\"{'ap-req':$ctrl.conf.cuenta.cuenta_tipo.requerido}\">{{$ctrl.conf.cuenta.cuenta_tipo.label}}:</label>\n      <uib-select name=\"cuenta_tipo\" ng-model=\"$ctrl.data.cuenta_tipo\" \n        items=\"$ctrl.tiposCuenta\" key-text=\"nombre\" key-value=\"sigla\" \n        placeholder=\"{{$ctrl.conf.cuenta.cuenta_tipo.label}}\" \n        ng-required=\"$ctrl.conf.cuenta.cuenta_tipo.requerido\" \n        ng-disabled=\"$ctrl.conf.cuenta.cuenta_tipo.disabled\"></uib-select>\n      <div ap-error ng-messages=\"cuenta_beneficiario_form.cuenta_tipo.$error\" role=\"alert\" ng-if=\"cuenta_beneficiario_form.cuenta_tipo.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n    <div class=\"form-group col-md-3\">\n      <label ng-class=\"{'ap-req':$ctrl.conf.cuenta.cuenta_moneda.requerido}\">{{$ctrl.conf.cuenta.cuenta_moneda.label}}:</label>\n      <uib-select name=\"cuenta_moneda\" ng-model=\"$ctrl.data.cuenta_moneda\" \n        items=\"$ctrl.monedas\" key-text=\"nombre\" key-value=\"sigla\" \n        placeholder=\"{{$ctrl.conf.cuenta.cuenta_moneda.label}}\" \n        ng-required=\"$ctrl.conf.cuenta.cuenta_moneda.requerido\" \n        ng-disabled=\"$ctrl.conf.cuenta.cuenta_moneda.disabled\"></uib-select>\n      <div ap-error ng-messages=\"cuenta_beneficiario_form.cuenta_moneda.$error\" role=\"alert\" ng-if=\"cuenta_beneficiario_form.cuenta_moneda.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n  </div>\n</ng-form>\n\n"

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"documento-indentidad\">\r\n  <ng-form name=\"doc_identidad_form\">\r\n    <div class=\"row mx-0\">\r\n      <div class=\"form-group\" ng-if=\"!$ctrl.onlyCi\">\r\n        <label class=\"ap-req\">Tipo de documento</label>\r\n        <select class=\"form-control\" ng-model=\"$ctrl.ngModel.tipo_documento\" size required ng-disabled=\"$ctrl.ngDisabled || ($ctrl.ngModel.tipo_documento == 'CARNET_IDENTIDAD' && $ctrl.fill)\" ng-change=\"$ctrl.changeType()\">\r\n          <option value=\"CARNET_IDENTIDAD\">Cédula de identidad</option>\r\n          <option value=\"PASAPORTE\">Pasaporte</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"col mt-a mb-0\">\r\n        <div class=\"alert alert-info\" ng-if=\"$ctrl.ngModel.tipo_documento == 'CARNET_IDENTIDAD' && !$ctrl.ngDisabled\">\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span>Ingrese número de documento y fecha de nacimiento para su búsqueda.</span>\r\n          <!-- <help message=\"$root.helpMessage.documento_identidad\" position=\"bottom\"></help> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-3\">\r\n        <div class=\"form-group\" ng-if=\"$ctrl.ngModel.tipo_documento == 'CARNET_IDENTIDAD'\" class=\"help-input\">\r\n          <label class=\"ap-req\">Número de documento:</label>\r\n          <input name=\"documento_identidad\" alpha-dash uppercase maxlength=\"25\" class=\"form-control\" \r\n          ng-model=\"$ctrl.ngModel.documento_identidad\" required maxlength=\"20\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill()\">\r\n          <!-- <help message=\"$root.helpMessage.documento_identidad\" position=\"bottom\"></help> -->\r\n          <div ap-error ng-messages=\"doc_identidad_form.documento_identidad.$error\" role=\"alert\" ng-if=\"doc_identidad_form.documento_identidad.$touched\">\r\n            <div ng-message=\"required\">El campo es requerido</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\" ng-if=\"$ctrl.ngModel.tipo_documento == 'PASAPORTE'\">\r\n          <label class=\"ap-req\">Número de documento:</label>\r\n          <input name=\"documento_identidad\" passport uppercase maxlength=\"25\" class=\"form-control\" ng-model=\"$ctrl.ngModel.documento_identidad\" required maxlength=\"15\" ng-disabled=\"$ctrl.ngDisabled\">\r\n          <!-- <help message=\"$root.helpMessage.documento_identidad\" position=\"bottom\"></help> -->\r\n          <div ap-error ng-messages=\"doc_identidad_form.documento_identidad.$error\" role=\"alert\" ng-if=\"doc_identidad_form.documento_identidad.$touched\">\r\n            <div ng-message=\"required\">El campo es requerido</div>\r\n          </div>\r\n        </div>\r\n        <!-- <div class=\"mt-a mb-3\">\r\n          <span class=\"fa fa-question btn-c-info\"></span>\r\n        </div> -->\r\n      </div>\r\n      <div class=\"form-group col-md-3\" ng-if=\"$ctrl.ngModel.tipo_documento === 'CARNET_IDENTIDAD' && $ctrl.completo === true\">\r\n        <label ng-class=\"{'ap-req':$ctrl.conf.rep_agui.departamento_expedido.requerido}\">Expedido:</label>\r\n        <uib-select name=\"expedido_departamento\" ng-model=\"$ctrl.ngModel.expedido_departamento\" \r\n          items=\"$ctrl.departamentos\" \r\n          key-value=\"sigla\"\r\n          key-text=\"nombre\"\r\n          key-text=\"expedido\" placeholder=\"Expedido\" \r\n          ng-required=\"$ctrl.conf.rep_agui.departamento_expedido.requerido\"\r\n          ng-disabled=\"$ctrl.conf.rep_agui.departamento_expedido.disabled && $ctrl.ngDisabled || $ctrl.isFill()\"></uib-select>\r\n\r\n        <div ap-error ng-messages=\"doc_identidad_form.expedido_departamento.$error\" role=\"alert\" ng-if=\"doc_identidad_form.expedido_departamento.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n      <select-date class=\"col-md-4\" ng-model=\"$ctrl.ngModel.fecha_nacimiento\" label=\"Fecha de nacimiento:\" ng-disabled=\"$ctrl.ngDisabled || ($ctrl.isFill() && $ctrl.isCI())\" ng-required=\"'true'\"></select-date>\r\n\r\n      <div class=\"col-md-2 mt-3 mb-2\">\r\n        <button type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.search()\" ng-disabled=\"$ctrl.isDisabled()\" ng-if=\"$ctrl.isCI() && !$ctrl.isFill()\">\r\n          <i class=\"fa fa-search\"></i>Buscar\r\n        </button>\r\n        <button type=\"button\" class=\"btn\" ng-click=\"$ctrl.nombreDel()\" ng-if=\"$ctrl.isCI() && $ctrl.isFill()\">\r\n          <i class=\"fa fa-rowswap\"></i>Cambiar\r\n        </button>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-4 form-group\">\r\n        <label>Primer apellido:</label>\r\n        <input name=\"primer_apellido\" alpha uppercase maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.ngModel.primer_apellido\" ng-disabled=\"$ctrl.isCI()\">\r\n        <div ap-error ng-messages=\"doc_identidad_form.primer_apellido.$error\" role=\"alert\" ng-if=\"doc_identidad_form.primer_apellido.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-4 form-group\" >\r\n        <label>Segundo apellido:</label>\r\n        <input name=\"segundo_apellido\" alpha uppercase maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.ngModel.segundo_apellido\" ng-disabled=\"$ctrl.isCI()\">\r\n        <div ap-error ng-messages=\"doc_identidad_form.segundo_apellido.$error\" role=\"alert\" ng-if=\"doc_identidad_form.segundo_apellido.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-4 form-group\" ng-if=\"$ctrl.completo === true\">\r\n        <label>Apellido de casada:</label>\r\n        <input name=\"apellido_casada\" alpha uppercase maxlength=\"100\" \r\n          class=\"form-control\" ng-model=\"$ctrl.ngModel.casada_apellido\" \r\n          >\r\n        <div ap-error ng-messages=\"doc_identidad_form.apellido_casada.$error\" role=\"alert\" ng-if=\"doc_identidad_form.apellido_casada.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-4 form-group\">\r\n        <label class=\"ap-req\">Nombre(s):</label>\r\n        <input name=\"nombres\" alpha uppercase maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.ngModel.nombres\" ng-disabled=\"$ctrl.isCI()\" required>\r\n        <div ap-error ng-messages=\"doc_identidad_form.nombres.$error\" role=\"alert\" ng-if=\"doc_identidad_form.nombres.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n  </div>\r\n  </ng-form>\r\n</div>\r\n"

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"documento-identidad\">\r\n  <ng-form name=\"doc_identidad_form\">\r\n    <div class=\"row mx-0\">\r\n      <div class=\"form-group\">\r\n        <label class=\"ap-req\">Tipo de documento</label>\r\n        <select class=\"form-control\" ng-model=\"$ctrl.ngModel.tipo_documento\" size required\r\n          ng-disabled=\"$ctrl.ngDisabled || ($ctrl.isCI() && $ctrl.isFill())\" ng-change=\"$ctrl.changeType()\">\r\n          <option value=\"CARNET_IDENTIDAD\">Cédula de identidad</option>\r\n          <option value=\"CARNET_EXTRANJERO\">Cédula de Extranjería</option>\r\n          <option ng-if=\"!$ctrl.onlyCi\" value=\"PASAPORTE\">Pasaporte</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"col mt-a mb-0\">\r\n        <div class=\"alert alert-info-second\" ng-if=\"$ctrl.isCI() && !$ctrl.ngDisabled\">\r\n          <i class=\"fa fa-info-circle\"></i>\r\n          <span>Ingrese su número de documento, fecha de nacimiento, nombres y apellidos para validación.</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-4\">\r\n        <div class=\"form-group\" ng-if=\"$ctrl.isCI()\" class=\"help-input\">\r\n          <label class=\"ap-req\">Número de documento:</label>\r\n          <input name=\"documento_identidad\" alpha-dash uppercase maxlength=\"25\" class=\"form-control\"\r\n          ng-model=\"$ctrl.ngModel.documento_identidad\" required maxlength=\"20\" ng-disabled=\"$ctrl.ngDisabled || $ctrl.isFill()\">\r\n          <div ap-error ng-messages=\"doc_identidad_form.documento_identidad.$error\" role=\"alert\" ng-if=\"doc_identidad_form.documento_identidad.$touched\">\r\n            <div ng-message=\"required\">El campo es requerido</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group\" ng-if=\"$ctrl.ngModel.tipo_documento == 'PASAPORTE'\">\r\n          <label class=\"ap-req\">Número de documento:</label>\r\n          <input name=\"documento_identidad\" passport uppercase maxlength=\"25\" class=\"form-control\" ng-model=\"$ctrl.ngModel.documento_identidad\"\r\n            required maxlength=\"15\" ng-disabled=\"$ctrl.ngDisabled\">\r\n          <div ap-error ng-messages=\"doc_identidad_form.documento_identidad.$error\" role=\"alert\" ng-if=\"doc_identidad_form.documento_identidad.$touched\">\r\n            <div ng-message=\"required\">El campo es requerido</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group col-md-3\" ng-if=\"$ctrl.isCI() && $ctrl.completo === true\">\r\n        <label ng-class=\"{'ap-req':$ctrl.conf.rep_agui.departamento_expedido.requerido}\">Expedido:</label>\r\n        <uib-select name=\"expedido_departamento\" ng-model=\"$ctrl.ngModel.expedido_departamento\"\r\n          items=\"$ctrl.departamentos\"\r\n          key-value=\"sigla\"\r\n          key-text=\"nombre\"\r\n          key-text=\"expedido\" placeholder=\"Expedido\"\r\n          ng-required=\"$ctrl.conf.rep_agui.departamento_expedido.requerido\"\r\n          ng-disabled=\"$ctrl.conf.rep_agui.departamento_expedido.disabled\"></uib-select>\r\n\r\n        <div ap-error ng-messages=\"doc_identidad_form.expedido_departamento.$error\" role=\"alert\" ng-if=\"doc_identidad_form.expedido_departamento.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n      <select-date class=\"col-md-5\" ng-model=\"$ctrl.ngModel.fecha_nacimiento\" label=\"Fecha de nacimiento:\"\r\n        ng-disabled=\"$ctrl.ngDisabled || ($ctrl.isFill() && $ctrl.isCI())\" ng-required=\"'true'\"></select-date>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-md-4 form-group\">\r\n        <label>Primer apellido:</label>\r\n        <input name=\"primer_apellido\" alpha uppercase maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.ngModel.primer_apellido\" ng-disabled=\"$ctrl.isFill() && $ctrl.isCI()\">\r\n        <div ap-error ng-messages=\"doc_identidad_form.primer_apellido.$error\" role=\"alert\" ng-if=\"doc_identidad_form.primer_apellido.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-4 form-group\" >\r\n        <label>Segundo apellido:</label>\r\n        <input name=\"segundo_apellido\" alpha uppercase maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.ngModel.segundo_apellido\" ng-disabled=\"$ctrl.isFill() && $ctrl.isCI()\">\r\n        <div ap-error ng-messages=\"doc_identidad_form.segundo_apellido.$error\" role=\"alert\" ng-if=\"doc_identidad_form.segundo_apellido.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-4 form-group\" ng-if=\"$ctrl.completo === true\">\r\n        <label>Apellido de casada:</label>\r\n        <input name=\"apellido_casada\" alpha uppercase maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.ngModel.casada_apellido\">\r\n        <div ap-error ng-messages=\"doc_identidad_form.apellido_casada.$error\" role=\"alert\" ng-if=\"doc_identidad_form.apellido_casada.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-4 form-group\">\r\n        <label class=\"ap-req\">Nombre(s):</label>\r\n        <input name=\"nombres\" alpha uppercase maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.ngModel.nombres\" ng-disabled=\"$ctrl.isFill() && $ctrl.isCI()\" required>\r\n        <div ap-error ng-messages=\"doc_identidad_form.nombres.$error\" role=\"alert\" ng-if=\"doc_identidad_form.nombres.$touched\">\r\n          <div ng-message=\"required\">El campo es requerido</div>\r\n        </div>\r\n      </div>\r\n  </div>\r\n  <div class=\"text-right mb-2\">\r\n    <button type=\"button\" class=\"btn btn-success text-right\" ng-click=\"$ctrl.search()\" ng-disabled=\"$ctrl.isDisabled()\"\r\n      ng-if=\"$ctrl.isCI() && !$ctrl.isFill()\">\r\n      <i class=\"fa fa-search\"></i>Validar\r\n    </button>\r\n    <button type=\"button\" class=\"btn\" ng-click=\"$ctrl.nombreDel()\" ng-if=\"$ctrl.isFill() && $ctrl.isCI()\">\r\n      <i class=\"fa fa-rowswap\"></i>Cambiar\r\n    </button>\r\n  </div>\r\n  </ng-form>\r\n</div>\r\n"

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-file-upload\">\n    <!-- 3. nv-file-over uploader=\"link\" over-class=\"className\" -->\n    <div ng-show=\"uploader.isHTML5\">\n        <!-- Example: ng-file-drop | ng-file-drop=\"options\" -->\n        <label for=\"{{ $ctrl.idFile }}\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"uploader\" over-class=\"other-over-zone\" class=\"other-drop-zone zone\">\n            <span ng-if=\"!$ctrl.textUpload\">Arrastre su{{ $ctrl.multiple ? 's' : ''}} archivo{{ $ctrl.multiple ? 's' : ''}} aquí <br> o <br> haga click aquí</span>\n            <span ng-if=\"$ctrl.textUpload\" ng-bind-html=\"$ctrl.textUpload\"></span>\n        </label>\n    </div>\n    <!-- Example: nv-file-select=\"\" uploader=\"{Object}\" options=\"{Object}\" filters=\"{String}\" -->\n    <!-- <label for=\"{{ $ctrl.idFile }}\" md-effect class=\"btn btn-outline-default\">\n        <i class=\"fa fa-paperclip\"></i> Seleccionar archivo{{ $ctrl.multiple ? 's' : ''}}\n    </label> -->\n    <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple === undefined\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" class=\"ng-hide\"/>\n    <input type=\"file\" nv-file-select=\"\" ng-if=\"$ctrl.multiple\" uploader=\"uploader\" id=\"{{ $ctrl.idFile }}\" multiple class=\"ng-hide\"/>\n    <ul>\n        <li ng-repeat=\"item in uploader.queue\" class=\"ui-file-container\">\n            <div ng-show=\"uploader.isHTML5\">\n                <div class=\"progress\">\n                    <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': item.progress + '%' }\"></div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-md-4\" ng-if=\"$ctrl.isImage(item._file)\">\n                    <div class=\"ui-file-img\">\n                        <!-- Image preview -->\n                        <!--auto height-->\n                        <!--<div ng-thumb=\"{ file: item.file, width: 100 }\"></div>-->\n                        <!--auto width-->\n                        <div ng-thumb=\"{ file: item._file, height: 100 }\"></div>\n                        <!--fixed width and height -->\n                        <!--<div ng-thumb=\"{ file: item.file, width: 100, height: 100 }\"></div>-->\n                    </div>\n                </div>\n                <div class=\"col-md-{{ $ctrl.isImage(item._file) ? '8' : '12' }}\">\n                    <p><strong>Nombre del archivo:</strong> {{ item.file.name }}</p>\n                    <p><strong>Tamaño:</strong> {{ item.file.size/1024/1024|number:2 }} Mb</p>\n                    <div class=\"ui-file-buttons\">\n                        <button type=\"button\" class=\"btn btn-primary btn-sm\" md-effect ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" ng-hide=\"item.isUploading\">\n                            <i class=\"fa fa-upload\"></i> {{ $ctrl.label || 'Subir' }}\n                        </button>\n                        <button type=\"button\" class=\"btn btn-outline-default btn-sm\" md-effect ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\" ng-hide=\"!item.isUploading\">\n                            <i class=\"fa fa-ban\"></i> Cancelar\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-sm\" md-effect ng-click=\"item.remove()\" uib-tooltip=\"Eliminar archivo\">\n                            <i class=\"fa fa-trash\"></i>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </li>\n    </ul>\n    <div ng-if=\"$ctrl.multiple\">\n        <div>\n            <div class=\"progress\">\n                <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ 'width': uploader.progress + '%' }\"></div>\n            </div>\n        </div>\n        <button type=\"button\" class=\"btn btn-primary btn-sm\" md-effect ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\">\n            <i class=\"fa fa-upload\"></i> Subir todo\n        </button>\n        <button type=\"button\" class=\"btn btn-outline-default btn-sm\" md-effect ng-click=\"uploader.cancelAll()\" ng-disabled=\"!uploader.isUploading\">\n            <i class=\"fa fa-ban\"></i> Cancelar todo\n        </button>\n        <button type=\"button\" class=\"btn btn-danger btn-sm\" md-effect ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.queue.length\">\n            <i class=\"fa fa-trash\"></i> Eliminar todo\n        </button>\n    </div>\n</div>\n"

/***/ }),
/* 572 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-file-upload-autorizacion\">\n    <div class=\"wrapper\">\n        <img width=\"100%\" class=\"previewImagenes\" height=\"200px\" style=\"object-fit: contain;\"/>\n        <div class=\"container-img\">\n          <div class=\"file-upload p-4\">\n            <input type=\"file\" name=\"uploadFile\" class=\"imagenes\" ng-model=\"$ctrl.selectedImage\" onchange=\"angular.element(this).scope().validImage(this)\"/>\n            Subir y/o cambiar imagen\n          </div>\n          <i class=\"icon fa fa-trash\" style=\"text-align: right; color: #ff5c75;\" onclick=\"angular.element(this).scope().deleteImg(this)\"></i>\n        </div>\n      </div>\n</div>\n"

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"formulario-beneficiario\">\n  <ng-form name=\"formulario_beneficiarios\">\n    <div class=\"alert alert-primary\">\n      <span aria-hidden=\"true\"></span>\n      <span><strong>Datos del Beneficiario</strong></span>\n    </div>\n    <div class=\"container\">\n\n      <div class=\"row\" style=\"margin-top: 20px\">\n        <div style=\"width: 100%;\">\n          <div class=\"col-md-12\" style=\"background: #fdefef; padding: 10px;\" ng-if=\"$ctrl.certificacion.estado === 'ENVIADO' && $ctrl.mostrarCorrecciones\">\n            <div style=\"padding-bottom: 20px;\">\n              <span style=\"color:#F35958\"><strong>Si usa esta sección, los datos de beneficiarios y verificación de cuenta bancaria serán reemplazados.</strong></span>\n            </div>\n            <div>\n              <label class=\"custom-control custom-radio\">\n                <input required  type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.tipoBeneficiario\" value=\"NATURAL\">\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">Natural</span>\n              </label>\n              <label class=\"custom-control custom-radio\">\n                <input required  type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.tipoBeneficiario\" value=\"JURIDICO\">\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">Jurídico</span>\n              </label>\n            </div>\n            <div>\n              <button type=\"button\" md-effect class=\"btn btn-default btn-beneficiario\" ng-click=\"$ctrl.verificarBeneficiario()\" uib-tooltip=\"Buscar beneficiario\">\n                <i class=\"fa fa-search\"></i>\n              </button>\n              <span><strong>Buscar Beneficiario SIGEP</strong></span>\n            </div>\n            <div>\n              <button type=\"button\" md-effect class=\"btn btn-default btn-beneficiario\" ng-click=\"$ctrl.crearBeneficiario()\" uib-tooltip=\"Crear beneficiario\">\n                <i class=\"fa fa-user-plus\"></i>\n              </button>\n              <span><strong>Creación de Beneficiario SIGEP</strong></span>\n            </div>\n          </div>\n          <div ng-if=\"!$ctrl.unidad_productiva.beneficiario\">\n            <div class=\"col-md-12\" ng-if=\"!$ctrl.noExisteBeneficiario\">\n              <button type=\"button\" md-effect class=\"btn btn-default btn-beneficiario\" ng-click=\"$ctrl.verificarBeneficiario()\" ng-disabled=\"$ctrl.unidad_productiva.beneficiario\" uib-tooltip=\"Buscar beneficiario\">\n                <i class=\"fa fa-search\"></i>\n              </button>\n              <span><strong>Buscar Beneficiario SIGEP</strong></span>\n              <span><strong>{{$ctrl.unidad_productiva.matricula_comercio ? 'Jurídico' : 'Natural'}}</strong></span>\n              <span class=\"badge badge-danger\" ng-if=\"!$ctrl.unidad_productiva.beneficiario\">PENDIENTE</span>\n            </div>\n            <div class=\"col-md-12\" ng-if=\"$ctrl.noExisteBeneficiario\">\n              <button type=\"button\" md-effect class=\"btn btn-default btn-beneficiario\" ng-click=\"$ctrl.crearBeneficiario()\" ng-disabled=\"$ctrl.unidad_productiva.beneficiario\" uib-tooltip=\"Crear beneficiario\">\n                <i class=\"fa fa-user-plus\"></i>\n              </button>\n              <span><strong>Creación de Beneficiario SIGEP</strong></span>\n              <span><strong>{{$ctrl.unidad_productiva.matricula_comercio ? 'Jurídico' : 'Natural'}}</strong></span>\n              <span class=\"badge badge-danger\" ng-if=\"!$ctrl.unidad_productiva.beneficiario\">PENDIENTE</span>\n            </div>\n            <div ng-if=\"$ctrl.noExisteBeneficiario\" class=\"col-md-12 card-overflow\" style=\"color:#F35958\"> <strong>El beneficiario no existe, por favor proceda a la creación del Beneficiario con el botón de arriba <i class=\"fa fa-user-plus\"></i>. </strong> </div>\n          </div>\n          <div class=\"col-md-12\" ng-if=\"$ctrl.unidad_productiva.beneficiario\" style=\"margin-top: 10px\">\n            <i class=\"fa fa-check\"></i>\n            <span><strong>Beneficiario SIGEP</strong></span>\n            <span><strong>{{$ctrl.unidad_productiva.proceso.beneficiario.beneficiario.razonSocial ? 'Jurídico' : 'Natural'}}</strong></span>\n            <span class=\"badge badge-success\" ng-if=\"$ctrl.unidad_productiva.beneficiario\">VERIFICADO</span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row container\" style=\"margin-top: 20px\">\n        <div class=\"col-sm-12\">\n          <div class=\"form-group\">\n            <label style=\"width: 100px;\">Beneficiario: </label><span> {{$ctrl.unidad_productiva.beneficiario ? $ctrl.unidad_productiva.beneficiario : 'PENDIENTE'}} </span>\n          </div>\n        </div>\n        <div class=\"col-sm-12\">\n          <div class=\"form-group\">\n            <label style=\"width: 100px;\">Nombre: </label><span>\n              {{$ctrl.unidad_productiva.proceso.beneficiario.beneficiario.nombreImpresion ?\n                $ctrl.unidad_productiva.proceso.beneficiario.beneficiario.nombreImpresion :\n                $ctrl.unidad_productiva.proceso.beneficiario.beneficiario.razonSocial ?\n                $ctrl.unidad_productiva.proceso.beneficiario.beneficiario.razonSocial : 'PENDIENTE'}}</span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"row\" style=\"margin-top: 20px\">\n        <div class=\"col-md-12\">\n          <button type=\"button\" md-effect class=\"btn btn-default btn-beneficiario\" ng-click=\"$ctrl.asociarCuenta()\" ng-if=\"$ctrl.certificacion.estado.indexOf('APROBADO') === -1 && $ctrl.unidad_productiva.cuenta_estado !== 'ACTIVO' && $ctrl.unidad_productiva.cuenta_validada !== 'VAL'\" ng-disabled=\"$ctrl.unidad_productiva.cuenta_estado === 'ACTIVO' && $ctrl.unidad_productiva.cuenta_validada === 'VAL'\">\n            <i class=\"fa fa-dollar\"></i>\n          </button>\n          <i ng-if=\"$ctrl.unidad_productiva.cuenta\" class=\"fa fa-check\"></i>\n          <span><strong>Asociación de cuenta bancaria</strong></span> \n          <span class=\"badge badge-danger\" ng-if=\"$ctrl.unidad_productiva.cuenta_validada !== 'VAL' || $ctrl.unidad_productiva.cuenta_estado !== 'ACTIVO'\">PENDIENTE</span>\n          <span class=\"badge badge-success\" ng-if=\"$ctrl.unidad_productiva.cuenta_validada === 'VAL' && $ctrl.unidad_productiva.cuenta_estado === 'ACTIVO'\">VERIFICADO</span>\n        </div>\n      </div>\n\n      <div class=\"row container\" style=\"margin-top: 20px\">\n        <div class=\"col-sm-12\">\n          <div class=\"form-group\">\n            <label style=\"width: 200px;\">Estado de Validación: </label><span> {{$ctrl.estadoDescripcion || 'PENDIENTE'}}</span>\n          </div>\n        </div>\n        <div class=\"col-sm-12\">\n          <div class=\"form-group\">\n            <label style=\"width: 200px;\">Banco: </label><span> {{$ctrl.unidad_productiva.banco && $ctrl.unidad_productiva.banco === '1014' ? 'BANCO UNIÓN S.A.' : ($ctrl.unidad_productiva.banco || 'PENDIENTE')}}</span>\n          </div>\n        </div>\n        <div class=\"col-sm-12\">\n          <div class=\"form-group\">\n            <label style=\"width: 200px;\">Cuenta: </label><span> {{$ctrl.unidad_productiva.cuenta ? $ctrl.unidad_productiva.cuenta : 'PENDIENTE'}} </span>\n          </div>\n        </div>\n        <div class=\"col-sm-12\">\n          <div class=\"form-group\">\n            <label style=\"width: 200px;\">Moneda: </label><span> {{$ctrl.monedaDescripcion ? $ctrl.monedaDescripcion : 'PENDIENTE'}} </span>\n          </div>\n        </div>\n        <div class=\"col-sm-12\">\n          <div class=\"form-group\">\n            <label style=\"width: 200px;\">Tipo de cuenta: </label><span> {{$ctrl.tipoDescripcion ? $ctrl.tipoDescripcion : 'PENDIENTE'}} </span>\n          </div>\n        </div>\n        <div class=\"col-sm-12\">\n          <div class=\"form-group\">\n            <label style=\"width: 200px;\">Departamento/Distrito: </label><span> {{$ctrl.departamentoDescripcion ? $ctrl.departamentoDescripcion : 'PENDIENTE'}} </span>\n          </div>\n        </div>\n      </div>\n\n<!--\n      <div class=\"row\" style=\"margin-top: 20px\">\n        <div class=\"col-md-12\">\n          <button type=\"button\" md-effect class=\"btn btn-default\" ng-click=\"$ctrl.actualizarDdjj()\" ng-if=\"$ctrl.certificacion.estado.indexOf('APROBADO') === -1\" ng-disabled=\"$ctrl.unidad_productiva.cuenta\">\n            <i class=\"fa fa-refresh\"></i>\n          </button>\n          <i ng-if=\"$ctrl.unidad_productiva.cuenta\" class=\"fa fa-check\"></i>\n          <span><strong>Envío de productos</strong></span>\n        </div>\n      </div> -->\n    </div>\n  </ng-form>\n</div>\n"

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"alert alert-warning\">\n  <i class=\"fa fa-info-circle\" ap></i>\n  <span>Registre los  productos que pondrá a la venta mediante la plataforma. Recuerde que todos los productos deben ser HECHOS EN BOLIVIA.</span>\n</div>\n<ng-form name=\"producto_form\">\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title\" ng-if=\"$ctrl.esRefrigerio\">\n      Registro de Productos/Servicios\n    </h5>\n    <h5 class=\"modal-title\" ng-if=\"!$ctrl.esRefrigerio\">\n      Registro de Productos\n    </h5>\n  </div>\n    <div class=\"row\">\n        <div class=\"col-md-2 form-group\" ng-if=\"$ctrl.conf.codigo.visible\">\n            <label ng-class=\"{'ap-req':$ctrl.conf.codigo.requerido}\">{{$ctrl.conf.codigo.label}}</label>\n            <input name=\"codigo_producto\" class=\"form-control\" ng-model=\"$ctrl.dataProducto.codigo\" ng-maxlength=\"250\" maxlength=\"250\" \n                  ng-required=\"$ctrl.conf.codigo_producto.requerido\" >\n            <div ap-error ng-if=\"$ctrl.data.codigo.length>10\" role=\"alert\">Superó el límite de los caracteres</div>\n    \n            <div ap-error ng-messages=\"producto_form.codigo_producto.$error\" role=\"alert\" ng-if=\"producto_form.codigo_producto.$touched\">\n              <div ng-message=\"required\">El campo es requerido</div>\n            </div>\n          </div>\n      <div class=\"col-md-4 form-group\" ng-if=\"$ctrl.conf.nombre_producto.visible\">\n        <label ng-class=\"{'ap-req':$ctrl.conf.nombre_producto.requerido}\">{{$ctrl.conf.nombre_producto.label}}:</label>\n        <input name=\"nombre_producto\" class=\"form-control\" ng-model=\"$ctrl.dataProducto.nombre_producto\" ng-maxlength=\"250\" maxlength=\"250\" \n              ng-required=\"$ctrl.conf.nombre_producto.requerido\" >\n        <div ap-error ng-if=\"$ctrl.data.nombre_producto.length>249\" role=\"alert\">Superó el límite de los caracteres</div>\n\n        <div ap-error ng-messages=\"producto_form.nombre_producto.$error\" role=\"alert\" ng-if=\"producto_form.nombre_producto.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n      <div class=\"col-md-4 form-group\" ng-if=\"$ctrl.conf.precio_referencial.visible\">\n          <label ng-class=\"{'ap-req':$ctrl.conf.precio_referencial.requerido}\">{{$ctrl.conf.precio_referencial.label}}:</label>\n          <input name=\"precio_referencial\" class=\"form-control\" decimal-format maxlength=\"17\" class=\"form-control\"  \n          ng-model=\"$ctrl.dataProducto.precio_unitario\" \n          ng-maxlength=\"199\" maxlength=\"200\"  ng-required=\"$ctrl.conf.precio_referencial.requerido\">\n          <div ap-error ng-messages=\"producto_form.precio_referencial.$error\" role=\"alert\" ng-if=\"producto_form.precio_referencial.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>\n          </div>\n      </div>\n      <div class=\"col-md-4\">\n        <div class=\"form-group\">\n          <select-parametro name=\"fid_par_unidad_medida\" \n          parametro=\"UNIDAD_MEDIDA\" label=\"{{$ctrl.conf.unidad_medida.label}}:\"\n                                    ng-model=\"$ctrl.dataProducto.fid_par_unidad_medida\"\n                                    ng-required=\"$ctrl.conf.fid_par_unidad_medida.requerido\"\n                                    ></select-parametro>\n        </div>\n        <div ap-error ng-messages=\"producto_form.fid_par_unidad_medida.$error\" role=\"alert\" ng-if=\"producto_form.fid_par_unidad_medida.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n\n        <input name=\"unidad_medida_text1\" maxlength=\"50\" class=\"form-control\" ng-model=\"$ctrl.dataProducto.unidad_medida\" placeholder=\"Ingresar Descripción\"\n               ng-show=\"$ctrl.dataProducto.fid_par_unidad_medida === 700\" ng-if=\"($ctrl.dataProducto.fid_par_unidad_medida === 700)\"\n               required=\"{{$ctrl.dataProducto.fid_par_unidad_medida === 700}}\"\n               ng-disabled=\"$ctrl.guardandoProducto\"\n               >\n        <div ap-error ng-messages=\"producto_form.unidad_medida_text1.$error\" role=\"alert\" ng-if=\"producto_form.unidad_medida_text1.$touched\">\n          <div ng-message=\"required\">Ingrese unidad de medida</div>\n        </div>\n      </div>\n\n      <!-- <leaflet width=\"100%\" height=\"380px\" lf-center=\"$ctrl.center\" markers=\"$ctrl.markers\"></leaflet> -->\n      <!--<leaflet width=\"100%\" height=\"380px\" event-broadcast=\"$ctrl.events_leaflet\" lf-center=\"$ctrl.center\" markers=\"$ctrl.markers\" legend = \"$ctrl.legend\" defaults=\"defaults\" ></leaflet>-->\n    </div>\n      <div class=\"card-footer text-right\">\n        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.productosImportar()\" ng-if=\"$ctrl.esRefrigerio\"> \n          <i class=\"fa fa-paperclip\"></i>\n          Importar CSV\n        </button>\n        \n        <button  type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.save(producto_form)\">\n          <i class=\"fa fa-check\"></i> Guardar\n        </button>\n        \n      </div>\n      \n \n</ng-form>\n<div class=\"table-ap\" ng-if=\"$ctrl.listaProductos.length > 0\" >\n  <table class=\"table\">\n    <thead>\n      <tr>\n        <th></th>\n        <th class=\"text-center\">Nro</th>\n        <th class=\"text-left\">{{$ctrl.conf.nombre_producto.label}}</th>\n        <th class=\"text-center\">{{$ctrl.conf.unidad_medida.label}}</th>\n        <th class=\"text-right\">{{$ctrl.conf.precio_referencial.label}}</th>\n        <th class=\"text-right\">Estado</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr ng-repeat=\"item in $ctrl.listaProductos\">\n        <td class=\"icon-group\">\n          <i ng-if=\"item.estado === 'NUEVO'\" class=\"fa fa-trash text-danger\" uib-tooltip=\"Eliminar producto\" ng-click=\"$ctrl.productoDel($index, item)\"></i>\n          <i ng-if=\"item.estado === 'APROBADO'\" class=\"fa fa-minus text-danger\" uib-tooltip=\"Inactivar producto\" ng-click=\"$ctrl.productoBaja($index, item)\"></i>\n        </td>\n        <td class=\"table-ap-text text-center\">{{$index + 1}}</td>\n        <td class=\"table-ap-text text-left\">{{item.codigo ? item.codigo + ' - ': ''}}{{item.nombre_producto}}</td>\n        <td class=\"table-ap-text\">{{item.par_unidad_medida.nombre}}</td>\n        <td class=\"table-ap-text text-right\">{{item.precio_unitario|currency:''}}</td>\n        <td class=\"table-ap-text\">{{item.estado}}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>"

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"input_chip_form\">\n  <div class=\"\">\n  </div>\n  <div class=\"ap-chips form-group\">\n    <label ng-class=\"{'ap-req':$ctrl.ngRequired}\">{{$ctrl.label}}</label>\n    <div class=\"row mx-0 form-control\">\n        <div class=\"chip\" ng-repeat=\"chip in $ctrl.ngModel\">\n          <span>{{chip}}</span>\n          <i class=\"fa fa-close\" ng-click=\"$ctrl.remChip($index)\"></i>\n        </div>\n        <input style=\"width: 100%\" ng-model=\"$ctrl.chip\" placeholder=\"{{$ctrl.ngDisabled? '': $ctrl.ngPlaceholder}}\" ng-keyup=\"$ctrl.keyChip($event)\" ng-blur=\"$ctrl.onBlurChip($event)\" ng-disabled=\"$ctrl.ngDisabled\" name=\"ichips\" uppercase ng-if=\"$ctrl.ngUppercase\">\n        <input style=\"width: 100%\" ng-model=\"$ctrl.chip\" placeholder=\"{{$ctrl.ngDisabled? '': $ctrl.ngPlaceholder}}\" ng-keyup=\"$ctrl.keyChip($event)\"  ng-blur=\"$ctrl.onBlurChip($event)\" ng-disabled=\"$ctrl.ngDisabled\" name=\"ichips\" ng-if=\"!$ctrl.ngUppercase\" >\n        <input type=\"hidden\" name=\"chips\" ng-model=\"$ctrl.chips_model\" ng-required=\"$ctrl.ngRequired\">\n    </div>\n    <div ap-error ng-messages=\"input_chip_form.chips.$error\" role=\"alert\" ng-if=\"input_chip_form.ichips.$touched\">\n      <div ng-message=\"required\">El campo es requerido</div>\n    </div>\n  </div>\n</ng-form>\n"

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"localizacion form-group\">\n  <label>{{$ctrl.ngLabel}}</label>\n  <div class=\"row no-gutters\">\n    <div class=\"col-md-4\">\n      <input class=\"form-control\" ng-model=\"$ctrl.latitud\" disabled placeholder=\"Latitud\">\n    </div>\n    <div class=\"col-md-4\">\n      <input class=\"form-control\" ng-model=\"$ctrl.longitud\" disabled placeholder=\"Longitud\">\n    </div>\n    <div class=\"col-md-4\">\n      <!-- <button class=\"btn btn-primary form-control\"><i class=\"fa fa-\"></i></button> -->\n      <img class=\"cursor-pointer\" ng-click=\"$ctrl.openModal()\" width=\"37\" height=\"37\"  src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAvCAYAAACVDljoAAAABHNCSVQICAgIfAhkiAAAABl0RVh0U29mdHdhcmUAZ25vbWUtc2NyZWVuc2hvdO8Dvz4AAArNSURBVFiFrZnZc5RXdsB/51t7VatBEohVMovBkJgCEmAw9pDJjD1T5UwqVZk4mUml8pS/J0+pVGoenEqNZyqZxFMZO5VZMBReiDGMMcGAAbELgdRaevv62+7JQ0sCoe6WID5V/dDd5977O8s9dxNVVZ5DVBWShLRepXX5Es2zn9C6+iXJdAUNQxDB8n2cdcP4e1+mcPgVvK2j2Lk8YtvPPJ48D6iqYhp1mufPMvvv7xBeuwqqiEhnfQARcgcPUf7zH+G/sAPJZLrqfy2gqko6M830O29T+837aBg+24CZLP0/+BF93/s+dqG46rbPBKqqJDPTVP7x72mc+RCN42eCXOhDXIe+7/4p5R/+7aphrWcZxARNZn/6No2znzwXJICIoHFC9b//k7lf/CsmClfVbtWgagz1j09RO/0B2mo9F+STsEQR1ffeJfjdZ6wmqKsGTWYqVH/5Llqv9YRUVVJVjCorDW/qNWZ//g6mUf96QFWVxkeniCfuo2naVa+VGmajhPFmxIMgYi5KiIzpCqxpSnR7jOb5T1dkcFYFGoU0znyENpsdvalAK0m5Ug24UW/RSg0ABcdiV1+O0UIG317uExFBw4jGx6cpHDuOSHe/rehRVUN070bbm0nSUceocmWuyeW5Jq3UICKICI1UOT/T4Fa91T0Pk5jwxlVMEPTk6AmqmqLhHcKr76Gtua56jTjlRr2FwjKPK/BltUlkOoOqKiYIiB+O95xUXUFVEzT4inTyn4jHT0ASdJ1EM1FConTMRVWlmRiaXaIBoGlIMnkBNd292hFUNUWDr0imfoxpfg5p1JniSelRrYQVmqcN0ul/w9Q/Rk1rdaCqioa3SSv/grauAAmSE7DoGpqSZ+PN5+UySBFyjkW+10bEAsuvkE79M6ZxDtXl3l8OmsyQzvwHJvgSNALAGZSe9aHPddic93Fl3tB5g1QVzxJ2FrN4HWb9giFWFuwykEySVn6CaY0tc8qS1mpiTO0UpvEZaMBCPN11gt0P3aqHJcKeUo6tOZ9+1ybn2ORsi7LnsK3gs6OY7VzWVMFWvM0WVlaAFI3uYGbfRdPaEt0lftLoNqZ2EtKZJUp2ziKz0yaZSDFB5+1czrHZv7bAo1ZMNU4RoOw5DGRc7G4rmYBkIPv7NrKQ5BphGr9DsmeQ0h8v1tZFUNUYUzuJRvcAw9OzI7vPJriUouN0nRmuZbEx57Ox899LRFURG7wtNpkdT4UqnUNrv0HzBxB3LfBE6DUaxzQvgqkvgwRwhyxyB+z2xFqxBKwsImCVhMJRGyvzdE4lmPAO2jy3+Iu1YJ1pnEPjya4QYgn5gw7+Tguc5985LYov5Pbb+Ds7VQMBU8fU/wc10WNQTIQJLkNapVdBtAsWxdcc3E0Clq5qe/a0KIoRYXrTRrxvZBG7y3gaY6I7aDzxGFSTSUgmgGjFYdxNFs7RAla/hTxjFqgqBovbxRd4b+QtTswdJ0gyXcfCNNDW1SdA4zuoadLLm6mxuFcf5vSDI1xedwDnQBbxBeQZSEWouiXe3/wXnDDf4u2v/pKZqNxNGUwLDW+hqvOzPp6EjkuXEqUe9xob+Gp2G19MvcSFyu+xb+AL9h66iNwPCK8omnY/gS72pJCIzadDr/H54BEEwahFYjweh+VJowU0QuOHoKYNqmkNNF7W8Vh1lIvTu7kwtZeL03uoRQUUQbGwC+C/6hA/iDEzvb2qqijCvfwIv938fYzlLGFKjMPN6hZuzI2ACL4dsqN0g02Fh2g6B8yDYgJ4an1V4MT9V/nV3T+iGhVRBJGlyZHZZpPZm9L8OEWTHl4VIRKXDza9yVR2/WIfqXEYmxthKujnV3e/ydlHB0GEsj/LD3f8jI2FB/Mr5Hzou51u7jc20EyyINIxe8WGwmGH1mWDmeq+31SEsdIuzg0dXWJMZHx+cesNbEkZq26lmeYB8OyQxMx7fb6yOG2DPZ7l5BymPpWwTCvNQEkJd4Y4MxUk0XYlX2oOsTh8sOlNArewaLAIpOpwefbF7gOJIOIDMg9qF0Ec2ktnu/NeFeBGdYSfXf8zXKud11qK+bb7E8rp9PJWArf6dnJpzYFeW9YlEhuXsepWzk8eZHDtNrZjzeeos4Zr1T1cn/IJU58d/Td4oe9W147GGxsYb2x44hfDUPk6xx78GluTJeFVVU5veIOWk1s1aJBk+OjhYcYaL3HczbFd5kHV3cLJidc5dXMdQZph/8DnfHPDh8yEJUyHlHg6uorFR8Pf5tDDk2SfOk5P+UNcXPsHyzOih6Tq8LA5RCoDZHMpIvOhxx2mZopUY58wdTg/9TKPgkHu1jditHfuLqyit4s7uJcfYXvtKsLjjfOFwcPUvNKqvbkgIkoho+xe/8Q2z7az7FjX5NxdpdVQ6nGRyzNPJbmAZytFD/K+kveUjAu+Db6juJZg6yE4fQ01j8OfPXKMo8WUMBVaiRBESi0S6qEQxLJo6JMeVwXPNoyUQ4bLpcegIsLBLTYnrhqmGoqqUPCVgbwymFfKufanz1fyHuRcyLiK74Bntw2wLcgM7yc981OI2uG3B9dz+JWtvCwJUSqEqRDGSjMWggiqoTAbCNNNodIUJuvt74pS9JVvjBpcx3sMCrBpbY5j22ps6EsoZ4XBQhuuPwtFXyn4kHEUEQjThGYa0khCwjSmnkaEcUKUazG4psiaiRBUGX9hI7GM49kevucyaHsUnAy+7WIhxEaoh1ALhbmWMNsUKk2YqApZL+XgaHbRy4ugjuNzfFfCvo0hedeQdZRYYyphnTutWSarc0yFNWaiOtUoIEhDGmlEYlLiNCbGkJiU76yxeGOiXdx+Xmxw5+p/YVsOruWQsVxyrkfezrDWK7DGLzKY7WPY72dkoI+CnSE2wlwLXNdjTTG3HBRgqJRFaXLu0XWuVR8wHkwz2ZpjJmpQiwOqSUAjbhGapL2vVF0ySUSE/rLwHcBYwql8SGV6rJ13gMwvw47YFJwMBTdDn5uj381R9goMZ8uMFtexb+0oWwc2IWJ3BrUsC9/3+aRyjd+OX2A6rBGZZAnIEv0ONed62Se2YSbrUMk6i22e1Ew0ZTZuMBs3UJ2a78ui4GTYU97Cy+u2YTtLz+fLak9fJs9rm/ZS9HMk+vjCa7UXt5NZhznf5lrJR62V2yz0bVAQODK8iy2loeVOebqhY9m8MryHv9v9OpsLA3TejnSX2LZ4UHC5WfJWvXtQVQqOz1vbX+UH245R9LLLdDref+Rcn9e37EeBf7j0Prdrj+h+HbtULBHuFjzu97mrxIQ+L8dfbX+Nv37xOOty/R11er6K1KKADx9c4seXf82Fyk1ik6wqBXY9CqjkbCYLXlcdnX+XGs6V+ZsXv8WbI4cYzpW79r/i800ribg0c4d3x87wy9tnmQ3rKL2PHnaqGAu0h44jNq8Mv8Rb24/xh0M7KWeKvTBW985k1DDemOaLyk3ev/0ZJ8f/l3rcvstc7SRbGMYSi31rR/mT0UMcWbeL0b71ePbKN/TP9CAWpTH3GxXG5iY4M3GFTyevcXX2Ps00xKJzZUhVsYCtxSH2D2zj6Prd7F6zmS2FoY6T5msBXZDEpFRaNaaCOaZaNe7WHnGnUWE2rFFLAlKj5B2PPi/PcH4NI4UhhnIlBjIlhrIlMk733P1aQRekfaGgtJKIRhK2l1I17XO4WLi2Q9b2yLsZbLH+X49o/wfYdD6/oyeZWAAAAABJRU5ErkJggg==\">\n    </div>\n  </div>\n</div>\n\n\n<!-- <leaflet width=\"100%\" height=\"480px\" lf-center=\"$ctrl.center\" markers=\"$ctrl.georeferenciacion2\"></leaflet> -->\n"

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i>{{$ctrl.ngLabel}}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <leaflet width=\"100%\" height=\"380px\" lf-center=\"$ctrl.center\" markers=\"$ctrl.markers\"></leaflet>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n        <i class=\"fa fa-check\"></i> Guardar\n    </button>\n</div>\n"

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = "  <div class=\"body-section\">\n    <ng-form name=\"representante_form\">\n      <div ng-show=\"$ctrl.axs.sw_propietario\">\n        <documento-identidad-contrastacion\n          ng-model=\"$ctrl.data.hist_representantes\"\n          conf=\"$ctrl.conf\"\n          completo=\"true\"\n          only-ci=\"true\"\n          departamentos=$ctrl.departamentos></documento-identidad-contrastacion>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-4 form-group\">\n          <div class=\"form-group mb-0\"><label ng-class=\"{'ap-req':$ctrl.conf.rep_agui.genero.requerido}\">Género:</label></div>\n          <label class=\"custom-control custom-radio\">\n            <input name=\"genero\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.hist_representantes.genero\" value=\"M\" ng-required=\"$ctrl.conf.rep_agui.genero.requerido\" ng-disabled=\"$ctrl.conf.rep_agui.genero.disabled\">\n            <span class=\"custom-control-indicator\"></span>\n            <span class=\"custom-control-description\">Masculino</span>\n          </label>\n          <label class=\"custom-control custom-radio\">\n            <input name=\"genero\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.hist_representantes.genero\" value=\"F\" ng-required=\"$ctrl.conf.rep_agui.genero.requerido\" ng-disabled=\"$ctrl.conf.rep_agui.genero.disabled\">\n            <span class=\"custom-control-indicator\"></span>\n            <span class=\"custom-control-description\">Femenino</span>\n          </label>\n          <div ap-error ng-messages=\"representante_form.genero.$error\" role=\"alert\" ng-if=\"representante_form.genero.$touched\">\n            <div ng-message=\"required\">El género es requerido</div>\n          </div>\n        </div>\n        <div class=\"col-md-4 form-group\" ng-if=\"$ctrl.conf.rep_agui.telefono.visible\">\n          <label ng-class=\"{'ap-req':$ctrl.conf.rep_agui.telefono.requerido}\">{{$ctrl.conf.rep_agui.telefono.label}}:</label>\n          <input name=\"telefono\" phone minlength=\"5\" maxlength=\"25\" class=\"form-control\" ng-model=\"$ctrl.data.hist_representantes.telefono\" ng-required=\"$ctrl.conf.rep_agui.telefono.requerido\" ng-disabled=\"$ctrl.conf.rep_agui.telefono.disabled\">\n          <div ap-error ng-messages=\"representante_form.telefono.$error\" role=\"alert\" ng-if=\"representante_form.telefono.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>\n            <div ng-message=\"minlength\">El número debe tener 5 o más caracteres</div>\n            <div ng-message=\"maxlength\">El número debe tener 25 o menos caracteres</div>\n          </div>\n        </div>\n        <div class=\"col-md-4 mt-4 pt-2 form-group\" ng-if=\"$ctrl.conf.rep_agui.discapacidad.visible\">\n            <label class=\"custom-control custom-checkbox\">\n              <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"$ctrl.data.hist_representantes.discapacidad\" ng-disabled=\"$ctrl.conf.rep_agui.discapacidad.disabled\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">Persona con discapacidad</span>\n            </label>\n          </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-group col-md-4\">\n          <label ng-class=\"{'ap-req':$ctrl.conf.rep_agui.estado_civil.requerido}\">{{$ctrl.conf.rep_agui.estado_civil.label}}:</label>\n          <uib-select name=\"estado_civil\" ng-model=\"$ctrl.data.hist_representantes.estado_civil\" \n            items=\"$ctrl.estadosCivil\" key-text=\"nombre\" key-value=\"sigla\" \n            placeholder=\"Estado Civil\" \n            ng-required=\"$ctrl.conf.rep_agui.estado_civil.requerido\" \n            ng-disabled=\"$ctrl.conf.rep_agui.estado_civil.disabled\"></uib-select>\n          <div ap-error ng-messages=\"representante_form.estado_civil.$error\" role=\"alert\" ng-if=\"representante_form.estado_civil.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>\n          </div>\n        </div>\n        <div class=\"form-group col-md-6\">\n          <label ng-class=\"{'ap-req':$ctrl.conf.rep_agui.formato_inf.requerido}\">{{$ctrl.conf.rep_agui.formato_inf.label}}</label>\n          <uib-select name=\"formato_inf\" ng-model=\"$ctrl.data.hist_representantes.formato_inf\" \n            items=\"$ctrl.formatos\" key-text=\"nombre\" key-value=\"sigla\" \n            placeholder=\"Formato de la Información\" ng-required=\"$ctrl.conf.rep_agui.formato_inf.requerido\" ng-disabled=\"$ctrl.conf.rep_agui.formato_inf.disabled\"></uib-select>\n          <div ap-error ng-messages=\"representante_form.formato_inf.$error\" role=\"alert\" ng-if=\"representante_form.formato_inf.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>\n          </div>\n        </div>        \n      </div>\n    </ng-form>\n  </div>\n"

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"select_date_form\">\r\n<div class=\"select-date form-group\">\r\n  <label ng-class=\"{'ap-req':$ctrl.ngRequired}\">{{$ctrl.label}}</label>\r\n  <div class=\"row mx-0\">\r\n    <input name=\"fecha\" numeric  maxlength=\"2\" minlength=\"1\" class=\"col-md-2 form-control day\" ng-model=\"$ctrl.day\" ng-change=\"$ctrl.changeDate('day')\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\" placeholder=\"Día\">\r\n    <uib-select name=\"fecha\" class=\"month\" ng-model=\"$ctrl.month\" items=\"$ctrl.months\" key-value=\"val\" key-text=\"name\" placeholder=\"Mes\" ng-required=\"$ctrl.ngRequerid\" ng-disabled=\"$ctrl.ngDisabled\"></uib-select> \r\n    <input name=\"fecha\" numeric maxlength=\"4\" minlength=\"4\" class=\"col-md-2 form-control year\" ng-model=\"$ctrl.year\" ng-change=\"$ctrl.changeDate('year')\" ng-required=\"$ctrl.ngRequired\" ng-disabled=\"$ctrl.ngDisabled\"  placeholder=\"Año\" >\r\n  </div>\r\n  <div ap-error ng-messages=\"select_date_form.fecha.$error\" role=\"alert\" ng-if=\"select_date_form.fecha.$touched\">\r\n    <div ng-message=\"required\">La fecha es requerida</div>\r\n    <div ng-message=\"minlength\">La fecha es requerida</div>\r\n    <div ng-message=\"maxlength\">La fecha es requerida</div>\r\n  </div>\r\n  <!-- <pre>{{select_date_form.fecha |json}}</pre> -->\r\n</div>\r\n</ng-form>\r\n"

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"dep_pro_mun_form\">\n  <div class=\"row\">\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"departamento\" label=\"Departamento:\" ng-model=\"$ctrl.departamento\" items=\"$ctrl.departamentos\" key-value=\"id\" key-text=\"descripcion\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_departamento.requerido\" ng-disabled=\"$ctrl.conf.fid_departamento.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.departamento.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.departamento.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"provincia\" label=\"Provincia:\" ng-model=\"$ctrl.provincia\" items=\"$ctrl.provincias\" key-value=\"id\" key-text=\"nombre\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_provincia.requerido\" ng-disabled=\"$ctrl.conf.fid_provincia.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.provincia.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.provincia.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n\n    <div class=\"form-group col-md-4\">\n      <uib-select name=\"municipio\" label=\"Municipio:\" ng-model=\"$ctrl.municipio\" items=\"$ctrl.municipios\" key-value=\"id\" key-text=\"nombre\" placeholder=\"Seleccione...\" ng-required=\"$ctrl.conf.fid_municipio.requerido\" ng-disabled=\"$ctrl.conf.fid_municipio.disabled\"></uib-select>\n      <div ap-error ng-messages=\"dep_pro_mun_form.municipio.$error\" role=\"alert\" ng-if=\"dep_pro_mun_form.municipio.$touched\">\n        <div ng-message=\"required\">El campo es requerido</div>\n      </div>\n    </div>\n  </div>\n</ng-form>\n"

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = "<uib-select ng-if=\"$ctrl.typeSelect=='model'\"\n  ng-model=\"$ctrl.ngModel\"\n  items=\"$ctrl.items\"\n  label=\"{{$ctrl.label}}\"\n  key-text=\"{{$ctrl.key}}\"\n  placeholder=\"Seleccione...\"\n  ng-disabled=\"$ctrl.ngDisabled\"\n  ng-required=\"$ctrl.ngRequired\">\n</uib-select>\n<uib-select ng-if=\"$ctrl.typeSelect=='id'\"\n  ng-model=\"$ctrl.ngModel\"\n  items=\"$ctrl.items\"\n  label=\"{{$ctrl.label}}\"\n  key-value=\"id_parametro\"\n  key-text=\"{{$ctrl.key}}\"\n  placeholder=\"Seleccione...\"\n  ng-disabled=\"$ctrl.ngDisabled\"\n  ng-required=\"$ctrl.ngRequired\">\n</uib-select>\n"

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"page_timeline\" class=\"body_modal\" >\n  <ul class=\"timeline\">\n  \t<li ng-repeat=\"time in $ctrl.ngModel\" >\n  \t\t<div ng-class-odd=\"'direction-l'\" ng-class-even=\"'direction-r'\">\n        <div class=\"flag-wrapper\">\n        \t\t\t\t<span class=\"flag\">{{time.estado}}</span>\n        \t\t\t\t<span class=\"time-wrapper\"><span class=\"time\">\n                  {{ time.fecha |  date:'MM/dd/yyyy - h:mma'}}\n                </span></span>\n        </div>\n        <div class=\"desc\" ng-hide=\"$ctrl.hiddenField=='usuario'\"><strong>Usuario: </strong> {{time.usuario.nombre?time.usuario.nombre:$ctrl.representante}}\n        </div>\n        <!-- <div class=\"desc\"><strong>Estado de firma: </strong>{{time.estado_firma}}\n        </div>-->\n        <div class=\"desc\" ng-if=\"time.observacion\"><strong>Observación: </strong> {{time.observacion}}\n        </div>\n  \t\t</div>\n  \t</li>\n  </ul>\n</ng-form>\n"

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar\">\n  <div class=\"form-inline navbar-buttons\">\n    <button type=\"button\" class=\"btn btn-link btn-toggle\" ng-click=\"$ctrl.toggleSidenav()\">\n        <i class=\"fa fa-bars text-primary\"></i>\n    </button>\n    <button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.refresh()\">\n        <i class=\"fa fa-refresh text-primary\"></i>\n    </button>\n    <button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.fullscreen()\">\n        <i class=\"fa fa-arrows-alt text-primary\"></i>\n    </button>\n    <!-- <button type=\"button\" class=\"btn btn-link\">\n        <i class=\"fa fa-bell-o\"></i>\n    </button>\n    <div class=\"input-group\">\n        <div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div>\n        <input type=\"text\" class=\"form-control\" id=\"inlineFormInputGroup\" placeholder=\"Escriba su búsqueda aquí\">\n    </div> -->\n    <!-- <uib-select ng-model=\"$ctrl.empresa\" placeholder=\"Seleccione una empresa\" items=\"$ctrl.empresas\"></uib-select> -->\n  </div>\n\n  <div class=\"row\" style=\"padding-right: 5px;\">\n    <!-- <div class=\"form-inline text-right telefono\" style=\"margin-right: 15px;\">\n        <i class=\"fa fa-phone\" style=\"margin-right: 10px;\"> </i>\n        800-10-1660\n    </div> -->\n    <div class=\"navbar-nav navbar-buttons\">\n      <div class=\"nav-item dropdown\" uib-dropdown is-open=\"status.isopen\">\n        <a id=\"single-button\" href=\"\" class=\"nav-link\" uib-dropdown-toggle>\n            <i class=\"fa fa-gear\"></i>\n        </a>\n        <div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"navbarDropdownMenuLink\" style=\"margin-top: -40px;\">\n          <a class=\"dropdown-item\" href=\"\" ng-click=\"$ctrl.miCuenta()\"><i class=\"fa fa-user\"></i> Mi cuenta</a>\n          <!-- <a class=\"dropdown-item\" href=\"\"><i class=\"fa fa-cog\"></i> Configuraciones</a> -->\n          <a class=\"dropdown-item\" href=\"\" ng-click=\"$ctrl.logout()\"><i class=\"fa fa-sign-out\"></i> Cerrar sesión</a>\n        </div>\n      </div>\n    </div>\n  </div>\n</nav>\n"

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sidenav\">\n    <div class=\"sidenav-app\">\n        <div class=\"sidenav-logo text-primary\">\n            <span class=\"sidenav-logo-probolivia\"></span>\n            <!--<span class=\"sidenav-logo-promueve\"></span>-->\n        </div>\n        <h1 class=\"sidenav-title\">{{ $ctrl.systemName }}</h1>\n    </div>\n    <div class=\"sidenav-user\" ng-if=\"$ctrl.getSidenav()\">\n        <figure class=\"sidenav-user-photo rounded-circle bg-{{ $ctrl.getColor() }}\">{{ $ctrl.getInitial() }}</figure>\n        <div class=\"sidenav-user-info\">\n            <label class=\"sidenav-user-name\" uib-tooltip=\"{{ $ctrl.getName() }}\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\">{{ $ctrl.getName() }}</label>\n            <label class=\"sidenav-user-mail\" uib-tooltip=\"{{ $ctrl.getEmail() }}\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\"><i class=\"fa fa-envelope-o\"></i> {{ $ctrl.getEmail() }}</label>\n        </div>\n    </div>\n    <div class=\"sidenav-container\" id=\"sidenav-menu\" ng-if=\"$ctrl.getVisible()\">\n        <ul class=\"sidenav-menu\">\n            <li ng-repeat=\"option in $ctrl.getMenu()\">\n                <a md-effect class=\"sidenav-item active\" href=\"\" ng-click=\"$ctrl.send(option.url, option.submenu.length)\" toggle-menu data-url=\"{{option.url || option.label }}\">\n                    <span class=\"sidenav-icon rounded-circle bg-{{option.color}}\"><i class=\"fa fa-{{option.icon}}\"></i></span>\n                    <label class=\"sidenav-item-text\">{{ option.label }}</label>\n                    <span class=\"sidenav-item-arrow\" ng-if=\"option.submenu.length\"><i class=\"fa fa-angle-right\"></i></span>\n                </a>\n                <ul class=\"sidenav-submenu\" ng-if=\"option.submenu.length\">\n                    <li ng-repeat=\"sub in option.submenu\">\n                        <a md-effect class=\"sidenav-submenu-item btn-default\" href=\"\" data-url=\"{{sub.url}}\" ng-class=\"{ 'active' : $ctrl.url == sub.url }\" ng-click=\"$ctrl.send(sub.url)\">{{ sub.label }}</a>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n    </div>\n</div>"

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"containt-verify\">\n  <nav class=\"navbar fixed-top\">\n    <div class=\"d-flex row justify-content-center\">\n      <div class=\"verify-logo\"></div>\n    </div>\n  </nav>\n  <div class=\"container p-5 content-verify\">\n    <div class=\"row\">\n      <div class=\"col-md-10 offset-0 offset-md-1\">\n        <div class=\"container\">\n          <div ng-if=\"$ctrl.loading\" id=\"loading-bar-spinner\" class=\"screen-locked\">\n            <div class=\"loading-container\">\n              <span class=\"loading-text text-primary\">Cargando...</span>\n              <span class=\"spinner-icon\"></span>\n            </div>\n          </div>\n          <!-- <h1>{{$ctrl.deviceDetector.device}}</h1> <\\!-- detectar el dispositivo -\\-> -->\n          <div ng-if=\"!$ctrl.loading\">\n            <div class=\"row\" ng-show=\"!$ctrl.mostrarData\">\n              <div class=\"col-lg-12 col-md-12 card-element\" style=\"padding: 50px\">\n                <strong class=\"mb-2\">\n                  No se ha encontrado la información solicitada o el enlace es incorrecto.\n                </strong>\n              </div>\n            </div>\n            <div class=\"row\" ng-show=\"$ctrl.mostrarData\">\n              <div class=\"col\">\n                <div class=\"row align-items-center\">\n                  <div class=\"col-12 col-md-4\">\n                    <div class=\"d-flex justify-content-center align-items-center img-containt\">\n                      <img src=\"data:image/jpeg;base64,{{data.img64}}\" class=\"img-fluid\">\n                    </div>\n                  </div>\n                  <div class=\"col-12 col-md-8\">\n                    <h5 class=\"mb-2 text-{{$ctrl.urlPdf? 'success':'danger'}}\">\n                      <i class=\"fa fa-{{$ctrl.urlPdf? 'check-circle':'close'}}\"></i>\n                      <strong> {{$ctrl.urlPdf? 'Certificado Válido': 'No se pudo verificar'}}</strong>\n                    </h5>\n                    <label class=\"font-weight-medium mt-3\">Nombre o Razón Social:</label>\n                    <div class=\"form-control-verify\">{{data.razon_social}}</div>\n                    <label class=\"font-weight-medium mt-3\">Representante Legal:</label>\n                    <div class=\"form-control-verify\">{{data.nombre_completo}}</div>\n                    <label class=\"font-weight-medium mt-3\">Nombre comercial del producto:</label>\n                    <div class=\"form-control-verify\">{{data.nombre_producto}}</div>\n                    <div class=\"row no-gutters\">\n                      <div class=\"col-12 col-md-6\">\n                        <label class=\"font-weight-medium mt-3\">Fecha Emisión: </label>\n                        <div class=\"form-control-verify\">{{data._fecha_aprobacion | date:'dd/MM/yyyy'}}</div>\n                      </div>\n                      <div class=\"col-12 col-md-6\">\n                        <label class=\"font-weight-medium mt-3\">Vigencia: </label>\n                        <div class=\"form-control-verify\">{{data._fecha_fin | date:'dd/MM/yyyy'}}</div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-12 px-0 px-md-5 mt-3\" style=\"background-color: #eff1f1; border: 1px solid #cccecf;\">\n                    <!--PDF para ordenador y android-->\n                    <div ng-show=\"!$ctrl.esEdge()\" style=\"max-height:450px; overflow-y:auto; padding:0px;\">\n                      <canvas id=\"the-canvas\"></canvas>\n                    </div>\n                    <!-- solo para edge y explorer -->\n                    <div ng-show=\"$ctrl.esEdge()\" class=\"text-center\">\n                      <div ng-pdf-object url=\"{{$ctrl.urlEdge}}\" ng-if=\"$ctrl.showPdf\"></div>\n                    </div>\n                    <!-- find pdf -->\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-user\"></i> Modal title</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <ul>\n        <li ng-repeat=\"item in $ctrl.items\">\n            <a href=\"#\" ng-click=\"$event.preventDefault(); $ctrl.selected.item = item\">{{ item.text }}</a>\n        </li>\n    </ul>\n    Selected: <strong>{{ $ctrl.selected.item.text }}</strong>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\n        <i class=\"fa fa-check\"></i> Guardar\n    </button>\n</div>"

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login__container\">\n  <div class=\"izq\">\n    <div class=\"images__container\">\n      <div class=\"top\">\n        <div class=\"logo\"></div>\n        <div class=\"dobleAguinaldo\"></div>\n        <div class=\"consumeNuestro\"></div>\n      </div>\n    </div>\n    <div class=\"descripcion\">\n      En este sitio el administrador puede realizar lo siguiente:\n      <ul>\n        <li>Realizar altas en el sistema</li>\n        <li>Realizar modificaciones en el sistema</li>\n        <li>Realizar eliminaciones en el sistema</li>\n        <li>Realizar configuraciones en el sistema</li>\n        <li>Realizar mas funcionalidades</li>\n      </ul>\n    </div>\n    <div class=\"phone text-primary hide--medium\">\n      <i class=\"fa fa-phone text-primary\"></i>\n      <section>800-10-1660</section>\n    </div>\n    <div class=\"bottom hide--medium\">\n      <div class=\"logoMinisterio\"></div>\n    </div>\n\n  </div>\n  <div class=\"der\">\n    <div class=\"login__administrador\">\n      <div class=\"alert alert-info text-center titulo\">\n        <i class=\"fa fa-building-o\"></i><strong>Administrador del sistema</strong>\n      </div>\n      <form ng-submit=\"$ctrl.signinAdmin()\">\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon text-info\"><i class=\"fa fa-user\"></i></span>\n          <md-input label=\" Usuario / Correo electrónico\" ng-model=\"$ctrl.usuario\" required id=\"usuario\"></md-input>\n        </div>\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon text-info\"><i class=\"fa fa-lock\"></i></span>\n          <md-input label=\"Contraseña\" ng-model=\"$ctrl.contrasena\" type=\"password\" required></md-input>\n        </div>\n        <button md-effect class=\"btn btn-primary btn-lg btn-block\" type=\"submit\">\n          <i class=\"fa fa-sign-in\"></i> Iniciar sesión\n        </button>\n        <p class=\"centerText\"><br/>\n          <span class=\"login-message\"><a href=\"\" ng-click=\"$ctrl.olvidoContrasena()\" class=\"text-success\">¿Olvidó su contraseña?</a></span>\n        </p>\n      </form>\n    </div>\n  </div>\n  <div class=\"show--medium\">\n    <div class=\"phone text-primary\">\n      <i class=\"fa fa-phone text-primary\"></i>\n      <section>800-10-1660</section>\n    </div>\n    <div class=\"bottom\">\n      <div class=\"logoMinisterio\"></div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login__container\">\n  <div class=\"izq\">\n    <div class=\"images__container\">\n      <div class=\"top\">\n        <div class=\"logo\"></div>\n        <div class=\"dobleAguinaldo\"></div>\n        <div class=\"consumeNuestro\"></div>\n      </div>\n      <!-- <div class=\"bottom\">\n        <div class=\"logoMinisterio\"></div>\n      </div> -->\n    </div>\n    <div class=\"descripcion\">\n      En este sitio usted puede:\n      <ul>\n        <li>Solicitar su certificado como Unidad Productiva, para el acceso a los beneficios contemplados en la <strong>Ley N°947</strong> Micro y Pequeñas Empresas</li>\n        <li>Solicitar su certificado como Artesano para el acceso a los beneficios contemplados en la <strong>Ley N° 306</strong> Promoción y Desarrollo Artesanal.</li>\n        <li>Certificar sus productos para contrataciones y licitaciones con el Estado.</li>\n        <li>Si ingresa con su NIT podrá inscribirse como Proveedor del Segundo Aguinaldo Esfuerzo por Bolivia para la venta de productos hechos en Bolivia.</li>\n        <li>Si ingresa su NIT podrá inscribirse como proveedor del refrigerio a los funcionarios públicos, conforme al Decreto Supremo <strong>Nº 4513</strong>, 26 de mayo de 2021 y su reglamentación aprobada mediante Resolución Ministerial <strong>MDPyEP/N°22.2021</strong></li>\n      </ul>\n    </div>\n    <div class=\"phone text-primary hide--medium\">\n      <i class=\"fa fa-phone text-primary\"></i>\n      <section>800-10-1660</section>\n    </div>\n    <div class=\"bottom hide--medium\">\n      <div class=\"logoMinisterio\"></div>\n    </div>\n  </div>\n  <div class=\"der\">\n    <div class=\"organizaciones__constituidas\">\n      <div class=\"alert alert-primary text-center titulo\">\n        <i class=\"fa fa-building-o\"></i><strong>Organizaciones constituidas</strong>\n      </div>\n      <form ng-submit=\"$ctrl.signinNIT()\">\n        <p class=\"login-message text-primary\">* Si cuenta con <strong>NIT</strong> ingrese aquí.</p>\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon\"><span class=\"img-nit\" uib-tooltip=\"Su NIT en Impuestos Nacionales\" tooltip-placement=\"left\"></span></span>\n          <div class=\"md-form-group\" md-event-label>\n            <input ng-model=\"$ctrl.nit\" id=\"nit\" required type=\"text\" focus-if=\"true\" nit>\n            <label class=\"md-control-label\" for=\"input\">NIT</label>\n            <i class=\"md-bar\"></i>\n          </div>\n        </div>\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon\"><i class=\"fa fa-user\"></i></span>\n          <div class=\"md-form-group\" md-event-label>\n            <input ng-model=\"$ctrl.usuario\" required id=\"usuario\" type=\"text\">\n            <label class=\"md-control-label\" for=\"input\">Usuario</label>\n            <i class=\"md-bar\"></i>\n          </div>\n        </div>\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon\"><i class=\"fa fa-lock\"></i></span>\n          <md-input label=\"Contraseña\" ng-model=\"$ctrl.contrasena\" type=\"password\" required></md-input>\n        </div>\n        <button md-effect class=\"btn btn-primary btn-lg btn-block\" type=\"submit\">\n          <i class=\"fa fa-sign-in\"></i> Ingresar\n        </button>\n      </form>\n    </div>\n    <div class=\"organizaciones__productivas\">\n      <div class=\"alert alert-info text-center titulo\" ng-if=\"!$ctrl.nitCheck2\">\n        <i class=\"fa fa-building-o\"></i> <strong>Otras organizaciones productivas</strong>\n      </div>\n      <form ng-submit=\"$ctrl.signin()\">\n        <p class=\"login-message text-info\">* Si <strong>no</strong> tiene <strong>NIT</strong>, solicite una cuenta para acceder al sistema haciendo click <strong><a href=\"\" ng-click=\"$ctrl.registrarCuenta()\" class=\"text-info\">AQUÍ</a></strong></p>\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon\"><i class=\"fa fa-user\"></i></span>\n          <div class=\"md-form-group\" md-event-label>\n            <input ng-model=\"$ctrl.usuario2\" required id=\"usuario\" type=\"text\"  ng-blur=\"$ctrl.validateMailKeyup()\">\n            <label class=\"md-control-label\" for=\"input\">Email</label>\n            <i class=\"md-bar\"></i>\n            <div class=\"md-input-warning\" ng-show=\"!$ctrl.isCorreoOk\">Correo inválido</div>\n          </div>\n        </div>\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon\"><i class=\"fa fa-lock\"></i></span>\n          <md-input label=\"Contraseña\" ng-model=\"$ctrl.contrasena2\" type=\"password\" required></md-input>\n        </div>\n        <div class=\"md-input-group text-center\">\n        </div><br/>\n        <button md-effect class=\"btn btn-info btn-lg btn-block\" type=\"submit\">\n          <i class=\"fa fa-sign-in\"></i> Ingresar\n        </button>\n        <p class=\"centerText\" style=\"margin: 5px 0 3px 0;\">\n          <span class=\"login-message\"><a href=\"\" ng-click=\"$ctrl.registrarCuenta()\" class=\"text-success\">Crear una cuenta nueva</a></span>\n        </p>\n        <p class=\"centerText\">\n          <span class=\"login-message\"><a href=\"\" ng-click=\"$ctrl.olvidoContrasena()\" class=\"text-info\">¿Olvidó su contraseña?</a></span>\n        </p>\n      </form>\n    </div>\n\n  </div>\n  <div class=\"show--medium\">\n    <div class=\"phone text-primary\">\n      <i class=\"fa fa-phone text-primary\"></i>\n      <section>800-10-1660</section>\n    </div>\n    <div class=\"bottom\">\n      <div class=\"logoMinisterio\"></div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"form\">\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title\">\n      <i class=\"fa fa-key\"></i>\n      Cambio de Contraseña\n    </h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body modal-ubicacion-body\">\n\n    <small>Ingrese su correo electrónico para recuperar su contraseña</small>\n\n    <div class=\"md-input-group\">\n      <div class=\"md-input-group\">\n        <span class=\"md-input-group-addon\"><i class=\"fa fa-envelope-o\" uib-tooltip=\"Su Correo Electrónico Registrado\" tooltip-placement=\"left\"></i></span>\n        <div class=\"md-form-group\" md-event-label>\n          <input ng-model=\"$ctrl.email\" required id=\"usuario\" type=\"text\">\n          <label class=\"md-control-label\" for=\"input\">Usuario</label>\n          <i class=\"md-bar\"></i>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n  <div class=\"text-right panel-margin\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n      <i class=\"fa fa-close\"></i> Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.enviar()\" ng-disabled=\"form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Enviar\n    </button>\n  </div>\n  <br>\n</ng-form>\n"

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-cogs\"></i> Detalles de <strong>cuenta</strong></h2>\n  <div class=\"card\">\n\n    <div class=\"card-block\">\n      <div class=\"col-12 col-md-12\">\n        <div class=\"jumbotron\">\n          <div class=\"centerText\">\n            <div class=\"login-logo\">\n              <div class=\"logo-probolivia\"></div>\n              <!--<div class=\"logo-promueve\"></div>-->\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <!--Detalles de la cuenta del usuario -->\n          <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\n            <h4> <i class=\"fa fa-user-circle\"></i> Detalles de Cuenta</h4>\n            <br/>\n\n            <div class=\"form-group row\">\n              <label  class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-form-label\">Usuario:</label>\n              <div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9\">\n                <input class=\"form-control\" type=\"text\"  ng-model=\"$ctrl.usuario.usuario\"  disabled>\n              </div>\n            </div>\n\n            <div class=\"form-group row\">\n              <label   class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-form-label\">Nombres: </label>\n              <div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9\">\n                <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.usuario.nombres\"  disabled >\n              </div>\n            </div>\n\n            <div class=\"form-group row\">\n              <label   class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-form-label\">Apellidos: </label>\n              <div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9\">\n                <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.usuario.apellidos\"  disabled >\n              </div>\n            </div>\n\n            <div class=\"form-group row\">\n              <label   class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-form-label\">Email: </label>\n              <div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9\">\n                <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.usuario.email\"  disabled >\n              </div>\n            </div>\n\n            <div class=\"form-group row\">\n              <label   class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-form-label\">Rol: </label>\n              <div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9\">\n                <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.usuario.rol.nombre\"  disabled >\n              </div>\n            </div>\n\n            <div class=\"form-group row\">\n              <label   class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-form-label\">Estado: </label>\n              <div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9\">\n                <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.usuario.rol.estado\"  disabled >\n              </div>\n            </div>\n          </div><!-- /Detalles de la cuenta del usuario -->\n\n          <!--Cambio de contraseña-->\n          <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\n            <div ng-show=\"$ctrl.autChange\" class=\"barLateralIzquierda\">\n                <form ng-submit=\"$ctrl.cambiarContrasena()\">\n                  <h4> <i class=\"fa fa-keyboard-o\"></i> Cambio de Contraseña</h4>\n                  <br/>\n                  <div class=\"form-group\">\n                    <label >Contraseña</label>\n                    <input type=\"password\" name=\"password\" class=\"form-control\" id=\"password\" placeholder=\"\" autocomplete=\"off\" maxlength=\"50\" ng-model=\"$ctrl.contrasena\" required>\n                    <small style=\"float: right; color: red\" ng-show=\"$ctrl.validarCampos($ctrl.contrasena)\" >Debe tener mínimo 8 caracteres</small>\n                  </div>\n                  <div class=\"form-group {{$ctrl.isCoinciden? 'has-success' : '' }}\">\n                    <label >Contraseña Nueva</label>\n                    <input type=\"password\" name=\"password\" class=\"form-control {{$ctrl.isCoinciden? 'form-control-success' : '' }}\" id=\"passwordNuevo\" placeholder=\"\" autocomplete=\"off\" maxlength=\"50\" ng-model=\"$ctrl.contrasenaNueva\" required\n                           ng-change=\"$ctrl.coincidenciaCampos()\" >\n                    <small style=\"float: right; color: red\" ng-show=\"$ctrl.validarCampos($ctrl.contrasenaNueva)\" >Debe tener mínimo 8 caracteres</small>\n                  </div>\n                  <div class=\"form-group {{$ctrl.isCoinciden? 'has-success' : '' }}\">\n                    <label>Confirmar Contraseña Nueva</label>\n                    <input type=\"password\" name=\"password\" class=\"form-control {{$ctrl.isCoinciden? 'form-control-success' : '' }}\" id=\"passworConfirmar\" placeholder=\"\" autocomplete=\"off\" maxlength=\"50\" ng-model=\"$ctrl.contrasenaConfirmacion\" required\n                           ng-change=\"$ctrl.coincidenciaCampos()\">\n                    <small style=\"float: right; color: red\" ng-show=\"$ctrl.validarCampos($ctrl.contrasenaConfirmacion)\" >Debe tener mínimo 8 caracteres</small>\n                  </div>\n                  <button type=\"submit\" class=\"btn btn-primary\" style=\"float: right\"   ><i class=\"fa fa-key\"></i> Cambiar Contraseña</button>\n                </form>\n            </div>\n          </div><!--/Cambio de contraseña-->\n\n          <!--Cambio de correo-->\n          <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-5\">\n            <div class=\"barLateralIzquierda\">\n                <form ng-submit=\"$ctrl.cambiarCorreo()\">\n                  <h4> <i class=\"fa fa-keyboard-o\"></i> Cambio de correo electrónico</h4>\n                  <br/>\n                  <div class=\"form-group\">\n                    <label >Nuevo correo electrónico</label>\n                    <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.nuevoCorreo\" placeholder=\"\" autocomplete=\"off\" maxlength=\"200\" required />\n                  </div>\n                  <button type=\"submit\" class=\"btn btn-primary\" style=\"float: right\"   ><i class=\"fa fa-key\"></i> Cambiar Correo electrónico</button>\n                </form>\n            </div>\n          </div><!--/Cambio de correo-->\n\n        </div><!--/row-->\n      </div>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title text-center\"><i class=\"fa fa-table\"></i> Formulario para actualizar datos de Banco Unión</h2>\n\n  <form ng-submit=\"$ctrl.enviar(bancoUnionForm)\" name=\"bancoUnionForm\" novalidate>\n    <div class=\"card\">\n      <div class=\"card-block d-flex justify-content-center\">\n        <div style=\"width: 420px;\">\n          <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.nro_cuenta.visible\">\n            <label ng-class=\"{'ap-req':$ctrl.conf.nro_cuenta.requerido}\">{{$ctrl.conf.nro_cuenta.label}}</label>\n            <input name=\"nro_cuenta\" class=\"form-control\" ng-model=\"$ctrl.data.nro_cuenta\" ng-required=\"$ctrl.conf.nro_cuenta.requerido\" ng-disabled=\"$ctrl.conf.nro_cuenta.disabled\" autocomplete=\"new-password\">\n            <div ap-error ng-messages=\"bancoUnionForm.nro_cuenta.$error\" role=\"alert\" ng-if=\"bancoUnionForm.nro_cuenta.$touched\">\n              <div ng-message=\"required\">El campo es requerido</div>\n            </div>\n          </div>\n          <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.contrasena.visible\">\n            <label ng-class=\"{'ap-req':$ctrl.conf.contrasena.requerido}\">{{$ctrl.conf.contrasena.label}}</label>\n            <input name=\"contrasena\" type=\"password\" class=\"form-control\" ng-model=\"$ctrl.data.contrasena\" ng-required=\"$ctrl.conf.contrasena.requerido\" ng-disabled=\"$ctrl.conf.contrasena.disabled\" autocomplete=\"new-password\">\n            <div ap-error ng-messages=\"bancoUnionForm.contrasena.$error\" role=\"alert\" ng-if=\"bancoUnionForm.contrasena.$touched\">\n              <div ng-message=\"required\">El campo es requerido</div>\n            </div>\n          </div>\n          <!-- <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.rdx.visible\">\n            <label ng-class=\"{'ap-req':$ctrl.conf.rdx.requerido}\">{{$ctrl.conf.rdx.label}}:</label>\n            <input name=\"rdx\" class=\"form-control\" placeholder=\"Autogenerado al llenar Nro. de cuenta y contraseña\" ng-model=\"$ctrl.data.rdx\" ng-required=\"$ctrl.conf.rdx.requerido\" ng-disabled=\"$ctrl.conf.rdx.disabled\">\n            <div ap-error ng-messages=\"bancoUnionForm.rdx.$error\" role=\"alert\" ng-if=\"bancoUnionForm.rdx.$touched\">\n              <div ng-message=\"required\">El campo es requerido</div>\n            </div>\n          </div> -->\n          <div class=\"col-md text-right\">\n            <!-- <button type=\"button\" class=\"btn btn-dafault\" ng-click=\"$ctrl.atras()\">\n              <i class=\"fa fa-angle-double-left\"></i> Atrás\n            </button> -->\n            <button type=\"submit\" class=\"btn btn-primary\">\n              Enviar\n              <i class=\"fa fa-angle-double-right\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login container\">\n  <div class=\"login-container\">\n    <div class=\"login-form\">\n      <div class=\"login-logo\">\n        <div class=\"logo-probolivia\"></div>\n        <!--<div class=\"logo-promueve\"></div>-->\n      </div>\n      <div class=\"login-header\">\n        <i class=\"fa fa-edit\"></i> Confirme su cuenta </strong>\n      </div>\n      <div class=\"card-container container\" >\n        <div class=\"row\" >\n          <div class=\"col-lg-12 col-md-12 card-element\" ng-hide=\"$ctrl.codigo !== undefined\"> No se tiene información de activación de cuenta.</div>\n          <div class=\"col-lg-12 col-md-12 card-element\" ng-hide=\"$ctrl.codigo === undefined\">\n            <div class=\"alert alert-info text-center\">\n              <!--<i class=\"fa fa-building-o\"></i> <strong>VALIDACIÓN</strong>-->\n            </div>\n            <form ng-submit=\"$ctrl.registrarUsuario()\">\n              <small>Por favor ingrese su contraseña</small>\n              <div class=\"md-input-group\">\n                <div class=\"form-group {{$ctrl.cssInput}}\">\n                  <label class=\"form-control-label\" for=\"contrasena\">Contraseña:</label>\n                  <input type=\"password\" class=\"form-control form-control-success\" id=\"contrasena\" ng-model=\"$ctrl.usuario.contrasena\" ng-keyup=\"$ctrl.compararContrasenas()\"   >\n                  <!--<div class=\"form-control-feedback\">Success! You've done it.</div>-->\n                </div>\n              </div>\n              <div class=\"md-input-group\">\n                <div class=\"form-group {{$ctrl.cssInput1}}\">\n                  <label class=\"form-control-label\" for=\"contrasenaconf\"> Confirmar Contraseña:</label>\n                  <input type=\"password\" class=\"form-control form-control-success\" id=\"contrasenaconf\" ng-model=\"$ctrl.usuario.contrasenaConfirmacion\"  ng-keyup=\"$ctrl.compararContrasenas()\" >\n                  <!--<div class=\"form-control-feedback\">Success! You've done it.</div>-->\n                </div>\n              </div>\n              <button md-effect class=\"btn btn-primary btn-lg btn-block\" type=\"submit\" ng-disabled =\"!$ctrl.isContrasenaIgual\" ng-click=\"$ctrl.actualizarContrasena()\" >\n                <i class=\"fa fa-check-circle\"></i> Actualizar Contraseña\n              </button>\n            </form>\n          </div>\n        </div>\n      </div>\n      <div class=\"logo-ministerio\"></div>\n    </div>\n  </div>"

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Bandeja <strong>de entrada</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n        </div>\n      </div>\n      <!--<crud-table buttons=\"$ctrl.buttons\" permission=\"$ctrl.permission\" url=\"$ctrl.url\" edit-modal-controller=\"$ctrl.editModalController\">-->\n      <!--</crud-table>-->\n      <div class=\"flex form-group\" uib-tooltip=\"Filtrar datos por departamento, NIT, matrícula, razón social, representante legal o CI\">\n        <input name=\"filtro\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.filtro_bandeja\" placeholder=\"Filtrar datos...\" ng-change=\"$ctrl.changeFilter()\">\n      </div>\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\" >\n        <table  class=\"table table-striped table-hover\" >\n          <tr ng-repeat=\"item in $data\">\n            <td>\n              <!--TODO check para firmar que ya esta funcionando, solo ocultamos-->\n              <!--<input type=\"checkbox\" ng-checked=\"item.isRowSelected\" ng-click=\"$ctrl.toggleSelection(item)\" ng-show=\"item.certificacion.estado==='APROBADO'\" />-->\n            </td>\n            <td data-title=\"'Acciones'\">\n              <button uib-tooltip=\"Regenerar Reporte\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.regenerarReporte(item)\"  >\n                <i class=\"fa fa-refresh\"></i>\n              </button>\n              <button uib-tooltip=\"Regenerar Certificado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.regenerarCertificado(item)\" ng-if=\"item.certificacion.fid_formulario !== 9\">\n                <i class=\"fa fa-certificate\"></i>\n              </button>\n              <button uib-tooltip=\"Anular\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.anularEliminar(item)\">\n                <i class=\"fa fa-close\"></i>\n              </button>\n<!--              <button uib-tooltip=\"Ver reporte\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.verPdfTabla(item)\"  >\n                <i class=\"fa fa-file-pdf-o\"></i>\n              </button>\n              <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"\n                      ng-click=\"$ctrl.veCertificadoTabla(item)\" ng-show=\"item.certificacion.estado === 'APROBADO'\" >\n                <i class=\"fa fa-file\"></i>\n              </button>-->\n            </td>\n            <!--<td data-title=\"'Organización Productiva'\" filter=\"{ 'organizacion': 'text'}\" sortable=\"'organizacion'\">-->\n            <td data-title=\"'Nro.'\"> {{(($ctrl.tableParams.page()-1) * $ctrl.tableParams.count()) + ($index+1)}}</td>\n            <td data-title=\"'Departamento'\">\n              {{ item.unidad_productiva.ubicaciones[0].departamento.descripcion}}\n            </td>\n            <td data-title=\"'Grupo'\">\n              {{ $ctrl.procesar(item.certificacion.formulario.nombre)}}\n            </td>\n            <td data-title=\"'Tipo'\">\n              {{ item.certificacion.tipo}}\n            </td>\n            <td data-title=\"'NIT/Matrícula'\">\n              <span ng-if=\"item.unidad_productiva.nit || item.unidad_productiva.matricula_comercio\">\n                {{ item.unidad_productiva.nit}}<br>\n                {{ item.unidad_productiva.matricula_comercio}}\n              </span>\n              <span ng-if=\"!item.unidad_productiva.nit && !item.unidad_productiva.matricula_comercio\">\n                <i>No tiene</i>\n              </span>\n            </td>\n            <td data-title=\"'Organización Productiva'\" >\n              {{item.unidad_productiva.razon_social}}\n            </td>\n            <td data-title=\"'Representante Legal/CI'\">\n              {{item.unidad_productiva.hist_representantes.nombre_completo}}  {{item.unidad_productiva.hist_representantes.documento_identidad}}\n            </td>\n            <td data-title=\"'Fecha de solicitud'\" class=\"text-center\" >\n              {{ item.certificacion._fecha_envio |  date:'dd/MM/yyyy HH:mm:ss' }}\n              <!-- {{ item.certificacion._fecha_envio |  date:'dd/MM/yyyy' }} -->\n            </td>\n\n            <td data-title=\"'Usuario de registro'\">\n              {{$ctrl.getUsuarioReg(item)}}\n              <br/>\n              <small>(Rol: <strong>{{item.unidad_productiva.usuario.usuarios_roles[0].rol.descripcion}}</strong>)</small>\n            </td>\n\n            <td data-title=\"'Estado'\" >\n              <span class=\"badge\n                    {{item.certificacion.estado ==='ENVIADO'? 'badge-primary':\n                  (item.certificacion.estado ==='APROBADO'? 'badge-success' : ( item.certificacion.estado ==='PENDIENTE_PAGO'? 'badge-warning' :\n                  (item.certificacion.estado ==='OBSERVADO'? 'badge-danger' : ( item.certificacion.estado ==='PAGADO'? 'badge-default' : 'badge-default'))))}}\n                    \">\n                {{item.certificacion.estado}}\n              </span>\n            </td>\n\n          </tr>\n        </table>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Bandeja <strong>de entrada</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n        </div>\n        <!--        <form name=\"$ctrl.searchForm\" class=\"form-search p-2\" novalidate ng-submit=\"$ctrl.search()\">\n                  <div class=\"input-group\">\n                    <span class=\"input-group-btn\" ng-if=\"$ctrl.searchTerm.length\">\n                      <button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cleanSearch()\" uib-tooltip=\"Limpiar búsqueda\">\n                        <i class=\"fa fa-trash\"></i>\n                      </button>\n                    </span>\n                    <input type=\"text\" class=\"form-control\" placeholder=\"Escriba su búsqueda aquí\" name=\"searchTerm\" ng-model=\"$ctrl.searchTerm\" required />\n                    <span class=\"input-group-btn\">\n                      <button class=\"btn btn-default\" type=\"submit\" ng-disabled=\"$ctrl.searchForm.$invalid\" uib-tooltip=\"Buscar en la tabla\">\n                        <i class=\"fa fa-search\"></i>\n                      </button>\n                    </span>\n                  </div>\n                </form>-->\n      </div>\n      <!--<crud-table buttons=\"$ctrl.buttons\" permission=\"$ctrl.permission\" url=\"$ctrl.url\" edit-modal-controller=\"$ctrl.editModalController\">-->\n      <!--</crud-table>-->\n      <div class=\"flex form-group\" uib-tooltip=\"Filtrar datos por departamento, NIT, matrícula, razón social, representante legal o CI\">\n        <input name=\"filtro\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.filtro_bandeja\" placeholder=\"Filtrar datos...\" ng-change=\"$ctrl.changeFilter()\">\n\n      </div>\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\" >\n        <table class=\"table table-striped table-hover\" >\n          <tr ng-repeat=\"item in $data\">\n            <td>\n              <!--TODO check para firmar que ya esta funcionando, solo ocultamos-->\n              <!--<input type=\"checkbox\" ng-checked=\"item.isRowSelected\" ng-click=\"$ctrl.toggleSelection(item)\" ng-show=\"item.certificacion.estado==='APROBADO'\" />-->\n            </td>\n            <td data-title=\"'Acciones'\" class=\"accionesSize\">\n              <div class=\"accionesSizeDiv\">\n                <button uib-tooltip=\"Ver y validar  declaración jurada\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.irDetalle(item)\"  >\n                  <i class=\"fa fa-eye\"></i>\n                </button>\n                <button uib-tooltip=\"Ver reporte\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.verPdfTabla(item)\"  >\n                  <i class=\"fa fa-file-pdf-o\"></i>\n                </button>\n                <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"\n                        ng-click=\"$ctrl.veCertificadoTabla(item)\" ng-show=\"item.certificacion.estado === 'APROBADO' && item.certificacion.fid_formulario !== 9\" >\n                  <i class=\"fa fa-file\"></i>\n                </button>\n                <button uib-tooltip=\"Ver historial\" md-effect class=\"btn btn-default\" ng-click=\"$ctrl.verHistorial(item)\">\n                  <i class=\"fa fa-line-chart\"></i>\n                </button>\n              </div>\n\n            </td>\n            <!--<td data-title=\"'Organización Productiva'\" filter=\"{ 'organizacion': 'text'}\" sortable=\"'organizacion'\">-->\n            <td data-title=\"'Nro.'\"> {{(($ctrl.tableParams.page()-1) * $ctrl.tableParams.count()) + ($index+1)}}</td>\n            <td data-title=\"'Departamento'\">\n              {{ item.unidad_productiva.ubicaciones[0].departamento.descripcion}}\n            </td>\n            <td data-title=\"'Grupo'\">\n              {{ $ctrl.procesar(item.certificacion.formulario.nombre)}}\n            </td>\n            <td data-title=\"'Tipo'\">\n              {{ item.certificacion.tipo}}\n            </td>\n            <td data-title=\"'NIT/Matrícula'\">\n              <span ng-if=\"item.unidad_productiva.nit || item.unidad_productiva.matricula_comercio\">\n                {{ item.unidad_productiva.nit}}<br>\n                {{ item.unidad_productiva.matricula_comercio}}\n              </span>\n              <span ng-if=\"!item.unidad_productiva.nit && !item.unidad_productiva.matricula_comercio\">\n                <i>No tiene</i>\n              </span>\n            </td>\n            <td data-title=\"'Organización Productiva'\" ng-class=\"item.unidad_productiva.razon_social.length > 30 ? 'card-overflow' : ''\" >\n              {{item.unidad_productiva.razon_social}}\n            </td>\n            <td data-title=\"'Representante Legal/CI'\">\n              {{item.unidad_productiva.hist_representantes.nombre_completo}}  {{item.unidad_productiva.hist_representantes.documento_identidad}}\n            </td>\n            <td data-title=\"'Fecha de solicitud'\" class=\"text-center\" >\n              {{ item.certificacion._fecha_envio |  date:'dd/MM/yyyy HH:mm:ss' }}\n              <!-- {{ item.certificacion._fecha_envio |  date:'dd/MM/yyyy' }} -->\n            </td>\n\n            <td data-title=\"'Usuario de registro'\">\n              {{$ctrl.getUsuarioReg(item)}}\n              <br/>\n              <small>(Rol: <strong>{{item.unidad_productiva.usuario.usuarios_roles[0].rol.descripcion}}</strong>)</small>\n            </td>\n\n            <td data-title=\"'Estado'\" >\n              <span class=\"badge\n                    {{item.certificacion.estado ==='ENVIADO'? 'badge-primary':\n                  (item.certificacion.estado ==='APROBADO'? 'badge-success' : ( item.certificacion.estado ==='PENDIENTE_PAGO'? 'badge-warning' :\n                  (item.certificacion.estado.indexOf('OBSERVADO') !== -1 ? 'badge-danger' : ( item.certificacion.estado ==='PAGADO'? 'badge-default' : 'badge-default'))))}}\n                    \">\n                {{item.certificacion.estado}}\n                <br/>\n                <small ng-if=\"item.certificacion.estado ==='APROBADO'\">Estado Firma: <strong>{{item.certificacion.estado_firma}}</strong></small>\n                <!-- <small ng-hide=\"item.certificacion.estado ==='ENVIADO' || item.certificacion.estado ==='PENDIENTE_PAGO' || item.certificacion.estado ==='OBSERVADO'  || item.certificacion.estado ==='PAGADO'\">Estado Firma: <strong>{{item.certificacion.estado_firma}}</strong></small> -->\n              </span>\n              <small ng-if=\"(item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' || item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO' ) && item.certificacion.estado.indexOf('APROBADO_') !== -1\">\n                <br/>\n                <strong class=\"text-danger\"> <i class=\"fa fa-shopping-cart\"></i> Productos pendientes de aprobación </strong>\n              </small>\n            </td>\n\n          </tr>\n        </table>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa  fa-fort-awesome \"></i>Razón Social: {{$ctrl.unidad_productiva.razon_social}}</h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"alert alert-primary\">\n        <span aria-hidden=\"true\"></span>\n        <span><strong>{{$ctrl.certificacion.tipo}} - {{$ctrl.certificacion.formulario.nombre}}</strong></span>\n      </div>\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-sm-4 form-group\">\n            <label>Nombre o Razón Social:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\">\n            {{$ctrl.unidad_productiva.razon_social}}\n          </div>\n          <div class=\"col-sm-4 form-group\">\n            <label>Representante legal:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\">\n            {{$ctrl.unidad_productiva.hist_representantes.nombre_completo}}\n          </div>\n          <div class=\"col-sm-4 form-group\">\n            <label>Categoría: </label>\n          </div>\n          <div class=\"col-sm-8 form-group\" ng-if=\"$ctrl.unidad_productiva.categorizacion != 'OECA' && $ctrl.unidad_productiva.categorizacion !== 'OECOM'\">\n            {{$ctrl.unidad_productiva.categorizacion}} {{$ctrl.certificacion.formulario.tipo=== 'ARTESANO'? '':'EMPRESA'}}\n          </div>\n          <div class=\"col-sm-8 form-group\"  ng-if=\"$ctrl.unidad_productiva.categorizacion == 'OECA' || $ctrl.unidad_productiva.categorizacion == 'OECOM'\">\n              {{$ctrl.unidad_productiva.categorizacion}}\n          </div>\n          \n<!--          <div class=\"col-sm-4 form-group\">\n            <label>Rubro:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\">\n            {{$ctrl.rubro}}\n          </div>-->\n          \n          <div class=\"col-sm-4 form-group\" ng-show=\"$ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA'\">\n            <label>Índice:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\" ng-show=\"$ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA'\">\n            {{$ctrl.unidad_productiva.indice}}\n          </div>\n          <div class=\"col-sm-4 form-group\" ng-show=\"($ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA' && $ctrl.unidad_productiva.subtipo) || $ctrl.certificacion.formulario.tipo === 'ARTESANO'\">\n            <label>Tipo:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\" ng-show=\"($ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA' && $ctrl.unidad_productiva.subtipo) || $ctrl.certificacion.formulario.tipo === 'ARTESANO'\">\n            {{$ctrl.unidad_productiva.subtipo}}\n          </div>\n          <div class=\"col-sm-4 form-group\" ng-show=\"$ctrl.certificacion.fecha_vigencia_anterior\">\n            <label>Fecha de Vigencia del anterior certificado:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\" ng-show=\"$ctrl.certificacion.fecha_vigencia_anterior\">\n            {{$ctrl.certificacion.fecha_vigencia_anterior | date:'dd/MM/yyyy'}}\n          </div>\n        </div>\n      </div>\n\n      <ng-form name=\"general_form\">\n        <div class=\"empresa\">\n          <section>\n            <header class=\"header-section\">{{$ctrl.conf.pag.sec_nombre}}</header>\n            <div ng-show=\"$ctrl.deposito.id_pago === undefined\">\n              <div class=\"alert alert-danger\" >\n                <span aria-hidden=\"true\"></span>\n                <i class=\"fa fa-info-circle\"></i>\n                {{$ctrl.usuario_ddjj_con_nit? 'El usuario debe llenar los datos de depósito.':'Debe llenar los datos de depósito.'}}\n              </div>\n            </div>\n            <div class=\"body-section\">\n              <ng-form name=\"depositos_form\">\n\n                <!--*****************-->\n                <div class=\"row\" ng-hide=\"(  ($ctrl.certificacion.estado === 'PAGADO'  && $ctrl.pagos.length>0 )  || $ctrl.certificacion.estado ==='APROBADO' )\">\n\n                  <div class=\"col-md form-group\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.pag.codigo_deposito.requerido}\">{{$ctrl.conf.pag.codigo_deposito.label}}</label>\n                    <input name=\"codigo_deposito\" alpha-dash minlength=\"5\" maxlength=\"15\" class=\"form-control\" ng-model=\"$ctrl.deposito.codigo_deposito\"\n                           ng-required=\"$ctrl.conf.pag.codigo_deposito.requerido\"\n                           ng-disabled=\"$ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\">\n                    <!-- ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\"> -->\n                    <div ap-error ng-messages=\"depositos_form.codigo_deposito.$error\" role=\"alert\" ng-if=\"depositos_form.codigo_deposito.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"minlength\">El campo debe tener 5 caracteres como mínimo</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.pag.fecha_deposito.requerido}\">{{$ctrl.conf.pag.fecha_deposito.label}}</label>\n                    <div class=\"input-group uib-input-date\">\n                      <input name=\"fecha_deposito\" maxlength=\"10\"\n                             class=\"form-control\" datepicker-append-to-body=\"true\"\n                             placeholder=\"dd/mm/aaaa\" uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\"\n                             ng-model=\"$ctrl.deposito.fecha_deposito\" ng-change=\"$ctrl.validateFechaDeposito(depositos_form)\"\n                             is-open=\"$ctrl.deposito.is_open\" datepicker-options=\"$ctrl.conf.pag.fecha_deposito.options\"\n                             ng-required=\"$ctrl.conf.pag.fecha_deposito.requerido\"\n                             ng-disabled=\"$ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\">\n                      <!-- ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\"> -->\n                      <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.deposito.is_open = true\"><i class=\"fa fa-calendar\"></i></button>\n                      </span>\n                    </div>\n                    <div ap-error ng-messages=\"depositos_form.fecha_deposito.$error\" role=\"alert\" ng-if=\"depositos_form.fecha_deposito.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"date\">Formato de fecha incorrecta (Ejemplo:15/02/1996)</div>\n                      <div ng-message=\"min_date\">La fecha mínima aceptada es {{$ctrl.conf.pag.fecha_deposito.options.minDate| date:'dd/MM/yyyy'}}</div>\n                      <div ng-message=\"max_date\">La fecha máxima aceptada es {{$ctrl.conf.pag.fecha_deposito.options.maxDate| date:'dd/MM/yyyy'}}</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.pag.nombre_razon_social.requerido}\">{{$ctrl.conf.pag.nombre_razon_social.label}}</label>\n                    <input name=\"nombre_razon_social\" maxlength=\"250\" class=\"form-control\" ng-model=\"$ctrl.deposito.nombre_razon_social\"\n                           ng-required=\"$ctrl.conf.pag.nombre_razon_social.requerido\"\n                           ng-disabled=\"$ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\">\n                    <div ap-error ng-messages=\"depositos_form.nombre_razon_social.$error\" role=\"alert\" ng-if=\"depositos_form.nombre_razon_social.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.pag.monto.requerido}\">{{$ctrl.conf.pag.monto.label}}:</label>\n                    <input name=\"monto\" decimal-format maxlength=\"6\" class=\"form-control\" ng-model=\"$ctrl.monto\" ng-required=\"$ctrl.conf.pag.monto.requerido\"\n                           ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO' || true\">\n                    <div ap-error ng-messages=\"depositos_form.monto.$error\" role=\"alert\" ng-if=\"depositos_form.monto.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                </div>\n                <!--******-->\n                <div class=\"row\" ng-show=\"(  ($ctrl.certificacion.estado === 'PAGADO'  && $ctrl.pagos.length>0 ) || $ctrl.certificacion.estado ==='APROBADO' )\">\n\n                  <table class=\"table mb-0 table-ap\">\n                    <thead>\n                      <tr class=\"text-primary font-weight-bold\">\n                        <td class=\"text-center\">Código de Boleta</td>\n                        <td class=\"text-center\">Fecha de Depósito</td>\n                        <td class=\"text-center\">Nombre o Razón Social</td>\n                        <td class=\"text-center\">Monto Bs.</td>\n                      </tr>\n                    </thead>\n                    <tr ng-repeat=\"item in $ctrl.pagos\">\n\n                      <td class=\"text-center\">{{item.codigo_deposito}}</td>\n                      <td class=\"text-center\">{{item.fecha_deposito | date:'dd/MM/yyyy'}}</td>\n                      <td class=\"text-center\">{{item.nombre_razon_social}}</td>\n                      <td class=\"text-right\">{{item.monto}}</td>\n                    </tr>\n                    </tbody>\n                  </table>\n\n\n                </div>\n\n\n              </ng-form>\n            </div>\n          </section>\n\n          <section>\n            <header class=\"header-section\">{{$ctrl.conf.fac.sec_nombre}}</header>\n            <div class=\"body-section\">\n              <ng-form name=\"factura_form\">\n                <div class=\"row\">\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.nombre_razon_social.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.nombre_razon_social.requerido}\">{{$ctrl.conf.fac.nombre_razon_social.label}}:</label>\n                    <!-- <input name=\"nombre_razon_social\" class=\"form-control\" ng-model=\"$ctrl.certificacion.nombre_razon_social\" ng-required=\"$ctrl.conf.fac.nombre_razon_social.requerido\" ng-disabled=\"$ctrl.conf.fac.nombre_razon_social.disabled\"> -->\n                    <textarea name=\"nombre_razon_social\" maxlength=\"250\" class=\"form-control\" autoresize ng-model=\"$ctrl.datos_factura.nombre_razon_social\"\n\n                              ng-required=\"$ctrl.conf.fac.nombre_razon_social.requerido\" ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO'\"></textarea>\n                    <div ap-error ng-messages=\"factura_form.nombre_razon_social.$error\" role=\"alert\" ng-if=\"factura_form.nombre_razon_social.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.nit.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.nit.requerido}\">{{$ctrl.conf.fac.nit.label}}:</label>\n                    <input name=\"nit\" maxlength=\"12\" class=\"form-control\" ng-model=\"$ctrl.datos_factura.nit\" ng-required=\"$ctrl.conf.fac.nit.requerido\" ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO'\">\n                    <div ap-error ng-messages=\"factura_form.nit.$error\" role=\"alert\" ng-if=\"factura_form.nit.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.numero_autorizacion.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.numero_autorizacion.requerido}\">{{$ctrl.conf.fac.numero_autorizacion.label}}:</label>\n                    <input name=\"numero_autorizacion\" class=\"form-control\" numeric\n                           minlength=\"{{$ctrl.conf.fac.numero_autorizacion.min_length}}\"\n                           maxlength=\"{{$ctrl.conf.fac.numero_autorizacion.max_length}}\"\n                           ng-model=\"$ctrl.datos_factura.numero_autorizacion\"\n                           ng-required=\"$ctrl.conf.fac.numero_autorizacion.requerido\"\n                           ng-disabled=\"!$ctrl.habilitarFac()\">\n                    <div ap-error ng-messages=\"factura_form.numero_autorizacion.$error\" role=\"alert\" ng-if=\"factura_form.numero_autorizacion.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"minlength\">El número debe tener {{$ctrl.conf.fac.numero_autorizacion.min_length}} o más caracteres</div>\n                      <div ng-message=\"maxlength\">El número debe tener {{$ctrl.conf.fac.numero_autorizacion.max_length}} o menos caracteres</div>\n                    </div>\n                  </div>\n                  <!--........-->\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.numero_factura.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.numero_factura.requerido}\">{{$ctrl.conf.fac.numero_factura.label}}:</label>\n\n                    <!--maxlength=\"{{$ctrl.conf.fac.numero_factura.max_length}}\"-->\n                    <input name=\"numero_factura\" class=\"form-control\" numeric\n                           minlength=\"{{$ctrl.conf.fac.numero_factura.min_length}}\"\n                           maxlength=\"9\"\n                           ng-model=\"$ctrl.datos_factura.nro_factura\"\n                           ng-required=\"$ctrl.conf.fac.numero_factura.requerido\"\n                           ng-disabled=\"!$ctrl.habilitarFac()\">\n                    <div ap-error ng-messages=\"factura_form.numero_factura.$error\" role=\"alert\" ng-if=\"factura_form.numero_factura.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"minlength\">El número debe tener {{$ctrl.conf.fac.numero_factura.min_length}} o más caracteres</div>\n                      <div ng-message=\"maxlength\">El número debe tener {{$ctrl.conf.fac.numero_factura.max_length}} o menos caracteres</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.fecha_factura.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.fecha_factura.requerido}\">{{$ctrl.conf.fac.fecha_factura.label}}:</label>\n                    <div class=\"input-group uib-input-date\">\n                      <input name=\"fecha_factura\" maxlength=\"10\"\n                             class=\"form-control\" datepicker-append-to-body=\"true\"\n                             placeholder=\"dd/mm/aaaa\" uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\"\n                             ng-model=\"$ctrl.datos_factura.fecha_factura\" ng-change=\"$ctrl.validateFechaFactura(factura_form)\"\n                             is-open=\"$ctrl.certificacion.is_open_fecha_factura\" datepicker-options=\"$ctrl.conf.fac.fecha_factura.options\"\n                             ng-required=\"$ctrl.conf.fac.fecha_factura.requerido\"\n                             ng-disabled=\"!$ctrl.habilitarFac()\">\n                      <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.certificacion.is_open_fecha_factura = true\"><i class=\"fa fa-calendar\"></i></button>\n                      </span>\n                    </div>\n                    <div ap-error ng-messages=\"factura_form.fecha_factura.$error\" role=\"alert\" ng-if=\"factura_form.fecha_factura.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"date\">Formato de fecha incorrecta (Ejemplo:15/02/1996)</div>\n                      <div ng-message=\"min_date\">La fecha mínima aceptada es {{$ctrl.conf.pag.fecha_deposito.options.minDate| date:'dd/MM/yyyy'}}</div>\n                      <div ng-message=\"max_date\">La fecha máxima aceptada es {{$ctrl.conf.pag.fecha_deposito.options.maxDate| date:'dd/MM/yyyy'}}</div>\n                    </div>\n                  </div>\n                </div>\n              </ng-form>\n            </div>\n          </section>\n        </div>\n        <div class=\"text-right mb-3\">\n          <button type=\"button\" md-effect class=\"btn btn-default\" ng-click=\"$ctrl.volver()\">\n            <i class=\"fa fa-close\"></i> Cerrar\n          </button>\n          <button type=\"button\" md-effect  class=\"btn btn-primary\" ng-click=\"$ctrl.finalizarAcreditacion(general_form)\"\n                  ng-show=\"$ctrl.certificacion.estado === 'PENDIENTE_PAGO' || $ctrl.certificacion.estado === 'PAGADO'\"\n                  ng-disabled=\"general_form.$invalid\">\n            <i class=\"fa fa-check\"></i> Finalizar\n          </button>\n        </div>\n      </ng-form>\n      <div ng-show=\"$ctrl.certificacion.estado === 'APROBADO'\">\n        <div class=\"alert alert-success\" >\n          <span aria-hidden=\"true\"></span>\n          <i class=\"fa fa-info-circle\"></i>\n          Se ha generado correctamente el Certificado de Registro Nacional.\n          <span ng-show=\"$ctrl.certificacion.estado === 'APROBADO'\">\n            <br/>ESTA CERTIFICACIÓN YA FUE APROBADA.\n          </span>\n        </div>\n        <div ng-show=\"!$ctrl.esEdge()\">\n          <iframe ng-src=\"{{$ctrl.urlPdf}}\" style=\"width:100%; height:550px;\" frameborder=\"0\">\n            <p>Su navegador no soporta iframe</p>\n          </iframe>\n        </div>\n        <div>\n          <span class=\"login-message\"><a href=\"\" ng-click=\"$ctrl.descargarCertificado()\" class=\"text-success\"> <i class=\"fa fa-download\"></i> Descargar certificado</a></span>\n        </div>\n\n\n      </div>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa  fa-fort-awesome \"></i> Razón Social: {{$ctrl.unidad_productiva.razon_social}}</h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"alert alert-primary\">\n        <span aria-hidden=\"true\"></span>\n        <span><strong>{{$ctrl.certificacion.tipo}} - {{$ctrl.certificacion.formulario.nombre}}</strong></span>\n      </div>\n      <div class=\"alert alert-primary\" ng-show=\"$ctrl.certificacion.estado !== 'OBSERVADO'\" >\n        <span aria-hidden=\"true\"></span>\n        <i class=\"fa fa-info-circle\"></i>\n        {{$ctrl.certificacion.estado === 'APROBADO'? 'ESTA CERTIFICACIÓN YA FUE APROBADA':  ( $ctrl.certificacion.estado === 'ENVIADO'? 'Proceso de verificación completado. Haga click en \\'APROBAR\\' para dar curso al trámite.':'Proceso de verificación completado. Haga click en \\'SIGUIENTE\\' para dar curso al trámite.' )  }}\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"alert alert-danger\" ng-show=\"$ctrl.certificacion.observaciones && $ctrl.certificacion.estado !== 'OBSERVADO'\">\n            <span aria-hidden=\"true\"></span>\n            <i class=\"fa fa-info-circle\"></i>\n            OBSERVACIONES ANTERIORES\n            <br/>\n          </div>\n          <div class=\"alert alert-danger\" ng-show=\"$ctrl.certificacion.observaciones && $ctrl.certificacion.estado === 'OBSERVADO'\">\n            <span aria-hidden=\"true\"></span>\n            <i class=\"fa fa-info-circle\"></i>\n            ESTA CERTIFICACIÓN SE ENCUENTRA OBSERVADA<br/>\n          </div>\n        </div>\n        <div class=\"col-md-12 card-overflow\" style=\"color:#F35958\" ng-show=\"$ctrl.certificacion.observaciones\" > <strong>Motivo de la observación: </strong>{{$ctrl.certificacion.observaciones}} </div>\n      </div>\n      <hr style=\"border-width: 3px\"/>\n      <div style=\"padding-left: 20px\">\n        <!--***-->\n        <div class=\"alert {{$ctrl.isDdjj? 'alert-success':'alert-warning'}}\" >\n          <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\n\n          <label class=\"tgl\" title=\"{{$ctrl.isDdjj? 'Observar':'Aprobar'}}\">\n            <input type=\"checkbox\" ng-checked=\"$ctrl.isDdjj\"  ng-click=\"$ctrl.actualizarDdjj()\"  ng-disabled=\"$ctrl.certificacion.estado !== 'ENVIADO' ? true : false\"  />\n            <span class=\"tgl_body\">\n              <span class=\"tgl_switch\"></span>\n              <span class=\"tgl_track\">\n                <span class=\"tgl_bgd\"></span>\n                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n              </span>\n            </span>\n          </label>\n          <!--<input type=\"checkbox\" class=\"checkbox\" ng-checked=\"$ctrl.isDdjj\"  ng-click=\"$ctrl.actualizarDdjj( )\"  ng-disabled=\"$ctrl.certificacion.estado !== 'ENVIADO' ? true : false\" />-->\n          Declaración jurada para el registro y acreditación nacional.\n          <!--<button md-effect class=\"btn btn-info btn-lg btn-secondary\" type=\"submit\" style=\"width:  150px; margin-left: 8px;margin-top: -8px; margin-bottom: -8px\" ng-click=\"$ctrl.verPdf()\" >-->\n          <button md-effect class=\"btn btn-secondary\" type=\"submit\" style=\"width:  150px; margin-left: 8px;margin-top: -8px; margin-bottom: -8px\" ng-click=\"$ctrl.verPdf()\" >\n            <i class=\"fa fa-file-pdf-o\"></i> Ver PDF\n          </button>\n        </div>\n        <div class=\"alert {{$ctrl.isSeccionCaebOk() ? 'alert-success' : 'alert-warning'}}\"\n             ng-show=\" ($ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA' || $ctrl.certificacion.formulario.tipo === 'ARTESANO' || $ctrl.certificacion.formulario.tipo === 'PROVEEDOR')\" >\n          <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\n\n          <!--<input type=\"checkbox\" ng-checked=\"$ctrl.isSeccionCaebOk()\"  ng-disabled=\"true\" />-->\n          <label class=\"tgl\">\n            <input type=\"checkbox\" ng-checked=\"$ctrl.isSeccionCaebOk()\"  ng-disabled=\"true\" />\n            <span class=\"tgl_body\">\n              <span class=\"tgl_switch\"></span>\n              <span class=\"tgl_track\">\n                <span class=\"tgl_bgd\"></span>\n                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n              </span>\n            </span>\n          </label>\n          Actividad económica (CAEB)\n        </div>\n        <div class=\"container\" ng-show=\" ($ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA' || $ctrl.certificacion.formulario.tipo === 'ARTESANO' || $ctrl.certificacion.formulario.tipo === 'PROVEEDOR')\">\n          <div class=\"row\">\n            <!--PRODUCTO 1-->\n            <span class=\"badge badge-success\">1</span>\n            <div class=\"col\">\n              <div class=\"row\">\n                <div class=\"col-sm-3\">\n                  <div class=\"form-group \">\n                    <label>Actividad 1: </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-9\">\n                  <div class=\"form-group\" ng-class=\"$ctrl.actividadesEconomicas[0].descripcion_actividad.length > 30 ? 'card-overflow' : ''\">\n                    <label>{{$ctrl.actividadesEconomicas[0].descripcion_actividad}}</label>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\" style=\"margin-top: -20px\">\n                <div class=\"col-sm-3\">\n                  <div class=\"form-group\">\n                    <label>Producto 1: </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-9\">\n                  <div class=\"form-group\" ng-class=\"$ctrl.actividadesEconomicas[0].nombre_producto.length > 30 ? 'card-overflow' : ''\">\n                    <label>{{$ctrl.actividadesEconomicas[0].nombre_producto}}</label>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\" style=\"margin-top: -20px\">\n                <div class=\"col-sm-3\">\n                  <div class=\"form-group\">\n                    <label>Seleccionar CAEB: </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-9\">\n                  <div class=\"form-group\">\n                    <div>\n                      <i class=\"fa fa-search\"></i>\n                      <small>Filtrar subclase</small>\n                    </div>\n                    <ui-select ng-model=\"$ctrl.item.selected\" theme=\"bootstrap\" title=\"{{$select.selected.descripcion}}\"\n                               on-select = \"$ctrl.asignarCaeb($ctrl.actividadesEconomicas[0], $select.selected)\"\n                               ng-disabled=\"$ctrl.certificacion.estado !== 'ENVIADO' ? true : false\"\n                               reset-search-input=\"false\">\n                      <ui-select-match placeholder=\"Seleccione o busque un ítem\" >{{$select.selected.codigo}} - {{$select.selected.descripcion}}</ui-select-match>\n                      <ui-select-choices repeat=\"item in $ctrl.listadoCaeb track by $index\"\n                                         refresh=\"$ctrl.refreshResult($select.search)\"\n                                         refresh-delay=\"0\">\n                        <span style=\"font-weight: bold;\" ng-bind-html=\"(item.codigo + ' - ' + item.descripcion) | highlight: $select.search\"></span>\n                        <br/><small ng-bind-html=\"(item.padre.padre.padre.padre.codigo + ' - ' + item.padre.padre.padre.padre.descripcion) | highlight: $select.search\"></small>\n                        <br/><small ng-bind-html=\"(item.padre.padre.padre.codigo + ' - ' + item.padre.padre.padre.descripcion) | highlight: $select.search\"></small>\n                        <br/><small ng-bind-html=\"(item.padre.padre.codigo + ' - ' + item.padre.padre.descripcion) | highlight: $select.search\"></small>\n                        <br/><small ng-bind-html=\"(item.padre.codigo + ' - ' + item.padre.descripcion) | highlight: $select.search\"></small>\n                        <!--<br/><small ng-bind-html=\"item.descripcion | highlight: $select.search\"></small>-->\n                      </ui-select-choices>\n                    </ui-select>\n                  </div>\n                </div>\n              </div>\n              <div style=\"margin-bottom: 10px\">\n                <div class=\"card\" ng-if=\"$ctrl.item.selected\" >\n                  <div class=\"card-block\">\n                    <h4 class=\"card-title\">CAEB</h4>\n                    <div style=\"font-size: 0.85rem; line-height: 0.6\">\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Sección: </label>  {{$ctrl.item.selected.padre.padre.padre.padre.codigo}}-{{$ctrl.item.selected.padre.padre.padre.padre.descripcion}}</p>\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">División: </label>  {{$ctrl.item.selected.padre.padre.padre.codigo}}-{{$ctrl.item.selected.padre.padre.padre.descripcion}}</p>\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Grupo: </label> {{$ctrl.item.selected.padre.padre.codigo}}-{{$ctrl.item.selected.padre.padre.descripcion}}</p>\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Clase: </label>  {{$ctrl.item.selected.padre.codigo}}-{{$ctrl.item.selected.padre.descripcion}}</p>\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">SubClase: </label>  {{$ctrl.item.selected.codigo}}-{{$ctrl.item.selected.descripcion}}</p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <!--PRODUCTO 2-->\n            <span class=\"badge badge-success\" ng-show=\"$ctrl.actividadesEconomicas.length > 1\" >2</span>\n            <div class=\"col\" ng-show=\"$ctrl.actividadesEconomicas.length > 1\">\n              <div class=\"row\">\n                <div class=\"col-sm-3\">\n                  <div class=\"form-group\">\n                    <label>Actividad 2: </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-9\">\n                  <div class=\"form-group\" ng-class=\"$ctrl.actividadesEconomicas[1].descripcion_actividad.length > 30 ? 'card-overflow' : ''\">\n                    <label>{{$ctrl.actividadesEconomicas[1].descripcion_actividad}}</label>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\" style=\"margin-top: -20px\">\n                <div class=\"col-sm-3\">\n                  <div class=\"form-group\">\n                    <label>Producto 2: </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-9\">\n                  <div class=\"form-group\" ng-class=\"$ctrl.actividadesEconomicas[1].nombre_producto.length > 30 ? 'card-overflow' : ''\">\n                    <label>{{$ctrl.actividadesEconomicas[1].nombre_producto}}</label>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\" style=\"margin-top: -20px\">\n                <div class=\"col-sm-3\">\n                  <div class=\"form-group\">\n                    <label>Seleccionar CAEB: </label>\n                  </div>\n                </div>\n                <div class=\"col-sm-9\">\n                  <div class=\"form-group\">\n                    <div>\n                      <i class=\"fa fa-search\"></i>\n                      <small>Filtrar subclase</small>\n                    </div>\n                    <ui-select ng-model=\"$ctrl.item2.selected\" theme=\"bootstrap\" title=\"{{$select.selected.descripcion}}\"\n                               on-select = \"$ctrl.asignarCaeb($ctrl.actividadesEconomicas[1], $select.selected)\"\n                               ng-disabled=\"$ctrl.certificacion.estado !== 'ENVIADO' ? true : false\"\n                               reset-search-input=\"false\">\n                      <ui-select-match placeholder=\"Seleccione o busque un ítem\" >{{$select.selected.codigo}} - {{$select.selected.descripcion}}</ui-select-match>\n                      <ui-select-choices repeat=\"item2 in $ctrl.listadoCaeb track by $index\"\n                                         refresh=\"$ctrl.refreshResult($select.search)\"\n                                         refresh-delay=\"0\">\n                        <span style=\"font-weight: bold;\" ng-bind-html=\"(item2.codigo + ' - ' + item2.descripcion) | highlight: $select.search\"></span>\n                        <br/><small ng-bind-html=\"(item2.padre.padre.padre.padre.codigo + ' - ' + item2.padre.padre.padre.padre.descripcion) | highlight: $select.search\"></small>\n                        <br/><small ng-bind-html=\"(item2.padre.padre.padre.codigo + ' - ' + item2.padre.padre.padre.descripcion) | highlight: $select.search\"></small>\n                        <br/><small ng-bind-html=\"(item2.padre.padre.codigo + ' - ' + item2.padre.padre.descripcion) | highlight: $select.search\"></small>\n                        <br/><small ng-bind-html=\"(item2.padre.codigo + ' - ' + item2.padre.descripcion) | highlight: $select.search\"></small>\n                        <!--<br/><small ng-bind-html=\"item2.descripcion | highlight: $select.search\"></small>-->\n                      </ui-select-choices>\n                    </ui-select>\n                  </div>\n                </div>\n              </div>\n              <div style=\"margin-bottom: 10px\">\n                <div class=\"card\" ng-if=\"$ctrl.item2.selected\" >\n                  <div class=\"card-block\">\n                    <h4 class=\"card-title\">CAEB</h4>\n                    <div style=\"font-size: 0.85rem; line-height: 0.6\">\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Sección: </label>  {{$ctrl.item2.selected.padre.padre.padre.padre.codigo}}-{{$ctrl.item2.selected.padre.padre.padre.padre.descripcion}}</p>\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">División: </label>  {{$ctrl.item2.selected.padre.padre.padre.codigo}}-{{$ctrl.item2.selected.padre.padre.padre.descripcion}}</p>\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Grupo: </label> {{$ctrl.item2.selected.padre.padre.codigo}}-{{$ctrl.item2.selected.padre.padre.descripcion}}</p>\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Clase: </label>  {{$ctrl.item2.selected.padre.codigo}}-{{$ctrl.item2.selected.padre.descripcion}}</p>\n                      <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">SubClase: </label>  {{$ctrl.item2.selected.codigo}}-{{$ctrl.item2.selected.descripcion}}</p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <!--***-->\n        <div class=\"alert {{$ctrl.isCategorizacion? 'alert-success':'alert-warning'}}\" ng-show=\" ($ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA' || $ctrl.certificacion.formulario.tipo === 'ARTESANO')\" >\n          <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\n\n          <!--<input type=\"checkbox\" ng-checked=\"$ctrl.isCategorizacion\"  ng-click=\"$ctrl.actualizarCategorizacion()\" ng-disabled=\"$ctrl.certificacion.estado !== 'ENVIADO' ? true : false\" />-->\n          <label class=\"tgl\" title=\"{{$ctrl.isCategorizacion? 'Observar':'Aprobar'}}\">\n            <input type=\"checkbox\" ng-checked=\"$ctrl.isCategorizacion\"  ng-click=\"$ctrl.actualizarCategorizacion()\" ng-disabled=\"$ctrl.certificacion.estado !== 'ENVIADO' ? true : false\" />\n            <span class=\"tgl_body\">\n              <span class=\"tgl_switch\"></span>\n              <span class=\"tgl_track\">\n                <span class=\"tgl_bgd\"></span>\n                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n              </span>\n            </span>\n          </label>\n          Categorización\n        </div>\n        <div class=\"row\" ng-show=\" ($ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA' || $ctrl.certificacion.formulario.tipo === 'ARTESANO')\">\n          <div class=\"col-sm-1\"></div>\n          <div class=\"col-sm-2\">\n            <div class=\"form-group\" ng-show=\"$ctrl.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA'\">\n              <!--<label>0.035 < L <= 0.115 </label>-->\n              <label>Índice: </label><span> {{$ctrl.unidad_productiva.indice}} </span>\n            </div>\n          </div>\n          <div class=\"col-sm-auto\">\n            <div class=\"form-group\">\n              <label>Resultado: </label>\n              <span ng-if=\"$ctrl.unidad_productiva.categorizacion != 'OECA' && $ctrl.unidad_productiva.categorizacion !== 'OECOM'\">{{$ctrl.unidad_productiva.categorizacion}} {{$ctrl.certificacion.formulario.tipo === 'ARTESANO'? '':'EMPRESA'}}</span>\n              <span ng-if=\"$ctrl.unidad_productiva.categorizacion == 'OECA' || $ctrl.unidad_productiva.categorizacion == 'OECOM'\">{{$ctrl.unidad_productiva.categorizacion}}</span>\n            </div>\n          </div>\n          <div class=\"col-sm-1\"></div>\n          <div class=\"col-sm-auto\" ng-if=\"$ctrl.unidad_productiva.subtipo\">\n            <div class=\"form-group\">\n              <label>Tipo: </label>\n              <span>{{$ctrl.unidad_productiva.subtipo}}</span>\n            </div>\n          </div>\n        </div>\n\n        <!--****************************-->\n\n        <div class=\"alert {{$ctrl.isCategorizacion? 'alert-success':'alert-warning'}}\" ng-show=\"$ctrl.certificacion.formulario.tipo === 'ICAP'\" >\n          <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\n          <label class=\"tgl\" title=\"{{$ctrl.isDdjj? 'Observar':'Aprobar'}}\">\n            <input type=\"checkbox\" ng-checked=\"$ctrl.isDdjj\"   ng-disabled=\" true\" />\n            <span class=\"tgl_body\">\n              <span class=\"tgl_switch\"></span>\n              <span class=\"tgl_track\">\n                <span class=\"tgl_bgd\"></span>\n                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n              </span>\n            </span>\n          </label>\n          Servicios\n        </div>\n        <div class=\"row\" ng-show=\"$ctrl.certificacion.formulario.tipo === 'ICAP'\">\n          <div class=\"col-sm-1\"></div>\n          <div class=\"col-sm-2\">\n            <div class=\"form-group\">\n              <!--<label>0.035 < L <= 0.115 </label>-->\n            </div>\n          </div>\n          <div class=\"col-sm-auto\">\n            <div class=\"form-group\">\n              <div ng-repeat=\"servicio in $ctrl.servicios\">\n                <label>\n                  <span ng-show=\"$ctrl.servicios.length > 1\"> {{$index + 1}}.- </span>\n                  {{servicio.servicio.parametro_padre.parametro_padre.nombre}} - {{servicio.servicio.parametro_padre.nombre}} - {{servicio.servicio.nombre}}\n                </label>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <hr style=\"color: black;\" />\n      <ng-form name=\"fvali\" novalidate=\"true\">\n        <div class=\"row form-group panel-margin\" ng-show=\"($ctrl.certificacion.fid_certificacion_origen === null && $ctrl.certificacion.tipo === 'RENOVACION') || $ctrl.certificacion.fid_certificacion_origen === null && $ctrl.certificacion.tipo === 'RENOVACION_EXPIRADA'\">\n          <!-- Razón social/Sigla-->\n          <div class=\"col-md-3 text-right\">\n            <label>Fecha de Vigencia del anterior certificado:</label>\n          </div>\n          <div class=\"col-md-6\">\n            <div class=\"input-group uib-input-date\">\n              <input name=\"fecha_vigencia\" maxlength=\"10\" type=\"text\"\n                     class=\"form-control\"\n                     placeholder=\"dd/mm/aaaa\" uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\"\n                     ng-model=\"$ctrl.fechaVigenciaAnterior\"\n                     is-open=\"$ctrl.fecha_vigencia.is_open\"\n                     datepicker-options =\"$ctrl.optionsFechaInicio\"\n                     ng-required=\"true\"\n                     ng-disabled=\"$ctrl.certificacion.estado !== 'ENVIADO' ? true : false\">\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.fecha_vigencia.is_open = true\"><i class=\"fa fa-calendar\"></i></button>\n              </span>\n\n              <div ap-error ng-messages=\"fvali.fecha_vigencia.$error\" role=\"alert\" ng-if=\"fvali.fecha_vigencia.$touched\">\n                <div ng-message=\"required\">El campo es requerido</div>\n              </div>\n\n            </div>\n          </div>\n        </div>\n      </ng-form>\n\n      <div class=\"row\" ng-if=\"$ctrl.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO'||$ctrl.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO'\">\n        <div class=\"col-md-12\">\n          <formulario-beneficiario data=\"$ctrl.datosCert\"></formulario-beneficiario>\n        </div>\n      </div>\n\n      <div class=\"text-right\">\n        <button type=\"button\" md-effect class=\"btn btn-default\" ng-click=\"$ctrl.volver()\">\n          <i class=\"fa fa-arrow-left\"></i> Atrás\n        </button>\n        <button uib-tooltip=\"Observar el documento\" tooltip-placement=\"top\"  md-effect  class=\"btn btn-warning\" ng-click=\"$ctrl.observar()\"\n                ng-disabled=\"$ctrl.certificacion.estado !== 'ENVIADO' ? true : false\" ng-hide=\"($ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'OBSERVADO' || $ctrl.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' || $ctrl.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO')\">\n          <i class=\"fa fa-comment-o\"></i> Observar\n        </button>\n        <button uib-tooltip=\"Siguiente Paso\" tooltip-placement=\"top\" md-effect  class=\"btn btn-primary\" ng-click=\"$ctrl.siguiente()\"\n                ng-if=\"$ctrl.certificacion.formulario.tipo !== 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO' && $ctrl.certificacion.formulario.tipo !== 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' && ($ctrl.certificacion.estado === 'PENDIENTE_PAGO' || $ctrl.certificacion.estado === 'PAGADO' || $ctrl.certificacion.estado === 'APROBADO')\">\n          <i class=\"fa fa-arrow-right\"></i> Siguiente\n        </button>\n\n        <button uib-tooltip=\"Aprobar declaración\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.aprobar()\"\n                ng-disabled=\" !($ctrl.isDdjj && $ctrl.isSeccionCaebOk() && $ctrl.isCategorizacion) || $ctrl.certificacion.estado === 'OBSERVADO'\"\n                ng-if=\"$ctrl.certificacion.estado === 'ENVIADO' && $ctrl.certificacion.formulario.tipo !== 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' && $ctrl.certificacion.formulario.tipo !== 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO'\">\n          <i class=\"fa fa-check\"></i> Aprobar\n        </button>\n        <button uib-tooltip=\"Observar el documento\" tooltip-placement=\"top\"  md-effect  class=\"btn btn-warning\" ng-click=\"$ctrl.observarAguinaldo()\"\n                ng-if=\"$ctrl.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' && ($ctrl.certificacion.estado === 'ENVIADO' || $ctrl.certificacion.estado === 'APROBADO_ENVIADO')\">\n          <i class=\"fa fa-comment-o\"></i> Observar\n        </button>\n        <button uib-tooltip=\"Aprobar declaración\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.aprobarAguinaldo()\"\n                ng-disabled=\" !($ctrl.isDdjj && $ctrl.isSeccionCaebOk() && $ctrl.isCategorizacion) || $ctrl.certificacion.estado === 'OBSERVADO'\"\n                ng-if=\"($ctrl.certificacion.estado === 'ENVIADO' || $ctrl.certificacion.estado === 'APROBADO_ENVIADO') && $ctrl.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO'\">\n          <i class=\"fa fa-check\"></i> Aprobar\n        </button>\n\n        <button uib-tooltip=\"Observar el documento\" tooltip-placement=\"top\"  md-effect  class=\"btn btn-warning\" ng-click=\"$ctrl.observarRefrigerio()\"\n                ng-if=\"$ctrl.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO' && ($ctrl.certificacion.estado === 'ENVIADO' || $ctrl.certificacion.estado === 'APROBADO_ENVIADO')\">\n          <i class=\"fa fa-comment-o\"></i> Observar\n        </button>\n        <button uib-tooltip=\"Aprobar declaración\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.aprobarRefrigerio()\"\n                ng-disabled=\" !($ctrl.isDdjj && $ctrl.isSeccionCaebOk() && $ctrl.isCategorizacion) || $ctrl.certificacion.estado === 'OBSERVADO'\"\n                ng-if=\"($ctrl.certificacion.estado === 'ENVIADO' || $ctrl.certificacion.estado === 'APROBADO_ENVIADO') && $ctrl.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO'\">\n          <i class=\"fa fa-check\"></i> Aprobar\n        </button>\n      </div>\n    </div>\n\n\n\n  </div>\n</div>\n"

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-comment-o\"></i> Observar </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<form name=\"form\" ng-submit=\"$ctrl.ok()\">\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label for=\"textaObs\">Ingresar observación:</label>\n      <textarea class=\"form-control\" maxlength=\"600\" id=\"textaObs\" rows=\"3\" ng-model=\"$ctrl.observacion\" required ></textarea>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Aceptar\n    </button>\n  </div>\n</form>\n"

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Lista de solicitud de <strong>duplicados</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n        </div>\n      </div>\n      <div class=\"flex form-group\" uib-tooltip=\"Filtrar datos por departamento, NIT, matrícula, razón social, representante legal o CI\">\n        <input name=\"filtro\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.filtro_bandeja\" placeholder=\"Filtrar datos...\" ng-change=\"$ctrl.changeFilter()\">\n      </div>\n      <!--<crud-table buttons=\"$ctrl.buttons\" permission=\"$ctrl.permission\" url=\"$ctrl.url\" edit-modal-controller=\"$ctrl.editModalController\">-->\n      <!--</crud-table>-->\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\">\n        <table class=\"table table-condensed table-striped table-hover\">\n          <tr ng-repeat=\"item in $data\">\n            <td data-title=\"'Acciones'\" >\n\n              <button uib-tooltip=\"{{item.certificacion.estado==='APROBADO'? 'Ver' : 'Aprobar'}}\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.aprobarDuplicado(item)\" >\n                <i class=\"fa fa-check-circle\" ng-show=\"{{item.certificacion.estado==='APROBADO'? false : true }}\"></i>\n                <i class=\"fa fa-eye\"  ng-show=\"{{item.certificacion.estado==='APROBADO'? true : false}}\"></i>\n              </button>\n\n            </td>\n            <td data-title=\"'Nro.'\"> {{(($ctrl.tableParams.page() - 1) * $ctrl.tableParams.count()) + ($index + 1)}}</td>\n            <td data-title=\"'Cantidad Duplicados'\"  class=\"text-right\">{{ item.certificacion.duplicados}}</td>\n            <td data-title=\"'Departamento'\">\n              {{ item.unidad_productiva.ubicaciones[0].departamento.descripcion}}\n            </td>\n            <td data-title=\"'Grupo'\">\n              {{ $ctrl.procesar(item.certificacion.formulario.nombre)}}\n            </td>\n            <td data-title=\"'Tipo'\">\n              {{ item.certificacion.tipo}}\n            </td>\n            <td data-title=\"'NIT/Matrícula'\">\n              <span ng-if=\"item.unidad_productiva.nit || item.unidad_productiva.matricula_comercio\">\n                {{ item.unidad_productiva.nit}}<br>\n                {{ item.unidad_productiva.matricula_comercio}}\n              </span>\n              <span ng-if=\"!item.unidad_productiva.nit && !item.unidad_productiva.matricula_comercio\">\n                <i>No tiene</i>\n              </span>\n            </td>\n            <td data-title=\"'Razón Social'\">\n              {{ item.unidad_productiva.razon_social}}\n            </td>\n            <td data-title=\"'Fecha Vigencia'\">\n              {{ item.certificacion._fecha_fin |  date:'dd/MM/yyyy' }}\n            </td>\n            <td data-title=\"'Representante Legal/CI'\">\n              {{item.unidad_productiva.hist_representantes.nombre_completo}}  {{item.unidad_productiva.hist_representantes.documento_identidad}}\n            </td>\n            <td data-title=\"'Estado'\" >\n              <span class=\"badge\n                    {{item.certificacion.estado ==='ENVIADO'? 'badge-primary':\n                  (item.certificacion.estado ==='APROBADO'? 'badge-success' : ( item.certificacion.estado ==='PENDIENTE_PAGO'? 'badge-warning' :\n                  (item.certificacion.estado ==='OBSERVADO'? 'badge-danger' : ( item.certificacion.estado ==='PAGADO'? 'badge-default' : 'badge-default'))))}}\">\n                {{item.certificacion.estado}}\n              </span>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-copy\"></i>  Solicitud de duplicados </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<ng-form name=\"general_form\">\n  <div class=\"modal-body\">\n\n    <div class=\"alert alert-warning row mx-0\" >\n      <i class=\"fa fa-info-circle\" ></i>\n      <span class=\"col\">\n        <p class=\"mb-0\">Para obtener duplicados de su certificado, debe llenar la siguiente información.</p>\n      </span>\n    </div>\n    <br/>\n    <div class=\"row\">\n      <div class=\"col-md form-group\">\n        <div class=\"form-group\">\n          <label>Cuantos duplicados solicita</label>\n          <input  name=\"cantidad\" ng-model=\"$ctrl.obj.duplicados\"  numeric maxlength=\"5\" class=\"form-control\"  placeholder=\"\" required  autocomplete=\"off\" >\n          <div ap-error ng-messages=\"general_form.cantidad.$error\" role=\"alert\" ng-if=\"general_form.cantidad.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md form-group\">\n\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md form-group\">\n        <div class=\"form-group\">\n          <label>Código de Boleta</label>\n          <input  name=\"codigo\" ng-model=\"$ctrl.obj.codigo_deposito\" class=\"form-control\"  placeholder=\"\" required maxlength=\"30\">\n          <div ap-error ng-messages=\"general_form.codigo.$error\" role=\"alert\" ng-if=\"general_form.codigo.$touched\">\n            <div ng-message=\"required\">El campo es requerido</div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md form-group\">\n        <label>Fecha de Depósito</label>\n        <div class=\"input-group uib-input-date\">\n          <input name=\"fecha_deposito\" maxlength=\"10\" class=\"form-control\" datepicker-append-to-body=\"true\" placeholder=\"dd/mm/aaaa\"\n                 uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\" ng-model=\"$ctrl.obj.fecha_deposito\" is-open=\"$ctrl.deposito.is_open\" ng-change=\"$ctrl.validateFechaDeposito(general_form)\"\n                 datepicker-options=\"$ctrl.conf\" ng-required=\"true\" close-text=\"Close\"/>\n          <span class=\"input-group-btn\">\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.deposito.is_open = true\"><i class=\"fa fa-calendar\"></i></button>\n          </span>\n        </div>\n        <div ap-error ng-messages=\"general_form.fecha_deposito.$error\" role=\"alert\" ng-if=\"general_form.fecha_deposito.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n          <div ng-message=\"date\">Formato de fecha incorrecta (Ejemplo:15/02/1996)</div>\n          <div ng-message=\"min_date\">La fecha mínima aceptada es {{$ctrl.conf.minDate| date:'dd/MM/yyyy'}}</div>\n          <div ng-message=\"max_date\">La fecha máxima aceptada es {{$ctrl.conf.maxDate| date:'dd/MM/yyyy'}}</div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.solicitar()\" ng-disabled=\"general_form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Solicitar\n    </button>\n  </div>\n</ng-form>\n"

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa  fa-fort-awesome \"></i>Razón Social: {{$ctrl.unidad_productiva.razon_social}}</h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"alert alert-primary\">\n        <span aria-hidden=\"true\"></span>\n        <span><strong>{{$ctrl.certificacion.tipo}} - {{$ctrl.certificacion.formulario.nombre}}</strong></span>\n      </div>\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-sm-4 form-group\">\n            <label>Nombre o Razón Social:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\">\n            {{$ctrl.unidad_productiva.razon_social}}\n          </div>\n          <div class=\"col-sm-4 form-group\">\n            <label>Representante legal:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\">\n            {{$ctrl.unidad_productiva.hist_representantes.nombre_completo}}\n          </div>\n          <div class=\"col-sm-4 form-group\">\n            <label>Categoría: </label>\n          </div>\n          <div class=\"col-sm-8 form-group\">\n            {{$ctrl.unidad_productiva.categorizacion}} {{$ctrl.certificacion.formulario.tipo=== 'ARTESANO'? '':'EMPRESA'}}\n          </div>\n<!--          <div class=\"col-sm-4 form-group\">\n            <label>Rubro:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\">\n            {{$ctrl.rubro}}\n          </div>-->\n          <div class=\"col-sm-4 form-group\">\n            <label>Número de copias:</label>\n          </div>\n          <div class=\"col-sm-8 form-group\">\n            <input    class=\"form-control\" ng-model=\"$ctrl.duplicados.length\"\n                      ng-disabled=\"true\">\n          </div>\n        </div>\n      </div>\n      <ng-form name=\"general_form\">\n        <div class=\"empresa\">\n          <section>\n            <!--<header class=\"header-section\">{{$ctrl.conf.pag.sec_nombre}}</header>-->\n            <header class=\"header-section\">DEPÓSITO DEL TRÁMITE</header>\n            <div ng-show=\"$ctrl.deposito.id_pago === undefined\">\n              <div class=\"alert alert-danger\" >\n                <span aria-hidden=\"true\"></span>\n                <i class=\"fa fa-info-circle\"></i>\n                {{$ctrl.usuario_ddjj_con_nit? 'El usuario debe llenar los datos de depósito.':'Debe llenar los datos de depósito.'}}\n              </div>\n            </div>\n            <div class=\"body-section\">\n              <ng-form name=\"depositos_form\">\n                <div class=\"row\">\n                  <div class=\"col-md form-group\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.pag.codigo_deposito.requerido}\">{{$ctrl.conf.pag.codigo_deposito.label}}</label>\n                    <input name=\"codigo_deposito\" alpha-dash maxlength=\"50\" class=\"form-control\" ng-model=\"$ctrl.deposito.codigo_deposito\"\n                           ng-required=\"$ctrl.conf.pag.codigo_deposito.requerido\"\n                           ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\">\n                    <div ap-error ng-messages=\"depositos_form.codigo_deposito.$error\" role=\"alert\" ng-if=\"depositos_form.codigo_deposito.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.pag.fecha_deposito.requerido}\">{{$ctrl.conf.pag.fecha_deposito.label}}</label>\n                    <div class=\"input-group uib-input-date\">\n                      <input name=\"fecha_deposito\" maxlength=\"10\"\n                             class=\"form-control\" datepicker-append-to-body=\"true\"\n                             placeholder=\"dd/mm/aaaa\" uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\"\n                             ng-model=\"$ctrl.deposito.fecha_deposito\" ng-change=\"$ctrl.validateFechaDeposito(depositos_form)\"\n                             is-open=\"$ctrl.deposito.is_open\" datepicker-options=\"$ctrl.conf.pag.fecha_deposito.options\"\n                             ng-required=\"$ctrl.conf.pag.fecha_deposito.requerido\" ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\">\n                      <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.deposito.is_open = true\"><i class=\"fa fa-calendar\"></i></button>\n                      </span>\n                    </div>\n                    <div ap-error ng-messages=\"depositos_form.fecha_deposito.$error\" role=\"alert\" ng-if=\"depositos_form.fecha_deposito.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"date\">Formato de fecha incorrecta (Ejemplo:15/02/1996)</div>\n                      <div ng-message=\"min_date\">La fecha mínima aceptada es {{$ctrl.conf.pag.fecha_deposito.options.minDate| date:'dd/MM/yyyy'}}</div>\n                      <div ng-message=\"max_date\">La fecha máxima aceptada es {{$ctrl.conf.pag.fecha_deposito.options.maxDate| date:'dd/MM/yyyy'}}</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.pag.nombre_razon_social.requerido}\">{{$ctrl.conf.pag.nombre_razon_social.label}}</label>\n                    <input name=\"nombre_razon_social\" maxlength=\"250\" class=\"form-control\" ng-model=\"$ctrl.deposito.nombre_razon_social\"\n                           ng-required=\"$ctrl.conf.pag.nombre_razon_social.requerido\"\n                           ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\">\n                    <!--ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO' || $ctrl.certificacion.estado === 'PAGADO'\">-->\n                    <div ap-error ng-messages=\"depositos_form.nombre_razon_social.$error\" role=\"alert\" ng-if=\"depositos_form.nombre_razon_social.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.pag.monto.requerido}\">{{$ctrl.conf.pag.monto.label}}:</label>\n                    <input name=\"monto\" decimal-format maxlength=\"15\" class=\"form-control\" ng-model=\"$ctrl.monto\" ng-required=\"$ctrl.conf.pag.monto.requerido\"\n                           ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO' || true\">\n                    <div ap-error ng-messages=\"depositos_form.monto.$error\" role=\"alert\" ng-if=\"depositos_form.monto.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                </div>\n              </ng-form>\n            </div>\n          </section>\n\n          <section>\n            <!--<header class=\"header-section\">{{$ctrl.conf.fac.sec_nombre}}</header>-->\n            <header class=\"header-section\">DATOS DE FACTURA</header>\n            <div class=\"body-section\">\n              <ng-form name=\"factura_form\">\n                <div class=\"row\">\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.nombre_razon_social.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.nombre_razon_social.requerido}\">{{$ctrl.conf.fac.nombre_razon_social.label}}:</label>\n                    <!-- <input name=\"nombre_razon_social\" class=\"form-control\" ng-model=\"$ctrl.certificacion.nombre_razon_social\" ng-required=\"$ctrl.conf.fac.nombre_razon_social.requerido\" ng-disabled=\"$ctrl.conf.fac.nombre_razon_social.disabled\"> -->\n                    <textarea name=\"nombre_razon_social\" maxlength=\"250\" class=\"form-control\" autoresize ng-model=\"$ctrl.datos_factura.nombre_razon_social\"\n\n                              ng-required=\"$ctrl.conf.fac.nombre_razon_social.requerido\" ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO'\"></textarea>\n                    <div ap-error ng-messages=\"factura_form.nombre_razon_social.$error\" role=\"alert\" ng-if=\"factura_form.nombre_razon_social.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.nit.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.nit.requerido}\">{{$ctrl.conf.fac.nit.label}}:</label>\n                    <input name=\"nit\" maxlength=\"20\" class=\"form-control\" ng-model=\"$ctrl.datos_factura.nit\" ng-required=\"$ctrl.conf.fac.nit.requerido\" ng-disabled=\"$ctrl.usuario_ddjj_con_nit || $ctrl.certificacion.estado === 'APROBADO'\">\n                    <div ap-error ng-messages=\"factura_form.nit.$error\" role=\"alert\" ng-if=\"factura_form.nit.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"row\">\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.numero_autorizacion.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.numero_autorizacion.requerido}\">{{$ctrl.conf.fac.numero_autorizacion.label}}:</label>\n                    <input name=\"numero_autorizacion\" class=\"form-control\" numeric\n                           minlength=\"{{$ctrl.conf.fac.numero_autorizacion.min_length}}\"\n                           maxlength=\"{{$ctrl.conf.fac.numero_autorizacion.max_length}}\"\n                           ng-model=\"$ctrl.datos_factura.numero_autorizacion\"\n                           ng-required=\"$ctrl.conf.fac.numero_autorizacion.requerido\"\n                           ng-disabled=\"!$ctrl.habilitarFac()\">\n                    <div ap-error ng-messages=\"factura_form.numero_autorizacion.$error\" role=\"alert\" ng-if=\"factura_form.numero_autorizacion.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"minlength\">El número debe tener {{$ctrl.conf.fac.numero_autorizacion.min_length}} o más caracteres</div>\n                      <div ng-message=\"maxlength\">El número debe tener {{$ctrl.conf.fac.numero_autorizacion.max_length}} o menos caracteres</div>\n                    </div>\n                  </div>\n                  <!--........-->\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.numero_factura.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.numero_factura.requerido}\">{{$ctrl.conf.fac.numero_factura.label}}:</label>\n                    <input name=\"numero_factura\" class=\"form-control\" numeric\n                           minlength=\"{{$ctrl.conf.fac.numero_factura.min_length}}\"\n                           maxlength=\"{{$ctrl.conf.fac.numero_factura.max_length}}\"\n                           ng-model=\"$ctrl.datos_factura.nro_factura\"\n                           ng-required=\"$ctrl.conf.fac.numero_factura.requerido\"\n                           ng-disabled=\"!$ctrl.habilitarFac()\">\n                    <div ap-error ng-messages=\"factura_form.numero_factura.$error\" role=\"alert\" ng-if=\"factura_form.numero_factura.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"minlength\">El número debe tener {{$ctrl.conf.fac.numero_factura.min_length}} o más caracteres</div>\n                      <div ng-message=\"maxlength\">El número debe tener {{$ctrl.conf.fac.numero_factura.max_length}} o menos caracteres</div>\n                    </div>\n                  </div>\n                  <!--........-->\n\n                  <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fac.fecha_factura.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.fac.fecha_factura.requerido}\">{{$ctrl.conf.fac.fecha_factura.label}}:</label>\n                    <div class=\"input-group uib-input-date\">\n                      <input name=\"fecha_factura\" maxlength=\"10\"\n                             class=\"form-control\" datepicker-append-to-body=\"true\"\n                             placeholder=\"dd/mm/aaaa\" uib-datepicker-popup=\"{{'dd/MM/yyyy'}}\"\n                             ng-model=\"$ctrl.datos_factura.fecha_factura\" ng-change=\"$ctrl.validateFechaFactura(factura_form)\"\n                             is-open=\"$ctrl.certificacion.is_open_fecha_factura\" datepicker-options=\"$ctrl.conf.fac.fecha_factura.options\"\n                             ng-required=\"$ctrl.conf.fac.fecha_factura.requerido\"\n                             ng-disabled=\"!$ctrl.habilitarFac()\">\n                      <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.certificacion.is_open_fecha_factura = true\"><i class=\"fa fa-calendar\"></i></button>\n                      </span>\n                    </div>\n                    <div ap-error ng-messages=\"factura_form.fecha_factura.$error\" role=\"alert\" ng-if=\"factura_form.fecha_factura.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                      <div ng-message=\"date\">Formato de fecha incorrecta (Ejemplo:15/02/1996)</div>\n                      <div ng-message=\"min_date\">La fecha mínima aceptada es {{$ctrl.conf.pag.fecha_deposito.options.minDate| date:'dd/MM/yyyy'}}</div>\n                      <div ng-message=\"max_date\">La fecha máxima aceptada es {{$ctrl.conf.pag.fecha_deposito.options.maxDate| date:'dd/MM/yyyy'}}</div>\n                    </div>\n                  </div>\n                </div>\n              </ng-form>\n            </div>\n          </section>\n        </div>\n        <div class=\"text-right mb-3\">\n          <button type=\"button\" md-effect class=\"btn btn-default\" ng-click=\"$ctrl.volver()\">\n            <i class=\"fa fa-close\"></i> Cerrar\n          </button>\n          <button type=\"button\" md-effect  class=\"btn btn-primary\" ng-click=\"$ctrl.finalizarAcreditacion(general_form)\"\n                  ng-show=\"$ctrl.certificacion.estado === 'PENDIENTE_PAGO' || $ctrl.certificacion.estado === 'PAGADO'\"\n                  ng-disabled=\"general_form.$invalid\">\n            <i class=\"fa fa-check\"></i> Finalizar\n          </button>\n        </div>\n      </ng-form>\n      <div>\n        <div class=\"alert alert-warning\"  ng-hide=\"$ctrl.certificadoDuplicado===false\">\n          <span aria-hidden=\"true\"></span>\n          <i class=\"fa fa-info-circle\"></i>\n          Se ha generado los certificados de registro\n        </div>\n\n        <uib-tabset active=\"active\"  ng-hide=\"$ctrl.certificadoDuplicado===false\">\n          <uib-tab index=\"$index\" ng-repeat=\"duplicado in $ctrl.duplicados\"  ng-click=\"$ctrl.cambiarTab(duplicado)\" >\n            <uib-tab-heading>\n              <i class=\"fa fa-file-pdf-o\"></i> {{$index + 1}}\n            </uib-tab-heading>\n            <div class=\"tab-container\">\n\n              <div ng-show=\"!$ctrl.esEdge()\">\n                <iframe ng-src=\"{{$ctrl.urlPdf}}\" style=\"width:100%; height:550px;\" frameborder=\"0\">\n                  <p>Su navegador no soporta iframe</p>\n                </iframe>\n              </div>\n              <div>\n                <span class=\"login-message\"><a href=\"\" ng-click=\"$ctrl.descargarCertificado(duplicado)\" class=\"text-success\"> <i class=\"fa fa-download\"></i> Descargar certificado</a></span>\n              </div>\n\n            </div>\n          </uib-tab>\n        </uib-tabset>\n\n      </div>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Bandeja <strong>de entrada</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n        </div>\n      </div>\n      <div class=\"flex form-group\" uib-tooltip=\"Filtrar datos por departamento, NIT, matrícula, razón social, representante legal o CI\">\n        <input name=\"filtro\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.filtro_bandeja\" placeholder=\"Filtrar datos...\" ng-change=\"$ctrl.changeFilter()\">\n\n      </div>\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\" >\n        <table class=\"table table-striped table-hover\" >\n          <tr ng-repeat=\"item in $data\">\n            <td>\n            </td>\n            <td data-title=\"'Acciones'\" class=\"accionesSize\">\n              <div class=\"accionesSizeDiv\">\n                <button uib-tooltip=\"Ver reporte\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.verPdfTabla(item)\"  >\n                  <i class=\"fa fa-file-pdf-o\"></i>\n                </button>\n              </div>\n            </td>\n            <td data-title=\"'Nro.'\"> {{(($ctrl.tableParams.page()-1) * $ctrl.tableParams.count()) + ($index+1)}}</td>\n            <td data-title=\"'Departamento'\">\n              {{ item.unidad_productiva.ubicaciones[0].departamento.descripcion}}\n            </td>\n            <td data-title=\"'Grupo'\">\n              {{ $ctrl.procesar(item.certificacion.formulario.nombre)}}\n            </td>\n            <td data-title=\"'Tipo'\">\n              {{ item.certificacion.tipo}}\n            </td>\n            <td data-title=\"'NIT/Matrícula'\">\n              <span ng-if=\"item.unidad_productiva.nit || item.unidad_productiva.matricula_comercio\">\n                {{ item.unidad_productiva.nit}}<br>\n                {{ item.unidad_productiva.matricula_comercio}}\n              </span>\n              <span ng-if=\"!item.unidad_productiva.nit && !item.unidad_productiva.matricula_comercio\">\n                <i>No tiene</i>\n              </span>\n            </td>\n            <td data-title=\"'Organización Productiva'\" ng-class=\"item.unidad_productiva.razon_social.length > 30 ? 'card-overflow' : ''\" >\n              {{item.unidad_productiva.razon_social}}\n            </td>\n            <td data-title=\"'Representante Legal/CI'\">\n              {{item.unidad_productiva.hist_representantes.nombre_completo}}  {{item.unidad_productiva.hist_representantes.documento_identidad}}\n            </td>\n            <td data-title=\"'Fecha de solicitud'\" class=\"text-center\" >\n              {{ item.certificacion._fecha_envio |  date:'dd/MM/yyyy HH:mm:ss' }}\n            </td>\n            <td data-title=\"'Usuario de registro'\">\n              {{$ctrl.getUsuarioReg(item)}}\n              <br/>\n              <small>(Rol: <strong>{{item.unidad_productiva.usuario.usuarios_roles[0].rol.descripcion}}</strong>)</small>\n            </td>\n            <td data-title=\"'Estado'\" >\n              <span class=\"badge\n                    {{item.certificacion.estado ==='ENVIADO'? 'badge-primary':\n                  (item.certificacion.estado ==='APROBADO'? 'badge-success' : ( item.certificacion.estado ==='PENDIENTE_PAGO'? 'badge-warning' :\n                  (item.certificacion.estado ==='OBSERVADO'? 'badge-danger' : ( item.certificacion.estado ==='PAGADO'? 'badge-default' : 'badge-default'))))}}\n                    \">\n                {{item.certificacion.estado}}\n                <br/>\n                <small>Estado Firma: <strong>{{item.certificacion.estado_firma}}</strong></small>\n              </span>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Parámetros <strong>del sistema</strong></h2>\n\n  <div class=\"card\">\n\n    <div class=\"card-block\">\n\n      <div class=\"row\">\n          <div class=\"alert alert-danger col-xs-12 col-sm-12\">\n            <i class=\"fa fa-info-circle\" ></i>\n            <span>Considere que la manipulación incorrecta de éstos datos puede alterar el funcionamiento normal del sistema.</span>\n          </div>\n      </div>\n\n      <div class=\"row\">\n\n        <div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-2\">\n          <a href=\"\" style=\"text-decoration:none;\" ng-click=\"$ctrl.cargarParametros('UNIDAD_MEDIDA')\">\n            <div class=\"card card-text card-block {{$ctrl.grupo==='UNIDAD_MEDIDA'? 'card-inverse card-danger':''}}\">\n              <div class=\"card-block\">\n                <p class=\"card-text text-center\"><i class=\"fa fa-balance-scale fa-3x\"></i></p>\n              </div>\n              <small class=\"text-center\"><strong>UNIDADES DE MEDIDA</strong></small>\n            </div>\n          </a>\n        </div>\n\n        <div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-2\">\n          <a href=\"\" style=\"text-decoration:none;\" ng-click=\"$ctrl.cargarParametros('TIOC')\"  >\n            <div class=\"card card-text card-block {{$ctrl.grupo==='TIOC'? 'card-inverse card-danger':''}}\">\n              <div class=\"card-block\">\n                <p class=\"card-text text-center\"><i class=\"fa fa-users fa-3x\"></i></p>\n              </div>\n              <small class=\"text-center\"><strong>TIOCs</strong></small>\n            </div>\n          </a>\n        </div>\n\n        <div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-2\">\n          <a href=\"\" style=\"text-decoration:none;\" ng-click=\"$ctrl.cargarParametros('TIPO_ORGANIZACION_AFILIADA')\"  >\n            <div class=\"card card-text card-block {{$ctrl.grupo==='TIPO_ORGANIZACION_AFILIADA'? 'card-inverse card-danger':''}}\">\n              <div class=\"card-block\">\n                <p class=\"card-text text-center\"><i class=\"fa fa-adjust fa-3x\"></i></p>\n              </div>\n              <small class=\"text-center\"><strong>TIPO ORG. AFILIADA</strong></small>\n            </div>\n          </a>\n        </div>\n\n      </div>\n\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-primary\" md-effect ng-click=\"$ctrl.add()\" type=\"button\" uib-tooltip=\"Agregar nuevo registro\" ><i class=\"fa fa-plus\"></i> Agregar</button>\n        </div>\n      </div>\n\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams1\" >\n        <table  class=\"table table-striped table-hover\" >\n          <tr ng-repeat=\"parametro in $data\">\n            <td title=\"'Acciones'\" >\n              <button uib-tooltip=\"Editar\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.editar(parametro)\"  >\n                <i class=\"fa fa-edit\"></i>\n              </button>\n            </td>\n            <td title=\"'Sigla'\" >\n              {{parametro.sigla}}\n            </td>\n            <td title=\"'Nombre'\" >\n              {{parametro.nombre}}\n            </td>\n            <td title=\"'Descripción'\" >\n              {{parametro.descripcion}}\n            </td>\n            <td title=\"'Orden'\" class=\"text-center\" >\n              {{parametro.orden}}\n            </td>\n            <td title=\"'Estado'\" class=\"text-center\" >\n              {{parametro.estado}}\n            </td>\n          </tr>\n        </table>\n      </div>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-edit\"></i> {{$ctrl.isEdicion? 'Actualizando Información de Parámetro' : 'Agregando Parámetro'}} </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <form name=\"form\">\n    <div class=\"row\" ng-show=\"!$ctrl.isEdicion\">\n      <div class=\"col-sm-3\">\n        <label>Grupo:</label>\n      </div>\n      <div class=\"col-sm-8\">\n        <label><strong>{{$ctrl.items.grupo}}</strong></label>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-3\">\n        <label>Sigla:</label>\n      </div>\n      <div class=\"col-sm-8\">\n        <input class=\"form-control\" name=\"sigla\" ng-model=\"$ctrl.parametro.sigla\" required>\n        <div ap-error ng-messages=\"form.sigla.$error\" role=\"alert\" ng-if=\"form.sigla.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-3\">\n        <label>Nombre:</label>\n      </div>\n      <div class=\"col-sm-8\">\n        <input class=\"form-control\" name=\"nombre\" ng-model=\"$ctrl.parametro.nombre\" required>\n        <div ap-error ng-messages=\"form.nombre.$error\" role=\"alert\" ng-if=\"form.nombre.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-3\">\n        <label>Descripción:</label>\n      </div>\n      <div class=\"col-sm-8\">\n        <input class=\"form-control\" name=\"descripcion\" ng-model=\"$ctrl.parametro.descripcion\" required>\n        <div ap-error ng-messages=\"form.descripcion.$error\" role=\"alert\" ng-if=\"form.descripcion.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-3\">\n        <label>Orden:</label>\n      </div>\n      <div class=\"col-sm-8\">\n        <input class=\"form-control\" name=\"orden\" ng-model=\"$ctrl.parametro.orden\" required>\n        <div ap-error ng-messages=\"form.orden.$error\" role=\"alert\" ng-if=\"form.orden.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-sm-3\">\n        <label>Estado:</label>\n      </div>\n      <div class=\"col-sm-8\">\n        <!--        <input class=\"form-control\" name=\"estado\" ng-model=\"$ctrl.parametro.estado\" required>\n                <div ap-error ng-messages=\"form.estado.$error\" role=\"alert\" ng-if=\"form.estado.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>-->\n        <select class=\"form-control\" name=\"estado\"  ng-model=\"$ctrl.parametro.estado\" required >\n          <option value=\"ACTIVO\">ACTIVO</option>\n          <option value=\"INACTIVO\">INACTIVO</option>\n        </select>\n        <div ap-error ng-messages=\"form.estado.$error\" role=\"alert\" ng-if=\"form.estado.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"form.$invalid\" >\n    <i class=\"fa fa-check\"></i>  {{$ctrl.isEdicion? 'Guardar Cambios' : 'Aceptar'}} \n  </button>\n</div>"

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login__container\">\n  <div class=\"izq\">\n    <div class=\"images__container\">\n      <div class=\"top\">\n        <div class=\"logo\"></div>\n        <div class=\"dobleAguinaldo\"></div>\n        <div class=\"consumeNuestro\"></div>\n      </div>\n    </div>\n    <div class=\"descripcion\">\n      En esta sección se puede crear accesos y solamenente se solicitara:\n      <ul>\n        <li>Una cuenta de correo</li>\n        <li>Una contraseña</li>\n      </ul>\n    </div>\n    <div class=\"phone text-primary hide--medium\">\n      <i class=\"fa fa-phone text-primary\"></i>\n      <section>800-10-1660</section>\n    </div>\n    <div class=\"bottom hide--medium\">\n      <div class=\"logoMinisterio\"></div>\n    </div>\n\n  </div>\n  <div class=\"der\">\n    <div class=\"login__administrador\">\n      <div class=\"alert alert-info text-center titulo\">\n        <i class=\"fa fa-building-o\"></i><strong>Registro de artesano u otro tipo de organización</strong>\n      </div>\n      <form ng-submit=\"$ctrl.registrarUsuario()\">\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon\"><i class=\"fa fa-envelope\"></i></span>\n          <div class=\"md-form-group\" md-event-label>\n            <input ng-model=\"$ctrl.usuario.email\" id=\"email\"   maxlength=\"100\" required ng-disabled=\"$ctrl.codigoCoincide\">\n            <label ng-if=\"!$ctrl.codigoCoincide\" class=\"md-control-label\">Email</label>\n            <i class=\"md-bar\"></i>\n          </div>\n        </div>\n\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon\"><i class=\"fa fa-lock\"></i></span>\n          <md-input label=\"Elija una Contraseña\" ng-model=\"$ctrl.usuario.contrasena\" type=\"password\" required minlength = \"6\" ng-keyup=\"$ctrl.validarInputs()\" ></md-input>\n          <div class=\"md-input-warning\" style=\"margin-top: -27px\">{{$ctrl.mensaje1}} <span class=\"md-input-group-addon\" ng-show=\"$ctrl.isContrasenaOk\"><i class=\"fa fa-check\" style=\"color: green\" title=\"Correcto, las contraseñas coinciden\"></i></span></div>\n        </div>\n\n        <div class=\"md-input-group\">\n          <span class=\"md-input-group-addon\"><i class=\"fa fa-lock\"></i></span>\n          <md-input label=\"Confirmar Contraseña Elegida\" ng-model=\"$ctrl.usuario.contrasenaConfirmacion\" type=\"password\" required minlength = \"6\" ng-keyup=\"$ctrl.validarInputs()\" ></md-input>\n          <div class=\"md-input-warning\" style=\"margin-top: -27px\">{{$ctrl.mensaje2}} <span class=\"md-input-group-addon\" ng-show=\"$ctrl.isContrasenaOk\"><i class=\"fa fa-check\" style=\"color: green\" title=\"Correcto, las contraseñas coinciden\"></i></span></div>\n\n        </div>\n\n        <div class=\"col-sm-12 text-center\" >\n          <div class=\"form-group\">\n          </div>\n        </div>\n        <button md-effect class=\"btn btn-primary btn-lg btn-block\" type=\"submit\">\n          <i class=\"fa fa-save\"></i> REGISTRAR MIS DATOS\n        </button>\n        <p class=\"centerText\">\n          <br/>\n          <span class=\"login-message\"><a href=\"\" class=\"text-success\" ng-click=\"$ctrl.volverLogin()\" >Regresar al inicio de sesión</a> </span>\n        </p>\n      </form>\n    </div>\n  </div>\n  <div class=\"show--medium\">\n    <div class=\"phone text-primary\">\n      <i class=\"fa fa-phone text-primary\"></i>\n      <section>800-10-1660</section>\n    </div>\n    <div class=\"bottom\">\n      <div class=\"logoMinisterio\"></div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-shield\"></i> Código de activación</h5>\n</div>\n<form ng-submit=\"$ctrl.confirmar()\" name=\"form\">\n  <div class=\"modal-body\">\n    <p class=\"text-justify text-primary\">Acabamos de enviarle un <strong>CÓDIGO DE ACTIVACIÓN</strong> al correo electrónico \n      <strong>{{$ctrl.correo}}</strong> \n      <!--<button uib-tooltip=\"Editar\" md-effect class=\"btn btn-default\" formnovalidate ng-click=\"$ctrl.editarCorreo\" type=\"button\"><i class=\"fa fa-pencil\"></i></button>-->\n      , ingrese al mismo <strong>copie</strong> o <strong>escriba</strong> su código de activación aquí para completar su registro.</p>\n    <div class=\"form-group row justify-content-center\">\n      <div class=\"col-sm-8\">\n        <input type=\"text\" class=\"form-control text-center\" id=\"codigo-activacion\" ng-focus=\"true\" name=\"codigo\" ng-model=\"$ctrl.codigo_activacion\" required placeholder=\"Escriba su código de activación aquí\" focus-me=\"{{ $ctrl.focus}}\" maxlength=\"5\"  minlength=\"5\" alpha-numeric>\n      </div>\n    </div>\n    <!-- <div class=\"alert alert-info\">\n        <i class=\"fa fa-info-circle\"></i> Este correo electrónico le servirá para recibir las distintas <strong>notificaciones</strong> que la plataforma le enviará.\n    </div> -->\n    <div class=\"alert alert-warning\">\n      <i class=\"fa fa-exclamation-triangle\"></i> El correo puede demorar unos minutos en llegar a su bandeja de entrada.\n    </div>\n<!--    <div class=\"col-sm-8\">\n      <input type=\"text\" class=\"form-control text-center\"    name=\"emailotro\" ng-model=\"$ctrl.emailOtro\" \n             placeholder=\"Ingresar correo\"  maxlength=\"100\" >\n    </div>-->\n\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n      <i class=\"fa fa-close\"></i> Cancelar registro\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.reenviarCorreo()\">\n      <i class=\"fa fa-close\"></i> Reenviar código\n    </button>\n    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"form.$invalid\">\n      <i class=\"fa fa-check\"></i> Confirmar código\n    </button>\n  </div>\n</form>"

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "<div></div>\n<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Certificados ProBolivia Aprobados-Firma por Director</h2>\n\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <crud-table url=\"$ctrl.solicitudes.url\"\n                query-extra=\"$ctrl.solicitudes.queryExtra\"\n                data=\"$ctrl.solicitudes.data\"\n                fields=\"$ctrl.solicitudes.fields\"\n                permission=\"$ctrl.solicitudes.permission\"\n                buttons=\"$ctrl.solicitudes.buttons\"\n                checks=\"$ctrl.solicitudes.checks\"\n                fks=\"$ctrl.solicitudes.fks\"\n                update=\"$ctrl.solicitudes.update\"\n                clases=\"$ctrl.solicitudes.clases\"\n                ng-if=\"$ctrl.solicitudes\"\n                no-sorting=\"$ctrl.noSorting\"\n                hidden-fields=\"$ctrl.solicitudes.hiddenFields\">\n            </crud-table>\n            <br />\n        </div>\n    </div>\n\n</div>\n"

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card card-verificacion col-md-6 push-md-2\">\n  <div class=\"card-header\">\n    <div class=\"row\">\n      <div class=\"col-md-9\">\n        <div class=\"logo-probolivia\"></div>\n        <!--<div class=\"logo-promueve\"></div>-->\n      </div>\n      <div class=\"col-md-3 verificacion-logo\" style=\"background-color: {{$ctrl.isCorrecto? 'green':'#E40421'}}\" ng-if=\"$ctrl.mostrarData\">\n        <i class=\"fa fa-{{$ctrl.isCorrecto? 'check':'close'}}\"></i><strong> {{$ctrl.isCorrecto? 'Certificado Válido': 'No se pudo verificar'}}</strong>\n      </div>\n    </div>\n  </div>\n  <div class=\"card-block\" ng-if=\"$ctrl.mostrarData\">\n    <div class=\"row\" ng-show=\"!$ctrl.isCorrecto\">\n      <div class=\"col-lg-12 col-md-12 card-element\" style=\"padding: 50px\">\n        <strong>No se ha encontrado la información solicitada o el enlace es incorrecto, por favor verifique nuevamente.</strong>\n      </div>\n    </div>\n\n    <div class=\"row\" ng-show=\"$ctrl.isCorrecto\">\n      <div class=\"col-lg-12 col-md-12 card-element\" style=\"padding: 10px\">\n        <!--HTML-->\n        <div class=\"form-group\" style=\"overflow-y: scroll; overflow-x: hidden; height:400px;\">\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">Nombre o Razón Social: </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\"> {{$ctrl.informacion.unidad_productiva.razon_social}}</p>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">Representante Legal: </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\">{{$ctrl.informacion.representante.nombre_completo}}</p>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">Categoria: </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\">{{$ctrl.informacion.unidad_productiva.categorizacion}} {{($ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'|| $ctrl.informacion.unidad_productiva.categorizacion==='ICAP' )? '':' EMPRESA'}}   </p>\n            </div>\n          </div>\n          <!--RUBROS (Para no ICAP)-->\n          <div ng-show=\"$ctrl.informacion.unidad_productiva.categorizacion !== 'ICAP'\">\n            <!--Rubro 1-->\n            <div class=\"form-group row\">\n              <label class=\"col-sm-2 col-form-label\">{{$ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'? 'Clasificación Principal:':'Rubro Principal:' }}</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\">{{$ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'? $ctrl.informacion.producto_principal.parametro.nombre :$ctrl.informacion.caeb_principal.padre.padre.padre.descripcion }}</p>\n              </div>\n            </div>\n\n            <div class=\"form-group row\">\n              <label class=\"col-sm-2 col-form-label\">Actividad Principal: </label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\">{{$ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'?  $ctrl.informacion.caeb_principal.descripcion: $ctrl.informacion.caeb_principal.padre.padre.descripcion}} </p>\n              </div>\n            </div>\n            <!--Rubro 2-->\n            <div class=\"form-group row\" ng-if=\"$ctrl.informacion.caeb_secundario\">\n              <label class=\"col-sm-2 col-form-label\">{{$ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'? 'Clasificación Secundaria:':'Rubro Secundario:' }}</label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\">{{$ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'? $ctrl.informacion.producto_secundario.parametro.nombre :$ctrl.informacion.caeb_secundario.padre.padre.padre.descripcion }}</p>\n              </div>\n            </div>\n\n            <div class=\"form-group row\" ng-if=\"$ctrl.informacion.caeb_secundario\">\n              <label class=\"col-sm-2 col-form-label\">Actividad Secundaria: </label>\n              <div class=\"col-sm-10\">\n                <p class=\"form-control-static\">{{$ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'?  $ctrl.informacion.caeb_secundario.descripcion: $ctrl.informacion.caeb_secundario.padre.padre.descripcion}}</p>\n              </div>\n            </div>\n          </div>\n\n          <!--SERVICIOS (Para ICAP)-->\n          <div ng-show=\"$ctrl.informacion.unidad_productiva.categorizacion === 'ICAP'\">\n            <!--Servicios-->\n            <div ng-repeat=\"serv in $ctrl.informacion.unidad_productiva.ddjj_servicios\"  >\n              <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">SERVICIO</label>\n                <div class=\"col-sm-10\">\n                  <p class=\"form-control-static text-uppercase\" >{{serv.servicio.parametro_padre.parametro_padre.sigla}} - {{serv.servicio.parametro_padre.nombre}}</p>\n                </div>\n              </div>\n              <div class=\"form-group row\">\n                <label class=\"col-sm-2 col-form-label\">ÁREA DE ESPECIALIZACIÓN: </label>\n                <div class=\"col-sm-10\">\n                  <p class=\"form-control-static\">{{serv.servicio.sigla}}</p>\n                </div>\n              </div>\n            </div>\n          </div>\n\n\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">{{$ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'? 'CI/NIT:':'NIT:' }}  </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\"> {{$ctrl.informacion.unidad_productiva.categorizacion === 'ARTESANO'? $ctrl.informacion.representante.documento_identidad: $ctrl.informacion.unidad_productiva.nit }} </p>\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">Departamento: </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\">{{$ctrl.informacion.ubicacion.departamento.descripcion}}</p>\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">Municipio: </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\">{{$ctrl.informacion.ubicacion.municipio.nombre}}</p>\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">Domicilio: </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\" ng-class=\"$ctrl.informacion.ubicacion.zona.length > 30 || $ctrl.informacion.ubicacion.avenida_calle.length > 30 ? 'card-overflow' : ''\">\n              {{$ctrl.informacion.ubicacion.zona}} {{$ctrl.informacion.ubicacion.avenida_calle}} {{ $ctrl.isNro ? 'Nro.':''}} {{$ctrl.informacion.ubicacion.numero}}</p>\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">Fecha Emisión: </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\">{{$ctrl.informacion.certificacion._fecha_aprobacion|  date:'dd/MM/yyyy'}}</p>\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 col-form-label\">Vigencia: </label>\n            <div class=\"col-sm-10\">\n              <p class=\"form-control-static\">{{$ctrl.informacion.certificacion._fecha_fin|  date:'dd/MM/yyyy'}}</p>\n            </div>\n          </div>\n        </div>\n        <!--PDF-->\n        <div ng-show=\"!$ctrl.esEdge()\">\n          <iframe ng-src=\"{{$ctrl.urlPdf}}\" style=\"width:100%; height:300px;\" frameborder=\"0\">\n            <p>Su navegador no soporta iframe</p>\n          </iframe>\n        </div>\n        <div ng-show=\"$ctrl.esEdge()\" class=\"text-center\">\n          <span class=\"login-message\"><a href=\"\" ng-click=\"$ctrl.descargarCertificado()\" class=\"text-success\"> <i class=\"fa fa-download\"></i> Descargar certificado</a></span>\n        </div>\n      </div>\n    </div>\n  </div>\n<div class=\"logo-ministerio\"></div>\n</div>\n"

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <div class=\"alert alert-primary\" >\n                <span aria-hidden=\"true\"></span>\n                <i class=\"fa fa-info-circle\"></i>\n                <span>Proceso de verificación completado! Haga click en aprobar para dar curso al trámite</span>\n            </div>\n            <!-- <h4>\n                Validación de\n                <span ng-if=\"$ctrl.prod.certificacion.formulario.nombre\">{{$ctrl.prod.certificacion.formulario.nombre}}</span>\n                <span ng-if=\"$ctrl.prod.certificacion.formulario.tipo && !$ctrl.prod.certificacion.formulario.nombre\">{{$ctrl.prod.certificacion.formulario.tipo.replace('_', ' ')}}</span>\n            </h4> -->\n\n            <div style=\"padding-left: 20px\">\n                <div class=\"alert alert-warning align-middle container-cshb\">\n                    <div>\n                        <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\n                        <label class=\"tgl\" title=\"{{$ctrl.ddjjProducto? 'Observar':'Aprobar'}}\">\n                            <input type=\"checkbox\" ng-model=\"$ctrl.ddjjProducto\"/>\n                            <span class=\"tgl_body\">\n                            <span class=\"tgl_switch\"></span>\n                            <span class=\"tgl_track\">\n                                <span class=\"tgl_bgd\"></span>\n                                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n                            </span>\n                            </span>\n                        </label>\n                    </div>\n                    <div style=\"padding-left: 10px; padding-right: 10px;\">Declaración jurada para el registro y acreditación nacional.</div>\n                    <button\n                        uib-tooltip=\"Descripción técnica del producto.\"\n                        tooltip-placement=\"bottom\"\n                        md-effect\n                        class=\"btn btn-info\"\n                        ng-click=\"$ctrl.verDDJJProducto()\"\n                    >\n                        <i class=\"fa fa-search\"></i> Ver DDJJ PDF\n                    </button>\n                </div>\n                <!-- PARA CERTIFICACION SELLO HECHO EN BOLIVIA -->\n                <div style=\"margin-bottom: 30px;\">\n                    <div class=\"alert alert-warning container-cshb {{$ctrl.ts === 'PLATA' ? 'silver' : $ctrl.ts === 'ORO' ? 'gold' : 'bronce'}}\">\n                        <label class=\"tgl\" title=\"Contenido de origen nacional\">\n                            <input type=\"checkbox\" disabled ng-model=\"$ctrl.cshb\"/>\n                            <span class=\"tgl_body\" style=\"cursor:default;\">\n                            <span class=\"tgl_switch\"></span>\n                            <span class=\"tgl_track\">\n                                <span class=\"tgl_bgd\"></span>\n                                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n                            </span>\n                            </span>\n                        </label>\n                        <div style=\"padding-left: 10px; width: 430px;\">Contenido de origen nacional</div>\n                        <div class=\"indicator\">\n                            <div style=\"font-size: 20px;\"><strong>{{$ctrl.prod.indice}}%</strong></div>\n                            <div ng-if=\"$ctrl.ts === 'ORO' || $ctrl.ts === 'PLATA' || $ctrl.ts === 'BRONCE'\">\n                                <strong>SELLO TIPO {{$ctrl.ts}}</strong>\n                            </div>\n                            <div ng-if=\"$ctrl.ts === 'BRONCE'\">\n                                <button\n                                    style=\"margin-top: 10px\"\n                                    md-effect class=\"btn btn-primary btn-md btn-block\"\n                                    ng-click=\"$ctrl.changeTipoSHB()\" >\n                                    <i class=\"fa fa-edit\"></i> Cambiar tipo\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!--  PARA CERTIFICACIONES DE COSTO BRUTO -->\n                <div ng-if=\"$ctrl.isTipo('COSTO_BRUTO') && false\">\n                    <div class=\"alert {{$ctrl.insumoNacional? 'alert-success':'alert-warning'}}\">\n                        <label class=\"tgl\" title=\"{{$ctrl.insumoNacional? 'Observar':'Aprobar'}}\">\n                            <input type=\"checkbox\"  ng-model=\"$ctrl.insumoNacional\"/>\n                            <span class=\"tgl_body\">\n                            <span class=\"tgl_switch\"></span>\n                            <span class=\"tgl_track\">\n                                <span class=\"tgl_bgd\"></span>\n                                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n                            </span>\n                            </span>\n                        </label>\n                        <strong>Insumos Nacionales. </strong>\n                        <span ng-if=\"$ctrl.prod.insumos.length>0\"> {{$ctrl.nombres_insumos_nacionales}}</span>\n                        <span ng-if=\"$ctrl.prod.insumos.length==0\"> No tiene</span>\n                    </div>\n                    <div class=\"alert {{$ctrl.van? 'alert-success':'alert-warning'}}\" ng-if=\"$ctrl.prod.indice>30\">\n                        <label class=\"tgl\" title=\"{{$ctrl.van? 'Observar':'Aprobar'}}\">\n                            <input type=\"checkbox\" ng-model=\"$ctrl.van\"/>\n                            <span class=\"tgl_body\">\n                            <span class=\"tgl_switch\"></span>\n                            <span class=\"tgl_track\">\n                                <span class=\"tgl_bgd\"></span>\n                                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n                            </span>\n                            </span>\n                        </label>\n                        <span ng-if=\"$ctrl.prod.indice>50\">\n                            <strong>C.O.N. = {{$ctrl.prod.indice}}% &nbsp;&nbsp;</strong> {{$ctrl.prod.indice}}% >= 50%\n                        </span>\n                        <span ng-if=\" 30<=$ctrl.prod.indice && $ctrl.prod.indice<=50 \">\n                            <strong>C.O.N. = {{$ctrl.prod.indice}}% &nbsp;&nbsp;</strong> 30% < {{$ctrl.prod.indice}}% < 50%\n                            <br />\n                            <strong>I.N. = {{$ctrl.prod.ins}}% &nbsp;&nbsp;</strong>  > 18%\n                        </span>\n                    </div>\n                    <div class=\"alert {{$ctrl.van? 'alert-success':'alert-warning'}}\" ng-if=\"!($ctrl.prod.indice>30)\">\n                        <!-- <label class=\"tgl\" title=\"{{$ctrl.van? 'Observar':'Aprobar'}}\">\n                            <input type=\"checkbox\"  ng-model=\"$ctrl.van\"/>\n                            <span class=\"tgl_body\">\n                            <span class=\"tgl_switch\"></span>\n                            <span class=\"tgl_track\">\n                                <span class=\"tgl_bgd\"></span>\n                                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n                            </span>\n                            </span>\n                        </label> -->\n                        <span> <strong>C.O.N. = {{$ctrl.prod.indice}}% &nbsp;&nbsp;</strong> {{$ctrl.prod.indice}}% <  30%</span>\n                    </div>\n                </div>\n\n                <!--  PARA CERTIFICACIONES DE BIEN PRODUCIDO -->\n                <div ng-if=\"$ctrl.isTipo('BIEN_PRODUCIDO') && false\">\n                    <div class=\"alert {{$ctrl.insumoNacional? 'alert-success':'alert-warning'}}\">\n                        <label class=\"tgl\" title=\"{{$ctrl.insumoNacional? 'Observar':'Aprobar'}}\">\n                            <input type=\"checkbox\"  ng-model=\"$ctrl.insumoNacional\"/>\n                            <span class=\"tgl_body\">\n                            <span class=\"tgl_switch\"></span>\n                            <span class=\"tgl_track\">\n                                <span class=\"tgl_bgd\"></span>\n                                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n                            </span>\n                            </span>\n                        </label>\n                        <strong>Materias primas de Origen Nacional.</strong>\n                        <span ng-if=\"$ctrl.prod.insumos.length>0\"> {{$ctrl.nombres_insumos_nacionales}}</span>\n                        <span ng-if=\"$ctrl.prod.insumos.length==0\"> No tiene </span>\n                    </div>\n                    <div class=\"alert {{$ctrl.van? 'alert-success':'alert-warning'}}\">\n                        <label class=\"tgl\" title=\"{{$ctrl.van? 'Observar':'Aprobar'}}\">\n                            <input type=\"checkbox\"  ng-model=\"$ctrl.van\"/>\n                            <span class=\"tgl_body\">\n                            <span class=\"tgl_switch\"></span>\n                            <span class=\"tgl_track\">\n                                <span class=\"tgl_bgd\"></span>\n                                <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n                            </span>\n                            </span>\n                        </label>\n                        <span ng-if=\"$ctrl.prod.insumos.length>0\">\n                            <strong> V.A.N. = {{$ctrl.prod.indice}}% &nbsp;&nbsp;</strong> {{$ctrl.prod.indice}}% >= 40%\n                        </span>\n                        <span ng-if=\"$ctrl.prod.insumos.length==0\">\n                            <strong> V.A.N. = {{$ctrl.prod.indice}}% &nbsp;&nbsp;</strong> {{$ctrl.prod.indice}}% >= 50%\n                        </span>\n                    </div>\n                </div>\n\n\n            </div>\n            <div style=\"text-align: right\">\n                <button type=\"button\" md-effect class=\"btn btn-default\" ng-click=\"$ctrl.volver()\">\n                  <i class=\"fa fa-arrow-left\"></i> Ir a bandeja\n                </button>\n                <button uib-tooltip=\"Observar el documento\" tooltip-placement=\"top\"  md-effect  class=\"btn btn-danger\" ng-click=\"$ctrl.rechazar()\">\n                    <i class=\"fa fa-hand-pointer-o\"></i> Rechazar\n                </button>\n                <button uib-tooltip=\"Observar el documento\" tooltip-placement=\"top\"  md-effect  class=\"btn btn-warning\" ng-click=\"$ctrl.observar()\">\n                    <i class=\"fa fa-comment-o\"></i> Observar\n                </button>\n                <button uib-tooltip=\"Ver certificado de aprobación\" tooltip-placement=\"top\" md-effect  class=\"btn btn-primary\" ng-click=\"$ctrl.aprobar()\"\n                        ng-disabled=\" !($ctrl.ddjjProducto)\">\n                    <i class=\"fa fa-check\"></i> Aprobar\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-comment-o\"></i>&nbsp;{{$ctrl.data.titulo}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<form name=\"form\" ng-submit=\"$ctrl.ok()\">\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label for=\"textaObs\">{{$ctrl.data.detalle_campo}}</label>\n      <textarea class=\"form-control\" id=\"textaObs\" rows=\"3\" maxlength=\"1000\" ng-model=\"$ctrl.observacion\" required ></textarea>\n      <span ng-if=\"$ctrl.observacion.length > 0\" style=\"font-size:12px;\">Cantidad {{$ctrl.observacion.length}} de 1000</span>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Cambiar a tipo plata\n    </button>\n  </div>\n</form>\n"

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-comment-o\"></i>&nbsp;{{$ctrl.data.titulo}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<form name=\"form\" ng-submit=\"$ctrl.ok()\">\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label for=\"textaObs\">{{$ctrl.data.detalle_campo}}</label>\n      <textarea class=\"form-control\" id=\"textaObs\" rows=\"3\" maxlength=\"1500\" ng-model=\"$ctrl.observacion\" required ></textarea>\n      <span ng-if=\"$ctrl.observacion.length > 0\" style=\"font-size:12px;\">Cantidad {{$ctrl.observacion.length}} de 1500</span>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Aceptar\n    </button>\n  </div>\n</form>\n"

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Solicitudes de aprobación de productos</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <crud-table url=\"$ctrl.solicitudes.url\"\n                query-extra=\"$ctrl.solicitudes.queryExtra\"\n                data=\"$ctrl.solicitudes.data\"\n                fields=\"$ctrl.solicitudes.fields\"\n                permission=\"$ctrl.solicitudes.permission\"\n                buttons=\"$ctrl.solicitudes.buttons\"\n                fks=\"$ctrl.solicitudes.fks\"\n                update=\"$ctrl.solicitudes.update\"\n                clases=\"$ctrl.solicitudes.clases\"\n                ng-if=\"$ctrl.solicitudes\" \n                hidden-fields=\"$ctrl.solicitudes.hiddenFields\">\n            </crud-table>\n            <br />\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\">\n  <i class=\"fa fa-line-chart\"></i> Historial\n  </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <section>\n    <page-timeline ng-model=\"$ctrl.Tiempos\" hidden-field=\"usuario\"></page-timeline>\n  </section>\n</div>\n"

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Aprobación de certificados</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <div>\n              <button\n                uib-tooltip=\"Observar el documento\"\n                tooltip-placement=\"top\"\n                md-effect  class=\"btn btn-warning\"\n                ng-click=\"$ctrl.atras()\">\n                <i class=\"fa fa-reply\"></i> Atrás\n              </button>\n            </div>\n            <div class=\"card-block\">\n              <section>\n                <form name=\"form\" novalidate>\n                  <section>\n                    <header class=\"header-section\">Datos generales</header>\n                    <div class=\"row my-3\">\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>Razon social:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.razon_social}}</div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"row my-3\">\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>Producto:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.nombre_producto}}</div>\n                        </div>\n                      </div>\n                    </div>\n                  </section>\n                  <section id=\"deposito-tramite\">\n                    <header class=\"header-section\">Datos del depósito</header>\n                    <div class=\"row my-3\">\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>Banco:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.deposito.nombreBanco}}</div>\n                        </div>\n                      </div>\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>Cuenta:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.deposito.cuenta}}</div>\n                        </div>\n                      </div>\n                    </div>\n                    <div class=\"row my-3\">\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>Código boleta:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.deposito.codigo_deposito}}</div>\n                        </div>\n                      </div>\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>Fecha depósito:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.deposito.fecha_deposito | date:'dd/MM/yyyy'}}</div>\n                        </div>\n                      </div>\n                    </div>\n                  </section>\n                  <section>\n                    <header class=\"header-section\">Datos de factura</header>\n                    <div class=\"row my-3\">\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>Razón social:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.factura.nombre_razon_social}}</div>\n                        </div>\n                      </div>\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>NIT/CI:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.factura.nit}}</div>\n                        </div>\n                      </div>\n                      <div class=\"col\">\n                        <div class=\"control-group\">\n                          <label>Total a facturar:</label>\n                          <div class=\"text-read\">{{$ctrl.solicitud.factura.monto}}</div>\n                        </div>\n                      </div>\n                    </div>\n                  </section>\n                  <section ng-if=\"$ctrl.solicitud.certificacion_pago_estado == 'ENVIADO'\">\n                    <header class=\"header-section\">Factura (Bs.)</header>\n                    <div class=\"row\">\n                      <div class=\"col\">\n                        <div class=\"control-group\" ng-class=\"{ 'has-danger': (form.numero_autorizacion.$touched || form.$submitted) && form.numero_autorizacion.$invalid }\">\n                          <label class=\"ap-req\" for=\"numero_autorizacion\">Número de Autorización</label>\n                          <input type=\"text\" class=\"form-control\" name=\"numero_autorizacion\" ng-model=\"$ctrl.numero_autorizacion\" ng-required='$ctrl.requiredFields'>\n                          <div ng-messages=\"form.numero_autorizacion.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.numero_autorizacion.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </div>\n                      <div class=\"col\">\n                        <div class=\"control-group\" ng-class=\"{ 'has-danger': (form.numero_factura.$touched || form.$submitted) && form.numero_factura.$invalid }\">\n                          <label class=\"ap-req\" for=\"numero_factura\">Número de factura</label>\n                          <input type=\"text\" class=\"form-control\" name=\"numero_factura\" ng-model=\"$ctrl.numero_factura\" ng-required='$ctrl.requiredFields'/>\n                          <div ng-messages=\"form.numero_factura.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.numero_factura.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </div>\n                      <div class=\"col\">\n                        <div class=\"control-group\" ng-class=\"{ 'has-danger': (form.fecha_factura.$touched || form.$submitted) && form.fecha_factura.$invalid }\">\n                          <label class=\"ap-req\" for=\"fecha_factura\">Fecha de facturación</label>\n                          <div class=\"input-group\">\n                            <input type=\"text\" class=\"form-control\" uib-datepicker-popup name=\"fecha_factura\" ng-model=\"$ctrl.fecha_factura\" is-open=\"$ctrl.opened\" datepicker-options=\"$ctrl.dateOptions\" ng-required='$ctrl.requiredFields'/>\n                            <span class=\"input-group-btn\">\n                              <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.opened = !$ctrl.opened\"><i class=\"fa fa-calendar\"></i></button>\n                            </span>\n                          </div>\n                          <div ng-messages=\"form.fecha_factura.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.fecha_factura.$touched\">\n                            <div ng-message=\"required\">La fecha es requerida</div>\n                            <div ng-message=\"date\">No es una fecha válida</div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </section>\n                  <br/>\n                  <div class=\"row\" ng-if=\"$ctrl.solicitud.certificacion_pago_estado == 'ENVIADO'\">\n                    <div class=\"col-6 hidden-sm-down\"></div>\n                    <div class=\"col-6\" style=\"text-align:right;\">\n                      <button md-effect class=\"btn btn-danger\"  ng-click=\"$ctrl.rechazar()\">\n                        <i class=\"fa fa-hand-pointer-o\"></i> Rechazar\n                      </button>\n                      <button md-effect class=\"btn btn-primary\"  ng-click=\"$ctrl.aprobar(form)\">\n                          <i class=\"fa fa-check\"></i> Aprobar\n                      </button>\n                    </div>\n                  </div>\n                </form>\n              </section>\n\n              <br/>\n              <section>\n                <uib-tabset active=\"active\">\n                  <uib-tab>\n                    <uib-tab-heading>\n                      <i class=\"fa fa-file-pdf-o\"></i> Declaración Jurada\n                    </uib-tab-heading>\n                    <div>\n                      <div style=\"padding-left: 20px\" ng-if=\"$ctrl.ddjjPdf\">\n                        <iframe ng-src=\"{{$ctrl.ddjjPdf}}\" style=\"width:100%; height:550px;\" frameborder=\"0\">\n                          <p>Su navegador no soporta iframe</p>\n                        </iframe>\n                      </div>\n                    </div>\n                  </uib-tab>\n                </uib-tabset>\n              </section>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-comment-o\"></i> {{$ctrl.data.titulo}}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<form name=\"form\" ng-submit=\"$ctrl.ok()\">\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label for=\"textaObs\">{{$ctrl.data.detalle_campo}}</label>\n      <textarea class=\"form-control\" id=\"textaObs\" rows=\"3\" maxlength=\"1000\" ng-model=\"$ctrl.observacion\" required ></textarea>\n      <span ng-if=\"$ctrl.observacion.length > 0\" style=\"font-size:12px;\">Cantidad {{$ctrl.observacion.length}} de 1000</span>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Aceptar\n    </button>\n  </div>\n</form>\n"

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Solicitudes de Certificación de Sello Hecho en Bolivia</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <crud-table url=\"$ctrl.solicitudes.url\"\n                query-extra=\"$ctrl.solicitudes.queryExtra\"\n                data=\"$ctrl.solicitudes.data\"\n                fields=\"$ctrl.solicitudes.fields\"\n                permission=\"$ctrl.solicitudes.permission\"\n                buttons=\"$ctrl.solicitudes.buttons\"\n                fks=\"$ctrl.solicitudes.fks\"\n                update=\"$ctrl.solicitudes.update\"\n                clases=\"$ctrl.solicitudes.clases\"\n                ng-if=\"$ctrl.solicitudes\"\n                hidden-fields=\"$ctrl.solicitudes.hiddenFields\">\n            </crud-table>\n            <br />\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Trámites concluidos</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <crud-table url=\"$ctrl.solicitudes.url\"\n                query-extra=\"$ctrl.solicitudes.queryExtra\"\n                data=\"$ctrl.solicitudes.data\"\n                fields=\"$ctrl.solicitudes.fields\"\n                permission=\"$ctrl.solicitudes.permission\"\n                buttons=\"$ctrl.solicitudes.buttons\"\n                fks=\"$ctrl.solicitudes.fks\"\n                update=\"$ctrl.solicitudes.update\"\n                clases=\"$ctrl.solicitudes.clases\"\n                ng-if=\"$ctrl.solicitudes\" \n                hidden-fields=\"$ctrl.solicitudes.hiddenFields\">\n            </crud-table>\n            <br />\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Solicitud de certificados Promueve</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <crud-table url=\"$ctrl.solicitudes.url\"\n                query-extra=\"$ctrl.solicitudes.queryExtra\"\n                data=\"$ctrl.solicitudes.data\"\n                fields=\"$ctrl.solicitudes.fields\"\n                permission=\"$ctrl.solicitudes.permission\"\n                buttons=\"$ctrl.solicitudes.buttons\"\n                checks=\"$ctrl.solicitudes.checks\"\n                fks=\"$ctrl.solicitudes.fks\"\n                update=\"$ctrl.solicitudes.update\"\n                clases=\"$ctrl.solicitudes.clases\"\n                ng-if=\"$ctrl.solicitudes\"\n                hidden-fields=\"$ctrl.solicitudes.hiddenFields\">\n            </crud-table>\n            <br />\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Solicitud de Autorización de  Sello Hecho en Bolivia</h2>\n    <!-- <div class=\"alert alert-info\">\n        <i class=\"fa fa-info-circle\"></i>\n        <span>\n          Tipo de Certificado\n        </span>\n        <ol>\n           <li>Tipo 1: Elemento identificador de la producción nacional.</li>\n           <li>Tipo 2: Elemento identificador de la producción nacional, certificación de materia prima y mano de obra Boliviana.</li>\n       </ol>\n    </div> -->\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <crud-table url=\"$ctrl.solicitudes.url\"\n                data=\"$ctrl.solicitudes.data\"\n                fields=\"$ctrl.solicitudes.fields\"\n                permission=\"$ctrl.solicitudes.permission\"\n                buttons=\"$ctrl.solicitudes.buttons\"\n                fks=\"$ctrl.solicitudes.fks\"\n                update=\"$ctrl.solicitudes.update\"\n                clases=\"$ctrl.solicitudes.clases\"\n                ng-if=\"$ctrl.solicitudes\"\n                no-sorting=\"$ctrl.noSorting\"\n                hidden-fields=\"$ctrl.solicitudes.hiddenFields\">\n            </crud-table>\n            <br />\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa  fa-fort-awesome \"></i> Autorización Sello Hecho en Bolivia</h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <!-- <div class=\"alert alert-primary\">\n        <span aria-hidden=\"true\"></span>\n        <span><strong>{{$ctrl.data.tipo}} - {{$ctrl.data.formulario.nombre}}</strong></span>\n      </div> -->\n      <!-- <div class=\"alert alert-primary\" ng-show=\"$ctrl.isEstado('PENDIENTE')\" >\n        <i class=\"fa fa-info-circle\"></i>\n        Haga clic en aprobar si verifico los datos del producto\n      </div> -->\n      <!-- <div class=\"mb-3\">\n        <button type=\"button\" md-effect class=\"btn\" ng-class=\"{'btn-default':$ctrl.urls.sw, 'btn-warning':!$ctrl.urls.sw}\" ng-click=\"$ctrl.changePdf()\" ng-disabled=\"!$ctrl.urls.sw\">\n          <i class=\"fa fa-file-pdf-o\"></i> PDF producto\n        </button>\n        <button type=\"button\" md-effect class=\"btn\" ng-class=\"{'btn-default':!$ctrl.urls.sw, 'btn-warning':$ctrl.urls.sw}\" ng-click=\"$ctrl.changePdf()\" ng-disabled=\"$ctrl.urls.sw\">\n          <i class=\"fa fa-file-pdf-o\"></i> PDF certificado\n        </button>\n      </div> -->\n      <!-- TEMP DS4505  REMOVE -->\n      <!-- <div class=\"row\">\n        <div class=\"col-sm-3\">\n          <div class=\"form-group\">\n            <label>Seleccionar CAEB: </label>\n          </div>\n        </div>\n        <div class=\"col-sm-9\">\n          <div class=\"form-group\">\n            <div>\n              <i class=\"fa fa-search\"></i>\n              <small>Filtrar subclase</small>\n            </div>\n            <ui-select ng-model=\"$ctrl.caeb.selected\" theme=\"bootstrap\" title=\"{{$select.selected.descripcion}}\"\n                        on-select = \"$ctrl.asignarCaeb($select.selected)\"\n                        ng-disabled=\"$ctrl.data.ddjj_estado !== 'PENDIENTE'\"\n                        reset-search-input=\"false\">\n              <ui-select-match placeholder=\"Seleccione o busque un item...\" >{{$select.selected.codigo}} - {{$select.selected.descripcion}}</ui-select-match>\n              <ui-select-choices repeat=\"item in $ctrl.listadoCaeb track by $index\"\n                                  refresh=\"$ctrl.refreshResult($select.search)\"\n                                  refresh-delay=\"0\">\n                <span style=\"font-weight: bold;\" ng-bind-html=\"(item.codigo + ' - ' + item.descripcion) | highlight: $select.search\"></span>\n                <br/><small ng-bind-html=\"(item.padre.padre.padre.padre.codigo + ' - ' + item.padre.padre.padre.padre.descripcion) | highlight: $select.search\"></small>\n                <br/><small ng-bind-html=\"(item.padre.padre.padre.codigo + ' - ' + item.padre.padre.padre.descripcion) | highlight: $select.search\"></small>\n                <br/><small ng-bind-html=\"(item.padre.padre.codigo + ' - ' + item.padre.padre.descripcion) | highlight: $select.search\"></small>\n                <br/><small ng-bind-html=\"(item.padre.codigo + ' - ' + item.padre.descripcion) | highlight: $select.search\"></small>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n      </div>\n      <div style=\"margin-bottom: 10px\">\n        <div class=\"card\" ng-if=\"$ctrl.caeb.selected\" >\n          <div class=\"card-block\">\n            <h4 class=\"card-title\">CAEB</h4>\n            <div style=\"font-size: 0.85rem; line-height: 0.6\">\n              <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Sección: </label>  {{$ctrl.caeb.selected.padre.padre.padre.padre.codigo}}-{{$ctrl.caeb.selected.padre.padre.padre.padre.descripcion}}</p>\n              <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">División: </label>  {{$ctrl.caeb.selected.padre.padre.padre.codigo}}-{{$ctrl.caeb.selected.padre.padre.padre.descripcion}}</p>\n              <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Grupo: </label> {{$ctrl.caeb.selected.padre.padre.codigo}}-{{$ctrl.caeb.selected.padre.padre.descripcion}}</p>\n              <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">Clase: </label>  {{$ctrl.caeb.selected.padre.codigo}}-{{$ctrl.caeb.selected.padre.descripcion}}</p>\n              <p class=\"mt-0 pb-1 mb-2\"><label class=\"label-primary\">SubClase: </label>  {{$ctrl.caeb.selected.codigo}}-{{$ctrl.caeb.selected.descripcion}}</p>\n            </div>\n          </div>\n        </div>\n      </div> -->\n\n      <div style=\"width:100%; height:550px;background-color: #f4f4f4; margin-bottom:10px;\">\n          <!-- <span class=\"login-message\"><a href=\"\" ng-click=\"$ctrl.descargarCertificado()\" class=\"text-success\"> <i class=\"fa fa-download\"></i> Descargar certificado</a></span> -->\n          <iframe ng-src=\"{{$ctrl.iframe_url}}\" style=\"width:100%; height:550px;\" frameborder=\"0\" ng-if=\"$ctrl.iframe_url\">\n            <p>Su navegador no soporta iframe</p>\n          </iframe>\n          <div ng-if=\"!$ctrl.iframe_url\" style=\"padding:20px;\">La declaración jurada no existe o no tiene permisos para visualizarlo.</div>\n      </div>\n      <div class=\"text-right\">\n        <button type=\"button\" md-effect class=\"btn btn-default\" ng-click=\"$ctrl.volver()\">\n          <i class=\"fa fa-arrow-left\"></i> Ir a bandeja\n        </button>\n        <button uib-tooltip=\"Rechazar la solicitud\" md-effect  class=\"btn btn-danger\" ng-click=\"$ctrl.observar(1)\" ng-if=\"$ctrl.isEstado('PENDIENTE')\">\n          <i class=\"fa fa-hand-pointer-o\"></i> Rechazar\n        </button>\n        <button uib-tooltip=\"Observar la solicitud\" md-effect  class=\"btn btn-warning\" ng-click=\"$ctrl.observar()\"ng-if=\"$ctrl.isEstado('PENDIENTE')\">\n          <i class=\"fa fa-comment-o\"></i> Observar\n        </button>\n        <!-- <button uib-tooltip=\"Siguiente Paso\" tooltip-placement=\"top\" md-effect  class=\"btn btn-primary\" ng-click=\"$ctrl.siguiente()\"\n                ng-if=\"$ctrl.data.estado === 'PENDIENTE_PAGO' || $ctrl.data.estado === 'PAGADO' || $ctrl.data.estado === 'APROBADO'\">\n          <i class=\"fa fa-arrow-right\"></i> Siguiente\n        </button> -->\n        <button uib-tooltip=\"Aprobar declaración\" md-effect class=\"btn btn-primary\" ng-click=\"$ctrl.aprobar()\" ng-if=\"$ctrl.isEstado('PENDIENTE')\">\n          <i class=\"fa fa-check\"></i> Aprobar\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-comment-o\"></i>  {{$ctrl.data.accion? 'Rechazar': 'Observar' }}  </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n\n<form name=\"form\" ng-submit=\"$ctrl.ok()\">\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label for=\"textaObs\">Ingresar observación:</label>\n      <textarea class=\"form-control\" maxlength=\"300\" id=\"textaObs\" rows=\"3\" ng-model=\"$ctrl.observacion\" required ></textarea>\n    </div>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\" >\n      <i class=\"fa fa-close\"></i>Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\" ng-disabled=\"form.$invalid\" >\n      <i class=\"fa fa-check\"></i> Aceptar\n    </button>\n  </div>\n</form>\n"

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Solicitud de certificados sello Hecho en Bolivia Pendientes</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <crud-table url=\"$ctrl.solicitudes.url\"\n                query-extra=\"$ctrl.solicitudes.queryExtra\"\n                data=\"$ctrl.solicitudes.data\"\n                fields=\"$ctrl.solicitudes.fields\"\n                permission=\"$ctrl.solicitudes.permission\"\n                buttons=\"$ctrl.solicitudes.buttons\"\n                checks=\"$ctrl.solicitudes.checks\"\n                fks=\"$ctrl.solicitudes.fks\"\n                update=\"$ctrl.solicitudes.update\"\n                clases=\"$ctrl.solicitudes.clases\"\n                ng-if=\"$ctrl.solicitudes\" \n                hidden-fields=\"$ctrl.solicitudes.hiddenFields\">\n            </crud-table>\n            <br />\n        </div>\n    </div>\n</div>"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\r\n  <h5 class=\"modal-title\">\r\n    <i class=\"fa fa-user\"></i>\r\n    {{$ctrl.tituloPagina}} </h5>\r\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div class=\"modal-body\">\r\n\r\n  <div class=\"card-block\">\r\n    <div id='datoPersonales' ng-hide=\"$ctrl.items.esEdicion\">\r\n      <div class=\"alert alert-info\" >\r\n        <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\r\n        <i class=\"fa fa-user\"></i>\r\n        Datos Personales\r\n      </div>\r\n      <div>\r\n        <documento-identidad-contrastacion ng-model=\"$ctrl.data.usuario\" conf=\"$ctrl.conf.rep\" only-ci=\"true\"></documento-identidad-contrastacion>\r\n      </div>\r\n    </div>\r\n    <div class=\"alert alert-info\" >\r\n      <!--<span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>-->\r\n      <i class=\"fa fa-forward\"></i>\r\n      Datos de Cuenta de Usuario\r\n    </div>\r\n    <div class=\"row\">\r\n      <!-- <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label for=\"usuario\">Nombre de Usuario:</label>\r\n          <input type=\"text\" class=\"form-control\" id=\"usuario\" placeholder=\"Usuario\" ng-model=\"$ctrl.usuario.usuario\" required ng-readonly=\"$ctrl.items.esEdicion\">\r\n        </div>\r\n      </div> -->\r\n      <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label for=\"email\">Correo electrónico:</label>\r\n          <input class=\"form-control\" id=\"email\" placeholder=\"Correo electrónico\" ng-model=\"$ctrl.usuario.email\" required ng-readonly=\"$ctrl.items.esEdicion && $ctrl.usuario.estado != 'PENDIENTE'\">\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label>Tipo de Usuario:</label>\r\n          <select class=\"form-control\" ng-model=\"$ctrl.usuario.fid_rol\">\r\n            <option ng-repeat=\"rol in $ctrl.roles\" ng-value=\"rol.id_rol\">  {{rol.nombre}} </option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-4\" ng-if=\"$ctrl.usuario.id_usuario && $ctrl.usuario.estado !== 'PENDIENTE' && $ctrl.usuario.id_usuario !== 1\">\r\n        <div class=\"form-group\">\r\n          <label>Estado del Usuario:</label>\r\n          <select class=\"form-control\" ng-model=\"$ctrl.usuario.estado\">\r\n            <option ng-repeat=\"estado in $ctrl.estados\" ng-value=\"estado\">  {{estado}} </option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-4\">\r\n      </div>\r\n      <div class=\"col-sm-4\">\r\n\r\n      </div>\r\n      <div class=\"col-sm-4\">\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\r\n    <i class=\"fa fa-close\"></i> Cerrar\r\n  </button>\r\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.ok()\">\r\n    <i class=\"fa fa-check\"></i>\r\n    {{ $ctrl.items.esEdicion? 'Editar':  'Guardar'}}\r\n  </button>\r\n</div>\r\n"

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Usuarios <strong>del sistema</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-primary\" md-effect ng-click=\"$ctrl.add()\" type=\"button\" uib-tooltip=\"Agregar nuevo registro\" ><i class=\"fa fa-plus\"></i> Agregar</button>\n          <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n        </div>\n      </div>\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\" >\n        <table  class=\"table table-striped table-hover\">\n          <tr ng-repeat=\"user in $data\">\n            <td title=\"'Acciones'\">\n              <button uib-tooltip=\"Editar\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.verEditar(user)\"  >\n                <i class=\"fa fa-edit\"></i>\n              </button>\n\n              <button uib-tooltip=\"Reenviar correo de activación\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.reenviarCorreo(user)\" ng-show=\"user.estado === 'PENDIENTE'\" >\n                <i class=\"fa fa-send-o\"></i>\n              </button>\n            </td>\n            <!--          <td title=\"'Nombre'\" filter=\"{ 'nombres': 'text'}\" sortable=\"'user.persona.nombres'\">\n                        {{user.persona.nombres}}\n                      </td>-->\n            <td title=\"'Nombre'\" >\n              {{user.persona.nombres}}\n            </td>\n            <td title=\"'Primer Apellido'\" >\n              {{user.persona.primer_apellido}}\n            </td>\n            <td title=\"'Segundo Apellido'\" >\n              {{user.persona.segundo_apellido}}\n            </td>\n            <!-- <td title=\"'Usuario'\" >\n              {{user.usuario}}\n            </td> -->\n            <td title=\"'Correo Electrónico'\" >\n              {{user.email}}\n            </td>\n            \n            <td title=\"'Rol'\" >\n               <div ng-repeat=\"rol in user.usuarios_roles\"> {{rol.nombre}} </div>\n<!--              {{user.usuarios_roles.rol.nombre}}-->\n            </td>\n            <td title=\"'Estado'\" >\n              {{user.estado}}\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Declaraciones juradas para la inscripción de proveedores - <strong>Segundo Aguinaldo</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n        </div>\n      </div>\n      <div class=\"flex form-group\" uib-tooltip=\"Filtrar datos por departamento, NIT, matrícula, razón social, representante legal o CI\">\n        <input name=\"filtro\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.filtro_bandeja\" placeholder=\"Filtrar datos...\" ng-change=\"$ctrl.changeFilter()\">\n      </div>\n      <!--<crud-table buttons=\"$ctrl.buttons\" permission=\"$ctrl.permission\" url=\"$ctrl.url\" edit-modal-controller=\"$ctrl.editModalController\">-->\n      <!--</crud-table>-->\n\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\">\n        <table class=\"table table-condensed table-striped table-hover\">\n          <tr ng-repeat=\"item in $data\">\n            <td data-title=\"'Acciones'\" >\n              <button uib-tooltip=\"Editar\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.editar(item)\" ng-show=\"(item.certificacion.estado === 'NUEVO' || item.certificacion.estado === 'OBSERVADO')\" >\n                <i class=\"fa fa-edit\"></i>\n              </button>\n              <button uib-tooltip=\"Eliminar\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.eliminar(item)\" ng-show=\"(item.certificacion.estado === 'NUEVO' || item.certificacion.estado === 'OBSERVADO')\" >\n                <i class=\"fa fa-trash\"></i>\n              </button>\n              <button uib-tooltip=\"Pedir duplicado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.duplicar(item)\"\n                      ng-show=\"(   item.certificacion.vigente === true  && item.certificacion.estado !=='ANULADO' && item.certificacion.duplicado !== 'false')\" >\n                <i class=\"fa fa-copy\"></i>\n              </button>\n              <button uib-tooltip=\"Ver reporte\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.verPdfTabla(item)\" ng-show=\"item.certificacion.estado !== 'NUEVO'\" >\n                <i class=\"fa fa-file-pdf-o\"></i>\n              </button>\n              <!-- <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.veCertificadoTabla(item)\"\n                      ng-show=\"item.certificacion.estado === 'APROBADO' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA'\"\n                      > -->\n              <button uib-tooltip=\"Editar productos\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.editarProductos(item)\" ng-show=\"item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' && (item.certificacion.estado === 'APROBADO' || item.certificacion.estado === 'APROBADO_PENDIENTE' || item.certificacion.estado === 'PRODUCTOS_OBSERVADOS')\" >\n                <i class=\"fa fa-list\"></i>\n              </button>\n              <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.veCertificadoTabla(item)\"\n                      ng-show=\"(item.certificacion.estado === 'APROBADO' && item.certificacion.estado_firma === 'FIRMADO' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA') ||\n                               (item.certificacion.estado === 'APROBADO' && item.certificacion.estado_firma === 'NO REQUIERE' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA')\"\n                      >\n                      <i class=\"fa fa-file\"></i>\n              </button>\n            \n\n              <button uib-tooltip=\"Ingresar datos de depósito\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.datosPago(item)\"\n                      ng-show=\"item.certificacion.estado === 'PENDIENTE_PAGO' && $ctrl.isTieneNit\"  >\n                <i class=\"fa fa-money\"></i>\n              </button>\n            </td>\n            <td data-title=\"'Nro.'\"> {{(($ctrl.tableParams.page()-1) * $ctrl.tableParams.count()) + ($index+1)}}</td>\n            <td data-title=\"'Departamento'\">\n              {{ item.unidad_productiva.ubicaciones[0].departamento.descripcion}}\n            </td>\n            <td data-title=\"'Grupo'\">\n              {{ $ctrl.procesar(item.certificacion.formulario.nombre)}}\n\n            </td>\n            <td data-title=\"'Tipo'\">\n              {{ item.certificacion.tipo}}\n            </td>\n            <td data-title=\"'NIT/Matrícula'\">\n              <span ng-if=\"item.unidad_productiva.nit || item.unidad_productiva.matricula_comercio\">\n                {{ item.unidad_productiva.nit}}<br>\n                {{ item.unidad_productiva.matricula_comercio}}\n              </span>\n              <span ng-if=\"!item.unidad_productiva.nit && !item.unidad_productiva.matricula_comercio\">\n                <i>No tiene</i>\n              </span>\n            </td>\n            <td data-title=\"'Razón Social'\">\n              {{ item.unidad_productiva.razon_social}}\n            </td>\n            <td data-title=\"'Fecha'\">\n              {{ item.certificacion._fecha_creacion |  date:'dd/MM/yyyy' }}\n            </td>\n            <td data-title=\"'Representante Legal/CI'\">\n              {{item.unidad_productiva.hist_representantes.nombre_completo}}  {{item.unidad_productiva.hist_representantes.documento_identidad}}\n            </td>\n            <td data-title=\"'Estado'\" >\n\n              <span class=\"badge\n                    {{item.certificacion.estado ==='ENVIADO'? 'badge-primary':\n                  (item.certificacion.estado ==='APROBADO'? 'badge-success' : ( item.certificacion.estado ==='PENDIENTE_PAGO'? 'badge-warning' :\n                  (item.certificacion.estado.indexOf('OBSERVADO') !== -1 ? 'badge-danger' : ( item.certificacion.estado ==='PAGADO'? 'badge-default' : 'badge-default'))))}}\n              \">\n              {{item.certificacion.estado}}\n              </span>\n              <small ng-if=\"item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' && item.certificacion.estado.indexOf('APROBADO') !== -1\">\n                <br>\n                <strong ng-if=\"item.certificacion.estado === 'APROBADO'\">\n                  <i class=\"fa fa-shopping-cart\"></i> Productos aprobados\n                </strong>\n                <strong class=\"text-danger\" ng-if=\"item.certificacion.estado.indexOf('APROBADO_') !== -1\">\n                  <i class=\"fa fa-shopping-cart\"></i> Productos pendientes de aprobación\n                </strong>\n              </small>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Bandeja <strong>de documentos</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n        </div>\n      </div>\n      <div class=\"flex form-group\" uib-tooltip=\"Filtrar datos por departamento, NIT, matrícula, razón social, representante legal o CI\">\n        <input name=\"filtro\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.filtro_bandeja\" placeholder=\"Filtrar datos...\" ng-change=\"$ctrl.changeFilter()\">\n      </div>\n      <!--<crud-table buttons=\"$ctrl.buttons\" permission=\"$ctrl.permission\" url=\"$ctrl.url\" edit-modal-controller=\"$ctrl.editModalController\">-->\n      <!--</crud-table>-->\n\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\">\n        <table class=\"table table-condensed table-striped table-hover\">\n          <tr ng-repeat=\"item in $data\">\n            <td data-title=\"'Acciones'\" >\n              <button uib-tooltip=\"Editar\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.editar(item)\" ng-show=\"(item.certificacion.estado === 'NUEVO' || item.certificacion.estado === 'OBSERVADO')\" >\n                <i class=\"fa fa-edit\"></i>\n              </button>\n              <button uib-tooltip=\"Eliminar\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.eliminar(item)\" ng-show=\"(item.certificacion.estado === 'NUEVO' || item.certificacion.estado === 'OBSERVADO')\" >\n                <i class=\"fa fa-trash\"></i>\n              </button>\n              <button uib-tooltip=\"Pedir duplicado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.duplicar(item)\"\n                      ng-show=\"(   item.certificacion.vigente === true  && item.certificacion.estado !=='ANULADO' && item.certificacion.duplicado !== 'false')\" >\n                <i class=\"fa fa-copy\"></i>\n              </button>\n              <button uib-tooltip=\"Ver reporte\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.verPdfTabla(item)\" ng-show=\"item.certificacion.estado !== 'NUEVO'\" >\n                <i class=\"fa fa-file-pdf-o\"></i>\n              </button>\n              <!-- <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.veCertificadoTabla(item)\"\n                      ng-show=\"item.certificacion.estado === 'APROBADO' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA'\"\n                      > -->\n              <button uib-tooltip=\"Editar productos/servicios\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.editarProductos(item)\" ng-show=\"item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO'  && (item.certificacion.estado === 'APROBADO' || item.certificacion.estado === 'APROBADO_PENDIENTE' || item.certificacion.estado === 'PRODUCTOS_OBSERVADOS')\" ng-if=\"item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO'\">\n                <i class=\"fa fa-list\"></i>\n              </button>\n              <button uib-tooltip=\"Editar productos\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.editarProductos(item)\" ng-show=\"item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' && (item.certificacion.estado === 'APROBADO' || item.certificacion.estado === 'APROBADO_PENDIENTE' || item.certificacion.estado === 'PRODUCTOS_OBSERVADOS')\" ng-if=\"item.certificacion.formulario.tipo !== 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO'\">\n                <i class=\"fa fa-list\"></i>\n              </button>\n              <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.veCertificadoTabla(item)\"\n                      ng-show=\"(item.certificacion.estado === 'APROBADO' && item.certificacion.estado_firma === 'FIRMADO' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA') ||\n                               (item.certificacion.estado === 'APROBADO' && item.certificacion.estado_firma === 'NO REQUIERE' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA')\"\n                      >\n                      <i class=\"fa fa-file\"></i>\n              </button>\n            \n\n              <button uib-tooltip=\"Ingresar datos de depósito\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.datosPago(item)\"\n                      ng-show=\"item.certificacion.estado === 'PENDIENTE_PAGO' && $ctrl.isTieneNit\"  >\n                <i class=\"fa fa-money\"></i>\n              </button>\n            </td>\n            <td data-title=\"'Nro.'\"> {{(($ctrl.tableParams.page()-1) * $ctrl.tableParams.count()) + ($index+1)}}</td>\n            <td data-title=\"'Departamento'\">\n              {{ item.unidad_productiva.ubicaciones[0].departamento.descripcion}}\n            </td>\n            <td data-title=\"'Grupo'\">\n              {{ $ctrl.procesar(item.certificacion.formulario.nombre)}}\n\n            </td>\n            <td data-title=\"'Tipo'\">\n              {{ item.certificacion.tipo}}\n            </td>\n            <td data-title=\"'NIT/Matrícula'\">\n              <span ng-if=\"item.unidad_productiva.nit || item.unidad_productiva.matricula_comercio\">\n                {{ item.unidad_productiva.nit}}<br>\n                {{ item.unidad_productiva.matricula_comercio}}\n              </span>\n              <span ng-if=\"!item.unidad_productiva.nit && !item.unidad_productiva.matricula_comercio\">\n                <i>No tiene</i>\n              </span>\n            </td>\n            <td data-title=\"'Razón Social'\">\n              {{ item.unidad_productiva.razon_social}}\n            </td>\n            <td data-title=\"'Fecha'\">\n              {{ item.certificacion._fecha_creacion |  date:'dd/MM/yyyy' }}\n            </td>\n            <td data-title=\"'Representante Legal/CI'\">\n              {{item.unidad_productiva.hist_representantes.nombre_completo}}  {{item.unidad_productiva.hist_representantes.documento_identidad}}\n            </td>\n            <td data-title=\"'Estado'\" >\n\n              <span class=\"badge\n                    {{item.certificacion.estado ==='ENVIADO'? 'badge-primary':\n                  (item.certificacion.estado ==='APROBADO'? 'badge-success' : ( item.certificacion.estado ==='PENDIENTE_PAGO'? 'badge-warning' :\n                  (item.certificacion.estado.indexOf('OBSERVADO') !== -1 ? 'badge-danger' : ( item.certificacion.estado ==='PAGADO'? 'badge-default' : 'badge-default'))))}}\n              \">\n              {{item.certificacion.estado}}\n              </span>\n              <small ng-if=\"(item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO' || item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO') && item.certificacion.estado.indexOf('APROBADO') !== -1\">\n                <br>\n                <strong ng-if=\"item.certificacion.estado === 'APROBADO'\">\n                  <i class=\"fa fa-shopping-cart\"></i> Productos aprobados\n                </strong>\n                <strong class=\"text-danger\" ng-if=\"item.certificacion.estado.indexOf('APROBADO_') !== -1\">\n                  <i class=\"fa fa-shopping-cart\"></i> Productos pendientes de aprobación\n                </strong>\n              </small>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Declaraciones juradas para la inscripción de proveedores -  <small><strong>Pago de refrigerio.</strong></small></h2>\n    <div class=\"card\">\n      <div class=\"card-block\">\n        <div class=\"d-flex justify-content-between\">\n          <div class=\"btn-container p-2\">\n            <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n          </div>\n        </div>\n        <div class=\"flex form-group\" uib-tooltip=\"Filtrar datos por departamento, NIT, matrícula, razón social, representante legal o CI\">\n          <input name=\"filtro\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.filtro_bandeja\" placeholder=\"Filtrar datos...\" ng-change=\"$ctrl.changeFilter()\">\n        </div>\n        <!--<crud-table buttons=\"$ctrl.buttons\" permission=\"$ctrl.permission\" url=\"$ctrl.url\" edit-modal-controller=\"$ctrl.editModalController\">-->\n        <!--</crud-table>-->\n  \n        <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\">\n          <table class=\"table table-condensed table-striped table-hover\">\n            <tr ng-repeat=\"item in $data\">\n              <td data-title=\"'Acciones'\" >\n                <button uib-tooltip=\"Editar\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.editar(item)\" ng-show=\"(item.certificacion.estado === 'NUEVO' || item.certificacion.estado === 'OBSERVADO')\" >\n                  <i class=\"fa fa-edit\"></i>\n                </button>\n                <button uib-tooltip=\"Eliminar\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.eliminar(item)\" ng-show=\"(item.certificacion.estado === 'NUEVO' || item.certificacion.estado === 'OBSERVADO')\" >\n                  <i class=\"fa fa-trash\"></i>\n                </button>\n                <button uib-tooltip=\"Pedir duplicado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.duplicar(item)\"\n                        ng-show=\"(   item.certificacion.vigente === true  && item.certificacion.estado !=='ANULADO' && item.certificacion.duplicado !== 'false')\" >\n                  <i class=\"fa fa-copy\"></i>\n                </button>\n                <button uib-tooltip=\"Ver reporte\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.verPdfTabla(item)\" ng-show=\"item.certificacion.estado !== 'NUEVO'\" >\n                  <i class=\"fa fa-file-pdf-o\"></i>\n                </button>\n                <!-- <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.veCertificadoTabla(item)\"\n                        ng-show=\"item.certificacion.estado === 'APROBADO' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA'\"\n                        > -->\n                <button uib-tooltip=\"Editar productos/Servicios\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.editarProductos(item)\" ng-show=\"item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO' && (item.certificacion.estado === 'APROBADO' || item.certificacion.estado === 'APROBADO_PENDIENTE' || item.certificacion.estado === 'PRODUCTOS_OBSERVADOS')\" >\n                  <i class=\"fa fa-list\"></i>\n                </button>\n                <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.veCertificadoTabla(item)\"\n                        ng-show=\"(item.certificacion.estado === 'APROBADO' && item.certificacion.estado_firma === 'FIRMADO' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA') ||\n                                 (item.certificacion.estado === 'APROBADO' && item.certificacion.estado_firma === 'NO REQUIERE' && item.certificacion.formulario.tipo === 'UNIDAD_PRODUCTIVA')\"\n                        >\n                        <i class=\"fa fa-file\"></i>\n                </button>\n              \n  \n                <button uib-tooltip=\"Ingresar datos de depósito\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.datosPago(item)\"\n                        ng-show=\"item.certificacion.estado === 'PENDIENTE_PAGO' && $ctrl.isTieneNit\"  >\n                  <i class=\"fa fa-money\"></i>\n                </button>\n              </td>\n              <td data-title=\"'Nro.'\"> {{(($ctrl.tableParams.page()-1) * $ctrl.tableParams.count()) + ($index+1)}}</td>\n              <td data-title=\"'Departamento'\">\n                {{ item.unidad_productiva.ubicaciones[0].departamento.descripcion}}\n              </td>\n              <td data-title=\"'Grupo'\">\n                {{ $ctrl.procesar(item.certificacion.formulario.nombre)}}\n  \n              </td>\n              <td data-title=\"'Tipo'\">\n                {{ item.certificacion.tipo}}\n              </td>\n              <td data-title=\"'NIT/Matrícula'\">\n                <span ng-if=\"item.unidad_productiva.nit || item.unidad_productiva.matricula_comercio\">\n                  {{ item.unidad_productiva.nit}}<br>\n                  {{ item.unidad_productiva.matricula_comercio}}\n                </span>\n                <span ng-if=\"!item.unidad_productiva.nit && !item.unidad_productiva.matricula_comercio\">\n                  <i>No tiene</i>\n                </span>\n              </td>\n              <td data-title=\"'Razón Social'\">\n                {{ item.unidad_productiva.razon_social}}\n              </td>\n              <td data-title=\"'Fecha'\">\n                {{ item.certificacion._fecha_creacion |  date:'dd/MM/yyyy' }}\n              </td>\n              <td data-title=\"'Representante Legal/CI'\">\n                {{item.unidad_productiva.hist_representantes.nombre_completo}}  {{item.unidad_productiva.hist_representantes.documento_identidad}}\n              </td>\n              <td data-title=\"'Estado'\" >\n  \n                <span class=\"badge\n                      {{item.certificacion.estado ==='ENVIADO'? 'badge-primary':\n                    (item.certificacion.estado ==='APROBADO'? 'badge-success' : ( item.certificacion.estado ==='PENDIENTE_PAGO'? 'badge-warning' :\n                    (item.certificacion.estado.indexOf('OBSERVADO') !== -1 ? 'badge-danger' : ( item.certificacion.estado ==='PAGADO'? 'badge-default' : 'badge-default'))))}}\n                \">\n                {{item.certificacion.estado}}\n                </span>\n                <small ng-if=\"item.certificacion.formulario.tipo === 'PROVEEDOR_NACIONAL_PAGO_REFRIGERIO' && item.certificacion.estado.indexOf('APROBADO') !== -1\">\n                  <br>\n                  <strong ng-if=\"item.certificacion.estado === 'APROBADO'\">\n                    <i class=\"fa fa-shopping-cart\"></i> Productos aprobados\n                  </strong>\n                  <strong class=\"text-danger\" ng-if=\"item.certificacion.estado.indexOf('APROBADO_') !== -1\">\n                    <i class=\"fa fa-shopping-cart\"></i> Productos pendientes de aprobación\n                  </strong>\n                </small>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  \n  </div>\n  \n\n "

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-user\"></i> Certificados</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <div class=\"alert alert-info\">\n                <i class=\"fa fa-info-circle\"></i> Estos son sus certificados\n            </div>\n            <div class=\"card-container text-center\">\n                <div class=\"card\" ng-repeat=\"certificado in $ctrl.certificados\">\n                    <div class=\"card-img-top badge-info\">\n                        <div class=\"img-form\"></div>\n                    </div>\n                    <div class=\"card-block\">\n                        <h4 class=\"card-title text-center\">{{ certificado.nombre }}</h4>\n                        <!-- <p>{{ certificado.nombre }}</p> -->\n                        <button md-effect class=\"btn btn-primary btn-block btn-lg\" ng-click=\"$ctrl.seleccionar(certificado)\" type=\"button\">\n                            <i class=\"fa fa-check-circle\"></i> Seleccionar\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Duplicar <strong>certificación</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <div class=\"d-flex justify-content-between\">\n        <div class=\"btn-container p-2\">\n          <button class=\"btn btn-default\" md-effect type=\"button\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"Actualizar tabla\"><i class=\"fa fa-refresh\"></i></button>\n        </div>\n      </div>\n      <div class=\"flex form-group\" uib-tooltip=\"Filtrar datos por departamento, NIT, matrícula, razón social, representante legal o CI\">\n        <input name=\"filtro\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.filtro_bandeja\" placeholder=\"Filtrar datos...\" ng-change=\"$ctrl.changeFilter()\">\n      </div>\n      <!--<crud-table buttons=\"$ctrl.buttons\" permission=\"$ctrl.permission\" url=\"$ctrl.url\" edit-modal-controller=\"$ctrl.editModalController\">-->\n      <!--</crud-table>-->\n      <div class=\"table-responsive\" ng-table=\"$ctrl.tableParams\">\n        <table class=\"table table-condensed table-striped table-hover\">\n          <tr ng-repeat=\"item in $data\">\n            <td data-title=\"'Acciones'\" >\n              <button uib-tooltip=\"Pedir duplicado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.duplicar(item)\"  >\n                <i class=\"fa fa-copy\"></i>\n              </button>\n<!--              <button uib-tooltip=\"Ver certificado\" md-effect class=\"btn btn-default\"  ng-click=\"$ctrl.veCertificadoTabla(item)\" >\n                <i class=\"fa fa-file\"></i>\n              </button>-->\n            </td>\n            <td data-title=\"'Nro.'\"> {{(($ctrl.tableParams.page()-1) * $ctrl.tableParams.count()) + ($index+1)}}</td>\n            <td data-title=\"'Departamento'\">\n              {{ item.unidad_productiva.ubicaciones[0].departamento.descripcion}}\n            </td>\n            <td data-title=\"'Grupo'\">\n              {{ $ctrl.procesar(item.certificacion.formulario.nombre)}}\n            </td>\n            <td data-title=\"'Tipo'\">\n              {{ item.certificacion.tipo}}\n            </td>\n            <td data-title=\"'NIT/Matrícula'\">\n              <span ng-if=\"item.unidad_productiva.nit || item.unidad_productiva.matricula_comercio\">\n                {{ item.unidad_productiva.nit}}<br>\n                {{ item.unidad_productiva.matricula_comercio}}\n              </span>\n              <span ng-if=\"!item.unidad_productiva.nit && !item.unidad_productiva.matricula_comercio\">\n                <i>No tiene</i>\n              </span>\n            </td>\n            <td data-title=\"'Razón Social'\">\n              {{ item.unidad_productiva.razon_social}}\n            </td>\n            <td data-title=\"'Fecha'\">\n              {{ item.certificacion._fecha_creacion |  date:'dd/MM/yyyy' }}\n            </td>\n            <td data-title=\"'Representante Legal/CI'\">\n              {{item.unidad_productiva.hist_representantes.nombre_completo}}  {{item.unidad_productiva.hist_representantes.documento_identidad}}\n            </td>\n            <td data-title=\"'Estado'\" >\n\n              <span class=\"badge\n                    {{item.certificacion.estado ==='ENVIADO'? 'badge-primary':\n                  (item.certificacion.estado ==='APROBADO'? 'badge-success' : ( item.certificacion.estado ==='PENDIENTE_PAGO'? 'badge-warning' :\n                  (item.certificacion.estado ==='OBSERVADO'? 'badge-danger' : ( item.certificacion.estado ==='PAGADO'? 'badge-default' : 'badge-default'))))}}\n              \">\n              {{item.certificacion.estado}}\n              </span>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title mb-2\"><i class=\"fa fa-trello icon-color\"></i> Formulario de Declaración Jurada para el registro de Acreditación Nacional</h2>\n  <div class=\"card card-main m-4\" style=\"background-color: rgb(255, 255, 250);\">\n    <div class=\"card-header bg-info\" ng-if=\"$ctrl.matricula\">\n      MATRÍCULA: {{ $ctrl.matricula.matricula}} - {{ $ctrl.matricula.razon_social}}\n    </div>\n    <div class=\"card-block\">\n      <div class=\"alert alert-warning\">\n        <i class=\"fa fa-info-circle\"></i> Seleccione un formulario de acuerdo al <strong>tipo</strong> de <strong>Declaración Jurada</strong> que necesite.\n      </div>\n      <div class=\"alert alert-info-second\" ng-if=\"!$ctrl.esAguinaldo && !$ctrl.esRefrigerio\">\n        <i class=\"fa fa-info-circle\"></i> Recuerde realizar el depósito bancario del costo del trámite en Banco Unión. <strong><a href=\"\" ng-click=\"$ctrl.verTablaCostos()\">Ver tabla de costos</a></strong>\n      </div>\n      <div class=\"alert alert-danger\" ng-if=\"$ctrl.show_actualizar_matricula\">\n        <i class=\"fa fa-info-circle\"></i> No se pudieron obtener sus matrículas de comercio, es probable que deba realizar una actualización de sus matrículas correspondientes.\n      </div>\n      <div class=\"card-container text-center\">\n        <div class=\"card shadow-sm rounded\" ng-repeat=\"formulario in $ctrl.formularios\">\n          <div class=\"card-img-top badge-refrigerio\">\n            <div ng-class=\"formulario.id_formulario === 9 ? 'img-form-aguinaldo' : formulario.id_formulario === 10 ? 'img-form-refrigerio': 'img-form'\"></div>\n          </div>\n          <div class=\"card-block\" ng-class=\"formulario.id_formulario === 9 ? 'card-aguinaldo mb-5 mb-sm-0' : formulario.id_formulario === 10 ? 'card-refrigerio mb-5 mb-sm-0':'card-refrigerio'\">\n            <h4 class=\"card-title text-center text-primary text-formulario\">{{ formulario.nombre}}</h4>\n            <!-- <p>{{ formulario.nombre }}</p> -->\n\n            <!--<small> <i class=\"fa fa-file-pdf-o\"></i> Manual de Usuario</small>-->\n            <span><a href=\"\" ng-click=\"$ctrl.descargarManual(formulario.tipo)\" ng-if=\"formulario.id_formulario != 10\" class=\"text-primary\" title=\"Descargar manual de usuario para: {{formulario.nombre}}\"><small> <i class=\"fa fa-file-pdf-o\"></i> Manual de Usuario</small></a></span>\n          </div>\n          <button md-effect class=\"btn btn-block btn-lg\" ng-class=\"'btn-' + formulario.color\" ng-click=\"$ctrl.seleccionarOpcion(formulario)\" type=\"button\">\n            <i class=\"fa fa-check-circle\"></i> Seleccionar\n          </button>\n        </div>\n      </div>\n      <div class=\"btn-container text-right\" ng-if=\"$ctrl.show_button_back\">\n        <button md-effect class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.atras()\">\n          <i class=\"fa fa-angle-double-left\"></i> Volver a matrículas\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-money\"></i> Tabla de costos</h5>\n</div>\n<div class=\"modal-body\"> \n  <div>\n    <p>\n      El depósito deberá realizarse a la cuenta <strong>Nº {{$ctrl.nroCuenta}}</strong> del <strong>Banco Unión</strong>.\n    </p>\n    <p>Estas tarifas corresponden únicamente a nuevos registros.</p>\n\n    <p>\n      El costo para la renovación del certificado es del 50% de la tarifa actual, siempre y cuando las Unidades Productivas lo soliciten dentro de la vigencia de su certificado. Sólo aplicable para Micro y Pequeñas empresas (MYPES).  \n    </p>\n  </div>\n  <table class=\"table table-striped table-hover table-bordered\"  style=\"display: block; width: 100%\" >\n    <tbody style=\" height: 300px; display: inline-block; width: 100%; overflow: auto;\">\n      <tr>\n        <th style=\"width: 20%\" class=\"text-ce<div class=\"modal-header\">\n          <h5 class=\"modal-title\"><i class=\"fa fa-money\"></i> Tabla de costos</h5>\n        </div>\n        <div class=\"modal-body\"> \n          <div>\n            <p>\n              El depósito deberá realizarse a la cuenta <strong>Nº {{$ctrl.nroCuenta}}</strong> del <strong>Banco Unión</strong>.\n            </p>\n            <p>Estas tarifas corresponden únicamente a nuevos registros.</p>\n        \n            <p>\n              El costo para la renovación del certificado es del 50% de la tarifa actual, siempre y cuando las Unidades Productivas lo soliciten dentro de la vigencia de su certificado. Sólo aplicable para Micro y Pequeñas empresas (MYPES).  \n            </p>\n          </div>\n          <table class=\"table table-striped table-hover table-bordered\"  style=\"display: block; width: 100%\" >\n            <tbody style=\" height: 300px; display: inline-block; width: 100%; overflow: auto;\">\n              <tr>\n                <th style=\"width: 20%\" class=\"text-center\">Tipo</th>\n                <th style=\"width: 60%\" class=\"text-center\">Categoria</th>\n                <th style=\"width: 20%\" class=\"text-center\">Monto (Bs.)</th>\n              </tr>\n              <tr ng-repeat=\"escala in $ctrl.escalas\" ng-if=\"escala.monto > 0\">\n                <td style=\"width: 20%\" scope=\"row\"> {{escala.tipo}}</td>\n                <td style=\"width: 60%\">\n                  {{escala.categoria}} {{escala.formulario.tipo==='UNIDAD_PRODUCTIVA'? 'EMPRESA':''}} <br/>\n                  <small>{{escala.par_tipo_societario.nombre}}</small>\n                  <small>{{escala.subtipo}}</small>\n                </td>\n                <td style=\"width: 20%\" class=\"text-right\">{{escala.monto}}&nbsp;&nbsp;</td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div class=\"modal-footer\">\n          <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n            <i class=\"fa fa-close\"></i> Cerrar\n          </button>\n        </div>\n        nter\">Tipo</th>\n        <th style=\"width: 60%\" class=\"text-center\">Categoria</th>\n        <th style=\"width: 20%\" class=\"text-center\">Monto (Bs.)</th>\n      </tr>\n      <tr ng-repeat=\"escala in $ctrl.escalas\" ng-if=\"escala.monto > 0\">\n        <td style=\"width: 20%\" scope=\"row\"> {{escala.tipo}}</td>\n        <td style=\"width: 60%\">\n          {{escala.categoria}} {{escala.formulario.tipo==='UNIDAD_PRODUCTIVA'? 'EMPRESA':''}} <br/>\n          <small>{{escala.par_tipo_societario.nombre}}</small>\n          <small>{{escala.subtipo}}</small>\n        </td>\n        <td style=\"width: 20%\" class=\"text-right\">{{escala.monto}}&nbsp;&nbsp;</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n    <i class=\"fa fa-close\"></i> Cerrar\n  </button>\n</div>\n"

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\"><i class=\"fa fa-info\"></i>  &nbsp; Seleccionar Opción</h5>\n</div>\n<div class=\"modal-body\">\n\n  <div class=\"control-label\">    \n    ¿Qué desea realizar?\n  </div>\n\n\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n    <i class=\"fa fa-close\"></i> Cerrar\n  </button>\n  <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.renovacion()\" ng-if=\"$ctrl.items.fid_formulario !== 10 && $ctrl.items.fid_formulario !== 9\">\n    <i class=\"fa fa-repeat\"></i> Renovación\n  </button>\n  <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.nuevo()\" >\n    <i class=\"fa fa-check\"></i> Nuevo Registro\n  </button>\n</div>\n"

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><samp style=\"font-size: 30px\"> <i class=\"fa fa-angle-double-right\"></i> </samp> &nbsp; Seleccionar Opción</h5>\n  </div>\n  <div class=\"modal-body\">\n  \n    <div class=\"control-label\" style=\"font-size: 17px;\">\n    ¿Usted quiere recuperar su declaración realizada en el Doble Aguinaldo para la Inscripción Proveedores - Refrigerio? <p></p>\n      \n    </div>\n  \n  \n  </div>\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel1()\">\n        <i class=\"fa fa-close\"></i> Cerrar \n      </button>\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.nuevo1()\">\n      <i class=\"fa fa-close\"></i> No Recuperar\n    </button>\n    <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.recuperar2()\">\n      <i class=\"fa fa-check\"></i> Recuperar\n    </button>\n  </div>\n                                                                                                                            \n\n\n  "

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-shield\"></i> Código de activación</h5>\n</div>\n<form ng-submit=\"$ctrl.confirmar()\" name=\"form\">\n    <div class=\"modal-body\">\n        <p class=\"text-justify text-primary\">Acabamos de enviarle un <strong>CÓDIGO DE ACTIVACIÓN</strong> al correo electrónico <strong>{{ $ctrl.correo }}</strong>, ingrese al mismo <strong>copie</strong> o <strong>escriba</strong> su código de activación aquí para completar su registro.</p>\n        <div class=\"form-group row justify-content-center\">\n            <div class=\"col-sm-8\">\n                <input type=\"text\" class=\"form-control text-center\" id=\"codigo-activacion\" ng-focus=\"true\" name=\"codigo\" ng-model=\"$ctrl.codigo_activacion\" required placeholder=\"Escriba su código de activación aquí\" focus-me=\"{{ $ctrl.focus }}\" maxlength=\"5\"  minlength=\"5\" alpha-numeric trim-paste autocomplete=\"off\">\n            </div>\n        </div>\n        <!-- <div class=\"alert alert-info\">\n            <i class=\"fa fa-info-circle\"></i> Este correo electrónico le servirá para recibir las distintas <strong>notificaciones</strong> que la plataforma le enviará.\n        </div> -->\n        <div class=\"alert alert-warning\">\n            <i class=\"fa fa-exclamation-triangle\"></i> El correo puede demorar unos minutos en llegar a su bandeja de entrada.\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n            <i class=\"fa fa-close\"></i> Cancelar registro\n        </button>\n        <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"form.$invalid\">\n            <i class=\"fa fa-check\"></i> Confirmar código\n        </button>\n    </div>\n</form>"

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container inscripcion\">\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <div class=\"alert alert-info\">\n                <i class=\"fa fa-info-circle\"></i> Ingrese o confirme la dirección de correo electrónico para continuar con su registro.\n            </div>\n            <form ng-submit=\"$ctrl.registrar()\" name=\"form\">\n                <div class=\"form-group\" ng-class=\"{ 'has-danger': form.correo.$touched && form.correo.$invalid }\">\n                    <label for=\"email-emp\"><strong>*</strong> Correo electrónico</label>\n                    <div class=\"input-group mb-2 mr-sm-2 mb-sm-0\">\n                        <div class=\"input-group-addon\"><i class=\"fa fa-envelope-o\"></i></div>\n                        <input type=\"email\" name=\"correo\" ng-model=\"$ctrl.correo\" class=\"form-control\" id=\"email-emp\" maxlength=\"100\" aria-describedby=\"emailHelp\" placeholder=\"Escriba su correo electrónico aquí\" required focus-if>\n                    </div>\n                    <div ng-messages=\"form.correo.$error\" class=\"form-error\" role=\"alert\">\n                        <div ng-message=\"email\">No es un correo electrónico válido</div>\n                    </div>\n                </div>\n                <label class=\"custom-control custom-checkbox inscripcion-terminos\">\n                    <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"$ctrl.terminos\" required>\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\">Acepto los <a href=\"\" ng-click=\"$ctrl.verTerminos()\">Términos y condiciones</a> de uso de la plataforma.</span>\n                </label>\n                <div class=\"text-right\">\n                    <button md-effect class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"form.$invalid\">\n                        <i class=\"fa fa-check\"></i> Continuar\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-shield\"></i> Términos y Condiciones del sistema</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <h2 class=\"text-center\">Términos y condiciones del servicio en línea</h2>\n    <p>La implementación del servicio en línea, tiene la finalidad de digitalizar el Registro y Acreditación de Unidades Productivas para facilitar la realización de trámites al sector productivo. Los documentos generados a partir del uso del Sistema son <strong>oficiales y válidos para todo efecto legal que corresponda.</strong> </p>\n\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n</div>\n"

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-user\"></i> Matrículas</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <div class=\"alert alert-info\">\n                <i class=\"fa fa-info-circle\"></i> Seleccione una matrícula de comercio\n            </div>\n            <div class=\"card-container\">\n                <div class=\"card\" ng-repeat=\"matricula in $ctrl.matriculas\">\n                    <div class=\"card-img-top badge-info\">\n                        <div class=\"img-empresa\"></div> <strong>MATRÍCULA: <br> <span>{{ matricula.matricula }}</span></strong>\n                    </div>\n                    <div class=\"card-block\">\n                        <h4 class=\"card-title\">{{ matricula.razon_social }}</h4>\n                    </div>\n                    <button md-effect type=\"button\" ng-click=\"$ctrl.seleccionar(matricula)\" class=\"btn btn-primary btn-block btn-lg\">\n                        <i class=\"fa fa-check-circle\"></i> Registrar\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-gavel\"></i> Declaración Jurada</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<form name=\"form\" ng-submit=\"$ctrl.ok()\">\n    <div ng-if=\"$ctrl.items.tipo_formulario !== 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO'\"> <!-- INICIO-->\n\n    <div class=\"modal-body\" ng-if=\"$ctrl.user.id_rol == 4\">\n        <div class=\"alert alert-info text-justify\">\n            <i class=\"fa fa-info-circle\"></i> En el transcurso de los siguientes {{$ctrl.items.numero_dias}} días hábiles, se le enviará un correo electrónico\n            para confirmarle el monto del depósito a realizar en el <strong>Banco Unión</strong> (Cuenta en bolivianos <strong>Nro. {{$ctrl.items.cuenta_banco}}</strong>). En caso de que su trámite haya sido aprobado. Caso\n            contrario, se le informará si este fuese observado o rechazado para tomar las medidas correspondientes.\n        </div>\n        <p class=\"text-justify\">\n          En cumplimiento del Artículo 1322° del Código Civil y Art. 157° Parágrafo IV del Código Procesal Civil, sujeto en caso de inexactitud o falsedad a la cancelación del trámite de constitución y, a las penalidades\n          establecidas en el Art. 169° del Código Penal como falso testimonio, DECLARO que la información contenida en el presente formulario es fidedigna.\n        </p>\n        <p>Por tanto:</p>\n        <div class=\"text-center\">\n            <label class=\"custom-control custom-checkbox inscripcion-terminos\">\n                <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"$ctrl.declarar\" required>\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\"> Acepto y declaro la veracidad de la información presentada.\n            </label>\n        </div>\n    </div>\n    <div class=\"modal-body\" ng-if=\"$ctrl.user.id_rol == 2 || $ctrl.user.id_rol == 5\">\n      <p class=\"text-justify\">\n        Después de confirmar la declaración jurada ya no podrá realizar cambios. ¿Desea continuar?\n      </p>\n    </div>\n\n    </div> <!-- FIN -->\n    <div class=\"modal-body\" ng-if=\"$ctrl.items.tipo_formulario === 'PROVEEDOR_NACIONAL_SEGUNDO_AGUINALDO'\"> <!-- INICIO-->\n        <p class=\"text-justify\">\n            En cumplimiento del Decreto Supremo N° 3747 del 12 de diciembre de 2018, declaro lo  siguiente:\n            <ul class=\"text-justify\">\n                <li>Que la información que declaré en el formulario de inscripción de proveedor de productos hechos en Bolivia es fidedigna.</li>\n                <li>Me comprometo a garantizar que:</li>\n                <ul>\n                    <li>La cuenta bancaria registrada en el formulario este vigente y habilitada para recibir pagos.</li>\n                    <li>Efectuaré únicamente la venta de productos hechos en Bolivia al emplear los mecanismos previstos en el Decreto Supremo N° 3747 de 12 de diciembre de 2018.</li>\n                    <li>Registraré información fidedigna respecto a cada venta realizada mediante el uso de la Plataforma Segundo Aguinaldo “Esfuerzo por Bolivia”.</li>\n                </ul>\n            </ul>\n        </p>\n        <p>Por tanto:</p>\n        <div class=\"text-center\">\n            <label class=\"custom-control custom-checkbox inscripcion-terminos\">\n                <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"$ctrl.declarar\" required>\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\"> Acepto los términos expuestos en la presente declaración jurada.\n            </label>\n        </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n            <i class=\"fa fa-close\"></i> Cancelar\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"$ctrl.ok()\" >\n            <i class=\"fa fa-check\"></i> Continuar\n        </button>\n    </div>\n\n</form>\n"

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\">\n      <i class=\"fa fa-paperclip\"></i>\n      Importar archivo CSV\n    </h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body modal-importar-body\">\n  <div class=\"alert alert-info\">\n      Pasos para importar el archivo CSV\n  </div>\n  <div class=\"planilla-dialog-content\">\n    <ol class=\"\">\n        <li>\n          Descargue el <strong><i class=\"fa fa-file mr-1\"></i> archivo base</strong> haciendo\n          <strong><a href=\"{{$ctrl.url.csv}}\" target=\"_blank\" download=\"archivo_base.csv\">click aquí.</a></strong>\n        </li>\n        <li>\n          Proceda a llenar datos en el archivo proporcionado. <br/>\n          <div class=\"text-justify\">\n              <strong>Instrucciones de llenado</strong><br/>\n              <ol class=\"pl-3\" style=\"list-style: lower-alpha;\">\n                <li>Utilice siempre el archivo base proporcionado.</li>\n                <li><strong>No modifique</strong> la primera fila (cabecera).</li>\n                <li><strong>No aumente columnas</strong> solamente edite las casillas respectivas.</li>\n                <li>La columna <strong>cantidad</strong> siempre debe ser un <strong>número entero</strong> sin decimales.</li>\n                <li>La columna <strong>descripción y marca</strong> permiten valores alfanuméricos que <strong>no</strong> tengan un largo <strong>mayor a 100 caracteres</strong>.</li>\n                <li>La columna <strong>precio unitario y total</strong> permiten ingresar valores numéricos con hasta dos decimales, siendo el punto <strong>(.)</strong> el caracter de separador de decimales.</li> </ol>\n          </div>\n        </li>\n        <li><strong>Guarde</strong> el archivo en formato <strong>“.csv”</strong>  empleando como separador el símbolo <strong>tabulador</strong>.</li>\n        <li><strong>Adjunte</strong> el <strong>“archivo csv”</strong> en el área de abajo</li>\n    </ol>\n  </div>\n\n  <div class=\"planilla-dialog-content\">\n      <div class=\"alert alert-warning\">\n          <strong>Importante.-</strong> Compruebe que el archivo que desea importar <strong>NO</strong> se encuentre abierto.\n      </div>\n      <ui-file-upload url=\"$ctrl.url.importar\"\n                  name=\"archivo\"\n                  on-complete-item=\"$ctrl.csv.onCompleteItem\"\n                  types=\"|csv|CSV|\"\n                  label=\"Importar\"\n                  on-after-adding-file=\"$ctrl.onAfterAddingFile\"\n                  show-danger=\"show_danger\">\n       </ui-file-upload>\n<!--  -->\n  </div>\n</div>\n<div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n        <i class=\"fa fa-close\"></i> Cancelar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.cancel()\" ng-if=\"$ctrl.isSuccess\">\n        <i class=\"fa fa-check\"></i> Terminar\n    </button>\n</div>\n"

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\">\n    <i class=\"fa fa-paperclip\"></i>\n    Importar archivo CSV\n  </h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body modal-importar-body\">\n  <div class=\"alert alert-info\">\n    Pasos para importar el archivo CSV\n  </div>\n  <div class=\"planilla-dialog-content\">\n    <ol class=\"\">\n      <li>\n        Descargue el <strong><i class=\"fa fa-file mr-1\"></i> archivo base</strong> haciendo\n        <strong><a href=\"{{$ctrl.url.csv}}\" target=\"_blank\" download=\"archivo_base.csv\">click aquí.</a></strong>\n      </li>\n      <li>\n        Para la columna <strong>Unidad,</strong> ingrese los códigos listados a continuación:\n\n      </li>\n<p></p>\n      <table class=\"default\"; border=\"1\" align=\"center\">\n\n        <tr>\n\n          <td>Código</td>\n          <td>Descripción</td>\n        </tr>\n        <tr>\n          <td>700</td>\n          <td>Otros</td>\n        </tr>\n        <tr>\n          <td>702</td>\n          <td>Arroba</td>\n        </tr>\n        <tr>\n          <td>705</td>\n          <td>Docenas</td>\n        </tr>\n        <tr>\n          <td>710</td>\n          <td>Gramos</td>\n        </tr>\n        <tr>\n          <td>715</td>\n          <td>Kilogramos</td>\n        </tr>\n\n\n        <tr>\n          <td>725</td>\n          <td>Libras</td>\n        </tr>\n        <tr>\n          <td>730</td>\n          <td>Litros</td>\n        </tr>\n                <tr>\n          <td>765</td>\n          <td>Quintales</td>\n        </tr>\n\n        <tr><tr>\n          <td>700</td>\n          <td>Otros</td>\n        </tr>\n          <td>770</td>\n          <td>Toneladas</td>\n        </tr>\n\n      </table>\n      <p></p>\n      <li>\n        Proceda a llenar datos en el archivo proporcionado. <br />\n        <div class=\"text-justify\">\n          <strong>Instrucciones de llenado</strong><br />\n          <ol class=\"pl-3\" style=\"list-style: lower-alpha;\">\n            <li>Utilice siempre el archivo base proporcionado.</li>\n            <li><strong>No modifique</strong> la primera fila (cabecera).</li>\n            <li><strong>No aumente columnas</strong> solamente edite las casillas respectivas.</li>\n            <li>La columna <strong>cantidad</strong> siempre debe ser un <strong>número entero</strong> sin decimales.\n            </li>\n            <li>La columna <strong>descripción y marca</strong> permiten valores alfanuméricos que <strong>no</strong>\n              tengan un largo <strong>mayor a 100 caracteres</strong>.</li>\n            <li>La columna <strong>precio unitario y total</strong> permiten ingresar valores numéricos con hasta dos\n              decimales, siendo el punto <strong>(.)</strong> el caracter de separador de decimales.</li>\n          </ol>\n        </div>\n      </li>\n      <li><strong>Guarde</strong> el archivo en formato <strong>“.csv”</strong> empleando como separador el símbolo\n        <strong>tabulador</strong>.</li>\n      <li><strong>Adjunte</strong> el <strong>“archivo csv”</strong> en el área de abajo</li>\n    </ol>\n  </div>\n\n  <div class=\"planilla-dialog-content\">\n    <div class=\"alert alert-warning\">\n      <strong>Importante.-</strong> Compruebe que el archivo que desea importar <strong>NO</strong> se encuentre\n      abierto.\n    </div>\n    <ui-file-upload url=\"$ctrl.url.importar\" name=\"archivo\" on-complete-item=\"$ctrl.csv.onCompleteItem\"\n      types=\"|csv|CSV|\" label=\"Importar\" on-after-adding-file=\"$ctrl.onAfterAddingFile\" show-danger=\"show_danger\">\n    </ui-file-upload>\n    <!--  -->\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n    <i class=\"fa fa-close\"></i> Cancelar\n  </button>\n  <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.cancel()\" ng-if=\"$ctrl.isSuccess\">\n    <i class=\"fa fa-check\"></i> Terminar\n  </button>\n</div>"

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container empresa registro\">\n  <h2 class=\"page-title\"><i class=\"fa fa-file-text-o\"></i> Declaración Jurada - {{ $ctrl.form.nombre}}</h2>\n  <div class=\"card card-main\">\n    <div class=\"card-header\" ng-if=\"$ctrl.tiene_matricula\">\n      MATRÍCULA: {{ $ctrl.data.matricula}} - {{ $ctrl.data.razon_social}}\n    </div>\n    <!--<img class=\"card-img-top\" src=\"http://www.fg-a.com/wallpapers/geo-shapes-black-1280b.jpg\" height=\"50\" alt=\"Card image cap\" >-->\n    <!-- <div class=\"row\">\n      $ctrl.data.propietario_representante {{$ctrl.data.propietario_representante}}<br>\n      $ctrl.data.emp.personeria_juridica {{$ctrl.data.emp.personeria_juridica}}<br>\n    </div> -->\n    <!-- <div> -->\n    <form ng-submit=\"$ctrl.declarar(registro_form)\" name=\"registro_form\" novalidate>\n      <div class=\"card-block\">\n        <div class=\"alert alert-danger row mx-0\" ng-if=\"$ctrl.certificacion.observaciones && $ctrl.certificacion.estado == 'OBSERVADO'\">\n          <i class=\"fa fa-eye\" ap></i>\n          <span class=\"col card-overflow\" >\n            <p class=\"mb-0\">ESTA CERTIFICACIÓN SE ENCUENTRA OBSERVADA</p>\n            <p> <strong>Motivo:</strong> {{$ctrl.certificacion.observaciones}}</p>\n          </span>\n          <i class=\"fa fa-close\" ng-click=\"$ctrl.certificacion.observaciones = ''\" uib-tooltip=\"Ocultar mensaje\"></i>\n        </div>\n        <div class=\"alert alert-info-second row mx-0\" ng-if=\"$ctrl.msjs.requireds\">\n          <i class=\"fa fa-info-circle\"></i>\n          <span class=\"col\">\n            <p class=\"mb-0\" ng-bind-html=\"$ctrl.msjs.requireds\"> </p>\n          </span>\n          <i class=\"fa fa-close\" ng-click=\"$ctrl.msjs.requireds = ''\" uib-tooltip=\"Ocultar mensaje\"></i>\n        </div>\n        <section ng-if=\"$ctrl.conf.emp.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.emp.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <div class=\"row\">\n              <div class=\"col-md-8 ap-form\">\n                <ng-form name=\"empresa_form\">\n                  <div class=\"form-group\" ng-if=\"$ctrl.conf.emp.razon_social.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.emp.razon_social.requerido}\">{{$ctrl.conf.emp.razon_social.label}}:</label>\n                    <input name=\"razon_social\" maxlength=\"250\" ng-model=\"$ctrl.data.razon_social\" class=\"form-control\" ng-required=\"$ctrl.conf.emp.razon_social.requerido\" ng-disabled=\"$ctrl.conf.emp.razon_social.disabled\" ng-change=\"$ctrl.empresaUpd()\">\n                    <div ap-error ng-messages=\"empresa_form.razon_social.$error\" role=\"alert\" ng-if=\"empresa_form.razon_social.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                  <div class=\"row\" ng-show=\"$ctrl.data.nit || $ctrl.esRolTecnico()\">\n                    <!--<div class=\"col-md form-group\" ng-if=\"$ctrl.conf.emp.matricula_comercio.visible && $ctrl.user.id_rol == 4\">-->\n                      <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.emp.matricula_comercio.visible && !$ctrl.esTecnicoAguinaldo\">\n                      <label ng-class=\"{'ap-req':$ctrl.conf.emp.matricula_comercio.requerido}\">{{$ctrl.conf.emp.matricula_comercio.label}}:</label>\n                      <input name=\"matricula_comercio\" maxlength=\"50\" class=\"form-control\" ng-model=\"$ctrl.data.matricula_comercio\" ng-required=\"$ctrl.conf.emp.matricula_comercio.requerido\" ng-disabled=\"$ctrl.conf.emp.matricula_comercio.disabled\"  ng-change=\"$ctrl.empresaUpd()\">\n                      <div ap-error ng-messages=\"empresa_form.matricula_comercio.$error\" role=\"alert\" ng-if=\"empresa_form.matricula_comercio.$touched\">\n                        <div ng-message=\"required\">El campo es requerido</div>\n                      </div>\n                    </div>\n                    <!--<div class=\"col-md form-group\" ng-if=\"$ctrl.conf.emp.nit.visible && $ctrl.user.id_rol == 4\">-->\n                    <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.emp.nit.visible\">\n                      <label ng-class=\"{'ap-req':$ctrl.conf.emp.nit.requerido}\">{{$ctrl.conf.emp.nit.label}}:</label>\n                      <input name=\"nit\" max-length=\"20\" class=\"form-control\" ng-model=\"$ctrl.data.nit\" ng-required=\"$ctrl.conf.emp.nit.requerido\" ng-disabled=\"$ctrl.conf.emp.nit.disabled || $ctrl.usuario_ddjj_con_nit\"  ng-change=\"$ctrl.empresaUpd()\" numeric>\n                      <div ap-error ng-messages=\"empresa_form.nit.$error\" role=\"alert\" ng-if=\"empresa_form.nit.$touched\">\n                        <div ng-message=\"required\">El campo es requerido</div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div class=\"row ml-0\">\n                    <div class=\"col-md-12 pl-0 form-group\" ng-if=\"$ctrl.conf.emp.fid_par_tipo_societario.visible\">\n                      <select-parametro name=\"fid_par_tipo_societario\" parametro=\"TIPO_SOCIETARIO\"\n                                        filtro=\"{{!$ctrl.data.nit && !$ctrl.esRolTecnico()}}-OECA-OECOM-PERSONA_NATURAL\"\n                                        label=\"{{$ctrl.conf.emp.fid_par_tipo_societario.label}}:\"\n                                        ng-model=\"$ctrl.data.fid_par_tipo_societario\"\n                                        query=\"&fid_formulario={{$ctrl.certificacion.fid_formulario}}\"\n                                        ng-required=\"$ctrl.conf.emp.fid_par_tipo_societario.requerido\"\n                                        ng-change=\"$ctrl.empresaUpd()\"></select-parametro>\n                      <div ap-error ng-messages=\"empresa_form.fid_par_tipo_societario.$error\" role=\"alert\" ng-if=\"empresa_form.fid_par_tipo_societario.$touched\">\n                          <!-- ng-disabled=\"$ctrl.conf.emp.fid_par_tipo_societario.disabled || (!$ctrl.data.nit && $ctrl.data.ambito == 'PROBOLIVIA' && $ctrl.user.id_rol != 2)\" -->\n                        <div ng-message=\"required\">El campo es requerido</div>\n                      </div>\n                    </div>\n                    <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.emp.anios_experiencia.visible\">\n                      <label ng-class=\"{'ap-req':$ctrl.conf.emp.anios_experiencia.requerido}\">{{$ctrl.conf.emp.anios_experiencia.label}}:</label>\n                      <input name=\"anios_experiencia\" numeric maxlength=\"3\"  class=\"form-control\" ng-model=\"$ctrl.data.anios_experiencia\" ng-change=\"$ctrl.empresaUpd()\" ng-required=\"$ctrl.conf.emp.anios_experiencia.requerido\" ng-disabled=\"$ctrl.conf.emp.anios_experiencia.disabled\">\n                      <div ap-error ng-messages=\"empresa_form.anios_experiencia.$error\" role=\"alert\" ng-if=\"empresa_form.anios_experiencia.$touched\">\n                        <div ng-message=\"required\">El campo es requerido y debe ser mayor a cero</div>\n                      </div>\n                    </div>\n                    <div class=\"col-md mt-a pb-3 form-group\" ng-if=\"$ctrl.conf.emp.personeria_juridica.visible\">\n                      <label class=\"custom-control custom-checkbox\">\n                        <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"$ctrl.data.personeria_juridica\" ng-required=\"$ctrl.conf.emp.personeria_juridica.requerido\" ng-disabled=\"$ctrl.conf.emp.personeria_juridica.disabled\"  ng-change=\"$ctrl.empresaUpd()\">\n                        <span class=\"custom-control-indicator\"></span>\n                        <span class=\"custom-control-description\">{{$ctrl.conf.emp.personeria_juridica.label}}</span>\n                      </label>\n                    </div>\n                  </div>\n                  <div class=\"form-group\" ng-if=\"$ctrl.conf.emp.fid_par_tipo_organizacion.visible\">\n                    <select-parametro opcional=\"{{!$ctrl.conf.emp.fid_par_tipo_organizacion.requerido}}\" name=\"fid_par_tipo_organizacion\" parametro=\"TIPO_ORGANIZACION_AFILIADA\" label=\"{{$ctrl.conf.emp.fid_par_tipo_organizacion.label}}:\"\n                                      ng-model=\"$ctrl.data.fid_par_tipo_organizacion\" ng-required=\"$ctrl.conf.emp.fid_par_tipo_organizacion.requerido\"\n                                      query=\"&fid_formulario={{$ctrl.certificacion.fid_formulario}}\"\n                                      ng-disabled=\"$ctrl.conf.emp.fid_par_tipo_organizacion.disabled\" ng-change=\"$ctrl.empresaUpd()\"></select-parametro>\n                    <div ap-error ng-messages=\"empresa_form.fid_par_tipo_organizacion.$error\" role=\"alert\" ng-if=\"empresa_form.fid_par_tipo_organizacion.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                    <div>\n                      <input name=\"tipo_organizacion_otro\" maxlength=\"50\" class=\"form-control\"\n                             placeholder=\"Ingresar Descripción, en caso de OTROS\"\n                             ng-model=\"$ctrl.data.tipo_organizacion_otro\"\n                             ng-show=\"$ctrl.data.fid_par_tipo_organizacion === 195\" ng-if=\"($ctrl.data.fid_par_tipo_organizacion === 195)\"\n                             required=\"{{$ctrl.data.fid_par_tipo_organizacion === 195}}\"\n                             ng-change=\"$ctrl.empresaUpd()\"\n                             >\n                      <div ap-error ng-messages=\"empresa_form.tipo_organizacion_otro.$error\" role=\"alert\" ng-if=\"empresa_form.tipo_organizacion_otro.$touched\">\n                        <div ng-message=\"required\">Ingrese organización afiliada</div>\n                      </div>\n                    </div>\n                  </div>\n                </ng-form>\n              </div>\n              <div class=\"col-md-4 text-center\">\n                <div class=\"fecha-creacion bg-success\">\n                {{$ctrl.certificacion.tipo === \"RENOVACION\" ? \"RENOVACIÓN\" : $ctrl.certificacion.tipo}}\n                </div>\n                <div class=\"fecha-creacion bg-info-second\" uib-tooltip=\"Fecha de creación\"> {{$ctrl.certificacion._fecha_creacion| date:'dd/MM/yyyy'}} </div>\n                <button type=\"button\" class=\"btn btn-warning\" ng-click=\"$ctrl.masInformacion()\" ng-if=\"$ctrl.tiene_matricula\">Ver más información<br /> de la empresa</button>\n                <div class=\"alert alert-info-second mt-3 mx-3 pl-2\">\n                  <i class=\"fa fa-info-circle\" ></i>\n                  <span>Los datos se guardarán automáticamente.</span>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\">\n\n              <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.emp.sitio_web.visible\">\n                <label ng-class=\"{'ap-req':$ctrl.conf.emp.sitio_web.requerido}\">{{$ctrl.conf.emp.sitio_web.label}}:</label>\n                <input name=\"sitio_web\" class=\"form-control\" ng-model=\"$ctrl.data.sitio_web\" ng-required=\"$ctrl.conf.emp.sitio_web.requerido\" ng-disabled=\"$ctrl.conf.emp.sitio_web.disabled\"  maxlength=\"100\" ng-change=\"$ctrl.empresaUpd()\">\n                <div ap-error ng-messages=\"empresa_form.sitio_web.$error\" role=\"alert\" ng-if=\"empresa_form.sitio_web.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>\n              </div>\n              <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.emp.correo_electronico.visible\">\n                <label ng-class=\"{'ap-req':$ctrl.conf.emp.correo_electronico.requerido}\">{{$ctrl.conf.emp.correo_electronico.label}}:</label>\n                <input name=\"correo_electronico\"class=\"form-control\" ng-model=\"$ctrl.data.correo_electronico\" ng-required=\"$ctrl.conf.emp.correo_electronico.requerido\" ng-disabled=\"$ctrl.conf.emp.correo_electronico.disabled\" maxlength=\"100\"  ng-change=\"$ctrl.empresaUpd()\"\n                       ng-blur=\"$ctrl.validateMailKeyup()\" >\n                <div ap-error ng-messages=\"empresa_form.correo_electronico.$error\" role=\"alert\" ng-if=\"empresa_form.correo_electronico.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>\n                <div class=\"md-input-warning\" ng-show=\"!$ctrl.isCorreoOk\">Correo inválido</div>\n              </div>\n            </div>\n\n          </div>\n        </section>\n\n        <section class=\"ap-form\" ng-if=\"$ctrl.conf.rep.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.rep.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <ng-form name=\"representante_form\">\n              <div class=\"row ml-0\">\n                <label class=\"col-md-3 custom-control custom-radio\">\n                  <input type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.propietario_representante\" value=\"PROPIETARIO\" ng-change=\"$ctrl.representanteChange(representante_form)\" ng-disabled=\"$ctrl.conf.emp.propietario_representante.disabled\">\n                  <span class=\"custom-control-indicator\"></span>\n                  <span class=\"custom-control-description\">Propietario</span>\n                </label>\n                <label class=\"col-md-3 custom-control custom-radio\">\n                  <input type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.propietario_representante\" value=\"REPRESENTANTE\" ng-change=\"$ctrl.representanteChange(representante_form)\" ng-disabled=\"$ctrl.conf.emp.propietario_representante.disabled\">\n                  <span class=\"custom-control-indicator\"></span>\n                  <span class=\"custom-control-description\">Representante legal</span>\n                </label>\n              </div>\n              <div ng-show=\"$ctrl.axs.sw_propietario\">\n                <documento-identidad-contrastacion ng-model=\"$ctrl.data.hist_representantes\" conf=\"$ctrl.conf.rep\"></documento-identidad-contrastacion>\n              </div>\n              <div ng-show=\"!$ctrl.axs.sw_propietario\">\n                <ng-form name=\"rep_legal_form\">\n                  <div class=\"row\">\n                    <select-date class=\"col-md-5\" ng-model=\"$ctrl.data.hist_representantes.fecha_nacimiento\" label=\"Fecha de nacimiento:\" ng-required=\"$ctrl.conf.rep.fecha_nacimiento.requerido\" ng-disabled=\"$ctrl.conf.rep.fecha_nacimiento.disabled\"></select-date>\n                  </div>\n                  <div class=\"form-group\" ng-if=\"$ctrl.conf.rep.nombre_completo.visible\">\n                    <label ng-class=\"{'ap-req':$ctrl.conf.rep.nombre_completo.requerido}\">Representante legal:</label>\n                    <uib-select name=\"nombre_completo\" class=\"select_rep_legal\" ng-model=\"$ctrl.data.hist_representantes.representante\" items=\"$ctrl.get.representantes\" key-text=\"ci_nombre\" placeholder=\"Representante legal\" ng-required=\"$ctrl.conf.rep.nombre_completo.requerido\" ng-disabled=\"$ctrl.conf.rep.nombre_completo.disabled\"></uib-select>\n                    <div ap-error ng-messages=\"rep_legal_form.nombre_completo.$error\" role=\"alert\" ng-if=\"rep_legal_form.nombre_completo.$touched\">\n                      <div ng-message=\"required\">El campo es requerido</div>\n                    </div>\n                  </div>\n                </ng-form>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-md-4 form-group\">\n                  <div class=\"form-group mb-0\"><label ng-class=\"{'ap-req':$ctrl.conf.rep.genero.requerido}\">Género:</label></div>\n                  <label class=\"custom-control custom-radio\">\n                    <input name=\"genero\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.hist_representantes.genero\" value=\"M\" ng-required=\"$ctrl.conf.rep.genero.requerido\" ng-disabled=\"$ctrl.conf.rep.genero.disabled\">\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\">Masculino</span>\n                  </label>\n                  <label class=\"custom-control custom-radio\">\n                    <input name=\"genero\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.hist_representantes.genero\" value=\"F\" ng-required=\"$ctrl.conf.rep.genero.requerido\" ng-disabled=\"$ctrl.conf.rep.genero.disabled\">\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\">Femenino</span>\n                  </label>\n                  <div ap-error ng-messages=\"representante_form.genero.$error\" role=\"alert\" ng-if=\"representante_form.genero.$touched\">\n                    <div ng-message=\"required\">El género es requerido</div>\n                  </div>\n                </div>\n                <div class=\"col-md-4 form-group\" ng-if=\"$ctrl.conf.rep.telefono.visible\">\n                  <label ng-class=\"{'ap-req':$ctrl.conf.rep.telefono.requerido}\">{{$ctrl.conf.rep.telefono.label}}:</label>\n                  <input name=\"telefono\" phone minlength=\"5\" maxlength=\"25\" class=\"form-control\" ng-model=\"$ctrl.data.hist_representantes.telefono\" ng-required=\"$ctrl.conf.rep.telefono.requerido\" ng-disabled=\"$ctrl.conf.rep.telefono.disabled\">\n                  <div ap-error ng-messages=\"representante_form.telefono.$error\" role=\"alert\" ng-if=\"representante_form.telefono.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"minlength\">El número debe tener 5 o más caracteres</div>\n                    <div ng-message=\"maxlength\">El número debe tener 25 o menos caracteres</div>\n                  </div>\n                </div>\n                <div class=\"col-md-4 mt-4 pt-2 form-group\" ng-if=\"$ctrl.conf.rep.discapacidad.visible\">\n                  <label class=\"custom-control custom-checkbox\">\n                    <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"$ctrl.data.hist_representantes.discapacidad\" ng-disabled=\"$ctrl.conf.rep.discapacidad.disabled\">\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\">Persona con discapacidad</span>\n                  </label>\n                </div>\n              </div>\n            </ng-form>\n          </div>\n        </section>\n        <section class=\"ap-form\" ng-if=\"$ctrl.conf.rep_agui.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.rep_agui.sec_nombre}}</header>\n          <div class=\"body-section\" ng-if=\"$ctrl.data && $ctrl.data.id_unidad_productiva\">\n              <formulario-representante\n                conf=\"$ctrl.conf\"\n                tiene-matricula=\"$ctrl.tiene_matricula\"\n                data=\"$ctrl.data\"\n                ></formulario-representante>\n          </div>\n        </section>\n        <section class=\"ap-form\" ng-if=\"$ctrl.conf.cuenta.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.cuenta.sec_nombre}}</header>\n          <div class=\"body-section\">\n              <formulario-cuenta\n                conf=\"$ctrl.conf\"\n                data=\"$ctrl.data\">\n              </formulario-cuenta>\n          </div>\n        </section>\n         <!-- area de registro de productos-->\n        <section ng-if=\"$ctrl.conf.prod.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.prod.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <div class=\"alert alert-info-second\" ng-if=\"$ctrl.esRefrigerio\">\n              <i class=\"fa fa-info-circle\" ap></i>\n              <span ng-bind-html=\"$ctrl.msjs.act_pro_imp\"></span>\n            </div>\n            <div class=\"row\" ng-if=\"$ctrl.conf.prod.sec_visible\">\n              <div class=\"pt-1 pl-2 col-md-12\">\n                <formulario-producto\n                name=\"formulario_producto\"\n                id-certificacion=\"$ctrl.certificacion.id_certificacion\"\n                data=\"$ctrl.conf.prod\"\n                ></formulario-producto>\n                <!--<span class=\"fa fa-plus btn-c-info\" uib-tooltip=\"Registrar productos\" ng-click=\"$ctrl.productosAddUpd()\"></span>-->\n              </div>\n            </div>\n          </div>\n        </section>\n        <section ng-if=\"$ctrl.conf.cont.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.cont.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <div class=\"row\" ng-if=\"$ctrl.conf.cont.sec_visible\">\n              <div class=\"pt-1 pl-2 col-md-12 \">\n                <formulario-contacto\n                name=\"formulario_contacto\"\n                id-certificacion=\"$ctrl.certificacion.id_certificacion\"\n                data=\"$ctrl.conf.cont\"\n                ></formulario-contacto>\n                <!--<span class=\"fa fa-plus btn-c-info\" uib-tooltip=\"Registrar productos\" ng-click=\"$ctrl.productosAddUpd()\"></span>-->\n              </div>\n            </div>\n          </div>\n        </section>\n\n        <section ng-if=\"$ctrl.conf.ubi.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.ubi.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <div class=\"row\" ng-if=\"!$ctrl.conf.ubi.zona.disabled && !$ctrl.esAguinaldo\">\n              <div class=\"pt-1 pl-2\">\n                <span class=\"fa fa-plus btn-c-info\" uib-tooltip=\"Registrar nueva ubicación\" ng-click=\"$ctrl.ubicacionesAddUpd()\"></span>\n              </div>\n              <div class=\"col-md\">\n                <div class=\"alert alert-info-second\">\n                  <i class=\"fa fa-info-circle\" ap></i>\n                  <span ng-bind-html=\"$ctrl.msjs.ubi_add\"></span>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\" ng-if=\"!$ctrl.conf.ubi.zona.disabled && $ctrl.data.ubicaciones == 0 && $ctrl.esAguinaldo\">\n              <div class=\"pt-1 pl-2\">\n                <span class=\"fa fa-plus btn-c-info\" uib-tooltip=\"Registrar nueva ubicación\" ng-click=\"$ctrl.ubicacionesAddUpd()\"></span>\n              </div>\n              <div class=\"col-md\">\n                <div class=\"alert alert-info-second\">\n                  <i class=\"fa fa-info-circle\" ap></i>\n                  <span ng-bind-html=\"$ctrl.msjs.ubi_add\"></span>\n                </div>\n              </div>\n            </div>\n            <div class=\"alert alert-danger\" ng-if=\"!$ctrl.conf.ubi.zona.disabled && $ctrl.data.ubicaciones == 0 && !$ctrl.esAguinaldo\">\n              <i class=\"fa fa-info-circle\" ap></i>\n              <span ng-bind-html=\"$ctrl.msjs.ubi_req\"> </span>\n            </div>\n            <div class=\"alert alert-warning\" ng-if=\"$ctrl.esAguinaldo && $ctrl.data.ubicaciones == 0\">\n              <i class=\"fa fa-info-circle\" ap></i>\n              <span ng-bind-html=\"$ctrl.msjs.ubi_req\"></span>\n            </div>\n            <div class=\"row ubicaciones\">\n              <div class=\"col-md-4 px-0\" ng-repeat=\"item in $ctrl.data.ubicaciones\">\n                <div class=\"card\">\n                  <header class=\"card-header row\">\n                    Ubicación {{$index + 1}}\n                    <span class=\"col\"></span>\n                    <div class=\"icon-group-card-header\">\n                      <i class=\"fa fa-edit text-success\" uib-tooltip=\"Editar\" ng-click=\"$ctrl.ubicacionesAddUpd($index, item)\"></i>\n                      <i class=\"fa fa-trash text-danger\" uib-tooltip=\"Eliminar\" ng-click=\"$ctrl.ubicacionesDel($index, item)\"></i>\n                    </div>\n                  </header>\n                  <div class=\"card-block\">\n                    <div class=\"form-group\">\n                      <label>{{$ctrl.conf.ubi.fid_departamento.label}}:</label>\n                      <span>{{item.departamento.descripcion}}</span>\n                    </div>\n                    <div class=\"form-group\">\n                      <label>{{$ctrl.conf.ubi.fid_provincia.label}}:</label>\n                      <span>{{item.provincia.nombre}}</span>\n                    </div>\n                    <div class=\"form-group\">\n                      <label>{{$ctrl.conf.ubi.fid_municipio.label}}:</label>\n                      <span>{{item.municipio.nombre}}</span>\n                    </div>\n                    <div class=\"form-group\" ng-if=\"item.zona\" ng-class=\"item.zona.length > 30 ? 'card-overflow' : ''\">\n                      <label>{{$ctrl.conf.ubi.zona.label}}:</label>\n                      <span>{{item.zona}}</span>\n                    </div>\n                    <div class=\"form-group\" ng-if=\"item.avenida_calle\" ng-class=\"item.avenida_calle.length > 30 ? 'card-overflow' : ''\">\n                      <label>{{$ctrl.conf.ubi.avenida_calle.label}}:</label>\n                      <span>{{item.avenida_calle}}</span>\n                    </div>\n                    <div class=\"form-group\" ng-if=\"item.numero\">\n                      <label>{{$ctrl.conf.ubi.numero.label}}:</label>\n                      <span>{{item.numero}}</span>\n                    </div>\n                    <div class=\"form-group\" ng-if=\"item.telefonos\">\n                      <label>{{$ctrl.conf.ubi.telefono.label}}:</label>\n                      <span>{{item.telefonos.split('|').join(', ')}}</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </section>\n\n        <section ng-if=\"$ctrl.conf.act_eco.sec_visible && $ctrl.axs.init_productos\">\n          <header class=\"header-section\">{{$ctrl.conf.act_eco.sec_nombre}}</header>\n          <div class=\"body-section ap-form\">\n            <div class=\"row\" ng-if=\"$ctrl.conf.emp.tipo_actividad_economica.visible\">\n              <div class=\"col-md-4 form-group\">\n                <label ng-class=\"{'ap-req':$ctrl.conf.emp.tipo_actividad_economica.requerido}\">{{$ctrl.conf.emp.tipo_actividad_economica.label}}:</label>\n              </div>\n              <label class=\"col-md-3 custom-control custom-radio\">\n                <input name=\"tipo_actividad_economica\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.tipo_actividad_economica\" value=\"TRANSFORMACION\" ng-required=\"$ctrl.conf.emp.tipo_actividad_economica.requerido\" ng-click=\"$ctrl.empresaUpd()\" ng-disabled=\"$ctrl.conf.emp.tipo_actividad_economica.disabled\">\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">Transformación</span>\n              </label>\n              <label class=\"col-md-3 custom-control custom-radio\">\n                <input name=\"tipo_actividad_economica\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.tipo_actividad_economica\" value=\"SERVICIOS\" ng-required=\"$ctrl.conf.emp.tipo_actividad_economica.requerido\" ng-click=\"$ctrl.empresaUpd()\" ng-disabled=\"$ctrl.conf.emp.tipo_actividad_economica.disabled\">\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">Servicios</span>\n              </label>\n            </div>\n            <ng-form name=\"productos_form1\">\n              <div class=\"form-group\" ng-if=\"$ctrl.conf.act_eco.fid_par_clasificacion_artesanal.visible\">\n                <select-parametro\n                name=\"fid_par_clasificacion_artesanal\"\n                parametro=\"CLASIFICACION_ARTESANAL\"\n                label=\"{{$ctrl.conf.act_eco.fid_par_clasificacion_artesanal.label}}:\"\n                ng-model=\"$ctrl.data.producto1.fid_par_clasificacion_artesanal\"\n                ng-change=\"$ctrl.productosUpd(productos_form1, 1)\"\n                ng-required=\"$ctrl.conf.act_eco.fid_par_clasificacion_artesanal.requerido\"\n                ng-disabled=\"$ctrl.conf.act_eco.fid_par_clasificacion_artesanal.disabled\"\n                ></select-parametro>\n                <div ap-error ng-messages=\"productos_form1.fid_par_clasificacion_artesanal.$error\" role=\"alert\" ng-if=\"productos_form1.fid_par_clasificacion_artesanal.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>\n              </div>\n              <div class=\"form-group\" ng-if=\"$ctrl.conf.act_eco.descripcion_actividad.visible\">\n                <label ng-class=\"{'ap-req':$ctrl.conf.act_eco.descripcion_actividad.requerido}\">{{$ctrl.conf.act_eco.descripcion_actividad.label}}:</label>\n                <input name=\"descripcion_actividad\" maxlength=\"250\" class=\"form-control\" ng-model=\"$ctrl.data.producto1.descripcion_actividad\" ng-change=\"$ctrl.productosUpd(productos_form1, 1)\" ng-required=\"$ctrl.conf.act_eco.descripcion_actividad.requerido\" ng-disabled=\"$ctrl.conf.act_eco.descripcion_actividad.disabled || $ctrl.guardandoProducto\">\n                <div ap-error ng-messages=\"productos_form1.descripcion_actividad.$error\" role=\"alert\" ng-if=\"productos_form1.descripcion_actividad.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>\n              </div>\n              <div class=\"row no-gutters\">\n                <div class=\"col form-group\" ng-if=\"$ctrl.conf.act_eco.nombre_producto.visible\">\n                  <label ng-class=\"{'ap-req':$ctrl.conf.act_eco.nombre_producto.requerido}\">{{$ctrl.conf.act_eco.nombre_producto.label}}:</label>\n                  <input name=\"nombre_producto\" maxlength=\"250\" class=\"form-control\" ng-model=\"$ctrl.data.producto1.nombre_producto\" ng-change=\"$ctrl.productosUpd(productos_form1, 1)\" ng-required=\"$ctrl.conf.act_eco.nombre_producto.requerido\" ng-disabled=\"$ctrl.conf.act_eco.nombre_producto.disabled || $ctrl.guardandoProducto\">\n                  <div ap-error ng-messages=\"productos_form1.nombre_producto.$error\" role=\"alert\" ng-if=\"productos_form1.nombre_producto.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-md-3 form-group\" ng-if=\"$ctrl.conf.act_eco.anio_inicio.visible\">\n                  <label ng-class=\"{'ap-req':$ctrl.conf.act_eco.anio_inicio.requerido}\">{{$ctrl.conf.act_eco.anio_inicio.label}}:</label>\n                  <input name=\"anio_inicio\" numeric maxlength=\"4\" class=\"form-control\" ng-model=\"$ctrl.data.producto1.anio_inicio\" ng-change=\"$ctrl.productosUpd(productos_form1, 1)\" ng-required=\"$ctrl.conf.act_eco.anio_inicio.requerido\" ng-disabled=\"$ctrl.conf.act_eco.anio_inicio.disabled || $ctrl.guardandoProducto\">\n                  <div ap-error ng-messages=\"productos_form1.anio_inicio.$error\" role=\"alert\" ng-if=\"productos_form1.anio_inicio.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"min_year\">El año debe ser mayor o igual a 1825</div>\n                    <div ng-message=\"max_year\">El año debe ser menor o igual a {{$ctrl.year_now}}</div>\n                  </div>\n                </div>\n                <div class=\"col-md-5 form-group\" ng-if=\"$ctrl.conf.act_eco.cantidad_promedio.visible\">\n                  <label ng-class=\"{'ap-req':$ctrl.conf.act_eco.cantidad_promedio.requerido}\">{{$ctrl.conf.act_eco.cantidad_promedio.label}}:</label>\n                  <input name=\"cantidad_promedio\" numeric maxlength=\"8\" class=\"form-control\" ng-model=\"$ctrl.data.producto1.cantidad_promedio\" ng-change=\"$ctrl.productosUpd(productos_form1, 1)\" ng-required=\"$ctrl.conf.act_eco.cantidad_promedio.requerido\" ng-disabled=\"$ctrl.conf.act_eco.cantidad_promedio.disabled || $ctrl.guardandoProducto\">\n                  <div ap-error ng-messages=\"productos_form1.cantidad_promedio.$error\" role=\"alert\" ng-if=\"productos_form1.cantidad_promedio.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                  </div>\n                </div>\n                <div class=\"col-md-4 form-group\" ng-if=\"$ctrl.conf.act_eco.fid_par_unidad_medida.visible\">\n                  <select-parametro name=\"fid_par_unidad_medida\" parametro=\"UNIDAD_MEDIDA\" label=\"{{$ctrl.conf.act_eco.fid_par_unidad_medida.label}}:\"\n                                    ng-model=\"$ctrl.data.producto1.fid_par_unidad_medida\"\n                                    ng-change=\"$ctrl.productosUpd(productos_form1, 1)\"\n                                    ng-required=\"$ctrl.conf.act_eco.fid_par_unidad_medida.requerido\"\n                                    ng-disabled=\"$ctrl.conf.act_eco.fid_par_unidad_medida.disabled || $ctrl.guardandoProducto\"></select-parametro>\n                  <!--{{$ctrl.data.producto1.fid_par_unidad_medida}}-->\n                  <div ap-error ng-messages=\"productos_form1.fid_par_unidad_medida.$error\" role=\"alert\" ng-if=\"productos_form1.fid_par_unidad_medida.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                  </div>\n\n                  <input name=\"unidad_medida_text1\" maxlength=\"50\" class=\"form-control\" ng-model=\"$ctrl.data.producto1.unidad_medida\" placeholder=\"Ingresar Descripción\"\n                         ng-show=\"$ctrl.data.producto1.fid_par_unidad_medida === 700\" ng-if=\"($ctrl.data.producto1.fid_par_unidad_medida === 700)\"\n                         required=\"{{$ctrl.data.producto1.fid_par_unidad_medida === 700}}\"\n                         ng-change=\"$ctrl.productosUpd(productos_form1, 1)\"\n                         ng-disabled=\"$ctrl.guardandoProducto\"\n                         >\n                  <div ap-error ng-messages=\"productos_form1.unidad_medida_text1.$error\" role=\"alert\" ng-if=\"productos_form1.unidad_medida_text1.$touched\">\n                    <div ng-message=\"required\">Ingrese unidad de medida</div>\n                  </div>\n                </div>\n              </div>\n            </ng-form>\n          </div>\n          <div class=\"body-section ap-form\" ng-if=\"$ctrl.conf.act_eco.visible2\">\n            <div class=\"ap-divider mt-1 mb-3\"></div>\n            <div class=\"alert alert-info-second\" ng-if=\"$ctrl.certificacion.estado == 'NUEVO' && $ctrl.msjs.act_eco2_op\">\n              <i class=\"fa fa-info-circle\" ap></i>\n              <span ng-bind-html=\"$ctrl.msjs.act_eco2_op\"></span>\n            </div>\n            <div class=\"text-right\">\n              <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"$ctrl.data.producto2.id_producto || $ctrl.data.tipo_actividad_economica_secundaria\" ng-click=\"$ctrl.productosDel(2)\" uib-tooltip=\"Eliminar actividad económica secundaria\"><i class=\"fa fa-trash\"></i>Eliminar</button>\n            </div>\n            <div class=\"row pt-2\" ng-if=\"$ctrl.conf.emp.tipo_actividad_economica_secundaria.visible\">\n              <div class=\"col-md-4 form-group\">\n                <label ng-class=\"{'ap-req':$ctrl.axs.conf.prod_2}\">{{$ctrl.conf.emp.tipo_actividad_economica_secundaria.label}}:</label>\n              </div>\n              <label class=\"col-md-3 custom-control custom-radio\">\n                <input name=\"tipo_actividad_economica_secundaria\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.tipo_actividad_economica_secundaria\" value=\"TRANSFORMACION\" ng-required=\"$ctrl.axs.conf.prod_2\" ng-click=\"$ctrl.empresaUpd()\" ng-disabled=\"$ctrl.conf.emp.tipo_actividad_economica_secundaria.disabled\">\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">Transformación</span>\n              </label>\n              <label class=\"col-md-3 custom-control custom-radio\">\n                <input name=\"tipo_actividad_economica_secundaria\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.tipo_actividad_economica_secundaria\" value=\"SERVICIOS\" ng-required=\"$ctrl.axs.conf.prod_2\" ng-click=\"$ctrl.empresaUpd()\" ng-disabled=\"$ctrl.conf.emp.tipo_actividad_economica_secundaria.disabled\">\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">Servicios</span>\n              </label>\n            </div>\n            <ng-form name=\"productos_form2\">\n              <div class=\"form-group\" ng-if=\"$ctrl.conf.act_eco.fid_par_clasificacion_artesanal2.visible\">\n                <select-parametro name=\"fid_par_clasificacion_artesanal\" parametro=\"CLASIFICACION_ARTESANAL\" opcional=\"true\" label=\"{{$ctrl.conf.act_eco.fid_par_clasificacion_artesanal2.label}}:\" ng-model=\"$ctrl.data.producto2.fid_par_clasificacion_artesanal\" ng-change=\"$ctrl.productosUpd(productos_form2, 2)\" ng-required=\"$ctrl.axs.conf.prod_2\" ng-disabled=\"$ctrl.conf.act_eco.fid_par_clasificacion_artesanal2.disabled\"></select-parametro>\n                <div ap-error ng-messages=\"productos_form2.fid_par_clasificacion_artesanal.$error\" role=\"alert\" ng-if=\"productos_form2.fid_par_clasificacion_artesanal.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>\n              </div>\n              <div class=\"form-group\" ng-if=\"$ctrl.conf.act_eco.descripcion_actividad2.visible\">\n                <label ng-class=\"{'ap-req':$ctrl.axs.conf.prod_2}\">{{$ctrl.conf.act_eco.descripcion_actividad2.label}}:</label>\n                <input name=\"descripcion_actividad\" maxlength=\"250\" class=\"form-control\" ng-model=\"$ctrl.data.producto2.descripcion_actividad\" ng-change=\"$ctrl.productosUpd(productos_form2, 2)\" ng-required=\"$ctrl.axs.conf.prod_2\" ng-disabled=\"$ctrl.conf.act_eco.descripcion_actividad2.disabled\">\n                <div ap-error ng-messages=\"productos_form2.descripcion_actividad.$error\" role=\"alert\" ng-if=\"productos_form2.descripcion_actividad.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>\n              </div>\n              <div class=\"row no-gutters\">\n                <div class=\"col form-group\" ng-if=\"$ctrl.conf.act_eco.nombre_producto2.visible\">\n                  <label ng-class=\"{'ap-req':$ctrl.axs.conf.prod_2}\">{{$ctrl.conf.act_eco.nombre_producto2.label}}:</label>\n                  <input name=\"nombre_producto\" maxlength=\"250\" class=\"form-control\" ng-model=\"$ctrl.data.producto2.nombre_producto\" ng-change=\"$ctrl.productosUpd(productos_form2, 2)\" ng-required=\"$ctrl.axs.conf.prod_2\" ng-disabled=\"$ctrl.conf.act_eco.nombre_producto2.disabled\">\n                  <div ap-error ng-messages=\"productos_form2.nombre_producto.$error\" role=\"alert\" ng-if=\"productos_form2.nombre_producto.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-md-3 form-group\" ng-if=\"$ctrl.conf.act_eco.anio_inicio2.visible\">\n                  <label ng-class=\"{'ap-req':$ctrl.axs.conf.prod_2}\">{{$ctrl.conf.act_eco.anio_inicio2.label}}:</label>\n                  <input name=\"anio_inicio\" numeric maxlength=\"4\" class=\"form-control\" ng-model=\"$ctrl.data.producto2.anio_inicio\" ng-change=\"$ctrl.productosUpd(productos_form2, 2)\" ng-required=\"$ctrl.axs.conf.prod_2\" ng-disabled=\"$ctrl.conf.act_eco.anio_inicio2.disabled\">\n                  <div ap-error ng-messages=\"productos_form2.anio_inicio.$error\" role=\"alert\" ng-if=\"productos_form2.anio_inicio.$touched && $ctrl.axs.conf.prod_2\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"min_year\">El año debe ser mayor o igual a 1825</div>\n                    <div ng-message=\"max_year\">El año debe ser menor o igual a {{$ctrl.year_now}}</div>\n                  </div>\n                </div>\n                <div class=\"col-md-5 form-group\" ng-if=\"$ctrl.conf.act_eco.cantidad_promedio2.visible\">\n                  <label ng-class=\"{'ap-req':$ctrl.axs.conf.prod_2}\">{{$ctrl.conf.act_eco.cantidad_promedio2.label}}:</label>\n                  <input name=\"cantidad_promedio\" numeric maxlength=\"8\" class=\"form-control\" ng-model=\"$ctrl.data.producto2.cantidad_promedio\" ng-change=\"$ctrl.productosUpd(productos_form2, 2)\" ng-required=\"$ctrl.axs.conf.prod_2\" ng-disabled=\"$ctrl.conf.act_eco.cantidad_promedio2.disabled\">\n                  <div ap-error ng-messages=\"productos_form2.cantidad_promedio.$error\" role=\"alert\" ng-if=\"productos_form2.cantidad_promedio.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                  </div>\n                </div>\n                <div class=\"col-md-4 form-group\" ng-if=\"$ctrl.conf.act_eco.fid_par_unidad_medida2.visible\">\n                  <select-parametro\n                    name=\"fid_par_unidad_medida\"\n                    parametro=\"UNIDAD_MEDIDA\"\n                    label=\"{{$ctrl.conf.act_eco.fid_par_unidad_medida2.label}}:\"\n                    ng-model=\"$ctrl.data.producto2.fid_par_unidad_medida\"\n                    ng-change=\"$ctrl.productosUpd(productos_form2, 2)\"\n                    ng-required=\"$ctrl.axs.conf.prod_2\" ng-disabled=\"$ctrl.conf.act_eco.fid_par_unidad_medida2.disabled\"></select-parametro>\n                  <div ap-error ng-messages=\"productos_form2.fid_par_unidad_medida.$error\" role=\"alert\" ng-if=\"productos_form2.fid_par_unidad_medida.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                  </div>\n                  <!--*********************-->\n                  <input name=\"unidad_medida_text2\" maxlength=\"50\" class=\"form-control\" ng-model=\"$ctrl.data.producto2.unidad_medida\" placeholder=\"Ingresar Descripción\"\n                         ng-show=\"$ctrl.data.producto2.fid_par_unidad_medida === 700\" ng-if=\"($ctrl.data.producto2.fid_par_unidad_medida === 700)\"\n                         required=\"{{$ctrl.data.producto2.fid_par_unidad_medida === 700}}\"\n                         ng-change=\"$ctrl.productosUpd(productos_form2, 2)\"\n                         >\n                  <div ap-error ng-messages=\"productos_form2.unidad_medida_text2.$error\" role=\"alert\" ng-if=\"productos_form2.unidad_medida_text2.$touched\">\n                    <div ng-message=\"required\">Ingrese unidad de medida</div>\n                  </div>\n                </div>\n              </div>\n            </ng-form>\n          </div>\n        </section>\n\n        <section ng-if=\"$ctrl.conf.rec.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.rec.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <div class=\"alert alert-danger\" ng-if=\"!$ctrl.data.personal_hombres_total && !$ctrl.data.personal_mujeres_total && !$ctrl.data.personal_hombres_discapacitados && !$ctrl.data.personal_mujeres_discapacitados\">\n              <i class=\"fa fa-info-circle\" ap></i>\n              <span ng-bind-html=\"$ctrl.msjs.rec_personal\"></span>\n            </div>\n            <ng-form name=\"personal_form\">\n              <div class=\"table-ap\">\n                <table class=\"table\">\n                  <thead>\n                    <tr>\n                      <th>Personal</th>\n                      <th>Permanente</th>\n                      <th>Eventual</th>\n                      <th>Familiar</th>\n                      <th>Persona con discapacidad</th>\n                      <th>Total</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td class=\"align-middle\">Hombres</td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_hombres_permanente\" numeric maxlength=\"5\" class=\"form-control\" ng-model=\"$ctrl.data.personal_hombres_permanente\" ng-required=\"$ctrl.conf.rec.personal_hombres_permanente.requerido\" ng-change=\"$ctrl.personalUpd()\" ng-disabled=\"$ctrl.conf.rec.personal_hombres_permanente.disabled\">\n                          <div ap-error ng-messages=\"personal_form.personal_hombres_permanente.$error\" role=\"alert\" ng-if=\"personal_form.personal_hombres_permanente.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_hombres_eventual\" numeric maxlength=\"5\" class=\"form-control\" ng-model=\"$ctrl.data.personal_hombres_eventual\" ng-required=\"$ctrl.conf.rec.personal_hombres_eventual.requerido\" ng-change=\"$ctrl.personalUpd()\" ng-disabled=\"$ctrl.conf.rec.personal_hombres_eventual.disabled\">\n                          <div ap-error ng-messages=\"personal_form.personal_hombres_eventual.$error\" role=\"alert\" ng-if=\"personal_form.personal_hombres_eventual.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_hombres_familiar\" numeric maxlength=\"5\" class=\"form-control\" ng-model=\"$ctrl.data.personal_hombres_familiar\" ng-required=\"$ctrl.conf.rec.personal_hombres_familiar.requerido\" ng-change=\"$ctrl.personalUpd()\" ng-disabled=\"$ctrl.conf.rec.personal_hombres_familiar.disabled\">\n                          <div ap-error ng-messages=\"personal_form.personal_hombres_familiar.$error\" role=\"alert\" ng-if=\"personal_form.personal_hombres_familiar.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_hombres_discapacitados\" numeric maxlength=\"5\" class=\"form-control\" ng-model=\"$ctrl.data.personal_hombres_discapacitados\" ng-required=\"$ctrl.conf.rec.personal_hombres_discapacitados.requerido\" ng-change=\"$ctrl.personalUpd()\" ng-disabled=\"$ctrl.conf.rec.personal_hombres_discapacitados.disabled\">\n                          <div ap-error ng-messages=\"personal_form.personal_hombres_discapacitados.$error\" role=\"alert\" ng-if=\"personal_form.personal_hombres_discapacitados.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_hombres_total\" numeric class=\"form-control\" ng-model=\"$ctrl.data.personal_hombres_total\" ng-required=\"$ctrl.conf.rec.personal_hombres_total.requerido\" disabled>\n                          <div ap-error ng-messages=\"personal_form.personal_hombres_total.$error\" role=\"alert\" ng-if=\"personal_form.personal_hombres_total.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                    </tr>\n                    <tr>\n                      <td class=\"align-middle\">Mujeres</td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_mujeres_permanente\" numeric maxlength=\"5\" class=\"form-control\" ng-model=\"$ctrl.data.personal_mujeres_permanente\" ng-required=\"$ctrl.conf.rec.personal_mujeres_permanente.requerido\" ng-change=\"$ctrl.personalUpd()\" ng-disabled=\"$ctrl.conf.rec.personal_mujeres_permanente.disabled\">\n                          <div ap-error ng-messages=\"personal_form.personal_mujeres_permanente.$error\" role=\"alert\" ng-if=\"personal_form.personal_mujeres_permanente.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_mujeres_eventual\" numeric maxlength=\"5\" class=\"form-control\" ng-model=\"$ctrl.data.personal_mujeres_eventual\" ng-required=\"$ctrl.conf.rec.personal_mujeres_eventual.requerido\" ng-change=\"$ctrl.personalUpd()\" ng-disabled=\"$ctrl.conf.rec.personal_mujeres_eventual.disabled\">\n                          <div ap-error ng-messages=\"personal_form.personal_mujeres_eventual.$error\" role=\"alert\" ng-if=\"personal_form.personal_mujeres_eventual.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_mujeres_familiar\" numeric maxlength=\"5\" class=\"form-control\" ng-model=\"$ctrl.data.personal_mujeres_familiar\" ng-required=\"$ctrl.conf.rec.personal_mujeres_familiar.requerido\" ng-change=\"$ctrl.personalUpd()\" ng-disabled=\"$ctrl.conf.rec.personal_mujeres_familiar.disabled\">\n                          <div ap-error ng-messages=\"personal_form.personal_mujeres_familiar.$error\" role=\"alert\" ng-if=\"personal_form.personal_mujeres_familiar.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_mujeres_discapacitados\" numeric maxlength=\"5\" class=\"form-control\" ng-model=\"$ctrl.data.personal_mujeres_discapacitados\" ng-required=\"$ctrl.conf.rec.personal_mujeres_discapacitados.requerido\" ng-change=\"$ctrl.personalUpd()\" ng-disabled=\"$ctrl.conf.rec.personal_mujeres_discapacitados.disabled\">\n                          <div ap-error ng-messages=\"personal_form.personal_mujeres_discapacitados.$error\" role=\"alert\" ng-if=\"personal_form.personal_mujeres_discapacitados.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"form-group mb-0\">\n                          <input name=\"personal_mujeres_total\" numeric class=\"form-control\" ng-model=\"$ctrl.data.personal_mujeres_total\" ng-required=\"$ctrl.conf.rec.personal_mujeres_total.requerido\" disabled>\n                          <div ap-error ng-messages=\"personal_form.personal_mujeres_total.$error\" role=\"alert\" ng-if=\"personal_form.personal_mujeres_total.$touched\">\n                            <div ng-message=\"required\">El campo es requerido</div>\n                          </div>\n                        </div>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </ng-form>\n          </div>\n        </section>\n\n        <section ng-if=\"$ctrl.conf.act_pro.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.act_pro.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <div class=\"alert alert-info-second\">\n              <i class=\"fa fa-info-circle\" ap></i>\n              <span ng-bind-html=\"$ctrl.msjs.act_pro_add\"></span>\n            </div>\n            <ng-form name=\"activos_form\">\n              <div class=\"row\" ng-if=\"!$ctrl.conf.act_pro.cantidad.disabled\">\n                <div class=\"table-ap col\">\n                  <table class=\"table mb-0\">\n                    <tbody>\n                      <tr>\n                        <td>\n                          <div class=\"form-group\">\n                            <label ng-class=\"{'ap-req':$ctrl.conf.act_pro.cantidad.requerido}\">{{$ctrl.conf.act_pro.cantidad.label}}:</label>\n                            <input name=\"cantidad\" numeric maxlength=\"8\"\n                            class=\"form-control\" ng-model=\"$ctrl.axs.item_activo.cantidad\"\n                            ng-required=\"$ctrl.conf.act_pro.cantidad.requerido\" ng-keyup=\"$ctrl.activosTotalUpd()\" ng-blur=\"$ctrl.activosBlur('cantidad-message', activos_form)\">\n                            <div id=\"cantidad-message\" ap-error ng-messages=\"activos_form.cantidad.$error\" role=\"alert\" ng-if=\"activos_form.cantidad.$touched\">\n                              <div ng-message=\"required\">El campo es requerido</div>\n                            </div>\n\n                          </div>\n                        </td>\n                        <td>\n                          <div class=\"form-group\">\n                            <label ng-class=\"{'ap-req':$ctrl.conf.act_pro.descripcion.requerido}\">{{$ctrl.conf.act_pro.descripcion.label}}:</label>\n                            <input name=\"descripcion\" maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.axs.item_activo.descripcion\"\n                                ng-required=\"$ctrl.conf.act_pro.descripcion.requerido\" ng-blur=\"$ctrl.activosBlur('descripcion-message', activos_form)\">\n                            <div id=\"descripcion-message\" ap-error ng-messages=\"activos_form.descripcion.$error\" role=\"alert\" ng-if=\"activos_form.descripcion.$touched\">\n                              <div ng-message=\"required\">El campo es requerido</div>\n                            </div>\n                          </div>\n                        </td>\n                        <td>\n                          <div class=\"form-group\">\n                            <label ng-class=\"{'ap-req':$ctrl.conf.act_pro.marca.requerido}\">{{$ctrl.conf.act_pro.marca.label}}:</label>\n                            <input name=\"marca\" maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.axs.item_activo.marca\" ng-required=\"$ctrl.conf.act_pro.marca.requerido\" ng-blur=\"$ctrl.activosBlur('marca-message', activos_form)\">\n                            <div id=\"marca-message\" ap-error ng-messages=\"activos_form.marca.$error\" role=\"alert\" ng-if=\"activos_form.marca.$touched\">\n                              <div ng-message=\"required\">El campo es requerido</div>\n                            </div>\n                          </div>\n                        </td>\n                        <td>\n                          <div class=\"form-group\">\n                            <label ng-class=\"{'ap-req':$ctrl.conf.act_pro.precio_unitario.requerido}\">{{$ctrl.conf.act_pro.precio_unitario.label}}:</label>\n                            <input name=\"precio_unitario\" decimal-format maxlength=\"17\" class=\"form-control\" ng-model=\"$ctrl.axs.item_activo.precio_unitario\" ng-required=\"$ctrl.conf.act_pro.precio_unitario.requerido\" ng-keyup=\"$ctrl.activosTotalUpd()\" ng-blur=\"$ctrl.activosBlur('precio_unitario-message', activos_form)\">\n                            <div id=\"precio_unitario-message\" ap-error ng-messages=\"activos_form.precio_unitario.$error\" role=\"alert\" ng-if=\"activos_form.precio_unitario.$touched\">\n                              <div ng-message=\"required\">El campo es requerido</div>\n                            </div>\n                          </div>\n                        </td>\n                        <td>\n                          <div class=\"form-group\">\n                            <label ng-class=\"{'ap-req':$ctrl.conf.act_pro.total.requerido}\">{{$ctrl.conf.act_pro.total.label}}:</label>\n                            <input name=\"total\" class=\"form-control\" ng-model=\"$ctrl.axs.item_activo.total\" ng-required=\"$ctrl.conf.act_pro.total.requerido\" disabled>\n                            <div id=\"total-message\" ap-error ng-messages=\"activos_form.total.$error\" role=\"alert\" ng-if=\"activos_form.total.$touched\">\n                              <div ng-message=\"required\">El campo es requerido</div>\n                            </div>\n                          </div>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                </div>\n                <div class=\"mt-3 pt-2 pr-2\">\n                  <span class=\"fa fa-check btn-c-info\" uib-tooltip=\"Agregar a la lista\" ng-click=\"$ctrl.activosSave(activos_form)\" ng-if=\"!$ctrl.axs.item_activo.id_activo_productivo\"></span>\n                  <span class=\"fa fa-pencil btn-c-info\" uib-tooltip=\"Editar\" ng-click=\"$ctrl.activosSave(activos_form)\" ng-if=\"$ctrl.axs.item_activo.id_activo_productivo\"></span>\n                  <span class=\"fa fa-minus btn-c-info bg-danger\" uib-tooltip=\"Cancelar\" ng-click=\"$ctrl.activosUpdCancel(activos_form)\" ng-if=\"$ctrl.axs.item_activo.id_activo_productivo\"></span>\n                </div>\n              </div>\n            </ng-form>\n            <div class=\"row mx-0 mt-3 mb-2\">\n              <!-- <button type=\"button\" class=\"btn btn-info btn-sm\" ng-if=\"!$ctrl.conf.act_pro.cantidad.disabled\" ng-click=\"$ctrl.activosDelAll()\" uib-tooltip=\"Eliminar todo\">\n                <i class=\"fa fa-trash\"></i>\n                Eliminar todo\n              </button> -->\n              <div ng-if=\"$ctrl.axs.activos.total > $ctrl.axs.activos.limit\">\n                <input uib-tooltip=\"Filtrar por {{$ctrl.conf.act_pro.descripcion.label|lowercase}}\" placeholder=\"Filtrar\" class=\"form-control\" ng-model=\"$ctrl.axs.activos.filter\" ng-change=\"$ctrl.activosPagUpd('page')\">\n              </div>\n              <div class=\"col\"></div>\n              <div class=\"my-a\">\n                <button type=\"button\" class=\"btn btn-success btn-sm\" ng-if=\"!$ctrl.conf.act_pro.cantidad.disabled\" ng-click=\"$ctrl.activosImportar()\">\n                  <i class=\"fa fa-paperclip\"></i>\n                  Importar CSV\n                </button>\n              </div>\n            </div>\n\n            <div class=\"table-ap\" ng-if=\"$ctrl.axs.activos.count > 0\">\n              <table class=\"table\">\n                <thead>\n                  <tr>\n                    <th></th>\n                    <th class=\"text-right\">Nro</th>\n                    <th class=\"text-right\">{{$ctrl.conf.act_pro.cantidad.label}}</th>\n                    <th>{{$ctrl.conf.act_pro.descripcion.label}}</th>\n                    <th>{{$ctrl.conf.act_pro.marca.label}}</th>\n                    <th class=\"text-right\">{{$ctrl.conf.act_pro.precio_unitario.label}}</th>\n                    <th class=\"text-right\">{{$ctrl.conf.act_pro.total.label}}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"item in $ctrl.data.activos_productivos\">\n                    <td class=\"icon-group\">\n                      <i class=\"fa fa-edit text-success\" uib-tooltip=\"Editar activo\" ng-click=\"$ctrl.activosUpd($index, item)\"></i>\n                      <i class=\"fa fa-trash text-danger\" uib-tooltip=\"Eliminar activo\" ng-click=\"$ctrl.activosDel($index, item)\"></i>\n                    </td>\n                    <td class=\"table-ap-text text-right\">{{ (($ctrl.axs.activos.page - 1) * $ctrl.axs.activos.limit) + ($index + 1)}}</td>\n                    <td class=\"table-ap-text text-right\">{{item.cantidad|currency:'':0}}</td>\n                    <td class=\"table-ap-text\">{{item.descripcion}}</td>\n                    <td class=\"table-ap-text\">{{item.marca}}</td>\n                    <td class=\"table-ap-text text-right\">{{item.precio_unitario|currency:''}}</td>\n                    <td class=\"table-ap-text text-right\">{{item.total|currency:''}}</td>\n                  </tr>\n                </tbody>\n                <tfoot>\n                  <tr>\n                    <td class=\"text-right pt-2\" colspan=\"6\">Total</td>\n                    <td class=\"table-ap-text pt-2 text-right\">{{$ctrl.axs.activos.total|currency:''}}</td>\n                  </tr>\n                </tfoot>\n              </table>\n            </div>\n            <div class=\"table-ap-pagination row\" ng-if=\"$ctrl.data.activos_productivos.length > 0\">\n              <div class=\"col my-a\">\n                Página {{$ctrl.axs.activos.page}} de {{$ctrl.axs.activos.total_pages}}\n              </div>\n              <div class=\"col btn-group justify-content-center\">\n                <button type=\"button\" class=\"btn btn-default py-1 px-3\" uib-tooltip=\"Inicio\" ng-click=\"$ctrl.activosPagUpd('aa')\" ng-disabled=\"$ctrl.axs.activos.page == 1\">\n                  <i class=\"fa fa-angle-double-left\"></i>\n                </button>\n                <button type=\"button\" class=\"btn btn-default py-1 px-3\" uib-tooltip=\"anterior\" ng-click=\"$ctrl.activosPagUpd('a')\" ng-disabled=\"$ctrl.axs.activos.page == 1\">\n                  <i class=\"fa fa-angle-left\"></i>\n                </button>\n                <input numeric maxlength=\"{{$ctrl.axs.activos.max_length_pages}}\"  uib-tooltip=\"Página\" class=\"form-control\" ng-model=\"$ctrl.axs.activos.page\" ng-change=\"$ctrl.activosPagUpd('page')\" ng-click=\"$ctrl.activosPageSelect($event)\">\n                <button type=\"button\" class=\"btn btn-default py-1 px-3\" uib-tooltip=\"siguiente\" ng-click=\"$ctrl.activosPagUpd('s')\" ng-disabled=\"$ctrl.axs.activos.page == $ctrl.axs.activos.total_pages\">\n                  <i class=\"fa fa-angle-right\"></i>\n                </button>\n                <button type=\"button\" class=\"btn btn-default py-1 px-3\" uib-tooltip=\"Final\" ng-click=\"$ctrl.activosPagUpd('ss')\" ng-disabled=\"$ctrl.axs.activos.page == $ctrl.axs.activos.total_pages\">\n                  <i class=\"fa fa-angle-double-right\"></i>\n                </button>\n              </div>\n              <div class=\"col limit row m-0\">\n                <span class=\"col\"></span>\n                <label class=\"my-a\">Filas por página</label>\n                <select class=\"form-control\" ng-model=\"$ctrl.axs.activos.limit\" ng-change=\"$ctrl.activosPagUpd('l');\">\n                  <option ng-repeat=\"item in $ctrl.axs.activos.limit_options\" ng-value=\"item\">{{item}}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n        </section>\n\n        <section class=\"ap-form\" ng-if=\"$ctrl.conf.inf.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.inf.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <ng-form name=\"informacion_form\">\n              <div class=\"form-group row\" ng-if=\"$ctrl.conf.inf.ingresos_anuales_venta.visible\">\n                <label class=\"col-md\" ng-class=\"{'ap-req':$ctrl.conf.inf.ingresos_anuales_venta.requerido}\">{{$ctrl.conf.inf.ingresos_anuales_venta.label}}:</label>\n                <div class=\"col-md pl-0\">\n                  <input name=\"ingresos_anuales_venta\" decimal-format maxlength=\"13\" class=\"form-control\" ng-model=\"$ctrl.data.ingresos_anuales_venta\" ng-change=\"$ctrl.informacionValidityMax('ingresos_anuales_venta')\" ng-required=\"$ctrl.conf.inf.ingresos_anuales_venta.requerido\" ng-disabled=\"$ctrl.conf.inf.ingresos_anuales_venta.disabled\" autocomplete=\"off\">\n                  <div ap-error ng-messages=\"informacion_form.ingresos_anuales_venta.$error\" role=\"alert\" ng-if=\"informacion_form.ingresos_anuales_venta.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"max_num\">El valor máximo permitido es 9999999999.99</div>\n                  </div>\n                  <div style=\"font-size:0.7rem; text-align:justify;\" ng-if=\"$ctrl.data.ingresos_anuales_venta\">\n                    {{$ctrl.numToWord.transformar($ctrl.data.ingresos_anuales_venta)}}\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group row\" ng-if=\"$ctrl.conf.inf.importaciones_anuales.visible\">\n                <label class=\"col-md\" ng-class=\"{'ap-req':$ctrl.conf.inf.importaciones_anuales.requerido}\">{{$ctrl.conf.inf.importaciones_anuales.label}}:</label>\n                <div class=\"col-md pl-0\">\n                  <input name=\"importaciones_anuales\" decimal-format maxlength=\"13\" class=\"form-control\" ng-model=\"$ctrl.data.importaciones_anuales\" ng-change=\"$ctrl.informacionValidityMax('importaciones_anuales')\" ng-required=\"$ctrl.conf.inf.importaciones_anuales.requerido\" ng-disabled=\"$ctrl.conf.inf.importaciones_anuales.disabled\" autocomplete=\"off\">\n                  <div ap-error ng-messages=\"informacion_form.importaciones_anuales.$error\" role=\"alert\" ng-if=\"informacion_form.importaciones_anuales.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"max_num\">El valor máximo permitido es 9999999999.99</div>\n                  </div>\n                  <div style=\"font-size:0.7rem; text-align:justify;\" ng-if=\"$ctrl.data.importaciones_anuales\">\n                    {{$ctrl.numToWord.transformar($ctrl.data.importaciones_anuales)}}\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group row\" ng-if=\"$ctrl.conf.inf.exportaciones_anuales_venta.visible\">\n                <label class=\"col-md\" ng-class=\"{'ap-req':$ctrl.conf.inf.exportaciones_anuales_venta.requerido}\">{{$ctrl.conf.inf.exportaciones_anuales_venta.label}}:</label>\n                <div class=\"col-md pl-0\">\n                  <input name=\"exportaciones_anuales_venta\" decimal-format maxlength=\"13\" class=\"form-control\" ng-model=\"$ctrl.data.exportaciones_anuales_venta\" ng-change=\"$ctrl.informacionValidityMax('exportaciones_anuales_venta')\" ng-required=\"$ctrl.conf.inf.exportaciones_anuales_venta.requerido\" ng-disabled=\"$ctrl.conf.inf.exportaciones_anuales_venta.disabled\" autocomplete=\"off\">\n                  <div ap-error ng-messages=\"informacion_form.exportaciones_anuales_venta.$error\" role=\"alert\" ng-if=\"informacion_form.exportaciones_anuales_venta.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"max_num\">El valor máximo permitido es 9999999999.99</div>\n                  </div>\n                  <div style=\"font-size:0.7rem; text-align:justify;\" ng-if=\"$ctrl.data.exportaciones_anuales_venta\">\n                    {{$ctrl.numToWord.transformar($ctrl.data.exportaciones_anuales_venta)}}\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group row\" ng-if=\"$ctrl.conf.inf.patrimonio_creacion.visible\">\n                <label class=\"col-md\" ng-class=\"{'ap-req':$ctrl.conf.inf.patrimonio_creacion.requerido}\">{{$ctrl.conf.inf.patrimonio_creacion.label}}:</label>\n                <div class=\"col-md pl-0\">\n                  <input name=\"patrimonio_creacion\" decimal-format maxlength=\"13\" class=\"form-control\" ng-model=\"$ctrl.data.patrimonio_creacion\" ng-change=\"$ctrl.informacionValidityMax('patrimonio_creacion')\" ng-required=\"$ctrl.conf.inf.patrimonio_creacion.requerido\" ng-disabled=\"$ctrl.conf.inf.patrimonio_creacion.disabled\" autocomplete=\"off\">\n                  <div ap-error ng-messages=\"informacion_form.patrimonio_creacion.$error\" role=\"alert\" ng-if=\"informacion_form.patrimonio_creacion.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"max_num\">El valor máximo permitido es 9999999999.99</div>\n                  </div>\n                  <div style=\"font-size:0.7rem; text-align:justify;\" ng-if=\"$ctrl.data.patrimonio_creacion\">\n                    {{$ctrl.numToWord.transformar($ctrl.data.patrimonio_creacion)}}\n                  </div>\n                </div>\n              </div>\n            </ng-form>\n          </div>\n        </section>\n\n        <section ng-if=\"$ctrl.conf.cob.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.cob.sec_nombre}}</header>\n          <div class=\"body-section\">\n            <div class=\"alert alert-danger\" ng-if=\"!$ctrl.data.cobertura_departamento\">\n              <i class=\"fa fa-info-circle\" ap></i>\n              <span ng-bind-html=\"$ctrl.msjs.cob_zero\"></span>\n            </div>\n            <div class=\"col-md form-group\">\n              <div class=\"row\">\n                <div class=\"col-md-4\" ng-repeat=\"item in $ctrl.get.departamentos\">\n                  <label class=\"custom-control custom-checkbox\">\n                    <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"item.selected\" ng-disabled=\"$ctrl.conf.cob.cobertura_departamento.disabled\"  ng-change=\"$ctrl.coberturasUpd()\">\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\">{{item.descripcion}}</span>\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n        </section>\n\n        <section ng-if=\"$ctrl.conf.ser.sec_visible\">\n          <header class=\"header-section\">{{$ctrl.conf.ser.sec_nombre}}</header>\n          <div class=\"body-section ap-form\">\n            <ng-form name=\"servicios_form1\">\n              <div class=\"row\">\n                <div class=\"col-md form-group mb-0\">\n                  <uib-select\n                    name=\"fid_par_servicio_p\"\n                    ng-model=\"$ctrl.data.servicio1.fid_par_servicio_p\"\n                    items=\"$ctrl.get.servicios\"\n                    label=\"Servicio principal\"\n                    group-by=\"parent_nom_formated\"\n                    key-value=\"id_parametro\"\n                    key-text=\"nom_formated\"\n                    placeholder=\"Seleccione...\"\n                    ng-disabled=\"$ctrl.conf.ser.fid_par_servicio.disabled\"\n                    ng-required=\"$ctrl.conf.ser.fid_par_servicio.requerido\">\n                  </uib-select>\n                  <div ap-error ng-messages=\"servicios_form1.fid_par_servicio_p.$error\" role=\"alert\" ng-if=\"servicios_form1.fid_par_servicio_p.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"repetido\">El servicio principal debe ser distinto al servicio secundario</div>\n                  </div>\n                </div>\n                <div class=\"col-md form-group mb-0\">\n                  <uib-select\n                    name=\"fid_par_servicio\"\n                    ng-model=\"$ctrl.data.servicio1.fid_par_servicio\"\n                    items=\"$ctrl.get.servicios1\"\n                    label=\"Opción principal\"\n                    key-value=\"id_parametro\"\n                    key-text=\"nombre\"\n                    placeholder=\"Seleccione...\"\n                    ng-disabled=\"$ctrl.conf.ser.fid_par_servicio.disabled\"\n                    ng-required=\"$ctrl.conf.ser.fid_par_servicio.requerido\">\n                  </uib-select>\n                  <div ap-error ng-messages=\"servicios_form1.fid_par_servicio.$error\" role=\"alert\" ng-if=\"servicios_form1.fid_par_servicio.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label ng-class=\"{'ap-req':$ctrl.conf.ser.descripcion.requerido}\">Descripción principal</label>\n                <input name=\"descripcion\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.data.servicio1.descripcion\" ng-change=\"$ctrl.serviciosUpd(1)\" ng-required=\"$ctrl.conf.ser.descripcion.requerido\" ng-disabled=\"$ctrl.conf.ser.parametricas_servicios_capacitacion.disabled\">\n                <div ap-error ng-messages=\"servicios_form1.descripcion.$error\" role=\"alert\" ng-if=\"servicios_form1.descripcion.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>\n              </div>\n            </ng-form>\n          </div>\n          <div class=\"body-section ap-form\">\n            <div class=\"ap-divider mb-3\"></div>\n            <ng-form name=\"servicios_form2\">\n              <div class=\"text-right mb-2\">\n                <button type=\"button\" class=\"btn btn-sm\" ng-if=\"$ctrl.data.servicio2.id_ddjj_servicio\" ng-click=\"$ctrl.serviciosSwap()\" uib-tooltip=\"Convertir a servicio principal\"><i class=\"fa fa-exchange\"></i></button>\n                <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"$ctrl.axs.conf.serv_2\" ng-click=\"$ctrl.serviciosDel(2)\"><i class=\"fa fa-trash\"></i>Eliminar</button>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-md form-group mb-0\">\n                  <uib-select\n                    name=\"fid_par_servicio_p\"\n                    ng-model=\"$ctrl.data.servicio2.fid_par_servicio_p\"\n                    items=\"$ctrl.get.servicios\"\n                    label=\"Servicio secundario\"\n                    group-by=\"parent_nom_formated\"\n                    key-value=\"id_parametro\"\n                    key-text=\"nom_formated\"\n                    placeholder=\"Seleccione...\"\n                    ng-disabled=\"$ctrl.conf.ser.fid_par_servicio.disabled\"\n                    ng-required=\"$ctrl.axs.conf.serv_2\">\n                  </uib-select>\n                  <div ap-error ng-messages=\"servicios_form2.fid_par_servicio_p.$error\" role=\"alert\" ng-if=\"servicios_form2.fid_par_servicio_p.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                    <div ng-message=\"repetido\">El servicio secundario debe ser distinto al servicio principal</div>\n                  </div>\n                </div>\n                <div class=\"col-md form-group mb-0\">\n                  <uib-select\n                    name=\"fid_par_servicio\"\n                    ng-model=\"$ctrl.data.servicio2.fid_par_servicio\"\n                    items=\"$ctrl.get.servicios2\"\n                    label=\"Opción secundaria\"\n                    key-value=\"id_parametro\"\n                    key-text=\"nombre\"\n                    placeholder=\"Seleccione...\"\n                    ng-disabled=\"$ctrl.conf.ser.fid_par_servicio.disabled\"\n                    ng-required=\"$ctrl.axs.conf.serv_2\">\n                  </uib-select>\n                  <div ap-error ng-messages=\"servicios_form2.fid_par_servicio.$error\" role=\"alert\" ng-if=\"servicios_form2.fid_par_servicio.$touched\">\n                    <div ng-message=\"required\">El campo es requerido</div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label ng-class=\"{'ap-req':$ctrl.axs.conf.serv_2}\">Descripción secundaria</label>\n                <input name=\"descripcion\" maxlength=\"200\" class=\"form-control\" ng-model=\"$ctrl.data.servicio2.descripcion\" ng-change=\"$ctrl.serviciosUpd(2)\" ng-required=\"$ctrl.axs.conf.serv_2\" ng-disabled=\"$ctrl.conf.ser.descripcion.disabled\">\n                <div ap-error ng-messages=\"servicios_form2.descripcion.$error\" role=\"alert\" ng-if=\"servicios_form2.descripcion.$touched\">\n                  <div ng-message=\"required\">El campo es requerido</div>\n                </div>\n              </div>\n            </ng-form>\n          </div>\n        </section>\n      </div>\n\n      <div class=\"card-footer text-right\">\n        <button type=\"button\" class=\"btn btn-dafault\" ng-click=\"$ctrl.atras()\">\n          <i class=\"fa fa-angle-double-left\"></i> Atrás\n        </button>\n        <button type=\"submit\" class=\"btn btn-primary\">\n          {{$ctrl.isForm('SHB_UNIDAD')? 'Continuar': 'Guardar y declarar'}}\n          <i class=\"fa fa-angle-double-right\"></i>\n        </button>\n      </div>\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"ubicacion_form\">\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title\">\n      <img class=\"cursor-pointer\" width=\"37\" height=\"37\"  src=\"data:image/png;base64,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\">\n      {{$ctrl.id_ubicacion? 'Editar':'Crear'}} ubicación\n    </h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body modal-ubicacion-body\">\n    <select-municipio departamento=\"$ctrl.data.fid_departamento\" provincia=\"$ctrl.data.fid_provincia\" municipio=\"$ctrl.data.fid_municipio\" conf=\"$ctrl.conf\"></select-municipio>\n    <div class=\"row\">\n      <div class=\"col-md-5 form-group\" ng-if=\"$ctrl.conf.zona.visible\">\n        <label ng-class=\"{'ap-req':$ctrl.conf.zona.requerido}\">{{$ctrl.conf.zona.label}}:</label>\n        <input name=\"zona\" class=\"form-control\" ng-model=\"$ctrl.data.zona\" ng-maxlength=\"100\" maxlength=\"100\" ng-required=\"$ctrl.conf.zona.requerido\" ng-disabled=\"$ctrl.conf.zona.disabled\">\n        <div ap-error ng-if=\"$ctrl.data.zona.length>99\" role=\"alert\">Superó el límite de los caracteres</div>\n        <div ap-error ng-messages=\"ubicacion_form.zona.$error\" role=\"alert\" ng-if=\"ubicacion_form.zona.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n      <div class=\"col-md-5 form-group\" ng-if=\"$ctrl.conf.avenida_calle.visible\">\n        <label ng-class=\"{'ap-req':$ctrl.conf.avenida_calle.requerido}\">{{$ctrl.conf.avenida_calle.label}}:</label>\n        <input name=\"avenida_calle\" class=\"form-control\"  ng-model=\"$ctrl.data.avenida_calle\" ng-maxlength=\"199\" maxlength=\"200\"  ng-required=\"$ctrl.conf.avenida_calle.requerido\" ng-disabled=\"$ctrl.conf.avenida_calle.disabled\">\n        <div ap-error ng-if=\"!ubicacion_form.avenida_calle.$valid\" role=\"alert\">Superó el límite de los caracteres</div>\n        <div ap-error ng-messages=\"ubicacion_form.avenida_calle.$error\" role=\"alert\" ng-if=\"ubicacion_form.avenida_calle.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n      <div class=\"col-md-2 form-group\" ng-if=\"$ctrl.conf.numero.visible\">\n        <label ng-class=\"{'ap-req':$ctrl.conf.numero.requerido}\">{{$ctrl.conf.numero.label}}:</label>\n        <input name=\"numero\"  maxlength=\"9\" class=\"form-control\" ng-model=\"$ctrl.data.numero\" ng-required=\"$ctrl.conf.numero.requerido\" ng-disabled=\"$ctrl.conf.numero.disabled\">\n        <div ap-error ng-messages=\"ubicacion_form.numero.$error\" role=\"alert\" ng-if=\"ubicacion_form.numero.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md-5 form-group\" ng-if=\"$ctrl.conf.avenida_calle_referencia.visible\">\n        <label ng-class=\"{'ap-req':$ctrl.conf.avenida_calle_referencia.requerido}\">{{$ctrl.conf.avenida_calle_referencia.label}}:</label>\n        <input name=\"avenida_calle_referencia\" class=\"form-control\" ng-model=\"$ctrl.data.avenida_calle_referencia\" ng-maxlength=\"199\" maxlength=\"200\" ng-required=\"$ctrl.conf.avenida_calle_referencia.requerido\" ng-disabled=\"$ctrl.conf.avenida_calle_referencia.disabled\">\n        <div ap-error ng-if=\"!ubicacion_form.avenida_calle_referencia.$valid\" role=\"alert\">Superó el límite de los caracteres</div>\n        <div ap-error ng-messages=\"ubicacion_form.avenida_calle_referencia.$error\" role=\"alert\" ng-if=\"ubicacion_form.avenida_calle_referencia.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n      <div class=\"col-md-5 form-group\" ng-if=\"$ctrl.conf.edificio.visible\">\n        <label ng-class=\"{'ap-req':$ctrl.conf.edificio.requerido}\">{{$ctrl.conf.edificio.label}}:</label>\n        <input name=\"edificio\" maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.data.edificio\" ng-required=\"$ctrl.conf.edificio.requerido\" ng-disabled=\"$ctrl.conf.edificio.disabled\">\n        <div ap-error ng-messages=\"ubicacion_form.edificio.$error\" role=\"alert\" ng-if=\"ubicacion_form.edificio.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n      <div class=\"col-md-2 form-group\" ng-if=\"$ctrl.conf.piso.visible\">\n        <label ng-class=\"{'ap-req':$ctrl.conf.piso.requerido}\">{{$ctrl.conf.piso.label}}:</label>\n        <input name=\"piso\" numeric maxlength=\"9\" class=\"form-control\" ng-model=\"$ctrl.data.piso\" ng-required=\"$ctrl.conf.piso.requerido\" ng-disabled=\"$ctrl.conf.piso.disabled\">\n        <div ap-error ng-messages=\"ubicacion_form.piso.$error\" role=\"alert\" ng-if=\"ubicacion_form.piso.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col-md form-group\">\n        <input-chips \n        name=\"telefonos\" \n        label=\"{{$ctrl.conf.telefono.label}}:\" \n        ng-model=\"$ctrl.data.telefonos\"\n        ng-required=\"$ctrl.conf.telefono.requerido\" \n        before-add=\"$ctrl.beforeAddTel($chip)\" ng-disabled=\"$ctrl.conf.telefono.disabled\">\n        </input-chips>\n        <div ap-error ng-messages=\"ubicacion_form.telefonos.$error\" role=\"alert\" ng-if=\"ubicacion_form.telefonos.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n      <div class=\"col-md form-group\" ng-if=\"$ctrl.conf.fid_par_territorio_indigena.visible\">\n        <select-parametro  opcional=\"true\" name=\"fid_par_territorio_indigena\" parametro=\"TIOC\" label=\"{{$ctrl.conf.fid_par_territorio_indigena.label}}:\" ng-model=\"$ctrl.data.fid_par_territorio_indigena\" ng-required=\"$ctrl.conf.fid_par_territorio_indigena.requerido\" ng-disabled=\"$ctrl.conf.fid_par_territorio_indigena.disabled\"></select-parametro>\n        <div ap-error ng-messages=\"ubicacion_form.fid_par_territorio_indigena.$error\" role=\"alert\" ng-if=\"ubicacion_form.fid_par_territorio_indigena.$touched\">\n          <div ng-message=\"required\">El campo es requerido</div>\n        </div>\n      </div>\n    </div>\n    <!-- <leaflet width=\"100%\" height=\"380px\" lf-center=\"$ctrl.center\" markers=\"$ctrl.markers\"></leaflet> -->\n    <leaflet width=\"100%\" height=\"380px\" event-broadcast=\"$ctrl.events_leaflet\" lf-center=\"$ctrl.center\" markers=\"$ctrl.markers\" legend = \"$ctrl.legend\" defaults=\"defaults\" ></leaflet>\n  </div>\n  <div style=\"float: left;text-align: left\" class=\"alert alert-{{$ctrl.data.latitud&&$ctrl.data.longitud? 'warning':'info' }} mb-0\">\n      <i class=\"fa fa-info-circle\" ap></i>\n      <span ng-if=\"$ctrl.data.latitud && $ctrl.data.longitud\">Doble clic en el ícono para <strong>eliminar</strong> la ubicación.</span>\n      <span ng-if=\"!($ctrl.data.latitud && $ctrl.data.longitud)\">Doble clic en el mapa para <strong>añadir</strong> ubicación.</span>\n    </div>\n  <div class=\"modal-footer\">\n\n\n\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n      <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.save(ubicacion_form)\">\n      <i class=\"fa fa-check\"></i> Guardar\n    </button>\n  </div>\n</ng-form>\n"

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container empresa\">\n    <h2 class=\"page-title\"><i class=\"fa fa-user\"></i>  Autorización Sello \"Hecho en Bolivia\"</h2>\n    <form name=\"form\" ng-submit=\"$ctrl.declarar(form)\" novalidate>\n        <div class=\"card card-main\">\n            <div class=\"card-header mt-3\">\n              MATRICULA: {{ $ctrl.certificacion.razon_social}} - {{ $ctrl.certificacion.nit_matricula }}\n            </div>\n            <div class=\"alert alert-warning\" ng-if=\"$ctrl.data.estado == 'OBSERVADO'\">\n                <h4><i class=\"fa fa-warning\"></i> OBSERVACIONES</h4>\n                {{ $ctrl.data.certificacion.observaciones }}\n            </div>\n            <div class=\"card-block\">\n                <section>\n                    <div class=\"row\">\n                        <div class=\"col-12\">\n                            <section id=\"descripcion-producto-otros\">\n                                <header class=\"header-section mt-0\">Producto</header>\n                                <div class=\"row\">\n                                    <!-- <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.codigoProducto.$touched || form.$submitted) && form.codigoProducto.$invalid }\">\n                                        <label for=\"codigoProducto\" class=\"ap-req\">Codigo Producto</label>\n                                        <input type=\"text\" class=\"form-control\" maxlength=\"10\" id=\"codigoProducto\" required name=\"codigoProducto\" ng-model=\"$ctrl.data.codigoProducto\" ng-model-options=\"{ debounce: 500 }\">\n                                        <ui-help message=\"$ctrl.helpLang.codigoProducto\" direction=\"top\"></ui-help>\n                                        <div ng-messages=\"form.codigoProducto.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.codigoProducto.$touched\">\n                                            <div ng-message=\"required\">El campo es obligatorio</div>\n                                        </div>\n                                    </div> -->\n\n                                    <!-- <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.codigoUnspsc.$touched || form.$submitted) && form.codigoUnspsc.$invalid }\">\n                                        <label for=\"codigoUnspsc\" class=\"ap-req\">Codigo Unspsc</label>\n                                        <input type=\"text\" class=\"form-control\" maxlength=\"20\" id=\"codigoUnspsc\" required name=\"codigoUnspsc\" ng-model=\"$ctrl.data.codigoUnspsc\" ng-model-options=\"{ debounce: 500 }\">\n                                        <ui-help message=\"$ctrl.helpLang.codigoUnspsc\" direction=\"top\"></ui-help>\n                                        <div ng-messages=\"form.codigoUnspsc.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.codigoUnspsc.$touched\">\n                                            <div ng-message=\"required\">El campo es obligatorio</div>\n                                        </div>\n                                    </div> -->\n\n                                    <!-- <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.codigoFicha.$touched || form.$submitted) && form.codigoFicha.$invalid }\">\n                                        <label for=\"codigoFicha\" class=\"ap-req\">Codigo Ficha</label>\n                                        <input type=\"text\" class=\"form-control\" maxlength=\"20\" id=\"codigoFicha\" required name=\"codigoFicha\" ng-model=\"$ctrl.data.codigoFicha\" ng-model-options=\"{ debounce: 500 }\">\n                                        <ui-help message=\"$ctrl.helpLang.codigoFicha\" direction=\"top\"></ui-help>\n                                        <div ng-messages=\"form.codigoFicha.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.codigoFicha.$touched\">\n                                            <div ng-message=\"required\">El campo es obligatorio</div>\n                                        </div>\n                                    </div> -->\n\n                                    <!-- <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.codigoNandina.$touched || form.$submitted) && form.codigoNandina.$invalid }\">\n                                        <label for=\"codigoNandina\" class=\"ap-req\">Codigo Nandina</label>\n                                        <input type=\"text\" class=\"form-control\" maxlength=\"20\" id=\"codigoNandina\" required name=\"codigoNandina\" ng-model=\"$ctrl.data.codigoNandina\" ng-model-options=\"{ debounce: 500 }\">\n                                        <ui-help message=\"$ctrl.helpLang.codigoNandina\" direction=\"top\"></ui-help>\n                                        <div ng-messages=\"form.codigoNandina.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.codigoNandina.$touched\">\n                                            <div ng-message=\"required\">El campo es obligatorio</div>\n                                        </div>\n                                    </div> -->\n\n                                    <div class=\"col-md-12 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.nombreProducto.$touched || form.$submitted) && form.nombreProducto.$invalid }\">\n                                      <label for=\"nombreProducto\">Nombre comercial del producto:</label>\n                                      <input type=\"text\" class=\"form-control\" maxlength=\"100\" id=\"nombreProducto\" name=\"nombreProducto\" ng-model=\"$ctrl.data.nombreProducto\" ng-model-options=\"{ debounce: 500 }\">\n                                      <ui-help message=\"$ctrl.helpLang.nombreProducto\" direction=\"top\"></ui-help>\n                                      <!-- <div ng-messages=\"form.nombreProducto.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.nombreProducto.$touched\">\n                                          <div ng-message=\"required\">El campo es obligatorio</div>\n                                      </div> -->\n                                    </div>\n\n                                    <div class=\"col-md-4 form-group\">\n                                      <uib-select\n                                          name=\"codigoUnidadMedida\"\n                                          ng-model=\"$ctrl.data.codigoUnidadMedida\"\n                                          items=\"$ctrl.unidades_peso\"\n                                          label=\"Unidad de medida:\"\n                                          key-value=\"id_parametro\"\n                                          key-text=\"nombre\"\n                                          placeholder=\"Seleccione...\"\n                                      >\n                                      </uib-select>\n                                      <!-- <div ap-error ng-messages=\"form.codigoUnidadMedida.$error\" role=\"alert\" ng-if=\"form.codigoUnidadMedida.$touched\">\n                                          <div ng-message=\"required\">El campo es requerido</div>\n                                      </div> -->\n                                      <input\n                                          name=\"codigoUnidadMedida\"\n                                          maxlength=\"50\"\n                                          class=\"form-control\"\n                                          ng-model=\"$ctrl.data.otrosUnidadMedida\"\n                                          placeholder=\"Ingresar Descripción\"\n                                          ng-show=\"$ctrl.data.codigoUnidadMedida === 700\"\n                                          ng-required=\"$ctrl.data.codigoUnidadMedida === 700\"\n                                      ng-model-options=\"{ debounce: 500 }\">\n                                      <div ap-error ng-messages=\"form.codigoUnidadMedida.$error\" role=\"alert\" ng-if=\"form.codigoUnidadMedida.$touched\">\n                                          <div ng-message=\"required\">El campo es obligatorio</div>\n                                      </div>\n                                    </div>\n\n                                    <div class=\"col-md-4 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.capacidadProduccionMensual.$touched || form.$submitted) && form.capacidadProduccionMensual.$invalid }\">\n                                      <label for=\"capacidadProduccionMensual\">Capacidad de produccion mensual:</label>\n                                      <input type=\"text\" class=\"form-control\" placeholder=\"Ej. 100\" maxlength=\"8\" id=\"capacidadProduccionMensual\" name=\"capacidadProduccionMensual\" ng-model=\"$ctrl.data.capacidadProduccionMensual\" ng-model-options=\"{ debounce: 500 }\">\n                                      <ui-help message=\"$ctrl.helpLang.capacidadProduccionMensual\" direction=\"top\"></ui-help>\n                                      <!-- <div ng-messages=\"form.capacidadProduccionMensual.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.capacidadProduccionMensual.$touched\">\n                                          <div ng-message=\"required\">El campo es obligatorio</div>\n                                      </div> -->\n                                    </div>\n\n                                    <div class=\"col-md-4 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.precioUnitario.$touched || form.$submitted) && form.precioUnitario.$invalid }\">\n                                      <label for=\"precioUnitario\">Precio unitario:</label>\n                                      <input type=\"text\" class=\"form-control\" placeholder=\"Ej. 850.50\" maxlength=\"8\" id=\"precioUnitario\" name=\"precioUnitario\" ng-model=\"$ctrl.data.precioUnitario\" ng-model-options=\"{ debounce: 500 }\">\n                                      <ui-help message=\"$ctrl.helpLang.precioUnitario\" direction=\"top\"></ui-help>\n                                      <!-- <div ng-messages=\"form.precioUnitario.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.precioUnitario.$touched\">\n                                          <div ng-message=\"required\">El campo es obligatorio</div>\n                                      </div> -->\n                                    </div>\n\n                                </div>\n\n                            </section>\n\n                            <section id=\"ashb-caracteristicas\">\n                              <header class=\"header-section my-3\">Características</header>\n                              <div class=\"row\">\n                                <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.color.$touched || form.$submitted) && form.color.$invalid }\">\n                                  <label for=\"color\">Color:</label>\n                                  <input class=\"form-control\" type=\"text\" placeholder=\"Ej. Rojo\" alpha-numeric id=\"color\" name=\"color\" maxlength=\"100\" ng-model=\"$ctrl.data.color\" ng-model-options=\"{ debounce: 500 }\">\n                                  <ui-help message=\"$ctrl.helpLang.color\" direction=\"top\"></ui-help>\n                                  <!-- <div ng-messages=\"form.color.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.color.$touched\">\n                                      <div ng-message=\"required\">El campo es obligatorio</div>\n                                  </div> -->\n                                </div>\n\n                                <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.talla.$touched || form.$submitted) && form.talla.$invalid }\">\n                                    <label for=\"talla\">Talla:</label>\n                                    <input class=\"form-control\" type=\"text\" placeholder=\"Ej. Grande\" alpha-numeric id=\"talla\" name=\"talla\" maxlength=\"10\" ng-model=\"$ctrl.data.talla\" ng-model-options=\"{ debounce: 500 }\">\n                                    <ui-help message=\"$ctrl.helpLang.talla\" direction=\"top\"></ui-help>\n                                    <!-- <div ng-messages=\"form.talla.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.talla.$touched\">\n                                        <div ng-message=\"required\">El campo es obligatorio</div>\n                                    </div> -->\n                                </div>\n\n                                <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.peso.$touched || form.$submitted) && form.peso.$invalid }\">\n                                    <label for=\"peso\">Peso:</label>\n                                    <input class=\"form-control\" type=\"text\" placeholder=\"Ej. 1.5\" id=\"peso\" name=\"peso\" maxlength=\"10\" ng-model=\"$ctrl.data.peso\" ng-model-options=\"{ debounce: 500 }\">\n                                    <ui-help message=\"$ctrl.helpLang.peso\" direction=\"top\"></ui-help>\n                                    <!-- <div ng-messages=\"form.peso.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.peso.$touched\">\n                                        <div ng-message=\"required\">El campo es obligatorio</div>\n                                    </div> -->\n                                </div>\n\n                                <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.marca.$touched || form.$submitted) && form.marca.$invalid }\">\n                                  <label for=\"marca\">Marca:</label>\n                                  <input class=\"form-control\" type=\"text\" placeholder=\"Ej. Bota de cuero\" alpha-numeric id=\"marca\" name=\"marca\" maxlength=\"100\" ng-model=\"$ctrl.data.marca\" ng-model-options=\"{ debounce: 500 }\">\n                                  <ui-help message=\"$ctrl.helpLang.marca\" direction=\"top\"></ui-help>\n                                  <!-- <div ng-messages=\"form.marca.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.marca.$touched\">\n                                      <div ng-message=\"required\">El campo es obligatorio</div>\n                                  </div> -->\n                                </div>\n\n                                <div class=\"col-md-6 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.medidas.$touched || form.$submitted) && form.medidas.$invalid }\">\n                                    <label for=\"medidas\">Medidas:</label>\n                                    <input class=\"form-control\" type=\"text\" placeholder=\"Ej. 30 cm x 25 cm x  3 cm\" alpha-numeric id=\"medidas\" name=\"medidas\" maxlength=\"100\" ng-model=\"$ctrl.data.medidas\" ng-model-options=\"{ debounce: 500 }\">\n                                    <ui-help message=\"$ctrl.helpLang.medidas\" direction=\"top\"></ui-help>\n                                    <!-- <div ng-messages=\"form.medidas.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.medidas.$touched\">\n                                        <div ng-message=\"required\">El campo es obligatorio</div>\n                                    </div> -->\n                                </div>\n\n                                <div class=\"col-md-6 form-group\">\n                                  <uib-select\n                                      name=\"comercio\"\n                                      ng-model=\"$ctrl.data.comercio\"\n                                      items=\"$ctrl.unidades_comercio\"\n                                      label=\"Tipo de comercio:\"\n                                      key-value=\"id_parametro\"\n                                      key-text=\"nombre\"\n                                      placeholder=\"Seleccione...\">\n                                  </uib-select>\n                                  <div ap-error ng-messages=\"form.comercio.$error\" role=\"alert\" ng-if=\"form.comercio.$touched\">\n                                      <div ng-message=\"required\">El campo es obligatorio</div>\n                                  </div>\n                                </div>\n\n                                <div class=\"col-md-12 my-3\" ng-class=\"{ 'has-danger': (form.medicamento.$touched || form.$submitted) && form.medicamento.$invalid }\">\n                                  <div class=\"form-group\">\n                                      <label for=\"medicamento\">Medicamento:</label>\n                                  </div>\n                                  <div>\n                                      <label class=\"custom-control custom-radio\">\n                                          <input id=\"tipo-comercio-1\" name=\"medicamento\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.medicamento\" value=\"true\">\n                                          <span class=\"custom-control-indicator\"></span>\n                                          <span class=\"custom-control-description\">SI</span>\n                                      </label>\n                                      <label class=\"custom-control custom-radio\">\n                                          <input id=\"tipo-comercio-2\" name=\"medicamento\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.medicamento\" value=\"false\">\n                                          <span class=\"custom-control-indicator\"></span>\n                                          <span class=\"custom-control-description\">NO</span>\n                                      </label>\n                                  </div>\n                                  <!-- <div ng-messages=\"form.medicamento.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.medicamento.$touched\">\n                                      <div ng-message=\"required\">El campo es obligatorio</div>\n                                  </div> -->\n                                </div>\n\n                                <div class=\"col-md-12 form-group\">\n                                  <label>El sello Hecho en Bolivia se aplicará a:</label>\n                                </div>\n                                <div class=\"col-md-4 form-group\" ng-repeat=\"lugar in $ctrl.opcionesLugar\">\n                                  <label class=\"custom-control custom-checkbox mb-3\">\n                                      <input type=\"checkbox\" class=\"custom-control-input\" name=\"lugar_sello{{$index}}\" ng-model=\"$ctrl.lugaresSeleccionados[lugar.key]\" ng-change=\"$ctrl.limpiarDependenciaUbicacion(lugar.key, $ctrl.lugaresSeleccionados[lugar.key])\">\n                                      <span class=\"custom-control-indicator\"></span>\n                                      <span class=\"custom-control-description\">{{lugar.label}}</span>\n                                  </label>\n                                  <div ng-show=\"lugar.key == 'OTROS' && $ctrl.lugaresSeleccionados[lugar.key]\">\n                                    <input\n                                        name=\"otroUbicacionASHB\"\n                                        maxlength=\"50\"\n                                        class=\"form-control\"\n                                        ng-model=\"$ctrl.data.autorizacionSHB.otroUbicacionASHB\"\n                                        placeholder=\"Ingresar otra ubicación del sello\"\n                                        ng-required=\"lugar.key == 'OTROS' && $ctrl.lugaresSeleccionados[lugar.key]\"\n                                        ng-model-options=\"{ debounce: 500 }\">\n                                    <div ap-error ng-messages=\"form.otroUbicacionASHB.$error\" role=\"alert\" ng-if=\"form.otroUbicacionASHB.$touched\">\n                                        <div ng-message=\"required\">El campo es obligatorio</div>\n                                    </div>\n                                  </div>\n                                </div>\n\n                              </div>\n                            </section>\n\n                            <section id=\"ashb-descripcion-prod\">\n                              <header class=\"header-section my-3\">Descripción detallada del producto</header>\n                              <div class=\"row\">\n                                <div class=\"col-md-12 form-group\" ng-class=\"{ 'has-danger': (form.descripcionLarga.$touched || form.$submitted) && form.descripcionLarga.$invalid }\">\n                                  <label for=\"descripcionLarga\">Descripción detallada del producto:</label>\n                                  <textarea class=\"form-control\" id=\"descripcionLarga\" maxlength=\"1000\" name=\"descripcionLarga\" rows=\"8\" ng-model=\"$ctrl.data.descripcionLarga\" ng-model-options=\"{ debounce: 500 }\"></textarea>\n                                  <div class=\"text-right\" ng-if=\"form.descripcionLarga.$viewValue\"><small>{{form.descripcionLarga.$viewValue.length}}/1000</small></div>\n                                  <!-- <div ng-messages=\"form.descProcesoProductivo.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.descProcesoProductivo.$touched\">\n                                      <div ng-message=\"required\">El campo es obligatorio</div>\n                                  </div> -->\n                                </div>\n                              </div>\n                            </section>\n\n                            <section id=\"ashb-proceso-prod\">\n                              <header class=\"header-section my-3\">Decripción del proceso productivo</header>\n                              <div class=\"row\">\n                                <div class=\"col-md-12 form-group\" ng-class=\"{ 'has-danger': (form.descProcesoProductivo.$touched || form.$submitted) && form.descProcesoProductivo.$invalid }\">\n                                  <label for=\"descProcesoProductivo\">Descripción del proceso productivo:</label>\n                                  <textarea class=\"form-control\" id=\"descProcesoProductivo\" maxlength=\"500\" name=\"descProcesoProductivo\" rows=\"8\" ng-model=\"$ctrl.data.descProcesoProductivo\" ng-model-options=\"{ debounce: 500 }\"></textarea>\n                                  <div class=\"text-right\" ng-if=\"form.descProcesoProductivo.$viewValue\"><small>{{form.descProcesoProductivo.$viewValue.length}}/500</small></div>\n                                  <!-- <div ng-messages=\"form.descProcesoProductivo.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.descProcesoProductivo.$touched\">\n                                      <div ng-message=\"required\">El campo es obligatorio</div>\n                                  </div> -->\n                                </div>\n                              </div>\n                            </section>\n\n                            <section id=\"imagen-producto\">\n                              <header class=\"header-section my-3\">Imágenes</header>\n                              <div class=\"row\">\n                                <div class=\"col-sm-12 col-md-6 col-lg-4 form-group\">\n                                  <div style=\"font-size: 12px;\"><strong>Imagen del producto:</strong></div>\n                                  <div ng-if=\"!$ctrl.urlImage\">\n                                      <ui-file-upload-autorizacion url=\"$ctrl.photo.url\" key=\"archivo\" name=\"archivo\" text-upload=\"Arrastre la imagen de su producto aquí o haga click aquí\"\n                                      types=\"|png|jpg|gif|jpeg|\" on-complete-item=\"$ctrl.photo.onCompleteItem\" label=\"Subir imagen\"></ui-file-upload-autorizacion>\n                                  </div>\n                                </div>\n                                <div class=\"col-sm-12 col-md-6 col-lg-4 form-group\">\n                                  <div style=\"font-size: 12px;\"><strong>Ubicación del producto:</strong></div>\n                                  <div ng-if=\"!$ctrl.urlImageSello\">\n                                      <ui-file-upload-autorizacion url=\"$ctrl.photo.url\" key=\"archivo1\" name=\"archivo1\" text-upload=\"Arrastre la imagen de su producto aquí o haga click aquí\"\n                                      types=\"|png|jpg|gif|jpeg|\" on-complete-item=\"$ctrl.photo.onCompleteItem\" label=\"Subir imagen\"></ui-file-upload-autorizacion>\n                                  </div>\n                                </div>\n                                <div class=\"col-sm-12 col-md-6 col-lg-4 form-group\">\n                                  <div style=\"font-size: 12px;\"><strong>Etiqueta:</strong></div>\n                                  <div ng-if=\"!$ctrl.urlImageEtiqueta\">\n                                      <ui-file-upload-autorizacion url=\"$ctrl.photo.url\" name=\"archivo2\" text-upload=\"Arrastre la imagen de su producto aquí o haga click aquí\"\n                                          types=\"|png|jpg|gif|jpeg|\" on-complete-item=\"$ctrl.photo.onCompleteItem\" label=\"Subir imagen\"></ui-file-upload-autorizacion>\n                                  </div>\n                                </div>\n                                <div class=\"col-sm-12 form-group\">\n                                  <small><strong>Nota.-</strong> La entidad no se hace responsable de los derechos de Copyright de las imágenes.</small>\n                                </div>\n                              </div>\n                            </section>\n                        </div>\n                    </div>\n                </section>\n\n                <section id=\"lista-insumos\" ng-if=\"!$ctrl.data.shb\">\n                    <header class=\"header-section\">Costo de producción</header>\n                    <div class=\"alert alert-info-second\">\n                        <i class=\"fa fa-info-circle\"></i> Nota.- El valor de la <strong>mano de obra</strong> es el costo aproximado que se le paga a una persona por producir una unidad del bien o producto.\n                    </div>\n                    <crud-table formly=\"$ctrl.insumos.formly\"\n                        permission=\"$ctrl.insumos.permission\"\n                        inline=\"true\"\n                        data=\"$ctrl.insumos.data\"\n                        fks=\"$ctrl.insumos.fks\"\n                        hidden-fields=\"$ctrl.insumos.hiddenFields\"\n                        merge-fields=\"$ctrl.insumos.mergeFields\"\n                        ng-if=\"$ctrl.renderInsumos\"\n                        callback-save=\"$ctrl.total.save\"\n                        fields=\"$ctrl.insumos.fields\"\n                        pagination=\"false\">\n                    </crud-table>\n                </section>\n\n\n            </div>\n            <div class=\"card-footer text-right\">\n                <div class=\"alert alert-danger pull-left margin-0\">\n                    (*) Los campos son obligatorios\n                </div>\n                <button md-effect type=\"button\" ng-click=\"$ctrl.guardarData()\" ng-disabled=\"$ctrl.btnSave\" class=\"btn btn-secondary\">\n                    <i class=\"fa fa-save\"></i>\n                    Guardar temporalmente\n                </button>\n                <button md-effect type=\"button\" ng-click=\"$ctrl.declarar()\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.btnSend\">\n                    Guardar y declarar\n                    <i class=\"fa fa-angle-double-right\"></i>\n                </button>\n            </div>\n        </div>\n    </form>\n</div>\n"

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Bandeja <strong>de solicitudes</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <crud-table url=\"$ctrl.solicitudes.url\"\n        data=\"$ctrl.solicitudes.data\"\n        fields=\"$ctrl.solicitudes.fields\"\n        permission=\"$ctrl.solicitudes.permission\"\n        event-edit=\"$ctrl.solicitudes.eventEdit\"\n        event-create=\"$ctrl.solicitudes.eventCreate\"\n        event-delete=\"$ctrl.solicitudes.eventDelete\"\n        buttons=\"$ctrl.solicitudes.buttons\"\n        labels=\"$ctrl.solicitudes.labels\"\n        fks=\"$ctrl.solicitudes.fks\"\n        update=\"$ctrl.solicitudes.update\"\n        delete=\"$ctrl.solicitudes.delete\"\n        clases=\"$ctrl.solicitudes.clases\"\n        hidden-fields=\"$ctrl.solicitudes.hiddenFields\">        \n      </crud-table>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Bandeja <strong>de certificaciones</strong></h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <crud-table url=\"$ctrl.solicitudes.url\"\n                  data=\"$ctrl.solicitudes.data\"\n                  fields=\"$ctrl.solicitudes.fields\"\n                  permission=\"$ctrl.solicitudes.permission\"\n                  event-edit=\"$ctrl.solicitudes.eventEdit\"\n                  event-create=\"$ctrl.solicitudes.eventCreate\"\n                  event-delete=\"$ctrl.solicitudes.eventDelete\"\n                  buttons=\"$ctrl.solicitudes.buttons\"\n                  labels=\"$ctrl.solicitudes.labels\"\n                  fks=\"$ctrl.solicitudes.fks\"\n                  update=\"$ctrl.solicitudes.update\"\n                  delete=\"$ctrl.solicitudes.delete\"\n                  clases=\"$ctrl.solicitudes.clases\"\n                  hidden-fields=\"$ctrl.solicitudes.hiddenFields\">\n      </crud-table>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container empresa\">\n    <h2 class=\"page-title\" ng-if=\"!$ctrl.data.shb\"><i class=\"fa fa-user\"></i> Certificación costo bruto de producción y bienes producidos en el país</h2>\n    <h2 class=\"page-title\" ng-if=\"$ctrl.data.shb\"><i class=\"fa fa-user\"></i>  Solicitud de sello \"Hecho en Bolivia\"</h2>\n    <form name=\"form\" ng-submit=\"$ctrl.declarar(form)\" novalidate>\n        <div class=\"card card-main\">\n            <div class=\"card-header\">\n              MATRICULA: {{ $ctrl.data.unidad_productiva.matricula_comercio}} - {{ $ctrl.data.unidad_productiva.razon_social }}\n            </div>\n            <div class=\"alert alert-warning\" ng-if=\"$ctrl.data.estado == 'OBSERVADO'\">\n                <h4><i class=\"fa fa-warning\"></i> OBSERVACIONES</h4>\n                {{ $ctrl.data.certificacion.observaciones }}\n            </div>\n            <div class=\"card-block\">\n                <div class=\"row\">\n                    <div class=\"col-md-8\">\n                        <div class=\"row\">\n                            <!-- <pre>{{ form | json }}</pre> -->\n                            <div class=\"col-md-4 form-group\">\n                                <label for=\"codigo-empresa\">Código de empresa</label>\n                                <p class=\"form-control-static\">{{ $ctrl.data.unidad_productiva.nro_certificacion }}</p>\n                            </div>\n                            <div class=\"col-md-8 form-group\">\n                                <label>Razón social</label>\n                                <p class=\"form-control-static\">{{ $ctrl.data.unidad_productiva.razon_social }}</p>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col form-group\">\n                                <label>Rubro</label>\n                                <p class=\"form-control-static\">{{ $ctrl.data.parametro_caeb.descripcion }}</p>\n                            </div>\n                            <div class=\"col form-group\">\n                                <label>Georeferenciación</label>\n                                <div class=\"btn-ubicaciones\">\n                                    <button uib-popover-html=\"ubicacion.html\"\n                                            popover-title=\"Ubicación {{ $index + 1 }}\"\n                                            ng-repeat=\"ubicacion in $ctrl.ubicaciones\"\n                                            md-effect\n                                            type=\"button\"\n                                            class=\"btn btn-outline-dafault btn-sm\"\n                                            popover-placement=\"bottom\"\n                                            popover-class=\"ubicacion-popup\"\n                                            uib-tooltip=\"Haga click aquí para ver/ocultar la ubicación\">\n                                        <i class=\"fa fa-map-marker\"></i> ubicación {{ $index + 1 }}\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-md-4 text-center\">\n                        <div class=\"fecha-creacion\"> {{$ctrl.data._fecha_creacion | date:'dd/MM/yyyy' }}</div>\n                        <button class=\"btn btn-warning\" type=\"button\" md-effect ng-click=\"$ctrl.masInformacion()\"><i class=\"fa fa-building\"></i> Ver más información<br /> de la empresa</button>\n                    </div>\n                </div>\n                <section>\n                    <header class=\"header-section\">Ficha técnica</header>\n                    <div class=\"alert alert-info\"><i class=\"fa fa-info-circle\"></i> {{$ctrl.helpLang.nombre_comercial}}</div>\n                    <div class=\"row\" id=\"nombre-producto\">\n                        <div class=\"col-md-7 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.nombre_producto.$touched || form.$submitted) && form.nombre_producto.$invalid }\">\n                            <label for=\"nombre-comercial\" class=\"ap-req\">Nombre comercial del producto y/o bien</label>\n                            <input type=\"text\" class=\"form-control\" maxlength=\"250\" id=\"nombre-comercial\" required name=\"nombre_producto\" ng-model=\"$ctrl.data.nombre_producto\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                            <ui-help message=\"$ctrl.helpLang.nombre_comercial\" direction=\"top\"></ui-help>\n                            <div ng-messages=\"form.nombre_producto.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.nombre_producto.$touched\">\n                                <div ng-message=\"required\">El campo es obligatorio</div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-5 form-group ui-help-input\">\n                            <label for=\"marca\">Marca</label>\n                            <input type=\"text\" class=\"form-control\" maxlength=\"100\" id=\"marca\" name=\"marca\" ng-model=\"$ctrl.data.marca\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                            <ui-help message=\"$ctrl.helpLang.marca\" direction=\"top\"></ui-help>\n                            <div ng-messages=\"form.marca.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.marca.$touched\">\n                                <div ng-message=\"required\">El campo es obligatorio</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-7\">\n                            <section id=\"descripcion-producto-otros\">\n                                <header class=\"header-section mt-0\">Descripción del producto</header>\n                                <div class=\"alert alert-info\">\n                                    <i class=\"fa fa-info-circle\"></i> Registre al menos un atributo del producto (color, talla, medidas, peso)\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-8 form-group ui-help-input\" ng-class=\"{ 'has-danger': (form.color.$touched || form.$submitted) && form.color.$invalid }\">\n                                        <label for=\"color\">Color</label>\n                                        <input class=\"form-control\" type=\"text\" placeholder=\"Ej. Rojo\" alpha-numeric id=\"color\" name=\"color\" maxlength=\"100\" ng-model=\"$ctrl.data.color\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                                        <ui-help message=\"$ctrl.helpLang.color\" direction=\"top\"></ui-help>\n                                        <!-- <div ng-messages=\"form.color.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.color.$touched\">\n                                            <div ng-message=\"required\">El campo es obligatorio</div>\n                                        </div> -->\n                                    </div>\n                                    <div class=\"col-md-4 form-group ui-help-input\">\n                                        <label for=\"talla\">Talla</label>\n                                        <input class=\"form-control\" type=\"text\" maxlength=\"10\" id=\"talla\" name=\"talla\" ng-model=\"$ctrl.data.talla\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                                        <ui-help message=\"$ctrl.helpLang.talla\" direction=\"top\"></ui-help>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md form-group ui-help-input\">\n                                        <label for=\"medidas\">Medidas</label>\n                                        <input class=\"form-control\" type=\"text\" placeholder=\"Alto X cm, Ancho X cm, Fondo X cm\" maxlength=\"100\" id=\"medidas\" name=\"medidas\" ng-model=\"$ctrl.data.medidas\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                                        <ui-help message=\"$ctrl.helpLang.medidas\" direction=\"top\"></ui-help>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-6 form-group ui-help-input\">\n                                        <label for=\"peso\">Peso</label>\n                                        <input class=\"form-control\" type=\"text\" placeholder=\"0.00\" maxlength=\"10\" decimal-format id=\"peso\" name=\"peso\" ng-model=\"$ctrl.data.peso\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                                        <ui-help message=\"$ctrl.helpLang.peso\" direction=\"top\"></ui-help>\n                                    </div>\n                                    <div class=\"col-md-6 form-group\">\n                                        <uib-select\n                                            name=\"fid_par_unidad_medida\"\n                                            ng-model=\"$ctrl.data.fid_par_unidad_medida\"\n                                            items=\"$ctrl.unidades_peso\"\n                                            label=\"Unidad de medida del peso\"\n                                            key-value=\"id_parametro\"\n                                            key-text=\"nombre\"\n                                            placeholder=\"Seleccione...\"\n                                            ng-required=\"$ctrl.data.peso\">\n                                        </uib-select>\n                                        <div ap-error ng-messages=\"form.fid_par_unidad_medida.$error\" role=\"alert\" ng-if=\"form.fid_par_unidad_medida.$touched\">\n                                            <div ng-message=\"required\">El campo es requerido</div>\n                                        </div>\n                                        <input name=\"unidad_medida_text\" maxlength=\"50\" class=\"form-control\" ng-model=\"$ctrl.data.unidad_medida\" placeholder=\"Ingresar Descripción\"\n                                                ng-show=\"$ctrl.data.fid_par_unidad_medida === 700\"\n                                                ng-required=\"$ctrl.data.fid_par_unidad_medida === 700 && !$ctrl.data.peso\"\n                                                ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                                        <div ap-error ng-messages=\"form.unidad_medida_text.$error\" role=\"alert\" ng-if=\"form.unidad_medida_text.$touched\">\n                                            <div ng-message=\"required\">Ingrese unidad de medida</div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </section>\n                        </div>\n                        <div class=\"col-md-5\">\n                            <section id=\"imagen-producto\">\n                                <figure ng-if=\"$ctrl.urlImage\" class=\"producto-imagen\">\n                                    <img ng-src=\"{{ $ctrl.urlImage }}\" alt=\"Imagen Producto\">\n                                    <figcaption>\n                                        <div class=\"btn-container\">\n                                            <button class=\"btn btn-outline-dafault\" md-effect type=\"button\" ng-click=\"$ctrl.cambiarImagen()\">\n                                                <i class=\"fa fa-exchange\"></i> Cambiar imagen\n                                            </button>\n                                            <button class=\"btn btn-danger\" md-effect type=\"button\" ng-click=\"$ctrl.eliminarImagen()\">\n                                                <i class=\"fa fa-trash\"></i> Eliminar imagen\n                                            </button>\n                                        </div>\n                                    </figcaption>\n                                </figure>\n                                <div ng-if=\"!$ctrl.urlImage\">\n                                    <ui-file-upload url=\"$ctrl.photo.url\" name=\"archivo\" text-upload=\"Arrastre la imagen de su producto aquí o haga click aquí\"\n                                        types=\"|png|jpg|gif|jpeg|\" on-complete-item=\"$ctrl.photo.onCompleteItem\" label=\"Subir imagen\"></ui-file-upload>\n                                    <span><strong>Nota.-</strong> La entidad no se hace responsable de los derechos de Copyright de la imagen.</span>\n                                    <div class=\"text-center\" ng-if=\"$ctrl.data.imagen_producto\">\n                                        <button class=\"btn btn-outline-dafault\" md-effect type=\"button\" ng-click=\"$ctrl.cancelarCambioImagen()\">\n                                            <i class=\"fa fa-ban\"></i> Cancelar cambio de imagen\n                                        </button>\n                                    </div>\n                                </div>\n                            </section>\n                        </div>\n                    </div>\n                </section>\n                <section>\n                    <div class=\"row\">\n                        <div class=\"col-md-7\" id=\"descripcion-producto\">\n                            <header class=\"header-section\">Descripción del proceso productivo</header>\n                            <div class=\"form-group\" ng-class=\"{ 'has-danger': (form.capacidad_prod_mensual.$touched || form.$submitted) && form.capacidad_prod_mensual.$invalid }\">\n                                <label for=\"capacidad-produccion\" class=\"ap-req\">Capacidad producción mensual</label>\n                                <input class=\"form-control\" type=\"text\" placeholder=\"0\" numeric id=\"capacidad-produccion\" maxlength=\"8\" required name=\"capacidad_prod_mensual\" ng-model=\"$ctrl.data.capacidad_prod_mensual\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                                <div ng-messages=\"form.capacidad_prod_mensual.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.capacidad_prod_mensual.$touched\">\n                                    <div ng-message=\"required\">El campo es obligatorio</div>\n                                </div>\n                            </div>\n                            <div class=\"form-group\" ng-class=\"{ 'has-danger': (form.desc_produccion.$touched || form.$submitted) && form.desc_produccion.$invalid }\">\n                                <label for=\"descripcion-proceso\" class=\"ap-req\">Breve descripción del proceso productivo</label>\n                                <textarea class=\"form-control\" id=\"descripcion-proceso\" maxlength=\"500\" name=\"desc_produccion\" required rows=\"8\" ng-model=\"$ctrl.data.desc_produccion\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\"></textarea>\n                                <div class=\"text-right\" ng-if=\"form.desc_produccion.$viewValue\"><small>{{form.desc_produccion.$viewValue.length}}/500</small></div>\n                                <div ng-messages=\"form.desc_produccion.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.desc_produccion.$touched\">\n                                    <div ng-message=\"required\">El campo es obligatorio</div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-5\">\n                            <section id=\"descripcion-producto-comercializacion\">\n                                <header class=\"header-section\">Comercialización</header>\n                                <div class=\"form-group\" ng-class=\"{ 'has-danger': (form.precio_unitario.$touched || form.$submitted) && form.precio_unitario.$invalid }\">\n                                    <label for=\"precio-unitario\" class=\"ap-req\">Precio {{$ctrl.data.shb? 'referencial':'unitario' }} </label>\n                                    <input class=\"form-control\" type=\"text\" placeholder=\"0.00\" decimal-format id=\"precio-unitario\" maxlength=\"8\" required name=\"precio_unitario\" ng-model=\"$ctrl.data.precio_unitario\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                                    <div ng-messages=\"form.precio_unitario.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.precio_unitario.$touched\">\n                                        <div ng-message=\"required\">El campo es obligatorio</div>\n                                    </div>\n                                </div>\n                                <div ng-class=\"{ 'has-danger': (form.tipo_comercio.$touched || form.$submitted) && form.tipo_comercio.$invalid }\">\n                                    <div class=\"form-group\">\n                                        <label for=\"tipo_comercio\" class=\"ap-req\">Comercio</label>\n                                    </div>\n                                    <div>\n                                        <label class=\"custom-control custom-radio\">\n                                            <input id=\"tipo-comercio-1\" required name=\"tipo_comercio\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.tipo_comercio\" value=\"NACIONAL\" ng-click=\"$ctrl.guardarForm()\">\n                                            <span class=\"custom-control-indicator\"></span>\n                                            <span class=\"custom-control-description\">Nacional</span>\n                                        </label>\n                                        <label class=\"custom-control custom-radio\">\n                                            <input id=\"tipo-comercio-2\" required name=\"tipo_comercio\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.tipo_comercio\" value=\"EXTRANJERO\" ng-click=\"$ctrl.guardarForm()\">\n                                            <span class=\"custom-control-indicator\"></span>\n                                            <span class=\"custom-control-description\">Externo</span>\n                                        </label>\n                                        <label class=\"custom-control custom-radio\">\n                                            <input id=\"tipo-comercio-3\" required name=\"tipo_comercio\" type=\"radio\" class=\"custom-control-input\" ng-model=\"$ctrl.data.tipo_comercio\" value=\"NACIONAL Y EXTRANJERO\" ng-click=\"$ctrl.guardarForm()\">\n                                            <span class=\"custom-control-indicator\"></span>\n                                            <span class=\"custom-control-description\">Nacional y externo</span>\n                                        </label>\n                                    </div>\n                                    <div ng-messages=\"form.tipo_comercio.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.tipo_comercio.$touched\">\n                                        <div ng-message=\"required\">El campo es obligatorio</div>\n                                    </div>\n                                </div>\n                            </section>\n                            <section>\n                                <header class=\"header-section\">Solo exportadores</header>\n                                <div class=\"form-group\">\n                                    <label for=\"posicion-arancelaria\">Posición arancelaria (NANDINA)</label>\n                                    <input type=\"text\" class=\"form-control\" id=\"posicion-arancelaria\" name=\"nandina\" maxlength=\"200\" ng-model=\"$ctrl.data.fid_nandina\" ng-change=\"$ctrl.guardarForm()\" ng-model-options=\"{ debounce: 500 }\">\n                                </div>\n                            </section>\n                        </div>\n                    </div>\n                </section>\n                <section id=\"lista-insumos\" ng-if=\"!$ctrl.data.shb\">\n                    <header class=\"header-section\">Cuadro de costo bruto de producción</header>\n                    <div class=\"alert alert-info\">\n                        <i class=\"fa fa-info-circle\"></i> Nota.- El valor de la <strong>mano de obra</strong> es el costo aproximado que se le paga a una persona por producir una unidad del bien o producto.\n                    </div>\n                    <crud-table formly=\"$ctrl.insumos.formly\"\n                                permission=\"$ctrl.insumos.permission\"\n                                inline=\"true\"\n                                data=\"$ctrl.insumos.data\"\n                                fks=\"$ctrl.insumos.fks\"\n                                hidden-fields=\"$ctrl.insumos.hiddenFields\"\n                                merge-fields=\"$ctrl.insumos.mergeFields\"\n                                ng-if=\"$ctrl.renderInsumos\"\n                                callback-save=\"$ctrl.total.save\"\n                                fields=\"$ctrl.insumos.fields\"\n                                pagination=\"false\">\n                    </crud-table>\n                    <!-- <div class=\"row\">\n                        <div class=\"col-md-6\"></div>\n                        <div class=\"col-md-3 form-group\">\n                            <label for=\"total_valor_costo_bruto\">Total valor costo bruto(Bs.)</label>\n                            <input type=\"text\" id=\"total_valor_costo_bruto\" ng-model=\"$ctrl.data.total_valor_costo_bruto\" class=\"form-control text-right\" ng-disabled=\"true\" placeholder=\"0\">\n                        </div>\n                        <div class=\"col-md-3 form-group\">\n                            <label for=\"total_costo_bruto\">Total costo bruto(Bs.)</label>\n                            <input type=\"text\" id=\"total_costo_bruto\" ng-model=\"$ctrl.data.total_costo_bruto\" class=\"form-control text-right\" ng-disabled=\"true\" placeholder=\"0\">\n                        </div>\n                    </div> -->\n                </section>\n                <!-- <section id=\"lista-pagos\">\n                    <header class=\"header-section\">Depósito del trámite</header>\n                    <crud-table formly=\"$ctrl.pagos.formly\"\n                                permission=\"$ctrl.pagos.permission\"\n                                inline=\"true\"\n                                data=\"$ctrl.pagos.data\"\n                                fks=\"$ctrl.pagos.data.fks\"\n                                ng-if=\"$ctrl.renderPagos\"\n                                pagination=\"false\">\n                    </crud-table>\n                </section>\n                <section>\n                    <header class=\"header-section\">Datos de factura</header>\n                    <div class=\"row\">\n                        <div class=\"col\">\n                            <div class=\"form-group\">\n                                <label for=\"razon-social\">Razón social</label>\n                                <p class=\"form-control-static\">{{ $ctrl.matricula.razon_social }}</p>\n                            </div>\n                        </div>\n                        <div class=\"col\">\n                            <div class=\"form-group\">\n                                <label for=\"ci-nit\">C.I. o NIT</label>\n                                <p class=\"form-control-static\">{{ $ctrl.usuario.nit }}</p>\n                            </div>\n                        </div>\n                    </div>\n                </section> -->\n            </div>\n            <div class=\"card-footer text-right\">\n                <div class=\"alert alert-danger pull-left margin-0\">\n                    (*) Los campos son obligatorios\n                </div>\n                <button type=\"button\" class=\"btn btn-dafault\" ng-click=\"$ctrl.atras()\">\n                    <i class=\"fa fa-angle-double-left\"></i> Atrás\n                </button>\n                <button type=\"submit\" class=\"btn btn-primary\">\n                    Guardar y declarar\n                    <i class=\"fa fa-angle-double-right\"></i>\n                </button>\n            </div>\n        </div>\n    </form>\n</div>\n"

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h5 class=\"modal-title\"><i class=\"fa fa-gavel\"></i> Declaración Jurada</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<form name=\"form\" ng-submit=\"$ctrl.ok()\">\n    <div class=\"modal-body\">\n        <div class=\"alert alert-info text-justify\">\n            <i class=\"fa fa-info-circle\"></i> En el transcurso de los siguientes {{$ctrl.items.numero_dias}} días hábiles, se le enviará un correo electrónico para informarle si el/los productos declarados han sido aprobados. Caso contrario, se le informará si su solicitud fuese observada o rechazada para tomar las medidas correspondientes.\n             <!-- presentando el comprobante de depósito en el Banco Unión (Cuenta en bolivianos Nro. {{$ctrl.items.cuenta_banco}}).  -->\n        </div>\n        <!-- <p class=\"text-justify\">El presente formulario tiene carácter de Declaración Jurada.</p> -->\n        <p class=\"text-justify\">En cumplimiento del Artículo 1322° del Código Civil y Art. 157° Parágrafo IV del Código Procesal Civil, sujeto en caso de inexactitud o falsedad a la cancelación del trámite de constitución y, a las penalidades establecidas en el Art. 169° del Código Penal como falso testimonio, DECLARO que la información contenida en el presente formulario es fidedigna.</p>\n        <p>Por tanto:</p>\n        <div class=\"text-center\">\n            <label class=\"custom-control custom-checkbox inscripcion-terminos\">\n                <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"$ctrl.declarar\" required>\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\"> Acepto y declaro la veracidad de la información presentada\n            </label>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n            <i class=\"fa fa-close\"></i> Cancelar\n        </button>\n        <button md-effect type=\"button\" class=\"btn btn-primary\" ng-disabled=\"form.$invalid\" ng-click=\"$ctrl.ok()\" >\n            <i class=\"fa fa-check\"></i> Continuar\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-user\"></i> Matrículas con certificación</h2>\n    <div class=\"card\">\n        <div class=\"card-block\">\n            <div class=\"alert alert-info\" ng-if=\"$ctrl.matriculas.length\">\n                <i class=\"fa fa-info-circle\"></i> Seleccione una matrícula de comercio\n            </div>\n            <div class=\"alert alert-danger\" ng-if=\"!$ctrl.matriculas\">\n                <i class=\"fa fa-warn-circle\"></i> No existen matrículas de comercio\n            </div>\n            <div class=\"card-container\">\n                <div class=\"card\" ng-repeat=\"matricula in $ctrl.matriculas\">\n                    <div class=\"card-img-top badge-info\">\n                        <div class=\"img-empresa\"></div> <strong>MATRÍCULA: <br> <span>{{ matricula.matricula }}</span></strong>\n                    </div>\n                    <div class=\"card-block\">\n                        <h4 class=\"card-title\">{{ matricula.razon_social }}</h4>\n                    </div>\n                    <button md-effect type=\"button\" ng-click=\"$ctrl.seleccionar(matricula)\" class=\"btn btn-primary btn-block btn-lg\">\n                        <i class=\"fa fa-check-circle\"></i> Registrar\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-user\"></i> Solicitud de certificados</h2>\n    <div class=\"card card-main\" ng-if=\"$ctrl.mostrarMatriculas\">\n        <div class=\"card-block\">\n            <div class=\"alert alert-info\" ng-if=\"$ctrl.matriculas.length\">\n                <i class=\"fa fa-info-circle\"></i> Seleccione una matrícula de comercio\n            </div>\n            <div class=\"alert alert-danger\" ng-if=\"!$ctrl.matriculas\">\n                <i class=\"fa fa-warn-circle\"></i> No existen matrículas de comercio\n            </div>\n            <div class=\"card-container\">\n                <div class=\"card\" ng-repeat=\"matricula in $ctrl.matriculas\">\n                    <div class=\"card-img-top badge-info\">\n                        <div class=\"img-empresa\"></div> <strong>MATRÍCULA: <br> <span>{{ matricula.matricula }}</span></strong>\n                    </div>\n                    <div class=\"card-block\">\n                        <h4 class=\"card-title\">{{ matricula.razon_social }}</h4>\n                    </div>\n                    <button md-effect type=\"button\" ng-click=\"$ctrl.seleccionar(matricula)\" class=\"btn btn-primary btn-block btn-lg\">\n                        <i class=\"fa fa-check-circle\"></i> Ver solicitudes\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"card card-main\" ng-if=\"$ctrl.mostrarSolicitudes\">\n        <div class=\"card-header\">\n          MATRICULA: {{ $ctrl.matricula.matricula }} - {{ $ctrl.matricula.razon_social }}\n        </div>\n        <div class=\"card-block\">\n            <section>\n                <uib-tabset active=\"active\">\n                    <uib-tab index=\"0\">\n                        <uib-tab-heading>\n                            <i class=\"fa fa-check-circle-o\"></i> Productos por certificar\n                        </uib-tab-heading>\n                        <div class=\"alert alert-warning\" ng-if=\"$ctrl.pendientes.length == 0\">\n                            <i class=\"fa fa-warning\"></i> No tiene ningún producto aprobado\n                        </div>\n                        <form name=\"form\" ng-submit=\"$ctrl.enviar(form)\" novalidate ng-if=\"$ctrl.pendientes.length\">\n                            <section id=\"deposito-tramite\">\n                                <header class=\"header-section\">Depósito del trámite</header>\n                                <div class=\"alert alert-warning\">\n                                    <i class=\"fa fa-info-circle\"></i> Si desea solicitar un certificado nuevo para un producto ya declarado con un cuce diferente,\n                                    sólo debe registrar el deposito correspondiente y enviar la solicitud, no es necesario volver a declarar el producto.\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col\">\n                                        <div class=\"control-group\" ng-class=\"{ 'has-danger': (form.codigo_boleta.$touched || form.$submitted) && form.codigo_boleta.$invalid }\">\n                                            <label for=\"codigo-boleta\">Código boleta</label>\n                                            <input type=\"text\" alpha-dash minlength=\"5\" maxlength=\"15\" class=\"form-control\" id=\"codigo-boleta\" required name=\"codigo_boleta\" ng-model=\"$ctrl.codigo_boleta\">\n                                            <div ng-messages=\"form.codigo_boleta.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.codigo_boleta.$touched\">\n                                                <div ng-message=\"required\">El código boleta es obligatorio</div>\n                                                <div ng-message=\"minlength\">El campo debe tener 5 caracteres como mínimo</div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col\">\n                                        <div class=\"control-group\" ng-class=\"{ 'has-danger': (form.fecha_deposito.$touched || form.$submitted) && form.fecha_deposito.$invalid }\">\n                                            <label for=\"fecha-deposito\">Fecha depósito</label>\n                                            <div class=\"input-group\">\n                                                <input type=\"text\" class=\"form-control\" uib-datepicker-popup name=\"fecha_deposito\"\n                                                ng-model=\"$ctrl.fecha_deposito\" is-open=\"$ctrl.opened\" datepicker-options=\"$ctrl.dateOptions\"\n                                                ng-required=\"true\" ng-change=\"$ctrl.validateFechaDeposito(form)\"/>\n                                                <span class=\"input-group-btn\">\n                                                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.opened = !$ctrl.opened\"><i class=\"fa fa-calendar\"></i></button>\n                                                </span>\n                                            </div>\n                                            <div ng-messages=\"form.fecha_deposito.$error\" class=\"form-error\" ng-if=\"form.$submitted || form.fecha_deposito.$touched\">\n                                                <div ng-message=\"required\">La fecha de depósito es obligatorio</div>\n                                                <div ng-message=\"date\">No es una fecha válida</div>\n                                                <div ng-message=\"min_date\">La fecha mínima aceptada es {{$ctrl.dateOptions.minDate| date:'dd/MM/yyyy'}}</div>\n                                                <div ng-message=\"max_date\">La fecha máxima aceptada es {{$ctrl.dateOptions.maxDate| date:'dd/MM/yyyy'}}</div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </section>\n                            <section>\n                                <header class=\"header-section\">Datos de factura</header>\n                                <div class=\"row\">\n                                    <div class=\"col\">\n                                        <div class=\"control-group\">\n                                            <label for=\"codigo-boleta\">Razón social</label>\n                                            <p class=\"form-control-static\">{{ $ctrl.matricula.razon_social }}</p>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-md-3\">\n                                        <div class=\"control-group\">\n                                            <label for=\"fecha-deposito\">C.I. o NIT</label>\n                                            <p class=\"form-control-static\">{{ $ctrl.usuario.nit }}</p>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-md-3\">\n                                        <div class=\"control-group\">\n                                            <label for=\"fecha-deposito\" class=\"text-warning\"><strong>Total a facturar</strong></label>\n                                            <p class=\"form-control-static text-right alert-warning border-0\">{{ $ctrl.totalPago() }}</p>\n                                        </div>\n                                    </div>\n                                </div>\n                            </section>\n                            <section id=\"lista-producto\">\n                                <header class=\"header-section\">Lista de productos aprobados</header>\n                                <div class=\"alert alert-info\">\n                                    <i class=\"fa fa-info-circle\"></i> Seleccione por lo menos un producto para su certificación\n                                </div>\n\n                                <table class=\"table table-hovered table-striped table-pendientes\">\n                                    <thead>\n                                        <tr>\n                                            <td class=\"pendiente-form\">\n                                                <label class=\"custom-control custom-checkbox\" uib-tooltip=\"Seleccionar/deseleccionar todo\">\n                                                    <input type=\"checkbox\" class=\"custom-control-input\" ng-model=\"$ctrl.checkSelectAll\" ng-checked=\"$ctrl.isSelectAll()\" ng-change=\"$ctrl.selectAll($event)\" required>\n                                                    <span class=\"custom-control-indicator\"></span>\n                                                </label>\n                                            </td>\n                                            <th>Producto</th>\n                                            <th>CUCE</th>\n                                            <th>Tipo Certificado</th>\n                                            <th>Fecha de aprobación</th>\n                                            <th>Fecha de finalización</th>\n                                            <th>Costo(Bs.)</th>\n                                        </tr>\n                                    </thead>\n                                    <tbody>\n                                        <tr ng-repeat=\"producto in $ctrl.pendientes\">\n                                            <td class=\"pendiente-form\">\n                                                <label class=\"custom-control custom-checkbox\">\n                                                    <input type=\"checkbox\" class=\"custom-control-input\" ng-change=\"$ctrl.selected(producto)\" ng-model=\"producto.select\" ng-value=\"producto.id_producto\" required>\n                                                    <span class=\"custom-control-indicator\"></span>\n                                                </label>\n                                            </td>\n                                            <td>{{ producto.nombre_producto }}</td>\n                                            <td class=\"pendiente-form text-left\" ng-class=\"{ 'has-danger': (form['cuce[' + $index + ']'].$touched || form.$submitted) && form['cuce[' + $index + ']'].$invalid }\">\n                                                <input type=\"text\" class=\"form-control\" name=\"cuce[{{$index}}]\" ng-required=\"producto.select\" ng-model=\"producto.cuce\" ng-disabled=\"!producto.select\" placeholder=\"Llene el CUCE del producto aquí\" focus-if=\"producto.select\" maxlength=\"50\">\n                                                <div ng-messages=\"form['cuce[' + $index + ']'].$error\" class=\"form-error\" ng-if=\"form.$submitted || form['cuce[' + $index + ']'].$touched\">\n                                                    <div ng-message=\"required\">El CUCE es obligatorio</div>\n                                                </div>\n                                            </td>\n                                            <td>{{ $ctrl.tipoProducto[producto.certificacion.formulario.tipo] }}</td>\n                                            <td>{{ producto.certificacion._fecha_aprobacion }}</td>\n                                            <td>{{ producto.certificacion._fecha_fin }}</td>\n                                            <td class=\"text-right\">{{ producto.certificacion.costo_certificacion }}</td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </section>\n                            <!-- <pre>{{ form.$error | json }}</pre> -->\n                            <div class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-dafault\" ng-click=\"$ctrl.atras()\" ng-if=\"$ctrl.mostrarMatriculas !== undefined\">\n                                    <i class=\"fa fa-angle-double-left\"></i> Atrás\n                                </button>\n                                <button class=\"btn btn-primary\" type=\"submit\">\n                                    <i class=\"fa fa-check\"></i> Enviar solicitud\n                                </button>\n                            </div>\n                        </form>\n                    </uib-tab>\n                    <!-- <uib-tab index=\"1\">\n                        <uib-tab-heading>\n                            <i class=\"fa fa-check-circle\"></i> Productos certificados\n                        </uib-tab-heading>\n                        <table class=\"table table-hovered table-striped\">\n                            <thead>\n                                <tr>\n                                    <th>Producto</th>\n                                    <th>CUCE</th>\n                                    <th>Certificado</th>\n                                    <th>Fecha</th>\n                                    <th>Costo(Bs.)</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"producto in $ctrl.pendientes\">\n                                    <td>{{ producto.producto }}</td>\n                                    <td>{{ producto.cuce }}</td>\n                                    <td>{{ producto.tipo }}</td>\n                                    <td>{{ producto.fecha | date:'dd/mm/yyyy' }}</td>\n                                    <td class=\"text-right\">{{ producto.costo }}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </uib-tab> -->\n                </uib-tabset>\n            </section>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-user\"></i> Nuevo trámite</h2>\n    <div class=\"card card-main\">\n        <div class=\"card-block\">\n            <div class=\"alert alert-info\">\n                <p><i class=\"fa fa-info-circle\"></i> Seleccione el tipo de trámite que necesite.</p>\n                <ul>\n                    <li><strong class=\"text-primary\">Costo Bruto de Producción:</strong> Está orientado a los productos que tienen materia prima principal de <strong>origen nacional</strong> (fabricada o producida en tierra Boliviana). Por ejemplo: alimentos procesados con frutas del país, muebles fabricados con madera nacional, textiles que trabajan con tela nacional, etc. Tendrá acceso al <strong>Margen de preferencia de 35 % en modalidad ANPE y 30 % Licitación</strong>.</li>\n                    \n                    <li><strong class=\"text-primary\">Bien Producido en el País:</strong> Está orientado a los productos que tienen materia prima principal de <strong>origen extranjero</strong>. Por ejemplo: muebles metálicos, textiles que trabajan con tela extranjera, muebles .de melanina, etc. Tendrá acceso al <strong>Margen de preferencia de 10 % en modalidad ANPE y Licitación</strong>.</li>\n                </ul>\n            </div>\n            <div class=\"card-container text-center\">\n                <div class=\"card\" ng-repeat=\"tramite in $ctrl.tramites\">\n                    <div class=\"card-img-top badge-info\">\n                        <div class=\"img-prod\"></div>\n                    </div>\n                    <div class=\"card-block\">\n                        <h4 class=\"card-title text-center text-primary\">{{ tramite.nombre }}</h4>\n                    </div>\n                    <button md-effect class=\"btn btn-primary btn-block btn-lg\" ng-click=\"$ctrl.seleccionar(tramite)\" type=\"button\">\n                        <i class=\"fa fa-check-circle\"></i> Seleccionar\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-user\"></i> Descargar archivo CSV.</h2>\n  <div class=\"card card-main\">\n    <div class=\"card-header\" ng-if=\"$ctrl.matricula\">\n\n    </div>\n    <div class=\"card-block\">\n\n      <form name=\"form1\">\n        <header class=\"header-section\">&nbsp;</header>\n        <div class=\"alert alert-info\">\n          <i class=\"fa fa-info-circle\"></i>\n          <strong>Fecha de creación del registro</strong>\n          <br>Seleccione el periodo de fechas para generar el archivo CSV.\n        </div>\n        <div class=\"body-section\">\n          <div class=\"row\" ng-if=\"$ctrl.rol==3\">\n            <div class=\"col-lg-6 form-group\">\n              <label for=\"input\">Ambito:</label>\n              <ui-select ng-model=\"$ctrl.ambito\" theme=\"bootstrap\" title=\"Seleccionar ámbito\">\n                <ui-select-match placeholder=\"Seleccione un ítem de la lista\">{{$select.selected.texto}}</ui-select-match>\n                <ui-select-choices repeat=\"item in $ctrl.promueves | filter: $select.search\">\n                  <span ng-bind-html=\"item.texto | highlight: $select.search\"></span>\n                  <!-- <small ng-bind-html=\"item.valor | highlight: $select.search\"></small> -->\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-6 form-group\">\n              <label>Fecha Inicial</label>\n              <div class=\"input-group\">\n                <input type=\"text\" name=\"inicio\" placeholder=\"dd/mm/yyyy\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.dt1.value\" is-open=\"$ctrl.dt1.opened\"\n                  datepicker-options=\"$ctrl.dt1.options\" ng-required=\"true\" close-text=\"Cerrar\" ng-change=\"$ctrl.dt1Change()\" ui-validate=\"{max:'$ctrl.isMayorIgual(form1.fin.$viewValue,form1.inicio.$viewValue)', now:'$ctrl.isMayorIgual($ctrl.fecha,form1.inicio.$viewValue)'}\" ui-validate-watch=\"'form1.fin.$viewValue'\" />\n                <span class=\"input-group-btn\">\n                  <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.dt1Open()\"><i class=\"fa fa-calendar\"></i></button>\n                </span>\n              </div>\n              <div ap-error ng-messages=\"form1.inicio.$error\" role=\"alert\" ng-if=\"form1.inicio.$touched\">\n                <div ng-message=\"required\">El campo es requerido</div>\n                <div ng-message=\"date\">El formato debe ser dd/mm/yyyy</div>\n                <div ng-message=\"max\">La fecha no debe ser mayor a la fecha final</div>\n                <div ng-message=\"now\">La fecha no debe ser mayor a la fecha actual</div>\n              </div>\n            </div>\n            <div class=\"col-md-6 form-group\">\n              <label>Fecha Final</label>\n              <div class=\"input-group\">\n                <input type=\"text\" name=\"fin\" placeholder=\"dd/mm/yyyy\" class=\"form-control\" uib-datepicker-popup ng-model=\"$ctrl.dt2.value\" is-open=\"$ctrl.dt2.opened\"\n                  datepicker-options=\"$ctrl.dt2.options\" ng-required=\"true\" close-text=\"Cerrar\" ng-change=\"$ctrl.dt2Change()\" ui-validate=\"{min:'$ctrl.isMayorIgual(form1.fin.$viewValue,form1.inicio.$viewValue)', now:'$ctrl.isMayorIgual($ctrl.fecha,form1.fin.$viewValue)'}\" ui-validate-watch=\"'form1.inicio.$viewValue'\" />\n                <span class=\"input-group-btn\">\n                  <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.dt2Open()\"><i class=\"fa fa-calendar\"></i></button>\n                </span>\n              </div>\n              <div ap-error ng-messages=\"form1.fin.$error\" role=\"alert\" ng-if=\"form1.fin.$touched || form1.dirty\">\n                <div ng-message=\"required\">El campo es requerido</div>\n                <div ng-message=\"date\">El formato debe ser dd/mm/yyyy</div>\n                <div ng-message=\"min\">La fecha no debe ser menor a la fecha inicial</div>\n                <div ng-message=\"now\">La fecha no debe ser mayor a la fecha actual</div>\n              </div>\n            </div>\n            <div ng-if=\"$ctrl.rol==2\">\n                <div class=\"checkbox\" style=\"padding-left: 20px\">\n                  <label>\n                    <input type=\"checkbox\" ng-model=\"$ctrl.incluyeMigrados\"> Incluir unidades productivas migradas\n                  </label>\n                </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"alert alert-warning\">\n          <i class=\"fa fa-info-circle\"></i><strong> Características del archivo</strong>\n          <br>Conjunto de caracteres Unicode (UTF-8)\n          <br>El separador usado es el caracter \"|\" (barra vertical, pipe o tuberia)\n        </div>\n      </form>\n      <!--\n      <div class=\"alert alert-danger\">\n        <i class=\"fa fa-info-circle\"></i>\n      </div>\n      -->\n      <div class=\"card-container text-center\">\n        <!-- <div class=\"card\" ng-repeat=\"formulario in $ctrl.formularios\"> -->\n        <div class=\"card\">\n          <div class=\"card-img-top badge-info\">\n            <div class=\"img-form\"></div>\n          </div>\n          <div class=\"card-block\">\n            <h4 class=\"card-title text-center text-primary\" ng-click=\"$ctrl.atras()\">Archivo CSV</h4>\n            <!-- <p>{{ formulario.nombre }}</p> -->\n\n            <i class=\"fa fa-file-text-o\"></i>\n            <!-- <span><a href=\"\" ng-click=\"$ctrl.descargarManual(formulario.tipo)\" class=\"text-primary\" title=\"Descargar archivo CSV del \"><small> <i class=\"fa fa-file-pdf-o\"></i> Archivo CSV</small></a></span> -->\n          </div>\n          <button md-effect class=\"btn btn-primary btn-block btn-lg\" ng-click=\"$ctrl.descargarCsv(form1)\" type=\"button\" nng-disabled=\"form1.$invalid\">\n            <i class=\"fa fa-check-circle\"></i> Descargar\n          </button>\n        </div>\n      </div>\n      <div class=\"btn-container text-right\" ng-if=\"false\">\n        <button md-effect class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.atras()\">\n          <i class=\"fa fa-angle-double-left\"></i> Volver a matrículas\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <h2 class=\"page-title\"><i class=\"fa fa-table\"></i> Bandeja de sellos</h2>\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <crud-table url=\"$ctrl.solicitudes.url\"\n                  data=\"$ctrl.solicitudes.data\"\n                  fields=\"$ctrl.solicitudes.fields\"\n                  permission=\"$ctrl.solicitudes.permission\"\n                  event-edit=\"$ctrl.solicitudes.eventEdit\"\n                  event-delete=\"$ctrl.solicitudes.eventDelete\"\n                  buttons-top=\"$ctrl.solicitudes.buttonsTop\"\n                  buttons=\"$ctrl.solicitudes.buttons\"\n                  labels=\"$ctrl.solicitudes.labels\"\n                  fks=\"$ctrl.solicitudes.fks\"\n                  update=\"$ctrl.solicitudes.update\"\n                  delete=\"$ctrl.solicitudes.delete\"\n                  clases=\"$ctrl.solicitudes.clases\"\n                  hidden-fields=\"$ctrl.solicitudes.hiddenFields\">        \n                  <!-- event-create=\"$ctrl.solicitudes.eventCreate\" -->\n      </crud-table>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"sello_form\">\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title\">Solicitud de autorización de sello \"Hecho en Bolivia\" <span ng-show=\"$ctrl.producto\"> para {{$ctrl.producto.nombre_producto.toLowerCase()}}</span></h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body modal-ubicacion-body\">\n    <div class=\"alert alert-info-second\" ng-if=\"$ctrl.unidades.length\">\n        <i class=\"fa fa-info-circle\"></i> Clic en \" <i class=\"fa fa-gg-circle\"></i> CREAR AUTORIZACION\"  para proceder con la solicitud del sello para un nuevo producto.\n        <br /><small>Nota.- En la bandeja solo se encuentran los registros de certificados vigentes de ProBolivia.</small>\n        <br /><small>Al hacer click en una opción se usará los datos de su unidad productiva correspondiente</small>\n    </div>\n\n    <!-- <div class=\"card-container mb-5\" ng-if=\"$ctrl.unidades.length\">\n        <crud-table url=\"$ctrl.conf_cert.url\"\n            query-extra=\"$ctrl.conf_cert.queryExtra\"\n            data=\"$ctrl.conf_cert.data\"\n            fields=\"$ctrl.conf_cert.fields\"\n            permission=\"$ctrl.conf_cert.permission\"\n            buttons=\"$ctrl.conf_cert.buttons\"\n            labels=\"$ctrl.conf_cert.labels\"\n            fks=\"$ctrl.conf_cert.fks\"\n            hidden-fields=\"$ctrl.conf_cert.hiddenFields\">\n        </crud-table>\n    </div> -->\n    <div class=\"card-container text-center\" ng-if=\"$ctrl.unidades.length\">\n      <div class=\"card\" ng-repeat=\"unidad in $ctrl.unidades\">\n        <div class=\"card-img-top badge-info text-center\">\n          <div>\n            <div class=\"img-empresa\"></div>\n          </div>\n          <strong>{{unidad.razon_social}}</strong>\n        </div>\n        <div class=\"card-block text-left\">\n          <!-- <h4 class=\"card-title\">{{ unidad.razon_social }}</h4> -->\n          <div ng-if=\"unidad.nit_matricula\" ng-hide=\"unidad.nit_matricula == 'null - null'\">\n            <strong>NIT - Matrícula: </strong><br> <span>{{ unidad.nit_matricula }}</span>\n          </div>\n          <div ng-if=\"unidad.representante\">\n            <strong>Representante: </strong><br> <span>{{ unidad.representante }}</span>\n          </div>\n          <br><br>\n        </div>\n        <button md-effect type=\"button\" ng-click=\"$ctrl.crearSolicitud(unidad.nit_matricula)\" class=\"btn btn-primary btn-block btn-lg\">\n          <!-- <i class=\"fa fa-check-circle\"></i> Usar datos -->\n          <i class=\"fa fa-gg-circle\"></i> Crear Autorización\n        </button>\n      </div>\n    </div>\n\n  </div>\n\n  <div class=\"modal-body modal-ubicacion-body\" ng-if=\"$ctrl.unidades.length===0\">\n    <div class=\"alert alert-info\" ng-if=\"!$ctrl.matriculas\">\n        <i class=\"fa fa-info-circle\"></i>\n        <span ng-if=\"$ctrl.usuario.nit && !$ctrl.matriculas\">\n          No se escontraron matrículas y usted no tiene certifificaciones vigentes en PROBOLIVIA, para solicitar su sello deberá:\n        </span>\n        <span ng-if=\"!$ctrl.usuario.nit && !$ctrl.matriculas\">\n          Usted no tiene certifificaciones vigentes en PROBOLIVIA, para solicitar su sello deberá:\n        </span>\n        <ol>\n            <li>Llenar un formulario con los datos de su empresa</li>\n            <li>Llenar un formulario con datos del producto para el cual quiere el sello</li>\n        </ol>\n        Para proceder con los pasos haga clic en aceptar\n    </div>\n    <div class=\"card-container\" ng-if=\"$ctrl.matriculas\">\n      <div class=\"alert alert-info\">\n          <i class=\"fa fa-info-circle\"></i>\n          <span ng-if=\"$ctrl.matriculas.length==1\">\n            Se encontró la siguiente matrícula para crear la solicitud, usted deberá:\n          </span>\n          <span ng-if=\"$ctrl.matriculas.length>1\">\n            Se encontraron las siguientes matrículas para crear la solicitud, usted deberá:\n          </span>\n\n          <ol>\n            <li>Llenar un formulario con los datos faltantes de su empresa</li>\n            <li>Llenar un formulario con datos del producto para el cual quiere el sello</li>\n          </ol>\n\n          Haga clic en el boton registrar de la matrícula con la que desea continuar.\n      </div>\n      <div class=\"text-center\">\n        <div class=\"card\" ng-repeat=\"matricula in $ctrl.matriculas\">\n          <div class=\"card-img-top badge-info\">\n              <div class=\"img-empresa\"></div> <strong>MATRÍCULA: <br> <span>{{ matricula.matricula }}</span></strong>\n          </div>\n          <div class=\"card-block\">\n              <h4 class=\"card-title\">{{ matricula.razon_social }}</h4>\n          </div>\n          <button md-effect type=\"button\" ng-click=\"$ctrl.crearSolicitud(matricula.matricula)\" class=\"btn btn-primary btn-block btn-lg\">\n              <i class=\"fa fa-check-circle\"></i> Crear una autorizacion\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n      <i class=\"fa fa-close\"></i>  {{$ctrl.modo_solo_shb? 'Cancelar':'Cerrar'}}\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.aceptar()\" ng-if=\"$ctrl.modo_solo_shb && !$ctrl.matriculas\">\n      <i class=\"fa fa-check\"></i> Aceptar\n    </button>\n  </div>\n</ng-form>\n"

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = "<ng-form name=\"sello_form\">\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title\">Solicitud de sello \"Hecho en Bolivia\" para {{$ctrl.producto.nombre_producto.toLowerCase()}}</h5>\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$ctrl.cancel()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body modal-ubicacion-body\">\n    <div class=\"row\">\n      <div class=\"col md-8\">\n        <div class=\"alert alert-danger\" ng-if=\"$ctrl.producto.observaciones_certificacion\">\n            <h4><i class=\"fa fa-warning\"></i> OBSERVACIONES</h4>\n            {{ $ctrl.producto.observaciones_certificacion }}\n        </div>\n        <div class=\"alert alert-info\">\n          <i class=\"fa fa-info-circle\"></i> Una vez completada la solicitud, en 2 dias hábiles se le enviará su certificado al correo electrónico registrado.\n        </div>\n        <div class=\"form-group\">\n          <label class=\"ap-req\">El sello Hecho en Bolivia se aplicará a:</label>\n        </div>\n        <div ng-repeat=\"lugar in $ctrl.opciones_lugar\">\n          <label class=\"custom-control custom-checkbox mb-3\">\n            <input type=\"checkbox\" class=\"custom-control-input\" name=\"lugar_sello{{$index}}\" ng-model=\"$ctrl.producto['lugar_sello'+$index]\">\n            <span class=\"custom-control-indicator\"></span>\n            <span class=\"custom-control-description\">{{lugar}}</span>\n          </label>\n        </div>\n        \n        <div class=\"form-group\">\n          <label>Otro lugar:</label>\n          <input name=\"lugar_sello_otro\" alpha-dash maxlength=\"100\" class=\"form-control\" ng-model=\"$ctrl.producto.lugar_sello_otro\">\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button md-effect type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.cancel()\">\n      <i class=\"fa fa-close\"></i> Cerrar\n    </button>\n    <button md-effect type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.save(sello_form)\">\n      <i class=\"fa fa-check\"></i> Guardar\n    </button>\n  </div>\n</ng-form>\n"

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n    <h2 class=\"page-title\"><i class=\"fa fa-user\"></i> Solicitud de autorización de sello \"Hecho en Bolivia\"</h2>\n    <div class=\"card card-main\">\n        <div class=\"card-block\">\n            <div class=\"alert alert-info\" ng-if=\"$ctrl.productos.length\">\n                <i class=\"fa fa-info-circle\"></i> Clic en el icono <if class=\"fa fa-gg-circle\"></if> para proceder con la solicitud del sello para su producto seleccionado.\n                <br /><small>Nota.- En la bandeja solo se encuentran los productos aprobados por Promueve Bolivia.</small>\n                <br /><small>Al hacer click en una fila se usarán los datos del producto aprobado y la unidad productiva correspondiente.</small>\n            </div>\n            <!-- <div class=\"alert alert-danger\" ng-if=\"!$ctrl.productos.length\">\n                <i class=\"fa fa-warn-circle\"></i> Aun no tiene productos aprobados en promueve.\n            </div> -->\n            <div class=\"card-container\" ng-if=\"$ctrl.confProd\">\n                <!-- <crud-table url=\"$ctrl.confProd.url\"\n                    query-extra=\"$ctrl.confProd.queryExtra\"\n                    data=\"$ctrl.confProd.data\"\n                    fields=\"$ctrl.confProd.fields\"\n                    labels=\"$ctrl.confProd.labels\"\n                    permission=\"$ctrl.confProd.permission\"\n                    event-create=\"$ctrl.confProd.eventCreate\"\n                    buttons=\"$ctrl.confProd.buttons\"\n                    fks=\"$ctrl.confProd.fks\"\n                    hidden-fields=\"$ctrl.confProd.hiddenFields\">\n                </crud-table> -->\n            </div>\n        </div>\n\n        <!-- <div class=\"card-block\" ng-if=\"$ctrl.casoSelloBolivia==1\">\n            <div class=\"alert alert-info\">\n                <i class=\"fa fa-info-circle\"></i> Usted no tiene registros en PROBOLIVIA ni en PROMUEVE, para solicitar su sello deberá:\n                <br /> \n                <ol>\n                    <li>Llenar un formulario con los datos de su empresa</li>\n                    <li>Llenar un formulario con datos del producto par ael cual quiere el sello</li>\n                </ol>\n                <br /> Para proceder con los pasos haga click en Siguiente\n            </div>\n\n            <div class=\"card-footer text-right\">\n                <button type=\"button\" class=\"btn btn-dafault ap-c-pointer\" ng-click=\"$ctrl.irBandeja()\">\n                <i class=\"fa fa-angle-double-left\"></i> Ir a bandeja de sellos\n                </button>\n                <button type=\"button\" class=\"btn btn-primary ap-c-pointer\" ng-click=\"$ctrl.irFormSello()\">\n                    Siguiente\n                    <i class=\"fa fa-angle-double-right\"></i>\n                </button>\n            </div>\n        </div> -->\n    </div>\n</div>"

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/* global window */
	/* global angular */
	/* global module */
	
	(function (module, window, angular) {
	    "use strict";
	
	    function test(string, regex) {
	        if (typeof regex === 'string' || regex instanceof String) {
	            regex=new RegExp(regex);
	        }
	
	        if (regex instanceof RegExp) {
	            return regex.test(string);
	        }
	        else if (regex && Array.isArray(regex.and)) {
	            return regex.and.every(function (item) {
	                return test(string, item);
	            });
	        }
	        else if (regex && Array.isArray(regex.or)) {
	            return regex.or.some(function (item) {
	                return test(string, item);
	            });
	        }
	        else if (regex && regex.not) {
	            return !test(string, regex.not);
	        }
	        else {
	            return false;
	        }
	    }
	
	    function exec(string, regex) {
	        if (typeof regex === 'string' || regex instanceof String) {
	            regex=new RegExp(regex);
	        }
	
	        if (regex instanceof RegExp) {
	            return regex.exec(string);
	        }
	        else if (regex && Array.isArray(regex)) {
	            return regex.reduce(function (res, item) {
	                return (!!res) ? res : exec(string, item);
	            }, null);
	        }
	        else {
	            return null;
	        }
	    }
	
	    if (!!angular) {
	        angular.module("reTree", []).factory("reTree", [function () {
	            return {
	                test: test,
	                exec: exec
	            };
	        }]);
	    }
	
	    if (!!window) {
	        window.reTree = {
	            test: test,
	            exec: exec
	        };
	    }
	
	    if (!!module) {
	        module.exports = {
	            test: test,
	            exec: exec
	        };
	    }
	})( false ? null : module, typeof window === 'undefined' ? null : window, typeof angular === 'undefined' ? null : angular);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)(module)))

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(96);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(19));
	util.inherits = __webpack_require__(20);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(32).Buffer;
	var util = __webpack_require__(677);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(95);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(97);
	exports.Duplex = __webpack_require__(15);
	exports.Transform = __webpack_require__(96);
	exports.PassThrough = __webpack_require__(656);


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(658).Transform


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Satellizer 0.15.5
	 * (c) 2016 Sahat Yalkabov 
	 * License: MIT 
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.satellizer = factory());
	}(this, function () { 'use strict';
	
	    var Config = (function () {
	        function Config() {
	            this.baseUrl = '/';
	            this.loginUrl = '/auth/login';
	            this.signupUrl = '/auth/signup';
	            this.unlinkUrl = '/auth/unlink/';
	            this.tokenName = 'token';
	            this.tokenPrefix = 'satellizer';
	            this.tokenHeader = 'Authorization';
	            this.tokenType = 'Bearer';
	            this.storageType = 'localStorage';
	            this.tokenRoot = null;
	            this.withCredentials = false;
	            this.providers = {
	                facebook: {
	                    name: 'facebook',
	                    url: '/auth/facebook',
	                    authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
	                    redirectUri: window.location.origin + '/',
	                    requiredUrlParams: ['display', 'scope'],
	                    scope: ['email'],
	                    scopeDelimiter: ',',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 580, height: 400 }
	                },
	                google: {
	                    name: 'google',
	                    url: '/auth/google',
	                    authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    optionalUrlParams: ['display', 'state'],
	                    scope: ['profile', 'email'],
	                    scopePrefix: 'openid',
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 452, height: 633 },
	                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
	                },
	                github: {
	                    name: 'github',
	                    url: '/auth/github',
	                    authorizationEndpoint: 'https://github.com/login/oauth/authorize',
	                    redirectUri: window.location.origin,
	                    optionalUrlParams: ['scope'],
	                    scope: ['user:email'],
	                    scopeDelimiter: ' ',
	                    oauthType: '2.0',
	                    popupOptions: { width: 1020, height: 618 }
	                },
	                instagram: {
	                    name: 'instagram',
	                    url: '/auth/instagram',
	                    authorizationEndpoint: 'https://api.instagram.com/oauth/authorize',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    scope: ['basic'],
	                    scopeDelimiter: '+',
	                    oauthType: '2.0'
	                },
	                linkedin: {
	                    name: 'linkedin',
	                    url: '/auth/linkedin',
	                    authorizationEndpoint: 'https://www.linkedin.com/uas/oauth2/authorization',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['state'],
	                    scope: ['r_emailaddress'],
	                    scopeDelimiter: ' ',
	                    state: 'STATE',
	                    oauthType: '2.0',
	                    popupOptions: { width: 527, height: 582 }
	                },
	                twitter: {
	                    name: 'twitter',
	                    url: '/auth/twitter',
	                    authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
	                    redirectUri: window.location.origin,
	                    oauthType: '1.0',
	                    popupOptions: { width: 495, height: 645 }
	                },
	                twitch: {
	                    name: 'twitch',
	                    url: '/auth/twitch',
	                    authorizationEndpoint: 'https://api.twitch.tv/kraken/oauth2/authorize',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    scope: ['user_read'],
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 560 }
	                },
	                live: {
	                    name: 'live',
	                    url: '/auth/live',
	                    authorizationEndpoint: 'https://login.live.com/oauth20_authorize.srf',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['display', 'scope'],
	                    scope: ['wl.emails'],
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 560 }
	                },
	                yahoo: {
	                    name: 'yahoo',
	                    url: '/auth/yahoo',
	                    authorizationEndpoint: 'https://api.login.yahoo.com/oauth2/request_auth',
	                    redirectUri: window.location.origin,
	                    scope: [],
	                    scopeDelimiter: ',',
	                    oauthType: '2.0',
	                    popupOptions: { width: 559, height: 519 }
	                },
	                bitbucket: {
	                    name: 'bitbucket',
	                    url: '/auth/bitbucket',
	                    authorizationEndpoint: 'https://bitbucket.org/site/oauth2/authorize',
	                    redirectUri: window.location.origin + '/',
	                    requiredUrlParams: ['scope'],
	                    scope: ['email'],
	                    scopeDelimiter: ' ',
	                    oauthType: '2.0',
	                    popupOptions: { width: 1028, height: 529 }
	                },
	                spotify: {
	                    name: 'spotify',
	                    url: '/auth/spotify',
	                    authorizationEndpoint: 'https://accounts.spotify.com/authorize',
	                    redirectUri: window.location.origin,
	                    optionalUrlParams: ['state'],
	                    requiredUrlParams: ['scope'],
	                    scope: ['user-read-email'],
	                    scopePrefix: '',
	                    scopeDelimiter: ',',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 530 },
	                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
	                }
	            };
	            this.httpInterceptor = function () { return true; };
	        }
	        Object.defineProperty(Config, "getConstant", {
	            get: function () {
	                return new Config();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return Config;
	    }());
	    ;
	
	    var AuthProvider = (function () {
	        function AuthProvider(SatellizerConfig) {
	            this.SatellizerConfig = SatellizerConfig;
	        }
	        Object.defineProperty(AuthProvider.prototype, "baseUrl", {
	            get: function () { return this.SatellizerConfig.baseUrl; },
	            set: function (value) { this.SatellizerConfig.baseUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "loginUrl", {
	            get: function () { return this.SatellizerConfig.loginUrl; },
	            set: function (value) { this.SatellizerConfig.loginUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "signupUrl", {
	            get: function () { return this.SatellizerConfig.signupUrl; },
	            set: function (value) { this.SatellizerConfig.signupUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "unlinkUrl", {
	            get: function () { return this.SatellizerConfig.unlinkUrl; },
	            set: function (value) { this.SatellizerConfig.unlinkUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenRoot", {
	            get: function () { return this.SatellizerConfig.tokenRoot; },
	            set: function (value) { this.SatellizerConfig.tokenRoot = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenName", {
	            get: function () { return this.SatellizerConfig.tokenName; },
	            set: function (value) { this.SatellizerConfig.tokenName = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenPrefix", {
	            get: function () { return this.SatellizerConfig.tokenPrefix; },
	            set: function (value) { this.SatellizerConfig.tokenPrefix = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenHeader", {
	            get: function () { return this.SatellizerConfig.tokenHeader; },
	            set: function (value) { this.SatellizerConfig.tokenHeader = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenType", {
	            get: function () { return this.SatellizerConfig.tokenType; },
	            set: function (value) { this.SatellizerConfig.tokenType = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "withCredentials", {
	            get: function () { return this.SatellizerConfig.withCredentials; },
	            set: function (value) { this.SatellizerConfig.withCredentials = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "storageType", {
	            get: function () { return this.SatellizerConfig.storageType; },
	            set: function (value) { this.SatellizerConfig.storageType = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "httpInterceptor", {
	            get: function () { return this.SatellizerConfig.httpInterceptor; },
	            set: function (value) {
	                if (typeof value === 'function') {
	                    this.SatellizerConfig.httpInterceptor = value;
	                }
	                else {
	                    this.SatellizerConfig.httpInterceptor = function () { return value; };
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        AuthProvider.prototype.facebook = function (options) {
	            angular.extend(this.SatellizerConfig.providers.facebook, options);
	        };
	        AuthProvider.prototype.google = function (options) {
	            angular.extend(this.SatellizerConfig.providers.google, options);
	        };
	        AuthProvider.prototype.github = function (options) {
	            angular.extend(this.SatellizerConfig.providers.github, options);
	        };
	        AuthProvider.prototype.instagram = function (options) {
	            angular.extend(this.SatellizerConfig.providers.instagram, options);
	        };
	        AuthProvider.prototype.linkedin = function (options) {
	            angular.extend(this.SatellizerConfig.providers.linkedin, options);
	        };
	        AuthProvider.prototype.twitter = function (options) {
	            angular.extend(this.SatellizerConfig.providers.twitter, options);
	        };
	        AuthProvider.prototype.twitch = function (options) {
	            angular.extend(this.SatellizerConfig.providers.twitch, options);
	        };
	        AuthProvider.prototype.live = function (options) {
	            angular.extend(this.SatellizerConfig.providers.live, options);
	        };
	        AuthProvider.prototype.yahoo = function (options) {
	            angular.extend(this.SatellizerConfig.providers.yahoo, options);
	        };
	        AuthProvider.prototype.bitbucket = function (options) {
	            angular.extend(this.SatellizerConfig.providers.bitbucket, options);
	        };
	        AuthProvider.prototype.spotify = function (options) {
	            angular.extend(this.SatellizerConfig.providers.spotify, options);
	        };
	        AuthProvider.prototype.oauth1 = function (options) {
	            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
	                oauthType: '1.0'
	            });
	        };
	        AuthProvider.prototype.oauth2 = function (options) {
	            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
	                oauthType: '2.0'
	            });
	        };
	        AuthProvider.prototype.$get = function (SatellizerShared, SatellizerLocal, SatellizerOAuth) {
	            return {
	                login: function (user, options) { return SatellizerLocal.login(user, options); },
	                signup: function (user, options) { return SatellizerLocal.signup(user, options); },
	                logout: function () { return SatellizerShared.logout(); },
	                authenticate: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
	                link: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
	                unlink: function (name, options) { return SatellizerOAuth.unlink(name, options); },
	                isAuthenticated: function () { return SatellizerShared.isAuthenticated(); },
	                getPayload: function () { return SatellizerShared.getPayload(); },
	                getToken: function () { return SatellizerShared.getToken(); },
	                setToken: function (token) { return SatellizerShared.setToken({ access_token: token }); },
	                removeToken: function () { return SatellizerShared.removeToken(); },
	                setStorageType: function (type) { return SatellizerShared.setStorageType(type); }
	            };
	        };
	        AuthProvider.$inject = ['SatellizerConfig'];
	        return AuthProvider;
	    }());
	    AuthProvider.prototype.$get.$inject = ['SatellizerShared', 'SatellizerLocal', 'SatellizerOAuth'];
	
	    function joinUrl(baseUrl, url) {
	        if (/^(?:[a-z]+:)?\/\//i.test(url)) {
	            return url;
	        }
	        var joined = [baseUrl, url].join('/');
	        var normalize = function (str) {
	            return str
	                .replace(/[\/]+/g, '/')
	                .replace(/\/\?/g, '?')
	                .replace(/\/\#/g, '#')
	                .replace(/\:\//g, '://');
	        };
	        return normalize(joined);
	    }
	    function getFullUrlPath(location) {
	        var isHttps = location.protocol === 'https:';
	        return location.protocol + '//' + location.hostname +
	            ':' + (location.port || (isHttps ? '443' : '80')) +
	            (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname);
	    }
	    function parseQueryString(str) {
	        var obj = {};
	        var key;
	        var value;
	        angular.forEach((str || '').split('&'), function (keyValue) {
	            if (keyValue) {
	                value = keyValue.split('=');
	                key = decodeURIComponent(value[0]);
	                obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
	            }
	        });
	        return obj;
	    }
	    function decodeBase64(str) {
	        var buffer;
	        if (typeof module !== 'undefined' && module.exports) {
	            try {
	                buffer = __webpack_require__(12).Buffer;
	            }
	            catch (err) {
	            }
	        }
	        var fromCharCode = String.fromCharCode;
	        var re_btou = new RegExp([
	            '[\xC0-\xDF][\x80-\xBF]',
	            '[\xE0-\xEF][\x80-\xBF]{2}',
	            '[\xF0-\xF7][\x80-\xBF]{3}'
	        ].join('|'), 'g');
	        var cb_btou = function (cccc) {
	            switch (cccc.length) {
	                case 4:
	                    var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
	                        | ((0x3f & cccc.charCodeAt(1)) << 12)
	                        | ((0x3f & cccc.charCodeAt(2)) << 6)
	                        | (0x3f & cccc.charCodeAt(3));
	                    var offset = cp - 0x10000;
	                    return (fromCharCode((offset >>> 10) + 0xD800)
	                        + fromCharCode((offset & 0x3FF) + 0xDC00));
	                case 3:
	                    return fromCharCode(((0x0f & cccc.charCodeAt(0)) << 12)
	                        | ((0x3f & cccc.charCodeAt(1)) << 6)
	                        | (0x3f & cccc.charCodeAt(2)));
	                default:
	                    return fromCharCode(((0x1f & cccc.charCodeAt(0)) << 6)
	                        | (0x3f & cccc.charCodeAt(1)));
	            }
	        };
	        var btou = function (b) {
	            return b.replace(re_btou, cb_btou);
	        };
	        var _decode = buffer ? function (a) {
	            return (a.constructor === buffer.constructor
	                ? a : new buffer(a, 'base64')).toString();
	        }
	            : function (a) {
	                return btou(atob(a));
	            };
	        return _decode(String(str).replace(/[-_]/g, function (m0) {
	            return m0 === '-' ? '+' : '/';
	        })
	            .replace(/[^A-Za-z0-9\+\/]/g, ''));
	    }
	
	    var Shared = (function () {
	        function Shared($q, $window, SatellizerConfig, SatellizerStorage) {
	            this.$q = $q;
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerStorage = SatellizerStorage;
	            var _a = this.SatellizerConfig, tokenName = _a.tokenName, tokenPrefix = _a.tokenPrefix;
	            this.prefixedTokenName = tokenPrefix ? [tokenPrefix, tokenName].join('_') : tokenName;
	        }
	        Shared.prototype.getToken = function () {
	            return this.SatellizerStorage.get(this.prefixedTokenName);
	        };
	        Shared.prototype.getPayload = function () {
	            var token = this.SatellizerStorage.get(this.prefixedTokenName);
	            if (token && token.split('.').length === 3) {
	                try {
	                    var base64Url = token.split('.')[1];
	                    var base64 = base64Url.replace('-', '+').replace('_', '/');
	                    return JSON.parse(decodeBase64(base64));
	                }
	                catch (e) {
	                }
	            }
	        };
	        Shared.prototype.setToken = function (response) {
	            var tokenRoot = this.SatellizerConfig.tokenRoot;
	            var tokenName = this.SatellizerConfig.tokenName;
	            var accessToken = response && response.access_token;
	            var token;
	            if (accessToken) {
	                if (angular.isObject(accessToken) && angular.isObject(accessToken.data)) {
	                    response = accessToken;
	                }
	                else if (angular.isString(accessToken)) {
	                    token = accessToken;
	                }
	            }
	            if (!token && response) {
	                var tokenRootData = tokenRoot && tokenRoot.split('.').reduce(function (o, x) { return o[x]; }, response.data);
	                token = tokenRootData ? tokenRootData[tokenName] : response.data && response.data[tokenName];
	            }
	            if (token) {
	                this.SatellizerStorage.set(this.prefixedTokenName, token);
	            }
	        };
	        Shared.prototype.removeToken = function () {
	            this.SatellizerStorage.remove(this.prefixedTokenName);
	        };
	        Shared.prototype.isAuthenticated = function () {
	            var token = this.SatellizerStorage.get(this.prefixedTokenName);
	            if (token) {
	                if (token.split('.').length === 3) {
	                    try {
	                        var base64Url = token.split('.')[1];
	                        var base64 = base64Url.replace('-', '+').replace('_', '/');
	                        var exp = JSON.parse(this.$window.atob(base64)).exp;
	                        if (typeof exp === 'number') {
	                            return Math.round(new Date().getTime() / 1000) < exp;
	                        }
	                    }
	                    catch (e) {
	                        return true; // Pass: Non-JWT token that looks like JWT
	                    }
	                }
	                return true; // Pass: All other tokens
	            }
	            return false; // Fail: No token at all
	        };
	        Shared.prototype.logout = function () {
	            this.SatellizerStorage.remove(this.prefixedTokenName);
	            return this.$q.when();
	        };
	        Shared.prototype.setStorageType = function (type) {
	            this.SatellizerConfig.storageType = type;
	        };
	        Shared.$inject = ['$q', '$window', 'SatellizerConfig', 'SatellizerStorage'];
	        return Shared;
	    }());
	
	    var Local = (function () {
	        function Local($http, SatellizerConfig, SatellizerShared) {
	            this.$http = $http;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerShared = SatellizerShared;
	        }
	        Local.prototype.login = function (user, options) {
	            var _this = this;
	            if (options === void 0) { options = {}; }
	            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.loginUrl);
	            options.data = user || options.data;
	            options.method = options.method || 'POST';
	            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(options).then(function (response) {
	                _this.SatellizerShared.setToken(response);
	                return response;
	            });
	        };
	        Local.prototype.signup = function (user, options) {
	            if (options === void 0) { options = {}; }
	            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.signupUrl);
	            options.data = user || options.data;
	            options.method = options.method || 'POST';
	            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(options);
	        };
	        Local.$inject = ['$http', 'SatellizerConfig', 'SatellizerShared'];
	        return Local;
	    }());
	
	    var Popup = (function () {
	        function Popup($interval, $window, $q) {
	            this.$interval = $interval;
	            this.$window = $window;
	            this.$q = $q;
	            this.popup = null;
	            this.defaults = {
	                redirectUri: null
	            };
	        }
	        Popup.prototype.stringifyOptions = function (options) {
	            var parts = [];
	            angular.forEach(options, function (value, key) {
	                parts.push(key + '=' + value);
	            });
	            return parts.join(',');
	        };
	        Popup.prototype.open = function (url, name, popupOptions, redirectUri, dontPoll) {
	            var width = popupOptions.width || 500;
	            var height = popupOptions.height || 500;
	            var options = this.stringifyOptions({
	                width: width,
	                height: height,
	                top: this.$window.screenY + ((this.$window.outerHeight - height) / 2.5),
	                left: this.$window.screenX + ((this.$window.outerWidth - width) / 2)
	            });
	            var popupName = this.$window['cordova'] || this.$window.navigator.userAgent.indexOf('CriOS') > -1 ? '_blank' : name;
	            this.popup = this.$window.open(url, popupName, options);
	            if (this.popup && this.popup.focus) {
	                this.popup.focus();
	            }
	            if (dontPoll) {
	                return;
	            }
	            if (this.$window['cordova']) {
	                return this.eventListener(redirectUri);
	            }
	            else {
	                if (url === 'about:blank') {
	                    this.popup.location = url;
	                }
	                return this.polling(redirectUri);
	            }
	        };
	        Popup.prototype.polling = function (redirectUri) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                var redirectUriParser = document.createElement('a');
	                redirectUriParser.href = redirectUri;
	                var redirectUriPath = getFullUrlPath(redirectUriParser);
	                var polling = _this.$interval(function () {
	                    if (!_this.popup || _this.popup.closed || _this.popup.closed === undefined) {
	                        _this.$interval.cancel(polling);
	                        reject(new Error('The popup window was closed'));
	                    }
	                    try {
	                        var popupWindowPath = getFullUrlPath(_this.popup.location);
	                        if (popupWindowPath === redirectUriPath) {
	                            if (_this.popup.location.search || _this.popup.location.hash) {
	                                var query = parseQueryString(_this.popup.location.search.substring(1).replace(/\/$/, ''));
	                                var hash = parseQueryString(_this.popup.location.hash.substring(1).replace(/[\/$]/, ''));
	                                var params = angular.extend({}, query, hash);
	                                if (params.error) {
	                                    reject(new Error(params.error));
	                                }
	                                else {
	                                    resolve(params);
	                                }
	                            }
	                            else {
	                                reject(new Error('OAuth redirect has occurred but no query or hash parameters were found. ' +
	                                    'They were either not set during the redirect, or were removed—typically by a ' +
	                                    'routing library—before Satellizer could read it.'));
	                            }
	                            _this.$interval.cancel(polling);
	                            _this.popup.close();
	                        }
	                    }
	                    catch (error) {
	                    }
	                }, 500);
	            });
	        };
	        Popup.prototype.eventListener = function (redirectUri) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                _this.popup.addEventListener('loadstart', function (event) {
	                    if (event.url.indexOf(redirectUri) !== 0) {
	                        return;
	                    }
	                    var parser = document.createElement('a');
	                    parser.href = event.url;
	                    if (parser.search || parser.hash) {
	                        var query = parseQueryString(parser.search.substring(1).replace(/\/$/, ''));
	                        var hash = parseQueryString(parser.hash.substring(1).replace(/[\/$]/, ''));
	                        var params = angular.extend({}, query, hash);
	                        if (params.error) {
	                            reject(new Error(params.error));
	                        }
	                        else {
	                            resolve(params);
	                        }
	                        _this.popup.close();
	                    }
	                });
	                _this.popup.addEventListener('loaderror', function () {
	                    reject(new Error('Authorization failed'));
	                });
	                _this.popup.addEventListener('exit', function () {
	                    reject(new Error('The popup window was closed'));
	                });
	            });
	        };
	        Popup.$inject = ['$interval', '$window', '$q'];
	        return Popup;
	    }());
	
	    var OAuth1 = (function () {
	        function OAuth1($http, $window, SatellizerConfig, SatellizerPopup) {
	            this.$http = $http;
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.defaults = {
	                name: null,
	                url: null,
	                authorizationEndpoint: null,
	                scope: null,
	                scopePrefix: null,
	                scopeDelimiter: null,
	                redirectUri: null,
	                requiredUrlParams: null,
	                defaultUrlParams: null,
	                oauthType: '1.0',
	                popupOptions: { width: null, height: null }
	            };
	        }
	        ;
	        OAuth1.prototype.init = function (options, userData) {
	            var _this = this;
	            angular.extend(this.defaults, options);
	            var name = options.name, popupOptions = options.popupOptions;
	            var redirectUri = this.defaults.redirectUri;
	            // Should open an empty popup and wait until request token is received
	            if (!this.$window['cordova']) {
	                this.SatellizerPopup.open('about:blank', name, popupOptions, redirectUri, true);
	            }
	            return this.getRequestToken().then(function (response) {
	                return _this.openPopup(options, response).then(function (popupResponse) {
	                    return _this.exchangeForToken(popupResponse, userData);
	                });
	            });
	        };
	        OAuth1.prototype.openPopup = function (options, response) {
	            var url = [options.authorizationEndpoint, this.buildQueryString(response.data)].join('?');
	            var redirectUri = this.defaults.redirectUri;
	            if (this.$window['cordova']) {
	                return this.SatellizerPopup.open(url, options.name, options.popupOptions, redirectUri);
	            }
	            else {
	                this.SatellizerPopup.popup.location = url;
	                return this.SatellizerPopup.polling(redirectUri);
	            }
	        };
	        OAuth1.prototype.getRequestToken = function () {
	            var url = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
	            return this.$http.post(url, this.defaults);
	        };
	        OAuth1.prototype.exchangeForToken = function (oauthData, userData) {
	            var payload = angular.extend({}, userData, oauthData);
	            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
	            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
	        };
	        OAuth1.prototype.buildQueryString = function (obj) {
	            var str = [];
	            angular.forEach(obj, function (value, key) {
	                str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	            });
	            return str.join('&');
	        };
	        OAuth1.$inject = ['$http', '$window', 'SatellizerConfig', 'SatellizerPopup'];
	        return OAuth1;
	    }());
	
	    var OAuth2 = (function () {
	        function OAuth2($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage) {
	            this.$http = $http;
	            this.$window = $window;
	            this.$timeout = $timeout;
	            this.$q = $q;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.SatellizerStorage = SatellizerStorage;
	            this.defaults = {
	                name: null,
	                url: null,
	                clientId: null,
	                authorizationEndpoint: null,
	                redirectUri: null,
	                scope: null,
	                scopePrefix: null,
	                scopeDelimiter: null,
	                state: null,
	                requiredUrlParams: null,
	                defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
	                responseType: 'code',
	                responseParams: {
	                    code: 'code',
	                    clientId: 'clientId',
	                    redirectUri: 'redirectUri'
	                },
	                oauthType: '2.0',
	                popupOptions: { width: null, height: null }
	            };
	        }
	        OAuth2.camelCase = function (name) {
	            return name.replace(/([\:\-\_]+(.))/g, function (_, separator, letter, offset) {
	                return offset ? letter.toUpperCase() : letter;
	            });
	        };
	        OAuth2.prototype.init = function (options, userData) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                angular.extend(_this.defaults, options);
	                var stateName = _this.defaults.name + '_state';
	                var _a = _this.defaults, name = _a.name, state = _a.state, popupOptions = _a.popupOptions, redirectUri = _a.redirectUri, responseType = _a.responseType;
	                if (typeof state === 'function') {
	                    _this.SatellizerStorage.set(stateName, state());
	                }
	                else if (typeof state === 'string') {
	                    _this.SatellizerStorage.set(stateName, state);
	                }
	                var url = [_this.defaults.authorizationEndpoint, _this.buildQueryString()].join('?');
	                _this.SatellizerPopup.open(url, name, popupOptions, redirectUri).then(function (oauth) {
	                    if (responseType === 'token' || !url) {
	                        return resolve(oauth);
	                    }
	                    if (oauth.state && oauth.state !== _this.SatellizerStorage.get(stateName)) {
	                        return reject(new Error('The value returned in the state parameter does not match the state value from your original ' +
	                            'authorization code request.'));
	                    }
	                    resolve(_this.exchangeForToken(oauth, userData));
	                }).catch(function (error) { return reject(error); });
	            });
	        };
	        OAuth2.prototype.exchangeForToken = function (oauthData, userData) {
	            var _this = this;
	            var payload = angular.extend({}, userData);
	            angular.forEach(this.defaults.responseParams, function (value, key) {
	                switch (key) {
	                    case 'code':
	                        payload[value] = oauthData.code;
	                        break;
	                    case 'clientId':
	                        payload[value] = _this.defaults.clientId;
	                        break;
	                    case 'redirectUri':
	                        payload[value] = _this.defaults.redirectUri;
	                        break;
	                    default:
	                        payload[value] = oauthData[key];
	                }
	            });
	            if (oauthData.state) {
	                payload.state = oauthData.state;
	            }
	            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ?
	                joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) :
	                this.defaults.url;
	            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
	        };
	        OAuth2.prototype.buildQueryString = function () {
	            var _this = this;
	            var keyValuePairs = [];
	            var urlParamsCategories = ['defaultUrlParams', 'requiredUrlParams', 'optionalUrlParams'];
	            angular.forEach(urlParamsCategories, function (paramsCategory) {
	                angular.forEach(_this.defaults[paramsCategory], function (paramName) {
	                    var camelizedName = OAuth2.camelCase(paramName);
	                    var paramValue = angular.isFunction(_this.defaults[paramName]) ? _this.defaults[paramName]() : _this.defaults[camelizedName];
	                    if (paramName === 'redirect_uri' && !paramValue) {
	                        return;
	                    }
	                    if (paramName === 'state') {
	                        var stateName = _this.defaults.name + '_state';
	                        paramValue = encodeURIComponent(_this.SatellizerStorage.get(stateName));
	                    }
	                    if (paramName === 'scope' && Array.isArray(paramValue)) {
	                        paramValue = paramValue.join(_this.defaults.scopeDelimiter);
	                        if (_this.defaults.scopePrefix) {
	                            paramValue = [_this.defaults.scopePrefix, paramValue].join(_this.defaults.scopeDelimiter);
	                        }
	                    }
	                    keyValuePairs.push([paramName, paramValue]);
	                });
	            });
	            return keyValuePairs.map(function (pair) { return pair.join('='); }).join('&');
	        };
	        OAuth2.$inject = ['$http', '$window', '$timeout', '$q', 'SatellizerConfig', 'SatellizerPopup', 'SatellizerStorage'];
	        return OAuth2;
	    }());
	
	    var OAuth = (function () {
	        function OAuth($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage, SatellizerShared, SatellizerOAuth1, SatellizerOAuth2) {
	            this.$http = $http;
	            this.$window = $window;
	            this.$timeout = $timeout;
	            this.$q = $q;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.SatellizerStorage = SatellizerStorage;
	            this.SatellizerShared = SatellizerShared;
	            this.SatellizerOAuth1 = SatellizerOAuth1;
	            this.SatellizerOAuth2 = SatellizerOAuth2;
	        }
	        OAuth.prototype.authenticate = function (name, userData) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                var provider = _this.SatellizerConfig.providers[name];
	                var oauth = null;
	                switch (provider.oauthType) {
	                    case '1.0':
	                        oauth = new OAuth1(_this.$http, _this.$window, _this.SatellizerConfig, _this.SatellizerPopup);
	                        break;
	                    case '2.0':
	                        oauth = new OAuth2(_this.$http, _this.$window, _this.$timeout, _this.$q, _this.SatellizerConfig, _this.SatellizerPopup, _this.SatellizerStorage);
	                        break;
	                    default:
	                        return reject(new Error('Invalid OAuth Type'));
	                }
	                return oauth.init(provider, userData).then(function (response) {
	                    if (provider.url) {
	                        _this.SatellizerShared.setToken(response);
	                    }
	                    resolve(response);
	                }).catch(function (error) {
	                    reject(error);
	                });
	            });
	        };
	        OAuth.prototype.unlink = function (provider, httpOptions) {
	            if (httpOptions === void 0) { httpOptions = {}; }
	            httpOptions.url = httpOptions.url ? httpOptions.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.unlinkUrl);
	            httpOptions.data = { provider: provider } || httpOptions.data;
	            httpOptions.method = httpOptions.method || 'POST';
	            httpOptions.withCredentials = httpOptions.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(httpOptions);
	        };
	        OAuth.$inject = [
	            '$http',
	            '$window',
	            '$timeout',
	            '$q',
	            'SatellizerConfig',
	            'SatellizerPopup',
	            'SatellizerStorage',
	            'SatellizerShared',
	            'SatellizerOAuth1',
	            'SatellizerOAuth2'
	        ];
	        return OAuth;
	    }());
	
	    var Storage = (function () {
	        function Storage($window, SatellizerConfig) {
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.memoryStore = {};
	        }
	        Storage.prototype.get = function (key) {
	            try {
	                return this.$window[this.SatellizerConfig.storageType].getItem(key);
	            }
	            catch (e) {
	                return this.memoryStore[key];
	            }
	        };
	        Storage.prototype.set = function (key, value) {
	            try {
	                this.$window[this.SatellizerConfig.storageType].setItem(key, value);
	            }
	            catch (e) {
	                this.memoryStore[key] = value;
	            }
	        };
	        Storage.prototype.remove = function (key) {
	            try {
	                this.$window[this.SatellizerConfig.storageType].removeItem(key);
	            }
	            catch (e) {
	                delete this.memoryStore[key];
	            }
	        };
	        Storage.$inject = ['$window', 'SatellizerConfig'];
	        return Storage;
	    }());
	
	    var Interceptor = (function () {
	        function Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage) {
	            var _this = this;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerShared = SatellizerShared;
	            this.SatellizerStorage = SatellizerStorage;
	            this.request = function (config) {
	                if (config['skipAuthorization']) {
	                    return config;
	                }
	                if (_this.SatellizerShared.isAuthenticated() && _this.SatellizerConfig.httpInterceptor()) {
	                    var tokenName = _this.SatellizerConfig.tokenPrefix ?
	                        [_this.SatellizerConfig.tokenPrefix, _this.SatellizerConfig.tokenName].join('_') : _this.SatellizerConfig.tokenName;
	                    var token = _this.SatellizerStorage.get(tokenName);
	                    if (_this.SatellizerConfig.tokenHeader && _this.SatellizerConfig.tokenType) {
	                        token = _this.SatellizerConfig.tokenType + ' ' + token;
	                    }
	                    config.headers[_this.SatellizerConfig.tokenHeader] = token;
	                }
	                return config;
	            };
	        }
	        Interceptor.Factory = function (SatellizerConfig, SatellizerShared, SatellizerStorage) {
	            return new Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage);
	        };
	        Interceptor.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
	        return Interceptor;
	    }());
	    Interceptor.Factory.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
	
	    var HttpProviderConfig = (function () {
	        function HttpProviderConfig($httpProvider) {
	            this.$httpProvider = $httpProvider;
	            $httpProvider.interceptors.push(Interceptor.Factory);
	        }
	        HttpProviderConfig.$inject = ['$httpProvider'];
	        return HttpProviderConfig;
	    }());
	
	    angular.module('satellizer', [])
	        .provider('$auth', ['SatellizerConfig', function (SatellizerConfig) { return new AuthProvider(SatellizerConfig); }])
	        .constant('SatellizerConfig', Config.getConstant)
	        .service('SatellizerShared', Shared)
	        .service('SatellizerLocal', Local)
	        .service('SatellizerPopup', Popup)
	        .service('SatellizerOAuth', OAuth)
	        .service('SatellizerOAuth2', OAuth2)
	        .service('SatellizerOAuth1', OAuth1)
	        .service('SatellizerStorage', Storage)
	        .service('SatellizerInterceptor', Interceptor)
	        .config(['$httpProvider', function ($httpProvider) { return new HttpProviderConfig($httpProvider); }]);
	    var ng1 = 'satellizer';
	
	    return ng1;
	
	}));
	//# sourceMappingURL=satellizer.js.map


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)))

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(661);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.19.8 - 2017-04-18T05:43:43.673Z
	 * License: MIT
	 */
	
	
	(function () { 
	"use strict";
	var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
	    },
	
	    isControl: function (e) {
	        var k = e.which;
	        switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	            return true;
	        }
	
	        if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	        return false;
	    },
	    isFunctionKey: function (k) {
	        k = k.which ? k.which : k;
	        return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function (k){
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function (k){
	      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function (k) {
	      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	function isNil(value) {
	  return angular.isUndefined(value) || value === null;
	}
	
	/**
	 * Add querySelectorAll() to jqLite.
	 *
	 * jqLite find() is limited to lookups by tag name.
	 * TODO This will change with future versions of AngularJS, to be removed when this happens
	 *
	 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	 */
	if (angular.element.prototype.querySelectorAll === undefined) {
	  angular.element.prototype.querySelectorAll = function(selector) {
	    return angular.element(this[0].querySelectorAll(selector));
	  };
	}
	
	/**
	 * Add closest() to jqLite.
	 */
	if (angular.element.prototype.closest === undefined) {
	  angular.element.prototype.closest = function( selector) {
	    var elem = this[0];
	    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	    while (elem) {
	      if (matchesSelector.bind(elem)(selector)) {
	        return elem;
	      } else {
	        elem = elem.parentElement;
	      }
	    }
	    return false;
	  };
	}
	
	var latestId = 0;
	
	var uis = angular.module('ui.select', [])
	
	.constant('uiSelectConfig', {
	  theme: 'bootstrap',
	  searchEnabled: true,
	  sortable: false,
	  placeholder: '', // Empty by default, like HTML tag <select>
	  refreshDelay: 1000, // In milliseconds
	  closeOnSelect: true,
	  skipFocusser: false,
	  dropdownPosition: 'auto',
	  removeSelected: true,
	  resetSearchInput: true,
	  generateId: function() {
	    return latestId++;
	  },
	  appendToBody: false,
	  spinnerEnabled: false,
	  spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
	  backspaceReset: true
	})
	
	// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	.service('uiSelectMinErr', function() {
	  var minErr = angular.$$minErr('ui.select');
	  return function() {
	    var error = minErr.apply(this, arguments);
	    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	    return new Error(message);
	  };
	})
	
	// Recreates old behavior of ng-transclude. Used internally.
	.directive('uisTranscludeAppend', function () {
	  return {
	    link: function (scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	})
	
	/**
	 * Highlights text that matches $select.search.
	 *
	 * Taken from AngularUI Bootstrap Typeahead
	 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	 */
	.filter('highlight', function() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  return function(matchItem, query) {
	    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	  };
	})
	
	/**
	 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	 *
	 * Taken from AngularUI Bootstrap Position:
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	 */
	.factory('uisOffset',
	  ['$document', '$window',
	  function ($document, $window) {
	
	  return function(element) {
	    var boundingClientRect = element[0].getBoundingClientRect();
	    return {
	      width: boundingClientRect.width || element.prop('offsetWidth'),
	      height: boundingClientRect.height || element.prop('offsetHeight'),
	      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	    };
	  };
	}]);
	
	uis.directive('uiSelectChoices',
	  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
	  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-choices');
	
	      // Gets theme attribute from parent (ui-select)
	      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	      return theme + '/choices.tpl.html';
	    },
	
	    compile: function(tElement, tAttrs) {
	
	      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	      // var repeat = RepeatParser.parse(attrs.repeat);
	      var groupByExp = tAttrs.groupBy;
	      var groupFilterExp = tAttrs.groupFilter;
	
	      if (groupByExp) {
	        var groups = tElement.querySelectorAll('.ui-select-choices-group');
	        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	      }
	
	      var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	      var choices = tElement.querySelectorAll('.ui-select-choices-row');
	      if (choices.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
	             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	      if (rowsInner.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	      }
	      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	      return function link(scope, element, attrs, $select) {
	
	
	        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	        $select.disableChoiceExpression = attrs.uiDisableChoice;
	        $select.onHighlightCallback = attrs.onHighlight;
	        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
	        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	        scope.$watch('$select.search', function(newValue) {
	          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
	          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	            $select.refresh(attrs.refresh);
	          } else {
	            $select.items = [];
	          }
	        });
	
	        attrs.$observe('refreshDelay', function() {
	          // $eval() is needed otherwise we get a string instead of a number
	          var refreshDelay = scope.$eval(attrs.refreshDelay);
	          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	        });
	
	        scope.$watch('$select.open', function(open) {
	          if (open) {
	            tElement.attr('role', 'listbox');
	            $select.refresh(attrs.refresh);
	          } else {
	            element.removeAttr('role');
	          }
	        });
	      };
	    }
	  };
	}]);
	
	/**
	 * Contains ui-select "intelligence".
	 *
	 * The goal is to limit dependency on the DOM whenever possible and
	 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	 */
	uis.controller('uiSelectCtrl',
	  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
	  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	  var ctrl = this;
	
	  var EMPTY_SEARCH = '';
	
	  ctrl.placeholder = uiSelectConfig.placeholder;
	  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	  ctrl.sortable = uiSelectConfig.sortable;
	  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	  ctrl.paste = uiSelectConfig.paste;
	  ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
	  ctrl.refreshing = false;
	  ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
	  ctrl.spinnerClass = uiSelectConfig.spinnerClass;
	  ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	  ctrl.search = EMPTY_SEARCH;
	
	  ctrl.activeIndex = 0; //Dropdown of choices
	  ctrl.items = []; //All available choices
	
	  ctrl.open = false;
	  ctrl.focus = false;
	  ctrl.disabled = false;
	  ctrl.selected = undefined;
	
	  ctrl.dropdownPosition = 'auto';
	
	  ctrl.focusser = undefined; //Reference to input element used to handle focus events
	  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	  ctrl.tagging = {isActivated: false, fct: undefined};
	  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
	  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	  ctrl.clickTriggeredSelect = false;
	  ctrl.$filter = $filter;
	  ctrl.$element = $element;
	
	  // Use $injector to check for $animate and store a reference to it
	  ctrl.$animate = (function () {
	    try {
	      return $injector.get('$animate');
	    } catch (err) {
	      // $animate does not exist
	      return null;
	    }
	  })();
	
	  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	  if (ctrl.searchInput.length !== 1) {
	    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	  }
	
	  ctrl.isEmpty = function() {
	    return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
	  };
	
	  function _findIndex(collection, predicate, thisArg){
	    if (collection.findIndex){
	      return collection.findIndex(predicate, thisArg);
	    } else {
	      var list = Object(collection);
	      var length = list.length >>> 0;
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }
	
	  // Most of the time the user does not want to empty the search input when in typeahead mode
	  function _resetSearchInput() {
	    if (ctrl.resetSearchInput) {
	      ctrl.search = EMPTY_SEARCH;
	      //reset activeIndex
	      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
	          return angular.equals(this, item);
	        }, ctrl.selected);
	      }
	    }
	  }
	
	    function _groupsFilter(groups, groupNames) {
	      var i, j, result = [];
	      for(i = 0; i < groupNames.length ;i++){
	        for(j = 0; j < groups.length ;j++){
	          if(groups[j].name == [groupNames[i]]){
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	  // When the user clicks on ui-select, displays the dropdown list
	  ctrl.activate = function(initSearchValue, avoidReset) {
	    if (!ctrl.disabled  && !ctrl.open) {
	      if(!avoidReset) _resetSearchInput();
	
	      $scope.$broadcast('uis:activate');
	      ctrl.open = true;
	      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	      // ensure that the index is set to zero for tagging variants
	      // that where first option is auto-selected
	      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
	        ctrl.activeIndex = 0;
	      }
	
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var searchInput = $element.querySelectorAll('.ui-select-search');
	      if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	        var animateHandler = function(elem, phase) {
	          if (phase === 'start' && ctrl.items.length === 0) {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          } else if (phase === 'close') {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('enter', container[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          }
	        };
	
	        if (ctrl.items.length > 0) {
	          ctrl.$animate.on('enter', container[0], animateHandler);
	        } else {
	          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	        }
	      } else {
	        $timeout(function () {
	          ctrl.focusSearchInput(initSearchValue);
	          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	            _ensureHighlightVisible();
	          }
	        });
	      }
	    }
	    else if (ctrl.open && !ctrl.searchEnabled) {
	      // Close the selection if we don't have search enabled, and we click on the select again
	      ctrl.close();
	    }
	  };
	
	  ctrl.focusSearchInput = function (initSearchValue) {
	    ctrl.search = initSearchValue || ctrl.search;
	    ctrl.searchInput[0].focus();
	  };
	
	  ctrl.findGroupByName = function(name) {
	    return ctrl.groups && ctrl.groups.filter(function(group) {
	      return group.name === name;
	    })[0];
	  };
	
	  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
	    function updateGroups(items) {
	      var groupFn = $scope.$eval(groupByExp);
	      ctrl.groups = [];
	      angular.forEach(items, function(item) {
	        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	        var group = ctrl.findGroupByName(groupName);
	        if(group) {
	          group.items.push(item);
	        }
	        else {
	          ctrl.groups.push({name: groupName, items: [item]});
	        }
	      });
	      if(groupFilterExp){
	        var groupFilterFn = $scope.$eval(groupFilterExp);
	        if( angular.isFunction(groupFilterFn)){
	          ctrl.groups = groupFilterFn(ctrl.groups);
	        } else if(angular.isArray(groupFilterFn)){
	          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	        }
	      }
	      ctrl.items = [];
	      ctrl.groups.forEach(function(group) {
	        ctrl.items = ctrl.items.concat(group.items);
	      });
	    }
	
	    function setPlainItems(items) {
	      ctrl.items = items || [];
	    }
	
	    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	    ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	    ctrl.isGrouped = !!groupByExp;
	    ctrl.itemProperty = ctrl.parserResult.itemName;
	
	    //If collection is an Object, convert it to Array
	
	    var originalSource = ctrl.parserResult.source;
	
	    //When an object is used as source, we better create an array and use it as 'source'
	    var createArrayFromObject = function(){
	      var origSrc = originalSource($scope);
	      $scope.$uisSource = Object.keys(origSrc).map(function(v){
	        var result = {};
	        result[ctrl.parserResult.keyName] = v;
	        result.value = origSrc[v];
	        return result;
	      });
	    };
	
	    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
	      createArrayFromObject();
	      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	      $scope.$watch(originalSource, function(newVal, oldVal){
	        if (newVal !== oldVal) createArrayFromObject();
	      }, true);
	    }
	
	    ctrl.refreshItems = function (data){
	      data = data || ctrl.parserResult.source($scope);
	      var selectedItems = ctrl.selected;
	      //TODO should implement for single mode removeSelected
	      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
	        ctrl.setItemsFn(data);
	      }else{
	        if ( data !== undefined && data !== null ) {
	          var filteredItems = data.filter(function(i) {
	            return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
	              return !angular.equals(i, selectedItem);
	            }) : !angular.equals(i, selectedItems);
	          });
	          ctrl.setItemsFn(filteredItems);
	        }
	      }
	      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
	        $scope.calculateDropdownPos();
	      }
	      $scope.$broadcast('uis:refresh');
	    };
	
	    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
	      if (items === undefined || items === null) {
	        // If the user specifies undefined or null => reset the collection
	        // Special case: items can be undefined if the user did not initialized the collection on the scope
	        // i.e $scope.addresses = [] is missing
	        ctrl.items = [];
	      } else {
	        if (!angular.isArray(items)) {
	          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	        } else {
	          //Remove already selected items (ex: while searching)
	          //TODO Should add a test
	          ctrl.refreshItems(items);
	
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
	            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	        }
	      }
	    });
	
	  };
	
	  var _refreshDelayPromise;
	
	  /**
	   * Typeahead mode: lets the user refresh the collection using his own function.
	   *
	   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	   */
	  ctrl.refresh = function(refreshAttr) {
	    if (refreshAttr !== undefined) {
	      // Debounce
	      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	      if (_refreshDelayPromise) {
	        $timeout.cancel(_refreshDelayPromise);
	      }
	      _refreshDelayPromise = $timeout(function() {
	        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
	          var refreshPromise = $scope.$eval(refreshAttr);
	          if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
	            ctrl.refreshing = true;
	            refreshPromise.finally(function() {
	              ctrl.refreshing = false;
	            });
	          }
	        }
	      }, ctrl.refreshDelay);
	    }
	  };
	
	  ctrl.isActive = function(itemScope) {
	    if ( !ctrl.open ) {
	      return false;
	    }
	    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	    var isActive =  itemIndex == ctrl.activeIndex;
	
	    if ( !isActive || itemIndex < 0 ) {
	      return false;
	    }
	
	    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	      itemScope.$eval(ctrl.onHighlightCallback);
	    }
	
	    return isActive;
	  };
	
	  var _isItemSelected = function (item) {
	    return (ctrl.selected && angular.isArray(ctrl.selected) &&
	        ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
	  };
	
	  var disabledItems = [];
	
	  function _updateItemDisabled(item, isDisabled) {
	    var disabledItemIndex = disabledItems.indexOf(item);
	    if (isDisabled && disabledItemIndex === -1) {
	      disabledItems.push(item);
	    }
	
	    if (!isDisabled && disabledItemIndex > -1) {
	      disabledItems.splice(disabledItemIndex, 1);
	    }
	  }
	
	  function _isItemDisabled(item) {
	    return disabledItems.indexOf(item) > -1;
	  }
	
	  ctrl.isDisabled = function(itemScope) {
	
	    if (!ctrl.open) return;
	
	    var item = itemScope[ctrl.itemProperty];
	    var itemIndex = ctrl.items.indexOf(item);
	    var isDisabled = false;
	
	    if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	      if (item.isTag) return false;
	
	      if (ctrl.multiple) {
	        isDisabled = _isItemSelected(item);
	      }
	
	      if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
	      }
	
	      _updateItemDisabled(item, isDisabled);
	    }
	
	    return isDisabled;
	  };
	
	
	  // When the user selects an item with ENTER or clicks the dropdown
	  ctrl.select = function(item, skipFocusser, $event) {
	    if (isNil(item) || !_isItemDisabled(item)) {
	
	      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;
	
	      if (!item || !_isItemDisabled(item)) {
	        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
	        ctrl.clickTriggeredSelect = false;
	        if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
	          ctrl.clickTriggeredSelect = true;
	
	        if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
	          // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	          if ( ctrl.taggingLabel === false ) {
	            if ( ctrl.activeIndex < 0 ) {
	              if (item === undefined) {
	                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	              }
	              if (!item || angular.equals( ctrl.items[0], item ) ) {
	                return;
	              }
	            } else {
	              // keyboard nav happened first, user selected from dropdown
	              item = ctrl.items[ctrl.activeIndex];
	            }
	          } else {
	            // tagging always operates at index zero, taggingLabel === false pushes
	            // the ctrl.search value without having it injected
	            if ( ctrl.activeIndex === 0 ) {
	              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	              // for `item` if it is a detected duplicate
	              if ( item === undefined ) return;
	
	              // create new item on the fly if we don't already have one;
	              // use tagging function if we have one
	              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
	                item = ctrl.tagging.fct(item);
	                if (!item) return;
	              // if item type is 'string', apply the tagging label
	              } else if ( typeof item === 'string' ) {
	                // trim the trailing space
	                item = item.replace(ctrl.taggingLabel,'').trim();
	              }
	            }
	          }
	          // search ctrl.selected for dupes potentially caused by tagging and return early if found
	          if (_isItemSelected(item)) {
	            ctrl.close(skipFocusser);
	            return;
	          }
	        }
	        _resetSearchInput();
	        $scope.$broadcast('uis:select', item);
	
	        if (ctrl.closeOnSelect) {
	          ctrl.close(skipFocusser);
	        }
	      }
	    }
	  };
	
	  // Closes the dropdown
	  ctrl.close = function(skipFocusser) {
	    if (!ctrl.open) return;
	    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	    ctrl.open = false;
	    _resetSearchInput();
	    $scope.$broadcast('uis:close', skipFocusser);
	
	  };
	
	  ctrl.setFocus = function(){
	    if (!ctrl.focus) ctrl.focusInput[0].focus();
	  };
	
	  ctrl.clear = function($event) {
	    ctrl.select(null);
	    $event.stopPropagation();
	    $timeout(function() {
	      ctrl.focusser[0].focus();
	    }, 0, false);
	  };
	
	  // Toggle dropdown
	  ctrl.toggle = function(e) {
	    if (ctrl.open) {
	      ctrl.close();
	      e.preventDefault();
	      e.stopPropagation();
	    } else {
	      ctrl.activate();
	    }
	  };
	
	  // Set default function for locked choices - avoids unnecessary
	  // logic if functionality is not being used
	  ctrl.isLocked = function () {
	    return false;
	  };
	
	  $scope.$watch(function () {
	    return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	  }, _initaliseLockedChoices);
	
	  function _initaliseLockedChoices(doInitalise) {
	    if(!doInitalise) return;
	
	    var lockedItems = [];
	
	    function _updateItemLocked(item, isLocked) {
	      var lockedItemIndex = lockedItems.indexOf(item);
	      if (isLocked && lockedItemIndex === -1) {
	        lockedItems.push(item);
	        }
	
	      if (!isLocked && lockedItemIndex > -1) {
	        lockedItems.splice(lockedItemIndex, 1);
	      }
	    }
	
	    function _isItemlocked(item) {
	      return lockedItems.indexOf(item) > -1;
	    }
	
	    ctrl.isLocked = function (itemScope, itemIndex) {
	      var isLocked = false,
	          item = ctrl.selected[itemIndex];
	
	      if(item) {
	        if (itemScope) {
	          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
	          _updateItemLocked(item, isLocked);
	        } else {
	          isLocked = _isItemlocked(item);
	        }
	      }
	
	      return isLocked;
	    };
	  }
	
	
	  var sizeWatch = null;
	  var updaterScheduled = false;
	  ctrl.sizeSearchInput = function() {
	
	    var input = ctrl.searchInput[0],
	        container = ctrl.$element[0],
	        calculateContainerWidth = function() {
	          // Return the container width only if the search input is visible
	          return container.clientWidth * !!input.offsetParent;
	        },
	        updateIfVisible = function(containerWidth) {
	          if (containerWidth === 0) {
	            return false;
	          }
	          var inputWidth = containerWidth - input.offsetLeft;
	          if (inputWidth < 50) inputWidth = containerWidth;
	          ctrl.searchInput.css('width', inputWidth+'px');
	          return true;
	        };
	
	    ctrl.searchInput.css('width', '10px');
	    $timeout(function() { //Give tags time to render correctly
	      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	        sizeWatch = $scope.$watch(function() {
	          if (!updaterScheduled) {
	            updaterScheduled = true;
	            $scope.$$postDigest(function() {
	              updaterScheduled = false;
	              if (updateIfVisible(calculateContainerWidth())) {
	                sizeWatch();
	                sizeWatch = null;
	              }
	            });
	          }
	        }, angular.noop);
	      }
	    });
	  };
	
	  function _handleDropDownSelection(key) {
	    var processed = true;
	    switch (key) {
	      case KEY.DOWN:
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex < ctrl.items.length - 1) {
	          var idx = ++ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
	            ctrl.activeIndex = ++idx;
	          }
	        }
	        break;
	      case KEY.UP:
	        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex > minActiveIndex) {
	          var idxmin = --ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
	            ctrl.activeIndex = --idxmin;
	          }
	        }
	        break;
	      case KEY.TAB:
	        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	        break;
	      case KEY.ENTER:
	        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
	          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	        } else {
	          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        }
	        break;
	      case KEY.ESC:
	        ctrl.close();
	        break;
	      default:
	        processed = false;
	    }
	    return processed;
	  }
	
	  // Bind to keyboard shortcuts
	  ctrl.searchInput.on('keydown', function(e) {
	
	    var key = e.which;
	
	    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    $scope.$apply(function() {
	
	      var tagged = false;
	
	      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	        if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        if ( ctrl.taggingTokens.isActivated ) {
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
	              // make sure there is a new value to push via tagging
	              if ( ctrl.search.length > 0 ) {
	                tagged = true;
	              }
	            }
	          }
	          if ( tagged ) {
	            $timeout(function() {
	              ctrl.searchInput.triggerHandler('tagged');
	              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
	              if ( ctrl.tagging.fct ) {
	                newItem = ctrl.tagging.fct( newItem );
	              }
	              if (newItem) ctrl.select(newItem, true);
	            });
	          }
	        }
	      }
	
	    });
	
	    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
	      _ensureHighlightVisible();
	    }
	
	    if (key === KEY.ENTER || key === KEY.ESC) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	  });
	
	  ctrl.searchInput.on('paste', function (e) {
	    var data;
	
	    if (window.clipboardData && window.clipboardData.getData) { // IE
	      data = window.clipboardData.getData('Text');
	    } else {
	      data = (e.originalEvent || e).clipboardData.getData('text/plain');
	    }
	
	    // Prepend the current input field text to the paste buffer.
	    data = ctrl.search + data;
	
	    if (data && data.length > 0) {
	      // If tagging try to split by tokens and add items
	      if (ctrl.taggingTokens.isActivated) {
	        var items = [];
	        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
	          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	          if (data.indexOf(separator) > -1) {
	            items = data.split(separator);
	            break;  // only split by one token
	          }
	        }
	        if (items.length === 0) {
	          items = [data];
	        }
	        var oldsearch = ctrl.search;
	        angular.forEach(items, function (item) {
	          var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	          if (newItem) {
	            ctrl.select(newItem, true);
	          }
	        });
	        ctrl.search = oldsearch || EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      } else if (ctrl.paste) {
	        ctrl.paste(data);
	        ctrl.search = EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  });
	
	  ctrl.searchInput.on('tagged', function() {
	    $timeout(function() {
	      _resetSearchInput();
	    });
	  });
	
	  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	  function _ensureHighlightVisible() {
	    var container = $element.querySelectorAll('.ui-select-choices-content');
	    var choices = container.querySelectorAll('.ui-select-choices-row');
	    if (choices.length < 1) {
	      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	    }
	
	    if (ctrl.activeIndex < 0) {
	      return;
	    }
	
	    var highlighted = choices[ctrl.activeIndex];
	    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	    var height = container[0].offsetHeight;
	
	    if (posY > height) {
	      container[0].scrollTop += posY - height;
	    } else if (posY < highlighted.clientHeight) {
	      if (ctrl.isGrouped && ctrl.activeIndex === 0)
	        container[0].scrollTop = 0; //To make group header visible when going all the way up
	      else
	        container[0].scrollTop -= highlighted.clientHeight - posY;
	    }
	  }
	
	  var onResize = $$uisDebounce(function() {
	    ctrl.sizeSearchInput();
	  }, 50);
	
	  angular.element($window).bind('resize', onResize);
	
	  $scope.$on('$destroy', function() {
	    ctrl.searchInput.off('keyup keydown tagged blur paste');
	    angular.element($window).off('resize', onResize);
	  });
	
	  $scope.$watch('$select.activeIndex', function(activeIndex) {
	    if (activeIndex)
	      $element.find('input').attr(
	        'aria-activedescendant',
	        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
	  });
	
	  $scope.$watch('$select.open', function(open) {
	    if (!open)
	      $element.find('input').removeAttr('aria-activedescendant');
	  });
	}]);
	
	uis.directive('uiSelect',
	  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
	  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	  return {
	    restrict: 'EA',
	    templateUrl: function(tElement, tAttrs) {
	      var theme = tAttrs.theme || uiSelectConfig.theme;
	      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	    },
	    replace: true,
	    transclude: true,
	    require: ['uiSelect', '^ngModel'],
	    scope: true,
	
	    controller: 'uiSelectCtrl',
	    controllerAs: '$select',
	    compile: function(tElement, tAttrs) {
	
	      // Allow setting ngClass on uiSelect
	      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	      if(match) {
	        var combined = '{'+ match[1] +', '+ match[2] +'}';
	        tAttrs.ngClass = combined;
	        tElement.attr('ng-class', combined);
	      }
	
	      //Multiple or Single depending if multiple attribute presence
	      if (angular.isDefined(tAttrs.multiple))
	        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
	      else
	        tElement.append('<ui-select-single/>');
	
	      if (tAttrs.inputId)
	        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	      return function(scope, element, attrs, ctrls, transcludeFn) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        $select.generatedId = uiSelectConfig.generateId();
	        $select.baseTitle = attrs.title || 'Select box';
	        $select.focusserTitle = $select.baseTitle + ' focus';
	        $select.focusserId = 'focusser-' + $select.generatedId;
	
	        $select.closeOnSelect = function() {
	          if (angular.isDefined(attrs.closeOnSelect)) {
	            return $parse(attrs.closeOnSelect)();
	          } else {
	            return uiSelectConfig.closeOnSelect;
	          }
	        }();
	
	        scope.$watch('skipFocusser', function() {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	        });
	
	        $select.onSelectCallback = $parse(attrs.onSelect);
	        $select.onRemoveCallback = $parse(attrs.onRemove);
	
	        //Set reference to ngModel from uiSelectCtrl
	        $select.ngModel = ngModel;
	
	        $select.choiceGrouped = function(group){
	          return $select.isGrouped && group && group.name;
	        };
	
	        if(attrs.tabindex){
	          attrs.$observe('tabindex', function(value) {
	            $select.focusInput.attr('tabindex', value);
	            element.removeAttr('tabindex');
	          });
	        }
	
	        scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
	          $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	        });
	
	        scope.$watch('sortable', function() {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	        });
	
	        attrs.$observe('backspaceReset', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var backspaceReset = scope.$eval(attrs.backspaceReset);
	          $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
	        });
	
	        attrs.$observe('limit', function() {
	          //Limit the number of selections allowed
	          $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
	        });
	
	        scope.$watch('removeSelected', function() {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	        });
	
	        attrs.$observe('disabled', function() {
	          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	        });
	
	        attrs.$observe('resetSearchInput', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	        });
	
	        attrs.$observe('paste', function() {
	          $select.paste = scope.$eval(attrs.paste);
	        });
	
	        attrs.$observe('tagging', function() {
	          if(attrs.tagging !== undefined)
	          {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var taggingEval = scope.$eval(attrs.tagging);
	            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
	          }
	          else
	          {
	            $select.tagging = {isActivated: false, fct: undefined};
	          }
	        });
	
	        attrs.$observe('taggingLabel', function() {
	          if(attrs.tagging !== undefined )
	          {
	            // check eval for FALSE, in this case, we disable the labels
	            // associated with tagging
	            if ( attrs.taggingLabel === 'false' ) {
	              $select.taggingLabel = false;
	            }
	            else
	            {
	              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	            }
	          }
	        });
	
	        attrs.$observe('taggingTokens', function() {
	          if (attrs.tagging !== undefined) {
	            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
	            $select.taggingTokens = {isActivated: true, tokens: tokens };
	          }
	        });
	
	        attrs.$observe('spinnerEnabled', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
	          $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
	        });
	
	        attrs.$observe('spinnerClass', function() {
	          var spinnerClass = attrs.spinnerClass;
	          $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
	        });
	
	        //Automatically gets focus when loaded
	        if (angular.isDefined(attrs.autofocus)){
	          $timeout(function(){
	            $select.setFocus();
	          });
	        }
	
	        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	        if (angular.isDefined(attrs.focusOn)){
	          scope.$on(attrs.focusOn, function() {
	              $timeout(function(){
	                $select.setFocus();
	              });
	          });
	        }
	
	        function onDocumentClick(e) {
	          if (!$select.open) return; //Skip it if dropdown is close
	
	          var contains = false;
	
	          if (window.jQuery) {
	            // Firefox 3.6 does not support element.contains()
	            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	            contains = window.jQuery.contains(element[0], e.target);
	          } else {
	            contains = element[0].contains(e.target);
	          }
	
	          if (!contains && !$select.clickTriggeredSelect) {
	            var skipFocusser;
	            if (!$select.skipFocusser) {
	              //Will lose focus only with certain targets
	              var focusableControls = ['input','button','textarea','select'];
	              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	            } else {
	              skipFocusser = true;
	            }
	            $select.close(skipFocusser);
	            scope.$digest();
	          }
	          $select.clickTriggeredSelect = false;
	        }
	
	        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	        $document.on('click', onDocumentClick);
	
	        scope.$on('$destroy', function() {
	          $document.off('click', onDocumentClick);
	        });
	
	        // Move transcluded elements to their correct position in main template
	        transcludeFn(scope, function(clone) {
	          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	          // One day jqLite will be replaced by jQuery and we will be able to write:
	          // var transcludedElement = clone.filter('.my-class')
	          // instead of creating a hackish DOM element:
	          var transcluded = angular.element('<div>').append(clone);
	
	          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	          if (transcludedMatch.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	          }
	          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	          if (transcludedChoices.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	          }
	          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	          if (transcludedNoChoice.length == 1) {
	            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	          }
	        });
	
	        // Support for appending the select field to the body when its open
	        var appendToBody = scope.$eval(attrs.appendToBody);
	        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	          scope.$watch('$select.open', function(isOpen) {
	            if (isOpen) {
	              positionDropdown();
	            } else {
	              resetDropdown();
	            }
	          });
	
	          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	          // it might stick around when the user routes away or the select field is otherwise removed
	          scope.$on('$destroy', function() {
	            resetDropdown();
	          });
	        }
	
	        // Hold on to a reference to the .ui-select-container element for appendToBody support
	        var placeholder = null,
	            originalWidth = '';
	
	        function positionDropdown() {
	          // Remember the absolute position of the element
	          var offset = uisOffset(element);
	
	          // Clone the element into a placeholder element to take its original place in the DOM
	          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	          placeholder[0].style.width = offset.width + 'px';
	          placeholder[0].style.height = offset.height + 'px';
	          element.after(placeholder);
	
	          // Remember the original value of the element width inline style, so it can be restored
	          // when the dropdown is closed
	          originalWidth = element[0].style.width;
	
	          // Now move the actual dropdown element to the end of the body
	          $document.find('body').append(element);
	
	          element[0].style.position = 'absolute';
	          element[0].style.left = offset.left + 'px';
	          element[0].style.top = offset.top + 'px';
	          element[0].style.width = offset.width + 'px';
	        }
	
	        function resetDropdown() {
	          if (placeholder === null) {
	            // The dropdown has not actually been display yet, so there's nothing to reset
	            return;
	          }
	
	          // Move the dropdown element back to its original location in the DOM
	          placeholder.replaceWith(element);
	          placeholder = null;
	
	          element[0].style.position = '';
	          element[0].style.left = '';
	          element[0].style.top = '';
	          element[0].style.width = originalWidth;
	
	          // Set focus back on to the moved element
	          $select.setFocus();
	        }
	
	        // Hold on to a reference to the .ui-select-dropdown element for direction support.
	        var dropdown = null,
	            directionUpClassName = 'direction-up';
	
	        // Support changing the direction of the dropdown if there isn't enough space to render it.
	        scope.$watch('$select.open', function() {
	
	          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
	            scope.calculateDropdownPos();
	          }
	
	        });
	
	        var setDropdownPosUp = function(offset, offsetDropdown){
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = 'absolute';
	          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
	          element.addClass(directionUpClassName);
	
	        };
	
	        var setDropdownPosDown = function(offset, offsetDropdown){
	
	          element.removeClass(directionUpClassName);
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = '';
	          dropdown[0].style.top = '';
	
	        };
	
	        var calculateDropdownPosAfterAnimation = function() {
	          // Delay positioning the dropdown until all choices have been added so its height is correct.
	          $timeout(function() {
	            if ($select.dropdownPosition === 'up') {
	              //Go UP
	              setDropdownPosUp();
	            } else {
	              //AUTO
	              element.removeClass(directionUpClassName);
	
	              var offset = uisOffset(element);
	              var offsetDropdown = uisOffset(dropdown);
	
	              //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	              var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	              // Determine if the direction of the dropdown needs to be changed.
	              if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                //Go UP
	                setDropdownPosUp(offset, offsetDropdown);
	              }else{
	                //Go DOWN
	                setDropdownPosDown(offset, offsetDropdown);
	              }
	            }
	
	            // Display the dropdown once it has been positioned.
	            dropdown[0].style.opacity = 1;
	          });
	        };
	
	        var opened = false;
	        
	        scope.calculateDropdownPos = function() {
	          if ($select.open) {
	            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	            if (dropdown.length === 0) {
	              return;
	            }
	
	           // Hide the dropdown so there is no flicker until $timeout is done executing.
	           if ($select.search === '' && !opened) {
	              dropdown[0].style.opacity = 0;
	              opened = true;
	           }
	
	            if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	              var needsCalculated = true;
	
	              $select.$animate.on('enter', dropdown, function (elem, phase) {
	                if (phase === 'close' && needsCalculated) {
	                  calculateDropdownPosAfterAnimation();
	                  needsCalculated = false;
	                }
	              });
	            } else {
	              calculateDropdownPosAfterAnimation();
	            }
	          } else {
	            if (dropdown === null || dropdown.length === 0) {
	              return;
	            }
	
	            // Reset the position of the dropdown.
	            dropdown[0].style.opacity = 0;
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	            element.removeClass(directionUpClassName);
	          }
	        };
	      };
	    }
	  };
	}]);
	
	uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-match');
	
	      var parent = tElement.parent();
	      // Gets theme attribute from parent (ui-select)
	      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	      var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
	    },
	    link: function(scope, element, attrs, $select) {
	      $select.lockChoiceExpression = attrs.uiLockChoice;
	      attrs.$observe('placeholder', function(placeholder) {
	        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	      });
	
	      function setAllowClear(allow) {
	        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
	      }
	
	      attrs.$observe('allowClear', setAllowClear);
	      setAllowClear(attrs.allowClear);
	
	      if($select.multiple){
	        $select.sizeSearchInput();
	      }
	
	    }
	  };
	
	  function getAttribute(elem, attribute) {
	    if (elem[0].hasAttribute(attribute))
	      return elem.attr(attribute);
	
	    if (elem[0].hasAttribute('data-' + attribute))
	      return elem.attr('data-' + attribute);
	
	    if (elem[0].hasAttribute('x-' + attribute))
	      return elem.attr('x-' + attribute);
	  }
	}]);
	
	uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	
	    controller: ['$scope','$timeout', function($scope, $timeout){
	
	      var ctrl = this,
	          $select = $scope.$select,
	          ngModel;
	
	      if (angular.isUndefined($select.selected))
	        $select.selected = [];
	
	      //Wait for link fn to inject it
	      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });
	
	      ctrl.activeMatchIndex = -1;
	
	      ctrl.updateModel = function(){
	        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	        ctrl.refreshComponent();
	      };
	
	      ctrl.refreshComponent = function(){
	        //Remove already selected items
	        //e.g. When user clicks on a selection, the selected array changes and
	        //the dropdown should remove that item
	        if($select.refreshItems){
	          $select.refreshItems();
	        }
	        if($select.sizeSearchInput){
	          $select.sizeSearchInput();
	        }
	      };
	
	      // Remove item from multiple select
	      ctrl.removeChoice = function(index){
	
	        // if the choice is locked, don't remove it
	        if($select.isLocked(null, index)) return false;
	
	        var removedChoice = $select.selected[index];
	
	        var locals = {};
	        locals[$select.parserResult.itemName] = removedChoice;
	
	        $select.selected.splice(index, 1);
	        ctrl.activeMatchIndex = -1;
	        $select.sizeSearchInput();
	
	        // Give some time for scope propagation.
	        $timeout(function(){
	          $select.onRemoveCallback($scope, {
	            $item: removedChoice,
	            $model: $select.parserResult.modelMapper($scope, locals)
	          });
	        });
	
	        ctrl.updateModel();
	
	        return true;
	      };
	
	      ctrl.getPlaceholder = function(){
	        //Refactor single?
	        if($select.selected && $select.selected.length) return;
	        return $select.placeholder;
	      };
	
	
	    }],
	    controllerAs: '$selectMultiple',
	
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = scope.ngModel = ctrls[1];
	      var $selectMultiple = scope.$selectMultiple;
	
	      //$select.selected = raw selected objects (ignoring any property binding)
	
	      $select.multiple = true;
	
	      //Input that will handle focus
	      $select.focusInput = $select.searchInput;
	
	      //Properly check for empty if set to multiple
	      ngModel.$isEmpty = function(value) {
	        return !value || value.length === 0;
	      };
	
	      //From view --> model
	      ngModel.$parsers.unshift(function () {
	        var locals = {},
	            result,
	            resultMultiple = [];
	        for (var j = $select.selected.length - 1; j >= 0; j--) {
	          locals = {};
	          locals[$select.parserResult.itemName] = $select.selected[j];
	          result = $select.parserResult.modelMapper(scope, locals);
	          resultMultiple.unshift(result);
	        }
	        return resultMultiple;
	      });
	
	      // From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (!data) return inputValue;
	        var resultMultiple = [];
	        var checkFnMultiple = function(list, value){
	          if (!list || !list.length) return;
	          for (var p = list.length - 1; p >= 0; p--) {
	            locals[$select.parserResult.itemName] = list[p];
	            result = $select.parserResult.modelMapper(scope, locals);
	            if($select.parserResult.trackByExp){
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
	                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
	                      resultMultiple.unshift(list[p]);
	                      return true;
	                  }
	                }
	            }
	            if (angular.equals(result,value)){
	              resultMultiple.unshift(list[p]);
	              return true;
	            }
	          }
	          return false;
	        };
	        if (!inputValue) return resultMultiple; //If ngModel was undefined
	        for (var k = inputValue.length - 1; k >= 0; k--) {
	          //Check model array of currently selected items
	          if (!checkFnMultiple($select.selected, inputValue[k])){
	            //Check model array of all items available
	            if (!checkFnMultiple(data, inputValue[k])){
	              //If not found on previous lists, just add it directly to resultMultiple
	              resultMultiple.unshift(inputValue[k]);
	            }
	          }
	        }
	        return resultMultiple;
	      });
	
	      //Watch for external model changes
	      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
	        if (oldValue != newValue){
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ngModel.$modelValue)) {
	            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	          $selectMultiple.refreshComponent();
	        }
	      });
	
	      ngModel.$render = function() {
	        // Make sure that model value is array
	        if(!angular.isArray(ngModel.$viewValue)){
	          // Have tolerance for null or undefined values
	          if (isNil(ngModel.$viewValue)){
	            ngModel.$viewValue = [];
	          } else {
	            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	          }
	        }
	        $select.selected = ngModel.$viewValue;
	        $selectMultiple.refreshComponent();
	        scope.$evalAsync(); //To force $digest
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        if($select.selected.length >= $select.limit) {
	          return;
	        }
	        $select.selected.push(item);
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function(){
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	        $selectMultiple.updateModel();
	      });
	
	      scope.$on('uis:activate', function () {
	        $selectMultiple.activeMatchIndex = -1;
	      });
	
	      scope.$watch('$select.disabled', function(newValue, oldValue) {
	        // As the search input field may now become visible, it may be necessary to recompute its size
	        if (oldValue && !newValue) $select.sizeSearchInput();
	      });
	
	      $select.searchInput.on('keydown', function(e) {
	        var key = e.which;
	        scope.$apply(function() {
	          var processed = false;
	          // var tagged = false; //Checkme
	          if(KEY.isHorizontalMovement(key)){
	            processed = _handleMatchSelection(key);
	          }
	          if (processed  && key != KEY.TAB) {
	            //TODO Check si el tab selecciona aun correctamente
	            //Crear test
	            e.preventDefault();
	            e.stopPropagation();
	          }
	        });
	      });
	      function _getCaretPosition(el) {
	        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
	        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	        else return el.value.length;
	      }
	      // Handles selected options in "multiple" mode
	      function _handleMatchSelection(key){
	        var caretPosition = _getCaretPosition($select.searchInput[0]),
	            length = $select.selected.length,
	            // none  = -1,
	            first = 0,
	            last  = length-1,
	            curr  = $selectMultiple.activeMatchIndex,
	            next  = $selectMultiple.activeMatchIndex+1,
	            prev  = $selectMultiple.activeMatchIndex-1,
	            newIndex = curr;
	
	        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
	
	        $select.close();
	
	        function getNewActiveMatchIndex(){
	          switch(key){
	            case KEY.LEFT:
	              // Select previous/first item
	              if(~$selectMultiple.activeMatchIndex) return prev;
	              // Select last item
	              else return last;
	              break;
	            case KEY.RIGHT:
	              // Open drop-down
	              if(!~$selectMultiple.activeMatchIndex || curr === last){
	                $select.activate();
	                return false;
	              }
	              // Select next/last item
	              else return next;
	              break;
	            case KEY.BACKSPACE:
	              // Remove selected item and select previous/first
	              if(~$selectMultiple.activeMatchIndex){
	                if($selectMultiple.removeChoice(curr)) {
	                  return prev;
	                } else {
	                  return curr;
	                }
	
	              } else {
	                // If nothing yet selected, select last item
	                return last;
	              }
	              break;
	            case KEY.DELETE:
	              // Remove selected item and select next item
	              if(~$selectMultiple.activeMatchIndex){
	                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                return curr;
	              }
	              else return false;
	          }
	        }
	
	        newIndex = getNewActiveMatchIndex();
	
	        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
	        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));
	
	        return true;
	      }
	
	      $select.searchInput.on('keyup', function(e) {
	
	        if ( ! KEY.isVerticalMovement(e.which) ) {
	          scope.$evalAsync( function () {
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          });
	        }
	        // Push a "create new" item into array if there is a search string
	        if ( $select.tagging.isActivated && $select.search.length > 0 ) {
	
	          // return early with these keys
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
	            return;
	          }
	          // always reset the activeIndex to the first item when tagging
	          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          // taggingLabel === false bypasses all of this
	          if ($select.taggingLabel === false) return;
	
	          var items = angular.copy( $select.items );
	          var stashArr = angular.copy( $select.items );
	          var newItem;
	          var item;
	          var hasTag = false;
	          var dupeIndex = -1;
	          var tagItems;
	          var tagItem;
	
	          // case for object tagging via transform `$select.tagging.fct` function
	          if ( $select.tagging.fct !== undefined) {
	            tagItems = $select.$filter('filter')(items,{'isTag': true});
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	            if ( items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.tagging.fct($select.search);
	            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	            if (
	              stashArr.some(function (origItem) {
	                 return angular.equals(origItem, newItem);
	              }) ||
	              $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })
	            ) {
	              scope.$evalAsync(function () {
	                $select.activeIndex = 0;
	                $select.items = items;
	              });
	              return;
	            }
	            if (newItem) newItem.isTag = true;
	          // handle newItem string and stripping dupes in tagging string context
	          } else {
	            // find any tagging items already in the $select.items array and store them
	            tagItems = $select.$filter('filter')(items,function (item) {
	              return item.match($select.taggingLabel);
	            });
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            item = items[0];
	            // remove existing tag item if found (should only ever be one tag item)
	            if ( item !== undefined && items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.search+' '+$select.taggingLabel;
	            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
	              return;
	            }
	            // verify the the tag doesn't match the value of an existing item from
	            // the searched data set or the items already selected
	            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
	              // if there is a tag from prev iteration, strip it / queue the change
	              // and return early
	              if ( hasTag ) {
	                items = stashArr;
	                scope.$evalAsync( function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	              }
	              return;
	            }
	            if ( _findCaseInsensitiveDupe(stashArr) ) {
	              // if there is a tag from prev iteration, strip it
	              if ( hasTag ) {
	                $select.items = stashArr.slice(1,stashArr.length);
	              }
	              return;
	            }
	          }
	          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
	          // dupe found, shave the first item
	          if ( dupeIndex > -1 ) {
	            items = items.slice(dupeIndex+1,items.length-1);
	          } else {
	            items = [];
	            if (newItem) items.push(newItem);
	            items = items.concat(stashArr);
	          }
	          scope.$evalAsync( function () {
	            $select.activeIndex = 0;
	            $select.items = items;
	
	            if ($select.isGrouped) {
	              // update item references in groups, so that indexOf will work after angular.copy
	              var itemsWithoutTag = newItem ? items.slice(1) : items;
	              $select.setItemsFn(itemsWithoutTag);
	              if (newItem) {
	                // add tag item as a new group
	                $select.items.unshift(newItem);
	                $select.groups.unshift({name: '', items: [newItem], tagging: true});
	              }
	            }
	          });
	        }
	      });
	      function _findCaseInsensitiveDupe(arr) {
	        if ( arr === undefined || $select.search === undefined ) {
	          return false;
	        }
	        var hasDupe = arr.filter( function (origItem) {
	          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
	            return false;
	          }
	          return origItem.toUpperCase() === $select.search.toUpperCase();
	        }).length > 0;
	
	        return hasDupe;
	      }
	      function _findApproxDupe(haystack, needle) {
	        var dupeIndex = -1;
	        if(angular.isArray(haystack)) {
	          var tempArr = angular.copy(haystack);
	          for (var i = 0; i <tempArr.length; i++) {
	            // handle the simple string version of tagging
	            if ( $select.tagging.fct === undefined ) {
	              // search the array for the match
	              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
	              dupeIndex = i;
	              }
	            // handle the object tagging implementation
	            } else {
	              var mockObj = tempArr[i];
	              if (angular.isObject(mockObj)) {
	                mockObj.isTag = true;
	              }
	              if ( angular.equals(mockObj, needle) ) {
	                dupeIndex = i;
	              }
	            }
	          }
	        }
	        return dupeIndex;
	      }
	
	      $select.searchInput.on('blur', function() {
	        $timeout(function() {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	      });
	
	    }
	  };
	}]);
	
	uis.directive('uiSelectNoChoice',
	    ['uiSelectConfig', function (uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function (tElement) {
	                // Needed so the uiSelect can detect the transcluded content
	                tElement.addClass('ui-select-no-choice');
	      
	                // Gets theme attribute from parent (ui-select)
	                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                return theme + '/no-choice.tpl.html';
	            }
	        };
	    }]);
	
	uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = ctrls[1];
	
	      //From view --> model
	      ngModel.$parsers.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var locals = {},
	            result;
	        locals[$select.parserResult.itemName] = inputValue;
	        result = $select.parserResult.modelMapper(scope, locals);
	        return result;
	      });
	
	      //From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (data){
	          var checkFnSingle = function(d){
	            locals[$select.parserResult.itemName] = d;
	            result = $select.parserResult.modelMapper(scope, locals);
	            return result === inputValue;
	          };
	          //If possible pass same object stored in $select.selected
	          if ($select.selected && checkFnSingle($select.selected)) {
	            return $select.selected;
	          }
	          for (var i = data.length - 1; i >= 0; i--) {
	            if (checkFnSingle(data[i])) return data[i];
	          }
	        }
	        return inputValue;
	      });
	
	      //Update viewValue if model change
	      scope.$watch('$select.selected', function(newValue) {
	        if (ngModel.$viewValue !== newValue) {
	          ngModel.$setViewValue(newValue);
	        }
	      });
	
	      ngModel.$render = function() {
	        $select.selected = ngModel.$viewValue;
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        $select.selected = item;
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function() {
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	      });
	
	      scope.$on('uis:close', function (event, skipFocusser) {
	        $timeout(function(){
	          $select.focusser.prop('disabled', false);
	          if (!skipFocusser) $select.focusser[0].focus();
	        },0,false);
	      });
	
	      scope.$on('uis:activate', function () {
	        focusser.prop('disabled', true); //Will reactivate it on .close()
	      });
	
	      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	      $compile(focusser)(scope);
	      $select.focusser = focusser;
	
	      //Input that will handle focus
	      $select.focusInput = focusser;
	
	      element.parent().append(focusser);
	      focusser.bind("focus", function(){
	        scope.$evalAsync(function(){
	          $select.focus = true;
	        });
	      });
	      focusser.bind("blur", function(){
	        scope.$evalAsync(function(){
	          $select.focus = false;
	        });
	      });
	      focusser.bind("keydown", function(e){
	
	        if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
	          e.preventDefault();
	          e.stopPropagation();
	          $select.select(undefined);
	          scope.$apply();
	          return;
	        }
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	          return;
	        }
	
	        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
	          e.preventDefault();
	          e.stopPropagation();
	          $select.activate();
	        }
	
	        scope.$digest();
	      });
	
	      focusser.bind("keyup input", function(e){
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	          return;
	        }
	
	        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	        focusser.val('');
	        scope.$digest();
	
	      });
	
	
	    }
	  };
	}]);
	
	// Make multiple matches sortable
	uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
	  return {
	    require: ['^^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	      if (scope[attrs.uiSelectSort] === null) {
	        throw uiSelectMinErr('sort', 'Expected a list to sort');
	      }
	
	      var $select = ctrls[0];
	      var $ngModel = ctrls[1];
	
	      var options = angular.extend({
	          axis: 'horizontal'
	        },
	        scope.$eval(attrs.uiSelectSortOptions));
	
	      var axis = options.axis;
	      var draggingClassName = 'dragging';
	      var droppingClassName = 'dropping';
	      var droppingBeforeClassName = 'dropping-before';
	      var droppingAfterClassName = 'dropping-after';
	
	      scope.$watch(function(){
	        return $select.sortable;
	      }, function(newValue){
	        if (newValue) {
	          element.attr('draggable', true);
	        } else {
	          element.removeAttr('draggable');
	        }
	      });
	
	      element.on('dragstart', function(event) {
	        element.addClass(draggingClassName);
	
	        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	      });
	
	      element.on('dragend', function() {
	        removeClass(draggingClassName);
	      });
	
	      var move = function(from, to) {
	        /*jshint validthis: true */
	        this.splice(to, 0, this.splice(from, 1)[0]);
	      };
	
	      var removeClass = function(className) {
	        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
	          angular.element(el).removeClass(className);
	        });
	      };
	
	      var dragOverHandler = function(event) {
	        event.preventDefault();
	
	        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
	          removeClass(droppingAfterClassName);
	          element.addClass(droppingBeforeClassName);
	
	        } else {
	          removeClass(droppingBeforeClassName);
	          element.addClass(droppingAfterClassName);
	        }
	      };
	
	      var dropTimeout;
	
	      var dropHandler = function(event) {
	        event.preventDefault();
	
	        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	        // prevent event firing multiple times in firefox
	        $timeout.cancel(dropTimeout);
	        dropTimeout = $timeout(function() {
	          _dropHandler(droppedItemIndex);
	        }, 20);
	      };
	
	      var _dropHandler = function(droppedItemIndex) {
	        var theList = scope.$eval(attrs.uiSelectSort);
	        var itemToMove = theList[droppedItemIndex];
	        var newIndex = null;
	
	        if (element.hasClass(droppingBeforeClassName)) {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index - 1;
	          } else {
	            newIndex = scope.$index;
	          }
	        } else {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index;
	          } else {
	            newIndex = scope.$index + 1;
	          }
	        }
	
	        move.apply(theList, [droppedItemIndex, newIndex]);
	
	        $ngModel.$setViewValue(Date.now());
	
	        scope.$apply(function() {
	          scope.$emit('uiSelectSort:change', {
	            array: theList,
	            item: itemToMove,
	            from: droppedItemIndex,
	            to: newIndex
	          });
	        });
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('drop', dropHandler);
	      };
	
	      element.on('dragenter', function() {
	        if (element.hasClass(draggingClassName)) {
	          return;
	        }
	
	        element.addClass(droppingClassName);
	
	        element.on('dragover', dragOverHandler);
	        element.on('drop', dropHandler);
	      });
	
	      element.on('dragleave', function(event) {
	        if (event.target != element) {
	          return;
	        }
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('dragover', dragOverHandler);
	        element.off('drop', dropHandler);
	      });
	    }
	  };
	}]);
	
	/**
	 * Debounces functions
	 *
	 * Taken from UI Bootstrap $$debounce source code
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	 *
	 */
	uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
	  return function(callback, debounceTime) {
	    var timeoutPromise;
	
	    return function() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	
	      timeoutPromise = $timeout(function() {
	        callback.apply(self, args);
	      }, debounceTime);
	    };
	  };
	}]);
	
	uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
	  return {
	    restrict: 'A',
	    require: 'uiSelect',
	    link: function (scope, element, attrs, $select) {
	      $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	      scope.$watch('$select.open', function (isOpen, previousState) {
	        if (isOpen !== previousState) {
	          $timeout(function () {
	            $select.onOpenCloseCallback(scope, {
	              isOpen: isOpen
	            });
	          });
	        }
	      });
	    }
	  };
	}]);
	
	/**
	 * Parses "repeat" attribute.
	 *
	 * Taken from AngularJS ngRepeat source code
	 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	 *
	 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	 */
	
	uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
	  var self = this;
	
	  /**
	   * Example:
	   * expression = "address in addresses | filter: {street: $select.search} track by $index"
	   * itemName = "address",
	   * source = "addresses | filter: {street: $select.search}",
	   * trackByExp = "$index",
	   */
	  self.parse = function(expression) {
	
	
	    var match;
	    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	    // If an array is used as collection
	
	    // if (isObjectCollection){
	    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	    // 1 Alias
	    // 2 Item
	    // 3 Key on (key,value)
	    // 4 Value on (key,value)
	    // 5 Source expression (including filters)
	    // 6 Track by
	
	    if (!match) {
	      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	              expression);
	    }
	    
	    var source = match[5], 
	        filters = '';
	
	    // When using (key,value) ui-select requires filters to be extracted, since the object
	    // is converted to an array for $select.items 
	    // (in which case the filters need to be reapplied)
	    if (match[3]) {
	      // Remove any enclosing parenthesis
	      source = match[5].replace(/(^\()|(\)$)/g, '');
	      // match all after | but not after ||
	      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	      if(filterMatch && filterMatch[1].trim()) {
	        filters = filterMatch[1];
	        source = source.replace(filters, '');
	      }      
	    }
	
	    return {
	      itemName: match[4] || match[2], // (lhs) Left-hand side,
	      keyName: match[3], //for (key, value) syntax
	      source: $parse(source),
	      filters: filters,
	      trackByExp: match[6],
	      modelMapper: $parse(match[1] || match[4] || match[2]),
	      repeatExpression: function (grouped) {
	        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	        if (this.trackByExp) {
	          expression += ' track by ' + this.trackByExp;
	        }
	        return expression;
	      } 
	    };
	
	  };
	
	  self.getGroupNgRepeatExpression = function() {
	    return '$group in $select.groups track by $group.name';
	  };
	
	}]);
	
	}());
	angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
	$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	$templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	$templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
	$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
	$templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(663);
	module.exports = 'ui.select';


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)(module), (function() { return this; }())))

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(665);
	var util = __webpack_require__(667);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(561);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 667 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 668 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 669 */
143,
/* 670 */
144,
/* 671 */
[678, 670, 669],
/* 672 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 674 */
673,
/* 675 */
673,
/* 676 */
673,
/* 677 */
673,
/* 678 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(__webpack_module_template_argument_0__);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(__webpack_module_template_argument_1__);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(7)))

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fileUpload = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _fileUpload3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _fileUpload4 = _interopRequireDefault(_fileUpload3);
	
	__webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileUploadComponent = {
	    bindings: {
	        onCompleteItem: '=',
	        onCompleteAll: '=',
	        onAfterAddingFile: '=',
	        onBeforeUploadItem: '=',
	        label: '@',
	        textUpload: '@',
	        multiple: '@',
	        types: '@',
	        name: '@',
	        url: '=',
	        form: '<',
	        data: '='
	    },
	    controller: _fileUpload2.default,
	    template: _fileUpload4.default
	};
	
	exports.default = FileUploadComponent;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ddjjdetalle = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _ddjjdetalle2 = _interopRequireDefault(_ddjjdetalle);
	
	var _ddjjdetalle3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _ddjjdetalle4 = _interopRequireDefault(_ddjjdetalle3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DdjjdetalleComponent = {
	    bindings: {},
	    controller: _ddjjdetalle2.default,
	    template: _ddjjdetalle4.default
	};
	
	exports.default = DdjjdetalleComponent;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _certificacionPromueve = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _certificacionPromueve2 = _interopRequireDefault(_certificacionPromueve);
	
	var _certificacionPromueve3 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _certificacionPromueve4 = _interopRequireDefault(_certificacionPromueve3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CertificacionComponent = {
	    bindings: {},
	    controller: _certificacionPromueve2.default,
	    template: _certificacionPromueve4.default
	};
	
	exports.default = CertificacionComponent;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	__webpack_require__(26);
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.1a15ca4cc4973afe2f3d.js